/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		1: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + ({"0":"polyfill-intl"}[chunkId]||chunkId) + "." + "aa6bc9ac24e22e445afe" + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 380);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(78);


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AddToCalendarPlacement */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return AuthenticatorType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdobePass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Api; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AppEnvs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return BlackoutTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return BucketLayout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return LayoutThresholds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return LayoutVariant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return Device; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return DeviceType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return BucketStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return OneIdEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return PageType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return PlayerError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return PlayerEvents; });
/* unused harmony export Route */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return Storage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return ModalType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ContentType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return URLPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ContentStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return SourceType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return AuthTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AuthStates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return Entitlements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ComScoreC3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return Flags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return PlayerPlacement; });
/* unused harmony export ESPNAppCookie */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return SyndicatedPlayerLoginOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return BreakPoints; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return BucketRatio; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return BucketRatioCols; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return RenderTemplateTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return SortOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return DarkThemeLogos; });
var _URLPath, _ComScoreC, _BreakPoints$MOBILE, _BreakPoints$MOBILE_L, _BreakPoints$TABLET, _BreakPoints$DESKTOP, _BreakPoints$DESKTOP_, _BucketRatioCols;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AddToCalendarPlacement = {
    ALERT: 'ALERT',
    EVENT_CARD: 'EVENT_CARD'
};

var AuthenticatorType = {
    ADOBE: 'adobe',
    IP: 'ip'
};

var AdobePass = {
    Env: {
        PROD: 'production',
        STAGING: 'staging'
    },
    METADATA: {
        TTL_AUTHN: 'TTL_AUTHN',
        TTL_AUTHZ: 'TTL_AUTHZ',
        USERID: 'userID',
        UPSTREAM_USERID: 'upstreamUserID',
        PACKAGE_ID: 'packageId',
        PACKAGE_TIER: 'tier'
    }
};

var Api = {
    Page: {
        EVENT_QUERY_KEYS: ['airingId', 'eventId', 'id', 'network', 'channel', 'gameId', 'country'],
        PCC_NETWORK_NAMES: ['espn', 'espn2', 'espn3', 'espnu', 'longhorn', 'espnews', 'espndeportes', 'sec', 'secplus', 'accextra', 'acc']
    },
    Env: {
        DEV: 'dev',
        QA: 'qa',
        STAGING: 'staging',
        PROD: 'prod'
    }
};

var AppEnvs = {
    prod: 'PROD',
    qa: 'QA',
    dev: 'DEV'
};

var BlackoutTypes = {
    DMA: 'dma',
    DEVICE: 'device'
};

var BucketLayout = {
    COLLECTION: 'COLLECTION',
    DEFAULT: 'DEFAULT',
    DEFAULT_UNLIMITED: 'DEFAULT_UNLIMITED',
    HERO: 'HERO',
    'feature-left': 'feature-left',
    'feature-right': 'feature-right',
    TAPESTRY_LEFT: 'TAPESTRY_LEFT', // will be deprecated
    TAPESTRY_RIGHT: 'TAPESTRY_RIGHT', // will be deprecated
    SixteenNineTapestryLeft: 'TAPESTRY_LEFT', // will be deprecated
    SixteenNineTapestryRight: 'TAPESTRY_RIGHT', // will be deprecated
    SCHEDULE_MODULE: 'SCHEDULE_MODULE',
    DEFAULT_EXPANDABLE: 'DEFAULT_EXPANDABLE',
    LARGE_EXPANDABLE: 'LARGE_EXPANDABLE',
    SixteenNine: 'SixteenNine',
    FiveTwo: 'FiveTwo',
    TwoThree: 'TwoThree',
    FourThree: 'FourThree',
    Carousel: 'carousel'
};

var LayoutThresholds = {
    DEFAULT_UNLIMITED: undefined,
    'feature-left': 5,
    'feature-right': 5,
    TAPESTRY_LEFT: 5,
    TAPESTRY_RIGHT: 5,
    COLLECTION: undefined
};

var LayoutVariant = {
    COLLECTION: 'collection',
    DTC: 'dtc'
};

var Device = {
    DESKTOP: 'desktop',
    HANDSET: 'handset',
    TABLET: 'tablet'
};

var DeviceType = Object.keys(Device).reduce(function (acc, key) {
    acc[Device[key]] = key;
    return acc;
}, {});

var BucketStatus = {
    WEB_LIVE: 'WEB_LIVE',
    WEB_UPCOMING: 'WEB_UPCOMING'
};

var OneIdEnv = {
    STAGING: 'staging',
    PROD: 'prod'
};

var PageType = {
    HOME: 'HOME',
    COLLECTION: 'COLLECTION',
    FEATURES: 'FEATURES',
    SEARCH: 'SEARCH',
    ORIGINALS: 'ORIGINALS',
    SID: 'SID',
    CATALOG: 'CATALOG'
};

var PlayerError = {
    AUTHORIZATION: 'AUTHORIZATION',
    DEFAULT: 'DEFAULT',
    UNSUPPORTED: 'UNSUPPORTED'
};

var PlayerEvents = {
    ESPN_PLAYING: 'espn.playing',
    ESPN_PLAY: 'espn.play',
    ESPN_PAUSE: 'espn.pause',
    ESPN_AD_POD_STARTED: 'espn.ads-pod-started',
    ESPN_AD_POD_ENDED: 'espn.ads-pod-ended',
    ESPN_AD_STARTED: 'espn.ads-ad-started',
    ESPN_AD_ENDED: 'espn.ads-ad-ended',
    ESPN_CONTENT_ENDED: 'espn.contentended',
    ESPN_CONTENT_LOADED: 'espn.contentloaded',
    ESPN_PROGRAM_CHANGE: 'espn.programchange',
    ESPN_AUTOPLAY_TOGGLED: 'espn.autoplaytoggled',
    ESPN_SOCIAL_OPENED: 'socialopened',
    ESPN_SOCIAL_CLOSED: 'socialclosed',
    ESPN_CAPTION_OPENED: 'captionopened',
    ESPN_CAPTION_CLOSED: 'captionclosed',
    ESPN_ERROR: 'espn.error'
};

var Route = {
    HOME: '',
    FEATURES: 'features',
    SCHEDULE: 'schedule',
    PLAYER: 'player'
};

var Storage = {
    Analytics: {
        IS_AUTHENTICATING: 'IS_AUTHENTICATING'
    }
};

var ModalType = {
    POPUP: 'POPUP',
    FLASH: 'FLASH',
    BLACKOUT_MAP: 'BLACKOUT_MAP',
    IFRAME_AUTH: 'IFRAME_AUTH',
    PAYWALL: 'PAYWALL',
    BROADCAST_PICKER: 'BROADCAST_PICKER'
};

var ContentType = {
    LISTING: 'listing',
    VOD: 'vod',
    PRODUCT: 'product',
    SHOW: 'show',
    FILM: 'film',
    ONDEMAND: 'onDemand',
    PROGRAM: 'program',
    // legacy type for `v1` Page API used for legacy 5.x app
    EVENT: 'event',
    VIDEO: 'video',
    TERM: 'term',
    COMPILATION: 'compilation'
};

var URLPath = (_URLPath = {}, _defineProperty(_URLPath, ContentType.PRODUCT, 'product'), _defineProperty(_URLPath, ContentType.SHOW, 'series'), _defineProperty(_URLPath, ContentType.FILM, 'film'), _defineProperty(_URLPath, ContentType.PROGRAM, 'program'), _defineProperty(_URLPath, ContentType.TERM, 'search'), _defineProperty(_URLPath, ContentType.COMPILATION, 'compilation'), _URLPath);

// should we use this for `type` field in listings API?
var ContentStatus = {
    LIVE: 'live',
    UPCOMING: 'upcoming',
    REPLAY: 'replay',
    OVER: 'over'
};

var SourceType = {
    LINEAR: 'linear',
    ONLINE: 'online'
};

var AuthTypes = {
    MVPD: 'mvpd',
    ISP: 'isp',
    BAM: 'direct',
    OPEN: 'open'
};

var AuthStates = {
    MVPD: 'mvpd_login',
    ISP: 'isp',
    MVPD_PREVIOUS: 'mvpd_previous'
};

var Entitlements = {
    ESPN_PLUS: 'ESPN_PLUS',
    ESPN_PLUS_MLB: 'ESPN_PLUS_MLB',
    ESPN_PLUS_NHL: 'ESPN_PLUS_NHL',
    ESPN_EXEC: 'ESPN_EXEC',
    ESPN_PLUS_UFC_PPV: 'ESPN_PLUS_UFC_PPV',
    ESPN_TDA: 'fallback_subscription_directbilling_tda'
};

var ComScoreC3 = (_ComScoreC = {}, _defineProperty(_ComScoreC, Entitlements.ESPN_PLUS, 'ESPNPlus'), _defineProperty(_ComScoreC, Entitlements.ESPN_PLUS_NHL, 'NHLTV'), _defineProperty(_ComScoreC, Entitlements.ESPN_PLUS_MLB, 'MLBTV'), _ComScoreC);

// list of URL query flags we use
var Flags = {
    APP_NAME: 'appName', // The app can be the default "webapp", or "espnapp"
    ADOBEPASS_ENV: 'passenv', // used to point Adobe Pass Access Enabler to different environment
    API_ENV: 'apienv', // points the site at whatever PageApi environment,
    CONFIG_ENV: 'configenv', // use config file for the specified env (`qa` or `prod`)
    COUNTRY: 'country', // allows to override X-Country header to determine country
    LANG: 'lang', // allows to override Accept-Language header
    DEBUG_AD: 'debug_ad', // used for printing out gpt ads info
    DEVICE: 'device', // overrides the devices detected from X-Device header
    PACKAGE_ID: 'packageId', // allows testing passing this packageId into pageApi
    PLAYER_TECH: 'playertech', // overrides the player tech (for forcing brightcove in webviews).
    ROADBLOCK: 'roadblock', // set to false to disable the authenticated content roadblock
    FROM_ROADBLOCK: 'rb', // set this to indicate that we were linked from the roadblock page (prevents cyclic redirection)
    ROADBLOCK_NO_UNIVERSAL_LINK: 'rb_noul', // do not use Universal Link logic
    HIDENAV: 'hidenav', // Used by webview in apps to remove top nav bars
    CLIENT_NAV: 'clientnav', // a flag to enable client side rendering from the header navigation
    WEBVIEW: 'webview', // Used by webview in apps to render the page completely w/o page shell
    ENABLE_SEARCH: 'search', // Used to enable search box on home page
    BYPASS_TOKEN: 'bypass_token', // Used to bypass AdobePass auth step
    PACKAGE_FILTER: 'pkg_filter', // Used to filter contents by packageId for international
    SSR: 'ssr', // Used to indicate if the server side rendering should be used or not,
    REGION: 'region', // ESPN App passes this as the edition to webviews.  We use this instead of headers if present
    PLAYER_ID: 'playerId', // A Brightcove playerId to override the default one
    ONEID_ENV: 'oneidenv', // Staging or Production OneID environment
    PARTNER: 'partner', // Used for partner syndicated player
    CATEGORY_ID: 'categoryId', // Syndicated player (i.e. US Open) to filter schedule correctly by (categoryId, id, partner)
    AUTO_DISPLAY_PROVIDER_DIALOG: 'autoDisplayDialog', // Used for syndicated player to show provider dialog immediately
    SHOW_SCHEDULE_IN_SYNDICATED_PLAYER: 'scheduleModule', // Used for showing schedule module in the syndicated player
    AUTH_RETRY: 'auth_retry', // Used when the syndicated player reload itself when the mvpd auth state failed to reflect
    XDOMAIN_BLOCKED: 'xd_blocked', // Used in the syndicated player to indicate that the browser blocks cross domain storage
    DEBUG: 'debug', // Used for the page shell to work in debug mode
    DISNEY_ENV: 'disneyid', // Used for the page shell to determine where to load `DisneyID.js`
    DISNEY_CLIENT_ID: 'disneyClientId', // Used for the page shell to override the `clientId` for OneID
    BAM_ENV: 'bamenv', // points BAM SDK to its env (`beta` or `qa`)
    MEDIA_LOCATION: 'ml', // temp param to override `media location(videoHref)`
    PAYWALL: 'paywall', // use BAM's paywall page
    PASS_ONEID_TOKEN: 'pass_token', // override bootstrap `bam.passToken` flag
    NO_SSR: 'no_ssr',
    PACKAGE_TIER: 'tier', // Package tier,
    EDITION: 'edition', // used to send edition to API calls i.e. carribean
    UNSUPPORTED_ERROR: 'unsupported_error', // Used to trigger the redirect to the /unsupported error page
    VIDEO_ADS_PROVIDER: 'videoAdsProvider', // Overrides which Ad Provider to use `google` or `freewheel` for the Player
    VIDEO_ADS_CMSID: 'videoAdsCMSID', // Overrides the GAM `cmsid` param for the Player
    VIDEO_ADS_NETWORK_CODE: 'videoAdsNetworkCode', // Overrides the `networkCode` adsConfig param for the Player
    VIDEO_ADS_AD_UNIT: 'videoAdsAdUnit', // Overrides the `adUnit` adsConfig param for the Player
    APP_DRM_SUPPORT: 'appDrmSupport', // indicates that the app (embedding the site as a webview) supports DRM
    MUTED: 'muted'
};

var PlayerPlacement = {
    HERO: 'hero',
    PLAYER: 'player'
};

var ESPNAppCookie = {
    AUTH: 'espnappwatchtab_auth',
    PERSONALIZATION: 'espnappwatchtab_personalization'
};

var SyndicatedPlayerLoginOptions = {
    SELF: 0,
    NEW_WINDOW: 1,
    NEW_WINDOW_MANAGED: 2
};

var BreakPoints = {
    MOBILE: 'mobile',
    MOBILE_LARGE: 'mobile-lg',
    TABLET: 'tablet',
    DESKTOP: 'desktop',
    DESKTOP_LARGE: 'desktop-lg'
};

var BucketRatio = {
    SixteenNine: '16x9',
    FourThree: '4x3',
    FiveTwo: '5x2',
    TwoThree: '2x3'
};

var BucketRatioCols = (_BucketRatioCols = {}, _defineProperty(_BucketRatioCols, BreakPoints.MOBILE, (_BreakPoints$MOBILE = {}, _defineProperty(_BreakPoints$MOBILE, BucketRatio.SixteenNine, 1), _defineProperty(_BreakPoints$MOBILE, BucketRatio.FourThree, 2), _defineProperty(_BreakPoints$MOBILE, BucketRatio.FiveTwo, 1), _defineProperty(_BreakPoints$MOBILE, BucketRatio.TwoThree, 2), _BreakPoints$MOBILE)), _defineProperty(_BucketRatioCols, BreakPoints.MOBILE_LARGE, (_BreakPoints$MOBILE_L = {}, _defineProperty(_BreakPoints$MOBILE_L, BucketRatio.SixteenNine, 1), _defineProperty(_BreakPoints$MOBILE_L, BucketRatio.FourThree, 4), _defineProperty(_BreakPoints$MOBILE_L, BucketRatio.FiveTwo, 1), _defineProperty(_BreakPoints$MOBILE_L, BucketRatio.TwoThree, 3), _BreakPoints$MOBILE_L)), _defineProperty(_BucketRatioCols, BreakPoints.TABLET, (_BreakPoints$TABLET = {}, _defineProperty(_BreakPoints$TABLET, BucketRatio.SixteenNine, 3), _defineProperty(_BreakPoints$TABLET, BucketRatio.FourThree, 4), _defineProperty(_BreakPoints$TABLET, BucketRatio.FiveTwo, 2), _defineProperty(_BreakPoints$TABLET, BucketRatio.TwoThree, 4), _BreakPoints$TABLET)), _defineProperty(_BucketRatioCols, BreakPoints.DESKTOP, (_BreakPoints$DESKTOP = {}, _defineProperty(_BreakPoints$DESKTOP, BucketRatio.SixteenNine, 4), _defineProperty(_BreakPoints$DESKTOP, BucketRatio.FourThree, 4), _defineProperty(_BreakPoints$DESKTOP, BucketRatio.FiveTwo, 2), _defineProperty(_BreakPoints$DESKTOP, BucketRatio.TwoThree, 5), _BreakPoints$DESKTOP)), _defineProperty(_BucketRatioCols, BreakPoints.DESKTOP_LARGE, (_BreakPoints$DESKTOP_ = {}, _defineProperty(_BreakPoints$DESKTOP_, BucketRatio.SixteenNine, 4), _defineProperty(_BreakPoints$DESKTOP_, BucketRatio.FourThree, 4), _defineProperty(_BreakPoints$DESKTOP_, BucketRatio.FiveTwo, 3), _defineProperty(_BreakPoints$DESKTOP_, BucketRatio.TwoThree, 6), _BreakPoints$DESKTOP_)), _BucketRatioCols);

var RenderTemplateTypes = {
    BASIC: 'basic',
    PAGE_SHELL: 'pageShell'
};

var SortOrder = {
    DESC: 'DESC',
    ASC: 'ASC'
};

var DarkThemeLogos = {
    espn_free: 'espn_free_wht',
    accextra: 'accextra_wht'
};

/* unused harmony default export */ var _unused_webpack_default_export = ({
    AddToCalendarPlacement: AddToCalendarPlacement,
    AdobePass: AdobePass,
    Api: Api,
    AppEnvs: AppEnvs,
    BucketLayout: BucketLayout,
    BucketStatus: BucketStatus,
    PageType: PageType,
    PlayerError: PlayerError,
    PlayerEvents: PlayerEvents,
    Route: Route,
    Storage: Storage,
    ModalType: ModalType,
    Flags: Flags,
    BucketRatio: BucketRatio,
    BucketRatioCols: BucketRatioCols
});

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*global window, global*/
var util = __webpack_require__(157)
var assert = __webpack_require__(225)
var now = __webpack_require__(385)

var slice = Array.prototype.slice
var console
var times = {}

if (typeof global !== "undefined" && global.console) {
    console = global.console
} else if (typeof window !== "undefined" && window.console) {
    console = window.console
} else {
    console = {}
}

var functions = [
    [log, "log"],
    [info, "info"],
    [warn, "warn"],
    [error, "error"],
    [time, "time"],
    [timeEnd, "timeEnd"],
    [trace, "trace"],
    [dir, "dir"],
    [consoleAssert, "assert"]
]

for (var i = 0; i < functions.length; i++) {
    var tuple = functions[i]
    var f = tuple[0]
    var name = tuple[1]

    if (!console[name]) {
        console[name] = f
    }
}

module.exports = console

function log() {}

function info() {
    console.log.apply(console, arguments)
}

function warn() {
    console.log.apply(console, arguments)
}

function error() {
    console.warn.apply(console, arguments)
}

function time(label) {
    times[label] = now()
}

function timeEnd(label) {
    var time = times[label]
    if (!time) {
        throw new Error("No such label: " + label)
    }

    var duration = now() - time
    console.log(label + ": " + duration + "ms")
}

function trace() {
    var err = new Error()
    err.name = "Trace"
    err.message = util.format.apply(null, arguments)
    console.error(err.stack)
}

function dir(object) {
    console.log(util.inspect(object) + "\n")
}

function consoleAssert(expression) {
    if (!expression) {
        var arr = slice.call(arguments, 1)
        assert.ok(false, util.format.apply(null, arr))
    }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/reselect/lib/index.js
var lib = __webpack_require__(9);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./app/enums.js
var enums = __webpack_require__(1);

// CONCATENATED MODULE: ./config/i18n/editionMap.js
// dateTime3 = 24h, dateTime2 = 12h + AM/PM
var esFaq = 'https://support.espn.com/hc/es';
var usFaq = 'https://support.espn.com/hc/en-us';
var brFaq = 'https://support.espn.com/hc/pt-br';
var carribFaq = 'http://cdn.espni.go.com/_templates/welcome-espnplay/popups/faq-en-espnplay.html';
var anzlFaq = 'https://support.espn.com/hc/en-au';

var faqMap = {
    ssla: esFaq,
    brazil: brFaq,
    caribbean: carribFaq,
    anzl: anzlFaq,
    us: usFaq
};

var editionMap = {
    MX: { pageShellRegion: 'mx', pageShellLanguage: 'es', edition: 'ssla', ad: { site: 'espn.latam.mx' }, dateFormat: 'dateTime3' }, // Mexico
    CR: { pageShellRegion: 'mx', pageShellLanguage: 'es', edition: 'ssla', ad: { site: 'espn.latam.mx' }, dateFormat: 'dateTime3' }, // Costa Rica
    BZ: { pageShellRegion: 'mx', pageShellLanguage: 'es', edition: 'ssla', ad: { site: 'espn.latam.mx' }, dateFormat: 'dateTime3' }, // Belize
    DO: { pageShellRegion: 'mx', pageShellLanguage: 'es', edition: 'ssla', ad: { site: 'espn.latam.mx' }, dateFormat: 'dateTime3' }, // Dominican Republic
    SV: { pageShellRegion: 'mx', pageShellLanguage: 'es', edition: 'ssla', ad: { site: 'espn.latam.mx' }, dateFormat: 'dateTime3' }, // El Salvador
    GT: { pageShellRegion: 'mx', pageShellLanguage: 'es', edition: 'ssla', ad: { site: 'espn.latam.mx' }, dateFormat: 'dateTime3' }, // Guatemala
    HN: { pageShellRegion: 'mx', pageShellLanguage: 'es', edition: 'ssla', ad: { site: 'espn.latam.mx' }, dateFormat: 'dateTime3' }, // Honduras
    NI: { pageShellRegion: 'mx', pageShellLanguage: 'es', edition: 'ssla', ad: { site: 'espn.latam.mx' }, dateFormat: 'dateTime3' }, // Nicaragua
    PA: { pageShellRegion: 'mx', pageShellLanguage: 'es', edition: 'ssla', ad: { site: 'espn.latam.mx' }, dateFormat: 'dateTime3' }, // Panama
    AR: { pageShellRegion: 'ar', pageShellLanguage: 'es', edition: 'ssla', ad: { site: 'espn.latam.ar' }, dateFormat: 'dateTime3' }, // Argentina
    PY: { pageShellRegion: 'ar', pageShellLanguage: 'es', edition: 'ssla', ad: { site: 'espn.latam.ar' }, dateFormat: 'dateTime3' }, // Paraguay
    UY: { pageShellRegion: 'ar', pageShellLanguage: 'es', edition: 'ssla', ad: { site: 'espn.latam.ar' }, dateFormat: 'dateTime3' }, // Uruguay
    BO: { pageShellRegion: 'cl', pageShellLanguage: 'es', edition: 'ssla', ad: { site: 'espn.latam.cl' }, dateFormat: 'dateTime3' }, // Bolivia
    CL: { pageShellRegion: 'cl', pageShellLanguage: 'es', edition: 'ssla', ad: { site: 'espn.latam.cl' }, dateFormat: 'dateTime3' }, // Chile
    PE: { pageShellRegion: 'pe', pageShellLanguage: 'es', edition: 'ssla', ad: { site: 'espn.latam.pe' }, dateFormat: 'dateTime3' }, // Peru
    CO: { pageShellRegion: 'co', pageShellLanguage: 'es', edition: 'ssla', ad: { site: 'espn.latam.co' }, dateFormat: 'dateTime3' }, // Colombia
    EC: { pageShellRegion: 'co', pageShellLanguage: 'es', edition: 'ssla', ad: { site: 'espn.latam.co' }, dateFormat: 'dateTime3' }, // Ecuador
    VE: { pageShellRegion: 've', pageShellLanguage: 'es', edition: 'ssla', ad: { site: 'espn.latam.ve' }, dateFormat: 'dateTime3' }, // Venezuela
    BR: { pageShellRegion: 'br', pageShellLanguage: 'pt', edition: 'brazil', ad: { site: 'espn.com.br' }, dateFormat: 'dateTime3' }, // Brasil
    AI: { pageShellRegion: 'uk', pageShellLanguage: 'en', edition: 'caribbean', ad: { site: 'espn.latam.mx' }, dateFormat: 'dateTime3' }, // Caribbean - Anguila
    AG: { pageShellRegion: 'uk', pageShellLanguage: 'en', edition: 'caribbean', ad: { site: 'espn.latam.mx' }, dateFormat: 'dateTime3' }, // Antigua and Barbuda
    AW: { pageShellRegion: 'uk', pageShellLanguage: 'en', edition: 'caribbean', ad: { site: 'espn.latam.mx' }, dateFormat: 'dateTime3' }, // Caribbean - Aruba
    BS: { pageShellRegion: 'uk', pageShellLanguage: 'en', edition: 'caribbean', ad: { site: 'espn.latam.mx' }, dateFormat: 'dateTime3' }, // Caribbean - Bahamas
    BB: { pageShellRegion: 'uk', pageShellLanguage: 'en', edition: 'caribbean', ad: { site: 'espn.latam.mx' }, dateFormat: 'dateTime3' }, // Caribbean - Barbados
    BM: { pageShellRegion: 'uk', pageShellLanguage: 'en', edition: 'caribbean', ad: { site: 'espn.latam.mx' }, dateFormat: 'dateTime3' }, // Caribbean - Bermuda
    KY: { pageShellRegion: 'uk', pageShellLanguage: 'en', edition: 'caribbean', ad: { site: 'espn.latam.mx' }, dateFormat: 'dateTime3' }, // Caribbean - Cayman Islands
    DM: { pageShellRegion: 'uk', pageShellLanguage: 'en', edition: 'caribbean', ad: { site: 'espn.latam.mx' }, dateFormat: 'dateTime3' }, // Caribbean - Dominica
    GD: { pageShellRegion: 'uk', pageShellLanguage: 'en', edition: 'caribbean', ad: { site: 'espn.latam.mx' }, dateFormat: 'dateTime3' }, // Caribbean - Grenada
    GP: { pageShellRegion: 'uk', pageShellLanguage: 'en', edition: 'caribbean', ad: { site: 'espn.latam.mx' }, dateFormat: 'dateTime3' }, // Caribbean - Guadeloupe
    GY: { pageShellRegion: 'uk', pageShellLanguage: 'en', edition: 'caribbean', ad: { site: 'espn.latam.mx' }, dateFormat: 'dateTime3' }, // Caribbean - Guyana
    HT: { pageShellRegion: 'uk', pageShellLanguage: 'en', edition: 'caribbean', ad: { site: 'espn.latam.mx' }, dateFormat: 'dateTime3' }, // Caribbean - Haiti
    JM: { pageShellRegion: 'uk', pageShellLanguage: 'en', edition: 'caribbean', ad: { site: 'espn.latam.mx' }, dateFormat: 'dateTime3' }, // Caribbean - Jamaica
    MQ: { pageShellRegion: 'uk', pageShellLanguage: 'en', edition: 'caribbean', ad: { site: 'espn.latam.mx' }, dateFormat: 'dateTime3' }, // Caribbean - Martinique
    LC: { pageShellRegion: 'uk', pageShellLanguage: 'en', edition: 'caribbean', ad: { site: 'espn.latam.mx' }, dateFormat: 'dateTime3' }, // Caribbean - Saint Lucia
    MF: { pageShellRegion: 'uk', pageShellLanguage: 'en', edition: 'caribbean', ad: { site: 'espn.latam.mx' }, dateFormat: 'dateTime3' }, // Caribbean - Saint Martin (French part)
    VC: { pageShellRegion: 'uk', pageShellLanguage: 'en', edition: 'caribbean', ad: { site: 'espn.latam.mx' }, dateFormat: 'dateTime3' }, // Caribbean - Saint Vincent and the Grenadines
    SR: { pageShellRegion: 'uk', pageShellLanguage: 'en', edition: 'caribbean', ad: { site: 'espn.latam.mx' }, dateFormat: 'dateTime3' }, // Caribbean - Suriname
    VG: { pageShellRegion: 'uk', pageShellLanguage: 'en', edition: 'caribbean', ad: { site: 'espn.latam.mx' }, dateFormat: 'dateTime3' }, // Caribbean - Virgin Islands (British)
    BQ: { pageShellRegion: 'uk', pageShellLanguage: 'en', edition: 'caribbean', ad: { site: 'espn.latam.mx' }, dateFormat: 'dateTime3' }, // Caribbean - Bonaire
    CW: { pageShellRegion: 'uk', pageShellLanguage: 'en', edition: 'caribbean', ad: { site: 'espn.latam.mx' }, dateFormat: 'dateTime3' }, // Caribbean - Curacao
    MS: { pageShellRegion: 'uk', pageShellLanguage: 'en', edition: 'caribbean', ad: { site: 'espn.latam.mx' }, dateFormat: 'dateTime3' }, // Caribbean - Montserrat
    BL: { pageShellRegion: 'uk', pageShellLanguage: 'en', edition: 'caribbean', ad: { site: 'espn.latam.mx' }, dateFormat: 'dateTime3' }, // Caribbean - Saint Barthelemy
    KN: { pageShellRegion: 'uk', pageShellLanguage: 'en', edition: 'caribbean', ad: { site: 'espn.latam.mx' }, dateFormat: 'dateTime3' }, // Caribbean - St Kitts and Nevis
    SX: { pageShellRegion: 'uk', pageShellLanguage: 'en', edition: 'caribbean', ad: { site: 'espn.latam.mx' }, dateFormat: 'dateTime3' }, // Caribbean - St Maarten
    TT: { pageShellRegion: 'uk', pageShellLanguage: 'en', edition: 'caribbean', ad: { site: 'espn.latam.mx' }, dateFormat: 'dateTime3' }, // Caribbean - Trinidad and Tobago
    TC: { pageShellRegion: 'uk', pageShellLanguage: 'en', edition: 'caribbean', ad: { site: 'espn.latam.mx' }, dateFormat: 'dateTime3' }, // Caribbean - Turks and Caicos
    AU: { pageShellRegion: 'au', pageShellLanguage: 'en', edition: 'anzl', ad: { site: 'espn.au' }, dateFormat: 'dateTime2' }, // Australia
    NZ: { pageShellRegion: 'au', pageShellLanguage: 'en', edition: 'anzl', ad: { site: 'espn.au' }, dateFormat: 'dateTime2' }, // New Zealand
    NL: { pageShellRegion: 'nl', pageShellLanguage: 'nl', edition: 'nl', ad: { site: 'espn.nl' }, dateFormat: 'dateTime3' }, // Netherlands
    // ?? Deportes - US
    US: { pageShellRegion: 'us', pageShellLanguage: 'en', edition: 'us', ad: { site: 'espn.com' }, dateFormat: 'dateTime2' }
};

/* harmony default export */ var i18n_editionMap = (editionMap);

function getEdition(countryCode) {
    return editionMap[countryCode] || editionMap['US'];
}

function getFaqUrl(edition, faqUrlsFromConfig) {
    // Default to hardcoded faq urls if external app-configurations is not available via bootstrap selector
    if (!faqUrlsFromConfig || !faqUrlsFromConfig[edition]) {
        return faqMap[edition] || faqMap['us'];
    }

    return faqUrlsFromConfig[edition];
}

function getAdEdition(countryCode) {
    var _getEdition = getEdition(countryCode),
        pageShellRegion = _getEdition.pageShellRegion,
        edition = _getEdition.edition;

    if (edition === 'caribbean') {
        return 'mx';
    }
    return pageShellRegion;
}
// EXTERNAL MODULE: ./app/lib/format/queryString.js
var queryString = __webpack_require__(18);

// EXTERNAL MODULE: ./app/lib/util/getUpsellUrlsConfigByEdition.js
var getUpsellUrlsConfigByEdition = __webpack_require__(307);

// EXTERNAL MODULE: ./app/common/selectors/bootstrapSelector.js
var bootstrapSelector = __webpack_require__(29);

// EXTERNAL MODULE: ./app/common/selectors/routingSelector.js
var routingSelector = __webpack_require__(23);

// EXTERNAL MODULE: ./app/common/selectors/whitelistSelector.js + 1 modules
var whitelistSelector = __webpack_require__(308);

// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__(16);
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// EXTERNAL MODULE: ./config/appNames.js
var appNames = __webpack_require__(309);
var appNames_default = /*#__PURE__*/__webpack_require__.n(appNames);

// CONCATENATED MODULE: ./app/common/selectors/appSelector.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return adobePassEnvSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return apiEnvSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return configEnvSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return countrySelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return editionSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return isDomesticSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return isIntlSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return faqUrlSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return adEditionSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return playbackMetaSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return dateFormatSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return upcomingScheduleDateFormatSelector; });
/* unused harmony export appNameSelector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return isESPNAppSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return webviewSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return hasPageShellSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return enableSearchSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return oneIdEnvSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return ssrSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return roadblockSelector; });
/* unused harmony export unsupportedErrorSelector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return playerTechSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return intlSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return contentIdInPlayerUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return hideNavSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return intlAppSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return bypassTokenSelector; });
/* unused harmony export isSyndicatedPlayerSelector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return packageFilterSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return isSecureSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return isAdDisabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return showDMVPDUpsellSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return locationSelector; });
/* unused harmony export isLegacyAppSelector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return apiVersionSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return upsellUrlSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return newRelicTrackingSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return showOneIdLoginSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return showHelpModuleSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return playerOptionsSelector; });












var appSelector = function appSelector(_ref) {
    var _ref$app = _ref.app,
        app = _ref$app === undefined ? {} : _ref$app;
    return app;
};

/* harmony default export */ var selectors_appSelector = __webpack_exports__["j"] = (Object(lib["createSelector"])(appSelector, function (app) {
    return app;
}));

var adobePassEnvSelector = Object(lib["createSelector"])(appSelector, function (_ref2) {
    var adobePassEnv = _ref2.adobePassEnv;
    return adobePassEnv;
});

var apiEnvSelector = Object(lib["createSelector"])(appSelector, function (_ref3) {
    var apiEnv = _ref3.apiEnv;
    return apiEnv;
});

var configEnvSelector = Object(lib["createSelector"])(appSelector, function (_ref4) {
    var configEnv = _ref4.configEnv;
    return configEnv;
});

var countrySelector = Object(lib["createSelector"])(appSelector, function (_ref5) {
    var country = _ref5.country;
    return country;
});

var editionSelector = Object(lib["createSelector"])(countrySelector, function (country) {
    return getEdition(country);
});

var isDomesticSelector = Object(lib["createSelector"])(countrySelector, function (country) {
    return country === 'US';
});

var isIntlSelector = Object(lib["createSelector"])(isDomesticSelector, function (isDomestic) {
    return !isDomestic;
});

var faqUrlSelector = Object(lib["createSelector"])(editionSelector, bootstrapSelector["a" /* default */], function (_ref6, _ref7) {
    var edition = _ref6.edition;
    var faqUrls = _ref7.faqUrls;
    return getFaqUrl(edition, faqUrls);
});

var adEditionSelector = Object(lib["createSelector"])(countrySelector, function (country) {
    return getAdEdition(country);
});

var playbackMetaSelector = Object(lib["createSelector"])(appSelector, function (_ref8) {
    var playbackMeta = _ref8.playbackMeta;
    return playbackMeta;
});

// Use format from config if available, otherwise choose based on domestic/intl
var dateFormatSelector = Object(lib["createSelector"])(countrySelector, isIntlSelector, function (country, isIntl) {
    return getEdition(country).dateFormat || isIntl && 'dateTime3' || 'dateTime2';
});

// For isIntl, format the date as `Weekday, number de month`; default to `dddd, MMMM Do`
var upcomingScheduleDateFormatSelector = Object(lib["createSelector"])(isIntlSelector, function (isIntl) {
    return isIntl && 'date15' || 'date10';
});

var appNameSelector = Object(lib["createSelector"])(appSelector, function (_ref9) {
    var appName = _ref9.appName;
    return appName;
});

var isESPNAppSelector = Object(lib["createSelector"])(appSelector, function (_ref10) {
    var appName = _ref10.appName;
    return appName === appNames_default.a.ESPNAPP;
});

var webviewSelector = Object(lib["createSelector"])(appSelector, isESPNAppSelector, function (_ref11, isESPNApp) {
    var webview = _ref11.webview;
    return webview || isESPNApp;
});

var hasPageShellSelector = Object(lib["createSelector"])(appSelector, function (_ref12) {
    var renderTemplateType = _ref12.renderTemplateType;
    return renderTemplateType === enums["C" /* RenderTemplateTypes */].PAGE_SHELL;
});

// Enable Search if query param search=true OR if set to true in config AND is domestic edition
var enableSearchSelector = Object(lib["createSelector"])(appSelector, isDomesticSelector, function (_ref13, isDomestic) {
    var appName = _ref13.appName,
        enableSearch = _ref13.enableSearch;
    return enableSearch || config_default.a.enableSearch && isDomestic && appName !== appNames_default.a.ESPNAPP;
});

var oneIdEnvSelector = Object(lib["createSelector"])(appSelector, function (_ref14) {
    var _ref14$location$query = _ref14.location.query,
        query = _ref14$location$query === undefined ? {} : _ref14$location$query;
    return query[enums["t" /* Flags */].ONEID_ENV] || enums["x" /* OneIdEnv */].PROD;
});

// FIXME: feedback page fails to populate intl providers on the server, fetching it client side
// Turn off SSR on Sched page to get localized date/times
var ssrSelector = Object(lib["createSelector"])(appSelector, function (_ref15) {
    var appName = _ref15.appName,
        _ref15$location = _ref15.location;
    _ref15$location = _ref15$location === undefined ? {} : _ref15$location;
    var _ref15$location$query = _ref15$location.query,
        query = _ref15$location$query === undefined ? {} : _ref15$location$query,
        _ref15$location$path = _ref15$location.path,
        path = _ref15$location$path === undefined ? '' : _ref15$location$path;
    return query[enums["t" /* Flags */].SSR] !== false && (appName !== appNames_default.a.ESPNAPP && path.indexOf('schedule') === -1 || path.indexOf('choose-provider') !== -1);
});

var roadblockSelector = Object(lib["createSelector"])(appSelector, isIntlSelector, whitelistSelector["a" /* default */], webviewSelector, function (_ref16, isIntl, inWhitelist, isWebview) {
    var _ref16$isMobile = _ref16.isMobile,
        isMobile = _ref16$isMobile === undefined ? false : _ref16$isMobile,
        options = _ref16.options,
        _ref16$location = _ref16.location;
    _ref16$location = _ref16$location === undefined ? {} : _ref16$location;
    var _ref16$location$query = _ref16$location.query,
        query = _ref16$location$query === undefined ? {} : _ref16$location$query;

    // don't roadblock some lucky people
    if (inWhitelist || isWebview || isIntl) {
        return false;
    }

    if (query && query[enums["t" /* Flags */].ROADBLOCK] !== undefined) {
        return query[enums["t" /* Flags */].ROADBLOCK];
    }

    if (options && options[enums["t" /* Flags */].ROADBLOCK] !== undefined) {
        return options[enums["t" /* Flags */].ROADBLOCK];
    }

    return isMobile;
});

var unsupportedErrorSelector = Object(lib["createSelector"])(appSelector, function (_ref17) {
    var appName = _ref17.appName,
        _ref17$location = _ref17.location;
    _ref17$location = _ref17$location === undefined ? {} : _ref17$location;
    var _ref17$location$query = _ref17$location.query,
        query = _ref17$location$query === undefined ? {} : _ref17$location$query,
        _ref17$location$path = _ref17$location.path,
        path = _ref17$location$path === undefined ? '' : _ref17$location$path;

    if (query && query[enums["t" /* Flags */].UNSUPPORTED_ERROR] !== undefined && appName !== appNames_default.a.ESPNAPP && path.indexOf('unsupported') === -1) {
        return query[enums["t" /* Flags */].UNSUPPORTED_ERROR];
    }

    return false;
});

var playerTechSelector = Object(lib["createSelector"])(appSelector, isIntlSelector, whitelistSelector["a" /* default */], function (_ref18, isIntl, inWhitelist) {
    var options = _ref18.options,
        _ref18$location = _ref18.location;
    _ref18$location = _ref18$location === undefined ? {} : _ref18$location;
    var _ref18$location$query = _ref18$location.query,
        query = _ref18$location$query === undefined ? {} : _ref18$location$query;

    // always let some lucky people get brightcove player
    if (inWhitelist || isIntl) {
        return 'brightcove';
    }

    // Supports assigning the playertech via query param `playertech=native || playertech=brightcove`
    if (query && query[enums["t" /* Flags */].PLAYER_TECH] !== undefined) {
        return query[enums["t" /* Flags */].PLAYER_TECH];
    }

    if (options && options[enums["t" /* Flags */].PLAYER_TECH] !== undefined) {
        return options[enums["t" /* Flags */].PLAYER_TECH];
    }

    return 'brightcove';
});

var intlSelector = Object(lib["createSelector"])(appSelector, function (_ref19) {
    var lang = _ref19.lang,
        messages = _ref19.messages;
    return { lang: lang, messages: messages };
});

var contentIdInPlayerUrl = Object(lib["createSelector"])(routingSelector["a" /* default */], function (_ref20) {
    var locationBeforeTransitions = _ref20.locationBeforeTransitions;

    var id = null;

    var _ref21 = locationBeforeTransitions || {},
        _ref21$pathname = _ref21.pathname,
        pathname = _ref21$pathname === undefined ? '' : _ref21$pathname,
        _ref21$query = _ref21.query,
        query = _ref21$query === undefined ? {} : _ref21$query;

    if (pathname === '/' || pathname === '/player') {
        id = query.id || query.eventId;
        if (!id && pathname === '/player') {
            return true; // Return true to indicate on player page w/o ID
        }
    }
    return id;
});

var hideNavSelector = Object(lib["createSelector"])(appSelector, function (_ref22) {
    var _ref22$location = _ref22.location;
    _ref22$location = _ref22$location === undefined ? {} : _ref22$location;
    var _ref22$location$query = _ref22$location.query,
        query = _ref22$location$query === undefined ? {} : _ref22$location$query;
    return query && query[enums["t" /* Flags */].HIDENAV] || false;
});

var intlAppSelector = Object(lib["createSelector"])(hideNavSelector, isIntlSelector, function (hideNav, isIntl) {
    return hideNav && isIntl;
});

var bypassTokenSelector = Object(lib["createSelector"])(appSelector, function (_ref23) {
    var _ref23$location = _ref23.location;
    _ref23$location = _ref23$location === undefined ? {} : _ref23$location;
    var _ref23$location$query = _ref23$location.query,
        query = _ref23$location$query === undefined ? {} : _ref23$location$query;
    return query && query[enums["t" /* Flags */].BYPASS_TOKEN];
});

var isSyndicatedPlayerSelector = Object(lib["createSelector"])(appSelector, function (_ref24) {
    var _ref24$location = _ref24.location;
    _ref24$location = _ref24$location === undefined ? {} : _ref24$location;
    var _ref24$location$path = _ref24$location.path,
        path = _ref24$location$path === undefined ? '' : _ref24$location$path;
    return path.indexOf('/syndicated/player') > -1;
});

var packageFilterSelector = Object(lib["createSelector"])(isSyndicatedPlayerSelector, function (isSyndicatedPlayer) {
    return !isSyndicatedPlayer;
});

var isSecureSelector = Object(lib["createSelector"])(appSelector, function (_ref25) {
    var _ref25$location = _ref25.location;
    _ref25$location = _ref25$location === undefined ? {} : _ref25$location;
    var protocol = _ref25$location.protocol,
        _ref25$location$path = _ref25$location.path,
        path = _ref25$location$path === undefined ? '' : _ref25$location$path;
    return protocol === 'https' || path.indexOf('/activate') !== -1;
});

var isAdDisabled = webviewSelector;

var showDMVPDUpsellSelector = Object(lib["createSelector"])(isDomesticSelector, editionSelector, function (isDomestic, _ref26) {
    var edition = _ref26.edition;
    return isDomestic || edition === 'brazil' && !isDomestic;
});

// returns the equivalent of `window.location` key/value pairs plus `query` which works universally
var locationSelector = Object(lib["createSelector"])(appSelector, routingSelector["a" /* default */], function (_ref27, _ref28) {
    var _ref27$location = _ref27.location;
    _ref27$location = _ref27$location === undefined ? {} : _ref27$location;
    var baseUrl = _ref27$location.baseUrl,
        host = _ref27$location.host,
        path = _ref27$location.path,
        protocolArg = _ref27$location.protocol,
        _ref27$location$query = _ref27$location.query,
        query = _ref27$location$query === undefined ? {} : _ref27$location$query;
    var hash = _ref28.locationBeforeTransitions.hash;

    var tmp = host.split(':');
    var hostname = tmp[0];
    var port = tmp[1];
    var protocol = protocolArg + ':';
    var origin = protocol + '//' + host;
    var pathname = '' + baseUrl + path;
    var search = Object(queryString["a" /* default */])(query, true);
    var href = '' + origin + pathname + search + hash;
    return {
        host: host,
        hostname: hostname,
        port: port,
        protocol: protocol,
        origin: origin,
        pathname: pathname,
        search: search,
        href: href,
        hash: hash,
        query: query
    };
});

var isLegacyAppSelector = Object(lib["createSelector"])(isESPNAppSelector, routingSelector["a" /* default */], function (isESPNApp, _ref29) {
    var _ref29$locationBefore = _ref29.locationBeforeTransitions.query;
    _ref29$locationBefore = _ref29$locationBefore === undefined ? {} : _ref29$locationBefore;
    var version = _ref29$locationBefore.version,
        appversion = _ref29$locationBefore.appversion;

    var ver = version || appversion; // `version` is for Android, `appversion` is for iOS
    return isESPNApp && ver && ver.indexOf('5') === 0;
});

var apiVersionSelector = Object(lib["createSelector"])(isLegacyAppSelector, function (isLegacyApp) {
    return isLegacyApp ? 'v1' : 'v3';
});

var upsellUrlSelector = Object(lib["createSelector"])(isESPNAppSelector, bootstrapSelector["a" /* default */], editionSelector, function (isESPNApp, _ref30, _ref31) {
    var _ref30$upsellUrls = _ref30.upsellUrls,
        upsellUrls = _ref30$upsellUrls === undefined ? {} : _ref30$upsellUrls;
    var edition = _ref31.edition;

    var upsellUrlsMap = Object(getUpsellUrlsConfigByEdition["a" /* default */])(edition, upsellUrls);

    if (upsellUrlsMap.mobile && upsellUrlsMap.desktop) {
        return isESPNApp ? upsellUrlsMap.mobile : upsellUrlsMap.desktop;
    }
    // default url if not found in config
    return 'http://www.espninstantaccess.com';
});

var newRelicTrackingSelector = Object(lib["createSelector"])(bootstrapSelector["a" /* default */], function (_ref32) {
    var _ref32$newrelic = _ref32.newrelic;
    _ref32$newrelic = _ref32$newrelic === undefined ? {} : _ref32$newrelic;
    var trackingOn = _ref32$newrelic.trackingOn;
    return trackingOn || false;
});

var showOneIdLoginSelector = Object(lib["createSelector"])(appSelector, function (_ref33) {
    var _ref33$location = _ref33.location;
    _ref33$location = _ref33$location === undefined ? {} : _ref33$location;
    var _ref33$location$query = _ref33$location.query;
    _ref33$location$query = _ref33$location$query === undefined ? {} : _ref33$location$query;
    var _ref33$location$query2 = _ref33$location$query.login,
        login = _ref33$location$query2 === undefined ? false : _ref33$location$query2;
    return login;
});

var showHelpModuleSelector = Object(lib["createSelector"])(bootstrapSelector["a" /* default */], function (_ref34) {
    var _ref34$activate = _ref34.activate;
    _ref34$activate = _ref34$activate === undefined ? {} : _ref34$activate;
    var _ref34$activate$helpM = _ref34$activate.helpModuleOn,
        helpModuleOn = _ref34$activate$helpM === undefined ? true : _ref34$activate$helpM;
    return helpModuleOn;
});

var playerOptionsSelector = Object(lib["createSelector"])(bootstrapSelector["a" /* default */], function (_ref35) {
    var _ref35$player = _ref35.player;
    _ref35$player = _ref35$player === undefined ? {} : _ref35$player;
    var _ref35$player$options = _ref35$player.options,
        options = _ref35$player$options === undefined ? {} : _ref35$player$options;
    return options;
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}
// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(177);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/PropTypes.js

var subscriptionShape = prop_types_default.a.shape({
  trySubscribe: prop_types_default.a.func.isRequired,
  tryUnsubscribe: prop_types_default.a.func.isRequired,
  notifyNestedSubs: prop_types_default.a.func.isRequired,
  isSubscribed: prop_types_default.a.func.isRequired
});
var storeShape = prop_types_default.a.shape({
  subscribe: prop_types_default.a.func.isRequired,
  dispatch: prop_types_default.a.func.isRequired,
  getState: prop_types_default.a.func.isRequired
});
// EXTERNAL MODULE: ./node_modules/react-redux/es/utils/warning.js
var warning = __webpack_require__(178);

// CONCATENATED MODULE: ./node_modules/react-redux/es/components/Provider.js





var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  Object(warning["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return react["Children"].only(this.props.children);
    };

    return Provider;
  }(react["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: storeShape.isRequired,
    children: prop_types_default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = storeShape.isRequired, _Provider$childContex[subscriptionKey] = subscriptionShape, _Provider$childContex);
  return Provider;
}
/* harmony default export */ var components_Provider = (createProvider());
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
// EXTERNAL MODULE: ./node_modules/react-redux/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(477);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);

// EXTERNAL MODULE: ./node_modules/invariant/browser.js
var browser = __webpack_require__(25);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);

// EXTERNAL MODULE: ./node_modules/react-is/index.js
var react_is = __webpack_require__(179);
var react_is_default = /*#__PURE__*/__webpack_require__.n(react_is);

// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/Subscription.js
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();


// CONCATENATED MODULE: ./node_modules/react-redux/es/components/connectAdvanced.js










var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = _objectWithoutPropertiesLoose(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = storeShape, _contextTypes[subscriptionKey] = subscriptionShape, _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = subscriptionShape, _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    browser_default()(Object(react_is["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      _inheritsLoose(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_assertThisInitialized(_assertThisInitialized(_this)));
        browser_default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        browser_default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new Subscription(this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = _extends({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(react["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(react["Component"]);
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return hoist_non_react_statics_cjs_default()(Connect, WrappedComponent);
  };
}
// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/shallowEqual.js
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}
// EXTERNAL MODULE: ./node_modules/redux/es/index.js + 14 modules
var es = __webpack_require__(180);

// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/isPlainObject.js
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}
// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/verifyPlainObject.js


function verifyPlainObject_verifyPlainObject(value, displayName, methodName) {
  if (!isPlainObject(value)) {
    Object(warning["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}
// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/wrapMapToProps.js

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}
// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mapDispatchToProps.js


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? wrapMapToPropsFunc(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? wrapMapToPropsConstant(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? wrapMapToPropsConstant(function (dispatch) {
    return Object(es["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ var connect_mapDispatchToProps = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);
// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mapStateToProps.js

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? wrapMapToPropsFunc(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? wrapMapToPropsConstant(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ var connect_mapStateToProps = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);
// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mergeProps.js


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ var connect_mergeProps = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);
// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/verifySubselectors.js


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(warning["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors_verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}
// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/selectorFactory.js


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutPropertiesLoose(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/connect.js








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? connectAdvanced : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? connect_mapStateToProps : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? connect_mapDispatchToProps : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? connect_mergeProps : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? finalPropsSelectorFactory : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? shallowEqual : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? shallowEqual : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? shallowEqual : _ref3$areMergedPropsE,
        extraOptions = _objectWithoutPropertiesLoose(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ var connect_connect = (createConnect());
// CONCATENATED MODULE: ./node_modules/react-redux/es/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return components_Provider; });
/* unused concated harmony import createProvider */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return createProvider; });
/* unused concated harmony import connectAdvanced */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return connectAdvanced; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return connect_connect; });





/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(37);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GRAPHQL_API_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SHIELD_API_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return MVPD_PREVIOUS_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GEO_LOCATION_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SUB_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SESSION_TOKEN_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return USER_TRACKING_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return PREAUTH_LOCALSTORAGE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FORCE_REFRESH_TOKEN_RETRY_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return PRODUCT_API_CONFIGURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GRAPHQL_API_CONFIGURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return LISTINGS_API_CONFIGURATION; });
/* unused harmony export xDeviceMap */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return unknownAuthStates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return clientRenderRoutes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return NO_CATEGORY_ID_MAPPINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return loadingImageUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return loadingImageUrlDark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return secureLoadingImageUrl; });
/* unused harmony export secureLoadingImageUrlDark */
/* unused harmony export promoImageUrl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return securePromoImageUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return notFoundUrl; });
/* unused harmony export UPCOMING_MINUTES_WINDOW */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BAM_PROXY_IFRAME_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BAM_PROMO_IFRAME_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BAM_PAYWALL_IFRAME_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return dotComNielsenData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return NIELSEN_APPID_EPLUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return NIELSEN_APPID_TVE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config__);



var secureCdnHost = __WEBPACK_IMPORTED_MODULE_1__config___default.a.secureCdnHost,
    cdnHost = __WEBPACK_IMPORTED_MODULE_1__config___default.a.cdnHost;


var GRAPHQL_API_KEY = '0dbf88e8-cc6d-41da-aa83-18b5c630bc5c';
var SHIELD_API_KEY = '5p8m6dw513q716wt2os04mec3';

var MVPD_PREVIOUS_KEY = '@watch:MVPD_PREVIOUS';
var GEO_LOCATION_KEY = '@watch:GEO_LOCATION';
var SUB_KEY = '@watch:SUB';
var SESSION_TOKEN_KEY = '@watch:SESSION_TOKEN';
var USER_TRACKING_KEY = '@watch:USER_TRACKING';
var PREAUTH_LOCALSTORAGE_KEY = '@watch:PREAUTHZ';
var FORCE_REFRESH_TOKEN_RETRY_KEY = '@watch:TOKEN_REFRESH_RETRY';
var PRODUCT_API_CONFIGURATION = {
    dev: {
        serviceUrl: '//watch.product.api.espnsb.com',
        internalServiceUrl: '//watch.product.api.espnsb.com'
    },
    qa: {
        serviceUrl: '//watch.product.api.espnqa.com',
        internalServiceUrl: '//watch.product.api.espnqa.com'
    },
    staging: {
        serviceUrl: '//watch.product.api.preview.espn.com',
        internalServiceUrl: '//watch.product.api.preview.espn.com'
    },
    prod: {
        serviceUrl: '//watch.product.api.espn.com',
        internalServiceUrl: '//watchproductapi.prod.internal.geo.espn.com'
    }
};

var GRAPHQL_API_CONFIGURATION = {
    dev: {
        serviceUrl: '//watch.graph.api.espnsb.com'
    },
    qa: {
        serviceUrl: '//watch.graph.api.espnqa.com'
    },
    staging: {
        serviceUrl: '//watch.graph.api.preview.espn.com'
    },
    prod: {
        serviceUrl: '//watch.graph.api.espn.com'
    }
};

var LISTINGS_API_CONFIGURATION = {
    dev: {
        serviceUrl: '//broadband.espnqa.com/espn360/apis/v1/watch',
        internalServiceUrl: '//broadband.espnqa.com/espn360/apis/v1/watch'
    },
    qa: {
        serviceUrl: '//api-app.espn.com/v1/watch',
        internalServiceUrl: '//api-app.espn.com/espn360/apis/v1/watch'
    },
    staging: {
        serviceUrl: '//api-app.espn.com/v1/watch',
        internalServiceUrl: '//api-app.espn.com/espn360/apis/v1/watch'
    },
    prod: {
        serviceUrl: '//api-app.espn.com/v1/watch',
        internalServiceUrl: '//api-app.espn.com/espn360/apis/v1/watch'
    }
};

// list of varnish x-deivce values
// https://github.disney.com/SEESPN/seespn_varnish/blob/4257d10478d4556183497914c22157aa08761613/files/default/etc/varnish/vcl/device.vcl#L50
// Map of X-Device values to supports device values of PageAPI
var xDeviceMap = {
    pc: __WEBPACK_IMPORTED_MODULE_0__enums__["q" /* Device */].DESKTOP,
    'pc-generic': __WEBPACK_IMPORTED_MODULE_0__enums__["q" /* Device */].DESKTOP,
    handset: __WEBPACK_IMPORTED_MODULE_0__enums__["q" /* Device */].HANDSET,
    mobile: __WEBPACK_IMPORTED_MODULE_0__enums__["q" /* Device */].HANDSET,
    'mobile-generic': __WEBPACK_IMPORTED_MODULE_0__enums__["q" /* Device */].HANDSET,
    'mobile-smartphone': __WEBPACK_IMPORTED_MODULE_0__enums__["q" /* Device */].HANDSET,
    tablet: __WEBPACK_IMPORTED_MODULE_0__enums__["q" /* Device */].TABLET
};

var unknownAuthStates = ['unknown_' + __WEBPACK_IMPORTED_MODULE_0__enums__["e" /* AuthTypes */].ISP, 'unknown_' + __WEBPACK_IMPORTED_MODULE_0__enums__["e" /* AuthTypes */].MVPD, 'unknown_' + __WEBPACK_IMPORTED_MODULE_0__enums__["s" /* Entitlements */].ESPN_PLUS, 'unknown_' + __WEBPACK_IMPORTED_MODULE_0__enums__["s" /* Entitlements */].ESPN_PLUS_NHL, 'unknown_' + __WEBPACK_IMPORTED_MODULE_0__enums__["s" /* Entitlements */].ESPN_PLUS_MLB];

var clientRenderRoutes = ['home', 'espnplus', 'product'];

var NO_CATEGORY_ID_MAPPINGS = {
    pt: 'outros',
    en: 'others',
    es: 'otros'
};

var loadingImageUrl = cdnHost + '/watchespn/images/espn-watch-placeholder.png';
var loadingImageUrlDark = cdnHost + '/watchespn/images/espn-watch-placeholder-dark.png';
var secureLoadingImageUrl = secureCdnHost + '/watchespn/images/espn-watch-placeholder.png';
var secureLoadingImageUrlDark = secureCdnHost + '/watchespn/images/espn-watch-placeholder-dark.png';
var promoImageUrl = cdnHost + '/watchespn/images/watch-promotional.jpg';
var securePromoImageUrl = secureCdnHost + '/watchespn/images/watch-promotional.jpg';
var notFoundUrl = 'https://www.espn.com/404';

var UPCOMING_MINUTES_WINDOW = 30;

var BAM_PROXY_IFRAME_ID = 'bam-proxy-iframe';
var BAM_PROMO_IFRAME_ID = 'bam-promo-iframe';
var BAM_PAYWALL_IFRAME_ID = 'bam-paywall-iframe';

var dotComNielsenData = {
    espnuk: {
        apid: 'P07264C85-15CD-4A80-8E56-B5BFA6D93296',
        vc: 'b01'
    },
    general: {
        ci: 'us-600140',
        assetid: 'N/A',
        segB: 'N/A',
        sfcode: 'dcr',
        segA: 'N/A',
        section: 'N/A',
        segC: 'N/A',
        apn: 'espnCOM'
    },
    espnza: {
        apid: 'P07264C85-15CD-4A80-8E56-B5BFA6D93296',
        vc: 'b01'
    },
    espnau: {
        apid: 'P07264C85-15CD-4A80-8E56-B5BFA6D93296',
        vc: 'b01'
    },
    espn: {
        apid: 'P07264C85-15CD-4A80-8E56-B5BFA6D93296',
        vc: 'b01'
    },
    espnin: {
        apid: 'P07264C85-15CD-4A80-8E56-B5BFA6D93296',
        vc: 'b01'
    },
    fantasy: {
        apid: 'P302B69D5-F1DD-4E7A-BF8D-3E60F0EB5E5A',
        vc: 'c07'
    },
    watchespn: {
        apid: 'P07264C85-15CD-4A80-8E56-B5BFA6D93296',
        vc: 'b01'
    },
    espndeportes: {
        apid: 'P890E2723-EDBC-4CCE-96BA-F35EA3E50650',
        vc: 'c02'
    },
    espnfc: {
        apid: 'PE6995AAE-0C49-4372-B5E7-54C61BFE2AA5',
        vc: 'c03'
    },
    cricinfo: {
        apid: 'PED8CDAC2-F114-41BE-8B98-AFA06FAEA06E',
        vc: 'c04'
    }
};

var NIELSEN_APPID_EPLUS = 'P3AB2D9A0-5877-41BF-A1AB-D0D590F79234';
var NIELSEN_APPID_TVE = 'P31187EE2-AC6E-46CB-BB54-D07591BED067';

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function defaultEqualityCheck(a, b) {
  return a === b;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length <= 1 || arguments[1] === undefined ? defaultEqualityCheck : arguments[1];

  var lastArgs = null;
  var lastResult = null;
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (lastArgs === null || lastArgs.length !== args.length || !args.every(function (value, index) {
      return equalityCheck(value, lastArgs[index]);
    })) {
      lastResult = func.apply(undefined, args);
    }
    lastArgs = args;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len2 = arguments.length, memoizeOptions = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    memoizeOptions[_key2 - 1] = arguments[_key2];
  }

  return function () {
    for (var _len3 = arguments.length, funcs = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      funcs[_key3] = arguments[_key3];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      return resultFunc.apply(undefined, arguments);
    }].concat(memoizeOptions));

    var selector = function selector(state, props) {
      for (var _len4 = arguments.length, args = Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
        args[_key4 - 2] = arguments[_key4];
      }

      var params = dependencies.map(function (dependency) {
        return dependency.apply(undefined, [state, props].concat(args));
      });
      return memoizedResultFunc.apply(undefined, _toConsumableArray(params));
    };

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length <= 1 || arguments[1] === undefined ? createSelector : arguments[1];

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len5 = arguments.length, values = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      values[_key5] = arguments[_key5];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {/* unused harmony export convertToSecureImage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return authenticationEnabledSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return authenticationSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return userAuthSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return adobePassSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return adobePassInfoSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return adobePassMetadataSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return adobePassInitializedSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return adobePassAuthenticatedSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return adobePassIsAuthorizedSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return checkAuthenticationCompleteSelector; });
/* unused harmony export ipSelector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ipInfoSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return userLocationSelector; });
/* unused harmony export bamSelector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return subscriptionsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return superBundleSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return bamSessionTokenSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return bamSubReadySelector; });
/* unused harmony export geoLocationSelector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return userTrackingSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return preauthorizedResourcesSelector; });
/* unused harmony export entitlementTokenSelector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return zipcodeSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return authStatesSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return passOneIdTokenSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__enums__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_util_localStorage__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_util_canUseDOM__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bootstrapSelector__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__appSelector__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__routingSelector__ = __webpack_require__(23);









// TODO: move this to `lib` once it's used in other places
function convertToSecureImage(provider) {
    if (!provider || !provider.images) {
        return provider;
    }
    return Object.keys(provider.images).reduce(function (acc, key) {
        var image = provider.images[key];
        if (image && image.href) {
            acc.images[key] = { href: image.href.replace('http://a.espncdn.com', 'https://secure.espncdn.com') };
        }
        return acc;
    }, provider);
}

var authenticationEnabledSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_6__appSelector__["D" /* roadblockSelector */], function (roadblock) {
    return !roadblock;
});

// generic auth selectors
var authenticationSelector = function authenticationSelector(_ref) {
    var _ref$authentication = _ref.authentication,
        authentication = _ref$authentication === undefined ? {} : _ref$authentication;
    return authentication;
};

var userAuthSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(authenticationSelector, __WEBPACK_IMPORTED_MODULE_6__appSelector__["e" /* bypassTokenSelector */], function (_ref2, bypassToken) {
    var _ref2$authTypes = _ref2.authTypes,
        authTypes = _ref2$authTypes === undefined ? [] : _ref2$authTypes;

    if (bypassToken) {
        return [__WEBPACK_IMPORTED_MODULE_2__enums__["e" /* AuthTypes */].ISP, __WEBPACK_IMPORTED_MODULE_2__enums__["e" /* AuthTypes */].MVPD];
    }

    return authTypes;
});

// adobe pass selectors
var adobePassSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(authenticationSelector, function (_ref3) {
    var _ref3$adobePass = _ref3.adobePass,
        adobePass = _ref3$adobePass === undefined ? {} : _ref3$adobePass;
    return adobePass;
});

var adobePassInfoSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(adobePassSelector, function (_ref4) {
    var _ref4$info = _ref4.info,
        info = _ref4$info === undefined ? null : _ref4$info;
    return convertToSecureImage(info);
});

var adobePassMetadataSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(adobePassSelector, function (_ref5) {
    var _ref5$metadata = _ref5.metadata,
        metadata = _ref5$metadata === undefined ? {} : _ref5$metadata;
    return metadata;
});

var adobePassInitializedSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(adobePassSelector, function (_ref6) {
    var _ref6$initialization = _ref6.initialization;
    _ref6$initialization = _ref6$initialization === undefined ? {} : _ref6$initialization;
    var completeTime = _ref6$initialization.completeTime;
    return !!completeTime;
});

var adobePassAuthenticatedSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(adobePassSelector, function (_ref7) {
    var isAuthenticated = _ref7.isAuthenticated;
    return !!isAuthenticated;
});

var adobePassIsAuthorizedSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(adobePassSelector, function (_ref8) {
    var isAuthorized = _ref8.isAuthorized;
    return !!isAuthorized;
});

var checkAuthenticationCompleteSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(adobePassSelector, function (_ref9) {
    var _ref9$checkAuthentica = _ref9.checkAuthentication;
    _ref9$checkAuthentica = _ref9$checkAuthentica === undefined ? {} : _ref9$checkAuthentica;
    var completeTime = _ref9$checkAuthentica.completeTime;
    return !!completeTime;
});

// ip selectors
var ipSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(authenticationSelector, function (_ref10) {
    var _ref10$ip = _ref10.ip,
        ip = _ref10$ip === undefined ? {} : _ref10$ip;
    return ip;
});

var ipInfoSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(ipSelector, function (_ref11) {
    var _ref11$info = _ref11.info,
        info = _ref11$info === undefined ? null : _ref11$info;
    return convertToSecureImage(info);
});

var userLocationSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(ipSelector, function (_ref12) {
    var _ref12$location = _ref12.location,
        location = _ref12$location === undefined ? {} : _ref12$location;
    return location;
});

// bam selectors
var bamSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(authenticationSelector, function (_ref13) {
    var _ref13$bam = _ref13.bam,
        bam = _ref13$bam === undefined ? {} : _ref13$bam;
    return bam;
});

var subscriptionsSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(bamSelector, function (_ref14) {
    var subscriptions = _ref14.subscriptions;
    return subscriptions;
});

var superBundleSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(subscriptionsSelector, function (subscriptions) {
    if (subscriptions && subscriptions.length) {
        return subscriptions.filter(function (sub) {
            return sub.isActive;
        }).some(function (sub) {
            // first test for the existance of the
            // bundle property and use it's value
            if ('bundle' in sub) {
                return sub.bundle;
            }

            // fall-back check for categoryCode of superbundle in products
            return sub.products.some(function (_ref15) {
                var categoryCodes = _ref15.categoryCodes;
                return categoryCodes && Array.isArray(categoryCodes) && categoryCodes.map(function (item) {
                    return item.toLowerCase();
                }).includes('superbundle');
            });
        });
    }
    return false;
});

var bamSessionTokenSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(bamSelector, function (_ref16) {
    var _ref16$session = _ref16.session;
    _ref16$session = _ref16$session === undefined ? {} : _ref16$session;
    var _ref16$session$token = _ref16$session.token,
        token = _ref16$session$token === undefined ? null : _ref16$session$token;
    return token;
});

var bamSubReadySelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(authenticationSelector, function (_ref17) {
    var _ref17$bamSubReady = _ref17.bamSubReady,
        bamSubReady = _ref17$bamSubReady === undefined ? false : _ref17$bamSubReady;
    return bamSubReady;
});

var geoLocationSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(bamSelector, function (_ref18) {
    var _ref18$geo = _ref18.geo,
        geo = _ref18$geo === undefined ? {} : _ref18$geo;
    return geo;
});

var userTrackingSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(bamSelector, function (_ref19) {
    var _ref19$userTracking = _ref19.userTracking,
        userTracking = _ref19$userTracking === undefined ? {} : _ref19$userTracking;
    return userTracking;
});

var preauthorizedResourcesSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(adobePassSelector, function (_ref20) {
    var preauthorizedResources = _ref20.preauthorizedResources;
    return preauthorizedResources;
});

var entitlementTokenSelector = function entitlementTokenSelector() {
    var entitlementToken = void 0;
    if (__WEBPACK_IMPORTED_MODULE_4__lib_util_canUseDOM__["a" /* default */]) {
        try {
            entitlementToken = window.localStorage.getItem('entitlementToken');
            if (entitlementToken) {
                entitlementToken = JSON.parse(entitlementToken);
            } else {
                entitlementToken = undefined;
            }
        } catch (err) {
            console.error(err);
        }
    }
    return entitlementToken;
};

var zipcodeSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(geoLocationSelector, userLocationSelector, function (_ref21, _ref22) {
    var zipCode = _ref21.zipCode;
    var zipcode = _ref22.zipcode;
    return zipCode || zipcode;
});

var authStatesSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(userAuthSelector, entitlementTokenSelector, function (userAuth) {
    var entitlementToken = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var authStates = void 0;
    var prevMVPDState = Object(__WEBPACK_IMPORTED_MODULE_3__lib_util_localStorage__["a" /* get */])(__WEBPACK_IMPORTED_MODULE_1__constants__["i" /* MVPD_PREVIOUS_KEY */]);
    var currMVPDState = entitlementToken.mvpd;
    var ispState = userAuth.filter(function (auth) {
        return auth === __WEBPACK_IMPORTED_MODULE_2__enums__["e" /* AuthTypes */].ISP;
    })[0];
    if (prevMVPDState) {
        authStates = [__WEBPACK_IMPORTED_MODULE_2__enums__["d" /* AuthStates */].MVPD_PREVIOUS];
    }
    if (currMVPDState) {
        if (!authStates) {
            authStates = [];
        }
        authStates.push(__WEBPACK_IMPORTED_MODULE_2__enums__["d" /* AuthStates */].MVPD);
    }
    if (ispState) {
        if (!authStates) {
            authStates = [];
        }
        authStates.push(__WEBPACK_IMPORTED_MODULE_2__enums__["d" /* AuthStates */].ISP);
    }
    return authStates;
});

var passOneIdTokenSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_5__bootstrapSelector__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__routingSelector__["a" /* default */], function (_ref23, _ref24) {
    var _ref23$bam = _ref23.bam;
    _ref23$bam = _ref23$bam === undefined ? {} : _ref23$bam;
    var _ref23$bam$passToken = _ref23$bam.passToken,
        passTokenArg = _ref23$bam$passToken === undefined ? true : _ref23$bam$passToken;
    var locationBeforeTransitions = _ref24.locationBeforeTransitions;

    var passToken = passTokenArg;

    var _ref25 = locationBeforeTransitions || {},
        _ref25$query = _ref25.query,
        query = _ref25$query === undefined ? {} : _ref25$query;

    if (query[__WEBPACK_IMPORTED_MODULE_2__enums__["t" /* Flags */].PASS_ONEID_TOKEN]) {
        passToken = query[__WEBPACK_IMPORTED_MODULE_2__enums__["t" /* Flags */].PASS_ONEID_TOKEN] === 'true';
    }
    return passToken;
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, console, global, setImmediate) {/* @preserve
 * The MIT License (MIT)
 * 
 * Copyright (c) 2013-2017 Petka Antonov
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 * 
 */
/**
 * bluebird build version 3.5.0
 * Features enabled: core, race, call_get, generators, map, nodeify, promisify, props, reduce, settle, some, using, timers, filter, any, each
*/
!function(e){if(true)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{var f;"undefined"!=typeof window?f=window:"undefined"!=typeof global?f=global:"undefined"!=typeof self&&(f=self),f.Promise=e()}}(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof _dereq_=="function"&&_dereq_;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof _dereq_=="function"&&_dereq_;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var SomePromiseArray = Promise._SomePromiseArray;
function any(promises) {
    var ret = new SomePromiseArray(promises);
    var promise = ret.promise();
    ret.setHowMany(1);
    ret.setUnwrap();
    ret.init();
    return promise;
}

Promise.any = function (promises) {
    return any(promises);
};

Promise.prototype.any = function () {
    return any(this);
};

};

},{}],2:[function(_dereq_,module,exports){
"use strict";
var firstLineError;
try {throw new Error(); } catch (e) {firstLineError = e;}
var schedule = _dereq_("./schedule");
var Queue = _dereq_("./queue");
var util = _dereq_("./util");

function Async() {
    this._customScheduler = false;
    this._isTickUsed = false;
    this._lateQueue = new Queue(16);
    this._normalQueue = new Queue(16);
    this._haveDrainedQueues = false;
    this._trampolineEnabled = true;
    var self = this;
    this.drainQueues = function () {
        self._drainQueues();
    };
    this._schedule = schedule;
}

Async.prototype.setScheduler = function(fn) {
    var prev = this._schedule;
    this._schedule = fn;
    this._customScheduler = true;
    return prev;
};

Async.prototype.hasCustomScheduler = function() {
    return this._customScheduler;
};

Async.prototype.enableTrampoline = function() {
    this._trampolineEnabled = true;
};

Async.prototype.disableTrampolineIfNecessary = function() {
    if (util.hasDevTools) {
        this._trampolineEnabled = false;
    }
};

Async.prototype.haveItemsQueued = function () {
    return this._isTickUsed || this._haveDrainedQueues;
};


Async.prototype.fatalError = function(e, isNode) {
    if (isNode) {
        process.stderr.write("Fatal " + (e instanceof Error ? e.stack : e) +
            "\n");
        process.exit(2);
    } else {
        this.throwLater(e);
    }
};

Async.prototype.throwLater = function(fn, arg) {
    if (arguments.length === 1) {
        arg = fn;
        fn = function () { throw arg; };
    }
    if (typeof setTimeout !== "undefined") {
        setTimeout(function() {
            fn(arg);
        }, 0);
    } else try {
        this._schedule(function() {
            fn(arg);
        });
    } catch (e) {
        throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
};

function AsyncInvokeLater(fn, receiver, arg) {
    this._lateQueue.push(fn, receiver, arg);
    this._queueTick();
}

function AsyncInvoke(fn, receiver, arg) {
    this._normalQueue.push(fn, receiver, arg);
    this._queueTick();
}

function AsyncSettlePromises(promise) {
    this._normalQueue._pushOne(promise);
    this._queueTick();
}

if (!util.hasDevTools) {
    Async.prototype.invokeLater = AsyncInvokeLater;
    Async.prototype.invoke = AsyncInvoke;
    Async.prototype.settlePromises = AsyncSettlePromises;
} else {
    Async.prototype.invokeLater = function (fn, receiver, arg) {
        if (this._trampolineEnabled) {
            AsyncInvokeLater.call(this, fn, receiver, arg);
        } else {
            this._schedule(function() {
                setTimeout(function() {
                    fn.call(receiver, arg);
                }, 100);
            });
        }
    };

    Async.prototype.invoke = function (fn, receiver, arg) {
        if (this._trampolineEnabled) {
            AsyncInvoke.call(this, fn, receiver, arg);
        } else {
            this._schedule(function() {
                fn.call(receiver, arg);
            });
        }
    };

    Async.prototype.settlePromises = function(promise) {
        if (this._trampolineEnabled) {
            AsyncSettlePromises.call(this, promise);
        } else {
            this._schedule(function() {
                promise._settlePromises();
            });
        }
    };
}

Async.prototype._drainQueue = function(queue) {
    while (queue.length() > 0) {
        var fn = queue.shift();
        if (typeof fn !== "function") {
            fn._settlePromises();
            continue;
        }
        var receiver = queue.shift();
        var arg = queue.shift();
        fn.call(receiver, arg);
    }
};

Async.prototype._drainQueues = function () {
    this._drainQueue(this._normalQueue);
    this._reset();
    this._haveDrainedQueues = true;
    this._drainQueue(this._lateQueue);
};

Async.prototype._queueTick = function () {
    if (!this._isTickUsed) {
        this._isTickUsed = true;
        this._schedule(this.drainQueues);
    }
};

Async.prototype._reset = function () {
    this._isTickUsed = false;
};

module.exports = Async;
module.exports.firstLineError = firstLineError;

},{"./queue":26,"./schedule":29,"./util":36}],3:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, tryConvertToPromise, debug) {
var calledBind = false;
var rejectThis = function(_, e) {
    this._reject(e);
};

var targetRejected = function(e, context) {
    context.promiseRejectionQueued = true;
    context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
};

var bindingResolved = function(thisArg, context) {
    if (((this._bitField & 50397184) === 0)) {
        this._resolveCallback(context.target);
    }
};

var bindingRejected = function(e, context) {
    if (!context.promiseRejectionQueued) this._reject(e);
};

Promise.prototype.bind = function (thisArg) {
    if (!calledBind) {
        calledBind = true;
        Promise.prototype._propagateFrom = debug.propagateFromFunction();
        Promise.prototype._boundValue = debug.boundValueFunction();
    }
    var maybePromise = tryConvertToPromise(thisArg);
    var ret = new Promise(INTERNAL);
    ret._propagateFrom(this, 1);
    var target = this._target();
    ret._setBoundTo(maybePromise);
    if (maybePromise instanceof Promise) {
        var context = {
            promiseRejectionQueued: false,
            promise: ret,
            target: target,
            bindingPromise: maybePromise
        };
        target._then(INTERNAL, targetRejected, undefined, ret, context);
        maybePromise._then(
            bindingResolved, bindingRejected, undefined, ret, context);
        ret._setOnCancel(maybePromise);
    } else {
        ret._resolveCallback(target);
    }
    return ret;
};

Promise.prototype._setBoundTo = function (obj) {
    if (obj !== undefined) {
        this._bitField = this._bitField | 2097152;
        this._boundTo = obj;
    } else {
        this._bitField = this._bitField & (~2097152);
    }
};

Promise.prototype._isBound = function () {
    return (this._bitField & 2097152) === 2097152;
};

Promise.bind = function (thisArg, value) {
    return Promise.resolve(value).bind(thisArg);
};
};

},{}],4:[function(_dereq_,module,exports){
"use strict";
var old;
if (typeof Promise !== "undefined") old = Promise;
function noConflict() {
    try { if (Promise === bluebird) Promise = old; }
    catch (e) {}
    return bluebird;
}
var bluebird = _dereq_("./promise")();
bluebird.noConflict = noConflict;
module.exports = bluebird;

},{"./promise":22}],5:[function(_dereq_,module,exports){
"use strict";
var cr = Object.create;
if (cr) {
    var callerCache = cr(null);
    var getterCache = cr(null);
    callerCache[" size"] = getterCache[" size"] = 0;
}

module.exports = function(Promise) {
var util = _dereq_("./util");
var canEvaluate = util.canEvaluate;
var isIdentifier = util.isIdentifier;

var getMethodCaller;
var getGetter;
if (false) {
var makeMethodCaller = function (methodName) {
    return new Function("ensureMethod", "                                    \n\
        return function(obj) {                                               \n\
            'use strict'                                                     \n\
            var len = this.length;                                           \n\
            ensureMethod(obj, 'methodName');                                 \n\
            switch(len) {                                                    \n\
                case 1: return obj.methodName(this[0]);                      \n\
                case 2: return obj.methodName(this[0], this[1]);             \n\
                case 3: return obj.methodName(this[0], this[1], this[2]);    \n\
                case 0: return obj.methodName();                             \n\
                default:                                                     \n\
                    return obj.methodName.apply(obj, this);                  \n\
            }                                                                \n\
        };                                                                   \n\
        ".replace(/methodName/g, methodName))(ensureMethod);
};

var makeGetter = function (propertyName) {
    return new Function("obj", "                                             \n\
        'use strict';                                                        \n\
        return obj.propertyName;                                             \n\
        ".replace("propertyName", propertyName));
};

var getCompiled = function(name, compiler, cache) {
    var ret = cache[name];
    if (typeof ret !== "function") {
        if (!isIdentifier(name)) {
            return null;
        }
        ret = compiler(name);
        cache[name] = ret;
        cache[" size"]++;
        if (cache[" size"] > 512) {
            var keys = Object.keys(cache);
            for (var i = 0; i < 256; ++i) delete cache[keys[i]];
            cache[" size"] = keys.length - 256;
        }
    }
    return ret;
};

getMethodCaller = function(name) {
    return getCompiled(name, makeMethodCaller, callerCache);
};

getGetter = function(name) {
    return getCompiled(name, makeGetter, getterCache);
};
}

function ensureMethod(obj, methodName) {
    var fn;
    if (obj != null) fn = obj[methodName];
    if (typeof fn !== "function") {
        var message = "Object " + util.classString(obj) + " has no method '" +
            util.toString(methodName) + "'";
        throw new Promise.TypeError(message);
    }
    return fn;
}

function caller(obj) {
    var methodName = this.pop();
    var fn = ensureMethod(obj, methodName);
    return fn.apply(obj, this);
}
Promise.prototype.call = function (methodName) {
    var args = [].slice.call(arguments, 1);;
    if (false) {
        if (canEvaluate) {
            var maybeCaller = getMethodCaller(methodName);
            if (maybeCaller !== null) {
                return this._then(
                    maybeCaller, undefined, undefined, args, undefined);
            }
        }
    }
    args.push(methodName);
    return this._then(caller, undefined, undefined, args, undefined);
};

function namedGetter(obj) {
    return obj[this];
}
function indexedGetter(obj) {
    var index = +this;
    if (index < 0) index = Math.max(0, index + obj.length);
    return obj[index];
}
Promise.prototype.get = function (propertyName) {
    var isIndex = (typeof propertyName === "number");
    var getter;
    if (!isIndex) {
        if (canEvaluate) {
            var maybeGetter = getGetter(propertyName);
            getter = maybeGetter !== null ? maybeGetter : namedGetter;
        } else {
            getter = namedGetter;
        }
    } else {
        getter = indexedGetter;
    }
    return this._then(getter, undefined, undefined, propertyName, undefined);
};
};

},{"./util":36}],6:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, PromiseArray, apiRejection, debug) {
var util = _dereq_("./util");
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var async = Promise._async;

Promise.prototype["break"] = Promise.prototype.cancel = function() {
    if (!debug.cancellation()) return this._warn("cancellation is disabled");

    var promise = this;
    var child = promise;
    while (promise._isCancellable()) {
        if (!promise._cancelBy(child)) {
            if (child._isFollowing()) {
                child._followee().cancel();
            } else {
                child._cancelBranched();
            }
            break;
        }

        var parent = promise._cancellationParent;
        if (parent == null || !parent._isCancellable()) {
            if (promise._isFollowing()) {
                promise._followee().cancel();
            } else {
                promise._cancelBranched();
            }
            break;
        } else {
            if (promise._isFollowing()) promise._followee().cancel();
            promise._setWillBeCancelled();
            child = promise;
            promise = parent;
        }
    }
};

Promise.prototype._branchHasCancelled = function() {
    this._branchesRemainingToCancel--;
};

Promise.prototype._enoughBranchesHaveCancelled = function() {
    return this._branchesRemainingToCancel === undefined ||
           this._branchesRemainingToCancel <= 0;
};

Promise.prototype._cancelBy = function(canceller) {
    if (canceller === this) {
        this._branchesRemainingToCancel = 0;
        this._invokeOnCancel();
        return true;
    } else {
        this._branchHasCancelled();
        if (this._enoughBranchesHaveCancelled()) {
            this._invokeOnCancel();
            return true;
        }
    }
    return false;
};

Promise.prototype._cancelBranched = function() {
    if (this._enoughBranchesHaveCancelled()) {
        this._cancel();
    }
};

Promise.prototype._cancel = function() {
    if (!this._isCancellable()) return;
    this._setCancelled();
    async.invoke(this._cancelPromises, this, undefined);
};

Promise.prototype._cancelPromises = function() {
    if (this._length() > 0) this._settlePromises();
};

Promise.prototype._unsetOnCancel = function() {
    this._onCancelField = undefined;
};

Promise.prototype._isCancellable = function() {
    return this.isPending() && !this._isCancelled();
};

Promise.prototype.isCancellable = function() {
    return this.isPending() && !this.isCancelled();
};

Promise.prototype._doInvokeOnCancel = function(onCancelCallback, internalOnly) {
    if (util.isArray(onCancelCallback)) {
        for (var i = 0; i < onCancelCallback.length; ++i) {
            this._doInvokeOnCancel(onCancelCallback[i], internalOnly);
        }
    } else if (onCancelCallback !== undefined) {
        if (typeof onCancelCallback === "function") {
            if (!internalOnly) {
                var e = tryCatch(onCancelCallback).call(this._boundValue());
                if (e === errorObj) {
                    this._attachExtraTrace(e.e);
                    async.throwLater(e.e);
                }
            }
        } else {
            onCancelCallback._resultCancelled(this);
        }
    }
};

Promise.prototype._invokeOnCancel = function() {
    var onCancelCallback = this._onCancel();
    this._unsetOnCancel();
    async.invoke(this._doInvokeOnCancel, this, onCancelCallback);
};

Promise.prototype._invokeInternalOnCancel = function() {
    if (this._isCancellable()) {
        this._doInvokeOnCancel(this._onCancel(), true);
        this._unsetOnCancel();
    }
};

Promise.prototype._resultCancelled = function() {
    this.cancel();
};

};

},{"./util":36}],7:[function(_dereq_,module,exports){
"use strict";
module.exports = function(NEXT_FILTER) {
var util = _dereq_("./util");
var getKeys = _dereq_("./es5").keys;
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;

function catchFilter(instances, cb, promise) {
    return function(e) {
        var boundTo = promise._boundValue();
        predicateLoop: for (var i = 0; i < instances.length; ++i) {
            var item = instances[i];

            if (item === Error ||
                (item != null && item.prototype instanceof Error)) {
                if (e instanceof item) {
                    return tryCatch(cb).call(boundTo, e);
                }
            } else if (typeof item === "function") {
                var matchesPredicate = tryCatch(item).call(boundTo, e);
                if (matchesPredicate === errorObj) {
                    return matchesPredicate;
                } else if (matchesPredicate) {
                    return tryCatch(cb).call(boundTo, e);
                }
            } else if (util.isObject(e)) {
                var keys = getKeys(item);
                for (var j = 0; j < keys.length; ++j) {
                    var key = keys[j];
                    if (item[key] != e[key]) {
                        continue predicateLoop;
                    }
                }
                return tryCatch(cb).call(boundTo, e);
            }
        }
        return NEXT_FILTER;
    };
}

return catchFilter;
};

},{"./es5":13,"./util":36}],8:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var longStackTraces = false;
var contextStack = [];

Promise.prototype._promiseCreated = function() {};
Promise.prototype._pushContext = function() {};
Promise.prototype._popContext = function() {return null;};
Promise._peekContext = Promise.prototype._peekContext = function() {};

function Context() {
    this._trace = new Context.CapturedTrace(peekContext());
}
Context.prototype._pushContext = function () {
    if (this._trace !== undefined) {
        this._trace._promiseCreated = null;
        contextStack.push(this._trace);
    }
};

Context.prototype._popContext = function () {
    if (this._trace !== undefined) {
        var trace = contextStack.pop();
        var ret = trace._promiseCreated;
        trace._promiseCreated = null;
        return ret;
    }
    return null;
};

function createContext() {
    if (longStackTraces) return new Context();
}

function peekContext() {
    var lastIndex = contextStack.length - 1;
    if (lastIndex >= 0) {
        return contextStack[lastIndex];
    }
    return undefined;
}
Context.CapturedTrace = null;
Context.create = createContext;
Context.deactivateLongStackTraces = function() {};
Context.activateLongStackTraces = function() {
    var Promise_pushContext = Promise.prototype._pushContext;
    var Promise_popContext = Promise.prototype._popContext;
    var Promise_PeekContext = Promise._peekContext;
    var Promise_peekContext = Promise.prototype._peekContext;
    var Promise_promiseCreated = Promise.prototype._promiseCreated;
    Context.deactivateLongStackTraces = function() {
        Promise.prototype._pushContext = Promise_pushContext;
        Promise.prototype._popContext = Promise_popContext;
        Promise._peekContext = Promise_PeekContext;
        Promise.prototype._peekContext = Promise_peekContext;
        Promise.prototype._promiseCreated = Promise_promiseCreated;
        longStackTraces = false;
    };
    longStackTraces = true;
    Promise.prototype._pushContext = Context.prototype._pushContext;
    Promise.prototype._popContext = Context.prototype._popContext;
    Promise._peekContext = Promise.prototype._peekContext = peekContext;
    Promise.prototype._promiseCreated = function() {
        var ctx = this._peekContext();
        if (ctx && ctx._promiseCreated == null) ctx._promiseCreated = this;
    };
};
return Context;
};

},{}],9:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, Context) {
var getDomain = Promise._getDomain;
var async = Promise._async;
var Warning = _dereq_("./errors").Warning;
var util = _dereq_("./util");
var canAttachTrace = util.canAttachTrace;
var unhandledRejectionHandled;
var possiblyUnhandledRejection;
var bluebirdFramePattern =
    /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/;
var nodeFramePattern = /\((?:timers\.js):\d+:\d+\)/;
var parseLinePattern = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/;
var stackFramePattern = null;
var formatStack = null;
var indentStackFrames = false;
var printWarning;
var debugging = !!(util.env("BLUEBIRD_DEBUG") != 0 &&
                        (true ||
                         util.env("BLUEBIRD_DEBUG") ||
                         util.env("NODE_ENV") === "development"));

var warnings = !!(util.env("BLUEBIRD_WARNINGS") != 0 &&
    (debugging || util.env("BLUEBIRD_WARNINGS")));

var longStackTraces = !!(util.env("BLUEBIRD_LONG_STACK_TRACES") != 0 &&
    (debugging || util.env("BLUEBIRD_LONG_STACK_TRACES")));

var wForgottenReturn = util.env("BLUEBIRD_W_FORGOTTEN_RETURN") != 0 &&
    (warnings || !!util.env("BLUEBIRD_W_FORGOTTEN_RETURN"));

Promise.prototype.suppressUnhandledRejections = function() {
    var target = this._target();
    target._bitField = ((target._bitField & (~1048576)) |
                      524288);
};

Promise.prototype._ensurePossibleRejectionHandled = function () {
    if ((this._bitField & 524288) !== 0) return;
    this._setRejectionIsUnhandled();
    async.invokeLater(this._notifyUnhandledRejection, this, undefined);
};

Promise.prototype._notifyUnhandledRejectionIsHandled = function () {
    fireRejectionEvent("rejectionHandled",
                                  unhandledRejectionHandled, undefined, this);
};

Promise.prototype._setReturnedNonUndefined = function() {
    this._bitField = this._bitField | 268435456;
};

Promise.prototype._returnedNonUndefined = function() {
    return (this._bitField & 268435456) !== 0;
};

Promise.prototype._notifyUnhandledRejection = function () {
    if (this._isRejectionUnhandled()) {
        var reason = this._settledValue();
        this._setUnhandledRejectionIsNotified();
        fireRejectionEvent("unhandledRejection",
                                      possiblyUnhandledRejection, reason, this);
    }
};

Promise.prototype._setUnhandledRejectionIsNotified = function () {
    this._bitField = this._bitField | 262144;
};

Promise.prototype._unsetUnhandledRejectionIsNotified = function () {
    this._bitField = this._bitField & (~262144);
};

Promise.prototype._isUnhandledRejectionNotified = function () {
    return (this._bitField & 262144) > 0;
};

Promise.prototype._setRejectionIsUnhandled = function () {
    this._bitField = this._bitField | 1048576;
};

Promise.prototype._unsetRejectionIsUnhandled = function () {
    this._bitField = this._bitField & (~1048576);
    if (this._isUnhandledRejectionNotified()) {
        this._unsetUnhandledRejectionIsNotified();
        this._notifyUnhandledRejectionIsHandled();
    }
};

Promise.prototype._isRejectionUnhandled = function () {
    return (this._bitField & 1048576) > 0;
};

Promise.prototype._warn = function(message, shouldUseOwnTrace, promise) {
    return warn(message, shouldUseOwnTrace, promise || this);
};

Promise.onPossiblyUnhandledRejection = function (fn) {
    var domain = getDomain();
    possiblyUnhandledRejection =
        typeof fn === "function" ? (domain === null ?
                                            fn : util.domainBind(domain, fn))
                                 : undefined;
};

Promise.onUnhandledRejectionHandled = function (fn) {
    var domain = getDomain();
    unhandledRejectionHandled =
        typeof fn === "function" ? (domain === null ?
                                            fn : util.domainBind(domain, fn))
                                 : undefined;
};

var disableLongStackTraces = function() {};
Promise.longStackTraces = function () {
    if (async.haveItemsQueued() && !config.longStackTraces) {
        throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    if (!config.longStackTraces && longStackTracesIsSupported()) {
        var Promise_captureStackTrace = Promise.prototype._captureStackTrace;
        var Promise_attachExtraTrace = Promise.prototype._attachExtraTrace;
        config.longStackTraces = true;
        disableLongStackTraces = function() {
            if (async.haveItemsQueued() && !config.longStackTraces) {
                throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
            }
            Promise.prototype._captureStackTrace = Promise_captureStackTrace;
            Promise.prototype._attachExtraTrace = Promise_attachExtraTrace;
            Context.deactivateLongStackTraces();
            async.enableTrampoline();
            config.longStackTraces = false;
        };
        Promise.prototype._captureStackTrace = longStackTracesCaptureStackTrace;
        Promise.prototype._attachExtraTrace = longStackTracesAttachExtraTrace;
        Context.activateLongStackTraces();
        async.disableTrampolineIfNecessary();
    }
};

Promise.hasLongStackTraces = function () {
    return config.longStackTraces && longStackTracesIsSupported();
};

var fireDomEvent = (function() {
    try {
        if (typeof CustomEvent === "function") {
            var event = new CustomEvent("CustomEvent");
            util.global.dispatchEvent(event);
            return function(name, event) {
                var domEvent = new CustomEvent(name.toLowerCase(), {
                    detail: event,
                    cancelable: true
                });
                return !util.global.dispatchEvent(domEvent);
            };
        } else if (typeof Event === "function") {
            var event = new Event("CustomEvent");
            util.global.dispatchEvent(event);
            return function(name, event) {
                var domEvent = new Event(name.toLowerCase(), {
                    cancelable: true
                });
                domEvent.detail = event;
                return !util.global.dispatchEvent(domEvent);
            };
        } else {
            var event = document.createEvent("CustomEvent");
            event.initCustomEvent("testingtheevent", false, true, {});
            util.global.dispatchEvent(event);
            return function(name, event) {
                var domEvent = document.createEvent("CustomEvent");
                domEvent.initCustomEvent(name.toLowerCase(), false, true,
                    event);
                return !util.global.dispatchEvent(domEvent);
            };
        }
    } catch (e) {}
    return function() {
        return false;
    };
})();

var fireGlobalEvent = (function() {
    if (util.isNode) {
        return function() {
            return process.emit.apply(process, arguments);
        };
    } else {
        if (!util.global) {
            return function() {
                return false;
            };
        }
        return function(name) {
            var methodName = "on" + name.toLowerCase();
            var method = util.global[methodName];
            if (!method) return false;
            method.apply(util.global, [].slice.call(arguments, 1));
            return true;
        };
    }
})();

function generatePromiseLifecycleEventObject(name, promise) {
    return {promise: promise};
}

var eventToObjectGenerator = {
    promiseCreated: generatePromiseLifecycleEventObject,
    promiseFulfilled: generatePromiseLifecycleEventObject,
    promiseRejected: generatePromiseLifecycleEventObject,
    promiseResolved: generatePromiseLifecycleEventObject,
    promiseCancelled: generatePromiseLifecycleEventObject,
    promiseChained: function(name, promise, child) {
        return {promise: promise, child: child};
    },
    warning: function(name, warning) {
        return {warning: warning};
    },
    unhandledRejection: function (name, reason, promise) {
        return {reason: reason, promise: promise};
    },
    rejectionHandled: generatePromiseLifecycleEventObject
};

var activeFireEvent = function (name) {
    var globalEventFired = false;
    try {
        globalEventFired = fireGlobalEvent.apply(null, arguments);
    } catch (e) {
        async.throwLater(e);
        globalEventFired = true;
    }

    var domEventFired = false;
    try {
        domEventFired = fireDomEvent(name,
                    eventToObjectGenerator[name].apply(null, arguments));
    } catch (e) {
        async.throwLater(e);
        domEventFired = true;
    }

    return domEventFired || globalEventFired;
};

Promise.config = function(opts) {
    opts = Object(opts);
    if ("longStackTraces" in opts) {
        if (opts.longStackTraces) {
            Promise.longStackTraces();
        } else if (!opts.longStackTraces && Promise.hasLongStackTraces()) {
            disableLongStackTraces();
        }
    }
    if ("warnings" in opts) {
        var warningsOption = opts.warnings;
        config.warnings = !!warningsOption;
        wForgottenReturn = config.warnings;

        if (util.isObject(warningsOption)) {
            if ("wForgottenReturn" in warningsOption) {
                wForgottenReturn = !!warningsOption.wForgottenReturn;
            }
        }
    }
    if ("cancellation" in opts && opts.cancellation && !config.cancellation) {
        if (async.haveItemsQueued()) {
            throw new Error(
                "cannot enable cancellation after promises are in use");
        }
        Promise.prototype._clearCancellationData =
            cancellationClearCancellationData;
        Promise.prototype._propagateFrom = cancellationPropagateFrom;
        Promise.prototype._onCancel = cancellationOnCancel;
        Promise.prototype._setOnCancel = cancellationSetOnCancel;
        Promise.prototype._attachCancellationCallback =
            cancellationAttachCancellationCallback;
        Promise.prototype._execute = cancellationExecute;
        propagateFromFunction = cancellationPropagateFrom;
        config.cancellation = true;
    }
    if ("monitoring" in opts) {
        if (opts.monitoring && !config.monitoring) {
            config.monitoring = true;
            Promise.prototype._fireEvent = activeFireEvent;
        } else if (!opts.monitoring && config.monitoring) {
            config.monitoring = false;
            Promise.prototype._fireEvent = defaultFireEvent;
        }
    }
    return Promise;
};

function defaultFireEvent() { return false; }

Promise.prototype._fireEvent = defaultFireEvent;
Promise.prototype._execute = function(executor, resolve, reject) {
    try {
        executor(resolve, reject);
    } catch (e) {
        return e;
    }
};
Promise.prototype._onCancel = function () {};
Promise.prototype._setOnCancel = function (handler) { ; };
Promise.prototype._attachCancellationCallback = function(onCancel) {
    ;
};
Promise.prototype._captureStackTrace = function () {};
Promise.prototype._attachExtraTrace = function () {};
Promise.prototype._clearCancellationData = function() {};
Promise.prototype._propagateFrom = function (parent, flags) {
    ;
    ;
};

function cancellationExecute(executor, resolve, reject) {
    var promise = this;
    try {
        executor(resolve, reject, function(onCancel) {
            if (typeof onCancel !== "function") {
                throw new TypeError("onCancel must be a function, got: " +
                                    util.toString(onCancel));
            }
            promise._attachCancellationCallback(onCancel);
        });
    } catch (e) {
        return e;
    }
}

function cancellationAttachCancellationCallback(onCancel) {
    if (!this._isCancellable()) return this;

    var previousOnCancel = this._onCancel();
    if (previousOnCancel !== undefined) {
        if (util.isArray(previousOnCancel)) {
            previousOnCancel.push(onCancel);
        } else {
            this._setOnCancel([previousOnCancel, onCancel]);
        }
    } else {
        this._setOnCancel(onCancel);
    }
}

function cancellationOnCancel() {
    return this._onCancelField;
}

function cancellationSetOnCancel(onCancel) {
    this._onCancelField = onCancel;
}

function cancellationClearCancellationData() {
    this._cancellationParent = undefined;
    this._onCancelField = undefined;
}

function cancellationPropagateFrom(parent, flags) {
    if ((flags & 1) !== 0) {
        this._cancellationParent = parent;
        var branchesRemainingToCancel = parent._branchesRemainingToCancel;
        if (branchesRemainingToCancel === undefined) {
            branchesRemainingToCancel = 0;
        }
        parent._branchesRemainingToCancel = branchesRemainingToCancel + 1;
    }
    if ((flags & 2) !== 0 && parent._isBound()) {
        this._setBoundTo(parent._boundTo);
    }
}

function bindingPropagateFrom(parent, flags) {
    if ((flags & 2) !== 0 && parent._isBound()) {
        this._setBoundTo(parent._boundTo);
    }
}
var propagateFromFunction = bindingPropagateFrom;

function boundValueFunction() {
    var ret = this._boundTo;
    if (ret !== undefined) {
        if (ret instanceof Promise) {
            if (ret.isFulfilled()) {
                return ret.value();
            } else {
                return undefined;
            }
        }
    }
    return ret;
}

function longStackTracesCaptureStackTrace() {
    this._trace = new CapturedTrace(this._peekContext());
}

function longStackTracesAttachExtraTrace(error, ignoreSelf) {
    if (canAttachTrace(error)) {
        var trace = this._trace;
        if (trace !== undefined) {
            if (ignoreSelf) trace = trace._parent;
        }
        if (trace !== undefined) {
            trace.attachExtraTrace(error);
        } else if (!error.__stackCleaned__) {
            var parsed = parseStackAndMessage(error);
            util.notEnumerableProp(error, "stack",
                parsed.message + "\n" + parsed.stack.join("\n"));
            util.notEnumerableProp(error, "__stackCleaned__", true);
        }
    }
}

function checkForgottenReturns(returnValue, promiseCreated, name, promise,
                               parent) {
    if (returnValue === undefined && promiseCreated !== null &&
        wForgottenReturn) {
        if (parent !== undefined && parent._returnedNonUndefined()) return;
        if ((promise._bitField & 65535) === 0) return;

        if (name) name = name + " ";
        var handlerLine = "";
        var creatorLine = "";
        if (promiseCreated._trace) {
            var traceLines = promiseCreated._trace.stack.split("\n");
            var stack = cleanStack(traceLines);
            for (var i = stack.length - 1; i >= 0; --i) {
                var line = stack[i];
                if (!nodeFramePattern.test(line)) {
                    var lineMatches = line.match(parseLinePattern);
                    if (lineMatches) {
                        handlerLine  = "at " + lineMatches[1] +
                            ":" + lineMatches[2] + ":" + lineMatches[3] + " ";
                    }
                    break;
                }
            }

            if (stack.length > 0) {
                var firstUserLine = stack[0];
                for (var i = 0; i < traceLines.length; ++i) {

                    if (traceLines[i] === firstUserLine) {
                        if (i > 0) {
                            creatorLine = "\n" + traceLines[i - 1];
                        }
                        break;
                    }
                }

            }
        }
        var msg = "a promise was created in a " + name +
            "handler " + handlerLine + "but was not returned from it, " +
            "see http://goo.gl/rRqMUw" +
            creatorLine;
        promise._warn(msg, true, promiseCreated);
    }
}

function deprecated(name, replacement) {
    var message = name +
        " is deprecated and will be removed in a future version.";
    if (replacement) message += " Use " + replacement + " instead.";
    return warn(message);
}

function warn(message, shouldUseOwnTrace, promise) {
    if (!config.warnings) return;
    var warning = new Warning(message);
    var ctx;
    if (shouldUseOwnTrace) {
        promise._attachExtraTrace(warning);
    } else if (config.longStackTraces && (ctx = Promise._peekContext())) {
        ctx.attachExtraTrace(warning);
    } else {
        var parsed = parseStackAndMessage(warning);
        warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
    }

    if (!activeFireEvent("warning", warning)) {
        formatAndLogError(warning, "", true);
    }
}

function reconstructStack(message, stacks) {
    for (var i = 0; i < stacks.length - 1; ++i) {
        stacks[i].push("From previous event:");
        stacks[i] = stacks[i].join("\n");
    }
    if (i < stacks.length) {
        stacks[i] = stacks[i].join("\n");
    }
    return message + "\n" + stacks.join("\n");
}

function removeDuplicateOrEmptyJumps(stacks) {
    for (var i = 0; i < stacks.length; ++i) {
        if (stacks[i].length === 0 ||
            ((i + 1 < stacks.length) && stacks[i][0] === stacks[i+1][0])) {
            stacks.splice(i, 1);
            i--;
        }
    }
}

function removeCommonRoots(stacks) {
    var current = stacks[0];
    for (var i = 1; i < stacks.length; ++i) {
        var prev = stacks[i];
        var currentLastIndex = current.length - 1;
        var currentLastLine = current[currentLastIndex];
        var commonRootMeetPoint = -1;

        for (var j = prev.length - 1; j >= 0; --j) {
            if (prev[j] === currentLastLine) {
                commonRootMeetPoint = j;
                break;
            }
        }

        for (var j = commonRootMeetPoint; j >= 0; --j) {
            var line = prev[j];
            if (current[currentLastIndex] === line) {
                current.pop();
                currentLastIndex--;
            } else {
                break;
            }
        }
        current = prev;
    }
}

function cleanStack(stack) {
    var ret = [];
    for (var i = 0; i < stack.length; ++i) {
        var line = stack[i];
        var isTraceLine = "    (No stack trace)" === line ||
            stackFramePattern.test(line);
        var isInternalFrame = isTraceLine && shouldIgnore(line);
        if (isTraceLine && !isInternalFrame) {
            if (indentStackFrames && line.charAt(0) !== " ") {
                line = "    " + line;
            }
            ret.push(line);
        }
    }
    return ret;
}

function stackFramesAsArray(error) {
    var stack = error.stack.replace(/\s+$/g, "").split("\n");
    for (var i = 0; i < stack.length; ++i) {
        var line = stack[i];
        if ("    (No stack trace)" === line || stackFramePattern.test(line)) {
            break;
        }
    }
    if (i > 0 && error.name != "SyntaxError") {
        stack = stack.slice(i);
    }
    return stack;
}

function parseStackAndMessage(error) {
    var stack = error.stack;
    var message = error.toString();
    stack = typeof stack === "string" && stack.length > 0
                ? stackFramesAsArray(error) : ["    (No stack trace)"];
    return {
        message: message,
        stack: error.name == "SyntaxError" ? stack : cleanStack(stack)
    };
}

function formatAndLogError(error, title, isSoft) {
    if (typeof console !== "undefined") {
        var message;
        if (util.isObject(error)) {
            var stack = error.stack;
            message = title + formatStack(stack, error);
        } else {
            message = title + String(error);
        }
        if (typeof printWarning === "function") {
            printWarning(message, isSoft);
        } else if (typeof console.log === "function" ||
            typeof console.log === "object") {
            console.log(message);
        }
    }
}

function fireRejectionEvent(name, localHandler, reason, promise) {
    var localEventFired = false;
    try {
        if (typeof localHandler === "function") {
            localEventFired = true;
            if (name === "rejectionHandled") {
                localHandler(promise);
            } else {
                localHandler(reason, promise);
            }
        }
    } catch (e) {
        async.throwLater(e);
    }

    if (name === "unhandledRejection") {
        if (!activeFireEvent(name, reason, promise) && !localEventFired) {
            formatAndLogError(reason, "Unhandled rejection ");
        }
    } else {
        activeFireEvent(name, promise);
    }
}

function formatNonError(obj) {
    var str;
    if (typeof obj === "function") {
        str = "[function " +
            (obj.name || "anonymous") +
            "]";
    } else {
        str = obj && typeof obj.toString === "function"
            ? obj.toString() : util.toString(obj);
        var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
        if (ruselessToString.test(str)) {
            try {
                var newStr = JSON.stringify(obj);
                str = newStr;
            }
            catch(e) {

            }
        }
        if (str.length === 0) {
            str = "(empty array)";
        }
    }
    return ("(<" + snip(str) + ">, no stack trace)");
}

function snip(str) {
    var maxChars = 41;
    if (str.length < maxChars) {
        return str;
    }
    return str.substr(0, maxChars - 3) + "...";
}

function longStackTracesIsSupported() {
    return typeof captureStackTrace === "function";
}

var shouldIgnore = function() { return false; };
var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
function parseLineInfo(line) {
    var matches = line.match(parseLineInfoRegex);
    if (matches) {
        return {
            fileName: matches[1],
            line: parseInt(matches[2], 10)
        };
    }
}

function setBounds(firstLineError, lastLineError) {
    if (!longStackTracesIsSupported()) return;
    var firstStackLines = firstLineError.stack.split("\n");
    var lastStackLines = lastLineError.stack.split("\n");
    var firstIndex = -1;
    var lastIndex = -1;
    var firstFileName;
    var lastFileName;
    for (var i = 0; i < firstStackLines.length; ++i) {
        var result = parseLineInfo(firstStackLines[i]);
        if (result) {
            firstFileName = result.fileName;
            firstIndex = result.line;
            break;
        }
    }
    for (var i = 0; i < lastStackLines.length; ++i) {
        var result = parseLineInfo(lastStackLines[i]);
        if (result) {
            lastFileName = result.fileName;
            lastIndex = result.line;
            break;
        }
    }
    if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName ||
        firstFileName !== lastFileName || firstIndex >= lastIndex) {
        return;
    }

    shouldIgnore = function(line) {
        if (bluebirdFramePattern.test(line)) return true;
        var info = parseLineInfo(line);
        if (info) {
            if (info.fileName === firstFileName &&
                (firstIndex <= info.line && info.line <= lastIndex)) {
                return true;
            }
        }
        return false;
    };
}

function CapturedTrace(parent) {
    this._parent = parent;
    this._promisesCreated = 0;
    var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
    captureStackTrace(this, CapturedTrace);
    if (length > 32) this.uncycle();
}
util.inherits(CapturedTrace, Error);
Context.CapturedTrace = CapturedTrace;

CapturedTrace.prototype.uncycle = function() {
    var length = this._length;
    if (length < 2) return;
    var nodes = [];
    var stackToIndex = {};

    for (var i = 0, node = this; node !== undefined; ++i) {
        nodes.push(node);
        node = node._parent;
    }
    length = this._length = i;
    for (var i = length - 1; i >= 0; --i) {
        var stack = nodes[i].stack;
        if (stackToIndex[stack] === undefined) {
            stackToIndex[stack] = i;
        }
    }
    for (var i = 0; i < length; ++i) {
        var currentStack = nodes[i].stack;
        var index = stackToIndex[currentStack];
        if (index !== undefined && index !== i) {
            if (index > 0) {
                nodes[index - 1]._parent = undefined;
                nodes[index - 1]._length = 1;
            }
            nodes[i]._parent = undefined;
            nodes[i]._length = 1;
            var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;

            if (index < length - 1) {
                cycleEdgeNode._parent = nodes[index + 1];
                cycleEdgeNode._parent.uncycle();
                cycleEdgeNode._length =
                    cycleEdgeNode._parent._length + 1;
            } else {
                cycleEdgeNode._parent = undefined;
                cycleEdgeNode._length = 1;
            }
            var currentChildLength = cycleEdgeNode._length + 1;
            for (var j = i - 2; j >= 0; --j) {
                nodes[j]._length = currentChildLength;
                currentChildLength++;
            }
            return;
        }
    }
};

CapturedTrace.prototype.attachExtraTrace = function(error) {
    if (error.__stackCleaned__) return;
    this.uncycle();
    var parsed = parseStackAndMessage(error);
    var message = parsed.message;
    var stacks = [parsed.stack];

    var trace = this;
    while (trace !== undefined) {
        stacks.push(cleanStack(trace.stack.split("\n")));
        trace = trace._parent;
    }
    removeCommonRoots(stacks);
    removeDuplicateOrEmptyJumps(stacks);
    util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
    util.notEnumerableProp(error, "__stackCleaned__", true);
};

var captureStackTrace = (function stackDetection() {
    var v8stackFramePattern = /^\s*at\s*/;
    var v8stackFormatter = function(stack, error) {
        if (typeof stack === "string") return stack;

        if (error.name !== undefined &&
            error.message !== undefined) {
            return error.toString();
        }
        return formatNonError(error);
    };

    if (typeof Error.stackTraceLimit === "number" &&
        typeof Error.captureStackTrace === "function") {
        Error.stackTraceLimit += 6;
        stackFramePattern = v8stackFramePattern;
        formatStack = v8stackFormatter;
        var captureStackTrace = Error.captureStackTrace;

        shouldIgnore = function(line) {
            return bluebirdFramePattern.test(line);
        };
        return function(receiver, ignoreUntil) {
            Error.stackTraceLimit += 6;
            captureStackTrace(receiver, ignoreUntil);
            Error.stackTraceLimit -= 6;
        };
    }
    var err = new Error();

    if (typeof err.stack === "string" &&
        err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
        stackFramePattern = /@/;
        formatStack = v8stackFormatter;
        indentStackFrames = true;
        return function captureStackTrace(o) {
            o.stack = new Error().stack;
        };
    }

    var hasStackAfterThrow;
    try { throw new Error(); }
    catch(e) {
        hasStackAfterThrow = ("stack" in e);
    }
    if (!("stack" in err) && hasStackAfterThrow &&
        typeof Error.stackTraceLimit === "number") {
        stackFramePattern = v8stackFramePattern;
        formatStack = v8stackFormatter;
        return function captureStackTrace(o) {
            Error.stackTraceLimit += 6;
            try { throw new Error(); }
            catch(e) { o.stack = e.stack; }
            Error.stackTraceLimit -= 6;
        };
    }

    formatStack = function(stack, error) {
        if (typeof stack === "string") return stack;

        if ((typeof error === "object" ||
            typeof error === "function") &&
            error.name !== undefined &&
            error.message !== undefined) {
            return error.toString();
        }
        return formatNonError(error);
    };

    return null;

})([]);

if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
    printWarning = function (message) {
        console.warn(message);
    };
    if (util.isNode && process.stderr.isTTY) {
        printWarning = function(message, isSoft) {
            var color = isSoft ? "\u001b[33m" : "\u001b[31m";
            console.warn(color + message + "\u001b[0m\n");
        };
    } else if (!util.isNode && typeof (new Error().stack) === "string") {
        printWarning = function(message, isSoft) {
            console.warn("%c" + message,
                        isSoft ? "color: darkorange" : "color: red");
        };
    }
}

var config = {
    warnings: warnings,
    longStackTraces: false,
    cancellation: false,
    monitoring: false
};

if (longStackTraces) Promise.longStackTraces();

return {
    longStackTraces: function() {
        return config.longStackTraces;
    },
    warnings: function() {
        return config.warnings;
    },
    cancellation: function() {
        return config.cancellation;
    },
    monitoring: function() {
        return config.monitoring;
    },
    propagateFromFunction: function() {
        return propagateFromFunction;
    },
    boundValueFunction: function() {
        return boundValueFunction;
    },
    checkForgottenReturns: checkForgottenReturns,
    setBounds: setBounds,
    warn: warn,
    deprecated: deprecated,
    CapturedTrace: CapturedTrace,
    fireDomEvent: fireDomEvent,
    fireGlobalEvent: fireGlobalEvent
};
};

},{"./errors":12,"./util":36}],10:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
function returner() {
    return this.value;
}
function thrower() {
    throw this.reason;
}

Promise.prototype["return"] =
Promise.prototype.thenReturn = function (value) {
    if (value instanceof Promise) value.suppressUnhandledRejections();
    return this._then(
        returner, undefined, undefined, {value: value}, undefined);
};

Promise.prototype["throw"] =
Promise.prototype.thenThrow = function (reason) {
    return this._then(
        thrower, undefined, undefined, {reason: reason}, undefined);
};

Promise.prototype.catchThrow = function (reason) {
    if (arguments.length <= 1) {
        return this._then(
            undefined, thrower, undefined, {reason: reason}, undefined);
    } else {
        var _reason = arguments[1];
        var handler = function() {throw _reason;};
        return this.caught(reason, handler);
    }
};

Promise.prototype.catchReturn = function (value) {
    if (arguments.length <= 1) {
        if (value instanceof Promise) value.suppressUnhandledRejections();
        return this._then(
            undefined, returner, undefined, {value: value}, undefined);
    } else {
        var _value = arguments[1];
        if (_value instanceof Promise) _value.suppressUnhandledRejections();
        var handler = function() {return _value;};
        return this.caught(value, handler);
    }
};
};

},{}],11:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var PromiseReduce = Promise.reduce;
var PromiseAll = Promise.all;

function promiseAllThis() {
    return PromiseAll(this);
}

function PromiseMapSeries(promises, fn) {
    return PromiseReduce(promises, fn, INTERNAL, INTERNAL);
}

Promise.prototype.each = function (fn) {
    return PromiseReduce(this, fn, INTERNAL, 0)
              ._then(promiseAllThis, undefined, undefined, this, undefined);
};

Promise.prototype.mapSeries = function (fn) {
    return PromiseReduce(this, fn, INTERNAL, INTERNAL);
};

Promise.each = function (promises, fn) {
    return PromiseReduce(promises, fn, INTERNAL, 0)
              ._then(promiseAllThis, undefined, undefined, promises, undefined);
};

Promise.mapSeries = PromiseMapSeries;
};


},{}],12:[function(_dereq_,module,exports){
"use strict";
var es5 = _dereq_("./es5");
var Objectfreeze = es5.freeze;
var util = _dereq_("./util");
var inherits = util.inherits;
var notEnumerableProp = util.notEnumerableProp;

function subError(nameProperty, defaultMessage) {
    function SubError(message) {
        if (!(this instanceof SubError)) return new SubError(message);
        notEnumerableProp(this, "message",
            typeof message === "string" ? message : defaultMessage);
        notEnumerableProp(this, "name", nameProperty);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, this.constructor);
        } else {
            Error.call(this);
        }
    }
    inherits(SubError, Error);
    return SubError;
}

var _TypeError, _RangeError;
var Warning = subError("Warning", "warning");
var CancellationError = subError("CancellationError", "cancellation error");
var TimeoutError = subError("TimeoutError", "timeout error");
var AggregateError = subError("AggregateError", "aggregate error");
try {
    _TypeError = TypeError;
    _RangeError = RangeError;
} catch(e) {
    _TypeError = subError("TypeError", "type error");
    _RangeError = subError("RangeError", "range error");
}

var methods = ("join pop push shift unshift slice filter forEach some " +
    "every map indexOf lastIndexOf reduce reduceRight sort reverse").split(" ");

for (var i = 0; i < methods.length; ++i) {
    if (typeof Array.prototype[methods[i]] === "function") {
        AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
    }
}

es5.defineProperty(AggregateError.prototype, "length", {
    value: 0,
    configurable: false,
    writable: true,
    enumerable: true
});
AggregateError.prototype["isOperational"] = true;
var level = 0;
AggregateError.prototype.toString = function() {
    var indent = Array(level * 4 + 1).join(" ");
    var ret = "\n" + indent + "AggregateError of:" + "\n";
    level++;
    indent = Array(level * 4 + 1).join(" ");
    for (var i = 0; i < this.length; ++i) {
        var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
        var lines = str.split("\n");
        for (var j = 0; j < lines.length; ++j) {
            lines[j] = indent + lines[j];
        }
        str = lines.join("\n");
        ret += str + "\n";
    }
    level--;
    return ret;
};

function OperationalError(message) {
    if (!(this instanceof OperationalError))
        return new OperationalError(message);
    notEnumerableProp(this, "name", "OperationalError");
    notEnumerableProp(this, "message", message);
    this.cause = message;
    this["isOperational"] = true;

    if (message instanceof Error) {
        notEnumerableProp(this, "message", message.message);
        notEnumerableProp(this, "stack", message.stack);
    } else if (Error.captureStackTrace) {
        Error.captureStackTrace(this, this.constructor);
    }

}
inherits(OperationalError, Error);

var errorTypes = Error["__BluebirdErrorTypes__"];
if (!errorTypes) {
    errorTypes = Objectfreeze({
        CancellationError: CancellationError,
        TimeoutError: TimeoutError,
        OperationalError: OperationalError,
        RejectionError: OperationalError,
        AggregateError: AggregateError
    });
    es5.defineProperty(Error, "__BluebirdErrorTypes__", {
        value: errorTypes,
        writable: false,
        enumerable: false,
        configurable: false
    });
}

module.exports = {
    Error: Error,
    TypeError: _TypeError,
    RangeError: _RangeError,
    CancellationError: errorTypes.CancellationError,
    OperationalError: errorTypes.OperationalError,
    TimeoutError: errorTypes.TimeoutError,
    AggregateError: errorTypes.AggregateError,
    Warning: Warning
};

},{"./es5":13,"./util":36}],13:[function(_dereq_,module,exports){
var isES5 = (function(){
    "use strict";
    return this === undefined;
})();

if (isES5) {
    module.exports = {
        freeze: Object.freeze,
        defineProperty: Object.defineProperty,
        getDescriptor: Object.getOwnPropertyDescriptor,
        keys: Object.keys,
        names: Object.getOwnPropertyNames,
        getPrototypeOf: Object.getPrototypeOf,
        isArray: Array.isArray,
        isES5: isES5,
        propertyIsWritable: function(obj, prop) {
            var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
            return !!(!descriptor || descriptor.writable || descriptor.set);
        }
    };
} else {
    var has = {}.hasOwnProperty;
    var str = {}.toString;
    var proto = {}.constructor.prototype;

    var ObjectKeys = function (o) {
        var ret = [];
        for (var key in o) {
            if (has.call(o, key)) {
                ret.push(key);
            }
        }
        return ret;
    };

    var ObjectGetDescriptor = function(o, key) {
        return {value: o[key]};
    };

    var ObjectDefineProperty = function (o, key, desc) {
        o[key] = desc.value;
        return o;
    };

    var ObjectFreeze = function (obj) {
        return obj;
    };

    var ObjectGetPrototypeOf = function (obj) {
        try {
            return Object(obj).constructor.prototype;
        }
        catch (e) {
            return proto;
        }
    };

    var ArrayIsArray = function (obj) {
        try {
            return str.call(obj) === "[object Array]";
        }
        catch(e) {
            return false;
        }
    };

    module.exports = {
        isArray: ArrayIsArray,
        keys: ObjectKeys,
        names: ObjectKeys,
        defineProperty: ObjectDefineProperty,
        getDescriptor: ObjectGetDescriptor,
        freeze: ObjectFreeze,
        getPrototypeOf: ObjectGetPrototypeOf,
        isES5: isES5,
        propertyIsWritable: function() {
            return true;
        }
    };
}

},{}],14:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var PromiseMap = Promise.map;

Promise.prototype.filter = function (fn, options) {
    return PromiseMap(this, fn, options, INTERNAL);
};

Promise.filter = function (promises, fn, options) {
    return PromiseMap(promises, fn, options, INTERNAL);
};
};

},{}],15:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, tryConvertToPromise, NEXT_FILTER) {
var util = _dereq_("./util");
var CancellationError = Promise.CancellationError;
var errorObj = util.errorObj;
var catchFilter = _dereq_("./catch_filter")(NEXT_FILTER);

function PassThroughHandlerContext(promise, type, handler) {
    this.promise = promise;
    this.type = type;
    this.handler = handler;
    this.called = false;
    this.cancelPromise = null;
}

PassThroughHandlerContext.prototype.isFinallyHandler = function() {
    return this.type === 0;
};

function FinallyHandlerCancelReaction(finallyHandler) {
    this.finallyHandler = finallyHandler;
}

FinallyHandlerCancelReaction.prototype._resultCancelled = function() {
    checkCancel(this.finallyHandler);
};

function checkCancel(ctx, reason) {
    if (ctx.cancelPromise != null) {
        if (arguments.length > 1) {
            ctx.cancelPromise._reject(reason);
        } else {
            ctx.cancelPromise._cancel();
        }
        ctx.cancelPromise = null;
        return true;
    }
    return false;
}

function succeed() {
    return finallyHandler.call(this, this.promise._target()._settledValue());
}
function fail(reason) {
    if (checkCancel(this, reason)) return;
    errorObj.e = reason;
    return errorObj;
}
function finallyHandler(reasonOrValue) {
    var promise = this.promise;
    var handler = this.handler;

    if (!this.called) {
        this.called = true;
        var ret = this.isFinallyHandler()
            ? handler.call(promise._boundValue())
            : handler.call(promise._boundValue(), reasonOrValue);
        if (ret === NEXT_FILTER) {
            return ret;
        } else if (ret !== undefined) {
            promise._setReturnedNonUndefined();
            var maybePromise = tryConvertToPromise(ret, promise);
            if (maybePromise instanceof Promise) {
                if (this.cancelPromise != null) {
                    if (maybePromise._isCancelled()) {
                        var reason =
                            new CancellationError("late cancellation observer");
                        promise._attachExtraTrace(reason);
                        errorObj.e = reason;
                        return errorObj;
                    } else if (maybePromise.isPending()) {
                        maybePromise._attachCancellationCallback(
                            new FinallyHandlerCancelReaction(this));
                    }
                }
                return maybePromise._then(
                    succeed, fail, undefined, this, undefined);
            }
        }
    }

    if (promise.isRejected()) {
        checkCancel(this);
        errorObj.e = reasonOrValue;
        return errorObj;
    } else {
        checkCancel(this);
        return reasonOrValue;
    }
}

Promise.prototype._passThrough = function(handler, type, success, fail) {
    if (typeof handler !== "function") return this.then();
    return this._then(success,
                      fail,
                      undefined,
                      new PassThroughHandlerContext(this, type, handler),
                      undefined);
};

Promise.prototype.lastly =
Promise.prototype["finally"] = function (handler) {
    return this._passThrough(handler,
                             0,
                             finallyHandler,
                             finallyHandler);
};


Promise.prototype.tap = function (handler) {
    return this._passThrough(handler, 1, finallyHandler);
};

Promise.prototype.tapCatch = function (handlerOrPredicate) {
    var len = arguments.length;
    if(len === 1) {
        return this._passThrough(handlerOrPredicate,
                                 1,
                                 undefined,
                                 finallyHandler);
    } else {
         var catchInstances = new Array(len - 1),
            j = 0, i;
        for (i = 0; i < len - 1; ++i) {
            var item = arguments[i];
            if (util.isObject(item)) {
                catchInstances[j++] = item;
            } else {
                return Promise.reject(new TypeError(
                    "tapCatch statement predicate: "
                    + "expecting an object but got " + util.classString(item)
                ));
            }
        }
        catchInstances.length = j;
        var handler = arguments[i];
        return this._passThrough(catchFilter(catchInstances, handler, this),
                                 1,
                                 undefined,
                                 finallyHandler);
    }

};

return PassThroughHandlerContext;
};

},{"./catch_filter":7,"./util":36}],16:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          apiRejection,
                          INTERNAL,
                          tryConvertToPromise,
                          Proxyable,
                          debug) {
var errors = _dereq_("./errors");
var TypeError = errors.TypeError;
var util = _dereq_("./util");
var errorObj = util.errorObj;
var tryCatch = util.tryCatch;
var yieldHandlers = [];

function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
    for (var i = 0; i < yieldHandlers.length; ++i) {
        traceParent._pushContext();
        var result = tryCatch(yieldHandlers[i])(value);
        traceParent._popContext();
        if (result === errorObj) {
            traceParent._pushContext();
            var ret = Promise.reject(errorObj.e);
            traceParent._popContext();
            return ret;
        }
        var maybePromise = tryConvertToPromise(result, traceParent);
        if (maybePromise instanceof Promise) return maybePromise;
    }
    return null;
}

function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
    if (debug.cancellation()) {
        var internal = new Promise(INTERNAL);
        var _finallyPromise = this._finallyPromise = new Promise(INTERNAL);
        this._promise = internal.lastly(function() {
            return _finallyPromise;
        });
        internal._captureStackTrace();
        internal._setOnCancel(this);
    } else {
        var promise = this._promise = new Promise(INTERNAL);
        promise._captureStackTrace();
    }
    this._stack = stack;
    this._generatorFunction = generatorFunction;
    this._receiver = receiver;
    this._generator = undefined;
    this._yieldHandlers = typeof yieldHandler === "function"
        ? [yieldHandler].concat(yieldHandlers)
        : yieldHandlers;
    this._yieldedPromise = null;
    this._cancellationPhase = false;
}
util.inherits(PromiseSpawn, Proxyable);

PromiseSpawn.prototype._isResolved = function() {
    return this._promise === null;
};

PromiseSpawn.prototype._cleanup = function() {
    this._promise = this._generator = null;
    if (debug.cancellation() && this._finallyPromise !== null) {
        this._finallyPromise._fulfill();
        this._finallyPromise = null;
    }
};

PromiseSpawn.prototype._promiseCancelled = function() {
    if (this._isResolved()) return;
    var implementsReturn = typeof this._generator["return"] !== "undefined";

    var result;
    if (!implementsReturn) {
        var reason = new Promise.CancellationError(
            "generator .return() sentinel");
        Promise.coroutine.returnSentinel = reason;
        this._promise._attachExtraTrace(reason);
        this._promise._pushContext();
        result = tryCatch(this._generator["throw"]).call(this._generator,
                                                         reason);
        this._promise._popContext();
    } else {
        this._promise._pushContext();
        result = tryCatch(this._generator["return"]).call(this._generator,
                                                          undefined);
        this._promise._popContext();
    }
    this._cancellationPhase = true;
    this._yieldedPromise = null;
    this._continue(result);
};

PromiseSpawn.prototype._promiseFulfilled = function(value) {
    this._yieldedPromise = null;
    this._promise._pushContext();
    var result = tryCatch(this._generator.next).call(this._generator, value);
    this._promise._popContext();
    this._continue(result);
};

PromiseSpawn.prototype._promiseRejected = function(reason) {
    this._yieldedPromise = null;
    this._promise._attachExtraTrace(reason);
    this._promise._pushContext();
    var result = tryCatch(this._generator["throw"])
        .call(this._generator, reason);
    this._promise._popContext();
    this._continue(result);
};

PromiseSpawn.prototype._resultCancelled = function() {
    if (this._yieldedPromise instanceof Promise) {
        var promise = this._yieldedPromise;
        this._yieldedPromise = null;
        promise.cancel();
    }
};

PromiseSpawn.prototype.promise = function () {
    return this._promise;
};

PromiseSpawn.prototype._run = function () {
    this._generator = this._generatorFunction.call(this._receiver);
    this._receiver =
        this._generatorFunction = undefined;
    this._promiseFulfilled(undefined);
};

PromiseSpawn.prototype._continue = function (result) {
    var promise = this._promise;
    if (result === errorObj) {
        this._cleanup();
        if (this._cancellationPhase) {
            return promise.cancel();
        } else {
            return promise._rejectCallback(result.e, false);
        }
    }

    var value = result.value;
    if (result.done === true) {
        this._cleanup();
        if (this._cancellationPhase) {
            return promise.cancel();
        } else {
            return promise._resolveCallback(value);
        }
    } else {
        var maybePromise = tryConvertToPromise(value, this._promise);
        if (!(maybePromise instanceof Promise)) {
            maybePromise =
                promiseFromYieldHandler(maybePromise,
                                        this._yieldHandlers,
                                        this._promise);
            if (maybePromise === null) {
                this._promiseRejected(
                    new TypeError(
                        "A value %s was yielded that could not be treated as a promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a\u000a".replace("%s", String(value)) +
                        "From coroutine:\u000a" +
                        this._stack.split("\n").slice(1, -7).join("\n")
                    )
                );
                return;
            }
        }
        maybePromise = maybePromise._target();
        var bitField = maybePromise._bitField;
        ;
        if (((bitField & 50397184) === 0)) {
            this._yieldedPromise = maybePromise;
            maybePromise._proxy(this, null);
        } else if (((bitField & 33554432) !== 0)) {
            Promise._async.invoke(
                this._promiseFulfilled, this, maybePromise._value()
            );
        } else if (((bitField & 16777216) !== 0)) {
            Promise._async.invoke(
                this._promiseRejected, this, maybePromise._reason()
            );
        } else {
            this._promiseCancelled();
        }
    }
};

Promise.coroutine = function (generatorFunction, options) {
    if (typeof generatorFunction !== "function") {
        throw new TypeError("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    var yieldHandler = Object(options).yieldHandler;
    var PromiseSpawn$ = PromiseSpawn;
    var stack = new Error().stack;
    return function () {
        var generator = generatorFunction.apply(this, arguments);
        var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler,
                                      stack);
        var ret = spawn.promise();
        spawn._generator = generator;
        spawn._promiseFulfilled(undefined);
        return ret;
    };
};

Promise.coroutine.addYieldHandler = function(fn) {
    if (typeof fn !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(fn));
    }
    yieldHandlers.push(fn);
};

Promise.spawn = function (generatorFunction) {
    debug.deprecated("Promise.spawn()", "Promise.coroutine()");
    if (typeof generatorFunction !== "function") {
        return apiRejection("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    var spawn = new PromiseSpawn(generatorFunction, this);
    var ret = spawn.promise();
    spawn._run(Promise.spawn);
    return ret;
};
};

},{"./errors":12,"./util":36}],17:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, PromiseArray, tryConvertToPromise, INTERNAL, async,
         getDomain) {
var util = _dereq_("./util");
var canEvaluate = util.canEvaluate;
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var reject;

if (false) {
if (canEvaluate) {
    var thenCallback = function(i) {
        return new Function("value", "holder", "                             \n\
            'use strict';                                                    \n\
            holder.pIndex = value;                                           \n\
            holder.checkFulfillment(this);                                   \n\
            ".replace(/Index/g, i));
    };

    var promiseSetter = function(i) {
        return new Function("promise", "holder", "                           \n\
            'use strict';                                                    \n\
            holder.pIndex = promise;                                         \n\
            ".replace(/Index/g, i));
    };

    var generateHolderClass = function(total) {
        var props = new Array(total);
        for (var i = 0; i < props.length; ++i) {
            props[i] = "this.p" + (i+1);
        }
        var assignment = props.join(" = ") + " = null;";
        var cancellationCode= "var promise;\n" + props.map(function(prop) {
            return "                                                         \n\
                promise = " + prop + ";                                      \n\
                if (promise instanceof Promise) {                            \n\
                    promise.cancel();                                        \n\
                }                                                            \n\
            ";
        }).join("\n");
        var passedArguments = props.join(", ");
        var name = "Holder$" + total;


        var code = "return function(tryCatch, errorObj, Promise, async) {    \n\
            'use strict';                                                    \n\
            function [TheName](fn) {                                         \n\
                [TheProperties]                                              \n\
                this.fn = fn;                                                \n\
                this.asyncNeeded = true;                                     \n\
                this.now = 0;                                                \n\
            }                                                                \n\
                                                                             \n\
            [TheName].prototype._callFunction = function(promise) {          \n\
                promise._pushContext();                                      \n\
                var ret = tryCatch(this.fn)([ThePassedArguments]);           \n\
                promise._popContext();                                       \n\
                if (ret === errorObj) {                                      \n\
                    promise._rejectCallback(ret.e, false);                   \n\
                } else {                                                     \n\
                    promise._resolveCallback(ret);                           \n\
                }                                                            \n\
            };                                                               \n\
                                                                             \n\
            [TheName].prototype.checkFulfillment = function(promise) {       \n\
                var now = ++this.now;                                        \n\
                if (now === [TheTotal]) {                                    \n\
                    if (this.asyncNeeded) {                                  \n\
                        async.invoke(this._callFunction, this, promise);     \n\
                    } else {                                                 \n\
                        this._callFunction(promise);                         \n\
                    }                                                        \n\
                                                                             \n\
                }                                                            \n\
            };                                                               \n\
                                                                             \n\
            [TheName].prototype._resultCancelled = function() {              \n\
                [CancellationCode]                                           \n\
            };                                                               \n\
                                                                             \n\
            return [TheName];                                                \n\
        }(tryCatch, errorObj, Promise, async);                               \n\
        ";

        code = code.replace(/\[TheName\]/g, name)
            .replace(/\[TheTotal\]/g, total)
            .replace(/\[ThePassedArguments\]/g, passedArguments)
            .replace(/\[TheProperties\]/g, assignment)
            .replace(/\[CancellationCode\]/g, cancellationCode);

        return new Function("tryCatch", "errorObj", "Promise", "async", code)
                           (tryCatch, errorObj, Promise, async);
    };

    var holderClasses = [];
    var thenCallbacks = [];
    var promiseSetters = [];

    for (var i = 0; i < 8; ++i) {
        holderClasses.push(generateHolderClass(i + 1));
        thenCallbacks.push(thenCallback(i + 1));
        promiseSetters.push(promiseSetter(i + 1));
    }

    reject = function (reason) {
        this._reject(reason);
    };
}}

Promise.join = function () {
    var last = arguments.length - 1;
    var fn;
    if (last > 0 && typeof arguments[last] === "function") {
        fn = arguments[last];
        if (false) {
            if (last <= 8 && canEvaluate) {
                var ret = new Promise(INTERNAL);
                ret._captureStackTrace();
                var HolderClass = holderClasses[last - 1];
                var holder = new HolderClass(fn);
                var callbacks = thenCallbacks;

                for (var i = 0; i < last; ++i) {
                    var maybePromise = tryConvertToPromise(arguments[i], ret);
                    if (maybePromise instanceof Promise) {
                        maybePromise = maybePromise._target();
                        var bitField = maybePromise._bitField;
                        ;
                        if (((bitField & 50397184) === 0)) {
                            maybePromise._then(callbacks[i], reject,
                                               undefined, ret, holder);
                            promiseSetters[i](maybePromise, holder);
                            holder.asyncNeeded = false;
                        } else if (((bitField & 33554432) !== 0)) {
                            callbacks[i].call(ret,
                                              maybePromise._value(), holder);
                        } else if (((bitField & 16777216) !== 0)) {
                            ret._reject(maybePromise._reason());
                        } else {
                            ret._cancel();
                        }
                    } else {
                        callbacks[i].call(ret, maybePromise, holder);
                    }
                }

                if (!ret._isFateSealed()) {
                    if (holder.asyncNeeded) {
                        var domain = getDomain();
                        if (domain !== null) {
                            holder.fn = util.domainBind(domain, holder.fn);
                        }
                    }
                    ret._setAsyncGuaranteed();
                    ret._setOnCancel(holder);
                }
                return ret;
            }
        }
    }
    var args = [].slice.call(arguments);;
    if (fn) args.pop();
    var ret = new PromiseArray(args).promise();
    return fn !== undefined ? ret.spread(fn) : ret;
};

};

},{"./util":36}],18:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          PromiseArray,
                          apiRejection,
                          tryConvertToPromise,
                          INTERNAL,
                          debug) {
var getDomain = Promise._getDomain;
var util = _dereq_("./util");
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var async = Promise._async;

function MappingPromiseArray(promises, fn, limit, _filter) {
    this.constructor$(promises);
    this._promise._captureStackTrace();
    var domain = getDomain();
    this._callback = domain === null ? fn : util.domainBind(domain, fn);
    this._preservedValues = _filter === INTERNAL
        ? new Array(this.length())
        : null;
    this._limit = limit;
    this._inFlight = 0;
    this._queue = [];
    async.invoke(this._asyncInit, this, undefined);
}
util.inherits(MappingPromiseArray, PromiseArray);

MappingPromiseArray.prototype._asyncInit = function() {
    this._init$(undefined, -2);
};

MappingPromiseArray.prototype._init = function () {};

MappingPromiseArray.prototype._promiseFulfilled = function (value, index) {
    var values = this._values;
    var length = this.length();
    var preservedValues = this._preservedValues;
    var limit = this._limit;

    if (index < 0) {
        index = (index * -1) - 1;
        values[index] = value;
        if (limit >= 1) {
            this._inFlight--;
            this._drainQueue();
            if (this._isResolved()) return true;
        }
    } else {
        if (limit >= 1 && this._inFlight >= limit) {
            values[index] = value;
            this._queue.push(index);
            return false;
        }
        if (preservedValues !== null) preservedValues[index] = value;

        var promise = this._promise;
        var callback = this._callback;
        var receiver = promise._boundValue();
        promise._pushContext();
        var ret = tryCatch(callback).call(receiver, value, index, length);
        var promiseCreated = promise._popContext();
        debug.checkForgottenReturns(
            ret,
            promiseCreated,
            preservedValues !== null ? "Promise.filter" : "Promise.map",
            promise
        );
        if (ret === errorObj) {
            this._reject(ret.e);
            return true;
        }

        var maybePromise = tryConvertToPromise(ret, this._promise);
        if (maybePromise instanceof Promise) {
            maybePromise = maybePromise._target();
            var bitField = maybePromise._bitField;
            ;
            if (((bitField & 50397184) === 0)) {
                if (limit >= 1) this._inFlight++;
                values[index] = maybePromise;
                maybePromise._proxy(this, (index + 1) * -1);
                return false;
            } else if (((bitField & 33554432) !== 0)) {
                ret = maybePromise._value();
            } else if (((bitField & 16777216) !== 0)) {
                this._reject(maybePromise._reason());
                return true;
            } else {
                this._cancel();
                return true;
            }
        }
        values[index] = ret;
    }
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= length) {
        if (preservedValues !== null) {
            this._filter(values, preservedValues);
        } else {
            this._resolve(values);
        }
        return true;
    }
    return false;
};

MappingPromiseArray.prototype._drainQueue = function () {
    var queue = this._queue;
    var limit = this._limit;
    var values = this._values;
    while (queue.length > 0 && this._inFlight < limit) {
        if (this._isResolved()) return;
        var index = queue.pop();
        this._promiseFulfilled(values[index], index);
    }
};

MappingPromiseArray.prototype._filter = function (booleans, values) {
    var len = values.length;
    var ret = new Array(len);
    var j = 0;
    for (var i = 0; i < len; ++i) {
        if (booleans[i]) ret[j++] = values[i];
    }
    ret.length = j;
    this._resolve(ret);
};

MappingPromiseArray.prototype.preservedValues = function () {
    return this._preservedValues;
};

function map(promises, fn, options, _filter) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }

    var limit = 0;
    if (options !== undefined) {
        if (typeof options === "object" && options !== null) {
            if (typeof options.concurrency !== "number") {
                return Promise.reject(
                    new TypeError("'concurrency' must be a number but it is " +
                                    util.classString(options.concurrency)));
            }
            limit = options.concurrency;
        } else {
            return Promise.reject(new TypeError(
                            "options argument must be an object but it is " +
                             util.classString(options)));
        }
    }
    limit = typeof limit === "number" &&
        isFinite(limit) && limit >= 1 ? limit : 0;
    return new MappingPromiseArray(promises, fn, limit, _filter).promise();
}

Promise.prototype.map = function (fn, options) {
    return map(this, fn, options, null);
};

Promise.map = function (promises, fn, options, _filter) {
    return map(promises, fn, options, _filter);
};


};

},{"./util":36}],19:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, INTERNAL, tryConvertToPromise, apiRejection, debug) {
var util = _dereq_("./util");
var tryCatch = util.tryCatch;

Promise.method = function (fn) {
    if (typeof fn !== "function") {
        throw new Promise.TypeError("expecting a function but got " + util.classString(fn));
    }
    return function () {
        var ret = new Promise(INTERNAL);
        ret._captureStackTrace();
        ret._pushContext();
        var value = tryCatch(fn).apply(this, arguments);
        var promiseCreated = ret._popContext();
        debug.checkForgottenReturns(
            value, promiseCreated, "Promise.method", ret);
        ret._resolveFromSyncValue(value);
        return ret;
    };
};

Promise.attempt = Promise["try"] = function (fn) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    ret._pushContext();
    var value;
    if (arguments.length > 1) {
        debug.deprecated("calling Promise.try with more than 1 argument");
        var arg = arguments[1];
        var ctx = arguments[2];
        value = util.isArray(arg) ? tryCatch(fn).apply(ctx, arg)
                                  : tryCatch(fn).call(ctx, arg);
    } else {
        value = tryCatch(fn)();
    }
    var promiseCreated = ret._popContext();
    debug.checkForgottenReturns(
        value, promiseCreated, "Promise.try", ret);
    ret._resolveFromSyncValue(value);
    return ret;
};

Promise.prototype._resolveFromSyncValue = function (value) {
    if (value === util.errorObj) {
        this._rejectCallback(value.e, false);
    } else {
        this._resolveCallback(value, true);
    }
};
};

},{"./util":36}],20:[function(_dereq_,module,exports){
"use strict";
var util = _dereq_("./util");
var maybeWrapAsError = util.maybeWrapAsError;
var errors = _dereq_("./errors");
var OperationalError = errors.OperationalError;
var es5 = _dereq_("./es5");

function isUntypedError(obj) {
    return obj instanceof Error &&
        es5.getPrototypeOf(obj) === Error.prototype;
}

var rErrorKey = /^(?:name|message|stack|cause)$/;
function wrapAsOperationalError(obj) {
    var ret;
    if (isUntypedError(obj)) {
        ret = new OperationalError(obj);
        ret.name = obj.name;
        ret.message = obj.message;
        ret.stack = obj.stack;
        var keys = es5.keys(obj);
        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!rErrorKey.test(key)) {
                ret[key] = obj[key];
            }
        }
        return ret;
    }
    util.markAsOriginatingFromRejection(obj);
    return obj;
}

function nodebackForPromise(promise, multiArgs) {
    return function(err, value) {
        if (promise === null) return;
        if (err) {
            var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
            promise._attachExtraTrace(wrapped);
            promise._reject(wrapped);
        } else if (!multiArgs) {
            promise._fulfill(value);
        } else {
            var args = [].slice.call(arguments, 1);;
            promise._fulfill(args);
        }
        promise = null;
    };
}

module.exports = nodebackForPromise;

},{"./errors":12,"./es5":13,"./util":36}],21:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var util = _dereq_("./util");
var async = Promise._async;
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;

function spreadAdapter(val, nodeback) {
    var promise = this;
    if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
    var ret =
        tryCatch(nodeback).apply(promise._boundValue(), [null].concat(val));
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}

function successAdapter(val, nodeback) {
    var promise = this;
    var receiver = promise._boundValue();
    var ret = val === undefined
        ? tryCatch(nodeback).call(receiver, null)
        : tryCatch(nodeback).call(receiver, null, val);
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}
function errorAdapter(reason, nodeback) {
    var promise = this;
    if (!reason) {
        var newReason = new Error(reason + "");
        newReason.cause = reason;
        reason = newReason;
    }
    var ret = tryCatch(nodeback).call(promise._boundValue(), reason);
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}

Promise.prototype.asCallback = Promise.prototype.nodeify = function (nodeback,
                                                                     options) {
    if (typeof nodeback == "function") {
        var adapter = successAdapter;
        if (options !== undefined && Object(options).spread) {
            adapter = spreadAdapter;
        }
        this._then(
            adapter,
            errorAdapter,
            undefined,
            this,
            nodeback
        );
    }
    return this;
};
};

},{"./util":36}],22:[function(_dereq_,module,exports){
"use strict";
module.exports = function() {
var makeSelfResolutionError = function () {
    return new TypeError("circular promise resolution chain\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
};
var reflectHandler = function() {
    return new Promise.PromiseInspection(this._target());
};
var apiRejection = function(msg) {
    return Promise.reject(new TypeError(msg));
};
function Proxyable() {}
var UNDEFINED_BINDING = {};
var util = _dereq_("./util");

var getDomain;
if (util.isNode) {
    getDomain = function() {
        var ret = process.domain;
        if (ret === undefined) ret = null;
        return ret;
    };
} else {
    getDomain = function() {
        return null;
    };
}
util.notEnumerableProp(Promise, "_getDomain", getDomain);

var es5 = _dereq_("./es5");
var Async = _dereq_("./async");
var async = new Async();
es5.defineProperty(Promise, "_async", {value: async});
var errors = _dereq_("./errors");
var TypeError = Promise.TypeError = errors.TypeError;
Promise.RangeError = errors.RangeError;
var CancellationError = Promise.CancellationError = errors.CancellationError;
Promise.TimeoutError = errors.TimeoutError;
Promise.OperationalError = errors.OperationalError;
Promise.RejectionError = errors.OperationalError;
Promise.AggregateError = errors.AggregateError;
var INTERNAL = function(){};
var APPLY = {};
var NEXT_FILTER = {};
var tryConvertToPromise = _dereq_("./thenables")(Promise, INTERNAL);
var PromiseArray =
    _dereq_("./promise_array")(Promise, INTERNAL,
                               tryConvertToPromise, apiRejection, Proxyable);
var Context = _dereq_("./context")(Promise);
 /*jshint unused:false*/
var createContext = Context.create;
var debug = _dereq_("./debuggability")(Promise, Context);
var CapturedTrace = debug.CapturedTrace;
var PassThroughHandlerContext =
    _dereq_("./finally")(Promise, tryConvertToPromise, NEXT_FILTER);
var catchFilter = _dereq_("./catch_filter")(NEXT_FILTER);
var nodebackForPromise = _dereq_("./nodeback");
var errorObj = util.errorObj;
var tryCatch = util.tryCatch;
function check(self, executor) {
    if (self == null || self.constructor !== Promise) {
        throw new TypeError("the promise constructor cannot be invoked directly\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    if (typeof executor !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(executor));
    }

}

function Promise(executor) {
    if (executor !== INTERNAL) {
        check(this, executor);
    }
    this._bitField = 0;
    this._fulfillmentHandler0 = undefined;
    this._rejectionHandler0 = undefined;
    this._promise0 = undefined;
    this._receiver0 = undefined;
    this._resolveFromExecutor(executor);
    this._promiseCreated();
    this._fireEvent("promiseCreated", this);
}

Promise.prototype.toString = function () {
    return "[object Promise]";
};

Promise.prototype.caught = Promise.prototype["catch"] = function (fn) {
    var len = arguments.length;
    if (len > 1) {
        var catchInstances = new Array(len - 1),
            j = 0, i;
        for (i = 0; i < len - 1; ++i) {
            var item = arguments[i];
            if (util.isObject(item)) {
                catchInstances[j++] = item;
            } else {
                return apiRejection("Catch statement predicate: " +
                    "expecting an object but got " + util.classString(item));
            }
        }
        catchInstances.length = j;
        fn = arguments[i];
        return this.then(undefined, catchFilter(catchInstances, fn, this));
    }
    return this.then(undefined, fn);
};

Promise.prototype.reflect = function () {
    return this._then(reflectHandler,
        reflectHandler, undefined, this, undefined);
};

Promise.prototype.then = function (didFulfill, didReject) {
    if (debug.warnings() && arguments.length > 0 &&
        typeof didFulfill !== "function" &&
        typeof didReject !== "function") {
        var msg = ".then() only accepts functions but was passed: " +
                util.classString(didFulfill);
        if (arguments.length > 1) {
            msg += ", " + util.classString(didReject);
        }
        this._warn(msg);
    }
    return this._then(didFulfill, didReject, undefined, undefined, undefined);
};

Promise.prototype.done = function (didFulfill, didReject) {
    var promise =
        this._then(didFulfill, didReject, undefined, undefined, undefined);
    promise._setIsFinal();
};

Promise.prototype.spread = function (fn) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }
    return this.all()._then(fn, undefined, undefined, APPLY, undefined);
};

Promise.prototype.toJSON = function () {
    var ret = {
        isFulfilled: false,
        isRejected: false,
        fulfillmentValue: undefined,
        rejectionReason: undefined
    };
    if (this.isFulfilled()) {
        ret.fulfillmentValue = this.value();
        ret.isFulfilled = true;
    } else if (this.isRejected()) {
        ret.rejectionReason = this.reason();
        ret.isRejected = true;
    }
    return ret;
};

Promise.prototype.all = function () {
    if (arguments.length > 0) {
        this._warn(".all() was passed arguments but it does not take any");
    }
    return new PromiseArray(this).promise();
};

Promise.prototype.error = function (fn) {
    return this.caught(util.originatesFromRejection, fn);
};

Promise.getNewLibraryCopy = module.exports;

Promise.is = function (val) {
    return val instanceof Promise;
};

Promise.fromNode = Promise.fromCallback = function(fn) {
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    var multiArgs = arguments.length > 1 ? !!Object(arguments[1]).multiArgs
                                         : false;
    var result = tryCatch(fn)(nodebackForPromise(ret, multiArgs));
    if (result === errorObj) {
        ret._rejectCallback(result.e, true);
    }
    if (!ret._isFateSealed()) ret._setAsyncGuaranteed();
    return ret;
};

Promise.all = function (promises) {
    return new PromiseArray(promises).promise();
};

Promise.cast = function (obj) {
    var ret = tryConvertToPromise(obj);
    if (!(ret instanceof Promise)) {
        ret = new Promise(INTERNAL);
        ret._captureStackTrace();
        ret._setFulfilled();
        ret._rejectionHandler0 = obj;
    }
    return ret;
};

Promise.resolve = Promise.fulfilled = Promise.cast;

Promise.reject = Promise.rejected = function (reason) {
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    ret._rejectCallback(reason, true);
    return ret;
};

Promise.setScheduler = function(fn) {
    if (typeof fn !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(fn));
    }
    return async.setScheduler(fn);
};

Promise.prototype._then = function (
    didFulfill,
    didReject,
    _,    receiver,
    internalData
) {
    var haveInternalData = internalData !== undefined;
    var promise = haveInternalData ? internalData : new Promise(INTERNAL);
    var target = this._target();
    var bitField = target._bitField;

    if (!haveInternalData) {
        promise._propagateFrom(this, 3);
        promise._captureStackTrace();
        if (receiver === undefined &&
            ((this._bitField & 2097152) !== 0)) {
            if (!((bitField & 50397184) === 0)) {
                receiver = this._boundValue();
            } else {
                receiver = target === this ? undefined : this._boundTo;
            }
        }
        this._fireEvent("promiseChained", this, promise);
    }

    var domain = getDomain();
    if (!((bitField & 50397184) === 0)) {
        var handler, value, settler = target._settlePromiseCtx;
        if (((bitField & 33554432) !== 0)) {
            value = target._rejectionHandler0;
            handler = didFulfill;
        } else if (((bitField & 16777216) !== 0)) {
            value = target._fulfillmentHandler0;
            handler = didReject;
            target._unsetRejectionIsUnhandled();
        } else {
            settler = target._settlePromiseLateCancellationObserver;
            value = new CancellationError("late cancellation observer");
            target._attachExtraTrace(value);
            handler = didReject;
        }

        async.invoke(settler, target, {
            handler: domain === null ? handler
                : (typeof handler === "function" &&
                    util.domainBind(domain, handler)),
            promise: promise,
            receiver: receiver,
            value: value
        });
    } else {
        target._addCallbacks(didFulfill, didReject, promise, receiver, domain);
    }

    return promise;
};

Promise.prototype._length = function () {
    return this._bitField & 65535;
};

Promise.prototype._isFateSealed = function () {
    return (this._bitField & 117506048) !== 0;
};

Promise.prototype._isFollowing = function () {
    return (this._bitField & 67108864) === 67108864;
};

Promise.prototype._setLength = function (len) {
    this._bitField = (this._bitField & -65536) |
        (len & 65535);
};

Promise.prototype._setFulfilled = function () {
    this._bitField = this._bitField | 33554432;
    this._fireEvent("promiseFulfilled", this);
};

Promise.prototype._setRejected = function () {
    this._bitField = this._bitField | 16777216;
    this._fireEvent("promiseRejected", this);
};

Promise.prototype._setFollowing = function () {
    this._bitField = this._bitField | 67108864;
    this._fireEvent("promiseResolved", this);
};

Promise.prototype._setIsFinal = function () {
    this._bitField = this._bitField | 4194304;
};

Promise.prototype._isFinal = function () {
    return (this._bitField & 4194304) > 0;
};

Promise.prototype._unsetCancelled = function() {
    this._bitField = this._bitField & (~65536);
};

Promise.prototype._setCancelled = function() {
    this._bitField = this._bitField | 65536;
    this._fireEvent("promiseCancelled", this);
};

Promise.prototype._setWillBeCancelled = function() {
    this._bitField = this._bitField | 8388608;
};

Promise.prototype._setAsyncGuaranteed = function() {
    if (async.hasCustomScheduler()) return;
    this._bitField = this._bitField | 134217728;
};

Promise.prototype._receiverAt = function (index) {
    var ret = index === 0 ? this._receiver0 : this[
            index * 4 - 4 + 3];
    if (ret === UNDEFINED_BINDING) {
        return undefined;
    } else if (ret === undefined && this._isBound()) {
        return this._boundValue();
    }
    return ret;
};

Promise.prototype._promiseAt = function (index) {
    return this[
            index * 4 - 4 + 2];
};

Promise.prototype._fulfillmentHandlerAt = function (index) {
    return this[
            index * 4 - 4 + 0];
};

Promise.prototype._rejectionHandlerAt = function (index) {
    return this[
            index * 4 - 4 + 1];
};

Promise.prototype._boundValue = function() {};

Promise.prototype._migrateCallback0 = function (follower) {
    var bitField = follower._bitField;
    var fulfill = follower._fulfillmentHandler0;
    var reject = follower._rejectionHandler0;
    var promise = follower._promise0;
    var receiver = follower._receiverAt(0);
    if (receiver === undefined) receiver = UNDEFINED_BINDING;
    this._addCallbacks(fulfill, reject, promise, receiver, null);
};

Promise.prototype._migrateCallbackAt = function (follower, index) {
    var fulfill = follower._fulfillmentHandlerAt(index);
    var reject = follower._rejectionHandlerAt(index);
    var promise = follower._promiseAt(index);
    var receiver = follower._receiverAt(index);
    if (receiver === undefined) receiver = UNDEFINED_BINDING;
    this._addCallbacks(fulfill, reject, promise, receiver, null);
};

Promise.prototype._addCallbacks = function (
    fulfill,
    reject,
    promise,
    receiver,
    domain
) {
    var index = this._length();

    if (index >= 65535 - 4) {
        index = 0;
        this._setLength(0);
    }

    if (index === 0) {
        this._promise0 = promise;
        this._receiver0 = receiver;
        if (typeof fulfill === "function") {
            this._fulfillmentHandler0 =
                domain === null ? fulfill : util.domainBind(domain, fulfill);
        }
        if (typeof reject === "function") {
            this._rejectionHandler0 =
                domain === null ? reject : util.domainBind(domain, reject);
        }
    } else {
        var base = index * 4 - 4;
        this[base + 2] = promise;
        this[base + 3] = receiver;
        if (typeof fulfill === "function") {
            this[base + 0] =
                domain === null ? fulfill : util.domainBind(domain, fulfill);
        }
        if (typeof reject === "function") {
            this[base + 1] =
                domain === null ? reject : util.domainBind(domain, reject);
        }
    }
    this._setLength(index + 1);
    return index;
};

Promise.prototype._proxy = function (proxyable, arg) {
    this._addCallbacks(undefined, undefined, arg, proxyable, null);
};

Promise.prototype._resolveCallback = function(value, shouldBind) {
    if (((this._bitField & 117506048) !== 0)) return;
    if (value === this)
        return this._rejectCallback(makeSelfResolutionError(), false);
    var maybePromise = tryConvertToPromise(value, this);
    if (!(maybePromise instanceof Promise)) return this._fulfill(value);

    if (shouldBind) this._propagateFrom(maybePromise, 2);

    var promise = maybePromise._target();

    if (promise === this) {
        this._reject(makeSelfResolutionError());
        return;
    }

    var bitField = promise._bitField;
    if (((bitField & 50397184) === 0)) {
        var len = this._length();
        if (len > 0) promise._migrateCallback0(this);
        for (var i = 1; i < len; ++i) {
            promise._migrateCallbackAt(this, i);
        }
        this._setFollowing();
        this._setLength(0);
        this._setFollowee(promise);
    } else if (((bitField & 33554432) !== 0)) {
        this._fulfill(promise._value());
    } else if (((bitField & 16777216) !== 0)) {
        this._reject(promise._reason());
    } else {
        var reason = new CancellationError("late cancellation observer");
        promise._attachExtraTrace(reason);
        this._reject(reason);
    }
};

Promise.prototype._rejectCallback =
function(reason, synchronous, ignoreNonErrorWarnings) {
    var trace = util.ensureErrorObject(reason);
    var hasStack = trace === reason;
    if (!hasStack && !ignoreNonErrorWarnings && debug.warnings()) {
        var message = "a promise was rejected with a non-error: " +
            util.classString(reason);
        this._warn(message, true);
    }
    this._attachExtraTrace(trace, synchronous ? hasStack : false);
    this._reject(reason);
};

Promise.prototype._resolveFromExecutor = function (executor) {
    if (executor === INTERNAL) return;
    var promise = this;
    this._captureStackTrace();
    this._pushContext();
    var synchronous = true;
    var r = this._execute(executor, function(value) {
        promise._resolveCallback(value);
    }, function (reason) {
        promise._rejectCallback(reason, synchronous);
    });
    synchronous = false;
    this._popContext();

    if (r !== undefined) {
        promise._rejectCallback(r, true);
    }
};

Promise.prototype._settlePromiseFromHandler = function (
    handler, receiver, value, promise
) {
    var bitField = promise._bitField;
    if (((bitField & 65536) !== 0)) return;
    promise._pushContext();
    var x;
    if (receiver === APPLY) {
        if (!value || typeof value.length !== "number") {
            x = errorObj;
            x.e = new TypeError("cannot .spread() a non-array: " +
                                    util.classString(value));
        } else {
            x = tryCatch(handler).apply(this._boundValue(), value);
        }
    } else {
        x = tryCatch(handler).call(receiver, value);
    }
    var promiseCreated = promise._popContext();
    bitField = promise._bitField;
    if (((bitField & 65536) !== 0)) return;

    if (x === NEXT_FILTER) {
        promise._reject(value);
    } else if (x === errorObj) {
        promise._rejectCallback(x.e, false);
    } else {
        debug.checkForgottenReturns(x, promiseCreated, "",  promise, this);
        promise._resolveCallback(x);
    }
};

Promise.prototype._target = function() {
    var ret = this;
    while (ret._isFollowing()) ret = ret._followee();
    return ret;
};

Promise.prototype._followee = function() {
    return this._rejectionHandler0;
};

Promise.prototype._setFollowee = function(promise) {
    this._rejectionHandler0 = promise;
};

Promise.prototype._settlePromise = function(promise, handler, receiver, value) {
    var isPromise = promise instanceof Promise;
    var bitField = this._bitField;
    var asyncGuaranteed = ((bitField & 134217728) !== 0);
    if (((bitField & 65536) !== 0)) {
        if (isPromise) promise._invokeInternalOnCancel();

        if (receiver instanceof PassThroughHandlerContext &&
            receiver.isFinallyHandler()) {
            receiver.cancelPromise = promise;
            if (tryCatch(handler).call(receiver, value) === errorObj) {
                promise._reject(errorObj.e);
            }
        } else if (handler === reflectHandler) {
            promise._fulfill(reflectHandler.call(receiver));
        } else if (receiver instanceof Proxyable) {
            receiver._promiseCancelled(promise);
        } else if (isPromise || promise instanceof PromiseArray) {
            promise._cancel();
        } else {
            receiver.cancel();
        }
    } else if (typeof handler === "function") {
        if (!isPromise) {
            handler.call(receiver, value, promise);
        } else {
            if (asyncGuaranteed) promise._setAsyncGuaranteed();
            this._settlePromiseFromHandler(handler, receiver, value, promise);
        }
    } else if (receiver instanceof Proxyable) {
        if (!receiver._isResolved()) {
            if (((bitField & 33554432) !== 0)) {
                receiver._promiseFulfilled(value, promise);
            } else {
                receiver._promiseRejected(value, promise);
            }
        }
    } else if (isPromise) {
        if (asyncGuaranteed) promise._setAsyncGuaranteed();
        if (((bitField & 33554432) !== 0)) {
            promise._fulfill(value);
        } else {
            promise._reject(value);
        }
    }
};

Promise.prototype._settlePromiseLateCancellationObserver = function(ctx) {
    var handler = ctx.handler;
    var promise = ctx.promise;
    var receiver = ctx.receiver;
    var value = ctx.value;
    if (typeof handler === "function") {
        if (!(promise instanceof Promise)) {
            handler.call(receiver, value, promise);
        } else {
            this._settlePromiseFromHandler(handler, receiver, value, promise);
        }
    } else if (promise instanceof Promise) {
        promise._reject(value);
    }
};

Promise.prototype._settlePromiseCtx = function(ctx) {
    this._settlePromise(ctx.promise, ctx.handler, ctx.receiver, ctx.value);
};

Promise.prototype._settlePromise0 = function(handler, value, bitField) {
    var promise = this._promise0;
    var receiver = this._receiverAt(0);
    this._promise0 = undefined;
    this._receiver0 = undefined;
    this._settlePromise(promise, handler, receiver, value);
};

Promise.prototype._clearCallbackDataAtIndex = function(index) {
    var base = index * 4 - 4;
    this[base + 2] =
    this[base + 3] =
    this[base + 0] =
    this[base + 1] = undefined;
};

Promise.prototype._fulfill = function (value) {
    var bitField = this._bitField;
    if (((bitField & 117506048) >>> 16)) return;
    if (value === this) {
        var err = makeSelfResolutionError();
        this._attachExtraTrace(err);
        return this._reject(err);
    }
    this._setFulfilled();
    this._rejectionHandler0 = value;

    if ((bitField & 65535) > 0) {
        if (((bitField & 134217728) !== 0)) {
            this._settlePromises();
        } else {
            async.settlePromises(this);
        }
    }
};

Promise.prototype._reject = function (reason) {
    var bitField = this._bitField;
    if (((bitField & 117506048) >>> 16)) return;
    this._setRejected();
    this._fulfillmentHandler0 = reason;

    if (this._isFinal()) {
        return async.fatalError(reason, util.isNode);
    }

    if ((bitField & 65535) > 0) {
        async.settlePromises(this);
    } else {
        this._ensurePossibleRejectionHandled();
    }
};

Promise.prototype._fulfillPromises = function (len, value) {
    for (var i = 1; i < len; i++) {
        var handler = this._fulfillmentHandlerAt(i);
        var promise = this._promiseAt(i);
        var receiver = this._receiverAt(i);
        this._clearCallbackDataAtIndex(i);
        this._settlePromise(promise, handler, receiver, value);
    }
};

Promise.prototype._rejectPromises = function (len, reason) {
    for (var i = 1; i < len; i++) {
        var handler = this._rejectionHandlerAt(i);
        var promise = this._promiseAt(i);
        var receiver = this._receiverAt(i);
        this._clearCallbackDataAtIndex(i);
        this._settlePromise(promise, handler, receiver, reason);
    }
};

Promise.prototype._settlePromises = function () {
    var bitField = this._bitField;
    var len = (bitField & 65535);

    if (len > 0) {
        if (((bitField & 16842752) !== 0)) {
            var reason = this._fulfillmentHandler0;
            this._settlePromise0(this._rejectionHandler0, reason, bitField);
            this._rejectPromises(len, reason);
        } else {
            var value = this._rejectionHandler0;
            this._settlePromise0(this._fulfillmentHandler0, value, bitField);
            this._fulfillPromises(len, value);
        }
        this._setLength(0);
    }
    this._clearCancellationData();
};

Promise.prototype._settledValue = function() {
    var bitField = this._bitField;
    if (((bitField & 33554432) !== 0)) {
        return this._rejectionHandler0;
    } else if (((bitField & 16777216) !== 0)) {
        return this._fulfillmentHandler0;
    }
};

function deferResolve(v) {this.promise._resolveCallback(v);}
function deferReject(v) {this.promise._rejectCallback(v, false);}

Promise.defer = Promise.pending = function() {
    debug.deprecated("Promise.defer", "new Promise");
    var promise = new Promise(INTERNAL);
    return {
        promise: promise,
        resolve: deferResolve,
        reject: deferReject
    };
};

util.notEnumerableProp(Promise,
                       "_makeSelfResolutionError",
                       makeSelfResolutionError);

_dereq_("./method")(Promise, INTERNAL, tryConvertToPromise, apiRejection,
    debug);
_dereq_("./bind")(Promise, INTERNAL, tryConvertToPromise, debug);
_dereq_("./cancel")(Promise, PromiseArray, apiRejection, debug);
_dereq_("./direct_resolve")(Promise);
_dereq_("./synchronous_inspection")(Promise);
_dereq_("./join")(
    Promise, PromiseArray, tryConvertToPromise, INTERNAL, async, getDomain);
Promise.Promise = Promise;
Promise.version = "3.5.0";
_dereq_('./map.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
_dereq_('./call_get.js')(Promise);
_dereq_('./using.js')(Promise, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug);
_dereq_('./timers.js')(Promise, INTERNAL, debug);
_dereq_('./generators.js')(Promise, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug);
_dereq_('./nodeify.js')(Promise);
_dereq_('./promisify.js')(Promise, INTERNAL);
_dereq_('./props.js')(Promise, PromiseArray, tryConvertToPromise, apiRejection);
_dereq_('./race.js')(Promise, INTERNAL, tryConvertToPromise, apiRejection);
_dereq_('./reduce.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
_dereq_('./settle.js')(Promise, PromiseArray, debug);
_dereq_('./some.js')(Promise, PromiseArray, apiRejection);
_dereq_('./filter.js')(Promise, INTERNAL);
_dereq_('./each.js')(Promise, INTERNAL);
_dereq_('./any.js')(Promise);
                                                         
    util.toFastProperties(Promise);                                          
    util.toFastProperties(Promise.prototype);                                
    function fillTypes(value) {                                              
        var p = new Promise(INTERNAL);                                       
        p._fulfillmentHandler0 = value;                                      
        p._rejectionHandler0 = value;                                        
        p._promise0 = value;                                                 
        p._receiver0 = value;                                                
    }                                                                        
    // Complete slack tracking, opt out of field-type tracking and           
    // stabilize map                                                         
    fillTypes({a: 1});                                                       
    fillTypes({b: 2});                                                       
    fillTypes({c: 3});                                                       
    fillTypes(1);                                                            
    fillTypes(function(){});                                                 
    fillTypes(undefined);                                                    
    fillTypes(false);                                                        
    fillTypes(new Promise(INTERNAL));                                        
    debug.setBounds(Async.firstLineError, util.lastLineError);               
    return Promise;                                                          

};

},{"./any.js":1,"./async":2,"./bind":3,"./call_get.js":5,"./cancel":6,"./catch_filter":7,"./context":8,"./debuggability":9,"./direct_resolve":10,"./each.js":11,"./errors":12,"./es5":13,"./filter.js":14,"./finally":15,"./generators.js":16,"./join":17,"./map.js":18,"./method":19,"./nodeback":20,"./nodeify.js":21,"./promise_array":23,"./promisify.js":24,"./props.js":25,"./race.js":27,"./reduce.js":28,"./settle.js":30,"./some.js":31,"./synchronous_inspection":32,"./thenables":33,"./timers.js":34,"./using.js":35,"./util":36}],23:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, tryConvertToPromise,
    apiRejection, Proxyable) {
var util = _dereq_("./util");
var isArray = util.isArray;

function toResolutionValue(val) {
    switch(val) {
    case -2: return [];
    case -3: return {};
    case -6: return new Map();
    }
}

function PromiseArray(values) {
    var promise = this._promise = new Promise(INTERNAL);
    if (values instanceof Promise) {
        promise._propagateFrom(values, 3);
    }
    promise._setOnCancel(this);
    this._values = values;
    this._length = 0;
    this._totalResolved = 0;
    this._init(undefined, -2);
}
util.inherits(PromiseArray, Proxyable);

PromiseArray.prototype.length = function () {
    return this._length;
};

PromiseArray.prototype.promise = function () {
    return this._promise;
};

PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
    var values = tryConvertToPromise(this._values, this._promise);
    if (values instanceof Promise) {
        values = values._target();
        var bitField = values._bitField;
        ;
        this._values = values;

        if (((bitField & 50397184) === 0)) {
            this._promise._setAsyncGuaranteed();
            return values._then(
                init,
                this._reject,
                undefined,
                this,
                resolveValueIfEmpty
           );
        } else if (((bitField & 33554432) !== 0)) {
            values = values._value();
        } else if (((bitField & 16777216) !== 0)) {
            return this._reject(values._reason());
        } else {
            return this._cancel();
        }
    }
    values = util.asArray(values);
    if (values === null) {
        var err = apiRejection(
            "expecting an array or an iterable object but got " + util.classString(values)).reason();
        this._promise._rejectCallback(err, false);
        return;
    }

    if (values.length === 0) {
        if (resolveValueIfEmpty === -5) {
            this._resolveEmptyArray();
        }
        else {
            this._resolve(toResolutionValue(resolveValueIfEmpty));
        }
        return;
    }
    this._iterate(values);
};

PromiseArray.prototype._iterate = function(values) {
    var len = this.getActualLength(values.length);
    this._length = len;
    this._values = this.shouldCopyValues() ? new Array(len) : this._values;
    var result = this._promise;
    var isResolved = false;
    var bitField = null;
    for (var i = 0; i < len; ++i) {
        var maybePromise = tryConvertToPromise(values[i], result);

        if (maybePromise instanceof Promise) {
            maybePromise = maybePromise._target();
            bitField = maybePromise._bitField;
        } else {
            bitField = null;
        }

        if (isResolved) {
            if (bitField !== null) {
                maybePromise.suppressUnhandledRejections();
            }
        } else if (bitField !== null) {
            if (((bitField & 50397184) === 0)) {
                maybePromise._proxy(this, i);
                this._values[i] = maybePromise;
            } else if (((bitField & 33554432) !== 0)) {
                isResolved = this._promiseFulfilled(maybePromise._value(), i);
            } else if (((bitField & 16777216) !== 0)) {
                isResolved = this._promiseRejected(maybePromise._reason(), i);
            } else {
                isResolved = this._promiseCancelled(i);
            }
        } else {
            isResolved = this._promiseFulfilled(maybePromise, i);
        }
    }
    if (!isResolved) result._setAsyncGuaranteed();
};

PromiseArray.prototype._isResolved = function () {
    return this._values === null;
};

PromiseArray.prototype._resolve = function (value) {
    this._values = null;
    this._promise._fulfill(value);
};

PromiseArray.prototype._cancel = function() {
    if (this._isResolved() || !this._promise._isCancellable()) return;
    this._values = null;
    this._promise._cancel();
};

PromiseArray.prototype._reject = function (reason) {
    this._values = null;
    this._promise._rejectCallback(reason, false);
};

PromiseArray.prototype._promiseFulfilled = function (value, index) {
    this._values[index] = value;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        this._resolve(this._values);
        return true;
    }
    return false;
};

PromiseArray.prototype._promiseCancelled = function() {
    this._cancel();
    return true;
};

PromiseArray.prototype._promiseRejected = function (reason) {
    this._totalResolved++;
    this._reject(reason);
    return true;
};

PromiseArray.prototype._resultCancelled = function() {
    if (this._isResolved()) return;
    var values = this._values;
    this._cancel();
    if (values instanceof Promise) {
        values.cancel();
    } else {
        for (var i = 0; i < values.length; ++i) {
            if (values[i] instanceof Promise) {
                values[i].cancel();
            }
        }
    }
};

PromiseArray.prototype.shouldCopyValues = function () {
    return true;
};

PromiseArray.prototype.getActualLength = function (len) {
    return len;
};

return PromiseArray;
};

},{"./util":36}],24:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var THIS = {};
var util = _dereq_("./util");
var nodebackForPromise = _dereq_("./nodeback");
var withAppended = util.withAppended;
var maybeWrapAsError = util.maybeWrapAsError;
var canEvaluate = util.canEvaluate;
var TypeError = _dereq_("./errors").TypeError;
var defaultSuffix = "Async";
var defaultPromisified = {__isPromisified__: true};
var noCopyProps = [
    "arity",    "length",
    "name",
    "arguments",
    "caller",
    "callee",
    "prototype",
    "__isPromisified__"
];
var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");

var defaultFilter = function(name) {
    return util.isIdentifier(name) &&
        name.charAt(0) !== "_" &&
        name !== "constructor";
};

function propsFilter(key) {
    return !noCopyPropsPattern.test(key);
}

function isPromisified(fn) {
    try {
        return fn.__isPromisified__ === true;
    }
    catch (e) {
        return false;
    }
}

function hasPromisified(obj, key, suffix) {
    var val = util.getDataPropertyOrDefault(obj, key + suffix,
                                            defaultPromisified);
    return val ? isPromisified(val) : false;
}
function checkValid(ret, suffix, suffixRegexp) {
    for (var i = 0; i < ret.length; i += 2) {
        var key = ret[i];
        if (suffixRegexp.test(key)) {
            var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
            for (var j = 0; j < ret.length; j += 2) {
                if (ret[j] === keyWithoutAsyncSuffix) {
                    throw new TypeError("Cannot promisify an API that has normal methods with '%s'-suffix\u000a\u000a    See http://goo.gl/MqrFmX\u000a"
                        .replace("%s", suffix));
                }
            }
        }
    }
}

function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
    var keys = util.inheritedDataKeys(obj);
    var ret = [];
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var value = obj[key];
        var passesDefaultFilter = filter === defaultFilter
            ? true : defaultFilter(key, value, obj);
        if (typeof value === "function" &&
            !isPromisified(value) &&
            !hasPromisified(obj, key, suffix) &&
            filter(key, value, obj, passesDefaultFilter)) {
            ret.push(key, value);
        }
    }
    checkValid(ret, suffix, suffixRegexp);
    return ret;
}

var escapeIdentRegex = function(str) {
    return str.replace(/([$])/, "\\$");
};

var makeNodePromisifiedEval;
if (false) {
var switchCaseArgumentOrder = function(likelyArgumentCount) {
    var ret = [likelyArgumentCount];
    var min = Math.max(0, likelyArgumentCount - 1 - 3);
    for(var i = likelyArgumentCount - 1; i >= min; --i) {
        ret.push(i);
    }
    for(var i = likelyArgumentCount + 1; i <= 3; ++i) {
        ret.push(i);
    }
    return ret;
};

var argumentSequence = function(argumentCount) {
    return util.filledRange(argumentCount, "_arg", "");
};

var parameterDeclaration = function(parameterCount) {
    return util.filledRange(
        Math.max(parameterCount, 3), "_arg", "");
};

var parameterCount = function(fn) {
    if (typeof fn.length === "number") {
        return Math.max(Math.min(fn.length, 1023 + 1), 0);
    }
    return 0;
};

makeNodePromisifiedEval =
function(callback, receiver, originalName, fn, _, multiArgs) {
    var newParameterCount = Math.max(0, parameterCount(fn) - 1);
    var argumentOrder = switchCaseArgumentOrder(newParameterCount);
    var shouldProxyThis = typeof callback === "string" || receiver === THIS;

    function generateCallForArgumentCount(count) {
        var args = argumentSequence(count).join(", ");
        var comma = count > 0 ? ", " : "";
        var ret;
        if (shouldProxyThis) {
            ret = "ret = callback.call(this, {{args}}, nodeback); break;\n";
        } else {
            ret = receiver === undefined
                ? "ret = callback({{args}}, nodeback); break;\n"
                : "ret = callback.call(receiver, {{args}}, nodeback); break;\n";
        }
        return ret.replace("{{args}}", args).replace(", ", comma);
    }

    function generateArgumentSwitchCase() {
        var ret = "";
        for (var i = 0; i < argumentOrder.length; ++i) {
            ret += "case " + argumentOrder[i] +":" +
                generateCallForArgumentCount(argumentOrder[i]);
        }

        ret += "                                                             \n\
        default:                                                             \n\
            var args = new Array(len + 1);                                   \n\
            var i = 0;                                                       \n\
            for (var i = 0; i < len; ++i) {                                  \n\
               args[i] = arguments[i];                                       \n\
            }                                                                \n\
            args[i] = nodeback;                                              \n\
            [CodeForCall]                                                    \n\
            break;                                                           \n\
        ".replace("[CodeForCall]", (shouldProxyThis
                                ? "ret = callback.apply(this, args);\n"
                                : "ret = callback.apply(receiver, args);\n"));
        return ret;
    }

    var getFunctionCode = typeof callback === "string"
                                ? ("this != null ? this['"+callback+"'] : fn")
                                : "fn";
    var body = "'use strict';                                                \n\
        var ret = function (Parameters) {                                    \n\
            'use strict';                                                    \n\
            var len = arguments.length;                                      \n\
            var promise = new Promise(INTERNAL);                             \n\
            promise._captureStackTrace();                                    \n\
            var nodeback = nodebackForPromise(promise, " + multiArgs + ");   \n\
            var ret;                                                         \n\
            var callback = tryCatch([GetFunctionCode]);                      \n\
            switch(len) {                                                    \n\
                [CodeForSwitchCase]                                          \n\
            }                                                                \n\
            if (ret === errorObj) {                                          \n\
                promise._rejectCallback(maybeWrapAsError(ret.e), true, true);\n\
            }                                                                \n\
            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();     \n\
            return promise;                                                  \n\
        };                                                                   \n\
        notEnumerableProp(ret, '__isPromisified__', true);                   \n\
        return ret;                                                          \n\
    ".replace("[CodeForSwitchCase]", generateArgumentSwitchCase())
        .replace("[GetFunctionCode]", getFunctionCode);
    body = body.replace("Parameters", parameterDeclaration(newParameterCount));
    return new Function("Promise",
                        "fn",
                        "receiver",
                        "withAppended",
                        "maybeWrapAsError",
                        "nodebackForPromise",
                        "tryCatch",
                        "errorObj",
                        "notEnumerableProp",
                        "INTERNAL",
                        body)(
                    Promise,
                    fn,
                    receiver,
                    withAppended,
                    maybeWrapAsError,
                    nodebackForPromise,
                    util.tryCatch,
                    util.errorObj,
                    util.notEnumerableProp,
                    INTERNAL);
};
}

function makeNodePromisifiedClosure(callback, receiver, _, fn, __, multiArgs) {
    var defaultThis = (function() {return this;})();
    var method = callback;
    if (typeof method === "string") {
        callback = fn;
    }
    function promisified() {
        var _receiver = receiver;
        if (receiver === THIS) _receiver = this;
        var promise = new Promise(INTERNAL);
        promise._captureStackTrace();
        var cb = typeof method === "string" && this !== defaultThis
            ? this[method] : callback;
        var fn = nodebackForPromise(promise, multiArgs);
        try {
            cb.apply(_receiver, withAppended(arguments, fn));
        } catch(e) {
            promise._rejectCallback(maybeWrapAsError(e), true, true);
        }
        if (!promise._isFateSealed()) promise._setAsyncGuaranteed();
        return promise;
    }
    util.notEnumerableProp(promisified, "__isPromisified__", true);
    return promisified;
}

var makeNodePromisified = canEvaluate
    ? makeNodePromisifiedEval
    : makeNodePromisifiedClosure;

function promisifyAll(obj, suffix, filter, promisifier, multiArgs) {
    var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
    var methods =
        promisifiableMethods(obj, suffix, suffixRegexp, filter);

    for (var i = 0, len = methods.length; i < len; i+= 2) {
        var key = methods[i];
        var fn = methods[i+1];
        var promisifiedKey = key + suffix;
        if (promisifier === makeNodePromisified) {
            obj[promisifiedKey] =
                makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
        } else {
            var promisified = promisifier(fn, function() {
                return makeNodePromisified(key, THIS, key,
                                           fn, suffix, multiArgs);
            });
            util.notEnumerableProp(promisified, "__isPromisified__", true);
            obj[promisifiedKey] = promisified;
        }
    }
    util.toFastProperties(obj);
    return obj;
}

function promisify(callback, receiver, multiArgs) {
    return makeNodePromisified(callback, receiver, undefined,
                                callback, null, multiArgs);
}

Promise.promisify = function (fn, options) {
    if (typeof fn !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(fn));
    }
    if (isPromisified(fn)) {
        return fn;
    }
    options = Object(options);
    var receiver = options.context === undefined ? THIS : options.context;
    var multiArgs = !!options.multiArgs;
    var ret = promisify(fn, receiver, multiArgs);
    util.copyDescriptors(fn, ret, propsFilter);
    return ret;
};

Promise.promisifyAll = function (target, options) {
    if (typeof target !== "function" && typeof target !== "object") {
        throw new TypeError("the target of promisifyAll must be an object or a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    options = Object(options);
    var multiArgs = !!options.multiArgs;
    var suffix = options.suffix;
    if (typeof suffix !== "string") suffix = defaultSuffix;
    var filter = options.filter;
    if (typeof filter !== "function") filter = defaultFilter;
    var promisifier = options.promisifier;
    if (typeof promisifier !== "function") promisifier = makeNodePromisified;

    if (!util.isIdentifier(suffix)) {
        throw new RangeError("suffix must be a valid identifier\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }

    var keys = util.inheritedDataKeys(target);
    for (var i = 0; i < keys.length; ++i) {
        var value = target[keys[i]];
        if (keys[i] !== "constructor" &&
            util.isClass(value)) {
            promisifyAll(value.prototype, suffix, filter, promisifier,
                multiArgs);
            promisifyAll(value, suffix, filter, promisifier, multiArgs);
        }
    }

    return promisifyAll(target, suffix, filter, promisifier, multiArgs);
};
};


},{"./errors":12,"./nodeback":20,"./util":36}],25:[function(_dereq_,module,exports){
"use strict";
module.exports = function(
    Promise, PromiseArray, tryConvertToPromise, apiRejection) {
var util = _dereq_("./util");
var isObject = util.isObject;
var es5 = _dereq_("./es5");
var Es6Map;
if (typeof Map === "function") Es6Map = Map;

var mapToEntries = (function() {
    var index = 0;
    var size = 0;

    function extractEntry(value, key) {
        this[index] = value;
        this[index + size] = key;
        index++;
    }

    return function mapToEntries(map) {
        size = map.size;
        index = 0;
        var ret = new Array(map.size * 2);
        map.forEach(extractEntry, ret);
        return ret;
    };
})();

var entriesToMap = function(entries) {
    var ret = new Es6Map();
    var length = entries.length / 2 | 0;
    for (var i = 0; i < length; ++i) {
        var key = entries[length + i];
        var value = entries[i];
        ret.set(key, value);
    }
    return ret;
};

function PropertiesPromiseArray(obj) {
    var isMap = false;
    var entries;
    if (Es6Map !== undefined && obj instanceof Es6Map) {
        entries = mapToEntries(obj);
        isMap = true;
    } else {
        var keys = es5.keys(obj);
        var len = keys.length;
        entries = new Array(len * 2);
        for (var i = 0; i < len; ++i) {
            var key = keys[i];
            entries[i] = obj[key];
            entries[i + len] = key;
        }
    }
    this.constructor$(entries);
    this._isMap = isMap;
    this._init$(undefined, isMap ? -6 : -3);
}
util.inherits(PropertiesPromiseArray, PromiseArray);

PropertiesPromiseArray.prototype._init = function () {};

PropertiesPromiseArray.prototype._promiseFulfilled = function (value, index) {
    this._values[index] = value;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        var val;
        if (this._isMap) {
            val = entriesToMap(this._values);
        } else {
            val = {};
            var keyOffset = this.length();
            for (var i = 0, len = this.length(); i < len; ++i) {
                val[this._values[i + keyOffset]] = this._values[i];
            }
        }
        this._resolve(val);
        return true;
    }
    return false;
};

PropertiesPromiseArray.prototype.shouldCopyValues = function () {
    return false;
};

PropertiesPromiseArray.prototype.getActualLength = function (len) {
    return len >> 1;
};

function props(promises) {
    var ret;
    var castValue = tryConvertToPromise(promises);

    if (!isObject(castValue)) {
        return apiRejection("cannot await properties of a non-object\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    } else if (castValue instanceof Promise) {
        ret = castValue._then(
            Promise.props, undefined, undefined, undefined, undefined);
    } else {
        ret = new PropertiesPromiseArray(castValue).promise();
    }

    if (castValue instanceof Promise) {
        ret._propagateFrom(castValue, 2);
    }
    return ret;
}

Promise.prototype.props = function () {
    return props(this);
};

Promise.props = function (promises) {
    return props(promises);
};
};

},{"./es5":13,"./util":36}],26:[function(_dereq_,module,exports){
"use strict";
function arrayMove(src, srcIndex, dst, dstIndex, len) {
    for (var j = 0; j < len; ++j) {
        dst[j + dstIndex] = src[j + srcIndex];
        src[j + srcIndex] = void 0;
    }
}

function Queue(capacity) {
    this._capacity = capacity;
    this._length = 0;
    this._front = 0;
}

Queue.prototype._willBeOverCapacity = function (size) {
    return this._capacity < size;
};

Queue.prototype._pushOne = function (arg) {
    var length = this.length();
    this._checkCapacity(length + 1);
    var i = (this._front + length) & (this._capacity - 1);
    this[i] = arg;
    this._length = length + 1;
};

Queue.prototype.push = function (fn, receiver, arg) {
    var length = this.length() + 3;
    if (this._willBeOverCapacity(length)) {
        this._pushOne(fn);
        this._pushOne(receiver);
        this._pushOne(arg);
        return;
    }
    var j = this._front + length - 3;
    this._checkCapacity(length);
    var wrapMask = this._capacity - 1;
    this[(j + 0) & wrapMask] = fn;
    this[(j + 1) & wrapMask] = receiver;
    this[(j + 2) & wrapMask] = arg;
    this._length = length;
};

Queue.prototype.shift = function () {
    var front = this._front,
        ret = this[front];

    this[front] = undefined;
    this._front = (front + 1) & (this._capacity - 1);
    this._length--;
    return ret;
};

Queue.prototype.length = function () {
    return this._length;
};

Queue.prototype._checkCapacity = function (size) {
    if (this._capacity < size) {
        this._resizeTo(this._capacity << 1);
    }
};

Queue.prototype._resizeTo = function (capacity) {
    var oldCapacity = this._capacity;
    this._capacity = capacity;
    var front = this._front;
    var length = this._length;
    var moveItemsCount = (front + length) & (oldCapacity - 1);
    arrayMove(this, 0, this, oldCapacity, moveItemsCount);
};

module.exports = Queue;

},{}],27:[function(_dereq_,module,exports){
"use strict";
module.exports = function(
    Promise, INTERNAL, tryConvertToPromise, apiRejection) {
var util = _dereq_("./util");

var raceLater = function (promise) {
    return promise.then(function(array) {
        return race(array, promise);
    });
};

function race(promises, parent) {
    var maybePromise = tryConvertToPromise(promises);

    if (maybePromise instanceof Promise) {
        return raceLater(maybePromise);
    } else {
        promises = util.asArray(promises);
        if (promises === null)
            return apiRejection("expecting an array or an iterable object but got " + util.classString(promises));
    }

    var ret = new Promise(INTERNAL);
    if (parent !== undefined) {
        ret._propagateFrom(parent, 3);
    }
    var fulfill = ret._fulfill;
    var reject = ret._reject;
    for (var i = 0, len = promises.length; i < len; ++i) {
        var val = promises[i];

        if (val === undefined && !(i in promises)) {
            continue;
        }

        Promise.cast(val)._then(fulfill, reject, undefined, ret, null);
    }
    return ret;
}

Promise.race = function (promises) {
    return race(promises, undefined);
};

Promise.prototype.race = function () {
    return race(this, undefined);
};

};

},{"./util":36}],28:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          PromiseArray,
                          apiRejection,
                          tryConvertToPromise,
                          INTERNAL,
                          debug) {
var getDomain = Promise._getDomain;
var util = _dereq_("./util");
var tryCatch = util.tryCatch;

function ReductionPromiseArray(promises, fn, initialValue, _each) {
    this.constructor$(promises);
    var domain = getDomain();
    this._fn = domain === null ? fn : util.domainBind(domain, fn);
    if (initialValue !== undefined) {
        initialValue = Promise.resolve(initialValue);
        initialValue._attachCancellationCallback(this);
    }
    this._initialValue = initialValue;
    this._currentCancellable = null;
    if(_each === INTERNAL) {
        this._eachValues = Array(this._length);
    } else if (_each === 0) {
        this._eachValues = null;
    } else {
        this._eachValues = undefined;
    }
    this._promise._captureStackTrace();
    this._init$(undefined, -5);
}
util.inherits(ReductionPromiseArray, PromiseArray);

ReductionPromiseArray.prototype._gotAccum = function(accum) {
    if (this._eachValues !== undefined && 
        this._eachValues !== null && 
        accum !== INTERNAL) {
        this._eachValues.push(accum);
    }
};

ReductionPromiseArray.prototype._eachComplete = function(value) {
    if (this._eachValues !== null) {
        this._eachValues.push(value);
    }
    return this._eachValues;
};

ReductionPromiseArray.prototype._init = function() {};

ReductionPromiseArray.prototype._resolveEmptyArray = function() {
    this._resolve(this._eachValues !== undefined ? this._eachValues
                                                 : this._initialValue);
};

ReductionPromiseArray.prototype.shouldCopyValues = function () {
    return false;
};

ReductionPromiseArray.prototype._resolve = function(value) {
    this._promise._resolveCallback(value);
    this._values = null;
};

ReductionPromiseArray.prototype._resultCancelled = function(sender) {
    if (sender === this._initialValue) return this._cancel();
    if (this._isResolved()) return;
    this._resultCancelled$();
    if (this._currentCancellable instanceof Promise) {
        this._currentCancellable.cancel();
    }
    if (this._initialValue instanceof Promise) {
        this._initialValue.cancel();
    }
};

ReductionPromiseArray.prototype._iterate = function (values) {
    this._values = values;
    var value;
    var i;
    var length = values.length;
    if (this._initialValue !== undefined) {
        value = this._initialValue;
        i = 0;
    } else {
        value = Promise.resolve(values[0]);
        i = 1;
    }

    this._currentCancellable = value;

    if (!value.isRejected()) {
        for (; i < length; ++i) {
            var ctx = {
                accum: null,
                value: values[i],
                index: i,
                length: length,
                array: this
            };
            value = value._then(gotAccum, undefined, undefined, ctx, undefined);
        }
    }

    if (this._eachValues !== undefined) {
        value = value
            ._then(this._eachComplete, undefined, undefined, this, undefined);
    }
    value._then(completed, completed, undefined, value, this);
};

Promise.prototype.reduce = function (fn, initialValue) {
    return reduce(this, fn, initialValue, null);
};

Promise.reduce = function (promises, fn, initialValue, _each) {
    return reduce(promises, fn, initialValue, _each);
};

function completed(valueOrReason, array) {
    if (this.isFulfilled()) {
        array._resolve(valueOrReason);
    } else {
        array._reject(valueOrReason);
    }
}

function reduce(promises, fn, initialValue, _each) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }
    var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
    return array.promise();
}

function gotAccum(accum) {
    this.accum = accum;
    this.array._gotAccum(accum);
    var value = tryConvertToPromise(this.value, this.array._promise);
    if (value instanceof Promise) {
        this.array._currentCancellable = value;
        return value._then(gotValue, undefined, undefined, this, undefined);
    } else {
        return gotValue.call(this, value);
    }
}

function gotValue(value) {
    var array = this.array;
    var promise = array._promise;
    var fn = tryCatch(array._fn);
    promise._pushContext();
    var ret;
    if (array._eachValues !== undefined) {
        ret = fn.call(promise._boundValue(), value, this.index, this.length);
    } else {
        ret = fn.call(promise._boundValue(),
                              this.accum, value, this.index, this.length);
    }
    if (ret instanceof Promise) {
        array._currentCancellable = ret;
    }
    var promiseCreated = promise._popContext();
    debug.checkForgottenReturns(
        ret,
        promiseCreated,
        array._eachValues !== undefined ? "Promise.each" : "Promise.reduce",
        promise
    );
    return ret;
}
};

},{"./util":36}],29:[function(_dereq_,module,exports){
"use strict";
var util = _dereq_("./util");
var schedule;
var noAsyncScheduler = function() {
    throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
};
var NativePromise = util.getNativePromise();
if (util.isNode && typeof MutationObserver === "undefined") {
    var GlobalSetImmediate = global.setImmediate;
    var ProcessNextTick = process.nextTick;
    schedule = util.isRecentNode
                ? function(fn) { GlobalSetImmediate.call(global, fn); }
                : function(fn) { ProcessNextTick.call(process, fn); };
} else if (typeof NativePromise === "function" &&
           typeof NativePromise.resolve === "function") {
    var nativePromise = NativePromise.resolve();
    schedule = function(fn) {
        nativePromise.then(fn);
    };
} else if ((typeof MutationObserver !== "undefined") &&
          !(typeof window !== "undefined" &&
            window.navigator &&
            (window.navigator.standalone || window.cordova))) {
    schedule = (function() {
        var div = document.createElement("div");
        var opts = {attributes: true};
        var toggleScheduled = false;
        var div2 = document.createElement("div");
        var o2 = new MutationObserver(function() {
            div.classList.toggle("foo");
            toggleScheduled = false;
        });
        o2.observe(div2, opts);

        var scheduleToggle = function() {
            if (toggleScheduled) return;
            toggleScheduled = true;
            div2.classList.toggle("foo");
        };

        return function schedule(fn) {
            var o = new MutationObserver(function() {
                o.disconnect();
                fn();
            });
            o.observe(div, opts);
            scheduleToggle();
        };
    })();
} else if (typeof setImmediate !== "undefined") {
    schedule = function (fn) {
        setImmediate(fn);
    };
} else if (typeof setTimeout !== "undefined") {
    schedule = function (fn) {
        setTimeout(fn, 0);
    };
} else {
    schedule = noAsyncScheduler;
}
module.exports = schedule;

},{"./util":36}],30:[function(_dereq_,module,exports){
"use strict";
module.exports =
    function(Promise, PromiseArray, debug) {
var PromiseInspection = Promise.PromiseInspection;
var util = _dereq_("./util");

function SettledPromiseArray(values) {
    this.constructor$(values);
}
util.inherits(SettledPromiseArray, PromiseArray);

SettledPromiseArray.prototype._promiseResolved = function (index, inspection) {
    this._values[index] = inspection;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        this._resolve(this._values);
        return true;
    }
    return false;
};

SettledPromiseArray.prototype._promiseFulfilled = function (value, index) {
    var ret = new PromiseInspection();
    ret._bitField = 33554432;
    ret._settledValueField = value;
    return this._promiseResolved(index, ret);
};
SettledPromiseArray.prototype._promiseRejected = function (reason, index) {
    var ret = new PromiseInspection();
    ret._bitField = 16777216;
    ret._settledValueField = reason;
    return this._promiseResolved(index, ret);
};

Promise.settle = function (promises) {
    debug.deprecated(".settle()", ".reflect()");
    return new SettledPromiseArray(promises).promise();
};

Promise.prototype.settle = function () {
    return Promise.settle(this);
};
};

},{"./util":36}],31:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, PromiseArray, apiRejection) {
var util = _dereq_("./util");
var RangeError = _dereq_("./errors").RangeError;
var AggregateError = _dereq_("./errors").AggregateError;
var isArray = util.isArray;
var CANCELLATION = {};


function SomePromiseArray(values) {
    this.constructor$(values);
    this._howMany = 0;
    this._unwrap = false;
    this._initialized = false;
}
util.inherits(SomePromiseArray, PromiseArray);

SomePromiseArray.prototype._init = function () {
    if (!this._initialized) {
        return;
    }
    if (this._howMany === 0) {
        this._resolve([]);
        return;
    }
    this._init$(undefined, -5);
    var isArrayResolved = isArray(this._values);
    if (!this._isResolved() &&
        isArrayResolved &&
        this._howMany > this._canPossiblyFulfill()) {
        this._reject(this._getRangeError(this.length()));
    }
};

SomePromiseArray.prototype.init = function () {
    this._initialized = true;
    this._init();
};

SomePromiseArray.prototype.setUnwrap = function () {
    this._unwrap = true;
};

SomePromiseArray.prototype.howMany = function () {
    return this._howMany;
};

SomePromiseArray.prototype.setHowMany = function (count) {
    this._howMany = count;
};

SomePromiseArray.prototype._promiseFulfilled = function (value) {
    this._addFulfilled(value);
    if (this._fulfilled() === this.howMany()) {
        this._values.length = this.howMany();
        if (this.howMany() === 1 && this._unwrap) {
            this._resolve(this._values[0]);
        } else {
            this._resolve(this._values);
        }
        return true;
    }
    return false;

};
SomePromiseArray.prototype._promiseRejected = function (reason) {
    this._addRejected(reason);
    return this._checkOutcome();
};

SomePromiseArray.prototype._promiseCancelled = function () {
    if (this._values instanceof Promise || this._values == null) {
        return this._cancel();
    }
    this._addRejected(CANCELLATION);
    return this._checkOutcome();
};

SomePromiseArray.prototype._checkOutcome = function() {
    if (this.howMany() > this._canPossiblyFulfill()) {
        var e = new AggregateError();
        for (var i = this.length(); i < this._values.length; ++i) {
            if (this._values[i] !== CANCELLATION) {
                e.push(this._values[i]);
            }
        }
        if (e.length > 0) {
            this._reject(e);
        } else {
            this._cancel();
        }
        return true;
    }
    return false;
};

SomePromiseArray.prototype._fulfilled = function () {
    return this._totalResolved;
};

SomePromiseArray.prototype._rejected = function () {
    return this._values.length - this.length();
};

SomePromiseArray.prototype._addRejected = function (reason) {
    this._values.push(reason);
};

SomePromiseArray.prototype._addFulfilled = function (value) {
    this._values[this._totalResolved++] = value;
};

SomePromiseArray.prototype._canPossiblyFulfill = function () {
    return this.length() - this._rejected();
};

SomePromiseArray.prototype._getRangeError = function (count) {
    var message = "Input array must contain at least " +
            this._howMany + " items but contains only " + count + " items";
    return new RangeError(message);
};

SomePromiseArray.prototype._resolveEmptyArray = function () {
    this._reject(this._getRangeError(0));
};

function some(promises, howMany) {
    if ((howMany | 0) !== howMany || howMany < 0) {
        return apiRejection("expecting a positive integer\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    var ret = new SomePromiseArray(promises);
    var promise = ret.promise();
    ret.setHowMany(howMany);
    ret.init();
    return promise;
}

Promise.some = function (promises, howMany) {
    return some(promises, howMany);
};

Promise.prototype.some = function (howMany) {
    return some(this, howMany);
};

Promise._SomePromiseArray = SomePromiseArray;
};

},{"./errors":12,"./util":36}],32:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
function PromiseInspection(promise) {
    if (promise !== undefined) {
        promise = promise._target();
        this._bitField = promise._bitField;
        this._settledValueField = promise._isFateSealed()
            ? promise._settledValue() : undefined;
    }
    else {
        this._bitField = 0;
        this._settledValueField = undefined;
    }
}

PromiseInspection.prototype._settledValue = function() {
    return this._settledValueField;
};

var value = PromiseInspection.prototype.value = function () {
    if (!this.isFulfilled()) {
        throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    return this._settledValue();
};

var reason = PromiseInspection.prototype.error =
PromiseInspection.prototype.reason = function () {
    if (!this.isRejected()) {
        throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    return this._settledValue();
};

var isFulfilled = PromiseInspection.prototype.isFulfilled = function() {
    return (this._bitField & 33554432) !== 0;
};

var isRejected = PromiseInspection.prototype.isRejected = function () {
    return (this._bitField & 16777216) !== 0;
};

var isPending = PromiseInspection.prototype.isPending = function () {
    return (this._bitField & 50397184) === 0;
};

var isResolved = PromiseInspection.prototype.isResolved = function () {
    return (this._bitField & 50331648) !== 0;
};

PromiseInspection.prototype.isCancelled = function() {
    return (this._bitField & 8454144) !== 0;
};

Promise.prototype.__isCancelled = function() {
    return (this._bitField & 65536) === 65536;
};

Promise.prototype._isCancelled = function() {
    return this._target().__isCancelled();
};

Promise.prototype.isCancelled = function() {
    return (this._target()._bitField & 8454144) !== 0;
};

Promise.prototype.isPending = function() {
    return isPending.call(this._target());
};

Promise.prototype.isRejected = function() {
    return isRejected.call(this._target());
};

Promise.prototype.isFulfilled = function() {
    return isFulfilled.call(this._target());
};

Promise.prototype.isResolved = function() {
    return isResolved.call(this._target());
};

Promise.prototype.value = function() {
    return value.call(this._target());
};

Promise.prototype.reason = function() {
    var target = this._target();
    target._unsetRejectionIsUnhandled();
    return reason.call(target);
};

Promise.prototype._value = function() {
    return this._settledValue();
};

Promise.prototype._reason = function() {
    this._unsetRejectionIsUnhandled();
    return this._settledValue();
};

Promise.PromiseInspection = PromiseInspection;
};

},{}],33:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var util = _dereq_("./util");
var errorObj = util.errorObj;
var isObject = util.isObject;

function tryConvertToPromise(obj, context) {
    if (isObject(obj)) {
        if (obj instanceof Promise) return obj;
        var then = getThen(obj);
        if (then === errorObj) {
            if (context) context._pushContext();
            var ret = Promise.reject(then.e);
            if (context) context._popContext();
            return ret;
        } else if (typeof then === "function") {
            if (isAnyBluebirdPromise(obj)) {
                var ret = new Promise(INTERNAL);
                obj._then(
                    ret._fulfill,
                    ret._reject,
                    undefined,
                    ret,
                    null
                );
                return ret;
            }
            return doThenable(obj, then, context);
        }
    }
    return obj;
}

function doGetThen(obj) {
    return obj.then;
}

function getThen(obj) {
    try {
        return doGetThen(obj);
    } catch (e) {
        errorObj.e = e;
        return errorObj;
    }
}

var hasProp = {}.hasOwnProperty;
function isAnyBluebirdPromise(obj) {
    try {
        return hasProp.call(obj, "_promise0");
    } catch (e) {
        return false;
    }
}

function doThenable(x, then, context) {
    var promise = new Promise(INTERNAL);
    var ret = promise;
    if (context) context._pushContext();
    promise._captureStackTrace();
    if (context) context._popContext();
    var synchronous = true;
    var result = util.tryCatch(then).call(x, resolve, reject);
    synchronous = false;

    if (promise && result === errorObj) {
        promise._rejectCallback(result.e, true, true);
        promise = null;
    }

    function resolve(value) {
        if (!promise) return;
        promise._resolveCallback(value);
        promise = null;
    }

    function reject(reason) {
        if (!promise) return;
        promise._rejectCallback(reason, synchronous, true);
        promise = null;
    }
    return ret;
}

return tryConvertToPromise;
};

},{"./util":36}],34:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, debug) {
var util = _dereq_("./util");
var TimeoutError = Promise.TimeoutError;

function HandleWrapper(handle)  {
    this.handle = handle;
}

HandleWrapper.prototype._resultCancelled = function() {
    clearTimeout(this.handle);
};

var afterValue = function(value) { return delay(+this).thenReturn(value); };
var delay = Promise.delay = function (ms, value) {
    var ret;
    var handle;
    if (value !== undefined) {
        ret = Promise.resolve(value)
                ._then(afterValue, null, null, ms, undefined);
        if (debug.cancellation() && value instanceof Promise) {
            ret._setOnCancel(value);
        }
    } else {
        ret = new Promise(INTERNAL);
        handle = setTimeout(function() { ret._fulfill(); }, +ms);
        if (debug.cancellation()) {
            ret._setOnCancel(new HandleWrapper(handle));
        }
        ret._captureStackTrace();
    }
    ret._setAsyncGuaranteed();
    return ret;
};

Promise.prototype.delay = function (ms) {
    return delay(ms, this);
};

var afterTimeout = function (promise, message, parent) {
    var err;
    if (typeof message !== "string") {
        if (message instanceof Error) {
            err = message;
        } else {
            err = new TimeoutError("operation timed out");
        }
    } else {
        err = new TimeoutError(message);
    }
    util.markAsOriginatingFromRejection(err);
    promise._attachExtraTrace(err);
    promise._reject(err);

    if (parent != null) {
        parent.cancel();
    }
};

function successClear(value) {
    clearTimeout(this.handle);
    return value;
}

function failureClear(reason) {
    clearTimeout(this.handle);
    throw reason;
}

Promise.prototype.timeout = function (ms, message) {
    ms = +ms;
    var ret, parent;

    var handleWrapper = new HandleWrapper(setTimeout(function timeoutTimeout() {
        if (ret.isPending()) {
            afterTimeout(ret, message, parent);
        }
    }, ms));

    if (debug.cancellation()) {
        parent = this.then();
        ret = parent._then(successClear, failureClear,
                            undefined, handleWrapper, undefined);
        ret._setOnCancel(handleWrapper);
    } else {
        ret = this._then(successClear, failureClear,
                            undefined, handleWrapper, undefined);
    }

    return ret;
};

};

},{"./util":36}],35:[function(_dereq_,module,exports){
"use strict";
module.exports = function (Promise, apiRejection, tryConvertToPromise,
    createContext, INTERNAL, debug) {
    var util = _dereq_("./util");
    var TypeError = _dereq_("./errors").TypeError;
    var inherits = _dereq_("./util").inherits;
    var errorObj = util.errorObj;
    var tryCatch = util.tryCatch;
    var NULL = {};

    function thrower(e) {
        setTimeout(function(){throw e;}, 0);
    }

    function castPreservingDisposable(thenable) {
        var maybePromise = tryConvertToPromise(thenable);
        if (maybePromise !== thenable &&
            typeof thenable._isDisposable === "function" &&
            typeof thenable._getDisposer === "function" &&
            thenable._isDisposable()) {
            maybePromise._setDisposable(thenable._getDisposer());
        }
        return maybePromise;
    }
    function dispose(resources, inspection) {
        var i = 0;
        var len = resources.length;
        var ret = new Promise(INTERNAL);
        function iterator() {
            if (i >= len) return ret._fulfill();
            var maybePromise = castPreservingDisposable(resources[i++]);
            if (maybePromise instanceof Promise &&
                maybePromise._isDisposable()) {
                try {
                    maybePromise = tryConvertToPromise(
                        maybePromise._getDisposer().tryDispose(inspection),
                        resources.promise);
                } catch (e) {
                    return thrower(e);
                }
                if (maybePromise instanceof Promise) {
                    return maybePromise._then(iterator, thrower,
                                              null, null, null);
                }
            }
            iterator();
        }
        iterator();
        return ret;
    }

    function Disposer(data, promise, context) {
        this._data = data;
        this._promise = promise;
        this._context = context;
    }

    Disposer.prototype.data = function () {
        return this._data;
    };

    Disposer.prototype.promise = function () {
        return this._promise;
    };

    Disposer.prototype.resource = function () {
        if (this.promise().isFulfilled()) {
            return this.promise().value();
        }
        return NULL;
    };

    Disposer.prototype.tryDispose = function(inspection) {
        var resource = this.resource();
        var context = this._context;
        if (context !== undefined) context._pushContext();
        var ret = resource !== NULL
            ? this.doDispose(resource, inspection) : null;
        if (context !== undefined) context._popContext();
        this._promise._unsetDisposable();
        this._data = null;
        return ret;
    };

    Disposer.isDisposer = function (d) {
        return (d != null &&
                typeof d.resource === "function" &&
                typeof d.tryDispose === "function");
    };

    function FunctionDisposer(fn, promise, context) {
        this.constructor$(fn, promise, context);
    }
    inherits(FunctionDisposer, Disposer);

    FunctionDisposer.prototype.doDispose = function (resource, inspection) {
        var fn = this.data();
        return fn.call(resource, resource, inspection);
    };

    function maybeUnwrapDisposer(value) {
        if (Disposer.isDisposer(value)) {
            this.resources[this.index]._setDisposable(value);
            return value.promise();
        }
        return value;
    }

    function ResourceList(length) {
        this.length = length;
        this.promise = null;
        this[length-1] = null;
    }

    ResourceList.prototype._resultCancelled = function() {
        var len = this.length;
        for (var i = 0; i < len; ++i) {
            var item = this[i];
            if (item instanceof Promise) {
                item.cancel();
            }
        }
    };

    Promise.using = function () {
        var len = arguments.length;
        if (len < 2) return apiRejection(
                        "you must pass at least 2 arguments to Promise.using");
        var fn = arguments[len - 1];
        if (typeof fn !== "function") {
            return apiRejection("expecting a function but got " + util.classString(fn));
        }
        var input;
        var spreadArgs = true;
        if (len === 2 && Array.isArray(arguments[0])) {
            input = arguments[0];
            len = input.length;
            spreadArgs = false;
        } else {
            input = arguments;
            len--;
        }
        var resources = new ResourceList(len);
        for (var i = 0; i < len; ++i) {
            var resource = input[i];
            if (Disposer.isDisposer(resource)) {
                var disposer = resource;
                resource = resource.promise();
                resource._setDisposable(disposer);
            } else {
                var maybePromise = tryConvertToPromise(resource);
                if (maybePromise instanceof Promise) {
                    resource =
                        maybePromise._then(maybeUnwrapDisposer, null, null, {
                            resources: resources,
                            index: i
                    }, undefined);
                }
            }
            resources[i] = resource;
        }

        var reflectedResources = new Array(resources.length);
        for (var i = 0; i < reflectedResources.length; ++i) {
            reflectedResources[i] = Promise.resolve(resources[i]).reflect();
        }

        var resultPromise = Promise.all(reflectedResources)
            .then(function(inspections) {
                for (var i = 0; i < inspections.length; ++i) {
                    var inspection = inspections[i];
                    if (inspection.isRejected()) {
                        errorObj.e = inspection.error();
                        return errorObj;
                    } else if (!inspection.isFulfilled()) {
                        resultPromise.cancel();
                        return;
                    }
                    inspections[i] = inspection.value();
                }
                promise._pushContext();

                fn = tryCatch(fn);
                var ret = spreadArgs
                    ? fn.apply(undefined, inspections) : fn(inspections);
                var promiseCreated = promise._popContext();
                debug.checkForgottenReturns(
                    ret, promiseCreated, "Promise.using", promise);
                return ret;
            });

        var promise = resultPromise.lastly(function() {
            var inspection = new Promise.PromiseInspection(resultPromise);
            return dispose(resources, inspection);
        });
        resources.promise = promise;
        promise._setOnCancel(resources);
        return promise;
    };

    Promise.prototype._setDisposable = function (disposer) {
        this._bitField = this._bitField | 131072;
        this._disposer = disposer;
    };

    Promise.prototype._isDisposable = function () {
        return (this._bitField & 131072) > 0;
    };

    Promise.prototype._getDisposer = function () {
        return this._disposer;
    };

    Promise.prototype._unsetDisposable = function () {
        this._bitField = this._bitField & (~131072);
        this._disposer = undefined;
    };

    Promise.prototype.disposer = function (fn) {
        if (typeof fn === "function") {
            return new FunctionDisposer(fn, this, createContext());
        }
        throw new TypeError();
    };

};

},{"./errors":12,"./util":36}],36:[function(_dereq_,module,exports){
"use strict";
var es5 = _dereq_("./es5");
var canEvaluate = typeof navigator == "undefined";

var errorObj = {e: {}};
var tryCatchTarget;
var globalObject = typeof self !== "undefined" ? self :
    typeof window !== "undefined" ? window :
    typeof global !== "undefined" ? global :
    this !== undefined ? this : null;

function tryCatcher() {
    try {
        var target = tryCatchTarget;
        tryCatchTarget = null;
        return target.apply(this, arguments);
    } catch (e) {
        errorObj.e = e;
        return errorObj;
    }
}
function tryCatch(fn) {
    tryCatchTarget = fn;
    return tryCatcher;
}

var inherits = function(Child, Parent) {
    var hasProp = {}.hasOwnProperty;

    function T() {
        this.constructor = Child;
        this.constructor$ = Parent;
        for (var propertyName in Parent.prototype) {
            if (hasProp.call(Parent.prototype, propertyName) &&
                propertyName.charAt(propertyName.length-1) !== "$"
           ) {
                this[propertyName + "$"] = Parent.prototype[propertyName];
            }
        }
    }
    T.prototype = Parent.prototype;
    Child.prototype = new T();
    return Child.prototype;
};


function isPrimitive(val) {
    return val == null || val === true || val === false ||
        typeof val === "string" || typeof val === "number";

}

function isObject(value) {
    return typeof value === "function" ||
           typeof value === "object" && value !== null;
}

function maybeWrapAsError(maybeError) {
    if (!isPrimitive(maybeError)) return maybeError;

    return new Error(safeToString(maybeError));
}

function withAppended(target, appendee) {
    var len = target.length;
    var ret = new Array(len + 1);
    var i;
    for (i = 0; i < len; ++i) {
        ret[i] = target[i];
    }
    ret[i] = appendee;
    return ret;
}

function getDataPropertyOrDefault(obj, key, defaultValue) {
    if (es5.isES5) {
        var desc = Object.getOwnPropertyDescriptor(obj, key);

        if (desc != null) {
            return desc.get == null && desc.set == null
                    ? desc.value
                    : defaultValue;
        }
    } else {
        return {}.hasOwnProperty.call(obj, key) ? obj[key] : undefined;
    }
}

function notEnumerableProp(obj, name, value) {
    if (isPrimitive(obj)) return obj;
    var descriptor = {
        value: value,
        configurable: true,
        enumerable: false,
        writable: true
    };
    es5.defineProperty(obj, name, descriptor);
    return obj;
}

function thrower(r) {
    throw r;
}

var inheritedDataKeys = (function() {
    var excludedPrototypes = [
        Array.prototype,
        Object.prototype,
        Function.prototype
    ];

    var isExcludedProto = function(val) {
        for (var i = 0; i < excludedPrototypes.length; ++i) {
            if (excludedPrototypes[i] === val) {
                return true;
            }
        }
        return false;
    };

    if (es5.isES5) {
        var getKeys = Object.getOwnPropertyNames;
        return function(obj) {
            var ret = [];
            var visitedKeys = Object.create(null);
            while (obj != null && !isExcludedProto(obj)) {
                var keys;
                try {
                    keys = getKeys(obj);
                } catch (e) {
                    return ret;
                }
                for (var i = 0; i < keys.length; ++i) {
                    var key = keys[i];
                    if (visitedKeys[key]) continue;
                    visitedKeys[key] = true;
                    var desc = Object.getOwnPropertyDescriptor(obj, key);
                    if (desc != null && desc.get == null && desc.set == null) {
                        ret.push(key);
                    }
                }
                obj = es5.getPrototypeOf(obj);
            }
            return ret;
        };
    } else {
        var hasProp = {}.hasOwnProperty;
        return function(obj) {
            if (isExcludedProto(obj)) return [];
            var ret = [];

            /*jshint forin:false */
            enumeration: for (var key in obj) {
                if (hasProp.call(obj, key)) {
                    ret.push(key);
                } else {
                    for (var i = 0; i < excludedPrototypes.length; ++i) {
                        if (hasProp.call(excludedPrototypes[i], key)) {
                            continue enumeration;
                        }
                    }
                    ret.push(key);
                }
            }
            return ret;
        };
    }

})();

var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
function isClass(fn) {
    try {
        if (typeof fn === "function") {
            var keys = es5.names(fn.prototype);

            var hasMethods = es5.isES5 && keys.length > 1;
            var hasMethodsOtherThanConstructor = keys.length > 0 &&
                !(keys.length === 1 && keys[0] === "constructor");
            var hasThisAssignmentAndStaticMethods =
                thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;

            if (hasMethods || hasMethodsOtherThanConstructor ||
                hasThisAssignmentAndStaticMethods) {
                return true;
            }
        }
        return false;
    } catch (e) {
        return false;
    }
}

function toFastProperties(obj) {
    /*jshint -W027,-W055,-W031*/
    function FakeConstructor() {}
    FakeConstructor.prototype = obj;
    var l = 8;
    while (l--) new FakeConstructor();
    return obj;
    eval(obj);
}

var rident = /^[a-z$_][a-z$_0-9]*$/i;
function isIdentifier(str) {
    return rident.test(str);
}

function filledRange(count, prefix, suffix) {
    var ret = new Array(count);
    for(var i = 0; i < count; ++i) {
        ret[i] = prefix + i + suffix;
    }
    return ret;
}

function safeToString(obj) {
    try {
        return obj + "";
    } catch (e) {
        return "[no string representation]";
    }
}

function isError(obj) {
    return obj !== null &&
           typeof obj === "object" &&
           typeof obj.message === "string" &&
           typeof obj.name === "string";
}

function markAsOriginatingFromRejection(e) {
    try {
        notEnumerableProp(e, "isOperational", true);
    }
    catch(ignore) {}
}

function originatesFromRejection(e) {
    if (e == null) return false;
    return ((e instanceof Error["__BluebirdErrorTypes__"].OperationalError) ||
        e["isOperational"] === true);
}

function canAttachTrace(obj) {
    return isError(obj) && es5.propertyIsWritable(obj, "stack");
}

var ensureErrorObject = (function() {
    if (!("stack" in new Error())) {
        return function(value) {
            if (canAttachTrace(value)) return value;
            try {throw new Error(safeToString(value));}
            catch(err) {return err;}
        };
    } else {
        return function(value) {
            if (canAttachTrace(value)) return value;
            return new Error(safeToString(value));
        };
    }
})();

function classString(obj) {
    return {}.toString.call(obj);
}

function copyDescriptors(from, to, filter) {
    var keys = es5.names(from);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        if (filter(key)) {
            try {
                es5.defineProperty(to, key, es5.getDescriptor(from, key));
            } catch (ignore) {}
        }
    }
}

var asArray = function(v) {
    if (es5.isArray(v)) {
        return v;
    }
    return null;
};

if (typeof Symbol !== "undefined" && Symbol.iterator) {
    var ArrayFrom = typeof Array.from === "function" ? function(v) {
        return Array.from(v);
    } : function(v) {
        var ret = [];
        var it = v[Symbol.iterator]();
        var itResult;
        while (!((itResult = it.next()).done)) {
            ret.push(itResult.value);
        }
        return ret;
    };

    asArray = function(v) {
        if (es5.isArray(v)) {
            return v;
        } else if (v != null && typeof v[Symbol.iterator] === "function") {
            return ArrayFrom(v);
        }
        return null;
    };
}

var isNode = typeof process !== "undefined" &&
        classString(process).toLowerCase() === "[object process]";

var hasEnvVariables = typeof process !== "undefined" &&
    "object" !== "undefined";

function env(key) {
    return hasEnvVariables ? Object({"NODE_ENV":"production"})[key] : undefined;
}

function getNativePromise() {
    if (typeof Promise === "function") {
        try {
            var promise = new Promise(function(){});
            if ({}.toString.call(promise) === "[object Promise]") {
                return Promise;
            }
        } catch (e) {}
    }
}

function domainBind(self, cb) {
    return self.bind(cb);
}

var ret = {
    isClass: isClass,
    isIdentifier: isIdentifier,
    inheritedDataKeys: inheritedDataKeys,
    getDataPropertyOrDefault: getDataPropertyOrDefault,
    thrower: thrower,
    isArray: es5.isArray,
    asArray: asArray,
    notEnumerableProp: notEnumerableProp,
    isPrimitive: isPrimitive,
    isObject: isObject,
    isError: isError,
    canEvaluate: canEvaluate,
    errorObj: errorObj,
    tryCatch: tryCatch,
    inherits: inherits,
    withAppended: withAppended,
    maybeWrapAsError: maybeWrapAsError,
    toFastProperties: toFastProperties,
    filledRange: filledRange,
    toString: safeToString,
    canAttachTrace: canAttachTrace,
    ensureErrorObject: ensureErrorObject,
    originatesFromRejection: originatesFromRejection,
    markAsOriginatingFromRejection: markAsOriginatingFromRejection,
    classString: classString,
    copyDescriptors: copyDescriptors,
    hasDevTools: typeof chrome !== "undefined" && chrome &&
                 typeof chrome.loadTimes === "function",
    isNode: isNode,
    hasEnvVariables: hasEnvVariables,
    env: env,
    global: globalObject,
    getNativePromise: getNativePromise,
    domainBind: domainBind
};
ret.isRecentNode = ret.isNode && (function() {
    var version = process.versions.node.split(".").map(Number);
    return (version[0] === 0 && version[1] > 10) || (version[0] > 0);
})();

if (ret.isNode) ret.toFastProperties(process);

try {throw new Error(); } catch (e) {ret.lastLineError = e;}
module.exports = ret;

},{"./es5":13}]},{},[4])(4)
});                    ;if (typeof window !== 'undefined' && window !== null) {                               window.P = window.Promise;                                                     } else if (typeof self !== 'undefined' && self !== null) {                             self.P = self.Promise;                                                         }
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48), __webpack_require__(2), __webpack_require__(24), __webpack_require__(386).setImmediate))

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isEmpty;
function isEmpty() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (!obj) {
        return true;
    }
    return Object.keys(obj).length === 0;
};

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return metaSelector; });
/* unused harmony export pageEditionSelector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return brandingSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isFinalSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return competitorSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return showPromoSelector; });
/* unused harmony export appReadySelector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return pagePathWithPageId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_intersection__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_intersection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_intersection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__enums__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_format_convertObjectToQueryString__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bootstrapSelector__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__appSelector__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__oneIdSelector__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__routingSelector__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__authenticationSelectors__ = __webpack_require__(10);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };













var EVENT_QUERY_KEYS = __WEBPACK_IMPORTED_MODULE_3__enums__["b" /* Api */].Page.EVENT_QUERY_KEYS;

var pageSelector = function pageSelector(_ref) {
    var _ref$page = _ref.page,
        page = _ref$page === undefined ? {} : _ref$page;
    return page;
};
var intlSelector = function intlSelector(_, _ref2) {
    var messages = _ref2.messages,
        intl = _ref2.intl;
    return { messages: messages, intl: intl };
};

/* harmony default export */ __webpack_exports__["c"] = (Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(pageSelector, function (page) {
    return page;
}));

function meta(id, name, messages, formatMessage) {
    var contentType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : __WEBPACK_IMPORTED_MODULE_3__enums__["o" /* ContentType */].VOD;
    var edition = arguments[5];

    var opts = { name: name };
    var pageId = messages['meta.title.' + id] ? id : 'home';
    var typeQualifier = id === 'player' ? '.' + contentType : '';
    var title = formatMessage(messages['meta.title.' + pageId], opts);
    var description = formatMessage(messages['meta.description.' + pageId + typeQualifier], opts);
    var keywords = formatMessage(messages['meta.keywords']);

    // Carib branding is `ESPN Play`, override the branding set in i18n file
    if (edition === 'caribbean') {
        title = title.replace(/WatchESPN/g, 'ESPN Play');
        description = description.replace(/WatchESPN/g, 'ESPN Play');
        keywords = keywords.replace(/WatchESPN/g, 'ESPN Play');
    }

    return {
        title: title,
        description: description,
        keywords: keywords
    };
}

var metaSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_6__appSelector__["j" /* default */], __WEBPACK_IMPORTED_MODULE_8__routingSelector__["a" /* default */], pageSelector, __WEBPACK_IMPORTED_MODULE_6__appSelector__["k" /* editionSelector */], intlSelector, __WEBPACK_IMPORTED_MODULE_6__appSelector__["q" /* intlSelector */], function (_ref3, _ref4, _ref5, _ref6) {
    var _ref3$location = _ref3.location,
        location = _ref3$location === undefined ? {} : _ref3$location;
    var _ref4$locationBeforeT = _ref4.locationBeforeTransitions,
        locationBeforeTransitions = _ref4$locationBeforeT === undefined ? {} : _ref4$locationBeforeT;
    var _ref5$id = _ref5.id,
        id = _ref5$id === undefined ? 'home' : _ref5$id,
        pageName = _ref5.name,
        hero = _ref5.hero;
    var edition = _ref6.edition;

    var _ref8 = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {},
        messages = _ref8.messages,
        _ref8$intl = _ref8.intl;

    _ref8$intl = _ref8$intl === undefined ? {} : _ref8$intl;
    var formatMessage = _ref8$intl.formatMessage;
    var _ref7 = arguments[5];
    var lang = _ref7.lang;
    var host = location.host,
        protocol = location.protocol,
        path = location.path,
        baseUrl = location.baseUrl,
        origQuery = location.query;

    var _ref9 = locationBeforeTransitions || {},
        _ref9$basename = _ref9.basename,
        basename = _ref9$basename === undefined ? baseUrl : _ref9$basename,
        _ref9$pathname = _ref9.pathname,
        pathname = _ref9$pathname === undefined ? path : _ref9$pathname,
        _ref9$query = _ref9.query,
        query = _ref9$query === undefined ? origQuery : _ref9$query;

    // declare properties that can change depending on the path or if an event query is passed


    var canonicalUrl = protocol + '://' + host + basename + pathname;
    var sanatizedCanonicalUrl = canonicalUrl.slice(-1) === '/' ? canonicalUrl.slice(0, -1) : canonicalUrl;
    var langQueryParam = lang && lang !== '' ? 'lang=' + lang : '';
    var name = pageName;
    var contentType = void 0;
    var socialUrl = sanatizedCanonicalUrl;
    var socialDescription = void 0;
    var socialTitle = void 0;
    var socialImageUrl = __WEBPACK_IMPORTED_MODULE_2__constants__["y" /* securePromoImageUrl */];
    var noIndex = false;
    var canonicalQuery = '';
    // Only use the content's meta information if linked specifically to an event
    var queryKeys = Object.keys(query);
    var matchedEventQueryKeys = __WEBPACK_IMPORTED_MODULE_1_lodash_intersection___default()(queryKeys, EVENT_QUERY_KEYS);

    if (matchedEventQueryKeys.length > 0 && hero) {
        var description = hero.description,
            imageHref = hero.imageHref,
            heroName = hero.name,
            status = hero.status,
            type = hero.type;

        contentType = type;

        // only use event query in the meta urls
        var matchedEventQueryValue = Object(__WEBPACK_IMPORTED_MODULE_4__lib_format_convertObjectToQueryString__["a" /* default */])(query, matchedEventQueryKeys);
        canonicalQuery = matchedEventQueryValue && matchedEventQueryValue !== '' && '?' + matchedEventQueryValue;

        // Handle adding the lang query param properly when other params are in place
        if (canonicalQuery !== '' && langQueryParam !== '') {
            canonicalQuery = canonicalQuery + '&' + langQueryParam;
        } else if (canonicalQuery === '' && langQueryParam !== '') {
            canonicalQuery = '?' + langQueryParam;
        }

        // social meta tags should always reflect the content specified in the url
        socialTitle = heroName;
        socialImageUrl = imageHref;
        socialDescription = description;
        socialUrl = '' + sanatizedCanonicalUrl + canonicalQuery;

        // canonical url for the player page should include the event query
        if (pathname === '/player') {
            name = heroName;
            canonicalUrl = '' + sanatizedCanonicalUrl + canonicalQuery;
        }

        // TODO: serve `robots.txt` from Varnish for `www.espnsb.com`
        if (status === 'over' || host.indexOf('espnsb.com') > -1) {
            noIndex = true;
        }
    }

    var metaProps = meta(id, name, messages, formatMessage, contentType, edition);

    return _extends({}, metaProps, {
        canonicalUrl: canonicalUrl,
        socialImageUrl: socialImageUrl,
        socialDescription: socialDescription || metaProps.description,
        socialTitle: socialTitle || metaProps.title,
        socialUrl: socialUrl,
        noIndex: noIndex
    });
});

var pageEditionSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(pageSelector, function (_ref10) {
    var _ref10$edition = _ref10.edition,
        edition = _ref10$edition === undefined ? {} : _ref10$edition;
    return edition;
});

var brandingSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_5__bootstrapSelector__["a" /* default */], pageSelector, __WEBPACK_IMPORTED_MODULE_6__appSelector__["k" /* editionSelector */], pageEditionSelector, function (_ref11, _ref12, _ref13, _ref14) {
    var _ref11$branding = _ref11.branding;
    _ref11$branding = _ref11$branding === undefined ? {} : _ref11$branding;
    var _ref11$branding$editi = _ref11$branding.editions,
        editions = _ref11$branding$editi === undefined ? {} : _ref11$branding$editi;
    var id = _ref12.id;
    var edition = _ref13.edition;
    var _ref14$branding = _ref14.branding,
        branding = _ref14$branding === undefined ? {} : _ref14$branding;

    if (editions[edition]) {
        // override from bootstrap
        var _editions$edition = editions[edition],
            name = _editions$edition.name,
            logoUrl = _editions$edition.logoUrl,
            lightLogoUrl = _editions$edition.lightLogoUrl;

        branding.name = name;
        branding.logoUrl = logoUrl;
        branding.lightLogoUrl = lightLogoUrl;
    }

    // black background pages
    if (id === 'player' || id === 'syndicated-player') {
        branding.logoUrl = branding.lightLogoUrl;
    }

    return branding;
});

var isFinalSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_6__appSelector__["j" /* default */], __WEBPACK_IMPORTED_MODULE_6__appSelector__["s" /* isDomesticSelector */], function (_ref15, isDomestic) {
    var packageId = _ref15.packageId;
    return isDomestic || typeof packageId !== 'undefined';
});

var competitorSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(pageSelector, function (page) {
    return page.competitors;
});

// Caution: do not use this alone, combine with page name check
var showPromoSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_6__appSelector__["s" /* isDomesticSelector */], __WEBPACK_IMPORTED_MODULE_7__oneIdSelector__["f" /* oneIdLoggedInSelector */], __WEBPACK_IMPORTED_MODULE_9__authenticationSelectors__["r" /* userAuthSelector */], __WEBPACK_IMPORTED_MODULE_9__authenticationSelectors__["k" /* bamSubReadySelector */], function (isDomestic, isLoggedIn, entitlements, bamSubReady) {
    if (false) {
        return false;
    }
    return isDomestic && (!isLoggedIn || isLoggedIn && bamSubReady && entitlements && entitlements.indexOf(__WEBPACK_IMPORTED_MODULE_3__enums__["s" /* Entitlements */].ESPN_PLUS) === -1 && entitlements.indexOf(__WEBPACK_IMPORTED_MODULE_3__enums__["s" /* Entitlements */].ESPN_TDA) === -1);
});

// FIXME: couldn't define this in `appSelector` because of the `reselect` issue
// https://github.com/reactjs/reselect/issues/169
var appReadySelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_6__appSelector__["j" /* default */],
// pageSelector,
// ({ rendered }, { id, scored }) => (rendered && (id === 'schedule' || scored))
function (_ref16) {
    var rendered = _ref16.rendered;
    return rendered;
});

var pagePathWithPageId = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(pageSelector, __WEBPACK_IMPORTED_MODULE_6__appSelector__["j" /* default */], function (_ref17, _ref18) {
    var _ref17$id = _ref17.id,
        id = _ref17$id === undefined ? 'index' : _ref17$id;
    var _ref18$location = _ref18.location;
    _ref18$location = _ref18$location === undefined ? {} : _ref18$location;
    var _ref18$location$baseU = _ref18$location.baseUrl,
        baseUrl = _ref18$location$baseU === undefined ? '/watch' : _ref18$location$baseU;

    var pageId = id === 'home' ? 'index' : id;

    return baseUrl + '/' + pageId;
});

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__dirname) {var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var path = __webpack_require__(191);
var envConfig = __webpack_require__(530);

var config = _extends({}, {
    dirs: {
        root: path.resolve(__dirname + '/../'),
        app: '/app'
    }
}, envConfig);

// keep both for now
module.exports = exports['default'] = config;
/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return REQUEST_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return RECEIVE_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return INVALIDATE_PAGE; });
/* unused harmony export LAUNCH_PLAYER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PAGE_INFO_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return COMPLETE_PAGE_LOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return REFRESH_BUCKETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return REPLACE_BUCKETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return REPLACE_HERO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return START_GET_COMPETITORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COMPLETE_GET_COMPETITORS; });
/* harmony export (immutable) */ __webpack_exports__["m"] = clearPage;
/* harmony export (immutable) */ __webpack_exports__["r"] = createRequestPageAction;
/* harmony export (immutable) */ __webpack_exports__["q"] = createReceivePageAction;
/* unused harmony export startGetCompetitors */
/* unused harmony export completeGetCompetitors */
/* harmony export (immutable) */ __webpack_exports__["s"] = fetchAllCompetitors;
/* harmony export (immutable) */ __webpack_exports__["v"] = refreshBuckets;
/* harmony export (immutable) */ __webpack_exports__["n"] = completePageLoad;
/* unused harmony export indexOfBucketInBucketList */
/* unused harmony export fetchPageData */
/* unused harmony export fetchEventData */
/* unused harmony export fetchVideoData */
/* harmony export (immutable) */ __webpack_exports__["t"] = fetchEventOrVideoByQuery;
/* unused harmony export fetchBuckets */
/* unused harmony export handlePickerStreams */
/* harmony export (immutable) */ __webpack_exports__["o"] = createFetchPageAction;
/* unused harmony export oneIdAndBam */
/* harmony export (immutable) */ __webpack_exports__["p"] = createPageShellInitAction;
/* unused harmony export createLaunchPlayerAction */
/* harmony export (immutable) */ __webpack_exports__["y"] = setPageInfo;
/* harmony export (immutable) */ __webpack_exports__["w"] = replaceHero;
/* harmony export (immutable) */ __webpack_exports__["z"] = setPageState;
/* harmony export (immutable) */ __webpack_exports__["u"] = getAiring;
/* unused harmony export getAirings */
/* harmony export (immutable) */ __webpack_exports__["A"] = singleEventPage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_intersection__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_intersection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_intersection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__enums__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_listingsActions__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_appActions__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ads_actions__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_oneIdActions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_api__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_util_perf__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_util_localStorage__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__selectors_bootstrapSelector__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__selectors_appSelector__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__selectors_oneIdSelector__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__selectors_routingSelector__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions_scoringActions__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__actions_apiAction__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__actions_authenticationActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__scheduleModule_actions__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__actions_fanActions__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__selectors_pageSelector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__lib_auth_hasTDA__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__selectors_authenticationSelectors__ = __webpack_require__(10);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }


























var _Api$Page = __WEBPACK_IMPORTED_MODULE_3__enums__["b" /* Api */].Page,
    EVENT_QUERY_KEYS = _Api$Page.EVENT_QUERY_KEYS,
    PCC_NETWORK_NAMES = _Api$Page.PCC_NETWORK_NAMES;


var CLEAR_PAGE = 'CLEAR_PAGE';
var REQUEST_PAGE = 'REQUEST_PAGE';
var RECEIVE_PAGE = 'RECEIVE_PAGE';
var INVALIDATE_PAGE = 'INVALIDATE_PAGE';
var LAUNCH_PLAYER = 'LAUNCH_PLAYER';
var PAGE_INFO_SET = 'PAGE_INFO_SET';
var COMPLETE_PAGE_LOAD = 'COMPLETE_PAGE_LOAD';
var REFRESH_BUCKETS = 'REFRESH_BUCKETS';
var REPLACE_BUCKETS = 'REPLACE_BUCKETS';
var REPLACE_HERO = 'REPLACE_HERO';
var SET_STATE = 'SET_STATE';
var START_GET_COMPETITORS = 'START_GET_COMPETITORS';
var COMPLETE_GET_COMPETITORS = 'COMPLETE_GET_COMPETITORS';

function clearPage() {
    return {
        type: CLEAR_PAGE
    };
}

function createRequestPageAction(id) {
    return {
        type: REQUEST_PAGE,
        id: id,
        requestedTime: Date.now()
    };
}

function createReceivePageAction(_ref) {
    var id = _ref.id,
        name = _ref.name,
        description = _ref.description,
        header = _ref.header,
        image = _ref.image,
        icon = _ref.icon,
        edition = _ref.edition,
        buckets = _ref.buckets,
        tracking = _ref.tracking,
        heroContent = _ref.heroContent,
        carouselBucket = _ref.carouselBucket,
        lang = _ref.lang,
        error = _ref.error,
        isFinal = _ref.isFinal,
        noHero = _ref.noHero;

    return {
        type: RECEIVE_PAGE,
        id: id,
        name: name,
        description: description,
        header: header,
        image: image,
        icon: icon,
        edition: edition,
        buckets: buckets,
        tracking: tracking,
        heroContent: heroContent,
        carouselBucket: carouselBucket,
        lang: lang,
        error: error,
        isFinal: isFinal,
        noHero: noHero,
        receivedTime: Date.now()
    };
}

function startGetCompetitors() {
    return {
        type: START_GET_COMPETITORS,
        startTime: Date.now()
    };
}

function completeGetCompetitors(competitors) {
    return {
        type: COMPLETE_GET_COMPETITORS,
        completeTime: Date.now(),
        competitors: competitors
    };
}

function fetchAllCompetitors() {
    return function (dispatch, getState) {
        var state = getState();
        var apiEnv = Object(__WEBPACK_IMPORTED_MODULE_12__selectors_appSelector__["c" /* apiEnvSelector */])(state);
        dispatch(startGetCompetitors());
        return __WEBPACK_IMPORTED_MODULE_8__lib_api__["e" /* SearchAPI */].getAllCompetitors(apiEnv).then(function (competitors) {
            dispatch(completeGetCompetitors(competitors));
            return competitors;
        });
    };
}

function refreshBuckets(pageName) {
    var _this = this;

    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$params = _ref2.params,
        params = _ref2$params === undefined ? {} : _ref2$params,
        _ref2$forceRefresh = _ref2.forceRefresh,
        forceRefresh = _ref2$forceRefresh === undefined ? false : _ref2$forceRefresh;

    return function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
            var state, _pageSelector, currentPageId, refreshedBuckets, id, seasonId, pathParams, newPageName, _ref4, _ref4$page, buckets, data, _data$page$buckets, _buckets, _pageSelector2, pageId;

            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            state = getState();
                            _pageSelector = Object(__WEBPACK_IMPORTED_MODULE_20__selectors_pageSelector__["c" /* default */])(getState()), currentPageId = _pageSelector.id;
                            refreshedBuckets = void 0;
                            _context.prev = 3;

                            if (!params.id) {
                                _context.next = 19;
                                break;
                            }

                            id = params.id, seasonId = params.seasonId;
                            pathParams = id;

                            if (seasonId) {
                                pathParams += '/seasons/' + seasonId;
                            }

                            /**
                             * pageName override calling collection and show page in the pageApi returns 404
                             */
                            newPageName = pageName;

                            if (pageName === 'collection') {
                                newPageName = 'bucket';
                            } else if (pageName === 'show') {
                                newPageName = 'series';
                            }
                            _context.next = 12;
                            return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_apiAction__["h" /* getPageWithPathId */])({
                                name: newPageName,
                                pathParams: pathParams
                            }));

                        case 12:
                            _ref4 = _context.sent;
                            _ref4$page = _ref4.page;
                            _ref4$page = _ref4$page === undefined ? {} : _ref4$page;
                            buckets = _ref4$page.buckets;

                            refreshedBuckets = buckets;
                            _context.next = 23;
                            break;

                        case 19:
                            _context.next = 21;
                            return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_apiAction__["f" /* getPage */])({ name: pageName }));

                        case 21:
                            data = _context.sent;

                            if (data && data.page) {
                                _data$page$buckets = data.page.buckets, _buckets = _data$page$buckets === undefined ? {} : _data$page$buckets;

                                refreshedBuckets = _buckets;
                            }

                        case 23:
                            _pageSelector2 = Object(__WEBPACK_IMPORTED_MODULE_20__selectors_pageSelector__["c" /* default */])(state), pageId = _pageSelector2.id;

                            if (!(pageId !== currentPageId)) {
                                _context.next = 26;
                                break;
                            }

                            return _context.abrupt('return');

                        case 26:

                            // Replace all the buckets
                            if (forceRefresh) {
                                dispatch({
                                    type: REPLACE_BUCKETS,
                                    buckets: refreshedBuckets
                                });
                            }

                            dispatch({
                                type: REFRESH_BUCKETS,
                                buckets: refreshedBuckets
                            });
                            _context.next = 34;
                            break;

                        case 30:
                            _context.prev = 30;
                            _context.t0 = _context['catch'](3);

                            console.error('refreshBuckets() Error: Unable to refresh buckets for page: ' + pageName, _context.t0);
                            throw _context.t0;

                        case 34:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this, [[3, 30]]);
        }));

        return function (_x2, _x3) {
            return _ref3.apply(this, arguments);
        };
    }();
}

function completePageLoad(buckets) {
    return {
        type: COMPLETE_PAGE_LOAD,
        startTime: Date.now(),
        buckets: buckets
    };
}

// Checks if the contents of bucketPage all exist in one of the buckets and the bucket names match.
// We then consider them equal.
function indexOfBucketInBucketList() {
    var buckets = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var bucket = arguments[1];

    var contentIds = bucket.contents.map(function (content) {
        return content.id;
    });

    if (!buckets.length > 0) {
        return -1;
    }

    var foundIndex = -1;

    var _loop = function _loop(index) {
        var bucketItem = buckets[index];
        var bucketItemContentIds = bucketItem.contents.map(function (content) {
            return content.id;
        });
        var isEqual = bucketItem.name === bucket.name && contentIds.every(function (id) {
            return bucketItemContentIds.indexOf(id) !== -1;
        });
        if (isEqual) {
            foundIndex = index;
            return 'break';
        }
    };

    for (var index = 0; index < buckets.length; index += 1) {
        var _ret = _loop(index);

        if (_ret === 'break') break;
    }

    return foundIndex;
}

function fetchPageData(pageName, params, query) {
    return function (dispatch) {
        if (pageName === 'collection') {
            var bucketId = query.bucketId;

            return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_apiAction__["d" /* getBucketPage */])({
                bucketId: params.id || bucketId,
                groupId: params.groupId,
                ignores: 'displayLimit'
            }));
        } else if (['film', 'product', 'show', 'program', 'compilation'].indexOf(pageName) !== -1) {
            var id = params.id,
                seasonId = params.seasonId;

            var name = __WEBPACK_IMPORTED_MODULE_3__enums__["H" /* URLPath */][pageName];
            var pathParams = id;
            if (seasonId) {
                pathParams += '/seasons/' + seasonId;
            }
            return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_apiAction__["h" /* getPageWithPathId */])({
                name: name,
                pathParams: pathParams
            }));
        } else if (pageName && params.id !== '') {
            // NOTE: Handles `/catalog/:guid` without strict matching
            // TODO: This will eventually replace some pageName conditions in the `else if` above
            // since we will be deprecating `show`, `film` pages and use `catalog`
            return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_apiAction__["h" /* getPageWithPathId */])({
                name: pageName,
                pathParams: params.id
            }));
        }

        return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_apiAction__["f" /* getPage */])({ name: pageName }));
    };
}

function fetchEventData(query) {
    return function (dispatch) {
        var channel = query.channel,
            networkQuery = query.network;

        var network = networkQuery || channel;

        if (network) {
            query.network = network;
        }

        var hasInvalidNetwork = network && PCC_NETWORK_NAMES.indexOf(network) === -1;
        if (__WEBPACK_IMPORTED_MODULE_1_lodash_intersection___default()(Object.keys(query), EVENT_QUERY_KEYS).length > 0 && !hasInvalidNetwork) {
            return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_apiAction__["e" /* getEvent */])({ query: query }));
        }

        return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve();
    };
}

function fetchVideoData(_ref5) {
    var id = _ref5.id;

    return function (dispatch) {
        return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_apiAction__["j" /* getVideo */])({ pathParams: id }));
    };
}

function fetchEventOrVideoByQuery(query) {
    var _this2 = this;

    return function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
            var data;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            data = void 0;
                            _context2.prev = 1;
                            _context2.next = 4;
                            return dispatch(fetchEventData(query));

                        case 4:
                            data = _context2.sent;
                            _context2.next = 10;
                            break;

                        case 7:
                            _context2.prev = 7;
                            _context2.t0 = _context2['catch'](1);

                            console.error(_context2.t0);

                        case 10:
                            if (data) {
                                _context2.next = 12;
                                break;
                            }

                            return _context2.abrupt('return', data);

                        case 12:
                            if (!(!data.page.contents && query.id)) {
                                _context2.next = 22;
                                break;
                            }

                            _context2.prev = 13;
                            _context2.next = 16;
                            return dispatch(fetchVideoData(query));

                        case 16:
                            data = _context2.sent;
                            _context2.next = 22;
                            break;

                        case 19:
                            _context2.prev = 19;
                            _context2.t1 = _context2['catch'](13);

                            console.error(_context2.t1);

                        case 22:
                            return _context2.abrupt('return', data);

                        case 23:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2, [[1, 7], [13, 19]]);
        }));

        return function (_x5) {
            return _ref6.apply(this, arguments);
        };
    }();
}

function fetchBuckets(query, fullUrl) {
    return function (dispatch) {
        var bucketId = query.bucketId;


        if (fullUrl) {
            return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_apiAction__["g" /* getPageByFullUrl */])({ url: fullUrl }));
        } else if (bucketId) {
            return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_apiAction__["d" /* getBucketPage */])({
                bucketId: bucketId
            }));
        }

        return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve();
    };
}

var handlePickerStreams = function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch, pickerApiUrl, eventId) {
        var pickerStream;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        /**
                         * if pickerApiUrl returns from above event pageApi, fetch picker pageApi
                         * and update picker redux state
                         */
                        pickerStream = void 0;

                        if (!pickerApiUrl) {
                            _context3.next = 5;
                            break;
                        }

                        _context3.next = 4;
                        return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_apiAction__["c" /* fetchPickerStreams */])(pickerApiUrl, eventId));

                    case 4:
                        pickerStream = _context3.sent;

                    case 5:
                        return _context3.abrupt('return', pickerStream);

                    case 6:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, this);
    }));

    return function handlePickerStreams(_x6, _x7, _x8) {
        return _ref7.apply(this, arguments);
    };
}();

function createFetchPageAction(id, params, query, lang, fullUrl) {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_9__lib_util_perf__["a" /* markStart */]('createFetchPageAction');
    return function () {
        var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dispatch, getState) {
            var pageName, state, isIntl, isFinal, _pageSelector3, currentId, noHero, shouldRefreshAds, pageData, heroData, bucketsData, _ref9, eventStreams, isHandlePickerCalled, _heroData$page$conten, contentId, isEvent, eventId, status, pickerApiUrl, eventHeroData, contents, _contents$links, links, _ref10, _ref10$page, name, description, header, image, icon, _ref10$page$edition, edition, _ref10$page$buckets, originalBuckets, tracking, error, buckets, newBucket, newBucketIndex, isBucketInBucketList, index, heroContent, carouselBucket, content, _heroContent, _heroContent$links, pickerUrl;

            return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            pageName = id;
                            state = getState();
                            isIntl = Object(__WEBPACK_IMPORTED_MODULE_12__selectors_appSelector__["u" /* isIntlSelector */])(state);
                            isFinal = Object(__WEBPACK_IMPORTED_MODULE_20__selectors_pageSelector__["d" /* isFinalSelector */])(state);
                            _pageSelector3 = Object(__WEBPACK_IMPORTED_MODULE_20__selectors_pageSelector__["c" /* default */])(state), currentId = _pageSelector3.id;
                            noHero = Object(__WEBPACK_IMPORTED_MODULE_20__selectors_pageSelector__["g" /* showPromoSelector */])(state) && id === 'espnplus';
                            shouldRefreshAds = id !== currentId;

                            dispatch(createRequestPageAction(id));

                            pageData = dispatch(fetchPageData(id, params, query));
                            heroData = dispatch(fetchEventOrVideoByQuery(query));
                            bucketsData = pageName === 'player' ? dispatch(fetchBuckets(query, fullUrl)) : __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve();
                            _context4.prev = 11;
                            _context4.next = 14;
                            return pageData;

                        case 14:
                            _context4.t0 = _context4.sent;
                            _context4.next = 17;
                            return heroData;

                        case 17:
                            _context4.t1 = _context4.sent;
                            _context4.next = 20;
                            return bucketsData;

                        case 20:
                            _context4.t2 = _context4.sent;
                            _ref9 = [_context4.t0, _context4.t1, _context4.t2];
                            pageData = _ref9[0];
                            heroData = _ref9[1];
                            bucketsData = _ref9[2];
                            _context4.next = 30;
                            break;

                        case 27:
                            _context4.prev = 27;
                            _context4.t3 = _context4['catch'](11);

                            console.error(_context4.t3);

                        case 30:
                            // even if deep linked with single `id`, if the feed is part of an event, the player should show feeds picker,
                            // so check if it's part of an event, and fetch all streams with `eventId` if so.
                            eventStreams = null;
                            isHandlePickerCalled = false;

                            if (!(!isIntl && query.id && !query.eventId && !query.gameId && heroData && heroData.page && heroData.page.contents && heroData.page.contents.type === __WEBPACK_IMPORTED_MODULE_3__enums__["o" /* ContentType */].LISTING)) {
                                _context4.next = 50;
                                break;
                            }

                            _heroData$page$conten = heroData.page.contents, contentId = _heroData$page$conten.id, isEvent = _heroData$page$conten.isEvent, eventId = _heroData$page$conten.eventId, status = _heroData$page$conten.status;

                            if (!(isEvent || eventId)) {
                                _context4.next = 50;
                                break;
                            }

                            /**
                             * following try catch block code will be called after calling event pageApi with an airingId,
                             * ex: watch/?id=9de24e02-1e11-43aa-9590-e12cf35a492a which will trigger event pageApi with an airingId.
                             * When the response returns eventId, event pageApi will call again with eventId to fetch event data
                             */
                            pickerApiUrl = void 0;
                            _context4.prev = 36;
                            _context4.next = 39;
                            return dispatch(fetchEventData({
                                eventId: eventId || contentId,
                                status: status.toUpperCase()
                            }));

                        case 39:
                            eventHeroData = _context4.sent;
                            contents = eventHeroData && eventHeroData.page && eventHeroData.page.contents;

                            if (contents && contents.streams && contents.streams.length > 0) {
                                _contents$links = contents.links, links = _contents$links === undefined ? {} : _contents$links;

                                pickerApiUrl = links.picker;
                                eventStreams = contents.streams;
                            }
                            _context4.next = 47;
                            break;

                        case 44:
                            _context4.prev = 44;
                            _context4.t4 = _context4['catch'](36);

                            console.error(_context4.t4);

                        case 47:
                            _context4.next = 49;
                            return handlePickerStreams(dispatch, pickerApiUrl, eventId);

                        case 49:
                            isHandlePickerCalled = _context4.sent;

                        case 50:

                            // getPage should never be rejected, it resolves with an error page skeleton, so no need for isFulfilled().
                            _ref10 = pageData || {}, _ref10$page = _ref10.page;
                            _ref10$page = _ref10$page === undefined ? {} : _ref10$page;
                            name = _ref10$page.name, description = _ref10$page.description, header = _ref10$page.header, image = _ref10$page.image, icon = _ref10$page.icon, _ref10$page$edition = _ref10$page.edition, edition = _ref10$page$edition === undefined ? {} : _ref10$page$edition, _ref10$page$buckets = _ref10$page.buckets, originalBuckets = _ref10$page$buckets === undefined ? [] : _ref10$page$buckets, tracking = _ref10$page.tracking, error = _ref10$page.error;

                            // bluebird seems to return a reference to originally cached pageapi request to player
                            // here's a trick to operate on a new reference

                            buckets = originalBuckets.concat([]);


                            if (bucketsData && bucketsData.page.buckets) {
                                newBucket = bucketsData.page.buckets[0];
                                newBucketIndex = indexOfBucketInBucketList(buckets, newBucket);
                                isBucketInBucketList = newBucketIndex !== -1;


                                if (isBucketInBucketList && newBucketIndex !== 0) {
                                    buckets[newBucketIndex].__replaced = true;
                                } else if (!isBucketInBucketList) {
                                    index = buckets.map(function (bucket) {
                                        return bucket.tags && bucket.tags.indexOf('replaceable') !== -1;
                                    }).indexOf(true);

                                    if (index !== -1) {
                                        buckets[index] = newBucket;
                                        buckets[index].__replaced = true;
                                    }
                                }
                            }

                            heroContent = null;


                            if (heroData && heroData.page && heroData.page.contents) {
                                heroContent = heroData.page.contents;
                                if (eventStreams && eventStreams.length > 0) {
                                    heroContent.streams = eventStreams;
                                }
                                // if the hero was determined via id param, mark as concrete as to not change when scored
                                heroContent.concrete = true;
                            }

                            // if there is a bucket which type is `BucketLayout.Carousel`,
                            // it should be rendered as a carousel component and featured on top (used in `Originals` page)
                            carouselBucket = void 0;

                            buckets.some(function (_ref11, index) {
                                var layout = _ref11.layout;

                                if (layout && layout.toLowerCase() === __WEBPACK_IMPORTED_MODULE_3__enums__["i" /* BucketLayout */].Carousel) {
                                    carouselBucket = buckets.splice(index, 1)[0];
                                    return true;
                                }
                                return false;
                            });

                            if (carouselBucket) {
                                noHero = true;
                            }

                            // If there is no specified hero content, grab the first content in the first bucket as hero

                            if (!(!heroContent && !noHero)) {
                                _context4.next = 72;
                                break;
                            }

                            content = void 0;

                            if (header) {
                                // film or show
                                if (header.bucket && header.bucket.contents && header.bucket.contents[0]) {
                                    content = header.bucket.contents[0];
                                    // workaround to remove duplicated live content in the first bucket
                                    if (buckets && buckets[0] && buckets[0].contents && buckets[0].contents.length === 1 && content.status === __WEBPACK_IMPORTED_MODULE_3__enums__["n" /* ContentStatus */].LIVE && buckets[0].contents[0].id === content.id) {
                                        buckets.shift();
                                    }
                                } else {
                                    noHero = true;
                                }
                            } else if (buckets && buckets[0] && buckets[0].contents && buckets[0].contents[0]) {
                                content = buckets[0].contents[0];
                            }

                            if (!(content && (content.type === __WEBPACK_IMPORTED_MODULE_3__enums__["o" /* ContentType */].LISTING || content.type === __WEBPACK_IMPORTED_MODULE_3__enums__["o" /* ContentType */].VOD || content.type === __WEBPACK_IMPORTED_MODULE_3__enums__["o" /* ContentType */].EVENT || content.type === __WEBPACK_IMPORTED_MODULE_3__enums__["o" /* ContentType */].VIDEO))) {
                                _context4.next = 72;
                                break;
                            }

                            /**
                             * Ticket: https://espnjira.disney.com/browse/WEWEB-2501
                             * Fixed missing content props that we need to pass to DSS from hero component
                             * */
                            if (content.streams.length && !content.streams[0].content) {
                                content = Object(__WEBPACK_IMPORTED_MODULE_16__actions_apiAction__["b" /* addContentToStream */])(content);
                            }

                            heroContent = content;
                            // NOTE: The following logic catches the case when there is no Hero content
                            // and we select the first item in the buckets array as a fallback for the Hero content
                            // If that first bucket contains an `eventId` or `isEvent` property is truthy,
                            // we fetch the picker streams using the first item data

                            if (!((heroContent.eventId || heroContent.isEvent) && !query.eventCalendarId && !isHandlePickerCalled)) {
                                _context4.next = 72;
                                break;
                            }

                            _heroContent = heroContent, _heroContent$links = _heroContent.links;
                            _heroContent$links = _heroContent$links === undefined ? {} : _heroContent$links;
                            pickerUrl = _heroContent$links.picker;
                            _context4.next = 72;
                            return handlePickerStreams(dispatch, pickerUrl, heroContent.eventId);

                        case 72:

                            dispatch(createReceivePageAction({
                                id: id,
                                name: name,
                                description: description,
                                header: header,
                                image: image,
                                icon: icon,
                                edition: edition,
                                buckets: buckets,
                                tracking: tracking,
                                heroContent: heroContent,
                                carouselBucket: carouselBucket,
                                lang: lang,
                                error: error,
                                isFinal: isFinal,
                                noHero: noHero
                            }));

                            if (shouldRefreshAds && pageName !== 'player') {
                                // player page sets ads config when a content is selected
                                dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__ads_actions__["g" /* initAdsConfig */])(pageName, tracking, {}, query));
                            }

                            __WEBPACK_IMPORTED_MODULE_9__lib_util_perf__["b" /* measureAndTime */]('createFetchPageAction');
                            return _context4.abrupt('return', __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve());

                        case 76:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this3, [[11, 27], [36, 44]]);
        }));

        return function (_x9, _x10) {
            return _ref8.apply(this, arguments);
        };
    }();
}

function oneIdAndBam(bamProxyIFrameId, requests) {
    return function (dispatch) {
        return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_oneIdActions__["g" /* checkOneIDAuthentication */])()).then(function () {
            return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_appActions__["B" /* createSDKWrapper */])(bamProxyIFrameId, requests));
        });
    };
}

function createPageShellInitAction(params, bamProxyIFrameId) {
    var _this4 = this;

    return function () {
        var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(dispatch, getState) {
            var state, isIntl, _bootstrapSelector, _bootstrapSelector$pa, _bootstrapSelector$pa2, queryParameters, _bootstrapSelector$pa3, requireClientRenderParams, _appSelector, lang, _routingSelector, locationBeforeTransitions, _pageSelector4, pageId, _ref13, _ref13$query, query, isLoggedIn, _oneIdSelector, swid, geo, userTracking, sub, sessionToken, requireClientRender, requireGeo, requireFan, requireCheckOneId, newState, entitlements, hasSuperBundle, bamSubReady, hasTDAEntitlement, isAuthenticated, requiredActions, _pageSelector5, currentPageId, actions;

            return regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            __WEBPACK_IMPORTED_MODULE_9__lib_util_perf__["a" /* markStart */]('createPageShellInitAction');
                            state = getState();
                            isIntl = Object(__WEBPACK_IMPORTED_MODULE_12__selectors_appSelector__["u" /* isIntlSelector */])(state);

                            if (!isIntl) {
                                _context5.next = 9;
                                break;
                            }

                            dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_authenticationActions__["V" /* createSmartAdobePassInitializeAction */])(params));
                            dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_authenticationActions__["W" /* createSmartIpAuthenticationAction */])());
                            dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_oneIdActions__["j" /* completeOneIDAuthentication */])(false, []));
                            _context5.next = 61;
                            break;

                        case 9:
                            _bootstrapSelector = Object(__WEBPACK_IMPORTED_MODULE_11__selectors_bootstrapSelector__["a" /* default */])(state), _bootstrapSelector$pa = _bootstrapSelector.pageApi;
                            _bootstrapSelector$pa = _bootstrapSelector$pa === undefined ? {} : _bootstrapSelector$pa;
                            _bootstrapSelector$pa2 = _bootstrapSelector$pa.queryParameters, queryParameters = _bootstrapSelector$pa2 === undefined ? [] : _bootstrapSelector$pa2, _bootstrapSelector$pa3 = _bootstrapSelector$pa.requireClientRenderParams, requireClientRenderParams = _bootstrapSelector$pa3 === undefined ? [] : _bootstrapSelector$pa3;
                            _appSelector = Object(__WEBPACK_IMPORTED_MODULE_12__selectors_appSelector__["j" /* default */])(state), lang = _appSelector.lang;
                            _routingSelector = Object(__WEBPACK_IMPORTED_MODULE_14__selectors_routingSelector__["a" /* default */])(state), locationBeforeTransitions = _routingSelector.locationBeforeTransitions;
                            _pageSelector4 = Object(__WEBPACK_IMPORTED_MODULE_20__selectors_pageSelector__["c" /* default */])(state), pageId = _pageSelector4.id;
                            _ref13 = locationBeforeTransitions || {}, _ref13$query = _ref13.query, query = _ref13$query === undefined ? {} : _ref13$query;
                            _context5.next = 18;
                            return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_oneIdActions__["h" /* checkSWIDAuthentication */])());

                        case 18:
                            isLoggedIn = _context5.sent;
                            _oneIdSelector = Object(__WEBPACK_IMPORTED_MODULE_13__selectors_oneIdSelector__["a" /* default */])(getState()), swid = _oneIdSelector.swid;
                            geo = Object(__WEBPACK_IMPORTED_MODULE_10__lib_util_localStorage__["a" /* get */])(__WEBPACK_IMPORTED_MODULE_2__constants__["e" /* GEO_LOCATION_KEY */]);
                            userTracking = Object(__WEBPACK_IMPORTED_MODULE_10__lib_util_localStorage__["a" /* get */])(__WEBPACK_IMPORTED_MODULE_2__constants__["r" /* USER_TRACKING_KEY */]);
                            sub = Object(__WEBPACK_IMPORTED_MODULE_10__lib_util_localStorage__["a" /* get */])(__WEBPACK_IMPORTED_MODULE_2__constants__["q" /* SUB_KEY */]);
                            sessionToken = Object(__WEBPACK_IMPORTED_MODULE_10__lib_util_localStorage__["a" /* get */])(__WEBPACK_IMPORTED_MODULE_2__constants__["o" /* SESSION_TOKEN_KEY */]);
                            requireClientRender = __WEBPACK_IMPORTED_MODULE_1_lodash_intersection___default()(queryParameters, requireClientRenderParams).length > 0;
                            requireGeo = requireClientRender && queryParameters.indexOf('zipcode') > -1 && !geo;
                            requireFan = requireClientRender && (queryParameters.indexOf('favoriteTeam') > -1 || queryParameters.indexOf('favoriteSport') > -1);
                            requireCheckOneId = isLoggedIn;


                            if (sub) {
                                if (!isLoggedIn || !sub.swid || sub.swid !== swid) {
                                    Object(__WEBPACK_IMPORTED_MODULE_10__lib_util_localStorage__["c" /* remove */])(__WEBPACK_IMPORTED_MODULE_2__constants__["q" /* SUB_KEY */]);
                                    sub = null;
                                } else {
                                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_authenticationActions__["P" /* createGetBAMAuthenticationInfoAction */])(sub.subscriptions));
                                    newState = getState();
                                    entitlements = Object(__WEBPACK_IMPORTED_MODULE_13__selectors_oneIdSelector__["d" /* oneIdEntitlementsSelector */])(newState);
                                    hasSuperBundle = Object(__WEBPACK_IMPORTED_MODULE_22__selectors_authenticationSelectors__["q" /* superBundleSelector */])(newState);
                                    bamSubReady = Object(__WEBPACK_IMPORTED_MODULE_22__selectors_authenticationSelectors__["k" /* bamSubReadySelector */])(newState);
                                    hasTDAEntitlement = Object(__WEBPACK_IMPORTED_MODULE_21__lib_auth_hasTDA__["a" /* default */])(sessionToken);
                                    isAuthenticated = entitlements && entitlements.length > 0 || hasTDAEntitlement;

                                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_oneIdActions__["j" /* completeOneIDAuthentication */])(isAuthenticated, entitlements, hasTDAEntitlement, hasSuperBundle, bamSubReady));
                                    requireCheckOneId = false;
                                }
                            }

                            if (geo) {
                                dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_authenticationActions__["R" /* createGetGeoLocationAction */])(geo));
                            }

                            if (sessionToken) {
                                if (!isLoggedIn) {
                                    Object(__WEBPACK_IMPORTED_MODULE_10__lib_util_localStorage__["c" /* remove */])(__WEBPACK_IMPORTED_MODULE_2__constants__["o" /* SESSION_TOKEN_KEY */]);
                                    sessionToken = null;
                                } else {
                                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_authenticationActions__["Q" /* createGetBAMSessionTokenAction */])(sessionToken));
                                }
                            }

                            if (userTracking) {
                                dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_authenticationActions__["T" /* createGetUserTrackingAction */])(userTracking));
                            }

                            if (isLoggedIn) {
                                dispatch(oneIdAndBam(bamProxyIFrameId, requireGeo ? ['geolocation', 'subscriptions', 'sessionToken', 'userTrackingInformation'] : ['subscriptions', 'sessionToken', 'userTrackingInformation']));
                            } else {
                                // if user is not logged, we need to trigger createSDKWrapper call to get user tracking info from DSS sdk
                                // ticket: https://jira.disney.com/browse/WEWEB-2597
                                dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_appActions__["B" /* createSDKWrapper */])(bamProxyIFrameId, ['userTrackingInformation']));
                                dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_oneIdActions__["j" /* completeOneIDAuthentication */])(false, []));
                            }
                            dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_authenticationActions__["V" /* createSmartAdobePassInitializeAction */])(params));
                            // find out what actions are necessary to await to reflect to Page API params
                            requiredActions = [];

                            if (requireGeo) {
                                // grabbing zipcode from location data since BAM's geolocation uses IP info as well.
                                requiredActions.push(dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_authenticationActions__["W" /* createSmartIpAuthenticationAction */])()));
                            } else {
                                dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_authenticationActions__["W" /* createSmartIpAuthenticationAction */])());
                            }

                            if (requireCheckOneId) {
                                requiredActions.push(dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_oneIdActions__["g" /* checkOneIDAuthentication */])()));
                            } else {
                                dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_oneIdActions__["g" /* checkOneIDAuthentication */])());
                            }

                            if (requireFan) {
                                requiredActions.push(dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions_fanActions__["b" /* createSmartFanAction */])()));
                            } // we don't need it now

                            if (!requiredActions.length) {
                                _context5.next = 47;
                                break;
                            }

                            _context5.prev = 39;
                            _context5.next = 42;
                            return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.all(requiredActions);

                        case 42:
                            _context5.next = 47;
                            break;

                        case 44:
                            _context5.prev = 44;
                            _context5.t0 = _context5['catch'](39);

                            console.error('createPageShellInitAction', _context5.t0);

                        case 47:
                            _pageSelector5 = Object(__WEBPACK_IMPORTED_MODULE_20__selectors_pageSelector__["c" /* default */])(getState()), currentPageId = _pageSelector5.id;

                            if (!(requireClientRender || query[__WEBPACK_IMPORTED_MODULE_3__enums__["t" /* Flags */].NO_SSR] === 'true' && __WEBPACK_IMPORTED_MODULE_2__constants__["s" /* clientRenderRoutes */].indexOf(pageId) > -1)) {
                                _context5.next = 61;
                                break;
                            }

                            if (!(pageId && pageId === currentPageId && pageId !== 'schedule' && pageId !== 'search' && pageId !== 'sid')) {
                                _context5.next = 61;
                                break;
                            }

                            actions = [dispatch(createFetchPageAction(pageId, params, query, lang))];

                            if (pageId !== 'player') {
                                actions.push(dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__scheduleModule_actions__["d" /* fetchScheduleModule */])(lang)));
                            }
                            _context5.prev = 52;
                            _context5.next = 55;
                            return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.all(actions);

                        case 55:
                            _context5.next = 60;
                            break;

                        case 57:
                            _context5.prev = 57;
                            _context5.t1 = _context5['catch'](52);

                            console.error('createPageShellInitAction', _context5.t1);

                        case 60:
                            __WEBPACK_IMPORTED_MODULE_9__lib_util_perf__["b" /* measureAndTime */]('createPageShellInitAction');

                        case 61:

                            dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_scoringActions__["a" /* scoreAll */])());

                        case 62:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this4, [[39, 44], [52, 57]]);
        }));

        return function (_x11, _x12) {
            return _ref12.apply(this, arguments);
        };
    }();
}

function createLaunchPlayerAction(content) {
    var id = content.id;
    var tileType = content.type || '';
    var source = content.sourceType === __WEBPACK_IMPORTED_MODULE_3__enums__["E" /* SourceType */].LINEAR ? content.source : null;

    return {
        type: LAUNCH_PLAYER,
        id: id,
        source: source,
        tileType: tileType,
        launchedAt: Date.now()
    };
}

function setPageInfo(id, name) {
    var autoPageViewTrack = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    return function (dispatch) {
        dispatch({
            type: PAGE_INFO_SET,
            id: id,
            name: name,
            isFinal: true,
            autoPageViewTrack: autoPageViewTrack
        });
    };
}

function replaceHero(content) {
    return {
        type: REPLACE_HERO,
        content: content
    };
}

function setPageState(isFinal) {
    return {
        type: SET_STATE,
        isFinal: isFinal
    };
}

function getAiring(_ref14) {
    var _this5 = this;

    var id = _ref14.id;

    return function () {
        var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(dispatch) {
            var _ref16, _ref16$data, data, airing;

            return regeneratorRuntime.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            _context6.prev = 0;
                            _context6.next = 3;
                            return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_apiAction__["k" /* graphql */])('getAiring', { id: id }));

                        case 3:
                            _ref16 = _context6.sent;
                            _ref16$data = _ref16.data;
                            data = _ref16$data === undefined ? {} : _ref16$data;
                            airing = data.airing;
                            return _context6.abrupt('return', airing);

                        case 10:
                            _context6.prev = 10;
                            _context6.t0 = _context6['catch'](0);
                            return _context6.abrupt('return', {});

                        case 13:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, _this5, [[0, 10]]);
        }));

        return function (_x14) {
            return _ref15.apply(this, arguments);
        };
    }();
}

function getAirings(_ref17) {
    var _this6 = this;

    var eventId = _ref17.eventId;

    return function () {
        var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(dispatch) {
            var _ref19, _ref19$data, data, airings;

            return regeneratorRuntime.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            _context7.prev = 0;
                            _context7.next = 3;
                            return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_apiAction__["k" /* graphql */])('getAirings', { eventId: eventId, limit: 500 }));

                        case 3:
                            _ref19 = _context7.sent;
                            _ref19$data = _ref19.data;
                            data = _ref19$data === undefined ? {} : _ref19$data;
                            airings = data.airings;
                            return _context7.abrupt('return', airings);

                        case 10:
                            _context7.prev = 10;
                            _context7.t0 = _context7['catch'](0);
                            return _context7.abrupt('return', []);

                        case 13:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, _this6, [[0, 10]]);
        }));

        return function (_x15) {
            return _ref18.apply(this, arguments);
        };
    }();
}

function singleEventPage(id, name, query) {
    var _this7 = this;

    return function () {
        var _ref20 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(dispatch) {
            var eventId, partner, dates, thumbnail, content, newQuery, payload, _ref21, _ref21$page, edition, heroContent, _heroContent$streams, streams;

            return regeneratorRuntime.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            dispatch(createRequestPageAction(id));
                            dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_appActions__["w" /* analyticsReady */])({}));

                            eventId = query.eventId || query.gameId;
                            partner = query.partner, dates = query.dates, thumbnail = query.thumbnail;
                            content = void 0;

                            if (!(!query.id && partner)) {
                                _context8.next = 9;
                                break;
                            }

                            _context8.next = 8;
                            return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_listingsActions__["a" /* getEventByQuery */])({ partner: partner, dates: dates }));

                        case 8:
                            content = _context8.sent;

                        case 9:
                            newQuery = void 0;

                            delete query.thumbnail;
                            if (content) {
                                delete query.eventId;
                                delete query.gameId;
                                delete query.league;
                                delete query.partner;
                                delete query.dates;
                                newQuery = _extends({}, query, { id: content.id });
                            } else if (eventId) {
                                newQuery = { eventId: eventId };
                            } else if (query.id || query.channel || query.network) {
                                newQuery = query;
                            } else if (!partner) {
                                newQuery = _extends({}, query, {
                                    network: 'espn'
                                });
                            }

                            payload = void 0;

                            if (!newQuery) {
                                _context8.next = 17;
                                break;
                            }

                            _context8.next = 16;
                            return dispatch(fetchEventOrVideoByQuery(newQuery));

                        case 16:
                            payload = _context8.sent;

                        case 17:
                            _ref21 = payload || {}, _ref21$page = _ref21.page;
                            _ref21$page = _ref21$page === undefined ? {} : _ref21$page;
                            edition = _ref21$page.edition, heroContent = _ref21$page.contents;

                            if (!heroContent) {
                                _context8.next = 26;
                                break;
                            }

                            if (thumbnail) {
                                heroContent.imageHref = thumbnail;
                            }
                            _heroContent$streams = heroContent.streams, streams = _heroContent$streams === undefined ? [] : _heroContent$streams;

                            if (!streams.length) {
                                _context8.next = 26;
                                break;
                            }

                            _context8.next = 26;
                            return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_appActions__["O" /* streamSelect */])(streams[0]));

                        case 26:
                            dispatch(createReceivePageAction({
                                id: id,
                                name: name,
                                edition: edition,
                                heroContent: heroContent,
                                isFinal: true
                            }));

                        case 27:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, _this7);
        }));

        return function (_x16) {
            return _ref20.apply(this, arguments);
        };
    }();
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = queryString;
function queryString(params) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var append = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var queryString = '';
    var first = !append;
    for (var key in params) {
        if (params.hasOwnProperty(key) && params[key]) {
            queryString += first ? '?' : '&';
            queryString += key + '=' + (encode ? encodeURIComponent(params[key]) : params[key]);
            first = false;
        }
    }
    return queryString;
};

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return APP_RENDERED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ANALYTICS_READY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLOSE_MODAL_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CONTENT_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CONTENT_UNSELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return STREAM_SELECTING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return STREAM_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return STREAM_UNSELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DISPLAY_MODAL_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return MEDIA_QUERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return INIT_APP_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_EXTERNAL_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_EMBEDDED_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return PACKAGE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return PACKAGE_TIER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return PICKER_STREAMS_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return PICKER_STREAMS_UNSELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return PICKER_STREAMS_SELECT_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return OPEN_PICKER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return OPEN_PICKER_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return PICKER_AUTO_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return PICKER_STATE_CLEAR; });
/* harmony export (immutable) */ __webpack_exports__["C"] = displayModalMessage;
/* harmony export (immutable) */ __webpack_exports__["y"] = closeModalMessage;
/* harmony export (immutable) */ __webpack_exports__["Q"] = updateRoute;
/* harmony export (immutable) */ __webpack_exports__["O"] = streamSelect;
/* harmony export (immutable) */ __webpack_exports__["P"] = streamUnSelect;
/* harmony export (immutable) */ __webpack_exports__["z"] = contentSelect;
/* harmony export (immutable) */ __webpack_exports__["A"] = contentUnSelect;
/* harmony export (immutable) */ __webpack_exports__["x"] = appRendered;
/* harmony export (immutable) */ __webpack_exports__["w"] = analyticsReady;
/* harmony export (immutable) */ __webpack_exports__["D"] = fetchExternalConfig;
/* unused harmony export initAppData */
/* harmony export (immutable) */ __webpack_exports__["E"] = mediaQuery;
/* harmony export (immutable) */ __webpack_exports__["L"] = savePackageId;
/* harmony export (immutable) */ __webpack_exports__["M"] = savePackageTier;
/* harmony export (immutable) */ __webpack_exports__["N"] = sendContentReward;
/* harmony export (immutable) */ __webpack_exports__["B"] = createSDKWrapper;
/* unused harmony export createSelectMultipleStreamsAction */
/* harmony export (immutable) */ __webpack_exports__["I"] = pickerStreamsSelect;
/* harmony export (immutable) */ __webpack_exports__["K"] = pickerStreamsUnSelect;
/* harmony export (immutable) */ __webpack_exports__["J"] = pickerStreamsSelectError;
/* harmony export (immutable) */ __webpack_exports__["G"] = openPickerSuccess;
/* harmony export (immutable) */ __webpack_exports__["F"] = openPickerError;
/* unused harmony export pickerAutoSelect */
/* harmony export (immutable) */ __webpack_exports__["H"] = pickerStateClear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_redux__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bluebird__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__enums__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__page_actions__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ads_actions__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__apiAction__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__oneIdActions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__selectors_bootstrapSelector__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__selectors_appSelector__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__selectors_flagsSelector__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__selectors_pageSelector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__selectors_routingSelector__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__selectors_oneIdSelector__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__selectors_authenticationSelectors__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__selectors_selectedContentSelector__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__selectors_selectedStreamSelector__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__authenticationActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__webapp_player_util__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__webapp_common_video_player__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__lib_util_isEmpty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__lib_util_getBamAuthConfig__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__lib_util_localStorage__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__lib_util_perf__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__lib_api_PageAPI__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__lib_auth_hasTDA__ = __webpack_require__(215);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new __WEBPACK_IMPORTED_MODULE_1_bluebird___default.a(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return __WEBPACK_IMPORTED_MODULE_1_bluebird___default.a.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/* Only gets fired on the client */





























var APP_RENDERED = 'APP_RENDERED';
var ANALYTICS_READY = 'ANALYTICS_READY';
var CLOSE_MODAL_MESSAGE = 'CLOSE_MODAL_MESSAGE';
var CONTENT_SELECT = 'CONTENT_SELECT';
var CONTENT_UNSELECT = 'CONTENT_UNSELECT';
var STREAM_SELECTING = 'STREAM_SELECTING';
var STREAM_SELECT = 'STREAM_SELECT';
var STREAM_UNSELECT = 'STREAM_UNSELECT';
var DISPLAY_MODAL_MESSAGE = 'DISPLAY_MODAL_MESSAGE';
var MEDIA_QUERY = 'MEDIA_QUERY';
var INIT_APP_DATA = 'INIT_APP_DATA';
var FETCH_EXTERNAL_CONFIG = 'FETCH_EXTERNAL_CONFIG';
var FETCH_EMBEDDED_OPTIONS = 'FETCH_EMBEDDED_OPTIONS';
var PACKAGE_ID = 'PACKAGE_ID';
var PACKAGE_TIER = 'PACKAGE_TIER';
var PICKER_STREAMS_SELECT = 'PICKER_STREAMS_SELECT';
var PICKER_STREAMS_UNSELECT = 'PICKER_STREAMS_UNSELECT';
var PICKER_STREAMS_SELECT_ERROR = 'PICKER_STREAMS_SELECT_ERROR';
var OPEN_PICKER_SUCCESS = 'OPEN_PICKER_SUCCESS';
var OPEN_PICKER_ERROR = 'OPEN_PICKER_ERROR';
var PICKER_AUTO_SELECT = 'PICKER_AUTO_SELECT';
var PICKER_STATE_CLEAR = 'PICKER_STATE_CLEAR';

var AdobePassEnv = __WEBPACK_IMPORTED_MODULE_2__enums__["a" /* AdobePass */].Env;
var ApiEnv = __WEBPACK_IMPORTED_MODULE_2__enums__["b" /* Api */].Env;


function displayModalMessage(messageType, messageData) {
    return {
        type: DISPLAY_MODAL_MESSAGE,
        messageType: messageType,
        messageData: messageData
    };
}

function closeModalMessage() {
    return {
        type: CLOSE_MODAL_MESSAGE
    };
}

function updateRoute(query) {
    return function (dispatch, getState) {
        var state = getState();
        var flags = Object(__WEBPACK_IMPORTED_MODULE_10__selectors_flagsSelector__["a" /* persistentFlagsSelector */])(state);

        var _routingSelector = Object(__WEBPACK_IMPORTED_MODULE_12__selectors_routingSelector__["a" /* default */])(state),
            locationBeforeTransitions = _routingSelector.locationBeforeTransitions;

        dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["replace"])(_extends({}, locationBeforeTransitions, { query: _extends({}, flags, query) })));
    };
}

function streamSelect(stream) {
    var _this = this;

    return function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
            var state, _appSelector, selectingStream, _appSelector$playback, playbackMetaArg, _pageSelector, pageId, _pageSelector$buckets, buckets, tracking, _routingSelector2, locationBeforeTransitions, _ref2, _ref2$query, query, content, selectedStream, type, bucketId, reselected, playbackMeta, _appSelector2, selectingStreamArg, id, _ref3, _ref3$tracking, sport, league, franchise, playerUrlId, regex, sp, lg, show;

            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (!Object(__WEBPACK_IMPORTED_MODULE_20__lib_util_isEmpty__["a" /* default */])(stream)) {
                                _context.next = 3;
                                break;
                            }

                            console.error('Empty stream selected');
                            return _context.abrupt('return');

                        case 3:
                            state = getState();
                            _appSelector = Object(__WEBPACK_IMPORTED_MODULE_9__selectors_appSelector__["j" /* default */])(state), selectingStream = _appSelector.selectingStream, _appSelector$playback = _appSelector.playbackMeta, playbackMetaArg = _appSelector$playback === undefined ? {} : _appSelector$playback;
                            _pageSelector = Object(__WEBPACK_IMPORTED_MODULE_11__selectors_pageSelector__["c" /* default */])(state), pageId = _pageSelector.id, _pageSelector$buckets = _pageSelector.buckets, buckets = _pageSelector$buckets === undefined ? [] : _pageSelector$buckets, tracking = _pageSelector.tracking;
                            _routingSelector2 = Object(__WEBPACK_IMPORTED_MODULE_12__selectors_routingSelector__["a" /* default */])(state), locationBeforeTransitions = _routingSelector2.locationBeforeTransitions;
                            _ref2 = locationBeforeTransitions || {}, _ref2$query = _ref2.query, query = _ref2$query === undefined ? {} : _ref2$query;
                            content = Object(__WEBPACK_IMPORTED_MODULE_15__selectors_selectedContentSelector__["a" /* default */])(state);
                            selectedStream = Object(__WEBPACK_IMPORTED_MODULE_16__selectors_selectedStreamSelector__["a" /* default */])(state);
                            type = content.type, bucketId = content.bucketId;
                            reselected = selectingStream && selectingStream.id === stream.id || playbackMetaArg.playbackState && playbackMetaArg.playbackState.id === stream.id;

                            if (!reselected) {
                                _context.next = 14;
                                break;
                            }

                            return _context.abrupt('return');

                        case 14:

                            // NOTE: Assigning the playlist array to the stream without mobile restrictions
                            if (type === __WEBPACK_IMPORTED_MODULE_2__enums__["o" /* ContentType */].VOD) {
                                stream.playlist = Object(__WEBPACK_IMPORTED_MODULE_18__webapp_player_util__["b" /* getContentPlaylistFromBuckets */])(content, buckets);
                            }

                            dispatch({
                                type: STREAM_SELECTING,
                                stream: stream
                            });

                            playbackMeta = void 0;

                            if (!(stream.links && stream.links.play)) {
                                _context.next = 30;
                                break;
                            }

                            _context.prev = 18;
                            _context.next = 21;
                            return Object(__WEBPACK_IMPORTED_MODULE_24__lib_api_PageAPI__["getPlaybackMeta"])(stream.links.play);

                        case 21:
                            playbackMeta = _context.sent;
                            _appSelector2 = Object(__WEBPACK_IMPORTED_MODULE_9__selectors_appSelector__["j" /* default */])(getState()), selectingStreamArg = _appSelector2.selectingStream;

                            if (selectingStreamArg) {
                                _context.next = 25;
                                break;
                            }

                            return _context.abrupt('return');

                        case 25:
                            _context.next = 30;
                            break;

                        case 27:
                            _context.prev = 27;
                            _context.t0 = _context['catch'](18);

                            console.error(_context.t0);

                        case 30:
                            id = stream.id;
                            _ref3 = playbackMeta || {}, _ref3$tracking = _ref3.tracking;
                            _ref3$tracking = _ref3$tracking === undefined ? {} : _ref3$tracking;
                            sport = _ref3$tracking.sport, league = _ref3$tracking.league, franchise = _ref3$tracking.franchise;
                            playerUrlId = Object(__WEBPACK_IMPORTED_MODULE_9__selectors_appSelector__["g" /* contentIdInPlayerUrl */])(state);

                            if (playerUrlId && selectedStream.id !== id) {
                                if (query.id && !query.eventId && !query.gameId || !stream.content.eventId) {
                                    dispatch(updateRoute({ id: id, bucketId: bucketId }));
                                }
                            }

                            // reset AdobePass error
                            dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__authenticationActions__["B" /* createAdobePassErrorAction */])());

                            dispatch({
                                type: STREAM_SELECT,
                                stream: stream,
                                playbackMeta: playbackMeta,
                                clickedTime: Date.now()
                            });

                            // refresh ads with the new ad targeting
                            if (pageId === 'player') {
                                // TODO: i think we can pass the value as is by encoding the value, but that might involves espn.com change.
                                regex = /\s|:|#|,|\(|\)|\[|]/g;
                                sp = sport && sport.replace(regex, '_');
                                lg = league && league.replace(regex, '_');
                                show = franchise && franchise.replace(regex, '_');

                                dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__ads_actions__["g" /* initAdsConfig */])(pageId, tracking, {
                                    sp: sp,
                                    lg: lg,
                                    show: show
                                }, query));
                            }

                        case 39:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this, [[18, 27]]);
        }));

        return function (_x, _x2) {
            return _ref.apply(this, arguments);
        };
    }();
}

function streamUnSelect() {
    return {
        type: STREAM_UNSELECT
    };
}

function contentSelect(contentArg) {
    var _this2 = this;

    return function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
            var state, content, stream, _pageSelector2, id;

            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            state = getState();
                            content = contentArg;
                            stream = void 0;
                            _pageSelector2 = Object(__WEBPACK_IMPORTED_MODULE_11__selectors_pageSelector__["c" /* default */])(state), id = _pageSelector2.id;

                            if (id === 'player') {
                                if (content) {
                                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__page_actions__["w" /* replaceHero */])(content));
                                }
                            }

                            dispatch({
                                type: CONTENT_SELECT,
                                content: content,
                                clickedTime: Date.now()
                            });

                            if (stream) {
                                dispatch(streamSelect(stream));
                            }

                        case 7:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }));

        return function (_x3, _x4) {
            return _ref4.apply(this, arguments);
        };
    }();
}

function contentUnSelect(content) {
    return {
        type: CONTENT_UNSELECT,
        content: content,
        clickedTime: Date.now()
    };
}

function appRendered() {
    return {
        type: APP_RENDERED
    };
}

function analyticsReady() {
    var initData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return {
        type: ANALYTICS_READY,
        initData: initData,
        completeTime: Date.now()
    };
}

function fetchExternalConfig() {
    var _this3 = this;

    return function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch) {
            var config;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.next = 2;
                            return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__apiAction__["l" /* loadBootstrap */])());

                        case 2:
                            config = _context3.sent;

                            dispatch({
                                type: FETCH_EXTERNAL_CONFIG,
                                bootstrap: config
                            });
                            return _context3.abrupt('return', config);

                        case 5:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }));

        return function (_x6) {
            return _ref5.apply(this, arguments);
        };
    }();
}
// TODO: DTC - point back to `ApiEnv.PROD`
function initAppData(_ref6) {
    var appName = _ref6.appName,
        _ref6$adobePassEnv = _ref6.adobePassEnv,
        adobePassEnv = _ref6$adobePassEnv === undefined ? AdobePassEnv.PROD : _ref6$adobePassEnv,
        _ref6$apiEnv = _ref6.apiEnv,
        apiEnv = _ref6$apiEnv === undefined ? ApiEnv.PROD : _ref6$apiEnv,
        configEnv = _ref6.configEnv,
        device = _ref6.device,
        env = _ref6.env,
        location = _ref6.location,
        lang = _ref6.lang,
        country = _ref6.country,
        messages = _ref6.messages,
        enableSearch = _ref6.enableSearch,
        packageId = _ref6.packageId,
        tier = _ref6.tier,
        edition = _ref6.edition,
        webview = _ref6.webview,
        renderTemplateType = _ref6.renderTemplateType,
        newrelicInsertKey = _ref6.newrelicInsertKey,
        newrelicAccountId = _ref6.newrelicAccountId;

    var isMobile = device === __WEBPACK_IMPORTED_MODULE_2__enums__["q" /* Device */].HANDSET || device === __WEBPACK_IMPORTED_MODULE_2__enums__["q" /* Device */].TABLET;

    return {
        type: INIT_APP_DATA,
        appName: appName,
        adobePassEnv: adobePassEnv,
        apiEnv: apiEnv,
        configEnv: configEnv,
        device: device,
        env: env,
        isMobile: isMobile,
        location: location,
        lang: lang,
        sourceLang: lang,
        country: country,
        messages: messages,
        enableSearch: enableSearch,
        packageId: packageId,
        tier: tier,
        edition: edition,
        webview: webview,
        renderTemplateType: renderTemplateType,
        newrelicInsertKey: newrelicInsertKey,
        newrelicAccountId: newrelicAccountId
    };
}

function mediaQuery(mq) {
    return {
        type: MEDIA_QUERY,
        mq: mq
    };
}

function savePackageId(packageId) {
    return {
        type: PACKAGE_ID,
        packageId: packageId
    };
}

function savePackageTier(tier) {
    return {
        type: PACKAGE_TIER,
        tier: tier
    };
}

function sendContentReward(_ref7) {
    var _this4 = this;

    var _ref7$selector = _ref7.selector,
        selector = _ref7$selector === undefined ? __WEBPACK_IMPORTED_MODULE_3__constants__["c" /* BAM_PROXY_IFRAME_ID */] : _ref7$selector,
        rewardToken = _ref7.rewardToken,
        contentId = _ref7.contentId,
        _ref7$userActivityAct = _ref7.userActivityAction,
        userActivityAction = _ref7$userActivityAct === undefined ? 'CLICK' : _ref7$userActivityAct,
        _ref7$recommendedCont = _ref7.recommendedContentIds,
        recommendedContentIds = _ref7$recommendedCont === undefined ? [] : _ref7$recommendedCont;

    return function () {
        var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dispatch, getState) {
            var state, _bootstrapSelector, bam, _routingSelector3, locationBeforeTransitions, _ref9, query, videoPlayer;

            return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            state = getState();
                            _bootstrapSelector = Object(__WEBPACK_IMPORTED_MODULE_8__selectors_bootstrapSelector__["a" /* default */])(state), bam = _bootstrapSelector.bam;
                            _routingSelector3 = Object(__WEBPACK_IMPORTED_MODULE_12__selectors_routingSelector__["a" /* default */])(state), locationBeforeTransitions = _routingSelector3.locationBeforeTransitions;
                            _ref9 = locationBeforeTransitions || {}, query = _ref9.query;
                            _context4.prev = 4;
                            videoPlayer = new __WEBPACK_IMPORTED_MODULE_19__webapp_common_video_player__["a" /* default */]({
                                bamPlayerOptions: query[__WEBPACK_IMPORTED_MODULE_2__enums__["t" /* Flags */].BAM_ENV] ? _extends({}, bam, { env: query[__WEBPACK_IMPORTED_MODULE_2__enums__["t" /* Flags */].BAM_ENV] }) : bam
                            });
                            _context4.next = 8;
                            return videoPlayer.sendContentReward({
                                selector: '#' + selector,
                                rewardToken: rewardToken,
                                contentId: contentId,
                                userActivityAction: userActivityAction,
                                recommendedContentIds: recommendedContentIds
                            });

                        case 8:
                            _context4.next = 13;
                            break;

                        case 10:
                            _context4.prev = 10;
                            _context4.t0 = _context4['catch'](4);

                            console.error('sendContentReward ERROR:', _context4.t0); // eslint-disable-line

                        case 13:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4, [[4, 10]]);
        }));

        return function (_x7, _x8) {
            return _ref8.apply(this, arguments);
        };
    }();
}

function createSDKWrapper(containerIdArg, requestsArg) {
    var _this5 = this;

    var transactionId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    return function (dispatch, getState) {
        var perfName = requestsArg ? 'createSDKWrapper_' + requestsArg.join('') : 'createSDKWrapper';
        __WEBPACK_IMPORTED_MODULE_23__lib_util_perf__["a" /* markStart */](perfName);
        var state = getState();

        var _bootstrapSelector2 = Object(__WEBPACK_IMPORTED_MODULE_8__selectors_bootstrapSelector__["a" /* default */])(state),
            bam = _bootstrapSelector2.bam;

        var passOneIdToken = Object(__WEBPACK_IMPORTED_MODULE_14__selectors_authenticationSelectors__["n" /* passOneIdTokenSelector */])(state);

        var _routingSelector4 = Object(__WEBPACK_IMPORTED_MODULE_12__selectors_routingSelector__["a" /* default */])(state),
            locationBeforeTransitions = _routingSelector4.locationBeforeTransitions;

        var _ref10 = locationBeforeTransitions || {},
            query = _ref10.query;

        var isOneIdLoggedIn = Object(__WEBPACK_IMPORTED_MODULE_13__selectors_oneIdSelector__["f" /* oneIdLoggedInSelector */])(state);
        var oneIdToken = Object(__WEBPACK_IMPORTED_MODULE_13__selectors_oneIdSelector__["g" /* oneIdTokenSelector */])(state);
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__authenticationActions__["X" /* createStartCheckBAMAuthenticationAction */])());
        return new __WEBPACK_IMPORTED_MODULE_1_bluebird___default.a(function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(resolve) {
                var geolocationKey, subscriptionsKey, sessionTokenKey, userTrackingKey, result, requests, videoPlayer, geo, complete, defaultActions, removeRequest, location, appContainerEl, containerId, el, elCnt, eventRes, config;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                geolocationKey = 'geolocation';
                                subscriptionsKey = 'subscriptions';
                                sessionTokenKey = 'sessionToken';
                                userTrackingKey = 'userTrackingInformation';
                                result = {};
                                requests = requestsArg || [geolocationKey, subscriptionsKey, sessionTokenKey, userTrackingKey];
                                videoPlayer = new __WEBPACK_IMPORTED_MODULE_19__webapp_common_video_player__["a" /* default */]({
                                    bamPlayerOptions: query[__WEBPACK_IMPORTED_MODULE_2__enums__["t" /* Flags */].BAM_ENV] ? _extends({}, bam, { env: query[__WEBPACK_IMPORTED_MODULE_2__enums__["t" /* Flags */].BAM_ENV] }) : bam
                                });
                                geo = Object(__WEBPACK_IMPORTED_MODULE_22__lib_util_localStorage__["a" /* get */])(__WEBPACK_IMPORTED_MODULE_3__constants__["e" /* GEO_LOCATION_KEY */]);

                                complete = function complete() {
                                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__authenticationActions__["J" /* createCompleteCheckBAMAuthenticationAction */])());
                                    __WEBPACK_IMPORTED_MODULE_23__lib_util_perf__["b" /* measureAndTime */](perfName);
                                    resolve(result);
                                };

                                defaultActions = function defaultActions() {
                                    if (!geo) {
                                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__authenticationActions__["R" /* createGetGeoLocationAction */])());
                                    }
                                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__authenticationActions__["P" /* createGetBAMAuthenticationInfoAction */])());
                                    complete();
                                };

                                removeRequest = function removeRequest(list, entry) {
                                    var index = list.indexOf(entry);
                                    if (index > -1) {
                                        list.splice(index, 1);
                                    }
                                };

                                if (requests.indexOf(geolocationKey) > -1) {
                                    if (geo) {
                                        // use cached one
                                        location = geo;

                                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__authenticationActions__["R" /* createGetGeoLocationAction */])(location));
                                        result[geolocationKey] = location;
                                        removeRequest(requests, geolocationKey);
                                    } else {
                                        videoPlayer.once(__WEBPACK_IMPORTED_MODULE_19__webapp_common_video_player__["a" /* default */].Events.GEOLOCATION_READY, function () {
                                            var _ref12 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                                                _ref12$body = _ref12.body;

                                            _ref12$body = _ref12$body === undefined ? {} : _ref12$body;
                                            var location = _ref12$body.location;

                                            dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__authenticationActions__["R" /* createGetGeoLocationAction */])(location));
                                            result[geolocationKey] = location;
                                            if (Object.keys(result).length >= requests.length) {
                                                complete();
                                            }
                                        });
                                    }
                                }
                                if (requests.indexOf(subscriptionsKey) > -1) {
                                    if (!isOneIdLoggedIn) {
                                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__authenticationActions__["P" /* createGetBAMAuthenticationInfoAction */])());
                                        removeRequest(requests, subscriptionsKey);
                                    } else {
                                        videoPlayer.once(__WEBPACK_IMPORTED_MODULE_19__webapp_common_video_player__["a" /* default */].Events.SUBSCRIPTIONS_READY, function () {
                                            var _ref13 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                                                _ref13$body = _ref13.body;

                                            _ref13$body = _ref13$body === undefined ? {} : _ref13$body;
                                            var subscriptions = _ref13$body.subscriptions;

                                            dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__authenticationActions__["P" /* createGetBAMAuthenticationInfoAction */])(subscriptions));
                                            var newState = getState();
                                            var entitlements = Object(__WEBPACK_IMPORTED_MODULE_13__selectors_oneIdSelector__["d" /* oneIdEntitlementsSelector */])(newState);
                                            var bamSessionToken = Object(__WEBPACK_IMPORTED_MODULE_14__selectors_authenticationSelectors__["j" /* bamSessionTokenSelector */])(newState);
                                            var hasSuperBundle = Object(__WEBPACK_IMPORTED_MODULE_14__selectors_authenticationSelectors__["q" /* superBundleSelector */])(newState);
                                            var hasTDAEntitlement = Object(__WEBPACK_IMPORTED_MODULE_25__lib_auth_hasTDA__["a" /* default */])(bamSessionToken);
                                            var isAuthenticated = entitlements && entitlements.length > 0 || hasTDAEntitlement;

                                            var _oneIdSelector = Object(__WEBPACK_IMPORTED_MODULE_13__selectors_oneIdSelector__["a" /* default */])(getState()),
                                                swid = _oneIdSelector.swid;

                                            Object(__WEBPACK_IMPORTED_MODULE_22__lib_util_localStorage__["d" /* set */])(__WEBPACK_IMPORTED_MODULE_3__constants__["q" /* SUB_KEY */], { swid: swid, subscriptions: subscriptions }, 24 * 60 * 60);
                                            dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__oneIdActions__["j" /* completeOneIDAuthentication */])(isAuthenticated, entitlements, hasTDAEntitlement, hasSuperBundle, true));
                                            result[subscriptionsKey] = subscriptions;
                                            if (Object.keys(result).length >= requests.length) {
                                                complete();
                                            }
                                        });
                                    }
                                }

                                if (requests.indexOf(userTrackingKey) > -1) {
                                    videoPlayer.once(__WEBPACK_IMPORTED_MODULE_19__webapp_common_video_player__["a" /* default */].Events.USER_TRACKING_INFORMATION_READY, function (_ref14) {
                                        var _ref14$body = _ref14.body,
                                            body = _ref14$body === undefined ? {} : _ref14$body;

                                        Object(__WEBPACK_IMPORTED_MODULE_22__lib_util_localStorage__["d" /* set */])(__WEBPACK_IMPORTED_MODULE_3__constants__["r" /* USER_TRACKING_KEY */], _extends({}, body), 24 * 60 * 60);
                                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__authenticationActions__["T" /* createGetUserTrackingAction */])(body));
                                        result[userTrackingKey] = body;
                                        if (Object.keys(result).length >= requests.length) {
                                            complete();
                                        }
                                    });
                                }

                                if (requests.indexOf(sessionTokenKey) > -1) {
                                    if (!isOneIdLoggedIn) {
                                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__authenticationActions__["Q" /* createGetBAMSessionTokenAction */])());
                                        removeRequest(requests, sessionTokenKey);
                                    } else {
                                        videoPlayer.once(__WEBPACK_IMPORTED_MODULE_19__webapp_common_video_player__["a" /* default */].Events.SESSIONTOKEN_READY, function () {
                                            var _ref15 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                                                _ref15$body = _ref15.body;

                                            _ref15$body = _ref15$body === undefined ? {} : _ref15$body;
                                            var token = _ref15$body.token;

                                            dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__authenticationActions__["Q" /* createGetBAMSessionTokenAction */])(token));
                                            // NOTE: Setting the sessionToken in temporary storage for subsequent calls to have quick access
                                            // On every page transition/load a new sessionToken will always be requested and re-assigned.
                                            Object(__WEBPACK_IMPORTED_MODULE_22__lib_util_localStorage__["d" /* set */])(__WEBPACK_IMPORTED_MODULE_3__constants__["o" /* SESSION_TOKEN_KEY */], token, 3600);
                                            result[sessionTokenKey] = token;
                                            if (Object.keys(result).length >= requests.length) {
                                                complete();
                                            }
                                        });
                                    }
                                }

                                if (requests.length) {
                                    _context5.next = 19;
                                    break;
                                }

                                defaultActions();
                                _context5.next = 41;
                                break;

                            case 19:
                                _context5.prev = 19;
                                appContainerEl = document.getElementById('app');
                                containerId = containerIdArg;
                                el = document.getElementById(containerId);
                                elCnt = 0;

                                if (el) {
                                    while (el) {
                                        elCnt += 1;
                                        containerId = '' + containerIdArg + elCnt;
                                        el = document.getElementById(containerId);
                                    }
                                }
                                el = document.createElement('div');
                                el.id = containerId;
                                el.className = containerIdArg;
                                appContainerEl.appendChild(el);
                                eventRes = [userTrackingKey];

                                if (isOneIdLoggedIn) {
                                    eventRes = [geolocationKey, subscriptionsKey, sessionTokenKey, userTrackingKey];
                                }
                                config = _extends({
                                    container: '#' + containerId,
                                    customProps: {}
                                }, Object(__WEBPACK_IMPORTED_MODULE_21__lib_util_getBamAuthConfig__["a" /* default */])(oneIdToken, passOneIdToken), {
                                    requests: eventRes,
                                    transactionId: transactionId,
                                    timeout: !(requests.length === 1 && requests.indexOf(subscriptionsKey) > -1)
                                });

                                console.log('createSDKWrapperConfig', config); // eslint-disable-line no-console
                                _context5.next = 35;
                                return videoPlayer.createSDKWrapper(config);

                            case 35:
                                _context5.next = 41;
                                break;

                            case 37:
                                _context5.prev = 37;
                                _context5.t0 = _context5['catch'](19);

                                console.error(_context5.t0);
                                defaultActions();

                            case 41:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this5, [[19, 37]]);
            }));

            return function (_x10) {
                return _ref11.apply(this, arguments);
            };
        }());
    };
}

/**
 * @description  Action to trigger watch web stream picker
 * It is not being used in currently. It has been replaced with .com stream picker.
 * We should remove it after .com stream picker is stable.
 * @param {object} content
 */
function createSelectMultipleStreamsAction() {
    var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return function (dispatch) {
        if (content.streams.length) {
            dispatch(displayModalMessage(__WEBPACK_IMPORTED_MODULE_2__enums__["w" /* ModalType */].BROADCAST_PICKER, content));
        }
    };
}

function pickerStreamsSelect(pickerStreams, pickerStreamsEventId) {
    return {
        type: PICKER_STREAMS_SELECT,
        pickerStreams: pickerStreams,
        pickerStreamsEventId: pickerStreamsEventId
    };
}

function pickerStreamsUnSelect() {
    return {
        type: PICKER_STREAMS_UNSELECT
    };
}

function pickerStreamsSelectError(error) {
    return {
        type: PICKER_STREAMS_SELECT_ERROR,
        error: error
    };
}

function openPickerSuccess(payload) {
    return {
        type: OPEN_PICKER_SUCCESS,
        payload: payload
    };
}

function openPickerError(error) {
    return {
        type: OPEN_PICKER_ERROR,
        error: error
    };
}

function pickerAutoSelect(stream) {
    return {
        type: PICKER_AUTO_SELECT,
        stream: stream
    };
}
function pickerStateClear() {
    return {
        type: PICKER_STATE_CLEAR
    };
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = injectIntl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hoist_non_react_statics__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(94);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2_react_intl__["e"]; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





function injectIntl(WrappedComponent) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var OrigInjectIntl = Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */])(WrappedComponent, options);

    var InjectIntl = function (_PureComponent) {
        _inherits(InjectIntl, _PureComponent);

        function InjectIntl() {
            _classCallCheck(this, InjectIntl);

            return _possibleConstructorReturn(this, (InjectIntl.__proto__ || Object.getPrototypeOf(InjectIntl)).apply(this, arguments));
        }

        _createClass(InjectIntl, [{
            key: 'getWrappedInstance',
            value: function getWrappedInstance() {
                return this.ref.getWrappedInstance();
            }
        }, {
            key: 'render',
            value: function render() {
                var _this2 = this;

                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OrigInjectIntl, _extends({
                    ref: function ref(inst) {
                        _this2.ref = inst;
                    }
                }, this.props, {
                    messages: this.context.messages
                }));
            }
        }]);

        return InjectIntl;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

    InjectIntl.contextTypes = {
        messages: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object
    };

    return __WEBPACK_IMPORTED_MODULE_1_hoist_non_react_statics___default()(InjectIntl, WrappedComponent);
}



/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var DOMProperty = __webpack_require__(82);
var ReactDOMComponentFlags = __webpack_require__(230);

var invariant = __webpack_require__(5);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var Flags = ReactDOMComponentFlags;

var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);

/**
 * Check if a given node should be cached.
 */
function shouldPrecacheNode(node, nodeID) {
  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
}

/**
 * Drill down (through composites and empty components) until we get a host or
 * host text component.
 *
 * This is pretty polymorphic but unavoidable with the current structure we have
 * for `_renderedChildren`.
 */
function getRenderedHostOrTextFromComponent(component) {
  var rendered;
  while (rendered = component._renderedComponent) {
    component = rendered;
  }
  return component;
}

/**
 * Populate `_hostNode` on the rendered host/text component with the given
 * DOM node. The passed `inst` can be a composite.
 */
function precacheNode(inst, node) {
  var hostInst = getRenderedHostOrTextFromComponent(inst);
  hostInst._hostNode = node;
  node[internalInstanceKey] = hostInst;
}

function uncacheNode(inst) {
  var node = inst._hostNode;
  if (node) {
    delete node[internalInstanceKey];
    inst._hostNode = null;
  }
}

/**
 * Populate `_hostNode` on each child of `inst`, assuming that the children
 * match up with the DOM (element) children of `node`.
 *
 * We cache entire levels at once to avoid an n^2 problem where we access the
 * children of a node sequentially and have to walk from the start to our target
 * node every time.
 *
 * Since we update `_renderedChildren` and the actual DOM at (slightly)
 * different times, we could race here and see a newer `_renderedChildren` than
 * the DOM nodes we see. To avoid this, ReactMultiChild calls
 * `prepareToManageChildren` before we change `_renderedChildren`, at which
 * time the container's child nodes are always cached (until it unmounts).
 */
function precacheChildNodes(inst, node) {
  if (inst._flags & Flags.hasCachedChildNodes) {
    return;
  }
  var children = inst._renderedChildren;
  var childNode = node.firstChild;
  outer: for (var name in children) {
    if (!children.hasOwnProperty(name)) {
      continue;
    }
    var childInst = children[name];
    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
    if (childID === 0) {
      // We're currently unmounting this child in ReactMultiChild; skip it.
      continue;
    }
    // We assume the child nodes are in the same order as the child instances.
    for (; childNode !== null; childNode = childNode.nextSibling) {
      if (shouldPrecacheNode(childNode, childID)) {
        precacheNode(childInst, childNode);
        continue outer;
      }
    }
    // We reached the end of the DOM children without finding an ID match.
     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
  }
  inst._flags |= Flags.hasCachedChildNodes;
}

/**
 * Given a DOM node, return the closest ReactDOMComponent or
 * ReactDOMTextComponent instance ancestor.
 */
function getClosestInstanceFromNode(node) {
  if (node[internalInstanceKey]) {
    return node[internalInstanceKey];
  }

  // Walk up the tree until we find an ancestor whose instance we have cached.
  var parents = [];
  while (!node[internalInstanceKey]) {
    parents.push(node);
    if (node.parentNode) {
      node = node.parentNode;
    } else {
      // Top of the tree. This node must not be part of a React tree (or is
      // unmounted, potentially).
      return null;
    }
  }

  var closest;
  var inst;
  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
    closest = inst;
    if (parents.length) {
      precacheChildNodes(inst, node);
    }
  }

  return closest;
}

/**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */
function getInstanceFromNode(node) {
  var inst = getClosestInstanceFromNode(node);
  if (inst != null && inst._hostNode === node) {
    return inst;
  } else {
    return null;
  }
}

/**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */
function getNodeFromInstance(inst) {
  // Without this first invariant, passing a non-DOM-component triggers the next
  // invariant for a missing parent, which is super confusing.
  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  if (inst._hostNode) {
    return inst._hostNode;
  }

  // Walk up the tree until we find an ancestor whose DOM node we have cached.
  var parents = [];
  while (!inst._hostNode) {
    parents.push(inst);
    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
    inst = inst._hostParent;
  }

  // Now parents contains each ancestor that does *not* have a cached native
  // node, and `inst` is the deepest ancestor that does.
  for (; parents.length; inst = parents.pop()) {
    precacheChildNodes(inst, inst._hostNode);
  }

  return inst._hostNode;
}

var ReactDOMComponentTree = {
  getClosestInstanceFromNode: getClosestInstanceFromNode,
  getInstanceFromNode: getInstanceFromNode,
  getNodeFromInstance: getNodeFromInstance,
  precacheChildNodes: precacheChildNodes,
  precacheNode: precacheNode,
  uncacheNode: uncacheNode
};

module.exports = ReactDOMComponentTree;

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {/* harmony export (immutable) */ __webpack_exports__["G"] = createAuthenticator;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return START_ADOBEPASS_INITIALIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return COMPLETE_ADOBEPASS_INITIALIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return START_CHECK_AUTHENTICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return COMPLETE_CHECK_AUTHENTICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return START_AUTHENTICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return COMPLETE_AUTHENTICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return START_AUTHORIZATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return COMPLETE_AUTHORIZATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return REQUEST_PROVIDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return RECEIVE_PROVIDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DISPLAY_PROVIDER_DIALOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLOSE_PROVIDER_DIALOG; });
/* unused harmony export SELECT_PROVIDER */
/* unused harmony export START_LOGOUT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return COMPLETE_LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return GET_AUTHENTICATION_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return GET_METADATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return COMPLETE_PREAUTH_CHECK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return GET_LOCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADOBEPASS_ERROR_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return START_CHECK_BAM_AUTHENTICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return COMPLETE_CHECK_BAM_AUTHENTICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return GET_BAM_AUTHENTICATION_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return GET_GEOLOCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return GET_BAM_SESSION_TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return GET_USER_TRACKING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return START_CHECK_IP_AUTHENTICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return COMPLETE_CHECK_IP_AUTHENTICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return GET_IP_AUTHENTICATION_INFO; });
/* harmony export (immutable) */ __webpack_exports__["P"] = createGetBAMAuthenticationInfoAction;
/* harmony export (immutable) */ __webpack_exports__["R"] = createGetGeoLocationAction;
/* harmony export (immutable) */ __webpack_exports__["Q"] = createGetBAMSessionTokenAction;
/* harmony export (immutable) */ __webpack_exports__["T"] = createGetUserTrackingAction;
/* harmony export (immutable) */ __webpack_exports__["X"] = createStartCheckBAMAuthenticationAction;
/* harmony export (immutable) */ __webpack_exports__["J"] = createCompleteCheckBAMAuthenticationAction;
/* unused harmony export createStartCheckIpAuthenticationAction */
/* harmony export (immutable) */ __webpack_exports__["K"] = createCompleteCheckIpAuthenticationAction;
/* unused harmony export createGetIpAuthenticationInfoAction */
/* unused harmony export createGetLocationAction */
/* harmony export (immutable) */ __webpack_exports__["S"] = createGetLocationFromUserDataAction;
/* unused harmony export createReceiveProvidersAction */
/* unused harmony export createRequestProvidersAction */
/* harmony export (immutable) */ __webpack_exports__["Z"] = getProviders;
/* harmony export (immutable) */ __webpack_exports__["W"] = createSmartIpAuthenticationAction;
/* unused harmony export createStartAdobePassInitializeAction */
/* unused harmony export createCompleteAdobePassInitializeAction */
/* unused harmony export createStartCheckAuthenticationAction */
/* harmony export (immutable) */ __webpack_exports__["L"] = createCompletePreauthCheckAction;
/* unused harmony export checkPreauthResources */
/* harmony export (immutable) */ __webpack_exports__["I"] = createCompleteCheckAuthenticationAction;
/* unused harmony export createStartAuthenticationAction */
/* unused harmony export createCompleteAuthenticationAction */
/* unused harmony export createStartAuthorizationAction */
/* unused harmony export createCompleteAuthorizationAction */
/* harmony export (immutable) */ __webpack_exports__["B"] = createAdobePassErrorAction;
/* harmony export (immutable) */ __webpack_exports__["N"] = createDisplayProviderDialogAction;
/* harmony export (immutable) */ __webpack_exports__["H"] = createCloseProviderDialogAction;
/* unused harmony export createStartLogoutAction */
/* unused harmony export createCompleteLogoutAction */
/* harmony export (immutable) */ __webpack_exports__["C"] = createAndPerformLogoutAction;
/* harmony export (immutable) */ __webpack_exports__["O"] = createGetAuthenticationInfoAction;
/* unused harmony export createGetMetadataAction */
/* unused harmony export listenForAdobePassErrorEvent */
/* unused harmony export initializeAdobePassAuthenticator */
/* unused harmony export checkAdobePassAuthentication */
/* harmony export (immutable) */ __webpack_exports__["Y"] = getAdobePassAuthenticationInfo;
/* unused harmony export getAdobePassMetadata */
/* harmony export (immutable) */ __webpack_exports__["F"] = createAsyncGetMetadataAction;
/* harmony export (immutable) */ __webpack_exports__["V"] = createSmartAdobePassInitializeAction;
/* harmony export (immutable) */ __webpack_exports__["D"] = createAndPerformStartAuthenticationAction;
/* harmony export (immutable) */ __webpack_exports__["E"] = createAndPerformStartAuthorizationAction;
/* harmony export (immutable) */ __webpack_exports__["U"] = createSelectProviderAction;
/* unused harmony export createAccountSelectorAction */
/* harmony export (immutable) */ __webpack_exports__["M"] = createDTCPaywallAction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_findIndex__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__enums__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_auth_Authenticator__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_auth_PreAuthZ__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_auth_streamHasDTCPackage__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_auth_streamHasAuthType__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_auth_getContentId__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_util_perf__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_metrics_untimelyLogoutTracker__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_api__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_format_dateFormat__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib_format_getAdobePassRedirectUrl__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib_format_addQueryToUrl__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib_omniture__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lib_util_isEmpty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__lib_util_getBamAuthConfig__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__lib_oneId__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__selectors_bootstrapSelector__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__selectors_authenticationSelectors__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__selectors_oneIdSelector__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__selectors_selectedContentSelector__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selectors_appSelector__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selectors_pageSelector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__selectors_flagsSelector__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__selectors_providerSelector__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__selectors_routingSelector__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__selectors_networksSelector__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__selectors_analyticsSelectors__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_lodash_uniq__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_lodash_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_lodash_uniq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_lodash_chunk__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_lodash_chunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_lodash_chunk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__appActions__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__page_actions__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__scheduleModule_actions__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__scoringActions__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__oneIdActions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__page_AccountSelector__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__webapp_common_video_player__ = __webpack_require__(115);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }












































function createAuthenticator(type) {
    return function (dispatch, getState) {
        if (type === __WEBPACK_IMPORTED_MODULE_3__enums__["f" /* AuthenticatorType */].IP) {
            return __WEBPACK_IMPORTED_MODULE_4__lib_auth_Authenticator__["a" /* default */].ip({ partner: 'watchespn', platform: 'web' });
        }
        return __WEBPACK_IMPORTED_MODULE_4__lib_auth_Authenticator__["a" /* default */].adobe({
            displayProviderDialogImpl: function displayProviderDialogImpl() {},
            elementId: 'ae_container',
            environment: Object(__WEBPACK_IMPORTED_MODULE_23__selectors_appSelector__["b" /* adobePassEnvSelector */])(getState()),
            redirectUrl: window.location.href,
            refreshless: true
        });
    };
}

// Reduxified Adobe Pass Actions
var START_ADOBEPASS_INITIALIZE = 'START_ADOBEPASS_INITIALIZE';
var COMPLETE_ADOBEPASS_INITIALIZE = 'COMPLETE_ADOBEPASS_INITIALIZE';
var START_CHECK_AUTHENTICATION = 'START_CHECK_AUTHENTICATION';
var COMPLETE_CHECK_AUTHENTICATION = 'COMPLETE_CHECK_AUTHENTICATION';
var START_AUTHENTICATION = 'START_AUTHENTICATION';
var COMPLETE_AUTHENTICATION = 'COMPLETE_AUTHENTICATION';
var START_AUTHORIZATION = 'START_AUTHORIZATION';
var COMPLETE_AUTHORIZATION = 'COMPLETE_AUTHORIZATION';
var REQUEST_PROVIDERS = 'REQUEST_PROVIDERS';
var RECEIVE_PROVIDERS = 'RECEIVE_PROVIDERS';
var DISPLAY_PROVIDER_DIALOG = 'DISPLAY_PROVIDER_DIALOG';
var CLOSE_PROVIDER_DIALOG = 'CLOSE_PROVIDER_DIALOG';
var SELECT_PROVIDER = 'SELECT_PROVIDER';
var START_LOGOUT = 'START_LOGOUT';
var COMPLETE_LOGOUT = 'COMPLETE_LOGOUT';
var GET_AUTHENTICATION_INFO = 'GET_AUTHENTICATION_INFO';
var GET_METADATA = 'GET_METADATA';
var COMPLETE_PREAUTH_CHECK = 'COMPLETE_PREAUTH_CHECK';
var GET_LOCATION = 'GET_LOCATION';
var ADOBEPASS_ERROR_EVENT = 'ADOBEPASS_ERROR_EVENT';

// BAM
var START_CHECK_BAM_AUTHENTICATION = 'START_CHECK_BAM_AUTHENTICATION';
var COMPLETE_CHECK_BAM_AUTHENTICATION = 'COMPLETE_CHECK_BAM_AUTHENTICATION';
var GET_BAM_AUTHENTICATION_INFO = 'GET_BAM_AUTHENTICATION_INFO';
var GET_GEOLOCATION = 'GET_GEOLOCATION';
var GET_BAM_SESSION_TOKEN = 'GET_BAM_SESSION_TOKEN';
var GET_USER_TRACKING = 'GET_USER_TRACKING';

// Reduxified IP actionsexport
var START_CHECK_IP_AUTHENTICATION = 'START_CHECK_IP_AUTHENTICATION';
var COMPLETE_CHECK_IP_AUTHENTICATION = 'COMPLETE_CHECK_IP_AUTHENTICATION';
var GET_IP_AUTHENTICATION_INFO = 'GET_IP_AUTHENTICATION_INFO';

function createGetBAMAuthenticationInfoAction(subscriptions) {
    return {
        type: GET_BAM_AUTHENTICATION_INFO,
        subscriptions: subscriptions
    };
}

function createGetGeoLocationAction(geo) {
    return {
        type: GET_GEOLOCATION,
        geo: geo
    };
}

function createGetBAMSessionTokenAction(sessionToken) {
    return {
        type: GET_BAM_SESSION_TOKEN,
        session: {
            token: sessionToken,
            completeTime: Date.now()
        }
    };
}

function createGetUserTrackingAction(userTracking) {
    return {
        type: GET_USER_TRACKING,
        userTracking: userTracking
    };
}

function createStartCheckBAMAuthenticationAction() {
    return {
        type: START_CHECK_BAM_AUTHENTICATION,
        startTime: Date.now()
    };
}

function createCompleteCheckBAMAuthenticationAction() {
    return {
        type: COMPLETE_CHECK_BAM_AUTHENTICATION,
        completeTime: Date.now()
    };
}

// define ip authentication actions
function createStartCheckIpAuthenticationAction() {
    return {
        type: START_CHECK_IP_AUTHENTICATION,
        startTime: Date.now()
    };
}

function createCompleteCheckIpAuthenticationAction(isAuthenticated) {
    return {
        type: COMPLETE_CHECK_IP_AUTHENTICATION,
        directive: isAuthenticated === true ? 'add' : 'remove',
        authType: 'isp',
        startTime: Date.now()
    };
}

function createGetIpAuthenticationInfoAction(info) {
    return {
        type: GET_IP_AUTHENTICATION_INFO,
        info: info
    };
}

function createGetLocationAction(location) {
    return {
        type: GET_LOCATION,
        location: location
    };
}

function createGetLocationFromUserDataAction() {
    return function (dispatch) {
        return dispatch(createAuthenticator(__WEBPACK_IMPORTED_MODULE_3__enums__["f" /* AuthenticatorType */].IP)).getLocation().then(function (location) {
            if (location && (typeof location === 'undefined' ? 'undefined' : _typeof(location)) === 'object') {
                location.timeZone = __WEBPACK_IMPORTED_MODULE_12__lib_format_dateFormat__["a" /* default */].getTimezone();
                dispatch(createGetLocationAction(location));
            }
        });
    };
}

function createReceiveProvidersAction(providers) {
    return {
        type: RECEIVE_PROVIDERS,
        providers: providers,
        completeTime: Date.now()
    };
}

function createRequestProvidersAction() {
    return {
        type: REQUEST_PROVIDERS,
        startTime: Date.now()
    };
}

var compareByName = function compareByName(providerA, providerB) {
    return providerA.name.toLowerCase() > providerB.name.toLowerCase() ? 1 : -1;
};
function getProviders() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        country = _ref.country,
        partner = _ref.partner,
        platform = _ref.platform,
        version = _ref.version;

    return function (dispatch, getState) {
        var state = getState();
        var opts = {
            partner: partner,
            platform: platform,
            version: version,
            country: country || Object(__WEBPACK_IMPORTED_MODULE_23__selectors_appSelector__["h" /* countrySelector */])(state),
            passenv: Object(__WEBPACK_IMPORTED_MODULE_23__selectors_appSelector__["b" /* adobePassEnvSelector */])(state)
        };
        var providersFromState = Object(__WEBPACK_IMPORTED_MODULE_26__selectors_providerSelector__["c" /* providersSelector */])(state);
        var providerPromise = void 0;
        dispatch(createRequestProvidersAction());
        if (providersFromState.length > 0) {
            providerPromise = __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve(providersFromState);
        } else {
            providerPromise = __WEBPACK_IMPORTED_MODULE_11__lib_api__["b" /* ClientAPI */].getProviders(opts).then(function () {
                var providersFromApi = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                return providersFromApi.sort(compareByName);
            });
        }
        return providerPromise.then(function (providers) {
            dispatch(createReceiveProvidersAction(providers));
            return providers;
        });
    };
}

function createSmartIpAuthenticationAction() {
    var _this = this;

    return function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
            var ipAuthenticator, isAuthenticated, _ref3, _ref4, providers, ipInfo, orderedProviders, providerIndex, country, provider, providerInfo;

            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            __WEBPACK_IMPORTED_MODULE_9__lib_util_perf__["a" /* markStart */]('createSmartIpAuthenticationAction');
                            ipAuthenticator = dispatch(createAuthenticator(__WEBPACK_IMPORTED_MODULE_3__enums__["f" /* AuthenticatorType */].IP));
                            _context.next = 4;
                            return dispatch(createGetLocationFromUserDataAction());

                        case 4:
                            dispatch(createStartCheckIpAuthenticationAction());
                            _context.next = 7;
                            return ipAuthenticator.checkAuthentication();

                        case 7:
                            isAuthenticated = _context.sent;

                            __WEBPACK_IMPORTED_MODULE_9__lib_util_perf__["b" /* measureAndTime */]('createSmartIpAuthenticationAction');
                            dispatch(createCompleteCheckIpAuthenticationAction(isAuthenticated));

                            if (!(isAuthenticated === true)) {
                                _context.next = 31;
                                break;
                            }

                            _context.next = 13;
                            return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.all([dispatch(getProviders()), ipAuthenticator.getAuthenticationInfo()]);

                        case 13:
                            _ref3 = _context.sent;
                            _ref4 = _slicedToArray(_ref3, 2);
                            providers = _ref4[0];
                            ipInfo = _ref4[1];
                            orderedProviders = providers;
                            providerIndex = __WEBPACK_IMPORTED_MODULE_1_lodash_findIndex___default()(providers, function (provider) {
                                return provider.ispId === ipInfo.mvpd;
                            });

                            // if the provider is not found in the provider list, check the legacy "watchespn-flash" client,
                            // which contains ISP only affs that "watchespn-web" does not

                            if (!(providerIndex === -1)) {
                                _context.next = 26;
                                break;
                            }

                            country = Object(__WEBPACK_IMPORTED_MODULE_23__selectors_appSelector__["h" /* countrySelector */])(getState());
                            _context.next = 23;
                            return __WEBPACK_IMPORTED_MODULE_11__lib_api__["b" /* ClientAPI */].getProvider({ abbreviation: ipInfo.mvpd, country: country });

                        case 23:
                            provider = _context.sent;

                            if (provider) {
                                orderedProviders.unshift(provider);
                                dispatch(createReceiveProvidersAction(orderedProviders));
                                dispatch(createGetIpAuthenticationInfoAction(provider));
                            }
                            return _context.abrupt('return', provider);

                        case 26:
                            providerInfo = providers[providerIndex];

                            if (providerIndex > 0) {
                                providers.splice(providerIndex, 1); // Removes currIndex from providers array
                                orderedProviders = [providerInfo].concat(_toConsumableArray(providers));
                            }
                            dispatch(createReceiveProvidersAction(orderedProviders));
                            dispatch(createGetIpAuthenticationInfoAction(providerInfo));
                            return _context.abrupt('return', providerInfo);

                        case 31:
                            return _context.abrupt('return', null);

                        case 32:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function (_x3, _x4) {
            return _ref2.apply(this, arguments);
        };
    }();
}

// Define Adobe Pass Authentication Actions
function createStartAdobePassInitializeAction() {
    return {
        type: START_ADOBEPASS_INITIALIZE,
        startTime: Date.now()
    };
}

function createCompleteAdobePassInitializeAction() {
    return {
        type: COMPLETE_ADOBEPASS_INITIALIZE,
        completeTime: Date.now()
    };
}

// Define Adobe Pass Check Authentication Actions
function createStartCheckAuthenticationAction() {
    return {
        type: START_CHECK_AUTHENTICATION,
        startTime: Date.now()
    };
}

function createCompletePreauthCheckAction() {
    var resources = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    return {
        type: COMPLETE_PREAUTH_CHECK,
        resources: resources
    };
}

function checkPreauthResources() {
    var _this2 = this;

    var resources = __WEBPACK_IMPORTED_MODULE_5__lib_auth_PreAuthZ__["a" /* default */].getResources();
    return function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
            var state, isIntl, _bootstrapSelector, _bootstrapSelector$ad, preauthorizeNetworksEnabled, _bootstrapSelector$ad2, preauthorizeNetworks, allAdobeIds, adobeAuthenticator, networks, chunkedAdobeIds, index, preAuthResources, channels, _chunkedAdobeIds, _index, _preAuthResources;

            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            state = getState();
                            isIntl = Object(__WEBPACK_IMPORTED_MODULE_23__selectors_appSelector__["u" /* isIntlSelector */])(state);
                            _bootstrapSelector = Object(__WEBPACK_IMPORTED_MODULE_19__selectors_bootstrapSelector__["a" /* default */])(state), _bootstrapSelector$ad = _bootstrapSelector.adobePass;
                            _bootstrapSelector$ad = _bootstrapSelector$ad === undefined ? {} : _bootstrapSelector$ad;
                            preauthorizeNetworksEnabled = _bootstrapSelector$ad.preauthorizeNetworksEnabled, _bootstrapSelector$ad2 = _bootstrapSelector$ad.preauthorizeNetworks, preauthorizeNetworks = _bootstrapSelector$ad2 === undefined ? [] : _bootstrapSelector$ad2;

                            if (!isIntl && !preauthorizeNetworksEnabled) {
                                // if preauth disabled for domestic, use static list of resources
                                resources = preauthorizeNetworks;
                            }

                            if (resources) {
                                _context2.next = 41;
                                break;
                            }

                            allAdobeIds = void 0;
                            adobeAuthenticator = dispatch(createAuthenticator(__WEBPACK_IMPORTED_MODULE_3__enums__["f" /* AuthenticatorType */].ADOBE));

                            if (!isIntl) {
                                _context2.next = 26;
                                break;
                            }

                            networks = Object(__WEBPACK_IMPORTED_MODULE_28__selectors_networksSelector__["a" /* default */])(state) || [];

                            allAdobeIds = __WEBPACK_IMPORTED_MODULE_30_lodash_uniq___default()(networks.filter(function (_ref6) {
                                var isActive = _ref6.isActive,
                                    adobeResource = _ref6.adobeResource;
                                return isActive && adobeResource;
                            }).map(function (_ref7) {
                                var adobeResource = _ref7.adobeResource;
                                return adobeResource;
                            }));
                            chunkedAdobeIds = __WEBPACK_IMPORTED_MODULE_31_lodash_chunk___default()(allAdobeIds, __WEBPACK_IMPORTED_MODULE_5__lib_auth_PreAuthZ__["a" /* default */].PREAUTH_MAX_LENGTH);
                            // FIXME: it started to return the same preauthorized resources in the subsequent chunked requests..
                            // https://tve.zendesk.com/hc/requests/34976
                            /**
                             * There cannot be multiple "adobeAuthenticator.checkPreauthorizedResources" in flight since
                             * there is only one global function to handle the preauthz callback in `watch-authenticators-js`.
                             * For this reason, we await in a conventional for loop until each "checkPreauthorizedResources" completes
                             */

                            index = 0;
                            index;

                        case 15:
                            if (!(index < chunkedAdobeIds.length)) {
                                _context2.next = 23;
                                break;
                            }

                            _context2.next = 18;
                            return adobeAuthenticator.checkPreauthorizedResources.apply(adobeAuthenticator, _toConsumableArray(chunkedAdobeIds[index]));

                        case 18:
                            preAuthResources = _context2.sent;

                            if (preAuthResources.length > 0) {
                                resources = (resources || []).concat(preAuthResources);
                            }

                        case 20:
                            index += 1;
                            _context2.next = 15;
                            break;

                        case 23:
                            resources = __WEBPACK_IMPORTED_MODULE_30_lodash_uniq___default()(resources);
                            _context2.next = 41;
                            break;

                        case 26:
                            channels = getState().schedule.channels || [];

                            allAdobeIds = __WEBPACK_IMPORTED_MODULE_30_lodash_uniq___default()(channels.map(function (channel) {
                                return channel.adobeResource;
                            }).filter(function (adobeResource) {
                                return !!adobeResource;
                            }));
                            _chunkedAdobeIds = __WEBPACK_IMPORTED_MODULE_31_lodash_chunk___default()(allAdobeIds, __WEBPACK_IMPORTED_MODULE_5__lib_auth_PreAuthZ__["a" /* default */].PREAUTH_MAX_LENGTH);
                            // FIXME: it started to return the same preauthorized resources in the subsequent chunked requests..
                            // https://tve.zendesk.com/hc/requests/34976
                            /**
                             * There cannot be multiple "adobeAuthenticator.checkPreauthorizedResources" in flight since
                             * there is only one global function to handle the preauthz callback in `watch-authenticators-js`.
                             * For this reason, we await in a conventional for loop until each "checkPreauthorizedResources" completes
                             */

                            _index = 0;
                            _index;

                        case 31:
                            if (!(_index < _chunkedAdobeIds.length)) {
                                _context2.next = 39;
                                break;
                            }

                            _context2.next = 34;
                            return adobeAuthenticator.checkPreauthorizedResources.apply(adobeAuthenticator, _toConsumableArray(_chunkedAdobeIds[_index]));

                        case 34:
                            _preAuthResources = _context2.sent;

                            if (_preAuthResources.length > 0) {
                                resources = (resources || []).concat(_preAuthResources);
                            }

                        case 36:
                            _index += 1;
                            _context2.next = 31;
                            break;

                        case 39:
                            resources = __WEBPACK_IMPORTED_MODULE_30_lodash_uniq___default()(resources);
                            if (resources && resources.length) {
                                // in case preauthz fails and return invalid data
                                __WEBPACK_IMPORTED_MODULE_5__lib_auth_PreAuthZ__["a" /* default */].setResources(resources, 1); // set expiration to 1 day
                                if (window.espn_ui && window.espn_ui.Helpers && window.espn_ui.Helpers.watchProviders && window.espn_ui.Helpers.watchProviders.setTVECookies) {
                                    window.espn_ui.Helpers.watchProviders.setTVECookies(resources);
                                }
                            }

                        case 41:

                            dispatch(createCompletePreauthCheckAction(resources));
                            return _context2.abrupt('return', resources);

                        case 43:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }));

        return function (_x6, _x7) {
            return _ref5.apply(this, arguments);
        };
    }();
}

function createCompleteCheckAuthenticationAction(isAuthenticated) {
    return {
        type: COMPLETE_CHECK_AUTHENTICATION,
        directive: isAuthenticated === true ? 'add' : 'remove',
        isAuthenticated: isAuthenticated,
        authType: __WEBPACK_IMPORTED_MODULE_3__enums__["e" /* AuthTypes */].MVPD,
        completeTime: Date.now()
    };
}

function createStartAuthenticationAction(content) {
    return {
        type: START_AUTHENTICATION,
        content: content,
        startTime: Date.now()
    };
}

function createCompleteAuthenticationAction(isAuthenticated, mvpd) {
    return {
        type: COMPLETE_AUTHENTICATION,
        directive: isAuthenticated === true ? 'add' : 'remove',
        isAuthenticated: isAuthenticated,
        authType: __WEBPACK_IMPORTED_MODULE_3__enums__["e" /* AuthTypes */].MVPD,
        mvpd: mvpd,
        completeTime: Date.now()
    };
}

function createStartAuthorizationAction(resourceId) {
    return {
        type: START_AUTHORIZATION,
        resourceId: resourceId,
        startTime: Date.now()
    };
}

function createCompleteAuthorizationAction(resourceId, token) {
    return {
        type: COMPLETE_AUTHORIZATION,
        resourceId: resourceId,
        token: token,
        completeTime: Date.now()
    };
}

function createAdobePassErrorAction(error) {
    return {
        type: ADOBEPASS_ERROR_EVENT,
        error: error
    };
}

// Provider Display and Select Action creators.
// The Display Provider Dialog action, which is triggered by startAuthentication
function createDisplayProviderDialogAction() {
    return function (dispatch, getState) {
        var state = getState();
        Object(__WEBPACK_IMPORTED_MODULE_15__lib_omniture__["n" /* trackMvpdPicker */])({ isDomestic: Object(__WEBPACK_IMPORTED_MODULE_23__selectors_appSelector__["s" /* isDomesticSelector */])(state) });
        dispatch({
            type: DISPLAY_PROVIDER_DIALOG,
            showProviderDialog: true
        });
    };
}

function createCloseProviderDialogAction() {
    var resume = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    return function (dispatch, getState) {
        dispatch({
            type: CLOSE_PROVIDER_DIALOG,
            showProviderDialog: false
        });
        if (resume) {
            var _appSelector = Object(__WEBPACK_IMPORTED_MODULE_23__selectors_appSelector__["j" /* default */])(getState()),
                previousContent = _appSelector.previousContent,
                playingStream = _appSelector.playingStream;

            if (!Object(__WEBPACK_IMPORTED_MODULE_16__lib_util_isEmpty__["a" /* default */])(playingStream)) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_32__appActions__["A" /* contentUnSelect */])());
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_32__appActions__["z" /* contentSelect */])(previousContent));
            }
        }
    };
}

function createStartLogoutAction() {
    return {
        type: START_LOGOUT,
        startTime: Date.now()
    };
}

function createCompleteLogoutAction() {
    __WEBPACK_IMPORTED_MODULE_5__lib_auth_PreAuthZ__["a" /* default */].clear();

    return {
        type: COMPLETE_LOGOUT,
        directive: 'remove',
        isAuthenticated: false,
        authType: __WEBPACK_IMPORTED_MODULE_3__enums__["e" /* AuthTypes */].MVPD,
        completeTime: Date.now()
    };
}

function createAndPerformLogoutAction(stream) {
    return function (dispatch, getState) {
        dispatch(createStartLogoutAction());
        __WEBPACK_IMPORTED_MODULE_5__lib_auth_PreAuthZ__["a" /* default */].clear();
        if (window.espn_ui && window.espn_ui.Helpers && window.espn_ui.Helpers.watchProviders && window.espn_ui.Helpers.watchProviders.setTVECookies) {
            window.espn_ui.Helpers.watchProviders.removeTVECookies();
        }
        return dispatch(createAuthenticator(__WEBPACK_IMPORTED_MODULE_3__enums__["f" /* AuthenticatorType */].ADOBE)).deauthenticate().then(function (isAuthenticated) {
            // purposefully logged out, forget their authn ttl so we don't track a discrepancy
            __WEBPACK_IMPORTED_MODULE_10__lib_metrics_untimelyLogoutTracker__["b" /* reset */]();
            if (isAuthenticated === false) {
                dispatch(createCompleteLogoutAction());
                if (stream && stream.authTypes) {
                    var content = Object(__WEBPACK_IMPORTED_MODULE_22__selectors_selectedContentSelector__["a" /* default */])(getState());
                    content.reEmbed = true;
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_32__appActions__["P" /* streamUnSelect */])());
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_32__appActions__["O" /* streamSelect */])(stream));
                }
            }
            return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve();
        });
    };
}

function createGetAuthenticationInfoAction(info) {
    return function (dispatch, getState) {
        var state = getState();
        var userAuth = Object(__WEBPACK_IMPORTED_MODULE_20__selectors_authenticationSelectors__["r" /* userAuthSelector */])(state);
        var isDomestic = Object(__WEBPACK_IMPORTED_MODULE_23__selectors_appSelector__["s" /* isDomesticSelector */])(state);
        var entitlementsTracking = Object(__WEBPACK_IMPORTED_MODULE_29__selectors_analyticsSelectors__["c" /* entitlementsTrackingSelector */])(state);
        Object(__WEBPACK_IMPORTED_MODULE_15__lib_omniture__["j" /* trackAuthenticationComplete */])({ userAuth: userAuth, provider: info, entitlementsTracking: entitlementsTracking, isDomestic: isDomestic });
        dispatch({
            type: GET_AUTHENTICATION_INFO,
            info: info
        });
    };
}

function createGetMetadataAction(key, value) {
    return {
        type: GET_METADATA,
        key: key,
        value: value
    };
}

function listenForAdobePassErrorEvent() {
    return function (dispatch) {
        return dispatch(createAuthenticator(__WEBPACK_IMPORTED_MODULE_3__enums__["f" /* AuthenticatorType */].ADOBE)).onErrorEvent(function (errorData) {
            dispatch(createAdobePassErrorAction(errorData));
        });
    };
}

function initializeAdobePassAuthenticator() {
    return function (dispatch) {
        dispatch(createStartAdobePassInitializeAction());
        dispatch(listenForAdobePassErrorEvent());
        return dispatch(createAuthenticator(__WEBPACK_IMPORTED_MODULE_3__enums__["f" /* AuthenticatorType */].ADOBE)).initialize().then(function (initialized) {
            if (initialized) {
                dispatch(createCompleteAdobePassInitializeAction());
            }
            return initialized;
        });
    };
}

function checkAdobePassAuthentication() {
    return function (dispatch, getState) {
        var adobePassInitialized = Object(__WEBPACK_IMPORTED_MODULE_20__selectors_authenticationSelectors__["c" /* adobePassInitializedSelector */])(getState());
        if (!adobePassInitialized) {
            return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve(false);
        }
        dispatch(createStartCheckAuthenticationAction());
        return dispatch(createAuthenticator(__WEBPACK_IMPORTED_MODULE_3__enums__["f" /* AuthenticatorType */].ADOBE)).checkAuthentication().then(function (isAuthenticated) {
            dispatch(createCompleteCheckAuthenticationAction(isAuthenticated));
            return isAuthenticated;
        });
    };
}

function getAdobePassAuthenticationInfo() {
    return function (dispatch) {
        return dispatch(createAuthenticator(__WEBPACK_IMPORTED_MODULE_3__enums__["f" /* AuthenticatorType */].ADOBE)).getAuthenticationInfo();
    };
}

function getAdobePassMetadata(key) {
    return function (dispatch) {
        return dispatch(createAuthenticator(__WEBPACK_IMPORTED_MODULE_3__enums__["f" /* AuthenticatorType */].ADOBE)).getMetadata(key);
    };
}

function createAsyncGetMetadataAction(key) {
    return function (dispatch) {
        return dispatch(getAdobePassMetadata(key)).then(function () {
            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '' + Math.random();

            dispatch(createGetMetadataAction(key, value));
            return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve(value);
        }, function (error) {
            return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.reject(error);
        });
    };
}

// Initializes Adobe, checks authentication, then gets provider list if not authenticated.
// Called on page load
function createSmartAdobePassInitializeAction(routerParams) {
    var _this3 = this;

    return function () {
        var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch, getState) {
            var isIntl, preAuthResources, state, isAuthenticated, info, providersFromApi, providerInfo, _appSelector2, lang, _routingSelector, locationBeforeTransitions, _pageSelector, pageId, _ref10, _ref10$query, query, packageId, packageTier, pkg, packageFilter;

            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            __WEBPACK_IMPORTED_MODULE_9__lib_util_perf__["a" /* markStart */]('createSmartAdobePassInitializeAction');
                            isIntl = Object(__WEBPACK_IMPORTED_MODULE_23__selectors_appSelector__["u" /* isIntlSelector */])(getState());

                            if (!isIntl) {
                                // check and store preauthz resource before awaiting async functions
                                preAuthResources = __WEBPACK_IMPORTED_MODULE_5__lib_auth_PreAuthZ__["a" /* default */].getResources();

                                if (preAuthResources) {
                                    dispatch(createCompletePreauthCheckAction(preAuthResources));
                                }
                            }
                            _context3.next = 5;
                            return dispatch(initializeAdobePassAuthenticator());

                        case 5:
                            _context3.next = 7;
                            return dispatch(checkAdobePassAuthentication());

                        case 7:
                            _context3.next = 9;
                            return dispatch(getProviders());

                        case 9:
                            // make sure to grab from `getState()` not from cached one
                            state = getState();
                            isAuthenticated = Object(__WEBPACK_IMPORTED_MODULE_20__selectors_authenticationSelectors__["a" /* adobePassAuthenticatedSelector */])(state);

                            if (!isAuthenticated) {
                                _context3.next = 53;
                                break;
                            }

                            _context3.next = 14;
                            return dispatch(getAdobePassAuthenticationInfo());

                        case 14:
                            info = _context3.sent;
                            _context3.next = 17;
                            return dispatch(createAsyncGetMetadataAction(__WEBPACK_IMPORTED_MODULE_3__enums__["a" /* AdobePass */].METADATA.UPSTREAM_USERID));

                        case 17:
                            providersFromApi = state.providerDialog.providers;
                            providerInfo = providersFromApi.filter(function (_ref9) {
                                var abbreviation = _ref9.abbreviation;
                                return abbreviation === info.mvpd;
                            }).shift();
                            // this means you are authenticated for mvpd in a different country
                            // if we swallow it, provider dialog won't show up for the current country and users get stuck,
                            // so logging out from the current invalid mvpd

                            if (providerInfo) {
                                _context3.next = 22;
                                break;
                            }

                            _context3.next = 22;
                            return dispatch(createAndPerformLogoutAction());

                        case 22:
                            _appSelector2 = Object(__WEBPACK_IMPORTED_MODULE_23__selectors_appSelector__["j" /* default */])(state), lang = _appSelector2.lang;
                            _routingSelector = Object(__WEBPACK_IMPORTED_MODULE_27__selectors_routingSelector__["a" /* default */])(state), locationBeforeTransitions = _routingSelector.locationBeforeTransitions;
                            _pageSelector = Object(__WEBPACK_IMPORTED_MODULE_24__selectors_pageSelector__["c" /* default */])(state), pageId = _pageSelector.id;
                            _ref10 = locationBeforeTransitions || {}, _ref10$query = _ref10.query, query = _ref10$query === undefined ? {} : _ref10$query;

                            if (!isIntl) {
                                _context3.next = 50;
                                break;
                            }

                            _context3.next = 29;
                            return dispatch(getAdobePassMetadata(__WEBPACK_IMPORTED_MODULE_3__enums__["a" /* AdobePass */].METADATA.PACKAGE_ID));

                        case 29:
                            packageId = _context3.sent;
                            _context3.next = 32;
                            return dispatch(getAdobePassMetadata(__WEBPACK_IMPORTED_MODULE_3__enums__["a" /* AdobePass */].METADATA.PACKAGE_TIER));

                        case 32:
                            packageTier = _context3.sent;

                            // consumerKey from the affiliateApi is the package ID.
                            pkg = providerInfo.packages.filter(function (item) {
                                return item.consumerKey === packageId;
                            }).shift();

                            if (!packageTier && pkg) {
                                // packageId from the affiliateApi contains package tier info.
                                packageTier = pkg.packageId;
                            }
                            dispatch(createGetMetadataAction(__WEBPACK_IMPORTED_MODULE_3__enums__["a" /* AdobePass */].METADATA.PACKAGE_ID, packageId));
                            dispatch(createGetMetadataAction(__WEBPACK_IMPORTED_MODULE_3__enums__["a" /* AdobePass */].METADATA.PACKAGE_TIER, packageTier));
                            dispatch(createGetAuthenticationInfoAction(_extends({}, providerInfo, { package: pkg })));
                            dispatch(Object(__WEBPACK_IMPORTED_MODULE_32__appActions__["L" /* savePackageId */])(packageId));
                            dispatch(Object(__WEBPACK_IMPORTED_MODULE_32__appActions__["M" /* savePackageTier */])(packageTier));

                            packageFilter = Object(__WEBPACK_IMPORTED_MODULE_23__selectors_appSelector__["z" /* packageFilterSelector */])(getState());

                            if (!(packageFilter && pageId !== 'syndicated-player')) {
                                _context3.next = 47;
                                break;
                            }

                            _context3.next = 44;
                            return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.all([dispatch(Object(__WEBPACK_IMPORTED_MODULE_33__page_actions__["o" /* createFetchPageAction */])(pageId, routerParams, query, lang)), dispatch(Object(__WEBPACK_IMPORTED_MODULE_34__scheduleModule_actions__["d" /* fetchScheduleModule */])(lang))]);

                        case 44:
                            dispatch(Object(__WEBPACK_IMPORTED_MODULE_35__scoringActions__["a" /* scoreAll */])());
                            _context3.next = 48;
                            break;

                        case 47:
                            dispatch(Object(__WEBPACK_IMPORTED_MODULE_33__page_actions__["z" /* setPageState */])(true));

                        case 48:
                            _context3.next = 51;
                            break;

                        case 50:
                            dispatch(createGetAuthenticationInfoAction(providerInfo));

                        case 51:

                            // save the authn ttl to local storage so we can track a discrepancy later
                            if (!__WEBPACK_IMPORTED_MODULE_10__lib_metrics_untimelyLogoutTracker__["a" /* isAuthNTtlSaved */]() && providerInfo) {
                                __WEBPACK_IMPORTED_MODULE_10__lib_metrics_untimelyLogoutTracker__["d" /* saveInitialAuthNData */](providerInfo);
                                dispatch(getAdobePassMetadata(__WEBPACK_IMPORTED_MODULE_3__enums__["a" /* AdobePass */].METADATA.TTL_AUTHN)).then(function (ttl) {
                                    __WEBPACK_IMPORTED_MODULE_10__lib_metrics_untimelyLogoutTracker__["c" /* saveAuthNTtl */](ttl);
                                });
                            }

                            if (isIntl) {
                                // TODO: add `fetchNetwork` back in PageShell.js and enable this once we are comfortable
                                /* const { location: { path = '' } } = appSelector(getState());
                                // only check preAuth for schedule page
                                if (path.indexOf('schedule') !== -1 && providerInfo) {
                                    dispatch(checkPreauthResources());
                                } */
                            } else {
                                // not awaiting on purpose based on the requirement, it's ok to reflect the `preAuthResources` next time
                                dispatch(checkPreauthResources());
                            }

                        case 53:
                            if (isIntl) {
                                dispatch(Object(__WEBPACK_IMPORTED_MODULE_33__page_actions__["z" /* setPageState */])(true));
                            }
                            __WEBPACK_IMPORTED_MODULE_10__lib_metrics_untimelyLogoutTracker__["e" /* trackUntimelyLogout */](Object(__WEBPACK_IMPORTED_MODULE_29__selectors_analyticsSelectors__["c" /* entitlementsTrackingSelector */])(getState()));
                            __WEBPACK_IMPORTED_MODULE_9__lib_util_perf__["b" /* measureAndTime */]('createSmartAdobePassInitializeAction');
                            return _context3.abrupt('return', null);

                        case 57:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }));

        return function (_x10, _x11) {
            return _ref8.apply(this, arguments);
        };
    }();
}

function createAndPerformStartAuthenticationAction() {
    var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        content = _ref11.content,
        stream = _ref11.stream,
        redirectUrlArg = _ref11.redirectUrl;

    return function (dispatch, getState) {
        var flags = Object(__WEBPACK_IMPORTED_MODULE_25__selectors_flagsSelector__["a" /* persistentFlagsSelector */])(getState());

        var _routingSelector2 = Object(__WEBPACK_IMPORTED_MODULE_27__selectors_routingSelector__["a" /* default */])(getState()),
            locationBeforeTransitions = _routingSelector2.locationBeforeTransitions;

        var _ref12 = locationBeforeTransitions || {},
            _ref12$query = _ref12.query,
            query = _ref12$query === undefined ? {} : _ref12$query,
            _ref12$pathname = _ref12.pathname,
            pathname = _ref12$pathname === undefined ? '' : _ref12$pathname;

        var redirectUrl = redirectUrlArg || Object(__WEBPACK_IMPORTED_MODULE_13__lib_format_getAdobePassRedirectUrl__["a" /* default */])({ content: content, stream: stream, flags: flags, query: query, pathname: pathname });
        dispatch(createStartAuthenticationAction(content));
        return dispatch(createAuthenticator(__WEBPACK_IMPORTED_MODULE_3__enums__["f" /* AuthenticatorType */].ADOBE)).authenticate(null, null, redirectUrl || '').then(function (isAuthenticated) {
            dispatch(createCompleteAuthenticationAction(isAuthenticated));
            return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve(isAuthenticated);
        });
    };
}

function createAndPerformStartAuthorizationAction(resource) {
    return function (dispatch, getState) {
        dispatch(createStartAuthorizationAction(resource));
        var state = getState();
        Object(__WEBPACK_IMPORTED_MODULE_15__lib_omniture__["l" /* trackAuthorizationStart */])({
            userAuth: Object(__WEBPACK_IMPORTED_MODULE_20__selectors_authenticationSelectors__["r" /* userAuthSelector */])(state),
            provider: Object(__WEBPACK_IMPORTED_MODULE_26__selectors_providerSelector__["a" /* default */])(state),
            entitlementsTracking: Object(__WEBPACK_IMPORTED_MODULE_29__selectors_analyticsSelectors__["c" /* entitlementsTrackingSelector */])(state),
            isDomestic: Object(__WEBPACK_IMPORTED_MODULE_23__selectors_appSelector__["s" /* isDomesticSelector */])(state)
        });

        return dispatch(createAuthenticator(__WEBPACK_IMPORTED_MODULE_3__enums__["f" /* AuthenticatorType */].ADOBE)).authorize(resource).then(function (response) {
            dispatch(createCompleteAuthorizationAction(response.resourceId, response.token));
            Object(__WEBPACK_IMPORTED_MODULE_15__lib_omniture__["k" /* trackAuthorizationComplete */])({
                userAuth: Object(__WEBPACK_IMPORTED_MODULE_20__selectors_authenticationSelectors__["r" /* userAuthSelector */])(state),
                provider: Object(__WEBPACK_IMPORTED_MODULE_26__selectors_providerSelector__["a" /* default */])(state),
                entitlementsTracking: Object(__WEBPACK_IMPORTED_MODULE_29__selectors_analyticsSelectors__["c" /* entitlementsTrackingSelector */])(state),
                isDomestic: Object(__WEBPACK_IMPORTED_MODULE_23__selectors_appSelector__["s" /* isDomesticSelector */])(state)
            });
            if (!response.errorCode && !response.errorDetails) {
                return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve({
                    resourceId: response.resourceId,
                    token: response.token
                });
            }
            return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.reject(new Error(response.errorDetails || response.errorCode));
        }).catch(function (error) {
            dispatch(createCompleteAuthorizationAction());
            return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.reject(error);
        });
    };
}

function createSelectProviderAction(provider) {
    return function (dispatch, getState) {
        var adobeProvider = {
            ID: provider && provider.ID || provider.abbreviation
        };

        if (adobeProvider.ID) {
            var state = getState();
            var isDomestic = Object(__WEBPACK_IMPORTED_MODULE_23__selectors_appSelector__["s" /* isDomesticSelector */])(state);
            Object(__WEBPACK_IMPORTED_MODULE_15__lib_omniture__["p" /* trackProviderSelect */])({
                userAuth: Object(__WEBPACK_IMPORTED_MODULE_20__selectors_authenticationSelectors__["r" /* userAuthSelector */])(state),
                entitlementsTracking: Object(__WEBPACK_IMPORTED_MODULE_29__selectors_analyticsSelectors__["c" /* entitlementsTrackingSelector */])(state),
                provider: provider,
                isDomestic: isDomestic
            });
        } else {
            Object(__WEBPACK_IMPORTED_MODULE_15__lib_omniture__["b" /* clearTrackingData */])();
        }
        dispatch(createAuthenticator(__WEBPACK_IMPORTED_MODULE_3__enums__["f" /* AuthenticatorType */].ADOBE)).selectProvider(adobeProvider).then(function (isAuthenticated) {
            // this probably won't ever get called
            dispatch(createCompleteAuthenticationAction(isAuthenticated, adobeProvider.ID));
        });
    };
}

function createAccountSelectorAction(content, redirectUrlArg) {
    return function (dispatch, getState) {
        var state = getState();
        var flags = Object(__WEBPACK_IMPORTED_MODULE_25__selectors_flagsSelector__["a" /* persistentFlagsSelector */])(state);

        var _routingSelector3 = Object(__WEBPACK_IMPORTED_MODULE_27__selectors_routingSelector__["a" /* default */])(state),
            locationBeforeTransitions = _routingSelector3.locationBeforeTransitions;

        var _ref13 = locationBeforeTransitions || {},
            _ref13$query = _ref13.query,
            query = _ref13$query === undefined ? {} : _ref13$query;

        var redirectUrl = redirectUrlArg || Object(__WEBPACK_IMPORTED_MODULE_13__lib_format_getAdobePassRedirectUrl__["a" /* default */])({ content: content, flags: flags, query: query });
        var mode = __WEBPACK_IMPORTED_MODULE_37__page_AccountSelector__["a" /* AccountSelectorComponent */].MODE.ACCOUNT_SELECTOR;
        var oneIdParam = query[__WEBPACK_IMPORTED_MODULE_3__enums__["t" /* Flags */].ONEID_ENV] ? __WEBPACK_IMPORTED_MODULE_3__enums__["t" /* Flags */].ONEID_ENV + '=' + query[__WEBPACK_IMPORTED_MODULE_3__enums__["t" /* Flags */].ONEID_ENV] + '&' : '';
        var url = '/watch/account-selector?' + oneIdParam + 'mode=' + mode + '&redirectUrl=' + encodeURIComponent(redirectUrl);
        window.location.href = url;
    };
}

function createDTCPaywallAction(_ref14) {
    var _this4 = this;

    var content = _ref14.content,
        stream = _ref14.stream,
        containerId = _ref14.containerId;

    return function () {
        var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dispatch, getState) {
            var state, _bootstrapSelector2, _bootstrapSelector2$b, bam, passOneIdToken, _routingSelector4, locationBeforeTransitions, _ref16, query, pathname, flags, oneIdToken, analytics, userAuth, redirectUrl, isPromo, navmethod, hasMLB, isVertical, isMatchup, matchup, matchupParam, oneIdParam, idParam, redirectParam, url, _oneIdParam, _idParam, _redirectParam, _url, promoEl, videoPlayer, contentId, eventIdOrId, paywallConfig, idKey, isContentInStream, firstStream, streamObject, _firstStream;

            return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            state = getState();
                            _bootstrapSelector2 = Object(__WEBPACK_IMPORTED_MODULE_19__selectors_bootstrapSelector__["a" /* default */])(state), _bootstrapSelector2$b = _bootstrapSelector2.bam, bam = _bootstrapSelector2$b === undefined ? {} : _bootstrapSelector2$b;
                            passOneIdToken = Object(__WEBPACK_IMPORTED_MODULE_20__selectors_authenticationSelectors__["n" /* passOneIdTokenSelector */])(state);
                            _routingSelector4 = Object(__WEBPACK_IMPORTED_MODULE_27__selectors_routingSelector__["a" /* default */])(state), locationBeforeTransitions = _routingSelector4.locationBeforeTransitions;
                            _ref16 = locationBeforeTransitions || {}, query = _ref16.query, pathname = _ref16.pathname;
                            flags = Object(__WEBPACK_IMPORTED_MODULE_25__selectors_flagsSelector__["a" /* persistentFlagsSelector */])(state);
                            oneIdToken = Object(__WEBPACK_IMPORTED_MODULE_21__selectors_oneIdSelector__["g" /* oneIdTokenSelector */])(state);
                            analytics = Object(__WEBPACK_IMPORTED_MODULE_21__selectors_oneIdSelector__["b" /* oneIdAnalyticsSelector */])(state) || {};
                            userAuth = Object(__WEBPACK_IMPORTED_MODULE_20__selectors_authenticationSelectors__["r" /* userAuthSelector */])(state);
                            redirectUrl = Object(__WEBPACK_IMPORTED_MODULE_13__lib_format_getAdobePassRedirectUrl__["a" /* default */])({ content: content, stream: stream, flags: flags, query: query, pathname: pathname });
                            isPromo = containerId === __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* BAM_PROMO_IFRAME_ID */];
                            navmethod = Object(__WEBPACK_IMPORTED_MODULE_29__selectors_analyticsSelectors__["d" /* navmethodSelector */])(state);

                            if (!(query[__WEBPACK_IMPORTED_MODULE_3__enums__["t" /* Flags */].PAYWALL] === 'false')) {
                                _context4.next = 19;
                                break;
                            }

                            if (!(!isPromo && !stream)) {
                                _context4.next = 16;
                                break;
                            }

                            console.error('Empty stream selected');
                            return _context4.abrupt('return');

                        case 16:
                            if (!isPromo) {
                                hasMLB = Object(__WEBPACK_IMPORTED_MODULE_6__lib_auth_streamHasDTCPackage__["a" /* default */])(stream, __WEBPACK_IMPORTED_MODULE_3__enums__["s" /* Entitlements */].ESPN_PLUS_MLB);
                                // TODO: DTC - find out how to detect `vertical` w/o checking particular package

                                isVertical = hasMLB || Object(__WEBPACK_IMPORTED_MODULE_6__lib_auth_streamHasDTCPackage__["a" /* default */])(stream, __WEBPACK_IMPORTED_MODULE_3__enums__["s" /* Entitlements */].ESPN_PLUS_NHL);
                                isMatchup = !!content.event; // TODO: DTC - confirm this check is correct

                                matchup = void 0;

                                if (!isVertical && isMatchup) {
                                    matchup = true;
                                }
                                matchupParam = matchup ? 'matchup=' + matchup + '&' : '';
                                // const oneIdParam = query[Flags.ONEID_ENV] ? `${Flags.ONEID_ENV}=${query[Flags.ONEID_ENV]}&` : '';

                                oneIdParam = query[__WEBPACK_IMPORTED_MODULE_3__enums__["t" /* Flags */].DISNEY_ENV] === 'stg' ? __WEBPACK_IMPORTED_MODULE_3__enums__["t" /* Flags */].ONEID_ENV + '=staging&' : '';
                                idParam = 'id=' + stream.id;
                                redirectParam = 'redirectUrl=' + encodeURIComponent(redirectUrl);
                                url = '/watch/account-selector?' + oneIdParam + matchupParam + idParam + '&' + redirectParam;

                                dispatch(Object(__WEBPACK_IMPORTED_MODULE_32__appActions__["C" /* displayModalMessage */])(__WEBPACK_IMPORTED_MODULE_3__enums__["w" /* ModalType */].PAYWALL, { src: url }));
                            } else {
                                _oneIdParam = query[__WEBPACK_IMPORTED_MODULE_3__enums__["t" /* Flags */].DISNEY_ENV] === 'stg' ? __WEBPACK_IMPORTED_MODULE_3__enums__["t" /* Flags */].ONEID_ENV + '=staging&' : '';
                                _idParam = 'id=' + content.id;
                                _redirectParam = 'redirectUrl=' + encodeURIComponent(redirectUrl);
                                _url = '/watch/account-selector?' + _oneIdParam + _idParam + '&' + _redirectParam;
                                promoEl = document.getElementById(__WEBPACK_IMPORTED_MODULE_2__constants__["b" /* BAM_PROMO_IFRAME_ID */]);

                                if (promoEl) {
                                    promoEl.innerHTML = '<iframe src="' + _url + '"></iframe>';
                                }
                            }
                            _context4.next = 39;
                            break;

                        case 19:
                            if (!isPromo) {
                                dispatch(Object(__WEBPACK_IMPORTED_MODULE_32__appActions__["C" /* displayModalMessage */])(__WEBPACK_IMPORTED_MODULE_3__enums__["w" /* ModalType */].PAYWALL, { content: content }));
                            }
                            videoPlayer = new __WEBPACK_IMPORTED_MODULE_38__webapp_common_video_player__["a" /* default */]({
                                bamPlayerOptions: query[__WEBPACK_IMPORTED_MODULE_3__enums__["t" /* Flags */].BAM_ENV] ? _extends({}, bam, { env: query[__WEBPACK_IMPORTED_MODULE_3__enums__["t" /* Flags */].BAM_ENV] }) : bam
                            });
                            contentId = Object(__WEBPACK_IMPORTED_MODULE_8__lib_auth_getContentId__["a" /* default */])(content);
                            eventIdOrId = contentId.eventId || contentId.id;
                            paywallConfig = _extends({
                                container: '#' + containerId,
                                customProps: {}
                            }, Object(__WEBPACK_IMPORTED_MODULE_17__lib_util_getBamAuthConfig__["a" /* default */])(oneIdToken, passOneIdToken, userAuth), {
                                redirectUrl: redirectUrl,
                                isPromo: isPromo,
                                analytics: analytics
                            });

                            // Only assign navmethod to analytics object if defined

                            if (typeof navmethod === 'string' && navmethod !== '') {
                                paywallConfig.analytics.navmethod = navmethod;
                            }

                            idKey = 'id';

                            if (!stream && contentId.eventId) {
                                idKey = 'eventId';
                            }

                            if (!isPromo) {
                                if (stream) {
                                    paywallConfig[idKey] = stream.id;
                                    /**
                                     * Set stream to `customProps` where DSS needs to handle paywall and playback
                                     * To handle the /schedule page which uses GraphQL, we must embed
                                     * the `content` object which has been updated to contain the `backgroundImageHref`
                                     * 1. var isContentInStream: check if stream has content props, if it is yes, use stream
                                     * 2. if isContentInStream returns false, get firstStream (stream[0]) from content
                                     * 3. if step 1 and step 2 fail, let's just pass content object along with stream
                                     */
                                    isContentInStream = stream && stream.content;
                                    firstStream = content.streams[0];
                                    streamObject = void 0;

                                    if (isContentInStream) {
                                        streamObject = stream;
                                    } else if (firstStream && firstStream.content) {
                                        streamObject = firstStream;
                                    } else {
                                        streamObject = _extends({}, stream, { content: content });
                                    }
                                    paywallConfig.customProps.stream = streamObject;
                                } else {
                                    paywallConfig[idKey] = eventIdOrId;
                                    // NOTE: In a multi-stream scenario we need to pass the event content to `customProps`
                                    // to ensure the generic paywall image is rendered.
                                    // The solution is to use the first stream which contains the `backgroundImageHref` as primary
                                    // and fallback to nesting the parent object with the content
                                    if (content) {
                                        _firstStream = content.streams[0];

                                        paywallConfig.customProps.stream = _firstStream || _extends({}, content, { content: content });
                                    }
                                }
                            }

                            if (query[__WEBPACK_IMPORTED_MODULE_3__enums__["t" /* Flags */].DISNEY_ENV] === 'stg') {
                                paywallConfig.oneIdEnv = 'stg';
                            }
                            if (!isPromo) {
                                videoPlayer.once(__WEBPACK_IMPORTED_MODULE_38__webapp_common_video_player__["a" /* default */].Events.LOGIN_REQUESTED, function (event) {
                                    var success = event.success,
                                        _event$body = event.body;
                                    _event$body = _event$body === undefined ? {} : _event$body;
                                    var authType = _event$body.authType,
                                        redirectUrlArg = _event$body.redirectUrl;

                                    if (!success) {
                                        console.error('LOGIN_REQUESTED', event);
                                    }
                                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_32__appActions__["y" /* closeModalMessage */])());
                                    if (authType === __WEBPACK_IMPORTED_MODULE_3__enums__["e" /* AuthTypes */].BAM) {
                                        __WEBPACK_IMPORTED_MODULE_18__lib_oneId__["k" /* on */]('login', function () {
                                            var _loginQuery;

                                            var streamArg = stream;
                                            if (!streamArg) {
                                                streamArg = content.streams.filter(function (streamParam) {
                                                    return Object(__WEBPACK_IMPORTED_MODULE_7__lib_auth_streamHasAuthType__["a" /* default */])(streamParam, __WEBPACK_IMPORTED_MODULE_3__enums__["e" /* AuthTypes */].BAM);
                                                })[0];
                                            }
                                            var loginQuery = (_loginQuery = {}, _defineProperty(_loginQuery, 'login_with_content_' + idKey, eventIdOrId), _defineProperty(_loginQuery, 'login_with_pkg', streamArg && streamArg.packages && streamArg.packages.join(',')), _loginQuery);
                                            // pass stream id only when it's different from content id
                                            if (streamArg && streamArg.id !== eventIdOrId) {
                                                loginQuery.login_with_id = streamArg.id;
                                            }
                                            // pass airingId that user selected from picker to login params
                                            // so that we know which stream to play in the player
                                            var airingId = query.airingId;

                                            if (airingId) {
                                                loginQuery.airingId = airingId;
                                            }
                                            window.location.href = Object(__WEBPACK_IMPORTED_MODULE_14__lib_format_addQueryToUrl__["a" /* default */])(redirectUrlArg, loginQuery);
                                        });
                                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_36__oneIdActions__["m" /* launchLogin */])());
                                    } else if (authType === __WEBPACK_IMPORTED_MODULE_3__enums__["e" /* AuthTypes */].MVPD) {
                                        dispatch(createAndPerformStartAuthenticationAction({ content: content, stream: stream })).then(function (isAuthenticated) {
                                            if (!isAuthenticated) {
                                                dispatch(createDisplayProviderDialogAction());
                                            }
                                        });
                                    }
                                });
                            }
                            _context4.prev = 30;

                            console.log('paywallConfig', paywallConfig); // eslint-disable-line no-console
                            _context4.next = 34;
                            return videoPlayer.renderPaywall(paywallConfig);

                        case 34:
                            _context4.next = 39;
                            break;

                        case 36:
                            _context4.prev = 36;
                            _context4.t0 = _context4['catch'](30);

                            console.error(_context4.t0);

                        case 39:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4, [[30, 36]]);
        }));

        return function (_x13, _x14) {
            return _ref15.apply(this, arguments);
        };
    }();
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);


var routingSelector = function routingSelector(_ref) {
  var _ref$routing = _ref.routing,
      routing = _ref$routing === undefined ? {} : _ref$routing;
  return routing;
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(routingSelector, function (routing) {
  return routing;
}));

/***/ }),
/* 24 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = routerWarning;
exports._resetWarned = _resetWarned;

var _warning = __webpack_require__(483);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var warned = {};

function routerWarning(falseToWarn, message) {
  // Only issue deprecation warnings once.
  if (message.indexOf('deprecated') !== -1) {
    if (warned[message]) {
      return;
    }

    warned[message] = true;
  }

  message = '[react-router] ' + message;

  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
}

function _resetWarned() {
  warned = {};
}

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return oneIdInitializedSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return oneIdLoggedInSelector; });
/* unused harmony export oneIdLangPrefSelector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return oneIdEntitlementsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return oneIdTokenSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return oneIdEntitlementsParamsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return oneIdAnalyticsSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniq__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_uniq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_cookie_cutter__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_cookie_cutter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_cookie_cutter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_util_isEmpty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_util_canUseDOM__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__authenticationSelectors__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fanSelector__ = __webpack_require__(91);









var oneIdSelector = function oneIdSelector(_ref) {
    var _ref$oneId = _ref.oneId,
        oneId = _ref$oneId === undefined ? {} : _ref$oneId;
    return oneId;
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(oneIdSelector, function (oneId) {
    return oneId;
}));

var oneIdInitializedSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(oneIdSelector, function (oneId) {
    return oneId && !!oneId.completeTime;
});

var oneIdLoggedInSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(oneIdSelector, function (oneId) {
    if (__WEBPACK_IMPORTED_MODULE_4__lib_util_canUseDOM__["a" /* default */] && window.espn && window.espn.core && window.espn.core.loggedIn != null) {
        return window.espn.core.loggedIn;
    }
    return oneId && !Object(__WEBPACK_IMPORTED_MODULE_3__lib_util_isEmpty__["a" /* default */])(oneId.data);
});

var oneIdLangPrefSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(oneIdSelector, function (oneId) {
    var langPref = void 0;
    if (oneId && !Object(__WEBPACK_IMPORTED_MODULE_3__lib_util_isEmpty__["a" /* default */])(oneId.data)) {
        langPref = oneId.data.profile.languagePreference;
    }
    return langPref;
});

var oneIdEntitlementsSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_5__authenticationSelectors__["p" /* subscriptionsSelector */], oneIdSelector, function (subscriptions, oneId) {
    var entitlements = void 0;
    if (subscriptions) {
        entitlements = __WEBPACK_IMPORTED_MODULE_1_lodash_uniq___default()(subscriptions.reduce(function (acc, _ref2) {
            var isActive = _ref2.isActive,
                _ref2$products = _ref2.products,
                products = _ref2$products === undefined ? [] : _ref2$products,
                _ref2$status = _ref2.status;
            _ref2$status = _ref2$status === undefined ? {} : _ref2$status;
            var type = _ref2$status.type;

            if (!isActive || type === 'UNSUBSCRIBED') {
                return acc;
            }
            var prdctEntitlements = products.reduce(function (acc2, _ref3) {
                var partner = _ref3.partner,
                    _ref3$entitlements = _ref3.entitlements,
                    productEntitlements = _ref3$entitlements === undefined ? [] : _ref3$entitlements;

                if (partner !== 'ESPN' && partner !== 'disney') {
                    return acc2;
                }
                return acc2.concat(productEntitlements.map(function (_ref4) {
                    var name = _ref4.name;
                    return name;
                }));
            }, []);
            return acc.concat(prdctEntitlements);
        }, []));
        return entitlements;
    }
    // fall back to use info from OneID
    if (oneId && !Object(__WEBPACK_IMPORTED_MODULE_3__lib_util_isEmpty__["a" /* default */])(oneId.data) && oneId.data.entitlements && oneId.data.entitlements.length) {
        entitlements = oneId.data.entitlements.filter(function (_ref5) {
            var digitalAssetName = _ref5.digitalAssetName;
            return digitalAssetName === 'ESPNPLUS';
        }).map(function (_ref6) {
            var digitalAssetSourceName = _ref6.digitalAssetSourceName;
            return digitalAssetSourceName;
        });
    }
    return entitlements;
});

var oneIdTokenSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(oneIdSelector, function (oneId) {
    return oneId && oneId.data && oneId.data.token;
});

var oneIdEntitlementsParamsSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(oneIdEntitlementsSelector, function (oneIdEntitlements) {
    return oneIdEntitlements;
});

function convertGender(gender) {
    return {
        1: 'M',
        2: 'F'
    }[gender] || 'not set';
}

var oneIdAnalyticsSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_6__fanSelector__["a" /* default */], oneIdSelector, function (fan, oneId) {
    var _ref7 = oneId || {},
        data = _ref7.data;

    var swid = fan.id || typeof document !== 'undefined' && __WEBPACK_IMPORTED_MODULE_2_cookie_cutter___default.a.get('SWID');
    var unid = fan.id || typeof document !== 'undefined' && __WEBPACK_IMPORTED_MODULE_2_cookie_cutter___default.a.get('UNID');
    var tracking = { swid: swid, unid: unid };
    if (!Object(__WEBPACK_IMPORTED_MODULE_3__lib_util_isEmpty__["a" /* default */])(data)) {
        var _data$profile = data.profile;
        _data$profile = _data$profile === undefined ? {} : _data$profile;
        var status = _data$profile.status,
            _data$profile$gender = _data$profile.gender,
            gender = _data$profile$gender === undefined ? '' : _data$profile$gender,
            _data$profile$dateOfB = _data$profile.dateOfBirth,
            dateOfBirth = _data$profile$dateOfB === undefined ? '' : _data$profile$dateOfB;

        tracking.registrationtype = 'espn';
        if (status) {
            tracking.loginstatus = 'Registered:Logged in ' + status;
        }
        tracking.gender = convertGender(gender);
        if (dateOfBirth) {
            tracking.birthage = dateOfBirth.slice(0, 4);
        }
    }
    return tracking;
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bootstrapPropTypes */
/* unused harmony export entitlementsPropTypes */
/* unused harmony export packagesPropTypes */
/* unused harmony export sourcePropTypes */
/* unused harmony export linksPropTypes */
/* unused harmony export streamPropTypes */
/* unused harmony export eventPropTypes */
/* unused harmony export contentPropTypes */
/* unused harmony export bucketMetadataPropTypes */
/* unused harmony export bucketLinksPropTypes */
/* unused harmony export bucketPropTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enums__ = __webpack_require__(1);



var string = __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
    number = __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
    bool = __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
    array = __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array,
    object = __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,
    shape = __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].shape,
    oneOf = __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].oneOf,
    arrayOf = __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf,
    oneOfType = __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].oneOfType;


var contentStatuses = Object.keys(__WEBPACK_IMPORTED_MODULE_1__enums__["n" /* ContentStatus */]).map(function (key) {
    return __WEBPACK_IMPORTED_MODULE_1__enums__["n" /* ContentStatus */][key];
});

var bootstrapPropTypes = shape({
    version: string,
    env: string,
    bam: shape({
        sdkHost: string,
        env: string,
        playerVersion: string
    }),
    player: shape({
        logos: object
    }),
    syndicatedPlayer: shape({
        gatedAll: bool,
        gatedIE: bool
    }),
    preRoll: shape({
        editions: object
    }),
    adobePass: shape({
        preauthorizeNetworks: array,
        preauthorizeNetworksEnabled: bool
    })
});

var entitlementsPropTypes = shape({
    entitled: bool
});

var packagesPropTypes = array;

var sourcePropTypes = shape({
    id: string,
    name: string,
    type: oneOf(Object.keys(__WEBPACK_IMPORTED_MODULE_1__enums__["E" /* SourceType */]).map(function (key) {
        return __WEBPACK_IMPORTED_MODULE_1__enums__["E" /* SourceType */][key];
    })),
    origination: string
});

var linksPropTypes = shape({
    play: string,
    web: string
});

var streamPropTypes = shape({
    id: string,
    name: string,
    status: oneOf(contentStatuses),
    duration: string,
    entitlements: entitlementsPropTypes,
    packages: packagesPropTypes,
    source: sourcePropTypes,
    score: number,
    authTypes: array,
    adobeRSS: string,
    links: linksPropTypes,
    blackoutText: string
});

var eventPropTypes = shape({
    type: string,
    gameState: string,
    teamOneName: string,
    teamTwoName: string,
    teamTwoRank: number,
    teamOneScore: string,
    teamTwoScore: string,
    teamOneIsWinner: bool,
    teamTwoIsWinner: bool,
    statusTextOne: string
});

// product content id is currently number
var contentPropTypes = shape({
    id: oneOfType([string, number]),
    guid: string,
    type: oneOf(Object.keys(__WEBPACK_IMPORTED_MODULE_1__enums__["o" /* ContentType */]).map(function (key) {
        return __WEBPACK_IMPORTED_MODULE_1__enums__["o" /* ContentType */][key];
    })),
    status: oneOf(contentStatuses),
    name: string,
    subtitle: string,
    imageHref: string,
    date: string,
    shortDate: string,
    utc: string,
    time: string,
    score: number,
    streams: arrayOf(streamPropTypes),
    event: eventPropTypes,
    description: string,
    iconHref: string,
    blackoutText: string,
    // To be added
    duration: string
});

var bucketMetadataPropTypes = shape({
    totalCount: number,
    displayCount: number,
    scored: bool,
    grouped: bool
});

var bucketLinksPropTypes = shape({
    self: string,
    web: string
});

var bucketPropTypes = shape({
    id: number,
    name: string,
    type: string,
    style: string,
    metadata: bucketMetadataPropTypes,
    links: bucketLinksPropTypes,
    contents: arrayOf(contentPropTypes)
});

/* unused harmony default export */ var _unused_webpack_default_export = ({
    bootstrap: bootstrapPropTypes,
    source: sourcePropTypes,
    links: linksPropTypes,
    stream: streamPropTypes,
    content: contentPropTypes,
    bucketMetadata: bucketMetadataPropTypes,
    bucketLinks: bucketLinksPropTypes,
    bucket: bucketPropTypes
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return espnPlayerSrcFilesSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);


var bootstrapSelector = function bootstrapSelector(_ref) {
    var _ref$app = _ref.app,
        app = _ref$app === undefined ? {} : _ref$app;
    var _app$bootstrap = app.bootstrap,
        bootstrap = _app$bootstrap === undefined ? {} : _app$bootstrap;

    return bootstrap;
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(bootstrapSelector, function (bootstrap) {
    return bootstrap;
}));

var espnPlayerSrcFilesSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(bootstrapSelector, function (bootstrap) {
    var _bootstrap$player = bootstrap.player,
        player = _bootstrap$player === undefined ? {} : _bootstrap$player;

    return {
        espnPlayerJsUrl: player['espn-web-player-js-url'],
        espnPlayerCssUrl: player['espn-web-player-css-url']
    };
});

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactSideEffect = __webpack_require__(675);

var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

var _deepEqual = __webpack_require__(677);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _objectAssign = __webpack_require__(15);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _HelmetConstants = __webpack_require__(680);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var HELMET_ATTRIBUTE = "data-react-helmet";

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props[property]) {
            return props[property];
        }
    }
    return null;
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, "title");
    var innermostTemplate = getInnermostProperty(propsList, "titleTemplate");

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, "defaultTitle");

    return innermostTitle || innermostDefaultTitle || "";
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, "onChangeClientState") || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[_HelmetConstants.TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    return propsList.filter(function (props) {
        return typeof props[tagName] !== "undefined";
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();
};

var updateTitle = function updateTitle(title, attributes) {
    document.title = title || document.title;
    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var htmlTag = document.getElementsByTagName(tagName)[0];
    var helmetAttributeString = htmlTag.getAttribute(HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        htmlTag.setAttribute(attribute, value);

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        htmlTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        htmlTag.removeAttribute(HELMET_ATTRIBUTE);
    } else {
        htmlTag.setAttribute(HELMET_ATTRIBUTE, helmetAttributes.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector("head");
    var tagNodes = headElement.querySelectorAll(type + "[" + HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === "innerHTML") {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === "cssText") {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateHtmlAttributesAsString = function generateHtmlAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes) {
    var attributeString = generateHtmlAttributesAsString(attributes);
    return attributeString ? "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(title) + "</" + type + ">" : "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(title) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags) {
    return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === "innerHTML" || attribute === "cssText");
        }).reduce(function (string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute]) + "\"";
            return string ? string + " " + attr : attr;
        }, "");

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = [_HelmetConstants.TAG_NAMES.NOSCRIPT, _HelmetConstants.TAG_NAMES.SCRIPT, _HelmetConstants.TAG_NAMES.STYLE].indexOf(type) === -1;

        return str + "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    // assigning into an array to define toString function on it
    var initProps = _defineProperty({
        key: title
    }, HELMET_ATTRIBUTE, true);
    var props = Object.keys(attributes).reduce(function (obj, key) {
        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);

    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function (tag, i) {
        var mappedTag = _defineProperty({
            key: i
        }, HELMET_ATTRIBUTE, true);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;

            if (mappedAttribute === "innerHTML" || mappedAttribute === "cssText") {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return _react2.default.createElement(type, mappedTag);
    });
};

var getMethodsForTag = function getMethodsForTag(type, tags) {
    switch (type) {
        case _HelmetConstants.TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes);
                }
            };
        case _HelmetConstants.TAG_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return tags;
                },
                toString: function toString() {
                    return generateHtmlAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var htmlAttributes = _ref.htmlAttributes,
        title = _ref.title,
        titleAttributes = _ref.titleAttributes,
        baseTag = _ref.baseTag,
        metaTags = _ref.metaTags,
        linkTags = _ref.linkTags,
        scriptTags = _ref.scriptTags,
        noscriptTags = _ref.noscriptTags,
        styleTags = _ref.styleTags;
    return {
        htmlAttributes: getMethodsForTag(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes),
        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }),
        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag),
        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags),
        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags),
        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
    };
};

var Helmet = function Helmet(Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
        _inherits(HelmetWrapper, _React$Component);

        function HelmetWrapper() {
            _classCallCheck(this, HelmetWrapper);

            return _possibleConstructorReturn(this, (HelmetWrapper.__proto__ || Object.getPrototypeOf(HelmetWrapper)).apply(this, arguments));
        }

        _createClass(HelmetWrapper, [{
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                return !(0, _deepEqual2.default)(this.props, nextProps);
            }
        }, {
            key: "render",
            value: function render() {
                return _react2.default.createElement(Component, this.props);
            }
        }], [{
            key: "canUseDOM",


            // Component.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.
            set: function set(canUseDOM) {
                Component.canUseDOM = canUseDOM;
            }
            /**
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {String} title: "Title"
             * @param {String} defaultTitle: "Default Title"
             * @param {String} titleTemplate: "MySite.com - %s"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div{ display: block; color: blue; }"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             */

        }]);

        return HelmetWrapper;
    }(_react2.default.Component), _class.propTypes = {
        htmlAttributes: _react2.default.PropTypes.object,
        title: _react2.default.PropTypes.string,
        defaultTitle: _react2.default.PropTypes.string,
        titleTemplate: _react2.default.PropTypes.string,
        titleAttributes: _react2.default.PropTypes.object,
        base: _react2.default.PropTypes.object,
        meta: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
        link: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
        script: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
        noscript: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
        style: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
        onChangeClientState: _react2.default.PropTypes.func
    }, _class.peek = Component.peek, _class.rewind = function () {
        var mappedState = Component.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = mapStateOnServer({
                htmlAttributes: {},
                title: "",
                titleAttributes: {},
                baseTag: [],
                metaTags: [],
                linkTags: [],
                scriptTags: [],
                noscriptTags: [],
                styleTags: []
            });
        }

        return mappedState;
    }, _temp;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.TAG_NAMES.HTML, propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList("titleAttributes", propsList),
        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
        onChangeClientState: getOnChangeClientState(propsList)
    };
};

var handleClientStateChange = function handleClientStateChange(newState) {
    var htmlAttributes = newState.htmlAttributes,
        title = newState.title,
        titleAttributes = newState.titleAttributes,
        baseTag = newState.baseTag,
        metaTags = newState.metaTags,
        linkTags = newState.linkTags,
        scriptTags = newState.scriptTags,
        noscriptTags = newState.noscriptTags,
        styleTags = newState.styleTags,
        onChangeClientState = newState.onChangeClientState;


    updateAttributes("html", htmlAttributes);

    updateTitle(title, titleAttributes);

    var tagUpdates = {
        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
    };

    var addedTags = {};
    var removedTags = {};

    Object.keys(tagUpdates).forEach(function (tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType],
            newTags = _tagUpdates$tagType.newTags,
            oldTags = _tagUpdates$tagType.oldTags;


        if (newTags.length) {
            addedTags[tagType] = newTags;
        }
        if (oldTags.length) {
            removedTags[tagType] = tagUpdates[tagType].oldTags;
        }
    });

    onChangeClientState(newState, addedTags, removedTags);
};

var NullComponent = function NullComponent() {
    return null;
};

var HelmetSideEffects = (0, _reactSideEffect2.default)(reducePropsToState, handleClientStateChange, mapStateOnServer)(NullComponent);

exports.default = Helmet(HelmetSideEffects);
module.exports = exports["default"];

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 32 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* jshint node:true */


// Date comparison taken from
// http://stackoverflow.com/questions/492994/compare-two-dates-with-javascript

var moment = __webpack_require__(589);
var selectn = __webpack_require__(112);

// date time formatting related settings
var dateTime = {
    'dateFormats': {
        'time1': '',
        'date1': 'D MMM, YYYY',
        'date2': 'D/M/YYYY',
        'date3': 'DD/MM/YYYY',
        'date4': 'DDMMYYYY',
        'date5': 'Do MMMM YYYY',
        'date6': 'dddd, Do MMMM YYYY',
        'date7': 'ddd, D MMM YYYY',
        'date8': 'D/M',
        'date9': 'ddd',
        'date10': 'dddd, MMMM Do',
        'date11': 'MMMM YYYY',
        'date12': 'YYYYMMDD',
        'date13': 'MMMM Do, YYYY',
        'date14': 'M/D',
        'date15': 'dddd, D [de] MMMM', // Brazil Edition
        'date16': 'dddd, Do MMMM',
        'dateTime1': 'h:mm A, MMMM D, YYYY',
        'dateTime2': 'h:mm A',
        'dateTime3': 'H:mm',
        'dateTime4': 'MM/DD/YY HH:mm z',
        'dateTime5': 'dddd, h:mm A',
        'dateTime6': 'M/D h:mm A',
        'dateTime7': 'dddd, MMMM DD YYYY - hh:mm A'
    },
    'dayNamesLong': 'Sunday Monday Tuesday Wednesday Thursday Friday Saturday'.split(' '),
    'dayNamesMedium': 'Sun Mon Tue Wed Thu Fri Sat'.split(' '),
    'dayNamesShort': 'Su Mo Tu We Th Fr Sa'.split(' '),
    'monthNamesLong': 'January February March April May June July August September October November December'.split(' '),
    'monthNamesShort': 'Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec'.split(' ')
};

/* harmony default export */ __webpack_exports__["a"] = ({

    getTimezone: function getTimezone() {
        return moment.tz.guess() || 'UTC';
    },

    dateToKey: function dateToKey(oDate) {
        return this.dateFormat(oDate, 'date12');
    },

    paramToCalendarDatesString: function paramToCalendarDatesString(sParam) {
        if (!sParam) {
            return sParam;
        }
        return sParam.substr(0, 4) + '-' + sParam.substr(4, 2) + '-' + sParam.substr(6, 2);
    },

    paramToDate: function paramToDate(sParam) {
        var dateStr = this.paramToCalendarDatesString(sParam);

        if (!dateStr) {
            return dateStr;
        }

        return moment(dateStr).toDate();
    },

    dateDayNamesMedium: function dateDayNamesMedium() {
        return dateTime.dayNamesMedium;
    },

    dateFormat: function dateFormat(ISODate, _dateFormat, showTimezone) {
        if (ISODate === undefined) {
            return ISODate;
        }

        if (_dateFormat === undefined) {
            _dateFormat = 'date6';
        }

        showTimezone = showTimezone || false;

        var formatsMap = dateTime.dateFormats;
        var utcMoment = moment(ISODate); //, moment.ISO_8601
        var localMoment = moment(utcMoment.utc().toDate());

        _dateFormat = formatsMap[_dateFormat];

        var dateString = localMoment.format(_dateFormat);
        //console.log(localMoment.format('z'))
        //window.moment().tz(window.jstz.determine().name()).format('z')
        //if ($(element).hasClass('time') && showTimezone === 'true') {
        //    var currentTimezone = espn_ui.Helpers.timezones.getCurrentTimezone()
        //    dateString += ' ' + espn_ui.Behaviors.date_timezone.replace(currentTimezone)
        //}

        return dateString;
    },

    /**
     * Returns a formatted date string for events following the criteria below:
     * 1) Same day - 5:00 PM
     * 2) Next day - Tomorrow, 5:00 PM
     * 3) Between 2-6 days - Thursday, 5:00 PM
     * 4) past date & 7+ days - 5/29, 5:00 PM
     *
     * @param {ISODate} - Standardized date object
     * @param {dateFormat} - Format of output string
     * @param {timeZone} - Optional user timezone
     * @param {nextDayString} - i18n string representation for the the next day
     */
    eventDateFormat: function eventDateFormat(ISODate, dateFormat, timeZone) {
        var nextDayString = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'Tomorrow';

        if (ISODate === undefined) {
            return ISODate;
        }

        var dateFormats = dateTime.dateFormats;

        var currentDateFormat = dateFormat || 'dateTime2';
        var eventDate = timeZone ? moment.tz(ISODate, timeZone) : moment(ISODate);
        var momentInstance = timeZone ? moment.tz(timeZone) : moment();
        var tomorrow = momentInstance.clone().add(1, 'day');
        var sevenDaysFromToday = momentInstance.clone().add(7, 'days');
        var eventDateFormatted = eventDate.format(dateFormats[currentDateFormat]);

        // Same day event
        if (eventDate.isSame(momentInstance, 'day')) {
            return eventDateFormatted; // Output: 5:00 PM
        }
        // Tomorrow
        if (eventDate.isSame(tomorrow, 'day')) {
            return nextDayString + ', ' + eventDateFormatted; // Output: Tomorrow, 5:00 PM; i18n supported
        }
        // 2-6 day range
        if (eventDate.isAfter(tomorrow, 'day') && eventDate.isBefore(sevenDaysFromToday, 'day')) {
            return eventDate.format(dateFormats['dateTime5']); // Output: Friday, 5:00 PM
        }
        // Past event and 7+ days (base case)
        return eventDate.format(dateFormats['dateTime6']); // Output: 06/13 5:00 PM
    },

    /**
     * Converts the date in d to a date-object using moment-timezone
     * @param  {String/object} d date in string/Object
     * @return {Object}          date-object
     */
    dateToObject: function dateToObject(d) {
        return moment(d).toDate();
    },

    /**
     * Compare two dates (could be of any type supported by the convert
     * function above) and returns:
     *  -1 : if a < b
     *   0 : if a = b
     *   1 : if a > b
     * NaN : if a or b is an illegal date
     * NOTE: The code inside isFinite does an assignment (=).
     *
     * @param  {String/object} a date in string/Object
     * @param  {String/object} b date in string/Object
     * @return {Number}        as described above
     **/
    dateCompare: function dateCompare(a, b) {
        return isFinite(a = this.dateToObject(a).valueOf()) && isFinite(b = this.dateToObject(b).valueOf()) ? (a > b) - (a < b) : NaN;
    },

    /**
     * Checks if date in d is between dates in start and end.
     * Returns a boolean or NaN:
     *    true  : if d is between start and end (inclusive)
     *    false : if d is before start or after end
     *    NaN   : if one or more of the dates is illegal.
     * NOTE: The code inside isFinite does an assignment (=).
     *
     * @param {String/object} d date in string/Object
     * @param {String/Object} start startdate
     * @param {String/Object} end startdate
     * @return {Boolean/NaN}  As described above
     **/
    dateInRange: function dateInRange(d, start, end) {
        return isFinite(d = this.dateToObject(d).valueOf()) && isFinite(start = this.dateToObject(start).valueOf()) && isFinite(end = this.dateToObject(end).valueOf()) ? start <= d && d <= end : NaN;
    },

    /**
     * Convert date/time as per the passed options of timezone and formatting
     * @param  {String} d date  String in ISO 8601 format
     * @param  {Object} options date formatting options
     * @return {String}         formatted time as per the options
     */
    convertDateTime: function convertDateTime(d, options) {
        // default return type
        var displayTime = '';

        /**
         * default formatting options
         * UTC as time zone - 'Europe/London'
         * 24HR time format - HH:mm z
         */
        var timeZone = 'Europe/London';
        var timeFormat = 'h:mm A';
        // Override default options if options input has valid properties
        if (typeof selectn('timeZone', options) !== 'undefined') {
            timeZone = options.timeZone;
        }

        if (typeof selectn('timeFormat', options) !== 'undefined') {
            timeFormat = options.timeFormat;
        }

        if (typeof selectn('dateFormat', options) !== 'undefined') {
            var formatsMap = dateTime.dateFormats;
            var dateFormat = options.dateFormat;

            if (formatsMap[dateFormat]) {
                timeFormat = formatsMap[dateFormat];
            }
        }

        // Convert to moment object
        var startTime = moment(d);
        // Format the date only if valid
        if (startTime.isValid() === true) {
            displayTime = startTime.tz(timeZone).format(timeFormat);
            //console.log('original, convertDateTime', d, displayTime)
        }
        return displayTime;
    },

    getTimezoneParam: function getTimezoneParam() {
        var tz = moment().utcOffset();
        var hour = Math.abs(Math.floor(tz / 60));
        var min = Math.abs(tz % 60);
        return 'UTC' + (tz >= 0 ? '+' : '-') + ('0' + hour).slice(-2) + ('0' + min).slice(-2);
    },

    /**
     * Convert date string from v1/listings API to the valid ISO string
     * @param  {String} str A date string to convert
     * @return {String} ISO 8601 date string
     */
    toISOString: function toISOString() {
        var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

        return str.replace(/GMT$/, 'Z').replace(/EST$/, '-05:00').replace(/EDT$/, '-04:00');
    },

    /**
     * Convert date to ISO string with minute precision
     * @param  {Date} Standardized date object
     * @return {String} ISO 8601 date string with minute precision
     */
    getISOStringWithMinPrecision: function getISOStringWithMinPrecision() {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();

        return date.toISOString().replace(/:\d+\.\d+Z$/, '');
    },

    /**
     * Formats a standardized date by the format specified with optional timezone
     * @param {date} - Standardized date object
     * @param {dateFormat} - Format of output string
     * @param {timeZone} - Optional user timezone
     */
    getDateTimeString: function getDateTimeString(date, dateFormat, timeZone, type, nextDayString) {
        if (type === 'schedule-event') {
            return this.eventDateFormat(date, dateFormat, timeZone, nextDayString);
        }

        if (timeZone) {
            return this.convertDateTime(date, { timeZone: timeZone, dateFormat: dateFormat });
        }
        return this.dateFormat(date, dateFormat);
    }
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OMNITURE_CONSTANTS; });
/* unused harmony export trackByIframe */
/* harmony export (immutable) */ __webpack_exports__["f"] = init;
/* harmony export (immutable) */ __webpack_exports__["b"] = clearTrackingData;
/* harmony export (immutable) */ __webpack_exports__["n"] = trackMvpdPicker;
/* harmony export (immutable) */ __webpack_exports__["p"] = trackProviderSelect;
/* harmony export (immutable) */ __webpack_exports__["j"] = trackAuthenticationComplete;
/* harmony export (immutable) */ __webpack_exports__["l"] = trackAuthorizationStart;
/* harmony export (immutable) */ __webpack_exports__["k"] = trackAuthorizationComplete;
/* harmony export (immutable) */ __webpack_exports__["q"] = trackSearch;
/* harmony export (immutable) */ __webpack_exports__["s"] = trackUntimelyLogout;
/* unused harmony export trackLeavePageAlertShown */
/* harmony export (immutable) */ __webpack_exports__["r"] = trackSocialShareClick;
/* unused harmony export trackReturnAfterLeavePageAlert */
/* harmony export (immutable) */ __webpack_exports__["o"] = trackPage;
/* harmony export (immutable) */ __webpack_exports__["h"] = trackActivatePage;
/* harmony export (immutable) */ __webpack_exports__["g"] = trackActivateCodeInvalid;
/* harmony export (immutable) */ __webpack_exports__["i"] = trackActivateSuccess;
/* harmony export (immutable) */ __webpack_exports__["m"] = trackEspnPlayerOnAdSkipped;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__format__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(8);
/* unused harmony reexport getOmniturePageName */
/* unused harmony reexport getVideoTypeFromContent */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__format__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__format__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__format__["f"]; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var UPSTREAM_USERID = __WEBPACK_IMPORTED_MODULE_0__enums__["a" /* AdobePass */].METADATA.UPSTREAM_USERID;

// nielsen uses this as well to format pageName and videoType



var OMNITURE_CONSTANTS = {
    Channel: 'web',
    Site: 'watchespn',
    ReportSuite: 'wdgespcom',
    ReportSuiteQA: 'wdgespncomdev',
    ReportSuiteIntl: 'wdgesp360international',
    ReportSuiteApp: 'wdgesp360netunoven',
    TrackingServer: 'w88.espn.com',
    SecureTrackingServer: 'sw88.espn.com'
};

// will be injected by the `init` call
var baseOmnitureData = void 0;
var initialized = false;
var initializing = false;
var trackingQueue = [];
var IS_AUTHENTICATING = __WEBPACK_IMPORTED_MODULE_0__enums__["F" /* Storage */].Analytics.IS_AUTHENTICATING;

/**
  * This function calls the actual omniture page tracking
  */

function _trackPage() {
    var omnitureData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var bootstrap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!Object.keys(omnitureData).length) {
        return;
    }
    if (window.espn && window.espn.track) {
        var espnTrack = window.espn.track;
        if (!initialized && espnTrack.init && espnTrack.trackPage) {
            initialized = true;
            initializing = true;

            var nielsenData = espnTrack.data && espnTrack.data.nielsen;
            espnTrack.init({ omniture: omnitureData, nielsen: nielsenData || __WEBPACK_IMPORTED_MODULE_2__constants__["t" /* dotComNielsenData */] });
            // espn.track.init() invokes async data fetch which we won't know when to complete
            // FIXME: we need to know when exactly all the remote data is ready w/o arbitrary timeout.
            setTimeout(function () {
                initializing = false;
                try {
                    trackingQueue.forEach(function (queuedData) {
                        espnTrack.trackPage(queuedData);
                    });
                    // TODO: DTC - remove this once https://code.espn.com/webdev/score/pull/9035 lands
                    var _bootstrap$bam = bootstrap.bam;
                    _bootstrap$bam = _bootstrap$bam === undefined ? {} : _bootstrap$bam;
                    var env = _bootstrap$bam.env,
                        playerdomainArg = _bootstrap$bam.playerdomain;

                    if (window._sf_async_config && playerdomainArg) {
                        var playerdomain = playerdomainArg;
                        if ((env === 'beta' || /bamenv=beta($|[^_])/.test(window.location.search)) && playerdomain.indexOf('espnqa') > -1) {
                            playerdomain = playerdomain.replace('espnqa', 'espn');
                        }
                        window._sf_async_config.playerdomain = playerdomain;
                    }
                } catch (err) {
                    console.error(err);
                }
                trackingQueue = [];
            }, 2000);
        } else if (initializing) {
            trackingQueue.push(omnitureData);
        } else if (espnTrack.trackPage) {
            espnTrack.trackPage(omnitureData);
        }
    } else {
        trackByIframe('page', omnitureData);
    }
}

/**
  * This function calls the actual omniture link tracking
  */
function _trackLink() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (window.espn && window.espn.track && window.espn.track.clear && window.espn.track.trackLink) {
        window.espn.track.clear();
        var linkData = _extends({}, data, { link: 'true' });
        window.espn.track.userClicked = true;
        window.espn.track.trackLink(linkData);
    } else {
        trackByIframe('link', data);
    }
}

function trackByIframe(type, data) {
    var baseUrl = window.location.protocol === 'https:' ? 'https://secure.espn.com' : 'http://espn.com';

    data.type = type;
    data.content = data.contentType;
    data.source = data.site;
    data.pagename = data.pageName;

    var hash = Object.keys(data).reduce(function (acc, key) {
        return '' + acc + (acc ? '&' : '') + key + '=' + encodeURIComponent(data[key]);
    }, '');
    var trackingUrl = baseUrl + '/core/tracking/iframe#' + hash;
    var id = 'espn-tracking-iframe';
    var iframe = document.getElementById(id);
    if (iframe && iframe.parentNode) {
        iframe.parentNode.removeChild(iframe);
    }
    iframe = document.createElement('iframe');
    iframe.id = id;
    iframe.src = trackingUrl;
    iframe.width = '0';
    iframe.height = '0';
    iframe.frameBorder = '0';
    document.body.appendChild(iframe);
}

function init(constants) {
    baseOmnitureData = {
        site: constants.Site,
        channel: constants.Channel,
        account: constants.ReportSuite,
        premium: 'premium-no',
        eVar1: 'DoNotSet',
        eVar12: constants.Edition,
        prop1: 'watchespn',
        prop16: constants.Edition
    };
}

function clearTrackingData() {
    localStorage.removeItem(IS_AUTHENTICATING);
}

function trackMvpdPicker(_ref) {
    var isDomestic = _ref.isDomestic;

    var mvpdPickerData = {
        events: 'event3,event49,event67',
        pageName: 'mvpd picker',
        eVar13: 'mvpd picker',
        prop4: 'authentication',
        prop5: 'authentication',
        eVar11: 'authentication:' + baseOmnitureData.site + ':authentication'
    };
    var omnitureData = _extends({}, baseOmnitureData, mvpdPickerData, Object(__WEBPACK_IMPORTED_MODULE_1__format__["a" /* getOmnitureAuthData */])([], {}, isDomestic));
    _trackPage(omnitureData);
}

function trackProviderSelect(_ref2) {
    var userAuth = _ref2.userAuth,
        provider = _ref2.provider,
        entitlementsTracking = _ref2.entitlementsTracking,
        isDomestic = _ref2.isDomestic;

    var providerName = provider.package ? provider.abbreviation : provider.name;
    var providerChosen = 'provider chosen:' + providerName;
    var providerSelectData = {
        events: 'event72',
        pev2: providerName,
        prop9: providerChosen,
        eVar74: providerChosen
    };
    var omnitureData = _extends({}, baseOmnitureData, Object(__WEBPACK_IMPORTED_MODULE_1__format__["a" /* getOmnitureAuthData */])(userAuth, provider, isDomestic), Object(__WEBPACK_IMPORTED_MODULE_1__format__["b" /* getOmnitureEntitlementsData */])(entitlementsTracking), providerSelectData);
    _trackLink(omnitureData);
    localStorage.setItem(IS_AUTHENTICATING, 'true');
}

function trackAuthenticationComplete(_ref3) {
    var userAuth = _ref3.userAuth,
        provider = _ref3.provider,
        entitlementsTracking = _ref3.entitlementsTracking,
        isDomestic = _ref3.isDomestic;

    var isAuthenticating = localStorage.getItem(IS_AUTHENTICATING);
    if (isAuthenticating === 'true' || isAuthenticating === true) {
        var authenticationComplete = 'authentication complete';
        var authenticationCompleteData = {
            events: 'event68',
            pev2: authenticationComplete,
            prop9: authenticationComplete,
            eVar74: authenticationComplete
        };
        var omnitureData = _extends({}, baseOmnitureData, Object(__WEBPACK_IMPORTED_MODULE_1__format__["a" /* getOmnitureAuthData */])(userAuth, provider, isDomestic), Object(__WEBPACK_IMPORTED_MODULE_1__format__["b" /* getOmnitureEntitlementsData */])(entitlementsTracking), authenticationCompleteData);
        _trackLink(omnitureData);
        clearTrackingData();
    }
}

function trackAuthorizationStart(_ref4) {
    var userAuth = _ref4.userAuth,
        provider = _ref4.provider,
        entitlementsTracking = _ref4.entitlementsTracking,
        isDomestic = _ref4.isDomestic;

    var authorizationStart = 'authorization start';
    var authorizationStartData = {
        events: 'event69',
        pev2: authorizationStart,
        prop9: authorizationStart,
        eVar74: authorizationStart
    };
    var omnitureData = _extends({}, baseOmnitureData, Object(__WEBPACK_IMPORTED_MODULE_1__format__["a" /* getOmnitureAuthData */])(userAuth, provider, isDomestic), Object(__WEBPACK_IMPORTED_MODULE_1__format__["b" /* getOmnitureEntitlementsData */])(entitlementsTracking), authorizationStartData);
    setTimeout(function () {
        _trackLink(omnitureData);
    }, 1000);
}

function trackAuthorizationComplete(_ref5) {
    var userAuth = _ref5.userAuth,
        provider = _ref5.provider,
        entitlementsTracking = _ref5.entitlementsTracking,
        isDomestic = _ref5.isDomestic;

    var authorizationComplete = 'authorization complete';
    var authorizationCompleteData = {
        events: 'event70',
        pev2: authorizationComplete,
        prop9: authorizationComplete,
        eVar74: authorizationComplete
    };
    var omnitureData = _extends({}, baseOmnitureData, Object(__WEBPACK_IMPORTED_MODULE_1__format__["a" /* getOmnitureAuthData */])(userAuth, provider, isDomestic), Object(__WEBPACK_IMPORTED_MODULE_1__format__["b" /* getOmnitureEntitlementsData */])(entitlementsTracking), authorizationCompleteData);
    setTimeout(function () {
        _trackLink(omnitureData);
    }, 1000);
}
// https://espnjira.disney.com/browse/WEWEB-1174
function trackSearch(_ref6) {
    var _ref6$fromHero = _ref6.fromHero,
        fromHero = _ref6$fromHero === undefined ? false : _ref6$fromHero,
        _ref6$searchTerm = _ref6.searchTerm,
        searchTerm = _ref6$searchTerm === undefined ? '' : _ref6$searchTerm,
        _ref6$isSuggestion = _ref6.isSuggestion,
        isSuggestion = _ref6$isSuggestion === undefined ? false : _ref6$isSuggestion,
        _ref6$isViewAllResult = _ref6.isViewAllResults,
        isViewAllResults = _ref6$isViewAllResult === undefined ? false : _ref6$isViewAllResult,
        type = _ref6.type,
        status = _ref6.status,
        entitlementsTracking = _ref6.entitlementsTracking;

    var context = fromHero === true ? 'search-hero' : 'search-page';
    var searchType = isSuggestion ? 'pre' : 'man';
    var submitMethod = 'submit';
    if (isSuggestion) {
        submitMethod = 'suggested';
        if (isViewAllResults) {
            submitMethod = 'view+all+results';
        } else if (type === __WEBPACK_IMPORTED_MODULE_0__enums__["o" /* ContentType */].VOD) {
            submitMethod = 'suggested-vod-clip';
        } else if (type && status) {
            submitMethod = 'suggested-' + status + '-' + type;
        }
    }
    var searchTrackData = {
        events: 'event2',
        eVar4: searchType + ':' + searchTerm,
        prop7: searchType + ':' + searchTerm,
        eVar5: '' + submitMethod,
        eVar74: context,
        prop9: context
    };
    var omnitureData = _extends({}, baseOmnitureData, searchTrackData, Object(__WEBPACK_IMPORTED_MODULE_1__format__["b" /* getOmnitureEntitlementsData */])(entitlementsTracking));
    _trackLink(omnitureData);
}

function trackUntimelyLogout() {
    var actual = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'unknown';
    var expected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'unknown';
    var provider = arguments[2];
    var entitlementsTracking = arguments[3];

    var untimelyLogout = 'Untimely Logout';

    var providerName = provider.name;
    var providerAbbreviation = provider.abbreviation;
    if (provider.package) {
        providerName = provider.abbreviation;
        providerAbbreviation = provider.package.name;
    }

    var authnData = {
        eVar17: providerName,
        prop42: providerName,
        eVar32: providerAbbreviation,
        prop43: providerAbbreviation
    };

    var untimelyLogoutData = {
        events: 'event123',
        eVar37: navigator.userAgent,
        eVar74: untimelyLogout,
        eVar81: 'actual:' + actual + '|expected:' + expected,
        prop37: navigator.userAgent,
        prop9: untimelyLogout
    };
    var omnitureData = _extends({}, baseOmnitureData, authnData, untimelyLogoutData, Object(__WEBPACK_IMPORTED_MODULE_1__format__["b" /* getOmnitureEntitlementsData */])(entitlementsTracking));
    _trackLink(omnitureData);
}

function trackLeavePageAlertShown() {
    var leavePageAlertShown = 'Leave Page Alert Shown';
    var leavePageData = {
        events: 'event120',
        eVar74: leavePageAlertShown,
        eVar72: leavePageAlertShown,
        prop9: leavePageAlertShown
    };
    var omnitureData = _extends({}, baseOmnitureData, leavePageData);
    _trackLink(omnitureData);
}

function trackSocialShareClick(content, page, provider, socialPlatform, userAuth, entitlementsTracking, isDomestic) {
    var authData = Object(__WEBPACK_IMPORTED_MODULE_1__format__["a" /* getOmnitureAuthData */])(userAuth, provider, isDomestic);

    var socialShareValue = 'social share:' + Object(__WEBPACK_IMPORTED_MODULE_1__format__["d" /* getOmniturePageName */])(page) + ':' + socialPlatform + ':' + content.name;

    var omnitureData = _extends({
        events: 'event62',
        pev2: socialShareValue,
        prop9: socialShareValue,
        eVar72: 'social share:' + socialPlatform + ':' + content.type,
        eVar74: socialShareValue
    }, authData, Object(__WEBPACK_IMPORTED_MODULE_1__format__["b" /* getOmnitureEntitlementsData */])(entitlementsTracking));

    _trackLink(omnitureData);
}

function trackReturnAfterLeavePageAlert() {
    var returnAfterLeavePageAlert = 'Return After Leave Page Alert';
    var leavePageData = {
        events: 'event121',
        eVar74: returnAfterLeavePageAlert,
        eVar72: returnAfterLeavePageAlert,
        prop9: returnAfterLeavePageAlert
    };
    var omnitureData = _extends({}, baseOmnitureData, leavePageData);
    _trackLink(omnitureData);
}

function trackPage(_ref7) {
    var app = _ref7.app,
        page = _ref7.page,
        provider = _ref7.provider,
        userAuth = _ref7.userAuth,
        entitlementsTracking = _ref7.entitlementsTracking,
        promoTracking = _ref7.promoTracking,
        _ref7$adobePassMetada = _ref7.adobePassMetadata,
        adobePassMetadata = _ref7$adobePassMetada === undefined ? {} : _ref7$adobePassMetada,
        isDomestic = _ref7.isDomestic;

    var lang = (app.lang || '').toLowerCase();
    var usid = adobePassMetadata[UPSTREAM_USERID];

    var pageTrackData = {
        events: 'event3',
        prop17: lang,
        eVar9: lang,
        eVar85: usid
    };

    if (promoTracking) {
        pageTrackData.events = 'event3,prodView,event131';
        pageTrackData.products = promoTracking;
    }

    var omnitureData = _extends({}, baseOmnitureData, Object(__WEBPACK_IMPORTED_MODULE_1__format__["c" /* getOmniturePageData */])(page), Object(__WEBPACK_IMPORTED_MODULE_1__format__["a" /* getOmnitureAuthData */])(userAuth, provider, isDomestic), Object(__WEBPACK_IMPORTED_MODULE_1__format__["b" /* getOmnitureEntitlementsData */])(entitlementsTracking), pageTrackData);
    _trackPage(omnitureData, app.bootstrap);
}

function trackActivatePage(lang) {
    var device = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'unknown';

    var trackingLang = lang.toLowerCase();
    var pageTrackData = {
        events: 'event3,event90',
        prop5: device,
        prop17: trackingLang,
        eVar9: trackingLang,
        eVar11: 'activate:watchespn:' + device,
        pageName: device + ':activate'
    };

    var omnitureData = _extends({}, baseOmnitureData, pageTrackData);
    _trackPage(omnitureData);
}

function trackActivateCodeInvalid() {
    var device = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'unknown';
    var provider = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var mvpdId = provider.abbreviation,
        mvpdName = provider.name;

    var invalidCode = device + ':activate:invalidcode';
    var invalidCodeData = {
        events: 'event90',
        prop9: invalidCode,
        eVar74: invalidCode,
        eVar32: mvpdId,
        prop43: mvpdId,
        eVar17: mvpdName,
        prop42: mvpdName,
        eVar79: device + ':activationfail'

    };
    var omnitureData = _extends({}, baseOmnitureData, invalidCodeData);
    _trackLink(omnitureData);
}

function trackActivateSuccess() {
    var device = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'unknown';
    var provider = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var mvpdId = provider.abbreviation,
        mvpdName = provider.name;

    var success = device + ':activate:success';
    var successData = {
        pageName: device + ':activate',
        events: 'event90',
        eVar11: 'activate:watchespn:' + device,
        prop9: success,
        eVar74: success,
        eVar32: mvpdId,
        prop43: mvpdId,
        eVar17: mvpdName,
        prop42: mvpdName,
        eVar79: device + ':activationsuccess'
    };
    var omnitureData = _extends({}, baseOmnitureData, successData);
    _trackPage(omnitureData);
}

// prop9 translates to c9, and eVar74 translates to v74
function trackEspnPlayerOnAdSkipped() {
    var omnitureData = {
        prop1: 'watchespn',
        prop9: 'preroll+ad+skip',
        eVar74: 'preroll+ad+skip',
        pev2: 'Preroll Ad Skip'
    };

    _trackLink(omnitureData);
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 35 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {/* unused harmony export START_CHECK_SWID_AUTHENTICATION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return COMPLETE_CHECK_SWID_AUTHENTICATION; });
/* unused harmony export START_CHECK_ONEID_AUTHENTICATION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COMPLETE_CHECK_ONEID_AUTHENTICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_GUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_GUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LOGIN_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LOGIN_CLOSED; });
/* unused harmony export startSWIDAuthentication */
/* unused harmony export completeSWIDAuthentication */
/* unused harmony export startOneIDAuthentication */
/* unused harmony export createLoginAction */
/* unused harmony export loginClosed */
/* unused harmony export setOneIdData */
/* harmony export (immutable) */ __webpack_exports__["j"] = completeOneIDAuthentication;
/* harmony export (immutable) */ __webpack_exports__["h"] = checkSWIDAuthentication;
/* unused harmony export getLoggedInStatus */
/* harmony export (immutable) */ __webpack_exports__["o"] = logout;
/* harmony export (immutable) */ __webpack_exports__["m"] = launchLogin;
/* harmony export (immutable) */ __webpack_exports__["n"] = launchReauth;
/* harmony export (immutable) */ __webpack_exports__["k"] = forceTokenRefresh;
/* harmony export (immutable) */ __webpack_exports__["l"] = getGuest;
/* harmony export (immutable) */ __webpack_exports__["i"] = clearGuest;
/* harmony export (immutable) */ __webpack_exports__["g"] = checkOneIDAuthentication;
/* unused harmony export disneyIDReadyAction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cookie_cutter__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cookie_cutter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_cookie_cutter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__enums__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_util_canUseDOM__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_util_perf__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_oneId__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__appActions__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__authenticationActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__selectors_appSelector__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__selectors_oneIdSelector__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_util_localStorage__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__selectors_authenticationSelectors__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib_auth_hasTDA__ = __webpack_require__(215);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/* eslint-disable no-use-before-define, no-return-assign */
















var SWID_RE = /^\{[\w-]+\}/;

var START_CHECK_SWID_AUTHENTICATION = 'START_CHECK_SWID_AUTHENTICATION';
var COMPLETE_CHECK_SWID_AUTHENTICATION = 'COMPLETE_CHECK_SWID_AUTHENTICATION';
var START_CHECK_ONEID_AUTHENTICATION = 'START_CHECK_ONEID_AUTHENTICATION';
var COMPLETE_CHECK_ONEID_AUTHENTICATION = 'COMPLETE_CHECK_ONEID_AUTHENTICATION';
var GET_GUEST = 'GET_GUEST';
var CLEAR_GUEST = 'CLEAR_GUEST';
var LOGIN_START = 'LOGIN_START';
var LOGIN_CLOSED = 'LOGIN_CLOSED';

var disneyIDReadyPromise = void 0;

function startSWIDAuthentication() {
    return {
        type: START_CHECK_SWID_AUTHENTICATION,
        startTime: Date.now()
    };
}

function completeSWIDAuthentication(isAuthenticated, swid) {
    return {
        type: COMPLETE_CHECK_SWID_AUTHENTICATION,
        isAuthenticated: isAuthenticated,
        swid: swid,
        completeTime: Date.now()
    };
}

function startOneIDAuthentication() {
    return {
        type: START_CHECK_ONEID_AUTHENTICATION,
        startTime: Date.now()
    };
}

function createLoginAction(params) {
    return {
        type: LOGIN_START,
        params: params
    };
}

function loginClosed() {
    return {
        type: LOGIN_CLOSED
    };
}

function setOneIdData(data) {
    return {
        type: GET_GUEST,
        data: data,
        completeTime: Date.now()
    };
}

function completeOneIDAuthentication(isAuthenticated, entitlements, hasTDAEntitlement, hasSuperBundle) {
    var bamSubReady = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

    return {
        type: COMPLETE_CHECK_ONEID_AUTHENTICATION,
        isAuthenticated: isAuthenticated,
        entitlements: entitlements,
        hasSuperBundle: hasSuperBundle,
        bamSubReady: bamSubReady,
        hasTDAEntitlement: hasTDAEntitlement,
        directive: isAuthenticated === true ? 'add' : 'remove',
        authType: __WEBPACK_IMPORTED_MODULE_2__enums__["e" /* AuthTypes */].BAM,
        completeTime: Date.now()
    };
}

// TODO: Maybe swid should come from some OneId library instead of the cookie
function checkSWIDAuthentication() {
    return function (dispatch) {
        dispatch(startSWIDAuthentication());
        var swid = __WEBPACK_IMPORTED_MODULE_1_cookie_cutter___default.a.get('SWID');
        var isAuthenticated = SWID_RE.test(swid);

        dispatch(completeSWIDAuthentication(isAuthenticated, swid));
        return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve(isAuthenticated);
    };
}

function getLoggedInStatus() {
    return function (dispatch, getState) {
        var isLoggedIn = Object(__WEBPACK_IMPORTED_MODULE_10__selectors_oneIdSelector__["f" /* oneIdLoggedInSelector */])(getState());
        return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve(isLoggedIn);
    };
}

function logout() {
    return function () {
        return Object(__WEBPACK_IMPORTED_MODULE_6__lib_oneId__["i" /* logout */])();
    };
}

function launchLogin(options, params) {
    return function (dispatch) {
        dispatch(createLoginAction(params));
        return Object(__WEBPACK_IMPORTED_MODULE_6__lib_oneId__["g" /* launchLogin */])(options);
    };
}

function launchReauth(options, params) {
    return function (dispatch) {
        dispatch(createLoginAction(params));
        return Object(__WEBPACK_IMPORTED_MODULE_6__lib_oneId__["h" /* launchReauth */])(options);
    };
}

function forceTokenRefresh() {
    return function () {
        return Object(__WEBPACK_IMPORTED_MODULE_6__lib_oneId__["c" /* forceTokenRefresh */])();
    };
}

function getGuest() {
    return function (dispatch) {
        return Object(__WEBPACK_IMPORTED_MODULE_6__lib_oneId__["d" /* getGuest */])().then(function (data) {
            dispatch(setOneIdData(data));
            return data;
        });
    };
}

function clearGuest() {
    return {
        type: CLEAR_GUEST,
        directive: 'remove',
        isAuthenticated: false,
        authType: __WEBPACK_IMPORTED_MODULE_2__enums__["e" /* AuthTypes */].BAM,
        completeTime: Date.now()
    };
}

var disneyIDReady = false;
var transactionId = 0;

function checkOneIDAuthentication() {
    var _this = this;

    return function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
            var hasPageShell, data, state, isLoggedIn, entitlements, bamSessionToken, hasSuperBundle, bamSubReady, hasTDAEntitlement, isAuthenticated;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            __WEBPACK_IMPORTED_MODULE_5__lib_util_perf__["a" /* markStart */]('checkOneIDAuthentication');
                            dispatch(startOneIDAuthentication());
                            hasPageShell = Object(__WEBPACK_IMPORTED_MODULE_9__selectors_appSelector__["n" /* hasPageShellSelector */])(getState());

                            if (!hasPageShell) {
                                _context2.next = 32;
                                break;
                            }

                            if (disneyIDReadyPromise) {
                                _context2.next = 24;
                                break;
                            }

                            data = void 0;
                            _context2.prev = 6;
                            _context2.next = 9;
                            return dispatch(disneyIDReadyAction());

                        case 9:
                            data = _context2.sent;

                            Object(__WEBPACK_IMPORTED_MODULE_6__lib_oneId__["k" /* on */])('refresh', _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                                return regeneratorRuntime.wrap(function _callee$(_context) {
                                    while (1) {
                                        switch (_context.prev = _context.next) {
                                            case 0:
                                                _context.next = 2;
                                                return dispatch(getGuest());

                                            case 2:
                                                transactionId += 1;
                                                // use new oneId token to refresh BAM token by calling SDK Data
                                                dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__appActions__["B" /* createSDKWrapper */])(__WEBPACK_IMPORTED_MODULE_3__constants__["c" /* BAM_PROXY_IFRAME_ID */], ['geolocation', 'subscriptions', 'sessionToken', 'userTrackingInformation'], transactionId));

                                            case 4:
                                            case 'end':
                                                return _context.stop();
                                        }
                                    }
                                }, _callee, _this);
                            })));
                            Object(__WEBPACK_IMPORTED_MODULE_6__lib_oneId__["k" /* on */])('logout', function () {
                                Object(__WEBPACK_IMPORTED_MODULE_11__lib_util_localStorage__["c" /* remove */])(__WEBPACK_IMPORTED_MODULE_3__constants__["q" /* SUB_KEY */]);
                                Object(__WEBPACK_IMPORTED_MODULE_11__lib_util_localStorage__["c" /* remove */])(__WEBPACK_IMPORTED_MODULE_3__constants__["o" /* SESSION_TOKEN_KEY */]);
                                Object(__WEBPACK_IMPORTED_MODULE_11__lib_util_localStorage__["c" /* remove */])(__WEBPACK_IMPORTED_MODULE_3__constants__["r" /* USER_TRACKING_KEY */]);
                                dispatch(clearGuest());
                                dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__authenticationActions__["P" /* createGetBAMAuthenticationInfoAction */])());
                                dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__authenticationActions__["Q" /* createGetBAMSessionTokenAction */])());
                                dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__authenticationActions__["T" /* createGetUserTrackingAction */])({}));
                                dispatch(completeOneIDAuthentication(false, []));
                            });
                            _context2.next = 20;
                            break;

                        case 14:
                            _context2.prev = 14;
                            _context2.t0 = _context2['catch'](6);

                            console.error(_context2.t0);
                            _context2.next = 19;
                            return dispatch(getGuest());

                        case 19:
                            data = _context2.sent;

                        case 20:
                            dispatch(setOneIdData(data));
                            disneyIDReady = true;
                            _context2.next = 30;
                            break;

                        case 24:
                            if (disneyIDReady) {
                                _context2.next = 28;
                                break;
                            }

                            return _context2.abrupt('return', disneyIDReadyPromise);

                        case 28:
                            _context2.next = 30;
                            return dispatch(getGuest());

                        case 30:
                            _context2.next = 34;
                            break;

                        case 32:
                            _context2.next = 34;
                            return dispatch(getGuest());

                        case 34:
                            state = getState();
                            isLoggedIn = Object(__WEBPACK_IMPORTED_MODULE_10__selectors_oneIdSelector__["f" /* oneIdLoggedInSelector */])(state);
                            entitlements = Object(__WEBPACK_IMPORTED_MODULE_10__selectors_oneIdSelector__["d" /* oneIdEntitlementsSelector */])(state);
                            bamSessionToken = Object(__WEBPACK_IMPORTED_MODULE_12__selectors_authenticationSelectors__["j" /* bamSessionTokenSelector */])(state);
                            hasSuperBundle = Object(__WEBPACK_IMPORTED_MODULE_12__selectors_authenticationSelectors__["q" /* superBundleSelector */])(state);
                            bamSubReady = Object(__WEBPACK_IMPORTED_MODULE_12__selectors_authenticationSelectors__["k" /* bamSubReadySelector */])(state);
                            hasTDAEntitlement = Object(__WEBPACK_IMPORTED_MODULE_13__lib_auth_hasTDA__["a" /* default */])(bamSessionToken);
                            isAuthenticated = entitlements && entitlements.length > 0 || hasTDAEntitlement;
                            // TODO: DTC - move this to `createSDKWrapper` action once BAM side can sync user login state with OneID

                            dispatch(completeOneIDAuthentication(isAuthenticated, entitlements, hasTDAEntitlement, hasSuperBundle, bamSubReady));
                            __WEBPACK_IMPORTED_MODULE_5__lib_util_perf__["b" /* measureAndTime */]('checkOneIDAuthentication');
                            return _context2.abrupt('return', {
                                isLoggedIn: isLoggedIn,
                                entitlements: entitlements
                            });

                        case 45:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this, [[6, 14]]);
        }));

        return function (_x2, _x3) {
            return _ref.apply(this, arguments);
        };
    }();
}

function disneyIDReadyAction() {
    var _this2 = this;

    return function (dispatch) {
        __WEBPACK_IMPORTED_MODULE_5__lib_util_perf__["a" /* markStart */]('disneyIDReadyAction');
        return disneyIDReadyPromise || (disneyIDReadyPromise = new __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a(function (resolve, reject) {
            var timeout = 60 * 1000;
            var userCreated = false;
            var userInitialized = false;
            if (!__WEBPACK_IMPORTED_MODULE_4__lib_util_canUseDOM__["a" /* default */]) {
                reject(new Error('memberservices not available server side'));
            } else if (window.jQuery) {
                window.jQuery(document).one('user.created', function () {
                    userCreated = true;
                    if (window.espn && window.espn.memberservices && window.espn.memberservices.ready) {
                        window.espn.memberservices.ready(function () {
                            userInitialized = true;
                            console.log('memberservices.ready'); // eslint-disable-line no-console
                        });
                    }
                    console.log('user.created'); // eslint-disable-line no-console
                });
                window.jQuery(document).one('user.initialized', function () {
                    userInitialized = true;
                    console.log('user.initialized'); // eslint-disable-line no-console
                });
                var userParsedTimer = window.setTimeout(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                    var guest;
                    return regeneratorRuntime.wrap(function _callee3$(_context3) {
                        while (1) {
                            switch (_context3.prev = _context3.next) {
                                case 0:
                                    __WEBPACK_IMPORTED_MODULE_5__lib_util_perf__["b" /* measureAndTime */]('disneyIDReadyAction');

                                    if (!(userCreated && userInitialized)) {
                                        _context3.next = 9;
                                        break;
                                    }

                                    _context3.next = 4;
                                    return dispatch(getGuest());

                                case 4:
                                    guest = _context3.sent;

                                    console.log('`user.parsed` timeout, retrieving guest'); // eslint-disable-line no-console
                                    __WEBPACK_IMPORTED_MODULE_5__lib_util_perf__["b" /* measureAndTime */]('disneyIDReadyAction');
                                    resolve(guest);
                                    return _context3.abrupt('return');

                                case 9:
                                    reject(new Error('user.parsed timeout'));

                                case 10:
                                case 'end':
                                    return _context3.stop();
                            }
                        }
                    }, _callee3, _this2);
                })), timeout);
                window.jQuery(document).one('user.parsed', function (event, guest) {
                    console.log('user.parsed'); // eslint-disable-line no-console
                    window.clearTimeout(userParsedTimer);
                    __WEBPACK_IMPORTED_MODULE_5__lib_util_perf__["b" /* measureAndTime */]('disneyIDReadyAction');
                    resolve(typeof guest !== 'string' ? guest : undefined);
                });
            } else {
                reject(new Error('jQuery is not available with page shell'));
            }
        }));
    };
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// Trust the developer to only use ReactInstrumentation with a __DEV__ check

var debugTool = null;

if (false) {
  var ReactDebugTool = require('./ReactDebugTool');
  debugTool = ReactDebugTool;
}

module.exports = { debugTool: debugTool };

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(280);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7),
    _assign = __webpack_require__(15);

var CallbackQueue = __webpack_require__(234);
var PooledClass = __webpack_require__(65);
var ReactFeatureFlags = __webpack_require__(235);
var ReactReconciler = __webpack_require__(83);
var Transaction = __webpack_require__(118);

var invariant = __webpack_require__(5);

var dirtyComponents = [];
var updateBatchNumber = 0;
var asapCallbackQueue = CallbackQueue.getPooled();
var asapEnqueued = false;

var batchingStrategy = null;

function ensureInjected() {
  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
}

var NESTED_UPDATES = {
  initialize: function () {
    this.dirtyComponentsLength = dirtyComponents.length;
  },
  close: function () {
    if (this.dirtyComponentsLength !== dirtyComponents.length) {
      // Additional updates were enqueued by componentDidUpdate handlers or
      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
      // these new updates so that if A's componentDidUpdate calls setState on
      // B, B will update before the callback A's updater provided when calling
      // setState.
      dirtyComponents.splice(0, this.dirtyComponentsLength);
      flushBatchedUpdates();
    } else {
      dirtyComponents.length = 0;
    }
  }
};

var UPDATE_QUEUEING = {
  initialize: function () {
    this.callbackQueue.reset();
  },
  close: function () {
    this.callbackQueue.notifyAll();
  }
};

var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

function ReactUpdatesFlushTransaction() {
  this.reinitializeTransaction();
  this.dirtyComponentsLength = null;
  this.callbackQueue = CallbackQueue.getPooled();
  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */true);
}

_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  destructor: function () {
    this.dirtyComponentsLength = null;
    CallbackQueue.release(this.callbackQueue);
    this.callbackQueue = null;
    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
    this.reconcileTransaction = null;
  },

  perform: function (method, scope, a) {
    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
    // with this transaction's wrappers around it.
    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
  }
});

PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

function batchedUpdates(callback, a, b, c, d, e) {
  ensureInjected();
  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
}

/**
 * Array comparator for ReactComponents by mount ordering.
 *
 * @param {ReactComponent} c1 first component you're comparing
 * @param {ReactComponent} c2 second component you're comparing
 * @return {number} Return value usable by Array.prototype.sort().
 */
function mountOrderComparator(c1, c2) {
  return c1._mountOrder - c2._mountOrder;
}

function runBatchedUpdates(transaction) {
  var len = transaction.dirtyComponentsLength;
  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;

  // Since reconciling a component higher in the owner hierarchy usually (not
  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
  // them before their children by sorting the array.
  dirtyComponents.sort(mountOrderComparator);

  // Any updates enqueued while reconciling must be performed after this entire
  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
  // C, B could update twice in a single batch if C's render enqueues an update
  // to B (since B would have already updated, we should skip it, and the only
  // way we can know to do so is by checking the batch counter).
  updateBatchNumber++;

  for (var i = 0; i < len; i++) {
    // If a component is unmounted before pending changes apply, it will still
    // be here, but we assume that it has cleared its _pendingCallbacks and
    // that performUpdateIfNecessary is a noop.
    var component = dirtyComponents[i];

    // If performUpdateIfNecessary happens to enqueue any new updates, we
    // shouldn't execute the callbacks until the next render happens, so
    // stash the callbacks first
    var callbacks = component._pendingCallbacks;
    component._pendingCallbacks = null;

    var markerName;
    if (ReactFeatureFlags.logTopLevelRenders) {
      var namedComponent = component;
      // Duck type TopLevelWrapper. This is probably always true.
      if (component._currentElement.type.isReactTopLevelWrapper) {
        namedComponent = component._renderedComponent;
      }
      markerName = 'React update: ' + namedComponent.getName();
      console.time(markerName);
    }

    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);

    if (markerName) {
      console.timeEnd(markerName);
    }

    if (callbacks) {
      for (var j = 0; j < callbacks.length; j++) {
        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
      }
    }
  }
}

var flushBatchedUpdates = function () {
  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
  // array and perform any updates enqueued by mount-ready handlers (i.e.,
  // componentDidUpdate) but we need to check here too in order to catch
  // updates enqueued by setState callbacks and asap calls.
  while (dirtyComponents.length || asapEnqueued) {
    if (dirtyComponents.length) {
      var transaction = ReactUpdatesFlushTransaction.getPooled();
      transaction.perform(runBatchedUpdates, null, transaction);
      ReactUpdatesFlushTransaction.release(transaction);
    }

    if (asapEnqueued) {
      asapEnqueued = false;
      var queue = asapCallbackQueue;
      asapCallbackQueue = CallbackQueue.getPooled();
      queue.notifyAll();
      CallbackQueue.release(queue);
    }
  }
};

/**
 * Mark a component as needing a rerender, adding an optional callback to a
 * list of functions which will be executed once the rerender occurs.
 */
function enqueueUpdate(component) {
  ensureInjected();

  // Various parts of our code (such as ReactCompositeComponent's
  // _renderValidatedComponent) assume that calls to render aren't nested;
  // verify that that's the case. (This is called by each top-level update
  // function, like setState, forceUpdate, etc.; creation and
  // destruction of top-level components is guarded in ReactMount.)

  if (!batchingStrategy.isBatchingUpdates) {
    batchingStrategy.batchedUpdates(enqueueUpdate, component);
    return;
  }

  dirtyComponents.push(component);
  if (component._updateBatchNumber == null) {
    component._updateBatchNumber = updateBatchNumber + 1;
  }
}

/**
 * Enqueue a callback to be run at the end of the current batching cycle. Throws
 * if no updates are currently being performed.
 */
function asap(callback, context) {
  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
  asapCallbackQueue.enqueue(callback, context);
  asapEnqueued = true;
}

var ReactUpdatesInjection = {
  injectReconcileTransaction: function (ReconcileTransaction) {
    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
  },

  injectBatchingStrategy: function (_batchingStrategy) {
    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
    batchingStrategy = _batchingStrategy;
  }
};

var ReactUpdates = {
  /**
   * React references `ReactReconcileTransaction` using this property in order
   * to allow dependency injection.
   *
   * @internal
   */
  ReactReconcileTransaction: null,

  batchedUpdates: batchedUpdates,
  enqueueUpdate: enqueueUpdate,
  flushBatchedUpdates: flushBatchedUpdates,
  injection: ReactUpdatesInjection,
  asap: asap
};

module.exports = ReactUpdates;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_superagent_bluebird_promise__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_superagent_bluebird_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_superagent_bluebird_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_superagent_cache__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_superagent_cache___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_superagent_cache__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(304);
//
// const request = require('superagent-bluebird-promise');
// const cacheModuleConfig = { defaultExpiration: 60 };
// require('superagent-cache')(request, cacheModuleConfig);
// module.exports = request;





var cacheModuleConfig = { defaultExpiration: 60 };

/* harmony default export */ __webpack_exports__["a"] = ((function () {
    if (true) {
        __WEBPACK_IMPORTED_MODULE_1_superagent_cache___default()(__WEBPACK_IMPORTED_MODULE_0_superagent_bluebird_promise___default.a, cacheModuleConfig);
        return __WEBPACK_IMPORTED_MODULE_0_superagent_bluebird_promise___default.a;
    }
    __WEBPACK_IMPORTED_MODULE_1_superagent_cache___default()(__WEBPACK_IMPORTED_MODULE_0_superagent_bluebird_promise___default.a, __WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */]);
    return __WEBPACK_IMPORTED_MODULE_0_superagent_bluebird_promise___default.a;
})());

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config__);


var httpProxy = __WEBPACK_IMPORTED_MODULE_0__config___default.a.httpProxy,
    noProxy = __WEBPACK_IMPORTED_MODULE_0__config___default.a.noProxy;

var noProxyRegEx = noProxy ? new RegExp(noProxy) : null;

var httpProxyAgent = false;
if (false) {
    var proxyAgent = require('http-proxy-agent');
    httpProxyAgent = new proxyAgent(httpProxy);
}

/* harmony default export */ __webpack_exports__["a"] = (function (request) {
    // if there's a proxy agent setup
    if (httpProxyAgent && 'agent' in request) {
        // if there's no noProxy regex or the url does not match the noProxy regex
        // then use the proxy
        if (!noProxyRegEx || noProxyRegEx.test(request.url) === false) {
            request.agent(httpProxyAgent);
        }
    }
    return request;
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {/* harmony export (immutable) */ __webpack_exports__["d"] = set;
/* harmony export (immutable) */ __webpack_exports__["a"] = get;
/* harmony export (immutable) */ __webpack_exports__["c"] = remove;
/* harmony export (immutable) */ __webpack_exports__["e"] = setSessionItem;
/* harmony export (immutable) */ __webpack_exports__["b"] = getSessionItem;
function set(key, value, expirationInSec) {
    try {
        var data = { value: value };
        if (expirationInSec) {
            data.expiration = Date.now() + expirationInSec * 1000;
        }
        window.localStorage.setItem(key, JSON.stringify(data));
    } catch (err) {
        console.error(err);
    }
}

function get(key) {
    try {
        var value = window.localStorage.getItem(key);
        if (value === null) {
            return undefined;
        }
        var data = JSON.parse(value);
        if (data.expiration && data.expiration < Date.now()) {
            remove(key);
            return undefined;
        }
        return data.value;
    } catch (err) {
        return undefined;
    }
}

function remove(key) {
    try {
        window.localStorage.removeItem(key);
    } catch (err) {
        console.error(err);
    }
}

function setSessionItem(key, object) {
    try {
        window.sessionStorage.setItem(key, JSON.stringify(object));
    } catch (err) {
        return undefined;
    }
}

function getSessionItem(key) {
    try {
        var value = window.sessionStorage.getItem(key);
        return value && JSON.parse(value);
    } catch (err) {
        return undefined;
    }
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = streamHasAuthType;
function streamHasAuthType() {
    var stream = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var authType = arguments[1];

    if (stream.authTypes && authType) {
        return stream.authTypes.filter(function (auth) {
            return auth === authType;
        }).length > 0;
    }
    return false;
};

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);


var selectedContentSelector = function selectedContentSelector(_ref) {
  var app = _ref.app;
  return app.selectedContent;
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(selectedContentSelector, function (selectedContent) {
  return selectedContent;
}));

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return persistentFlagsSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__whitelistSelector__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appSelector__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routingSelector__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enums__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var flagsSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_2__appSelector__["o" /* hideNavSelector */], __WEBPACK_IMPORTED_MODULE_2__appSelector__["C" /* playerTechSelector */], __WEBPACK_IMPORTED_MODULE_2__appSelector__["D" /* roadblockSelector */], function (hideNav, playerTech, roadblock) {
    return {
        hideNav: hideNav,
        playerTech: playerTech,
        roadblock: roadblock.toString()
    };
});

var persistentFlagsSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_2__appSelector__["j" /* default */], __WEBPACK_IMPORTED_MODULE_3__routingSelector__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__whitelistSelector__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__appSelector__["K" /* webviewSelector */], function (_ref, routing, inWhitelist, isWebview) {
    var isMobile = _ref.isMobile;

    // if flags were passed in the URL, persist them
    var locationBeforeTransitions = routing.locationBeforeTransitions;
    // `locationBeforeTransitions` is set to `null` on the server side, so default value assignment doesn't work

    var _ref2 = locationBeforeTransitions || {},
        _ref2$pathname = _ref2.pathname,
        pathname = _ref2$pathname === undefined ? '' : _ref2$pathname,
        _ref2$query = _ref2.query,
        query = _ref2$query === undefined ? {} : _ref2$query;

    // take all the query params that are also flags and persist through auth


    var persistentFlags = Object.keys(__WEBPACK_IMPORTED_MODULE_4__enums__["t" /* Flags */]).reduce(function (acc, currentFlag) {
        var queryKey = __WEBPACK_IMPORTED_MODULE_4__enums__["t" /* Flags */][currentFlag];
        // if query param is a flag, accumulate it
        if (query[queryKey]) {
            acc[queryKey] = query[queryKey];
        }
        return acc;
    }, {});

    if (pathname === '/syndicated/player') {
        persistentFlags = _extends({}, persistentFlags, {
            type: query.type,
            dates: query.dates
        });
    }

    // special case to disable roadblock for those opted in to that experience
    if (isMobile && (inWhitelist || isWebview)) {
        persistentFlags[__WEBPACK_IMPORTED_MODULE_4__enums__["t" /* Flags */].ROADBLOCK] = 'false';
    }

    return persistentFlags;
});

/* unused harmony default export */ var _unused_webpack_default_export = (flagsSelector);

/***/ }),
/* 48 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {

  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null

};

module.exports = ReactCurrentOwner;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(15);

var PooledClass = __webpack_require__(65);

var emptyFunction = __webpack_require__(37);
var warning = __webpack_require__(6);

var didWarnForAddedNewProperty = false;
var isProxySupported = typeof Proxy === 'function';

var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  target: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */
function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
  if (false) {
    // these have a getter/setter for warnings
    delete this.nativeEvent;
    delete this.preventDefault;
    delete this.stopPropagation;
  }

  this.dispatchConfig = dispatchConfig;
  this._targetInst = targetInst;
  this.nativeEvent = nativeEvent;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    if (false) {
      delete this[propName]; // this has a getter/setter for warnings
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      if (propName === 'target') {
        this.target = nativeEventTarget;
      } else {
        this[propName] = nativeEvent[propName];
      }
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
  return this;
}

_assign(SyntheticEvent.prototype, {

  preventDefault: function () {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
    } else if (typeof event.returnValue !== 'unknown') {
      // eslint-disable-line valid-typeof
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function () {
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
    } else if (typeof event.cancelBubble !== 'unknown') {
      // eslint-disable-line valid-typeof
      // The ChangeEventPlugin registers a "propertychange" event for
      // IE. This event does not support bubbling or cancelling, and
      // any references to cancelBubble throw "Member not found".  A
      // typeof check of "unknown" circumvents this issue (and is also
      // IE specific).
      event.cancelBubble = true;
    }

    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function () {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function () {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      if (false) {
        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
      } else {
        this[propName] = null;
      }
    }
    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
      this[shouldBeReleasedProperties[i]] = null;
    }
    if (false) {
      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
    }
  }

});

SyntheticEvent.Interface = EventInterface;

if (false) {
  if (isProxySupported) {
    /*eslint-disable no-func-assign */
    SyntheticEvent = new Proxy(SyntheticEvent, {
      construct: function (target, args) {
        return this.apply(target, Object.create(target.prototype), args);
      },
      apply: function (constructor, that, args) {
        return new Proxy(constructor.apply(that, args), {
          set: function (target, prop, value) {
            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
              didWarnForAddedNewProperty = true;
            }
            target[prop] = value;
            return true;
          }
        });
      }
    });
    /*eslint-enable no-func-assign */
  }
}
/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function (Class, Interface) {
  var Super = this;

  var E = function () {};
  E.prototype = Super.prototype;
  var prototype = new E();

  _assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = _assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;

  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
};

PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);

module.exports = SyntheticEvent;

/**
  * Helper to nullify syntheticEvent instance properties when destructing
  *
  * @param {object} SyntheticEvent
  * @param {String} propName
  * @return {object} defineProperty object
  */
function getPooledWarningPropertyDefinition(propName, getVal) {
  var isFunction = typeof getVal === 'function';
  return {
    configurable: true,
    set: set,
    get: get
  };

  function set(val) {
    var action = isFunction ? 'setting the method' : 'setting the property';
    warn(action, 'This is effectively a no-op');
    return val;
  }

  function get() {
    var action = isFunction ? 'accessing the method' : 'accessing the property';
    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
    warn(action, result);
    return getVal;
  }

  function warn(action, result) {
    var warningCondition = false;
     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
  }
}

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(196),
    isLength = __webpack_require__(198);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OneIdJs; });
/* unused harmony export loadDisneyID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getGuest; });
/* unused harmony export getLoggedInStatus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return launchLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return launchReauth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return forceTokenRefresh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return logout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return on; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return off; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getLicensePlateDataBag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return launchLicensePlate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Error; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enums__ = __webpack_require__(1);
var _OneIdJs;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var oneIdConfig = {
    clientId: 'ESPN-ONESITE.WEB',
    responderPage: 'https://www.espn.com/login/responder/index.html',
    cssOverride: 'https://secure.espncdn.com/combiner/c?css=disneyid/core.css'
};

var OneIdJs = (_OneIdJs = {}, _defineProperty(_OneIdJs, __WEBPACK_IMPORTED_MODULE_1__enums__["x" /* OneIdEnv */].STAGING, 'https://stg.cdn.registerdisney.go.com/v2/outer/DisneyID.js'), _defineProperty(_OneIdJs, __WEBPACK_IMPORTED_MODULE_1__enums__["x" /* OneIdEnv */].PROD, 'https://cdn.registerdisney.go.com/v2/outer/DisneyID.js'), _OneIdJs);

var disneyIdPromise = void 0;
var oneIdInstance = void 0;
var initialized = void 0;
var initializing = void 0;

function get() {
    if (true) {
        if (window.DisneyID) {
            if (oneIdInstance && (initialized || initializing)) {
                return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve(oneIdInstance);
            }

            initializing = true;

            if (window.did) {
                // the page already provides initialized oneId instance
                initialized = true;
                initializing = false;
                oneIdInstance = window.did;
                return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve(oneIdInstance);
            }

            if (window.location.pathname === '/watch/activate') {
                oneIdConfig.optionalConfigs = {
                    reporting: {
                        source: 'ott auth',
                        context: 'ott auth'
                    }
                };
            }

            // NOTE: Supports new subscribe activation code page
            // https://espnjira.disney.com/browse/WEWEB-2044
            if (window.location.pathname === '/watch/subscribe') {
                oneIdConfig.optionalConfigs = {
                    reporting: {
                        source: 'ott auth',
                        context: 'dtc',
                        subcontext1: 'subscribe'
                    }
                };
            }

            if (!/\.espn\.com$/.test(window.location.hostname)) {
                oneIdConfig.responderPage = oneIdConfig.responderPage.replace('www.espn.com', window.location.hostname);
            }
            oneIdInstance = window.DisneyID.get(oneIdConfig);
            window.did = oneIdInstance;
            return oneIdInstance.init().then(function () {
                initialized = true;
                initializing = false;
                return oneIdInstance;
            }).catch(function (error) {
                console.error(error);
            });
        } else {
            // TODO: support passing `oneIdEnv`
            return loadDisneyID().then(get);
        }
    } else {
        return Promise.resolve(null);
    }
}

function loadDisneyID() {
    var oneIdEnv = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_1__enums__["x" /* OneIdEnv */].PROD;

    return disneyIdPromise || (disneyIdPromise = new __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a(function (resolve, reject) {
        if (window.DisneyID) {
            resolve(window.DisneyID);
        } else {
            var url = OneIdJs[oneIdEnv];
            var script = document.createElement('script');
            script.async = true;

            script.onload = function () {
                if (window.DisneyID) {
                    resolve(window.DisneyID);
                } else {
                    reject(new Error('script loaded but window.DisneyID not found.'));
                }
            };

            script.onerror = function () {
                reject(new Error('failed to load DisneyID'));
            };

            script.src = url;
            document.head.appendChild(script);
        }
    }));
}

// `getGuest()` rejects when user is not logged in, make sure to catch
var getGuest = function getGuest() {
    return get().then(function (oneId) {
        if (!oneId) {
            return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve();
        }
        return oneId.getGuest().catch(function (err) {
            // `GUEST_READ_FAILURE` when token is not valid,
            // but most likely `logout()` won't work either when this happens
            if (err === 'GUEST_READ_FAILURE') {
                return logout().then(function () {
                    return undefined;
                }).catch(function () {
                    return undefined;
                });
            }
            // this means user is not logged in, e.g. `Session not established`
            return undefined;
        });
    });
};

var getLoggedInStatus = function getLoggedInStatus(options) {
    return get().then(function (oneId) {
        return oneId && oneId.getLoggedInStatus(options);
    }).then(function (status) {
        return status;
    }).catch(function () {
        return false;
    });
};

var launchLogin = function launchLogin(options) {
    return get().then(function (oneId) {
        return oneId && oneId.launchLogin(options);
    });
};

var launchReauth = function launchReauth(options) {
    return get().then(function (oneId) {
        return oneId && oneId.launchReauth(options);
    }).catch(function () {
        return launchLogin(options);
    });
};

var forceTokenRefresh = function forceTokenRefresh() {
    return get().then(function (oneId) {
        return oneId && oneId.forceTokenRefresh();
    }).catch(function () {
        return undefined;
    });
};

var logout = function logout() {
    return get().then(function (oneId) {
        return oneId && oneId.logout();
    });
};

var on = function on(eventName, callback) {
    return get().then(function (oneId) {
        return oneId && oneId.on(eventName, callback);
    });
};

var off = function off(eventName, callback) {
    return get().then(function (oneId) {
        return oneId && oneId.off(eventName, callback);
    });
};

var getLicensePlateDataBag = function getLicensePlateDataBag(options) {
    return get().then(function (oneId) {
        return oneId && oneId.getLicensePlateDataBag(options);
    });
};

var launchLicensePlate = function launchLicensePlate(options) {
    return get().then(function (oneId) {
        return oneId && oneId.launchLicensePlate(options);
    });
};

var Error = {
    CANCEL_BY_USER: 'CANCEL_BY_USER',
    INVALID_PAIRING_CODE: 'INVALID_PAIRING_CODE',
    MISSING_PAIRING_CODE: 'MISSING_PAIRING_CODE',
    UNKNOWN_ERROR: 'UNKNOWN_ERROR'
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export providerDialogSelector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return displayProviderDialogSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return providersSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__authenticationSelectors__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_util_isEmpty__ = __webpack_require__(12);





/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_1__authenticationSelectors__["b" /* adobePassInfoSelector */], __WEBPACK_IMPORTED_MODULE_1__authenticationSelectors__["m" /* ipInfoSelector */], function (adobePassInfo, ipInfo) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_2__lib_util_isEmpty__["a" /* default */])(adobePassInfo)) {
        return adobePassInfo;
    } else if (!Object(__WEBPACK_IMPORTED_MODULE_2__lib_util_isEmpty__["a" /* default */])(ipInfo)) {
        return ipInfo;
    }
    return {};
}));

var providerDialogSelector = function providerDialogSelector(_ref) {
    var _ref$providerDialog = _ref.providerDialog,
        providerDialog = _ref$providerDialog === undefined ? {} : _ref$providerDialog;
    return providerDialog;
};

var displayProviderDialogSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(providerDialogSelector, function (_ref2) {
    var _ref2$display = _ref2.display,
        display = _ref2$display === undefined ? false : _ref2$display;
    return display;
});

var providersSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(providerDialogSelector, function (_ref3) {
    var _ref3$providers = _ref3.providers,
        providers = _ref3$providers === undefined ? [] : _ref3$providers;
    return providers;
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getNielsenValue */
/* unused harmony export getEventValueFromContent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return analyticsConstantsSelector; });
/* unused harmony export storyIdSelector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return navmethodSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return entitlementsTrackingSelector; });
/* unused harmony export promoTrackingSelector */
/* unused harmony export wasPersonalizedSelector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return nielsenTrackingSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return comscoreTrackingSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return pageTrackingSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return placementPrefixSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniq__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_uniq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_intersection__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_intersection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_intersection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__enums__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrapSelector__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__appSelector__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__providerSelector__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__apiParamsSelector__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__authenticationSelectors__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pageSelector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__selectedContentSelector__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__selectedStreamSelector__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__fanSelector__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__oneIdSelector__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__routingSelector__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib_auth_getAccessMethodFromAuthTypes__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lib_auth_streamHasAuthType__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__lib_util_isEmpty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__lib_omniture__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_cookie_cutter__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_cookie_cutter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_cookie_cutter__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();























var UPSTREAM_USERID = __WEBPACK_IMPORTED_MODULE_3__enums__["a" /* AdobePass */].METADATA.UPSTREAM_USERID;

// utility functions to format data specifically for nielsen

function yesOrNo(boolParam) {
    return boolParam === true ? 'yes' : 'no';
}

/**
 * getNielsenValue - Returns the expected nielsen value. If no value is defined, the fallbackValue
 * will be returned. Ensures backwards compatibility when called without fallbackValue will result
 * as 'Not Applicable'
 *
 * @param  {string} value - the expected value to be returned if defined
 * @param  {string} fallbackValue = 'Not Applicable' - fallback value when value is not defined
 * @return {string}
 */
var getNielsenValue = function getNielsenValue(value) {
    var fallbackValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Not Applicable';
    return value && typeof value === 'string' && value.trim() !== '' ? value : fallbackValue;
};

/**
 * getEventValueFromContent - Returns the proper NielsenValue if the content.type matches the
 * contentType parameter. Provides a fallback value option.
 *
 * @param  {object} content - object containing the type property that is used to compare with contentType
 * @param  {string} contentType - content type to match current content with
 * @param  {string} value - Expected value to be returned if condition is truthy
 * @param  {string} fallbackValue = 'Not Applicable' - fallback value when value is not defined
 * @return {string}
 */
var getEventValueFromContent = function getEventValueFromContent() {
    var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var contentType = arguments[1];
    var value = arguments[2];
    var fallbackValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'Not Applicable';
    return content && content.type === contentType ? getNielsenValue(value, fallbackValue) : fallbackValue;
};

function getNielsenPersonalizationData(fan) {
    if (Object.keys(fan).length > 0) {
        var _fan$profile$settings = fan.profile.settings,
            settings = _fan$profile$settings === undefined ? {} : _fan$profile$settings;
        var _settings$activeProdu = settings.activeProducts,
            activeProducts = _settings$activeProdu === undefined ? {} : _settings$activeProdu;
        var _activeProducts$metaD = activeProducts.metaData,
            metaData = _activeProducts$metaD === undefined ? {} : _activeProducts$metaD;


        var hasFantasy = Object.keys(metaData).filter(function (key) {
            return metaData[key] === 'true';
        }).map(function (key) {
            return key.indexOf('lm_') !== -1;
        }).length > 0;

        var hasFavorites = fan.preferences && fan.preferences.length > 0;
        var hasNotifications = fan.profile && fan.profile.hasNotificationPreferences;
        var videoAutoStart = settings.videoAutoStart && settings.videoAutoStart.value === '2';
        return 'has favorites:' + yesOrNo(hasFavorites) + '|fantasy:' + yesOrNo(hasFantasy) + '|notifications:' + hasNotifications + '|docking:no-autostart:' + yesOrNo(videoAutoStart); // eslint-disable-line
    }
    return 'Not Applicable';
}

function getNielsenLoginStatusFromFan(fan) {
    if (Object.keys(fan).length > 0) {
        return 'Registered:Logged in Active';
    }
    return 'Not Applicable';
}

function getActiveSubscriptions() {
    var subscriptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var stream = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // eslint-disable-line
    var packages = stream.packages;

    var activeSubscriptions = subscriptions.filter(function (_ref) {
        var isActive = _ref.isActive,
            _ref$products = _ref.products;
        _ref$products = _ref$products === undefined ? [] : _ref$products;

        var _ref$products2 = _slicedToArray(_ref$products, 1),
            _ref$products2$ = _ref$products2[0],
            product = _ref$products2$ === undefined ? {} : _ref$products2$,
            type = _ref.status.type;

        var _product$productEntit = product.productEntitlements;
        _product$productEntit = _product$productEntit === undefined ? [] : _product$productEntit;

        var _product$productEntit2 = _slicedToArray(_product$productEntit, 1),
            _product$productEntit3 = _product$productEntit2[0],
            entitlement = _product$productEntit3 === undefined ? {} : _product$productEntit3;

        return isActive && type === 'SUBSCRIBED' && (!packages || packages.indexOf(entitlement.name) > -1);
    });

    return activeSubscriptions;
}

function formatNielsenData() {
    var playbackMeta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var fan = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var provider = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var selectedContent = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    var selectedStream = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
    var userAuth = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
    var entitlementsTracking = arguments[7];
    var adobePassMetadata = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : {};
    var constants = arguments[9];
    var navmethod = arguments[10];
    var storyId = arguments[11];
    var wasPersonalized = arguments[12];
    var Site = constants.Site,
        ReportSuite = constants.ReportSuite,
        Edition = constants.Edition;
    var _playbackMeta$playbac = playbackMeta.playbackState,
        playbackState = _playbackMeta$playbac === undefined ? {} : _playbackMeta$playbac,
        _playbackMeta$trackin = playbackMeta.tracking,
        tracking = _playbackMeta$trackin === undefined ? {} : _playbackMeta$trackin;
    var usid = adobePassMetadata[UPSTREAM_USERID];

    if (provider.abbreviation === 'Comcast_SSO' || provider.abbreviation === 'YouTubeTV') {
        usid = undefined;
    }
    var Language = (page.lang || '').toLowerCase();
    var Placement = selectedContent.placement || 'player-direct';
    var PlayLocation = navmethod;
    var InsiderStatus = yesOrNo(fan.isInsider);

    // watch specific values
    var networkVal = selectedStream.source && selectedStream.source.dtc && selectedStream.source.dtc.toLowerCase() || selectedStream.source && selectedStream.source.id && selectedStream.source.id.toLowerCase() || selectedStream.source && selectedStream.source.name && selectedStream.source.name.toLowerCase();
    var Network = getEventValueFromContent(selectedContent, __WEBPACK_IMPORTED_MODULE_3__enums__["o" /* ContentType */].LISTING, networkVal);
    var AirDate = getEventValueFromContent(selectedContent, __WEBPACK_IMPORTED_MODULE_3__enums__["o" /* ContentType */].LISTING, selectedContent.date);
    var AirTime = getEventValueFromContent(selectedContent, __WEBPACK_IMPORTED_MODULE_3__enums__["o" /* ContentType */].LISTING, selectedContent.time);
    // TODO: DTC - `airingId` not available in stream
    var AiringID = getEventValueFromContent(selectedContent, __WEBPACK_IMPORTED_MODULE_3__enums__["o" /* ContentType */].LISTING, playbackState.airingId || playbackState.id);
    var isStudio = selectedContent.type === __WEBPACK_IMPORTED_MODULE_3__enums__["o" /* ContentType */].LISTING ? yesOrNo(tracking.isStudio) : 'Not Applicable';
    var trackingId = tracking.trackingId;
    var WasPersonalized = yesOrNo(wasPersonalized);
    var ProgramCode = getEventValueFromContent(selectedContent, __WEBPACK_IMPORTED_MODULE_3__enums__["o" /* ContentType */].LISTING, tracking.programCode);
    var SegC = ProgramCode;
    var SegA = selectedStream.name;

    var AccessMethod = getEventValueFromContent(selectedContent, __WEBPACK_IMPORTED_MODULE_3__enums__["o" /* ContentType */].LISTING, Object(__WEBPACK_IMPORTED_MODULE_15__lib_auth_getAccessMethodFromAuthTypes__["a" /* default */])(userAuth), 'Not Authenticated');
    var AuthenticationStatus = AccessMethod;
    var AffiliateName = getEventValueFromContent(selectedContent, __WEBPACK_IMPORTED_MODULE_3__enums__["o" /* ContentType */].LISTING, provider.package ? provider.abbreviation : provider.name, 'Not Authenticated');
    var AffiliateID = getEventValueFromContent(selectedContent, __WEBPACK_IMPORTED_MODULE_3__enums__["o" /* ContentType */].LISTING, provider.package ? provider.package.name : provider.abbreviation, 'Not Authenticated');
    usid = getEventValueFromContent(selectedContent, __WEBPACK_IMPORTED_MODULE_3__enums__["o" /* ContentType */].LISTING, usid);

    var LoginStatus = getNielsenLoginStatusFromFan(fan);
    var Personalization = getNielsenPersonalizationData(fan);
    var Embedded = 'no';

    var SWID = fan.id || typeof document !== 'undefined' && __WEBPACK_IMPORTED_MODULE_19_cookie_cutter___default.a.get('SWID');
    var unid = fan.id || typeof document !== 'undefined' && __WEBPACK_IMPORTED_MODULE_19_cookie_cutter___default.a.get('UNID');
    var UserAgent = typeof window !== 'undefined' ? window.navigator.userAgent : 'Not Applicable';

    // Entitlements
    var purchaseMethod = entitlementsTracking.purchaseMethod,
        subscriberType = entitlementsTracking.subscriberType,
        entitlements = entitlementsTracking.entitlements,
        oneIdLoggedIn = entitlementsTracking.oneIdLoggedIn,
        userTracking = entitlementsTracking.userTracking,
        hasSuperBundle = entitlementsTracking.hasSuperBundle;

    var PurchaseMethod = purchaseMethod || 'Not Applicable';
    var SubscriberType = subscriberType || 'Not Applicable';
    var DisneyPlusBundle = hasSuperBundle ? 'Yes' : 'No';
    var DTCEntitlements = entitlements || 'Not Applicable';
    var DSSID = Object(__WEBPACK_IMPORTED_MODULE_18__lib_omniture__["d" /* getOmnitureUserTrackingData */])(oneIdLoggedIn, userTracking);

    // #TODO get real orientation when mobile player launches
    var Orientation = 'Desktop';
    var VideoType = Object(__WEBPACK_IMPORTED_MODULE_18__lib_omniture__["e" /* getVideoTypeFromStream */])(selectedContent);
    var ContentDuration = tracking.duration || -1;
    var Sport = getNielsenValue(tracking.sport);
    var League = getNielsenValue(tracking.league);
    // if No League, set it equal to the sport, ask Hopkins.
    League = League !== 'No League' ? League : Sport;
    // TODO: DTC - is this currently working?
    var GameID = getNielsenValue(selectedContent.gameId);
    var PlayerName = VideoType === __WEBPACK_IMPORTED_MODULE_3__enums__["o" /* ContentType */].VOD ? 'Brightcove-vod' : 'Brightcove-live';
    if (selectedStream.authTypes && selectedStream.authTypes.indexOf(__WEBPACK_IMPORTED_MODULE_3__enums__["e" /* AuthTypes */].BAM) > -1) {
        PlayerName = 'BAM-live';
    }

    var VideoTypeDetail = getNielsenValue(tracking.coverageType);
    // #TODO: get these values
    var isVOD = selectedContent.type === __WEBPACK_IMPORTED_MODULE_3__enums__["o" /* ContentType */].VOD;
    var dateTimeArray = isVOD ? (tracking.originalPublishDate || '').split('T') : [];
    var PublishDate = isVOD ? dateTimeArray[0] : 'Not Applicable';
    var PublishTime = isVOD ? dateTimeArray[1] : 'Not Applicable';
    var ExpirationDate = isVOD ? tracking.expirationDate : 'Not Applicable';
    var DateLastModified = isVOD ? tracking.lastModified : 'Not Applicable';
    var CMSID = isVOD ? selectedContent.id + '-' + tracking.name : 'Not Applicable';
    var ShowCode = isVOD ? tracking.showCode : 'Not Applicable';
    var VideoPlaylist = 'Not Applicable';
    var isfullepisode = isVOD ? 'n' : 'y';
    var StoryID = storyId;

    return {
        Site: Site,
        ReportSuite: ReportSuite,
        SWID: SWID,
        UserAgent: UserAgent,
        Language: Language,
        Placement: Placement,
        PlayLocation: PlayLocation,
        Network: Network,
        InsiderStatus: InsiderStatus,
        AirDate: AirDate,
        AirTime: AirTime,
        AiringID: AiringID,
        isStudio: isStudio,
        trackingId: trackingId,
        WasPersonalized: WasPersonalized,
        SegA: SegA,
        SegC: SegC,
        ProgramCode: ProgramCode,
        LoginStatus: LoginStatus,
        Personalization: Personalization,
        Embedded: Embedded,
        Orientation: Orientation,
        AccessMethod: AccessMethod,
        AffiliateID: AffiliateID,
        AffiliateName: AffiliateName,
        AuthenticationStatus: AuthenticationStatus,
        PurchaseMethod: PurchaseMethod,
        SubscriberType: SubscriberType,
        Entitlements: DTCEntitlements,
        Edition: Edition,
        GameID: GameID,
        StoryID: StoryID,
        VideoType: VideoType,
        ContentDuration: ContentDuration,
        Sport: Sport,
        League: League,
        PlayerName: PlayerName,
        VideoTypeDetail: VideoTypeDetail,
        PublishDate: PublishDate,
        PublishTime: PublishTime,
        ExpirationDate: ExpirationDate,
        DateLastModified: DateLastModified,
        CMSID: CMSID,
        ShowCode: ShowCode,
        VideoPlaylist: VideoPlaylist,
        isfullepisode: isfullepisode,
        unid: unid,
        usid: usid,
        navmethod: navmethod,
        DSSID: DSSID,
        DisneyPlusBundle: DisneyPlusBundle
    };
}

var analyticsSelector = function analyticsSelector(_ref2) {
    var _ref2$app = _ref2.app;
    _ref2$app = _ref2$app === undefined ? {} : _ref2$app;
    var _ref2$app$analytics = _ref2$app.analytics,
        analytics = _ref2$app$analytics === undefined ? null : _ref2$app$analytics;
    return analytics;
};

var analyticsConstantsSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_5__appSelector__["j" /* default */], __WEBPACK_IMPORTED_MODULE_5__appSelector__["v" /* isSecureSelector */], __WEBPACK_IMPORTED_MODULE_5__appSelector__["u" /* isIntlSelector */], __WEBPACK_IMPORTED_MODULE_5__appSelector__["p" /* intlAppSelector */], __WEBPACK_IMPORTED_MODULE_5__appSelector__["k" /* editionSelector */], function (_ref3, isSecure, isIntl, intlApp, _ref4) {
    var env = _ref3.env,
        _ref3$location$path = _ref3.location.path,
        path = _ref3$location$path === undefined ? '' : _ref3$location$path;
    var edition = _ref4.edition;
    var Channel = __WEBPACK_IMPORTED_MODULE_18__lib_omniture__["a" /* OMNITURE_CONSTANTS */].Channel,
        Site = __WEBPACK_IMPORTED_MODULE_18__lib_omniture__["a" /* OMNITURE_CONSTANTS */].Site,
        ReportSuite = __WEBPACK_IMPORTED_MODULE_18__lib_omniture__["a" /* OMNITURE_CONSTANTS */].ReportSuite,
        ReportSuiteQA = __WEBPACK_IMPORTED_MODULE_18__lib_omniture__["a" /* OMNITURE_CONSTANTS */].ReportSuiteQA,
        ReportSuiteIntl = __WEBPACK_IMPORTED_MODULE_18__lib_omniture__["a" /* OMNITURE_CONSTANTS */].ReportSuiteIntl,
        ReportSuiteApp = __WEBPACK_IMPORTED_MODULE_18__lib_omniture__["a" /* OMNITURE_CONSTANTS */].ReportSuiteApp,
        TrackingServer = __WEBPACK_IMPORTED_MODULE_18__lib_omniture__["a" /* OMNITURE_CONSTANTS */].TrackingServer,
        SecureTrackingServer = __WEBPACK_IMPORTED_MODULE_18__lib_omniture__["a" /* OMNITURE_CONSTANTS */].SecureTrackingServer;

    var constants = {
        Channel: Channel,
        Site: Site,
        ReportSuite: ReportSuite,
        TrackingServer: isSecure ? SecureTrackingServer : TrackingServer,
        Edition: edition === 'us' ? 'en-us' : edition
    };
    if (intlApp) {
        constants.ReportSuite = ReportSuiteApp;
    } else if (isIntl) {
        // TODO: remove this on the 1st of the following month of the last intl. launch
        constants.ReportSuite = ReportSuiteIntl;
    } else if (env !== __WEBPACK_IMPORTED_MODULE_3__enums__["c" /* AppEnvs */].prod) {
        constants.ReportSuite = ReportSuiteQA;
    }

    if (path.indexOf('/activate') !== -1) {
        constants.Channel = 'device:activation';
    }

    return constants;
});

var storyIdSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_14__routingSelector__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pageSelector__["c" /* default */], function (_ref5) {
    var locationBeforeTransitions = _ref5.locationBeforeTransitions;

    var _ref6 = locationBeforeTransitions || {},
        _ref6$query = _ref6.query,
        query = _ref6$query === undefined ? {} : _ref6$query;

    var storyId = query['om-storyid'] || 'Not Applicable';

    return storyId;
});

var navmethodSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_14__routingSelector__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__selectedContentSelector__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pageSelector__["c" /* default */], function (_ref7, selectedContent, page) {
    var locationBeforeTransitions = _ref7.locationBeforeTransitions;

    var _ref8 = selectedContent || {},
        isHero = _ref8.isHero,
        placement = _ref8.placement,
        bucketName = _ref8.bucketName,
        pageId = _ref8.pageId,
        pageName = _ref8.pageName,
        omNavmethod = _ref8['om-navmethod'];

    var _ref9 = locationBeforeTransitions || {},
        _ref9$query = _ref9.query,
        query = _ref9$query === undefined ? {} : _ref9$query;

    var navmethod = query['om-navmethod'] || omNavmethod;
    // set navmethod on tile click, based on position
    if (!Object(__WEBPACK_IMPORTED_MODULE_17__lib_util_isEmpty__["a" /* default */])(selectedContent) && !navmethod) {
        var _pageId = pageId || page.id;
        var _pageName = pageName || page.name;
        var path = 'watch';
        if (_pageId === 'collection') {
            path += ':' + _pageName;
        } else if (_pageId !== 'home') {
            path += ':' + _pageId;
        }

        var rowName = 'Not Applicable';
        if (isHero || placement === 'inline-hero') {
            rowName = 'hero';
        } else if (bucketName) {
            rowName = bucketName;
        }

        navmethod = path + ':' + rowName;
    }

    return navmethod;
});

var entitlementsTrackingSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_5__appSelector__["s" /* isDomesticSelector */], __WEBPACK_IMPORTED_MODULE_8__authenticationSelectors__["p" /* subscriptionsSelector */], __WEBPACK_IMPORTED_MODULE_13__oneIdSelector__["d" /* oneIdEntitlementsSelector */], __WEBPACK_IMPORTED_MODULE_13__oneIdSelector__["f" /* oneIdLoggedInSelector */], __WEBPACK_IMPORTED_MODULE_8__authenticationSelectors__["t" /* userTrackingSelector */], __WEBPACK_IMPORTED_MODULE_8__authenticationSelectors__["q" /* superBundleSelector */], function (isDomestic, subscriptions) {
    var entitlementsArg = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var oneIdLoggedIn = arguments[3];
    var userTracking = arguments[4];
    var hasSuperBundle = arguments[5];

    if (!isDomestic) {
        return {};
    }

    var purchaseMethod = [];
    var subscriberType = 'not subscribed';
    var entitlements = entitlementsArg;

    if (subscriptions) {
        purchaseMethod = __WEBPACK_IMPORTED_MODULE_1_lodash_uniq___default()(subscriptions.map(function (_ref10) {
            var _ref10$source = _ref10.source;
            _ref10$source = _ref10$source === undefined ? {} : _ref10$source;
            var provider = _ref10$source.provider;
            return provider && provider.toLowerCase();
        }));

        var subscriberTypes = __WEBPACK_IMPORTED_MODULE_1_lodash_uniq___default()(subscriptions.map(function (_ref11) {
            var isActive = _ref11.isActive;
            return isActive;
        }));

        if (subscriberTypes.length) {
            subscriberType = subscriberTypes.some(function (isActive) {
                return !!isActive;
            }) ? 'active' : 'inactive';
        }
    }

    if (!purchaseMethod.length) {
        purchaseMethod = ['no entitlements'];
    }

    if (!entitlements.length) {
        entitlements = ['no entitlements'];
    }

    return {
        hasSuperBundle: hasSuperBundle,
        subscriberType: subscriberType,
        oneIdLoggedIn: oneIdLoggedIn,
        userTracking: userTracking,
        purchaseMethod: purchaseMethod.join(','),
        entitlements: entitlements.join(',')
    };
});

var promoTrackingSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_4__bootstrapSelector__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pageSelector__["c" /* default */], __WEBPACK_IMPORTED_MODULE_9__pageSelector__["g" /* showPromoSelector */], function (_ref12, _ref13, showPromo) {
    var _ref12$sku = _ref12.sku,
        sku = _ref12$sku === undefined ? [] : _ref12$sku;
    var id = _ref13.id;

    var productsVal = void 0;
    if (id !== 'espnplus' || !showPromo) {
        return productsVal;
    }
    var products = sku.filter(function (_ref14) {
        var _ref14$name = _ref14.name,
            name = _ref14$name === undefined ? '' : _ref14$name;
        return name.toLowerCase().indexOf('base') > -1;
    }).map(function (_ref15) {
        var value = _ref15.value;
        return ';' + value;
    });
    productsVal = 'D2C' + products.join(',');
    return productsVal;
});

var wasPersonalizedSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_4__bootstrapSelector__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__apiParamsSelector__["e" /* pageAPIParamsSelector */], function (_ref16, pageAPIParams) {
    var _ref16$pageApi = _ref16.pageApi;
    _ref16$pageApi = _ref16$pageApi === undefined ? {} : _ref16$pageApi;
    var _ref16$pageApi$requir = _ref16$pageApi.requireClientRenderParams,
        requireClientRenderParams = _ref16$pageApi$requir === undefined ? [] : _ref16$pageApi$requir;

    var hasPersonalizedParams = __WEBPACK_IMPORTED_MODULE_2_lodash_intersection___default()(Object.keys(pageAPIParams), requireClientRenderParams).length > 0;
    return hasPersonalizedParams;
});

// last argument on the selector gets passed the previous arguments
var nielsenTrackingSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_5__appSelector__["A" /* playbackMetaSelector */], __WEBPACK_IMPORTED_MODULE_12__fanSelector__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pageSelector__["c" /* default */], __WEBPACK_IMPORTED_MODULE_6__providerSelector__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__selectedContentSelector__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__selectedStreamSelector__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__authenticationSelectors__["r" /* userAuthSelector */], entitlementsTrackingSelector, __WEBPACK_IMPORTED_MODULE_8__authenticationSelectors__["e" /* adobePassMetadataSelector */], analyticsConstantsSelector, navmethodSelector, storyIdSelector, wasPersonalizedSelector, formatNielsenData);

var comscoreTrackingSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_5__appSelector__["k" /* editionSelector */], __WEBPACK_IMPORTED_MODULE_11__selectedStreamSelector__["a" /* default */], function (_ref17, selectedStream) {
    var edition = _ref17.edition;

    var c3 = void 0;
    var c4 = edition === 'brazil' ? '"watchespncombr"' : '"watchespncom"';
    if (Object(__WEBPACK_IMPORTED_MODULE_16__lib_auth_streamHasAuthType__["a" /* default */])(selectedStream, __WEBPACK_IMPORTED_MODULE_3__enums__["e" /* AuthTypes */].BAM)) {
        c4 = '"' + __WEBPACK_IMPORTED_MODULE_3__enums__["m" /* ComScoreC3 */][__WEBPACK_IMPORTED_MODULE_3__enums__["s" /* Entitlements */].ESPN_PLUS] + '"';
        var _selectedStream$packa = selectedStream.packages,
            packages = _selectedStream$packa === undefined ? [] : _selectedStream$packa;

        if (packages.length) {
            if (packages.indexOf(__WEBPACK_IMPORTED_MODULE_3__enums__["s" /* Entitlements */].ESPN_PLUS) > -1) {
                c3 = __WEBPACK_IMPORTED_MODULE_3__enums__["m" /* ComScoreC3 */][__WEBPACK_IMPORTED_MODULE_3__enums__["s" /* Entitlements */].ESPN_PLUS];
            } else {
                c3 = __WEBPACK_IMPORTED_MODULE_3__enums__["m" /* ComScoreC3 */][packages[0]];
            }
        }
    }
    var labels = {
        c4: c4
    };
    if (c3) {
        labels.c3 = '"' + c3 + '"';
    }
    return {
        labels: labels
    };
});

var pageTrackingSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_5__appSelector__["s" /* isDomesticSelector */], __WEBPACK_IMPORTED_MODULE_8__authenticationSelectors__["b" /* adobePassInfoSelector */], analyticsSelector, __WEBPACK_IMPORTED_MODULE_5__appSelector__["j" /* default */], __WEBPACK_IMPORTED_MODULE_8__authenticationSelectors__["m" /* ipInfoSelector */], __WEBPACK_IMPORTED_MODULE_9__pageSelector__["c" /* default */], __WEBPACK_IMPORTED_MODULE_8__authenticationSelectors__["r" /* userAuthSelector */], __WEBPACK_IMPORTED_MODULE_8__authenticationSelectors__["p" /* subscriptionsSelector */], __WEBPACK_IMPORTED_MODULE_13__oneIdSelector__["f" /* oneIdLoggedInSelector */], entitlementsTrackingSelector, promoTrackingSelector, __WEBPACK_IMPORTED_MODULE_8__authenticationSelectors__["e" /* adobePassMetadataSelector */], function (isDomestic, adobePassInfo, analytics, app, ipInfo, page, userAuth, subscriptions, oneIdLoggedIn, entitlementsTracking, promoTracking, adobePassMetadata) {
    return {
        isDomestic: isDomestic,
        adobePassInfo: adobePassInfo,
        analytics: analytics,
        app: app,
        ipInfo: ipInfo,
        page: page,
        userAuth: userAuth,
        subscriptions: subscriptions,
        oneIdLoggedIn: oneIdLoggedIn,
        entitlementsTracking: entitlementsTracking,
        promoTracking: promoTracking,
        adobePassMetadata: adobePassMetadata
    };
});

var placementPrefixSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_9__pageSelector__["c" /* default */], function (page) {
    var prefix = page.id;
    if (page.id === 'collection' || page.id === 'product') {
        prefix += '-' + page.name;
    }
    prefix += '-';
    return prefix;
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SEARCH_TYPES; });
/* harmony export (immutable) */ __webpack_exports__["b"] = addContentToStream;
/* unused harmony export parseContents */
/* harmony export (immutable) */ __webpack_exports__["k"] = graphql;
/* harmony export (immutable) */ __webpack_exports__["i"] = getSearchResults;
/* harmony export (immutable) */ __webpack_exports__["l"] = loadBootstrap;
/* harmony export (immutable) */ __webpack_exports__["f"] = getPage;
/* harmony export (immutable) */ __webpack_exports__["e"] = getEvent;
/* harmony export (immutable) */ __webpack_exports__["j"] = getVideo;
/* harmony export (immutable) */ __webpack_exports__["d"] = getBucketPage;
/* harmony export (immutable) */ __webpack_exports__["h"] = getPageWithPathId;
/* harmony export (immutable) */ __webpack_exports__["g"] = getPageByFullUrl;
/* unused harmony export getScoringInfluencers */
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchPickerStreams;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_api__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors_bootstrapSelector__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__selectors_apiParamsSelector__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__selectors_appSelector__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectors_authenticationSelectors__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__appActions__ = __webpack_require__(19);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








// un-comment to debug multiple feeds scenario
// import getTestFeed from 'lib/api/TestFeeds';

var SEARCH_TYPES = {
    search: 'SEARCH',
    suggest: 'SUGGEST',
    competitors: 'COMPETITORS',
    listingsByCompetitor: 'LISTINGS_BY_COMPETITOR'
};

function addRecommendedConentIdsToContents(contents) {
    var recommendedContentIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    // To each content containing `dss` object, we want to expose the `recommendedContentIds` array
    contents.forEach(function (content) {
        if (content.dss) {
            content.dss.recommendedContentIds = recommendedContentIds;
        }
    });
}

function addContentToStream(content) {
    var streams = content.streams,
        contentParams = _objectWithoutProperties(content, ['streams']);

    if (Array.isArray(streams) && streams.length > 0) {
        streams.forEach(function (stream) {
            // should we just add content id and look up content metadata on demand?
            stream.contentId = content.id;
            stream.content = contentParams;
            // adds dss object to top level content
            if (stream.dss) {
                content.dss = stream.dss;
            }
        });
    }

    return content;
}

function parseContents(contents) {
    if (!contents) {
        return contents;
    }
    var recommendedContentIds = [];

    if (!Array.isArray(contents)) {
        return addContentToStream(contents);
    }

    contents.forEach(function (content) {
        addContentToStream(content);
        // NOTE: For each given content containing `dss.contentId`, we want to keep track via
        // recommendedContentIds which is required when executing `sendContentReward()`.
        if (content.dss && content.dss.contentId) {
            recommendedContentIds.push(content.dss.contentId);
        }
    });

    if (recommendedContentIds.length) {
        addRecommendedConentIdsToContents(contents, recommendedContentIds);
    }

    return contents;
}

function graphql(api, variables) {
    return function (dispatch, getState) {
        var state = getState();

        var _graphqlParamsSelecto = Object(__WEBPACK_IMPORTED_MODULE_3__selectors_apiParamsSelector__["c" /* graphqlParamsSelector */])(state),
            apiEnv = _graphqlParamsSelecto.apiEnv,
            lang = _graphqlParamsSelecto.lang,
            params = _objectWithoutProperties(_graphqlParamsSelecto, ['apiEnv', 'lang']);

        return __WEBPACK_IMPORTED_MODULE_1__lib_api__["c" /* GraphQL */][api]({
            apiEnv: apiEnv,
            lang: lang,
            variables: _extends({}, params, variables)
        });
    };
}

function getSearchResults(query, apiEnv) {
    var endpoint = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : SEARCH_TYPES.search;

    var _this = this;

    var sortBy = arguments[3];
    var sortOrder = arguments[4];

    if (query.length === 0) {
        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.reject('No Query Entered'));

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));
    }
    switch (endpoint) {
        case SEARCH_TYPES.suggest:
            return function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
                    var state, suggestApiParams, data;
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    state = getState();
                                    suggestApiParams = Object(__WEBPACK_IMPORTED_MODULE_3__selectors_apiParamsSelector__["h" /* suggestApiParamsSelector */])(state);
                                    _context2.next = 4;
                                    return __WEBPACK_IMPORTED_MODULE_1__lib_api__["e" /* SearchAPI */].getSuggestion(query, apiEnv, _extends({}, suggestApiParams));

                                case 4:
                                    data = _context2.sent;
                                    return _context2.abrupt('return', data);

                                case 6:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, _this);
                }));

                return function (_x3, _x4) {
                    return _ref2.apply(this, arguments);
                };
            }();
        case SEARCH_TYPES.competitors:
            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                return _context3.abrupt('return', __WEBPACK_IMPORTED_MODULE_1__lib_api__["e" /* SearchAPI */].getAllCompetitors(apiEnv));

                            case 1:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this);
            }));
        case SEARCH_TYPES.listingsByCompetitor:
            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                return _context4.abrupt('return', __WEBPACK_IMPORTED_MODULE_1__lib_api__["e" /* SearchAPI */].getEventsForTeam(query, apiEnv, { size: 1000, includes: 'sid', sortBy: sortBy, sortOrder: sortOrder }));

                            case 1:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this);
            }));
        case SEARCH_TYPES.search:
        default:
            return function () {
                var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(dispatch, getState) {
                    var state, searchApiParams, data;
                    return regeneratorRuntime.wrap(function _callee5$(_context5) {
                        while (1) {
                            switch (_context5.prev = _context5.next) {
                                case 0:
                                    state = getState();
                                    searchApiParams = Object(__WEBPACK_IMPORTED_MODULE_3__selectors_apiParamsSelector__["f" /* searchApiParamsSelector */])(state);
                                    _context5.next = 4;
                                    return __WEBPACK_IMPORTED_MODULE_1__lib_api__["e" /* SearchAPI */].getSearchResults(query, apiEnv, _extends({}, searchApiParams));

                                case 4:
                                    data = _context5.sent;
                                    return _context5.abrupt('return', data);

                                case 6:
                                case 'end':
                                    return _context5.stop();
                            }
                        }
                    }, _callee5, _this);
                }));

                return function (_x5, _x6) {
                    return _ref5.apply(this, arguments);
                };
            }();
    }
}

function loadBootstrap() {
    var _this2 = this;

    return function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(dispatch, getState) {
            var configEnv, config;
            return regeneratorRuntime.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            configEnv = Object(__WEBPACK_IMPORTED_MODULE_4__selectors_appSelector__["f" /* configEnvSelector */])(getState());
                            _context6.next = 3;
                            return __WEBPACK_IMPORTED_MODULE_1__lib_api__["a" /* Bootstrap */].loadBootstrap({ configEnv: configEnv });

                        case 3:
                            config = _context6.sent;
                            return _context6.abrupt('return', config);

                        case 5:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, _this2);
        }));

        return function (_x7, _x8) {
            return _ref6.apply(this, arguments);
        };
    }();
}

var testFeed = void 0; // eslint-disable-line prefer-const;

function getPage(_ref7) {
    var _this3 = this;

    var name = _ref7.name,
        paramsArg = _objectWithoutProperties(_ref7, ['name']);

    return function () {
        var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(dispatch, getState) {
            var state, _bootstrapSelector, _bootstrapSelector$pa, _bootstrapSelector$pa2, pages, sessionToken, isTopLevel, pageAPIParams, data;

            return regeneratorRuntime.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            state = getState();
                            _bootstrapSelector = Object(__WEBPACK_IMPORTED_MODULE_2__selectors_bootstrapSelector__["a" /* default */])(state), _bootstrapSelector$pa = _bootstrapSelector.pageApi;
                            _bootstrapSelector$pa = _bootstrapSelector$pa === undefined ? {} : _bootstrapSelector$pa;
                            _bootstrapSelector$pa2 = _bootstrapSelector$pa.pages, pages = _bootstrapSelector$pa2 === undefined ? [] : _bootstrapSelector$pa2;
                            sessionToken = Object(__WEBPACK_IMPORTED_MODULE_5__selectors_authenticationSelectors__["j" /* bamSessionTokenSelector */])(getState());
                            isTopLevel = pages.some(function (_ref9) {
                                var id = _ref9.id;
                                return id === name;
                            });
                            pageAPIParams = isTopLevel ? Object(__WEBPACK_IMPORTED_MODULE_3__selectors_apiParamsSelector__["e" /* pageAPIParamsSelector */])(state) : Object(__WEBPACK_IMPORTED_MODULE_3__selectors_apiParamsSelector__["d" /* pageAPILimitedParamsSelector */])(state);
                            _context7.next = 9;
                            return __WEBPACK_IMPORTED_MODULE_1__lib_api__["d" /* PageAPI */].getPage(_extends({}, pageAPIParams, paramsArg, {
                                name: name,
                                sessionToken: sessionToken
                            }));

                        case 9:
                            data = _context7.sent;


                            // un-comment to debug multiple feeds scenario
                            // testFeed = getTestFeed('espn3', configEnvSelector(getState()));
                            if (data && data.page && data.page.buckets) {
                                if (testFeed && data.page.buckets[0].contents[0].streams) {
                                    data.page.buckets[0].contents[0].streams.push(testFeed);
                                }
                                data.page.buckets.forEach(function (bucket) {
                                    var contents = bucket.contents;

                                    bucket.contents = parseContents(contents);
                                });
                            }

                            return _context7.abrupt('return', data);

                        case 12:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, _this3);
        }));

        return function (_x9, _x10) {
            return _ref8.apply(this, arguments);
        };
    }();
}

function getEvent(_ref10) {
    var _this4 = this;

    var query = _ref10.query,
        paramsArg = _objectWithoutProperties(_ref10, ['query']);

    return function () {
        var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(dispatch, getState) {
            var state, pageAPIParams, data, notReplays, content;
            return regeneratorRuntime.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            state = getState();
                            pageAPIParams = Object(__WEBPACK_IMPORTED_MODULE_3__selectors_apiParamsSelector__["d" /* pageAPILimitedParamsSelector */])(state);
                            _context8.next = 4;
                            return __WEBPACK_IMPORTED_MODULE_1__lib_api__["d" /* PageAPI */].getEvent(_extends({}, pageAPIParams, paramsArg, {
                                query: query
                            }));

                        case 4:
                            data = _context8.sent;
                            notReplays = void 0;
                            // un-comment to debug multiple feeds scenario
                            // testFeed = getTestFeed('espn3', configEnvSelector(getState()));

                            if (data && data.page && data.page.contents) {
                                if (testFeed) {
                                    data.page.contents.streams.push(testFeed);
                                }
                                data.page.contents = parseContents(data.page.contents);

                                content = data.page.contents[0];

                                if (content && !query.status) {
                                    notReplays = content.streams.filter(function (stream) {
                                        return stream.status !== 'upcoming';
                                    });
                                }
                            }

                            return _context8.abrupt('return', notReplays || data);

                        case 8:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, _this4);
        }));

        return function (_x11, _x12) {
            return _ref11.apply(this, arguments);
        };
    }();
}

function getVideo(_ref12) {
    var _this5 = this;

    var pathParams = _ref12.pathParams,
        paramsArg = _objectWithoutProperties(_ref12, ['pathParams']);

    return function () {
        var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(dispatch, getState) {
            var state, pageAPIParams, data;
            return regeneratorRuntime.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            state = getState();
                            pageAPIParams = Object(__WEBPACK_IMPORTED_MODULE_3__selectors_apiParamsSelector__["d" /* pageAPILimitedParamsSelector */])(state);
                            _context9.next = 4;
                            return __WEBPACK_IMPORTED_MODULE_1__lib_api__["d" /* PageAPI */].getVideo(_extends({}, pageAPIParams, paramsArg, {
                                pathParams: pathParams
                            }));

                        case 4:
                            data = _context9.sent;


                            if (data && data.page && data.page.contents) {
                                data.page.contents = parseContents(data.page.contents);
                            }

                            return _context9.abrupt('return', data);

                        case 7:
                        case 'end':
                            return _context9.stop();
                    }
                }
            }, _callee9, _this5);
        }));

        return function (_x13, _x14) {
            return _ref13.apply(this, arguments);
        };
    }();
}

function getBucketPage(_ref14) {
    var _this6 = this;

    var bucketId = _ref14.bucketId,
        groupId = _ref14.groupId,
        ignores = _ref14.ignores,
        paramsArg = _objectWithoutProperties(_ref14, ['bucketId', 'groupId', 'ignores']);

    return function () {
        var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(dispatch, getState) {
            var state, pageAPIParams, sessionToken, data;
            return regeneratorRuntime.wrap(function _callee10$(_context10) {
                while (1) {
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            state = getState();
                            pageAPIParams = Object(__WEBPACK_IMPORTED_MODULE_3__selectors_apiParamsSelector__["e" /* pageAPIParamsSelector */])(state);
                            sessionToken = Object(__WEBPACK_IMPORTED_MODULE_5__selectors_authenticationSelectors__["j" /* bamSessionTokenSelector */])(getState());
                            _context10.next = 5;
                            return __WEBPACK_IMPORTED_MODULE_1__lib_api__["d" /* PageAPI */].getBucketPage(_extends({}, pageAPIParams, paramsArg, {
                                bucketId: bucketId,
                                groupId: groupId,
                                ignores: ignores,
                                sessionToken: sessionToken
                            }));

                        case 5:
                            data = _context10.sent;


                            if (data && data.page && data.page.buckets) {
                                data.page.buckets.forEach(function (bucket) {
                                    var contents = bucket.contents;

                                    bucket.contents = parseContents(contents);
                                });
                            }

                            return _context10.abrupt('return', data);

                        case 8:
                        case 'end':
                            return _context10.stop();
                    }
                }
            }, _callee10, _this6);
        }));

        return function (_x15, _x16) {
            return _ref15.apply(this, arguments);
        };
    }();
}

function getPageWithPathId(_ref16) {
    var _this7 = this;

    var name = _ref16.name,
        pathParams = _ref16.pathParams,
        paramsArg = _objectWithoutProperties(_ref16, ['name', 'pathParams']);

    return function () {
        var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(dispatch, getState) {
            var state, pageAPIParams, sessionToken, data;
            return regeneratorRuntime.wrap(function _callee11$(_context11) {
                while (1) {
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            state = getState();
                            pageAPIParams = Object(__WEBPACK_IMPORTED_MODULE_3__selectors_apiParamsSelector__["d" /* pageAPILimitedParamsSelector */])(state);
                            sessionToken = Object(__WEBPACK_IMPORTED_MODULE_5__selectors_authenticationSelectors__["j" /* bamSessionTokenSelector */])(getState());
                            _context11.next = 5;
                            return __WEBPACK_IMPORTED_MODULE_1__lib_api__["d" /* PageAPI */].getPage(_extends({}, pageAPIParams, paramsArg, {
                                name: name,
                                sessionToken: sessionToken,
                                pathParams: pathParams
                            }));

                        case 5:
                            data = _context11.sent;


                            if (data && data.page && data.page.buckets) {
                                data.page.buckets.forEach(function (bucket) {
                                    var contents = bucket.contents;

                                    bucket.contents = contents;
                                });
                            }

                            return _context11.abrupt('return', data);

                        case 8:
                        case 'end':
                            return _context11.stop();
                    }
                }
            }, _callee11, _this7);
        }));

        return function (_x17, _x18) {
            return _ref17.apply(this, arguments);
        };
    }();
}

function getPageByFullUrl(_ref18) {
    var _this8 = this;

    var url = _ref18.url,
        paramsArg = _objectWithoutProperties(_ref18, ['url']);

    return function () {
        var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(dispatch, getState) {
            var state, pageAPIParams, sessionToken, data;
            return regeneratorRuntime.wrap(function _callee12$(_context12) {
                while (1) {
                    switch (_context12.prev = _context12.next) {
                        case 0:
                            state = getState();
                            pageAPIParams = Object(__WEBPACK_IMPORTED_MODULE_3__selectors_apiParamsSelector__["d" /* pageAPILimitedParamsSelector */])(state);
                            sessionToken = Object(__WEBPACK_IMPORTED_MODULE_5__selectors_authenticationSelectors__["j" /* bamSessionTokenSelector */])(getState());
                            _context12.next = 5;
                            return __WEBPACK_IMPORTED_MODULE_1__lib_api__["d" /* PageAPI */].getPageByFullUrl(_extends({}, pageAPIParams, paramsArg, {
                                url: url,
                                sessionToken: sessionToken
                            }));

                        case 5:
                            data = _context12.sent;


                            if (data && data.page && data.page.buckets) {
                                data.page.buckets.forEach(function (bucket) {
                                    var contents = bucket.contents;

                                    bucket.contents = parseContents(contents);
                                });
                            }

                            return _context12.abrupt('return', data);

                        case 8:
                        case 'end':
                            return _context12.stop();
                    }
                }
            }, _callee12, _this8);
        }));

        return function (_x19, _x20) {
            return _ref19.apply(this, arguments);
        };
    }();
}

function getScoringInfluencers(paramsArg) {
    return function (dispatch, getState) {
        var params = Object(__WEBPACK_IMPORTED_MODULE_3__selectors_apiParamsSelector__["b" /* default */])(getState());
        return __WEBPACK_IMPORTED_MODULE_1__lib_api__["d" /* PageAPI */].getScoringInfluencers(_extends({}, params, paramsArg));
    };
}

function fetchPickerStreams(pickerUrl, eventId) {
    var _this9 = this;

    return function () {
        var _ref20 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(dispatch) {
            var data, _data$page, buckets;

            return regeneratorRuntime.wrap(function _callee13$(_context13) {
                while (1) {
                    switch (_context13.prev = _context13.next) {
                        case 0:
                            _context13.prev = 0;
                            _context13.next = 3;
                            return __WEBPACK_IMPORTED_MODULE_1__lib_api__["d" /* PageAPI */].getPickerStreams(pickerUrl);

                        case 3:
                            data = _context13.sent;
                            _data$page = data.page;
                            _data$page = _data$page === undefined ? {} : _data$page;
                            buckets = _data$page.buckets;

                            // NOTE: The `espn-web-player` is written to respect the nested `content` object
                            // within the stream object (parent). In order to ensure backwards compatibility,
                            // we need to maintain the same structure.
                            // This happens when the new `stream picker` is displayed during an AuthZ error state
                            // to allow the user to transition to a new stream

                            if (!(Array.isArray(buckets) && buckets.length)) {
                                _context13.next = 12;
                                break;
                            }

                            buckets.forEach(function (bucket) {
                                var contents = bucket.contents;

                                bucket.contents = parseContents(contents);
                            });

                            dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__appActions__["I" /* pickerStreamsSelect */])(buckets, eventId));
                            _context13.next = 13;
                            break;

                        case 12:
                            throw new Error('Picker buckets list is not an array or empty');

                        case 13:
                            return _context13.abrupt('return', buckets);

                        case 16:
                            _context13.prev = 16;
                            _context13.t0 = _context13['catch'](0);

                            dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__appActions__["J" /* pickerStreamsSelectError */])(_context13.t0));
                            return _context13.abrupt('return', []);

                        case 20:
                        case 'end':
                            return _context13.stop();
                    }
                }
            }, _callee13, _this9, [[0, 16]]);
        }));

        return function (_x21) {
            return _ref20.apply(this, arguments);
        };
    }();
}

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return heroImageSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pageSelector__ = __webpack_require__(13);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_1__pageSelector__["c" /* default */], function (_ref) {
    var _ref$hero = _ref.hero,
        hero = _ref$hero === undefined ? {} : _ref$hero;
    return hero;
}));

// Need to do this until the Page API can handle device specific images
// Selector takes a content and returns the imageHref
var heroImageParams = '&templateId=espn.web.hero.1&size=xxl';
var contentSelector = function contentSelector() {
    var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return content;
};
var heroImageSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(contentSelector, function (_ref2) {
    var _ref2$imageHref = _ref2.imageHref,
        imageHref = _ref2$imageHref === undefined ? '' : _ref2$imageHref;
    return imageHref.indexOf('espncdn.com/stitcher/artwork/collections') === -1 ? imageHref : '' + imageHref + heroImageParams;
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_oneId__ = __webpack_require__(52);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var MainContainer = function (_Component) {
    _inherits(MainContainer, _Component);

    function MainContainer() {
        _classCallCheck(this, MainContainer);

        return _possibleConstructorReturn(this, (MainContainer.__proto__ || Object.getPrototypeOf(MainContainer)).apply(this, arguments));
    }

    _createClass(MainContainer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var showLogin = this.props.showLogin;
            // navigating between routes could have potentially wiped away espn_ui's reference to the main-container
            // this reinitializes that container after re-render

            if (window.espn_ui && window.espn_ui.Helpers && window.espn_ui.Helpers.page && window.jQuery) {
                window.espn_ui.Helpers.page.container = window.jQuery('#main-container');
            }

            if (showLogin) {
                try {
                    Object(__WEBPACK_IMPORTED_MODULE_1__lib_oneId__["k" /* on */])('login', function () {
                        /**
                         * trigger page reload so that oneId login state will be refreshed
                         * and user can see playback after logging in
                         */
                        window.location.reload();
                    });
                    Object(__WEBPACK_IMPORTED_MODULE_1__lib_oneId__["g" /* launchLogin */])();
                } catch (err) {
                    console.error('Show login error: ' + err);
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _jsx('div', {
                className: this.props.className
            }, void 0, this.props.pre, _jsx('section', {
                id: 'main-container'
            }, void 0, _jsx('div', {
                className: 'main-content layout-dbc'
            }, void 0, this.props.children)));
        }
    }]);

    return MainContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (MainContainer);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.isReactChildren = isReactChildren;
exports.createRouteFromReactElement = createRouteFromReactElement;
exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
exports.createRoutes = createRoutes;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isValidChild(object) {
  return object == null || _react2.default.isValidElement(object);
}

function isReactChildren(object) {
  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
}

function createRoute(defaultProps, props) {
  return _extends({}, defaultProps, props);
}

function createRouteFromReactElement(element) {
  var type = element.type;
  var route = createRoute(type.defaultProps, element.props);

  if (route.children) {
    var childRoutes = createRoutesFromReactChildren(route.children, route);

    if (childRoutes.length) route.childRoutes = childRoutes;

    delete route.children;
  }

  return route;
}

/**
 * Creates and returns a routes object from the given ReactChildren. JSX
 * provides a convenient way to visualize how routes in the hierarchy are
 * nested.
 *
 *   import { Route, createRoutesFromReactChildren } from 'react-router'
 *
 *   const routes = createRoutesFromReactChildren(
 *     <Route component={App}>
 *       <Route path="home" component={Dashboard}/>
 *       <Route path="news" component={NewsFeed}/>
 *     </Route>
 *   )
 *
 * Note: This method is automatically used when you provide <Route> children
 * to a <Router> component.
 */
function createRoutesFromReactChildren(children, parentRoute) {
  var routes = [];

  _react2.default.Children.forEach(children, function (element) {
    if (_react2.default.isValidElement(element)) {
      // Component classes may have a static create* method.
      if (element.type.createRouteFromReactElement) {
        var route = element.type.createRouteFromReactElement(element, parentRoute);

        if (route) routes.push(route);
      } else {
        routes.push(createRouteFromReactElement(element));
      }
    }
  });

  return routes;
}

/**
 * Creates and returns an array of routes from the given object which
 * may be a JSX route, a plain object route, or an array of either.
 */
function createRoutes(routes) {
  if (isReactChildren(routes)) {
    routes = createRoutesFromReactChildren(routes);
  } else if (routes && !Array.isArray(routes)) {
    routes = [routes];
  }

  return routes;
}

/***/ }),
/* 59 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getContentId;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums__ = __webpack_require__(1);


function getContentId() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        id = _ref.id,
        eventId = _ref.eventId,
        status = _ref.status,
        isEvent = _ref.isEvent,
        _ref$streams = _ref.streams,
        streams = _ref$streams === undefined ? [] : _ref$streams,
        _ref$isEventOverride = _ref.isEventOverride,
        isEventOverride = _ref$isEventOverride === undefined ? false : _ref$isEventOverride;

    var content = { id: streams[0] && streams[0].id || id };
    // if (streams.length > 1 || isEventOverride || (status === ContentStatus.UPCOMING && (isEvent))) {
    //     content = { eventId: eventId || id };
    // }
    return content;
}

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/* harmony default export */ __webpack_exports__["a"] = (canUseDOM);

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);


var selectedStreamSelector = function selectedStreamSelector(_ref) {
  var app = _ref.app;
  return app.selectedStream;
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(selectedStreamSelector, function (selectedStream) {
  return selectedStream;
}));

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REQUEST_SCHEDULE_MODULE_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RECEIVE_SCHEDULE_MODULE_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SCORE_SCHEDULE_MODULE_DATA; });
/* unused harmony export createReceiveScheduleModuleAction */
/* harmony export (immutable) */ __webpack_exports__["d"] = fetchScheduleModule;
/* unused harmony export completeScheduleModuleScoring */
/* harmony export (immutable) */ __webpack_exports__["e"] = scoreScheduleModule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_apiAction__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectors_bootstrapSelector__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors_routingSelector__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_format_getMinutesUntilStart__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_uniqBy__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_util_perf__ = __webpack_require__(75);








var REQUEST_SCHEDULE_MODULE_DATA = 'REQUEST_SCHEDULE_MODULE_DATA';
var RECEIVE_SCHEDULE_MODULE_DATA = 'RECEIVE_SCHEDULE_MODULE_DATA';
var SCORE_SCHEDULE_MODULE_DATA = 'SCORE_SCHEDULE_MODULE_DATA';

function decayContentScoreWithTime(content) {
    var DECAY_THRESHOLD = 30; // minutes until start time
    var minutesUntilStart = Object(__WEBPACK_IMPORTED_MODULE_3__lib_format_getMinutesUntilStart__["a" /* default */])(content);

    if (minutesUntilStart >= DECAY_THRESHOLD) {
        content.score -= minutesUntilStart;
    }
    return content;
}

function dedupeBucketContents() {
    var buckets = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    return buckets.map(function (bucket) {
        var dedupedContents = __WEBPACK_IMPORTED_MODULE_4_lodash_uniqBy___default()(bucket.contents || [], 'name');
        bucket.contents = dedupedContents;
        return bucket;
    });
}

function scoreBucketsWithTime() {
    var buckets = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    return buckets.map(function (bucket) {
        var scoredContents = bucket.contents.map(function (content) {
            return decayContentScoreWithTime(content);
        }).sort(function (aContent, bContent) {
            if (aContent.score > bContent.score) {
                return -1;
            } else if (aContent.score < bContent.score) {
                return 1;
            }
            return 0;
        });
        bucket.contents = scoredContents;
        return bucket;
    });
}

function createReceiveScheduleModuleAction(name, buckets) {
    return {
        type: RECEIVE_SCHEDULE_MODULE_DATA,
        name: name,
        buckets: buckets,
        receivedTime: Date.now()
    };
}

function fetchScheduleModule(langArg) {
    return function (dispatch, getState) {
        __WEBPACK_IMPORTED_MODULE_5__lib_util_perf__["a" /* markStart */]('fetchScheduleModule');
        var lang = langArg || undefined;
        var state = getState();
        var bootstrap = Object(__WEBPACK_IMPORTED_MODULE_1__selectors_bootstrapSelector__["a" /* default */])(state);
        var _bootstrap$scheduleMo = bootstrap.scheduleModule,
            scheduleModule = _bootstrap$scheduleMo === undefined ? {} : _bootstrap$scheduleMo;

        var _routingSelector = Object(__WEBPACK_IMPORTED_MODULE_2__selectors_routingSelector__["a" /* default */])(state),
            locationBeforeTransitions = _routingSelector.locationBeforeTransitions;

        var _ref = locationBeforeTransitions || {},
            _ref$pathname = _ref.pathname,
            pathname = _ref$pathname === undefined ? '' : _ref$pathname;

        var pageName = 'scheduleModule';
        Object.keys(scheduleModule).some(function (key) {
            var paths = scheduleModule[key].paths;
            if (paths.some(function (path) {
                return pathname.indexOf(path) > -1;
            })) {
                pageName = key;
                return true;
            }
            return false;
        });
        dispatch({
            type: REQUEST_SCHEDULE_MODULE_DATA,
            requestedTime: Date.now()
        });

        return dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions_apiAction__["f" /* getPage */])({ name: pageName, lang: lang })).then(function () {
            var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var _response$page = response.page;
            _response$page = _response$page === undefined ? {} : _response$page;
            var _response$page$bucket = _response$page.buckets,
                buckets = _response$page$bucket === undefined ? [] : _response$page$bucket;

            if (buckets.length > 0) {
                var timeScoredBuckets = dedupeBucketContents(scoreBucketsWithTime(buckets));
                dispatch(createReceiveScheduleModuleAction(pageName, timeScoredBuckets));
                __WEBPACK_IMPORTED_MODULE_5__lib_util_perf__["b" /* measureAndTime */]('fetchScheduleModule');
            }
        });
    };
}

function completeScheduleModuleScoring(buckets) {
    return {
        type: SCORE_SCHEDULE_MODULE_DATA,
        buckets: buckets ? scoreBucketsWithTime(buckets) : undefined,
        receivedTime: Date.now()
    };
}

function scoreScheduleModule() {
    return function (dispatch) {
        return dispatch(completeScheduleModuleScoring());
    };
}

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(4);

// EXTERNAL MODULE: ./node_modules/react-router/lib/index.js
var lib = __webpack_require__(85);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/lodash/flatMap.js
var flatMap = __webpack_require__(712);
var flatMap_default = /*#__PURE__*/__webpack_require__.n(flatMap);

// EXTERNAL MODULE: ./app/common/PropTypes.js
var PropTypes = __webpack_require__(28);

// EXTERNAL MODULE: ./app/common/actions/appActions.js
var appActions = __webpack_require__(19);

// EXTERNAL MODULE: ./app/common/selectors/appSelector.js + 1 modules
var appSelector = __webpack_require__(3);

// EXTERNAL MODULE: ./app/common/selectors/flagsSelector.js
var flagsSelector = __webpack_require__(47);

// EXTERNAL MODULE: ./app/common/selectors/playingStreamSelector.js
var playingStreamSelector = __webpack_require__(148);

// EXTERNAL MODULE: ./app/common/selectors/authenticationSelectors.js
var authenticationSelectors = __webpack_require__(10);

// EXTERNAL MODULE: ./app/common/selectors/pageSelector.js
var pageSelector = __webpack_require__(13);

// EXTERNAL MODULE: ./app/common/selectors/oneIdSelector.js
var oneIdSelector = __webpack_require__(27);

// EXTERNAL MODULE: ./app/common/selectors/pickerStreamsSelector.js
var pickerStreamsSelector = __webpack_require__(149);

// EXTERNAL MODULE: ./app/lib/auth/canPlayContent.js
var canPlayContent = __webpack_require__(116);

// CONCATENATED MODULE: ./app/lib/auth/contentContainsStream.js
function contentContainsStream(_ref) {
    var _ref$streams = _ref.streams,
        streams = _ref$streams === undefined ? [] : _ref$streams;
    var stream = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return streams.some(function (_ref2) {
        var id = _ref2.id;
        return id === stream.id;
    });
}
// EXTERNAL MODULE: ./app/lib/auth/isContentLocked.js
var isContentLocked = __webpack_require__(220);

// EXTERNAL MODULE: ./app/lib/auth/getContentId.js
var getContentId = __webpack_require__(60);

// CONCATENATED MODULE: ./app/lib/ui/scrollTo.js
var scrollTo = function scrollTo(element, to, duration) {
    if (duration <= 0) return;
    var difference = to - element.scrollTop;
    var perTick = difference / duration * 10;

    setTimeout(function () {
        element.scrollTop = element.scrollTop + perTick;
        if (element.scrollTop === to) return;
        scrollTo(element, to, duration - 10);
    }, 10);
};

/* harmony default export */ var ui_scrollTo = (scrollTo);
// EXTERNAL MODULE: ./app/lib/util/isEmpty.js
var isEmpty = __webpack_require__(12);

// EXTERNAL MODULE: ./app/lib/streamPicker/index.js + 9 modules
var streamPicker = __webpack_require__(221);

// EXTERNAL MODULE: ./app/lib/format/queryString.js
var queryString = __webpack_require__(18);

// EXTERNAL MODULE: ./app/enums.js
var enums = __webpack_require__(1);

// EXTERNAL MODULE: ./app/webapp/player/globalVideoElement.js
var globalVideoElement = __webpack_require__(348);

// CONCATENATED MODULE: ./app/webapp/common/playable.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



























/* harmony default export */ var playable = __webpack_exports__["a"] = (function (WrappedComponent) {
    var Playable = function (_Component) {
        _inherits(Playable, _Component);

        function Playable(props) {
            _classCallCheck(this, Playable);

            var _this = _possibleConstructorReturn(this, (Playable.__proto__ || Object.getPrototypeOf(Playable)).call(this, props));

            _this.blackoutClickHandler = _this.blackoutClickHandler.bind(_this);
            _this.clickHandler = _this.clickHandler.bind(_this);
            _this.isUserBlackedOut = _this.isUserBlackedOut.bind(_this);
            return _this;
        }

        /**
         * Generates a URL for content that does not go to the player page when clicked
         * @param {string} page - show|film|product
         * @param {boolean} seo - whether or not to put descriptive "junk" on the end of the url
         * @param {boolean} toURL - used in render function for right click -> open in new tab
         */


        _createClass(Playable, [{
            key: 'getContentPageUrl',
            value: function getContentPageUrl(page) {
                var seo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var toURL = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                var _props = this.props,
                    _props$content = _props.content,
                    id = _props$content.id,
                    name = _props$content.name,
                    type = _props$content.type,
                    suggestion = _props$content.suggestion,
                    flags = _props.flags,
                    routing = _props.routing;

                var _ref = routing && routing.locationBeforeTransitions || {},
                    basename = _ref.basename;

                var junk = '';

                if (seo && typeof name === 'string') {
                    var currentName = name.trim().toLowerCase();
                    // catching edge case where URL ends with "espn+"
                    if (currentName === 'espn+') {
                        junk = '/' + currentName;
                    } else {
                        // replace all special characters to include spaces with a "-"
                        junk = '/' + currentName.replace(/[^A-Z0-9]+/ig, '-');
                    }
                }

                // TODO: DTC - API to return `links.web`
                var pathname = '';
                if (enums["o" /* ContentType */].TERM === type) {
                    pathname = '/' + page + '/' + encodeURIComponent(suggestion);
                } else {
                    pathname = '/' + page + '/' + id + junk;
                }
                var query = _extends({}, flags);

                if (toURL) {
                    return '' + basename + pathname + Object(queryString["a" /* default */])(query);
                }

                return {
                    pathname: pathname,
                    query: query
                };
            }
        }, {
            key: 'isUserBlackedOut',
            value: function isUserBlackedOut() {
                var _props2 = this.props,
                    listing = _props2.listing,
                    userLocation = _props2.userLocation,
                    _props2$content = _props2.content;
                _props2$content = _props2$content === undefined ? {} : _props2$content;
                var _props2$content$strea = _props2$content.streams,
                    streams = _props2$content$strea === undefined ? [] : _props2$content$strea;

                // do not label the content as `blackout` unless all the streams are blacked out

                if (streams.length && streams.every(function (stream) {
                    return !!stream.blackoutText;
                })) {
                    return true;
                }

                // This logic is for schedule link only
                // FIXME: currently GraphQL doesn't support blackout info (it used to work when using V1 listings)
                var _listing$blackouts = listing.blackouts,
                    blackouts = _listing$blackouts === undefined ? [] : _listing$blackouts;

                var userIsBlackedOut = false;
                if (blackouts.length > 0) {
                    // Return true if we don't have userLocation - this check is only for UI purposes
                    if (!userLocation) {
                        return true;
                    }

                    var _ref2 = userLocation || {},
                        _ref2$dma = _ref2.dma,
                        dma = _ref2$dma === undefined ? '' : _ref2$dma;

                    var dmaBlackout = blackouts.filter(function (_ref3) {
                        var type = _ref3.type;
                        return type === 'dma';
                    }).shift();
                    userIsBlackedOut = dmaBlackout && dmaBlackout.detail.indexOf(dma.toString()) >= 0;
                }
                return userIsBlackedOut;
            }
        }, {
            key: 'blackoutClickHandler',
            value: function blackoutClickHandler(event) {
                event.preventDefault();
                this.props.dispatch(Object(appActions["C" /* displayModalMessage */])(enums["w" /* ModalType */].BLACKOUT_MAP, { content: this.props.content }));
            }
        }, {
            key: 'clickHandler',
            value: function clickHandler(event) {
                if (event) {
                    event.preventDefault();
                }
                var _props3 = this.props,
                    bucketId = _props3.bucketId,
                    content = _props3.content,
                    playingStream = _props3.playingStream,
                    dispatch = _props3.dispatch,
                    groupId = _props3.groupId,
                    flags = _props3.flags,
                    isHero = _props3.isHero,
                    isMobile = _props3.isMobile,
                    placement = _props3.placement,
                    bucketName = _props3.bucketName,
                    pageId = _props3.pageId,
                    pageName = _props3.pageName,
                    roadblock = _props3.roadblock,
                    router = _props3.router,
                    _props3$routing = _props3.routing,
                    routing = _props3$routing === undefined ? {} : _props3$routing,
                    userAuth = _props3.userAuth,
                    entitlements = _props3.entitlements,
                    preauthorizedResources = _props3.preauthorizedResources,
                    country = _props3.country,
                    lang = _props3.lang,
                    _props3$pickerStreams = _props3.pickerStreams,
                    pickerStreams = _props3$pickerStreams === undefined ? [] : _props3$pickerStreams,
                    isAuthorized = _props3.isAuthorized;

                var _ref4 = routing && routing.locationBeforeTransitions || {},
                    _ref4$pathname = _ref4.pathname,
                    pathname = _ref4$pathname === undefined ? '' : _ref4$pathname,
                    _ref4$query = _ref4.query,
                    query = _ref4$query === undefined ? {} : _ref4$query;

                if (Object(isEmpty["a" /* default */])(playingStream)) {
                    globalVideoElement["a" /* default */].prime();
                }

                if (roadblock === true && content.type === enums["o" /* ContentType */].LISTING) {
                    var contentId = Object(getContentId["a" /* default */])(content);
                    // NOTE: Obtain the `ESPN_PLUS_*` packages as a flattened array
                    var packages = content.streams && flatMap_default()(content.streams, function (stream) {
                        return stream.packages;
                    }).filter(function (result) {
                        return result;
                    }) // Removes undefined values from the array
                    || [];
                    var isPurchasable = packages.length > 0;
                    var isEntitled = packages.some(function (pkg) {
                        return entitlements.indexOf(pkg) !== -1;
                    });

                    var roadblockUrl = '/watch/roadblock' + Object(queryString["a" /* default */])(contentId);
                    if (query[enums["t" /* Flags */].ROADBLOCK_NO_UNIVERSAL_LINK] !== 'true' && !(isPurchasable && !isEntitled)) {
                        // m.espn.com is enabled for Universal Link treatment on iOS, so use this domain
                        roadblockUrl = '//m.espn.com' + roadblockUrl;
                    }
                    window.location = roadblockUrl;
                    return;
                }

                if ([enums["o" /* ContentType */].PRODUCT, enums["o" /* ContentType */].SHOW, enums["o" /* ContentType */].FILM, enums["o" /* ContentType */].PROGRAM, enums["o" /* ContentType */].TERM, enums["o" /* ContentType */].COMPILATION].indexOf(content.type) !== -1) {
                    var contentPageUrl = this.getContentPageUrl(enums["H" /* URLPath */][content.type], true);
                    router.push(contentPageUrl);
                    return;
                }

                var enhancedContent = !Object(isEmpty["a" /* default */])(content) ? _extends({}, content, {
                    bucketId: bucketId,
                    groupId: groupId,
                    isHero: isHero,
                    placement: placement,
                    bucketName: bucketName,
                    pageId: pageId,
                    pageName: pageName
                }) : content;

                var onSyndicatedPlayerPage = pathname.indexOf('/syndicated/player') !== -1;
                var canPlay = Object(canPlayContent["a" /* default */])(enhancedContent, userAuth, false);
                var isESPNPlus = enhancedContent.streams.some(function (_ref5) {
                    var _ref5$source = _ref5.source,
                        id = _ref5$source.id,
                        name = _ref5$source.name;
                    return name === 'ESPN+' || ['ESPN_DTC', 'ESPN_PPV'].indexOf(id) > -1;
                });
                var _enhancedContent$dss = enhancedContent.dss;
                _enhancedContent$dss = _enhancedContent$dss === undefined ? {} : _enhancedContent$dss;
                var _enhancedContent$dss$ = _enhancedContent$dss.rewardToken,
                    rewardToken = _enhancedContent$dss$ === undefined ? null : _enhancedContent$dss$,
                    _enhancedContent$dss$2 = _enhancedContent$dss.contentId,
                    dssContentId = _enhancedContent$dss$2 === undefined ? null : _enhancedContent$dss$2,
                    _enhancedContent$dss$3 = _enhancedContent$dss.recommendedContentIds,
                    recommendedContentIds = _enhancedContent$dss$3 === undefined ? null : _enhancedContent$dss$3;


                if (rewardToken && dssContentId && recommendedContentIds) {
                    dispatch(Object(appActions["N" /* sendContentReward */])({
                        rewardToken: rewardToken,
                        contentId: dssContentId,
                        recommendedContentIds: recommendedContentIds
                    }));
                }

                var syndicatedScheduleLink = onSyndicatedPlayerPage && placement.indexOf('schedule') > -1;
                var syndicatedBigPlayButton = onSyndicatedPlayerPage && !syndicatedScheduleLink;
                var playerUrlQueryProps = { bucketId: bucketId, groupId: groupId, flags: flags, routing: routing };

                // Allow linear/TVE to display in-player provider picker, but open ESPN+/DTC in a new tab
                if (!canPlay && (syndicatedScheduleLink || syndicatedBigPlayButton && isESPNPlus)) {
                    // Force content to open in a new browser window/tab, minus the `/syndicated` path segment
                    var target = '_blank';

                    // Except for ESPN+ content embedded on a domain matching `/espn/`
                    if (syndicatedBigPlayButton && isESPNPlus && window.frameElement && window.location.origin.match(/espn/)) {
                        target = '_parent';
                    }

                    var playerUrl = Object(streamPicker["b" /* getPlayerUrl */])(_extends({
                        content: enhancedContent,
                        toURL: true,
                        absoluteUrl: true
                    }, playerUrlQueryProps));
                    window.open(playerUrl, target);
                    return;
                }

                if (syndicatedScheduleLink || canPlay) {
                    var onPlayerPage = !syndicatedScheduleLink && pathname.indexOf('/player') !== -1;
                    // if you're not in a Hero or on the player or syndicated player page, route to it
                    if (!onPlayerPage && !syndicatedBigPlayButton) {
                        var urlParams = _extends({
                            isHero: isHero,
                            content: enhancedContent,
                            onSyndicatedPlayerPage: onSyndicatedPlayerPage
                        }, playerUrlQueryProps);
                        var _playerUrl = Object(streamPicker["b" /* getPlayerUrl */])(urlParams);
                        if (_playerUrl) {
                            // if a user selects upcoming content, direct to the player page with the upcoming alert badge
                            var alertContent = enhancedContent.status === enums["n" /* ContentStatus */].UPCOMING ? enhancedContent : null;
                            var rState = { alertContent: alertContent, placement: placement, bucketId: bucketId, bucketName: bucketName, pageId: pageId, pageName: pageName, userInitiated: true };
                            var _enhancedContent$link = enhancedContent.links;
                            _enhancedContent$link = _enhancedContent$link === undefined ? {} : _enhancedContent$link;
                            var picker = _enhancedContent$link.picker;

                            var showPicker = picker !== undefined;
                            /**
                             * if user can play the content, we don't want to send it to the player right away; otherwise
                             * player will pick the first stream and play it to the user.
                             * We will show picker if links.picker is defined
                             */
                            if (showPicker) {
                                enhancedContent.isOnTile = true;
                                dispatch(Object(appActions["z" /* contentSelect */])(enhancedContent));
                                Object(streamPicker["e" /* openStreamPicker */])({
                                    lang: lang,
                                    country: country,
                                    dispatch: dispatch,
                                    pickerStreams: pickerStreams,
                                    content: enhancedContent,
                                    urlParams: urlParams,
                                    route: {
                                        router: router,
                                        rState: rState,
                                        locationBeforeTransitions: routing.locationBeforeTransitions
                                    },
                                    authRes: { userAuth: userAuth, preauthorizedResources: preauthorizedResources }
                                });
                            } else if (isHero && isAuthorized === false && pickerStreams.length) {
                                /**
                                 * there are flaws how adobe authenticated user currently. User logs in with an authrized
                                 * MVPD account, it assumes user can play selected content, but it doesn't know
                                 * whether or not user can play single stream until doing another authentication check.
                                 * We need to handle usecase when user is authenticated and clicks on video hero compenent
                                 * and user is not isAuthorized to place selected stream, we will reload the page, so
                                 * the auth Z error will be handled in connectPlayer.js
                                 */
                                window.location.reload();
                            } else {
                                // we may need to handle use case here when links.picker is not defined and if it is multi streams
                                router.push(_extends({}, _playerUrl, {
                                    state: rState
                                }));
                            }
                            return;
                        }
                    } else if (isMobile === true && onPlayerPage) {
                        ui_scrollTo(document.body, 0, 250);
                    }
                }

                dispatch(Object(appActions["z" /* contentSelect */])(enhancedContent));
            }
        }, {
            key: 'render',
            value: function render() {
                var _props4 = this.props,
                    content = _props4.content,
                    playingStream = _props4.playingStream,
                    placement = _props4.placement,
                    bucketName = _props4.bucketName,
                    pageId = _props4.pageId,
                    pageName = _props4.pageName,
                    userAuth = _props4.userAuth,
                    preauthorizedResources = _props4.preauthorizedResources;


                var userAuthenticatedForContent = Object(canPlayContent["a" /* default */])(content, userAuth);

                var showLock = Object(isContentLocked["a" /* default */])(content, userAuth, preauthorizedResources);

                var playerHref = void 0;
                if ([enums["o" /* ContentType */].PRODUCT, enums["o" /* ContentType */].SHOW, enums["o" /* ContentType */].FILM, enums["o" /* ContentType */].PROGRAM, enums["o" /* ContentType */].TERM, enums["o" /* ContentType */].COMPILATION].indexOf(content.type) !== -1) {
                    playerHref = this.getContentPageUrl(enums["H" /* URLPath */][content.type], true, true) || '#';
                } else {
                    var _props5 = this.props,
                        bucketId = _props5.bucketId,
                        groupId = _props5.groupId,
                        flags = _props5.flags,
                        routing = _props5.routing;


                    playerHref = Object(streamPicker["b" /* getPlayerUrl */])({
                        content: content,
                        toURL: true,
                        bucketId: bucketId,
                        groupId: groupId,
                        flags: flags,
                        routing: routing
                    }) || '#';
                }

                var userIsBlackedOut = this.isUserBlackedOut();

                var newProps = _extends({}, this.props, {
                    playerHref: playerHref,
                    content: !Object(isEmpty["a" /* default */])(content) ? _extends({}, content, { placement: placement, bucketName: bucketName, pageId: pageId, pageName: pageName }) : content,
                    selected: contentContainsStream(content, playingStream),
                    userAuthenticatedForContent: userAuthenticatedForContent,
                    userIsBlackedOut: userIsBlackedOut,
                    showLock: showLock
                });
                return react_default.a.createElement(WrappedComponent, _extends({}, newProps, {
                    blackoutClickHandler: this.blackoutClickHandler,
                    clickHandler: this.clickHandler
                }));
            }
        }]);

        return Playable;
    }(react["Component"]);

    Playable.defaultProps = {
        featured: false,
        isMobile: false,
        layoutType: enums["i" /* BucketLayout */].DEFAULT,
        placement: 'unknown',
        bucketName: undefined,
        pageId: undefined,
        pageName: undefined,
        playingStream: {},
        listing: {},
        content: {},
        entitlements: []
    };

    var mapStateToProps = function mapStateToProps(state) {
        var routing = state.routing;

        var _pageSelector = Object(pageSelector["c" /* default */])(state),
            pageId = _pageSelector.id,
            pageName = _pageSelector.name;

        var _state$app = state.app,
            lang = _state$app.lang,
            country = _state$app.country,
            isMobile = _state$app.isMobile;

        return {
            routing: routing,
            lang: lang,
            isMobile: isMobile,
            pageId: pageId,
            pageName: pageName,
            country: country,
            entitlements: Object(oneIdSelector["d" /* oneIdEntitlementsSelector */])(state),
            flags: Object(flagsSelector["a" /* persistentFlagsSelector */])(state),
            playingStream: Object(playingStreamSelector["a" /* default */])(state),
            preauthorizedResources: Object(authenticationSelectors["o" /* preauthorizedResourcesSelector */])(state),
            roadblock: Object(appSelector["D" /* roadblockSelector */])(state),
            userAuth: Object(authenticationSelectors["r" /* userAuthSelector */])(state),
            userLocation: Object(authenticationSelectors["s" /* userLocationSelector */])(state),
            pickerStreams: Object(pickerStreamsSelector["a" /* default */])(state),
            isAuthorized: Object(authenticationSelectors["d" /* adobePassIsAuthorizedSelector */])(state)
        };
    };

    return Object(lib["withRouter"])(Object(es["b" /* connect */])(mapStateToProps)(Playable), { withRef: true });
});

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(7);

var invariant = __webpack_require__(5);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
exports.falsy = falsy;

var _react = __webpack_require__(0);

var func = _react.PropTypes.func;
var object = _react.PropTypes.object;
var arrayOf = _react.PropTypes.arrayOf;
var oneOfType = _react.PropTypes.oneOfType;
var element = _react.PropTypes.element;
var shape = _react.PropTypes.shape;
var string = _react.PropTypes.string;
function falsy(props, propName, componentName) {
  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
}

var history = exports.history = shape({
  listen: func.isRequired,
  push: func.isRequired,
  replace: func.isRequired,
  go: func.isRequired,
  goBack: func.isRequired,
  goForward: func.isRequired
});

var component = exports.component = oneOfType([func, string]);
var components = exports.components = oneOfType([component, object]);
var route = exports.route = oneOfType([object, element]);
var routes = exports.routes = oneOfType([route, arrayOf(route)]);

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Indicates that navigation was caused by a call to history.push.
 */


exports.__esModule = true;
var PUSH = 'PUSH';

exports.PUSH = PUSH;
/**
 * Indicates that navigation was caused by a call to history.replace.
 */
var REPLACE = 'REPLACE';

exports.REPLACE = REPLACE;
/**
 * Indicates that navigation was caused by some other action such
 * as using a browser's back/forward buttons and/or manually manipulating
 * the URL in a browser's location bar. This is the default.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
 * for more information.
 */
var POP = 'POP';

exports.POP = POP;
exports['default'] = {
  PUSH: PUSH,
  REPLACE: REPLACE,
  POP: POP
};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.extractPath = extractPath;
exports.parsePath = parsePath;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(41);

var _warning2 = _interopRequireDefault(_warning);

function extractPath(string) {
  var match = string.match(/^https?:\/\/[^\/]*/);

  if (match == null) return string;

  return string.substring(match[0].length);
}

function parsePath(path) {
  var pathname = extractPath(path);
  var search = '';
  var hash = '';

   false ? _warning2['default'](path === pathname, 'A path must be pathname + search + hash only, not a fully qualified URL like "%s"', path) : undefined;

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substring(hashIndex);
    pathname = pathname.substring(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substring(searchIndex);
    pathname = pathname.substring(0, searchIndex);
  }

  if (pathname === '') pathname = '/';

  return {
    pathname: pathname,
    search: search,
    hash: hash
  };
}

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;

var _reducer = __webpack_require__(272);

Object.defineProperty(exports, 'LOCATION_CHANGE', {
  enumerable: true,
  get: function get() {
    return _reducer.LOCATION_CHANGE;
  }
});
Object.defineProperty(exports, 'routerReducer', {
  enumerable: true,
  get: function get() {
    return _reducer.routerReducer;
  }
});

var _actions = __webpack_require__(273);

Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
  enumerable: true,
  get: function get() {
    return _actions.CALL_HISTORY_METHOD;
  }
});
Object.defineProperty(exports, 'push', {
  enumerable: true,
  get: function get() {
    return _actions.push;
  }
});
Object.defineProperty(exports, 'replace', {
  enumerable: true,
  get: function get() {
    return _actions.replace;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _actions.go;
  }
});
Object.defineProperty(exports, 'goBack', {
  enumerable: true,
  get: function get() {
    return _actions.goBack;
  }
});
Object.defineProperty(exports, 'goForward', {
  enumerable: true,
  get: function get() {
    return _actions.goForward;
  }
});
Object.defineProperty(exports, 'routerActions', {
  enumerable: true,
  get: function get() {
    return _actions.routerActions;
  }
});

var _sync = __webpack_require__(531);

var _sync2 = _interopRequireDefault(_sync);

var _middleware = __webpack_require__(532);

var _middleware2 = _interopRequireDefault(_middleware);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports.syncHistoryWithStore = _sync2['default'];
exports.routerMiddleware = _middleware2['default'];

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addQueryToUrl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(277);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function addQueryToUrl() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var finalQuery = query;

    var pathAndQuery = url.split('?');
    if (pathAndQuery.length > 1) {
        var urlQuery = Object(__WEBPACK_IMPORTED_MODULE_0____["a" /* convertQueryStringToObject */])(pathAndQuery[1]);
        finalQuery = _extends({}, urlQuery, finalQuery);
    }
    return '' + pathAndQuery[0] + Object(__WEBPACK_IMPORTED_MODULE_0____["b" /* queryString */])(finalQuery);
};

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(108),
    getRawTag = __webpack_require__(540),
    objectToString = __webpack_require__(541);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(548),
    getValue = __webpack_require__(551);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(console) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
* loglevel - https://github.com/pimterry/loglevel
*
* Copyright (c) 2013 Tim Perry
* Licensed under the MIT license.
*/
(function (root, definition) {
    "use strict";
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        module.exports = definition();
    } else {
        root.log = definition();
    }
}(this, function () {
    "use strict";
    var noop = function() {};
    var undefinedType = "undefined";

    function realMethod(methodName) {
        if (typeof console === undefinedType) {
            return false; // We can't build a real method without a console to log to
        } else if (console[methodName] !== undefined) {
            return bindMethod(console, methodName);
        } else if (console.log !== undefined) {
            return bindMethod(console, 'log');
        } else {
            return noop;
        }
    }

    function bindMethod(obj, methodName) {
        var method = obj[methodName];
        if (typeof method.bind === 'function') {
            return method.bind(obj);
        } else {
            try {
                return Function.prototype.bind.call(method, obj);
            } catch (e) {
                // Missing bind shim or IE8 + Modernizr, fallback to wrapping
                return function() {
                    return Function.prototype.apply.apply(method, [obj, arguments]);
                };
            }
        }
    }

    // these private functions always need `this` to be set properly

    function enableLoggingWhenConsoleArrives(methodName, level, loggerName) {
        return function () {
            if (typeof console !== undefinedType) {
                replaceLoggingMethods.call(this, level, loggerName);
                this[methodName].apply(this, arguments);
            }
        };
    }

    function replaceLoggingMethods(level, loggerName) {
        /*jshint validthis:true */
        for (var i = 0; i < logMethods.length; i++) {
            var methodName = logMethods[i];
            this[methodName] = (i < level) ?
                noop :
                this.methodFactory(methodName, level, loggerName);
        }
    }

    function defaultMethodFactory(methodName, level, loggerName) {
        /*jshint validthis:true */
        return realMethod(methodName) ||
               enableLoggingWhenConsoleArrives.apply(this, arguments);
    }

    var logMethods = [
        "trace",
        "debug",
        "info",
        "warn",
        "error"
    ];

    function Logger(name, defaultLevel, factory) {
      var self = this;
      var currentLevel;
      var storageKey = "loglevel";
      if (name) {
        storageKey += ":" + name;
      }

      function persistLevelIfPossible(levelNum) {
          var levelName = (logMethods[levelNum] || 'silent').toUpperCase();

          // Use localStorage if available
          try {
              window.localStorage[storageKey] = levelName;
              return;
          } catch (ignore) {}

          // Use session cookie as fallback
          try {
              window.document.cookie =
                encodeURIComponent(storageKey) + "=" + levelName + ";";
          } catch (ignore) {}
      }

      function getPersistedLevel() {
          var storedLevel;

          try {
              storedLevel = window.localStorage[storageKey];
          } catch (ignore) {}

          if (typeof storedLevel === undefinedType) {
              try {
                  var cookie = window.document.cookie;
                  var location = cookie.indexOf(
                      encodeURIComponent(storageKey) + "=");
                  if (location) {
                      storedLevel = /^([^;]+)/.exec(cookie.slice(location))[1];
                  }
              } catch (ignore) {}
          }

          // If the stored level is not valid, treat it as if nothing was stored.
          if (self.levels[storedLevel] === undefined) {
              storedLevel = undefined;
          }

          return storedLevel;
      }

      /*
       *
       * Public API
       *
       */

      self.levels = { "TRACE": 0, "DEBUG": 1, "INFO": 2, "WARN": 3,
          "ERROR": 4, "SILENT": 5};

      self.methodFactory = factory || defaultMethodFactory;

      self.getLevel = function () {
          return currentLevel;
      };

      self.setLevel = function (level, persist) {
          if (typeof level === "string" && self.levels[level.toUpperCase()] !== undefined) {
              level = self.levels[level.toUpperCase()];
          }
          if (typeof level === "number" && level >= 0 && level <= self.levels.SILENT) {
              currentLevel = level;
              if (persist !== false) {  // defaults to true
                  persistLevelIfPossible(level);
              }
              replaceLoggingMethods.call(self, level, name);
              if (typeof console === undefinedType && level < self.levels.SILENT) {
                  return "No console available for logging";
              }
          } else {
              throw "log.setLevel() called with invalid level: " + level;
          }
      };

      self.setDefaultLevel = function (level) {
          if (!getPersistedLevel()) {
              self.setLevel(level, false);
          }
      };

      self.enableAll = function(persist) {
          self.setLevel(self.levels.TRACE, persist);
      };

      self.disableAll = function(persist) {
          self.setLevel(self.levels.SILENT, persist);
      };

      // Initialize with the right level
      var initialLevel = getPersistedLevel();
      if (initialLevel == null) {
          initialLevel = defaultLevel == null ? "WARN" : defaultLevel;
      }
      self.setLevel(initialLevel, false);
    }

    /*
     *
     * Package-level API
     *
     */

    var defaultLogger = new Logger();

    var _loggersByName = {};
    defaultLogger.getLogger = function getLogger(name) {
        if (typeof name !== "string" || name === "") {
          throw new TypeError("You must supply a name when creating a logger.");
        }

        var logger = _loggersByName[name];
        if (!logger) {
          logger = _loggersByName[name] = new Logger(
            name, defaultLogger.getLevel(), defaultLogger.methodFactory);
        }
        return logger;
    };

    // Grab the current global log variable in case of overwrite
    var _log = (typeof window !== undefinedType) ? window.log : undefined;
    defaultLogger.noConflict = function() {
        if (typeof window !== undefinedType &&
               window.log === defaultLogger) {
            window.log = _log;
        }

        return defaultLogger;
    };

    return defaultLogger;
}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {/* unused harmony export getCacheFallback */
/* unused harmony export setCacheFallback */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loglevel__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loglevel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loglevel__);




var log = __WEBPACK_IMPORTED_MODULE_2_loglevel___default.a.getLogger('fallbackCache');

var EXPIRATION = 86400; // one day

function getCacheFallback(url) {
    log.warn('getCacheFallback: ' + url);
    return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.fromCallback(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* default */].get.bind(null, 'fallback:' + url)).catch(function (err) {
        console.error('Unable to get data from fallback cache');
    });
}

function setCacheFallback(url, value) {
    var expiration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EXPIRATION;

    if (!!value) {
        __WEBPACK_IMPORTED_MODULE_1__index__["a" /* default */].set('fallback:' + url, value, expiration);
    }
}

var defaultExport = {
    get: getCacheFallback,
    set: setCacheFallback
};

/* harmony default export */ __webpack_exports__["a"] = (defaultExport);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {/* unused harmony export canUsePerformance */
/* unused harmony export mark */
/* harmony export (immutable) */ __webpack_exports__["a"] = markStart;
/* unused harmony export markEnd */
/* unused harmony export clear */
/* unused harmony export measure */
/* harmony export (immutable) */ __webpack_exports__["b"] = measureAndTime;
/* unused harmony export time */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__canUseDOM__ = __webpack_require__(61);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();



var canUsePerformance = __WEBPACK_IMPORTED_MODULE_0__canUseDOM__["a" /* default */] && typeof window.performance !== 'undefined';
var perfDebug = __WEBPACK_IMPORTED_MODULE_0__canUseDOM__["a" /* default */] && window.location.search.indexOf('perf_debug=true') > -1;
var perfEnabled = canUsePerformance && perfDebug;
var logMark = perfEnabled && window.location.search.indexOf('perf_mark_log=true') > -1;

function mark(name) {
    if (!perfEnabled) {
        return;
    }
    window.performance.mark(name);
}

function markStart(name) {
    if (logMark) {
        console.log('perf: mark \'' + name + '\'');
    }
    mark(name + '_start');
}

function markEnd(name) {
    mark(name + '_end');
}

function clear(name) {
    if (!perfEnabled) {
        return;
    }
    var startMark = name + '_start';
    var endMark = name + '_end';
    window.performance.clearMarks(startMark);
    window.performance.clearMarks(endMark);
    window.performance.clearMeasures(name);
}

function measure(name, startMarkArg, endMarkArg) {
    if (!perfEnabled) {
        return;
    }
    var startMark = startMarkArg || name + '_start';
    var endMark = endMarkArg || name + '_end';

    var _window$performance$g = window.performance.getEntriesByName(endMark),
        _window$performance$g2 = _slicedToArray(_window$performance$g, 1),
        entry = _window$performance$g2[0];

    if (!entry) {
        mark(endMark);
    }
    try {
        window.performance.measure(name, startMark, endMark);
    } catch (err) {}
}

function measureAndTime(name, startMark, endMark) {
    measure(name, startMark, endMark);
    time(name);
    clear(name);
}

function time(name) {
    var all = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var print = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    if (!perfEnabled) {
        return;
    }
    var entries = void 0;
    if (name) {
        entries = window.performance.getEntriesByName(name);
    } else {
        entries = window.performance.getEntriesByType('measure');
    }
    if (!all) {
        entries = entries[0];
        if (print) {
            console.log('perf: measure \'' + name + '\'', entries);
        }
    } else if (print) {
        entries.forEach(function (entry) {
            console.log('perf: measure \'' + entry.name + '\'', entry);
        });
    }
    return entries;
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AdContainer__ = __webpack_require__(218);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var BannerAd = function BannerAd(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__AdContainer__["a" /* default */], _extends({
        className: 'ad-slot-banner ad-wrapper',
        kvps: { pos: 'banner' },
        slotType: 'banner'
    }, props));
};

BannerAd.defaultProps = {
    refreshOnLoad: false
};

/* harmony default export */ __webpack_exports__["a"] = (BannerAd);

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = authStateKnown;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(8);


function authStateKnown(userAuth) {
    if (Array.isArray(userAuth) && userAuth.length) {
        return userAuth.every(function (auth) {
            return __WEBPACK_IMPORTED_MODULE_0__constants__["z" /* unknownAuthStates */].indexOf(auth) === -1;
        });
    }
    return false;
};

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(15);

var ReactChildren = __webpack_require__(388);
var ReactComponent = __webpack_require__(158);
var ReactPureComponent = __webpack_require__(392);
var ReactClass = __webpack_require__(393);
var ReactDOMFactories = __webpack_require__(394);
var ReactElement = __webpack_require__(80);
var ReactPropTypes = __webpack_require__(395);
var ReactVersion = __webpack_require__(397);

var onlyChild = __webpack_require__(398);
var warning = __webpack_require__(6);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;

if (false) {
  var warned = false;
  __spread = function () {
    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
    warned = true;
    return _assign.apply(null, arguments);
  };
}

var React = {

  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactComponent,
  PureComponent: ReactPureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: ReactClass.createClass,
  createFactory: createFactory,
  createMixin: function (mixin) {
    // Currently a noop. Will be used to validate and trace mixins.
    return mixin;
  },

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

module.exports = React;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(15);

var ReactCurrentOwner = __webpack_require__(49);

var warning = __webpack_require__(6);
var canDefineProperty = __webpack_require__(226);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(227);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(399);


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var invariant = __webpack_require__(5);

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

var DOMPropertyInjection = {
  /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */
  MUST_USE_PROPERTY: 0x1,
  HAS_BOOLEAN_VALUE: 0x4,
  HAS_NUMERIC_VALUE: 0x8,
  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,

  /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */
  injectDOMPropertyConfig: function (domPropertyConfig) {
    var Injection = DOMPropertyInjection;
    var Properties = domPropertyConfig.Properties || {};
    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

    if (domPropertyConfig.isCustomAttribute) {
      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
    }

    for (var propName in Properties) {
      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;

      var lowerCased = propName.toLowerCase();
      var propConfig = Properties[propName];

      var propertyInfo = {
        attributeName: lowerCased,
        attributeNamespace: null,
        propertyName: propName,
        mutationMethod: null,

        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
      };
      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;

      if (false) {
        DOMProperty.getPossibleStandardName[lowerCased] = propName;
      }

      if (DOMAttributeNames.hasOwnProperty(propName)) {
        var attributeName = DOMAttributeNames[propName];
        propertyInfo.attributeName = attributeName;
        if (false) {
          DOMProperty.getPossibleStandardName[attributeName] = propName;
        }
      }

      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
      }

      if (DOMPropertyNames.hasOwnProperty(propName)) {
        propertyInfo.propertyName = DOMPropertyNames[propName];
      }

      if (DOMMutationMethods.hasOwnProperty(propName)) {
        propertyInfo.mutationMethod = DOMMutationMethods[propName];
      }

      DOMProperty.properties[propName] = propertyInfo;
    }
  }
};

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
/* eslint-enable max-len */

/**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */
var DOMProperty = {

  ID_ATTRIBUTE_NAME: 'data-reactid',
  ROOT_ATTRIBUTE_NAME: 'data-reactroot',

  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',

  /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */
  properties: {},

  /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   *
   * autofocus is predefined, because adding it to the property whitelist
   * causes unintended side effects.
   *
   * @type {Object}
   */
  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,

  /**
   * All of the isCustomAttribute() functions that have been injected.
   */
  _isCustomAttributeFunctions: [],

  /**
   * Checks whether a property name is a custom attribute.
   * @method
   */
  isCustomAttribute: function (attributeName) {
    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
      if (isCustomAttributeFn(attributeName)) {
        return true;
      }
    }
    return false;
  },

  injection: DOMPropertyInjection
};

module.exports = DOMProperty;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactRef = __webpack_require__(407);
var ReactInstrumentation = __webpack_require__(38);

var warning = __webpack_require__(6);

/**
 * Helper to call ReactRef.attachRefs with this composite component, split out
 * to avoid allocations in the transaction mount-ready queue.
 */
function attachRefs() {
  ReactRef.attachRefs(this, this._currentElement);
}

var ReactReconciler = {

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} the containing host component instance
   * @param {?object} info about the host container
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID // 0 in production and for roots
  ) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
      }
    }
    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
      }
    }
    return markup;
  },

  /**
   * Returns a value that can be passed to
   * ReactComponentEnvironment.replaceNodeWithMarkup.
   */
  getHostNode: function (internalInstance) {
    return internalInstance.getHostNode();
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (internalInstance, safely) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
      }
    }
    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
    internalInstance.unmountComponent(safely);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */
  receiveComponent: function (internalInstance, nextElement, transaction, context) {
    var prevElement = internalInstance._currentElement;

    if (nextElement === prevElement && context === internalInstance._context) {
      // Since elements are immutable after the owner is rendered,
      // we can do a cheap identity compare here to determine if this is a
      // superfluous reconcile. It's possible for state to be mutable but such
      // change should trigger an update of the owner which would recreate
      // the element. We explicitly check for the existence of an owner since
      // it's possible for an element created outside a composite to be
      // deeply mutated and reused.

      // TODO: Bailing out early is just a perf optimization right?
      // TODO: Removing the return statement should affect correctness?
      return;
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
      }
    }

    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);

    if (refsChanged) {
      ReactRef.detachRefs(internalInstance, prevElement);
    }

    internalInstance.receiveComponent(nextElement, transaction, context);

    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
      // The component's enqueued batch number should always be the current
      // batch or the following one.
       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
      return;
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
      }
    }
    internalInstance.performUpdateIfNecessary(transaction);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  }

};

module.exports = ReactReconciler;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMNamespaces = __webpack_require__(167);
var setInnerHTML = __webpack_require__(120);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(168);
var setTextContent = __webpack_require__(238);

var ELEMENT_NODE_TYPE = 1;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

/**
 * In IE (8-11) and Edge, appending nodes with no children is dramatically
 * faster than appending a full subtree, so we essentially queue up the
 * .appendChild calls here and apply them so each node is added to its parent
 * before any children are added.
 *
 * In other browsers, doing so is slower or neutral compared to the other order
 * (in Firefox, twice as slow) so we only do this inversion in IE.
 *
 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
 */
var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);

function insertTreeChildren(tree) {
  if (!enableLazy) {
    return;
  }
  var node = tree.node;
  var children = tree.children;
  if (children.length) {
    for (var i = 0; i < children.length; i++) {
      insertTreeBefore(node, children[i], null);
    }
  } else if (tree.html != null) {
    setInnerHTML(node, tree.html);
  } else if (tree.text != null) {
    setTextContent(node, tree.text);
  }
}

var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
  // DocumentFragments aren't actually part of the DOM after insertion so
  // appending children won't update the DOM. We need to ensure the fragment
  // is properly populated first, breaking out of our lazy approach for just
  // this level. Also, some <object> plugins (like Flash Player) will read
  // <param> nodes immediately upon insertion into the DOM, so <object>
  // must also be populated prior to insertion into the DOM.
  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
    insertTreeChildren(tree);
    parentNode.insertBefore(tree.node, referenceNode);
  } else {
    parentNode.insertBefore(tree.node, referenceNode);
    insertTreeChildren(tree);
  }
});

function replaceChildWithTree(oldNode, newTree) {
  oldNode.parentNode.replaceChild(newTree.node, oldNode);
  insertTreeChildren(newTree);
}

function queueChild(parentTree, childTree) {
  if (enableLazy) {
    parentTree.children.push(childTree);
  } else {
    parentTree.node.appendChild(childTree.node);
  }
}

function queueHTML(tree, html) {
  if (enableLazy) {
    tree.html = html;
  } else {
    setInnerHTML(tree.node, html);
  }
}

function queueText(tree, text) {
  if (enableLazy) {
    tree.text = text;
  } else {
    setTextContent(tree.node, text);
  }
}

function toString() {
  return this.node.nodeName;
}

function DOMLazyTree(node) {
  return {
    node: node,
    children: [],
    html: null,
    text: null,
    toString: toString
  };
}

DOMLazyTree.insertTreeBefore = insertTreeBefore;
DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
DOMLazyTree.queueChild = queueChild;
DOMLazyTree.queueHTML = queueHTML;
DOMLazyTree.queueText = queueText;

module.exports = DOMLazyTree;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.PropTypes = exports.RoutingContext = exports.RouterContext = exports.createRoutes = exports.useRoutes = exports.RouteContext = exports.Lifecycle = exports.History = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;

var _RouteUtils = __webpack_require__(58);

Object.defineProperty(exports, 'createRoutes', {
  enumerable: true,
  get: function get() {
    return _RouteUtils.createRoutes;
  }
});

var _PropTypes2 = __webpack_require__(181);

Object.defineProperty(exports, 'locationShape', {
  enumerable: true,
  get: function get() {
    return _PropTypes2.locationShape;
  }
});
Object.defineProperty(exports, 'routerShape', {
  enumerable: true,
  get: function get() {
    return _PropTypes2.routerShape;
  }
});

var _PatternUtils = __webpack_require__(86);

Object.defineProperty(exports, 'formatPattern', {
  enumerable: true,
  get: function get() {
    return _PatternUtils.formatPattern;
  }
});

var _Router2 = __webpack_require__(484);

var _Router3 = _interopRequireDefault(_Router2);

var _Link2 = __webpack_require__(264);

var _Link3 = _interopRequireDefault(_Link2);

var _IndexLink2 = __webpack_require__(506);

var _IndexLink3 = _interopRequireDefault(_IndexLink2);

var _withRouter2 = __webpack_require__(507);

var _withRouter3 = _interopRequireDefault(_withRouter2);

var _IndexRedirect2 = __webpack_require__(508);

var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);

var _IndexRoute2 = __webpack_require__(509);

var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);

var _Redirect2 = __webpack_require__(265);

var _Redirect3 = _interopRequireDefault(_Redirect2);

var _Route2 = __webpack_require__(510);

var _Route3 = _interopRequireDefault(_Route2);

var _History2 = __webpack_require__(511);

var _History3 = _interopRequireDefault(_History2);

var _Lifecycle2 = __webpack_require__(512);

var _Lifecycle3 = _interopRequireDefault(_Lifecycle2);

var _RouteContext2 = __webpack_require__(513);

var _RouteContext3 = _interopRequireDefault(_RouteContext2);

var _useRoutes2 = __webpack_require__(514);

var _useRoutes3 = _interopRequireDefault(_useRoutes2);

var _RouterContext2 = __webpack_require__(126);

var _RouterContext3 = _interopRequireDefault(_RouterContext2);

var _RoutingContext2 = __webpack_require__(515);

var _RoutingContext3 = _interopRequireDefault(_RoutingContext2);

var _PropTypes3 = _interopRequireDefault(_PropTypes2);

var _match2 = __webpack_require__(516);

var _match3 = _interopRequireDefault(_match2);

var _useRouterHistory2 = __webpack_require__(268);

var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);

var _applyRouterMiddleware2 = __webpack_require__(518);

var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);

var _browserHistory2 = __webpack_require__(519);

var _browserHistory3 = _interopRequireDefault(_browserHistory2);

var _hashHistory2 = __webpack_require__(521);

var _hashHistory3 = _interopRequireDefault(_hashHistory2);

var _createMemoryHistory2 = __webpack_require__(266);

var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Router = _Router3.default; /* components */

exports.Link = _Link3.default;
exports.IndexLink = _IndexLink3.default;
exports.withRouter = _withRouter3.default;

/* components (configuration) */

exports.IndexRedirect = _IndexRedirect3.default;
exports.IndexRoute = _IndexRoute3.default;
exports.Redirect = _Redirect3.default;
exports.Route = _Route3.default;

/* mixins */

exports.History = _History3.default;
exports.Lifecycle = _Lifecycle3.default;
exports.RouteContext = _RouteContext3.default;

/* utils */

exports.useRoutes = _useRoutes3.default;
exports.RouterContext = _RouterContext3.default;
exports.RoutingContext = _RoutingContext3.default;
exports.PropTypes = _PropTypes3.default;
exports.match = _match3.default;
exports.useRouterHistory = _useRouterHistory3.default;
exports.applyRouterMiddleware = _applyRouterMiddleware3.default;

/* histories */

exports.browserHistory = _browserHistory3.default;
exports.hashHistory = _hashHistory3.default;
exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.compilePattern = compilePattern;
exports.matchPattern = matchPattern;
exports.getParamNames = getParamNames;
exports.getParams = getParams;
exports.formatPattern = formatPattern;

var _invariant = __webpack_require__(25);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function _compilePattern(pattern) {
  var regexpSource = '';
  var paramNames = [];
  var tokens = [];

  var match = void 0,
      lastIndex = 0,
      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)/g;
  while (match = matcher.exec(pattern)) {
    if (match.index !== lastIndex) {
      tokens.push(pattern.slice(lastIndex, match.index));
      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
    }

    if (match[1]) {
      regexpSource += '([^/]+)';
      paramNames.push(match[1]);
    } else if (match[0] === '**') {
      regexpSource += '(.*)';
      paramNames.push('splat');
    } else if (match[0] === '*') {
      regexpSource += '(.*?)';
      paramNames.push('splat');
    } else if (match[0] === '(') {
      regexpSource += '(?:';
    } else if (match[0] === ')') {
      regexpSource += ')?';
    }

    tokens.push(match[0]);

    lastIndex = matcher.lastIndex;
  }

  if (lastIndex !== pattern.length) {
    tokens.push(pattern.slice(lastIndex, pattern.length));
    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
  }

  return {
    pattern: pattern,
    regexpSource: regexpSource,
    paramNames: paramNames,
    tokens: tokens
  };
}

var CompiledPatternsCache = Object.create(null);

function compilePattern(pattern) {
  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);

  return CompiledPatternsCache[pattern];
}

/**
 * Attempts to match a pattern on the given pathname. Patterns may use
 * the following special characters:
 *
 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
 *                  captured string is considered a "param"
 * - ()             Wraps a segment of the URL that is optional
 * - *              Consumes (non-greedy) all characters up to the next
 *                  character in the pattern, or to the end of the URL if
 *                  there is none
 * - **             Consumes (greedy) all characters up to the next character
 *                  in the pattern, or to the end of the URL if there is none
 *
 *  The function calls callback(error, matched) when finished.
 * The return value is an object with the following properties:
 *
 * - remainingPathname
 * - paramNames
 * - paramValues
 */
function matchPattern(pattern, pathname) {
  // Ensure pattern starts with leading slash for consistency with pathname.
  if (pattern.charAt(0) !== '/') {
    pattern = '/' + pattern;
  }

  var _compilePattern2 = compilePattern(pattern);

  var regexpSource = _compilePattern2.regexpSource;
  var paramNames = _compilePattern2.paramNames;
  var tokens = _compilePattern2.tokens;


  if (pattern.charAt(pattern.length - 1) !== '/') {
    regexpSource += '/?'; // Allow optional path separator at end.
  }

  // Special-case patterns like '*' for catch-all routes.
  if (tokens[tokens.length - 1] === '*') {
    regexpSource += '$';
  }

  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
  if (match == null) {
    return null;
  }

  var matchedPath = match[0];
  var remainingPathname = pathname.substr(matchedPath.length);

  if (remainingPathname) {
    // Require that the match ends at a path separator, if we didn't match
    // the full path, so any remaining pathname is a new path segment.
    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
      return null;
    }

    // If there is a remaining pathname, treat the path separator as part of
    // the remaining pathname for properly continuing the match.
    remainingPathname = '/' + remainingPathname;
  }

  return {
    remainingPathname: remainingPathname,
    paramNames: paramNames,
    paramValues: match.slice(1).map(function (v) {
      return v && decodeURIComponent(v);
    })
  };
}

function getParamNames(pattern) {
  return compilePattern(pattern).paramNames;
}

function getParams(pattern, pathname) {
  var match = matchPattern(pattern, pathname);
  if (!match) {
    return null;
  }

  var paramNames = match.paramNames;
  var paramValues = match.paramValues;

  var params = {};

  paramNames.forEach(function (paramName, index) {
    params[paramName] = paramValues[index];
  });

  return params;
}

/**
 * Returns a version of the given pattern with params interpolated. Throws
 * if there is a dynamic segment of the pattern for which there is no param.
 */
function formatPattern(pattern, params) {
  params = params || {};

  var _compilePattern3 = compilePattern(pattern);

  var tokens = _compilePattern3.tokens;

  var parenCount = 0,
      pathname = '',
      splatIndex = 0;

  var token = void 0,
      paramName = void 0,
      paramValue = void 0;
  for (var i = 0, len = tokens.length; i < len; ++i) {
    token = tokens[i];

    if (token === '*' || token === '**') {
      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;

      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;

      if (paramValue != null) pathname += encodeURI(paramValue);
    } else if (token === '(') {
      parenCount += 1;
    } else if (token === ')') {
      parenCount -= 1;
    } else if (token.charAt(0) === ':') {
      paramName = token.substring(1);
      paramValue = params[paramName];

      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;

      if (paramValue != null) pathname += encodeURIComponent(paramValue);
    } else {
      pathname += token;
    }
  }

  return pathname.replace(/\/+/g, '/');
}

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(133),
    baseIntersection = __webpack_require__(600),
    baseRest = __webpack_require__(302),
    castArrayLikeObject = __webpack_require__(606);

/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */
var intersection = baseRest(function(arrays) {
  var mapped = arrayMap(arrays, castArrayLikeObject);
  return (mapped.length && mapped[0] === arrays[0])
    ? baseIntersection(mapped)
    : [];
});

module.exports = intersection;


/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Bootstrap_namespaceObject = {};
__webpack_require__.d(Bootstrap_namespaceObject, "getUrl", function() { return getUrl; });
__webpack_require__.d(Bootstrap_namespaceObject, "getFallbackConfig", function() { return getFallbackConfig; });
__webpack_require__.d(Bootstrap_namespaceObject, "loadBootstrap", function() { return loadBootstrap; });
var ClientAPI_namespaceObject = {};
__webpack_require__.d(ClientAPI_namespaceObject, "FULL_PREAUTH_PROVIDERS", function() { return FULL_PREAUTH_PROVIDERS; });
__webpack_require__.d(ClientAPI_namespaceObject, "getClient", function() { return getClient; });
__webpack_require__.d(ClientAPI_namespaceObject, "getProviders", function() { return getProviders; });
__webpack_require__.d(ClientAPI_namespaceObject, "getProvider", function() { return getProvider; });
var SearchAPI_namespaceObject = {};
__webpack_require__.d(SearchAPI_namespaceObject, "ERROR_PAGE_RESPONSE", function() { return ERROR_PAGE_RESPONSE; });
__webpack_require__.d(SearchAPI_namespaceObject, "DEFAULT_CONFIGURATION", function() { return DEFAULT_CONFIGURATION; });
__webpack_require__.d(SearchAPI_namespaceObject, "getSuggestion", function() { return getSuggestion; });
__webpack_require__.d(SearchAPI_namespaceObject, "getSearchResults", function() { return getSearchResults; });
__webpack_require__.d(SearchAPI_namespaceObject, "getAllCompetitors", function() { return getAllCompetitors; });
__webpack_require__.d(SearchAPI_namespaceObject, "getEventsForTeam", function() { return getEventsForTeam; });
var VideoAPI_namespaceObject = {};
__webpack_require__.d(VideoAPI_namespaceObject, "getChannels", function() { return getChannels; });
var WatchAPI_namespaceObject = {};
__webpack_require__.d(WatchAPI_namespaceObject, "getServiceUrl", function() { return WatchAPI_getServiceUrl; });
__webpack_require__.d(WatchAPI_namespaceObject, "getListings", function() { return getListings; });
__webpack_require__.d(WatchAPI_namespaceObject, "getListingsBySubcategory", function() { return getListingsBySubcategory; });
__webpack_require__.d(WatchAPI_namespaceObject, "getTopCategories", function() { return getTopCategories; });
__webpack_require__.d(WatchAPI_namespaceObject, "getPrioritizedEventFromListings", function() { return getPrioritizedEventFromListings; });
var GraphQL_namespaceObject = {};
__webpack_require__.d(GraphQL_namespaceObject, "config", function() { return GraphQL_config; });
__webpack_require__.d(GraphQL_namespaceObject, "getServiceUrl", function() { return GraphQL_getServiceUrl; });
__webpack_require__.d(GraphQL_namespaceObject, "getBaseUrl", function() { return getBaseUrl; });
__webpack_require__.d(GraphQL_namespaceObject, "getNetworks", function() { return getNetworks; });
__webpack_require__.d(GraphQL_namespaceObject, "getAirings", function() { return getAirings; });
__webpack_require__.d(GraphQL_namespaceObject, "getAiring", function() { return getAiring; });
__webpack_require__.d(GraphQL_namespaceObject, "getVideo", function() { return getVideo; });
__webpack_require__.d(GraphQL_namespaceObject, "makeRequest", function() { return makeRequest; });

// EXTERNAL MODULE: ./node_modules/loglevel/lib/loglevel.js
var loglevel = __webpack_require__(73);
var loglevel_default = /*#__PURE__*/__webpack_require__.n(loglevel);

// EXTERNAL MODULE: ./config/index.js
var config_0 = __webpack_require__(16);
var config_default = /*#__PURE__*/__webpack_require__.n(config_0);

// EXTERNAL MODULE: ./app/enums.js
var enums = __webpack_require__(1);

// EXTERNAL MODULE: ./app/lib/metrics/newRelicEventBus.js
var newRelicEventBus = __webpack_require__(137);

// EXTERNAL MODULE: ./app/lib/api/cache/requestCache.js
var requestCache = __webpack_require__(42);

// EXTERNAL MODULE: ./app/lib/api/requestProxy.js
var requestProxy = __webpack_require__(43);

// EXTERNAL MODULE: ./app/lib/api/cache/fallbackCache.js
var fallbackCache = __webpack_require__(74);

// EXTERNAL MODULE: ./config/watchespn-web-1.0.config.qa.json
var watchespn_web_1_0_config_qa = __webpack_require__(634);
var watchespn_web_1_0_config_qa_default = /*#__PURE__*/__webpack_require__.n(watchespn_web_1_0_config_qa);

// EXTERNAL MODULE: ./config/watchespn-web-1.0.config.json
var watchespn_web_1_0_config = __webpack_require__(635);
var watchespn_web_1_0_config_default = /*#__PURE__*/__webpack_require__.n(watchespn_web_1_0_config);

// CONCATENATED MODULE: ./app/lib/api/Bootstrap.js
var _BOOTSTRAP_URL;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }











var log = loglevel_default.a.getLogger('Bootstrap');

var DEFAULT_EXPIRATION = 300;
var DEFAULT_TIMEOUT = 5000;
var BOOTSTRAP_URL = (_BOOTSTRAP_URL = {}, _defineProperty(_BOOTSTRAP_URL, enums["c" /* AppEnvs */].dev, config_0["secureCdnHost"] + '/connected-devices/app-configurations/watchespn-web-3.0_dev.config.json'), _defineProperty(_BOOTSTRAP_URL, enums["c" /* AppEnvs */].qa, config_0["secureCdnHost"] + '/connected-devices/app-configurations/watchespn-web-3.0_qa.config.json'), _defineProperty(_BOOTSTRAP_URL, enums["c" /* AppEnvs */].prod, config_0["secureCdnHost"] + '/connected-devices/app-configurations/watchespn-web-3.0.config.json'), _BOOTSTRAP_URL);

function getUrl() {
    var env = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : config_0["appEnv"];

    var url = BOOTSTRAP_URL[env];
    if (false) {
        // use non ssl domain for server side
        url = url.replace(secureCdnHost, 'http://proxy.espn.com');
    }
    return url;
}

function getFallbackConfig() {
    var env = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : config_0["appEnv"];

    return env === enums["c" /* AppEnvs */].prod ? watchespn_web_1_0_config_default.a : watchespn_web_1_0_config_qa_default.a;
}

function loadBootstrap() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        configEnv = _ref.configEnv;

    var url = getUrl(configEnv);
    return requestCache["a" /* default */].get(url).expiration(DEFAULT_EXPIRATION).use(requestProxy["a" /* default */]).timeout(DEFAULT_TIMEOUT).then(function (_ref2) {
        var body = _ref2.body;

        fallbackCache["a" /* default */].set(url, body);
        return body;
    }).catch(function (err) {
        log.error('loadBootstrap: ' + url, err.status, err.originalError);
        newRelicEventBus["b" /* newRelicEmitter */].emit(newRelicEventBus["a" /* UNFULFILLED_PROMISE_EVENT */], err);
        return fallbackCache["a" /* default */].get(url).then(function (config) {
            if (!config) {
                log.error('loadBootstrap: using fallbackConfig');
                var fallbackConfig = getFallbackConfig(configEnv);
                return fallbackConfig;
            }
            return config;
        });
    });
}
// EXTERNAL MODULE: ./app/lib/url-adapter/toAbsoluteURL.js
var toAbsoluteURL = __webpack_require__(90);

// EXTERNAL MODULE: ./app/lib/format/queryString.js
var queryString = __webpack_require__(18);

// CONCATENATED MODULE: ./app/lib/auth/Provider.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var appLinkBase = 'espnapi://espnnetworks.AdobePassProviderChosen';

var Provider_Provider = function () {
    function Provider(_ref) {
        var id = _ref.id,
            name = _ref.name,
            abbreviation = _ref.abbreviation,
            ispId = _ref.ispId,
            _ref$tier = _ref.tier,
            tier = _ref$tier === undefined ? 2 : _ref$tier,
            rank = _ref.rank,
            links = _ref.links,
            images = _ref.images,
            _ref$analytics = _ref.analytics,
            analytics = _ref$analytics === undefined ? {} : _ref$analytics,
            _ref$streamLimiting = _ref.streamLimiting,
            streamLimiting = _ref$streamLimiting === undefined ? {} : _ref$streamLimiting,
            _ref$countries = _ref.countries,
            countries = _ref$countries === undefined ? [{ countryCode: 'US' }] : _ref$countries,
            _ref$packages = _ref.packages,
            packages = _ref$packages === undefined ? [] : _ref$packages;
        var partner = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'espn';
        var platform = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'web';
        var version = arguments[3];

        _classCallCheck(this, Provider);

        this.id = id;
        this.name = name;
        this.abbreviation = abbreviation || ispId;
        this.ispId = ispId;
        this.tier = tier;
        this.rank = rank, this.links = links;
        this.images = images;
        this.analytics = analytics;
        this.streamLimiting = streamLimiting;
        this.countries = countries;
        this.packages = packages;
        var appLinkQuery = Object(queryString["a" /* default */])({ partner: partner, platform: platform, version: version, mvpd: abbreviation });
        this.appLink = '' + appLinkBase + appLinkQuery;
    }

    /**
     * Provider
     * @Param {Object} domesticProvider - A domestic provider from /watch/clients/watchespn-web/providers
     */


    _createClass(Provider, null, [{
        key: 'createProviderDomestic',
        value: function createProviderDomestic(provider, partner, platform, version) {
            return new Provider(provider, partner, platform, version);
        }

        /**
         * Provider
         * @Param {Object} intlProvider - An international affiliate from the intl provider feed
         */

    }, {
        key: 'createProviderIntl',
        value: function createProviderIntl(_ref2) {
            var name = _ref2.name,
                adobeId = _ref2.adobeId,
                analyticsId = _ref2.analyticsId,
                ispId = _ref2.ispId,
                _ref2$logos = _ref2.logos,
                desktop = _ref2$logos.desktop,
                mobile = _ref2$logos.mobile,
                settop = _ref2$logos.settop,
                pickerImage = _ref2$logos.pickerImage,
                negativebgcolorImage = _ref2$logos.negativebgcolorImage,
                positivebgcolorImage = _ref2$logos.positivebgcolorImage,
                websiteUrl = _ref2.websiteUrl,
                _ref2$countries = _ref2.countries,
                countries = _ref2$countries === undefined ? [] : _ref2$countries,
                packages = _ref2.packages;
            var countryCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

            var providerCountry = countries.filter(function (country) {
                return country.countryCode.toLowerCase() === countryCode.toLowerCase();
            });
            var tier = providerCountry.length > 0 && providerCountry[0].tier === 1 ? 1 : 2;
            var rank = providerCountry.length > 0 && providerCountry[0].rank ? providerCountry[0].rank : null;

            return new Provider({
                id: adobeId,
                name: name,
                abbreviation: adobeId,
                ispId: ispId,
                links: { web: { href: websiteUrl } },
                images: {
                    logo: { href: desktop },
                    mobile: { href: mobile },
                    settop: { href: settop },
                    picker: { href: pickerImage },
                    whiteBackground: { href: positivebgcolorImage },
                    colorWithPositiveBackground: { href: positivebgcolorImage },
                    colorWithNegativeBackground: { href: negativebgcolorImage }
                },
                analytics: { id: analyticsId },
                countries: countries,
                tier: tier,
                rank: rank,
                packages: packages
            });
        }
    }]);

    return Provider;
}();

/* harmony default export */ var auth_Provider = (Provider_Provider);
// CONCATENATED MODULE: ./app/lib/api/ClientAPI.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









var AdobePassEnv = enums["a" /* AdobePass */].Env;


var ClientAPI_log = loglevel_default.a.getLogger('ClientAPI');

var ONE_HOUR = 3600;

var CONFIGURATION = {
    baseUrl: '//api-app.espn.com',
    baseInternalUrl: '//sports-bc.prod.espninfra.starwave.com',
    endPoint: '/v1/watch/clients/',
    apiKey: '',
    intlProviderServiceUrl: 'https://affiliate.api.espn.com/affiliateApi/affiliates'
};

var QA_CONFIGURATION = {
    baseUrl: '//broadband.espnqa.com/espn360/apis',
    baseInternalUrl: '//sports-bc.qa.espninfra.starwave.com/espn360/apis',
    endPoint: '/v1/watch/clients/',
    apiKey: '',
    intlProviderServiceUrl: 'https://affiliate.api.qa.espn.com/affiliateApi/affiliates'
};

var INTL_QUERY = {
    includeProperties: true,
    rows: 1000,
    apikey: 'iay88gnrz4un1jiaclo88df33'
};

var FULL_PREAUTH_PROVIDERS = ['Comcast_SSO', 'ATT', 'Charter_Direct', 'TWC', 'Brighthouse', 'Cablevision', 'Verizon', 'Bend', 'WOW', 'Suddenlink', 'Mediacom', 'Dish', 'Grande', 'HTC', 'RCN'];

function ClientAPI_getServiceUrl() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        passenv = _ref.passenv,
        _ref$platform = _ref.platform,
        platform = _ref$platform === undefined ? 'web' : _ref$platform,
        _ref$partner = _ref.partner,
        partner = _ref$partner === undefined ? 'watchespn' : _ref$partner;

    var config = CONFIGURATION;
    if (passenv === AdobePassEnv.STAGING) {
        config = QA_CONFIGURATION;
    }
    return '' + Object(toAbsoluteURL["a" /* default */])(config.baseUrl) + config.endPoint + partner + '-' + platform;
}

function getProviderServiceUrl(_ref2) {
    var country = _ref2.country,
        passenv = _ref2.passenv,
        platform = _ref2.platform;

    var config = CONFIGURATION;
    if (passenv === AdobePassEnv.STAGING) {
        config = QA_CONFIGURATION;
    }
    if (country === 'US') {
        return ClientAPI_getServiceUrl({ passenv: passenv, platform: platform }) + '/providers?country=' + country;
    }

    return '' + config.intlProviderServiceUrl + Object(queryString["a" /* default */])(_extends({}, INTL_QUERY, { country: country }));
}

function getClient() {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref3$passenv = _ref3.passenv,
        passenv = _ref3$passenv === undefined ? AdobePassEnv.PROD : _ref3$passenv,
        _ref3$platform = _ref3.platform,
        platform = _ref3$platform === undefined ? 'web' : _ref3$platform;

    var url = ClientAPI_getServiceUrl({ passenv: passenv, platform: platform }) + '?enable=providers,channels';

    ClientAPI_log.debug('getClient: ' + url);

    return Object(requestCache["a" /* default */])(url).expiration(ONE_HOUR).use(requestProxy["a" /* default */]).then(function (_ref4) {
        var body = _ref4.body;

        var client = body.clients[0];
        var result = {
            channels: client.channels,
            providers: client.providers
        };

        fallbackCache["a" /* default */].set(url, result);
        return result;
    }).catch(function (err) {
        ClientAPI_log.error('getClient:', err.originalError);
        return fallbackCache["a" /* default */].get(url);
    });
}

function getProviders() {
    var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        country = _ref5.country,
        _ref5$passenv = _ref5.passenv,
        passenv = _ref5$passenv === undefined ? AdobePassEnv.PROD : _ref5$passenv,
        partner = _ref5.partner,
        platform = _ref5.platform,
        version = _ref5.version;

    var url = getProviderServiceUrl({ country: country, passenv: passenv, platform: platform });
    ClientAPI_log.debug('getProviders: ' + url);

    return requestCache["a" /* default */].get(url).expiration(ONE_HOUR).use(requestProxy["a" /* default */]).then(function (_ref6) {
        var body = _ref6.body;
        var clients = body.clients;

        if (clients) {
            var client = clients[0];
            var providers = client.providers.map(function (provider) {
                return auth_Provider.createProviderDomestic(provider, partner, platform, version);
            });
            fallbackCache["a" /* default */].set(url, providers);
            return providers;
        }

        var rows = body.rows;

        if (rows) {
            var intlProviders = rows.map(function (_ref7) {
                var data = _ref7.data;
                return auth_Provider.createProviderIntl(data, country);
            });
            fallbackCache["a" /* default */].set(url, intlProviders);
            return intlProviders;
        }
    }).catch(function (err) {
        ClientAPI_log.error('getProviders:', err.originalError);
        return fallbackCache["a" /* default */].get(url);
    });
}

function getProvider() {
    var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        abbreviation = _ref8.abbreviation,
        _ref8$country = _ref8.country,
        country = _ref8$country === undefined ? 'US' : _ref8$country,
        _ref8$passenv = _ref8.passenv,
        passenv = _ref8$passenv === undefined ? AdobePassEnv.PROD : _ref8$passenv,
        _ref8$partner = _ref8.partner,
        partner = _ref8$partner === undefined ? 'watchespn' : _ref8$partner,
        _ref8$platform = _ref8.platform,
        platform = _ref8$platform === undefined ? 'flash' : _ref8$platform;

    if (country === 'US') {
        var url = ClientAPI_getServiceUrl({ passenv: passenv, platform: platform }) + '/providers/' + abbreviation;

        ClientAPI_log.debug('getProviders: ' + url);

        return requestCache["a" /* default */].get(url).expiration(ONE_HOUR).use(requestProxy["a" /* default */]).then(function (_ref9) {
            var body = _ref9.body;
            var clients = body.clients;

            if (clients) {
                var client = clients[0];
                var provider = auth_Provider.createProviderDomestic(client.providers[0], partner, platform);
                fallbackCache["a" /* default */].set(url, provider);
                return provider;
            }
        }).catch(function (err) {
            ClientAPI_log.error('getProvider:', err.originalError);
            return fallbackCache["a" /* default */].get(url);
        });
    }
    return Promise.resolve();
}
// EXTERNAL MODULE: ./app/lib/api/PageAPI.js
var PageAPI = __webpack_require__(207);

// EXTERNAL MODULE: ./node_modules/bluebird/js/browser/bluebird.js
var bluebird = __webpack_require__(11);
var bluebird_default = /*#__PURE__*/__webpack_require__.n(bluebird);

// CONCATENATED MODULE: ./app/lib/format/sanitizeQuery.js
// Only allow Alpha-numeric, spaces, #, () and - in query

var emojiRegExp = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32-\ude3a]|[\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/;

function sanitizeQueryString(queryString) {
    var decodedQuery = decodeURIComponent(queryString);
    if (emojiRegExp.test(decodedQuery)) {
        return decodedQuery.codePointAt(0).toString(16);
    }
    return encodeURIComponent(decodedQuery.replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"$%*+,\\/:;<=>?@\[\]^_`{|}~]/gim, ''));
}
// CONCATENATED MODULE: ./app/lib/api/SearchAPI.js
var SearchAPI__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };












var SearchAPI_DEFAULT_TIMEOUT = 10000;
var ApiEnv = enums["b" /* Api */].Env;


var ERROR_PAGE_RESPONSE = {
    page: {
        name: 'Search API Error',
        buckets: []
    }
};
var ENVIRONMENT_CONFIGURATION = {
    dev: {
        serviceUrl: '//watch-search.espnsb.com'
    },
    qa: {
        serviceUrl: '//watch-search.espnqa.com'
    },
    staging: {
        serviceUrl: '//watch-search.espnqa.com'
    },
    prod: {
        serviceUrl: '//watch-search.espn.com'
    }
};

var DEFAULT_CONFIGURATION = {
    serviceUrl: ENVIRONMENT_CONFIGURATION.qa.serviceUrl,
    paths: {
        base: '/api/product/v3/watchespn/web/',
        search: '/api/product/v3/watchespn/web/search',
        suggest: '/api/product/v3/watchespn/web/suggest',
        keyword: {
            base: '/api/product/v3/watchespn/web/keywords',
            listings: '/listings'
        }
    }
};

var SearchAPI_config = SearchAPI__extends({}, DEFAULT_CONFIGURATION, config_0["searchApi"]);

var SearchAPI_getServiceUrl = function getServiceUrl() {
    var env = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ApiEnv.PROD;

    if (true) {
        var browserEnvironment = env; //global.watchGlobals && global.watchGlobals.env;
        return ENVIRONMENT_CONFIGURATION[browserEnvironment || env].serviceUrl;
    }
    return Object(toAbsoluteURL["a" /* default */])(ENVIRONMENT_CONFIGURATION[env].serviceUrl);
};

function getSuggestion() {
    var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var apiEnv = arguments[1];

    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        authNetworks = _ref.authNetworks,
        countryCode = _ref.countryCode,
        _ref$deviceType = _ref.deviceType,
        deviceType = _ref$deviceType === undefined ? enums["q" /* Device */].DESKTOP : _ref$deviceType,
        zipcode = _ref.zipcode,
        lang = _ref.lang,
        tz = _ref.tz;

    if (query.length === 0) {
        return bluebird_default.a.reject(new Error('No query to get a suggestion.'));
    }
    var sanitizedQuery = sanitizeQueryString(query);
    if (!sanitizedQuery) {
        return bluebird_default.a.reject(new Error('No Valid Query Entered'));
    }
    var qs = Object(queryString["a" /* default */])({
        q: sanitizedQuery,
        size: 3,
        authNetworks: authNetworks,
        countryCode: countryCode,
        deviceType: deviceType,
        zipcode: zipcode,
        lang: lang,
        tz: tz,
        includeDtcContent: true
    });
    var url = '' + SearchAPI_getServiceUrl(apiEnv) + SearchAPI_config.paths.suggest + qs;

    return requestCache["a" /* default */].get(url).use(requestProxy["a" /* default */]).timeout(SearchAPI_DEFAULT_TIMEOUT).then(function (_ref2) {
        var body = _ref2.body;

        fallbackCache["a" /* default */].set(url, body);
        return body;
    }, function (err) {
        if (err.status === 404) {
            return ERROR_PAGE_RESPONSE;
        }
        return fallbackCache["a" /* default */].get(url);
    });
}

function getSearchResults() {
    var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var apiEnv = arguments[1];

    var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        authNetworks = _ref3.authNetworks,
        countryCode = _ref3.countryCode,
        _ref3$deviceType = _ref3.deviceType,
        deviceType = _ref3$deviceType === undefined ? enums["q" /* Device */].DESKTOP : _ref3$deviceType,
        zipcode = _ref3.zipcode,
        lang = _ref3.lang,
        tz = _ref3.tz;

    if (query.length === 0) {
        return bluebird_default.a.reject(new Error('No params to get a search result.'));
    }

    var sanitizedQuery = sanitizeQueryString(query);
    if (!sanitizedQuery) {
        return bluebird_default.a.reject(new Error('No Valid Query Entered'));
    }
    var qs = Object(queryString["a" /* default */])({
        q: sanitizedQuery,
        size: 50,
        authNetworks: authNetworks,
        countryCode: countryCode,
        deviceType: deviceType,
        zipcode: zipcode,
        lang: lang,
        tz: tz,
        includeDtcContent: true
    });
    var url = '' + SearchAPI_getServiceUrl(apiEnv) + SearchAPI_config.paths.search + qs;

    return requestCache["a" /* default */].get(url).use(requestProxy["a" /* default */]).timeout(SearchAPI_DEFAULT_TIMEOUT).then(function (_ref4) {
        var body = _ref4.body;

        fallbackCache["a" /* default */].set(url, body);
        return body;
    }, function (err) {
        if (err.status === 404) {
            return ERROR_PAGE_RESPONSE;
        }
        return fallbackCache["a" /* default */].get(url);
    });
}

function getAllCompetitors(apiEnv) {
    var url = '' + SearchAPI_getServiceUrl(apiEnv) + SearchAPI_config.paths.keyword.base;
    return requestCache["a" /* default */].get(url).use(requestProxy["a" /* default */]).timeout(SearchAPI_DEFAULT_TIMEOUT).then(function (_ref5) {
        var body = _ref5.body;

        fallbackCache["a" /* default */].set(url, body);
        return body;
    }, function (err) {
        if (err.status === 404) {
            return [];
        }
        return fallbackCache["a" /* default */].get(url);
    });
}

function getEventsForTeam(team, apiEnv) {
    var _ref6 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        size = _ref6.size,
        includes = _ref6.includes,
        sortBy = _ref6.sortBy,
        sortOrder = _ref6.sortOrder;

    var qs = Object(queryString["a" /* default */])({
        size: size,
        includes: includes,
        sortBy: sortBy,
        sortOrder: sortOrder
    });
    var url = '' + SearchAPI_getServiceUrl(apiEnv) + SearchAPI_config.paths.keyword.base + '/' + encodeURIComponent(team) + '/listings' + qs;
    return requestCache["a" /* default */].get(url).use(requestProxy["a" /* default */]).timeout(SearchAPI_DEFAULT_TIMEOUT).then(function (_ref7) {
        var body = _ref7.body;

        fallbackCache["a" /* default */].set(url, body);
        return body;
    }, function (err) {
        if (err.status === 404) {
            return ERROR_PAGE_RESPONSE;
        }
        return fallbackCache["a" /* default */].get(url);
    });
}
// CONCATENATED MODULE: ./app/lib/api/VideoAPI.js
var VideoAPI__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var videoApiConfig = config_default.a.videoApi;

var VideoAPI_DEFAULT_CONFIGURATION = {
    serviceUrl: '//api-app.espn.com/v1/video',
    internalServiceUrl: '//sports-bc.prod.espninfra.starwave.com/allsports/apis/v1/video',
    apiKey: ''
};

var VideoAPI_config = VideoAPI__extends({}, VideoAPI_DEFAULT_CONFIGURATION, videoApiConfig);

function getChannels() {
    var url = Object(toAbsoluteURL["a" /* default */])(VideoAPI_config.serviceUrl) + '/channels';

    return Object(requestCache["a" /* default */])(url).use(requestProxy["a" /* default */]).then(function (response) {
        return response.body;
    }, function () {
        throw new Error('Could not retrieve video api data.');
    });
}
// EXTERNAL MODULE: ./app/lib/format/apiDateFormatter.js
var apiDateFormatter = __webpack_require__(105);

// EXTERNAL MODULE: ./app/constants.js
var constants = __webpack_require__(8);

// CONCATENATED MODULE: ./app/lib/api/WatchAPI.js
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var WatchAPI__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }













var WatchAPI_ApiEnv = enums["b" /* Api */].Env;


var WatchAPI_log = loglevel_default.a.getLogger('WatchAPI');
var watchApiConfig = config_default.a.watchApi;

var WatchAPI_DEFAULT_CONFIGURATION = {
    apiKey: '',
    networks: 'espn1,espn2,espn3,espnu,sec,secplus,espnews,espndeportes,longhorn,goalline,buzzerbeater,acc,accextra,secplus',
    resultsLimit: 200
};

var WatchAPI_getServiceUrl = function getServiceUrl() {
    var env = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : WatchAPI_ApiEnv.PROD;
    return Object(toAbsoluteURL["a" /* default */])(constants["h" /* LISTINGS_API_CONFIGURATION */][env].serviceUrl);
};

var WatchAPI_config = WatchAPI__extends({}, WatchAPI_DEFAULT_CONFIGURATION, watchApiConfig);

function getListings(_ref, listingsHref) {
    var types = _ref.types,
        networks = _ref.networks,
        id = _ref.id,
        eventId = _ref.eventId,
        airingId = _ref.airingId,
        categories = _ref.categories,
        subcategories = _ref.subcategories,
        dates = _ref.dates,
        _ref$limit = _ref.limit,
        limit = _ref$limit === undefined ? WatchAPI_config.resultsLimit : _ref$limit,
        _ref$apiEnv = _ref.apiEnv,
        apiEnv = _ref$apiEnv === undefined ? WatchAPI_ApiEnv.PROD : _ref$apiEnv;

    var typesQuery = types ? types.join(',') : '';
    var networksQuery = networks === '' ? WatchAPI_config.networks : null;
    var categoriesQuery = categories ? categories.join(',') : '';
    var subcategoriesQuery = subcategories ? subcategories.join(',') : '';
    var datesQuery = dates ? apiDateFormatter["a" /* default */].apply(undefined, _toConsumableArray(dates)) : 0;
    var limitQuery = limit;
    // Need ability to pass in listingsHref for conference channels (from state)
    var baseUrl = listingsHref || WatchAPI_getServiceUrl(apiEnv) + '/listings';

    var qs = Object(queryString["a" /* default */])({
        types: typesQuery,
        networks: networksQuery,
        id: id,
        eventId: eventId,
        airingId: airingId,
        categories: categoriesQuery,
        subcategories: subcategoriesQuery,
        dates: datesQuery,
        limit: limitQuery
    });
    // if a baseUrl is passed in, it could potentially already have queryParamters.  Need to replace ? with & if so
    var url = baseUrl.indexOf('?') !== -1 ? '' + baseUrl + qs.replace('?', '&') : '' + baseUrl + qs;

    WatchAPI_log.debug('getClient: ' + url);
    return Object(requestCache["a" /* default */])(url).use(requestProxy["a" /* default */]).then(function (response) {
        var listings = response.body.listings || [];
        fallbackCache["a" /* default */].set(url, listings);
        return listings;
    }).catch(function (err) {
        WatchAPI_log.error('getListings:', err.originalError);
        return fallbackCache["a" /* default */].get(url);
    });
}

function getListingsBySubcategory(_ref2) {
    var types = _ref2.types,
        networks = _ref2.networks,
        id = _ref2.id,
        eventId = _ref2.eventId,
        airingId = _ref2.airingId,
        subcategory = _ref2.subcategory,
        dates = _ref2.dates,
        _ref2$limit = _ref2.limit,
        limit = _ref2$limit === undefined ? WatchAPI_config.resultsLimit : _ref2$limit,
        _ref2$apiEnv = _ref2.apiEnv,
        apiEnv = _ref2$apiEnv === undefined ? WatchAPI_ApiEnv.PROD : _ref2$apiEnv;

    var typesQuery = types ? types.join(',') : '';
    var networksQuery = networks === '' ? WatchAPI_config.networks : networks.join(',');
    var datesQuery = 0;
    if (typeof dates === 'string' && /^\d{8}/.test(dates)) {
        datesQuery = dates;
    } else if (Array.isArray(dates)) {
        datesQuery = apiDateFormatter["a" /* default */].apply(undefined, _toConsumableArray(dates));
    }
    var limitQuery = limit;
    var baseUrl = WatchAPI_getServiceUrl(apiEnv) + '/subcategories/' + subcategory + '/listings';

    var qs = Object(queryString["a" /* default */])({
        types: typesQuery,
        networks: networksQuery,
        id: id,
        eventId: eventId,
        airingId: airingId,
        dates: datesQuery,
        limit: limitQuery
    });
    // if a baseUrl is passed in, it could potentially already have queryParamters.  Need to replace ? with & if so
    var url = baseUrl.indexOf('?') !== -1 ? '' + baseUrl + qs.replace('?', '&') : '' + baseUrl + qs;

    return Object(requestCache["a" /* default */])(url).use(requestProxy["a" /* default */]).then(function (response) {
        var subcategories = response.body.subcategories || [];
        var listings = subcategories[0] && subcategories[0].listings;
        fallbackCache["a" /* default */].set(url, listings);
        return listings;
    }).catch(function (err) {
        WatchAPI_log.error('getListingsBySubcategory:', err.originalError);
        return fallbackCache["a" /* default */].get(url);
    });
}

function getTopCategories() {
    var apiEnv = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : WatchAPI_ApiEnv.PROD;

    var url = WatchAPI_getServiceUrl(apiEnv) + '/categories/top';

    return Object(requestCache["a" /* default */])(url).use(requestProxy["a" /* default */]).then(function (response) {
        var categories = response.body.categories || [];
        fallbackCache["a" /* default */].set(url, categories);
        return categories;
    }).catch(function (err) {
        WatchAPI_log.error('getTopCategories:', err.originalError);
        return fallbackCache["a" /* default */].get(url);
    });
}

function getPrioritizedEventFromListings(listings, lang) {
    var event = void 0;
    var matchedLangLiveNonE3 = void 0;
    var matchedLiveE3 = void 0;
    var matchedLangLiveE3 = void 0;
    var matchedLiveNonE3 = void 0;
    var matchedLangNonE3 = void 0;
    var matchedLangE3 = void 0;
    var matchedLangReplay = void 0;
    var index = 0;
    var len = listings.length;

    for (; index < len; index += 1) {
        var content = listings[index];

        var type = content.type,
            sourceLang = content.lang,
            _content$broadcasts = _slicedToArray(content.broadcasts, 1),
            ncsId = _content$broadcasts[0].ncsId;

        event = content;
        if (len === 1) {
            break;
        }
        // prefer same lang, live and non-E3
        if (sourceLang === lang) {
            if (type === 'live') {
                if (ncsId !== 'n360') {
                    matchedLangLiveNonE3 = event;
                    break;
                } else if (!matchedLangLiveE3) {
                    matchedLangLiveE3 = event;
                }
            } else if (type === 'replay') {
                if (!matchedLangReplay) {
                    matchedLangReplay = event;
                }
            } else if (ncsId !== 'n360') {
                if (!matchedLangNonE3) {
                    matchedLangNonE3 = event;
                }
            } else if (!matchedLangE3) {
                matchedLangE3 = event;
            }
        } else if (type === 'live') {
            if (ncsId !== 'n360') {
                if (!matchedLiveNonE3) {
                    matchedLiveNonE3 = event;
                }
            } else if (!matchedLiveE3) {
                matchedLiveE3 = event;
            }
        }
    }

    return matchedLangLiveNonE3 || matchedLangLiveE3 || matchedLiveNonE3 || matchedLiveE3 || matchedLangReplay || matchedLangNonE3 || matchedLangE3 || event;
}
// CONCATENATED MODULE: ./app/queries.js
var AIRINGS = "\n    query Airings (\n        $countryCode: String!,\n        $deviceType: DeviceType!,\n        $tz: String!,\n        $type: AiringType,\n        $categories: [String],\n        $networks: [String],\n        $packages: [String],\n        $eventId: String,\n        $packageId: String,\n        $start: String,\n        $end: String,\n        $day: String,\n        $limit: Int\n    ) {\n        airings(\n            countryCode: $countryCode,\n            deviceType: $deviceType,\n            tz: $tz,\n            type: $type,\n            categories: $categories,\n            networks: $networks,\n            packages: $packages,\n            eventId: $eventId,\n            packageId: $packageId,\n            start: $start,\n            end: $end,\n            day: $day,\n            limit: $limit\n        ) {\n            id\n            airingId\n            simulcastAiringId\n            name\n            type\n            startDateTime\n            shortDate: startDate(style: SHORT)\n            authTypes\n            adobeRSS\n            duration\n            feedName\n            purchaseImage {\n                url\n            }\n            image {\n                url\n            }\n            network {\n                id\n                type\n                abbreviation\n                name\n                shortName\n                adobeResource\n                isIpAuth\n            }\n            source {\n                url\n                authorizationType\n                hasPassThroughAds\n                hasNielsenWatermarks\n                hasEspnId3Heartbeats\n                commercialReplacement\n            }\n            packages {\n                name\n            }\n            category {\n                id\n                name\n            }\n            subcategory {\n                id\n                name\n            }\n            sport {\n                id\n                name\n                abbreviation\n                code\n            }\n            league {\n                id\n                name\n                abbreviation\n                code\n            }\n            franchise {\n                id\n                name\n            }\n            program {\n                id\n                code\n                categoryCode\n                isStudio\n            }\n            tracking {\n                nielsenCrossId1\n                nielsenCrossId2\n                comscoreC6\n                trackingId\n            }\n        }\n    }\n";

var AIRING = "\n    query Airing (\n        $id: ID!,\n        $countryCode: String!,\n        $deviceType: DeviceType!,\n        $tz: String!\n    ) {\n        airing(\n            id: $id,\n            countryCode: $countryCode,\n            deviceType: $deviceType,\n            tz: $tz\n        ) {\n            id\n            airingId\n            simulcastAiringId\n            name\n            type\n            startDateTime\n            shortDate: startDate(style: SHORT)\n            authTypes\n            adobeRSS\n            duration\n            feedName\n            image {\n                url\n            }\n            network {\n                id\n                type\n                abbreviation\n                name\n                shortName\n                adobeResource\n                isIpAuth\n            }\n            source {\n                url\n                authorizationType\n                hasPassThroughAds\n                hasNielsenWatermarks\n                hasEspnId3Heartbeats\n                commercialReplacement\n            }\n            packages {\n                name\n            }\n            category {\n                id\n                name\n            }\n            subcategory {\n                id\n                name\n            }\n            sport {\n                id\n                name\n                abbreviation\n                code\n            }\n            league {\n                id\n                name\n                abbreviation\n                code\n            }\n            franchise {\n                id\n                name\n            }\n            program {\n                id\n                code\n                categoryCode\n                isStudio\n            }\n            tracking {\n                nielsenCrossId1\n                nielsenCrossId2\n                comscoreC6\n                trackingId\n            }\n        }\n    }\n";

var VOD = "\n    query VOD(\n        $countryCode: String!,\n        $deviceType: DeviceType!,\n        $tz: String!,\n        $packageId: String,\n        $id: ID!\n    ) {\n        VOD(\n            countryCode: $countryCode,\n            deviceType: $deviceType,\n            tz: $tz,\n            $packageId: String,\n            id: $id\n        ) {\n            id\n            name\n            origination\n            originalPublishDate\n            embargoDate\n            expirationDate\n            lastModifiedDate\n            image {\n                url\n            }\n            description\n            source {\n                url\n                authorizationType\n            }\n            category {\n                id\n                name\n            }\n            subcategory {\n                id\n                name\n            }\n            sport {\n                id\n                name\n                abbreviation\n                code\n            }\n            league {\n                id\n                name\n                abbreviation\n                code\n            }\n            links {\n                web\n            }\n            tracking {\n                name\n                sportName\n                leagueName\n            }\n            ad {\n                sport\n                bundle\n            }\n            coverageType\n            authTypes\n            duration\n        }\n    }\n";

var NETWORKS = "\n    query Networks(\n        $countryCode: String!\n    ) {\n        networks(\n            countryCode: $countryCode\n        ) {\n            id\n            name\n            abbreviation\n            shortName\n            adobeResource\n            type\n            isActive\n            isIpAuth\n        }\n    }\n";
// CONCATENATED MODULE: ./app/lib/api/GraphQL.js












var GraphQL_ApiEnv = enums["b" /* Api */].Env;


var GraphQL_log = loglevel_default.a.getLogger('GraphQL');

var GraphQL_config = {
    basePath: '/api'
};

var GraphQL_getServiceUrl = function getServiceUrl() {
    var env = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : GraphQL_ApiEnv.PROD;

    return Object(toAbsoluteURL["a" /* default */])(constants["f" /* GRAPHQL_API_CONFIGURATION */][env].serviceUrl);
};

var getBaseUrl = function getBaseUrl() {
    var env = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : GraphQL_ApiEnv.PROD;

    return '' + GraphQL_getServiceUrl(env) + GraphQL_config.basePath;
};

function getNetworks(_ref) {
    var lang = _ref.lang,
        apiEnv = _ref.apiEnv,
        variables = _ref.variables;

    return makeRequest({
        lang: lang,
        apiEnv: apiEnv,
        query: NETWORKS,
        variables: variables
    });
}

function getAirings(_ref2) {
    var lang = _ref2.lang,
        apiEnv = _ref2.apiEnv,
        variables = _ref2.variables;

    return makeRequest({
        lang: lang,
        apiEnv: apiEnv,
        query: AIRINGS,
        variables: variables
    });
}

function getAiring(_ref3) {
    var lang = _ref3.lang,
        apiEnv = _ref3.apiEnv,
        variables = _ref3.variables;

    return makeRequest({
        lang: lang,
        apiEnv: apiEnv,
        query: AIRING,
        variables: variables
    });
}

function getVideo(_ref4) {
    var lang = _ref4.lang,
        apiEnv = _ref4.apiEnv,
        variables = _ref4.variables;

    return makeRequest({
        lang: lang,
        apiEnv: apiEnv,
        query: VOD,
        variables: variables
    });
}

function makeRequest(_ref5) {
    var lang = _ref5.lang,
        apiEnv = _ref5.apiEnv,
        query = _ref5.query,
        variables = _ref5.variables;

    var qs = Object(queryString["a" /* default */])({
        query: query.replace(/\n/g, '').replace(/^(\s+)|(\s+)$/g, '').replace(/(\s+)/g, ' '),
        variables: JSON.stringify(variables),
        apiKey: constants["g" /* GRAPHQL_API_KEY */]
    }, true);
    var url = '' + getBaseUrl(apiEnv) + qs;
    GraphQL_log.debug('makeRequest: ' + url);

    return requestCache["a" /* default */].get(url).set('Accept-Language', lang).use(requestProxy["a" /* default */]).then(function (_ref6) {
        var body = _ref6.body;

        if (body.errors) {
            if (body.errors[0]) {
                var err = new Error(body.errors[0].message);
                GraphQL_log.error('makeRequest: ' + url, err.message);
                newRelicEventBus["b" /* newRelicEmitter */].emit(newRelicEventBus["a" /* UNFULFILLED_PROMISE_EVENT */], err);
            }
            return body;
        }
        fallbackCache["a" /* default */].set(url, body);
        return body;
    }).catch(function (err) {
        GraphQL_log.error('makeRequest: ' + url, err.status);
        newRelicEventBus["b" /* newRelicEmitter */].emit(newRelicEventBus["a" /* UNFULFILLED_PROMISE_EVENT */], err);
        // make sure response is not `null`, so we can use default assignment
        return fallbackCache["a" /* default */].get(url).then(function (response) {
            return response || {};
        });
    });
}
// CONCATENATED MODULE: ./app/lib/api/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return Bootstrap_namespaceObject; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return ClientAPI_namespaceObject; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return PageAPI; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return SearchAPI_namespaceObject; });
/* unused concated harmony import VideoAPI */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return VideoAPI_namespaceObject; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "f", function() { return WatchAPI_namespaceObject; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return GraphQL_namespaceObject; });










/***/ }),
/* 89 */
/***/ (function(module, exports) {



/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toAbsoluteURL;
function toAbsoluteURL(url) {
    if (url && url.indexOf('//') === 0 && !true) {
        // protocol relative and server side
        return 'http:' + url;
    } else if (url && url.indexOf('//') === 0 && true) {
        return 'https:' + url;
    }
    return url;
}

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return favoriteTeamSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return favoriteSportSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);


var fanSelector = function fanSelector(_ref) {
    var _ref$fan = _ref.fan,
        fan = _ref$fan === undefined ? {} : _ref$fan;
    return fan;
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(fanSelector, function (fan) {
    return fan;
}));

var favoriteTeamSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(fanSelector, function (_ref2) {
    var preferences = _ref2.preferences;

    var uids = void 0;
    if (!preferences || !preferences.metaData) {
        return uids;
    }

    uids = preferences.filter(function (_ref3) {
        var metaData = _ref3.metaData;
        return !!metaData.team;
    }).map(function (_ref4) {
        var metaData = _ref4.metaData;
        var sportId = metaData.sportId,
            teamId = metaData.teamId;

        var value = '';
        // do not grab `uid` since it includes the league info we never supports
        if (sportId) {
            value = 's:' + sportId;
            if (teamId) {
                value += '~t:' + teamId;
            }
        }
        return value;
    });
    return uids.join(',');
});

var favoriteSportSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(fanSelector, function (_ref5) {
    var preferences = _ref5.preferences;

    var uids = void 0;
    if (!preferences || !preferences.metaData) {
        return uids;
    }

    uids = preferences.filter(function (_ref6) {
        var metaData = _ref6.metaData;
        return !!metaData.sport;
    }).map(function (_ref7) {
        var metaData = _ref7.metaData;
        var sportId = metaData.sportId;

        var value = '';
        // do not grab `uid` since it includes the league info we never supports
        if (sportId) {
            value = 's:' + sportId;
        }
        return value;
    });
    return uids.join(',');
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADS_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADS_CONFIG_INVALIDATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADS_INITIALIZED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ADS_REFRESHED; });
/* unused harmony export setAdsConfig */
/* harmony export (immutable) */ __webpack_exports__["g"] = initAdsConfig;
/* unused harmony export invalidateAdsConfig */
/* harmony export (immutable) */ __webpack_exports__["e"] = adsInitialized;
/* harmony export (immutable) */ __webpack_exports__["f"] = adsRefreshed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_appSelector__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectors_adsSelector__ = __webpack_require__(310);



var ADS_CONFIG = 'ADS_CONFIG';
var ADS_CONFIG_INVALIDATED = 'ADS_CONFIG_INVALIDATED';
var ADS_INITIALIZED = 'ADS_INITIALIZED';
var ADS_REFRESHED = 'ADS_REFRESHED';

function normalizePageId(id) {
    return id === 'home' ? 'index' : id;
}

function setAdsConfig(id, config) {
    return {
        type: ADS_CONFIG,
        id: id,
        config: config
    };
}

function initAdsConfig() {
    var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var tracking = arguments[1];
    var kvps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var query = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    return function (dispatch, getState) {
        var pageId = normalizePageId(id);
        var state = getState();
        var adSite = Object(__WEBPACK_IMPORTED_MODULE_1__selectors_adsSelector__["a" /* adSiteSelector */])(state);
        var adEdition = Object(__WEBPACK_IMPORTED_MODULE_0__selectors_appSelector__["a" /* adEditionSelector */])(state);
        var pgn = normalizePageId((tracking && tracking.context && tracking.context.PageName || '').toLowerCase());
        var adprodtest = query.adprodtest,
            adtar = query.adtar,
            tstAdTar = query.tstAdTar;
        // NOTE: The `adtar`, `adprodtest` and `tstAdTar` query params are used to test Content|Overlay|Banner Ads
        // Example: ?adprodtest=usuaptest01 will return test Ad placeholders

        var adtarParam = adprodtest || adtar || null;
        var tstAdTarParam = tstAdTar || null;

        kvps.pgtyp = pageId;
        kvps.ed = adEdition;
        if (pgn) {
            kvps.pgn = pgn;
        }

        // NOTE: New key as of 05/2019
        // SEE: https://espnjira.disney.com/browse/WEWEB-2308
        if (tstAdTarParam) {
            kvps.tstAdTar = tstAdTarParam;
        } else if (adtarParam) {
            kvps.adtar = adtarParam;
        }

        var config = { level: adSite + '/watch/' + pageId, kvps: kvps };
        return dispatch(setAdsConfig(id, config));
    };
}

function invalidateAdsConfig() {
    return {
        type: ADS_CONFIG_INVALIDATED
    };
}

function adsInitialized() {
    return {
        type: ADS_INITIALIZED
    };
}

function adsRefreshed() {
    return {
        type: ADS_REFRESHED
    };
}

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__(323);

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

module.exports = uniq;


/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../locale-data/index.js (ignored)
var locale_data_ignored_ = __webpack_require__(692);
var locale_data_ignored__default = /*#__PURE__*/__webpack_require__.n(locale_data_ignored_);

// EXTERNAL MODULE: ./node_modules/intl-messageformat/index.js
var intl_messageformat = __webpack_require__(336);
var intl_messageformat_default = /*#__PURE__*/__webpack_require__.n(intl_messageformat);

// EXTERNAL MODULE: ./node_modules/intl-relativeformat/index.js
var intl_relativeformat = __webpack_require__(701);
var intl_relativeformat_default = /*#__PURE__*/__webpack_require__.n(intl_relativeformat);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(177);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-intl/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(708);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);

// EXTERNAL MODULE: ./node_modules/invariant/browser.js
var browser = __webpack_require__(25);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);

// CONCATENATED MODULE: ./node_modules/intl-format-cache/lib/index.js
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
var RelativeTimeFormat;
// -- Utilities ----------------------------------------------------------------
function getCacheId(inputs) {
    return JSON.stringify(inputs.map(function (input) {
        return input && typeof input === 'object' ? orderedProps(input) : input;
    }));
}
function orderedProps(obj) {
    return Object.keys(obj)
        .sort()
        .map(function (k) {
        var _a;
        return (_a = {}, _a[k] = obj[k], _a);
    });
}
var memoizeFormatConstructor = function (FormatConstructor, cache) {
    if (cache === void 0) { cache = {}; }
    return function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var cacheId = getCacheId(args);
        var format = cacheId && cache[cacheId];
        if (!format) {
            format = new ((_a = FormatConstructor).bind.apply(_a, [void 0].concat(args)))();
            if (cacheId) {
                cache[cacheId] = format;
            }
        }
        return format;
    };
};
/* harmony default export */ var lib = (memoizeFormatConstructor);
//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./node_modules/react-intl/lib/index.es.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return addLocaleData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return intlShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return injectIntl; });
/* unused harmony export defineMessages */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return index_es_IntlProvider; });
/* unused harmony export FormattedDate */
/* unused harmony export FormattedTime */
/* unused harmony export FormattedRelative */
/* unused harmony export FormattedNumber */
/* unused harmony export FormattedPlural */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return index_es_FormattedMessage; });
/* unused harmony export FormattedHTMLMessage */
/*
 * Copyright 2019, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */










// GENERATED FILE
var defaultLocaleData = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
    var s = String(n).split("."),
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
  }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "year-short": { "displayName": "yr.", "relative": { "0": "this yr.", "1": "next yr.", "-1": "last yr." }, "relativeTime": { "future": { "one": "in {0} yr.", "other": "in {0} yr." }, "past": { "one": "{0} yr. ago", "other": "{0} yr. ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "month-short": { "displayName": "mo.", "relative": { "0": "this mo.", "1": "next mo.", "-1": "last mo." }, "relativeTime": { "future": { "one": "in {0} mo.", "other": "in {0} mo." }, "past": { "one": "{0} mo. ago", "other": "{0} mo. ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "day-short": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "hour-short": { "displayName": "hr.", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hr.", "other": "in {0} hr." }, "past": { "one": "{0} hr. ago", "other": "{0} hr. ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "minute-short": { "displayName": "min.", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} min.", "other": "in {0} min." }, "past": { "one": "{0} min. ago", "other": "{0} min. ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } }, "second-short": { "displayName": "sec.", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} sec.", "other": "in {0} sec." }, "past": { "one": "{0} sec. ago", "other": "{0} sec. ago" } } } } };

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function addLocaleData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var locales = Array.isArray(data) ? data : [data];

  locales.forEach(function (localeData) {
    if (localeData && localeData.locale) {
      intl_messageformat_default.a.__addLocaleData(localeData);
      intl_relativeformat_default.a.__addLocaleData(localeData);
    }
  });
}

function hasLocaleData(locale) {
  var localeParts = (locale || '').split('-');

  while (localeParts.length > 0) {
    if (hasIMFAndIRFLocaleData(localeParts.join('-'))) {
      return true;
    }

    localeParts.pop();
  }

  return false;
}

function hasIMFAndIRFLocaleData(locale) {
  var normalizedLocale = locale && locale.toLowerCase();

  return !!(intl_messageformat_default.a.__localeData__[normalizedLocale] && intl_relativeformat_default.a.__localeData__[normalizedLocale]);
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};



















var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var bool = prop_types_default.a.bool;
var number = prop_types_default.a.number;
var string = prop_types_default.a.string;
var func = prop_types_default.a.func;
var object = prop_types_default.a.object;
var oneOf = prop_types_default.a.oneOf;
var shape = prop_types_default.a.shape;
var any = prop_types_default.a.any;
var oneOfType = prop_types_default.a.oneOfType;

var localeMatcher = oneOf(['best fit', 'lookup']);
var narrowShortLong = oneOf(['narrow', 'short', 'long']);
var numeric2digit = oneOf(['numeric', '2-digit']);
var funcReq = func.isRequired;

var intlConfigPropTypes = {
  locale: string,
  timeZone: string,
  formats: object,
  messages: object,
  textComponent: any,

  defaultLocale: string,
  defaultFormats: object,

  onError: func
};

var intlFormatPropTypes = {
  formatDate: funcReq,
  formatTime: funcReq,
  formatRelative: funcReq,
  formatNumber: funcReq,
  formatPlural: funcReq,
  formatMessage: funcReq,
  formatHTMLMessage: funcReq
};

var intlShape = shape(_extends({}, intlConfigPropTypes, intlFormatPropTypes, {
  formatters: object,
  now: funcReq
}));

var messageDescriptorPropTypes = {
  id: string.isRequired,
  description: oneOfType([string, object]),
  defaultMessage: string
};

var dateTimeFormatPropTypes = {
  localeMatcher: localeMatcher,
  formatMatcher: oneOf(['basic', 'best fit']),

  timeZone: string,
  hour12: bool,

  weekday: narrowShortLong,
  era: narrowShortLong,
  year: numeric2digit,
  month: oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
  day: numeric2digit,
  hour: numeric2digit,
  minute: numeric2digit,
  second: numeric2digit,
  timeZoneName: oneOf(['short', 'long'])
};

var numberFormatPropTypes = {
  localeMatcher: localeMatcher,

  style: oneOf(['decimal', 'currency', 'percent']),
  currency: string,
  currencyDisplay: oneOf(['symbol', 'code', 'name']),
  useGrouping: bool,

  minimumIntegerDigits: number,
  minimumFractionDigits: number,
  maximumFractionDigits: number,
  minimumSignificantDigits: number,
  maximumSignificantDigits: number
};

var relativeFormatPropTypes = {
  style: oneOf(['best fit', 'numeric']),
  units: oneOf(['second', 'minute', 'hour', 'day', 'month', 'year', 'second-short', 'minute-short', 'hour-short', 'day-short', 'month-short', 'year-short'])
};

var pluralFormatPropTypes = {
  style: oneOf(['cardinal', 'ordinal'])
};

/*
HTML escaping and shallow-equals implementations are the same as React's
(on purpose.) Therefore, it has the following Copyright and Licensing:

Copyright 2013-2014, Facebook, Inc.
All rights reserved.

This source code is licensed under the BSD-style license found in the LICENSE
file in the root directory of React's source tree.
*/

var intlConfigPropNames = Object.keys(intlConfigPropTypes);

var ESCAPED_CHARS = {
  '&': '&amp;',
  '>': '&gt;',
  '<': '&lt;',
  '"': '&quot;',
  "'": '&#x27;'
};

var UNSAFE_CHARS_REGEX = /[&><"']/g;

function index_es_escape(str) {
  return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
    return ESCAPED_CHARS[match];
  });
}

function filterProps(props, whitelist) {
  var defaults$$1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return whitelist.reduce(function (filtered, name) {
    if (props.hasOwnProperty(name)) {
      filtered[name] = props[name];
    } else if (defaults$$1.hasOwnProperty(name)) {
      filtered[name] = defaults$$1[name];
    }

    return filtered;
  }, {});
}

function invariantIntlContext() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      intl = _ref.intl;

  browser_default()(intl, '[React Intl] Could not find required `intl` object. ' + '<IntlProvider> needs to exist in the component ancestry.');
}

function shallowEquals(objA, objB) {
  if (objA === objB) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
  for (var i = 0; i < keysA.length; i++) {
    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

function shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
  var props = _ref2.props,
      state = _ref2.state,
      _ref2$context = _ref2.context,
      context = _ref2$context === undefined ? {} : _ref2$context;
  var nextContext = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _context$intl = context.intl,
      intl = _context$intl === undefined ? {} : _context$intl;
  var _nextContext$intl = nextContext.intl,
      nextIntl = _nextContext$intl === undefined ? {} : _nextContext$intl;


  return !shallowEquals(nextProps, props) || !shallowEquals(nextState, state) || !(nextIntl === intl || shallowEquals(filterProps(nextIntl, intlConfigPropNames), filterProps(intl, intlConfigPropNames)));
}

function createError(message, exception) {
  var eMsg = exception ? '\n' + exception : '';
  return '[React Intl] ' + message + eMsg;
}

function defaultErrorHandler(error) {
  if (false) {
    console.error(error);
  }
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// Inspired by react-redux's `connect()` HOC factory function implementation:
// https://github.com/rackt/react-redux

function getDisplayName(Component$$1) {
  return Component$$1.displayName || Component$$1.name || 'Component';
}

function injectIntl(WrappedComponent) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$intlPropName = options.intlPropName,
      intlPropName = _options$intlPropName === undefined ? 'intl' : _options$intlPropName,
      _options$withRef = options.withRef,
      withRef = _options$withRef === undefined ? false : _options$withRef;

  var InjectIntl = function (_Component) {
    inherits(InjectIntl, _Component);

    function InjectIntl(props, context) {
      classCallCheck(this, InjectIntl);

      var _this = possibleConstructorReturn(this, (InjectIntl.__proto__ || Object.getPrototypeOf(InjectIntl)).call(this, props, context));

      invariantIntlContext(context);
      return _this;
    }

    createClass(InjectIntl, [{
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        browser_default()(withRef, '[React Intl] To access the wrapped instance, ' + 'the `{withRef: true}` option must be set when calling: ' + '`injectIntl()`');

        return this._wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        return react_default.a.createElement(WrappedComponent, _extends({}, this.props, defineProperty({}, intlPropName, this.context.intl), {
          ref: withRef ? /* istanbul ignore next */function (ref) {
            return _this2._wrappedInstance = ref;
          } : null
        }));
      }
    }]);
    return InjectIntl;
  }(react["Component"]);

  InjectIntl.displayName = 'InjectIntl(' + getDisplayName(WrappedComponent) + ')';
  InjectIntl.contextTypes = {
    intl: intlShape
  };
  InjectIntl.WrappedComponent = WrappedComponent;


  return hoist_non_react_statics_cjs_default()(InjectIntl, WrappedComponent);
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function defineMessages(messageDescriptors) {
  // This simply returns what's passed-in because it's meant to be a hook for
  // babel-plugin-react-intl.
  return messageDescriptors;
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// This is a "hack" until a proper `intl-pluralformat` package is created.

function resolveLocale(locales) {
  // IntlMessageFormat#_resolveLocale() does not depend on `this`.
  return intl_messageformat_default.a.prototype._resolveLocale(locales);
}

function findPluralFunction(locale) {
  // IntlMessageFormat#_findPluralFunction() does not depend on `this`.
  return intl_messageformat_default.a.prototype._findPluralRuleFunction(locale);
}

var IntlPluralFormat = function IntlPluralFormat(locales) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  classCallCheck(this, IntlPluralFormat);

  var useOrdinal = options.style === 'ordinal';
  var pluralFn = findPluralFunction(resolveLocale(locales));

  this.format = function (value) {
    return pluralFn(value, useOrdinal);
  };
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var DATE_TIME_FORMAT_OPTIONS = Object.keys(dateTimeFormatPropTypes);
var NUMBER_FORMAT_OPTIONS = Object.keys(numberFormatPropTypes);
var RELATIVE_FORMAT_OPTIONS = Object.keys(relativeFormatPropTypes);
var PLURAL_FORMAT_OPTIONS = Object.keys(pluralFormatPropTypes);

var RELATIVE_FORMAT_THRESHOLDS = {
  second: 60, // seconds to minute
  minute: 60, // minutes to hour
  hour: 24, // hours to day
  day: 30, // days to month
  month: 12 };

function updateRelativeFormatThresholds(newThresholds) {
  var thresholds = intl_relativeformat_default.a.thresholds;
  thresholds.second = newThresholds.second;
  thresholds.minute = newThresholds.minute;
  thresholds.hour = newThresholds.hour;
  thresholds.day = newThresholds.day;
  thresholds.month = newThresholds.month;
  thresholds['second-short'] = newThresholds['second-short'];
  thresholds['minute-short'] = newThresholds['minute-short'];
  thresholds['hour-short'] = newThresholds['hour-short'];
  thresholds['day-short'] = newThresholds['day-short'];
  thresholds['month-short'] = newThresholds['month-short'];
}

function getNamedFormat(formats, type, name, onError) {
  var format = formats && formats[type] && formats[type][name];
  if (format) {
    return format;
  }

  onError(createError('No ' + type + ' format named: ' + name));
}

function index_es_formatDate(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      timeZone = config.timeZone;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var defaults$$1 = _extends({}, timeZone && { timeZone: timeZone }, format && getNamedFormat(formats, 'date', format, onError));
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    onError(createError('Error formatting date.', e));
  }

  return String(date);
}

function index_es_formatTime(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      timeZone = config.timeZone;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var defaults$$1 = _extends({}, timeZone && { timeZone: timeZone }, format && getNamedFormat(formats, 'time', format, onError));
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  if (!filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second) {
    // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = _extends({}, filteredOptions, { hour: 'numeric', minute: 'numeric' });
  }

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    onError(createError('Error formatting time.', e));
  }

  return String(date);
}

function index_es_formatRelative(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var now = new Date(options.now);
  var defaults$$1 = format && getNamedFormat(formats, 'relative', format, onError);
  var filteredOptions = filterProps(options, RELATIVE_FORMAT_OPTIONS, defaults$$1);

  // Capture the current threshold values, then temporarily override them with
  // specific values just for this render.
  var oldThresholds = _extends({}, intl_relativeformat_default.a.thresholds);
  updateRelativeFormatThresholds(RELATIVE_FORMAT_THRESHOLDS);

  try {
    return state.getRelativeFormat(locale, filteredOptions).format(date, {
      now: isFinite(now) ? now : state.now()
    });
  } catch (e) {
    onError(createError('Error formatting relative time.', e));
  } finally {
    updateRelativeFormatThresholds(oldThresholds);
  }

  return String(date);
}

function index_es_formatNumber(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var defaults$$1 = format && getNamedFormat(formats, 'number', format, onError);
  var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getNumberFormat(locale, filteredOptions).format(value);
  } catch (e) {
    onError(createError('Error formatting number.', e));
  }

  return String(value);
}

function index_es_formatPlural(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale;


  var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);
  var onError = config.onError || defaultErrorHandler;

  try {
    return state.getPluralFormat(locale, filteredOptions).format(value);
  } catch (e) {
    onError(createError('Error formatting plural.', e));
  }

  return 'other';
}

function formatMessage(config, state) {
  var messageDescriptor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      messages = config.messages,
      defaultLocale = config.defaultLocale,
      defaultFormats = config.defaultFormats;
  var id = messageDescriptor.id,
      defaultMessage = messageDescriptor.defaultMessage;

  // Produce a better error if the user calls `intl.formatMessage(element)`

  if (false) {
    invariant(!isValidElement(config), '[React Intl] Don\'t pass React elements to ' + 'formatMessage(), pass `.props`.');
  }

  // `id` is a required field of a Message Descriptor.
  browser_default()(id, '[React Intl] An `id` must be provided to format a message.');

  var message = messages && messages[id];
  var hasValues = Object.keys(values).length > 0;

  // Avoid expensive message formatting for simple messages without values. In
  // development messages will always be formatted in case of missing values.
  if (!hasValues && "production" === 'production') {
    return message || defaultMessage || id;
  }

  var formattedMessage = void 0;
  var onError = config.onError || defaultErrorHandler;

  if (message) {
    try {
      var formatter = state.getMessageFormat(message, locale, formats);

      formattedMessage = formatter.format(values);
    } catch (e) {
      onError(createError('Error formatting message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : ''), e));
    }
  } else {
    // This prevents warnings from littering the console in development
    // when no `messages` are passed into the <IntlProvider> for the
    // default locale, and a default message is in the source.
    if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) {
      onError(createError('Missing message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : '')));
    }
  }

  if (!formattedMessage && defaultMessage) {
    try {
      var _formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);

      formattedMessage = _formatter.format(values);
    } catch (e) {
      onError(createError('Error formatting the default message for: "' + id + '"', e));
    }
  }

  if (!formattedMessage) {
    onError(createError('Cannot format message: "' + id + '", ' + ('using message ' + (message || defaultMessage ? 'source' : 'id') + ' as fallback.')));
  }

  return formattedMessage || message || defaultMessage || id;
}

function index_es_formatHTMLMessage(config, state, messageDescriptor) {
  var rawValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  // Process all the values before they are used when formatting the ICU
  // Message string. Since the formatted message might be injected via
  // `innerHTML`, all String-based values need to be HTML-escaped.
  var escapedValues = Object.keys(rawValues).reduce(function (escaped, name) {
    var value = rawValues[name];
    escaped[name] = typeof value === 'string' ? index_es_escape(value) : value;
    return escaped;
  }, {});

  return formatMessage(config, state, messageDescriptor, escapedValues);
}



var index_es_format = Object.freeze({
	formatDate: index_es_formatDate,
	formatTime: index_es_formatTime,
	formatRelative: index_es_formatRelative,
	formatNumber: index_es_formatNumber,
	formatPlural: index_es_formatPlural,
	formatMessage: formatMessage,
	formatHTMLMessage: index_es_formatHTMLMessage
});

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var intlConfigPropNames$1 = Object.keys(intlConfigPropTypes);
var intlFormatPropNames = Object.keys(intlFormatPropTypes);

// These are not a static property on the `IntlProvider` class so the intl
// config values can be inherited from an <IntlProvider> ancestor.
var defaultProps = {
  formats: {},
  messages: {},
  timeZone: null,
  textComponent: 'span',

  defaultLocale: 'en',
  defaultFormats: {},

  onError: defaultErrorHandler
};

var index_es_IntlProvider = function (_Component) {
  inherits(IntlProvider, _Component);

  function IntlProvider(props) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    classCallCheck(this, IntlProvider);

    var _this = possibleConstructorReturn(this, (IntlProvider.__proto__ || Object.getPrototypeOf(IntlProvider)).call(this, props, context));

    browser_default()(typeof Intl !== 'undefined', '[React Intl] The `Intl` APIs must be available in the runtime, ' + 'and do not appear to be built-in. An `Intl` polyfill should be loaded.\n' + 'See: http://formatjs.io/guides/runtime-environments/');

    var intlContext = context.intl;

    // Used to stabilize time when performing an initial rendering so that
    // all relative times use the same reference "now" time.

    var initialNow = void 0;
    if (isFinite(props.initialNow)) {
      initialNow = Number(props.initialNow);
    } else {
      // When an `initialNow` isn't provided via `props`, look to see an
      // <IntlProvider> exists in the ancestry and call its `now()`
      // function to propagate its value for "now".
      initialNow = intlContext ? intlContext.now() : Date.now();
    }

    // Creating `Intl*` formatters is expensive. If there's a parent
    // `<IntlProvider>`, then its formatters will be used. Otherwise, this
    // memoize the `Intl*` constructors and cache them for the lifecycle of
    // this IntlProvider instance.

    var _ref = intlContext || {},
        _ref$formatters = _ref.formatters,
        formatters = _ref$formatters === undefined ? {
      getDateTimeFormat: lib(Intl.DateTimeFormat),
      getNumberFormat: lib(Intl.NumberFormat),
      getMessageFormat: lib(intl_messageformat_default.a),
      getRelativeFormat: lib(intl_relativeformat_default.a),
      getPluralFormat: lib(IntlPluralFormat)
    } : _ref$formatters;

    _this.state = _extends({}, formatters, {

      // Wrapper to provide stable "now" time for initial render.
      now: function now() {
        return _this._didDisplay ? Date.now() : initialNow;
      }
    });
    return _this;
  }

  createClass(IntlProvider, [{
    key: 'getConfig',
    value: function getConfig() {
      var intlContext = this.context.intl;

      // Build a whitelisted config object from `props`, defaults, and
      // `context.intl`, if an <IntlProvider> exists in the ancestry.

      var config = filterProps(this.props, intlConfigPropNames$1, intlContext);

      // Apply default props. This must be applied last after the props have
      // been resolved and inherited from any <IntlProvider> in the ancestry.
      // This matches how React resolves `defaultProps`.
      for (var propName in defaultProps) {
        if (config[propName] === undefined) {
          config[propName] = defaultProps[propName];
        }
      }

      if (!hasLocaleData(config.locale)) {
        var _config = config,
            locale = _config.locale,
            defaultLocale = _config.defaultLocale,
            defaultFormats = _config.defaultFormats,
            onError = _config.onError;


        onError(createError('Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale + '" as fallback.')));

        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        config = _extends({}, config, {
          locale: defaultLocale,
          formats: defaultFormats,
          messages: defaultProps.messages
        });
      }

      return config;
    }
  }, {
    key: 'getBoundFormatFns',
    value: function getBoundFormatFns(config, state) {
      return intlFormatPropNames.reduce(function (boundFormatFns, name) {
        boundFormatFns[name] = index_es_format[name].bind(null, config, state);
        return boundFormatFns;
      }, {});
    }
  }, {
    key: 'getChildContext',
    value: function getChildContext() {
      var config = this.getConfig();

      // Bind intl factories and current config to the format functions.
      var boundFormatFns = this.getBoundFormatFns(config, this.state);

      var _state = this.state,
          now = _state.now,
          formatters = objectWithoutProperties(_state, ['now']);


      return {
        intl: _extends({}, config, boundFormatFns, {
          formatters: formatters,
          now: now
        })
      };
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._didDisplay = true;
    }
  }, {
    key: 'render',
    value: function render() {
      return react["Children"].only(this.props.children);
    }
  }]);
  return IntlProvider;
}(react["Component"]);

index_es_IntlProvider.displayName = 'IntlProvider';
index_es_IntlProvider.contextTypes = {
  intl: intlShape
};
index_es_IntlProvider.childContextTypes = {
  intl: intlShape.isRequired
};
 false ? index_es_IntlProvider.propTypes = _extends({}, intlConfigPropTypes, {
  children: PropTypes.element.isRequired,
  initialNow: PropTypes.any
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var index_es_FormattedDate = function (_Component) {
  inherits(FormattedDate, _Component);

  function FormattedDate(props, context) {
    classCallCheck(this, FormattedDate);

    var _this = possibleConstructorReturn(this, (FormattedDate.__proto__ || Object.getPrototypeOf(FormattedDate)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedDate, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatDate = _context$intl.formatDate,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedDate = formatDate(value, this.props);

      if (typeof children === 'function') {
        return children(formattedDate);
      }

      return react_default.a.createElement(
        Text,
        null,
        formattedDate
      );
    }
  }]);
  return FormattedDate;
}(react["Component"]);

index_es_FormattedDate.displayName = 'FormattedDate';
index_es_FormattedDate.contextTypes = {
  intl: intlShape
};
 false ? index_es_FormattedDate.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var index_es_FormattedTime = function (_Component) {
  inherits(FormattedTime, _Component);

  function FormattedTime(props, context) {
    classCallCheck(this, FormattedTime);

    var _this = possibleConstructorReturn(this, (FormattedTime.__proto__ || Object.getPrototypeOf(FormattedTime)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedTime, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatTime = _context$intl.formatTime,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedTime = formatTime(value, this.props);

      if (typeof children === 'function') {
        return children(formattedTime);
      }

      return react_default.a.createElement(
        Text,
        null,
        formattedTime
      );
    }
  }]);
  return FormattedTime;
}(react["Component"]);

index_es_FormattedTime.displayName = 'FormattedTime';
index_es_FormattedTime.contextTypes = {
  intl: intlShape
};
 false ? index_es_FormattedTime.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var SECOND = 1000;
var MINUTE = 1000 * 60;
var HOUR = 1000 * 60 * 60;
var DAY = 1000 * 60 * 60 * 24;

// The maximum timer delay value is a 32-bit signed integer.
// See: https://mdn.io/setTimeout
var MAX_TIMER_DELAY = 2147483647;

function selectUnits(delta) {
  var absDelta = Math.abs(delta);

  if (absDelta < MINUTE) {
    return 'second';
  }

  if (absDelta < HOUR) {
    return 'minute';
  }

  if (absDelta < DAY) {
    return 'hour';
  }

  // The maximum scheduled delay will be measured in days since the maximum
  // timer delay is less than the number of milliseconds in 25 days.
  return 'day';
}

function getUnitDelay(units) {
  switch (units) {
    case 'second':
      return SECOND;
    case 'minute':
      return MINUTE;
    case 'hour':
      return HOUR;
    case 'day':
      return DAY;
    default:
      return MAX_TIMER_DELAY;
  }
}

function isSameDate(a, b) {
  if (a === b) {
    return true;
  }

  var aTime = new Date(a).getTime();
  var bTime = new Date(b).getTime();

  return isFinite(aTime) && isFinite(bTime) && aTime === bTime;
}

var index_es_FormattedRelative = function (_Component) {
  inherits(FormattedRelative, _Component);

  function FormattedRelative(props, context) {
    classCallCheck(this, FormattedRelative);

    var _this = possibleConstructorReturn(this, (FormattedRelative.__proto__ || Object.getPrototypeOf(FormattedRelative)).call(this, props, context));

    invariantIntlContext(context);

    var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();

    // `now` is stored as state so that `render()` remains a function of
    // props + state, instead of accessing `Date.now()` inside `render()`.
    _this.state = { now: now };
    return _this;
  }

  createClass(FormattedRelative, [{
    key: 'scheduleNextUpdate',
    value: function scheduleNextUpdate(props, state) {
      var _this2 = this;

      // Cancel and pending update because we're scheduling a new update.
      clearTimeout(this._timer);

      var value = props.value,
          units = props.units,
          updateInterval = props.updateInterval;

      var time = new Date(value).getTime();

      // If the `updateInterval` is falsy, including `0` or we don't have a
      // valid date, then auto updates have been turned off, so we bail and
      // skip scheduling an update.
      if (!updateInterval || !isFinite(time)) {
        return;
      }

      var delta = time - state.now;
      var unitDelay = getUnitDelay(units || selectUnits(delta));
      var unitRemainder = Math.abs(delta % unitDelay);

      // We want the largest possible timer delay which will still display
      // accurate information while reducing unnecessary re-renders. The delay
      // should be until the next "interesting" moment, like a tick from
      // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
      var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);

      this._timer = setTimeout(function () {
        _this2.setState({ now: _this2.context.intl.now() });
      }, delay);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scheduleNextUpdate(this.props, this.state);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var nextValue = _ref.value;

      // When the `props.value` date changes, `state.now` needs to be updated,
      // and the next update can be rescheduled.
      if (!isSameDate(nextValue, this.props.value)) {
        this.setState({ now: this.context.intl.now() });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      this.scheduleNextUpdate(nextProps, nextState);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this._timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatRelative = _context$intl.formatRelative,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedRelative = formatRelative(value, _extends({}, this.props, this.state));

      if (typeof children === 'function') {
        return children(formattedRelative);
      }

      return react_default.a.createElement(
        Text,
        null,
        formattedRelative
      );
    }
  }]);
  return FormattedRelative;
}(react["Component"]);

index_es_FormattedRelative.displayName = 'FormattedRelative';
index_es_FormattedRelative.contextTypes = {
  intl: intlShape
};
index_es_FormattedRelative.defaultProps = {
  updateInterval: 1000 * 10
};
 false ? index_es_FormattedRelative.propTypes = _extends({}, relativeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  updateInterval: PropTypes.number,
  initialNow: PropTypes.any,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var index_es_FormattedNumber = function (_Component) {
  inherits(FormattedNumber, _Component);

  function FormattedNumber(props, context) {
    classCallCheck(this, FormattedNumber);

    var _this = possibleConstructorReturn(this, (FormattedNumber.__proto__ || Object.getPrototypeOf(FormattedNumber)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedNumber, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatNumber = _context$intl.formatNumber,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedNumber = formatNumber(value, this.props);

      if (typeof children === 'function') {
        return children(formattedNumber);
      }

      return react_default.a.createElement(
        Text,
        null,
        formattedNumber
      );
    }
  }]);
  return FormattedNumber;
}(react["Component"]);

index_es_FormattedNumber.displayName = 'FormattedNumber';
index_es_FormattedNumber.contextTypes = {
  intl: intlShape
};
 false ? index_es_FormattedNumber.propTypes = _extends({}, numberFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var index_es_FormattedPlural = function (_Component) {
  inherits(FormattedPlural, _Component);

  function FormattedPlural(props, context) {
    classCallCheck(this, FormattedPlural);

    var _this = possibleConstructorReturn(this, (FormattedPlural.__proto__ || Object.getPrototypeOf(FormattedPlural)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedPlural, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatPlural = _context$intl.formatPlural,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          other = _props.other,
          children = _props.children;


      var pluralCategory = formatPlural(value, this.props);
      var formattedPlural = this.props[pluralCategory] || other;

      if (typeof children === 'function') {
        return children(formattedPlural);
      }

      return react_default.a.createElement(
        Text,
        null,
        formattedPlural
      );
    }
  }]);
  return FormattedPlural;
}(react["Component"]);

index_es_FormattedPlural.displayName = 'FormattedPlural';
index_es_FormattedPlural.contextTypes = {
  intl: intlShape
};
index_es_FormattedPlural.defaultProps = {
  style: 'cardinal'
};
 false ? index_es_FormattedPlural.propTypes = _extends({}, pluralFormatPropTypes, {
  value: PropTypes.any.isRequired,

  other: PropTypes.node.isRequired,
  zero: PropTypes.node,
  one: PropTypes.node,
  two: PropTypes.node,
  few: PropTypes.node,
  many: PropTypes.node,

  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var index_es_defaultFormatMessage = function defaultFormatMessage(descriptor, values) {
  if (false) {
    console.error('[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry. Using default message as fallback.');
  }
  return formatMessage({}, { getMessageFormat: lib(intl_messageformat_default.a) }, descriptor, values);
};

var index_es_FormattedMessage = function (_Component) {
  inherits(FormattedMessage, _Component);

  function FormattedMessage(props, context) {
    classCallCheck(this, FormattedMessage);

    var _this = possibleConstructorReturn(this, (FormattedMessage.__proto__ || Object.getPrototypeOf(FormattedMessage)).call(this, props, context));

    if (!props.defaultMessage) {
      invariantIntlContext(context);
    }
    return _this;
  }

  createClass(FormattedMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _ref = this.context.intl || {},
          _ref$formatMessage = _ref.formatMessage,
          formatMessage$$1 = _ref$formatMessage === undefined ? index_es_defaultFormatMessage : _ref$formatMessage,
          _ref$textComponent = _ref.textComponent,
          Text = _ref$textComponent === undefined ? 'span' : _ref$textComponent;

      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          values = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var tokenDelimiter = void 0;
      var tokenizedValues = void 0;
      var elements = void 0;

      var hasValues = values && Object.keys(values).length > 0;
      if (hasValues) {
        // Creates a token with a random UID that should not be guessable or
        // conflict with other parts of the `message` string.
        var uid = Math.floor(Math.random() * 0x10000000000).toString(16);

        var generateToken = function () {
          var counter = 0;
          return function () {
            return 'ELEMENT-' + uid + '-' + (counter += 1);
          };
        }();

        // Splitting with a delimiter to support IE8. When using a regex
        // with a capture group IE8 does not include the capture group in
        // the resulting array.
        tokenDelimiter = '@__' + uid + '__@';
        tokenizedValues = {};
        elements = {};

        // Iterates over the `props` to keep track of any React Element
        // values so they can be represented by the `token` as a placeholder
        // when the `message` is formatted. This allows the formatted
        // message to then be broken-up into parts with references to the
        // React Elements inserted back in.
        Object.keys(values).forEach(function (name) {
          var value = values[name];

          if (Object(react["isValidElement"])(value)) {
            var token = generateToken();
            tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
            elements[token] = value;
          } else {
            tokenizedValues[name] = value;
          }
        });
      }

      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedMessage = formatMessage$$1(descriptor, tokenizedValues || values);

      var nodes = void 0;

      var hasElements = elements && Object.keys(elements).length > 0;
      if (hasElements) {
        // Split the message into parts so the React Element values captured
        // above can be inserted back into the rendered message. This
        // approach allows messages to render with React Elements while
        // keeping React's virtual diffing working properly.
        nodes = formattedMessage.split(tokenDelimiter).filter(function (part) {
          return !!part;
        }).map(function (part) {
          return elements[part] || part;
        });
      } else {
        nodes = [formattedMessage];
      }

      if (typeof children === 'function') {
        return children.apply(undefined, toConsumableArray(nodes));
      }

      // Needs to use `createElement()` instead of JSX, otherwise React will
      // warn about a missing `key` prop with rich-text message formatting.
      return react["createElement"].apply(undefined, [Component$$1, null].concat(toConsumableArray(nodes)));
    }
  }]);
  return FormattedMessage;
}(react["Component"]);

index_es_FormattedMessage.displayName = 'FormattedMessage';
index_es_FormattedMessage.contextTypes = {
  intl: intlShape
};
index_es_FormattedMessage.defaultProps = {
  values: {}
};
 false ? index_es_FormattedMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var index_es_FormattedHTMLMessage = function (_Component) {
  inherits(FormattedHTMLMessage, _Component);

  function FormattedHTMLMessage(props, context) {
    classCallCheck(this, FormattedHTMLMessage);

    var _this = possibleConstructorReturn(this, (FormattedHTMLMessage.__proto__ || Object.getPrototypeOf(FormattedHTMLMessage)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedHTMLMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatHTMLMessage = _context$intl.formatHTMLMessage,
          Text = _context$intl.textComponent;
      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          rawValues = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);

      if (typeof children === 'function') {
        return children(formattedHTMLMessage);
      }

      // Since the message presumably has HTML in it, we need to set
      // `innerHTML` in order for it to be rendered and not escaped by React.
      // To be safe, all string prop values were escaped when formatting the
      // message. It is assumed that the message is not UGC, and came from the
      // developer making it more like a template.
      //
      // Note: There's a perf impact of using this component since there's no
      // way for React to do its virtual DOM diffing.
      var html = { __html: formattedHTMLMessage };
      return react_default.a.createElement(Component$$1, { dangerouslySetInnerHTML: html });
    }
  }]);
  return FormattedHTMLMessage;
}(react["Component"]);

index_es_FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
index_es_FormattedHTMLMessage.contextTypes = {
  intl: intlShape
};
index_es_FormattedHTMLMessage.defaultProps = {
  values: {}
};
 false ? index_es_FormattedHTMLMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(defaultLocaleData);

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(locale_data_ignored__default.a);




/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return START_GET_SCHEDULE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COMPLETE_GET_SCHEDULE; });
/* unused harmony export START_GET_CATEGORIES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COMPLETE_GET_CATEGORIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_STATUS_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_SPORTS_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_NETWORK_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_DATE_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_REPLAY_DATE_FILTER; });
/* unused harmony export startGetSchedule */
/* unused harmony export completeGetSchedule */
/* harmony export (immutable) */ __webpack_exports__["l"] = setStatusFilter;
/* unused harmony export getQueryFromParams */
/* harmony export (immutable) */ __webpack_exports__["j"] = fetchSchedule;
/* harmony export (immutable) */ __webpack_exports__["k"] = fetchSyndicatedSchedule;
/* unused harmony export startGetCategories */
/* unused harmony export completeGetCategories */
/* harmony export (immutable) */ __webpack_exports__["i"] = fetchCategories;
/* unused harmony export setSportsFilter */
/* unused harmony export setNetworkFilter */
/* unused harmony export setDateFilter */
/* unused harmony export setReplayDateFilter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_format_dateFormat__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_format_apiDateFormatter__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__selectors_appSelector__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__selectors_apiParamsSelector__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_apiAction__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StatusFilter__ = __webpack_require__(96);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();










var START_GET_SCHEDULE = 'START_GET_SCHEDULE';
var COMPLETE_GET_SCHEDULE = 'COMPLETE_GET_SCHEDULE';
var START_GET_CATEGORIES = 'START_GET_CATEGORIES';
var COMPLETE_GET_CATEGORIES = 'COMPLETE_GET_CATEGORIES';
var SET_STATUS_FILTER = 'SET_STATUS_FILTER';
var SET_SPORTS_FILTER = 'SET_SPORTS_FILTER';
var SET_NETWORK_FILTER = 'SET_NETWORK_FILTER';
var SET_DATE_FILTER = 'SET_DATE_FILTER';
var SET_REPLAY_DATE_FILTER = 'SET_REPLAY_DATE_FILTER';

function startGetSchedule() {
    return {
        type: START_GET_SCHEDULE,
        startTime: Date.now()
    };
}

function completeGetSchedule(listings) {
    return {
        type: COMPLETE_GET_SCHEDULE,
        completeTime: Date.now(),
        listings: listings
    };
}

function setStatusFilter(status) {
    return {
        type: SET_STATUS_FILTER,
        status: status
    };
}

function getQueryFromParams(_ref) {
    var _ref$type = _ref.type,
        type = _ref$type === undefined ? __WEBPACK_IMPORTED_MODULE_6__StatusFilter__["a" /* default */].Options.LIVE : _ref$type,
        categoryId = _ref.categoryId,
        channel = _ref.channel,
        startDate = _ref.startDate,
        endDate = _ref.endDate;

    var categories = categoryId && [categoryId.toString()];

    var packageMap = {
        espn_plus: 'espn_plus',
        espn_plus_mlb: 'espn_plus_mlb',
        espn_plus_nhl: 'espn_plus_nhl'
    };

    var packages = null;
    var networks = null;

    // ESPN+, MLB.TV, and NHL.TV are treated as packages, and not networks
    if (channel && packageMap[channel.toLowerCase()]) {
        packages = [channel.toLowerCase()];
    } else {
        networks = channel && [channel.toLowerCase()];
    }

    var dates = [startDate];

    // end date is only used for replays, and should always reflect current time of today
    var end = new Date();

    if (endDate) {
        dates.push(end);
    }
    if (type === __WEBPACK_IMPORTED_MODULE_6__StatusFilter__["a" /* default */].Options.REPLAY && !startDate) {
        // set default date range
        var start = new Date();
        dates = [Object(__WEBPACK_IMPORTED_MODULE_2__lib_format_apiDateFormatter__["a" /* default */])(start)];
    }

    return {
        type: type.toUpperCase(),
        networks: networks,
        packages: packages,
        categories: categories,
        dates: dates
    };
}

function fetchSchedule(params) {
    return function (dispatch, getState) {
        dispatch(startGetSchedule());
        var state = getState();
        var isDomestic = Object(__WEBPACK_IMPORTED_MODULE_3__selectors_appSelector__["s" /* isDomesticSelector */])(state);

        var _getQueryFromParams = getQueryFromParams(params),
            typeArg = _getQueryFromParams.type,
            categories = _getQueryFromParams.categories,
            networks = _getQueryFromParams.networks,
            packages = _getQueryFromParams.packages,
            dates = _getQueryFromParams.dates;

        var day = void 0;
        var start = void 0;
        var end = void 0;
        if (dates.length === 1) {
            day = __WEBPACK_IMPORTED_MODULE_1__lib_format_dateFormat__["a" /* default */].paramToCalendarDatesString(dates[0]);
        } else if (dates.length === 2) {
            // API only allows the date to be down to minute precision:(
            start = dates && dates[0] && __WEBPACK_IMPORTED_MODULE_1__lib_format_dateFormat__["a" /* default */].getISOStringWithMinPrecision(__WEBPACK_IMPORTED_MODULE_1__lib_format_dateFormat__["a" /* default */].paramToDate(dates[0]));
            end = dates && dates[1] && __WEBPACK_IMPORTED_MODULE_1__lib_format_dateFormat__["a" /* default */].getISOStringWithMinPrecision(dates[1]);
        }
        var limit = 500;

        return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_apiAction__["k" /* graphql */])('getAirings', {
            type: typeArg,
            categories: categories,
            networks: networks,
            packages: packages,
            start: start,
            end: end,
            day: day,
            limit: limit
        })).then(function (_ref2) {
            var _ref2$data = _ref2.data,
                data = _ref2$data === undefined ? {} : _ref2$data;
            var airings = data.airings;

            airings = airings || []; // response could return `null` for `airings` node when there is an error
            var listings = airings.map(function (_ref3) {
                var id = _ref3.id,
                    name = _ref3.name,
                    type = _ref3.type,
                    startDateTime = _ref3.startDateTime,
                    shortDate = _ref3.shortDate,
                    mediumTime = _ref3.mediumTime,
                    network = _ref3.network,
                    category = _ref3.category,
                    subcategory = _ref3.subcategory,
                    feedName = _ref3.feedName,
                    backgroundImageHref = _ref3.purchaseImage.url,
                    _ref3$image = _ref3.image;
                _ref3$image = _ref3$image === undefined ? {} : _ref3$image;
                var imageUrl = _ref3$image.url,
                    packageArray = _ref3.packages;

                var mapped = {
                    id: id,
                    name: name,
                    feedName: feedName,
                    type: type.toLowerCase(),
                    startTime: startDateTime,
                    startDate: shortDate,
                    mediumTime: mediumTime,
                    backgroundImageHref: backgroundImageHref,
                    broadcasts: network ? [{
                        abbreviation: isDomestic ? network.abbreviation.toLowerCase() : network.adobeResource,
                        adobeResource: network.adobeResource,
                        name: network.name,
                        code: network.id.toUpperCase(),
                        type: network.type,
                        shortName: network.shortName,
                        ipAuth: network.isIpAuth,
                        packages: packageArray ? packageArray.map(function (_ref4) {
                            var nameArg = _ref4.name;
                            return nameArg;
                        }) : []
                    }] : [{}],
                    thumbnails: {
                        large: {
                            width: 640,
                            height: 360,
                            href: imageUrl
                        }
                    },
                    categories: [category],
                    subcategories: subcategory ? [subcategory] : []
                };
                return mapped;
            });

            dispatch(completeGetSchedule(listings));

            return listings;
        });
    };
}
function fetchSyndicatedSchedule(params) {
    return function (dispatch, getState) {
        dispatch(startGetSchedule());
        var state = getState();
        var isDomestic = Object(__WEBPACK_IMPORTED_MODULE_3__selectors_appSelector__["s" /* isDomesticSelector */])(state);

        var _getQueryFromParams2 = getQueryFromParams(params),
            typeArg = _getQueryFromParams2.type,
            categories = _getQueryFromParams2.categories,
            networks = _getQueryFromParams2.networks,
            packages = _getQueryFromParams2.packages;

        var dates = params.dates || Object(__WEBPACK_IMPORTED_MODULE_2__lib_format_apiDateFormatter__["a" /* default */])(new Date());

        var day = void 0;
        var start = void 0;
        var end = void 0;

        if (params.dates && params.dates.match(/-/)) {
            // API only allows the date to be down to minute precision:(
            var _params$dates$split = params.dates.split('-');

            var _params$dates$split2 = _slicedToArray(_params$dates$split, 2);

            start = _params$dates$split2[0];
            end = _params$dates$split2[1];
            start = __WEBPACK_IMPORTED_MODULE_1__lib_format_dateFormat__["a" /* default */].getISOStringWithMinPrecision(__WEBPACK_IMPORTED_MODULE_1__lib_format_dateFormat__["a" /* default */].paramToDate(start));
            end = __WEBPACK_IMPORTED_MODULE_1__lib_format_dateFormat__["a" /* default */].getISOStringWithMinPrecision(__WEBPACK_IMPORTED_MODULE_1__lib_format_dateFormat__["a" /* default */].paramToDate(end));
        } else {
            day = __WEBPACK_IMPORTED_MODULE_1__lib_format_dateFormat__["a" /* default */].paramToCalendarDatesString(dates);
        }
        var limit = 500;

        return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_apiAction__["k" /* graphql */])('getAirings', {
            type: typeArg,
            categories: categories,
            networks: networks,
            packages: packages,
            start: start,
            end: end,
            day: day,
            limit: limit
        })).then(function (_ref5) {
            var _ref5$data = _ref5.data,
                data = _ref5$data === undefined ? {} : _ref5$data;
            var airings = data.airings;

            airings = airings || []; // response could return `null` for `airings` node when there is an error
            // TODO: update schedule page to reflect the data structure from GraphQL API so that this mapping is not necessary
            var listings = airings.map(function (_ref6) {
                var id = _ref6.id,
                    name = _ref6.name,
                    type = _ref6.type,
                    startDateTime = _ref6.startDateTime,
                    shortDate = _ref6.shortDate,
                    mediumTime = _ref6.mediumTime,
                    network = _ref6.network,
                    category = _ref6.category,
                    subcategory = _ref6.subcategory,
                    feedName = _ref6.feedName,
                    _ref6$purchaseImage = _ref6.purchaseImage;
                _ref6$purchaseImage = _ref6$purchaseImage === undefined ? {} : _ref6$purchaseImage;
                var backgroundImageHref = _ref6$purchaseImage.url,
                    _ref6$image = _ref6.image;
                _ref6$image = _ref6$image === undefined ? {} : _ref6$image;
                var imageUrl = _ref6$image.url,
                    packageArray = _ref6.packages;

                var mapped = {
                    id: id,
                    name: name,
                    feedName: feedName,
                    type: type.toLowerCase(),
                    startTime: startDateTime,
                    startDate: shortDate,
                    mediumTime: mediumTime,
                    backgroundImageHref: backgroundImageHref,
                    broadcasts: network ? [{
                        abbreviation: isDomestic ? network.abbreviation.toLowerCase() : network.adobeResource,
                        adobeResource: network.adobeResource,
                        name: network.name,
                        code: network.id.toUpperCase(),
                        type: network.type,
                        shortName: network.shortName,
                        ipAuth: network.isIpAuth,
                        packages: packageArray ? packageArray.map(function (_ref7) {
                            var nameArg = _ref7.name;
                            return nameArg;
                        }) : []
                    }] : [{}],
                    thumbnails: {
                        large: {
                            width: 640,
                            height: 360,
                            href: imageUrl
                        }
                    },
                    categories: [category],
                    subcategories: subcategory ? [subcategory] : []
                };

                return mapped;
            });

            dispatch(completeGetSchedule(listings));

            return listings;
        });
    };
}

function startGetCategories() {
    return {
        type: START_GET_CATEGORIES,
        startTime: Date.now()
    };
}

function completeGetCategories(categories) {
    return {
        type: COMPLETE_GET_CATEGORIES,
        completeTime: Date.now(),
        categories: categories
    };
}

function fetchCategories() {
    return function (dispatch, getState) {
        var state = getState();
        var apiEnv = Object(__WEBPACK_IMPORTED_MODULE_3__selectors_appSelector__["c" /* apiEnvSelector */])(state);
        var params = Object(__WEBPACK_IMPORTED_MODULE_4__selectors_apiParamsSelector__["a" /* collectionParamsSelector */])(state);
        dispatch(startGetCategories);
        return __WEBPACK_IMPORTED_MODULE_0__lib_api__["d" /* PageAPI */].getCategories(apiEnv, params).then(function (categories) {
            dispatch(completeGetCategories(categories));
            return categories;
        });
    };
}

function setSportsFilter(option) {
    return {
        type: SET_SPORTS_FILTER,
        value: option.value,
        filterType: option.type,
        label: option.label
    };
}

function setNetworkFilter(option) {
    return {
        type: SET_NETWORK_FILTER,
        value: option.value,
        label: option.label
    };
}

function setDateFilter(date) {
    return {
        type: SET_DATE_FILTER,
        date: date
    };
}

function setReplayDateFilter(startDate, endDate) {
    return {
        type: SET_REPLAY_DATE_FILTER,
        startDate: startDate,
        endDate: endDate
    };
}

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var StatusFilter = function StatusFilter(_ref) {
    var handleClick = _ref.handleClick,
        selected = _ref.selected,
        labels = _ref.labels;

    var onClick = function onClick(event) {
        event.preventDefault();
        var status = event.target.getAttribute('data-status');
        handleClick(status);
    };

    var options = Object.keys(StatusFilter.Options).map(function (key) {
        var option = StatusFilter.Options[key];
        return _jsx('a', {
            className: 'button-filter-alt med ' + (selected === option ? 'active' : ''),
            'data-status': option,
            onClick: onClick
        }, option, labels[option]);
    });

    return _jsx('div', {
        className: 'form-group button-group tabbed',
        'data-behavior': 'tabs'
    }, void 0, options);
};

StatusFilter.Options = {
    LIVE: 'live',
    UPCOMING: 'upcoming',
    REPLAY: 'replay'
};

StatusFilter.defaultProps = {
    selected: StatusFilter.Options.LIVE
};

/* harmony default export */ __webpack_exports__["a"] = (StatusFilter);

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/cookie-cutter/index.js
var cookie_cutter = __webpack_require__(139);
var cookie_cutter_default = /*#__PURE__*/__webpack_require__.n(cookie_cutter);

// EXTERNAL MODULE: ./app/common/actions/appActions.js
var appActions = __webpack_require__(19);

// EXTERNAL MODULE: ./app/common/actions/apiAction.js
var apiAction = __webpack_require__(55);

// EXTERNAL MODULE: ./app/common/selectors/authenticationSelectors.js
var authenticationSelectors = __webpack_require__(10);

// EXTERNAL MODULE: ./node_modules/reselect/lib/index.js
var lib = __webpack_require__(9);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./app/common/selectors/fanSelector.js
var fanSelector = __webpack_require__(91);

// CONCATENATED MODULE: ./app/common/selectors/fanAutoStartSelector.js



/* harmony default export */ var fanAutoStartSelector = (Object(lib["createSelector"])(fanSelector["a" /* default */], function (_ref) {
    var _ref$profile = _ref.profile;
    _ref$profile = _ref$profile === undefined ? {} : _ref$profile;
    var _ref$profile$settings = _ref$profile.settings,
        settings = _ref$profile$settings === undefined ? {} : _ref$profile$settings;
    var _settings$videoAutoSt = settings.videoAutoStart;
    _settings$videoAutoSt = _settings$videoAutoSt === undefined ? {} : _settings$videoAutoSt;
    var _settings$videoAutoSt2 = _settings$videoAutoSt.value,
        value = _settings$videoAutoSt2 === undefined ? null : _settings$videoAutoSt2;

    return value;
}));
// EXTERNAL MODULE: ./app/common/selectors/routingSelector.js
var routingSelector = __webpack_require__(23);

// EXTERNAL MODULE: ./app/common/selectors/pageSelector.js
var pageSelector = __webpack_require__(13);

// EXTERNAL MODULE: ./app/common/selectors/selectedContentSelector.js
var selectedContentSelector = __webpack_require__(46);

// EXTERNAL MODULE: ./app/common/selectors/analyticsSelectors.js
var analyticsSelectors = __webpack_require__(54);

// EXTERNAL MODULE: ./app/common/selectors/appSelector.js + 1 modules
var appSelector = __webpack_require__(3);

// EXTERNAL MODULE: ./app/enums.js
var enums = __webpack_require__(1);

// CONCATENATED MODULE: ./app/lib/auth/locationBlackedOutForContent.js


/**
 * @param {object} location
 * @param {array} blackouts - destrctured from content {object}
 * Destructures a blackout array from content and checks for blackouts
 * against user location
*/
function locationBlackedOutForContent() {
    var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _ref = arguments[1];
    var _ref$blackouts = _ref.blackouts,
        blackouts = _ref$blackouts === undefined ? [] : _ref$blackouts;

    return blackouts.filter(function (blackout) {
        switch (blackout.type) {
            case enums["g" /* BlackoutTypes */].DMA:
                return (blackout.detail || []).indexOf(location.dma) !== -1;
                break;
            case enums["g" /* BlackoutTypes */].DEVICE:
                // #TODO: implement when live content is support on mobile
                return false;
                break;
            default:
                return false;
        }
    }).length > 0;
};
// CONCATENATED MODULE: ./app/webapp/player/actions/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AUTHORIZATION_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AUTOPLAY_UPDATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AUTOEMBED_TIMER_COMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CLEAR_PLAYING_STREAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return STREAM_PLAYING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PLAYER_EMBEDDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PLAYER_EMBEDDED; });
/* unused harmony export PLAYER_INITIALIZED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PLAYER_READY; });
/* unused harmony export PROGRAM_CHANGE */
/* unused harmony export RECEIVER_AVAILABLE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return REGISTER_PLAYER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return RESET_PLAYER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FEED_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FEED_RESET; });
/* unused harmony export createRegisterPlayerAction */
/* harmony export (immutable) */ __webpack_exports__["u"] = createPlayerEmbeddingAction;
/* harmony export (immutable) */ __webpack_exports__["t"] = createPlayerEmbeddedAction;
/* unused harmony export createPlayerInitializedAction */
/* harmony export (immutable) */ __webpack_exports__["x"] = createResetPlayerAction;
/* harmony export (immutable) */ __webpack_exports__["n"] = createAutoEmbedTimerCompleteAction;
/* harmony export (immutable) */ __webpack_exports__["o"] = createAutoplayUpdatedAction;
/* harmony export (immutable) */ __webpack_exports__["y"] = createStreamPlayingAction;
/* harmony export (immutable) */ __webpack_exports__["p"] = createClearPlayingStreamAction;
/* harmony export (immutable) */ __webpack_exports__["s"] = createFeedSelectAction;
/* harmony export (immutable) */ __webpack_exports__["r"] = createFeedResetAction;
/* harmony export (immutable) */ __webpack_exports__["v"] = createPlayerReadyAction;
/* unused harmony export createReceiverAvailableAction */
/* harmony export (immutable) */ __webpack_exports__["m"] = createAuthorizationErrorAction;
/* harmony export (immutable) */ __webpack_exports__["w"] = createProgramChangeAction;
/* harmony export (immutable) */ __webpack_exports__["q"] = createContinuousPlayAction;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }















var AUTHORIZATION_ERROR = 'AUTHORIZATION_ERROR';
var AUTOPLAY_UPDATED = 'AUTOPLAY_UPDATED';
var AUTOEMBED_TIMER_COMPLETE = 'AUTOEMBED_TIMER_COMPLETE';
var CLEAR_PLAYING_STREAM = 'CLEAR_PLAYING_STREAM';
var STREAM_PLAYING = 'STREAM_PLAYING';
var PLAYER_EMBEDDING = 'PLAYER_EMBEDDING';
var PLAYER_EMBEDDED = 'PLAYER_EMBEDDED';
var PLAYER_INITIALIZED = 'PLAYER_INITIALIZED';
var PLAYER_READY = 'PLAYER_READY';
var PROGRAM_CHANGE = 'PROGRAM_CHANGE';
var RECEIVER_AVAILABLE = 'RECEIVER_AVAILABLE';
var REGISTER_PLAYER = 'REGISTER_PLAYER';
var RESET_PLAYER = 'RESET_PLAYER';
var FEED_SELECT = 'FEED_SELECT';
var FEED_RESET = 'FEED_RESET';

function createRegisterPlayerAction() {
    return {
        type: REGISTER_PLAYER,
        ready: false
    };
}

function createPlayerEmbeddingAction() {
    var embedding = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    return {
        type: PLAYER_EMBEDDING,
        embedding: embedding
    };
}

function createPlayerEmbeddedAction() {
    var embedded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    return {
        type: PLAYER_EMBEDDED,
        embedded: embedded
    };
}

function createPlayerInitializedAction() {
    var initialized = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    return {
        type: PLAYER_INITIALIZED,
        initialized: initialized
    };
}

function createResetPlayerAction() {
    return {
        type: RESET_PLAYER
    };
}

function createAutoEmbedTimerCompleteAction() {
    return {
        type: AUTOEMBED_TIMER_COMPLETE
    };
}

function createAutoplayUpdatedAction() {
    var autoplay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    return {
        type: AUTOPLAY_UPDATED,
        autoplay: autoplay
    };
}

function createStreamPlayingAction(_ref) {
    var stream = _ref.stream,
        _ref$error = _ref.error,
        error = _ref$error === undefined ? false : _ref$error;

    return {
        type: STREAM_PLAYING,
        stream: stream,
        error: error
    };
}

function createClearPlayingStreamAction() {
    return {
        type: CLEAR_PLAYING_STREAM
    };
}

function createFeedSelectAction(streamId) {
    return function (dispatch, getState) {
        var content = Object(selectedContentSelector["a" /* default */])(getState());
        dispatch({
            type: FEED_SELECT,
            content: content,
            streamId: streamId
        });
    };
}

function createFeedResetAction() {
    return {
        type: FEED_RESET
    };
}

function createPlayerReadyAction(playerPlacement) {
    var content = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return function (dispatch, getState) {
        var state = getState();
        var _state$app$isMobile = state.app.isMobile,
            isMobile = _state$app$isMobile === undefined ? false : _state$app$isMobile;

        var _pageSelector = Object(pageSelector["c" /* default */])(state),
            pageId = _pageSelector.id;

        var _routingSelector = Object(routingSelector["a" /* default */])(state),
            _routingSelector$loca = _routingSelector.locationBeforeTransitions;

        _routingSelector$loca = _routingSelector$loca === undefined ? {} : _routingSelector$loca;
        var _routingSelector$loca2 = _routingSelector$loca.query;
        _routingSelector$loca2 = _routingSelector$loca2 === undefined ? {} : _routingSelector$loca2;
        var id = _routingSelector$loca2.id,
            autoStart = _routingSelector$loca2.autoStart;

        var roadblock = Object(appSelector["D" /* roadblockSelector */])(state);
        var fanAutoStart = fanAutoStartSelector(state);

        var autoEmbed = true;
        // always autoEmbed if an id is passed, or user is on player page
        if (!id && pageId !== 'player') {
            var videoAutoStartCookie = cookie_cutter_default.a.get('VAS');
            if (fanAutoStart !== null) {
                autoEmbed = fanAutoStart === '1' || fanAutoStart === 1;
            } else if (videoAutoStartCookie) {
                // check for cookie autoplay (1=on, anything else=off)
                autoEmbed = videoAutoStartCookie === '1' || videoAutoStartCookie === 1;
            }
        }

        // don't autoembed users who are blacked out for content
        if (playerPlacement === enums["B" /* PlayerPlacement */].HERO) {
            var userLocation = Object(authenticationSelectors["s" /* userLocationSelector */])(state);
            autoEmbed = !locationBlackedOutForContent(userLocation, content);
        }

        // don't autoEmbed if it's authenticated content on mobile (only respect this if roadblock is enabled)
        if (roadblock) {
            var _content$authTypes = content.authTypes,
                authTypes = _content$authTypes === undefined ? [] : _content$authTypes;

            if (isMobile && authTypes.length > 0) {
                autoEmbed = false;
            }
        }

        if (autoStart === 'false') {
            autoEmbed = false;
        }

        var action = {
            type: PLAYER_READY,
            autoEmbed: autoEmbed,
            ready: true
        };

        dispatch(action);
        return action;
    };
}

function createReceiverAvailableAction() {
    return {
        type: RECEIVER_AVAILABLE
    };
}

function createAuthorizationErrorAction(message) {
    return {
        type: AUTHORIZATION_ERROR,
        message: message
    };
}

// TODO: We should be able to check if content is already available in bucket and not get from network
function createProgramChangeAction(query, streamId) {
    var _this = this;

    return function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
            var resp, trackingData, selectedContent, content, stream;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            dispatch({ type: PROGRAM_CHANGE, query: query });
                            _context.next = 3;
                            return dispatch(Object(apiAction["e" /* getEvent */])({ query: query }));

                        case 3:
                            resp = _context.sent;
                            trackingData = void 0;

                            if (!(resp && resp.page && resp.page.contents)) {
                                _context.next = 16;
                                break;
                            }

                            // preserve custom "placement" property by merging the next content rather than replacing
                            selectedContent = Object(selectedContentSelector["a" /* default */])(getState());
                            content = _extends({}, selectedContent, resp.page.contents);

                            content.reEmbed = false; // don't initiate reEmbed for program changes or playlists
                            stream = content.streams && content.streams.filter(function (_ref3) {
                                var id = _ref3.id;
                                return id === streamId;
                            })[0] || content.streams[0];

                            dispatch(Object(appActions["z" /* contentSelect */])(content));
                            _context.next = 13;
                            return dispatch(Object(appActions["O" /* streamSelect */])(stream));

                        case 13:
                            dispatch(createStreamPlayingAction({ stream: stream }));
                            trackingData = Object(analyticsSelectors["e" /* nielsenTrackingSelector */])(getState());
                            return _context.abrupt('return', trackingData);

                        case 16:
                            return _context.abrupt('return', trackingData);

                        case 17:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function (_x6, _x7) {
            return _ref2.apply(this, arguments);
        };
    }();
}

// TODO: We should be able to check if content is already available in bucket and not get from network
function createContinuousPlayAction(streamId) {
    return function (dispatch, getState) {
        return dispatch(Object(apiAction["j" /* getVideo */])({ pathParams: streamId })).then(function (resp) {
            if (resp && resp.page && resp.page.contents) {
                // preserve custom "placement" property by merging the next content rather than replacing
                var selectedContent = Object(selectedContentSelector["a" /* default */])(getState());
                var content = _extends({}, selectedContent, resp.page.contents);
                content.reEmbed = false; // don't initiate reEmbed for program changes or playlists
                var stream = content.streams && content.streams.filter(function (_ref4) {
                    var id = _ref4.id;
                    return id === streamId;
                })[0] || content.streams[0];
                dispatch(Object(appActions["z" /* contentSelect */])(content));
                dispatch(Object(appActions["O" /* streamSelect */])(stream));
                dispatch(createStreamPlayingAction({ stream: stream }));
            }
        });
    };
}

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export insertScheduleModuleIntoBuckets */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_intersection__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_intersection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_intersection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PropTypes__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__alias_ScheduleModuleContainer__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__enums__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Bucket__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__selectors_authenticationSelectors__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__selectors_pageSelector__ = __webpack_require__(13);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












function insertScheduleModuleIntoBuckets(buckets, pageType) {
    var clonedBuckets = buckets.slice();
    // on the home page, find the live bucket, and insert the schedule module right after it
    if (pageType === __WEBPACK_IMPORTED_MODULE_6__enums__["y" /* PageType */].HOME) {
        var insertIndex = -1;
        buckets.forEach(function (bucket, index) {
            var _bucket$tags = bucket.tags,
                tags = _bucket$tags === undefined ? [] : _bucket$tags;

            if (tags.indexOf(__WEBPACK_IMPORTED_MODULE_6__enums__["l" /* BucketStatus */].WEB_LIVE) !== -1) {
                insertIndex = index;
            }
        });
        // if we found the live buckets, insert right after it, otherwise, push it on the end
        if (insertIndex !== -1) {
            clonedBuckets.splice(insertIndex + 1, 0, { __schedule_module_placeholder__: true });
            return clonedBuckets;
        }
    }

    clonedBuckets.push({ __schedule_module_placeholder__: true });
    return clonedBuckets;
}

// these are the buckets we don't want to render below the hero
var heroExcludeTags = [__WEBPACK_IMPORTED_MODULE_6__enums__["i" /* BucketLayout */].HERO, __WEBPACK_IMPORTED_MODULE_6__enums__["i" /* BucketLayout */].SCHEDULE_MODULE];

var BucketListContainer = function (_Component) {
    _inherits(BucketListContainer, _Component);

    function BucketListContainer(props) {
        _classCallCheck(this, BucketListContainer);

        var _this = _possibleConstructorReturn(this, (BucketListContainer.__proto__ || Object.getPrototypeOf(BucketListContainer)).call(this, props));

        _this.showPromoOnHero = _this.showPromoOnHero.bind(_this);
        return _this;
    }

    _createClass(BucketListContainer, [{
        key: 'showPromoOnHero',
        value: function showPromoOnHero() {
            var _props = this.props,
                id = _props.page.id,
                showPromo = _props.showPromo;

            return showPromo && id === 'espnplus';
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                buckets = _props2.buckets,
                heroContentId = _props2.heroContentId,
                renderHeroInBucket = _props2.renderHeroInBucket,
                layoutOverride = _props2.layoutOverride,
                pageType = _props2.pageType,
                origHideHeaderLink = _props2.hideHeaderLink,
                bamSubReady = _props2.bamSubReady,
                page = _props2.page;


            var curatedBuckets = insertScheduleModuleIntoBuckets(buckets.filter(function (_ref) {
                var type = _ref.type;
                return type !== 'hero';
            }), pageType);
            var showPromo = this.showPromoOnHero();
            var id = page.id;


            return _jsx('div', {
                className: 'bucket-list'
            }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_helmet___default.a, {
                style: [{
                    cssText: '\n                        .dtc-watch__row--showAll .dtc-watch__item{\n                            display:block !important;\n                        }\n                    '
                }]
            }), curatedBuckets.map(function (bucket, index) {
                // inserts the schedule module into a mobile only container depending on what page we're on
                if (bucket.__schedule_module_placeholder__ === true) {
                    return _jsx('div', {
                        className: 'mobile-tablet-only'
                    }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_5__alias_ScheduleModuleContainer__["a" /* default */], {
                        contentLimit: 3
                    }));
                }

                // some pages such as the /watch/shows page do not have a hero
                var bucketContents = bucket.contents.filter(function (content) {
                    return renderHeroInBucket || id === 'espnplus' && (bamSubReady && !showPromo && heroContentId !== content.id || bamSubReady && showPromo && content.id || !bamSubReady && content.id) || id !== 'espnplus' && heroContentId !== content.id;
                });

                var contentLength = bucketContents.length; // same as displayCount
                if (!renderHeroInBucket && !showPromo && (contentLength === 1 && bucketContents[0].id === heroContentId || bucket.tags && __WEBPACK_IMPORTED_MODULE_3_lodash_intersection___default()(heroExcludeTags, bucket.tags).length > 0)) {
                    return null;
                }

                var hideHeaderLink = origHideHeaderLink && index === 0;

                // make the link relative by chopping off the host

                var _ref2 = bucket || {},
                    _ref2$links = _ref2.links;

                _ref2$links = _ref2$links === undefined ? {} : _ref2$links;
                var _ref2$links$web = _ref2$links.web,
                    web = _ref2$links$web === undefined ? '' : _ref2$links$web,
                    metadata = _ref2.metadata;

                var link = web.replace(/https?:\/\/[^\/]*(?:\/watch)?/, '');
                var bucketId = metadata && metadata.bucketId || bucket.id;
                var groupId = metadata && metadata.groupId;
                // Avoids duplicate key assignment error
                var uniqueKey = '' + bucket.id + index;

                return _jsx(__WEBPACK_IMPORTED_MODULE_7__Bucket__["a" /* default */], {
                    bucketId: bucketId,
                    hideHeaderLink: hideHeaderLink,
                    contents: bucketContents,
                    groupId: groupId,
                    iconHref: bucket.iconHref,
                    layout: bucket.layout,
                    layoutOverride: layoutOverride,
                    link: link,
                    metadata: bucket.metadata,
                    name: bucket.name,
                    pageType: pageType,
                    tags: bucket.tags,
                    type: bucket.type,
                    tier: index + 1
                }, uniqueKey);
            }));
        }
    }]);

    return BucketListContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

BucketListContainer.defaultProps = {
    buckets: [],
    renderHeroInBucket: false
};

var mapStateToProps = function mapStateToProps(state) {
    return {
        buckets: state.page && state.page.buckets || [],
        heroContentId: state.page.hero && state.page.hero.id,
        page: Object(__WEBPACK_IMPORTED_MODULE_9__selectors_pageSelector__["c" /* default */])(state),
        bamSubReady: Object(__WEBPACK_IMPORTED_MODULE_8__selectors_authenticationSelectors__["k" /* bamSubReadySelector */])(state),
        showPromo: Object(__WEBPACK_IMPORTED_MODULE_9__selectors_pageSelector__["g" /* showPromoSelector */])(state)
    };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(BucketListContainer));

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(101);
var EventPluginUtils = __webpack_require__(161);

var accumulateInto = __webpack_require__(231);
var forEachAccumulated = __webpack_require__(232);
var warning = __webpack_require__(6);

var getListener = EventPluginHub.getListener;

/**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */
function listenerAtPhase(inst, event, propagationPhase) {
  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
  return getListener(inst, registrationName);
}

/**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */
function accumulateDirectionalDispatches(inst, phase, event) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
  }
  var listener = listenerAtPhase(inst, event, phase);
  if (listener) {
    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
  }
}

/**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */
function accumulateTwoPhaseDispatchesSingle(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
 */
function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    var targetInst = event._targetInst;
    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */
function accumulateDispatches(inst, ignoredDirection, event) {
  if (event && event.dispatchConfig.registrationName) {
    var registrationName = event.dispatchConfig.registrationName;
    var listener = getListener(inst, registrationName);
    if (listener) {
      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
    }
  }
}

/**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */
function accumulateDirectDispatchesSingle(event) {
  if (event && event.dispatchConfig.registrationName) {
    accumulateDispatches(event._targetInst, null, event);
  }
}

function accumulateTwoPhaseDispatches(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
}

function accumulateTwoPhaseDispatchesSkipTarget(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
}

function accumulateEnterLeaveDispatches(leave, enter, from, to) {
  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
}

function accumulateDirectDispatches(events) {
  forEachAccumulated(events, accumulateDirectDispatchesSingle);
}

/**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing event a
 * single one.
 *
 * @constructor EventPropagators
 */
var EventPropagators = {
  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
  accumulateDirectDispatches: accumulateDirectDispatches,
  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
};

module.exports = EventPropagators;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var EventPluginRegistry = __webpack_require__(160);
var EventPluginUtils = __webpack_require__(161);
var ReactErrorUtils = __webpack_require__(162);

var accumulateInto = __webpack_require__(231);
var forEachAccumulated = __webpack_require__(232);
var invariant = __webpack_require__(5);

/**
 * Internal store for event listeners
 */
var listenerBank = {};

/**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */
var eventQueue = null;

/**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @private
 */
var executeDispatchesAndRelease = function (event, simulated) {
  if (event) {
    EventPluginUtils.executeDispatchesInOrder(event, simulated);

    if (!event.isPersistent()) {
      event.constructor.release(event);
    }
  }
};
var executeDispatchesAndReleaseSimulated = function (e) {
  return executeDispatchesAndRelease(e, true);
};
var executeDispatchesAndReleaseTopLevel = function (e) {
  return executeDispatchesAndRelease(e, false);
};

var getDictionaryKey = function (inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
};

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

function shouldPreventMouseEvent(name, type, props) {
  switch (name) {
    case 'onClick':
    case 'onClickCapture':
    case 'onDoubleClick':
    case 'onDoubleClickCapture':
    case 'onMouseDown':
    case 'onMouseDownCapture':
    case 'onMouseMove':
    case 'onMouseMoveCapture':
    case 'onMouseUp':
    case 'onMouseUpCapture':
      return !!(props.disabled && isInteractive(type));
    default:
      return false;
  }
}

/**
 * This is a unified interface for event plugins to be installed and configured.
 *
 * Event plugins can implement the following properties:
 *
 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
 *     Required. When a top-level event is fired, this method is expected to
 *     extract synthetic events that will in turn be queued and dispatched.
 *
 *   `eventTypes` {object}
 *     Optional, plugins that fire events must publish a mapping of registration
 *     names that are used to register listeners. Values of this mapping must
 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
 *
 *   `executeDispatch` {function(object, function, string)}
 *     Optional, allows plugins to override how an event gets dispatched. By
 *     default, the listener is simply invoked.
 *
 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
 *
 * @public
 */
var EventPluginHub = {

  /**
   * Methods for injecting dependencies.
   */
  injection: {

    /**
     * @param {array} InjectedEventPluginOrder
     * @public
     */
    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

    /**
     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
     */
    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName

  },

  /**
   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {function} listener The callback to store.
   */
  putListener: function (inst, registrationName, listener) {
    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;

    var key = getDictionaryKey(inst);
    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
    bankForRegistrationName[key] = listener;

    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.didPutListener) {
      PluginModule.didPutListener(inst, registrationName, listener);
    }
  },

  /**
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @return {?function} The stored callback.
   */
  getListener: function (inst, registrationName) {
    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
    // live here; needs to be moved to a better place soon
    var bankForRegistrationName = listenerBank[registrationName];
    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
      return null;
    }
    var key = getDictionaryKey(inst);
    return bankForRegistrationName && bankForRegistrationName[key];
  },

  /**
   * Deletes a listener from the registration bank.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   */
  deleteListener: function (inst, registrationName) {
    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.willDeleteListener) {
      PluginModule.willDeleteListener(inst, registrationName);
    }

    var bankForRegistrationName = listenerBank[registrationName];
    // TODO: This should never be null -- when is it?
    if (bankForRegistrationName) {
      var key = getDictionaryKey(inst);
      delete bankForRegistrationName[key];
    }
  },

  /**
   * Deletes all listeners for the DOM element with the supplied ID.
   *
   * @param {object} inst The instance, which is the source of events.
   */
  deleteAllListeners: function (inst) {
    var key = getDictionaryKey(inst);
    for (var registrationName in listenerBank) {
      if (!listenerBank.hasOwnProperty(registrationName)) {
        continue;
      }

      if (!listenerBank[registrationName][key]) {
        continue;
      }

      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
      if (PluginModule && PluginModule.willDeleteListener) {
        PluginModule.willDeleteListener(inst, registrationName);
      }

      delete listenerBank[registrationName][key];
    }
  },

  /**
   * Allows registered plugins an opportunity to extract events from top-level
   * native browser events.
   *
   * @return {*} An accumulation of synthetic events.
   * @internal
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events;
    var plugins = EventPluginRegistry.plugins;
    for (var i = 0; i < plugins.length; i++) {
      // Not every plugin in the ordering may be loaded at runtime.
      var possiblePlugin = plugins[i];
      if (possiblePlugin) {
        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
        if (extractedEvents) {
          events = accumulateInto(events, extractedEvents);
        }
      }
    }
    return events;
  },

  /**
   * Enqueues a synthetic event that should be dispatched when
   * `processEventQueue` is invoked.
   *
   * @param {*} events An accumulation of synthetic events.
   * @internal
   */
  enqueueEvents: function (events) {
    if (events) {
      eventQueue = accumulateInto(eventQueue, events);
    }
  },

  /**
   * Dispatches all synthetic events on the event queue.
   *
   * @internal
   */
  processEventQueue: function (simulated) {
    // Set `eventQueue` to null before processing it so that we can tell if more
    // events get enqueued while processing.
    var processingEventQueue = eventQueue;
    eventQueue = null;
    if (simulated) {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
    } else {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
    }
    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
    // This would be a good time to rethrow if any of the event handlers threw.
    ReactErrorUtils.rethrowCaughtError();
  },

  /**
   * These are needed for tests only. Do not use!
   */
  __purge: function () {
    listenerBank = {};
  },

  __getListenerBank: function () {
    return listenerBank;
  }

};

module.exports = EventPluginHub;

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(50);

var getEventTarget = __webpack_require__(163);

/**
 * @interface UIEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var UIEventInterface = {
  view: function (event) {
    if (event.view) {
      return event.view;
    }

    var target = getEventTarget(event);
    if (target.window === target) {
      // target is a window object
      return target;
    }

    var doc = target.ownerDocument;
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    if (doc) {
      return doc.defaultView || doc.parentWindow;
    } else {
      return window;
    }
  },
  detail: function (event) {
    return event.detail || 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

module.exports = SyntheticUIEvent;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 */

// TODO: Replace this with ES6: var ReactInstanceMap = new Map();

var ReactInstanceMap = {

  /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */
  remove: function (key) {
    key._reactInternalInstance = undefined;
  },

  get: function (key) {
    return key._reactInternalInstance;
  },

  has: function (key) {
    return key._reactInternalInstance !== undefined;
  },

  set: function (key, value) {
    key._reactInternalInstance = value;
  }

};

module.exports = ReactInstanceMap;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = apiDateFormatter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


function apiDateFormatter(startDate, endDate) {
    var startDateToFormat = startDate ? __WEBPACK_IMPORTED_MODULE_0_moment___default()(startDate) : __WEBPACK_IMPORTED_MODULE_0_moment___default()();
    var formattedStartDate = startDateToFormat.format('YYYYMMDD');
    var apiDate = '';
    if (endDate) {
        var endDateToFormat = __WEBPACK_IMPORTED_MODULE_0_moment___default()(endDate);
        var formattedEndDate = endDateToFormat.format('YYYYMMDD');
        if (formattedEndDate === formattedStartDate) {
            apiDate = formattedEndDate;
        } else if (formattedEndDate > formattedStartDate) {
            apiDate = formattedStartDate + '-' + formattedEndDate;
        } else {
            apiDate = formattedEndDate + '-' + formattedStartDate;
        }
    } else {
        apiDate = '' + formattedStartDate;
    }

    return apiDate;
};

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(console, module) {//! moment.js
//! version : 2.15.2
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, function () { 'use strict';

    var hookCallback;

    function utils_hooks__hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        var k;
        for (k in obj) {
            // even if its not own property I'd still call it non-empty
            return false;
        }
        return true;
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function create_utc__createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function valid__isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function valid__createInvalid (flags) {
        var m = create_utc__createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    function isUndefined(input) {
        return input === void 0;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = utils_hooks__hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i in momentProperties) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            utils_hooks__hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (utils_hooks__hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (utils_hooks__hooks.deprecationHandler != null) {
                utils_hooks__hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (utils_hooks__hooks.deprecationHandler != null) {
            utils_hooks__hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    utils_hooks__hooks.suppressDeprecationWarnings = false;
    utils_hooks__hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function locale_set__set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _ordinalParseLenient.
        this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function locale_calendar__calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relative__relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                get_set__set(this, unit, value);
                utils_hooks__hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get_set__get(this, unit);
            }
        };
    }

    function get_set__get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function get_set__set (mom, unit, value) {
        if (mom.isValid()) {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;


    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (typeof callback === 'number') {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return this._months;
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return this._monthsShort;
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function units_month__handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = create_utc__createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return units_month__handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = create_utc__createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (typeof value !== 'number') {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            utils_hooks__hooks.updateOffset(this, true);
            return this;
        } else {
            return get_set__get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = create_utc__createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? utils_hooks__hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = utils_hooks__hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    utils_hooks__hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function createDate (y, m, d, h, M, s, ms) {
        //can't just apply() to create a date:
        //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
        var date = new Date(y, m, d, h, M, s, ms);

        //the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
        return date;
    }

    function createUTCDate (y) {
        var date = new Date(Date.UTC.apply(null, arguments));

        //the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    //http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        if (!m) {
            return this._weekdays;
        }
        return isArray(this._weekdays) ? this._weekdays[m.day()] :
            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function day_of_week__handleStrictParse(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = create_utc__createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return day_of_week__handleStrictParse.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = create_utc__createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = create_utc__createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour he wants. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        ordinalParse: defaultOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return null;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                // because defineLocale currently also sets the global locale, we
                // want to undo that for lazy loaded locales
                locale_locales__getSetGlobalLocale(oldLocale);
            } catch (e) { }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function locale_locales__getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = locale_locales__getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    // treat as if there is no base config
                    deprecateSimple('parentLocaleUndefined',
                            'specified parentLocale is not defined yet. See http://momentjs.com/guides/#/warnings/parent-locale/');
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            // backwards compat for now: also set the locale
            locale_locales__getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, parentConfig = baseConfig;
            // MERGE
            if (locales[name] != null) {
                parentConfig = locales[name]._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            locale_locales__getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function locale_locales__getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function locale_locales__listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
            utils_hooks__hooks.createFromInputFallback(config);
        }
    }

    utils_hooks__hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(utils_hooks__hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse)) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(local__createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            weekYear = defaults(w.gg, config._a[YEAR], weekOfYear(local__createLocal(), dow, doy).year);
            week = defaults(w.w, 1);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from begining of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to begining of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    utils_hooks__hooks.ISO_8601 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === utils_hooks__hooks.ISO_8601) {
            configFromISO(config);
            return;
        }

        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!valid__isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || locale_locales__getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return valid__createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (isDate(input)) {
            config._d = input;
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!valid__isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (input === undefined) {
            config._d = new Date(utils_hooks__hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (typeof(input) === 'object') {
            configFromObject(config);
        } else if (typeof(input) === 'number') {
            // from milliseconds
            config._d = new Date(input);
        } else {
            utils_hooks__hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (typeof(locale) === 'boolean') {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function local__createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = local__createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return valid__createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = local__createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return valid__createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return local__createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = locale_locales__getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = ((string || '').match(matcher) || []);
        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : local__createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            utils_hooks__hooks.updateOffset(res, false);
            return res;
        } else {
            return local__createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    utils_hooks__hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
            } else if (Math.abs(input) < 16) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    add_subtract__addSubtract(this, create__createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    utils_hooks__hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm) {
            this.utcOffset(this._tzm);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);

            if (tZone === 0) {
                this.utcOffset(0, true);
            } else {
                this.utcOffset(offsetFromString(matchOffset, this._i));
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? local__createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? create_utc__createUTC(c._a) : local__createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;

    function create__createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (typeof input === 'number') {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(local__createLocal(duration.from), local__createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    create__createDuration.fn = Duration.prototype;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {milliseconds: 0, months: 0};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = create__createDuration(val, period);
            add_subtract__addSubtract(this, dur, direction);
            return this;
        };
    }

    function add_subtract__addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (days) {
            get_set__set(mom, 'Date', get_set__get(mom, 'Date') + days * isAdding);
        }
        if (months) {
            setMonth(mom, get_set__get(mom, 'Month') + months * isAdding);
        }
        if (updateOffset) {
            utils_hooks__hooks.updateOffset(mom, days || months);
        }
    }

    var add_subtract__add      = createAdder(1, 'add');
    var add_subtract__subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function moment_calendar__calendar (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || local__createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = utils_hooks__hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, local__createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : local__createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : local__createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : local__createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units || 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input,units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input,units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            delta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        if (units === 'year' || units === 'month' || units === 'quarter') {
            output = monthDiff(this, that);
            if (units === 'quarter') {
                output = output / 3;
            } else if (units === 'year') {
                output = output / 12;
            }
        } else {
            delta = this - that;
            output = units === 'second' ? delta / 1e3 : // 1000
                units === 'minute' ? delta / 6e4 : // 1000 * 60
                units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
                units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
                units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
                delta;
        }
        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    utils_hooks__hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    utils_hooks__hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function moment_format__toISOString () {
        var m = this.clone().utc();
        if (0 < m.year() && m.year() <= 9999) {
            if (isFunction(Date.prototype.toISOString)) {
                // native implementation is ~50x faster, use it when we can
                return this.toDate().toISOString();
            } else {
                return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
            }
        } else {
            return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
        }
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? utils_hooks__hooks.defaultFormatUtc : utils_hooks__hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 local__createLocal(time).isValid())) {
            return create__createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(local__createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 local__createLocal(time).isValid())) {
            return create__createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(local__createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = locale_locales__getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    function startOf (units) {
        units = normalizeUnits(units);
        // the following switch intentionally omits break keywords
        // to utilize falling through the cases.
        switch (units) {
            case 'year':
                this.month(0);
                /* falls through */
            case 'quarter':
            case 'month':
                this.date(1);
                /* falls through */
            case 'week':
            case 'isoWeek':
            case 'day':
            case 'date':
                this.hours(0);
                /* falls through */
            case 'hour':
                this.minutes(0);
                /* falls through */
            case 'minute':
                this.seconds(0);
                /* falls through */
            case 'second':
                this.milliseconds(0);
        }

        // weeks are a special case
        if (units === 'week') {
            this.weekday(0);
        }
        if (units === 'isoWeek') {
            this.isoWeekday(1);
        }

        // quarters are also special
        if (units === 'quarter') {
            this.month(Math.floor(this.month() / 3) * 3);
        }

        return this;
    }

    function endOf (units) {
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond') {
            return this;
        }

        // 'date' is an alias for 'day', so it should be considered as such.
        if (units === 'date') {
            units = 'day';
        }

        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
    }

    function to_type__valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function moment_valid__isValid () {
        return valid__isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = utils_hooks__hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIOROITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0], 10);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var momentPrototype__proto = Moment.prototype;

    momentPrototype__proto.add               = add_subtract__add;
    momentPrototype__proto.calendar          = moment_calendar__calendar;
    momentPrototype__proto.clone             = clone;
    momentPrototype__proto.diff              = diff;
    momentPrototype__proto.endOf             = endOf;
    momentPrototype__proto.format            = format;
    momentPrototype__proto.from              = from;
    momentPrototype__proto.fromNow           = fromNow;
    momentPrototype__proto.to                = to;
    momentPrototype__proto.toNow             = toNow;
    momentPrototype__proto.get               = stringGet;
    momentPrototype__proto.invalidAt         = invalidAt;
    momentPrototype__proto.isAfter           = isAfter;
    momentPrototype__proto.isBefore          = isBefore;
    momentPrototype__proto.isBetween         = isBetween;
    momentPrototype__proto.isSame            = isSame;
    momentPrototype__proto.isSameOrAfter     = isSameOrAfter;
    momentPrototype__proto.isSameOrBefore    = isSameOrBefore;
    momentPrototype__proto.isValid           = moment_valid__isValid;
    momentPrototype__proto.lang              = lang;
    momentPrototype__proto.locale            = locale;
    momentPrototype__proto.localeData        = localeData;
    momentPrototype__proto.max               = prototypeMax;
    momentPrototype__proto.min               = prototypeMin;
    momentPrototype__proto.parsingFlags      = parsingFlags;
    momentPrototype__proto.set               = stringSet;
    momentPrototype__proto.startOf           = startOf;
    momentPrototype__proto.subtract          = add_subtract__subtract;
    momentPrototype__proto.toArray           = toArray;
    momentPrototype__proto.toObject          = toObject;
    momentPrototype__proto.toDate            = toDate;
    momentPrototype__proto.toISOString       = moment_format__toISOString;
    momentPrototype__proto.toJSON            = toJSON;
    momentPrototype__proto.toString          = toString;
    momentPrototype__proto.unix              = unix;
    momentPrototype__proto.valueOf           = to_type__valueOf;
    momentPrototype__proto.creationData      = creationData;

    // Year
    momentPrototype__proto.year       = getSetYear;
    momentPrototype__proto.isLeapYear = getIsLeapYear;

    // Week Year
    momentPrototype__proto.weekYear    = getSetWeekYear;
    momentPrototype__proto.isoWeekYear = getSetISOWeekYear;

    // Quarter
    momentPrototype__proto.quarter = momentPrototype__proto.quarters = getSetQuarter;

    // Month
    momentPrototype__proto.month       = getSetMonth;
    momentPrototype__proto.daysInMonth = getDaysInMonth;

    // Week
    momentPrototype__proto.week           = momentPrototype__proto.weeks        = getSetWeek;
    momentPrototype__proto.isoWeek        = momentPrototype__proto.isoWeeks     = getSetISOWeek;
    momentPrototype__proto.weeksInYear    = getWeeksInYear;
    momentPrototype__proto.isoWeeksInYear = getISOWeeksInYear;

    // Day
    momentPrototype__proto.date       = getSetDayOfMonth;
    momentPrototype__proto.day        = momentPrototype__proto.days             = getSetDayOfWeek;
    momentPrototype__proto.weekday    = getSetLocaleDayOfWeek;
    momentPrototype__proto.isoWeekday = getSetISODayOfWeek;
    momentPrototype__proto.dayOfYear  = getSetDayOfYear;

    // Hour
    momentPrototype__proto.hour = momentPrototype__proto.hours = getSetHour;

    // Minute
    momentPrototype__proto.minute = momentPrototype__proto.minutes = getSetMinute;

    // Second
    momentPrototype__proto.second = momentPrototype__proto.seconds = getSetSecond;

    // Millisecond
    momentPrototype__proto.millisecond = momentPrototype__proto.milliseconds = getSetMillisecond;

    // Offset
    momentPrototype__proto.utcOffset            = getSetOffset;
    momentPrototype__proto.utc                  = setOffsetToUTC;
    momentPrototype__proto.local                = setOffsetToLocal;
    momentPrototype__proto.parseZone            = setOffsetToParsedOffset;
    momentPrototype__proto.hasAlignedHourOffset = hasAlignedHourOffset;
    momentPrototype__proto.isDST                = isDaylightSavingTime;
    momentPrototype__proto.isLocal              = isLocal;
    momentPrototype__proto.isUtcOffset          = isUtcOffset;
    momentPrototype__proto.isUtc                = isUtc;
    momentPrototype__proto.isUTC                = isUtc;

    // Timezone
    momentPrototype__proto.zoneAbbr = getZoneAbbr;
    momentPrototype__proto.zoneName = getZoneName;

    // Deprecations
    momentPrototype__proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    momentPrototype__proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    momentPrototype__proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    momentPrototype__proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    momentPrototype__proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    var momentPrototype = momentPrototype__proto;

    function moment__createUnix (input) {
        return local__createLocal(input * 1000);
    }

    function moment__createInZone () {
        return local__createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var prototype__proto = Locale.prototype;

    prototype__proto.calendar        = locale_calendar__calendar;
    prototype__proto.longDateFormat  = longDateFormat;
    prototype__proto.invalidDate     = invalidDate;
    prototype__proto.ordinal         = ordinal;
    prototype__proto.preparse        = preParsePostFormat;
    prototype__proto.postformat      = preParsePostFormat;
    prototype__proto.relativeTime    = relative__relativeTime;
    prototype__proto.pastFuture      = pastFuture;
    prototype__proto.set             = locale_set__set;

    // Month
    prototype__proto.months            =        localeMonths;
    prototype__proto.monthsShort       =        localeMonthsShort;
    prototype__proto.monthsParse       =        localeMonthsParse;
    prototype__proto.monthsRegex       = monthsRegex;
    prototype__proto.monthsShortRegex  = monthsShortRegex;

    // Week
    prototype__proto.week = localeWeek;
    prototype__proto.firstDayOfYear = localeFirstDayOfYear;
    prototype__proto.firstDayOfWeek = localeFirstDayOfWeek;

    // Day of Week
    prototype__proto.weekdays       =        localeWeekdays;
    prototype__proto.weekdaysMin    =        localeWeekdaysMin;
    prototype__proto.weekdaysShort  =        localeWeekdaysShort;
    prototype__proto.weekdaysParse  =        localeWeekdaysParse;

    prototype__proto.weekdaysRegex       =        weekdaysRegex;
    prototype__proto.weekdaysShortRegex  =        weekdaysShortRegex;
    prototype__proto.weekdaysMinRegex    =        weekdaysMinRegex;

    // Hours
    prototype__proto.isPM = localeIsPM;
    prototype__proto.meridiem = localeMeridiem;

    function lists__get (format, index, field, setter) {
        var locale = locale_locales__getLocale();
        var utc = create_utc__createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (typeof format === 'number') {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return lists__get(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = lists__get(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (typeof format === 'number') {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (typeof format === 'number') {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = locale_locales__getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return lists__get(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = lists__get(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function lists__listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function lists__listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function lists__listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function lists__listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function lists__listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    locale_locales__getSetGlobalLocale('en', {
        ordinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports
    utils_hooks__hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', locale_locales__getSetGlobalLocale);
    utils_hooks__hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', locale_locales__getLocale);

    var mathAbs = Math.abs;

    function duration_abs__abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function duration_add_subtract__addSubtract (duration, input, value, direction) {
        var other = create__createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function duration_add_subtract__add (input, value) {
        return duration_add_subtract__addSubtract(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function duration_add_subtract__subtract (input, value) {
        return duration_add_subtract__addSubtract(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'year') {
            days   = this._days   + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            return units === 'month' ? months : months / 12;
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function duration_as__valueOf () {
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asYears        = makeAs('y');

    function duration_get__get (units) {
        units = normalizeUnits(units);
        return this[units + 's']();
    }

    function makeGetter(name) {
        return function () {
            return this._data[name];
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        s: 45,  // seconds to minute
        m: 45,  // minutes to hour
        h: 22,  // hours to day
        d: 26,  // days to month
        M: 11   // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function duration_humanize__relativeTime (posNegDuration, withoutSuffix, locale) {
        var duration = create__createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds < thresholds.s && ['s', seconds]  ||
                minutes <= 1           && ['m']           ||
                minutes < thresholds.m && ['mm', minutes] ||
                hours   <= 1           && ['h']           ||
                hours   < thresholds.h && ['hh', hours]   ||
                days    <= 1           && ['d']           ||
                days    < thresholds.d && ['dd', days]    ||
                months  <= 1           && ['M']           ||
                months  < thresholds.M && ['MM', months]  ||
                years   <= 1           && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function duration_humanize__getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function duration_humanize__getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        return true;
    }

    function humanize (withSuffix) {
        var locale = this.localeData();
        var output = duration_humanize__relativeTime(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var iso_string__abs = Math.abs;

    function iso_string__toISOString() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        var seconds = iso_string__abs(this._milliseconds) / 1000;
        var days         = iso_string__abs(this._days);
        var months       = iso_string__abs(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds;
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        return (total < 0 ? '-' : '') +
            'P' +
            (Y ? Y + 'Y' : '') +
            (M ? M + 'M' : '') +
            (D ? D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? h + 'H' : '') +
            (m ? m + 'M' : '') +
            (s ? s + 'S' : '');
    }

    var duration_prototype__proto = Duration.prototype;

    duration_prototype__proto.abs            = duration_abs__abs;
    duration_prototype__proto.add            = duration_add_subtract__add;
    duration_prototype__proto.subtract       = duration_add_subtract__subtract;
    duration_prototype__proto.as             = as;
    duration_prototype__proto.asMilliseconds = asMilliseconds;
    duration_prototype__proto.asSeconds      = asSeconds;
    duration_prototype__proto.asMinutes      = asMinutes;
    duration_prototype__proto.asHours        = asHours;
    duration_prototype__proto.asDays         = asDays;
    duration_prototype__proto.asWeeks        = asWeeks;
    duration_prototype__proto.asMonths       = asMonths;
    duration_prototype__proto.asYears        = asYears;
    duration_prototype__proto.valueOf        = duration_as__valueOf;
    duration_prototype__proto._bubble        = bubble;
    duration_prototype__proto.get            = duration_get__get;
    duration_prototype__proto.milliseconds   = milliseconds;
    duration_prototype__proto.seconds        = seconds;
    duration_prototype__proto.minutes        = minutes;
    duration_prototype__proto.hours          = hours;
    duration_prototype__proto.days           = days;
    duration_prototype__proto.weeks          = weeks;
    duration_prototype__proto.months         = months;
    duration_prototype__proto.years          = years;
    duration_prototype__proto.humanize       = humanize;
    duration_prototype__proto.toISOString    = iso_string__toISOString;
    duration_prototype__proto.toString       = iso_string__toISOString;
    duration_prototype__proto.toJSON         = iso_string__toISOString;
    duration_prototype__proto.locale         = locale;
    duration_prototype__proto.localeData     = localeData;

    // Deprecations
    duration_prototype__proto.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', iso_string__toISOString);
    duration_prototype__proto.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    utils_hooks__hooks.version = '2.15.2';

    setHookCallback(local__createLocal);

    utils_hooks__hooks.fn                    = momentPrototype;
    utils_hooks__hooks.min                   = min;
    utils_hooks__hooks.max                   = max;
    utils_hooks__hooks.now                   = now;
    utils_hooks__hooks.utc                   = create_utc__createUTC;
    utils_hooks__hooks.unix                  = moment__createUnix;
    utils_hooks__hooks.months                = lists__listMonths;
    utils_hooks__hooks.isDate                = isDate;
    utils_hooks__hooks.locale                = locale_locales__getSetGlobalLocale;
    utils_hooks__hooks.invalid               = valid__createInvalid;
    utils_hooks__hooks.duration              = create__createDuration;
    utils_hooks__hooks.isMoment              = isMoment;
    utils_hooks__hooks.weekdays              = lists__listWeekdays;
    utils_hooks__hooks.parseZone             = moment__createInZone;
    utils_hooks__hooks.localeData            = locale_locales__getLocale;
    utils_hooks__hooks.isDuration            = isDuration;
    utils_hooks__hooks.monthsShort           = lists__listMonthsShort;
    utils_hooks__hooks.weekdaysMin           = lists__listWeekdaysMin;
    utils_hooks__hooks.defineLocale          = defineLocale;
    utils_hooks__hooks.updateLocale          = updateLocale;
    utils_hooks__hooks.locales               = locale_locales__listLocales;
    utils_hooks__hooks.weekdaysShort         = lists__listWeekdaysShort;
    utils_hooks__hooks.normalizeUnits        = normalizeUnits;
    utils_hooks__hooks.relativeTimeRounding = duration_humanize__getSetRelativeTimeRounding;
    utils_hooks__hooks.relativeTimeThreshold = duration_humanize__getSetRelativeTimeThreshold;
    utils_hooks__hooks.calendarFormat        = getCalendarFormat;
    utils_hooks__hooks.prototype             = momentPrototype;

    var _moment = utils_hooks__hooks;

    return _moment;

}));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(107)(module)))

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(39);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 109 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(128);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(571),
    isObjectLike = __webpack_require__(59);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curry2 = __webpack_require__(593)
var debug = __webpack_require__(595)('selectn')
var dotted = __webpack_require__(598)
var splits = __webpack_require__(599)
var string = Object.prototype.toString

module.exports = curry2(selectn)

/**
 * Curried property accessor function that resolves deeply-nested object properties via dot/bracket-notation
 * string path while mitigating `TypeErrors` via friendly and composable API.
 *
 * @param {String|Array} path
 * Dot/bracket-notation string path or array.
 *
 * @param {Object} object
 * Object to access.
 *
 * @return {Function|*|undefined}
 * (1) returns `selectn/1` when partially applied.
 * (2) returns value at path if path exists.
 * (3) returns undefined if path does not exist.
 */
function selectn (path, object) {
  debug('arguments:', {
    path: path,
    object: object
  })

  var idx = -1
  var seg = string.call(path) === '[object Array]' ? path : splits(dotted(path))
  var end = seg.length
  var ref = end ? object : void 0

  while (++idx < end) {
    if (Object(ref) !== ref) return void 0
    ref = ref[seg[idx]]
  }

  debug('ref:', ref)
  return typeof ref === 'function' ? ref() : ref
}


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(636),
    baseMatchesProperty = __webpack_require__(658),
    identity = __webpack_require__(199),
    isArray = __webpack_require__(32),
    property = __webpack_require__(660);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return shieldApiKeySelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return graphqlParamsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return collectionParamsSelector; });
/* unused harmony export getWhitelistedParams */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return searchApiParamsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return suggestApiParamsSelector; });
/* unused harmony export pageApiFeatureFlagsSelector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return pageAPIParamsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return pageAPILimitedParamsSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enums__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrapSelector__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__appSelector__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__authenticationSelectors__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__oneIdSelector__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fanSelector__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_format_dateFormat__ = __webpack_require__(33);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };











var apiConfigParams = ['apiEnv', 'apiVersion'];

var apiParamsSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_3__appSelector__["j" /* default */], __WEBPACK_IMPORTED_MODULE_3__appSelector__["c" /* apiEnvSelector */], __WEBPACK_IMPORTED_MODULE_3__appSelector__["d" /* apiVersionSelector */], function (app, apiEnv, apiVersion) {
    var deviceType = app.device,
        country = app.country,
        lang = app.lang,
        sourceLang = app.sourceLang,
        packageId = app.packageId,
        tier = app.tier,
        edition = app.edition;

    var tz = __WEBPACK_IMPORTED_MODULE_7__lib_format_dateFormat__["a" /* default */].getTimezoneParam();
    return {
        apiEnv: apiEnv,
        apiVersion: apiVersion,
        countryCode: country,
        deviceType: deviceType,
        lang: lang,
        sourceLang: sourceLang,
        tz: tz,
        packageId: packageId,
        tier: tier,
        edition: edition
    };
});

var shieldApiKeySelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_3__appSelector__["j" /* default */], __WEBPACK_IMPORTED_MODULE_3__appSelector__["k" /* editionSelector */], function (_ref, _ref2) {
    var shieldApiKeys = _ref.bootstrap.shieldApiKey;
    var edition = _ref2.edition;

    if (shieldApiKeys[edition]) {
        return shieldApiKeys[edition];
    }

    // If we haven't returned, go with domestic/US.
    return shieldApiKeys.domestic;
});

var graphqlParamsSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_3__appSelector__["j" /* default */], __WEBPACK_IMPORTED_MODULE_3__appSelector__["c" /* apiEnvSelector */], function (app, apiEnv) {
    var device = app.device,
        countryCode = app.country,
        lang = app.lang,
        packageId = app.packageId;

    var tz = __WEBPACK_IMPORTED_MODULE_7__lib_format_dateFormat__["a" /* default */].getTimezoneParam();
    return {
        apiEnv: apiEnv,
        countryCode: countryCode,
        deviceType: __WEBPACK_IMPORTED_MODULE_1__enums__["r" /* DeviceType */][device],
        lang: lang,
        tz: tz,
        packageId: packageId
    };
});

var collectionParamsSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_3__appSelector__["j" /* default */], function (app) {
    var country = app.country,
        lang = app.lang;

    return {
        countryCode: country,
        lang: lang
    };
});

function getWhitelistedParams(paramsArg, queryParameters) {
    var params = paramsArg;
    if (queryParameters) {
        var whitelisted = queryParameters.concat(apiConfigParams);
        params = Object.keys(params).reduce(function (acc, key) {
            if (whitelisted.indexOf(key) > -1) {
                acc[key] = params[key];
            }
            return acc;
        }, {});
    }

    return params;
}

var searchApiParamsSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_2__bootstrapSelector__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__appSelector__["s" /* isDomesticSelector */], apiParamsSelector, __WEBPACK_IMPORTED_MODULE_4__authenticationSelectors__["o" /* preauthorizedResourcesSelector */], __WEBPACK_IMPORTED_MODULE_4__authenticationSelectors__["u" /* zipcodeSelector */], function (_ref3, isDomestic, apiParams, authNetworks, zipcode) {
    var _ref3$pageApi = _ref3.pageApi;
    _ref3$pageApi = _ref3$pageApi === undefined ? {} : _ref3$pageApi;
    var queryParameters = _ref3$pageApi.queryParameters;

    var params = isDomestic ? _extends({}, apiParams, {
        authNetworks: authNetworks,
        zipcode: zipcode
    }) : apiParams;

    params = getWhitelistedParams(params, queryParameters);

    return params;
});

var suggestApiParamsSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_2__bootstrapSelector__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__appSelector__["s" /* isDomesticSelector */], apiParamsSelector, __WEBPACK_IMPORTED_MODULE_4__authenticationSelectors__["o" /* preauthorizedResourcesSelector */], __WEBPACK_IMPORTED_MODULE_4__authenticationSelectors__["u" /* zipcodeSelector */], function (_ref4, isDomestic, apiParams, authNetworks, zipcode) {
    var _ref4$pageApi = _ref4.pageApi;
    _ref4$pageApi = _ref4$pageApi === undefined ? {} : _ref4$pageApi;
    var queryParameters = _ref4$pageApi.queryParameters;

    var params = isDomestic ? _extends({}, apiParams, {
        authNetworks: authNetworks,
        zipcode: zipcode
    }) : apiParams;

    params = getWhitelistedParams(params, queryParameters);

    return params;
});

var pageApiFeatureFlagsSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_2__bootstrapSelector__["a" /* default */], function (_ref5) {
    var _ref5$pageApi = _ref5.pageApi;
    _ref5$pageApi = _ref5$pageApi === undefined ? {} : _ref5$pageApi;
    var _ref5$pageApi$feature = _ref5$pageApi.featureFlags,
        featureFlags = _ref5$pageApi$feature === undefined ? [] : _ref5$pageApi$feature;

    var features = featureFlags.length ? featureFlags.join(',') : undefined;

    return {
        features: features
    };
});

var pageAPIParamsSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_2__bootstrapSelector__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__appSelector__["s" /* isDomesticSelector */], apiParamsSelector, __WEBPACK_IMPORTED_MODULE_4__authenticationSelectors__["g" /* authStatesSelector */], __WEBPACK_IMPORTED_MODULE_4__authenticationSelectors__["o" /* preauthorizedResourcesSelector */], __WEBPACK_IMPORTED_MODULE_5__oneIdSelector__["c" /* oneIdEntitlementsParamsSelector */], __WEBPACK_IMPORTED_MODULE_4__authenticationSelectors__["u" /* zipcodeSelector */], __WEBPACK_IMPORTED_MODULE_6__fanSelector__["c" /* favoriteTeamSelector */], __WEBPACK_IMPORTED_MODULE_6__fanSelector__["b" /* favoriteSportSelector */], pageApiFeatureFlagsSelector, function (_ref6, isDomestic, apiParams, authStates, authNetworks, entitlements, zipcode, favoriteTeam, favoriteSport, features) {
    var _ref6$pageApi = _ref6.pageApi;
    _ref6$pageApi = _ref6$pageApi === undefined ? {} : _ref6$pageApi;
    var queryParameters = _ref6$pageApi.queryParameters;

    var params = isDomestic ? _extends({}, apiParams, features, {
        authStates: authStates,
        authNetworks: authNetworks,
        entitlements: entitlements,
        zipcode: zipcode,
        favoriteTeam: favoriteTeam,
        favoriteSport: favoriteSport
    }) : _extends({}, apiParams, features);

    params = getWhitelistedParams(params, queryParameters);

    return params;
});

// `/web/event` and `/web/video`
var pageAPILimitedParamsSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_2__bootstrapSelector__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__appSelector__["s" /* isDomesticSelector */], apiParamsSelector, __WEBPACK_IMPORTED_MODULE_4__authenticationSelectors__["u" /* zipcodeSelector */], __WEBPACK_IMPORTED_MODULE_5__oneIdSelector__["c" /* oneIdEntitlementsParamsSelector */], pageApiFeatureFlagsSelector, function (_ref7, isDomestic, apiParams, zipcode, entitlements, features) {
    var _ref7$pageApi = _ref7.pageApi;
    _ref7$pageApi = _ref7$pageApi === undefined ? {} : _ref7$pageApi;
    var queryParameters = _ref7$pageApi.queryParameters;

    var params = isDomestic ? _extends({}, apiParams, features, {
        entitlements: entitlements,
        zipcode: zipcode
    }) : _extends({}, apiParams, features);

    params = getWhitelistedParams(params, queryParameters);

    return params;
});

/* harmony default export */ __webpack_exports__["b"] = (apiParamsSelector);

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/bluebird/js/browser/bluebird.js
var bluebird = __webpack_require__(11);
var bluebird_default = /*#__PURE__*/__webpack_require__.n(bluebird);

// EXTERNAL MODULE: ./app/webapp/common/video-player/constants.js
var constants = __webpack_require__(213);

// EXTERNAL MODULE: ./app/webapp/common/video-player/player-tech/PlayerBase.js
var PlayerBase = __webpack_require__(214);

// EXTERNAL MODULE: ./app/webapp/common/video-player/player-tech/BAMPlayer/index.js
var BAMPlayer = __webpack_require__(682);

// CONCATENATED MODULE: ./app/webapp/common/video-player/player-tech/BrightcovePlayer/index.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable class-methods-use-this, no-return-assign */




var BrightcovePlayer_BrightcovePlayer = function (_PlayerBase) {
    _inherits(BrightcovePlayer, _PlayerBase);

    function BrightcovePlayer() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            playerTech = _ref.playerTech,
            options = _objectWithoutProperties(_ref, ['playerTech']);

        _classCallCheck(this, BrightcovePlayer);

        var _this = _possibleConstructorReturn(this, (BrightcovePlayer.__proto__ || Object.getPrototypeOf(BrightcovePlayer)).call(this));

        _this._playerTech = playerTech;
        _this._options = options;
        return _this;
    }

    _createClass(BrightcovePlayer, [{
        key: 'currentTime',
        value: function currentTime(value) {
            var _this2 = this;

            return new bluebird_default.a(function (resolve, reject) {
                try {
                    if (value && _this2._player) {
                        _this2._player.currentTime(value);
                        resolve(_this2);
                        return;
                    }
                    resolve(_this2._player && _this2._player.currentTime());
                } catch (err) {
                    reject(err);
                }
            });
        }
    }, {
        key: 'createPlayer',
        value: function createPlayer() {
            var _this3 = this;

            var ESPNVideoPlayer = window.ESPNVideoPlayer;
            return this._playerPromise || (this._playerPromise = new bluebird_default.a(function (resolve, reject) {
                if (ESPNVideoPlayer) {
                    _this3._player = new ESPNVideoPlayer(_this3._playerTech, _this3._options);
                    _this3._player.ready(resolve);
                } else {
                    setTimeout(function () {
                        reject(new Error('ESPN web player bunlde JS not available.'));
                    }, 1000);
                }
            }));
        }
    }, {
        key: 'addPlayerListeners',
        value: function addPlayerListeners() {
            var _this4 = this;

            var _ref2 = this._player || {},
                player = _ref2.player;

            if (player) {
                this._unsubscribes = Object.keys(BrightcovePlayer.Events).map(function (key) {
                    var callback = function callback() {
                        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                            args[_key] = arguments[_key];
                        }

                        _this4.emit.apply(_this4, [BrightcovePlayer.Events[key]].concat(args));
                    };
                    player.on(BrightcovePlayer.Events[key], callback);
                    return function () {
                        player.off(BrightcovePlayer.Events[key], callback);
                    };
                });
            }
        }
    }, {
        key: 'removePlayerListeners',
        value: function removePlayerListeners() {
            if (this._unsubscribes) {
                while (this._unsubscribes.length) {
                    this._unsubscribes.pop()();
                }
                this._unsubscribes = null;
            }
        }
    }, {
        key: 'create',
        value: function create(options) {
            var _this5 = this;

            return this.createPlayer().then(function () {
                var guid = options.guid,
                    el = options.el,
                    playOptions = options.options;

                return new bluebird_default.a(function (resolve) {
                    _this5._player.embed(guid, el, playOptions, function () {
                        _this5.addPlayerListeners();
                        resolve(_this5);
                    });
                });
            });
        }
    }, {
        key: 'delete',
        value: function _delete() {
            this.removePlayerListeners();
            this._player.unembed();
            return bluebird_default.a.resolve(this);
        }
    }, {
        key: 'play',
        value: function play() {
            var _this6 = this;

            return new bluebird_default.a(function (resolve, reject) {
                try {
                    _this6._player.play();
                    resolve(_this6);
                } catch (err) {
                    reject(err);
                }
            });
        }
    }, {
        key: 'pause',
        value: function pause() {
            var _this7 = this;

            return new bluebird_default.a(function (resolve, reject) {
                try {
                    _this7._player.pause();
                    resolve(_this7);
                } catch (err) {
                    reject(err);
                }
            });
        }
    }, {
        key: 'mute',
        value: function mute() {
            var _this8 = this;

            return new bluebird_default.a(function (resolve, reject) {
                try {
                    _this8._player.muted(true);
                    resolve(_this8);
                } catch (err) {
                    reject(err);
                }
            });
        }
    }, {
        key: 'unmute',
        value: function unmute() {
            var _this9 = this;

            return new bluebird_default.a(function (resolve, reject) {
                try {
                    _this9._player.muted(false);
                    resolve(_this9);
                } catch (err) {
                    reject(err);
                }
            });
        }
    }, {
        key: 'requestFullscreen',
        value: function requestFullscreen() {
            var _this10 = this;

            return new bluebird_default.a(function (resolve, reject) {
                try {
                    _this10._player.requestFullscreen();
                    resolve(_this10);
                } catch (err) {
                    reject(err);
                }
            });
        }
    }, {
        key: 'exitFullscreen',
        value: function exitFullscreen() {
            var _this11 = this;

            return new bluebird_default.a(function (resolve, reject) {
                try {
                    _this11._player.exitFullscreen();
                    resolve(_this11);
                } catch (err) {
                    reject(err);
                }
            });
        }
    }, {
        key: 'error',
        value: function error(err, content) {
            var _this12 = this;

            return new bluebird_default.a(function (resolve, reject) {
                try {
                    _this12._player.error(err, content);
                    resolve(_this12);
                } catch (err2) {
                    reject(err2);
                }
            });
        }
    }, {
        key: 'getPlayerConfigs',
        value: function getPlayerConfigs() {
            return bluebird_default.a.resolve(this._player.bundle.options);
        }
    }, {
        key: 'updatePlayerConfigs',
        value: function updatePlayerConfigs(newConfigs) {
            return bluebird_default.a.resolve(newConfigs);
        }
    }, {
        key: 'tech',
        get: function get() {
            return constants["a" /* PlayerTech */].BRIGHTCOVE;
        }
    }, {
        key: 'container',
        get: function get() {
            return this._player && this._player.bundle.element.parentNode;
        }
    }, {
        key: 'player',
        get: function get() {
            return this._player && this._player.player;
        }
    }, {
        key: 'analytics',
        get: function get() {
            return this._player && this._player.analytics;
        }
    }, {
        key: 'advertising',
        get: function get() {
            return this._player && this._player.advertising;
        }
    }]);

    return BrightcovePlayer;
}(PlayerBase["a" /* default */]);

BrightcovePlayer_BrightcovePlayer.Events = {
    ESPN_PLAYING: 'espn.playing',
    ESPN_PLAY: 'espn.play',
    ESPN_PAUSE: 'espn.pause',
    ESPN_AD_POD_STARTED: 'espn.ads-pod-started',
    ESPN_AD_POD_ENDED: 'espn.ads-pod-ended',
    ESPN_AD_STARTED: 'espn.ads-ad-started',
    ESPN_AD_ENDED: 'espn.ads-ad-ended',
    ESPN_CONTENT_ENDED: 'espn.contentended',
    ESPN_CONTENT_LOADED: 'espn.contentloaded',
    ESPN_PROGRAM_CHANGE: 'espn.programchange',
    ESPN_AUTOPLAY_TOGGLED: 'espn.autoplaytoggled',
    ESPN_SOCIAL_OPENED: 'socialopened',
    ESPN_SOCIAL_CLOSED: 'socialclosed',
    ESPN_CAPTION_OPENED: 'captionopened',
    ESPN_CAPTION_CLOSED: 'captionclosed',
    ESPN_ERROR: 'espn.error',
    ESPN_DRM_ERROR: 'espn.drm.error',
    ESPN_ADS_AD_SKIPPED: 'ads-ad-skipped'
};

/* harmony default export */ var player_tech_BrightcovePlayer = (BrightcovePlayer_BrightcovePlayer);
// CONCATENATED MODULE: ./app/webapp/common/video-player/index.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var video_player__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function video_player__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function video_player__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function video_player__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function video_player__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable class-methods-use-this */






var video_player_WatchESPNWebPlayer = function (_PlayerBase) {
    video_player__inherits(WatchESPNWebPlayer, _PlayerBase);

    function WatchESPNWebPlayer() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$bamPlayerOptions = _ref.bamPlayerOptions,
            bamPlayerOptions = _ref$bamPlayerOptions === undefined ? {} : _ref$bamPlayerOptions,
            _ref$brightcovePlayer = _ref.brightcovePlayerOptions,
            brightcovePlayerOptions = _ref$brightcovePlayer === undefined ? {} : _ref$brightcovePlayer;

        video_player__classCallCheck(this, WatchESPNWebPlayer);

        var _this = video_player__possibleConstructorReturn(this, (WatchESPNWebPlayer.__proto__ || Object.getPrototypeOf(WatchESPNWebPlayer)).call(this));

        _this._bamPlayer = null;
        _this._brightcovePlayer = null;
        _this._bamPlayerOptions = bamPlayerOptions;
        _this._brightcovePlayerOptions = brightcovePlayerOptions;
        return _this;
    }

    video_player__createClass(WatchESPNWebPlayer, [{
        key: 'create',
        value: function create(_ref2) {
            var _this2 = this;

            var playerTech = _ref2.playerTech,
                container = _ref2.container,
                options = video_player__objectWithoutProperties(_ref2, ['playerTech', 'container']);

            var promise = bluebird_default.a.resolve();
            if (playerTech === constants["a" /* PlayerTech */].BAM) {
                if (!this._bamPlayer) {
                    this._bamPlayer = new BAMPlayer["a" /* default */](this._bamPlayerOptions);
                    Object.keys(BAMPlayer["a" /* default */].Events).forEach(function (event) {
                        _this2._bamPlayer.on(BAMPlayer["a" /* default */].Events[event], _this2.proxyEvent.bind(_this2, BAMPlayer["a" /* default */].Events[event]));
                    });
                }
                if (this._player && this._player.tech !== constants["a" /* PlayerTech */].BAM) {
                    promise = this.delete();
                }
                this._player = this._bamPlayer;
            } else if (playerTech === constants["a" /* PlayerTech */].BRIGHTCOVE) {
                if (!this._brightcovePlayer) {
                    this._brightcovePlayer = new player_tech_BrightcovePlayer(this._brightcovePlayerOptions);
                    Object.keys(player_tech_BrightcovePlayer.Events).forEach(function (event) {
                        _this2._brightcovePlayer.on(player_tech_BrightcovePlayer.Events[event], _this2.proxyEvent.bind(_this2, player_tech_BrightcovePlayer.Events[event]));
                    });
                }
                if (this._player && this._player.tech !== constants["a" /* PlayerTech */].BRIGHTCOVE) {
                    promise = this.delete();
                }
                this._player = this._brightcovePlayer;
            }
            if (!this._player) {
                return bluebird_default.a.reject(new Error('cannot create player.'));
            }

            var containerEl = void 0;
            try {
                if (typeof container === 'string') {
                    containerEl = document.querySelector(container);
                } else {
                    containerEl = container;
                }
            } catch (err) {
                return bluebird_default.a.reject(err);
            }

            var playerOptions = _extends({}, options, {
                selector: container,
                el: containerEl
            });

            return promise.then(function () {
                return _this2._player.create(playerOptions);
            }).then(function () {
                _this2.emit(WatchESPNWebPlayer.Events.READY);
            });
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            var _this3 = this;

            if (!this._player) {
                return bluebird_default.a.resolve(this);
            }

            if (this._bamPlayer && this._player.destroyPlayer) {
                return this._player.destroyPlayer().then(function () {
                    _this3._bamPlayer.removeAllListeners();
                });
            }

            return this.delete().then(function () {
                _this3._brightcovePlayer.removeAllListeners();
                _this3._brightcovePlayer = null;
            });
        }
    }, {
        key: 'getPlayer',
        value: function getPlayer(tech) {
            switch (tech) {
                case constants["a" /* PlayerTech */].BRIGHTCOVE:
                    return this._brightcovePlayer;
                case constants["a" /* PlayerTech */].BAM:
                    return this._bamPlayer;
                default:
                    // return currently active player
                    return this._player;
            }
        }
    }, {
        key: 'getGeoLocation',
        value: function getGeoLocation(options) {
            var player = new BAMPlayer["a" /* default */](this._bamPlayerOptions);
            player.once(BAMPlayer["a" /* default */].Events.GEOLOCATION_READY, this.proxyEvent.bind(this, BAMPlayer["a" /* default */].Events.GEOLOCATION_READY));
            return player.getGeoLocation(_extends({}, options, { selector: options.container }));
        }
    }, {
        key: 'renderPaywall',
        value: function renderPaywall(options) {
            var player = new BAMPlayer["a" /* default */](this._bamPlayerOptions);
            player.once(BAMPlayer["a" /* default */].Events.LOGIN_REQUESTED, this.proxyEvent.bind(this, BAMPlayer["a" /* default */].Events.LOGIN_REQUESTED));
            return player.renderPaywall(_extends({}, options, { selector: options.container }));
        }
    }, {
        key: 'createSDKWrapper',
        value: function createSDKWrapper(options) {
            var player = new BAMPlayer["a" /* default */](this._bamPlayerOptions);
            player.once(BAMPlayer["a" /* default */].Events.SUBSCRIPTIONS_READY, this.proxyEvent.bind(this, BAMPlayer["a" /* default */].Events.SUBSCRIPTIONS_READY));
            player.once(BAMPlayer["a" /* default */].Events.GEOLOCATION_READY, this.proxyEvent.bind(this, BAMPlayer["a" /* default */].Events.GEOLOCATION_READY));
            player.once(BAMPlayer["a" /* default */].Events.SESSIONTOKEN_READY, this.proxyEvent.bind(this, BAMPlayer["a" /* default */].Events.SESSIONTOKEN_READY));

            player.once(BAMPlayer["a" /* default */].Events.USER_TRACKING_INFORMATION_READY, this.proxyEvent.bind(this, BAMPlayer["a" /* default */].Events.USER_TRACKING_INFORMATION_READY));

            window.sdkWrapper = player;
            return player.createSDKWrapper(_extends({}, options, { selector: options.container }));
        }
    }, {
        key: 'sendContentReward',
        value: function sendContentReward(_ref3) {
            var selector = _ref3.selector,
                rewardToken = _ref3.rewardToken,
                contentId = _ref3.contentId,
                userActivityAction = _ref3.userActivityAction,
                recommendedContentIds = _ref3.recommendedContentIds;

            if (window.sdkWrapper) {
                return window.sdkWrapper.sendContentReward(selector, rewardToken, contentId, userActivityAction, recommendedContentIds);
            }

            return bluebird_default.a.resolve(this);
        }
    }, {
        key: 'delete',
        value: function _delete() {
            var _this4 = this;

            if (!this._player) {
                return bluebird_default.a.resolve(this);
            }
            return this._player.delete().then(function () {
                _this4._player = null;
            });
        }
    }, {
        key: 'loadMedia',
        value: function loadMedia(options) {
            if (!this._player) {
                return bluebird_default.a.resolve(this);
            }
            return this._player.loadMedia(_extends({}, options, { selector: options.container }));
        }
    }, {
        key: 'changeFeed',
        value: function changeFeed(options) {
            if (!this._player) {
                return bluebird_default.a.resolve(this);
            }
            return this._player.changeFeed(_extends({}, options, { selector: options.container }));
        }
    }, {
        key: 'deactivate',
        value: function deactivate() {
            var _player;

            if (!this._player) {
                return bluebird_default.a.resolve(this);
            }
            return (_player = this._player).deactivate.apply(_player, arguments);
        }
    }, {
        key: 'play',
        value: function play() {
            if (!this._player) {
                return bluebird_default.a.resolve(this);
            }
            return this._player.play();
        }
    }, {
        key: 'pause',
        value: function pause() {
            if (!this._player) {
                return bluebird_default.a.resolve(this);
            }
            return this._player.pause();
        }
    }, {
        key: 'mute',
        value: function mute() {
            if (!this._player) {
                return bluebird_default.a.resolve(this);
            }
            return this._player.mute();
        }
    }, {
        key: 'unmute',
        value: function unmute() {
            if (!this._player) {
                return bluebird_default.a.resolve(this);
            }
            return this._player.unmute();
        }
    }, {
        key: 'error',
        value: function error() {
            var _player2;

            if (!this._player) {
                return bluebird_default.a.resolve(this);
            }
            return (_player2 = this._player).error.apply(_player2, arguments);
        }
    }, {
        key: 'getPlayerConfigs',
        value: function getPlayerConfigs() {
            if (!this._player) {
                return bluebird_default.a.resolve();
            }
            return this._player.getPlayerConfigs();
        }
    }, {
        key: 'updatePlayerConfigs',
        value: function updatePlayerConfigs() {
            var _player3;

            if (!this._player) {
                return bluebird_default.a.resolve(this);
            }
            return (_player3 = this._player).updatePlayerConfigs.apply(_player3, arguments);
        }
    }, {
        key: 'proxyEvent',
        value: function proxyEvent(type) {
            for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                args[_key - 1] = arguments[_key];
            }

            this.emit.apply(this, [type].concat(args));
        }
    }]);

    return WatchESPNWebPlayer;
}(PlayerBase["a" /* default */]);

video_player_WatchESPNWebPlayer.Events = _extends({
    READY: 'READY'
}, player_tech_BrightcovePlayer.Events, BAMPlayer["a" /* default */].Events);

video_player_WatchESPNWebPlayer.PlayerTech = constants["a" /* PlayerTech */];

/* harmony default export */ var video_player = __webpack_exports__["a"] = (video_player_WatchESPNWebPlayer);

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = canPlayContent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__canPlayStream__ = __webpack_require__(117);


function canPlayContent() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        status = _ref.status,
        _ref$streams = _ref.streams,
        streams = _ref$streams === undefined ? [] : _ref$streams;

    var userAuth = arguments[1];
    var optimisitic = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    return status != 'upcoming' && streams.some(function (stream) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__canPlayStream__["a" /* default */])(stream, userAuth, optimisitic);
    });
}

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = canPlayStream;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shallowCheckAuthentication__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty__);



function canPlayStream() {
    var stream = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var userAuth = arguments[1];
    var optimisitic = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    // theoretically should be able to use `showKey` field
    return Object(__WEBPACK_IMPORTED_MODULE_0__shallowCheckAuthentication__["b" /* default */])(stream, userAuth, optimisitic);
};

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(7);

var invariant = __webpack_require__(5);

var OBSERVED_ERROR = {};

/**
 * `Transaction` creates a black box that is able to wrap any method such that
 * certain invariants are maintained before and after the method is invoked
 * (Even if an exception is thrown while invoking the wrapped method). Whoever
 * instantiates a transaction can provide enforcers of the invariants at
 * creation time. The `Transaction` class itself will supply one additional
 * automatic invariant for you - the invariant that any transaction instance
 * should not be run while it is already being run. You would typically create a
 * single instance of a `Transaction` for reuse multiple times, that potentially
 * is used to wrap several different methods. Wrappers are extremely simple -
 * they only require implementing two methods.
 *
 * <pre>
 *                       wrappers (injected at creation time)
 *                                      +        +
 *                                      |        |
 *                    +-----------------|--------|--------------+
 *                    |                 v        |              |
 *                    |      +---------------+   |              |
 *                    |   +--|    wrapper1   |---|----+         |
 *                    |   |  +---------------+   v    |         |
 *                    |   |          +-------------+  |         |
 *                    |   |     +----|   wrapper2  |--------+   |
 *                    |   |     |    +-------------+  |     |   |
 *                    |   |     |                     |     |   |
 *                    |   v     v                     v     v   | wrapper
 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | +---+ +---+   +---------+   +---+ +---+ |
 *                    |  initialize                    close    |
 *                    +-----------------------------------------+
 * </pre>
 *
 * Use cases:
 * - Preserving the input selection ranges before/after reconciliation.
 *   Restoring selection even in the event of an unexpected error.
 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
 *   while guaranteeing that afterwards, the event system is reactivated.
 * - Flushing a queue of collected DOM mutations to the main UI thread after a
 *   reconciliation takes place in a worker thread.
 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
 *   content.
 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
 * - (Future use case): Layout calculations before and after DOM updates.
 *
 * Transactional plugin API:
 * - A module that has an `initialize` method that returns any precomputation.
 * - and a `close` method that accepts the precomputation. `close` is invoked
 *   when the wrapped process is completed, or has failed.
 *
 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
 * that implement `initialize` and `close`.
 * @return {Transaction} Single transaction for reuse in thread.
 *
 * @class Transaction
 */
var TransactionImpl = {
  /**
   * Sets up this instance so that it is prepared for collecting metrics. Does
   * so such that this setup method may be used on an instance that is already
   * initialized, in a way that does not consume additional memory upon reuse.
   * That can be useful if you decide to make your subclass of this mixin a
   * "PooledClass".
   */
  reinitializeTransaction: function () {
    this.transactionWrappers = this.getTransactionWrappers();
    if (this.wrapperInitData) {
      this.wrapperInitData.length = 0;
    } else {
      this.wrapperInitData = [];
    }
    this._isInTransaction = false;
  },

  _isInTransaction: false,

  /**
   * @abstract
   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
   */
  getTransactionWrappers: null,

  isInTransaction: function () {
    return !!this._isInTransaction;
  },

  /**
   * Executes the function within a safety window. Use this for the top level
   * methods that result in large amounts of computation/mutations that would
   * need to be safety checked. The optional arguments helps prevent the need
   * to bind in many cases.
   *
   * @param {function} method Member of scope to call.
   * @param {Object} scope Scope to invoke from.
   * @param {Object?=} a Argument to pass to the method.
   * @param {Object?=} b Argument to pass to the method.
   * @param {Object?=} c Argument to pass to the method.
   * @param {Object?=} d Argument to pass to the method.
   * @param {Object?=} e Argument to pass to the method.
   * @param {Object?=} f Argument to pass to the method.
   *
   * @return {*} Return value from `method`.
   */
  perform: function (method, scope, a, b, c, d, e, f) {
    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
    var errorThrown;
    var ret;
    try {
      this._isInTransaction = true;
      // Catching errors makes debugging more difficult, so we start with
      // errorThrown set to true before setting it to false after calling
      // close -- if it's still set to true in the finally block, it means
      // one of these calls threw.
      errorThrown = true;
      this.initializeAll(0);
      ret = method.call(scope, a, b, c, d, e, f);
      errorThrown = false;
    } finally {
      try {
        if (errorThrown) {
          // If `method` throws, prefer to show that stack trace over any thrown
          // by invoking `closeAll`.
          try {
            this.closeAll(0);
          } catch (err) {}
        } else {
          // Since `method` didn't throw, we don't want to silence the exception
          // here.
          this.closeAll(0);
        }
      } finally {
        this._isInTransaction = false;
      }
    }
    return ret;
  },

  initializeAll: function (startIndex) {
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      try {
        // Catching errors makes debugging more difficult, so we start with the
        // OBSERVED_ERROR state before overwriting it with the real return value
        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
        // block, it means wrapper.initialize threw.
        this.wrapperInitData[i] = OBSERVED_ERROR;
        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
      } finally {
        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
          // The initializer for wrapper i threw an error; initialize the
          // remaining wrappers but silence any exceptions from them to ensure
          // that the first error is the one to bubble up.
          try {
            this.initializeAll(i + 1);
          } catch (err) {}
        }
      }
    }
  },

  /**
   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
   * them the respective return values of `this.transactionWrappers.init[i]`
   * (`close`rs that correspond to initializers that failed will not be
   * invoked).
   */
  closeAll: function (startIndex) {
    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      var initData = this.wrapperInitData[i];
      var errorThrown;
      try {
        // Catching errors makes debugging more difficult, so we start with
        // errorThrown set to true before setting it to false after calling
        // close -- if it's still set to true in the finally block, it means
        // wrapper.close threw.
        errorThrown = true;
        if (initData !== OBSERVED_ERROR && wrapper.close) {
          wrapper.close.call(this, initData);
        }
        errorThrown = false;
      } finally {
        if (errorThrown) {
          // The closer for wrapper i threw an error; close the remaining
          // wrappers but silence any exceptions from them to ensure that the
          // first error is the one to bubble up.
          try {
            this.closeAll(i + 1);
          } catch (e) {}
        }
      }
    }
    this.wrapperInitData.length = 0;
  }
};

module.exports = TransactionImpl;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(102);
var ViewportMetrics = __webpack_require__(237);

var getEventModifierState = __webpack_require__(165);

/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var MouseEventInterface = {
  screenX: null,
  screenY: null,
  clientX: null,
  clientY: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  getModifierState: getEventModifierState,
  button: function (event) {
    // Webkit, Firefox, IE9+
    // which:  1 2 3
    // button: 0 1 2 (standard)
    var button = event.button;
    if ('which' in event) {
      return button;
    }
    // IE<9
    // which:  undefined
    // button: 0 0 0
    // button: 1 4 2 (onmouseup)
    return button === 2 ? 2 : button === 4 ? 1 : 0;
  },
  buttons: null,
  relatedTarget: function (event) {
    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
  },
  // "Proprietary" Interface.
  pageX: function (event) {
    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
  },
  pageY: function (event) {
    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

module.exports = SyntheticMouseEvent;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(31);
var DOMNamespaces = __webpack_require__(167);

var WHITESPACE_TEST = /^[ \r\n\t\f]/;
var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

var createMicrosoftUnsafeLocalFunction = __webpack_require__(168);

// SVG temp container for IE lacking innerHTML
var reusableSVGContainer;

/**
 * Set the innerHTML property of a node, ensuring that whitespace is preserved
 * even in IE8.
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */
var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
  // IE does not have innerHTML for SVG nodes, so instead we inject the
  // new markup in a temp node and then move the child nodes across into
  // the target node
  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
    var svgNode = reusableSVGContainer.firstChild;
    while (svgNode.firstChild) {
      node.appendChild(svgNode.firstChild);
    }
  } else {
    node.innerHTML = html;
  }
});

if (ExecutionEnvironment.canUseDOM) {
  // IE8: When updating a just created node with innerHTML only leading
  // whitespace is removed. When updating an existing node with innerHTML
  // whitespace in root TextNodes is also collapsed.
  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

  // Feature detection; only IE8 is known to behave improperly like this.
  var testElement = document.createElement('div');
  testElement.innerHTML = ' ';
  if (testElement.innerHTML === '') {
    setInnerHTML = function (node, html) {
      // Magic theory: IE8 supposedly differentiates between added and updated
      // nodes when processing innerHTML, innerHTML on updated nodes suffers
      // from worse whitespace behavior. Re-adding a node like this triggers
      // the initial and more favorable whitespace behavior.
      // TODO: What to do on a detached node?
      if (node.parentNode) {
        node.parentNode.replaceChild(node, node);
      }

      // We also implement a workaround for non-visible tags disappearing into
      // thin air on IE8, this only happens if there is no visible text
      // in-front of the non-visible tags. Piggyback on the whitespace fix
      // and simply check if any non-visible tags appear in the source.
      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
        // Recover leading whitespace by temporarily prepending any character.
        // \uFEFF has the potential advantage of being zero-width/invisible.
        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
        // in hopes that this is preserved even if "\uFEFF" is transformed to
        // the actual Unicode character (by Babel, for example).
        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
        node.innerHTML = String.fromCharCode(0xFEFF) + html;

        // deleteData leaves an empty `TextNode` which offsets the index of all
        // children. Definitely want to avoid this.
        var textNode = node.firstChild;
        if (textNode.data.length === 1) {
          node.removeChild(textNode);
        } else {
          textNode.deleteData(0, 1);
        }
      } else {
        node.innerHTML = html;
      }
    };
  }
  testElement = null;
}

module.exports = setInnerHTML;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * Based on the escape-html library, which is used under the MIT License below:
 *
 * Copyright (c) 2012-2013 TJ Holowaychuk
 * Copyright (c) 2015 Andreas Lubbe
 * Copyright (c) 2015 Tiancheng "Timothy" Gu
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 */



// code copied and modified from escape-html
/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34:
        // "
        escape = '&quot;';
        break;
      case 38:
        // &
        escape = '&amp;';
        break;
      case 39:
        // '
        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
        break;
      case 60:
        // <
        escape = '&lt;';
        break;
      case 62:
        // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}
// end code copied and modified from escape-html


/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */
function escapeTextContentForBrowser(text) {
  if (typeof text === 'boolean' || typeof text === 'number') {
    // this shortcircuit helps perf for types that we know will never have
    // special characters, especially given that this function is used often
    // for numeric dom ids.
    return '' + text;
  }
  return escapeHtml(text);
}

module.exports = escapeTextContentForBrowser;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(15);

var EventPluginRegistry = __webpack_require__(160);
var ReactEventEmitterMixin = __webpack_require__(428);
var ViewportMetrics = __webpack_require__(237);

var getVendorPrefixedEventName = __webpack_require__(429);
var isEventSupported = __webpack_require__(164);

/**
 * Summary of `ReactBrowserEventEmitter` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactEventListener, which is injected and can therefore support pluggable
 *    event sources. This is the only work that occurs in the main thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginHub` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginHub` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|EventPluginHub|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */

var hasEventPageXY;
var alreadyListeningTo = {};
var isMonitoringScrollValue = false;
var reactTopListenersCounter = 0;

// For events like 'submit' which don't consistently bubble (which we trap at a
// lower node than `document`), binding at `document` would cause duplicate
// events so we don't include them here
var topEventMapping = {
  topAbort: 'abort',
  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
  topBlur: 'blur',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topChange: 'change',
  topClick: 'click',
  topCompositionEnd: 'compositionend',
  topCompositionStart: 'compositionstart',
  topCompositionUpdate: 'compositionupdate',
  topContextMenu: 'contextmenu',
  topCopy: 'copy',
  topCut: 'cut',
  topDoubleClick: 'dblclick',
  topDrag: 'drag',
  topDragEnd: 'dragend',
  topDragEnter: 'dragenter',
  topDragExit: 'dragexit',
  topDragLeave: 'dragleave',
  topDragOver: 'dragover',
  topDragStart: 'dragstart',
  topDrop: 'drop',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topFocus: 'focus',
  topInput: 'input',
  topKeyDown: 'keydown',
  topKeyPress: 'keypress',
  topKeyUp: 'keyup',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topMouseDown: 'mousedown',
  topMouseMove: 'mousemove',
  topMouseOut: 'mouseout',
  topMouseOver: 'mouseover',
  topMouseUp: 'mouseup',
  topPaste: 'paste',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topScroll: 'scroll',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topSelectionChange: 'selectionchange',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTextInput: 'textInput',
  topTimeUpdate: 'timeupdate',
  topTouchCancel: 'touchcancel',
  topTouchEnd: 'touchend',
  topTouchMove: 'touchmove',
  topTouchStart: 'touchstart',
  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting',
  topWheel: 'wheel'
};

/**
 * To ensure no conflicts with other potential React instances on the page
 */
var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

function getListeningForDocument(mountAt) {
  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
  // directly.
  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
    mountAt[topListenersIDKey] = reactTopListenersCounter++;
    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
  }
  return alreadyListeningTo[mountAt[topListenersIDKey]];
}

/**
 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
 * example:
 *
 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
 *
 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
 *
 * @internal
 */
var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {

  /**
   * Injectable event backend
   */
  ReactEventListener: null,

  injection: {
    /**
     * @param {object} ReactEventListener
     */
    injectReactEventListener: function (ReactEventListener) {
      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
    }
  },

  /**
   * Sets whether or not any created callbacks should be enabled.
   *
   * @param {boolean} enabled True if callbacks should be enabled.
   */
  setEnabled: function (enabled) {
    if (ReactBrowserEventEmitter.ReactEventListener) {
      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
    }
  },

  /**
   * @return {boolean} True if callbacks are enabled.
   */
  isEnabled: function () {
    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
  },

  /**
   * We listen for bubbled touch events on the document object.
   *
   * Firefox v8.01 (and possibly others) exhibited strange behavior when
   * mounting `onmousemove` events at some node that was not the document
   * element. The symptoms were that if your mouse is not moving over something
   * contained within that mount point (for example on the background) the
   * top-level listeners for `onmousemove` won't be called. However, if you
   * register the `mousemove` on the document object, then it will of course
   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
   * top-level listeners to the document object only, at least for these
   * movement types of events and possibly all events.
   *
   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
   *
   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
   * they bubble to document.
   *
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {object} contentDocumentHandle Document which owns the container
   */
  listenTo: function (registrationName, contentDocumentHandle) {
    var mountAt = contentDocumentHandle;
    var isListening = getListeningForDocument(mountAt);
    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];

    for (var i = 0; i < dependencies.length; i++) {
      var dependency = dependencies[i];
      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
        if (dependency === 'topWheel') {
          if (isEventSupported('wheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
          } else if (isEventSupported('mousewheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
          } else {
            // Firefox needs to capture a different mouse scroll event.
            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
          }
        } else if (dependency === 'topScroll') {

          if (isEventSupported('scroll', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
          } else {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
          }
        } else if (dependency === 'topFocus' || dependency === 'topBlur') {

          if (isEventSupported('focus', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
          } else if (isEventSupported('focusin')) {
            // IE has `focusin` and `focusout` events which bubble.
            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
          }

          // to make sure blur and focus event listeners are only attached once
          isListening.topBlur = true;
          isListening.topFocus = true;
        } else if (topEventMapping.hasOwnProperty(dependency)) {
          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
        }

        isListening[dependency] = true;
      }
    }
  },

  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
  },

  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
  },

  /**
   * Protect against document.createEvent() returning null
   * Some popup blocker extensions appear to do this:
   * https://github.com/facebook/react/issues/6887
   */
  supportsEventPageXY: function () {
    if (!document.createEvent) {
      return false;
    }
    var ev = document.createEvent('MouseEvent');
    return ev != null && 'pageX' in ev;
  },

  /**
   * Listens to window scroll and resize events. We cache scroll values so that
   * application code can access them without triggering reflows.
   *
   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
   * pageX/pageY isn't supported (legacy browsers).
   *
   * NOTE: Scroll events do not bubble.
   *
   * @see http://www.quirksmode.org/dom/events/scroll.html
   */
  ensureScrollValueMonitoring: function () {
    if (hasEventPageXY === undefined) {
      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
    }
    if (!hasEventPageXY && !isMonitoringScrollValue) {
      var refresh = ViewportMetrics.refreshScrollValues;
      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
      isMonitoringScrollValue = true;
    }
  }

});

module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.canUseMembrane = undefined;

var _routerWarning = __webpack_require__(26);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var canUseMembrane = exports.canUseMembrane = false;

// No-op by default.
var deprecateObjectProperties = function deprecateObjectProperties(object) {
  return object;
};

if (false) {
  try {
    if (Object.defineProperty({}, 'x', {
      get: function get() {
        return true;
      }
    }).x) {
      exports.canUseMembrane = canUseMembrane = true;
    }
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

  if (canUseMembrane) {
    deprecateObjectProperties = function deprecateObjectProperties(object, message) {
      // Wrap the deprecated object in a membrane to warn on property access.
      var membrane = {};

      var _loop = function _loop(prop) {
        if (!Object.prototype.hasOwnProperty.call(object, prop)) {
          return 'continue';
        }

        if (typeof object[prop] === 'function') {
          // Can't use fat arrow here because of use of arguments below.
          membrane[prop] = function () {
            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
            return object[prop].apply(object, arguments);
          };
          return 'continue';
        }

        // These properties are non-enumerable to prevent React dev tools from
        // seeing them and causing spurious warnings when accessing them. In
        // principle this could be done with a proxy, but support for the
        // ownKeys trap on proxies is not universal, even among browsers that
        // otherwise support proxies.
        Object.defineProperty(membrane, prop, {
          get: function get() {
            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
            return object[prop];
          }
        });
      };

      for (var prop in object) {
        var _ret = _loop(prop);

        if (_ret === 'continue') continue;
      }

      return membrane;
    };
  }
}

exports.default = deprecateObjectProperties;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
exports.canUseDOM = canUseDOM;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(41);

var _warning2 = _interopRequireDefault(_warning);

var _queryString = __webpack_require__(498);

var _runTransitionHook = __webpack_require__(185);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _PathUtils = __webpack_require__(68);

var _deprecate = __webpack_require__(186);

var _deprecate2 = _interopRequireDefault(_deprecate);

var SEARCH_BASE_KEY = '$searchBase';

function defaultStringifyQuery(query) {
  return _queryString.stringify(query).replace(/%20/g, '+');
}

var defaultParseQueryString = _queryString.parse;

function isNestedObject(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p) && typeof object[p] === 'object' && !Array.isArray(object[p]) && object[p] !== null) return true;
  }return false;
}

/**
 * Returns a new createHistory function that may be used to create
 * history objects that know how to handle URL queries.
 */
function useQueries(createHistory) {
  return function () {
    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var history = createHistory(options);

    var stringifyQuery = options.stringifyQuery;
    var parseQueryString = options.parseQueryString;

    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;

    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;

    function addQuery(location) {
      if (location.query == null) {
        var search = location.search;

        location.query = parseQueryString(search.substring(1));
        location[SEARCH_BASE_KEY] = { search: search, searchBase: '' };
      }

      // TODO: Instead of all the book-keeping here, this should just strip the
      // stringified query from the search.

      return location;
    }

    function appendQuery(location, query) {
      var _extends2;

      var searchBaseSpec = location[SEARCH_BASE_KEY];
      var queryString = query ? stringifyQuery(query) : '';
      if (!searchBaseSpec && !queryString) {
        return location;
      }

       false ? _warning2['default'](stringifyQuery !== defaultStringifyQuery || !isNestedObject(query), 'useQueries does not stringify nested query objects by default; ' + 'use a custom stringifyQuery function') : undefined;

      if (typeof location === 'string') location = _PathUtils.parsePath(location);

      var searchBase = undefined;
      if (searchBaseSpec && location.search === searchBaseSpec.search) {
        searchBase = searchBaseSpec.searchBase;
      } else {
        searchBase = location.search || '';
      }

      var search = searchBase;
      if (queryString) {
        search += (search ? '&' : '?') + queryString;
      }

      return _extends({}, location, (_extends2 = {
        search: search
      }, _extends2[SEARCH_BASE_KEY] = { search: search, searchBase: searchBase }, _extends2));
    }

    // Override all read methods with query-aware versions.
    function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        _runTransitionHook2['default'](hook, addQuery(location), callback);
      });
    }

    function listen(listener) {
      return history.listen(function (location) {
        listener(addQuery(location));
      });
    }

    // Override all write methods with query-aware versions.
    function push(location) {
      history.push(appendQuery(location, location.query));
    }

    function replace(location) {
      history.replace(appendQuery(location, location.query));
    }

    function createPath(location, query) {
       false ? _warning2['default'](!query, 'the query argument to createPath is deprecated; use a location descriptor instead') : undefined;

      return history.createPath(appendQuery(location, query || location.query));
    }

    function createHref(location, query) {
       false ? _warning2['default'](!query, 'the query argument to createHref is deprecated; use a location descriptor instead') : undefined;

      return history.createHref(appendQuery(location, query || location.query));
    }

    function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var fullLocation = history.createLocation.apply(history, [appendQuery(location, location.query)].concat(args));
      if (location.query) {
        fullLocation.query = location.query;
      }
      return addQuery(fullLocation);
    }

    // deprecated
    function pushState(state, path, query) {
      if (typeof path === 'string') path = _PathUtils.parsePath(path);

      push(_extends({ state: state }, path, { query: query }));
    }

    // deprecated
    function replaceState(state, path, query) {
      if (typeof path === 'string') path = _PathUtils.parsePath(path);

      replace(_extends({ state: state }, path, { query: query }));
    }

    return _extends({}, history, {
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation,

      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
    });
  };
}

exports['default'] = useQueries;
module.exports = exports['default'];

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(25);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _deprecateObjectProperties = __webpack_require__(123);

var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);

var _getRouteParams = __webpack_require__(505);

var _getRouteParams2 = _interopRequireDefault(_getRouteParams);

var _RouteUtils = __webpack_require__(58);

var _routerWarning = __webpack_require__(26);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _React$PropTypes = _react2.default.PropTypes;
var array = _React$PropTypes.array;
var func = _React$PropTypes.func;
var object = _React$PropTypes.object;

/**
 * A <RouterContext> renders the component tree for a given router state
 * and sets the history object and the current location in context.
 */

var RouterContext = _react2.default.createClass({
  displayName: 'RouterContext',


  propTypes: {
    history: object,
    router: object.isRequired,
    location: object.isRequired,
    routes: array.isRequired,
    params: object.isRequired,
    components: array.isRequired,
    createElement: func.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      createElement: _react2.default.createElement
    };
  },


  childContextTypes: {
    history: object,
    location: object.isRequired,
    router: object.isRequired
  },

  getChildContext: function getChildContext() {
    var _props = this.props;
    var router = _props.router;
    var history = _props.history;
    var location = _props.location;

    if (!router) {
       false ? (0, _routerWarning2.default)(false, '`<RouterContext>` expects a `router` rather than a `history`') : void 0;

      router = _extends({}, history, {
        setRouteLeaveHook: history.listenBeforeLeavingRoute
      });
      delete router.listenBeforeLeavingRoute;
    }

    if (false) {
      location = (0, _deprecateObjectProperties2.default)(location, '`context.location` is deprecated, please use a route component\'s `props.location` instead. http://tiny.cc/router-accessinglocation');
    }

    return { history: history, location: location, router: router };
  },
  createElement: function createElement(component, props) {
    return component == null ? null : this.props.createElement(component, props);
  },
  render: function render() {
    var _this = this;

    var _props2 = this.props;
    var history = _props2.history;
    var location = _props2.location;
    var routes = _props2.routes;
    var params = _props2.params;
    var components = _props2.components;

    var element = null;

    if (components) {
      element = components.reduceRight(function (element, components, index) {
        if (components == null) return element; // Don't create new children; use the grandchildren.

        var route = routes[index];
        var routeParams = (0, _getRouteParams2.default)(route, params);
        var props = {
          history: history,
          location: location,
          params: params,
          route: route,
          routeParams: routeParams,
          routes: routes
        };

        if ((0, _RouteUtils.isReactChildren)(element)) {
          props.children = element;
        } else if (element) {
          for (var prop in element) {
            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
          }
        }

        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
          var elements = {};

          for (var key in components) {
            if (Object.prototype.hasOwnProperty.call(components, key)) {
              // Pass through the key as a prop to createElement to allow
              // custom createElement functions to know which named component
              // they're rendering, for e.g. matching up to fetched data.
              elements[key] = _this.createElement(components[key], _extends({
                key: key }, props));
            }
          }

          return elements;
        }

        return _this.createElement(components, props);
      }, element);
    }

    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;

    return element;
  }
});

exports.default = RouterContext;
module.exports = exports['default'];

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(32),
    isKey = __webpack_require__(194),
    stringToPath = __webpack_require__(542),
    toString = __webpack_require__(566);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(71),
    isObjectLike = __webpack_require__(59);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(72);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(556),
    listCacheDelete = __webpack_require__(557),
    listCacheGet = __webpack_require__(558),
    listCacheHas = __webpack_require__(559),
    listCacheSet = __webpack_require__(560);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(109);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(562);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 133 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(283);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 135 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 136 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UNFULFILLED_PROMISE_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return nrEmitter; });
var NOOP = function NOOP() {};
var env = Object({"NODE_ENV":"production"});
var nrEmitter = void 0;
if (false) {
    var newRelic = require('newrelic');
    var EventEmitter = require('events');
    nrEmitter = new EventEmitter();
    // newRelicEmitter.on(UNFULFILLED_PROMISE_EVENT, (err) => {
    //     newRelic.noticeError(err);
    // });
} else {
    nrEmitter = { emit: NOOP };
}

var UNFULFILLED_PROMISE_EVENT = 'unfulfilledPromise';


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function $getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return $getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = $getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  var args = [];
  for (var i = 0; i < arguments.length; i++) args.push(arguments[i]);
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    ReflectApply(this.listener, this.target, args);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      if (typeof listener !== 'function') {
        throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
      }
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      if (typeof listener !== 'function') {
        throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
      }

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 139 */
/***/ (function(module, exports) {

var exports = module.exports = function (doc) {
    if (!doc) doc = {};
    if (typeof doc === 'string') doc = { cookie: doc };
    if (doc.cookie === undefined) doc.cookie = '';
    
    var self = {};
    self.get = function (key) {
        var splat = doc.cookie.split(/;\s*/);
        for (var i = 0; i < splat.length; i++) {
            var ps = splat[i].split('=');
            var k = unescape(ps[0]);
            if (k === key) return unescape(ps[1]);
        }
        return undefined;
    };
    
    self.set = function (key, value, opts) {
        if (!opts) opts = {};
        var s = escape(key) + '=' + escape(value);
        if (opts.expires) s += '; expires=' + opts.expires;
        if (opts.path) s += '; path=' + escape(opts.path);
        if (opts.domain) s += '; domain=' + escape(opts.domain);
        if (opts.secure) s += '; secure';
        doc.cookie = s;
        return s;
    };
    return self;
};

if (typeof document !== 'undefined') {
    var cookie = exports(document);
    exports.get = cookie.get;
    exports.set = cookie.set;
}


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(314),
    baseKeys = __webpack_require__(200),
    isArrayLike = __webpack_require__(51);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(39),
    stubFalse = __webpack_require__(654);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(107)(module)))

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(655),
    baseUnary = __webpack_require__(301),
    nodeUtil = __webpack_require__(656);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = streamHasDTCPackage;
function streamHasDTCPackage() {
    var stream = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var packageName = arguments[1];

    if (stream.packages && packageName) {
        return stream.packages.indexOf(packageName) > -1;
    }
    return false;
};

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getBamAuthConfig;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * getBamAuthConfig - returns a proper formatted auth object containing the token and swid keys.
 * Defaults to null values if id_token and swid values are undefined
 * @param  {boolean} oneIdTokenObject = {} - Object containing both token and swid data
 * @param  {object} passOneIdToken = false - Boolean flag to determine if a oneIdToken was passed
 * @param  {array}  userAuth = [] or array list of user auth types
 * @return {object}
 */
function getBamAuthConfig() {
  var oneIdTokenObject = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var passOneIdToken = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var userAuth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var authObject = {
    auth: {
      token: null,
      swid: null,
      userAuth: userAuth
    }
  };

  if (passOneIdToken === true && (typeof oneIdTokenObject === 'undefined' ? 'undefined' : _typeof(oneIdTokenObject)) === 'object') {
    var _oneIdTokenObject$id_ = oneIdTokenObject.id_token,
        id_token = _oneIdTokenObject$id_ === undefined ? null : _oneIdTokenObject$id_,
        _oneIdTokenObject$swi = oneIdTokenObject.swid,
        swid = _oneIdTokenObject$swi === undefined ? null : _oneIdTokenObject$swi;

    authObject = _extends({}, authObject, { auth: { token: id_token, swid: swid, userAuth: userAuth } });
  }

  return authObject;
};

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(113),
    baseUniq = __webpack_require__(323);

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}

module.exports = uniqBy;


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isEspnPlusExecAccount */
/* unused harmony export isEspnPlusTDA */
/* harmony export (immutable) */ __webpack_exports__["a"] = checkESPNPlusAuthentication;
/* harmony export (immutable) */ __webpack_exports__["b"] = shallowCheckAuthentication;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_intersection__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_intersection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_intersection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enums__ = __webpack_require__(1);



/**
 * Verifies if the user's authenticated entitlements contain the Exectuive entitlement.
 * @param {array} userAuth - array of entitlements
 * @returns {boolean}
 */
function isEspnPlusExecAccount() {
    var userAuth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    return !!userAuth.length && userAuth.indexOf(__WEBPACK_IMPORTED_MODULE_1__enums__["s" /* Entitlements */].ESPN_EXEC) !== -1;
}

/**
 * Verifies if the user's authenticated entitlements contain TDA entitlement.
 * @param {array} userAuth - array of entitlements
 * @returns {boolean}
 */
function isEspnPlusTDA() {
    var userAuth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    return !!userAuth.length && userAuth.indexOf(__WEBPACK_IMPORTED_MODULE_1__enums__["s" /* Entitlements */].ESPN_TDA) !== -1;
}

function checkESPNPlusAuthentication() {
    var stream = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var userAuth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var authTypes = stream.authTypes,
        _stream$packages = stream.packages,
        packages = _stream$packages === undefined ? [] : _stream$packages;

    if (authTypes.indexOf(__WEBPACK_IMPORTED_MODULE_1__enums__["e" /* AuthTypes */].BAM) === -1) {
        return false;
    }

    if (packages.length === 0) {
        return true;
    }

    var userAuthForESPNPlus = userAuth.filter(function (auth) {
        return auth.indexOf(__WEBPACK_IMPORTED_MODULE_1__enums__["e" /* AuthTypes */].MVPD) === -1 && auth.indexOf(__WEBPACK_IMPORTED_MODULE_1__enums__["e" /* AuthTypes */].ISP) === -1;
    });

    // NOTE: For `Executive` accounts we always allow access to all content
    if (isEspnPlusExecAccount(userAuth)) {
        return true;
    }

    // For TDA accounts, allow access to all content
    if (isEspnPlusTDA(userAuth)) {
        return true;
    }

    if (packages.length === 1 && userAuthForESPNPlus.indexOf(packages[0]) > -1) {
        return true;
    }

    if (__WEBPACK_IMPORTED_MODULE_0_lodash_intersection___default()(packages, userAuthForESPNPlus).length > 0) {
        return true;
    }

    return false;
}
/**
 * Checks a user's authentication status for a given content based on what is available in state.
 * It is shallow because it doesn't fetch any additional data, just calculates based on what we have already.
 *
 * @param {array} authTypes - Destructured from content object.  The authTypes required to watch this content
 * @param {array} userAuth - The authTypes a user has at this given moment
 * @param {boolean} optimistic - Returns true if a user's authTypes are currently unknown
 */

function shallowCheckAuthentication() {
    var stream = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var userAuth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var optimisitic = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var authTypes = stream.authTypes,
        _stream$source = stream.source,
        source = _stream$source === undefined ? '' : _stream$source;
    // if a content does not have authTypes, it's available for everyone

    if (!authTypes || authTypes.length === 0 || authTypes.some(function (authType) {
        return authType === __WEBPACK_IMPORTED_MODULE_1__enums__["e" /* AuthTypes */].OPEN;
    })) {
        return true;
    }

    // E+ content in legacy app
    if (authTypes.indexOf(__WEBPACK_IMPORTED_MODULE_1__enums__["e" /* AuthTypes */].MVPD) > -1 && source === 'ESPN+') {
        return false;
    }

    // check if a user's authTypes intersects with a content's authTypes
    if (userAuth && authTypes) {
        var ESPNPlusAuthentication = checkESPNPlusAuthentication(stream, userAuth);

        return ESPNPlusAuthentication || authTypes.some(function (authType) {
            return userAuth.indexOf(authType) !== -1 || userAuth.indexOf('unknown_' + authType) !== -1 && optimisitic;
        });
    }

    // if we got here, we didn't have all the information to shallow check auth
    return optimisitic;
};

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__selectors_flagsSelector__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_format_addQueryToUrl__ = __webpack_require__(70);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };








var LinkWithFlags = function LinkWithFlags(props) {
    var ownProps = props.ownProps,
        flags = props.flags,
        toArg = props.to;

    var to = void 0;
    if ((typeof toArg === 'undefined' ? 'undefined' : _typeof(toArg)) === 'object') {
        to = _extends({}, toArg, {
            query: _extends({}, toArg.query, flags)
        });
    } else {
        to = Object(__WEBPACK_IMPORTED_MODULE_4__lib_format_addQueryToUrl__["a" /* default */])(toArg, flags);
    }
    var newProps = _extends({}, ownProps, {
        to: to
    });
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Link"], newProps);
};

LinkWithFlags.defaultProps = __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"].defaultProps;

var mapStateToProps = function mapStateToProps(state, ownProps) {
    return {
        ownProps: ownProps,
        flags: Object(__WEBPACK_IMPORTED_MODULE_3__selectors_flagsSelector__["a" /* persistentFlagsSelector */])(state)
    };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(LinkWithFlags));

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);


var playingStreamSelector = function playingStreamSelector(_ref) {
  var app = _ref.app;
  return app.playingStream || {};
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(playingStreamSelector, function (playingStream) {
  return playingStream;
}));

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_merge__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_merge__);





var pickerStreamsSelector = function pickerStreamsSelector(_ref) {
    var app = _ref.app;
    return app.pickerStreams;
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(pickerStreamsSelector, function () {
    var pickerStreams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    if (pickerStreams.length > 0) {
        pickerStreams.forEach(function (item) {
            if (Array.isArray(item.contents) && item.contents.length > 0) {
                item.contents.forEach(function (content) {
                    // NOTE: Merges first matching nested `stream` object to the parent to ensure we have
                    // all the metadata the players need for UI and playback such as `authTypes` and `packages`
                    if (Array.isArray(content.streams) && content.streams.length > 0 && content.id) {
                        var id = content.id,
                            streams = content.streams;

                        var matchingStream = __WEBPACK_IMPORTED_MODULE_1_lodash_find___default()(streams, { id: id });

                        if (matchingStream) {
                            __WEBPACK_IMPORTED_MODULE_2_lodash_merge___default()(content, matchingStream);
                        }
                    }
                });
            }
        });
    }

    return pickerStreams;
}));

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AdContainer__ = __webpack_require__(218);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var InContentAd = function InContentAd(props) {
    var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('ad-slot-incontent ad-wrapper', props.adClassName);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__AdContainer__["a" /* default */], _extends({
        className: className,
        slotType: 'incontent',
        kvps: { pos: 'incontent' },
        render: InContentAd.render
    }, props));
};

// This pattern is for AdContainer to give control to disable ads based on global state
InContentAd.render = function (children) {
    return _jsx('div', {
        className: 'ad-wrapper'
    }, void 0, _jsx('article', {
        className: 'ad-300'
    }, void 0, _jsx('div', {
        className: 'ad-center'
    }, void 0, children)));
};

/* harmony default export */ __webpack_exports__["a"] = (InContentAd);

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contentSubtitle__ = __webpack_require__(352);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__contentSubtitle__["a"]; });
/* eslint-disable import/prefer-default-export */


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(4);

// EXTERNAL MODULE: ./app/constants.js
var constants = __webpack_require__(8);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(14);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./app/enums.js
var enums = __webpack_require__(1);

// EXTERNAL MODULE: ./app/common/PropTypes.js
var PropTypes = __webpack_require__(28);

// EXTERNAL MODULE: ./app/common/selectors/heroSelector.js
var heroSelector = __webpack_require__(56);

// EXTERNAL MODULE: ./app/common/ResponsiveThumbnail.js
var ResponsiveThumbnail = __webpack_require__(222);

// EXTERNAL MODULE: ./app/webapp/player/connectPlayer.js
var connectPlayer = __webpack_require__(223);

// EXTERNAL MODULE: ./app/common/page/hero/ContentMetadataLarge.js
var ContentMetadataLarge = __webpack_require__(355);

// EXTERNAL MODULE: ./app/webapp/lib/format/index.js
var format = __webpack_require__(151);

// EXTERNAL MODULE: ./app/lib/util/isEmpty.js
var isEmpty = __webpack_require__(12);

// CONCATENATED MODULE: ./app/webapp/page/hero/Hero.js
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var IMAGE_WIDTHS = [400, 640, 1200, 1800];

// this needs to be a class because we're connecting a player to it

var Hero_Hero = function (_Component) {
    _inherits(Hero, _Component);

    function Hero() {
        _classCallCheck(this, Hero);

        return _possibleConstructorReturn(this, (Hero.__proto__ || Object.getPrototypeOf(Hero)).apply(this, arguments));
    }

    _createClass(Hero, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                content = _props.content,
                selectedStream = _props.selectedStream,
                playingStream = _props.playingStream,
                clickHandler = _props.clickHandler,
                userIsBlackedOut = _props.userIsBlackedOut,
                showLock = _props.showLock;

            var stream = !Object(isEmpty["a" /* default */])(playingStream) ? playingStream : selectedStream;
            var contentId = content.id,
                contentName = content.name,
                contentScore = content.score,
                contentStatus = content.status;


            var imageHref = Object(heroSelector["b" /* heroImageSelector */])(content);
            var _stream$id = stream.id,
                id = _stream$id === undefined ? contentId : _stream$id,
                _stream$name = stream.name,
                name = _stream$name === undefined ? contentName : _stream$name,
                _stream$score = stream.score,
                score = _stream$score === undefined ? contentScore : _stream$score,
                _stream$status = stream.status,
                status = _stream$status === undefined ? contentStatus : _stream$status;

            var isPlayable = !userIsBlackedOut;
            var title = content.name;
            var subtitle = Object(format["a" /* contentSubtitle */])(content);

            var playButtonClasses = classnames_default()({
                'button-play button-play--video': isPlayable,
                'button-play--live': isPlayable && status === enums["n" /* ContentStatus */].LIVE
            });

            var blurredImage = _jsx(ResponsiveThumbnail["a" /* default */], {
                className: 'hero_img hero_img--blurred',
                src: imageHref,
                srcSetWidths: IMAGE_WIDTHS,
                sizes: '100vw',
                alt: name
            });

            var hero = id ? _jsx('article', {
                className: 'hero--super',
                'data-score': score
            }, void 0, react_default.a.createElement(
                'figure',
                { className: 'hero_wrapper', ref: 'playerContainer' },
                _jsx('a', {
                    className: 'col-a'
                }, void 0, _jsx('div', {
                    onClick: isPlayable && clickHandler,
                    id: 'hero-' + id
                }, void 0, _jsx(ResponsiveThumbnail["a" /* default */], {
                    className: 'hero_img',
                    src: imageHref,
                    srcSetWidths: IMAGE_WIDTHS,
                    sizes: '100vw',
                    alt: name
                }), _jsx('div', {
                    className: playButtonClasses
                })))
            ), _jsx(ContentMetadataLarge["a" /* default */], {
                blurredImage: blurredImage,
                title: title,
                subtitle: subtitle,
                content: content,
                isHero: true,
                showLock: showLock,
                userIsBlackedOut: userIsBlackedOut
            })) : null;

            return _jsx('div', {}, void 0, hero);
        }
    }]);

    return Hero;
}(react["Component"]);

Hero_Hero.defaultProps = {
    clickHandler: function clickHandler(event) {
        event.preventDefault();
    }
};

/* harmony default export */ var hero_Hero = (Object(connectPlayer["a" /* default */])(Hero_Hero));
// EXTERNAL MODULE: ./app/common/search/SearchContainer.js + 3 modules
var SearchContainer = __webpack_require__(154);

// EXTERNAL MODULE: ./app/webapp/scheduleModule/ScheduleModuleContainer.js + 8 modules
var ScheduleModuleContainer = __webpack_require__(338);

// EXTERNAL MODULE: ./app/webapp/common/playable.js + 2 modules
var playable = __webpack_require__(64);

// CONCATENATED MODULE: ./app/webapp/common/BAMIFrame.js
var BAMIFrame__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var BAMIFrame = function BAMIFrame(_ref) {
    var id = _ref.id,
        src = _ref.src;

    var content = src && BAMIFrame__jsx('iframe', {
        src: src
    });
    return BAMIFrame__jsx('div', {
        id: id
    }, void 0, content);
};

/* harmony default export */ var common_BAMIFrame = (BAMIFrame);
// EXTERNAL MODULE: ./app/common/selectors/appSelector.js + 1 modules
var appSelector = __webpack_require__(3);

// EXTERNAL MODULE: ./app/common/selectors/pageSelector.js
var pageSelector = __webpack_require__(13);

// EXTERNAL MODULE: ./app/common/selectors/analyticsSelectors.js
var analyticsSelectors = __webpack_require__(54);

// EXTERNAL MODULE: ./app/common/actions/authenticationActions.js
var authenticationActions = __webpack_require__(22);

// CONCATENATED MODULE: ./app/common/page/common/TopLayoutContainer.js
/* unused harmony export BaseTopLayoutContainer */
var TopLayoutContainer__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var TopLayoutContainer__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function TopLayoutContainer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TopLayoutContainer__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function TopLayoutContainer__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var PlayableHero = Object(playable["a" /* default */])(hero_Hero);

var TopLayoutContainer_TopLayoutContainer = function (_PureComponent) {
    TopLayoutContainer__inherits(TopLayoutContainer, _PureComponent);

    function TopLayoutContainer(props) {
        TopLayoutContainer__classCallCheck(this, TopLayoutContainer);

        var _this = TopLayoutContainer__possibleConstructorReturn(this, (TopLayoutContainer.__proto__ || Object.getPrototypeOf(TopLayoutContainer)).call(this, props));

        _this.state = {
            promoShown: false
        };
        return _this;
    }

    TopLayoutContainer__createClass(TopLayoutContainer, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var promoShown = this.state.promoShown;
            var dispatch = this.props.dispatch;
            // can't use `ref` for stateless component(BAMIFrame), so checking against real DOM element

            if (!promoShown && this.showPromo && document.getElementById(constants["b" /* BAM_PROMO_IFRAME_ID */])) {
                dispatch(Object(authenticationActions["M" /* createDTCPaywallAction */])({
                    containerId: constants["b" /* BAM_PROMO_IFRAME_ID */]
                }));
                if (!this.state.promoShown) {
                    this.promoShown();
                }
            }
        }
    }, {
        key: 'promoShown',
        value: function promoShown() {
            this.setState({ promoShown: true });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                heroArg = _props.hero,
                apiEnv = _props.apiEnv,
                showSearch = _props.showSearch,
                entitlementsTracking = _props.entitlementsTracking;

            var hero = null;
            var search = null;
            var scheduleModule = null;

            if (this.showPromo) {
                hero = TopLayoutContainer__jsx(common_BAMIFrame, {
                    id: constants["b" /* BAM_PROMO_IFRAME_ID */]
                });
            } else if (!Object(isEmpty["a" /* default */])(heroArg)) {
                hero = TopLayoutContainer__jsx(PlayableHero, {
                    content: heroArg,
                    playerPlacement: enums["B" /* PlayerPlacement */].HERO,
                    placement: 'inline-hero',
                    isHero: true
                });
            }
            if (hero) {
                search = TopLayoutContainer__jsx(SearchContainer["a" /* default */], {
                    apiEnv: apiEnv,
                    entitlementsTracking: entitlementsTracking,
                    pageType: enums["y" /* PageType */].HOME,
                    enabled: showSearch
                });
                scheduleModule = TopLayoutContainer__jsx(ScheduleModuleContainer["a" /* default */], {});
            }
            var colCClassName = showSearch ? 'col-c' : 'col-c no-search';
            return TopLayoutContainer__jsx('div', {
                className: 'layout-bc'
            }, void 0, TopLayoutContainer__jsx('section', {
                className: 'mobile-tablet-only'
            }, void 0, search), TopLayoutContainer__jsx('section', {
                className: 'col-b'
            }, void 0, hero), TopLayoutContainer__jsx('section', {
                className: colCClassName
            }, void 0, search, scheduleModule));
        }
    }, {
        key: 'showPromo',
        get: function get() {
            var _props2 = this.props,
                id = _props2.page.id,
                showPromoArg = _props2.showPromo;

            return showPromoArg && id === 'espnplus';
        }
    }]);

    return TopLayoutContainer;
}(react["PureComponent"]);

var TopLayoutContainer_mapStateToProps = function mapStateToProps(state) {
    return {
        page: Object(pageSelector["c" /* default */])(state),
        hero: Object(heroSelector["a" /* default */])(state),
        showSearch: Object(appSelector["l" /* enableSearchSelector */])(state),
        showPromo: Object(pageSelector["g" /* showPromoSelector */])(state),
        apiEnv: Object(appSelector["c" /* apiEnvSelector */])(state),
        entitlementsTracking: Object(analyticsSelectors["c" /* entitlementsTrackingSelector */])(state)
    };
};

/* harmony default export */ var common_TopLayoutContainer = __webpack_exports__["a"] = (Object(es["b" /* connect */])(TopLayoutContainer_mapStateToProps)(TopLayoutContainer_TopLayoutContainer));


/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return autoPlaySelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return lastFeedsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return playerAdsConfigSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return prerollConfigSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return recommendMobileWebSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return dssPlayerMutedSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enums__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appSelector__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pageSelector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__selectedStreamSelector__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bootstrapSelector__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__oneIdSelector__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__adsSelector__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_util_getAndroidVersionFromUserAgent__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_util_getPrerollConfigByEdition__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_util_getAdsConfigByEdition__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_util_getAdsConfigByAdProvider__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_util_hasTier__ = __webpack_require__(333);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
















var playerSelector = function playerSelector(_ref) {
    var _ref$player = _ref.player,
        player = _ref$player === undefined ? {} : _ref$player;
    return player;
};

/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(playerSelector, function (player) {
    return player;
}));

var autoPlaySelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_2__appSelector__["j" /* default */], __WEBPACK_IMPORTED_MODULE_4__selectedStreamSelector__["a" /* default */], function (_ref2) {
    var isMobile = _ref2.isMobile,
        _ref2$location = _ref2.location;
    _ref2$location = _ref2$location === undefined ? {} : _ref2$location;
    var _ref2$location$query = _ref2$location.query;
    _ref2$location$query = _ref2$location$query === undefined ? {} : _ref2$location$query;
    var autoplay = _ref2$location$query.autoplay;
    var selectedStream = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    // set `autoplay` to false for the first mobile/tablet playback
    // until Brightcove fixes the issue where the player incorrectly detects the device is auto-playable.
    // TODO: remove this once Brightcove player fixes the mobile/tablet playback.
    if (isMobile) {
        return false;
    }

    if (autoplay != null) {
        return autoplay;
    }

    // The selectedStream used for playback does not get autoplayed if the tier property is not primary
    if (!Object(__WEBPACK_IMPORTED_MODULE_12__lib_util_hasTier__["a" /* default */])(selectedStream, 'primary') && selectedStream.content && selectedStream.content.type !== __WEBPACK_IMPORTED_MODULE_1__enums__["o" /* ContentType */].VOD) {
        return false;
    }

    return true;
});

var lastFeedsSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(playerSelector, function (_ref3) {
    var feeds = _ref3.feeds;
    return feeds;
});

var playerAdsConfigSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_7__adsSelector__["a" /* adSiteSelector */], __WEBPACK_IMPORTED_MODULE_3__pageSelector__["f" /* pagePathWithPageId */], __WEBPACK_IMPORTED_MODULE_5__bootstrapSelector__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__appSelector__["j" /* default */], __WEBPACK_IMPORTED_MODULE_2__appSelector__["k" /* editionSelector */], function (adSite, pathWithId, _ref4, _ref5, _ref6) {
    var _ref4$syndicatedPlaye = _ref4.syndicatedPlayer;
    _ref4$syndicatedPlaye = _ref4$syndicatedPlaye === undefined ? {} : _ref4$syndicatedPlaye;
    var _ref4$syndicatedPlaye2 = _ref4$syndicatedPlaye.adsConfig,
        adsConfig = _ref4$syndicatedPlaye2 === undefined ? {} : _ref4$syndicatedPlaye2;
    var _ref5$location = _ref5.location;
    _ref5$location = _ref5$location === undefined ? {} : _ref5$location;
    var _ref5$location$query = _ref5$location.query,
        query = _ref5$location$query === undefined ? {} : _ref5$location$query;
    var _ref6$edition = _ref6.edition,
        edition = _ref6$edition === undefined ? 'us' : _ref6$edition;

    var adProviderOverride = query[__WEBPACK_IMPORTED_MODULE_1__enums__["t" /* Flags */].VIDEO_ADS_PROVIDER];
    var configByEdition = Object(__WEBPACK_IMPORTED_MODULE_10__lib_util_getAdsConfigByEdition__["a" /* default */])(edition, adsConfig);
    var configByAdProvider = Object(__WEBPACK_IMPORTED_MODULE_11__lib_util_getAdsConfigByAdProvider__["a" /* default */])(adProviderOverride, configByEdition);
    var isActiveAdProviderGoogle = typeof configByAdProvider.activeAdProvider === 'string' && configByAdProvider.activeAdProvider.toLowerCase().indexOf('google') !== -1;
    // NOTE: Appending `adUnit` only for Google Ad Manager
    if (adSite && isActiveAdProviderGoogle) {
        configByAdProvider = _extends({}, configByAdProvider, { adUnit: '' + adSite + pathWithId });
    }

    if (isActiveAdProviderGoogle) {
        var cmsidOverride = query[__WEBPACK_IMPORTED_MODULE_1__enums__["t" /* Flags */].VIDEO_ADS_CMSID];
        var networkCodeOverride = query[__WEBPACK_IMPORTED_MODULE_1__enums__["t" /* Flags */].VIDEO_ADS_NETWORK_CODE];
        var adUnitOverride = query[__WEBPACK_IMPORTED_MODULE_1__enums__["t" /* Flags */].VIDEO_ADS_AD_UNIT];

        configByAdProvider.cmsid = cmsidOverride || configByAdProvider.cmsid;
        configByAdProvider.networkCode = networkCodeOverride || configByAdProvider.networkCode;
        configByAdProvider.adUnit = adUnitOverride || configByAdProvider.adUnit;
    }

    return configByAdProvider;
});

var prerollConfigSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_5__bootstrapSelector__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__oneIdSelector__["d" /* oneIdEntitlementsSelector */], __WEBPACK_IMPORTED_MODULE_2__appSelector__["k" /* editionSelector */], __WEBPACK_IMPORTED_MODULE_4__selectedStreamSelector__["a" /* default */], function (_ref7) {
    var _ref7$preRoll = _ref7.preRoll;
    _ref7$preRoll = _ref7$preRoll === undefined ? {} : _ref7$preRoll;
    var _ref7$preRoll$edition = _ref7$preRoll.editions,
        prerollConfigEditionMap = _ref7$preRoll$edition === undefined ? {} : _ref7$preRoll$edition;
    var entitlements = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var _ref8 = arguments[2];
    var _ref8$edition = _ref8.edition,
        edition = _ref8$edition === undefined ? 'us' : _ref8$edition;
    var selectedStream = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    var defaultInterval = 0;
    var intervals = {};
    var exportedConfig = {};
    var _selectedStream$conte = selectedStream.content,
        content = _selectedStream$conte === undefined ? {} : _selectedStream$conte;

    var contentType = content.type || null;
    var prerollEditionConfig = Object(__WEBPACK_IMPORTED_MODULE_9__lib_util_getPrerollConfigByEdition__["a" /* default */])(edition, prerollConfigEditionMap);
    var prerollContentTypeConfig = contentType ? prerollEditionConfig[contentType] : null;

    if (prerollContentTypeConfig) {
        // Use defaults from contentType match
        intervals = prerollContentTypeConfig.intervals;
        if (intervals && intervals.default) {
            defaultInterval = intervals.default;
        }

        // Merge initial config with new contentType config
        exportedConfig.contentType = content.type;
        exportedConfig = _extends({}, exportedConfig, prerollContentTypeConfig);
    }

    var rate = entitlements.map(function (packageName) {
        return intervals[packageName];
    }).reduce(function (minRate) {
        var packageRate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        return Math.min(minRate, packageRate);
    }, defaultInterval);

    // Add numerical rate and boolean flag to enable/disable preroll
    exportedConfig.calculatedRate = rate;
    exportedConfig.enablePreroll = rate >= 1;

    return exportedConfig;
});

var recommendMobileWebSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_2__appSelector__["p" /* intlAppSelector */], function (intlApp) {
    return intlApp && Object(__WEBPACK_IMPORTED_MODULE_8__lib_util_getAndroidVersionFromUserAgent__["a" /* default */])() < 5.0;
});

var dssPlayerMutedSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_5__bootstrapSelector__["a" /* default */], function (_ref9) {
    var _ref9$syndicatedPlaye = _ref9.syndicatedPlayer;
    _ref9$syndicatedPlaye = _ref9$syndicatedPlaye === undefined ? {} : _ref9$syndicatedPlaye;
    var _ref9$syndicatedPlaye2 = _ref9$syndicatedPlaye.dssPlayer;
    _ref9$syndicatedPlaye2 = _ref9$syndicatedPlaye2 === undefined ? {} : _ref9$syndicatedPlaye2;
    var muted = _ref9$syndicatedPlaye2.muted;
    return muted;
});

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(4);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(14);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./app/enums.js
var enums = __webpack_require__(1);

// EXTERNAL MODULE: ./node_modules/react-router/lib/index.js
var lib = __webpack_require__(85);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./app/common/injectIntl.js
var injectIntl = __webpack_require__(20);

// EXTERNAL MODULE: ./app/common/actions/apiAction.js
var apiAction = __webpack_require__(55);

// CONCATENATED MODULE: ./app/common/Tag.js
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();






var Tag_Tag = function Tag(_ref) {
    var content = _ref.content,
        formatMessage = _ref.intl.formatMessage,
        messages = _ref.messages,
        userIsBlackedOut = _ref.userIsBlackedOut;
    var status = content.status,
        streams = content.streams,
        type = content.type;


    var classes = classnames_default()('search__results__bug', { 'search__results__bug--live': status === enums["n" /* ContentStatus */].LIVE }, { 'search__results__bug--blackout': userIsBlackedOut });

    var tagContent = null;

    if (userIsBlackedOut) {
        tagContent = formatMessage(messages.blackout).toUpperCase();
    } else if (type === enums["o" /* ContentType */].VOD) {
        tagContent = streams[0].duration;
    } else {
        tagContent = status.toUpperCase();
    }

    return _jsx('span', {
        className: classes
    }, void 0, tagContent);
};

/* harmony default export */ var common_Tag = (Object(injectIntl["a" /* default */])(Tag_Tag));
// EXTERNAL MODULE: ./app/webapp/lib/format/index.js
var format = __webpack_require__(151);

// EXTERNAL MODULE: ./app/webapp/common/playable.js + 2 modules
var playable = __webpack_require__(64);

// CONCATENATED MODULE: ./app/common/search/SuggestionItem.js
var SuggestionItem__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var liStyle = {
    textAlign: 'left',
    position: 'relative'
};

var SuggestionItem_SuggestionItem = function (_Component) {
    _inherits(SuggestionItem, _Component);

    function SuggestionItem(props) {
        _classCallCheck(this, SuggestionItem);

        var _this = _possibleConstructorReturn(this, (SuggestionItem.__proto__ || Object.getPrototypeOf(SuggestionItem)).call(this, props));

        _this.handleSuggestionOnClick = _this.handleSuggestionOnClick.bind(_this);
        _this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
        return _this;
    }

    _createClass(SuggestionItem, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _props = this.props,
                enterPressed = _props.enterPressed,
                isSelected = _props.isSelected;

            if (nextProps.enterPressed && enterPressed !== nextProps.enterPressed && isSelected) {
                this.handleSuggestionOnClick();
            }
        }
    }, {
        key: 'handleMouseEnter',
        value: function handleMouseEnter() {
            this.props.handleItemEnter(this.props.index);
        }
    }, {
        key: 'isUserBlackedOut',
        value: function isUserBlackedOut() {
            var _props$content = this.props.content;
            _props$content = _props$content === undefined ? {} : _props$content;
            var _props$content$stream = _props$content.streams,
                streams = _props$content$stream === undefined ? [] : _props$content$stream;

            // do not label the content as `blackout` unless all the streams are blacked out

            if (streams.length && streams.every(function (stream) {
                return !!stream.blackoutText;
            })) {
                return true;
            }
            return false;
        }
    }, {
        key: 'handleSuggestionOnClick',
        value: function handleSuggestionOnClick() {
            this.props.handleClick(this.props.content);
            this.props.clickHandler();
        }

        // const SuggestionItem = ({ content, handleClick, hideKey, pageType, isSelected }) => {

    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                content = _props2.content,
                pageType = _props2.pageType,
                isSelected = _props2.isSelected,
                handleItemLeave = _props2.handleItemLeave;

            var formattedSubtitle = Object(format["a" /* contentSubtitle */])(content);
            var subtitleEl = formattedSubtitle ? SuggestionItem__jsx('span', {}, void 0, formattedSubtitle) : null;
            var userIsBlackedOut = this.isUserBlackedOut();

            var status = '';
            var tag = void 0;
            var metaDataClass = void 0;
            var type = content.type;

            switch (type) {
                case enums["o" /* ContentType */].LISTING:
                    status = content.status;
                    tag = SuggestionItem__jsx(common_Tag, {
                        content: content,
                        pageType: pageType,
                        userIsBlackedOut: userIsBlackedOut
                    });
                    metaDataClass = classnames_default()('collection_item_meta', 'icon-font-before', {
                        'icon-lock-solid-before': content.isLocked
                    });
                    break;
                case enums["o" /* ContentType */].TERM:
                    break;
                case enums["o" /* ContentType */].VOD:
                    tag = SuggestionItem__jsx(common_Tag, {
                        content: content,
                        pageType: pageType
                    });
                    break;
                default:
                    break;
            }
            var liClass = classnames_default()('search_results__item', { focused: isSelected });

            return SuggestionItem__jsx('li', {
                value: content.name,
                type: type,
                'data-status': status,
                id: content.id,
                onClick: !userIsBlackedOut && this.handleSuggestionOnClick,
                onMouseEnter: !userIsBlackedOut && this.handleMouseEnter,
                onMouseLeave: !userIsBlackedOut && handleItemLeave,
                className: liClass,
                style: liStyle
            }, void 0, SuggestionItem__jsx('div', {}, void 0, SuggestionItem__jsx('a', {
                className: 'search_results__link'
            }, void 0, SuggestionItem__jsx('div', {
                className: 'search__results__linkContent'
            }, void 0, SuggestionItem__jsx('span', {
                className: 'search_results__keyword'
            }, void 0, content.name), SuggestionItem__jsx('div', {
                className: metaDataClass
            }, void 0, SuggestionItem__jsx('div', {
                className: 'collection_item_truncate'
            }, void 0, subtitleEl))), tag)));
        }
    }]);

    return SuggestionItem;
}(react["Component"]);

/* harmony default export */ var search_SuggestionItem = (Object(playable["a" /* default */])(SuggestionItem_SuggestionItem));
// CONCATENATED MODULE: ./app/common/search/SearchSuggestionGroup.js
var SearchSuggestionGroup__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();





var SearchSuggestionGroup_SearchSuggestionGroup = function SearchSuggestionGroup(_ref) {
    var suggestion = _ref.suggestion,
        handleClick = _ref.handleClick,
        pageType = _ref.pageType,
        offset = _ref.offset,
        selectedIndex = _ref.selectedIndex,
        handleItemEnter = _ref.handleItemEnter,
        handleItemLeave = _ref.handleItemLeave,
        enterPressed = _ref.enterPressed;
    var name = suggestion.name,
        type = suggestion.type,
        contents = suggestion.contents;

    var suggestionHeader = type !== 'terms' ? SearchSuggestionGroup__jsx('div', {
        className: 'search_results__header'
    }, void 0, name) : null;
    var classNames = type !== 'terms' ? 'search_results__suggestions search_results__suggestions--cat' : 'search_results__autocomplete';
    var suggestionText = contents.map(function (content, index) {
        return SearchSuggestionGroup__jsx(search_SuggestionItem, {
            content: content,
            handleClick: handleClick,
            isSelected: offset + index === selectedIndex,
            handleItemEnter: handleItemEnter,
            handleItemLeave: handleItemLeave,
            index: offset + index,
            pageType: pageType,
            enterPressed: enterPressed
        });
    });
    return SearchSuggestionGroup__jsx('div', {}, void 0, suggestionHeader, SearchSuggestionGroup__jsx('ul', {
        className: classNames
    }, void 0, suggestionText));
};

/* harmony default export */ var search_SearchSuggestionGroup = (SearchSuggestionGroup_SearchSuggestionGroup);
// EXTERNAL MODULE: ./app/common/selectors/pageSelector.js
var pageSelector = __webpack_require__(13);

// EXTERNAL MODULE: ./app/common/selectors/appSelector.js + 1 modules
var appSelector = __webpack_require__(3);

// EXTERNAL MODULE: ./app/lib/omniture/index.js
var omniture = __webpack_require__(34);

// CONCATENATED MODULE: ./app/common/search/SearchContainer.js
var SearchContainer__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var SearchContainer__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function SearchContainer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SearchContainer__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SearchContainer__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var SearchContainer_SearchComponent = function (_Component) {
    SearchContainer__inherits(SearchComponent, _Component);

    function SearchComponent(props) {
        SearchContainer__classCallCheck(this, SearchComponent);

        var _this = SearchContainer__possibleConstructorReturn(this, (SearchComponent.__proto__ || Object.getPrototypeOf(SearchComponent)).call(this, props));

        _this.handleSearchSubmit = _this.handleSearchSubmit.bind(_this);
        _this.handleSearchTermChange = _this.handleSearchTermChange.bind(_this);
        _this.handleInputOnBlur = _this.handleInputOnBlur.bind(_this);
        _this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
        _this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
        _this.handleArrowKeyDown = _this.handleArrowKeyDown.bind(_this);
        _this.handleSuggestionSelected = _this.handleSuggestionSelected.bind(_this);
        _this.routeToSearchTerm = _this.routeToSearchTerm.bind(_this);
        _this.setStateSearchTerm = _this.setStateSearchTerm.bind(_this);
        _this.handleFooterClick = _this.handleFooterClick.bind(_this);
        _this.handleMouseEnterItem = _this.handleMouseEnterItem.bind(_this);
        _this.handleMouseLeaveItem = _this.handleMouseLeaveItem.bind(_this);

        _this.state = {
            searchTerm: '',
            userEnteredText: '',
            suggestionBuckets: [],
            canCollapse: true,
            displaySuggestions: false,
            selectedIndex: -1,
            suggestionCount: 0,
            enterPressed: false,
            showFooter: true
        };
        return _this;
    }

    SearchContainer__createClass(SearchComponent, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            document.addEventListener('keydown', this.handleArrowKeyDown);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('keydown', this.handleArrowKeyDown);
        }
    }, {
        key: 'setStateSearchTerm',
        value: function setStateSearchTerm(term) {
            this.setState({ searchTerm: term, suggestionBuckets: [], displaySuggestions: false });
        }
    }, {
        key: 'handleSuggestionSelected',
        value: function handleSuggestionSelected(_ref) {
            var type = _ref.type,
                name = _ref.name,
                status = _ref.status;
            var enterPressed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var _props = this.props,
                pageType = _props.pageType,
                entitlementsTracking = _props.entitlementsTracking;

            var fromHero = pageType !== enums["y" /* PageType */].SEARCH;
            if (type === enums["o" /* ContentType */].VOD || type === enums["o" /* ContentType */].LISTING && (status === enums["n" /* ContentStatus */].REPLAY || status === enums["n" /* ContentStatus */].LIVE)) {
                var placement = pageType === enums["y" /* PageType */].SEARCH ? 'search-page' : 'search-hero';
                Object(omniture["q" /* trackSearch */])({
                    type: type,
                    status: status,
                    isSuggestion: true,
                    fromHero: fromHero,
                    searchTerm: name,
                    entitlementsTracking: entitlementsTracking
                });
                this.setState({ placement: placement, userInitiated: true, enterPressed: enterPressed });
                return;
            }
            Object(omniture["q" /* trackSearch */])({
                isSuggestion: true,
                fromHero: fromHero,
                searchTerm: name,
                entitlementsTracking: entitlementsTracking
            });
            this.routeToSearchTerm(name);
        }
    }, {
        key: 'handleMouseEnter',
        value: function handleMouseEnter() {
            this.setState({ canCollapse: false });
        }
    }, {
        key: 'handleMouseLeave',
        value: function handleMouseLeave() {
            this.setState({ canCollapse: true });
        }
    }, {
        key: 'handleFooterClick',
        value: function handleFooterClick() {
            var searchTerm = this.state.userEnteredText;
            Object(omniture["q" /* trackSearch */])({
                isSuggestion: true,
                fromHero: this.props.pageType !== enums["y" /* PageType */].SEARCH,
                searchTerm: searchTerm,
                isViewAllResults: true,
                entitlementsTracking: this.props.entitlementsTracking
            });
            this.routeToSearchTerm(searchTerm);
        }
    }, {
        key: 'handleMouseEnterItem',
        value: function handleMouseEnterItem(index) {
            this.setState({ searchTerm: this.state.userEnteredText, selectedIndex: index });
        }
    }, {
        key: 'handleMouseLeaveItem',
        value: function handleMouseLeaveItem() {
            this.setState({ selectedIndex: -1 });
        }
    }, {
        key: 'routeToSearchTerm',
        value: function routeToSearchTerm(term) {
            this.setStateSearchTerm(term);
            if (this.props.pageType === enums["y" /* PageType */].SID) {
                this.props.router.push('/sid/' + encodeURIComponent(term));
            } else {
                this.props.router.push('/search/' + encodeURIComponent(term));
            }
        }
    }, {
        key: 'handleSearchSubmit',
        value: function handleSearchSubmit(event) {
            event.preventDefault();
            if (this.state.selectedIndex !== -1) {
                var contents = this.state.suggestionBuckets.map(function (suggestion) {
                    return suggestion.contents;
                }).reduce(function (cur, result) {
                    return [].concat(_toConsumableArray(cur), _toConsumableArray(result));
                }, []);
                var content = contents[this.state.selectedIndex];
                this.handleSuggestionSelected(content, true);
                return;
            }
            if (this.state.searchTerm) {
                Object(omniture["q" /* trackSearch */])({
                    fromHero: this.props.pageType !== enums["y" /* PageType */].SEARCH,
                    searchTerm: this.state.searchTerm,
                    entitlementsTracking: this.props.entitlementsTracking
                });
                this.routeToSearchTerm(this.state.searchTerm);
            }
        }
    }, {
        key: 'handleArrowKeyDown',
        value: function handleArrowKeyDown(event) {
            var keyCode = event.keyCode;

            if (!this.state.displaySuggestions || keyCode !== 38 && keyCode !== 40) {
                return;
            }
            event.preventDefault();
            var contents = this.state.suggestionBuckets.map(function (suggestion) {
                return suggestion.contents;
            }).reduce(function (cur, result) {
                return [].concat(_toConsumableArray(cur), _toConsumableArray(result));
            }, []);
            // 38 is UP
            if (keyCode === 38) {
                var newIndex = Math.max(this.state.selectedIndex - 1, 0);
                var content = contents[newIndex];
                this.setState({ selectedIndex: newIndex, searchTerm: content.suggestion });
            } else if (keyCode === 40) {
                var _newIndex = Math.min(this.state.suggestionCount - 1, this.state.selectedIndex + 1);
                var _content = contents[_newIndex];
                this.setState({ selectedIndex: _newIndex, searchTerm: _content.suggestion });
            }
        }
    }, {
        key: 'handleSearchTermChange',
        value: function handleSearchTermChange(event) {
            var _this2 = this;

            var searchTermQuery = event.target.value;
            // Updating the searchTerm to be used while searching by pressing 'enter' key,
            // and resetting suggestions to 0 for rendering
            // if somebody backspacspaces in the textbox
            this.setState({ userEnteredText: searchTermQuery, searchTerm: searchTermQuery, selectedIndex: -1 });

            // Suggestions are only returned when the query is 3 char or more long
            if (this.props.pageType === enums["y" /* PageType */].SID) {
                var typeAhead = this.props.typeAhead;
                var teamSearchQuery = searchTermQuery.toLowerCase();
                var contents = typeAhead.filter(function (term) {
                    return term.toLowerCase().indexOf(teamSearchQuery) !== -1;
                }).map(function (term, index) {
                    return { name: term, id: index };
                });
                var sugBuckets = [{ name: 'Teams', type: 'terms', contents: contents }];
                this.setState({ suggestionBuckets: sugBuckets, displaySuggestions: true, suggestionCount: typeAhead.length });
            } else if (searchTermQuery.length > 2) {
                var _props2 = this.props,
                    dispatch = _props2.dispatch,
                    apiEnv = _props2.apiEnv;

                dispatch(Object(apiAction["i" /* getSearchResults */])(searchTermQuery, apiEnv, apiAction["a" /* SEARCH_TYPES */].suggest)).then(function (_ref2) {
                    var _ref2$page$buckets = _ref2.page.buckets,
                        buckets = _ref2$page$buckets === undefined ? [] : _ref2$page$buckets;

                    var count = buckets.reduce(function (sum, bucket) {
                        return sum + bucket.contents.length;
                    }, 0);
                    _this2.setState({ suggestionBuckets: buckets, displaySuggestions: true, suggestionCount: count });
                }).catch(function () {});
            } else {
                this.setState({ displaySuggestions: false, suggestionBuckets: [] });
            }
        }
    }, {
        key: 'handleInputOnBlur',
        value: function handleInputOnBlur() {
            if (this.state.canCollapse) {
                this.setState({ displaySuggestions: false });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props3 = this.props,
                enabled = _props3.enabled,
                messages = _props3.messages,
                formatMessage = _props3.intl.formatMessage,
                pageType = _props3.pageType;

            var searchClasses = classnames_default()('search-section', 'icon-font-before', 'icon-search-solid-before');
            var style = pageType === enums["y" /* PageType */].SEARCH ? { width: '100%', margin: '0 auto 16px' } : { width: '100%', margin: '0 auto' };
            var suggestions = this.state.suggestionBuckets;
            var offset = 0;
            var suggestionElements = suggestions.map(function (suggestion) {
                var element = SearchContainer__jsx(search_SearchSuggestionGroup, {
                    offset: offset,
                    selectedIndex: _this3.state.selectedIndex,
                    suggestion: suggestion,
                    handleClick: _this3.handleSuggestionSelected,
                    handleItemEnter: _this3.handleMouseEnterItem,
                    handleItemLeave: _this3.handleMouseLeaveItem,
                    pageType: pageType,
                    enterPressed: _this3.state.enterPressed
                }, suggestion.name);
                offset += suggestion.contents.length;
                return element;
            });
            var footer = this.props.showFooter ? SearchContainer__jsx('footer', {}, void 0, SearchContainer__jsx('a', {
                onClick: this.handleFooterClick
            }, void 0, 'View All Results for ', this.state.userEnteredText)) : null;
            var suggestionsNode = this.state.displaySuggestions ? SearchContainer__jsx('div', {
                className: 'search_results search_results--active'
            }, void 0, SearchContainer__jsx('div', {
                className: 'search_results__wrapper'
            }, void 0, suggestionElements), footer) : null;

            return enabled ? SearchContainer__jsx('section', {
                style: style,
                onMouseEnter: this.handleMouseEnter,
                onMouseLeave: this.handleMouseLeave,
                className: searchClasses
            }, void 0, SearchContainer__jsx('form', {
                onSubmit: this.handleSearchSubmit
            }, void 0, SearchContainer__jsx('input', {
                type: 'text',
                autoComplete: 'off',
                placeholder: formatMessage(messages['search.placeholder']),
                name: 'search-section',
                value: this.state.searchTerm,
                onChange: this.handleSearchTermChange,
                onBlur: this.handleInputOnBlur
            })), suggestionsNode) : null;
        }
    }]);

    return SearchComponent;
}(react["Component"]);

SearchContainer_SearchComponent.defaultProps = {
    enabled: false,
    typeAhead: [],
    showFooter: true
};

var SearchContainer_mapStateToProps = function mapStateToProps(state) {
    return {
        apiEnv: Object(appSelector["c" /* apiEnvSelector */])(state),
        typeAhead: Object(pageSelector["b" /* competitorSelector */])(state)
    };
};

/* harmony default export */ var SearchContainer = __webpack_exports__["a"] = (Object(lib["withRouter"])(Object(injectIntl["a" /* default */])(Object(es["b" /* connect */])(SearchContainer_mapStateToProps)(SearchContainer_SearchComponent))));

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(4);

// EXTERNAL MODULE: ./app/common/actions/appActions.js
var appActions = __webpack_require__(19);

// EXTERNAL MODULE: ./node_modules/react-modal/lib/index.js
var lib = __webpack_require__(364);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(14);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./app/enums.js
var enums = __webpack_require__(1);

// CONCATENATED MODULE: ./app/webapp/modal/messaging/PopUpBlockerWarning.js
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var PopupBlockerWarning = function PopupBlockerWarning() {
    return _jsx('div', {}, void 0, _jsx('p', {}, void 0, 'It appears you have a pop-up blocker on that kept the video player from launching.'), _jsx('p', {}, void 0, 'Please allow pop-ups from www.espn.com in your browser settings or contact Customer Care at 888-549-ESPN if you need assistance.'));
};

/* harmony default export */ var PopUpBlockerWarning = (PopupBlockerWarning);
// CONCATENATED MODULE: ./app/webapp/modal/messaging/FlashWarning.js
var FlashWarning__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var FlashWarning = function FlashWarning() {
    return FlashWarning__jsx('div', {}, void 0, FlashWarning__jsx('h2', {
        style: { color: 'black' }
    }, void 0, 'Insufficient Flash Player Requirements'), FlashWarning__jsx('div', {
        className: 'clr'
    }), FlashWarning__jsx('div', {}, void 0, FlashWarning__jsx('p', {}, void 0, 'Click below to download the latest version of Flash'), FlashWarning__jsx('p', {}, void 0, FlashWarning__jsx('a', {
        target: '_blank',
        rel: 'noopener noreferrer',
        href: 'http://get.adobe.com/flashplayer/'
    }, void 0, FlashWarning__jsx('img', {
        style: { display: 'block', marginLeft: 'auto', marginRight: 'auto', paddingTop: '10px' },
        alt: 'Get Adobe Flash Player',
        src: 'http://a.espncdn.com/espn3/images/watchespn/get_adobe_flash_player.png'
    })))));
};

/* harmony default export */ var messaging_FlashWarning = (FlashWarning);
// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__(16);
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// CONCATENATED MODULE: ./app/webapp/modal/messaging/BlackoutMap.js
var BlackoutMap__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var secureCdnHost = config_default.a.secureCdnHost;


var fallbackUrl = secureCdnHost + '/espn3/images/watchespn/blackout-default-map.png';

var BlackoutMap = function BlackoutMap(props) {
    var content = props.content;
    var fallbackImgStyle = {
        backgroundImage: 'url(' + fallbackUrl + ')',
        height: '315px',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat'
    };
    var mapUrl = secureCdnHost + '/espn3/images/2010/blackout/' + content.id + '.jpg';
    return BlackoutMap__jsx('div', {}, void 0, BlackoutMap__jsx('div', {
        style: fallbackImgStyle
    }, void 0, BlackoutMap__jsx('img', {
        style: { height: '315px' },
        src: mapUrl,
        alt: 'Blackout map'
    })), BlackoutMap__jsx('div', {}, void 0, content.name, ' - ', content.date), BlackoutMap__jsx('div', {
        id: 'blackout-key'
    }, void 0, BlackoutMap__jsx('div', {
        className: 'channel',
        id: 'espn'
    }, void 0, BlackoutMap__jsx('img', {
        src: secureCdnHost + '/espn3/images/watchespn/key_lin_e3_available.png',
        alt: 'Available on ' + content.source
    }), '\xA0Available on ', BlackoutMap__jsx('span', {
        id: 'linOnlyChan'
    }, void 0, content.source)), BlackoutMap__jsx('div', {
        className: 'channel',
        id: 'not-available'
    }, void 0, BlackoutMap__jsx('img', {
        src: secureCdnHost + '/espn3/images/watchespn/key_notavailable.png',
        alt: 'Not available'
    }), '\xA0Not available')));
};

/* harmony default export */ var messaging_BlackoutMap = (BlackoutMap);
// EXTERNAL MODULE: ./app/webapp/common/authenticationAware.js
var authenticationAware = __webpack_require__(224);

// CONCATENATED MODULE: ./app/webapp/modal/messaging/BroadcastPicker.js
var BroadcastPicker__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var BroadcastPicker_BroadcastPicker = function (_Component) {
    _inherits(BroadcastPicker, _Component);

    function BroadcastPicker(props) {
        _classCallCheck(this, BroadcastPicker);

        var _this = _possibleConstructorReturn(this, (BroadcastPicker.__proto__ || Object.getPrototypeOf(BroadcastPicker)).call(this, props));

        _this.getMetadataClass = _this.getMetadataClass.bind(_this);
        _this.renderMetaSource = _this.renderMetaSource.bind(_this);
        _this.renderBlackoutPill = _this.renderBlackoutPill.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }

    _createClass(BroadcastPicker, [{
        key: 'getMetadataClass',
        value: function getMetadataClass() {
            var showLock = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            var baseClass = this.props.baseClass;


            return classnames_default()(baseClass + '__meta', {
                'icon-font-before icon-lock-solid-before': showLock
            });
        }
    }, {
        key: 'handleClick',
        value: function handleClick(stream, event) {
            event.preventDefault();

            var _props = this.props,
                dispatch = _props.dispatch,
                onSelectStreamTracking = _props.onSelectStreamTracking;

            // Avoids the `reselected` return logic when clicking the same stream

            dispatch(Object(appActions["P" /* streamUnSelect */])());
            // In a multiple modal scenario, we need to dispatch a closeModal prior to stream selection
            dispatch(Object(appActions["y" /* closeModalMessage */])());
            stream.feedSwitch = true;
            dispatch(Object(appActions["O" /* streamSelect */])(stream));

            /**
            * onSelectStreamTracking is passed down from authenticationAware HOC component
            * When user selects the stream, onSelectStreamTracking in authenticationAware
            * HOC component got triggered. We need to check onSelectStreamTracking nil
            * value before calling it since if newrelic tracking is turned off in config,
            * onSelectStreamTracking will be passed as null value from HOC component
            */
            if (onSelectStreamTracking !== null) {
                onSelectStreamTracking(stream);
            }
        }
    }, {
        key: 'renderMetaSource',
        value: function renderMetaSource() {
            var stream = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var _stream$source = stream.source;
            _stream$source = _stream$source === undefined ? {} : _stream$source;
            var name = _stream$source.name;


            return name ? BroadcastPicker__jsx('div', {
                className: this.getMetadataClass(stream.isLocked)
            }, void 0, BroadcastPicker__jsx('span', {}, void 0, name)) : null;
        }
    }, {
        key: 'renderBlackoutPill',
        value: function renderBlackoutPill() {
            var stream = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'BLACKOUT';
            // eslint-disable-line class-methods-use-this
            var _stream$blackoutText = stream.blackoutText,
                blackoutText = _stream$blackoutText === undefined ? '' : _stream$blackoutText,
                _stream$status = stream.status,
                status = _stream$status === undefined ? '' : _stream$status;

            var className = classnames_default()('media-duration media-duration--blackout', {
                'media-duration--live': status === 'live'
            });

            return blackoutText && blackoutText !== '' ? BroadcastPicker__jsx('div', {
                className: className
            }, void 0, text) : null;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props2 = this.props,
                content = _props2.content,
                baseClass = _props2.baseClass;
            var _content$streams = content.streams,
                streams = _content$streams === undefined ? [] : _content$streams;


            return streams.length ? BroadcastPicker__jsx('div', {
                className: baseClass + '__wrapper'
            }, void 0, streams.map(function (stream) {
                return BroadcastPicker__jsx('div', {
                    className: baseClass + '__item',
                    onClick: function onClick(event) {
                        return _this2.handleClick(stream, event);
                    }
                }, stream.id, BroadcastPicker__jsx('div', {
                    className: baseClass + '__item__name'
                }, void 0, BroadcastPicker__jsx('h2', {
                    className: baseClass + '__item__text'
                }, void 0, stream.name), _this2.renderBlackoutPill(stream)), _this2.renderMetaSource(stream));
            })) : null;
        }
    }]);

    return BroadcastPicker;
}(react["Component"]);

BroadcastPicker_BroadcastPicker.defaultProps = {
    baseClass: 'watchBroadcast'
};

/* harmony default export */ var messaging_BroadcastPicker = (Object(authenticationAware["a" /* default */])()(BroadcastPicker_BroadcastPicker));
// CONCATENATED MODULE: ./app/webapp/modal/activation/IframeAuth.js
var IframeAuth__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var IframeAuth = function IframeAuth(_ref) {
    var src = _ref.src,
        _ref$width = _ref.width,
        width = _ref$width === undefined ? '100%' : _ref$width,
        _ref$height = _ref.height,
        height = _ref$height === undefined ? '100%' : _ref$height;
    return IframeAuth__jsx('iframe', {
        src: src,
        style: { width: width, height: height }
    });
};

/* harmony default export */ var activation_IframeAuth = (IframeAuth);
// EXTERNAL MODULE: ./app/constants.js
var constants = __webpack_require__(8);

// CONCATENATED MODULE: ./app/webapp/modal/messaging/Paywall.js
var Paywall__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var Paywall_Paywall = function Paywall(props) {
    var src = props.src;

    var content = src && Paywall__jsx('iframe', {
        src: src
    });

    return Paywall__jsx('div', {
        id: constants["a" /* BAM_PAYWALL_IFRAME_ID */],
        style: { width: '100%', height: '100%', overflow: 'auto' }
    }, void 0, content);
};

/* harmony default export */ var messaging_Paywall = (Paywall_Paywall);
// CONCATENATED MODULE: ./app/webapp/modal/messaging/ModalMessaging.js
var ModalMessaging__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();












// empty the modal's default styles
lib_default.a.defaultStyles = {};

// TODO: any way we can sync this with the css value?
var HEADER_HEIGHT = 50;

function getModalContent(type) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _ref = arguments[2];
    var headerHeight = _ref.headerHeight;

    var body = '';
    var title = '';
    var bodyClass = '';
    var modalStyles = {
        height: 500
    };
    var bodyStyles = {
        marginLeft: '5%'
    };
    var titleStyles = {};
    var closeBtnStyles = {};
    var lightboxClass = void 0;
    switch (type) {
        case enums["w" /* ModalType */].POPUP:
            title = 'Pop-up Blocked';
            body = ModalMessaging__jsx(PopUpBlockerWarning, {});
            break;
        case enums["w" /* ModalType */].FLASH:
            title = 'Flash not Enabled';
            body = ModalMessaging__jsx(messaging_FlashWarning, {});
            break;
        case enums["w" /* ModalType */].BLACKOUT_MAP:
            title = 'Blackout Map';
            body = ModalMessaging__jsx(messaging_BlackoutMap, {
                content: data.content
            });
            break;
        case enums["w" /* ModalType */].BROADCAST_PICKER:
            title = 'Choose Broadcast';
            body = ModalMessaging__jsx(messaging_BroadcastPicker, {
                content: data
            });
            bodyClass = 'watchProvider__scroll watchBroadcast__scroll';
            bodyStyles = {};
            lightboxClass = 'watch-broadcast-modal';
            break;
        case enums["w" /* ModalType */].IFRAME_AUTH:
            title = 'Authentication';
            body = ModalMessaging__jsx(activation_IframeAuth, {
                src: data.src
            });
            modalStyles = {
                width: data.width,
                height: data.height + headerHeight,
                marginLeft: -(data.width / 2)
            };
            bodyStyles = {
                width: '100%',
                height: '100%',
                marginTop: -22
            };
            break;
        case enums["w" /* ModalType */].PAYWALL:
            title = 'ESPN+';
            body = ModalMessaging__jsx(messaging_Paywall, {
                src: data.src
            });
            modalStyles = {
                position: 'absolute',
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                width: '100%',
                height: '100%',
                padding: 0,
                margin: 0,
                background: 'rgba(0, 0, 0, 0.7)',
                borderRadius: 0,
                boxShadow: 'none'
            };
            bodyStyles = {
                width: '100%',
                height: '100%',
                margin: 0,
                padding: 0
            };
            titleStyles = {
                display: 'none'
            };
            closeBtnStyles = {
                right: 20,
                top: 20,
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                WebkitBackdropFilter: 'blur(10px)',
                backdropFilter: 'blur(10px)',
                width: 36,
                height: 36,
                borderRadius: 18
            };
            lightboxClass = 'lightbox-paywall';
            break;
        default:
            break;
    }
    return {
        title: title,
        body: body,
        modalStyles: modalStyles,
        bodyStyles: bodyStyles,
        bodyClass: bodyClass,
        titleStyles: titleStyles,
        closeBtnStyles: closeBtnStyles,
        lightboxClass: lightboxClass
    };
}

var ModalMessaging_renderTransparentMask = function renderTransparentMask() {
    var shouldShowModal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var modalType = arguments[1];
    return shouldShowModal && modalType === enums["w" /* ModalType */].BROADCAST_PICKER ? ModalMessaging__jsx('div', {
        className: 'js-feed-item-mask active'
    }) : null;
};

var ModalMessaging_ModalMessaging = function ModalMessaging(_ref2) {
    var showModalMessage = _ref2.showModalMessage,
        closeModal = _ref2.closeModal,
        messageType = _ref2.messageType,
        messageData = _ref2.messageData;

    var _getModalContent = getModalContent(messageType, messageData, { headerHeight: HEADER_HEIGHT }),
        title = _getModalContent.title,
        body = _getModalContent.body,
        modalStyles = _getModalContent.modalStyles,
        bodyStyles = _getModalContent.bodyStyles,
        bodyClass = _getModalContent.bodyClass,
        titleStyles = _getModalContent.titleStyles,
        closeBtnStyles = _getModalContent.closeBtnStyles,
        lightboxClass = _getModalContent.lightboxClass;

    var containerClass = classnames_default()(lightboxClass, 'lightbox-watch', 'watch-provider-modal', 'js-bloomed');

    return (
        // emulates the same mask used on .com when lightbox is opened
        ModalMessaging__jsx('div', {}, void 0, ModalMessaging_renderTransparentMask(showModalMessage, messageType), ModalMessaging__jsx(lib_default.a, {
            isOpen: showModalMessage,
            onRequestClose: closeModal,
            overlayClassName: 'lightbox-container'
        }, void 0, ModalMessaging__jsx('article', {
            className: containerClass,
            style: modalStyles
        }, void 0, ModalMessaging__jsx('div', {
            className: 'btn-close icon-font-before icon-close-solid-before',
            style: closeBtnStyles,
            onClick: closeModal
        }), ModalMessaging__jsx('section', {
            className: 'watchProvider--modal'
        }, void 0, ModalMessaging__jsx('h1', {
            className: 'watchProvider__title',
            style: titleStyles
        }, void 0, ModalMessaging__jsx('span', {}, void 0, title)), ModalMessaging__jsx('div', {
            style: bodyStyles,
            className: bodyClass
        }, void 0, body)))))
    );
};

ModalMessaging_ModalMessaging.defaultProps = {
    showModalMessage: false,
    messageData: null
};

/* harmony default export */ var messaging_ModalMessaging = (ModalMessaging_ModalMessaging);
// CONCATENATED MODULE: ./app/webapp/modal/messaging/MessagingContainer.js
var MessagingContainer__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var MessagingContainer__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function MessagingContainer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function MessagingContainer__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function MessagingContainer__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var MessagingContainer_MessagingContainer = function (_Component) {
    MessagingContainer__inherits(MessagingContainer, _Component);

    function MessagingContainer(props) {
        MessagingContainer__classCallCheck(this, MessagingContainer);

        var _this = MessagingContainer__possibleConstructorReturn(this, (MessagingContainer.__proto__ || Object.getPrototypeOf(MessagingContainer)).call(this, props));

        _this.closeModal = _this.closeModal.bind(_this);
        return _this;
    }

    MessagingContainer__createClass(MessagingContainer, [{
        key: 'closeModal',
        value: function closeModal() {
            this.props.dispatch(Object(appActions["y" /* closeModalMessage */])());
        }
    }, {
        key: 'render',
        value: function render() {
            return MessagingContainer__jsx(messaging_ModalMessaging, {
                showModalMessage: this.props.showModalMessage,
                closeModal: this.closeModal,
                messageType: this.props.messageType,
                messageData: this.props.messageData
            });
        }
    }]);

    return MessagingContainer;
}(react["Component"]);

var mapStateToProps = function mapStateToProps(state) {
    var _state$app = state.app,
        _state$app$showModalM = _state$app.showModalMessage,
        showModalMessage = _state$app$showModalM === undefined ? false : _state$app$showModalM,
        _state$app$messageTyp = _state$app.messageType,
        messageType = _state$app$messageTyp === undefined ? '' : _state$app$messageTyp,
        _state$app$messageDat = _state$app.messageData,
        messageData = _state$app$messageDat === undefined ? null : _state$app$messageDat;


    return {
        showModalMessage: showModalMessage,
        messageType: messageType,
        messageData: messageData
    };
};

/* harmony default export */ var messaging_MessagingContainer = __webpack_exports__["a"] = (Object(es["b" /* connect */])(mapStateToProps)(MessagingContainer_MessagingContainer));

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {

exports.__esModule = true;
exports.canUseDOM = exports.slidesOnLeft = exports.slidesOnRight = exports.siblingDirection = exports.getTotalSlides = exports.getPostClones = exports.getPreClones = exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = exports.checkSpecKeys = exports.getSlideCount = exports.checkNavigable = exports.getNavigableIndexes = exports.swipeEnd = exports.swipeMove = exports.swipeStart = exports.keyHandler = exports.changeSlide = exports.slideHandler = exports.initializedState = exports.extractObject = exports.canGoNext = exports.getSwipeDirection = exports.getHeight = exports.getWidth = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.lazyStartIndex = exports.getRequiredLazySlides = exports.getOnDemandLazySlides = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(81);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getOnDemandLazySlides = exports.getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
  var onDemandSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);
  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
      onDemandSlides.push(slideIndex);
    }
  }
  return onDemandSlides;
};

// return list of slides that need to be present
var getRequiredLazySlides = exports.getRequiredLazySlides = function getRequiredLazySlides(spec) {
  var requiredSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);
  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    requiredSlides.push(slideIndex);
  }
  return requiredSlides;
};

// startIndex that needs to be present
var lazyStartIndex = exports.lazyStartIndex = function lazyStartIndex(spec) {
  return spec.currentSlide - lazySlidesOnLeft(spec);
};
var lazyEndIndex = exports.lazyEndIndex = function lazyEndIndex(spec) {
  return spec.currentSlide + lazySlidesOnRight(spec);
};
var lazySlidesOnLeft = exports.lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};
var lazySlidesOnRight = exports.lazySlidesOnRight = function lazySlidesOnRight(spec) {
  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
};

// get width of an element
var getWidth = exports.getWidth = function getWidth(elem) {
  return elem && elem.offsetWidth || 0;
};
var getHeight = exports.getHeight = function getHeight(elem) {
  return elem && elem.offsetHeight || 0;
};
var getSwipeDirection = exports.getSwipeDirection = function getSwipeDirection(touchObject) {
  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var xDist, yDist, r, swipeAngle;
  xDist = touchObject.startX - touchObject.curX;
  yDist = touchObject.startY - touchObject.curY;
  r = Math.atan2(yDist, xDist);
  swipeAngle = Math.round(r * 180 / Math.PI);
  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }
  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
    return "left";
  }
  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return "right";
  }
  if (verticalSwiping === true) {
    if (swipeAngle >= 35 && swipeAngle <= 135) {
      return "up";
    } else {
      return "down";
    }
  }

  return "vertical";
};

// whether or not we can go next
var canGoNext = exports.canGoNext = function canGoNext(spec) {
  var canGo = true;
  if (!spec.infinite) {
    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
      canGo = false;
    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
      canGo = false;
    }
  }
  return canGo;
};

// given an object and a list of keys, return new object with given keys
var extractObject = exports.extractObject = function extractObject(spec, keys) {
  var newObject = {};
  keys.forEach(function (key) {
    return newObject[key] = spec[key];
  });
  return newObject;
};

// get initialized state
var initializedState = exports.initializedState = function initializedState(spec) {
  // spec also contains listRef, trackRef
  var slideCount = _react2.default.Children.count(spec.children);
  var listWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.listRef)));
  var trackWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.trackRef)));
  var slideWidth = void 0;
  if (!spec.vertical) {
    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
      centerPaddingAdj *= listWidth / 100;
    }
    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
  } else {
    slideWidth = listWidth;
  }
  var slideHeight = _reactDom2.default.findDOMNode(spec.listRef) && getHeight(_reactDom2.default.findDOMNode(spec.listRef).querySelector('[data-index="0"]'));
  var listHeight = slideHeight * spec.slidesToShow;
  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
  if (spec.rtl && spec.currentSlide === undefined) {
    currentSlide = slideCount - 1 - spec.initialSlide;
  }
  var lazyLoadedList = spec.lazyLoadedList || [];
  var slidesToLoad = getOnDemandLazySlides({ currentSlide: currentSlide, lazyLoadedList: lazyLoadedList }, spec);
  lazyLoadedList.concat(slidesToLoad);

  var state = {
    slideCount: slideCount,
    slideWidth: slideWidth,
    listWidth: listWidth,
    trackWidth: trackWidth,
    currentSlide: currentSlide,
    slideHeight: slideHeight,
    listHeight: listHeight,
    lazyLoadedList: lazyLoadedList
  };

  if (spec.autoplaying === null && spec.autoplay) {
    state["autoplaying"] = "playing";
  }

  return state;
};

var slideHandler = exports.slideHandler = function slideHandler(spec) {
  var waitForAnimate = spec.waitForAnimate,
      animating = spec.animating,
      fade = spec.fade,
      infinite = spec.infinite,
      index = spec.index,
      slideCount = spec.slideCount,
      lazyLoadedList = spec.lazyLoadedList,
      lazyLoad = spec.lazyLoad,
      currentSlide = spec.currentSlide,
      centerMode = spec.centerMode,
      slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      useCSS = spec.useCSS;

  if (waitForAnimate && animating) return {};
  var animationSlide = index,
      finalSlide = void 0,
      animationLeft = void 0,
      finalLeft = void 0;
  var state = {},
      nextState = {};
  if (fade) {
    if (!infinite && (index < 0 || index >= slideCount)) return {};
    if (index < 0) {
      animationSlide = index + slideCount;
    } else if (index >= slideCount) {
      animationSlide = index - slideCount;
    }
    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
      lazyLoadedList.push(animationSlide);
    }
    state = {
      animating: true,
      currentSlide: animationSlide,
      lazyLoadedList: lazyLoadedList
    };
    nextState = { animating: false };
  } else {
    finalSlide = animationSlide;
    if (animationSlide < 0) {
      finalSlide = animationSlide + slideCount;
      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
      animationSlide = finalSlide = currentSlide;
    } else if (centerMode && animationSlide >= slideCount) {
      animationSlide = infinite ? slideCount : slideCount - 1;
      finalSlide = infinite ? 0 : slideCount - 1;
    } else if (animationSlide >= slideCount) {
      finalSlide = animationSlide - slideCount;
      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
    }
    animationLeft = getTrackLeft(_extends({}, spec, { slideIndex: animationSlide }));
    finalLeft = getTrackLeft(_extends({}, spec, { slideIndex: finalSlide }));
    if (!infinite) {
      if (animationLeft === finalLeft) animationSlide = finalSlide;
      animationLeft = finalLeft;
    }
    lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_extends({}, spec, { currentSlide: animationSlide })));
    if (!useCSS) {
      state = {
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
        lazyLoadedList: lazyLoadedList
      };
    } else {
      state = {
        animating: true,
        currentSlide: finalSlide,
        trackStyle: getTrackAnimateCSS(_extends({}, spec, { left: animationLeft })),
        lazyLoadedList: lazyLoadedList
      };
      nextState = {
        animating: false,
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
        swipeLeft: null
      };
    }
  }
  return { state: state, nextState: nextState };
};

var changeSlide = exports.changeSlide = function changeSlide(spec, options) {
  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
  var slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      slideCount = spec.slideCount,
      currentSlide = spec.currentSlide,
      lazyLoad = spec.lazyLoad,
      infinite = spec.infinite;

  unevenOffset = slideCount % slidesToScroll !== 0;
  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

  if (options.message === "previous") {
    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
    targetSlide = currentSlide - slideOffset;
    if (lazyLoad && !infinite) {
      previousInt = currentSlide - slideOffset;
      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
    }
  } else if (options.message === "next") {
    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
    targetSlide = currentSlide + slideOffset;
    if (lazyLoad && !infinite) {
      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
    }
  } else if (options.message === "dots") {
    // Click on dots
    targetSlide = options.index * options.slidesToScroll;
    if (targetSlide === options.currentSlide) {
      return null;
    }
  } else if (options.message === "children") {
    // Click on the slides
    targetSlide = options.index;
    if (targetSlide === options.currentSlide) {
      return null;
    }
    if (infinite) {
      var direction = siblingDirection(_extends({}, spec, { targetSlide: targetSlide }));
      if (targetSlide > options.currentSlide && direction === "left") {
        targetSlide = targetSlide - slideCount;
      } else if (targetSlide < options.currentSlide && direction === "right") {
        targetSlide = targetSlide + slideCount;
      }
    }
  } else if (options.message === "index") {
    targetSlide = Number(options.index);
    if (targetSlide === options.currentSlide) {
      return null;
    }
  }
  return targetSlide;
};
var keyHandler = exports.keyHandler = function keyHandler(e, accessibility, rtl) {
  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
  if (e.keyCode === 37) return rtl ? "next" : "previous";
  if (e.keyCode === 39) return rtl ? "previous" : "next";
  return "";
};

var swipeStart = exports.swipeStart = function swipeStart(e, swipe, draggable) {
  e.target.tagName === "IMG" && e.preventDefault();
  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
  return {
    dragging: true,
    touchObject: {
      startX: e.touches ? e.touches[0].pageX : e.clientX,
      startY: e.touches ? e.touches[0].pageY : e.clientY,
      curX: e.touches ? e.touches[0].pageX : e.clientX,
      curY: e.touches ? e.touches[0].pageY : e.clientY
    }
  };
};
var swipeMove = exports.swipeMove = function swipeMove(e, spec) {
  // spec also contains, trackRef and slideIndex
  var scrolling = spec.scrolling,
      animating = spec.animating,
      vertical = spec.vertical,
      swipeToSlide = spec.swipeToSlide,
      verticalSwiping = spec.verticalSwiping,
      rtl = spec.rtl,
      currentSlide = spec.currentSlide,
      edgeFriction = spec.edgeFriction,
      edgeDragged = spec.edgeDragged,
      onEdge = spec.onEdge,
      swiped = spec.swiped,
      swiping = spec.swiping,
      slideCount = spec.slideCount,
      slidesToScroll = spec.slidesToScroll,
      infinite = spec.infinite,
      touchObject = spec.touchObject,
      swipeEvent = spec.swipeEvent,
      listHeight = spec.listHeight,
      listWidth = spec.listWidth;

  if (scrolling) return;
  if (animating) return e.preventDefault();
  if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
  var swipeLeft = void 0,
      state = {};
  var curLeft = getTrackLeft(spec);
  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
    return { scrolling: true };
  }
  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;

  var dotCount = Math.ceil(slideCount / slidesToScroll);
  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
  var touchSwipeLength = touchObject.swipeLength;
  if (!infinite) {
    if (currentSlide === 0 && swipeDirection === "right" || currentSlide + 1 >= dotCount && swipeDirection === "left" || !canGoNext(spec) && swipeDirection === "left") {
      touchSwipeLength = touchObject.swipeLength * edgeFriction;
      if (edgeDragged === false && onEdge) {
        onEdge(swipeDirection);
        state["edgeDragged"] = true;
      }
    }
  }
  if (!swiped && swipeEvent) {
    swipeEvent(swipeDirection);
    state["swiped"] = true;
  }
  if (!vertical) {
    if (!rtl) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    } else {
      swipeLeft = curLeft - touchSwipeLength * positionOffset;
    }
  } else {
    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
  }
  if (verticalSwiping) {
    swipeLeft = curLeft + touchSwipeLength * positionOffset;
  }
  state = _extends({}, state, {
    touchObject: touchObject,
    swipeLeft: swipeLeft,
    trackStyle: getTrackCSS(_extends({}, spec, { left: swipeLeft }))
  });
  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
    return state;
  }
  if (touchObject.swipeLength > 10) {
    state["swiping"] = true;
    e.preventDefault();
  }
  return state;
};
var swipeEnd = exports.swipeEnd = function swipeEnd(e, spec) {
  var dragging = spec.dragging,
      swipe = spec.swipe,
      touchObject = spec.touchObject,
      listWidth = spec.listWidth,
      touchThreshold = spec.touchThreshold,
      verticalSwiping = spec.verticalSwiping,
      listHeight = spec.listHeight,
      currentSlide = spec.currentSlide,
      swipeToSlide = spec.swipeToSlide,
      scrolling = spec.scrolling,
      onSwipe = spec.onSwipe;

  if (!dragging) {
    if (swipe) e.preventDefault();
    return {};
  }
  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping);
  // reset the state of touch related state variables.
  var state = {
    dragging: false,
    edgeDragged: false,
    scrolling: false,
    swiping: false,
    swiped: false,
    swipeLeft: null,
    touchObject: {}
  };
  if (scrolling) {
    return state;
  }
  if (!touchObject.swipeLength) {
    return state;
  }
  if (touchObject.swipeLength > minSwipe) {
    e.preventDefault();
    if (onSwipe) {
      onSwipe(swipeDirection);
    }
    var slideCount = void 0,
        newSlide = void 0;
    switch (swipeDirection) {
      case "left":
      case "up":
        newSlide = currentSlide + getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 0;
        break;
      case "right":
      case "down":
        newSlide = currentSlide - getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 1;
        break;
      default:
        slideCount = currentSlide;
    }
    state["triggerSlideHandler"] = slideCount;
  } else {
    // Adjust the track back to it's original position.
    var currentLeft = getTrackLeft(spec);
    state["trackStyle"] = getTrackAnimateCSS(_extends({}, spec, { left: currentLeft }));
  }
  return state;
};
var getNavigableIndexes = exports.getNavigableIndexes = function getNavigableIndexes(spec) {
  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
  var indexes = [];
  while (breakpoint < max) {
    indexes.push(breakpoint);
    breakpoint = counter + spec.slidesToScroll;
    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
  }
  return indexes;
};
var checkNavigable = exports.checkNavigable = function checkNavigable(spec, index) {
  var navigables = getNavigableIndexes(spec);
  var prevNavigable = 0;
  if (index > navigables[navigables.length - 1]) {
    index = navigables[navigables.length - 1];
  } else {
    for (var n in navigables) {
      if (index < navigables[n]) {
        index = prevNavigable;
        break;
      }
      prevNavigable = navigables[n];
    }
  }
  return index;
};
var getSlideCount = exports.getSlideCount = function getSlideCount(spec) {
  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
  if (spec.swipeToSlide) {
    var swipedSlide = void 0;
    var slickList = _reactDom2.default.findDOMNode(spec.listRef);
    var slides = slickList.querySelectorAll(".slick-slide");
    Array.from(slides).every(function (slide) {
      if (!spec.vertical) {
        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      } else {
        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      }

      return true;
    });

    if (!swipedSlide) {
      return 0;
    }
    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
    return slidesTraversed;
  } else {
    return spec.slidesToScroll;
  }
};

var checkSpecKeys = exports.checkSpecKeys = function checkSpecKeys(spec, keysArray) {
  return keysArray.reduce(function (value, key) {
    return value && spec.hasOwnProperty(key);
  }, true) ? null : console.error("Keys Missing:", spec);
};

var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var trackWidth = void 0,
      trackHeight = void 0;
  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
  if (!spec.vertical) {
    trackWidth = getTotalSlides(spec) * spec.slideWidth;
  } else {
    trackHeight = trackChildren * spec.slideHeight;
  }
  var style = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };
  if (spec.useTransform) {
    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
    style = _extends({}, style, {
      WebkitTransform: WebkitTransform,
      transform: transform,
      msTransform: msTransform
    });
  } else {
    if (spec.vertical) {
      style["top"] = spec.left;
    } else {
      style["left"] = spec.left;
    }
  }
  if (spec.fade) style = { opacity: 1 };
  if (trackWidth) style.width = trackWidth;
  if (trackHeight) style.height = trackHeight;

  // Fallback for IE8
  if (window && !window.addEventListener && window.attachEvent) {
    if (!spec.vertical) {
      style.marginLeft = spec.left + "px";
    } else {
      style.marginTop = spec.left + "px";
    }
  }

  return style;
};
var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var style = getTrackCSS(spec);
  // useCSS is true by default so it can be undefined
  if (spec.useTransform) {
    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
  } else {
    if (spec.vertical) {
      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    } else {
      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    }
  }
  return style;
};
var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {
  if (spec.unslick) {
    return 0;
  }

  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);

  var slideIndex = spec.slideIndex,
      trackRef = spec.trackRef,
      infinite = spec.infinite,
      centerMode = spec.centerMode,
      slideCount = spec.slideCount,
      slidesToShow = spec.slidesToShow,
      slidesToScroll = spec.slidesToScroll,
      slideWidth = spec.slideWidth,
      listWidth = spec.listWidth,
      variableWidth = spec.variableWidth,
      slideHeight = spec.slideHeight,
      fade = spec.fade,
      vertical = spec.vertical;


  var slideOffset = 0;
  var targetLeft;
  var targetSlide;
  var verticalOffset = 0;

  if (fade || spec.slideCount === 1) {
    return 0;
  }

  var slidesToOffset = 0;
  if (infinite) {
    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
    }
    // shift current slide to center of the frame
    if (centerMode) {
      slidesToOffset += parseInt(slidesToShow / 2);
    }
  } else {
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
    }
    if (centerMode) {
      slidesToOffset = parseInt(slidesToShow / 2);
    }
  }
  slideOffset = slidesToOffset * slideWidth;
  verticalOffset = slidesToOffset * slideHeight;

  if (!vertical) {
    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
  } else {
    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
  }

  if (variableWidth === true) {
    var targetSlideIndex;
    var trackElem = _reactDom2.default.findDOMNode(trackRef);
    targetSlideIndex = slideIndex + getPreClones(spec);
    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
    if (centerMode === true) {
      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
      targetSlide = trackElem && trackElem.children[targetSlideIndex];
      targetLeft = 0;
      for (var slide = 0; slide < targetSlideIndex; slide++) {
        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
      }
      targetLeft -= parseInt(spec.centerPadding);
      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
    }
  }

  return targetLeft;
};

var getPreClones = exports.getPreClones = function getPreClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }
  if (spec.variableWidth) {
    return spec.slideCount;
  }
  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};

var getPostClones = exports.getPostClones = function getPostClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }
  return spec.slideCount;
};

var getTotalSlides = exports.getTotalSlides = function getTotalSlides(spec) {
  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
};
var siblingDirection = exports.siblingDirection = function siblingDirection(spec) {
  if (spec.targetSlide > spec.currentSlide) {
    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
      return "left";
    }
    return "right";
  } else {
    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
      return "right";
    }
    return "left";
  }
};

var slidesOnRight = exports.slidesOnRight = function slidesOnRight(_ref) {
  var slidesToShow = _ref.slidesToShow,
      centerMode = _ref.centerMode,
      rtl = _ref.rtl,
      centerPadding = _ref.centerPadding;

  // returns no of slides on the right of active slide
  if (centerMode) {
    var right = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) right += 1;
    if (rtl && slidesToShow % 2 === 0) right += 1;
    return right;
  }
  if (rtl) {
    return 0;
  }
  return slidesToShow - 1;
};

var slidesOnLeft = exports.slidesOnLeft = function slidesOnLeft(_ref2) {
  var slidesToShow = _ref2.slidesToShow,
      centerMode = _ref2.centerMode,
      rtl = _ref2.rtl,
      centerPadding = _ref2.centerPadding;

  // returns no of slides on the left of active slide
  if (centerMode) {
    var left = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) left += 1;
    if (!rtl && slidesToShow % 2 === 0) left += 1;
    return left;
  }
  if (rtl) {
    return slidesToShow - 1;
  }
  return 0;
};

var canUseDOM = exports.canUseDOM = function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, console) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
  function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for (var i = 0; i < keys.length; i++) {
      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    }
    return descriptors;
  };

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  if (typeof process !== 'undefined' && process.noDeprecation === true) {
    return fn;
  }

  // Allow for deprecating things in the process of starting up.
  if (typeof process === 'undefined') {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = Object({"NODE_ENV":"production"}).NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(383);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(384);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

exports.promisify = function promisify(original) {
  if (typeof original !== 'function')
    throw new TypeError('The "original" argument must be of type Function');

  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
    var fn = original[kCustomPromisifiedSymbol];
    if (typeof fn !== 'function') {
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    }
    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn, enumerable: false, writable: false, configurable: true
    });
    return fn;
  }

  function fn() {
    var promiseResolve, promiseReject;
    var promise = new Promise(function (resolve, reject) {
      promiseResolve = resolve;
      promiseReject = reject;
    });

    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
    args.push(function (err, value) {
      if (err) {
        promiseReject(err);
      } else {
        promiseResolve(value);
      }
    });

    try {
      original.apply(this, args);
    } catch (err) {
      promiseReject(err);
    }

    return promise;
  }

  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
    value: fn, enumerable: false, writable: false, configurable: true
  });
  return Object.defineProperties(
    fn,
    getOwnPropertyDescriptors(original)
  );
}

exports.promisify.custom = kCustomPromisifiedSymbol

function callbackifyOnRejected(reason, cb) {
  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
  // Because `null` is a special error value in callbacks which means "no error
  // occurred", we error-wrap so the callback consumer can distinguish between
  // "the promise rejected with null" or "the promise fulfilled with undefined".
  if (!reason) {
    var newReason = new Error('Promise was rejected with a falsy value');
    newReason.reason = reason;
    reason = newReason;
  }
  return cb(reason);
}

function callbackify(original) {
  if (typeof original !== 'function') {
    throw new TypeError('The "original" argument must be of type Function');
  }

  // We DO NOT return the promise as it gives the user a false sense that
  // the promise is actually somehow related to the callback's execution
  // and that the callback throwing will reject the promise.
  function callbackified() {
    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }

    var maybeCb = args.pop();
    if (typeof maybeCb !== 'function') {
      throw new TypeError('The last argument must be of type Function');
    }
    var self = this;
    var cb = function() {
      return maybeCb.apply(self, arguments);
    };
    // In true node style we process the callback on `nextTick` with all the
    // implications (stack, `uncaughtException`, `async_hooks`)
    original.apply(this, args)
      .then(function(ret) { process.nextTick(cb, null, ret) },
            function(rej) { process.nextTick(callbackifyOnRejected, rej, cb) });
  }

  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
  Object.defineProperties(callbackified,
                          getOwnPropertyDescriptors(original));
  return callbackified;
}
exports.callbackify = callbackify;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48), __webpack_require__(2)))

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(79);

var ReactNoopUpdateQueue = __webpack_require__(159);

var canDefineProperty = __webpack_require__(226);
var emptyObject = __webpack_require__(99);
var invariant = __webpack_require__(5);
var warning = __webpack_require__(6);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

module.exports = ReactComponent;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var warning = __webpack_require__(6);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(7);

var invariant = __webpack_require__(5);

/**
 * Injectable ordering of event plugins.
 */
var eventPluginOrder = null;

/**
 * Injectable mapping from names to event plugin modules.
 */
var namesToPlugins = {};

/**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */
function recomputePluginOrdering() {
  if (!eventPluginOrder) {
    // Wait until an `eventPluginOrder` is injected.
    return;
  }
  for (var pluginName in namesToPlugins) {
    var pluginModule = namesToPlugins[pluginName];
    var pluginIndex = eventPluginOrder.indexOf(pluginName);
    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
    if (EventPluginRegistry.plugins[pluginIndex]) {
      continue;
    }
    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
    var publishedEvents = pluginModule.eventTypes;
    for (var eventName in publishedEvents) {
      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
    }
  }
}

/**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */
function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
  if (phasedRegistrationNames) {
    for (var phaseName in phasedRegistrationNames) {
      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
        var phasedRegistrationName = phasedRegistrationNames[phaseName];
        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
      }
    }
    return true;
  } else if (dispatchConfig.registrationName) {
    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
    return true;
  }
  return false;
}

/**
 * Publishes a registration name that is used to identify dispatched events and
 * can be used with `EventPluginHub.putListener` to register listeners.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */
function publishRegistrationName(registrationName, pluginModule, eventName) {
  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;

  if (false) {
    var lowerCasedName = registrationName.toLowerCase();
    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;

    if (registrationName === 'onDoubleClick') {
      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
    }
  }
}

/**
 * Registers plugins so that they can extract and dispatch events.
 *
 * @see {EventPluginHub}
 */
var EventPluginRegistry = {

  /**
   * Ordered list of injected plugins.
   */
  plugins: [],

  /**
   * Mapping from event name to dispatch config
   */
  eventNameDispatchConfigs: {},

  /**
   * Mapping from registration name to plugin module
   */
  registrationNameModules: {},

  /**
   * Mapping from registration name to event name
   */
  registrationNameDependencies: {},

  /**
   * Mapping from lowercase registration names to the properly cased version,
   * used to warn in the case of missing event handlers. Available
   * only in __DEV__.
   * @type {Object}
   */
  possibleRegistrationNames:  false ? {} : null,
  // Trust the developer to only use possibleRegistrationNames in __DEV__

  /**
   * Injects an ordering of plugins (by plugin name). This allows the ordering
   * to be decoupled from injection of the actual plugins so that ordering is
   * always deterministic regardless of packaging, on-the-fly injection, etc.
   *
   * @param {array} InjectedEventPluginOrder
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginOrder}
   */
  injectEventPluginOrder: function (injectedEventPluginOrder) {
    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
    // Clone the ordering so it cannot be dynamically mutated.
    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
    recomputePluginOrdering();
  },

  /**
   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
   * in the ordering injected by `injectEventPluginOrder`.
   *
   * Plugins can be injected as part of page initialization or on-the-fly.
   *
   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginsByName}
   */
  injectEventPluginsByName: function (injectedNamesToPlugins) {
    var isOrderingDirty = false;
    for (var pluginName in injectedNamesToPlugins) {
      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
        continue;
      }
      var pluginModule = injectedNamesToPlugins[pluginName];
      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
        namesToPlugins[pluginName] = pluginModule;
        isOrderingDirty = true;
      }
    }
    if (isOrderingDirty) {
      recomputePluginOrdering();
    }
  },

  /**
   * Looks up the plugin for the supplied event.
   *
   * @param {object} event A synthetic event.
   * @return {?object} The plugin that created the supplied event.
   * @internal
   */
  getPluginModuleForEvent: function (event) {
    var dispatchConfig = event.dispatchConfig;
    if (dispatchConfig.registrationName) {
      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
    }
    if (dispatchConfig.phasedRegistrationNames !== undefined) {
      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
      // that it is not undefined.
      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;

      for (var phase in phasedRegistrationNames) {
        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
          continue;
        }
        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
        if (pluginModule) {
          return pluginModule;
        }
      }
    }
    return null;
  },

  /**
   * Exposed for unit testing.
   * @private
   */
  _resetEventPlugins: function () {
    eventPluginOrder = null;
    for (var pluginName in namesToPlugins) {
      if (namesToPlugins.hasOwnProperty(pluginName)) {
        delete namesToPlugins[pluginName];
      }
    }
    EventPluginRegistry.plugins.length = 0;

    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
    for (var eventName in eventNameDispatchConfigs) {
      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
        delete eventNameDispatchConfigs[eventName];
      }
    }

    var registrationNameModules = EventPluginRegistry.registrationNameModules;
    for (var registrationName in registrationNameModules) {
      if (registrationNameModules.hasOwnProperty(registrationName)) {
        delete registrationNameModules[registrationName];
      }
    }

    if (false) {
      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
      for (var lowerCasedName in possibleRegistrationNames) {
        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
          delete possibleRegistrationNames[lowerCasedName];
        }
      }
    }
  }

};

module.exports = EventPluginRegistry;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var ReactErrorUtils = __webpack_require__(162);

var invariant = __webpack_require__(5);
var warning = __webpack_require__(6);

/**
 * Injected dependencies:
 */

/**
 * - `ComponentTree`: [required] Module that can convert between React instances
 *   and actual node references.
 */
var ComponentTree;
var TreeTraversal;
var injection = {
  injectComponentTree: function (Injected) {
    ComponentTree = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
    }
  },
  injectTreeTraversal: function (Injected) {
    TreeTraversal = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
    }
  }
};

function isEndish(topLevelType) {
  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
}

function isMoveish(topLevelType) {
  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
}
function isStartish(topLevelType) {
  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
}

var validateEventDispatches;
if (false) {
  validateEventDispatches = function (event) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchInstances = event._dispatchInstances;

    var listenersIsArr = Array.isArray(dispatchListeners);
    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;

    var instancesIsArr = Array.isArray(dispatchInstances);
    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;

    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
  };
}

/**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @param {function} listener Application-level callback
 * @param {*} inst Internal component instance
 */
function executeDispatch(event, simulated, listener, inst) {
  var type = event.type || 'unknown-event';
  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
  if (simulated) {
    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
  } else {
    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
  }
  event.currentTarget = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches.
 */
function executeDispatchesInOrder(event, simulated) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
    }
  } else if (dispatchListeners) {
    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
  }
  event._dispatchListeners = null;
  event._dispatchInstances = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches, but stops
 * at the first dispatch execution returning true, and returns that id.
 *
 * @return {?string} id of the first dispatch execution who's listener returns
 * true, or null if no listener returned true.
 */
function executeDispatchesInOrderStopAtTrueImpl(event) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      if (dispatchListeners[i](event, dispatchInstances[i])) {
        return dispatchInstances[i];
      }
    }
  } else if (dispatchListeners) {
    if (dispatchListeners(event, dispatchInstances)) {
      return dispatchInstances;
    }
  }
  return null;
}

/**
 * @see executeDispatchesInOrderStopAtTrueImpl
 */
function executeDispatchesInOrderStopAtTrue(event) {
  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
  event._dispatchInstances = null;
  event._dispatchListeners = null;
  return ret;
}

/**
 * Execution of a "direct" dispatch - there must be at most one dispatch
 * accumulated on the event or it is considered an error. It doesn't really make
 * sense for an event with multiple dispatches (bubbled) to keep track of the
 * return values at each dispatch execution, but it does tend to make sense when
 * dealing with "direct" dispatches.
 *
 * @return {*} The return value of executing the single dispatch.
 */
function executeDirectDispatch(event) {
  if (false) {
    validateEventDispatches(event);
  }
  var dispatchListener = event._dispatchListeners;
  var dispatchInstance = event._dispatchInstances;
  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
  var res = dispatchListener ? dispatchListener(event) : null;
  event.currentTarget = null;
  event._dispatchListeners = null;
  event._dispatchInstances = null;
  return res;
}

/**
 * @param {SyntheticEvent} event
 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
 */
function hasDispatches(event) {
  return !!event._dispatchListeners;
}

/**
 * General utilities that are useful in creating custom Event Plugins.
 */
var EventPluginUtils = {
  isEndish: isEndish,
  isMoveish: isMoveish,
  isStartish: isStartish,

  executeDirectDispatch: executeDirectDispatch,
  executeDispatchesInOrder: executeDispatchesInOrder,
  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
  hasDispatches: hasDispatches,

  getInstanceFromNode: function (node) {
    return ComponentTree.getInstanceFromNode(node);
  },
  getNodeFromInstance: function (node) {
    return ComponentTree.getNodeFromInstance(node);
  },
  isAncestor: function (a, b) {
    return TreeTraversal.isAncestor(a, b);
  },
  getLowestCommonAncestor: function (a, b) {
    return TreeTraversal.getLowestCommonAncestor(a, b);
  },
  getParentInstance: function (inst) {
    return TreeTraversal.getParentInstance(inst);
  },
  traverseTwoPhase: function (target, fn, arg) {
    return TreeTraversal.traverseTwoPhase(target, fn, arg);
  },
  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
  },

  injection: injection
};

module.exports = EventPluginUtils;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var caughtError = null;

/**
 * Call a function while guarding against errors that happens within it.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} a First argument
 * @param {*} b Second argument
 */
function invokeGuardedCallback(name, func, a) {
  try {
    func(a);
  } catch (x) {
    if (caughtError === null) {
      caughtError = x;
    }
  }
}

var ReactErrorUtils = {
  invokeGuardedCallback: invokeGuardedCallback,

  /**
   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
   * handler are sure to be rethrown by rethrowCaughtError.
   */
  invokeGuardedCallbackWithCatch: invokeGuardedCallback,

  /**
   * During execution of guarded functions we will capture the first error which
   * we will rethrow to be handled by the top level error handler.
   */
  rethrowCaughtError: function () {
    if (caughtError) {
      var error = caughtError;
      caughtError = null;
      throw error;
    }
  }
};

if (false) {
  /**
   * To help development we can get better devtools integration by simulating a
   * real browser event.
   */
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');
    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
      var boundFunc = func.bind(null, a);
      var evtType = 'react-' + name;
      fakeNode.addEventListener(evtType, boundFunc, false);
      var evt = document.createEvent('Event');
      // $FlowFixMe https://github.com/facebook/flow/issues/2336
      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);
      fakeNode.removeEventListener(evtType, boundFunc, false);
    };
  }
}

module.exports = ReactErrorUtils;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */

function getEventTarget(nativeEvent) {
  var target = nativeEvent.target || nativeEvent.srcElement || window;

  // Normalize SVG <use> element events #4963
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html
  return target.nodeType === 3 ? target.parentNode : target;
}

module.exports = getEventTarget;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(31);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */

var modifierKeyToProp = {
  'Alt': 'altKey',
  'Control': 'ctrlKey',
  'Meta': 'metaKey',
  'Shift': 'shiftKey'
};

// IE8 does not implement getModifierState so we simply map it to the only
// modifier keys exposed by the event itself, does not support Lock-keys.
// Currently, all major browsers except Chrome seems to support Lock-keys.
function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;
  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }
  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}

module.exports = getEventModifierState;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMLazyTree = __webpack_require__(84);
var Danger = __webpack_require__(413);
var ReactDOMComponentTree = __webpack_require__(21);
var ReactInstrumentation = __webpack_require__(38);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(168);
var setInnerHTML = __webpack_require__(120);
var setTextContent = __webpack_require__(238);

function getNodeAfter(parentNode, node) {
  // Special case for text components, which return [open, close] comments
  // from getHostNode.
  if (Array.isArray(node)) {
    node = node[1];
  }
  return node ? node.nextSibling : parentNode.firstChild;
}

/**
 * Inserts `childNode` as a child of `parentNode` at the `index`.
 *
 * @param {DOMElement} parentNode Parent node in which to insert.
 * @param {DOMElement} childNode Child node to insert.
 * @param {number} index Index at which to insert the child.
 * @internal
 */
var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
  // We rely exclusively on `insertBefore(node, null)` instead of also using
  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
  // we are careful to use `null`.)
  parentNode.insertBefore(childNode, referenceNode);
});

function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
}

function moveChild(parentNode, childNode, referenceNode) {
  if (Array.isArray(childNode)) {
    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
  } else {
    insertChildAt(parentNode, childNode, referenceNode);
  }
}

function removeChild(parentNode, childNode) {
  if (Array.isArray(childNode)) {
    var closingComment = childNode[1];
    childNode = childNode[0];
    removeDelimitedText(parentNode, childNode, closingComment);
    parentNode.removeChild(closingComment);
  }
  parentNode.removeChild(childNode);
}

function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
  var node = openingComment;
  while (true) {
    var nextNode = node.nextSibling;
    insertChildAt(parentNode, node, referenceNode);
    if (node === closingComment) {
      break;
    }
    node = nextNode;
  }
}

function removeDelimitedText(parentNode, startNode, closingComment) {
  while (true) {
    var node = startNode.nextSibling;
    if (node === closingComment) {
      // The closing comment is removed by ReactMultiChild.
      break;
    } else {
      parentNode.removeChild(node);
    }
  }
}

function replaceDelimitedText(openingComment, closingComment, stringText) {
  var parentNode = openingComment.parentNode;
  var nodeAfterComment = openingComment.nextSibling;
  if (nodeAfterComment === closingComment) {
    // There are no text nodes between the opening and closing comments; insert
    // a new one if stringText isn't empty.
    if (stringText) {
      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
    }
  } else {
    if (stringText) {
      // Set the text content of the first node after the opening comment, and
      // remove all following nodes up until the closing comment.
      setTextContent(nodeAfterComment, stringText);
      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
    } else {
      removeDelimitedText(parentNode, openingComment, closingComment);
    }
  }

  if (false) {
    ReactInstrumentation.debugTool.onHostOperation({
      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
      type: 'replace text',
      payload: stringText
    });
  }
}

var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
if (false) {
  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
    if (prevInstance._debugID !== 0) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: prevInstance._debugID,
        type: 'replace with',
        payload: markup.toString()
      });
    } else {
      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
      if (nextInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: nextInstance._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  };
}

/**
 * Operations for updating with DOM children.
 */
var DOMChildrenOperations = {

  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,

  replaceDelimitedText: replaceDelimitedText,

  /**
   * Updates a component's children by processing a series of updates. The
   * update configurations are each expected to have a `parentNode` property.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  processUpdates: function (parentNode, updates) {
    if (false) {
      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
    }

    for (var k = 0; k < updates.length; k++) {
      var update = updates[k];
      switch (update.type) {
        case 'INSERT_MARKUP':
          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'insert child',
              payload: { toIndex: update.toIndex, content: update.content.toString() }
            });
          }
          break;
        case 'MOVE_EXISTING':
          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'move child',
              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
            });
          }
          break;
        case 'SET_MARKUP':
          setInnerHTML(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace children',
              payload: update.content.toString()
            });
          }
          break;
        case 'TEXT_CONTENT':
          setTextContent(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace text',
              payload: update.content.toString()
            });
          }
          break;
        case 'REMOVE_NODE':
          removeChild(parentNode, update.fromNode);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'remove child',
              payload: { fromIndex: update.fromIndex }
            });
          }
          break;
      }
    }
  }

};

module.exports = DOMChildrenOperations;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg'
};

module.exports = DOMNamespaces;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* globals MSApp */



/**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */

var createMicrosoftUnsafeLocalFunction = function (func) {
  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
    return function (arg0, arg1, arg2, arg3) {
      MSApp.execUnsafeLocalFunction(function () {
        return func(arg0, arg1, arg2, arg3);
      });
    };
  } else {
    return func;
  }
};

module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var React = __webpack_require__(78);
var ReactPropTypesSecret = __webpack_require__(431);

var invariant = __webpack_require__(5);
var warning = __webpack_require__(6);

var hasReadOnlyValue = {
  'button': true,
  'checkbox': true,
  'image': true,
  'hidden': true,
  'radio': true,
  'reset': true,
  'submit': true
};

function _assertSingleLink(inputProps) {
  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
}
function _assertValueLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
}

function _assertCheckedLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
}

var propTypes = {
  value: function (props, propName, componentName) {
    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  checked: function (props, propName, componentName) {
    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  onChange: React.PropTypes.func
};

var loggedTypeFailures = {};
function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Provide a linked `value` attribute for controlled forms. You should not use
 * this outside of the ReactDOM controlled form components.
 */
var LinkedValueUtils = {
  checkPropTypes: function (tagName, props, owner) {
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
      }
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum(owner);
         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
      }
    }
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current value of the input either from value prop or link.
   */
  getValue: function (inputProps) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.value;
    }
    return inputProps.value;
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current checked status of the input either from checked prop
   *             or link.
   */
  getChecked: function (inputProps) {
    if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.value;
    }
    return inputProps.checked;
  },

  /**
   * @param {object} inputProps Props for form component
   * @param {SyntheticEvent} event change event to handle
   */
  executeOnChange: function (inputProps, event) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.requestChange(event.target.value);
    } else if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.requestChange(event.target.checked);
    } else if (inputProps.onChange) {
      return inputProps.onChange.call(undefined, event);
    }
  }
};

module.exports = LinkedValueUtils;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(7);

var invariant = __webpack_require__(5);

var injected = false;

var ReactComponentEnvironment = {

  /**
   * Optionally injectable hook for swapping out mount images in the middle of
   * the tree.
   */
  replaceNodeWithMarkup: null,

  /**
   * Optionally injectable hook for processing a queue of child updates. Will
   * later move into MultiChildComponents.
   */
  processChildrenUpdates: null,

  injection: {
    injectEnvironment: function (environment) {
      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
      injected = true;
    }
  }

};

module.exports = ReactComponentEnvironment;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Given a `prevElement` and `nextElement`, determines if the existing
 * instance should be updated as opposed to being destroyed or replaced by a new
 * instance. Both arguments are elements. This ensures that this logic can
 * operate on stateless trees without any backing instance.
 *
 * @param {?object} prevElement
 * @param {?object} nextElement
 * @return {boolean} True if the existing instance should be updated.
 * @protected
 */

function shouldUpdateReactComponent(prevElement, nextElement) {
  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;
  if (prevEmpty || nextEmpty) {
    return prevEmpty === nextEmpty;
  }

  var prevType = typeof prevElement;
  var nextType = typeof nextElement;
  if (prevType === 'string' || prevType === 'number') {
    return nextType === 'string' || nextType === 'number';
  } else {
    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
  }
}

module.exports = shouldUpdateReactComponent;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var ReactCurrentOwner = __webpack_require__(49);
var ReactInstanceMap = __webpack_require__(103);
var ReactInstrumentation = __webpack_require__(38);
var ReactUpdates = __webpack_require__(40);

var invariant = __webpack_require__(5);
var warning = __webpack_require__(6);

function enqueueUpdate(internalInstance) {
  ReactUpdates.enqueueUpdate(internalInstance);
}

function formatUnexpectedArgument(arg) {
  var type = typeof arg;
  if (type !== 'object') {
    return type;
  }
  var displayName = arg.constructor && arg.constructor.name || type;
  var keys = Object.keys(arg);
  if (keys.length > 0 && keys.length < 20) {
    return displayName + ' (keys: ' + keys.join(', ') + ')';
  }
  return displayName;
}

function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
  var internalInstance = ReactInstanceMap.get(publicInstance);
  if (!internalInstance) {
    if (false) {
      var ctor = publicInstance.constructor;
      // Only warn when we have a callerName. Otherwise we should be silent.
      // We're probably calling from enqueueCallback. We don't want to warn
      // there because we already warned for the corresponding lifecycle method.
      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
    }
    return null;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
  }

  return internalInstance;
}

/**
 * ReactUpdateQueue allows for state updates to be scheduled into a later
 * reconciliation step.
 */
var ReactUpdateQueue = {

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    if (false) {
      var owner = ReactCurrentOwner.current;
      if (owner !== null) {
        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
        owner._warnedAboutRefsInRender = true;
      }
    }
    var internalInstance = ReactInstanceMap.get(publicInstance);
    if (internalInstance) {
      // During componentWillMount and render this will still be null but after
      // that will always render to something. At least for now. So we can use
      // this hack.
      return !!internalInstance._renderedComponent;
    } else {
      return false;
    }
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @param {string} callerName Name of the calling function in the public API.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback, callerName) {
    ReactUpdateQueue.validateCallback(callback, callerName);
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

    // Previously we would throw an error if we didn't have an internal
    // instance. Since we want to make it a no-op instead, we mirror the same
    // behavior we have in other enqueue* methods.
    // We also need to ignore callbacks in componentWillMount. See
    // enqueueUpdates.
    if (!internalInstance) {
      return null;
    }

    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    // TODO: The callback here is ignored when setState is called from
    // componentWillMount. Either fix it or disallow doing so completely in
    // favor of getInitialState. Alternatively, we can disallow
    // componentWillMount during server-side rendering.
    enqueueUpdate(internalInstance);
  },

  enqueueCallbackInternal: function (internalInstance, callback) {
    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    enqueueUpdate(internalInstance);
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingForceUpdate = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingStateQueue = [completeState];
    internalInstance._pendingReplaceState = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    if (false) {
      ReactInstrumentation.debugTool.onSetState();
      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
    }

    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');

    if (!internalInstance) {
      return;
    }

    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
    queue.push(partialState);

    enqueueUpdate(internalInstance);
  },

  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
    internalInstance._pendingElement = nextElement;
    // TODO: introduce _pendingContext instead of setting it directly.
    internalInstance._context = nextContext;
    enqueueUpdate(internalInstance);
  },

  validateCallback: function (callback, callerName) {
    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
  }

};

module.exports = ReactUpdateQueue;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(15);

var emptyFunction = __webpack_require__(37);
var warning = __webpack_require__(6);

var validateDOMNesting = emptyFunction;

if (false) {
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.

  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',

  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
  var buttonScopeTags = inScopeTags.concat(['button']);

  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];

  var emptyAncestorInfo = {
    current: null,

    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,

    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  var updatedAncestorInfo = function (oldInfo, tag, instance) {
    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
    var info = { tag: tag, instance: instance };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }
    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    }

    // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.current = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }
    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }
    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }
    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }
    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }
    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }
    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };

  /**
   * Returns whether
   */
  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';
      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but
      case 'option':
        return tag === '#text';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
      case 'colgroup':
        return tag === 'col' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
      case 'html':
        return tag === 'head' || tag === 'body';
      case '#document':
        return tag === 'html';
    }

    // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'body':
      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frame':
      case 'head':
      case 'html':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };

  /**
   * Returns whether
   */
  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':

      case 'pre':
      case 'listing':

      case 'table':

      case 'hr':

      case 'xmp':

      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  /**
   * Given a ReactCompositeComponent instance, return a list of its recursive
   * owners, starting at the root and ending with the instance itself.
   */
  var findOwnerStack = function (instance) {
    if (!instance) {
      return [];
    }

    var stack = [];
    do {
      stack.push(instance);
    } while (instance = instance._currentElement._owner);
    stack.reverse();
    return stack;
  };

  var didWarn = {};

  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;

    if (childText != null) {
      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
      childTag = '#text';
    }

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var problematic = invalidParent || invalidAncestor;

    if (problematic) {
      var ancestorTag = problematic.tag;
      var ancestorInstance = problematic.instance;

      var childOwner = childInstance && childInstance._currentElement._owner;
      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;

      var childOwners = findOwnerStack(childOwner);
      var ancestorOwners = findOwnerStack(ancestorOwner);

      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
      var i;

      var deepestCommon = -1;
      for (i = 0; i < minStackLen; i++) {
        if (childOwners[i] === ancestorOwners[i]) {
          deepestCommon = i;
        } else {
          break;
        }
      }

      var UNKNOWN = '(unknown)';
      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ownerInfo = [].concat(
      // If the parent and child instances have a common owner ancestor, start
      // with that -- otherwise we just start with the parent's owners.
      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
      // If we're warning about an invalid (non-parent) ancestry, add '...'
      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');

      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
      if (didWarn[warnKey]) {
        return;
      }
      didWarn[warnKey] = true;

      var tagDisplayName = childTag;
      var whitespaceInfo = '';
      if (childTag === '#text') {
        if (/\S/.test(childText)) {
          tagDisplayName = 'Text nodes';
        } else {
          tagDisplayName = 'Whitespace text nodes';
          whitespaceInfo = ' Make sure you don\'t have any extra whitespace between tags on ' + 'each line of your source code.';
        }
      } else {
        tagDisplayName = '<' + childTag + '>';
      }

      if (invalidParent) {
        var info = '';
        if (ancestorTag === 'table' && childTag === 'tr') {
          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
        }
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
      } else {
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
      }
    }
  };

  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;

  // For testing
  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;
    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
  };
}

module.exports = validateDOMNesting;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */

function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode;

    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  }

  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.
  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

module.exports = getEventCharCode;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(475)();
}


/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(478);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/lodash-es/_freeGlobal.js
var _freeGlobal = __webpack_require__(479);

// CONCATENATED MODULE: ./node_modules/lodash-es/_root.js


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ var _root = (root);

// CONCATENATED MODULE: ./node_modules/lodash-es/_Symbol.js


/** Built-in value references. */
var Symbol = _root.Symbol;

/* harmony default export */ var _Symbol = (Symbol);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getRawTag.js


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _getRawTag_hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = _getRawTag_hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ var _getRawTag = (getRawTag);

// CONCATENATED MODULE: ./node_modules/lodash-es/_objectToString.js
/** Used for built-in method references. */
var _objectToString_objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var _objectToString_nativeObjectToString = _objectToString_objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return _objectToString_nativeObjectToString.call(value);
}

/* harmony default export */ var _objectToString = (objectToString);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseGetTag.js




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var _baseGetTag_symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (_baseGetTag_symToStringTag && _baseGetTag_symToStringTag in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

/* harmony default export */ var _baseGetTag = (baseGetTag);

// CONCATENATED MODULE: ./node_modules/lodash-es/_overArg.js
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ var _overArg = (overArg);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getPrototype.js


/** Built-in value references. */
var getPrototype = _overArg(Object.getPrototypeOf, Object);

/* harmony default export */ var _getPrototype = (getPrototype);

// CONCATENATED MODULE: ./node_modules/lodash-es/isObjectLike.js
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ var lodash_es_isObjectLike = (isObjectLike);

// CONCATENATED MODULE: ./node_modules/lodash-es/isPlainObject.js




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    isPlainObject_objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var isPlainObject_hasOwnProperty = isPlainObject_objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!lodash_es_isObjectLike(value) || _baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = _getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = isPlainObject_hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ var lodash_es_isPlainObject = (isPlainObject);

// EXTERNAL MODULE: ./node_modules/symbol-observable/es/index.js
var es = __webpack_require__(480);

// CONCATENATED MODULE: ./node_modules/redux/es/createStore.js



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'
};

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} enhancer The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */
function createStore_createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore_createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!lodash_es_isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      listeners[i]();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/zenparsing/es-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[es["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[es["a" /* default */]] = observable, _ref2;
}
// EXTERNAL MODULE: ./node_modules/redux/es/utils/warning.js
var utils_warning = __webpack_require__(254);

// CONCATENATED MODULE: ./node_modules/redux/es/combineReducers.js




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!lodash_es_isPlainObject(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerSanity(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: ActionTypes.INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  if (false) {
    var unexpectedKeyCache = {};
  }

  var sanityError;
  try {
    assertReducerSanity(finalReducers);
  } catch (e) {
    sanityError = e;
  }

  return function combination() {
    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
    var action = arguments[1];

    if (sanityError) {
      throw sanityError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var i = 0; i < finalReducerKeys.length; i++) {
      var key = finalReducerKeys[i];
      var reducer = finalReducers[key];
      var previousStateForKey = state[key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(key, action);
        throw new Error(errorMessage);
      }
      nextState[key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}
// CONCATENATED MODULE: ./node_modules/redux/es/bindActionCreators.js
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}
// CONCATENATED MODULE: ./node_modules/redux/es/compose.js
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  var last = funcs[funcs.length - 1];
  var rest = funcs.slice(0, -1);
  return function () {
    return rest.reduceRight(function (composed, f) {
      return f(composed);
    }, last.apply(undefined, arguments));
  };
}
// CONCATENATED MODULE: ./node_modules/redux/es/applyMiddleware.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}
// CONCATENATED MODULE: ./node_modules/redux/es/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return createStore_createStore; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return combineReducers; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return bindActionCreators; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return applyMiddleware; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return compose; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.router = exports.routes = exports.route = exports.components = exports.component = exports.location = exports.history = exports.falsy = exports.locationShape = exports.routerShape = undefined;

var _react = __webpack_require__(0);

var _deprecateObjectProperties = __webpack_require__(123);

var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);

var _InternalPropTypes = __webpack_require__(66);

var InternalPropTypes = _interopRequireWildcard(_InternalPropTypes);

var _routerWarning = __webpack_require__(26);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var func = _react.PropTypes.func;
var object = _react.PropTypes.object;
var shape = _react.PropTypes.shape;
var string = _react.PropTypes.string;
var routerShape = exports.routerShape = shape({
  push: func.isRequired,
  replace: func.isRequired,
  go: func.isRequired,
  goBack: func.isRequired,
  goForward: func.isRequired,
  setRouteLeaveHook: func.isRequired,
  isActive: func.isRequired
});

var locationShape = exports.locationShape = shape({
  pathname: string.isRequired,
  search: string.isRequired,
  state: object,
  action: string.isRequired,
  key: string
});

// Deprecated stuff below:

var falsy = exports.falsy = InternalPropTypes.falsy;
var history = exports.history = InternalPropTypes.history;
var location = exports.location = locationShape;
var component = exports.component = InternalPropTypes.component;
var components = exports.components = InternalPropTypes.components;
var route = exports.route = InternalPropTypes.route;
var routes = exports.routes = InternalPropTypes.routes;
var router = exports.router = routerShape;

if (false) {
  (function () {
    var deprecatePropType = function deprecatePropType(propType, message) {
      return function () {
        process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
        return propType.apply(undefined, arguments);
      };
    };

    var deprecateInternalPropType = function deprecateInternalPropType(propType) {
      return deprecatePropType(propType, 'This prop type is not intended for external use, and was previously exported by mistake. These internal prop types are deprecated for external use, and will be removed in a later version.');
    };

    var deprecateRenamedPropType = function deprecateRenamedPropType(propType, name) {
      return deprecatePropType(propType, 'The `' + name + '` prop type is now exported as `' + name + 'Shape` to avoid name conflicts. This export is deprecated and will be removed in a later version.');
    };

    exports.falsy = falsy = deprecateInternalPropType(falsy);
    exports.history = history = deprecateInternalPropType(history);
    exports.component = component = deprecateInternalPropType(component);
    exports.components = components = deprecateInternalPropType(components);
    exports.route = route = deprecateInternalPropType(route);
    exports.routes = routes = deprecateInternalPropType(routes);

    exports.location = location = deprecateRenamedPropType(location, 'location');
    exports.router = router = deprecateRenamedPropType(router, 'router');
  })();
}

var defaultExport = {
  falsy: falsy,
  history: history,
  location: location,
  component: component,
  components: components,
  route: route,
  // For some reason, routes was never here.
  router: router
};

if (false) {
  defaultExport = (0, _deprecateObjectProperties2.default)(defaultExport, 'The default export from `react-router/lib/PropTypes` is deprecated. Please use the named exports instead.');
}

exports.default = defaultExport;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.addEventListener = addEventListener;
exports.removeEventListener = removeEventListener;
exports.getHashPath = getHashPath;
exports.replaceHashPath = replaceHashPath;
exports.getWindowPath = getWindowPath;
exports.go = go;
exports.getUserConfirmation = getUserConfirmation;
exports.supportsHistory = supportsHistory;
exports.supportsGoWithoutReloadUsingHash = supportsGoWithoutReloadUsingHash;

function addEventListener(node, event, listener) {
  if (node.addEventListener) {
    node.addEventListener(event, listener, false);
  } else {
    node.attachEvent('on' + event, listener);
  }
}

function removeEventListener(node, event, listener) {
  if (node.removeEventListener) {
    node.removeEventListener(event, listener, false);
  } else {
    node.detachEvent('on' + event, listener);
  }
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  return window.location.href.split('#')[1] || '';
}

function replaceHashPath(path) {
  window.location.replace(window.location.pathname + window.location.search + '#' + path);
}

function getWindowPath() {
  return window.location.pathname + window.location.search + window.location.hash;
}

function go(n) {
  if (n) window.history.go(n);
}

function getUserConfirmation(message, callback) {
  callback(window.confirm(message));
}

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/rackt/react-router/issues/586
 */

function supportsHistory() {
  var ua = navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
    return false;
  }
  return window.history && 'pushState' in window.history;
}

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  var ua = navigator.userAgent;
  return ua.indexOf('Firefox') === -1;
}

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*eslint-disable no-empty */


exports.__esModule = true;
exports.saveState = saveState;
exports.readState = readState;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(41);

var _warning2 = _interopRequireDefault(_warning);

var KeyPrefix = '@@History/';
var QuotaExceededErrors = ['QuotaExceededError', 'QUOTA_EXCEEDED_ERR'];

var SecurityError = 'SecurityError';

function createKey(key) {
  return KeyPrefix + key;
}

function saveState(key, state) {
  try {
    if (state == null) {
      window.sessionStorage.removeItem(createKey(key));
    } else {
      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
    }
  } catch (error) {
    if (error.name === SecurityError) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available due to security settings') : undefined;

      return;
    }

    if (QuotaExceededErrors.indexOf(error.name) >= 0 && window.sessionStorage.length === 0) {
      // Safari "private mode" throws QuotaExceededError.
       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : undefined;

      return;
    }

    throw error;
  }
}

function readState(key) {
  var json = undefined;
  try {
    json = window.sessionStorage.getItem(createKey(key));
  } catch (error) {
    if (error.name === SecurityError) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? _warning2['default'](false, '[history] Unable to read state; sessionStorage is not available due to security settings') : undefined;

      return null;
    }
  }

  if (json) {
    try {
      return JSON.parse(json);
    } catch (error) {
      // Ignore invalid JSON.
    }
  }

  return null;
}

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(258);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var arePropertyDescriptorsSupported = function () {
	var obj = {};
	try {
		origDefineProperty(obj, 'x', { enumerable: false, value: obj });
		// eslint-disable-next-line no-unused-vars, no-restricted-syntax
		for (var _ in obj) { // jscs:ignore disallowUnusedVariables
			return false;
		}
		return obj.x === obj;
	} catch (e) { /* this is IE 8. */
		return false;
	}
};
var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value;
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(41);

var _warning2 = _interopRequireDefault(_warning);

function runTransitionHook(hook, location, callback) {
  var result = hook(location, callback);

  if (hook.length < 2) {
    // Assume the hook runs synchronously and automatically
    // call the callback with the return value.
    callback(result);
  } else {
     false ? _warning2['default'](result === undefined, 'You should not "return" in a transition hook with a callback argument; call the callback instead') : undefined;
  }
}

exports['default'] = runTransitionHook;
module.exports = exports['default'];

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(41);

var _warning2 = _interopRequireDefault(_warning);

function deprecate(fn, message) {
  return function () {
     false ? _warning2['default'](false, '[history] ' + message) : undefined;
    return fn.apply(this, arguments);
  };
}

exports['default'] = deprecate;
module.exports = exports['default'];

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = createTransitionManager;

var _routerWarning = __webpack_require__(26);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _computeChangedRoutes2 = __webpack_require__(500);

var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);

var _TransitionUtils = __webpack_require__(501);

var _isActive2 = __webpack_require__(502);

var _isActive3 = _interopRequireDefault(_isActive2);

var _getComponents = __webpack_require__(503);

var _getComponents2 = _interopRequireDefault(_getComponents);

var _matchRoutes = __webpack_require__(504);

var _matchRoutes2 = _interopRequireDefault(_matchRoutes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hasAnyProperties(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
  }return false;
}

function createTransitionManager(history, routes) {
  var state = {};

  // Signature should be (location, indexOnly), but needs to support (path,
  // query, indexOnly)
  function isActive(location) {
    var indexOnlyOrDeprecatedQuery = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
    var deprecatedIndexOnly = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];

    var indexOnly = void 0;
    if (indexOnlyOrDeprecatedQuery && indexOnlyOrDeprecatedQuery !== true || deprecatedIndexOnly !== null) {
       false ? (0, _routerWarning2.default)(false, '`isActive(pathname, query, indexOnly) is deprecated; use `isActive(location, indexOnly)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
      location = { pathname: location, query: indexOnlyOrDeprecatedQuery };
      indexOnly = deprecatedIndexOnly || false;
    } else {
      location = history.createLocation(location);
      indexOnly = indexOnlyOrDeprecatedQuery;
    }

    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
  }

  var partialNextState = void 0;

  function match(location, callback) {
    if (partialNextState && partialNextState.location === location) {
      // Continue from where we left off.
      finishMatch(partialNextState, callback);
    } else {
      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
        if (error) {
          callback(error);
        } else if (nextState) {
          finishMatch(_extends({}, nextState, { location: location }), callback);
        } else {
          callback();
        }
      });
    }
  }

  function finishMatch(nextState, callback) {
    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState);

    var leaveRoutes = _computeChangedRoutes.leaveRoutes;
    var changeRoutes = _computeChangedRoutes.changeRoutes;
    var enterRoutes = _computeChangedRoutes.enterRoutes;


    (0, _TransitionUtils.runLeaveHooks)(leaveRoutes, state);

    // Tear down confirmation hooks for left routes
    leaveRoutes.filter(function (route) {
      return enterRoutes.indexOf(route) === -1;
    }).forEach(removeListenBeforeHooksForRoute);

    // change and enter hooks are run in series
    (0, _TransitionUtils.runChangeHooks)(changeRoutes, state, nextState, function (error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      (0, _TransitionUtils.runEnterHooks)(enterRoutes, nextState, finishEnterHooks);
    });

    function finishEnterHooks(error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      // TODO: Fetch components after state is updated.
      (0, _getComponents2.default)(nextState, function (error, components) {
        if (error) {
          callback(error);
        } else {
          // TODO: Make match a pure function and have some other API
          // for "match and update state".
          callback(null, null, state = _extends({}, nextState, { components: components }));
        }
      });
    }

    function handleErrorOrRedirect(error, redirectInfo) {
      if (error) callback(error);else callback(null, redirectInfo);
    }
  }

  var RouteGuid = 1;

  function getRouteID(route) {
    var create = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];

    return route.__id__ || create && (route.__id__ = RouteGuid++);
  }

  var RouteHooks = Object.create(null);

  function getRouteHooksForRoutes(routes) {
    return routes.reduce(function (hooks, route) {
      hooks.push.apply(hooks, RouteHooks[getRouteID(route)]);
      return hooks;
    }, []);
  }

  function transitionHook(location, callback) {
    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
      if (nextState == null) {
        // TODO: We didn't actually match anything, but hang
        // onto error/nextState so we don't have to matchRoutes
        // again in the listen callback.
        callback();
        return;
      }

      // Cache some state here so we don't have to
      // matchRoutes() again in the listen callback.
      partialNextState = _extends({}, nextState, { location: location });

      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);

      var result = void 0;
      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
        // Passing the location arg here indicates to
        // the user that this is a transition hook.
        result = hooks[i](location);
      }

      callback(result);
    });
  }

  /* istanbul ignore next: untestable with Karma */
  function beforeUnloadHook() {
    // Synchronously check to see if any route hooks want
    // to prevent the current window/tab from closing.
    if (state.routes) {
      var hooks = getRouteHooksForRoutes(state.routes);

      var message = void 0;
      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
        // Passing no args indicates to the user that this is a
        // beforeunload hook. We don't know the next location.
        message = hooks[i]();
      }

      return message;
    }
  }

  var unlistenBefore = void 0,
      unlistenBeforeUnload = void 0;

  function removeListenBeforeHooksForRoute(route) {
    var routeID = getRouteID(route, false);
    if (!routeID) {
      return;
    }

    delete RouteHooks[routeID];

    if (!hasAnyProperties(RouteHooks)) {
      // teardown transition & beforeunload hooks
      if (unlistenBefore) {
        unlistenBefore();
        unlistenBefore = null;
      }

      if (unlistenBeforeUnload) {
        unlistenBeforeUnload();
        unlistenBeforeUnload = null;
      }
    }
  }

  /**
   * Registers the given hook function to run before leaving the given route.
   *
   * During a normal transition, the hook function receives the next location
   * as its only argument and can return either a prompt message (string) to show the user,
   * to make sure they want to leave the page; or `false`, to prevent the transition.
   * Any other return value will have no effect.
   *
   * During the beforeunload event (in browsers) the hook receives no arguments.
   * In this case it must return a prompt message to prevent the transition.
   *
   * Returns a function that may be used to unbind the listener.
   */
  function listenBeforeLeavingRoute(route, hook) {
    // TODO: Warn if they register for a route that isn't currently
    // active. They're probably doing something wrong, like re-creating
    // route objects on every location change.
    var routeID = getRouteID(route);
    var hooks = RouteHooks[routeID];

    if (!hooks) {
      var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);

      RouteHooks[routeID] = [hook];

      if (thereWereNoRouteHooks) {
        // setup transition & beforeunload hooks
        unlistenBefore = history.listenBefore(transitionHook);

        if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
      }
    } else {
      if (hooks.indexOf(hook) === -1) {
         false ? (0, _routerWarning2.default)(false, 'adding multiple leave hooks for the same route is deprecated; manage multiple confirmations in your own code instead') : void 0;

        hooks.push(hook);
      }
    }

    return function () {
      var hooks = RouteHooks[routeID];

      if (hooks) {
        var newHooks = hooks.filter(function (item) {
          return item !== hook;
        });

        if (newHooks.length === 0) {
          removeListenBeforeHooksForRoute(route);
        } else {
          RouteHooks[routeID] = newHooks;
        }
      }
    };
  }

  /**
   * This is the API for stateful environments. As the location
   * changes, we update state and call the listener. We can also
   * gracefully handle errors and redirects.
   */
  function listen(listener) {
    // TODO: Only use a single history listener. Otherwise we'll
    // end up with multiple concurrent calls to match.
    return history.listen(function (location) {
      if (state.location === location) {
        listener(null, state);
      } else {
        match(location, function (error, redirectLocation, nextState) {
          if (error) {
            listener(error);
          } else if (redirectLocation) {
            history.replace(redirectLocation);
          } else if (nextState) {
            listener(null, nextState);
          } else {
             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
          }
        });
      }
    });
  }

  return {
    isActive: isActive,
    match: match,
    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
    listen: listen
  };
}

//export default useRoutes

module.exports = exports['default'];

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.loopAsync = loopAsync;
exports.mapAsync = mapAsync;
function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var sync = false,
      hasNext = false,
      doneArgs = void 0;

  function done() {
    isDone = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      doneArgs = [].concat(Array.prototype.slice.call(arguments));
      return;
    }

    callback.apply(this, arguments);
  }

  function next() {
    if (isDone) {
      return;
    }

    hasNext = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      return;
    }

    sync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work.call(this, currentTurn++, next, done);
    }

    sync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(this, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  }

  next();
}

function mapAsync(array, work, callback) {
  var length = array.length;
  var values = [];

  if (length === 0) return callback(null, values);

  var isDone = false,
      doneCount = 0;

  function done(index, error, value) {
    if (isDone) return;

    if (error) {
      isDone = true;
      callback(error);
    } else {
      values[index] = value;

      isDone = ++doneCount === length;

      if (isDone) callback(null, values);
    }
  }

  array.forEach(function (item, index) {
    work(item, index, function (error, value) {
      done(index, error, value);
    });
  });
}

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAccessMethodFromAuthTypes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums__ = __webpack_require__(1);


function getAccessMethodFromAuthTypes() {
    var userAuth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    if (userAuth.indexOf(__WEBPACK_IMPORTED_MODULE_0__enums__["e" /* AuthTypes */].MVPD) !== -1) {
        return 'Authenticated - ESPN';
    } else if (userAuth.indexOf(__WEBPACK_IMPORTED_MODULE_0__enums__["e" /* AuthTypes */].ISP) !== -1) {
        return 'ISP';
    }
    return 'Not Authenticated';
};

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)))

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(console) {/**
 * Root reference for iframes.
 */

var root;
if (typeof window !== 'undefined') { // Browser window
  root = window;
} else if (typeof self !== 'undefined') { // Web Worker
  root = self;
} else { // Other environments
  console.warn("Using browser-only version of superagent in non-browser environment");
  root = this;
}

var Emitter = __webpack_require__(533);
var requestBase = __webpack_require__(534);
var isObject = __webpack_require__(275);

/**
 * Noop.
 */

function noop(){};

/**
 * Expose `request`.
 */

var request = module.exports = __webpack_require__(535).bind(null, Request);

/**
 * Determine XHR.
 */

request.getXHR = function () {
  if (root.XMLHttpRequest
      && (!root.location || 'file:' != root.location.protocol
          || !root.ActiveXObject)) {
    return new XMLHttpRequest;
  } else {
    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
  }
  throw Error("Browser-only verison of superagent could not find XHR");
};

/**
 * Removes leading and trailing whitespace, added to support IE.
 *
 * @param {String} s
 * @return {String}
 * @api private
 */

var trim = ''.trim
  ? function(s) { return s.trim(); }
  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };

/**
 * Serialize the given `obj`.
 *
 * @param {Object} obj
 * @return {String}
 * @api private
 */

function serialize(obj) {
  if (!isObject(obj)) return obj;
  var pairs = [];
  for (var key in obj) {
    if (null != obj[key]) {
      pushEncodedKeyValuePair(pairs, key, obj[key]);
    }
  }
  return pairs.join('&');
}

/**
 * Helps 'serialize' with serializing arrays.
 * Mutates the pairs array.
 *
 * @param {Array} pairs
 * @param {String} key
 * @param {Mixed} val
 */

function pushEncodedKeyValuePair(pairs, key, val) {
  if (Array.isArray(val)) {
    return val.forEach(function(v) {
      pushEncodedKeyValuePair(pairs, key, v);
    });
  } else if (isObject(val)) {
    for(var subkey in val) {
      pushEncodedKeyValuePair(pairs, key + '[' + subkey + ']', val[subkey]);
    }
    return;
  }
  pairs.push(encodeURIComponent(key)
    + '=' + encodeURIComponent(val));
}

/**
 * Expose serialization method.
 */

 request.serializeObject = serialize;

 /**
  * Parse the given x-www-form-urlencoded `str`.
  *
  * @param {String} str
  * @return {Object}
  * @api private
  */

function parseString(str) {
  var obj = {};
  var pairs = str.split('&');
  var pair;
  var pos;

  for (var i = 0, len = pairs.length; i < len; ++i) {
    pair = pairs[i];
    pos = pair.indexOf('=');
    if (pos == -1) {
      obj[decodeURIComponent(pair)] = '';
    } else {
      obj[decodeURIComponent(pair.slice(0, pos))] =
        decodeURIComponent(pair.slice(pos + 1));
    }
  }

  return obj;
}

/**
 * Expose parser.
 */

request.parseString = parseString;

/**
 * Default MIME type map.
 *
 *     superagent.types.xml = 'application/xml';
 *
 */

request.types = {
  html: 'text/html',
  json: 'application/json',
  xml: 'application/xml',
  urlencoded: 'application/x-www-form-urlencoded',
  'form': 'application/x-www-form-urlencoded',
  'form-data': 'application/x-www-form-urlencoded'
};

/**
 * Default serialization map.
 *
 *     superagent.serialize['application/xml'] = function(obj){
 *       return 'generated xml here';
 *     };
 *
 */

 request.serialize = {
   'application/x-www-form-urlencoded': serialize,
   'application/json': JSON.stringify
 };

 /**
  * Default parsers.
  *
  *     superagent.parse['application/xml'] = function(str){
  *       return { object parsed from str };
  *     };
  *
  */

request.parse = {
  'application/x-www-form-urlencoded': parseString,
  'application/json': JSON.parse
};

/**
 * Parse the given header `str` into
 * an object containing the mapped fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

function parseHeader(str) {
  var lines = str.split(/\r?\n/);
  var fields = {};
  var index;
  var line;
  var field;
  var val;

  lines.pop(); // trailing CRLF

  for (var i = 0, len = lines.length; i < len; ++i) {
    line = lines[i];
    index = line.indexOf(':');
    field = line.slice(0, index).toLowerCase();
    val = trim(line.slice(index + 1));
    fields[field] = val;
  }

  return fields;
}

/**
 * Check if `mime` is json or has +json structured syntax suffix.
 *
 * @param {String} mime
 * @return {Boolean}
 * @api private
 */

function isJSON(mime) {
  return /[\/+]json\b/.test(mime);
}

/**
 * Return the mime type for the given `str`.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

function type(str){
  return str.split(/ *; */).shift();
};

/**
 * Return header field parameters.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

function params(str){
  return str.split(/ *; */).reduce(function(obj, str){
    var parts = str.split(/ *= */),
        key = parts.shift(),
        val = parts.shift();

    if (key && val) obj[key] = val;
    return obj;
  }, {});
};

/**
 * Initialize a new `Response` with the given `xhr`.
 *
 *  - set flags (.ok, .error, etc)
 *  - parse header
 *
 * Examples:
 *
 *  Aliasing `superagent` as `request` is nice:
 *
 *      request = superagent;
 *
 *  We can use the promise-like API, or pass callbacks:
 *
 *      request.get('/').end(function(res){});
 *      request.get('/', function(res){});
 *
 *  Sending data can be chained:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' })
 *        .end(function(res){});
 *
 *  Or passed to `.send()`:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' }, function(res){});
 *
 *  Or passed to `.post()`:
 *
 *      request
 *        .post('/user', { name: 'tj' })
 *        .end(function(res){});
 *
 * Or further reduced to a single call for simple cases:
 *
 *      request
 *        .post('/user', { name: 'tj' }, function(res){});
 *
 * @param {XMLHTTPRequest} xhr
 * @param {Object} options
 * @api private
 */

function Response(req, options) {
  options = options || {};
  this.req = req;
  this.xhr = this.req.xhr;
  // responseText is accessible only if responseType is '' or 'text' and on older browsers
  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
     ? this.xhr.responseText
     : null;
  this.statusText = this.req.xhr.statusText;
  this._setStatusProperties(this.xhr.status);
  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
  // getResponseHeader still works. so we get content-type even if getting
  // other headers fails.
  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
  this._setHeaderProperties(this.header);
  this.body = this.req.method != 'HEAD'
    ? this._parseBody(this.text ? this.text : this.xhr.response)
    : null;
}

/**
 * Get case-insensitive `field` value.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

Response.prototype.get = function(field){
  return this.header[field.toLowerCase()];
};

/**
 * Set header related properties:
 *
 *   - `.type` the content type without params
 *
 * A response of "Content-Type: text/plain; charset=utf-8"
 * will provide you with a `.type` of "text/plain".
 *
 * @param {Object} header
 * @api private
 */

Response.prototype._setHeaderProperties = function(header){
  // content-type
  var ct = this.header['content-type'] || '';
  this.type = type(ct);

  // params
  var obj = params(ct);
  for (var key in obj) this[key] = obj[key];
};

/**
 * Parse the given body `str`.
 *
 * Used for auto-parsing of bodies. Parsers
 * are defined on the `superagent.parse` object.
 *
 * @param {String} str
 * @return {Mixed}
 * @api private
 */

Response.prototype._parseBody = function(str){
  var parse = request.parse[this.type];
  if (!parse && isJSON(this.type)) {
    parse = request.parse['application/json'];
  }
  return parse && str && (str.length || str instanceof Object)
    ? parse(str)
    : null;
};

/**
 * Set flags such as `.ok` based on `status`.
 *
 * For example a 2xx response will give you a `.ok` of __true__
 * whereas 5xx will be __false__ and `.error` will be __true__. The
 * `.clientError` and `.serverError` are also available to be more
 * specific, and `.statusType` is the class of error ranging from 1..5
 * sometimes useful for mapping respond colors etc.
 *
 * "sugar" properties are also defined for common cases. Currently providing:
 *
 *   - .noContent
 *   - .badRequest
 *   - .unauthorized
 *   - .notAcceptable
 *   - .notFound
 *
 * @param {Number} status
 * @api private
 */

Response.prototype._setStatusProperties = function(status){
  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
  if (status === 1223) {
    status = 204;
  }

  var type = status / 100 | 0;

  // status / class
  this.status = this.statusCode = status;
  this.statusType = type;

  // basics
  this.info = 1 == type;
  this.ok = 2 == type;
  this.clientError = 4 == type;
  this.serverError = 5 == type;
  this.error = (4 == type || 5 == type)
    ? this.toError()
    : false;

  // sugar
  this.accepted = 202 == status;
  this.noContent = 204 == status;
  this.badRequest = 400 == status;
  this.unauthorized = 401 == status;
  this.notAcceptable = 406 == status;
  this.notFound = 404 == status;
  this.forbidden = 403 == status;
};

/**
 * Return an `Error` representative of this response.
 *
 * @return {Error}
 * @api public
 */

Response.prototype.toError = function(){
  var req = this.req;
  var method = req.method;
  var url = req.url;

  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
  var err = new Error(msg);
  err.status = this.status;
  err.method = method;
  err.url = url;

  return err;
};

/**
 * Expose `Response`.
 */

request.Response = Response;

/**
 * Initialize a new `Request` with the given `method` and `url`.
 *
 * @param {String} method
 * @param {String} url
 * @api public
 */

function Request(method, url) {
  var self = this;
  this._query = this._query || [];
  this.method = method;
  this.url = url;
  this.header = {}; // preserves header name case
  this._header = {}; // coerces header names to lowercase
  this.on('end', function(){
    var err = null;
    var res = null;

    try {
      res = new Response(self);
    } catch(e) {
      err = new Error('Parser is unable to parse the response');
      err.parse = true;
      err.original = e;
      // issue #675: return the raw response if the response parsing fails
      err.rawResponse = self.xhr && self.xhr.responseText ? self.xhr.responseText : null;
      // issue #876: return the http status code if the response parsing fails
      err.statusCode = self.xhr && self.xhr.status ? self.xhr.status : null;
      return self.callback(err);
    }

    self.emit('response', res);

    var new_err;
    try {
      if (res.status < 200 || res.status >= 300) {
        new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
        new_err.original = err;
        new_err.response = res;
        new_err.status = res.status;
      }
    } catch(e) {
      new_err = e; // #985 touching res may cause INVALID_STATE_ERR on old Android
    }

    // #1000 don't catch errors from the callback to avoid double calling it
    if (new_err) {
      self.callback(new_err, res);
    } else {
      self.callback(null, res);
    }
  });
}

/**
 * Mixin `Emitter` and `requestBase`.
 */

Emitter(Request.prototype);
for (var key in requestBase) {
  Request.prototype[key] = requestBase[key];
}

/**
 * Set Content-Type to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.xml = 'application/xml';
 *
 *      request.post('/')
 *        .type('xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 *      request.post('/')
 *        .type('application/xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 * @param {String} type
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.type = function(type){
  this.set('Content-Type', request.types[type] || type);
  return this;
};

/**
 * Set responseType to `val`. Presently valid responseTypes are 'blob' and
 * 'arraybuffer'.
 *
 * Examples:
 *
 *      req.get('/')
 *        .responseType('blob')
 *        .end(callback);
 *
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.responseType = function(val){
  this._responseType = val;
  return this;
};

/**
 * Set Accept to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.json = 'application/json';
 *
 *      request.get('/agent')
 *        .accept('json')
 *        .end(callback);
 *
 *      request.get('/agent')
 *        .accept('application/json')
 *        .end(callback);
 *
 * @param {String} accept
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.accept = function(type){
  this.set('Accept', request.types[type] || type);
  return this;
};

/**
 * Set Authorization field value with `user` and `pass`.
 *
 * @param {String} user
 * @param {String} pass
 * @param {Object} options with 'type' property 'auto' or 'basic' (default 'basic')
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.auth = function(user, pass, options){
  if (!options) {
    options = {
      type: 'basic'
    }
  }

  switch (options.type) {
    case 'basic':
      var str = btoa(user + ':' + pass);
      this.set('Authorization', 'Basic ' + str);
    break;

    case 'auto':
      this.username = user;
      this.password = pass;
    break;
  }
  return this;
};

/**
* Add query-string `val`.
*
* Examples:
*
*   request.get('/shoes')
*     .query('size=10')
*     .query({ color: 'blue' })
*
* @param {Object|String} val
* @return {Request} for chaining
* @api public
*/

Request.prototype.query = function(val){
  if ('string' != typeof val) val = serialize(val);
  if (val) this._query.push(val);
  return this;
};

/**
 * Queue the given `file` as an attachment to the specified `field`,
 * with optional `filename`.
 *
 * ``` js
 * request.post('/upload')
 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
 *   .end(callback);
 * ```
 *
 * @param {String} field
 * @param {Blob|File} file
 * @param {String} filename
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.attach = function(field, file, filename){
  this._getFormData().append(field, file, filename || file.name);
  return this;
};

Request.prototype._getFormData = function(){
  if (!this._formData) {
    this._formData = new root.FormData();
  }
  return this._formData;
};

/**
 * Invoke the callback with `err` and `res`
 * and handle arity check.
 *
 * @param {Error} err
 * @param {Response} res
 * @api private
 */

Request.prototype.callback = function(err, res){
  var fn = this._callback;
  this.clearTimeout();
  fn(err, res);
};

/**
 * Invoke callback with x-domain error.
 *
 * @api private
 */

Request.prototype.crossDomainError = function(){
  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
  err.crossDomain = true;

  err.status = this.status;
  err.method = this.method;
  err.url = this.url;

  this.callback(err);
};

/**
 * Invoke callback with timeout error.
 *
 * @api private
 */

Request.prototype._timeoutError = function(){
  var timeout = this._timeout;
  var err = new Error('timeout of ' + timeout + 'ms exceeded');
  err.timeout = timeout;
  this.callback(err);
};

/**
 * Compose querystring to append to req.url
 *
 * @api private
 */

Request.prototype._appendQueryString = function(){
  var query = this._query.join('&');
  if (query) {
    this.url += ~this.url.indexOf('?')
      ? '&' + query
      : '?' + query;
  }
};

/**
 * Initiate request, invoking callback `fn(res)`
 * with an instanceof `Response`.
 *
 * @param {Function} fn
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.end = function(fn){
  var self = this;
  var xhr = this.xhr = request.getXHR();
  var timeout = this._timeout;
  var data = this._formData || this._data;

  // store callback
  this._callback = fn || noop;

  // state change
  xhr.onreadystatechange = function(){
    if (4 != xhr.readyState) return;

    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
    // result in the error "Could not complete the operation due to error c00c023f"
    var status;
    try { status = xhr.status } catch(e) { status = 0; }

    if (0 == status) {
      if (self.timedout) return self._timeoutError();
      if (self._aborted) return;
      return self.crossDomainError();
    }
    self.emit('end');
  };

  // progress
  var handleProgress = function(e){
    if (e.total > 0) {
      e.percent = e.loaded / e.total * 100;
    }
    e.direction = 'download';
    self.emit('progress', e);
  };
  if (this.hasListeners('progress')) {
    xhr.onprogress = handleProgress;
  }
  try {
    if (xhr.upload && this.hasListeners('progress')) {
      xhr.upload.onprogress = handleProgress;
    }
  } catch(e) {
    // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
    // Reported here:
    // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
  }

  // timeout
  if (timeout && !this._timer) {
    this._timer = setTimeout(function(){
      self.timedout = true;
      self.abort();
    }, timeout);
  }

  // querystring
  this._appendQueryString();

  // initiate request
  if (this.username && this.password) {
    xhr.open(this.method, this.url, true, this.username, this.password);
  } else {
    xhr.open(this.method, this.url, true);
  }

  // CORS
  if (this._withCredentials) xhr.withCredentials = true;

  // body
  if ('GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !this._isHost(data)) {
    // serialize stuff
    var contentType = this._header['content-type'];
    var serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
    if (!serialize && isJSON(contentType)) serialize = request.serialize['application/json'];
    if (serialize) data = serialize(data);
  }

  // set header fields
  for (var field in this.header) {
    if (null == this.header[field]) continue;
    xhr.setRequestHeader(field, this.header[field]);
  }

  if (this._responseType) {
    xhr.responseType = this._responseType;
  }

  // send stuff
  this.emit('request', this);

  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
  // We need null here if data is undefined
  xhr.send(typeof data !== 'undefined' ? data : null);
  return this;
};


/**
 * Expose `Request`.
 */

request.Request = Request;

/**
 * GET `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.get = function(url, data, fn){
  var req = request('GET', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * HEAD `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.head = function(url, data, fn){
  var req = request('HEAD', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * OPTIONS query to `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.options = function(url, data, fn){
  var req = request('OPTIONS', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * DELETE `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

function del(url, fn){
  var req = request('DELETE', url);
  if (fn) req.end(fn);
  return req;
};

request['del'] = del;
request['delete'] = del;

/**
 * PATCH `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.patch = function(url, data, fn){
  var req = request('PATCH', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * POST `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.post = function(url, data, fn){
  var req = request('POST', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * PUT `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.put = function(url, data, fn){
  var req = request('PUT', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(127),
    toKey = __webpack_require__(110);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(32),
    isSymbol = __webpack_require__(128);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(545),
    mapCacheDelete = __webpack_require__(561),
    mapCacheGet = __webpack_require__(563),
    mapCacheHas = __webpack_require__(564),
    mapCacheSet = __webpack_require__(565);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(71),
    isObject = __webpack_require__(35);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(72),
    root = __webpack_require__(39);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 198 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 199 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(136),
    nativeKeys = __webpack_require__(580);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(581),
    Map = __webpack_require__(197),
    Promise = __webpack_require__(582),
    Set = __webpack_require__(290),
    WeakMap = __webpack_require__(583),
    baseGetTag = __webpack_require__(71),
    toSource = __webpack_require__(281);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getMinutesUntilStart;
/* eslint-disable */
// not using this anymore now that utc has offset from GMT accounted for
function getTimezoneOffsetFromGMT() {
    var offset = new Date().getTimezoneOffset() / 60;

    // American locations are east of GMT so default to negative
    var formattedOffset = '-';
    if (offset < 0) {
        formattedOffset = '+';
    }

    // pad the offset in the front with 0s if needed
    if (Math.abs(offset) >= 10) {
        return '' + formattedOffset + offset + '00';
    }
    return formattedOffset + '0' + offset + '00';
}
/* eslint-enable */

function getMinutesUntilStart(_ref) {
    var utc = _ref.utc;
    var targetDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();

    var now = targetDate.getTime();
    var eventTime = new Date(utc).getTime();

    return Math.floor((eventTime - now) / 1000 / 60);
};

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = normalizeQueryString;
// this function will convert string booleans to boolean types
// it will also normalize any overloaded query params the app can receive - eg: eventId/gameId
function normalizeQueryString() {
    var queryObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var convertedQuery = {};
    for (var key in queryObj) {
        if (queryObj.hasOwnProperty(key)) {
            var convertedVal = queryObj[key];

            if (convertedVal === 'true') {
                convertedVal = true;
            } else if (convertedVal === 'false') {
                convertedVal = false;
            }

            // legacy value support
            if ((key === 'channel' || key === 'network') && convertedVal === 'espn1') {
                convertedVal = 'espn';
            }

            if (key === 'eventCalendarId') {
                convertedQuery['eventId'] = convertedVal;
            } else {
                convertedQuery[key] = convertedVal;
            }
        }
    }
    return convertedQuery;
};

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(195),
    setCacheAdd = __webpack_require__(601),
    setCacheHas = __webpack_require__(602);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 205 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getListingsByType */
/* unused harmony export getListingsBySubcategory */
/* harmony export (immutable) */ __webpack_exports__["a"] = getEventByQuery;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_api__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectors_appSelector__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




function getListingsByType(type, query) {
    var _this = this;

    return function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
            var listings, _appSelector, lang, league, hasLeague, filtered;

            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_0__lib_api__["f" /* WatchAPI */].getListings(_extends({}, query, { types: [type] }));

                        case 2:
                            listings = _context.sent;
                            _appSelector = Object(__WEBPACK_IMPORTED_MODULE_1__selectors_appSelector__["j" /* default */])(getState()), lang = _appSelector.lang;
                            league = query.league;
                            // inherited from the legacy logic

                            hasLeague = league && league !== 'tennis' && league !== 'golf';
                            filtered = hasLeague ? listings.filter(function (listing) {
                                return listing.subcategories.filter(function (_ref2) {
                                    var name = _ref2.name,
                                        shortName = _ref2.shortName,
                                        abbreviation = _ref2.abbreviation,
                                        id = _ref2.id;
                                    return league === name || league === shortName || league === abbreviation || league === id;
                                }).length > 0;
                            }) : listings;
                            return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_0__lib_api__["f" /* WatchAPI */].getPrioritizedEventFromListings(filtered, lang));

                        case 8:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function (_x, _x2) {
            return _ref.apply(this, arguments);
        };
    }();
}

function getListingsBySubcategory(type, query) {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var listings;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_0__lib_api__["f" /* WatchAPI */].getListingsBySubcategory(_extends({}, query, { types: [type] }));

                    case 2:
                        listings = _context2.sent;
                        return _context2.abrupt('return', listings);

                    case 4:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, _this2);
    }));
}

function getEventByQuery() {
    var _this3 = this;

    var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch) {
            var partner, dates, liveData, upcomingData, replayData, newQuery, _ref5, _ref6;

            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            partner = query.partner, dates = query.dates;
                            liveData = void 0;
                            upcomingData = void 0;
                            replayData = void 0;

                            if (!partner) {
                                _context3.next = 23;
                                break;
                            }

                            newQuery = { subcategory: partner, networks: ['espn3'], dates: dates };

                            liveData = dispatch(getListingsBySubcategory('live', newQuery));
                            upcomingData = dispatch(getListingsBySubcategory('upcoming', newQuery));
                            replayData = dispatch(getListingsBySubcategory('replay', newQuery));
                            _context3.next = 11;
                            return liveData;

                        case 11:
                            _context3.t0 = _context3.sent;
                            _context3.next = 14;
                            return upcomingData;

                        case 14:
                            _context3.t1 = _context3.sent;
                            _context3.next = 17;
                            return replayData;

                        case 17:
                            _context3.t2 = _context3.sent;
                            _ref5 = [_context3.t0, _context3.t1, _context3.t2];
                            liveData = _ref5[0];
                            upcomingData = _ref5[1];
                            replayData = _ref5[2];
                            return _context3.abrupt('return', liveData && liveData[0] || upcomingData && upcomingData[0] || replayData && replayData[0]);

                        case 23:

                            liveData = dispatch(getListingsByType('live', query));
                            upcomingData = dispatch(getListingsByType('upcoming', query));
                            replayData = dispatch(getListingsByType('replay', query));
                            _context3.next = 28;
                            return liveData;

                        case 28:
                            _context3.t3 = _context3.sent;
                            _context3.next = 31;
                            return upcomingData;

                        case 31:
                            _context3.t4 = _context3.sent;
                            _context3.next = 34;
                            return replayData;

                        case 34:
                            _context3.t5 = _context3.sent;
                            _ref6 = [_context3.t3, _context3.t4, _context3.t5];
                            liveData = _ref6[0];
                            upcomingData = _ref6[1];
                            replayData = _ref6[2];
                            return _context3.abrupt('return', liveData || replayData || upcomingData);

                        case 40:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }));

        return function (_x4) {
            return _ref4.apply(this, arguments);
        };
    }();
}

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERROR_CODES", function() { return ERROR_CODES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERROR_PAGE_RESPONSE", function() { return ERROR_PAGE_RESPONSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "config", function() { return config; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getServiceUrl", function() { return getServiceUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPath", function() { return getPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPageBaseUrl", function() { return getPageBaseUrl; });
/* harmony export (immutable) */ __webpack_exports__["getPageApiUrl"] = getPageApiUrl;
/* harmony export (immutable) */ __webpack_exports__["getPage"] = getPage;
/* harmony export (immutable) */ __webpack_exports__["getEvent"] = getEvent;
/* harmony export (immutable) */ __webpack_exports__["getVideo"] = getVideo;
/* harmony export (immutable) */ __webpack_exports__["getBucketPage"] = getBucketPage;
/* harmony export (immutable) */ __webpack_exports__["getPageByFullUrl"] = getPageByFullUrl;
/* harmony export (immutable) */ __webpack_exports__["getPlaybackMeta"] = getPlaybackMeta;
/* harmony export (immutable) */ __webpack_exports__["getCategories"] = getCategories;
/* harmony export (immutable) */ __webpack_exports__["getNetworks"] = getNetworks;
/* harmony export (immutable) */ __webpack_exports__["getPickerStreams"] = getPickerStreams;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loglevel__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loglevel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loglevel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__format_queryString__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__url_adapter_toAbsoluteURL__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__metrics_newRelicEventBus__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cache_requestCache__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__requestProxy__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cache_fallbackCache__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__enums__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__config__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };














var ApiEnv = __WEBPACK_IMPORTED_MODULE_9__enums__["b" /* Api */].Env;


var log = __WEBPACK_IMPORTED_MODULE_1_loglevel___default.a.getLogger('PageAPI');

var pageApiConfig = __WEBPACK_IMPORTED_MODULE_10__config___default.a.pageApi;

var DEFAULT_EXPIRATION = 60;
var DEFAULT_TIMEOUT = 10000;
var ONE_HOUR = 3600;

// we can set catalogPageTypes in app config if it is needed to be more manageable. 
var catalogPageTypes = new Set(["competitionGroup", "compilation", "conference", "event", "film", "franchise", "institution", "league", "organizer", "other", "qualifier", "season", "series", "short", "sport", "tour", "tournament", "network"]);

var ERROR_CODES = {
    GENERIC_ERROR: 'GENERIC_ERROR',
    PAGE_NOT_CONFIGURED: 'PAGE_NOT_CONFIGURED',
    COUNTRY_NOT_SUPPORTED: 'COUNTRY_NOT_SUPPORTED',
    COUNTRY_AND_EDITION_CONFLICT: 'COUNTRY_AND_EDITION_CONFLICT'
};
// TODO: This could be something more elegant, like a bucket for the linear channels
var ERROR_PAGE_RESPONSE = {
    page: {
        error: {
            errorCode: ERROR_CODES.GENERIC_ERROR,
            message: 'Page data not found'
        }
    }
};

var DEFAULT_CONFIGURATION = {
    paths: {
        base: '/api/product/{version}/watchespn/web',
        home: '/api/product/{version}/watchespn/web/home',
        event: '/api/product/{version}/watchespn/web/event',
        video: '/api/product/{version}/watchespn/web/video'
    }
};

var config = _extends({}, DEFAULT_CONFIGURATION, pageApiConfig);

var getServiceUrl = function getServiceUrl() {
    var env = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ApiEnv.PROD;

    return Object(__WEBPACK_IMPORTED_MODULE_4__url_adapter_toAbsoluteURL__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__constants__["n" /* PRODUCT_API_CONFIGURATION */][env].serviceUrl);
};

var getPath = function getPath() {
    var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'base';
    var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'v3';

    return '' + config.paths[path].replace('{version}', version);
};

var getPageBaseUrl = function getPageBaseUrl() {
    var env = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ApiEnv.PROD;
    var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'v3';

    return '' + getServiceUrl(env) + getPath('base', version);
};

function getPageApiUrl(params) {
    var name = params.name,
        qs = params.qs,
        apiEnv = params.apiEnv,
        apiVersion = params.apiVersion,
        pathParamsArg = params.pathParamsArg;
    /**
     * Jira ticket: WEWEB-2141
     * Please see comments in refreshBuckets where pageName has been overridden to be correct page name
     * refreshBuckets is called when user is logged in which is triggered down getPage being called.
     * When user logged in to collection page, pageApi url returns ".../collection/5060?..."
     * and causes 404 from the api. We need to update name from 'collection' to 'bucket' and append 
     * bucketId in the url
     */

    if (name === 'bucket' && pathParamsArg) {
        return getPageBaseUrl(apiEnv, apiVersion) + '/' + name + qs + '&bucketId=' + pathParamsArg;
    }

    var type = name;
    if (catalogPageTypes.has(name)) {
        type = 'catalog';
    }
    var pathParams = pathParamsArg ? '/' + pathParamsArg : '';
    return getPageBaseUrl(apiEnv, apiVersion) + '/' + type + pathParams + qs;
}

function getPage(_ref) {
    var apiEnv = _ref.apiEnv,
        apiVersion = _ref.apiVersion,
        authStates = _ref.authStates,
        authNetworks = _ref.authNetworks,
        entitlements = _ref.entitlements,
        favoriteTeam = _ref.favoriteTeam,
        favoriteSport = _ref.favoriteSport,
        countryCode = _ref.countryCode,
        _ref$deviceType = _ref.deviceType,
        deviceType = _ref$deviceType === undefined ? __WEBPACK_IMPORTED_MODULE_9__enums__["q" /* Device */].DESKTOP : _ref$deviceType,
        zipcode = _ref.zipcode,
        pathParamsArg = _ref.pathParams,
        lang = _ref.lang,
        tz = _ref.tz,
        name = _ref.name,
        packageId = _ref.packageId,
        tier = _ref.tier,
        edition = _ref.edition,
        sessionToken = _ref.sessionToken,
        features = _ref.features;

    var isShortStopLive = name === 'shortstoplive';
    var ssBust = isShortStopLive ? Math.floor(Math.random() * 1000) : null;
    var qs = Object(__WEBPACK_IMPORTED_MODULE_3__format_queryString__["a" /* default */])({
        authStates: authStates,
        authNetworks: authNetworks,
        entitlements: entitlements,
        favoriteTeam: favoriteTeam,
        favoriteSport: favoriteSport,
        lang: lang,
        tz: tz,
        deviceType: deviceType,
        ssBust: ssBust,
        countryCode: countryCode,
        zipcode: zipcode,
        packageId: packageId,
        tier: tier,
        edition: edition,
        features: features
    });

    var url = getPageApiUrl({ name: name, qs: qs, apiEnv: apiEnv, apiVersion: apiVersion, pathParamsArg: pathParamsArg });

    log.debug('getPage: ' + url);

    return __WEBPACK_IMPORTED_MODULE_6__cache_requestCache__["a" /* default */].get(url).set('Accept-Language', lang + '-' + countryCode).set('dss-session-token', sessionToken).expiration(isShortStopLive ? 0 : DEFAULT_EXPIRATION).use(__WEBPACK_IMPORTED_MODULE_7__requestProxy__["a" /* default */]).timeout(DEFAULT_TIMEOUT).then(function (_ref2) {
        var body = _ref2.body;

        __WEBPACK_IMPORTED_MODULE_8__cache_fallbackCache__["a" /* default */].set(url, body);
        return body;
    }).catch(function (err) {
        log.error('getPage: ' + url, err.status);
        __WEBPACK_IMPORTED_MODULE_5__metrics_newRelicEventBus__["b" /* newRelicEmitter */].emit(__WEBPACK_IMPORTED_MODULE_5__metrics_newRelicEventBus__["a" /* UNFULFILLED_PROMISE_EVENT */], err);
        if (err.status >= 400 && err.status < 500) {
            return err.body && err.body.page && err.body.page.error ? err.body : ERROR_PAGE_RESPONSE;
        }
        return __WEBPACK_IMPORTED_MODULE_8__cache_fallbackCache__["a" /* default */].get(url).then(function (response) {
            return response || undefined;
        });
    });
}

function getEvent(_ref3) {
    var apiEnv = _ref3.apiEnv,
        apiVersion = _ref3.apiVersion,
        countryCode = _ref3.countryCode,
        authStates = _ref3.authStates,
        authNetworks = _ref3.authNetworks,
        entitlements = _ref3.entitlements,
        favoriteTeam = _ref3.favoriteTeam,
        favoriteSport = _ref3.favoriteSport,
        _ref3$deviceType = _ref3.deviceType,
        deviceType = _ref3$deviceType === undefined ? __WEBPACK_IMPORTED_MODULE_9__enums__["q" /* Device */].DESKTOP : _ref3$deviceType,
        zipcode = _ref3.zipcode,
        lang = _ref3.lang,
        tz = _ref3.tz,
        packageId = _ref3.packageId,
        tier = _ref3.tier,
        _ref3$query = _ref3.query,
        query = _ref3$query === undefined ? {} : _ref3$query,
        features = _ref3.features;

    // essentially our schema for event page requests
    var airingId = query.airingId,
        eventId = query.eventId,
        id = query.id,
        network = query.network,
        sourceLang = query.sourceLang,
        status = query.status;

    var eventQuery = { airingId: airingId, eventId: eventId, id: id, network: network, sourceLang: sourceLang, status: status };

    var qs = Object(__WEBPACK_IMPORTED_MODULE_3__format_queryString__["a" /* default */])(_extends({}, eventQuery, {
        authStates: authStates,
        authNetworks: authNetworks,
        entitlements: entitlements,
        favoriteTeam: favoriteTeam,
        favoriteSport: favoriteSport,
        lang: lang,
        tz: tz,
        deviceType: deviceType,
        countryCode: countryCode,
        zipcode: zipcode,
        packageId: packageId,
        tier: tier,
        features: features
    }));
    var url = '' + getServiceUrl(apiEnv) + getPath('event', apiVersion) + qs;

    if (!Object.keys(query || {}).length) {
        return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.reject(new Error('No query params to get an event.'));
    }

    log.debug('getEvent: ' + url);

    return __WEBPACK_IMPORTED_MODULE_6__cache_requestCache__["a" /* default */].get(url).set('Accept-Language', lang + '-' + countryCode).use(__WEBPACK_IMPORTED_MODULE_7__requestProxy__["a" /* default */]).timeout(DEFAULT_TIMEOUT).then(function (_ref4) {
        var body = _ref4.body;

        __WEBPACK_IMPORTED_MODULE_8__cache_fallbackCache__["a" /* default */].set(url, body);
        return body;
    }).catch(function (err) {
        log.error('getEvent: ' + url, err.originalError);
        __WEBPACK_IMPORTED_MODULE_5__metrics_newRelicEventBus__["b" /* newRelicEmitter */].emit(__WEBPACK_IMPORTED_MODULE_5__metrics_newRelicEventBus__["a" /* UNFULFILLED_PROMISE_EVENT */], err);
        return __WEBPACK_IMPORTED_MODULE_8__cache_fallbackCache__["a" /* default */].get(url).then(function (response) {
            return response || undefined;
        });
    });
}

// video endpoint is slightly different and uses a path param
function getVideo(_ref5) {
    var apiEnv = _ref5.apiEnv,
        apiVersion = _ref5.apiVersion,
        countryCode = _ref5.countryCode,
        _ref5$deviceType = _ref5.deviceType,
        deviceType = _ref5$deviceType === undefined ? __WEBPACK_IMPORTED_MODULE_9__enums__["q" /* Device */].DESKTOP : _ref5$deviceType,
        authStates = _ref5.authStates,
        authNetworks = _ref5.authNetworks,
        entitlements = _ref5.entitlements,
        favoriteTeam = _ref5.favoriteTeam,
        favoriteSport = _ref5.favoriteSport,
        lang = _ref5.lang,
        sourceLang = _ref5.sourceLang,
        tz = _ref5.tz,
        packageId = _ref5.packageId,
        tier = _ref5.tier,
        pathParamsArg = _ref5.pathParams,
        _ref5$query = _ref5.query,
        query = _ref5$query === undefined ? {} : _ref5$query,
        features = _ref5.features;

    var qs = Object(__WEBPACK_IMPORTED_MODULE_3__format_queryString__["a" /* default */])(_extends({}, query, {
        authStates: authStates,
        authNetworks: authNetworks,
        entitlements: entitlements,
        favoriteTeam: favoriteTeam,
        favoriteSport: favoriteSport,
        lang: lang,
        sourceLang: sourceLang,
        tz: tz,
        deviceType: deviceType,
        countryCode: countryCode,
        packageId: packageId,
        tier: tier,
        features: features
    }));
    var pathParams = pathParamsArg ? '/' + pathParamsArg : '';
    var url = '' + getServiceUrl(apiEnv) + getPath('video', apiVersion) + pathParams + qs;

    if (!pathParamsArg) {
        return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.reject(new Error('No params to get a video.'));
    }

    log.debug('getVideo: ' + url);

    return __WEBPACK_IMPORTED_MODULE_6__cache_requestCache__["a" /* default */].get(url).set('Accept-Language', lang + '-' + countryCode).use(__WEBPACK_IMPORTED_MODULE_7__requestProxy__["a" /* default */]).timeout(DEFAULT_TIMEOUT).then(function (_ref6) {
        var body = _ref6.body;

        __WEBPACK_IMPORTED_MODULE_8__cache_fallbackCache__["a" /* default */].set(url, body);
        return body;
    }).catch(function (err) {
        log.error('getVideo: ' + url, err);
        __WEBPACK_IMPORTED_MODULE_5__metrics_newRelicEventBus__["b" /* newRelicEmitter */].emit(__WEBPACK_IMPORTED_MODULE_5__metrics_newRelicEventBus__["a" /* UNFULFILLED_PROMISE_EVENT */], err);
        return __WEBPACK_IMPORTED_MODULE_8__cache_fallbackCache__["a" /* default */].get(url).then(function (response) {
            return response || undefined;
        });
    });
}

function getBucketPage(_ref7) {
    var apiEnv = _ref7.apiEnv,
        apiVersion = _ref7.apiVersion,
        authStates = _ref7.authStates,
        authNetworks = _ref7.authNetworks,
        entitlements = _ref7.entitlements,
        favoriteTeam = _ref7.favoriteTeam,
        favoriteSport = _ref7.favoriteSport,
        bucketId = _ref7.bucketId,
        countryCode = _ref7.countryCode,
        _ref7$deviceType = _ref7.deviceType,
        deviceType = _ref7$deviceType === undefined ? __WEBPACK_IMPORTED_MODULE_9__enums__["q" /* Device */].DESKTOP : _ref7$deviceType,
        zipcode = _ref7.zipcode,
        groupId = _ref7.groupId,
        ignores = _ref7.ignores,
        lang = _ref7.lang,
        tz = _ref7.tz,
        packageId = _ref7.packageId,
        tier = _ref7.tier,
        sessionToken = _ref7.sessionToken,
        features = _ref7.features;

    var qs = Object(__WEBPACK_IMPORTED_MODULE_3__format_queryString__["a" /* default */])({
        authStates: authStates,
        authNetworks: authNetworks,
        entitlements: entitlements,
        favoriteTeam: favoriteTeam,
        favoriteSport: favoriteSport,
        bucketId: bucketId,
        countryCode: countryCode,
        deviceType: deviceType,
        zipcode: zipcode,
        groupId: groupId,
        ignores: ignores,
        lang: lang,
        tz: tz,
        packageId: packageId,
        tier: tier,
        features: features
    });

    var url = getPageBaseUrl(apiEnv, apiVersion) + '/bucket' + qs;

    log.debug('getBucketPage: ' + url);

    return __WEBPACK_IMPORTED_MODULE_6__cache_requestCache__["a" /* default */].get(url).set('Accept-Language', lang + '-' + countryCode).set('dss-session-token', sessionToken).use(__WEBPACK_IMPORTED_MODULE_7__requestProxy__["a" /* default */]).timeout(DEFAULT_TIMEOUT).then(function (_ref8) {
        var body = _ref8.body;

        __WEBPACK_IMPORTED_MODULE_8__cache_fallbackCache__["a" /* default */].set(url, body);
        return body;
    }).catch(function (err) {
        log.error('getBucketPage: ' + url, err.message);
        __WEBPACK_IMPORTED_MODULE_5__metrics_newRelicEventBus__["b" /* newRelicEmitter */].emit(__WEBPACK_IMPORTED_MODULE_5__metrics_newRelicEventBus__["a" /* UNFULFILLED_PROMISE_EVENT */], err);
        return __WEBPACK_IMPORTED_MODULE_8__cache_fallbackCache__["a" /* default */].get(url).then(function (response) {
            return response || undefined;
        });
    });
}

// #TODO: check the format of the url param and reject if invalid
function getPageByFullUrl(_ref9) {
    var countryCode = _ref9.countryCode,
        _ref9$deviceType = _ref9.deviceType,
        deviceType = _ref9$deviceType === undefined ? __WEBPACK_IMPORTED_MODULE_9__enums__["q" /* Device */].DESKTOP : _ref9$deviceType,
        urlArg = _ref9.url,
        sessionToken = _ref9.sessionToken,
        features = _ref9.features;

    var qs = Object(__WEBPACK_IMPORTED_MODULE_3__format_queryString__["a" /* default */])({ deviceType: deviceType, countryCode: countryCode, features: features });
    var url = '' + urlArg + qs;

    log.debug('getUrl: ' + url);

    if (url) {
        return __WEBPACK_IMPORTED_MODULE_6__cache_requestCache__["a" /* default */].get(url).use(__WEBPACK_IMPORTED_MODULE_7__requestProxy__["a" /* default */]).set('dss-session-token', sessionToken).timeout(DEFAULT_TIMEOUT).then(function (_ref10) {
            var body = _ref10.body;

            __WEBPACK_IMPORTED_MODULE_8__cache_fallbackCache__["a" /* default */].set(url, body);
            return body;
        }).catch(function (err) {
            log.error('getUrl: ' + url, err.status);
            __WEBPACK_IMPORTED_MODULE_5__metrics_newRelicEventBus__["b" /* newRelicEmitter */].emit(__WEBPACK_IMPORTED_MODULE_5__metrics_newRelicEventBus__["a" /* UNFULFILLED_PROMISE_EVENT */], err);
            if (err.status === 404) {
                return ERROR_PAGE_RESPONSE;
            }
            return __WEBPACK_IMPORTED_MODULE_8__cache_fallbackCache__["a" /* default */].get(url).then(function (response) {
                return response || undefined;
            });
        });
    }
    return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.reject(new Error('No url supplied'));
}

function getPlaybackMeta(urlArg) {
    var url = urlArg;
    // Replacing the playback url with https due to server side making request with http and dehydrated to the client side.
    if (true && url.indexOf('http://') === 0) {
        url = url.replace('http://', 'https://');
    }

    log.debug('getPlaybackMeta: ' + url);

    return __WEBPACK_IMPORTED_MODULE_6__cache_requestCache__["a" /* default */].get('' + url + (url.indexOf('?') === -1 ? '?' : '&') + 'rand=' + Date.now()).expiration(0).use(__WEBPACK_IMPORTED_MODULE_7__requestProxy__["a" /* default */]).timeout(DEFAULT_TIMEOUT).then(function (_ref11) {
        var body = _ref11.body;

        __WEBPACK_IMPORTED_MODULE_8__cache_fallbackCache__["a" /* default */].set(url, body);
        return body;
    }).catch(function (err) {
        log.error('getPlaybackMeta: ' + url, err.originalError);
        __WEBPACK_IMPORTED_MODULE_5__metrics_newRelicEventBus__["b" /* newRelicEmitter */].emit(__WEBPACK_IMPORTED_MODULE_5__metrics_newRelicEventBus__["a" /* UNFULFILLED_PROMISE_EVENT */], err);
        return __WEBPACK_IMPORTED_MODULE_8__cache_fallbackCache__["a" /* default */].get(url).then(function (response) {
            return response || undefined;
        });
    });
}

function getCategories() {
    var apiEnv = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ApiEnv.PROD;
    var _ref12 = arguments[1];
    var _ref12$countryCode = _ref12.countryCode,
        countryCode = _ref12$countryCode === undefined ? 'US' : _ref12$countryCode,
        _ref12$lang = _ref12.lang,
        lang = _ref12$lang === undefined ? 'en' : _ref12$lang;

    var qs = Object(__WEBPACK_IMPORTED_MODULE_3__format_queryString__["a" /* default */])({ countryCode: countryCode, lang: lang });
    var url = getServiceUrl(apiEnv) + '/api/product/v3/watchespn/web/collection/alias/schedule_categories' + qs;
    return Object(__WEBPACK_IMPORTED_MODULE_6__cache_requestCache__["a" /* default */])(url).use(__WEBPACK_IMPORTED_MODULE_7__requestProxy__["a" /* default */]).then(function (response) {
        var categories = response.body.nodes || [];
        __WEBPACK_IMPORTED_MODULE_8__cache_fallbackCache__["a" /* default */].set(url, categories);
        return categories;
    }).catch(function (err) {
        log.error('getCategories:', err.originalError);
        return __WEBPACK_IMPORTED_MODULE_8__cache_fallbackCache__["a" /* default */].get(url);
    });
}

function getNetworks() {
    var apiEnv = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ApiEnv.PROD;
    var _ref13 = arguments[1];
    var _ref13$countryCode = _ref13.countryCode,
        countryCode = _ref13$countryCode === undefined ? 'US' : _ref13$countryCode,
        _ref13$lang = _ref13.lang,
        lang = _ref13$lang === undefined ? 'en' : _ref13$lang;

    var qs = Object(__WEBPACK_IMPORTED_MODULE_3__format_queryString__["a" /* default */])({ countryCode: countryCode, lang: lang });
    var url = getServiceUrl(apiEnv) + '/api/product/v3/watchespn/web/collection/alias/schedule_networks' + qs;
    return Object(__WEBPACK_IMPORTED_MODULE_6__cache_requestCache__["a" /* default */])(url).use(__WEBPACK_IMPORTED_MODULE_7__requestProxy__["a" /* default */]).then(function (response) {
        var networks = response.body.nodes || [];
        __WEBPACK_IMPORTED_MODULE_8__cache_fallbackCache__["a" /* default */].set(url, networks);
        return networks;
    }).catch(function (err) {
        log.error('getNetworks:', err.originalError);
        return __WEBPACK_IMPORTED_MODULE_8__cache_fallbackCache__["a" /* default */].get(url);
    });
}

function getPickerStreams(url) {
    if (url && typeof url === 'string') {
        if (window.location.protocol === 'https:') {
            url = url.replace('http://', 'https://');
        }
        return __WEBPACK_IMPORTED_MODULE_6__cache_requestCache__["a" /* default */].get(url).use(__WEBPACK_IMPORTED_MODULE_7__requestProxy__["a" /* default */]).timeout(DEFAULT_TIMEOUT).then(function (_ref14) {
            var body = _ref14.body;

            __WEBPACK_IMPORTED_MODULE_8__cache_fallbackCache__["a" /* default */].set(url, body);
            return body;
        }).catch(function (err) {
            log.error('getPicker: ' + url, err.originalError);
            __WEBPACK_IMPORTED_MODULE_5__metrics_newRelicEventBus__["b" /* newRelicEmitter */].emit(__WEBPACK_IMPORTED_MODULE_5__metrics_newRelicEventBus__["a" /* UNFULFILLED_PROMISE_EVENT */], err);
            return __WEBPACK_IMPORTED_MODULE_8__cache_fallbackCache__["a" /* default */].get(url).then(function (response) {
                return response || undefined;
            });
        });
    }
}

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(299),
    baseIteratee = __webpack_require__(113),
    toInteger = __webpack_require__(317);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(130),
    stackClear = __webpack_require__(638),
    stackDelete = __webpack_require__(639),
    stackGet = __webpack_require__(640),
    stackHas = __webpack_require__(641),
    stackSet = __webpack_require__(642);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 210 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable no-unused-vars */

/**
 * Abstract Authenticator class.
 * @class Authenticator
 */
function Authenticator() {
  if (!(this instanceof Authenticator)) {
    return new Authenticator();
  }
}

/**
 * initializes the Authenticator
 */
Authenticator.prototype.initialize = function initialize(callback) {};

/**
 * returns the authentication status
 * @abstract
 * @returns {Boolean}
 */
Authenticator.prototype.isAuthenticated = function isAuthenticated() {
  return false;
};

/**
 * check if the user is authenticated
 * @abstract
 * @param {Authenticator~checkAuthenticationCallback} callback -
 *     The callback to be executed when authentication is complete.
 * @returns {Promise.<Boolean>} - A Promise that will be resolved with a Boolean
 * value indicating the authentication status.
 */
Authenticator.prototype.checkAuthentication = function checkAuthentication(callback) {
  throw new Error('checkAuthentication is not implemented.');
};

/**
 * Authenticate the user
 * @abstract
 * @param {Object} identity - The identity to be authenticated.
 * @param {Authenticator~authenticateCallback} callback -
 *     The callback to be executed when authentication is complete.
 * @returns {Promise.<Boolean>} - A Promise that will be resolved with a Boolean
 * value indicating the authentication status.
 */
Authenticator.prototype.authenticate = function authenticate(identity, callback) {
  throw new Error('authenticate is not implemented.');
};

/**
 * Deauthenticate the user
 * @abstract
 * @param {Authenticator~deauthenticateCallback} callback -
 *     The callback to be executed when deauthentication is complete.
 * @returns {Promise.<Boolean>}
 */
Authenticator.prototype.deauthenticate = function deauthenticate(callback) {
  throw new Error('deauthenticate is not implemented.');
};

/**
 * Retrieve the current authentication information.
 * Response will be null if the identity has not be authenticated.
 * @abstract
 * @param {Authenticator~getAuthenticationInfoCallback} callback -
 *     The callback to be executed when the authentication info has been retrieved.
 * @returns {Promise.<Object>}
 */
Authenticator.prototype.getAuthenticationInfo = function getAuthenticationInfo(callback) {
  throw new Error('getAuthenticationInfo is not implemented.');
};

exports.default = Authenticator;
module.exports = exports['default'];

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = scoreAll;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__page_actions__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scheduleModule_actions__ = __webpack_require__(63);




function scoreAll() {
    // eslint-disable-line
    return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.all([dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__page_actions__["n" /* completePageLoad */])()), dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__scheduleModule_actions__["e" /* scoreScheduleModule */])())]);
    };
}

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PlayerTech; });
var PlayerTech = {
    BAM: 'bam',
    BRIGHTCOVE: 'brightcove'
};

/* unused harmony default export */ var _unused_webpack_default_export = ({
    PlayerTech: PlayerTech
});

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_eventemitter3__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_eventemitter3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_eventemitter3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bluebird__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bluebird__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable class-methods-use-this */



var PlayerBase = function (_EventEmitter) {
    _inherits(PlayerBase, _EventEmitter);

    function PlayerBase() {
        _classCallCheck(this, PlayerBase);

        return _possibleConstructorReturn(this, (PlayerBase.__proto__ || Object.getPrototypeOf(PlayerBase)).apply(this, arguments));
    }

    _createClass(PlayerBase, [{
        key: 'create',
        value: function create(options) {
            return __WEBPACK_IMPORTED_MODULE_1_bluebird___default.a.resolve(options);
        }
    }, {
        key: 'insert',
        value: function insert() {
            return __WEBPACK_IMPORTED_MODULE_1_bluebird___default.a.resolve();
        }
    }, {
        key: 'delete',
        value: function _delete() {
            return __WEBPACK_IMPORTED_MODULE_1_bluebird___default.a.resolve();
        }
    }, {
        key: 'play',
        value: function play() {
            return __WEBPACK_IMPORTED_MODULE_1_bluebird___default.a.resolve();
        }
    }, {
        key: 'pause',
        value: function pause() {
            return __WEBPACK_IMPORTED_MODULE_1_bluebird___default.a.resolve();
        }
    }, {
        key: 'mute',
        value: function mute() {
            return __WEBPACK_IMPORTED_MODULE_1_bluebird___default.a.resolve();
        }
    }, {
        key: 'unmute',
        value: function unmute() {
            return __WEBPACK_IMPORTED_MODULE_1_bluebird___default.a.resolve();
        }
    }, {
        key: 'error',
        value: function error() {
            return __WEBPACK_IMPORTED_MODULE_1_bluebird___default.a.resolve();
        }
    }, {
        key: 'getPlayerConfigs',
        value: function getPlayerConfigs() {
            return __WEBPACK_IMPORTED_MODULE_1_bluebird___default.a.resolve();
        }
    }, {
        key: 'updatePlayerConfigs',
        value: function updatePlayerConfigs(newConfigs) {
            return __WEBPACK_IMPORTED_MODULE_1_bluebird___default.a.resolve(newConfigs);
        }
    }, {
        key: 'getGeoLocation',
        value: function getGeoLocation() {
            return __WEBPACK_IMPORTED_MODULE_1_bluebird___default.a.resolve();
        }
    }]);

    return PlayerBase;
}(__WEBPACK_IMPORTED_MODULE_0_eventemitter3___default.a);

/* harmony default export */ __webpack_exports__["a"] = (PlayerBase);

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/jwt-decode/lib/index.js
var lib = __webpack_require__(684);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./app/lib/auth/jwtDecodeToken.js
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



function jwtDecodeToken() {
    var token = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var res = {};
    try {
        // need replace the Bearer header to avoid Uncaught InvalidTokenError {message: "Invalid token specified: Cannot read property 'replace' of undefined"}       
        var jwtToken = lib_default()(token.replace('Bearer ', ''));
        if ((typeof jwtToken === 'undefined' ? 'undefined' : _typeof(jwtToken)) === 'object') {
            res = { jwtToken: jwtToken, decodeSuccess: true };
        }
    } catch (e) {
        res = { decodeSuccess: false, decodeErr: e };
    }
    return res;
};
// EXTERNAL MODULE: ./app/enums.js
var enums = __webpack_require__(1);

// CONCATENATED MODULE: ./app/lib/auth/hasTDA.js
/* harmony export (immutable) */ __webpack_exports__["a"] = hasTDA;



function hasTDA(bamSessionToken) {
    var res = jwtDecodeToken(bamSessionToken);
    if (res.decodeSuccess) {
        var _ref = res.jwtToken || {},
            _ref$context = _ref.context;

        _ref$context = _ref$context === undefined ? {} : _ref$context;
        var _ref$context$subscrip = _ref$context.subscriptions,
            subscriptions = _ref$context$subscrip === undefined ? [] : _ref$context$subscrip;

        var _hasTDA = subscriptions.some(function (sub) {
            return sub.entitlements.some(function (val) {
                return val === enums["s" /* Entitlements */].ESPN_TDA;
            });
        });
        if (_hasTDA) {
            return true;
        }
    }
    return false;
}

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export START_GET_FAN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COMPLETE_GET_FAN; });
/* unused harmony export startGetFan */
/* unused harmony export completeGetFan */
/* unused harmony export getFan */
/* harmony export (immutable) */ __webpack_exports__["b"] = createSmartFanAction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_watch_fanapi__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_watch_fanapi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_watch_fanapi__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectors_fanSelector__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__oneIdActions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_util_isEmpty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_util_perf__ = __webpack_require__(75);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }








var START_GET_FAN = 'START_GET_FAN';
var COMPLETE_GET_FAN = 'COMPLETE_GET_FAN';

var fanApi = new __WEBPACK_IMPORTED_MODULE_0_watch_fanapi___default.a({ sourceHeader: 'espncom-watch' });

function startGetFan() {
    return {
        type: START_GET_FAN,
        startTime: Date.now()
    };
}

function completeGetFan(fan) {
    return {
        type: COMPLETE_GET_FAN,
        completeTime: Date.now(),
        fan: fan
    };
}

function getFan(swid) {
    return function (dispatch) {
        dispatch(startGetFan());
        return fanApi.getFanForId(swid).then(function (fan) {
            dispatch(completeGetFan(fan));
            return fan;
        }).catch(function () {
            dispatch(completeGetFan({}));
            return {};
        });
    };
}

function createSmartFanAction() {
    var _this = this;

    return function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
            var fan, _getState, _getState$oneId, isLoggedIn, _getState2, _getState2$oneId, swid;

            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            __WEBPACK_IMPORTED_MODULE_4__lib_util_perf__["a" /* markStart */]('createSmartFanAction');
                            fan = Object(__WEBPACK_IMPORTED_MODULE_1__selectors_fanSelector__["a" /* default */])(getState());

                            if (!Object(__WEBPACK_IMPORTED_MODULE_3__lib_util_isEmpty__["a" /* default */])(fan)) {
                                _context.next = 17;
                                break;
                            }

                            _getState = getState(), _getState$oneId = _getState.oneId;
                            _getState$oneId = _getState$oneId === undefined ? {} : _getState$oneId;
                            isLoggedIn = _getState$oneId.isLoggedIn;

                            if (isLoggedIn) {
                                _context.next = 10;
                                break;
                            }

                            _context.next = 9;
                            return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__oneIdActions__["h" /* checkSWIDAuthentication */])());

                        case 9:
                            isLoggedIn = _context.sent;

                        case 10:
                            if (!isLoggedIn) {
                                _context.next = 17;
                                break;
                            }

                            _getState2 = getState(), _getState2$oneId = _getState2.oneId;
                            _getState2$oneId = _getState2$oneId === undefined ? {} : _getState2$oneId;
                            swid = _getState2$oneId.swid;
                            _context.next = 16;
                            return dispatch(getFan(swid));

                        case 16:
                            fan = _context.sent;

                        case 17:
                            __WEBPACK_IMPORTED_MODULE_4__lib_util_perf__["b" /* measureAndTime */]('createSmartFanAction');
                            return _context.abrupt('return', fan);

                        case 19:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function (_x, _x2) {
            return _ref.apply(this, arguments);
        };
    }();
}

/**
 Update the "uid" in the preferences for this fan to test scoring
 */
//  const myFan = {
//    "id":"{AEDB5BCC-173D-49BD-9B0B-77DFD5964C19}",
//    "profile":{
//       "createDate":1422286205898,
//       "lastUpdateDate":1502446881443,
//       "lastUpdateSource":"fuse-v2-batch",
//       "isInsider":true,
//       "gender":"M",
//       "hasNotificationPreferences":false,
//       "useSortGlobal":true,
//       "age":30,
//       "countryCode":"US",
//       "postalCode":"11501",
//       "dmaId":"501",
//       "registrationSource":"espn_video",
//       "registrationDate":1271055600000
//    },
//    "lastAccessDate":"2017-08-11T18:56:19Z",
//    "createDate":"2010-07-21T02:33:45Z",
//    "lastUpdateDate":"2017-08-11T22:23:27Z",
//    "createSource":null,
//    "lastUpdateSource":"ESPN.com - FAM",
//    "lastAccessSource":"ESPN.com - FAM",
//    "preferences":[
//        {
//             "id": "14315045-A46A-478F-BEAE-8ACD3F36B8CD",
//             "createDate": 1502490872419,
//             "createSource": "ESPN.com - FAM",
//             "metaData": {
//                 "sportId": "54",
//                 "teamId": "251",
//                 "team": {
//                     "uid": "s:600~l:602"
//                 }
//             },
//             "sortGlobal": 109
//        }
//    ]
// };

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./app/lib/util/concatAll.js
function concatAll() {
    var theArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var results = [];
    theArray.forEach(function (subArray) {
        subArray.forEach(function (value) {
            results.push(value);
        });
    });
    return results;
}
// CONCATENATED MODULE: ./app/webapp/player/util/getContentPlaylistFromBuckets.js


// creates an array of arrays of content (only if content exists in that bucket)
// flattens that array of arrays using "concatAll"

function getContentPlaylistFromBuckets() {
    var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var buckets = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    var contentIndex = 0; // this should really never be used, but default to 0
    // if there are no buckets, create a single item playlist of the content
    if (buckets.length === 0) {
        return [{
            id: content.guid,
            headline: content.name,
            poster: content.imageHref
        }];
    }
    return concatAll(buckets.filter(function (bucket) {
        var contains = false;
        bucket.contents.forEach(function (bucketContent, index) {
            if (bucketContent.id === content.id) {
                if (content.bucketName) {
                    if (content.bucketName === bucket.name) {
                        contains = true;
                        contentIndex = index;
                    }
                } else {
                    contains = true;
                    contentIndex = index;
                }
            }
        });
        return contains;
    }).map(function (bucket) {
        return bucket.contents.slice(contentIndex, bucket.contents.length).map(function (bucketContent) {
            var _bucketContent$guid = bucketContent.guid,
                id = _bucketContent$guid === undefined ? null : _bucketContent$guid,
                _bucketContent$name = bucketContent.name,
                headline = _bucketContent$name === undefined ? null : _bucketContent$name,
                _bucketContent$imageH = bucketContent.imageHref,
                poster = _bucketContent$imageH === undefined ? null : _bucketContent$imageH;

            if (id && headline && poster) {
                return {
                    id: id,
                    headline: headline,
                    poster: poster
                };
            }
            return {};
        });
    }));
}
// EXTERNAL MODULE: ./app/enums.js
var enums = __webpack_require__(1);

// EXTERNAL MODULE: ./app/constants.js
var constants = __webpack_require__(8);

// CONCATENATED MODULE: ./app/webapp/player/util/getAdobeDCRConfig.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var getAdobeDCRConfig = (function (nielsenTrackingData) {
    var moreCustomMetadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var env = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : enums["c" /* AppEnvs */].prod;
    var player = arguments[3];
    var ReportSuite = nielsenTrackingData.ReportSuite;

    delete nielsenTrackingData.ReportSuite;

    var apid = constants["k" /* NIELSEN_APPID_TVE */];
    if (player === 'bam') {
        apid = constants["j" /* NIELSEN_APPID_EPLUS */];
    }

    var isSecureProtocol = window && window.location && window.location.protocol && window.location.protocol.indexOf('https') > -1;

    var data = {
        APP_MEASUREMENT: {
            RSID: '' + ReportSuite + (env === enums["c" /* AppEnvs */].prod ? ',wdgespge' : ''),
            TRACKING_SERVER: isSecureProtocol ? 'sw88.espn.com' : 'w88.espn.com',
            TRACKING_SERVER_SECURE: 'sw88.espn.com'
        },
        ESPN_CUSTOM_METADATA: _extends({}, nielsenTrackingData, moreCustomMetadata),
        HEARTBEAT: {
            DEBUG_LOGGING: false
        },
        NIELSEN_DATA: {
            APP_INFO: {
                apid: apid,
                clientId: 'us-600140',
                sfcode: 'dcr',
                DEV: {
                    apid: apid,
                    clientId: 'us-600140',
                    sfcode: 'dcr'
                },
                PROD: {
                    apid: apid,
                    clientId: 'us-600140',
                    sfcode: 'dcr'
                }
            },
            CONTENT_METADATA: {
                segA: nielsenTrackingData.SegA,
                segC: nielsenTrackingData.SegC,
                isfullepisode: nielsenTrackingData.isfullepisode
            }
        }
    };
    return data;
});
// EXTERNAL MODULE: ./app/lib/auth/Authenticator.js
var Authenticator = __webpack_require__(319);

// EXTERNAL MODULE: ./app/lib/auth/streamHasAuthType.js
var streamHasAuthType = __webpack_require__(45);

// EXTERNAL MODULE: ./app/lib/api/PageAPI.js
var PageAPI = __webpack_require__(207);

// EXTERNAL MODULE: ./app/lib/util/localStorage.js
var localStorage = __webpack_require__(44);

// CONCATENATED MODULE: ./app/webapp/player/util/getPrerollSetting.js
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



function initializePrerollHistory() {
    if (!Object(localStorage["b" /* getSessionItem */])('playedItems')) {
        Object(localStorage["e" /* setSessionItem */])('playedItems', []);
    }
}

/**
 * getPrerollSetting - Returns a boolean flag used to set `opts.preroll` in player options.
 * If `savePrerollHistory` is defined along with the `contentId` parameter,
 * this function will initialize played items session storage to keep track of already played streams.
 * If a stream has been played (stored in storage), it will return false to avoid preroll.
 *
 * @param {object} prerollConfig = {} - Object containing contentType specific preroll properties such
 * as `enablePreroll` and `savePrerollHistory`.
 * @param {string} contentId - contentId of the given stream to be played
 *
 * @return {boolean}
 */
/* harmony default export */ var getPrerollSetting = (function () {
    var prerollConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var contentId = arguments[1];
    var _prerollConfig$savePr = prerollConfig.savePrerollHistory,
        savePrerollHistory = _prerollConfig$savePr === undefined ? false : _prerollConfig$savePr,
        _prerollConfig$enable = prerollConfig.enablePreroll,
        enablePreroll = _prerollConfig$enable === undefined ? false : _prerollConfig$enable;


    if (savePrerollHistory && typeof contentId === 'string' && contentId.trim() !== '') {
        initializePrerollHistory();
        var playedItemsInSession = Object(localStorage["b" /* getSessionItem */])('playedItems');

        if (playedItemsInSession.indexOf(contentId) === -1) {
            Object(localStorage["e" /* setSessionItem */])('playedItems', [].concat(_toConsumableArray(playedItemsInSession), [contentId]));
            return true;
        }

        return false;
    }

    return enablePreroll;
});
// EXTERNAL MODULE: ./app/lib/util/isEmpty.js
var isEmpty = __webpack_require__(12);

// EXTERNAL MODULE: ./app/lib/util/getDeviceTypeFromUA.js
var getDeviceTypeFromUA = __webpack_require__(326);

// EXTERNAL MODULE: ./app/lib/util/isSafariBrowser.js
var isSafariBrowser = __webpack_require__(327);

// CONCATENATED MODULE: ./app/lib/util/getSiteSectionId.js
/**
 * getSiteSectionId - Returns a properly formatted string representing the site section id for BrightCove Player
 *
 * @param {string} platformType - String parameter representing the platform (i.e. android, ios, unknown)
 * @param {string}   deviceType - String parameter representing the device type (i.e. desktop, tablet, handset)
 * @param {string}   contentType - String parameter representing the content type (i.e. clips, vod)
 * @param {string}   rootName - Optional string parameter representing the root name assignment for the SSID; defaults to `watchespn`
 *
 * @return {string} - Concatenated string value generated by platform type, device type and content type.
 */
function getSiteSectionId() {
    var platformType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var deviceType = arguments[1];
    var contentType = arguments[2];
    var rootName = arguments[3];

    var ssid = typeof rootName === 'string' && rootName !== '' ? rootName : 'watchespn';

    // Client side user-agent detection is used for platformType;
    // unknown is the default assignment when no matches are found
    if (platformType !== '' && platformType !== 'unknown') {
        ssid = ssid + ':' + platformType;
    }

    if (typeof deviceType === 'string' && deviceType !== '') {
        ssid = ssid + ':' + deviceType;
    }

    if (typeof contentType === 'string' && contentType !== '') {
        ssid = ssid + ':' + contentType;
    }

    return ssid;
}
// EXTERNAL MODULE: ./app/lib/util/getAndroidVersionFromUserAgent.js
var getAndroidVersionFromUserAgent = __webpack_require__(328);

// CONCATENATED MODULE: ./app/lib/util/peak.js
function peak() {
    var theArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    if (theArray.length > 0) {
        return theArray[0];
    }
    return null;
};
// EXTERNAL MODULE: ./app/lib/util/getBamAuthConfig.js
var getBamAuthConfig = __webpack_require__(144);

// EXTERNAL MODULE: ./app/lib/util/sortByRank.js
var sortByRank = __webpack_require__(329);

// EXTERNAL MODULE: ./app/lib/util/getAdsConfigByEdition.js
var getAdsConfigByEdition = __webpack_require__(330);

// EXTERNAL MODULE: ./app/lib/util/getUpsellUrlsConfigByEdition.js
var getUpsellUrlsConfigByEdition = __webpack_require__(307);

// EXTERNAL MODULE: ./app/lib/util/getPrerollConfigByEdition.js
var getPrerollConfigByEdition = __webpack_require__(331);

// EXTERNAL MODULE: ./app/lib/util/getAdsConfigByAdProvider.js
var getAdsConfigByAdProvider = __webpack_require__(332);

// EXTERNAL MODULE: ./app/lib/util/hasTier.js
var hasTier = __webpack_require__(333);

// EXTERNAL MODULE: ./app/lib/util/hasObj.js
var hasObj = __webpack_require__(334);

// CONCATENATED MODULE: ./app/lib/util/index.js















// EXTERNAL MODULE: ./app/webapp/common/video-player/index.js + 1 modules
var video_player = __webpack_require__(115);

// CONCATENATED MODULE: ./app/webapp/player/util/getPlayerOptions.js
var _this = this;

var getPlayerOptions__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }












var ApiEnv = enums["b" /* Api */].Env;

var listing = void 0;

function isGoogleAdProvider(providerName) {
    return typeof providerName === 'string' && providerName.toLowerCase().indexOf('google') !== -1;
}

function appendToken(url) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        token = _ref.token,
        tokenType = _ref.tokenType,
        resource = _ref.resource;

    var apiKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : constants["p" /* SHIELD_API_KEY */];

    var newUrl = url;
    if (token && url && url.indexOf('startSession') === -1) {
        var tokenParam = '&token=' + token;
        var resourceParam = '';

        if (tokenType === 'ADOBEPASS') {
            tokenParam = '&adobeToken=' + token;
            resourceParam = '&adobeResource=' + resource;
        }

        // TODO: remove once `videoHref` points to `https`
        newUrl = newUrl.replace('http:', 'https:');
        newUrl += (newUrl.indexOf('?') === -1 ? '?' : '&') + 'apikey=' + apiKey + tokenParam + resourceParam;
    }

    return newUrl;
}

/* harmony default export */ var getPlayerOptions = (function (_ref2) {
    var apiEnv = _ref2.apiEnv,
        stream = _ref2.stream,
        _ref2$authorization = _ref2.authorization,
        authorization = _ref2$authorization === undefined ? {} : _ref2$authorization,
        streamlimiter = _ref2.streamlimiter,
        _ref2$nielsenTracking = _ref2.nielsenTrackingData,
        nielsenTrackingData = _ref2$nielsenTracking === undefined ? {} : _ref2$nielsenTracking,
        comscoreTrackingData = _ref2.comscoreTrackingData,
        _ref2$isMobile = _ref2.isMobile,
        isMobile = _ref2$isMobile === undefined ? false : _ref2$isMobile,
        device = _ref2.device,
        _ref2$error = _ref2.error,
        error = _ref2$error === undefined ? null : _ref2$error,
        env = _ref2.env,
        lang = _ref2.lang,
        _ref2$provider = _ref2.provider,
        provider = _ref2$provider === undefined ? {} : _ref2$provider,
        isDomestic = _ref2.isDomestic,
        social = _ref2.social,
        logo = _ref2.logo,
        settingsMenu = _ref2.settingsMenu,
        feedsMenu = _ref2.feedsMenu,
        userInitiated = _ref2.userInitiated,
        playbackMeta = _ref2.playbackMeta,
        prerollConfig = _ref2.prerollConfig,
        adsConfig = _ref2.adsConfig,
        _ref2$userAuth = _ref2.userAuth,
        userAuth = _ref2$userAuth === undefined ? [] : _ref2$userAuth,
        shieldApiKey = _ref2.shieldApiKey,
        _ref2$playerOpts = _ref2.playerOpts,
        playerOpts = _ref2$playerOpts === undefined ? {} : _ref2$playerOpts;
    var content = stream.content;
    var affiliate = provider.name;


    var autoplay = 'on';
    // always user initiated on mobile
    // TODO: perhaps Hero should be wrapped in connectPlayer as well as playable
    var wasUserInitiated = isMobile ? true : !!userInitiated;
    var conviva = null;

    var playerTech = Object(streamHasAuthType["a" /* default */])(stream, enums["e" /* AuthTypes */].BAM) ? video_player["a" /* default */].PlayerTech.BAM : video_player["a" /* default */].PlayerTech.BRIGHTCOVE;
    var analytics = {
        adobeDCR: getAdobeDCRConfig(nielsenTrackingData, {}, env, playerTech),
        comscore: comscoreTrackingData,
        chartbeat: {
            uid: '22222',
            domain: 'espn.com'
        }
    };

    // for easy debugging
    var opts = null;
    var auth = void 0;

    var authToken = authorization.token;
    if (authToken) {
        auth = {
            token: authorization.encoded ? authToken : window.btoa(unescape(encodeURIComponent(authToken))),
            resource: window.btoa(unescape(encodeURIComponent(authorization.resourceId || ''))),
            tokenType: authorization.tokenType || 'ADOBEPASS',
            partnerName: authorization.partnerName,
            userAuth: userAuth
        };
    }

    if (content.type === enums["o" /* ContentType */].VOD) {
        var moreOptions = {};
        if (stream.playlist && stream.playlist.length > 0) {
            moreOptions.playlist = stream.playlist;
        } else {
            moreOptions.clipId = stream.id;
        }

        if (env === enums["c" /* AppEnvs */].prod) {
            conviva = {
                customerKey: 'fc8dbfdc5da519f576628f619306a357f31bd006'
            };
        }

        opts = getPlayerOptions__extends({}, moreOptions, {
            affiliate: affiliate,
            language: lang,
            advertising: {
                siteSectionId: getSiteSectionId(Object(getDeviceTypeFromUA["a" /* default */])(), device, 'clips')
            },
            analytics: getPlayerOptions__extends({}, analytics, {
                conviva: conviva
            }),
            auth: auth,
            autoplay: autoplay,
            social: social,
            logo: logo,
            settingsMenu: settingsMenu,
            feedsMenu: feedsMenu,
            endcard: true,
            streamlimiter: streamlimiter,
            wasUserInitiated: wasUserInitiated
        });
    } else if (content.type === enums["o" /* ContentType */].LISTING) {
        var _stream$source = stream.source,
            sourceType = _stream$source.type,
            sourceId = _stream$source.id,
            id = stream.id,
            status = stream.status;

        var asset = {
            channelId: sourceId
        };
        if (sourceType === enums["E" /* SourceType */].ONLINE || status === enums["n" /* ContentStatus */].REPLAY) {
            asset.watchId = id;
        }

        if (env === enums["c" /* AppEnvs */].prod) {
            conviva = {
                customerKey: '766ee8daa5d5deaeeeab4481239072ea53f6f1cc'
            };
        }

        var api = apiEnv === ApiEnv.QA ? {
            WATCH_BASE_URL: '//broadband.espnqa.com/espn360/apis/v1/watch'
        } : {};

        opts = getPlayerOptions__extends({
            affiliate: affiliate,
            language: lang,
            autoplay: autoplay,
            social: social,
            logo: logo,
            settingsMenu: settingsMenu,
            feedsMenu: feedsMenu,
            advertising: {
                assetId: stream.id
            },
            analytics: getPlayerOptions__extends({}, analytics, {
                conviva: conviva
            }),
            api: api,
            wasUserInitiated: wasUserInitiated
        }, asset, {
            auth: auth,
            streamlimiter: streamlimiter,
            error: error
        });
    }

    if (!Object(isEmpty["a" /* default */])(prerollConfig)) {
        opts.preroll = getPrerollSetting(prerollConfig, content.id);
    }

    if (!opts) {
        return opts;
    }

    opts.api = opts.api || {};
    opts.api.shieldApiKey = shieldApiKey || constants["p" /* SHIELD_API_KEY */];

    var shouldOverrideListings = !error && stream.authTypes && stream.authTypes.length && stream.authTypes.some(function (authType) {
        return [enums["e" /* AuthTypes */].MVPD, enums["e" /* AuthTypes */].OPEN].indexOf(authType) > -1;
    }) && stream.links && stream.links.play;

    var initialPlaybackMeta = getPlayerOptions__extends({}, playbackMeta);

    var listings = shouldOverrideListings ? function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(callback) {
            var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var _opts, _opts$auth, tokenType, authenticator, _listing, adobeRSS, origVideoHref, response, token, resource, videoHref, _response, _ref4, playbackState, _adobeRSS, _ref5, _origVideoHref, _videoHref;

            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _opts = opts, _opts$auth = _opts.auth;
                            _opts$auth = _opts$auth === undefined ? {} : _opts$auth;
                            tokenType = _opts$auth.tokenType;

                            if (!(listing && context && tokenType === 'ADOBEPASS')) {
                                _context.next = 25;
                                break;
                            }

                            // the very initial Authenticator factory call sends the configuration
                            authenticator = Authenticator["a" /* default */].adobe();
                            _listing = listing, adobeRSS = _listing.adobeRSS, origVideoHref = _listing.origVideoHref;

                            if (adobeRSS) {
                                _context.next = 9;
                                break;
                            }

                            callback(null, listing);
                            return _context.abrupt('return');

                        case 9:
                            _context.prev = 9;
                            _context.next = 12;
                            return authenticator.authorize(adobeRSS);

                        case 12:
                            response = _context.sent;
                            token = window.btoa(unescape(encodeURIComponent(response.token)));
                            resource = window.btoa(unescape(encodeURIComponent(response.resourceId || '')));

                            opts.auth = { token: token, resource: resource, tokenType: tokenType };
                            videoHref = appendToken(origVideoHref, opts.auth, shieldApiKey);

                            listing = getPlayerOptions__extends({}, listing, { videoHref: videoHref });
                            callback(null, listing);
                            _context.next = 24;
                            break;

                        case 21:
                            _context.prev = 21;
                            _context.t0 = _context['catch'](9);

                            callback(_context.t0);

                        case 24:
                            return _context.abrupt('return');

                        case 25:
                            _context.prev = 25;

                            if (Object(isEmpty["a" /* default */])(initialPlaybackMeta)) {
                                _context.next = 30;
                                break;
                            }

                            _context.t1 = initialPlaybackMeta;
                            _context.next = 33;
                            break;

                        case 30:
                            _context.next = 32;
                            return Object(PageAPI["getPlaybackMeta"])(stream.links.play);

                        case 32:
                            _context.t1 = _context.sent;

                        case 33:
                            _response = _context.t1;

                            // `fallbackCache` returns `null` instead of `undefined`, so can't use default value
                            _ref4 = _response || {}, playbackState = _ref4.playbackState, _adobeRSS = _ref4.adobeRSS;
                            _ref5 = playbackState || {}, _origVideoHref = _ref5.videoHref;

                            if (_origVideoHref) {
                                _context.next = 39;
                                break;
                            }

                            callback('No playback URL found', null); // TODO: localize message or move this check in the player
                            return _context.abrupt('return');

                        case 39:
                            _videoHref = appendToken(_origVideoHref, opts.auth, shieldApiKey);

                            listing = getPlayerOptions__extends({}, playbackState, { origVideoHref: _origVideoHref, videoHref: _videoHref, adobeRSS: _adobeRSS });
                            initialPlaybackMeta = null;
                            callback(null, listing);
                            _context.next = 48;
                            break;

                        case 45:
                            _context.prev = 45;
                            _context.t2 = _context['catch'](25);

                            callback(_context.t2);

                        case 48:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this, [[9, 21], [25, 45]]);
        }));

        return function (_x4) {
            return _ref3.apply(this, arguments);
        };
    }() : null;

    var programChangePollingInterval = shouldOverrideListings && !isDomestic && stream.source.type === enums["E" /* SourceType */].LINEAR ? 60 * 1000 : null;

    // this won't technically happen right now,
    // but remove `playlist` and `clipId` so that `listings` value is respected in the player
    if (listings) {
        opts.playlist = null;
        opts.clipId = null;
    }

    // NOTE: The adsConfig is handled by the external app-configuration file via Bootstrap
    // See: https://code.espn.com/connected-devices/app-configurations/blob/master/configurations/watchespn-web-3.0.config.json
    if (!Object(isEmpty["a" /* default */])(adsConfig)) {
        var activeAdProvider = adsConfig.activeAdProvider,
            allowAdSkip = adsConfig.allowAdSkip,
            useNewUI = adsConfig.useNewUI,
            iphoneplaysinline = adsConfig.iphoneplaysinline;
        // NOTE: Sets the Ad Provider for the Player instance

        opts.adProviderOrder = activeAdProvider;
        opts.advertising.allowAdSkip = allowAdSkip;
        opts.advertising.useNewUI = useNewUI;
        opts.iphoneplaysinline = iphoneplaysinline;

        if (isGoogleAdProvider(activeAdProvider)) {
            var cmsid = adsConfig.cmsid,
                networkCode = adsConfig.networkCode,
                pp = adsConfig.pp,
                adUnit = adsConfig.adUnit;


            opts.advertising.googleIMA = function (options) {
                if (cmsid) {
                    options.cmsid = cmsid;
                }

                // NOTE: `adUnit` and `networkCode` will be used for MOAT tracking
                if (networkCode) {
                    options.networkCode = networkCode;
                }

                if (adUnit) {
                    options.adUnit = adUnit;
                }

                // NOTE: INTL editions will have `pp` property from config
                if (pp) {
                    options.pp = isMobile ? pp.mobile : pp.desktop;
                }

                return options;
            };

            if (content.type === enums["o" /* ContentType */].LISTING && opts.auth) {
                opts.auth.adEnv = env === enums["c" /* AppEnvs */].prod ? 'prod' : 'dev';
                opts.auth.adProvider = activeAdProvider;
            }
        }
    }

    opts.enableDRM = playerOpts.enableDRM;

    return getPlayerOptions__extends({}, opts, {
        listings: listings,
        programChangePollingInterval: programChangePollingInterval,
        newStreamPicker: true
    });
});
// EXTERNAL MODULE: ./app/lib/url-adapter/index.js + 4 modules
var url_adapter = __webpack_require__(335);

// CONCATENATED MODULE: ./app/webapp/player/util/getPlayerBackgroundStyle.js




function getPlayerBackgroundStyle(content) {
    if (!Object(isEmpty["a" /* default */])(content)) {
        var bgUrl = Object(url_adapter["a" /* getImageUrlWithParams */])(Object(url_adapter["b" /* removeDimensions */])(content.imageHref), { cquality: 40 });
        var backgroundImage = 'url(' + bgUrl + ')';
        return { backgroundImage: backgroundImage, backgroundSize: 'cover' };
    }
    return {};
}
// CONCATENATED MODULE: ./app/webapp/player/util/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return getAdobeDCRConfig; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return getContentPlaylistFromBuckets; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return getPlayerOptions; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return getPlayerBackgroundStyle; });
/* unused concated harmony import getPrerollSetting */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getPrerollSetting; });








/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__selectors_appSelector__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var AdContainer = function (_Component) {
    _inherits(AdContainer, _Component);

    function AdContainer(props) {
        _classCallCheck(this, AdContainer);

        // state is maintained by AdManager
        var _this = _possibleConstructorReturn(this, (AdContainer.__proto__ || Object.getPrototypeOf(AdContainer)).call(this, props));

        _this.state = {
            refreshed: false
        };
        return _this;
    }

    _createClass(AdContainer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (!this.props.disabled && this.context.watchAdManager) {
                this.context.watchAdManager.addInstance(this);
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            if (this.props.ads.id === nextProps.ads.id) {
                return false;
            }
            return true;
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (!this.props.disabled) {
                this.context.watchAdManager.removeInstance(this);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                collapseBeforeLoad = _props.collapseBeforeLoad,
                exclude = _props.exclude,
                id = _props.id,
                include = _props.include,
                inView = _props.inView,
                isOutOfPage = _props.isOutOfPage,
                kvps = _props.kvps,
                refreshWhenVisible = _props.refreshWhenVisible,
                slotType = _props.slotType,
                disabled = _props.disabled,
                render = _props.render;


            var slotKvps = [];
            var adProps = { id: id, key: id };

            /* no type no ad */
            if (disabled || slotType === null) {
                return null;
            }

            /* default if pos not specified */
            if (typeof kvps.pos === 'undefined') {
                kvps.pos = slotType;
            }

            /* build key value pair string */
            Object.keys(kvps).forEach(function (key) {
                if (key !== null && kvps.k !== null) {
                    slotKvps.push(key + '=' + kvps[key]);
                }
            });

            /* build up the div properties */
            adProps.className = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('react-ad', className, {
                'ad-slot': !inView
            });

            adProps['data-slot-type'] = slotType;

            if (isOutOfPage) {
                adProps['data-out-of-page'] = 'true';
            }

            if (collapseBeforeLoad) {
                adProps['data-collapse-before-load'] = 'true';
            }

            if (include.length > 0) {
                var includeStr = include.join(',');
                adProps['data-include-bp'] = includeStr;
            }

            if (exclude.length > 0) {
                var excludeStr = exclude.join(',');
                adProps['data-exclude-bp'] = excludeStr;
            }

            if (slotKvps.length > 0) {
                var kvpsStr = slotKvps.join(',');
                adProps['data-slot-kvps'] = kvpsStr;
            }

            if (refreshWhenVisible === false) {
                adProps['data-refresh-on-pageload'] = 'true';
            }

            return render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', _extends({ ref: 'adSlot' }, adProps)));
        }
    }]);

    return AdContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

AdContainer.defaultProps = {
    className: '',
    exclude: [],
    include: [],
    inView: false,
    kvps: {},
    refreshWhenVisible: false,
    slotType: null,
    disabled: false,
    render: function render(children) {
        return children;
    }
};

AdContainer.contextTypes = {
    watchAdManager: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object
};

var mapStateToProps = function mapStateToProps(state) {
    return {
        ads: state.ads,
        disabled: Object(__WEBPACK_IMPORTED_MODULE_3__selectors_appSelector__["r" /* isAdDisabled */])(state)
    };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(AdContainer));

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var DEFAULT_ICON = 'espn-default';

var Logo = function Logo(_ref) {
    var className = _ref.className,
        _ref$iconHref = _ref.iconHref,
        iconHref = _ref$iconHref === undefined ? DEFAULT_ICON : _ref$iconHref;

    if (iconHref.indexOf('http://') === -1) {
        return _jsx('div', {
            className: className + ' icon-font-before icon-' + (iconHref || DEFAULT_ICON) + '-solid-before'
        });
    }
    return _jsx('div', {
        className: className
    }, void 0, _jsx('img', {
        src: iconHref,
        className: 'imageLoaded',
        alt: 'sport icon'
    }));
};

/* harmony default export */ __webpack_exports__["a"] = (Logo);

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isContentLocked;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty__);



function isContentLocked(_ref, userAuth) {
    var _ref$streams = _ref.streams,
        streams = _ref$streams === undefined ? [] : _ref$streams;
    var preauthorizedResources = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    if (__WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty___default()(streams) || __WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty___default()(userAuth) || __WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty___default()(preauthorizedResources)) {
        return false;
    }

    var isLocked = userAuth.indexOf(__WEBPACK_IMPORTED_MODULE_0__enums__["e" /* AuthTypes */].MVPD) > -1 && streams.some(function (_ref2) {
        var _ref2$authTypes = _ref2.authTypes,
            authTypes = _ref2$authTypes === undefined ? [] : _ref2$authTypes,
            _ref2$adobeRSS = _ref2.adobeRSS,
            adobeRSS = _ref2$adobeRSS === undefined ? '' : _ref2$adobeRSS,
            adobeResourceArg = _ref2.adobeResource;

        var adobeResource = adobeResourceArg;
        if (!adobeResource) {
            var result = /<title>([^<]+)<\/title>/.exec(adobeRSS);
            if (result && result[1]) {
                adobeResource = result[1];
            }
        }
        return adobeResource && authTypes.indexOf(__WEBPACK_IMPORTED_MODULE_0__enums__["e" /* AuthTypes */].MVPD) > -1 && preauthorizedResources.indexOf(adobeResource) === -1;
    });

    return isLocked;
}

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./app/constants.js
var constants = __webpack_require__(8);

// EXTERNAL MODULE: ./app/enums.js
var enums = __webpack_require__(1);

// EXTERNAL MODULE: ./app/common/actions/appActions.js
var appActions = __webpack_require__(19);

// EXTERNAL MODULE: ./app/common/actions/authenticationActions.js
var authenticationActions = __webpack_require__(22);

// EXTERNAL MODULE: ./app/lib/auth/streamHasAuthType.js
var streamHasAuthType = __webpack_require__(45);

// CONCATENATED MODULE: ./app/lib/auth/isStreamStatus.js
/**
 * isStreamStatus - Returns a boolean flag determined by an exact string match between the
 * stream.status property and the statusType string parameter.
 *
 * @param {object} streamObject - Object containing the status string property
 * @param {string} statusType - Represents the statusType to match
 *
 * @return {boolean} Returns true if the stream.status property matches the statusType; false otherwise.
 */
function isStreamStatus() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      status = _ref.status;

  var statusType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  return typeof status === 'string' && status.trim() !== '' && statusType !== '' && statusType === status;
};
// CONCATENATED MODULE: ./app/lib/auth/isUserAuthenticated.js


/**
 * isUserAuthenticated - Verifies if the current userAuth array matches a given provider.
 * For `ESPN_PLUS`, we rely that the match is not `MVPD` and not `ISP`. If the result of .find returns
 * a non-empty array we assume a match is found.
 *
 * @param {array} userAuth - An array holding the current user authentication state; can have more than one
 * @param {string} provider - A string used to represent the authentication provider (MVPD, BAM or ISP)
 *
 * @return {boolean} Returns a boolean flag based on finding a match between the userAuth array and given provider
 */
function isUserAuthenticated() {
    var userAuth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var provider = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    if (userAuth.length === 0 || typeof provider !== 'string' || provider.trim() === '') {
        return false;
    }

    var userIsAuthenticated = void 0;
    if (provider === enums["e" /* AuthTypes */].BAM) {
        userIsAuthenticated = userAuth.filter(function (auth) {
            return auth.indexOf(enums["e" /* AuthTypes */].MVPD) === -1 && auth.indexOf(enums["e" /* AuthTypes */].ISP) === -1;
        });
    } else {
        userIsAuthenticated = userAuth.filter(function (auth) {
            return auth.indexOf(provider) !== -1;
        });
    }

    if (userIsAuthenticated.length) {
        return true;
    }

    return false;
}
// CONCATENATED MODULE: ./app/lib/auth/getFirstStreamUserAuth.js




function getFirstStreamUserAuth(streams, userAuth) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = streams[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var stream = _step.value;

            var isTVEAuthenticated = isUserAuthenticated(userAuth, enums["e" /* AuthTypes */].MVPD) || isUserAuthenticated(userAuth, enums["e" /* AuthTypes */].ISP);
            var isBAMAuthenticated = isUserAuthenticated(userAuth, enums["e" /* AuthTypes */].BAM);
            var isBAMStream = Object(streamHasAuthType["a" /* default */])(stream, enums["e" /* AuthTypes */].BAM);
            var isTVEStream = Object(streamHasAuthType["a" /* default */])(stream, enums["e" /* AuthTypes */].MVPD) || Object(streamHasAuthType["a" /* default */])(stream, enums["e" /* AuthTypes */].ISP);

            if (isTVEAuthenticated && isTVEStream || isBAMAuthenticated && isBAMStream) {
                return stream;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return null;
}
// CONCATENATED MODULE: ./app/lib/streamPicker/handleMultipleStreamAuthentication.js
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }












/**
 * Multi stream authentication rules
 * 1. stream is upcoming, show DSS paywall
 * 2. show picker if showPicker is set to true
 * 3. select first stream for authentication
 */
var handleMultipleStreamAuthentication = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(args) {
        var nextSelectedContent, dispatch, showPicker, _args$pickerStreams, pickerStreams, _args$authRes, authRes, locationBeforeTransitions, lang, country, _nextSelectedContent$, streams, firstStream, _authRes$userAuth, userAuth, selectedFirstStream;

        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        nextSelectedContent = args.nextSelectedContent, dispatch = args.dispatch, showPicker = args.showPicker, _args$pickerStreams = args.pickerStreams, pickerStreams = _args$pickerStreams === undefined ? [] : _args$pickerStreams, _args$authRes = args.authRes, authRes = _args$authRes === undefined ? {} : _args$authRes, locationBeforeTransitions = args.locationBeforeTransitions, lang = args.lang, country = args.country;
                        _nextSelectedContent$ = nextSelectedContent.streams, streams = _nextSelectedContent$ === undefined ? [] : _nextSelectedContent$;
                        firstStream = streams[0] || {};


                        if (isStreamStatus(firstStream, 'upcoming')) {
                            dispatch(Object(authenticationActions["M" /* createDTCPaywallAction */])({
                                containerId: constants["a" /* BAM_PAYWALL_IFRAME_ID */],
                                content: nextSelectedContent,
                                stream: firstStream
                            }));
                        } else if (showPicker) {
                            openStreamPicker({
                                lang: lang,
                                country: country,
                                dispatch: dispatch,
                                pickerStreams: pickerStreams,
                                authRes: authRes,
                                content: nextSelectedContent,
                                route: { locationBeforeTransitions: locationBeforeTransitions }
                            });
                        } else {
                            /**
                             * if showPicker is not true and this is multi streams content, we will first
                             * check if user is authenticated any of the streams, getFirstStreamUserAuth will
                             * returns first stream user is authenticated. If user is not authenticated any of
                             * streams, we will get the first stream (streams[0]) from streams
                             */
                            _authRes$userAuth = authRes.userAuth, userAuth = _authRes$userAuth === undefined ? [] : _authRes$userAuth;
                            selectedFirstStream = getFirstStreamUserAuth(streams, userAuth) || firstStream;

                            dispatch(Object(appActions["z" /* contentSelect */])(selectedFirstStream));
                        }

                    case 4:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function handleMultipleStreamAuthentication(_x) {
        return _ref.apply(this, arguments);
    };
}();;
// EXTERNAL MODULE: ./app/lib/util/localStorage.js
var localStorage = __webpack_require__(44);

// CONCATENATED MODULE: ./app/lib/streamPicker/handleSingleStreamAuthentication.js
function handleSingleStreamAuthentication__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }








function fetchTVEAuthAction(dispatch, nextSelectedContent, stream) {
    dispatch(Object(authenticationActions["D" /* createAndPerformStartAuthenticationAction */])({
        content: nextSelectedContent,
        stream: stream
    })).then(function (isAuthenticated) {
        if (!isAuthenticated) {
            return dispatch(Object(authenticationActions["N" /* createDisplayProviderDialogAction */])());
        }
    });
}
/**
 * Single stream authentication rules
 * 1. if stream is upcoming or stream requires DTC, show DSS paywall
 * 2. if stream requires MVPD or ISP, 'tve is passed in query string, or
      MVPD_PREVIOUS_KEY is set in localStorage
 * 3. if 1 and 2 conditions are not met, show DSS paywall
 *
 * @param {args}   object list of requiredAuths, nextSelectedContent, query and dispatch 
   requiredAuths - Array containing all authTypes for the stream
   nextSelectedContent - Parent object containing the selected content with streams array
   query - React Router query object containing all possible query params
   dispatch - redux store dispatch
 */
var handleSingleStreamAuthentication = function () {
    var _ref = handleSingleStreamAuthentication__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(args) {
        var requiredAuths, nextSelectedContent, _args$query, query, dispatch, stream, chooseTVEAuth, userHasAuthedMVPD;

        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        requiredAuths = args.requiredAuths, nextSelectedContent = args.nextSelectedContent, _args$query = args.query, query = _args$query === undefined ? {} : _args$query, dispatch = args.dispatch, stream = args.stream;
                        chooseTVEAuth = query.auth === 'tve';
                        userHasAuthedMVPD = Object(localStorage["a" /* get */])(constants["i" /* MVPD_PREVIOUS_KEY */]);


                        if (requiredAuths.every(function (authType) {
                            return authType === enums["e" /* AuthTypes */].BAM;
                        }) || isStreamStatus(stream, 'upcoming')) {
                            dispatch(Object(authenticationActions["M" /* createDTCPaywallAction */])({
                                containerId: constants["a" /* BAM_PAYWALL_IFRAME_ID */],
                                content: nextSelectedContent,
                                stream: stream
                            }));
                        } else if (requiredAuths.every(function (authType) {
                            return authType === enums["e" /* AuthTypes */].MVPD || authType === enums["e" /* AuthTypes */].ISP;
                        }) || chooseTVEAuth || userHasAuthedMVPD) {
                            fetchTVEAuthAction(dispatch, nextSelectedContent, stream);
                        } else {
                            dispatch(Object(authenticationActions["M" /* createDTCPaywallAction */])({
                                containerId: constants["a" /* BAM_PAYWALL_IFRAME_ID */],
                                content: nextSelectedContent,
                                stream: stream
                            }));
                        }

                    case 4:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function handleSingleStreamAuthentication(_x) {
        return _ref.apply(this, arguments);
    };
}();;
// EXTERNAL MODULE: ./app/lib/auth/getContentId.js
var getContentId = __webpack_require__(60);

// EXTERNAL MODULE: ./app/lib/format/queryString.js
var queryString = __webpack_require__(18);

// CONCATENATED MODULE: ./app/lib/streamPicker/getPlayerUrl.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





function getPlayerUrl(props) {
    var content = props.content,
        _props$toURL = props.toURL,
        toURL = _props$toURL === undefined ? false : _props$toURL,
        _props$onSyndicatedPl = props.onSyndicatedPlayerPage,
        onSyndicatedPlayerPage = _props$onSyndicatedPl === undefined ? false : _props$onSyndicatedPl,
        _props$absoluteUrl = props.absoluteUrl,
        absoluteUrl = _props$absoluteUrl === undefined ? false : _props$absoluteUrl,
        _props$airingId = props.airingId,
        airingId = _props$airingId === undefined ? null : _props$airingId,
        _props$useLocationPat = props.useLocationPathname,
        useLocationPathname = _props$useLocationPat === undefined ? false : _props$useLocationPat,
        _props$isHero = props.isHero,
        isHero = _props$isHero === undefined ? false : _props$isHero,
        bucketId = props.bucketId,
        groupId = props.groupId,
        flags = props.flags,
        routing = props.routing;


    if (content) {
        var _ref = routing && routing.locationBeforeTransitions || {},
            basename = _ref.basename,
            queryParams = _ref.query,
            pathname = _ref.pathname;

        var _ref2 = queryParams || {},
            categoryId = _ref2.categoryId,
            id = _ref2.id;

        var contentId = void 0;
        if (isHero && id) {
            contentId = { id: id };
        } else if (airingId) {
            contentId = { id: airingId };
        } else {
            contentId = Object(getContentId["a" /* default */])(content);
        }

        var query = _extends({
            bucketId: bucketId,
            groupId: groupId
        }, contentId, flags);

        var routePath = onSyndicatedPlayerPage ? '/syndicated/player' : '/player';
        if (useLocationPathname) {
            routePath = pathname;
        }

        if (categoryId) {
            query.categoryId = categoryId;
        }

        if (toURL) {

            if (absoluteUrl) {
                var domain = window && window.location && window.location.hostname;
                if (domain) {
                    var port = window.location.port || '';
                    if (port !== '') {
                        port = ':' + port;
                    }
                    return 'http://' + domain + port + basename + routePath + Object(queryString["a" /* default */])(query);
                }
            }
            return '' + basename + routePath + Object(queryString["a" /* default */])(query);
        }

        return {
            pathname: routePath,
            query: query
        };
    }

    return null;
};
// EXTERNAL MODULE: ./app/lib/util/hasObj.js
var hasObj = __webpack_require__(334);

// EXTERNAL MODULE: ./app/common/selectors/pickerStreamsSelector.js
var pickerStreamsSelector = __webpack_require__(149);

// EXTERNAL MODULE: ./app/common/selectors/selectedContentSelector.js
var selectedContentSelector = __webpack_require__(46);

// EXTERNAL MODULE: ./app/common/actions/apiAction.js
var apiAction = __webpack_require__(55);

// EXTERNAL MODULE: ./app/lib/auth/canPlayStream.js
var canPlayStream = __webpack_require__(117);

// EXTERNAL MODULE: ./app/lib/auth/authStateKnown.js
var authStateKnown = __webpack_require__(77);

// CONCATENATED MODULE: ./app/lib/streamPicker/openStreamPicker.js
var openStreamPicker__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function openStreamPicker__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }















var MAX_RETRIES = 5;
var RETRY_WAIT_TIME = 1000;

function getPickerStreams(content, pickerStreams) {
    var _this = this;

    return function () {
        var _ref = openStreamPicker__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
            var state, nextSelectedContent, selectPickerStreams, _nextSelectedContent$, links, eventId, pickerStreamsEventId, pickerApiUrl, nextStreams;

            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            state = getState();
                            nextSelectedContent = Object(selectedContentSelector["a" /* default */])(state);
                            selectPickerStreams = pickerStreams;
                            // new content is selected

                            if (nextSelectedContent.id !== content.id) {
                                selectPickerStreams = Object(pickerStreamsSelector["a" /* default */])(state);
                            }
                            _nextSelectedContent$ = nextSelectedContent.links, links = _nextSelectedContent$ === undefined ? {} : _nextSelectedContent$, eventId = nextSelectedContent.eventId;
                            pickerStreamsEventId = state.app.pickerStreamsEventId;

                            // if id is equal to pickerStreamsEventId, than means we had pickerStreams

                            if (!(selectPickerStreams && selectPickerStreams.length && pickerStreamsEventId === eventId)) {
                                _context.next = 8;
                                break;
                            }

                            return _context.abrupt('return', {
                                nextSelectedContent: nextSelectedContent,
                                nextPickerStreams: selectPickerStreams
                            });

                        case 8:
                            // otherwise; let's trigger a new picker pageApi call and fetch pickerStreams data 
                            pickerApiUrl = links.picker;

                            if (!pickerApiUrl) {
                                _context.next = 15;
                                break;
                            }

                            dispatch(Object(appActions["K" /* pickerStreamsUnSelect */])());
                            _context.next = 13;
                            return dispatch(Object(apiAction["c" /* fetchPickerStreams */])(pickerApiUrl, eventId));

                        case 13:
                            nextStreams = Object(pickerStreamsSelector["a" /* default */])(getState());
                            return _context.abrupt('return', {
                                nextSelectedContent: nextSelectedContent,
                                nextPickerStreams: nextStreams
                            });

                        case 15:
                            return _context.abrupt('return', {});

                        case 16:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function (_x, _x2) {
            return _ref.apply(this, arguments);
        };
    }();
}
var handleSelectedStream = function () {
    var _ref2 = openStreamPicker__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(props) {
        var content, route, urlParams, pickerStreams, airingId, dispatch, _props$authRes$userAu, userAuth, router, rState, _route$locationBefore, locationBeforeTransitions, basename, _locationBeforeTransi, pathname, _locationBeforeTransi2, query, useqa, id, _spHost, eventCalendarId, resQs, qs, _ref3, nextPickerStreams, nextSelectedContent, streamFromPicker, placement, status, onHero, stream, canPlay, useLocationPathname, playerUrl;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        content = props.content, route = props.route, urlParams = props.urlParams, pickerStreams = props.pickerStreams, airingId = props.airingId, dispatch = props.dispatch, _props$authRes$userAu = props.authRes.userAuth, userAuth = _props$authRes$userAu === undefined ? [] : _props$authRes$userAu;
                        router = route.router, rState = route.rState, _route$locationBefore = route.locationBeforeTransitions, locationBeforeTransitions = _route$locationBefore === undefined ? {} : _route$locationBefore;
                        basename = locationBeforeTransitions.basename, _locationBeforeTransi = locationBeforeTransitions.pathname, pathname = _locationBeforeTransi === undefined ? '' : _locationBeforeTransi, _locationBeforeTransi2 = locationBeforeTransitions.query, query = _locationBeforeTransi2 === undefined ? {} : _locationBeforeTransi2;
                        useqa = query.useqa, id = query.id, _spHost = query._spHost, eventCalendarId = query.eventCalendarId, resQs = _objectWithoutProperties(query, ['useqa', 'id', '_spHost', 'eventCalendarId']);
                        qs = {};

                        if (useqa) {
                            /**
                             * if useqa is passed in the query, we want to keep the rest of query string
                             * except _spHost for testing purpose in QA
                             */
                            qs = openStreamPicker__extends({ useqa: useqa }, resQs);
                        }
                        _context2.next = 8;
                        return dispatch(getPickerStreams(content, pickerStreams));

                    case 8:
                        _ref3 = _context2.sent;
                        nextPickerStreams = _ref3.nextPickerStreams;
                        nextSelectedContent = _ref3.nextSelectedContent;
                        streamFromPicker = filterPickerStreamsById(nextPickerStreams, airingId);
                        placement = content.placement, status = content.status;
                        onHero = placement === 'inline-hero';

                        if (streamFromPicker && Array.isArray(streamFromPicker.streams)) {
                            // Avoids the `reselected` return logic when clicking the same stream
                            stream = streamFromPicker.streams[0];
                            canPlay = Object(canPlayStream["a" /* default */])(stream, userAuth, false);

                            if (!canPlay && (onHero || eventCalendarId && nextSelectedContent.id === eventCalendarId)) {
                                /**
                                 * ticket: https://jira.disney.com/browse/WEWEB-2684
                                 * When multicast eventCalendarId is passed in the url, user is logged to MVPD,
                                 * BC player is embed and user is not logged to E+ and select E+ content, or if user is
                                 * logged to E+, DSS player is embed and user is not logged to MVPD and select TVE content,
                                 * we need to trigger url update with selected stream id from the picker.
                                 * Auth flow will be triggered in handleSingleStreamAuthentication (selectStreamForAuthUsers.js)
                                 */
                                qs.id = stream.id;
                                window.location.href = '' + basename + pathname + Object(queryString["a" /* default */])(qs);
                            } else {
                                dispatch(Object(appActions["P" /* streamUnSelect */])());
                                stream.feedSwitch = true;
                                dispatch(Object(appActions["y" /* closeModalMessage */])());
                                dispatch(Object(appActions["O" /* streamSelect */])(stream));

                                /**
                                 * urlParams is passed when user clicks on tiles from
                                 * clickHandler event, file app/webapp/common/playable.js.
                                 * Before this update, for all multi streams, user didn't give an option to
                                 * select the streams after they logged it, so we will enforce to open the picker
                                 * even if user is logged it.
                                 */
                                if (urlParams) {
                                    useLocationPathname = (onHero || (id || eventCalendarId) && !urlParams) && status !== enums["n" /* ContentStatus */].UPCOMING;

                                    urlParams.content = nextSelectedContent;
                                    playerUrl = getPlayerUrl(openStreamPicker__extends({ useLocationPathname: useLocationPathname }, urlParams));
                                    // if playerUrl is set, re-route the page to the playerUrl

                                    if (playerUrl.query) {
                                        playerUrl.query = openStreamPicker__extends({}, qs, playerUrl.query, {
                                            airingId: airingId
                                        });
                                    }
                                    router.push(openStreamPicker__extends({}, playerUrl, {
                                        state: openStreamPicker__extends({ pickerStreams: nextPickerStreams }, rState)
                                    }));
                                }
                            }
                        } else {
                            handleStreamPickerOnError(props);
                        }

                    case 15:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    return function handleSelectedStream(_x3) {
        return _ref2.apply(this, arguments);
    };
}();

function onRowClickCallback(props) {
    // close the picker as soon as use clicks on the row.
    espn_ui.Helpers.streamPicker.closePicker();
    handleSelectedStream(props);

    window.jQuery.unsubscribe && window.jQuery.unsubscribe(window.espn_ui.Helpers.streamPicker.evts.ON_ROW_CLICK);
}

function isPickerReady() {
    var hasSubscribe = Object(hasObj["a" /* default */])(window, 'jQuery.subscribe');
    var hasRowClick = Object(hasObj["a" /* default */])(window, 'espn_ui.Helpers.streamPicker.evts.ON_ROW_CLICK');
    var hasOpenPicker = Object(hasObj["a" /* default */])(window, 'espn_ui.Helpers.streamPicker.openPicker');
    return hasSubscribe && hasRowClick && hasOpenPicker;
}

function handleStreamPickerOnError(props) {
    var content = props.content,
        dispatch = props.dispatch,
        urlParams = props.urlParams,
        route = props.route,
        _props$authRes$userAu2 = props.authRes.userAuth,
        userAuth = _props$authRes$userAu2 === undefined ? [] : _props$authRes$userAu2;
    var _content$streams = content.streams,
        streams = _content$streams === undefined ? [] : _content$streams;

    var selectedStream = getFirstStreamUserAuth(streams, userAuth) || streams[0];
    if (selectedStream) {
        dispatch(Object(appActions["P" /* streamUnSelect */])());
        selectedStream.feedSwitch = true;
        dispatch(Object(appActions["y" /* closeModalMessage */])());
        dispatch(Object(appActions["O" /* streamSelect */])(selectedStream));

        if (urlParams) {
            var router = route.router,
                rState = route.rState;

            var playerUrl = getPlayerUrl(openStreamPicker__extends({}, urlParams));
            router.push(openStreamPicker__extends({}, playerUrl, {
                state: openStreamPicker__extends({}, rState)
            }));
        }
    }
}

// check .com stream picker script functions are available in the dom
var waitUntilPickerScriptReady = function () {
    var _ref4 = openStreamPicker__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(isPickerReady, maxReTries, waitTime) {
        var retry;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        retry = 0;
                        _context3.next = 3;
                        return new Promise(function (resolve) {
                            var reTryOpenPicker = setInterval(function () {
                                if (retry < maxReTries) {
                                    var isReady = isPickerReady();
                                    if (isReady) {
                                        resolve(true);
                                        clearInterval(reTryOpenPicker);
                                    }
                                } else {
                                    clearInterval(reTryOpenPicker);
                                    resolve(false);
                                }
                                retry += 1;
                            }, waitTime);
                        });

                    case 3:
                        return _context3.abrupt('return', _context3.sent);

                    case 4:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, this);
    }));

    return function waitUntilPickerScriptReady(_x4, _x5, _x6) {
        return _ref4.apply(this, arguments);
    };
}();

/**
 * @description:
 * Open .com stream picker which is an iframe that uses jQuery pub/sub.
 * We need to check if .com jQuery events are available before calling it.
 * We check every 500ms up to 4 times, total of 3 seconds. If .com jQuery events
 * are available, we call window.espn_ui.Helpers.streamPicker.openPicker and
 * dispatch openPickerSuccess; otherwise, dispatch openPickerError
 * 
 * @param {object} content   // content.id will be needed for the triggering stream picker
 * @param {object} route     // empty object or route state object of { router, playerUrl, rState }
 * @param {object} dispatch  // store dispatch
 * @param {object} authRes   // empty object or includes userAuth and preauthorizedResources props
 */
var openStreamPicker = function () {
    var _ref5 = openStreamPicker__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(props) {
        var content, _props$route, route, dispatch, _props$country, country, _props$lang, lang, _props$pickerStreams, pickerStreams, _props$authRes, _props$authRes$userAu3, userAuth, _props$authRes$preaut, preauthorizedResources, retry, _route$locationBefore2, _route$locationBefore3, pathname, eventCalendarId, darkmode, _content$links, links, eventId, _ref6, nextPickerStreams, pickerScriptReady;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        content = props.content, _props$route = props.route, route = _props$route === undefined ? {} : _props$route, dispatch = props.dispatch, _props$country = props.country, country = _props$country === undefined ? '' : _props$country, _props$lang = props.lang, lang = _props$lang === undefined ? '' : _props$lang, _props$pickerStreams = props.pickerStreams, pickerStreams = _props$pickerStreams === undefined ? [] : _props$pickerStreams, _props$authRes = props.authRes, _props$authRes$userAu3 = _props$authRes.userAuth, userAuth = _props$authRes$userAu3 === undefined ? [] : _props$authRes$userAu3, _props$authRes$preaut = _props$authRes.preauthorizedResources, preauthorizedResources = _props$authRes$preaut === undefined ? [] : _props$authRes$preaut;
                        retry = 0;

                        dispatch(Object(appActions["H" /* pickerStateClear */])()); // clear previous picker state 

                        _route$locationBefore2 = route.locationBeforeTransitions, _route$locationBefore3 = _route$locationBefore2.pathname, pathname = _route$locationBefore3 === undefined ? '' : _route$locationBefore3, eventCalendarId = _route$locationBefore2.query.eventCalendarId;
                        darkmode = pathname.indexOf('/player') !== -1;

                        /**
                         * we need to fetch pickerStreams data for in-player stream picker, 
                         * in case when user closes stream picker without picking a stream on pageload
                         */

                        if (!(eventCalendarId && pickerStreams && !pickerStreams.length)) {
                            _context4.next = 13;
                            break;
                        }

                        _content$links = content.links, links = _content$links === undefined ? {} : _content$links, eventId = content.eventId;
                        // use == not === to compare value only between eventCalendarId and eventId

                        if (!(eventCalendarId == eventId && links.picker)) {
                            _context4.next = 13;
                            break;
                        }

                        _context4.next = 10;
                        return dispatch(getPickerStreams(content, pickerStreams));

                    case 10:
                        _ref6 = _context4.sent;
                        nextPickerStreams = _ref6.nextPickerStreams;

                        props.pickerStreams = nextPickerStreams;

                    case 13:
                        pickerScriptReady = void 0;
                        _context4.next = 16;
                        return waitUntilPickerScriptReady(isPickerReady, MAX_RETRIES, RETRY_WAIT_TIME).then(function (res) {
                            return pickerScriptReady = res;
                        });

                    case 16:

                        if (pickerScriptReady) {
                            try {
                                if (content && content.id) {

                                    window.espn_ui.Helpers.streamPicker.openPicker({
                                        eventId: content.id,
                                        triggerEvtOnNav: true,
                                        entitlements: userAuth,
                                        tvePreauthResources: preauthorizedResources,
                                        countryCode: country,
                                        lang: lang,
                                        darkmode: darkmode
                                    }).then(function () {
                                        window.jQuery.subscribe(window.espn_ui.Helpers.streamPicker.evts.ON_ROW_CLICK, function (res) {
                                            return onRowClickCallback(openStreamPicker__extends({ airingId: res.airing.id }, props));
                                        });
                                        dispatch(Object(appActions["G" /* openPickerSuccess */])({ id: content.id, retryTime: retry }));
                                    }).catch(function () {
                                        dispatch(Object(appActions["F" /* openPickerError */])('Open picker error: openPicker failed, retryTime ' + retry));
                                        window.espn_ui.Helpers.streamPicker.closePicker();
                                        handleStreamPickerOnError(props);
                                    });
                                }
                            } catch (err) {
                                dispatch(Object(appActions["F" /* openPickerError */])('Open picker error: ' + err.message));
                            }
                        } else {
                            handleStreamPickerOnError(props);
                        }

                    case 17:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, _callee4, this);
    }));

    return function openStreamPicker(_x7) {
        return _ref5.apply(this, arguments);
    };
}();
// EXTERNAL MODULE: ./app/lib/util/isEmpty.js
var isEmpty = __webpack_require__(12);

// CONCATENATED MODULE: ./app/lib/streamPicker/selectStreamForAuthUsers.js
var selectStreamForAuthUsers__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function selectStreamForAuthUsers__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }










var selectStreamForAuthUsers = function () {
    var _ref = selectStreamForAuthUsers__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(payload) {
        var dispatch, authRes, _payload$pickerStream, pickerStreams, content, _payload$feeds, feeds, _payload$locationBefo, locationBeforeTransitions, _content$streams, streams, _content$placement, placement, isEvent, playerSideBarContent, query, _locationBeforeTransi, id, airingId, _authRes$userAuth, userAuth, contentId, nextPickerStreams, filteredStreams, lastFeeds, lastSelectedStream;

        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        dispatch = payload.dispatch, authRes = payload.authRes, _payload$pickerStream = payload.pickerStreams, pickerStreams = _payload$pickerStream === undefined ? [] : _payload$pickerStream, content = payload.content, _payload$feeds = payload.feeds, feeds = _payload$feeds === undefined ? {} : _payload$feeds, _payload$locationBefo = payload.locationBeforeTransitions, locationBeforeTransitions = _payload$locationBefo === undefined ? {} : _payload$locationBefo;
                        _content$streams = content.streams, streams = _content$streams === undefined ? [] : _content$streams, _content$placement = content.placement, placement = _content$placement === undefined ? '' : _content$placement, isEvent = content.isEvent;
                        playerSideBarContent = placement.indexOf('playback-page-recommended') !== -1;
                        query = locationBeforeTransitions.query, _locationBeforeTransi = locationBeforeTransitions.query;
                        _locationBeforeTransi = _locationBeforeTransi === undefined ? {} : _locationBeforeTransi;
                        id = _locationBeforeTransi.id, airingId = _locationBeforeTransi.airingId;
                        _authRes$userAuth = authRes.userAuth, userAuth = _authRes$userAuth === undefined ? [] : _authRes$userAuth;
                        contentId = airingId || id;
                        nextPickerStreams = pickerStreams;
                        // playerSideBarContent will be true when user clicks on sidebar content on player page

                        if (!playerSideBarContent) {
                            _context.next = 16;
                            break;
                        }

                        contentId = Object(getContentId["a" /* default */])(content);
                        dispatch(Object(appActions["K" /* pickerStreamsUnSelect */])());

                        if (!isEvent) {
                            _context.next = 16;
                            break;
                        }

                        _context.next = 15;
                        return dispatch(getPickerStreams(content, pickerStreams));

                    case 15:
                        nextPickerStreams = _context.sent;

                    case 16:
                        filteredStreams = filterPickerStreamsById(nextPickerStreams, contentId);

                        if (filteredStreams && Array.isArray(filteredStreams.streams)) {
                            filteredStreams = filteredStreams.streams[0];
                        }
                        // if airing content is not found in pickerStreams, get it from content.streams
                        if (!filteredStreams) {
                            filteredStreams = streams.filter(function (stream) {
                                return stream.id === contentId;
                            })[0];
                        }

                        if (!filteredStreams && !Object(isEmpty["a" /* default */])(feeds)) {
                            lastFeeds = Object.keys(feeds).map(function (key) {
                                return feeds[key];
                            });
                            lastSelectedStream = streams.filter(function (_ref2) {
                                var id = _ref2.id;
                                return lastFeeds.indexOf(contentId) > -1;
                            })[0];

                            if (lastSelectedStream) {
                                filteredStreams = lastSelectedStream;
                            }
                        }

                        // last fallback
                        if (!filteredStreams) {
                            filteredStreams = getFirstStreamUserAuth(streams, userAuth) || streams[0];
                        }

                        // add missing content props that we need to pass to DSS 
                        if (filteredStreams && !filteredStreams.content) {
                            filteredStreams = selectStreamForAuthUsers__extends({}, filteredStreams, { content: content });
                        }

                        if (Object(canPlayStream["a" /* default */])(filteredStreams, userAuth, false) && filteredStreams.status !== 'upcoming') {
                            dispatch(Object(appActions["O" /* streamSelect */])(filteredStreams));
                        } else {
                            handleSingleStreamAuthentication({
                                query: query,
                                dispatch: dispatch,
                                stream: filteredStreams,
                                requiredAuths: filteredStreams.authTypes,
                                nextSelectedContent: content
                            });
                        }

                    case 23:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function selectStreamForAuthUsers(_x) {
        return _ref.apply(this, arguments);
    };
}();
// CONCATENATED MODULE: ./app/lib/streamPicker/filterPickerStreamsById.js
var filterPickerStreamsById = function filterPickerStreamsById(pickerStreams, id) {
    if (pickerStreams && pickerStreams.length) {
        var contents = pickerStreams.map(function (streams) {
            return streams.contents;
        });
        var streams = contents.filter(function (content) {
            return content.filter(function (stream) {
                return stream.id === id;
            }).length > 0;
        })[0];
        if (streams && streams.length) {
            return streams.filter(function (stream) {
                return stream.id === id;
            })[0];
        }
    }
    return null;
};
// CONCATENATED MODULE: ./app/lib/streamPicker/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return handleMultipleStreamAuthentication; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return handleSingleStreamAuthentication; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return getPlayerUrl; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return openStreamPicker; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "f", function() { return selectStreamForAuthUsers; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return filterPickerStreamsById; });







/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_url_adapter__ = __webpack_require__(335);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();





var COMPRESSION_RATE = 40;

/**
 * Generates a single srcSet entry
 * @param {string} url
 * @param {number} width
 */
function getSrcSetEntry(url, width) {
    return url + ' ' + width + 'w';
}

/**
 * Take an image url and returns full srcSet value
 * @param {string} url - Either an artwork or CDN url
 * @return {array} - array of size numbers
 */
function getSrcSet(url, cquality) {
    var sizes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    return sizes.map(function (width) {
        var sizedUrl = Object(__WEBPACK_IMPORTED_MODULE_2__lib_url_adapter__["a" /* getImageUrlWithParams */])(url, { cquality: cquality, width: width });
        return getSrcSetEntry(sizedUrl, width);
    }).reduce(function (acc, srcSetEntry) {
        return srcSetEntry + ', ' + acc;
    });
}

var ResponsiveThumbnail = function ResponsiveThumbnail(_ref) {
    var alt = _ref.alt,
        className = _ref.className,
        style = _ref.style,
        lazyload = _ref.lazyload,
        srcSetWidths = _ref.srcSetWidths,
        srcProp = _ref.src,
        sizes = _ref.sizes,
        cquality = _ref.cquality;

    if (!srcProp) {
        return null;
    }
    // compress combiner urls
    var src = Object(__WEBPACK_IMPORTED_MODULE_2__lib_url_adapter__["a" /* getImageUrlWithParams */])(srcProp, { cquality: cquality });
    var srcSet = srcSetWidths.length > 0 ? getSrcSet(srcProp, cquality, srcSetWidths) : null;

    var imgProps = {
        src: src,
        srcSet: srcSet,
        className: className,
        style: style
    };

    if (lazyload) {
        imgProps = {
            src: __WEBPACK_IMPORTED_MODULE_1__constants__["x" /* secureLoadingImageUrl */],
            'data-src': src,
            'data-srcset': srcSet,
            className: className + ' lazyload'
        };
    }

    return _jsx('picture', {}, void 0, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', _extends({}, imgProps, { sizes: sizes, alt: alt })));
};

ResponsiveThumbnail.defaultProps = {
    src: '',
    srcSetWidths: [],
    sizes: '25vw',
    className: 'media-wrapper_image',
    lazyload: false,
    cquality: COMPRESSION_RATE
};

/* harmony default export */ __webpack_exports__["a"] = (ResponsiveThumbnail);

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bluebird__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_selectn__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_selectn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_selectn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_uniqBy__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_video_player__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FeedsSelector__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_PropTypes__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__enums__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_actions_appActions__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_actions_authenticationActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_actions_oneIdActions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_selectors_bootstrapSelector__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_selectors_analyticsSelectors__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_selectors_appSelector__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__common_selectors_playerSelector__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__common_selectors_initialEmbedSelector__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__common_selectors_onDeckContentSelector__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__common_selectors_pageSelector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__common_selectors_selectedContentSelector__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__common_selectors_selectedStreamSelector__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__common_selectors_playingStreamSelector__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__common_selectors_pickerStreamsSelector__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__common_selectors_providerSelector__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__common_selectors_authenticationSelectors__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__common_selectors_oneIdSelector__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__common_selectors_flagsSelector__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__lib_auth_authStateKnown__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__lib_auth_streamHasAuthType__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__lib_auth_streamHasDTCPackage__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__lib_auth_shallowCheckAuthentication__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__lib_auth_canPlayContent__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__lib_auth_PreAuthZ__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__lib_api_newRelicApi__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__lib_util_isEmpty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__lib_util_getBamAuthConfig__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__lib_format_addQueryToUrl__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__lib_omniture__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__common_injectIntl__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__util__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__actions__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__globalVideoElement__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__lib_util_localStorage__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__lib_streamPicker__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__lib_native_bridge_espnapp__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__common_selectors_apiParamsSelector__ = __webpack_require__(114);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new __WEBPACK_IMPORTED_MODULE_2_bluebird___default.a(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return __WEBPACK_IMPORTED_MODULE_2_bluebird___default.a.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















































var METADATA = __WEBPACK_IMPORTED_MODULE_10__enums__["a" /* AdobePass */].METADATA;

// Begin Higher Order Component definition

function connectPlayer(WrappedComponent) {
    var ESPNPlayer = function (_Component) {
        _inherits(ESPNPlayer, _Component);

        function ESPNPlayer(props) {
            _classCallCheck(this, ESPNPlayer);

            var _this = _possibleConstructorReturn(this, (ESPNPlayer.__proto__ || Object.getPrototypeOf(ESPNPlayer)).call(this, props));

            _this.state = {
                autoEmbedCountDown: _this.props.initialAutoEmbedCountDown,
                deferPlayerInitialization: false, // if we have nothing to play yet
                deferInitialStreamSelect: false,
                initialized: false,
                initializedWithAuthZError: false,
                socialOpened: false,
                showFeedsSelector: false,
                feedsSelectorMessage: ''
            };
            _this.onToggleAutoPlay = _this.onToggleAutoPlay.bind(_this);
            _this.onContentLoaded = _this.onContentLoaded.bind(_this);
            _this.onSocialOpened = _this.onSocialOpened.bind(_this);
            _this.onSocialClosed = _this.onSocialClosed.bind(_this);
            _this.onProgramChange = _this.onProgramChange.bind(_this);
            _this.onPlaybackError = _this.onPlaybackError.bind(_this);
            _this.onDrmError = _this.onDrmError.bind(_this);
            _this.onBAMAuthrizeUser = _this.onBAMAuthrizeUser.bind(_this);
            _this.onBAMFeedChange = _this.onBAMFeedChange.bind(_this);
            _this.onBAMSettingsChanged = _this.onBAMSettingsChanged.bind(_this);
            _this.onBAMMediaLoaded = _this.onBAMMediaLoaded.bind(_this);
            _this.onBAMPlaybackError = _this.onBAMPlaybackError.bind(_this);
            _this.onFeedClick = _this.onFeedClick.bind(_this);
            _this.hasUserFeedSwitchedStream = _this.hasUserFeedSwitchedStream.bind(_this);
            _this.playerReady = _this.playerReady.bind(_this);
            _this.initializePlayer = _this.initializePlayer.bind(_this);
            _this.handleClick = _this.handleClick.bind(_this);
            _this.unregisterEvents = _this.unregisterEvents.bind(_this);
            _this.registerEvents = _this.registerEvents.bind(_this);
            _this.startAutoEmbedTimer = _this.startAutoEmbedTimer.bind(_this);
            _this.unembedPlayer = _this.unembedPlayer.bind(_this);
            _this.embedPlayer = _this.embedPlayer.bind(_this);
            _this.throwError = _this.throwError.bind(_this);
            _this.newRelicTrackingOnPlayer = _this.newRelicTrackingOnPlayer.bind(_this);
            _this.onFeedCloseModal = _this.onFeedCloseModal.bind(_this);
            // reference to the BrightCove player
            _this.player = null;
            // is the component mounted?
            _this._isMounted = false;
            // unmounting if we detect a route chage
            _this._isUnMounting = false;
            // hold a reference to the timer to clear later
            _this._autoEmbedTimer = null;
            _this._isAuthorizing = false;
            return _this;
        }

        _createClass(ESPNPlayer, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
                this._isMounted = true;
                this.startAutoEmbedTimer();
                /**
                  Initialize the player on mount if:
                    1 - It's the player page
                    2 - The player has already been primed
                    3 - It's not a mobile device
                */
                if (this.props.playerPlacement === __WEBPACK_IMPORTED_MODULE_10__enums__["B" /* PlayerPlacement */].PLAYER || __WEBPACK_IMPORTED_MODULE_43__globalVideoElement__["a" /* default */].primed || !this.props.isMobile) {
                    this.initializePlayer();
                }

                // comment out newrelic tracking until tracking is required for new stream picker
                // const { isNewrelicTrackingOn, selectedStream } = this.props;
                // if (isNewrelicTrackingOn && selectedStream.length) {
                //     // send newrelic track for selected stream that is presented to the users
                //     this.newRelicTrackingOnPlayer(selectedStream);
                // }
            }
        }, {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                var _this2 = this;

                if (this._isMounted === false || this._isUnMounting === true) {
                    return;
                }

                var _props = this.props,
                    lang = _props.lang,
                    country = _props.country,
                    dispatch = _props.dispatch,
                    selectedContent = _props.selectedContent,
                    selectedStream = _props.selectedStream,
                    playingStream = _props.playingStream,
                    userAuth = _props.userAuth,
                    onDeckContent = _props.onDeckContent,
                    locationBeforeTransitions = _props.routing.locationBeforeTransitions;
                var nextSelectedContent = nextProps.selectedContent,
                    nextPlayingStream = nextProps.playingStream,
                    nextUserAuth = nextProps.userAuth,
                    nextOnDeckContent = nextProps.onDeckContent,
                    nextPickerStreams = nextProps.pickerStreams,
                    nextRecommendMobileWeb = nextProps.recommendMobileWeb,
                    nextLocationBeforeTransitions = nextProps.routing.locationBeforeTransitions,
                    nextLastFeeds = nextProps.lastFeeds,
                    nextPreauthorizedResources = nextProps.preauthorizedResources;

                // if the user is no longer authd for the playing content, unembed the player

                if (Object(__WEBPACK_IMPORTED_MODULE_32__lib_auth_shallowCheckAuthentication__["b" /* default */])(playingStream, userAuth, false) && !Object(__WEBPACK_IMPORTED_MODULE_32__lib_auth_shallowCheckAuthentication__["b" /* default */])(nextPlayingStream, nextUserAuth, false)) {
                    this.unembedPlayer();
                    return;
                }

                if (this.state.feedsSelectorMessage && selectedContent.id === nextSelectedContent.id) {
                    return;
                }

                // player initialization is deferred if there's no selected content, and page api has not yet returned
                if (this.state.deferPlayerInitialization && nextProps.scoringComplete && !Object(__WEBPACK_IMPORTED_MODULE_36__lib_util_isEmpty__["a" /* default */])(nextProps.initialEmbedContent)) {
                    this.setState({ deferPlayerInitialization: false });
                    this.initializePlayer(nextProps);
                }

                /*
                * The following logic handles:
                * 1) Verifying a valid authentication state (i.e. 'mvpd')
                * 2) Checking if the call to playerReady() updated the state to deferInitialStreamSelect as a truthy value.
                * Occurs when the page has not fully loaded and will be caught in componentDidMount()
                * 3) If deferInitialStreamSelect is `false`, the logic verifies that the `selectedContent`
                * and `selectedStream` are both empty or both non-empty or the boolean initializedWithAuthZError
                * is `true` and the `selectedStream` is empty then it will proceed to select the preferred stream
                * 4) If content is 'vod', user can play
                */
                var isVod = nextSelectedContent.type === 'vod';
                if ((Object(__WEBPACK_IMPORTED_MODULE_29__lib_auth_authStateKnown__["a" /* default */])(nextUserAuth) || isVod || !nextUserAuth.length) && (this.state.deferInitialStreamSelect || (Object(__WEBPACK_IMPORTED_MODULE_36__lib_util_isEmpty__["a" /* default */])(selectedContent) && Object(__WEBPACK_IMPORTED_MODULE_36__lib_util_isEmpty__["a" /* default */])(selectedStream) || !Object(__WEBPACK_IMPORTED_MODULE_36__lib_util_isEmpty__["a" /* default */])(selectedContent) && !Object(__WEBPACK_IMPORTED_MODULE_36__lib_util_isEmpty__["a" /* default */])(selectedStream) || Object(__WEBPACK_IMPORTED_MODULE_36__lib_util_isEmpty__["a" /* default */])(selectedStream) && (this.state.initializedWithAuthZError || isVod || !nextUserAuth.length)) && selectedContent.id !== nextSelectedContent.id // this is for the subsequent content change
                )) {
                    if (this.state.deferInitialStreamSelect) {
                        this.setState({ deferInitialStreamSelect: false });
                    }

                    /* Verifies that a user can play the selected content by:
                    * 1) Ensuring the `selectedContent` status is not `upcoming`
                    * 2) Ensuring that there is no program change in progress via `onProgramChange`
                    */
                    if (Object(__WEBPACK_IMPORTED_MODULE_33__lib_auth_canPlayContent__["a" /* default */])(nextSelectedContent, nextUserAuth, false) && !this.state.programChanging) {
                        var _nextSelectedContent$ = nextSelectedContent.links;
                        _nextSelectedContent$ = _nextSelectedContent$ === undefined ? {} : _nextSelectedContent$;
                        var picker = _nextSelectedContent$.picker,
                            isOnTile = nextSelectedContent.isOnTile;
                        var _nextLocationBeforeTr = nextLocationBeforeTransitions.query;
                        _nextLocationBeforeTr = _nextLocationBeforeTr === undefined ? {} : _nextLocationBeforeTr;
                        var eventCalendarId = _nextLocationBeforeTr.eventCalendarId,
                            pathname = nextLocationBeforeTransitions.pathname;

                        var authRes = { userAuth: nextUserAuth, preauthorizedResources: nextPreauthorizedResources };

                        if (isOnTile && playingStream && pathname.indexOf('/player') === -1) {
                            /**
                             * when user is logged in and clicks on the tiles, we dispatch contentSelect in playable.js so
                             * that the new selected content will be updated and passed to stream picker; If it is on hero
                             * component and content is playing, we don't want to trigger new stream select.
                             */
                            return;
                        }

                        if (eventCalendarId && picker) {
                            Object(__WEBPACK_IMPORTED_MODULE_45__lib_streamPicker__["e" /* openStreamPicker */])({
                                lang: lang,
                                country: country,
                                dispatch: dispatch,
                                authRes: authRes,
                                pickerStreams: nextPickerStreams,
                                content: nextSelectedContent,
                                route: { locationBeforeTransitions: nextLocationBeforeTransitions }
                            });
                        } else {
                            Object(__WEBPACK_IMPORTED_MODULE_45__lib_streamPicker__["f" /* selectStreamForAuthUsers */])({
                                dispatch: dispatch,
                                authRes: authRes,
                                pickerStreams: nextPickerStreams,
                                content: nextSelectedContent,
                                feeds: nextLastFeeds,
                                locationBeforeTransitions: nextLocationBeforeTransitions
                            });
                        }
                        if (this.state.feedsSelectorMessage) {
                            this.setState({ feedsSelectorMessage: '' });
                        }
                        return;
                    }
                }

                // if the route has changed, anticipate the component unmounting
                if (locationBeforeTransitions.pathname !== nextLocationBeforeTransitions.pathname) {
                    this._isUnMounting = true;
                    this.unembedPlayer();
                    return;
                }

                if (Object(__WEBPACK_IMPORTED_MODULE_36__lib_util_isEmpty__["a" /* default */])(nextOnDeckContent) || onDeckContent.id === nextOnDeckContent.id || nextProps.player.embedding === true || this._isAuthorizing === true) {
                    return;
                }

                // NOTE: The logic below handles 1) embedding the player and commencing playback 2) error scenarios
                // Based on the selectedStream AuthType (BAM, MVPD/TVE, ISP) it will execute embedPlayer() with the
                // correct properties
                if (nextRecommendMobileWeb) {
                    this.throwError(nextOnDeckContent, __WEBPACK_IMPORTED_MODULE_10__enums__["z" /* PlayerError */].UNSUPPORTED, 'player.error.recommendMobileWeb', nextProps);
                } else if (nextOnDeckContent.sourceId === 'SHORTSTOPLIVE') {
                    this.embedPlayer(nextProps, nextOnDeckContent, { token: 'xbox_watch', tokenType: 'DEVICE' });
                } else if (nextProps.bypassToken) {
                    this.embedPlayer(nextProps, nextOnDeckContent, {
                        token: decodeURIComponent(nextProps.bypassToken),
                        tokenType: 'GATEKEEPER',
                        encoded: true
                    });
                } else if (!nextOnDeckContent.authTypes || nextOnDeckContent.authTypes.length === 0) {
                    this.embedPlayer(nextProps, nextOnDeckContent);
                } else if (Object(__WEBPACK_IMPORTED_MODULE_30__lib_auth_streamHasAuthType__["a" /* default */])(nextOnDeckContent, __WEBPACK_IMPORTED_MODULE_10__enums__["e" /* AuthTypes */].OPEN)) {
                    this.embedPlayer(nextProps, nextOnDeckContent, { token: 'open', tokenType: 'OPEN' });
                } else if (Object(__WEBPACK_IMPORTED_MODULE_30__lib_auth_streamHasAuthType__["a" /* default */])(nextOnDeckContent, __WEBPACK_IMPORTED_MODULE_10__enums__["e" /* AuthTypes */].ISP) && nextProps.userAuth.indexOf(__WEBPACK_IMPORTED_MODULE_10__enums__["e" /* AuthTypes */].ISP) !== -1) {
                    this.embedPlayer(nextProps, nextOnDeckContent, { token: 'online', tokenType: 'DEVICE' });
                } else if (Object(__WEBPACK_IMPORTED_MODULE_30__lib_auth_streamHasAuthType__["a" /* default */])(nextOnDeckContent, __WEBPACK_IMPORTED_MODULE_10__enums__["e" /* AuthTypes */].MVPD)) {
                    var adobePassInfo = nextOnDeckContent.adobePassInfo;
                    if (adobePassInfo) {
                        var messages = nextProps.messages,
                            formatMessage = nextProps.intl.formatMessage,
                            preauthorizedResources = nextProps.preauthorizedResources;

                        this._isAuthorizing = true;
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__common_actions_authenticationActions__["E" /* createAndPerformStartAuthorizationAction */])(nextOnDeckContent.adobeRSS)).then(function (authorization) {
                            if (locationBeforeTransitions && locationBeforeTransitions.query && locationBeforeTransitions.query.prePlayPicker) {
                                return __WEBPACK_IMPORTED_MODULE_2_bluebird___default.a.reject(new Error(formatMessage(messages['player.error.unexpectedMessage'])));
                            }
                            if (authorization.resourceId && authorization.token) {
                                // in case preauthz rsource info is incorrect, add the network to the list when
                                // the playback is successful
                                var _nextOnDeckContent$ad = nextOnDeckContent.adobeRSS,
                                    adobeRSS = _nextOnDeckContent$ad === undefined ? '' : _nextOnDeckContent$ad;

                                var result = /<title>([^<]+)<\/title>/.exec(adobeRSS);
                                if (result && result[1]) {
                                    var adobeResource = result[1];
                                    if (adobeResource) {
                                        if (preauthorizedResources && preauthorizedResources.indexOf(adobeResource) === -1) {
                                            var resources = preauthorizedResources.concat(adobeResource);
                                            __WEBPACK_IMPORTED_MODULE_34__lib_auth_PreAuthZ__["a" /* default */].setResources(resources, 1);
                                            dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__common_actions_authenticationActions__["L" /* createCompletePreauthCheckAction */])(resources));
                                        }
                                    }
                                }
                                return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__common_actions_authenticationActions__["F" /* createAsyncGetMetadataAction */])(METADATA.UPSTREAM_USERID)).then(function (accountId) {
                                    // eslint-disable-line arrow-body-style
                                    // if accountId doesn't exist, use a random number to avoid stream limiting everyone
                                    return _this2.embedPlayer(nextProps, nextOnDeckContent, authorization, {
                                        mvpd: adobePassInfo.abbreviation,
                                        accountId: accountId
                                    });
                                });
                            }
                            return __WEBPACK_IMPORTED_MODULE_2_bluebird___default.a.reject(new Error(formatMessage(messages['player.error.unexpectedMessage'])));
                        }).catch(function (_ref) {
                            var message = _ref.message;
                            var _props2 = _this2.props,
                                playerPlacement = _props2.playerPlacement,
                                _props2$pickerStreams = _props2.pickerStreams,
                                pickerStreams = _props2$pickerStreams === undefined ? [] : _props2$pickerStreams;
                            // On non-player page (i.e. hero), don't embed the player with an error
                            // If the user is on a hero player scenario and selects an additional feed
                            // from the feed selector, ensure error handling is in place only after
                            // the user has initiated the click event

                            if (!_this2.state.initializedWithAuthZError && playerPlacement !== __WEBPACK_IMPORTED_MODULE_10__enums__["B" /* PlayerPlacement */].PLAYER && !_this2.hasUserFeedSwitchedStream(nextOnDeckContent)) {
                                if (pickerStreams.length) {
                                    _this2.unregisterEvents();
                                    _this2.unembedPlayer();
                                    // TODO: localize message
                                    _this2.setState({
                                        showFeedsSelector: true,
                                        feedsSelectorMessage: message,
                                        initializedWithAuthZError: true
                                    });
                                } else {
                                    // if the user clicks on the event, don't do this logic again
                                    _this2.setState({
                                        initializedWithAuthZError: true
                                    });
                                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__common_actions_appActions__["A" /* contentUnSelect */])());
                                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__common_actions_appActions__["P" /* streamUnSelect */])());
                                }
                                return;
                            }

                            dispatch(Object(__WEBPACK_IMPORTED_MODULE_42__actions__["m" /* createAuthorizationErrorAction */])(message));
                            dispatch(Object(__WEBPACK_IMPORTED_MODULE_42__actions__["y" /* createStreamPlayingAction */])({ stream: nextOnDeckContent, error: true }));

                            _this2.throwError(nextOnDeckContent, __WEBPACK_IMPORTED_MODULE_10__enums__["z" /* PlayerError */].AUTHORIZATION, message && message !== 'null' ? message : 'player.error.defaultMessage', nextProps);
                            // Fixes undhandled promise rejection error in console
                            return null; // eslint-disable-line consistent-return
                        }).finally(function () {
                            _this2._isAuthorizing = false;
                        });
                    }
                } else if (Object(__WEBPACK_IMPORTED_MODULE_30__lib_auth_streamHasAuthType__["a" /* default */])(nextOnDeckContent, __WEBPACK_IMPORTED_MODULE_10__enums__["e" /* AuthTypes */].BAM)) {
                    // TODO: DTC - need authorization
                    this.embedPlayer(nextProps, nextOnDeckContent);
                }
            }
        }, {
            key: 'shouldComponentUpdate',
            value: function shouldComponentUpdate() {
                return this._isMounted === true && this._isUnMounting === false;
            }
        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                var dispatch = this.props.dispatch;

                this._isMounted = false;
                clearTimeout(this._autoEmbedTimer);
                this.unregisterEvents();
                this.unembedPlayer(true);
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__common_actions_appActions__["K" /* pickerStreamsUnSelect */])());
            }
        }, {
            key: 'onToggleAutoPlay',
            value: function onToggleAutoPlay(event, _ref2) {
                var _ref2$autoplay = _ref2.autoplay,
                    autoplay = _ref2$autoplay === undefined ? true : _ref2$autoplay;

                this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_42__actions__["o" /* createAutoplayUpdatedAction */])(autoplay));
            }
        }, {
            key: 'onContentLoaded',
            value: function onContentLoaded(event) {
                var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
                    id = _ref3.id,
                    clipId = _ref3.clipId,
                    _ref3$mediainfo = _ref3.mediainfo,
                    mediainfo = _ref3$mediainfo === undefined ? {} : _ref3$mediainfo;

                if (event.type === __WEBPACK_IMPORTED_MODULE_10__enums__["A" /* PlayerEvents */].ESPN_CONTENT_LOADED) {
                    // `clipId` is for domestic and `sourceId=intlvod` is for intl VOD
                    if (clipId || mediainfo.sourceId === 'intlvod') {
                        this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_42__actions__["q" /* createContinuousPlayAction */])(clipId || id));
                    } else {
                        var _props3 = this.props,
                            dispatch = _props3.dispatch,
                            selectedStream = _props3.selectedStream;

                        if (selectedStream.feedSwitch) {
                            dispatch(Object(__WEBPACK_IMPORTED_MODULE_42__actions__["s" /* createFeedSelectAction */])(id));
                            delete selectedStream.feedSwitch;
                        }
                    }
                    // update nielsen tracking info with the new content
                    this.videoPlayer.getPlayer(__WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].PlayerTech.BRIGHTCOVE).analytics.configure({
                        adobeDCR: Object(__WEBPACK_IMPORTED_MODULE_41__util__["a" /* getAdobeDCRConfig */])(this.props.nielsenTrackingData, {}, this.props.env, 'brightcove')
                    });
                }
            }
        }, {
            key: 'onSocialOpened',
            value: function onSocialOpened() {
                this.setState({ socialOpened: true });
                if (this.props.onSocialOpened) {
                    this.props.onSocialOpened();
                }
            }
        }, {
            key: 'onSocialClosed',
            value: function onSocialClosed() {
                this.setState({ socialOpened: false });
                if (this.props.onSocialClosed) {
                    this.props.onSocialClosed();
                }
            }
        }, {
            key: 'onCaptionOpened',
            value: function onCaptionOpened() {
                this.setState({ captionOpened: true });
                if (this.props.onCaptionOpened) {
                    this.props.onCaptionOpened();
                }
            }
        }, {
            key: 'onCaptionClosed',
            value: function onCaptionClosed() {
                this.setState({ captionOpened: false });
                if (this.props.onCaptionClosed) {
                    this.props.onCaptionClosed();
                }
            }
        }, {
            key: 'onBAMAuthrizeUser',
            value: function onBAMAuthrizeUser(event) {
                // eslint-disable-line
                var success = event.success;

                if (!success) {
                    console.error('onBAMAuthrizeUser', event);
                    var _props4 = this.props,
                        dispatch = _props4.dispatch,
                        selectedContent = _props4.selectedContent,
                        selectedStream = _props4.selectedStream,
                        oneIdToken = _props4.oneIdToken;
                    // when there is a token and still trigger an auth error, consider it's token expiration

                    if (oneIdToken.id_token) {
                        var retryCount = Object(__WEBPACK_IMPORTED_MODULE_44__lib_util_localStorage__["a" /* get */])(__WEBPACK_IMPORTED_MODULE_6__constants__["d" /* FORCE_REFRESH_TOKEN_RETRY_KEY */]);
                        if (retryCount) {
                            retryCount = parseInt(retryCount, 10);
                            if (retryCount >= 1) {
                                Object(__WEBPACK_IMPORTED_MODULE_44__lib_util_localStorage__["c" /* remove */])(__WEBPACK_IMPORTED_MODULE_6__constants__["d" /* FORCE_REFRESH_TOKEN_RETRY_KEY */], retryCount);
                                dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__common_actions_oneIdActions__["o" /* logout */])());
                                return;
                            }
                            retryCount += 1;
                        } else {
                            retryCount = 1;
                        }
                        Object(__WEBPACK_IMPORTED_MODULE_44__lib_util_localStorage__["d" /* set */])(__WEBPACK_IMPORTED_MODULE_6__constants__["d" /* FORCE_REFRESH_TOKEN_RETRY_KEY */], retryCount);
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__common_actions_oneIdActions__["k" /* forceTokenRefresh */])()).then(function () {
                            window.location.reload();
                        }).catch(function (err) {
                            console.error(err);
                            dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__common_actions_oneIdActions__["o" /* logout */])());
                        });
                        return;
                    }
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__common_actions_authenticationActions__["M" /* createDTCPaywallAction */])({
                        containerId: __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* BAM_PAYWALL_IFRAME_ID */],
                        content: selectedContent,
                        stream: selectedStream
                    }));
                }
            }
        }, {
            key: 'onBAMFeedChange',
            value: function onBAMFeedChange(event) {
                console.log('onBAMFeedChange', event); // eslint-disable-line no-console
                var _event$body = event.body;
                _event$body = _event$body === undefined ? {} : _event$body;
                var stream = _event$body.stream;

                if (stream) {
                    var _props5 = this.props,
                        dispatch = _props5.dispatch,
                        selectedContent = _props5.selectedContent;

                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__common_actions_appActions__["z" /* contentSelect */])(_extends({}, selectedContent, { reEmbed: true })));
                    // TODO: set this in the event when BAM player fires successful playback event
                    if (Object(__WEBPACK_IMPORTED_MODULE_30__lib_auth_streamHasAuthType__["a" /* default */])(stream, __WEBPACK_IMPORTED_MODULE_10__enums__["e" /* AuthTypes */].BAM)) {
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_42__actions__["s" /* createFeedSelectAction */])(stream.id));
                    }
                    stream.feedSwitch = true;
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__common_actions_appActions__["O" /* streamSelect */])(stream));
                }
            }
        }, {
            key: 'onBAMSettingsChanged',
            value: function onBAMSettingsChanged(event) {
                // eslint-disable-line
                console.log('onBAMSettingsChanged', event); // eslint-disable-line no-console
                // TODO: implement logic to reflect settings change from BAM player to BC player
            }
        }, {
            key: 'onBAMMediaLoaded',
            value: function onBAMMediaLoaded(event) {
                // eslint-disable-line
                console.log('onBAMMediaLoaded', event); // eslint-disable-line no-console
            }
        }, {
            key: 'onBAMPlaybackError',
            value: function onBAMPlaybackError(event) {
                // eslint-disable-line
                console.log('onBAMPlaybackError', event); // eslint-disable-line no-console
                var _event$exception = event.exception;
                _event$exception = _event$exception === undefined ? {} : _event$exception;
                var _event$exception$mess = _event$exception.message,
                    message = _event$exception$mess === undefined ? '' : _event$exception$mess;
                var _props6 = this.props,
                    dispatch = _props6.dispatch,
                    selectedContent = _props6.selectedContent,
                    selectedStream = _props6.selectedStream,
                    _props6$pickerStreams = _props6.pickerStreams,
                    pickerStreams = _props6$pickerStreams === undefined ? [] : _props6$pickerStreams;

                if (message === 'NotEntitled') {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__common_actions_authenticationActions__["M" /* createDTCPaywallAction */])({
                        containerId: __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* BAM_PAYWALL_IFRAME_ID */],
                        content: selectedContent,
                        stream: selectedStream
                    }));
                } else {
                    var isBlackout = message.toLowerCase().indexOf('blackout') > -1;
                    var isStreamConcurrencyViolation = message.toLowerCase().indexOf('streamconcurrencyviolation') > -1;
                    var feedsSelectorMessage = message;

                    if (isBlackout) {
                        selectedStream.blackoutText = 'BLACKOUT';
                        feedsSelectorMessage = 'This event has been blacked out in your area.';
                    } else if (isStreamConcurrencyViolation) {
                        feedsSelectorMessage = 'You have reached your device limit for streaming.\n                     To continue viewing on this device, please stop streaming on another device.';
                    }

                    var _selectedContent$stre = selectedContent.streams,
                        streams = _selectedContent$stre === undefined ? [] : _selectedContent$stre;

                    // on first embed, embed with an error

                    if (streams.length > 1 || pickerStreams.length) {
                        this.unregisterEvents();
                        this.unembedPlayer();
                        // TODO: localize message
                        this.setState({
                            showFeedsSelector: true,
                            feedsSelectorMessage: feedsSelectorMessage
                        });
                    }
                }
            }
        }, {
            key: 'onProgramChange',
            value: function onProgramChange(event, _ref4) {
                var _this3 = this;

                var id = _ref4.id,
                    eventId = _ref4.eventId,
                    callback = _ref4.callback;

                if (event.type === __WEBPACK_IMPORTED_MODULE_10__enums__["A" /* PlayerEvents */].ESPN_PROGRAM_CHANGE) {
                    // guard against program change called with the same id
                    var _props$playingStream = this.props.playingStream,
                        playingStream = _props$playingStream === undefined ? {} : _props$playingStream;

                    if (playingStream.id === id) {
                        return;
                    }
                    this.setState({ programChanging: true });
                    var query = eventId ? { eventId: eventId } : { id: id };
                    this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_42__actions__["w" /* createProgramChangeAction */])(query, id)).then(function (trackingData) {
                        _this3.setState({ programChanging: false });
                        // update nielsen tracking info with the new
                        _this3.videoPlayer.getPlayer(__WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].PlayerTech.BRIGHTCOVE).analytics.configure({
                            adobeDCR: Object(__WEBPACK_IMPORTED_MODULE_41__util__["a" /* getAdobeDCRConfig */])(trackingData || _this3.props.nielsenTrackingData, { startType: 'live-show-boundary' }, _this3.props.env, 'brightcove')
                        });
                        // this actually triggers the analytics call for program changes
                        if (callback && typeof callback === 'function') {
                            callback();
                        }
                    });
                }
            }
        }, {
            key: 'onPlaybackError',
            value: function onPlaybackError(event, error) {
                console.log('onPlaybackError', error); // eslint-disable-line no-console
                if (error) {
                    var customErrorMessage = void 0;
                    var _props7 = this.props,
                        selectedStream = _props7.selectedStream,
                        _props7$selectedConte = _props7.selectedContent.streams,
                        streams = _props7$selectedConte === undefined ? [] : _props7$selectedConte,
                        _props7$pickerStreams = _props7.pickerStreams,
                        pickerStreams = _props7$pickerStreams === undefined ? [] : _props7$pickerStreams;

                    if (error.code === 'BLACKOUT' || error.message.indexOf('blacked out') > -1) {
                        selectedStream.blackoutText = 'BLACKOUT';
                    }

                    if ((error.code === 403 || error.type && error.type.indexOf('authorization')) && typeof error.message === 'string' && error.message.trim() === '') {
                        customErrorMessage = 'You are not authorized to view this event';
                    }

                    // on first embed, embed with an error
                    if (streams.length > 1 || pickerStreams.length) {
                        this.unregisterEvents();
                        this.unembedPlayer();
                        this.setState({
                            showFeedsSelector: true,
                            feedsSelectorMessage: customErrorMessage || error.message
                        });
                    }
                }
            }
        }, {
            key: 'onDrmError',
            value: function onDrmError(event, error) {
                console.log('onDrmError', error); // eslint-disable-line no-console

                var _props8 = this.props,
                    selectedStream = _props8.selectedStream,
                    appName = _props8.appName,
                    hideNav = _props8.hideNav,
                    apiEnv = _props8.apiEnv,
                    flags = _props8.flags;

                var isEditions = (appName === 'watcheditions' || appName === 'webapp') && hideNav;
                var appDrmSupport = flags[__WEBPACK_IMPORTED_MODULE_10__enums__["t" /* Flags */].APP_DRM_SUPPORT];
                var appSupportsDrm = appDrmSupport !== null && appDrmSupport !== undefined;

                if (!isEditions || !selectedStream || !appSupportsDrm) {
                    return;
                }

                // target url is:
                // watchespn-editions://x-callback-url/openBrowser?url=https://www.espn.com/watch/player?id=1d405c1b-481a-4804-9f21-4595a0073a72

                var url = 'https://' + window.location.host + '/watch/player?id=' + selectedStream.id + '&roadblock=false';
                if (apiEnv) {
                    url = url + '&apienv=' + apiEnv;
                }
                var params = {
                    url: encodeURIComponent(url)
                };

                var appLink = Object(__WEBPACK_IMPORTED_MODULE_46__lib_native_bridge_espnapp__["a" /* getAppLink */])('openBrowser', params, false);
                appLink = appLink.replace('sportscenter://', 'watchespn-editions://');

                window.location = appLink;
            }
        }, {
            key: 'onFeedClick',
            value: function onFeedClick(feed) {
                var _props9 = this.props,
                    dispatch = _props9.dispatch,
                    selectedContent = _props9.selectedContent;
                var _feed$streams = feed.streams,
                    streams = _feed$streams === undefined ? [] : _feed$streams;

                var feedStream = feed;
                var feedContent = selectedContent;

                if (streams && streams.length) {
                    feedStream = streams[0];
                    feedContent = feed;
                }

                if (feedStream) {
                    this.setState({
                        feedsSelectorMessage: ''
                    });

                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__common_actions_appActions__["z" /* contentSelect */])(_extends({}, feedContent, { reEmbed: true })));
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__common_actions_appActions__["P" /* streamUnSelect */])());
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__common_actions_appActions__["y" /* closeModalMessage */])());
                    feedStream.feedSwitch = true;
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__common_actions_appActions__["O" /* streamSelect */])(feedStream));
                }
            }
        }, {
            key: 'onFeedCloseModal',
            value: function onFeedCloseModal() {
                this.setState({ showFeedsSelector: false });
            }
        }, {
            key: 'getDSSPlayerMutedOnAuthPlay',
            value: function getDSSPlayerMutedOnAuthPlay(mutedQuery, authPlay) {
                if (authPlay === true || authPlay === 'true') {
                    var dssPlayerMuted = this.props.dssPlayerMuted;

                    var muted = dssPlayerMuted;
                    if (mutedQuery !== undefined) {
                        if (mutedQuery === false || mutedQuery === 'false') {
                            muted = false;
                        } else if (mutedQuery === true || mutedQuery === 'true') {
                            muted = true;
                        }
                    }
                    return muted;
                }
                return null;
            }

            /**
             * hasUserFeedSwitchedStream - Handles returning a boolean flag which determines
             if the
             * current stream has been triggered via a feedSwitch (i.e. click from feed selector dialog)
             *
             * @param {Object} currentStream - Stream object containing the feedSwitch property
             *
             * @return {Boolean}
             */

        }, {
            key: 'hasUserFeedSwitchedStream',
            value: function hasUserFeedSwitchedStream(currentStream) {
                // eslint-disable-line class-methods-use-this
                return currentStream && currentStream.feedSwitch ? currentStream.feedSwitch : false;
            }

            // fire actions and set state to indicate the player is ready for embed

        }, {
            key: 'playerReady',
            value: function playerReady() {
                var initialEmbedContent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                var _props10 = this.props,
                    disableAuthPrompt = _props10.disableAuthPrompt,
                    dispatch = _props10.dispatch,
                    placement = _props10.placement,
                    bucketId = _props10.bucketId,
                    bucketName = _props10.bucketName,
                    pageId = _props10.pageId,
                    pageName = _props10.pageName,
                    playerPlacement = _props10.playerPlacement,
                    userAuth = _props10.userAuth,
                    lastFeeds = _props10.lastFeeds,
                    locationBeforeTransitions = _props10.routing.locationBeforeTransitions;

                var _ref5 = locationBeforeTransitions || {},
                    _ref5$query = _ref5.query,
                    query = _ref5$query === undefined ? {} : _ref5$query,
                    pathname = _ref5.pathname;

                var playerReadyAction = dispatch(Object(__WEBPACK_IMPORTED_MODULE_42__actions__["v" /* createPlayerReadyAction */])(playerPlacement, initialEmbedContent));

                var omnitureQuery = Object(__WEBPACK_IMPORTED_MODULE_39__lib_omniture__["c" /* getOmnitureQuery */])(query);

                if (playerReadyAction.autoEmbed === true) {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__common_actions_appActions__["z" /* contentSelect */])(_extends({}, initialEmbedContent, {
                        disableAuthPrompt: disableAuthPrompt,
                        placement: placement,
                        bucketId: bucketId,
                        bucketName: bucketName,
                        pageId: pageId,
                        pageName: pageName
                    }, omnitureQuery)));

                    var _props11 = this.props,
                        preauthorizedResources = _props11.preauthorizedResources,
                        pickerStreams = _props11.pickerStreams;

                    var authRes = { userAuth: userAuth, preauthorizedResources: preauthorizedResources };
                    var isVod = initialEmbedContent && initialEmbedContent.type === 'vod';

                    if (Object(__WEBPACK_IMPORTED_MODULE_29__lib_auth_authStateKnown__["a" /* default */])(userAuth) || isVod || !userAuth.length) {
                        if (Object(__WEBPACK_IMPORTED_MODULE_33__lib_auth_canPlayContent__["a" /* default */])(initialEmbedContent, userAuth, false)) {
                            Object(__WEBPACK_IMPORTED_MODULE_45__lib_streamPicker__["f" /* selectStreamForAuthUsers */])({
                                dispatch: dispatch,
                                authRes: authRes,
                                pickerStreams: pickerStreams,
                                content: initialEmbedContent,
                                feeds: lastFeeds,
                                locationBeforeTransitions: locationBeforeTransitions
                            });
                        }
                    } else {
                        /**
                         * when user is not authenticated. We don't want to trigger auth flow
                         * for non-player pages
                         */
                        if (pathname.indexOf('/player') === -1 && initialEmbedContent.id === query.id) {
                            dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__common_actions_appActions__["z" /* contentSelect */])(initialEmbedContent));
                        }
                        this.setState({ deferInitialStreamSelect: true });
                    }
                }
            }
        }, {
            key: 'newRelicTrackingOnPlayer',
            value: function () {
                var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(stream) {
                    var _props12, env, device, newrelicInsertKey, newrelicAccountId, oneId, id, content, streams, param;

                    return regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _props12 = this.props, env = _props12.env, device = _props12.device, newrelicInsertKey = _props12.newrelicInsertKey, newrelicAccountId = _props12.newrelicAccountId, oneId = _props12.oneId;
                                    id = stream.id, content = stream.content, streams = stream.streams;
                                    param = {
                                        newrelicInsertKey: newrelicInsertKey,
                                        newrelicAccountId: newrelicAccountId,
                                        trackingData: {
                                            env: env,
                                            device: device,
                                            eventId: content ? content.eventId : null,
                                            action: 'SelectedStreamOnPlayer',
                                            streams: id,
                                            streamCount: streams ? streams.length : 1,
                                            swid: oneId.swid,
                                            eventType: 'PlaybackFlow',
                                            devicePlatform: 'watchWeb'
                                        }
                                    };
                                    _context.next = 5;
                                    return Object(__WEBPACK_IMPORTED_MODULE_35__lib_api_newRelicApi__["a" /* newRelicTrackEvent */])(param);

                                case 5:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, this);
                }));

                function newRelicTrackingOnPlayer(_x3) {
                    return _ref6.apply(this, arguments);
                }

                return newRelicTrackingOnPlayer;
            }()

            // called on componentDidMount (if autoplay), handleClick, or componentWillReceiveProps for deferred initialization.
            // takes props as a parameter for when called from componentWillReceiveProps, which passes "nextProps" in

        }, {
            key: 'initializePlayer',
            value: function initializePlayer(nextProps) {
                var props = nextProps || this.props;
                if (this.state.initialized === false) {
                    if (this._isMounted === false) {
                        return;
                    }

                    var bam = props.bootstrap.bam,
                        initialEmbedContent = props.initialEmbedContent,
                        scoringComplete = props.scoringComplete,
                        playerTech = props.playerTech,
                        locationBeforeTransitions = props.routing.locationBeforeTransitions;

                    var _ref7 = locationBeforeTransitions || {},
                        _ref7$query = _ref7.query,
                        query = _ref7$query === undefined ? {} : _ref7$query;

                    // if there is no content yet (no selected event and page request hasn't completed),
                    // defer player initialization to componentWillReceiveProps


                    if (!initialEmbedContent || Object(__WEBPACK_IMPORTED_MODULE_36__lib_util_isEmpty__["a" /* default */])(initialEmbedContent) || !scoringComplete) {
                        this.setState({ deferPlayerInitialization: true });
                        return;
                    }

                    this.videoPlayer = new __WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */]({
                        bamPlayerOptions: query[__WEBPACK_IMPORTED_MODULE_10__enums__["t" /* Flags */].BAM_ENV] ? _extends({}, bam, { env: query[__WEBPACK_IMPORTED_MODULE_10__enums__["t" /* Flags */].BAM_ENV] }) : bam,
                        brightcovePlayerOptions: {
                            playerTech: playerTech,
                            optimizeLive: true,
                            // Enables the Brightcove player to use the native HTML5 video player when set to true
                            // The `native` value is passed via query parameter (playertech=native)
                            native: playerTech === 'native'
                        }
                    });
                    this.playerReady(initialEmbedContent);
                    this.setState({ initialized: true });
                }
            }
        }, {
            key: 'handleClick',
            value: function handleClick(event) {
                event.preventDefault();
                __WEBPACK_IMPORTED_MODULE_43__globalVideoElement__["a" /* default */].prime();

                if (this.props.clickHandler) {
                    this.props.clickHandler(event);
                }

                // only initialize player if it hasn't been already
                if (this.props.player.embedded === false) {
                    this.initializePlayer(this.props);
                }
            }
        }, {
            key: 'unregisterEvents',
            value: function unregisterEvents() {
                if (!this.videoPlayer) {
                    return;
                }
                // Brightcove Player Events
                this.videoPlayer.off(__WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].Events.ESPN_AUTOPLAY_TOGGLED, this.onToggleAutoPlay);
                this.videoPlayer.off(__WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].Events.ESPN_PROGRAM_CHANGE, this.onProgramChange);
                this.videoPlayer.off(__WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].Events.ESPN_CONTENT_LOADED, this.onContentLoaded);
                this.videoPlayer.off(__WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].Events.ESPN_SOCIAL_OPENED, this.onSocialOpened);
                this.videoPlayer.off(__WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].Events.ESPN_SOCIAL_CLOSED, this.onSocialClosed);
                this.videoPlayer.off(__WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].Events.ESPN_CAPTION_OPENED, this.onCaptionOpened);
                this.videoPlayer.off(__WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].Events.ESPN_CAPTION_CLOSED, this.onCaptionClosed);
                this.videoPlayer.off(__WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].Events.ESPN_ERROR, this.onPlaybackError);
                this.videoPlayer.off(__WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].Events.ESPN_DRM_ERROR, this.onDrmError);
                this.videoPlayer.off(__WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].Events.ESPN_ADS_AD_SKIPPED, __WEBPACK_IMPORTED_MODULE_39__lib_omniture__["m" /* trackEspnPlayerOnAdSkipped */]);

                // BAM Player Events
                this.videoPlayer.off(__WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].Events.AUTHORIZE_USER, this.onBAMAuthrizeUser);
                this.videoPlayer.off(__WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].Events.FEED_CHANGE_REQUEST, this.onBAMFeedChange);
                this.videoPlayer.off(__WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].Events.SETTINGS_CHANGED, this.onBAMSettingsChanged);
                this.videoPlayer.off(__WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].Events.MEDIA_LOADED, this.onBAMMediaLoaded);
                this.videoPlayer.off(__WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].Events.PLAYBACK_ERROR, this.onBAMPlaybackError);
            }
        }, {
            key: 'registerEvents',
            value: function registerEvents() {
                if (!this.videoPlayer) {
                    return;
                }
                // Brightcove Player Events
                this.videoPlayer.on(__WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].Events.ESPN_AUTOPLAY_TOGGLED, this.onToggleAutoPlay);
                this.videoPlayer.on(__WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].Events.ESPN_PROGRAM_CHANGE, this.onProgramChange);
                this.videoPlayer.on(__WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].Events.ESPN_CONTENT_LOADED, this.onContentLoaded);
                this.videoPlayer.on(__WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].Events.ESPN_SOCIAL_OPENED, this.onSocialOpened);
                this.videoPlayer.on(__WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].Events.ESPN_SOCIAL_CLOSED, this.onSocialClosed);
                this.videoPlayer.on(__WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].Events.ESPN_CAPTION_OPENED, this.onCaptionOpened);
                this.videoPlayer.on(__WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].Events.ESPN_CAPTION_CLOSED, this.onCaptionClosed);
                this.videoPlayer.on(__WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].Events.ESPN_ERROR, this.onPlaybackError);
                this.videoPlayer.on(__WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].Events.ESPN_DRM_ERROR, this.onDrmError);
                this.videoPlayer.on(__WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].Events.ESPN_ADS_AD_SKIPPED, __WEBPACK_IMPORTED_MODULE_39__lib_omniture__["m" /* trackEspnPlayerOnAdSkipped */]);

                // BAM Player Events
                this.videoPlayer.on(__WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].Events.AUTHORIZE_USER, this.onBAMAuthrizeUser);
                this.videoPlayer.on(__WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].Events.FEED_CHANGE_REQUEST, this.onBAMFeedChange);
                this.videoPlayer.on(__WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].Events.SETTINGS_CHANGED, this.onBAMSettingsChanged);
                this.videoPlayer.on(__WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].Events.MEDIA_LOADED, this.onBAMMediaLoaded);
                this.videoPlayer.on(__WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].Events.PLAYBACK_ERROR, this.onBAMPlaybackError);
            }
        }, {
            key: 'startAutoEmbedTimer',
            value: function startAutoEmbedTimer() {
                if (this.state.autoEmbedCountDown <= 0) {
                    this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_42__actions__["n" /* createAutoEmbedTimerCompleteAction */])());
                    clearTimeout(this._autoEmbedTimer);
                    return;
                }
                if (this._isMounted === true && this.state.autoEmbedCountDown > 0) {
                    this.setState({ autoEmbedCountDown: this.state.autoEmbedCountDown - 1 });
                    this._autoEmbedTimer = setTimeout(this.startAutoEmbedTimer, 1000);
                }
            }

            /**
             * Display an internationalized error message within the player.
             * Embeds with an error if not embedded, otherwise calls error on the player object.
             * @param {object} stream
             * @param {string} type
             * @param {string} messageKey
             * @param {object} props
             */

        }, {
            key: 'throwError',
            value: function throwError(stream) {
                var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_10__enums__["z" /* PlayerError */].DEFAULT;
                var messageArg = arguments[2];
                var props = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this.props;
                var messages = props.messages,
                    formatMessage = props.intl.formatMessage,
                    player = props.player,
                    selectedContent = props.selectedContent,
                    locationBeforeTransitions = props.routing.locationBeforeTransitions;

                var _ref8 = locationBeforeTransitions || {},
                    _ref8$query = _ref8.query,
                    query = _ref8$query === undefined ? {} : _ref8$query;

                var message = messageArg;
                if (message.indexOf('player.error') === 0) {
                    message = formatMessage(messages[message]);
                }

                var errorObj = {
                    type: type,
                    message: message
                };
                var _selectedContent$stre2 = selectedContent.streams,
                    streams = _selectedContent$stre2 === undefined ? [] : _selectedContent$stre2;
                // ensure to remove dupes, avoids FeedsSelector component from re-rendering duplicate streams

                streams = streams.length && __WEBPACK_IMPORTED_MODULE_5_lodash_uniqBy___default()(streams, 'id');

                if (query.prePlayPicker && streams.length === 1) {
                    streams.push(_extends({}, streams[0], { tier: 'primary', id: streams[0].id + '1', test: true }));
                    streams.push(_extends({}, streams[0], { tier: 'primary', id: streams[0].id + '2', test: true }));
                    streams.push(_extends({}, streams[0], { tier: 'secondary', id: streams[0].id + '3', test: true }));
                }

                // on first embed, embed with an error
                if (streams.length > 1) {
                    this.unregisterEvents();
                    this.unembedPlayer();
                    this.setState({
                        showFeedsSelector: true,
                        feedsSelectorMessage: message
                    });
                } else if (player.embedded === false) {
                    this.embedPlayer(props, stream, {}, {}, errorObj);
                } else {
                    this.videoPlayer.error(errorObj);
                }
            }
        }, {
            key: 'unembedPlayer',
            value: function () {
                var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(destroy) {
                    var dispatch;
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    dispatch = this.props.dispatch;

                                    if (!this.videoPlayer) {
                                        _context2.next = 16;
                                        break;
                                    }

                                    // removes flickering of previous thumbnail
                                    __WEBPACK_IMPORTED_MODULE_43__globalVideoElement__["a" /* default */].poster = '';
                                    _context2.prev = 3;

                                    if (!destroy) {
                                        _context2.next = 9;
                                        break;
                                    }

                                    _context2.next = 7;
                                    return this.videoPlayer.destroy();

                                case 7:
                                    _context2.next = 11;
                                    break;

                                case 9:
                                    _context2.next = 11;
                                    return this.videoPlayer.delete();

                                case 11:
                                    _context2.next = 16;
                                    break;

                                case 13:
                                    _context2.prev = 13;
                                    _context2.t0 = _context2['catch'](3);

                                    console.error(_context2.t0);

                                case 16:
                                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_42__actions__["y" /* createStreamPlayingAction */])({ stream: {} }));
                                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_42__actions__["t" /* createPlayerEmbeddedAction */])(false));

                                case 18:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, this, [[3, 13]]);
                }));

                function unembedPlayer(_x6) {
                    return _ref9.apply(this, arguments);
                }

                return unembedPlayer;
            }()
        }, {
            key: 'createSettingsMenuConfig',
            value: function createSettingsMenuConfig(stream) {
                var _this4 = this;

                var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;
                var dispatch = props.dispatch,
                    isDomestic = props.isDomestic,
                    provider = props.provider,
                    userAuth = props.userAuth,
                    messages = props.messages,
                    formatMessage = props.intl.formatMessage;

                var menuItems = [];

                if (isDomestic && Object(__WEBPACK_IMPORTED_MODULE_30__lib_auth_streamHasAuthType__["a" /* default */])(stream, __WEBPACK_IMPORTED_MODULE_10__enums__["e" /* AuthTypes */].MVPD) && userAuth.indexOf(__WEBPACK_IMPORTED_MODULE_10__enums__["e" /* AuthTypes */].MVPD) > -1 && provider.name) {
                    menuItems.push({
                        label: formatMessage(messages['player.menu.logout'], { providerName: provider.name }),
                        fn: function fn() {
                            dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__common_actions_authenticationActions__["C" /* createAndPerformLogoutAction */])(_this4.props.onDeckContent));
                        }
                    });
                }

                return {
                    menuItems: menuItems
                };
            }
        }, {
            key: 'createLogoConfig',
            value: function createLogoConfig(stream) {
                var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;
                var _props$bootstrap$play = props.bootstrap.player;
                _props$bootstrap$play = _props$bootstrap$play === undefined ? {} : _props$bootstrap$play;
                var _props$bootstrap$play2 = _props$bootstrap$play.logos,
                    logos = _props$bootstrap$play2 === undefined ? {} : _props$bootstrap$play2,
                    isDomestic = props.isDomestic,
                    provider = props.provider,
                    locationBeforeTransitions = props.routing.locationBeforeTransitions,
                    flags = props.flags,
                    origin = props.location.origin;

                var _ref10 = locationBeforeTransitions || {},
                    pathname = _ref10.pathname;

                var logo = void 0;
                if (!isDomestic || pathname === '/syndicated/player') {
                    // syndicated player has its header to show logo
                    return logo;
                }
                if (Object(__WEBPACK_IMPORTED_MODULE_30__lib_auth_streamHasAuthType__["a" /* default */])(stream, __WEBPACK_IMPORTED_MODULE_10__enums__["e" /* AuthTypes */].MVPD) || Object(__WEBPACK_IMPORTED_MODULE_30__lib_auth_streamHasAuthType__["a" /* default */])(stream, __WEBPACK_IMPORTED_MODULE_10__enums__["e" /* AuthTypes */].ISP)) {
                    logo = {
                        src: __WEBPACK_IMPORTED_MODULE_4_selectn___default()('images.colorWithNegativeBackground.href', provider) || __WEBPACK_IMPORTED_MODULE_4_selectn___default()('images.logo.href', provider),
                        href: __WEBPACK_IMPORTED_MODULE_4_selectn___default()('links.web.href', provider)
                    };
                } else if (Object(__WEBPACK_IMPORTED_MODULE_30__lib_auth_streamHasAuthType__["a" /* default */])(stream, __WEBPACK_IMPORTED_MODULE_10__enums__["e" /* AuthTypes */].BAM)) {
                    if (Object(__WEBPACK_IMPORTED_MODULE_31__lib_auth_streamHasDTCPackage__["a" /* default */])(stream, __WEBPACK_IMPORTED_MODULE_10__enums__["s" /* Entitlements */].ESPN_PLUS_NHL)) {
                        logo = logos[__WEBPACK_IMPORTED_MODULE_10__enums__["s" /* Entitlements */].ESPN_PLUS_NHL];
                    } else if (Object(__WEBPACK_IMPORTED_MODULE_31__lib_auth_streamHasDTCPackage__["a" /* default */])(stream, __WEBPACK_IMPORTED_MODULE_10__enums__["s" /* Entitlements */].ESPN_PLUS_MLB)) {
                        logo = logos[__WEBPACK_IMPORTED_MODULE_10__enums__["s" /* Entitlements */].ESPN_PLUS_MLB];
                    } else if (Object(__WEBPACK_IMPORTED_MODULE_31__lib_auth_streamHasDTCPackage__["a" /* default */])(stream, __WEBPACK_IMPORTED_MODULE_10__enums__["s" /* Entitlements */].ESPN_PLUS)) {
                        logo = logos[__WEBPACK_IMPORTED_MODULE_10__enums__["s" /* Entitlements */].ESPN_PLUS];
                    }
                }
                if (logo && logo.href && logo.href.indexOf('http') !== 0) {
                    logo.href = '' + Object(__WEBPACK_IMPORTED_MODULE_38__lib_format_addQueryToUrl__["a" /* default */])('' + origin + logo.href, flags);
                }
                return logo;
            }
        }, {
            key: 'createFeedsMenuConfig',
            value: function createFeedsMenuConfig(stream) {
                var _this5 = this;

                var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;
                var feedsSelectorMessage = this.state.feedsSelectorMessage;
                var messages = props.messages,
                    formatMessage = props.intl.formatMessage,
                    pickerStreams = props.pickerStreams;


                var feeds = pickerStreams.length > 0 && pickerStreams.map(function (streamItem) {
                    var streamData = _extends({}, streamItem);
                    if (Array.isArray(streamData.contents) && streamData.contents.length > 0) {
                        streamData.contents.forEach(function (item) {
                            var selected = item && typeof item.id === 'string' && item.id === stream.id;

                            item.selected = selected;
                            item.playbackErrorMessage = selected && feedsSelectorMessage;
                        });
                    }

                    return _extends({}, streamData, {
                        fn: function fn(feed) {
                            _this5.onFeedClick(feed);
                        }
                    });
                });

                var feedsMenu = pickerStreams.length > 0 && {
                    title: formatMessage(messages['player.feeds.title']),
                    feeds: feeds
                };
                return feedsMenu;
            }
        }, {
            key: 'embedPlayer',
            value: function () {
                var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                    var stream = arguments[1];
                    var authorization = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                    var streamlimiter = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                    var error = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
                    var callback = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : function () {};

                    var _ref12, _ref12$wrappedCompone, _ref12$wrappedCompone2, wrappedComponentRefs, playerContainer, apiEnv, env, lang, nielsenTrackingData, comscoreTrackingData, dispatch, isMobile, device, provider, isDomestic, edition, autoPlay, intlApp, oneIdToken, passOneIdToken, selectedContent, userInitiated, location, locationBeforeTransitions, playbackMeta, prerollConfig, playerAdsConfig, userAuth, pickerStreams, shieldApiKey, playerOpts, _ref13, _ref13$query, query, _ref14, locationQueryParams, host, protocol, auth, social, playerTech, currentPlayerTech, player, logo, settingsMenu, feedsMenu, opts, autoplay, isBamPlayer, isBrightCovePlayer, elementId, wrapperEl, playerOptions, streamObj, shareBaseUrl, muted, customProps;

                    return regeneratorRuntime.wrap(function _callee3$(_context3) {
                        while (1) {
                            switch (_context3.prev = _context3.next) {
                                case 0:
                                    // the playerContainer is the container in which we embed the player
                                    // (its DOM is not manipulated by the ESPNVideoPlayer)
                                    _ref12 = this.refs || {}, _ref12$wrappedCompone = _ref12.wrappedComponent;
                                    _ref12$wrappedCompone = _ref12$wrappedCompone === undefined ? {} : _ref12$wrappedCompone;
                                    _ref12$wrappedCompone2 = _ref12$wrappedCompone.refs, wrappedComponentRefs = _ref12$wrappedCompone2 === undefined ? {} : _ref12$wrappedCompone2;
                                    playerContainer = wrappedComponentRefs.playerContainer;

                                    if (!playerContainer) {
                                        _context3.next = 70;
                                        break;
                                    }

                                    this.setState({
                                        showFeedsSelector: false,
                                        feedsSelectorMessage: ''
                                    });

                                    apiEnv = props.apiEnv, env = props.env, lang = props.lang, nielsenTrackingData = props.nielsenTrackingData, comscoreTrackingData = props.comscoreTrackingData, dispatch = props.dispatch, isMobile = props.isMobile, device = props.device, provider = props.provider, isDomestic = props.isDomestic, edition = props.edition, autoPlay = props.autoPlay, intlApp = props.intlApp, oneIdToken = props.oneIdToken, passOneIdToken = props.passOneIdToken, selectedContent = props.selectedContent, userInitiated = props.userInitiated, location = props.location, locationBeforeTransitions = props.routing.locationBeforeTransitions, playbackMeta = props.playbackMeta, prerollConfig = props.prerollConfig, playerAdsConfig = props.playerAdsConfig, userAuth = props.userAuth, pickerStreams = props.pickerStreams, shieldApiKey = props.shieldApiKey, playerOpts = props.playerOpts;
                                    _ref13 = locationBeforeTransitions || {}, _ref13$query = _ref13.query, query = _ref13$query === undefined ? {} : _ref13$query;
                                    _ref14 = location || {}, locationQueryParams = _ref14.query, host = _ref14.host, protocol = _ref14.protocol;
                                    auth = _extends({}, authorization, {
                                        partnerName: query[__WEBPACK_IMPORTED_MODULE_10__enums__["t" /* Flags */].PARTNER]
                                    });
                                    social = !intlApp ? {
                                        url: 'http://www.espn.com/watch?id={{ID}}'
                                    } : false;
                                    playerTech = Object(__WEBPACK_IMPORTED_MODULE_30__lib_auth_streamHasAuthType__["a" /* default */])(stream, __WEBPACK_IMPORTED_MODULE_10__enums__["e" /* AuthTypes */].BAM) ? __WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].PlayerTech.BAM : __WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].PlayerTech.BRIGHTCOVE;
                                    currentPlayerTech = void 0;


                                    if (this.videoPlayer) {
                                        player = this.videoPlayer.getPlayer();

                                        if (player && player.tech === __WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].PlayerTech.BRIGHTCOVE) {
                                            currentPlayerTech = __WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].PlayerTech.BRIGHTCOVE;
                                        } else if (player && player.tech === __WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].PlayerTech.BAM) {
                                            currentPlayerTech = __WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].PlayerTech.BAM;
                                        }
                                    }

                                    _context3.prev = 14;

                                    if (!(currentPlayerTech === __WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].PlayerTech.BRIGHTCOVE)) {
                                        _context3.next = 20;
                                        break;
                                    }

                                    _context3.next = 18;
                                    return this.videoPlayer.delete();

                                case 18:
                                    _context3.next = 23;
                                    break;

                                case 20:
                                    if (!(currentPlayerTech === __WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].PlayerTech.BAM && playerTech === __WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].PlayerTech.BRIGHTCOVE)) {
                                        _context3.next = 23;
                                        break;
                                    }

                                    _context3.next = 23;
                                    return this.videoPlayer.delete();

                                case 23:
                                    _context3.next = 28;
                                    break;

                                case 25:
                                    _context3.prev = 25;
                                    _context3.t0 = _context3['catch'](14);

                                    console.error(_context3.t0);

                                case 28:

                                    // create `logo`
                                    logo = this.createLogoConfig(stream, props);
                                    // create `settingsMenu`

                                    settingsMenu = this.createSettingsMenuConfig(stream, props);
                                    // create `feedsMenu`

                                    feedsMenu = this.createFeedsMenuConfig(stream, props);
                                    opts = Object(__WEBPACK_IMPORTED_MODULE_41__util__["d" /* getPlayerOptions */])({
                                        apiEnv: apiEnv,
                                        stream: stream,
                                        authorization: auth,
                                        streamlimiter: streamlimiter,
                                        nielsenTrackingData: nielsenTrackingData,
                                        comscoreTrackingData: comscoreTrackingData,
                                        isMobile: isMobile,
                                        device: device,
                                        error: error,
                                        env: env,
                                        lang: lang,
                                        provider: provider,
                                        isDomestic: isDomestic,
                                        social: social,
                                        userInitiated: userInitiated,
                                        logo: logo,
                                        settingsMenu: settingsMenu,
                                        feedsMenu: feedsMenu,
                                        playbackMeta: playbackMeta,
                                        prerollConfig: prerollConfig,
                                        adsConfig: playerAdsConfig,
                                        edition: edition,
                                        userAuth: userAuth,
                                        pickerStreams: pickerStreams,
                                        shieldApiKey: shieldApiKey,
                                        playerOpts: playerOpts
                                    });

                                    console.log('ESPN PLAYER FEEDS MENU:', feedsMenu); // eslint-disable-line
                                    console.log('ESPN PLAYER OPTIONS:', opts); // eslint-disable-line

                                    // `autoPlay` flag only applies to the initial playback.
                                    autoplay = autoPlay || !!__WEBPACK_IMPORTED_MODULE_43__globalVideoElement__["a" /* default */].primed;
                                    isBamPlayer = playerTech === __WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].PlayerTech.BAM;
                                    isBrightCovePlayer = playerTech === __WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].PlayerTech.BRIGHTCOVE;


                                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_42__actions__["u" /* createPlayerEmbeddingAction */])(true));

                                    if (isBrightCovePlayer) {
                                        __WEBPACK_IMPORTED_MODULE_43__globalVideoElement__["a" /* default */].poster = stream.content.imageHref;
                                        __WEBPACK_IMPORTED_MODULE_43__globalVideoElement__["a" /* default */].className = 'vjs-tech';
                                    }

                                    elementId = isBrightCovePlayer ? 'watchespn-player' : 'watchespn-bam-player';
                                    wrapperEl = void 0;


                                    if (currentPlayerTech !== __WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].PlayerTech.BAM || playerTech !== __WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].PlayerTech.BAM) {
                                        // create a wrapper element so the video player doesn't manipulate the DOM that is registered with React
                                        wrapperEl = document.createElement('div');
                                        wrapperEl.setAttribute('data-vjs-player', '');
                                        wrapperEl.id = elementId;
                                        wrapperEl.style.display = 'none'; // to avoid FOUC
                                        if (playerTech === __WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].PlayerTech.BRIGHTCOVE) {
                                            wrapperEl.appendChild(__WEBPACK_IMPORTED_MODULE_43__globalVideoElement__["a" /* default */]);
                                        }

                                        playerContainer.appendChild(wrapperEl);
                                        wrapperEl.style.display = 'block';
                                    }

                                    playerOptions = {
                                        playerTech: playerTech,
                                        container: isBamPlayer ? '#' + elementId : __WEBPACK_IMPORTED_MODULE_43__globalVideoElement__["a" /* default */]
                                    };


                                    if (isBamPlayer) {
                                        // test stream url: `ml=https://qa-espn-edge.bamgrid.com/media/052c5f81-4a57-4b9b-8d51-080c3730fabf/scenarios/{scenario}`
                                        streamObj = {
                                            id: stream.id
                                        };
                                        // Derive the root url from react-router; default to production base url

                                        shareBaseUrl = host && protocol ? protocol + '//' + host + '/watch/player' : 'http://www.espn.com/watch/player';

                                        streamObj.shareUrl = shareBaseUrl + '?id=' + stream.id;

                                        if (query.ml) {
                                            // test param
                                            streamObj.mediaLocation = query.ml;
                                        }

                                        // Handles query parameter `t` for video startTime
                                        if (query.t) {
                                            streamObj.startTime = query.t;
                                        } else if (locationQueryParams.t) {
                                            streamObj.startTime = locationQueryParams.t;
                                            delete locationQueryParams.t; // Prevent `t` from showing up in subsequent media loads
                                        }

                                        muted = this.getDSSPlayerMutedOnAuthPlay(query[__WEBPACK_IMPORTED_MODULE_10__enums__["t" /* Flags */].MUTED], autoPlay);
                                        customProps = {
                                            autoPlay: autoplay,
                                            muted: muted,
                                            analytics: opts.analytics,
                                            poster: stream.content.imageHref,
                                            logo: logo,
                                            adsConfig: playerAdsConfig, // Pass Active Ad Provider config derived from selector to BAM player
                                            hudson: true
                                        };


                                        if (stream.feedSwitch && currentPlayerTech === __WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].PlayerTech.BAM) {
                                            customProps = _extends({}, customProps, {
                                                playlistItem: stream
                                            });
                                        } else {
                                            customProps = _extends({}, customProps, {
                                                pageApiMeta: _extends({}, selectedContent, { pickerStreams: pickerStreams })
                                            });
                                        }

                                        playerOptions = _extends({}, playerOptions, Object(__WEBPACK_IMPORTED_MODULE_37__lib_util_getBamAuthConfig__["a" /* default */])(oneIdToken, passOneIdToken, userAuth), {
                                            language: {
                                                ui: 'en',
                                                audio: 'en'
                                            },
                                            playlist: [streamObj],
                                            autoPlay: autoplay,
                                            customProps: customProps
                                        });
                                    } else if (isBrightCovePlayer) {
                                        playerOptions = _extends({}, playerOptions, {
                                            options: _extends({}, opts, { autoplay: autoplay })
                                        });
                                    }

                                    _context3.prev = 44;

                                    if (!(stream.feedSwitch && currentPlayerTech === __WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].PlayerTech.BAM && playerTech === __WEBPACK_IMPORTED_MODULE_7__common_video_player__["a" /* default */].PlayerTech.BAM)) {
                                        _context3.next = 51;
                                        break;
                                    }

                                    delete stream.feedSwitch;
                                    _context3.next = 49;
                                    return this.videoPlayer.changeFeed(playerOptions);

                                case 49:
                                    _context3.next = 53;
                                    break;

                                case 51:
                                    _context3.next = 53;
                                    return this.videoPlayer.create(playerOptions);

                                case 53:
                                    _context3.next = 58;
                                    break;

                                case 55:
                                    _context3.prev = 55;
                                    _context3.t1 = _context3['catch'](44);

                                    console.error(_context3.t1);

                                case 58:

                                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_42__actions__["u" /* createPlayerEmbeddingAction */])(false));

                                    if (!(this._isMounted === false || this._isUnMounting === true)) {
                                        _context3.next = 62;
                                        break;
                                    }

                                    this.videoPlayer.delete();
                                    return _context3.abrupt('return');

                                case 62:

                                    if (wrapperEl) {
                                        wrapperEl.style.display = 'block';
                                    }
                                    this.unregisterEvents();
                                    this.registerEvents();

                                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_42__actions__["t" /* createPlayerEmbeddedAction */])(true));
                                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_42__actions__["y" /* createStreamPlayingAction */])({ stream: stream, error: !!error }));
                                    callback();
                                    // comment out newrelic tracking until tracking is required for new stream picker
                                    // if (isNewrelicTrackingOn &&
                                    //     (currentPlayerTech === WatchESPNWebPlayer.PlayerTech.BAM ||
                                    //         playerTech === WatchESPNWebPlayer.PlayerTech.BAM)) {
                                    //     // send newrelic track for selected stream that is presented to the users
                                    //     await this.newRelicTrackingOnPlayer(stream);
                                    // }
                                    _context3.next = 71;
                                    break;

                                case 70:
                                    console.error('Cannot embed player.  ' + WrappedComponent.displayName + ' is missing "playerElement" ref'); // eslint-disable-line

                                case 71:
                                case 'end':
                                    return _context3.stop();
                            }
                        }
                    }, _callee3, this, [[14, 25], [44, 55]]);
                }));

                function embedPlayer() {
                    return _ref11.apply(this, arguments);
                }

                return embedPlayer;
            }()
        }, {
            key: 'render',
            value: function render() {
                var showFeedsSelector = this.state.showFeedsSelector;
                // const showFeedsSelector = true;

                var _props13 = this.props,
                    selectedStream = _props13.selectedStream,
                    userAuth = _props13.userAuth;

                var feedsMenu = void 0;
                if (showFeedsSelector) {
                    feedsMenu = this.createFeedsMenuConfig(selectedStream, this.props, true);
                }
                return _jsx('div', {
                    style: { position: 'relative', width: '100%', height: '100%' }
                }, void 0, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({
                    ref: 'wrappedComponent'
                }, this.props, this.state, {
                    clickHandler: this.handleClick
                })), showFeedsSelector && feedsMenu && _jsx(__WEBPACK_IMPORTED_MODULE_8__FeedsSelector__["a" /* default */], {
                    title: feedsMenu.title,
                    feeds: feedsMenu.feeds,
                    userAuth: userAuth,
                    onClick: this.onFeedClick,
                    onClose: this.onFeedCloseModal
                }));
            }
        }]);

        return ESPNPlayer;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    ESPNPlayer.defaultProps = {
        disableAuthPrompt: true,
        initialAutoEmbedCountDown: 2,
        initialEmbedContent: {},
        recommendMobileWeb: false,
        userAuth: [],
        oneIdToken: {}
    };

    var mapStateToProps = function mapStateToProps(state) {
        var _state$app = state.app,
            _state$app$isMobile = _state$app.isMobile,
            isMobile = _state$app$isMobile === undefined ? false : _state$app$isMobile,
            env = _state$app.env,
            lang = _state$app.lang,
            country = _state$app.country,
            device = _state$app.device,
            openPicker = _state$app.openPicker,
            appName = _state$app.appName,
            player = state.player,
            routing = state.routing;

        var page = Object(__WEBPACK_IMPORTED_MODULE_20__common_selectors_pageSelector__["c" /* default */])(state);
        var edition = Object(__WEBPACK_IMPORTED_MODULE_16__common_selectors_appSelector__["k" /* editionSelector */])(state).edition;
        var shieldApiKey = Object(__WEBPACK_IMPORTED_MODULE_47__common_selectors_apiParamsSelector__["g" /* shieldApiKeySelector */])(state, edition);
        var playerOpts = Object(__WEBPACK_IMPORTED_MODULE_16__common_selectors_appSelector__["B" /* playerOptionsSelector */])(state);

        return {
            bootstrap: Object(__WEBPACK_IMPORTED_MODULE_14__common_selectors_bootstrapSelector__["a" /* default */])(state),
            apiEnv: Object(__WEBPACK_IMPORTED_MODULE_16__common_selectors_appSelector__["c" /* apiEnvSelector */])(state),
            env: env,
            lang: lang,
            country: country,
            initialEmbedContent: Object(__WEBPACK_IMPORTED_MODULE_18__common_selectors_initialEmbedSelector__["a" /* default */])(state),
            isMobile: isMobile,
            device: device,
            openPicker: openPicker,
            nielsenTrackingData: Object(__WEBPACK_IMPORTED_MODULE_15__common_selectors_analyticsSelectors__["e" /* nielsenTrackingSelector */])(state),
            comscoreTrackingData: Object(__WEBPACK_IMPORTED_MODULE_15__common_selectors_analyticsSelectors__["b" /* comscoreTrackingSelector */])(state),
            onDeckContent: Object(__WEBPACK_IMPORTED_MODULE_19__common_selectors_onDeckContentSelector__["a" /* default */])(state),
            player: player,
            playerTech: Object(__WEBPACK_IMPORTED_MODULE_16__common_selectors_appSelector__["C" /* playerTechSelector */])(state),
            autoPlay: Object(__WEBPACK_IMPORTED_MODULE_17__common_selectors_playerSelector__["a" /* autoPlaySelector */])(state),
            dssPlayerMuted: Object(__WEBPACK_IMPORTED_MODULE_17__common_selectors_playerSelector__["c" /* dssPlayerMutedSelector */])(state),
            selectedContent: Object(__WEBPACK_IMPORTED_MODULE_21__common_selectors_selectedContentSelector__["a" /* default */])(state),
            selectedStream: Object(__WEBPACK_IMPORTED_MODULE_22__common_selectors_selectedStreamSelector__["a" /* default */])(state),
            playingStream: Object(__WEBPACK_IMPORTED_MODULE_23__common_selectors_playingStreamSelector__["a" /* default */])(state),
            provider: Object(__WEBPACK_IMPORTED_MODULE_25__common_selectors_providerSelector__["a" /* default */])(state),
            routing: routing,
            scoringComplete: page.scored,
            userAuth: Object(__WEBPACK_IMPORTED_MODULE_26__common_selectors_authenticationSelectors__["r" /* userAuthSelector */])(state),
            preauthorizedResources: Object(__WEBPACK_IMPORTED_MODULE_26__common_selectors_authenticationSelectors__["o" /* preauthorizedResourcesSelector */])(state),
            oneIdToken: Object(__WEBPACK_IMPORTED_MODULE_27__common_selectors_oneIdSelector__["g" /* oneIdTokenSelector */])(state),
            passOneIdToken: Object(__WEBPACK_IMPORTED_MODULE_26__common_selectors_authenticationSelectors__["n" /* passOneIdTokenSelector */])(state),
            bypassToken: Object(__WEBPACK_IMPORTED_MODULE_16__common_selectors_appSelector__["e" /* bypassTokenSelector */])(state),
            isDomestic: Object(__WEBPACK_IMPORTED_MODULE_16__common_selectors_appSelector__["s" /* isDomesticSelector */])(state),
            edition: edition,
            intlApp: Object(__WEBPACK_IMPORTED_MODULE_16__common_selectors_appSelector__["p" /* intlAppSelector */])(state),
            recommendMobileWeb: Object(__WEBPACK_IMPORTED_MODULE_17__common_selectors_playerSelector__["g" /* recommendMobileWebSelector */])(state),
            flags: Object(__WEBPACK_IMPORTED_MODULE_28__common_selectors_flagsSelector__["a" /* persistentFlagsSelector */])(state),
            location: Object(__WEBPACK_IMPORTED_MODULE_16__common_selectors_appSelector__["w" /* locationSelector */])(state),
            playbackMeta: Object(__WEBPACK_IMPORTED_MODULE_16__common_selectors_appSelector__["A" /* playbackMetaSelector */])(state),
            prerollConfig: Object(__WEBPACK_IMPORTED_MODULE_17__common_selectors_playerSelector__["f" /* prerollConfigSelector */])(state),
            lastFeeds: Object(__WEBPACK_IMPORTED_MODULE_17__common_selectors_playerSelector__["d" /* lastFeedsSelector */])(state),
            playerAdsConfig: Object(__WEBPACK_IMPORTED_MODULE_17__common_selectors_playerSelector__["e" /* playerAdsConfigSelector */])(state),
            oneId: state.oneId,
            newrelicInsertKey: state.app.newrelicInsertKey,
            newrelicAccountId: state.app.newrelicAccountId,
            isNewrelicTrackingOn: Object(__WEBPACK_IMPORTED_MODULE_16__common_selectors_appSelector__["x" /* newRelicTrackingSelector */])(state),
            pickerStreams: Object(__WEBPACK_IMPORTED_MODULE_24__common_selectors_pickerStreamsSelector__["a" /* default */])(state),
            appName: appName,
            hideNav: Object(__WEBPACK_IMPORTED_MODULE_16__common_selectors_appSelector__["o" /* hideNavSelector */])(state),
            shieldApiKey: shieldApiKey,
            playerOpts: playerOpts
        };
    };

    return Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, null, null, { withRef: true })(Object(__WEBPACK_IMPORTED_MODULE_40__common_injectIntl__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default()(ESPNPlayer, WrappedComponent), { withRef: true }));
}

/* harmony default export */ __webpack_exports__["a"] = (connectPlayer);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = authenticationAware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_uniq__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_uniq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enums__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_PropTypes__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_actions_authenticationActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_actions_appActions__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_api_newRelicApi__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_util_isEmpty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_auth_authStateKnown__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_auth_canPlayContent__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_auth_canPlayStream__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib_auth_streamHasAuthType__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib_streamPicker__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_selectors_authenticationSelectors__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_selectors_selectedContentSelector__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__common_selectors_selectedStreamSelector__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__common_selectors_routingSelector__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__common_selectors_pickerStreamsSelector__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__common_selectors_oneIdSelector__ = __webpack_require__(27);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





















// import { newRelicTrackingSelector } from 'common/selectors/appSelector';



function authenticationAware() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    /**
     * Currently options is not being passed from authenticationAware caller.
     * createDisplayProviderDialogAction is just assigned to nonAuthedActionCreator
     * We don't need to do the following assignment if we remove options arg
     */
    var _options$nonAuthedAct = options.nonAuthedActionCreator,
        nonAuthedActionCreator = _options$nonAuthedAct === undefined ? __WEBPACK_IMPORTED_MODULE_6__common_actions_authenticationActions__["N" /* createDisplayProviderDialogAction */] : _options$nonAuthedAct;


    return function wrap(WrappedComponent) {
        var AuthenticationAware = function (_Component) {
            _inherits(AuthenticationAware, _Component);

            function AuthenticationAware(props) {
                _classCallCheck(this, AuthenticationAware);

                var _this = _possibleConstructorReturn(this, (AuthenticationAware.__proto__ || Object.getPrototypeOf(AuthenticationAware)).call(this, props));

                _this.providerSelect = _this.providerSelect.bind(_this);
                _this.adobePassLogout = _this.adobePassLogout.bind(_this);
                _this.newRelicTrackingOnStreamAuth = _this.newRelicTrackingOnStreamAuth.bind(_this);
                _this.newRelicTrackingOnSelectStream = _this.newRelicTrackingOnSelectStream.bind(_this);
                _this.state = {
                    isPaywallRendered: false
                };
                return _this;
            }

            _createClass(AuthenticationAware, [{
                key: 'componentWillReceiveProps',
                value: function componentWillReceiveProps(_ref) {
                    var _ref$adobePass = _ref.adobePass,
                        nextAdobePass = _ref$adobePass === undefined ? {} : _ref$adobePass,
                        authenticationEnabled = _ref.authenticationEnabled,
                        checkAuthenticationComplete = _ref.checkAuthenticationComplete,
                        nextSelectedContent = _ref.selectedContent,
                        nextSelectedStream = _ref.selectedStream,
                        oneIdToken = _ref.oneIdToken,
                        userAuth = _ref.userAuth,
                        nextBamSubReady = _ref.bamSubReady;
                    var _props = this.props,
                        dispatch = _props.dispatch,
                        _props$adobePass = _props.adobePass;
                    _props$adobePass = _props$adobePass === undefined ? {} : _props$adobePass;
                    var _props$adobePass$chec = _props$adobePass.checkAuthentication;
                    _props$adobePass$chec = _props$adobePass$chec === undefined ? {} : _props$adobePass$chec;
                    var completeTime = _props$adobePass$chec.completeTime,
                        selectedContent = _props.selectedContent,
                        selectedStream = _props.selectedStream,
                        locationBeforeTransitions = _props.routing.locationBeforeTransitions;

                    var _ref2 = locationBeforeTransitions || {},
                        _ref2$query = _ref2.query,
                        query = _ref2$query === undefined ? {} : _ref2$query,
                        pathname = _ref2.pathname;

                    var _nextAdobePass$checkA = nextAdobePass.checkAuthentication;
                    _nextAdobePass$checkA = _nextAdobePass$checkA === undefined ? {} : _nextAdobePass$checkA;
                    var nextCompleteTime = _nextAdobePass$checkA.completeTime;
                    var status = nextSelectedContent.status;

                    var isUpcoming = status === 'upcoming';

                    if (Object(__WEBPACK_IMPORTED_MODULE_9__lib_util_isEmpty__["a" /* default */])(nextSelectedContent)) {
                        return;
                    }

                    var loginWithContentID = query.login_with_content_eventId || query.login_with_content_id;
                    // logic for realoding page after OneID login triggered by Paywall(`LOGIN_REQUESTED`)
                    // trigger paywall again and updateRoute if following condition is met after user is logged in
                    if (loginWithContentID) {
                        var authTypes = [__WEBPACK_IMPORTED_MODULE_4__enums__["e" /* AuthTypes */].BAM];
                        var packages = query.login_with_pkg && query.login_with_pkg.split(',');
                        var streamPlaywableAfterLogin = Object(__WEBPACK_IMPORTED_MODULE_12__lib_auth_canPlayStream__["a" /* default */])({ authTypes: authTypes, packages: packages }, userAuth, false);
                        var cannotPlay = isUpcoming || Object(__WEBPACK_IMPORTED_MODULE_10__lib_auth_authStateKnown__["a" /* default */])(userAuth) && !streamPlaywableAfterLogin;

                        if (cannotPlay || Object(__WEBPACK_IMPORTED_MODULE_10__lib_auth_authStateKnown__["a" /* default */])(userAuth) || nextBamSubReady && !userAuth.length) {
                            if (!packages || !packages.length) {
                                return;
                            }

                            // trigger paywall if it is upcoming event and if user
                            // can't play the content after DSS sub check is complete
                            if (!this.state.isPaywallRendered && (cannotPlay || nextBamSubReady && !streamPlaywableAfterLogin)) {
                                var contentId = query.login_with_content_eventId || query.login_with_content_id;
                                var streamId = query.login_with_id || contentId;
                                var stream = streamId && { id: streamId };
                                /**
                                 * https://espnjira.disney.com/browse/WEWEB-2501
                                 * Fix background image missing in paywallConfig for unpaid E+ user on login
                                 * pass nextSelectedContent to paywall instead of just contentId,
                                 * so that DSS can get the background image from paywallConfig
                                 */
                                dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__common_actions_authenticationActions__["M" /* createDTCPaywallAction */])({
                                    containerId: __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* BAM_PAYWALL_IFRAME_ID */],
                                    content: nextSelectedContent,
                                    stream: stream
                                }));
                                this.setState({
                                    isPaywallRendered: true
                                });
                            }
                            // trigger route change: removing login params.
                            var newQuery = _extends({}, query);
                            newQuery.login_with_content_eventId = undefined;
                            newQuery.login_with_content_id = undefined;
                            newQuery.login_with_id = undefined;
                            newQuery.login_with_pkg = undefined;
                            dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__common_actions_appActions__["Q" /* updateRoute */])(newQuery));
                            return;
                        }
                    }

                    var checkAuthenticationStateComplete = completeTime !== nextCompleteTime;

                    /**
                     * ticket: https://jira.disney.com/browse/WEWEB-2745
                     * When users right click open on upcoming content on a new tab, we need to check if oneId getGuest
                     * event is completed (oneIdToken not undefined). We need to pass oneId token along with auth state to DSS so that
                     * they can render the paywall without sign up button on the paywall if users are entitled
                     * add isPaywallRendered state check to prevent paywall rendering more than one
                     */

                    if (isUpcoming && !this.state.isPaywallRendered) {
                        if (oneIdToken || checkAuthenticationStateComplete && !userAuth.length) {
                            checkAuthenticationStateComplete = true;
                            this.setState({
                                isPaywallRendered: true
                            });
                        } else {
                            checkAuthenticationStateComplete = false;
                        }
                    }

                    var newContentSelected = selectedContent !== nextSelectedContent;
                    var newStreamSelected = !newContentSelected && !Object(__WEBPACK_IMPORTED_MODULE_9__lib_util_isEmpty__["a" /* default */])(nextSelectedStream) && selectedStream !== nextSelectedStream;
                    var chooseTVEAuth = query.auth === 'tve';
                    var eventOnHero = query.eventCalendarId && pathname.indexOf('/player') === -1;
                    // if check authentication completes and a piece of content was already selected,
                    // or if check authentication has completed already and user clicked on content, perform authentication
                    // add loginWithContentID check to prevent rendering authentication flow again
                    // because of getting entitlement deplay from DSS
                    var newContentClick =
                    // user clicked playable item(hero, tile, schedule link, etc), or eventCalendarId is passed on non-player page
                    (!nextSelectedContent.disableAuthPrompt || chooseTVEAuth || eventOnHero) && !loginWithContentID && !Object(__WEBPACK_IMPORTED_MODULE_11__lib_auth_canPlayContent__["a" /* default */])(nextSelectedContent, userAuth, false) && (checkAuthenticationStateComplete || newContentSelected && checkAuthenticationComplete);
                    var newStreamFeedSelect = !Object(__WEBPACK_IMPORTED_MODULE_12__lib_auth_canPlayStream__["a" /* default */])(nextSelectedStream, userAuth, false) && // no streams are playable with user's auth state
                    newStreamSelected && checkAuthenticationComplete;

                    if (authenticationEnabled && ( // authentication is enabled
                    newContentClick || newStreamFeedSelect)) {
                        if (newStreamFeedSelect) {
                            if (Object(__WEBPACK_IMPORTED_MODULE_13__lib_auth_streamHasAuthType__["a" /* default */])(nextSelectedStream, __WEBPACK_IMPORTED_MODULE_4__enums__["e" /* AuthTypes */].MVPD) || Object(__WEBPACK_IMPORTED_MODULE_13__lib_auth_streamHasAuthType__["a" /* default */])(nextSelectedStream, __WEBPACK_IMPORTED_MODULE_4__enums__["e" /* AuthTypes */].ISP)) {
                                // TVE-only content
                                dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__common_actions_authenticationActions__["D" /* createAndPerformStartAuthenticationAction */])({
                                    content: nextSelectedContent,
                                    stream: nextSelectedStream
                                })).then(function (isAuthenticated) {
                                    if (!isAuthenticated) {
                                        dispatch(nonAuthedActionCreator());
                                    }
                                });
                            } else if (Object(__WEBPACK_IMPORTED_MODULE_13__lib_auth_streamHasAuthType__["a" /* default */])(nextSelectedStream, __WEBPACK_IMPORTED_MODULE_4__enums__["e" /* AuthTypes */].BAM)) {
                                if (!this.state.isPaywallRendered) {
                                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__common_actions_authenticationActions__["M" /* createDTCPaywallAction */])({
                                        containerId: __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* BAM_PAYWALL_IFRAME_ID */],
                                        content: nextSelectedContent,
                                        stream: nextSelectedStream
                                    }));
                                }
                            }

                            return;
                        }

                        var _nextSelectedContent$ = nextSelectedContent.streams,
                            streams = _nextSelectedContent$ === undefined ? [] : _nextSelectedContent$,
                            _nextSelectedContent$2 = nextSelectedContent.links;
                        _nextSelectedContent$2 = _nextSelectedContent$2 === undefined ? {} : _nextSelectedContent$2;
                        var picker = _nextSelectedContent$2.picker;

                        if (!streams.length) {
                            return;
                        }

                        // comment out newrelic tracking until tracking is required for new stream picker
                        // const newRelicTrackFields = {
                        //     eventId,
                        //     userAuth: userAuth.length ? userAuth.join('|') : userAuth,
                        //     action: 'MultipleStreamAuth',
                        //     streams: streams.length ? streams.map(item => item.id).join('|') : '',
                        //     streamCount: streams.length
                        // };

                        var showPicker = picker !== undefined;
                        /*
                        * NOTE: Handles multiple streams scenario without `id` query parameter.
                        * If the `id` query parameter is defined, we match by single stream
                        */
                        if (showPicker && !query.id) {
                            var _props2 = this.props,
                                preauthorizedResources = _props2.preauthorizedResources,
                                country = _props2.country,
                                lang = _props2.lang,
                                pickerStreams = _props2.pickerStreams;

                            var authRes = { userAuth: userAuth, preauthorizedResources: preauthorizedResources };
                            Object(__WEBPACK_IMPORTED_MODULE_14__lib_streamPicker__["c" /* handleMultipleStreamAuthentication */])({
                                lang: lang,
                                country: country,
                                nextSelectedContent: nextSelectedContent,
                                dispatch: dispatch,
                                showPicker: showPicker,
                                pickerStreams: pickerStreams,
                                authRes: authRes,
                                locationBeforeTransitions: locationBeforeTransitions
                            });
                            // newRelicTrackFields.action = 'MultipleStreamAuth';
                        } else {
                            var singleStream = streams;
                            if (query.id && streams.length > 1) {
                                singleStream = streams.filter(function (item) {
                                    return item.id === query.id;
                                });
                            }
                            var requiredAuths = __WEBPACK_IMPORTED_MODULE_2_lodash_uniq___default()(singleStream.reduce(function (acc, _ref3) {
                                var authTypes = _ref3.authTypes;
                                return acc.concat(authTypes);
                            }, []));

                            Object(__WEBPACK_IMPORTED_MODULE_14__lib_streamPicker__["d" /* handleSingleStreamAuthentication */])({
                                requiredAuths: requiredAuths,
                                nextSelectedContent: nextSelectedContent,
                                query: query,
                                dispatch: dispatch,
                                stream: singleStream[0]
                            });
                            // newRelicTrackFields.action = 'SingleStreamAuth';
                        }

                        // comment out newrelic tracking until tracking is required for new stream picker
                        // if (isNewrelicTrackingOn) {
                        //     this.newRelicTrackingOnStreamAuth(newRelicTrackFields);
                        // }
                    }
                }
            }, {
                key: 'providerSelect',
                value: function providerSelect(provider) {
                    this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__common_actions_authenticationActions__["U" /* createSelectProviderAction */])(provider));
                }
            }, {
                key: 'adobePassLogout',
                value: function adobePassLogout() {
                    var _props3 = this.props,
                        selectedStream = _props3.selectedStream,
                        dispatch = _props3.dispatch;

                    return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__common_actions_authenticationActions__["C" /* createAndPerformLogoutAction */])(selectedStream));
                }
            }, {
                key: 'newRelicTrackingOnStreamAuth',
                value: function () {
                    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
                        var _props4, env, device, newrelicInsertKey, newrelicAccountId, oneId, param;

                        return regeneratorRuntime.wrap(function _callee$(_context) {
                            while (1) {
                                switch (_context.prev = _context.next) {
                                    case 0:
                                        _props4 = this.props, env = _props4.env, device = _props4.device, newrelicInsertKey = _props4.newrelicInsertKey, newrelicAccountId = _props4.newrelicAccountId, oneId = _props4.oneId;
                                        param = {
                                            newrelicInsertKey: newrelicInsertKey,
                                            newrelicAccountId: newrelicAccountId,
                                            trackingData: _extends({
                                                env: env,
                                                device: device
                                            }, data, {
                                                swid: oneId.swid,
                                                eventType: 'PlaybackFlow',
                                                devicePlatform: 'watchWeb'
                                            })
                                        };
                                        _context.next = 4;
                                        return Object(__WEBPACK_IMPORTED_MODULE_8__lib_api_newRelicApi__["a" /* newRelicTrackEvent */])(param);

                                    case 4:
                                    case 'end':
                                        return _context.stop();
                                }
                            }
                        }, _callee, this);
                    }));

                    function newRelicTrackingOnStreamAuth(_x2) {
                        return _ref4.apply(this, arguments);
                    }

                    return newRelicTrackingOnStreamAuth;
                }()

                // we pass down this method to the child component (BroadcastPicker) via props

            }, {
                key: 'newRelicTrackingOnSelectStream',
                value: function () {
                    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(stream) {
                        var _props5, env, device, newrelicInsertKey, newrelicAccountId, oneId, id, content, streams, param;

                        return regeneratorRuntime.wrap(function _callee2$(_context2) {
                            while (1) {
                                switch (_context2.prev = _context2.next) {
                                    case 0:
                                        _props5 = this.props, env = _props5.env, device = _props5.device, newrelicInsertKey = _props5.newrelicInsertKey, newrelicAccountId = _props5.newrelicAccountId, oneId = _props5.oneId;
                                        id = stream.id, content = stream.content, streams = stream.streams;
                                        param = {
                                            newrelicInsertKey: newrelicInsertKey,
                                            newrelicAccountId: newrelicAccountId,
                                            trackingData: {
                                                env: env,
                                                device: device,
                                                eventId: content ? content.eventId : null,
                                                action: 'UserSelectedStream',
                                                streams: id,
                                                streamCount: streams ? streams.length : 1,
                                                swid: oneId.swid,
                                                eventType: 'PlaybackFlow',
                                                devicePlatform: 'watchWeb'
                                            }
                                        };
                                        _context2.next = 5;
                                        return Object(__WEBPACK_IMPORTED_MODULE_8__lib_api_newRelicApi__["a" /* newRelicTrackEvent */])(param);

                                    case 5:
                                    case 'end':
                                        return _context2.stop();
                                }
                            }
                        }, _callee2, this);
                    }));

                    function newRelicTrackingOnSelectStream(_x3) {
                        return _ref5.apply(this, arguments);
                    }

                    return newRelicTrackingOnSelectStream;
                }()
            }, {
                key: 'render',
                value: function render() {
                    var isNewrelicTrackingOn = this.props.isNewrelicTrackingOn;

                    var onSelectStreamTracking = isNewrelicTrackingOn ? this.newRelicTrackingOnSelectStream : null;
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({}, this.props, {
                        providerSelect: this.providerSelect,
                        adobePassLogout: this.adobePassLogout,
                        onSelectStreamTracking: onSelectStreamTracking
                    }));
                }
            }]);

            return AuthenticationAware;
        }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

        AuthenticationAware.defaultProps = {
            selectedContent: {}
        };

        var mapStateToProps = function mapStateToProps(state) {
            var _state$app = state.app,
                env = _state$app.env,
                lang = _state$app.lang,
                country = _state$app.country,
                device = _state$app.device,
                newrelicInsertKey = _state$app.newrelicInsertKey,
                newrelicAccountId = _state$app.newrelicAccountId;

            return {
                env: env,
                lang: lang,
                country: country,
                device: device,
                newrelicInsertKey: newrelicInsertKey,
                newrelicAccountId: newrelicAccountId,
                adobePass: Object(__WEBPACK_IMPORTED_MODULE_15__common_selectors_authenticationSelectors__["f" /* adobePassSelector */])(state),
                oneIdToken: Object(__WEBPACK_IMPORTED_MODULE_20__common_selectors_oneIdSelector__["g" /* oneIdTokenSelector */])(state),
                authenticationEnabled: Object(__WEBPACK_IMPORTED_MODULE_15__common_selectors_authenticationSelectors__["h" /* authenticationEnabledSelector */])(state),
                checkAuthenticationComplete: Object(__WEBPACK_IMPORTED_MODULE_15__common_selectors_authenticationSelectors__["l" /* checkAuthenticationCompleteSelector */])(state),
                selectedContent: Object(__WEBPACK_IMPORTED_MODULE_16__common_selectors_selectedContentSelector__["a" /* default */])(state),
                selectedStream: Object(__WEBPACK_IMPORTED_MODULE_17__common_selectors_selectedStreamSelector__["a" /* default */])(state),
                providerDialog: state.providerDialog,
                userAuth: Object(__WEBPACK_IMPORTED_MODULE_15__common_selectors_authenticationSelectors__["r" /* userAuthSelector */])(state),
                routing: Object(__WEBPACK_IMPORTED_MODULE_18__common_selectors_routingSelector__["a" /* default */])(state),
                oneId: state.oneId,
                // isNewrelicTrackingOn: newRelicTrackingSelector(state),
                preauthorizedResources: Object(__WEBPACK_IMPORTED_MODULE_15__common_selectors_authenticationSelectors__["o" /* preauthorizedResourcesSelector */])(state),
                pickerStreams: Object(__WEBPACK_IMPORTED_MODULE_19__common_selectors_pickerStreamsSelector__["a" /* default */])(state),
                bamSubReady: Object(__WEBPACK_IMPORTED_MODULE_15__common_selectors_authenticationSelectors__["k" /* bamSubReadySelector */])(state)
            };
        };

        return Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(AuthenticationAware);
    };
}

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var objectAssign = __webpack_require__(15);

// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:

/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
function compare(a, b) {
  if (a === b) {
    return 0;
  }

  var x = a.length;
  var y = b.length;

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }

  if (x < y) {
    return -1;
  }
  if (y < x) {
    return 1;
  }
  return 0;
}
function isBuffer(b) {
  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
    return global.Buffer.isBuffer(b);
  }
  return !!(b != null && b._isBuffer);
}

// based on node assert, original notice:
// NB: The URL to the CommonJS spec is kept just for tradition.
//     node-assert has evolved a lot since then, both in API and behavior.

// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
//
// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
//
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var util = __webpack_require__(157);
var hasOwn = Object.prototype.hasOwnProperty;
var pSlice = Array.prototype.slice;
var functionsHaveNames = (function () {
  return function foo() {}.name === 'foo';
}());
function pToString (obj) {
  return Object.prototype.toString.call(obj);
}
function isView(arrbuf) {
  if (isBuffer(arrbuf)) {
    return false;
  }
  if (typeof global.ArrayBuffer !== 'function') {
    return false;
  }
  if (typeof ArrayBuffer.isView === 'function') {
    return ArrayBuffer.isView(arrbuf);
  }
  if (!arrbuf) {
    return false;
  }
  if (arrbuf instanceof DataView) {
    return true;
  }
  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
    return true;
  }
  return false;
}
// 1. The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.

var assert = module.exports = ok;

// 2. The AssertionError is defined in assert.
// new assert.AssertionError({ message: message,
//                             actual: actual,
//                             expected: expected })

var regex = /\s*function\s+([^\(\s]*)\s*/;
// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
function getName(func) {
  if (!util.isFunction(func)) {
    return;
  }
  if (functionsHaveNames) {
    return func.name;
  }
  var str = func.toString();
  var match = str.match(regex);
  return match && match[1];
}
assert.AssertionError = function AssertionError(options) {
  this.name = 'AssertionError';
  this.actual = options.actual;
  this.expected = options.expected;
  this.operator = options.operator;
  if (options.message) {
    this.message = options.message;
    this.generatedMessage = false;
  } else {
    this.message = getMessage(this);
    this.generatedMessage = true;
  }
  var stackStartFunction = options.stackStartFunction || fail;
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, stackStartFunction);
  } else {
    // non v8 browsers so we can have a stacktrace
    var err = new Error();
    if (err.stack) {
      var out = err.stack;

      // try to strip useless frames
      var fn_name = getName(stackStartFunction);
      var idx = out.indexOf('\n' + fn_name);
      if (idx >= 0) {
        // once we have located the function frame
        // we need to strip out everything before it (and its line)
        var next_line = out.indexOf('\n', idx + 1);
        out = out.substring(next_line + 1);
      }

      this.stack = out;
    }
  }
};

// assert.AssertionError instanceof Error
util.inherits(assert.AssertionError, Error);

function truncate(s, n) {
  if (typeof s === 'string') {
    return s.length < n ? s : s.slice(0, n);
  } else {
    return s;
  }
}
function inspect(something) {
  if (functionsHaveNames || !util.isFunction(something)) {
    return util.inspect(something);
  }
  var rawname = getName(something);
  var name = rawname ? ': ' + rawname : '';
  return '[Function' +  name + ']';
}
function getMessage(self) {
  return truncate(inspect(self.actual), 128) + ' ' +
         self.operator + ' ' +
         truncate(inspect(self.expected), 128);
}

// At present only the three keys mentioned above are used and
// understood by the spec. Implementations or sub modules can pass
// other keys to the AssertionError's constructor - they will be
// ignored.

// 3. All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided.  All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.

function fail(actual, expected, message, operator, stackStartFunction) {
  throw new assert.AssertionError({
    message: message,
    actual: actual,
    expected: expected,
    operator: operator,
    stackStartFunction: stackStartFunction
  });
}

// EXTENSION! allows for well behaved errors defined elsewhere.
assert.fail = fail;

// 4. Pure assertion tests whether a value is truthy, as determined
// by !!guard.
// assert.ok(guard, message_opt);
// This statement is equivalent to assert.equal(true, !!guard,
// message_opt);. To test strictly for the value true, use
// assert.strictEqual(true, guard, message_opt);.

function ok(value, message) {
  if (!value) fail(value, true, message, '==', assert.ok);
}
assert.ok = ok;

// 5. The equality assertion tests shallow, coercive equality with
// ==.
// assert.equal(actual, expected, message_opt);

assert.equal = function equal(actual, expected, message) {
  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
};

// 6. The non-equality assertion tests for whether two objects are not equal
// with != assert.notEqual(actual, expected, message_opt);

assert.notEqual = function notEqual(actual, expected, message) {
  if (actual == expected) {
    fail(actual, expected, message, '!=', assert.notEqual);
  }
};

// 7. The equivalence assertion tests a deep equality relation.
// assert.deepEqual(actual, expected, message_opt);

assert.deepEqual = function deepEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
  }
};

assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
  }
};

function _deepEqual(actual, expected, strict, memos) {
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;
  } else if (isBuffer(actual) && isBuffer(expected)) {
    return compare(actual, expected) === 0;

  // 7.2. If the expected value is a Date object, the actual value is
  // equivalent if it is also a Date object that refers to the same time.
  } else if (util.isDate(actual) && util.isDate(expected)) {
    return actual.getTime() === expected.getTime();

  // 7.3 If the expected value is a RegExp object, the actual value is
  // equivalent if it is also a RegExp object with the same source and
  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
    return actual.source === expected.source &&
           actual.global === expected.global &&
           actual.multiline === expected.multiline &&
           actual.lastIndex === expected.lastIndex &&
           actual.ignoreCase === expected.ignoreCase;

  // 7.4. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if ((actual === null || typeof actual !== 'object') &&
             (expected === null || typeof expected !== 'object')) {
    return strict ? actual === expected : actual == expected;

  // If both values are instances of typed arrays, wrap their underlying
  // ArrayBuffers in a Buffer each to increase performance
  // This optimization requires the arrays to have the same type as checked by
  // Object.prototype.toString (aka pToString). Never perform binary
  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
  // bit patterns are not identical.
  } else if (isView(actual) && isView(expected) &&
             pToString(actual) === pToString(expected) &&
             !(actual instanceof Float32Array ||
               actual instanceof Float64Array)) {
    return compare(new Uint8Array(actual.buffer),
                   new Uint8Array(expected.buffer)) === 0;

  // 7.5 For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else if (isBuffer(actual) !== isBuffer(expected)) {
    return false;
  } else {
    memos = memos || {actual: [], expected: []};

    var actualIndex = memos.actual.indexOf(actual);
    if (actualIndex !== -1) {
      if (actualIndex === memos.expected.indexOf(expected)) {
        return true;
      }
    }

    memos.actual.push(actual);
    memos.expected.push(expected);

    return objEquiv(actual, expected, strict, memos);
  }
}

function isArguments(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
}

function objEquiv(a, b, strict, actualVisitedObjects) {
  if (a === null || a === undefined || b === null || b === undefined)
    return false;
  // if one is a primitive, the other must be same
  if (util.isPrimitive(a) || util.isPrimitive(b))
    return a === b;
  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
    return false;
  var aIsArgs = isArguments(a);
  var bIsArgs = isArguments(b);
  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
    return false;
  if (aIsArgs) {
    a = pSlice.call(a);
    b = pSlice.call(b);
    return _deepEqual(a, b, strict);
  }
  var ka = objectKeys(a);
  var kb = objectKeys(b);
  var key, i;
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length !== kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] !== kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
      return false;
  }
  return true;
}

// 8. The non-equivalence assertion tests for any deep inequality.
// assert.notDeepEqual(actual, expected, message_opt);

assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
  }
};

assert.notDeepStrictEqual = notDeepStrictEqual;
function notDeepStrictEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
  }
}


// 9. The strict equality assertion tests strict equality, as determined by ===.
// assert.strictEqual(actual, expected, message_opt);

assert.strictEqual = function strictEqual(actual, expected, message) {
  if (actual !== expected) {
    fail(actual, expected, message, '===', assert.strictEqual);
  }
};

// 10. The strict non-equality assertion tests for strict inequality, as
// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);

assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
  if (actual === expected) {
    fail(actual, expected, message, '!==', assert.notStrictEqual);
  }
};

function expectedException(actual, expected) {
  if (!actual || !expected) {
    return false;
  }

  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
    return expected.test(actual);
  }

  try {
    if (actual instanceof expected) {
      return true;
    }
  } catch (e) {
    // Ignore.  The instanceof check doesn't work for arrow functions.
  }

  if (Error.isPrototypeOf(expected)) {
    return false;
  }

  return expected.call({}, actual) === true;
}

function _tryBlock(block) {
  var error;
  try {
    block();
  } catch (e) {
    error = e;
  }
  return error;
}

function _throws(shouldThrow, block, expected, message) {
  var actual;

  if (typeof block !== 'function') {
    throw new TypeError('"block" argument must be a function');
  }

  if (typeof expected === 'string') {
    message = expected;
    expected = null;
  }

  actual = _tryBlock(block);

  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
            (message ? ' ' + message : '.');

  if (shouldThrow && !actual) {
    fail(actual, expected, 'Missing expected exception' + message);
  }

  var userProvidedMessage = typeof message === 'string';
  var isUnwantedException = !shouldThrow && util.isError(actual);
  var isUnexpectedException = !shouldThrow && actual && !expected;

  if ((isUnwantedException &&
      userProvidedMessage &&
      expectedException(actual, expected)) ||
      isUnexpectedException) {
    fail(actual, expected, 'Got unwanted exception' + message);
  }

  if ((shouldThrow && actual && expected &&
      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
    throw actual;
  }
}

// 11. Expected to throw an error:
// assert.throws(block, Error_opt, message_opt);

assert.throws = function(block, /*optional*/error, /*optional*/message) {
  _throws(true, block, error, message);
};

// EXTENSION! This is annoying to write outside this module.
assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
  _throws(false, block, error, message);
};

assert.ifError = function(err) { if (err) throw err; };

// Expose a strict only variant of assert
function strict(value, message) {
  if (!value) fail(value, true, message, '==', strict);
}
assert.strict = objectAssign(strict, assert, {
  equal: assert.strictEqual,
  deepEqual: assert.deepStrictEqual,
  notEqual: assert.notStrictEqual,
  notDeepEqual: assert.notDeepStrictEqual
});
assert.strict.strict = assert.strict;

var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    if (hasOwn.call(obj, key)) keys.push(key);
  }
  return keys;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactPropTypeLocationNames = {};

if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
}

module.exports = ReactPropTypeLocationNames;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentFlags = {
  hasCachedChildNodes: 1 << 0
};

module.exports = ReactDOMComponentFlags;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(7);

var invariant = __webpack_require__(5);

/**
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */

function accumulateInto(current, next) {
  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;

  if (current == null) {
    return next;
  }

  // Both are not empty. Warning: Never call x.concat(y) when you are not
  // certain that x is an Array (x could be a string with concat method).
  if (Array.isArray(current)) {
    if (Array.isArray(next)) {
      current.push.apply(current, next);
      return current;
    }
    current.push(next);
    return current;
  }

  if (Array.isArray(next)) {
    // A bit too dangerous to mutate `next`.
    return [current].concat(next);
  }

  return [current, next];
}

module.exports = accumulateInto;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 */

function forEachAccumulated(arr, cb, scope) {
  if (Array.isArray(arr)) {
    arr.forEach(cb, scope);
  } else if (arr) {
    cb.call(scope, arr);
  }
}

module.exports = forEachAccumulated;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(31);

var contentKey = null;

/**
 * Gets the key used to access text content on a DOM node.
 *
 * @return {?string} Key used to access text content.
 * @internal
 */
function getTextContentAccessor() {
  if (!contentKey && ExecutionEnvironment.canUseDOM) {
    // Prefer textContent to innerText because many browsers support both but
    // SVG <text> elements don't support innerText even when <div> does.
    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
  }
  return contentKey;
}

module.exports = getTextContentAccessor;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(7);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PooledClass = __webpack_require__(65);

var invariant = __webpack_require__(5);

/**
 * A specialized pseudo-event module to help keep track of components waiting to
 * be notified when their DOM representations are available for use.
 *
 * This implements `PooledClass`, so you should never need to instantiate this.
 * Instead, use `CallbackQueue.getPooled()`.
 *
 * @class ReactMountReady
 * @implements PooledClass
 * @internal
 */

var CallbackQueue = function () {
  function CallbackQueue(arg) {
    _classCallCheck(this, CallbackQueue);

    this._callbacks = null;
    this._contexts = null;
    this._arg = arg;
  }

  /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */


  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
    this._callbacks = this._callbacks || [];
    this._callbacks.push(callback);
    this._contexts = this._contexts || [];
    this._contexts.push(context);
  };

  /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */


  CallbackQueue.prototype.notifyAll = function notifyAll() {
    var callbacks = this._callbacks;
    var contexts = this._contexts;
    var arg = this._arg;
    if (callbacks && contexts) {
      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
      this._callbacks = null;
      this._contexts = null;
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].call(contexts[i], arg);
      }
      callbacks.length = 0;
      contexts.length = 0;
    }
  };

  CallbackQueue.prototype.checkpoint = function checkpoint() {
    return this._callbacks ? this._callbacks.length : 0;
  };

  CallbackQueue.prototype.rollback = function rollback(len) {
    if (this._callbacks && this._contexts) {
      this._callbacks.length = len;
      this._contexts.length = len;
    }
  };

  /**
   * Resets the internal queue.
   *
   * @internal
   */


  CallbackQueue.prototype.reset = function reset() {
    this._callbacks = null;
    this._contexts = null;
  };

  /**
   * `PooledClass` looks for this.
   */


  CallbackQueue.prototype.destructor = function destructor() {
    this.reset();
  };

  return CallbackQueue;
}();

module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactFeatureFlags = {
  // When true, call console.time() before and .timeEnd() after each top-level
  // render (both initial renders and updates). Useful when looking at prod-mode
  // timeline profiles in Chrome, for example.
  logTopLevelRenders: false
};

module.exports = ReactFeatureFlags;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */

var supportedInputTypes = {
  'color': true,
  'date': true,
  'datetime': true,
  'datetime-local': true,
  'email': true,
  'month': true,
  'number': true,
  'password': true,
  'range': true,
  'search': true,
  'tel': true,
  'text': true,
  'time': true,
  'url': true,
  'week': true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

  if (nodeName === 'input') {
    return !!supportedInputTypes[elem.type];
  }

  if (nodeName === 'textarea') {
    return true;
  }

  return false;
}

module.exports = isTextInputElement;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ViewportMetrics = {

  currentScrollLeft: 0,

  currentScrollTop: 0,

  refreshScrollValues: function (scrollPosition) {
    ViewportMetrics.currentScrollLeft = scrollPosition.x;
    ViewportMetrics.currentScrollTop = scrollPosition.y;
  }

};

module.exports = ViewportMetrics;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(31);
var escapeTextContentForBrowser = __webpack_require__(121);
var setInnerHTML = __webpack_require__(120);

/**
 * Set the textContent property of a node, ensuring that whitespace is preserved
 * even in IE8. innerText is a poor substitute for textContent and, among many
 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
 * as it should.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */
var setTextContent = function (node, text) {
  if (text) {
    var firstChild = node.firstChild;

    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
      firstChild.nodeValue = text;
      return;
    }
  }
  node.textContent = text;
};

if (ExecutionEnvironment.canUseDOM) {
  if (!('textContent' in document.documentElement)) {
    setTextContent = function (node, text) {
      if (node.nodeType === 3) {
        node.nodeValue = text;
        return;
      }
      setInnerHTML(node, escapeTextContentForBrowser(text));
    };
  }
}

module.exports = setTextContent;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridColumn: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

module.exports = CSSProperty;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(82);
var ReactDOMComponentTree = __webpack_require__(21);
var ReactInstrumentation = __webpack_require__(38);

var quoteAttributeValueForBrowser = __webpack_require__(427);
var warning = __webpack_require__(6);

var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};

function isAttributeNameSafe(attributeName) {
  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
    return true;
  }
  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
    return false;
  }
  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }
  illegalAttributeNameCache[attributeName] = true;
   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
  return false;
}

function shouldIgnoreValue(propertyInfo, value) {
  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
}

/**
 * Operations for dealing with DOM properties.
 */
var DOMPropertyOperations = {

  /**
   * Creates markup for the ID property.
   *
   * @param {string} id Unescaped ID.
   * @return {string} Markup string.
   */
  createMarkupForID: function (id) {
    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
  },

  setAttributeForID: function (node, id) {
    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
  },

  createMarkupForRoot: function () {
    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
  },

  setAttributeForRoot: function (node) {
    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
  },

  /**
   * Creates markup for a property.
   *
   * @param {string} name
   * @param {*} value
   * @return {?string} Markup string, or null if the property was invalid.
   */
  createMarkupForProperty: function (name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      if (shouldIgnoreValue(propertyInfo, value)) {
        return '';
      }
      var attributeName = propertyInfo.attributeName;
      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
        return attributeName + '=""';
      }
      return attributeName + '=' + quoteAttributeValueForBrowser(value);
    } else if (DOMProperty.isCustomAttribute(name)) {
      if (value == null) {
        return '';
      }
      return name + '=' + quoteAttributeValueForBrowser(value);
    }
    return null;
  },

  /**
   * Creates markup for a custom property.
   *
   * @param {string} name
   * @param {*} value
   * @return {string} Markup string, or empty string if the property was invalid.
   */
  createMarkupForCustomAttribute: function (name, value) {
    if (!isAttributeNameSafe(name) || value == null) {
      return '';
    }
    return name + '=' + quoteAttributeValueForBrowser(value);
  },

  /**
   * Sets the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   * @param {*} value
   */
  setValueForProperty: function (node, name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, value);
      } else if (shouldIgnoreValue(propertyInfo, value)) {
        this.deleteValueForProperty(node, name);
        return;
      } else if (propertyInfo.mustUseProperty) {
        // Contrary to `setAttribute`, object properties are properly
        // `toString`ed by IE8/9.
        node[propertyInfo.propertyName] = value;
      } else {
        var attributeName = propertyInfo.attributeName;
        var namespace = propertyInfo.attributeNamespace;
        // `setAttribute` with objects becomes only `[object]` in IE8/9,
        // ('' + value) makes it output the correct toString()-value.
        if (namespace) {
          node.setAttributeNS(namespace, attributeName, '' + value);
        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
          node.setAttribute(attributeName, '');
        } else {
          node.setAttribute(attributeName, '' + value);
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      DOMPropertyOperations.setValueForAttribute(node, name, value);
      return;
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  setValueForAttribute: function (node, name, value) {
    if (!isAttributeNameSafe(name)) {
      return;
    }
    if (value == null) {
      node.removeAttribute(name);
    } else {
      node.setAttribute(name, '' + value);
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  /**
   * Deletes an attributes from a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForAttribute: function (node, name) {
    node.removeAttribute(name);
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  },

  /**
   * Deletes the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForProperty: function (node, name) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, undefined);
      } else if (propertyInfo.mustUseProperty) {
        var propName = propertyInfo.propertyName;
        if (propertyInfo.hasBooleanValue) {
          node[propName] = false;
        } else {
          node[propName] = '';
        }
      } else {
        node.removeAttribute(propertyInfo.attributeName);
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      node.removeAttribute(name);
    }

    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  }

};

module.exports = DOMPropertyOperations;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(15);

var LinkedValueUtils = __webpack_require__(169);
var ReactDOMComponentTree = __webpack_require__(21);
var ReactUpdates = __webpack_require__(40);

var warning = __webpack_require__(6);

var didWarnValueLink = false;
var didWarnValueDefaultValue = false;

function updateOptionsIfPendingUpdateAndMounted() {
  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
    this._wrapperState.pendingUpdate = false;

    var props = this._currentElement.props;
    var value = LinkedValueUtils.getValue(props);

    if (value != null) {
      updateOptions(this, Boolean(props.multiple), value);
    }
  }
}

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

var valuePropNames = ['value', 'defaultValue'];

/**
 * Validation function for `value` and `defaultValue`.
 * @private
 */
function checkSelectPropTypes(inst, props) {
  var owner = inst._currentElement._owner;
  LinkedValueUtils.checkPropTypes('select', props, owner);

  if (props.valueLink !== undefined && !didWarnValueLink) {
     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
    didWarnValueLink = true;
  }

  for (var i = 0; i < valuePropNames.length; i++) {
    var propName = valuePropNames[i];
    if (props[propName] == null) {
      continue;
    }
    var isArray = Array.isArray(props[propName]);
    if (props.multiple && !isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    } else if (!props.multiple && isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    }
  }
}

/**
 * @param {ReactDOMComponent} inst
 * @param {boolean} multiple
 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
 * @private
 */
function updateOptions(inst, multiple, propValue) {
  var selectedValue, i;
  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;

  if (multiple) {
    selectedValue = {};
    for (i = 0; i < propValue.length; i++) {
      selectedValue['' + propValue[i]] = true;
    }
    for (i = 0; i < options.length; i++) {
      var selected = selectedValue.hasOwnProperty(options[i].value);
      if (options[i].selected !== selected) {
        options[i].selected = selected;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    selectedValue = '' + propValue;
    for (i = 0; i < options.length; i++) {
      if (options[i].value === selectedValue) {
        options[i].selected = true;
        return;
      }
    }
    if (options.length) {
      options[0].selected = true;
    }
  }
}

/**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */
var ReactDOMSelect = {
  getHostProps: function (inst, props) {
    return _assign({}, props, {
      onChange: inst._wrapperState.onChange,
      value: undefined
    });
  },

  mountWrapper: function (inst, props) {
    if (false) {
      checkSelectPropTypes(inst, props);
    }

    var value = LinkedValueUtils.getValue(props);
    inst._wrapperState = {
      pendingUpdate: false,
      initialValue: value != null ? value : props.defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      wasMultiple: Boolean(props.multiple)
    };

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
      didWarnValueDefaultValue = true;
    }
  },

  getSelectValueContext: function (inst) {
    // ReactDOMOption looks at this initial value so the initial generated
    // markup has correct `selected` attributes
    return inst._wrapperState.initialValue;
  },

  postUpdateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // After the initial mount, we control selected-ness manually so don't pass
    // this value down
    inst._wrapperState.initialValue = undefined;

    var wasMultiple = inst._wrapperState.wasMultiple;
    inst._wrapperState.wasMultiple = Boolean(props.multiple);

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      inst._wrapperState.pendingUpdate = false;
      updateOptions(inst, Boolean(props.multiple), value);
    } else if (wasMultiple !== Boolean(props.multiple)) {
      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
      if (props.defaultValue != null) {
        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
      } else {
        // Revert the select back to its default unselected state.
        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
      }
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  if (this._rootNodeID) {
    this._wrapperState.pendingUpdate = true;
  }
  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
  return returnValue;
}

module.exports = ReactDOMSelect;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7),
    _assign = __webpack_require__(15);

var ReactCompositeComponent = __webpack_require__(436);
var ReactEmptyComponent = __webpack_require__(245);
var ReactHostComponent = __webpack_require__(246);

var getNextDebugID = __webpack_require__(437);
var invariant = __webpack_require__(5);
var warning = __webpack_require__(6);

// To avoid a cyclic dependency, we create the final class in this module
var ReactCompositeComponentWrapper = function (element) {
  this.construct(element);
};
_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
  _instantiateReactComponent: instantiateReactComponent
});

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Check if the type reference is a known internal type. I.e. not a user
 * provided composite type.
 *
 * @param {function} type
 * @return {boolean} Returns true if this is a valid internal type.
 */
function isInternalComponentType(type) {
  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
}

/**
 * Given a ReactNode, create an instance that will actually be mounted.
 *
 * @param {ReactNode} node
 * @param {boolean} shouldHaveDebugID
 * @return {object} A new instance of the element's constructor.
 * @protected
 */
function instantiateReactComponent(node, shouldHaveDebugID) {
  var instance;

  if (node === null || node === false) {
    instance = ReactEmptyComponent.create(instantiateReactComponent);
  } else if (typeof node === 'object') {
    var element = node;
    var type = element.type;
    if (typeof type !== 'function' && typeof type !== 'string') {
      var info = '';
      if (false) {
        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
          info += ' You likely forgot to export your component from the file ' + 'it\'s defined in.';
        }
      }
      info += getDeclarationErrorAddendum(element._owner);
       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
    }

    // Special case string values
    if (typeof element.type === 'string') {
      instance = ReactHostComponent.createInternalComponent(element);
    } else if (isInternalComponentType(element.type)) {
      // This is temporarily available for custom components that are not string
      // representations. I.e. ART. Once those are updated to use the string
      // representation, we can drop this code path.
      instance = new element.type(element);

      // We renamed this. Allow the old name for compat. :(
      if (!instance.getHostNode) {
        instance.getHostNode = instance.getNativeNode;
      }
    } else {
      instance = new ReactCompositeComponentWrapper(element);
    }
  } else if (typeof node === 'string' || typeof node === 'number') {
    instance = ReactHostComponent.createInstanceForText(node);
  } else {
     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
  }

  // These two fields are used by the DOM and ART diffing algorithms
  // respectively. Instead of using expandos on components, we should be
  // storing the state needed by the diffing algorithms elsewhere.
  instance._mountIndex = 0;
  instance._mountImage = null;

  if (false) {
    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
  }

  // Internal instances should fully constructed at this point, so they should
  // not get any new fields added to them at this point.
  if (false) {
    if (Object.preventExtensions) {
      Object.preventExtensions(instance);
    }
  }

  return instance;
}

module.exports = instantiateReactComponent;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(7);

var React = __webpack_require__(78);

var invariant = __webpack_require__(5);

var ReactNodeTypes = {
  HOST: 0,
  COMPOSITE: 1,
  EMPTY: 2,

  getType: function (node) {
    if (node === null || node === false) {
      return ReactNodeTypes.EMPTY;
    } else if (React.isValidElement(node)) {
      if (typeof node.type === 'function') {
        return ReactNodeTypes.COMPOSITE;
      } else {
        return ReactNodeTypes.HOST;
      }
    }
     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
  }
};

module.exports = ReactNodeTypes;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyComponentFactory;

var ReactEmptyComponentInjection = {
  injectEmptyComponentFactory: function (factory) {
    emptyComponentFactory = factory;
  }
};

var ReactEmptyComponent = {
  create: function (instantiate) {
    return emptyComponentFactory(instantiate);
  }
};

ReactEmptyComponent.injection = ReactEmptyComponentInjection;

module.exports = ReactEmptyComponent;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var invariant = __webpack_require__(5);

var genericComponentClass = null;
var textComponentClass = null;

var ReactHostComponentInjection = {
  // This accepts a class that receives the tag string. This is a catch all
  // that can render any kind of tag.
  injectGenericComponentClass: function (componentClass) {
    genericComponentClass = componentClass;
  },
  // This accepts a text component class that takes the text string to be
  // rendered as props.
  injectTextComponentClass: function (componentClass) {
    textComponentClass = componentClass;
  }
};

/**
 * Get a host internal component class for a specific tag.
 *
 * @param {ReactElement} element The element to create.
 * @return {function} The internal class constructor function.
 */
function createInternalComponent(element) {
  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
  return new genericComponentClass(element);
}

/**
 * @param {ReactText} text
 * @return {ReactComponent}
 */
function createInstanceForText(text) {
  return new textComponentClass(text);
}

/**
 * @param {ReactComponent} component
 * @return {boolean}
 */
function isTextComponent(component) {
  return component instanceof textComponentClass;
}

var ReactHostComponent = {
  createInternalComponent: createInternalComponent,
  createInstanceForText: createInstanceForText,
  isTextComponent: isTextComponent,
  injection: ReactHostComponentInjection
};

module.exports = ReactHostComponent;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var ReactCurrentOwner = __webpack_require__(49);
var REACT_ELEMENT_TYPE = __webpack_require__(438);

var getIteratorFn = __webpack_require__(439);
var invariant = __webpack_require__(5);
var KeyEscapeUtils = __webpack_require__(173);
var warning = __webpack_require__(6);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(79);

var ReactCurrentOwner = __webpack_require__(49);

var invariant = __webpack_require__(5);
var warning = __webpack_require__(6);

function isNative(fn) {
  // Based on isNative() from Lodash
  var funcToString = Function.prototype.toString;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var reIsNative = RegExp('^' + funcToString
  // Take an example native function source for comparison
  .call(hasOwnProperty)
  // Strip regex characters so we can use it for regex
  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  // Remove hasOwnProperty from the template to make it generic
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  try {
    var source = funcToString.call(fn);
    return reIsNative.test(source);
  } catch (err) {
    return false;
  }
}

var canUseCollections =
// Array.from
typeof Array.from === 'function' &&
// Map
typeof Map === 'function' && isNative(Map) &&
// Map.prototype.keys
Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
// Set
typeof Set === 'function' && isNative(Set) &&
// Set.prototype.keys
Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);

var setItem;
var getItem;
var removeItem;
var getItemIDs;
var addRoot;
var removeRoot;
var getRootIDs;

if (canUseCollections) {
  var itemMap = new Map();
  var rootIDSet = new Set();

  setItem = function (id, item) {
    itemMap.set(id, item);
  };
  getItem = function (id) {
    return itemMap.get(id);
  };
  removeItem = function (id) {
    itemMap['delete'](id);
  };
  getItemIDs = function () {
    return Array.from(itemMap.keys());
  };

  addRoot = function (id) {
    rootIDSet.add(id);
  };
  removeRoot = function (id) {
    rootIDSet['delete'](id);
  };
  getRootIDs = function () {
    return Array.from(rootIDSet.keys());
  };
} else {
  var itemByKey = {};
  var rootByKey = {};

  // Use non-numeric keys to prevent V8 performance issues:
  // https://github.com/facebook/react/pull/7232
  var getKeyFromID = function (id) {
    return '.' + id;
  };
  var getIDFromKey = function (key) {
    return parseInt(key.substr(1), 10);
  };

  setItem = function (id, item) {
    var key = getKeyFromID(id);
    itemByKey[key] = item;
  };
  getItem = function (id) {
    var key = getKeyFromID(id);
    return itemByKey[key];
  };
  removeItem = function (id) {
    var key = getKeyFromID(id);
    delete itemByKey[key];
  };
  getItemIDs = function () {
    return Object.keys(itemByKey).map(getIDFromKey);
  };

  addRoot = function (id) {
    var key = getKeyFromID(id);
    rootByKey[key] = true;
  };
  removeRoot = function (id) {
    var key = getKeyFromID(id);
    delete rootByKey[key];
  };
  getRootIDs = function () {
    return Object.keys(rootByKey).map(getIDFromKey);
  };
}

var unmountedIDs = [];

function purgeDeep(id) {
  var item = getItem(id);
  if (item) {
    var childIDs = item.childIDs;

    removeItem(id);
    childIDs.forEach(purgeDeep);
  }
}

function describeComponentFrame(name, source, ownerName) {
  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
}

function getDisplayName(element) {
  if (element == null) {
    return '#empty';
  } else if (typeof element === 'string' || typeof element === 'number') {
    return '#text';
  } else if (typeof element.type === 'string') {
    return element.type;
  } else {
    return element.type.displayName || element.type.name || 'Unknown';
  }
}

function describeID(id) {
  var name = ReactComponentTreeHook.getDisplayName(id);
  var element = ReactComponentTreeHook.getElement(id);
  var ownerID = ReactComponentTreeHook.getOwnerID(id);
  var ownerName;
  if (ownerID) {
    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
  }
   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
  return describeComponentFrame(name, element && element._source, ownerName);
}

var ReactComponentTreeHook = {
  onSetChildren: function (id, nextChildIDs) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.childIDs = nextChildIDs;

    for (var i = 0; i < nextChildIDs.length; i++) {
      var nextChildID = nextChildIDs[i];
      var nextChild = getItem(nextChildID);
      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
      if (nextChild.parentID == null) {
        nextChild.parentID = id;
        // TODO: This shouldn't be necessary but mounting a new root during in
        // componentWillMount currently causes not-yet-mounted components to
        // be purged from our tree data so their parent id is missing.
      }
      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
    }
  },
  onBeforeMountComponent: function (id, element, parentID) {
    var item = {
      element: element,
      parentID: parentID,
      text: null,
      childIDs: [],
      isMounted: false,
      updateCount: 0
    };
    setItem(id, item);
  },
  onBeforeUpdateComponent: function (id, element) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.element = element;
  },
  onMountComponent: function (id) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.isMounted = true;
    var isRoot = item.parentID === 0;
    if (isRoot) {
      addRoot(id);
    }
  },
  onUpdateComponent: function (id) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.updateCount++;
  },
  onUnmountComponent: function (id) {
    var item = getItem(id);
    if (item) {
      // We need to check if it exists.
      // `item` might not exist if it is inside an error boundary, and a sibling
      // error boundary child threw while mounting. Then this instance never
      // got a chance to mount, but it still gets an unmounting event during
      // the error boundary cleanup.
      item.isMounted = false;
      var isRoot = item.parentID === 0;
      if (isRoot) {
        removeRoot(id);
      }
    }
    unmountedIDs.push(id);
  },
  purgeUnmountedComponents: function () {
    if (ReactComponentTreeHook._preventPurging) {
      // Should only be used for testing.
      return;
    }

    for (var i = 0; i < unmountedIDs.length; i++) {
      var id = unmountedIDs[i];
      purgeDeep(id);
    }
    unmountedIDs.length = 0;
  },
  isMounted: function (id) {
    var item = getItem(id);
    return item ? item.isMounted : false;
  },
  getCurrentStackAddendum: function (topElement) {
    var info = '';
    if (topElement) {
      var name = getDisplayName(topElement);
      var owner = topElement._owner;
      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
    }

    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    info += ReactComponentTreeHook.getStackAddendumByID(id);
    return info;
  },
  getStackAddendumByID: function (id) {
    var info = '';
    while (id) {
      info += describeID(id);
      id = ReactComponentTreeHook.getParentID(id);
    }
    return info;
  },
  getChildIDs: function (id) {
    var item = getItem(id);
    return item ? item.childIDs : [];
  },
  getDisplayName: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element) {
      return null;
    }
    return getDisplayName(element);
  },
  getElement: function (id) {
    var item = getItem(id);
    return item ? item.element : null;
  },
  getOwnerID: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element || !element._owner) {
      return null;
    }
    return element._owner._debugID;
  },
  getParentID: function (id) {
    var item = getItem(id);
    return item ? item.parentID : null;
  },
  getSource: function (id) {
    var item = getItem(id);
    var element = item ? item.element : null;
    var source = element != null ? element._source : null;
    return source;
  },
  getText: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (typeof element === 'string') {
      return element;
    } else if (typeof element === 'number') {
      return '' + element;
    } else {
      return null;
    }
  },
  getUpdateCount: function (id) {
    var item = getItem(id);
    return item ? item.updateCount : 0;
  },


  getRootIDs: getRootIDs,
  getRegisteredIDs: getItemIDs
};

module.exports = ReactComponentTreeHook;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(37);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMSelection = __webpack_require__(451);

var containsNode = __webpack_require__(453);
var focusNode = __webpack_require__(239);
var getActiveElement = __webpack_require__(251);

function isInDocument(node) {
  return containsNode(document.documentElement, node);
}

/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */
var ReactInputSelection = {

  hasSelectionCapabilities: function (elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
  },

  getSelectionInformation: function () {
    var focusedElem = getActiveElement();
    return {
      focusedElem: focusedElem,
      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
    };
  },

  /**
   * @restoreSelection: If any selection information was potentially lost,
   * restore it. This is useful when performing operations that could remove dom
   * nodes and place them back in, resulting in focus being lost.
   */
  restoreSelection: function (priorSelectionInformation) {
    var curFocusedElem = getActiveElement();
    var priorFocusedElem = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
      }
      focusNode(priorFocusedElem);
    }
  },

  /**
   * @getSelection: Gets the selection bounds of a focused textarea, input or
   * contentEditable node.
   * -@input: Look up selection bounds of this input
   * -@return {start: selectionStart, end: selectionEnd}
   */
  getSelection: function (input) {
    var selection;

    if ('selectionStart' in input) {
      // Modern browser with input or textarea.
      selection = {
        start: input.selectionStart,
        end: input.selectionEnd
      };
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      // IE8 input.
      var range = document.selection.createRange();
      // There can only be one selection per document in IE, so it must
      // be in our element.
      if (range.parentElement() === input) {
        selection = {
          start: -range.moveStart('character', -input.value.length),
          end: -range.moveEnd('character', -input.value.length)
        };
      }
    } else {
      // Content editable or old IE textarea.
      selection = ReactDOMSelection.getOffsets(input);
    }

    return selection || { start: 0, end: 0 };
  },

  /**
   * @setSelection: Sets the selection bounds of a textarea or input and focuses
   * the input.
   * -@input     Set selection bounds of this input or textarea
   * -@offsets   Object of same form that is returned from get*
   */
  setSelection: function (input, offsets) {
    var start = offsets.start;
    var end = offsets.end;
    if (end === undefined) {
      end = start;
    }

    if ('selectionStart' in input) {
      input.selectionStart = start;
      input.selectionEnd = Math.min(end, input.value.length);
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    } else {
      ReactDOMSelection.setOffsets(input, offsets);
    }
  }
};

module.exports = ReactInputSelection;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var DOMLazyTree = __webpack_require__(84);
var DOMProperty = __webpack_require__(82);
var React = __webpack_require__(78);
var ReactBrowserEventEmitter = __webpack_require__(122);
var ReactCurrentOwner = __webpack_require__(49);
var ReactDOMComponentTree = __webpack_require__(21);
var ReactDOMContainerInfo = __webpack_require__(468);
var ReactDOMFeatureFlags = __webpack_require__(469);
var ReactFeatureFlags = __webpack_require__(235);
var ReactInstanceMap = __webpack_require__(103);
var ReactInstrumentation = __webpack_require__(38);
var ReactMarkupChecksum = __webpack_require__(470);
var ReactReconciler = __webpack_require__(83);
var ReactUpdateQueue = __webpack_require__(174);
var ReactUpdates = __webpack_require__(40);

var emptyObject = __webpack_require__(99);
var instantiateReactComponent = __webpack_require__(243);
var invariant = __webpack_require__(5);
var setInnerHTML = __webpack_require__(120);
var shouldUpdateReactComponent = __webpack_require__(172);
var warning = __webpack_require__(6);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;

var ELEMENT_NODE_TYPE = 1;
var DOC_NODE_TYPE = 9;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

var instancesByReactRootID = {};

/**
 * Finds the index of the first character
 * that's not common between the two given strings.
 *
 * @return {number} the index of the character where the strings diverge
 */
function firstDifferenceIndex(string1, string2) {
  var minLen = Math.min(string1.length, string2.length);
  for (var i = 0; i < minLen; i++) {
    if (string1.charAt(i) !== string2.charAt(i)) {
      return i;
    }
  }
  return string1.length === string2.length ? -1 : minLen;
}

/**
 * @param {DOMElement|DOMDocument} container DOM element that may contain
 * a React component
 * @return {?*} DOM element that may have the reactRoot ID, or null.
 */
function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

function internalGetID(node) {
  // If node is something like a window, document, or text node, none of
  // which support attributes or a .getAttribute method, gracefully return
  // the empty string, as if the attribute were missing.
  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
}

/**
 * Mounts this component and inserts it into the DOM.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {ReactReconcileTransaction} transaction
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
  var markerName;
  if (ReactFeatureFlags.logTopLevelRenders) {
    var wrappedElement = wrapperInstance._currentElement.props.child;
    var type = wrappedElement.type;
    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
    console.time(markerName);
  }

  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
  );

  if (markerName) {
    console.timeEnd(markerName);
  }

  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
}

/**
 * Batched mount.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */
  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
  ReactUpdates.ReactReconcileTransaction.release(transaction);
}

/**
 * Unmounts a component and removes it from the DOM.
 *
 * @param {ReactComponent} instance React component instance.
 * @param {DOMElement} container DOM element to unmount from.
 * @final
 * @internal
 * @see {ReactMount.unmountComponentAtNode}
 */
function unmountComponentFromNode(instance, container, safely) {
  if (false) {
    ReactInstrumentation.debugTool.onBeginFlush();
  }
  ReactReconciler.unmountComponent(instance, safely);
  if (false) {
    ReactInstrumentation.debugTool.onEndFlush();
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    container = container.documentElement;
  }

  // http://jsperf.com/emptying-a-node
  while (container.lastChild) {
    container.removeChild(container.lastChild);
  }
}

/**
 * True if the supplied DOM node has a direct React-rendered child that is
 * not a React root element. Useful for warning in `render`,
 * `unmountComponentAtNode`, etc.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM element contains a direct child that was
 * rendered by React but is not a root element.
 * @internal
 */
function hasNonRootReactChild(container) {
  var rootEl = getReactRootElementInContainer(container);
  if (rootEl) {
    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
    return !!(inst && inst._hostParent);
  }
}

/**
 * True if the supplied DOM node is a React DOM element and
 * it has been rendered by another copy of React.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM has been rendered by another copy of React
 * @internal
 */
function nodeIsRenderedByOtherInstance(container) {
  var rootEl = getReactRootElementInContainer(container);
  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
}

/**
 * True if the supplied DOM node is a valid node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid DOM node.
 * @internal
 */
function isValidContainer(node) {
  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
}

/**
 * True if the supplied DOM node is a valid React node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid React DOM node.
 * @internal
 */
function isReactNode(node) {
  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
}

function getHostRootInstanceInContainer(container) {
  var rootEl = getReactRootElementInContainer(container);
  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
}

function getTopLevelWrapperInContainer(container) {
  var root = getHostRootInstanceInContainer(container);
  return root ? root._hostContainerInfo._topLevelWrapper : null;
}

/**
 * Temporary (?) hack so that we can store all top-level pending updates on
 * composites instead of having to worry about different types of components
 * here.
 */
var topLevelRootCounter = 1;
var TopLevelWrapper = function () {
  this.rootID = topLevelRootCounter++;
};
TopLevelWrapper.prototype.isReactComponent = {};
if (false) {
  TopLevelWrapper.displayName = 'TopLevelWrapper';
}
TopLevelWrapper.prototype.render = function () {
  return this.props.child;
};
TopLevelWrapper.isReactTopLevelWrapper = true;

/**
 * Mounting is the process of initializing a React component by creating its
 * representative DOM elements and inserting them into a supplied `container`.
 * Any prior content inside `container` is destroyed in the process.
 *
 *   ReactMount.render(
 *     component,
 *     document.getElementById('container')
 *   );
 *
 *   <div id="container">                   <-- Supplied `container`.
 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
 *       // ...                                 component.
 *     </div>
 *   </div>
 *
 * Inside of `container`, the first element rendered is the "reactRoot".
 */
var ReactMount = {

  TopLevelWrapper: TopLevelWrapper,

  /**
   * Used by devtools. The keys are not important.
   */
  _instancesByReactRootID: instancesByReactRootID,

  /**
   * This is a hook provided to support rendering React components while
   * ensuring that the apparent scroll position of its `container` does not
   * change.
   *
   * @param {DOMElement} container The `container` being rendered into.
   * @param {function} renderCallback This must be called once to do the render.
   */
  scrollMonitor: function (container, renderCallback) {
    renderCallback();
  },

  /**
   * Take a component that's already mounted into the DOM and replace its props
   * @param {ReactComponent} prevComponent component instance already in the DOM
   * @param {ReactElement} nextElement component instance to render
   * @param {DOMElement} container container to render into
   * @param {?function} callback function triggered on completion
   */
  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
    ReactMount.scrollMonitor(container, function () {
      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
      if (callback) {
        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
      }
    });

    return prevComponent;
  },

  /**
   * Render a new component into the DOM. Hooked by hooks!
   *
   * @param {ReactElement} nextElement element to render
   * @param {DOMElement} container container to render into
   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
   * @return {ReactComponent} nextComponent
   */
  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case.
     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;

    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
    var componentInstance = instantiateReactComponent(nextElement, false);

    // The initial render is synchronous but any updates that happen during
    // rendering, in componentWillMount or componentDidMount, will be batched
    // according to the current batching strategy.

    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);

    var wrapperID = componentInstance._instance.rootID;
    instancesByReactRootID[wrapperID] = componentInstance;

    return componentInstance;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
  },

  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
    // Check if it quacks like an element
    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;

     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;

    var nextWrappedElement = React.createElement(TopLevelWrapper, { child: nextElement });

    var nextContext;
    if (parentComponent) {
      var parentInst = ReactInstanceMap.get(parentComponent);
      nextContext = parentInst._processChildContext(parentInst._context);
    } else {
      nextContext = emptyObject;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);

    if (prevComponent) {
      var prevWrappedElement = prevComponent._currentElement;
      var prevElement = prevWrappedElement.props.child;
      if (shouldUpdateReactComponent(prevElement, nextElement)) {
        var publicInst = prevComponent._renderedComponent.getPublicInstance();
        var updatedCallback = callback && function () {
          callback.call(publicInst);
        };
        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
        return publicInst;
      } else {
        ReactMount.unmountComponentAtNode(container);
      }
    }

    var reactRootElement = getReactRootElementInContainer(container);
    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
    var containerHasNonRootReactChild = hasNonRootReactChild(container);

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;

      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
        var rootElementSibling = reactRootElement;
        while (rootElementSibling) {
          if (internalGetID(rootElementSibling)) {
            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
            break;
          }
          rootElementSibling = rootElementSibling.nextSibling;
        }
      }
    }

    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
    if (callback) {
      callback.call(component);
    }
    return component;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  render: function (nextElement, container, callback) {
    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
  },

  /**
   * Unmounts and destroys the React component rendered in the `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
   *
   * @param {DOMElement} container DOM element containing a React component.
   * @return {boolean} True if a component was found in and unmounted from
   *                   `container`
   */
  unmountComponentAtNode: function (container) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case. (Strictly speaking, unmounting won't cause a
    // render but we still don't expect to be in a render call here.)
     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by another copy of React.') : void 0;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);
    if (!prevComponent) {
      // Check if the node being unmounted was rendered by React, but isn't a
      // root node.
      var containerHasNonRootReactChild = hasNonRootReactChild(container);

      // Check if the container itself is a React root node.
      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
      }

      return false;
    }
    delete instancesByReactRootID[prevComponent._instance.rootID];
    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
    return true;
  },

  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;

    if (shouldReuseMarkup) {
      var rootElement = getReactRootElementInContainer(container);
      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
        ReactDOMComponentTree.precacheNode(instance, rootElement);
        return;
      } else {
        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);

        var rootMarkup = rootElement.outerHTML;
        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);

        var normalizedMarkup = markup;
        if (false) {
          // because rootMarkup is retrieved from the DOM, various normalizations
          // will have occurred which will not be present in `markup`. Here,
          // insert markup into a <div> or <iframe> depending on the container
          // type to perform the same normalizations before comparing.
          var normalizer;
          if (container.nodeType === ELEMENT_NODE_TYPE) {
            normalizer = document.createElement('div');
            normalizer.innerHTML = markup;
            normalizedMarkup = normalizer.innerHTML;
          } else {
            normalizer = document.createElement('iframe');
            document.body.appendChild(normalizer);
            normalizer.contentDocument.write(markup);
            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
            document.body.removeChild(normalizer);
          }
        }

        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);

        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;

        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
        }
      }
    }

    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;

    if (transaction.useCreateElement) {
      while (container.lastChild) {
        container.removeChild(container.lastChild);
      }
      DOMLazyTree.insertTreeBefore(container, markup, null);
    } else {
      setInnerHTML(container, markup);
      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
    }

    if (false) {
      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
      if (hostNode._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: hostNode._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  }
};

module.exports = ReactMount;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactNodeTypes = __webpack_require__(244);

function getHostComponentFromComposite(inst) {
  var type;

  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
    inst = inst._renderedComponent;
  }

  if (type === ReactNodeTypes.HOST) {
    return inst._renderedComponent;
  } else if (type === ReactNodeTypes.EMPTY) {
    return null;
  }
}

module.exports = getHostComponentFromComposite;

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(41);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(25);

var _invariant2 = _interopRequireDefault(_invariant);

var _Actions = __webpack_require__(67);

var _PathUtils = __webpack_require__(68);

var _ExecutionEnvironment = __webpack_require__(124);

var _DOMUtils = __webpack_require__(182);

var _DOMStateStorage = __webpack_require__(183);

var _createDOMHistory = __webpack_require__(256);

var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);

function isAbsolutePath(path) {
  return typeof path === 'string' && path.charAt(0) === '/';
}

function ensureSlash() {
  var path = _DOMUtils.getHashPath();

  if (isAbsolutePath(path)) return true;

  _DOMUtils.replaceHashPath('/' + path);

  return false;
}

function addQueryStringValueToPath(path, key, value) {
  return path + (path.indexOf('?') === -1 ? '?' : '&') + (key + '=' + value);
}

function stripQueryStringValueFromPath(path, key) {
  return path.replace(new RegExp('[?&]?' + key + '=[a-zA-Z0-9]+'), '');
}

function getQueryStringValueFromPath(path, key) {
  var match = path.match(new RegExp('\\?.*?\\b' + key + '=(.+?)\\b'));
  return match && match[1];
}

var DefaultQueryKey = '_k';

function createHashHistory() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Hash history needs a DOM') : _invariant2['default'](false) : undefined;

  var queryKey = options.queryKey;

  if (queryKey === undefined || !!queryKey) queryKey = typeof queryKey === 'string' ? queryKey : DefaultQueryKey;

  function getCurrentLocation() {
    var path = _DOMUtils.getHashPath();

    var key = undefined,
        state = undefined;
    if (queryKey) {
      key = getQueryStringValueFromPath(path, queryKey);
      path = stripQueryStringValueFromPath(path, queryKey);

      if (key) {
        state = _DOMStateStorage.readState(key);
      } else {
        state = null;
        key = history.createKey();
        _DOMUtils.replaceHashPath(addQueryStringValueToPath(path, queryKey, key));
      }
    } else {
      key = state = null;
    }

    var location = _PathUtils.parsePath(path);

    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
  }

  function startHashChangeListener(_ref) {
    var transitionTo = _ref.transitionTo;

    function hashChangeListener() {
      if (!ensureSlash()) return; // Always make sure hashes are preceeded with a /.

      transitionTo(getCurrentLocation());
    }

    ensureSlash();
    _DOMUtils.addEventListener(window, 'hashchange', hashChangeListener);

    return function () {
      _DOMUtils.removeEventListener(window, 'hashchange', hashChangeListener);
    };
  }

  function finishTransition(location) {
    var basename = location.basename;
    var pathname = location.pathname;
    var search = location.search;
    var state = location.state;
    var action = location.action;
    var key = location.key;

    if (action === _Actions.POP) return; // Nothing to do.

    var path = (basename || '') + pathname + search;

    if (queryKey) {
      path = addQueryStringValueToPath(path, queryKey, key);
      _DOMStateStorage.saveState(key, state);
    } else {
      // Drop key and state.
      location.key = location.state = null;
    }

    var currentHash = _DOMUtils.getHashPath();

    if (action === _Actions.PUSH) {
      if (currentHash !== path) {
        window.location.hash = path;
      } else {
         false ? _warning2['default'](false, 'You cannot PUSH the same path using hash history') : undefined;
      }
    } else if (currentHash !== path) {
      // REPLACE
      _DOMUtils.replaceHashPath(path);
    }
  }

  var history = _createDOMHistory2['default'](_extends({}, options, {
    getCurrentLocation: getCurrentLocation,
    finishTransition: finishTransition,
    saveState: _DOMStateStorage.saveState
  }));

  var listenerCount = 0,
      stopHashChangeListener = undefined;

  function listenBefore(listener) {
    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);

    var unlisten = history.listenBefore(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopHashChangeListener();
    };
  }

  function listen(listener) {
    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);

    var unlisten = history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopHashChangeListener();
    };
  }

  function push(location) {
     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;

    history.push(location);
  }

  function replace(location) {
     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;

    history.replace(location);
  }

  var goIsSupportedWithoutReload = _DOMUtils.supportsGoWithoutReloadUsingHash();

  function go(n) {
     false ? _warning2['default'](goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : undefined;

    history.go(n);
  }

  function createHref(path) {
    return '#' + history.createHref(path);
  }

  // deprecated
  function registerTransitionHook(hook) {
    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);

    history.registerTransitionHook(hook);
  }

  // deprecated
  function unregisterTransitionHook(hook) {
    history.unregisterTransitionHook(hook);

    if (--listenerCount === 0) stopHashChangeListener();
  }

  // deprecated
  function pushState(state, path) {
     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;

    history.pushState(state, path);
  }

  // deprecated
  function replaceState(state, path) {
     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;

    history.replaceState(state, path);
  }

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen,
    push: push,
    replace: replace,
    go: go,
    createHref: createHref,

    registerTransitionHook: registerTransitionHook, // deprecated - warning is in createHistory
    unregisterTransitionHook: unregisterTransitionHook, // deprecated - warning is in createHistory
    pushState: pushState, // deprecated - warning is in createHistory
    replaceState: replaceState // deprecated - warning is in createHistory
  });
}

exports['default'] = createHashHistory;
module.exports = exports['default'];

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _invariant = __webpack_require__(25);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(124);

var _DOMUtils = __webpack_require__(182);

var _createHistory = __webpack_require__(257);

var _createHistory2 = _interopRequireDefault(_createHistory);

function createDOMHistory(options) {
  var history = _createHistory2['default'](_extends({
    getUserConfirmation: _DOMUtils.getUserConfirmation
  }, options, {
    go: _DOMUtils.go
  }));

  function listen(listener) {
    !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'DOM history needs a DOM') : _invariant2['default'](false) : undefined;

    return history.listen(listener);
  }

  return _extends({}, history, {
    listen: listen
  });
}

exports['default'] = createDOMHistory;
module.exports = exports['default'];

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(41);

var _warning2 = _interopRequireDefault(_warning);

var _deepEqual = __webpack_require__(485);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _PathUtils = __webpack_require__(68);

var _AsyncUtils = __webpack_require__(496);

var _Actions = __webpack_require__(67);

var _createLocation2 = __webpack_require__(497);

var _createLocation3 = _interopRequireDefault(_createLocation2);

var _runTransitionHook = __webpack_require__(185);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _deprecate = __webpack_require__(186);

var _deprecate2 = _interopRequireDefault(_deprecate);

function createRandomKey(length) {
  return Math.random().toString(36).substr(2, length);
}

function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search &&
  //a.action === b.action && // Different action !== location change.
  a.key === b.key && _deepEqual2['default'](a.state, b.state);
}

var DefaultKeyLength = 6;

function createHistory() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
  var getCurrentLocation = options.getCurrentLocation;
  var finishTransition = options.finishTransition;
  var saveState = options.saveState;
  var go = options.go;
  var getUserConfirmation = options.getUserConfirmation;
  var keyLength = options.keyLength;

  if (typeof keyLength !== 'number') keyLength = DefaultKeyLength;

  var transitionHooks = [];

  function listenBefore(hook) {
    transitionHooks.push(hook);

    return function () {
      transitionHooks = transitionHooks.filter(function (item) {
        return item !== hook;
      });
    };
  }

  var allKeys = [];
  var changeListeners = [];
  var location = undefined;

  function getCurrent() {
    if (pendingLocation && pendingLocation.action === _Actions.POP) {
      return allKeys.indexOf(pendingLocation.key);
    } else if (location) {
      return allKeys.indexOf(location.key);
    } else {
      return -1;
    }
  }

  function updateLocation(newLocation) {
    var current = getCurrent();

    location = newLocation;

    if (location.action === _Actions.PUSH) {
      allKeys = [].concat(allKeys.slice(0, current + 1), [location.key]);
    } else if (location.action === _Actions.REPLACE) {
      allKeys[current] = location.key;
    }

    changeListeners.forEach(function (listener) {
      listener(location);
    });
  }

  function listen(listener) {
    changeListeners.push(listener);

    if (location) {
      listener(location);
    } else {
      var _location = getCurrentLocation();
      allKeys = [_location.key];
      updateLocation(_location);
    }

    return function () {
      changeListeners = changeListeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function confirmTransitionTo(location, callback) {
    _AsyncUtils.loopAsync(transitionHooks.length, function (index, next, done) {
      _runTransitionHook2['default'](transitionHooks[index], location, function (result) {
        if (result != null) {
          done(result);
        } else {
          next();
        }
      });
    }, function (message) {
      if (getUserConfirmation && typeof message === 'string') {
        getUserConfirmation(message, function (ok) {
          callback(ok !== false);
        });
      } else {
        callback(message !== false);
      }
    });
  }

  var pendingLocation = undefined;

  function transitionTo(nextLocation) {
    if (location && locationsAreEqual(location, nextLocation)) return; // Nothing to do.

    pendingLocation = nextLocation;

    confirmTransitionTo(nextLocation, function (ok) {
      if (pendingLocation !== nextLocation) return; // Transition was interrupted.

      if (ok) {
        // treat PUSH to current path like REPLACE to be consistent with browsers
        if (nextLocation.action === _Actions.PUSH) {
          var prevPath = createPath(location);
          var nextPath = createPath(nextLocation);

          if (nextPath === prevPath && _deepEqual2['default'](location.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
        }

        if (finishTransition(nextLocation) !== false) updateLocation(nextLocation);
      } else if (location && nextLocation.action === _Actions.POP) {
        var prevIndex = allKeys.indexOf(location.key);
        var nextIndex = allKeys.indexOf(nextLocation.key);

        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL.
      }
    });
  }

  function push(location) {
    transitionTo(createLocation(location, _Actions.PUSH, createKey()));
  }

  function replace(location) {
    transitionTo(createLocation(location, _Actions.REPLACE, createKey()));
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function createKey() {
    return createRandomKey(keyLength);
  }

  function createPath(location) {
    if (location == null || typeof location === 'string') return location;

    var pathname = location.pathname;
    var search = location.search;
    var hash = location.hash;

    var result = pathname;

    if (search) result += search;

    if (hash) result += hash;

    return result;
  }

  function createHref(location) {
    return createPath(location);
  }

  function createLocation(location, action) {
    var key = arguments.length <= 2 || arguments[2] === undefined ? createKey() : arguments[2];

    if (typeof action === 'object') {
       false ? _warning2['default'](false, 'The state (2nd) argument to history.createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;

      if (typeof location === 'string') location = _PathUtils.parsePath(location);

      location = _extends({}, location, { state: action });

      action = key;
      key = arguments[3] || createKey();
    }

    return _createLocation3['default'](location, action, key);
  }

  // deprecated
  function setState(state) {
    if (location) {
      updateLocationState(location, state);
      updateLocation(location);
    } else {
      updateLocationState(getCurrentLocation(), state);
    }
  }

  function updateLocationState(location, state) {
    location.state = _extends({}, location.state, state);
    saveState(location.key, location.state);
  }

  // deprecated
  function registerTransitionHook(hook) {
    if (transitionHooks.indexOf(hook) === -1) transitionHooks.push(hook);
  }

  // deprecated
  function unregisterTransitionHook(hook) {
    transitionHooks = transitionHooks.filter(function (item) {
      return item !== hook;
    });
  }

  // deprecated
  function pushState(state, path) {
    if (typeof path === 'string') path = _PathUtils.parsePath(path);

    push(_extends({ state: state }, path));
  }

  // deprecated
  function replaceState(state, path) {
    if (typeof path === 'string') path = _PathUtils.parsePath(path);

    replace(_extends({ state: state }, path));
  }

  return {
    listenBefore: listenBefore,
    listen: listen,
    transitionTo: transitionTo,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    createKey: createKey,
    createPath: createPath,
    createHref: createHref,
    createLocation: createLocation,

    setState: _deprecate2['default'](setState, 'setState is deprecated; use location.key to save state instead'),
    registerTransitionHook: _deprecate2['default'](registerTransitionHook, 'registerTransitionHook is deprecated; use listenBefore instead'),
    unregisterTransitionHook: _deprecate2['default'](unregisterTransitionHook, 'unregisterTransitionHook is deprecated; use the callback returned from listenBefore instead'),
    pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
    replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
  };
}

exports['default'] = createHistory;
module.exports = exports['default'];

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var slice = Array.prototype.slice;
var isArgs = __webpack_require__(259);

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(486);

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toObject = Object;
var TypeErr = TypeError;

module.exports = function flags() {
	if (this != null && this !== toObject(this)) {
		throw new TypeErr('RegExp.prototype.flags getter called on non-object');
	}
	var result = '';
	if (this.global) {
		result += 'g';
	}
	if (this.ignoreCase) {
		result += 'i';
	}
	if (this.multiline) {
		result += 'm';
	}
	if (this.dotAll) {
		result += 's';
	}
	if (this.unicode) {
		result += 'u';
	}
	if (this.sticky) {
		result += 'y';
	}
	return result;
};


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(260);

var supportsDescriptors = __webpack_require__(184).supportsDescriptors;
var gOPD = Object.getOwnPropertyDescriptor;
var TypeErr = TypeError;

module.exports = function getPolyfill() {
	if (!supportsDescriptors) {
		throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
	}
	if (/a/mig.flags === 'gim') {
		var descriptor = gOPD(RegExp.prototype, 'flags');
		if (descriptor && typeof descriptor.get === 'function' && typeof (/a/).dotAll === 'boolean') {
			return descriptor.get;
		}
	}
	return implementation;
};


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = makeStateWithLocation;

var _deprecateObjectProperties = __webpack_require__(123);

var _routerWarning = __webpack_require__(26);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function makeStateWithLocation(state, location) {
  if (false) {
    var stateWithLocation = _extends({}, state);

    // I don't use deprecateObjectProperties here because I want to keep the
    // same code path between development and production, in that we just
    // assign extra properties to the copy of the state object in both cases.

    var _loop = function _loop(prop) {
      if (!Object.prototype.hasOwnProperty.call(location, prop)) {
        return 'continue';
      }

      Object.defineProperty(stateWithLocation, prop, {
        get: function get() {
          process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, 'Accessing location properties directly from the first argument to `getComponent`, `getComponents`, `getChildRoutes`, and `getIndexRoute` is deprecated. That argument is now the router state (`nextState` or `partialNextState`) rather than the location. To access the location, use `nextState.location` or `partialNextState.location`.') : void 0;
          return location[prop];
        }
      });
    };

    for (var prop in location) {
      var _ret = _loop(prop);

      if (_ret === 'continue') continue;
    }

    return stateWithLocation;
  }

  return _extends({}, state, location);
}
module.exports = exports['default'];

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.createRouterObject = createRouterObject;
exports.createRoutingHistory = createRoutingHistory;

var _deprecateObjectProperties = __webpack_require__(123);

var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createRouterObject(history, transitionManager) {
  return _extends({}, history, {
    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
    isActive: transitionManager.isActive
  });
}

// deprecated
function createRoutingHistory(history, transitionManager) {
  history = _extends({}, history, transitionManager);

  if (false) {
    history = (0, _deprecateObjectProperties2.default)(history, '`props.history` and `context.history` are deprecated. Please use `context.router`. http://tiny.cc/router-contextchanges');
  }

  return history;
}

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _routerWarning = __webpack_require__(26);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _invariant = __webpack_require__(25);

var _invariant2 = _interopRequireDefault(_invariant);

var _PropTypes = __webpack_require__(181);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var _React$PropTypes = _react2.default.PropTypes;
var bool = _React$PropTypes.bool;
var object = _React$PropTypes.object;
var string = _React$PropTypes.string;
var func = _React$PropTypes.func;
var oneOfType = _React$PropTypes.oneOfType;


function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
function isEmptyObject(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
  }return true;
}

function createLocationDescriptor(to, _ref) {
  var query = _ref.query;
  var hash = _ref.hash;
  var state = _ref.state;

  if (query || hash || state) {
    return { pathname: to, query: query, hash: hash, state: state };
  }

  return to;
}

/**
 * A <Link> is used to create an <a> element that links to a route.
 * When that route is active, the link gets the value of its
 * activeClassName prop.
 *
 * For example, assuming you have the following route:
 *
 *   <Route path="/posts/:postID" component={Post} />
 *
 * You could use the following component to link to that route:
 *
 *   <Link to={`/posts/${post.id}`} />
 *
 * Links may pass along location state and/or query string parameters
 * in the state/query props, respectively.
 *
 *   <Link ... query={{ show: true }} state={{ the: 'state' }} />
 */
var Link = _react2.default.createClass({
  displayName: 'Link',


  contextTypes: {
    router: _PropTypes.routerShape
  },

  propTypes: {
    to: oneOfType([string, object]),
    query: object,
    hash: string,
    state: object,
    activeStyle: object,
    activeClassName: string,
    onlyActiveOnIndex: bool.isRequired,
    onClick: func,
    target: string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onlyActiveOnIndex: false,
      style: {}
    };
  },
  handleClick: function handleClick(event) {
    if (this.props.onClick) this.props.onClick(event);

    if (event.defaultPrevented) return;

    !this.context.router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;

    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;

    // If target prop is set (e.g. to "_blank"), let browser handle link.
    /* istanbul ignore if: untestable with Karma */
    if (this.props.target) return;

    event.preventDefault();

    var _props = this.props;
    var to = _props.to;
    var query = _props.query;
    var hash = _props.hash;
    var state = _props.state;

    var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });

    this.context.router.push(location);
  },
  render: function render() {
    var _props2 = this.props;
    var to = _props2.to;
    var query = _props2.query;
    var hash = _props2.hash;
    var state = _props2.state;
    var activeClassName = _props2.activeClassName;
    var activeStyle = _props2.activeStyle;
    var onlyActiveOnIndex = _props2.onlyActiveOnIndex;

    var props = _objectWithoutProperties(_props2, ['to', 'query', 'hash', 'state', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);

     false ? (0, _routerWarning2.default)(!(query || hash || state), 'the `query`, `hash`, and `state` props on `<Link>` are deprecated, use `<Link to={{ pathname, query, hash, state }}/>. http://tiny.cc/router-isActivedeprecated') : void 0;

    // Ignore if rendered outside the context of router, simplifies unit testing.
    var router = this.context.router;


    if (router) {
      // If user does not specify a `to` prop, return an empty anchor tag.
      if (to == null) {
        return _react2.default.createElement('a', props);
      }

      var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
      props.href = router.createHref(location);

      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
        if (router.isActive(location, onlyActiveOnIndex)) {
          if (activeClassName) {
            if (props.className) {
              props.className += ' ' + activeClassName;
            } else {
              props.className = activeClassName;
            }
          }

          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
        }
      }
    }

    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
  }
});

exports.default = Link;
module.exports = exports['default'];

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _invariant = __webpack_require__(25);

var _invariant2 = _interopRequireDefault(_invariant);

var _RouteUtils = __webpack_require__(58);

var _PatternUtils = __webpack_require__(86);

var _InternalPropTypes = __webpack_require__(66);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _React$PropTypes = _react2.default.PropTypes;
var string = _React$PropTypes.string;
var object = _React$PropTypes.object;

/**
 * A <Redirect> is used to declare another URL path a client should
 * be sent to when they request a given URL.
 *
 * Redirects are placed alongside routes in the route configuration
 * and are traversed in the same manner.
 */

var Redirect = _react2.default.createClass({
  displayName: 'Redirect',


  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element) {
      var route = (0, _RouteUtils.createRouteFromReactElement)(element);

      if (route.from) route.path = route.from;

      route.onEnter = function (nextState, replace) {
        var location = nextState.location;
        var params = nextState.params;


        var pathname = void 0;
        if (route.to.charAt(0) === '/') {
          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
        } else if (!route.to) {
          pathname = location.pathname;
        } else {
          var routeIndex = nextState.routes.indexOf(route);
          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
        }

        replace({
          pathname: pathname,
          query: route.query || location.query,
          state: route.state || location.state
        });
      };

      return route;
    },
    getRoutePattern: function getRoutePattern(routes, routeIndex) {
      var parentPattern = '';

      for (var i = routeIndex; i >= 0; i--) {
        var route = routes[i];
        var pattern = route.path || '';

        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;

        if (pattern.indexOf('/') === 0) break;
      }

      return '/' + parentPattern;
    }
  },

  propTypes: {
    path: string,
    from: string, // Alias for path
    to: string.isRequired,
    query: object,
    state: object,
    onEnter: _InternalPropTypes.falsy,
    children: _InternalPropTypes.falsy
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
  }
});

exports.default = Redirect;
module.exports = exports['default'];

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createMemoryHistory;

var _useQueries = __webpack_require__(125);

var _useQueries2 = _interopRequireDefault(_useQueries);

var _useBasename = __webpack_require__(267);

var _useBasename2 = _interopRequireDefault(_useBasename);

var _createMemoryHistory = __webpack_require__(517);

var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createMemoryHistory(options) {
  // signatures and type checking differ between `useRoutes` and
  // `createMemoryHistory`, have to create `memoryHistory` first because
  // `useQueries` doesn't understand the signature
  var memoryHistory = (0, _createMemoryHistory2.default)(options);
  var createHistory = function createHistory() {
    return memoryHistory;
  };
  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
  history.__v2_compatible__ = true;
  return history;
}
module.exports = exports['default'];

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(41);

var _warning2 = _interopRequireDefault(_warning);

var _ExecutionEnvironment = __webpack_require__(124);

var _PathUtils = __webpack_require__(68);

var _runTransitionHook = __webpack_require__(185);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _deprecate = __webpack_require__(186);

var _deprecate2 = _interopRequireDefault(_deprecate);

function useBasename(createHistory) {
  return function () {
    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var history = createHistory(options);

    var basename = options.basename;

    var checkedBaseHref = false;

    function checkBaseHref() {
      if (checkedBaseHref) {
        return;
      }

      // Automatically use the value of <base href> in HTML
      // documents as basename if it's not explicitly given.
      if (basename == null && _ExecutionEnvironment.canUseDOM) {
        var base = document.getElementsByTagName('base')[0];
        var baseHref = base && base.getAttribute('href');

        if (baseHref != null) {
          basename = baseHref;

           false ? _warning2['default'](false, 'Automatically setting basename using <base href> is deprecated and will ' + 'be removed in the next major release. The semantics of <base href> are ' + 'subtly different from basename. Please pass the basename explicitly in ' + 'the options to createHistory') : undefined;
        }
      }

      checkedBaseHref = true;
    }

    function addBasename(location) {
      checkBaseHref();

      if (basename && location.basename == null) {
        if (location.pathname.indexOf(basename) === 0) {
          location.pathname = location.pathname.substring(basename.length);
          location.basename = basename;

          if (location.pathname === '') location.pathname = '/';
        } else {
          location.basename = '';
        }
      }

      return location;
    }

    function prependBasename(location) {
      checkBaseHref();

      if (!basename) return location;

      if (typeof location === 'string') location = _PathUtils.parsePath(location);

      var pname = location.pathname;
      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
      var pathname = normalizedBasename + normalizedPathname;

      return _extends({}, location, {
        pathname: pathname
      });
    }

    // Override all read methods with basename-aware versions.
    function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        _runTransitionHook2['default'](hook, addBasename(location), callback);
      });
    }

    function listen(listener) {
      return history.listen(function (location) {
        listener(addBasename(location));
      });
    }

    // Override all write methods with basename-aware versions.
    function push(location) {
      history.push(prependBasename(location));
    }

    function replace(location) {
      history.replace(prependBasename(location));
    }

    function createPath(location) {
      return history.createPath(prependBasename(location));
    }

    function createHref(location) {
      return history.createHref(prependBasename(location));
    }

    function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
    }

    // deprecated
    function pushState(state, path) {
      if (typeof path === 'string') path = _PathUtils.parsePath(path);

      push(_extends({ state: state }, path));
    }

    // deprecated
    function replaceState(state, path) {
      if (typeof path === 'string') path = _PathUtils.parsePath(path);

      replace(_extends({ state: state }, path));
    }

    return _extends({}, history, {
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation,

      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
    });
  };
}

exports['default'] = useBasename;
module.exports = exports['default'];

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = useRouterHistory;

var _useQueries = __webpack_require__(125);

var _useQueries2 = _interopRequireDefault(_useQueries);

var _useBasename = __webpack_require__(267);

var _useBasename2 = _interopRequireDefault(_useBasename);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useRouterHistory(createHistory) {
  return function (options) {
    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
    history.__v2_compatible__ = true;
    return history;
  };
}
module.exports = exports['default'];

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (createHistory) {
  var history = void 0;
  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
  return history;
};

var _useRouterHistory = __webpack_require__(268);

var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

module.exports = exports['default'];

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function getWindow(node) {
  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
};

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getVideoTypeFromContent */
/* harmony export (immutable) */ __webpack_exports__["g"] = getVideoTypeFromStream;
/* harmony export (immutable) */ __webpack_exports__["d"] = getOmniturePageName;
/* harmony export (immutable) */ __webpack_exports__["c"] = getOmniturePageData;
/* harmony export (immutable) */ __webpack_exports__["a"] = getOmnitureAuthData;
/* harmony export (immutable) */ __webpack_exports__["f"] = getOmnitureUserTrackingData;
/* harmony export (immutable) */ __webpack_exports__["b"] = getOmnitureEntitlementsData;
/* harmony export (immutable) */ __webpack_exports__["e"] = getOmnitureQuery;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth_getAccessMethodFromAuthTypes__ = __webpack_require__(190);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Utility functions to format tracking data
 */

function isCollectionsPage(_ref) {
    var _ref$id = _ref.id,
        pageId = _ref$id === undefined ? '' : _ref$id,
        _ref$name = _ref.name,
        pageName = _ref$name === undefined ? '' : _ref$name;

    return pageId !== 'espnplus' && pageId !== pageName.toLowerCase();
}

function getVideoTypeFromContent() {
    var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (content.status) {
        // if the status of the event is over, it's linear, and the previous event was selected, so actually live
        if (content.status === __WEBPACK_IMPORTED_MODULE_0__enums__["n" /* ContentStatus */].OVER) {
            return __WEBPACK_IMPORTED_MODULE_0__enums__["n" /* ContentStatus */].LIVE;
        }
        return content.status;
    }
    return __WEBPACK_IMPORTED_MODULE_0__enums__["o" /* ContentType */].VOD;
}

function getVideoTypeFromStream() {
    var stream = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (stream.status) {
        // if the status of the event is over, it's linear, and the previous event was selected, so actually live
        if (stream.status === __WEBPACK_IMPORTED_MODULE_0__enums__["n" /* ContentStatus */].OVER) {
            return __WEBPACK_IMPORTED_MODULE_0__enums__["n" /* ContentStatus */].LIVE;
        }
        return stream.status;
    }
    return __WEBPACK_IMPORTED_MODULE_0__enums__["o" /* ContentType */].VOD;
}

function getOmniturePageName(page) {
    var _page$id = page.id,
        pageId = _page$id === undefined ? '' : _page$id,
        _page$name = page.name,
        pageName = _page$name === undefined ? '' : _page$name;

    var formattedPageName = pageName.toLowerCase();
    var formattedPageId = pageId.toLowerCase();
    return !isCollectionsPage(page) ? formattedPageId : formattedPageId + ':' + formattedPageName;
}

function getOmniturePageData(page) {
    var _page$name2 = page.name,
        pageName = _page$name2 === undefined ? '' : _page$name2;

    var formattedPageName = pageName.toLowerCase();

    var omniturePageName = getOmniturePageName(page);
    // if collections page, add prop35
    var collectionsPageData = {};
    if (isCollectionsPage(page)) {
        collectionsPageData.prop35 = formattedPageName;
    }

    var pageData = {
        pageName: omniturePageName,
        sections: omniturePageName,
        section: omniturePageName,
        // only the schedule page has a different contentType... just do as we're told
        contentType: formattedPageName === 'schedule' ? 'schedule' : 'index'
    };

    return _extends({}, pageData, collectionsPageData);
}

function getOmnitureAuthData() {
    var userAuth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var provider = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var isDomestic = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    var authenticated = userAuth.indexOf(__WEBPACK_IMPORTED_MODULE_0__enums__["e" /* AuthTypes */].MVPD) !== -1 || userAuth.indexOf(__WEBPACK_IMPORTED_MODULE_0__enums__["e" /* AuthTypes */].ISP) !== -1;
    var authenticationStatus = Object(__WEBPACK_IMPORTED_MODULE_1__auth_getAccessMethodFromAuthTypes__["a" /* default */])(userAuth);
    var pathname = window && window.location && window.location.pathname;
    var notOnSyndicatedPlayerPage = pathname.indexOf('/syndicated/player') === -1;
    var providerName = 'not authenticated';
    var providerPackageName = 'not authenticated';

    if (authenticated === true) {
        // Only assign once authenticated and the `provider` object contains the `name` property
        if (provider.name) {
            providerName = provider.name;
        }

        // NOTE: Domestic Providers use the `abbreviation` property, it should never be `unavailable`
        if (isDomestic) {
            if (provider.abbreviation) {
                providerPackageName = provider.abbreviation;
            }
        } else {
            var _provider$package = provider.package,
                providerPackage = _provider$package === undefined ? {} : _provider$package;
            // NOTE: The only instance `providerPackageName` will be `unavailable` is if there is no match found
            // via a mismatch with the `consumerKey` property in the packages array and the Adobe `packageId`.
            // See: `authenticationActions.js - createSmartAdobePassInitializeAction` function.

            providerPackageName = providerPackage.packageName || providerPackage.name || 'unavailable';
        }
    }

    var authnData = {
        eVar17: providerName,
        prop42: providerName,
        prop43: providerPackageName,
        eVar68: authenticationStatus
    };

    if (notOnSyndicatedPlayerPage) {
        authnData.eVar32 = providerPackageName;
    }

    return authnData;
}

function getOmnitureUserTrackingData(isLoggedIn, userTracking) {
    var _ref2 = userTracking || {},
        _ref2$sessionId = _ref2.sessionId,
        sessionId = _ref2$sessionId === undefined ? 'No Device ID' : _ref2$sessionId,
        _ref2$deviceId = _ref2.deviceId,
        deviceId = _ref2$deviceId === undefined ? 'No Session ID' : _ref2$deviceId,
        _ref2$accountId = _ref2.accountId,
        accountId = _ref2$accountId === undefined ? 'No Account ID' : _ref2$accountId;

    var eVar102 = '';
    if (isLoggedIn) {
        eVar102 = deviceId + ',' + sessionId + ',' + accountId;
    } else {
        eVar102 = deviceId + ',' + sessionId;
    }
    return eVar102;
}

function getOmnitureEntitlementsData(payload) {
    var _ref3 = payload || {},
        purchaseMethod = _ref3.purchaseMethod,
        subscriberType = _ref3.subscriberType,
        entitlements = _ref3.entitlements,
        oneIdLoggedIn = _ref3.oneIdLoggedIn,
        userTracking = _ref3.userTracking,
        hasSupderSundle = _ref3.hasSupderSundle;
    // get eVar102 user tracking string


    var eVar102 = getOmnitureUserTrackingData(oneIdLoggedIn, userTracking);
    if (!entitlements) {
        return {
            eVar102: eVar102
        };
    }

    var eVar104 = hasSupderSundle ? 'Yes' : 'No';
    var data = {
        eVar104: eVar104,
        eVar102: eVar102,
        eVar87: subscriberType,
        list1: entitlements,
        list2: purchaseMethod
    };
    return data;
}

function getOmnitureQuery() {
    var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var omnitureQuery = Object.keys(query).filter(function (key) {
        return key.indexOf('om-') === 0;
    }).reduce(function (acc, key) {
        acc[key] = query[key];
        return acc;
    }, {});

    return omnitureQuery;
}

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.routerReducer = routerReducer;
/**
 * This action type will be dispatched when your history
 * receives a location change.
 */
var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

var initialState = {
  locationBeforeTransitions: null
};

/**
 * This reducer will update the state with the most recent location history
 * has transitioned to. This may not be in sync with the router, particularly
 * if you have asynchronously-loaded routes, so reading from and relying on
 * this state is discouraged.
 */
function routerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  if (type === LOCATION_CHANGE) {
    return _extends({}, state, { locationBeforeTransitions: payload });
  }

  return state;
}

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * This action type will be dispatched by the history actions below.
 * If you're writing a middleware to watch for navigation events, be sure to
 * look for actions of this type.
 */
var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';

function updateLocation(method) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return {
      type: CALL_HISTORY_METHOD,
      payload: { method: method, args: args }
    };
  };
}

/**
 * These actions correspond to the history API.
 * The associated routerMiddleware will capture these events before they get to
 * your reducer and reissue them as the matching function on your history.
 */
var push = exports.push = updateLocation('push');
var replace = exports.replace = updateLocation('replace');
var go = exports.go = updateLocation('go');
var goBack = exports.goBack = updateLocation('goBack');
var goForward = exports.goForward = updateLocation('goForward');

var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

// From https://gist.github.com/epeli/11209665

var Promise = __webpack_require__(11);

// So you can `var request = require("superagent-bluebird-promise")`
var superagent = module.exports = __webpack_require__(192);
var Request = superagent.Request;

Promise.config({
    // Enable cancellation.
    cancellation: true
});
// Create custom error type.
// Create a new object, that prototypally inherits from the Error constructor.
var SuperagentPromiseError = function(message, originalError) {
  var stack;
  this.message = message;
  this.name = 'SuperagentPromiseError';
  this.originalError = originalError;

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
    stack = this.stack;
  }
  else {
    stack = (new Error(message)).stack;
  }

  if (Object.defineProperty) {
    Object.defineProperty(this, 'stack', {
      get: function() {
        if (this.originalError) {
          return stack + '\nCaused by:  ' + this.originalError.stack;
        }

        return stack;
      }
    });
  }
};

SuperagentPromiseError.prototype = new Error();
SuperagentPromiseError.prototype.constructor = SuperagentPromiseError;
superagent.SuperagentPromiseError = SuperagentPromiseError;

/**
 * @namespace utils
 * @class Superagent
 */

/**
 *
 * Add promise support for superagent/supertest
 *
 * Call .promise() to return promise for the request
 *
 * @method then
 * @return {Bluebird.Promise}
 */
Request.prototype.promise = function() {
  var req = this;
  var error;

  return new Promise(function(resolve, reject, onCancel) {
      req.end(function(err, res) {
        if (typeof res !== "undefined" && res.status >= 400) {
          var msg = 'cannot ' + req.method + ' ' + req.url + ' (' + res.status + ')';
          error = new SuperagentPromiseError(msg);
          error.status = res.status;
          error.body = res.body;
          error.res = res;
          reject(error);
        } else if (err) {
          reject(new SuperagentPromiseError('Bad request', err));
        } else {
          resolve(res);
        }
      });
      onCancel(function() {
        req.abort();
       });

    });
};

/**
 *
 * Make superagent requests Promises/A+ conformant
 *
 * Call .then([onFulfilled], [onRejected]) to register callbacks
 *
 * @method then
 * @param {function} [onFulfilled]
 * @param {function} [onRejected]
 * @return {Bluebird.Promise}
 */
Request.prototype.then = function() {
  var promise = this.promise();
  return promise.then.apply(promise, arguments);
};


/***/ }),
/* 275 */
/***/ (function(module, exports) {

/**
 * Check if `obj` is an object.
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */

function isObject(obj) {
  return null !== obj && 'object' === typeof obj;
}

module.exports = isObject;


/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = removeQueryFromUrl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(277);


function removeQueryFromUrl() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var params = arguments[1];

    var finalQuery = {};
    var pathAndQuery = url.split('?');
    if (pathAndQuery.length > 1) {
        finalQuery = Object(__WEBPACK_IMPORTED_MODULE_0____["a" /* convertQueryStringToObject */])(pathAndQuery[1]);
    }

    params.split(',').forEach(function (param) {
        if (finalQuery[param]) {
            delete finalQuery[param];
        }
    });
    return '' + pathAndQuery[0] + Object(__WEBPACK_IMPORTED_MODULE_0____["b" /* queryString */])(finalQuery);
};

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./app/lib/format/addQueryToUrl.js
var addQueryToUrl = __webpack_require__(70);

// EXTERNAL MODULE: ./app/lib/format/apiDateFormatter.js
var apiDateFormatter = __webpack_require__(105);

// EXTERNAL MODULE: ./app/enums.js
var enums = __webpack_require__(1);

// CONCATENATED MODULE: ./app/lib/format/streamSubtitle.js


function streamSubtitle(_ref) {
    var _ref$authTypes = _ref.authTypes,
        authTypes = _ref$authTypes === undefined ? [] : _ref$authTypes,
        _ref$content = _ref.content,
        type = _ref$content.type,
        _ref$content$subtitle = _ref$content.subtitle,
        subtitle = _ref$content$subtitle === undefined ? '' : _ref$content$subtitle;

    // no subtitle with non-auth vod
    if (type === enums["o" /* ContentType */].VOD && authTypes.length === 0) {
        return null;
    }

    return subtitle;
};
// EXTERNAL MODULE: ./app/lib/format/convertQueryStringToObject.js
var convertQueryStringToObject = __webpack_require__(278);

// EXTERNAL MODULE: ./app/lib/format/convertObjectToQueryString.js
var convertObjectToQueryString = __webpack_require__(279);

// EXTERNAL MODULE: ./app/lib/format/dateFormat.js
var dateFormat = __webpack_require__(33);

// EXTERNAL MODULE: ./app/lib/format/getContentFromListing.js
var getContentFromListing = __webpack_require__(293);

// EXTERNAL MODULE: ./app/lib/format/getMinutesUntilStart.js
var getMinutesUntilStart = __webpack_require__(202);

// EXTERNAL MODULE: ./app/lib/format/getSiteUrlForPath.js
var getSiteUrlForPath = __webpack_require__(294);

// EXTERNAL MODULE: ./app/lib/format/getI18nInclude.js
var getI18nInclude = __webpack_require__(295);

// EXTERNAL MODULE: ./app/lib/format/getMobileGameCastUrlForContent.js
var getMobileGameCastUrlForContent = __webpack_require__(296);

// CONCATENATED MODULE: ./app/lib/format/normalizeCountry.js

var usTerritories = ['GU', 'PR', 'VI'];

/**
 * This function determines if a country is part of the US and returns US if so
 * @param {string} country
 */
function normalizeCountry(country) {
  return usTerritories.indexOf(country) === -1 ? country : 'US';
}
// EXTERNAL MODULE: ./app/lib/format/normalizeQueryString.js
var normalizeQueryString = __webpack_require__(203);

// EXTERNAL MODULE: ./app/lib/format/queryString.js
var queryString = __webpack_require__(18);

// CONCATENATED MODULE: ./app/lib/format/getQueryParamsFromString.js
/**
 * getQueryParamsFromString - Given a url containing query parameters,
 * it will return only the query parameters as a string. Optionally takes an includeOnlyList array
 * that will only return matchingQueryParams or a default empty string
 *
 * @param  {string} url - url to extract query parameters from
 * @param  {array} includeOnlyList - optional array parameter used to filter query params included in the array
 * @return {string} - properly formatted query parameters or defaults to an empty string
 */

function getQueryParamsFromString(url, includeOnlyList) {
    if (typeof url === 'string' && url.split('?').length > 1) {
        var queryParams = url.split('?')[1];

        if (!queryParams || queryParams.trim() === '') {
            return '';
        }

        // Handle the optional includeOnlyList array
        if (includeOnlyList && Array.isArray(includeOnlyList) && includeOnlyList.length) {
            var matchingQueryParams = [];
            var sanitizedQueryParams = '';
            includeOnlyList.forEach(function (item, index) {
                var queryParamName = item.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
                var regex = new RegExp('[\\?&]' + queryParamName + '=([^&#]*)');
                var result = regex.exec(queryParams);

                if (result && Array.isArray(result) && result[0]) {
                    matchingQueryParams.push(result[0].replace('&', '')); // remove prepended `&`
                }
            });

            if (matchingQueryParams.length === 1) {
                sanitizedQueryParams += matchingQueryParams.join('');
            } else if (matchingQueryParams.length > 1) {
                sanitizedQueryParams += matchingQueryParams.join('&');
            }

            return sanitizedQueryParams;
        }

        return queryParams;
    }

    return '';
};
// EXTERNAL MODULE: ./app/lib/format/removeQueryFromUrl.js
var removeQueryFromUrl = __webpack_require__(276);

// CONCATENATED MODULE: ./app/lib/format/convertV1ToV3.js


function convertV1ToV3(content) {
    var v3Content = void 0;
    if (content.type === 'event') {
        v3Content = {
            id: '' + content.id,
            status: content.status,
            type: enums["o" /* ContentType */].LISTING,
            name: content.name,
            description: content.description,
            imageHref: content.imageHref,
            subtitle: content.subtitle,
            date: content.date,
            shortDate: content.shortDate,
            utc: content.rawDate,
            time: content.time,
            streams: [{
                id: '' + content.id,
                name: content.name,
                status: content.status,
                duration: content.duration,
                source: {
                    id: content.sourceId,
                    name: content.source,
                    type: content.sourceType
                },
                score: content.score,
                authTypes: content.authTypes,
                adobeRSS: content.adobeRSS,
                links: content.links
            }],
            iconHref: content.iconHref
        };
    } else if (content.type === 'video') {
        v3Content = {
            id: '' + content.id,
            guid: content.guid,
            type: enums["o" /* ContentType */].VOD,
            name: content.name,
            description: content.description,
            imageHref: content.imageHref,
            subtitle: content.subtitle,
            streams: [{
                id: '' + content.id,
                name: content.name,
                duration: content.duration,
                source: {
                    name: content.source
                },
                links: content.links
            }]
        };
    }
    return v3Content;
}
// CONCATENATED MODULE: ./app/lib/format/getStreamForContent.js
/**
 * getStreamForContent
 * @description return stream which `id` matches with content's `id`, otherwise return the first stream item
 * @param content
 * @returns {Stream}
 */
function getStreamForContent(content) {
    var id = content.id,
        _content$streams = content.streams,
        streams = _content$streams === undefined ? [] : _content$streams;

    var stream = streams.filter(function (streamItem) {
        return streamItem.id === id;
    })[0];
    if (!streams) {
        stream = streams[0];
    }
    return stream;
}
// CONCATENATED MODULE: ./app/lib/format/convertV3ToV1.js




function convertV3ToV1(content) {
    var stream = getStreamForContent(content);
    var contentId = isNaN(parseInt(content.id, 10)) ? content.id : parseInt(content.id, 10);
    var v1Content = void 0;
    if (content.type === enums["o" /* ContentType */].LISTING) {
        v1Content = {
            id: contentId,
            status: content.status,
            type: 'event',
            name: content.name,
            description: content.description,
            imageHref: content.imageHref,
            duration: stream.duration,
            subtitle: content.subtitle,
            date: content.date,
            shortDate: content.shortDate,
            rawDate: content.utc,
            time: content.time,
            authTypes: stream.authTypes,
            airings: [{}],
            source: stream.source.name,
            sourceId: stream.source.id,
            sourceType: stream.source.type,
            adobeRSS: stream.adobeRSS,
            links: stream.links,
            tracking: {
                // TODO: check if ESPN App uses this
            },
            iconHref: content.iconHref
        };
    } else if (content.type === enums["o" /* ContentType */].VOD) {
        v1Content = {
            id: contentId,
            guid: content.guid,
            type: 'video',
            name: content.name,
            description: content.description,
            imageHref: content.imageHref,
            duration: stream.duration,
            subtitle: content.subtitle,
            airings: [{
                airingId: content.id
            }],
            source: stream.source.name,
            links: stream.links,
            tracking: {
                // TODO: check if ESPN App uses this
            }
        };
    }
    return v1Content;
}
// EXTERNAL MODULE: ./app/lib/format/getAdobePassRedirectUrl.js
var getAdobePassRedirectUrl = __webpack_require__(297);

// CONCATENATED MODULE: ./app/lib/format/index.js
/* unused concated harmony import addQueryToUrl */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return addQueryToUrl["a" /* default */]; });
/* unused concated harmony import apiDateFormatter */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return apiDateFormatter["a" /* default */]; });
/* unused concated harmony import streamSubtitle */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return streamSubtitle; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return convertQueryStringToObject["a" /* default */]; });
/* unused concated harmony import convertObjectToQueryString */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return convertObjectToQueryString["a" /* default */]; });
/* unused concated harmony import dateFormat */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return dateFormat["a" /* default */]; });
/* unused concated harmony import getContentFromListing */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getContentFromListing["a" /* default */]; });
/* unused concated harmony import getMinutesUntilStart */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getMinutesUntilStart["a" /* default */]; });
/* unused concated harmony import getSiteUrlForPath */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getSiteUrlForPath["a" /* default */]; });
/* unused concated harmony import getI18nInclude */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getI18nInclude["a" /* default */]; });
/* unused concated harmony import getMobileGameCastUrlForContent */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getMobileGameCastUrlForContent["a" /* default */]; });
/* unused concated harmony import normalizeCountry */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return normalizeCountry; });
/* unused concated harmony import normalizeQueryString */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return normalizeQueryString["a" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return queryString["a" /* default */]; });
/* unused concated harmony import getQueryParamsFromString */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getQueryParamsFromString; });
/* unused concated harmony import removeQueryFromUrl */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return removeQueryFromUrl["a" /* default */]; });
/* unused concated harmony import convertV1ToV3 */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return convertV1ToV3; });
/* unused concated harmony import convertV3ToV1 */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return convertV3ToV1; });
/* unused concated harmony import getStreamForContent */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getStreamForContent; });
/* unused concated harmony import getAdobePassRedirectUrl */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getAdobePassRedirectUrl["a" /* default */]; });





















/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = convertQueryStringToObject;
function convertQueryStringToObject() {
    var queryString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var queryParams = queryString.split('&');
    return queryParams.reduce(function (acc, next) {
        var keyAndValue = next.split('=');
        if (keyAndValue.length > 0) {
            var key = keyAndValue[0];
            acc[key] = keyAndValue[1];
        }
        return acc;
    }, {});
}

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = convertObjectToQueryString;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_pick__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_size__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_size___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_size__);



/**
 * convertObjectToQueryString - Converts a given object with matching keys (keysArray) as a query formatted string.
 *
 * @param  {object} object - object containing N amount of properties to be matched by the keysArray
 * @param  {array} keysArray - array containing keys that should match the passed object
 * @return {string} - returns a properly formatted query string (i.e. id=123&lang=pt...); defaults to an empty string
 */
function convertObjectToQueryString(object, keysArray) {
    if (!object || !keysArray || Array.isArray(keysArray) === false || keysArray.length < 1) {
        return '';
    }

    var convertedString = '';
    var matchingObject = __WEBPACK_IMPORTED_MODULE_0_lodash_pick___default()(object, keysArray);

    if (matchingObject) {
        var currentObjectCount = 0;
        var lengthOfMatchingObject = __WEBPACK_IMPORTED_MODULE_1_lodash_size___default()(matchingObject);

        Object.keys(matchingObject).forEach(function (key) {
            var value = matchingObject[key];
            currentObjectCount++;
            convertedString += key + '=' + value;

            if (currentObjectCount !== lengthOfMatchingObject) {
                convertedString += '&';
            }
        });
    }

    return convertedString;
}

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 281 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(134),
    eq = __webpack_require__(109);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(72);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(569),
    hasPath = __webpack_require__(570);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(286),
    isFlattenable = __webpack_require__(574);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 286 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(575);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(576),
    shortOut = __webpack_require__(578);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 289 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(72),
    root = __webpack_require__(39);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 291 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(console, module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate (y) {
        var date;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            var args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays (ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays :
            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
            : (m) ? weekdays[m.day()] : weekdays;
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    var MS_PER_SECOND = 1000;
    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':   return months;
                case 'quarter': return months / 3;
                case 'year':    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asQuarters     = makeAs('Q');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asQuarters     = asQuarters;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.24.0';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(107)(module)))

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getContentFromListing;
/* unused harmony export getV1ContentFromListing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums__ = __webpack_require__(1);


function getAuthTypesFromBroadcasts() {
    var broadcasts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var authTypes = [];
    if (broadcasts.length > 0) {
        if (['espn_dtc', 'bam_dtc', 'espn_ppv'].indexOf(broadcasts[0].adobeResource) !== -1) {
            authTypes.push(__WEBPACK_IMPORTED_MODULE_0__enums__["e" /* AuthTypes */].BAM);
        } else {
            authTypes.push(__WEBPACK_IMPORTED_MODULE_0__enums__["e" /* AuthTypes */].MVPD);
        }
        if (broadcasts[0].ipAuth === true) {
            authTypes.push(__WEBPACK_IMPORTED_MODULE_0__enums__["e" /* AuthTypes */].ISP);
        }
    }
    return authTypes;
}

function getPackagesFromBroadcasts() {
    var broadcasts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var packages = [];
    if (broadcasts.length > 0 && broadcasts[0].packages) {
        packages = broadcasts[0].packages;
    }
    return packages;
}

function getSourceTypeFromBroadcasts() {
    var broadcasts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var sourceType = void 0;
    if (broadcasts.length > 0) {
        sourceType = broadcasts[0].type;
    }
    return sourceType;
}

function getSourceIdFromBroadcasts() {
    var broadcasts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var sourceId = void 0;
    if (broadcasts.length > 0) {
        sourceId = broadcasts[0].code;
    }
    return sourceId;
}

function getSourceFromBroadcasts() {
    var broadcasts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var source = void 0;
    if (broadcasts.length > 0) {
        source = broadcasts[0].shortName;
    }
    return source;
}

function getAdobeResourceFromBroadcasts() {
    var broadcasts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var adobeResource = void 0;
    if (broadcasts.length > 0) {
        adobeResource = broadcasts[0].adobeResource;
    }
    return adobeResource;
}

function getImageHrefFromBroadcasts() {
    var thumbnails = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var imageHref = void 0;
    if (thumbnails.large) {
        imageHref = thumbnails.large.href;
    }
    return imageHref;
}

/**
 * Takes a listing from the v1 api and converts it to a content item
 */
// TODO: DTC - make sure this works for both 5.x and 6.x app
function getContentFromListing() {
    var listing = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return {
        id: listing.id.toString(),
        type: __WEBPACK_IMPORTED_MODULE_0__enums__["o" /* ContentType */].LISTING,
        name: listing.name,
        status: listing.type,
        imageHref: getImageHrefFromBroadcasts(listing.thumbnails),
        backgroundImageHref: listing.backgroundImageHref,
        streams: [{
            id: listing.id.toString(),
            status: listing.type,
            name: listing.name,
            source: {
                id: getSourceIdFromBroadcasts(listing.broadcasts),
                name: getSourceFromBroadcasts(listing.broadcasts),
                type: getSourceTypeFromBroadcasts(listing.broadcasts)
            },
            authTypes: getAuthTypesFromBroadcasts(listing.broadcasts),
            adobeResource: getAdobeResourceFromBroadcasts(listing.broadcasts),
            packages: getPackagesFromBroadcasts(listing.broadcasts)
        }]
    };
};

function getV1ContentFromListing() {
    var listing = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return {
        id: listing.id,
        type: __WEBPACK_IMPORTED_MODULE_0__enums__["o" /* ContentType */].EVENT,
        name: listing.name,
        status: listing.type,
        source: getSourceFromBroadcasts(listing.broadcasts),
        sourceId: getSourceIdFromBroadcasts(listing.broadcasts),
        sourceType: getSourceTypeFromBroadcasts(listing.broadcasts),
        authTypes: getAuthTypesFromBroadcasts(listing.broadcasts),
        packages: getPackagesFromBroadcasts(listing.broadcasts),
        imageHref: getImageHrefFromBroadcasts(listing.thumbnails)
    };
};

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getSiteUrlForPath;
/**
 * Returns the fully qualified site base url
 */

var ROOT = '/watch';

function getSiteUrlForPath() {
    var pathArg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    // prepend a slash if the path doesn't have it
    var path = pathArg.indexOf('/') === 0 ? pathArg : '/' + pathArg;
    var url = path;
    if (window) {
        var _window = window,
            _window$location = _window.location,
            hostname = _window$location.hostname,
            port = _window$location.port,
            protocol = _window$location.protocol;

        url = protocol + '//' + hostname + (port ? ':' + port : port) + ROOT + path;
    }
    return url;
}

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getI18nInclude;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__queryString__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config__);



var baseUrl = 'https://secure.espn.com/core/format/modules/head/i18n';

function getI18nInclude() {
    var query = {
        'edition-host': 'espn.com',
        lang: 'en',
        region: 'us',
        site: 'espn',
        'site=type': 'full',
        type: 'ext',
        build: '0.362.4.1',
        'edition-view': 'espn-en-us',
        edition: 'espn-en-us'
    };
    return '' + baseUrl + Object(__WEBPACK_IMPORTED_MODULE_0__queryString__["a" /* default */])(query);
};

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getMobileGameCastUrlForContent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_getContentId__ = __webpack_require__(60);

/**
 * Generates a gamecast url for a given content object
 * @param {object} content - Destructured an eventId from content
 */

var scoresHost = "http://scores.espn.com";
var mobileHost = "http://m.espn.com";

var leagueCodePathMap = {
    ncaam: 'ncb',
    nba: 'nba',
    nfl: 'nfl',
    ncaaf: 'ncaaf'
};

function getMobileGameCastUrlForContent(content) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        leagueCode = _ref.leagueCode;

    var _getContentId = Object(__WEBPACK_IMPORTED_MODULE_0__auth_getContentId__["a" /* default */])(content),
        eventId = _getContentId.eventId;

    if (eventId && leagueCode) {
        var lowerLeagueCode = leagueCode.toLowerCase();
        if (lowerLeagueCode === 'mlb') {
            return mobileHost + "/mlb/gamecast?eventId=" + eventId;
        } else if (leagueCodePathMap[lowerLeagueCode]) {
            return scoresHost + "/" + leagueCodePathMap[lowerLeagueCode] + "/gamecast?version=mobile&gameId=" + eventId;
        }
    }
    return null;
}

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export getId */
/* harmony export (immutable) */ __webpack_exports__["a"] = getAdobePassRedirectUrl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__queryString__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth_getContentId__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__omniture__ = __webpack_require__(34);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






function getId(content, stream, query) {
    var contentId = void 0;
    var id = query.id,
        airingId = query.airingId;

    if (airingId && airingId === id) {
        contentId = { id: airingId };
    } else {
        contentId = stream ? { id: stream.id } : Object(__WEBPACK_IMPORTED_MODULE_1__auth_getContentId__["a" /* default */])(content);
    }
    return contentId;
}

function getAdobePassRedirectUrl(_ref) {
    var content = _ref.content,
        stream = _ref.stream,
        _ref$flags = _ref.flags,
        flags = _ref$flags === undefined ? {} : _ref$flags,
        _ref$query = _ref.query,
        query = _ref$query === undefined ? {} : _ref$query,
        _ref$pathname = _ref.pathname,
        pathname = _ref$pathname === undefined ? '' : _ref$pathname;

    if (content == null || global.location.pathname === '/watch/syndicated/player') {
        return '';
    }
    var bucketId = content.bucketId,
        groupId = content.groupId,
        network = content.network,
        _content$placement = content.placement,
        placement = _content$placement === undefined ? '' : _content$placement;

    var contentId = getId(content, stream, query);

    var omnitureQuery = Object(__WEBPACK_IMPORTED_MODULE_2__omniture__["c" /* getOmnitureQuery */])(query);

    var qs = Object(__WEBPACK_IMPORTED_MODULE_0__queryString__["a" /* default */])(_extends({
        bucketId: bucketId,
        groupId: groupId,
        network: network
    }, contentId, flags, omnitureQuery));
    // if it should play in hero, don't re-route to player page
    var id = query.id;

    var playInHero = content.isHero || placement === 'inline-hero' || id === content.id && pathname !== '/player';
    // if entering via SEO friendly parameter URL, chop all the path params off and use straight query params for redirectUrl
    var path = playInHero ? global.location.pathname.replace(/\/_\/?.+/, '') : '/watch/player';
    var port = global.location.port !== '' ? ':' + global.location.port : '';
    return global.location.protocol + '//' + global.location.hostname + port + path + qs;
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(24)))

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(603);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 299 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 300 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 301 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(199),
    overRest = __webpack_require__(287),
    setToString = __webpack_require__(288);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(51),
    isObjectLike = __webpack_require__(59);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config__);

var cacheModuleConfig = { verbose: false, defaultExpiration: 30, memcached: __WEBPACK_IMPORTED_MODULE_0__config__["cache"] || {} };

/* harmony default export */ __webpack_exports__["a"] = ((function () {
    if (true) {
        var CacheService = __webpack_require__(613);
        return new CacheService({ defaultExpiration: 30 });
    }
    return __webpack_require__(614)(cacheModuleConfig);
})());

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(617)
var ieee754 = __webpack_require__(618)
var isArray = __webpack_require__(619)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createHash = __webpack_require__(89).createHash
  , toString = Object.prototype.toString;

exports.validateArg = function validateArg (args, config) {
  var err;

  args.validate.forEach(function (tokens) {
    var key = tokens[0]
      , value = args[key];

    switch(tokens[1]){
      case Number:
        if (toString.call(value) !== '[object Number]') {
          err = 'Argument "' + key + '" is not a valid Number.';
        }

        break;

      case Boolean:
        if (toString.call(value) !== '[object Boolean]') {
          err = 'Argument "' + key + '" is not a valid Boolean.';
        }

        break;

      case Array:
        if (toString.call(value) !== '[object Array]') {
          err = 'Argument "' + key + '" is not a valid Array.';
        }
        if (!err && key === 'key') {
          for (var vKey=0; vKey<value.length; vKey++) {
            var vValue = value[vKey];
            var result = validateKeySize(config, vKey, vValue);
            if (result.err) {
              err = result.err;
            } else {
              args.command = args.command.replace(vValue, result['value']);
            }
          }
        }
        break;

      case Object:
        if (toString.call(value) !== '[object Object]') {
          err = 'Argument "' + key + '" is not a valid Object.';
        }

        break;

      case Function:
        if (toString.call(value) !== '[object Function]') {
          err = 'Argument "' + key + '" is not a valid Function.';
        }

        break;

      case String:
        if (toString.call(value) !== '[object String]') {
          err = 'Argument "' + key + '" is not a valid String.';
        }

        if (!err && key === 'key') {
          var result = validateKeySize(config, key, value);
          if (result.err) {
            err = result.err;
          } else {
            args.command = reallocString(args.command).replace(value, result['value']);
          }
        }
        break;

      default:
        if (toString.call(value) === '[object global]' && !tokens[2]) {
          err = 'Argument "' + key + '" is not defined.';
        }
    }
  });

  if (err){
    if (args.callback) args.callback(new Error(err));
    return false;
  }

  return true;
};

var validateKeySize = function validateKeySize(config, key, value) {
  if (value.length > config.maxKeySize) {
    if (config.keyCompression){
      return { err: false, value: createHash('md5').update(value).digest('hex') };
    } else {
      return { err: 'Argument "' + key + '" is longer than the maximum allowed length of ' + config.maxKeySize };
    }
  } else if (/[\s\n\r]/.test(value)) {
    return { err: 'The key should not contain any whitespace or new lines' };
  } else {
    return { err: false, value: value };
  }
};

// a small util to use an object for eventEmitter
exports.fuse = function fuse (target, handlers) {
  for (var i in handlers)
    if (handlers.hasOwnProperty(i)){
      target.on(i, handlers[i]);
    }
};

// merges a object's proppertys / values with a other object
exports.merge = function merge (target, obj) {
  for (var i in obj) {
    target[i] = obj[i];
  }

  return target;
};

// curry/bind functions
exports.curry = function curry (context, fn) {
  var copy = Array.prototype.slice
    , args = copy.call(arguments, 2);

  return function bowlofcurry () {
    return fn.apply(context || this, args.concat(copy.call(arguments)));
  };
};

// a small items iterator
exports.Iterator = function iterator (collection, callback) {
  var arr = Array.isArray(collection)
    , keys = !arr ? Object.keys(collection) : false
    , index = 0
    , maximum = arr ? collection.length : keys.length
    , self = this;

  // returns next item
  this.next = function next () {
    var obj = arr ? collection[index] : { key: keys[index], value: collection[keys[index]] };
    callback(obj, index++, collection, self);
  };

  // check if we have more items
  this.hasNext = function hasNext () {
    return index < maximum;
  };
};

//Escapes values by putting backslashes before line breaks
exports.escapeValue = function(value) {
  return value.replace(/(\r|\n)/g, '\\$1');
};

//Unescapes escaped values by removing backslashes before line breaks
exports.unescapeValue = function(value) {
  return value.replace(/\\(\r|\n)/g, '$1');
};

var reallocString = exports.reallocString = function(value) {
  // Reallocate string to fix slow string operations in node 0.10
  // see https://code.google.com/p/v8/issues/detail?id=2869 for details
  return (' ' + value).substr(1);
};


/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUpsellUrlsConfigByEdition;
/**
 * getUpsellUrlsConfigByEdition - Returns the proper edition adsConfig object from the external `app-configurations`
 * JSON; defaults to an empty object for easier destructuring.
 *
 * @param {string} edition - Top level app edition obtained from editionMapping
 * @param {object} adsConfig = {} - External adsConfig object supporting multiple editions
 *
 * @return {object} - Config object containing possible properties such as `profile`, `networkId` and `host`
 */
function getUpsellUrlsConfigByEdition(edition) {
    var urlsConfigMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    // catches null or undefined
    if (!edition || !urlsConfigMap) {
        return {};
    }

    if (urlsConfigMap[edition]) {
        return urlsConfigMap[edition];
    }

    if (edition === 'us' && urlsConfigMap.domestic) {
        return urlsConfigMap.domestic;
    }

    // no mapping found from external config object
    return {};
}

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/reselect/lib/index.js
var lib = __webpack_require__(9);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./app/common/selectors/fanSelector.js
var fanSelector = __webpack_require__(91);

// CONCATENATED MODULE: ./app/lib/whitelist/index.js
var whitelistedSwids = ['{AEDB5BCC-173D-49BD-9B0B-77DFD5964C19}', // rob wong
'{CAF029A0-42FD-4A72-A3B4-225A523BB6F8}', // alex murp
'{41806771-14BA-4372-8067-7114BA137205}', // paul ferrug
'{83557C90-D1C1-48E5-BD25-C180CF1A843C}', // takashi aoki
'{3D4B6DA0-89C1-4061-93BE-4DF366407219}', // mike andrews
'{64BFB324-993C-11D2-94D2-00A0C9E596A0}', // aaron laberge
'{DC6D6CAB-31D6-47A9-B570-E388A23E82DE}', // john racz
'{340CE85D-75A3-4266-B2EA-20442C0C9DCB}', // jesse pringle
'{83CA9BE6-3078-460B-9104-BD7F202524E6}' // mike kidd
];

function isSwidInWhitelist(swid) {
    if (swid) {
        return whitelistedSwids.indexOf(swid) !== -1;
    }
    return false;
}
// CONCATENATED MODULE: ./app/common/selectors/whitelistSelector.js




/* harmony default export */ var whitelistSelector = __webpack_exports__["a"] = (Object(lib["createSelector"])(fanSelector["a" /* default */], function (_ref) {
    var id = _ref.id;
    return isSwidInWhitelist(id);
}));

/***/ }),
/* 309 */
/***/ (function(module, exports) {

/**
 * Each app results in a separate bundle
 */
module.exports = {
  WEBAPP: 'webapp',
  ESPNAPP: 'espnapp'
};

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return adSiteSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appSelector__ = __webpack_require__(3);



var adsSelector = function adsSelector(_ref) {
    var _ref$ads = _ref.ads,
        ads = _ref$ads === undefined ? {} : _ref$ads;
    return ads;
};

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(adsSelector, function (ads) {
    return ads;
}));

var adSiteSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_1__appSelector__["k" /* editionSelector */], __WEBPACK_IMPORTED_MODULE_1__appSelector__["p" /* intlAppSelector */], function (_ref2, intlApp) {
    var ad = _ref2.ad;
    return intlApp ? 'm.app.espnplay' : ad.site;
});

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(643),
    isObjectLike = __webpack_require__(59);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(204),
    arraySome = __webpack_require__(644),
    cacheHas = __webpack_require__(205);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(39);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(653),
    isArguments = __webpack_require__(111),
    isArray = __webpack_require__(32),
    isBuffer = __webpack_require__(141),
    isIndex = __webpack_require__(135),
    isTypedArray = __webpack_require__(142);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(35);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 316 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(662);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(35),
    isSymbol = __webpack_require__(128);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export adobe */
/* unused harmony export ip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_watch_authenticators__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_watch_authenticators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_watch_authenticators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enums__ = __webpack_require__(1);



var AdobePassEnv = __WEBPACK_IMPORTED_MODULE_1__enums__["a" /* AdobePass */].Env;


var ipAuthenticator = void 0;
var adobePassAuthenticator = void 0;

var adobe = function adobe(opts) {
    if (adobePassAuthenticator) {
        return adobePassAuthenticator;
    }

    if (!opts) {
        throw new Error("Must specify opts the first time Adobe Authenticator is retrieved");
    }

    adobePassAuthenticator = new __WEBPACK_IMPORTED_MODULE_0_watch_authenticators__["AdobePassAuthenticator"](opts);
    return adobePassAuthenticator;
};

var ip = function ip() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { partner: 'watchespn', platform: 'web' };

    if (ipAuthenticator) {
        return ipAuthenticator;
    }

    if (!opts) {
        throw new Error("Must specify opts the first time IP Authenticator is retrieved");
    }

    ipAuthenticator = new __WEBPACK_IMPORTED_MODULE_0_watch_authenticators__["IpAuthenticator"](opts);
    return ipAuthenticator;
};

/* harmony default export */ __webpack_exports__["a"] = ({
    adobe: adobe,
    ip: ip
});

/***/ }),
/* 320 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = assign;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    nullTag = '[object Null]',
    proxyTag = '[object Proxy]',
    undefinedTag = '[object Undefined]';

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isFunction;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PREAUTH_MAX_LENGTH */
/* unused harmony export getResources */
/* unused harmony export setResources */
/* unused harmony export clear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_localStorage__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(8);



var PREAUTH_MAX_LENGTH = 5;

function getResources() {
    var resources = Object(__WEBPACK_IMPORTED_MODULE_0__util_localStorage__["a" /* get */])(__WEBPACK_IMPORTED_MODULE_1__constants__["m" /* PREAUTH_LOCALSTORAGE_KEY */]);
    return resources;
}

// expiration in days
function setResources(resources) {
    var expiration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    Object(__WEBPACK_IMPORTED_MODULE_0__util_localStorage__["d" /* set */])(__WEBPACK_IMPORTED_MODULE_1__constants__["m" /* PREAUTH_LOCALSTORAGE_KEY */], resources, expiration * 60 * 60 * 24);
}

function clear() {
    Object(__WEBPACK_IMPORTED_MODULE_0__util_localStorage__["c" /* remove */])(__WEBPACK_IMPORTED_MODULE_1__constants__["m" /* PREAUTH_LOCALSTORAGE_KEY */]);
}

/* harmony default export */ __webpack_exports__["a"] = ({
    PREAUTH_MAX_LENGTH: PREAUTH_MAX_LENGTH,
    getResources: getResources,
    setResources: setResources,
    clear: clear
});

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(204),
    arrayIncludes = __webpack_require__(298),
    arrayIncludesWith = __webpack_require__(300),
    cacheHas = __webpack_require__(205),
    createSet = __webpack_require__(670),
    setToArray = __webpack_require__(210);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(109),
    isArrayLike = __webpack_require__(51),
    isIndex = __webpack_require__(135),
    isObject = __webpack_require__(35);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccountSelectorComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__enums__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_oneId__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_auth_streamHasDTCPackage__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_auth_shallowCheckAuthentication__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_format_addQueryToUrl__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_oneIdActions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__selectors_appSelector__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__selectors_oneIdSelector__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__selectors_authenticationSelectors__ = __webpack_require__(10);
var _AccountSelectorCompo, _AccountSelectorCompo2;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var OneIdJs = __WEBPACK_IMPORTED_MODULE_4__lib_oneId__["b" /* OneIdJs */];


var AccountSelectorComponent = function (_PureComponent) {
    _inherits(AccountSelectorComponent, _PureComponent);

    function AccountSelectorComponent(props) {
        _classCallCheck(this, AccountSelectorComponent);

        var _this = _possibleConstructorReturn(this, (AccountSelectorComponent.__proto__ || Object.getPrototypeOf(AccountSelectorComponent)).call(this, props));

        _this.state = {
            purchaseFlow: false,
            mode: AccountSelectorComponent.MODE.UNKNOWN
        };
        _this.getGuest = _this.getGuest.bind(_this);
        _this.clearGuest = _this.clearGuest.bind(_this);
        _this.onTVEClick = _this.onTVEClick.bind(_this);
        _this.onPurchaseClick = _this.onPurchaseClick.bind(_this);
        _this.onLogin = _this.onLogin.bind(_this);
        _this.onCancelClick = _this.onCancelClick.bind(_this);
        _this.processRedirect = _this.processRedirect.bind(_this);
        _this.processRedirectBySkip = _this.processRedirectBySkip.bind(_this);
        _this.navigateToESPNPlus = _this.navigateToESPNPlus.bind(_this);
        return _this;
    }

    _createClass(AccountSelectorComponent, [{
        key: 'componentDidMount',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var _props, dispatch, id, _ref2, isLoggedIn, airing;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _props = this.props, dispatch = _props.dispatch, id = _props.location.query.id;

                                __WEBPACK_IMPORTED_MODULE_4__lib_oneId__["k" /* on */]('login', this.getGuest);
                                __WEBPACK_IMPORTED_MODULE_4__lib_oneId__["k" /* on */]('logout', this.clearGuest);
                                _context.next = 5;
                                return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_oneIdActions__["g" /* checkOneIDAuthentication */])());

                            case 5:
                                _ref2 = _context.sent;
                                isLoggedIn = _ref2.isLoggedIn;

                                if (!id) {
                                    _context.next = 19;
                                    break;
                                }

                                _context.prev = 8;
                                _context.next = 11;
                                return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["u" /* getAiring */])({ id: id }));

                            case 11:
                                airing = _context.sent;

                                this.setContent(airing);
                                _context.next = 18;
                                break;

                            case 15:
                                _context.prev = 15;
                                _context.t0 = _context['catch'](8);

                                console.error(_context.t0);

                            case 18:

                                if (!isLoggedIn) {
                                    this.onLogin();
                                }

                            case 19:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[8, 15]]);
            }));

            function componentDidMount() {
                return _ref.apply(this, arguments);
            }

            return componentDidMount;
        }()
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var packages = this.state.packages;

            var notEntitledForContent = this.isNotEntitledForContent();
            var nextNotEntitledForContent = this.isNotEntitledForContent(nextProps);
            if (packages && notEntitledForContent && !nextNotEntitledForContent) {
                this.processRedirect();
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, _ref3) {
            var prevPackages = _ref3.packages;
            var packages = this.state.packages;

            if (!prevPackages && packages) {
                var notEntitledForContent = this.isNotEntitledForContent();
                if (!notEntitledForContent) {
                    this.processRedirect();
                }
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            __WEBPACK_IMPORTED_MODULE_4__lib_oneId__["j" /* off */]('login', this.getGuest);
            __WEBPACK_IMPORTED_MODULE_4__lib_oneId__["j" /* off */]('logout', this.clearGuest);
        }
    }, {
        key: 'onTVEClick',
        value: function onTVEClick() {
            var _props$location$query = this.props.location.query;
            _props$location$query = _props$location$query === undefined ? {} : _props$location$query;
            var redirectUrl = _props$location$query.redirectUrl;

            if (redirectUrl) {
                var win = window.parent !== window.self ? window.parent : window;
                win.location.href = '' + redirectUrl + (redirectUrl.indexOf('?') > -1 ? '&' : '?') + 'auth=tve';
            }
        }
    }, {
        key: 'onLogin',
        value: function onLogin() {
            var _props2 = this.props,
                dispatch = _props2.dispatch,
                isLoggedIn = _props2.isLoggedIn;

            if (isLoggedIn) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_oneIdActions__["n" /* launchReauth */])());
                return;
            }
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_oneIdActions__["m" /* launchLogin */])());
        }
    }, {
        key: 'onPurchaseClick',
        value: function onPurchaseClick() {
            // eslint-disable-line
            alert('Purchase flow'); // eslint-disable-line no-alert
        }
    }, {
        key: 'onCancelClick',
        value: function onCancelClick() {
            this.navigateToESPNPlus();
        }
    }, {
        key: 'setContent',
        value: function setContent() {
            var airing = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var packages = airing.packages && airing.packages.map(function (_ref4) {
                var name = _ref4.name;
                return name;
            });
            if (!packages) {
                return;
            }
            console.log('ariging', airing); // eslint-disable-line no-console
            this.setState({ packages: packages });
        }
    }, {
        key: 'getMode',
        value: function getMode() {
            var mode = AccountSelectorComponent.MODE.UNKNOWN;
            var packages = this.state.packages;
            var _props3 = this.props,
                _props3$location$quer = _props3.location.query,
                modeArg = _props3$location$quer.mode,
                isMatchup = _props3$location$quer.matchup,
                entitlements = _props3.entitlements;

            if (modeArg !== undefined) {
                // override
                mode = parseInt(modeArg, 10);
            } else if (packages) {
                var hasMLB = Object(__WEBPACK_IMPORTED_MODULE_5__lib_auth_streamHasDTCPackage__["a" /* default */])({ packages: packages }, __WEBPACK_IMPORTED_MODULE_3__enums__["s" /* Entitlements */].ESPN_PLUS_MLB);
                var isVertical = hasMLB || Object(__WEBPACK_IMPORTED_MODULE_5__lib_auth_streamHasDTCPackage__["a" /* default */])({ packages: packages }, __WEBPACK_IMPORTED_MODULE_3__enums__["s" /* Entitlements */].ESPN_PLUS_NHL);
                var hasESPNPlusBase = entitlements && entitlements.indexOf(__WEBPACK_IMPORTED_MODULE_3__enums__["s" /* Entitlements */].ESPN_PLUS) > -1;

                if (!isVertical) {
                    if (isMatchup) {
                        // TODO: how do we know from graphql response that the steream is matchup?
                        mode = AccountSelectorComponent.MODE.PURCHASE_BASE_MATCHUP;
                    } else {
                        mode = AccountSelectorComponent.MODE.PURCHASE_BASE;
                    }
                } else if (!hasMLB) {
                    mode = AccountSelectorComponent.MODE.PURCHASE_NHL;
                } else if (hasESPNPlusBase) {
                    mode = AccountSelectorComponent.MODE.PURCHASE_MLB_ADDON;
                } else {
                    mode = AccountSelectorComponent.MODE.PURCHASE_MLB_BUNDLE;
                }
            }

            return mode;
        }
    }, {
        key: 'getGuest',
        value: function getGuest() {
            this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_oneIdActions__["g" /* checkOneIDAuthentication */])());
        }
    }, {
        key: 'clearGuest',
        value: function clearGuest() {
            return this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_oneIdActions__["i" /* clearGuest */])());
        }
    }, {
        key: 'processRedirect',
        value: function processRedirect() {
            var isSkip = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            var _props$location$query2 = this.props.location.query;
            _props$location$query2 = _props$location$query2 === undefined ? {} : _props$location$query2;
            var redirectUrl = _props$location$query2.redirectUrl;

            if (redirectUrl) {
                var win = window.parent !== window.self ? window.parent : window;
                win.location.href = '' + redirectUrl + (isSkip ? '&bypassAuth=true' : '');
            }
        }
    }, {
        key: 'processRedirectBySkip',
        value: function processRedirectBySkip() {
            // this.processRedirect(true);
            this.navigateToESPNPlus();
        }
    }, {
        key: 'navigateToESPNPlus',
        value: function navigateToESPNPlus() {
            var _props$location$query3 = this.props.location.query,
                query = _props$location$query3 === undefined ? {} : _props$location$query3;

            var newQuery = {};
            if (query[__WEBPACK_IMPORTED_MODULE_3__enums__["t" /* Flags */].ONEID_ENV] === __WEBPACK_IMPORTED_MODULE_3__enums__["x" /* OneIdEnv */].STAGING) {
                newQuery.debug = true;
                newQuery.disneyid = 'stg';
            }
            var win = window.parent !== window.self ? window.parent : window;
            win.location.href = Object(__WEBPACK_IMPORTED_MODULE_7__lib_format_addQueryToUrl__["a" /* default */])(window.location.origin + '/watch/espnplus', newQuery);
        }
    }, {
        key: 'isNotEntitledForContent',
        value: function isNotEntitledForContent() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
            var packages = this.state.packages;
            var userAuth = props.userAuth;


            var authTypes = [__WEBPACK_IMPORTED_MODULE_3__enums__["e" /* AuthTypes */].BAM];
            if (!packages) {
                return true;
            }
            var ESPNPlusAuthentication = Object(__WEBPACK_IMPORTED_MODULE_6__lib_auth_shallowCheckAuthentication__["a" /* checkESPNPlusAuthentication */])({ authTypes: authTypes, packages: packages }, userAuth);

            return !ESPNPlusAuthentication;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props4 = this.props,
                oneIdEnv = _props4.oneIdEnv,
                isLoggedIn = _props4.isLoggedIn,
                oneIdData = _props4.oneIdData,
                entitlements = _props4.entitlements;


            var mode = this.getMode();
            var notEntitledForContent = this.isNotEntitledForContent();
            var modeKnown = mode !== AccountSelectorComponent.MODE.UNKNOWN;
            var title = AccountSelectorComponent.TITLE[mode];
            var label = AccountSelectorComponent.LABEL[mode];
            var entitlementsInfo = entitlements && entitlements.length ? '(' + entitlements.join(',') + ')' : '(No entitlements)';
            var loginLabel = isLoggedIn ? _jsx('span', {
                className: 'login-label'
            }, void 0, 'Hi, ', _jsx('a', {
                className: 'login-btn',
                onClick: this.onLogin
            }, void 0, oneIdData.profile.firstName), entitlementsInfo) : _jsx('span', {
                className: 'login-label'
            }, void 0, _jsx('a', {
                className: 'login-btn',
                onClick: this.onLogin
            }, void 0, 'Log In'));

            return _jsx('div', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_helmet___default.a, {
                meta: [{ name: 'robots', content: 'noindex, nofollow' }],
                script: [{
                    src: OneIdJs[oneIdEnv]
                }],
                style: [{
                    cssText: '\n                            body {\n                                background: url(https://secure.espncdn.com/redesign/assets/img/dtc/auth-bg-1280x728.png) no-repeat;\n                                background-attachment: fixed;\n                                background-size: cover;\n                                min-height: 100vh;\n                                margin: 0;\n                                color: #fff;\n                                font-family: SFProText, sans-serif;\n                                text-align: center;\n                            }\n\n                            .account-selector {\n                                margin: 0 auto;\n                                padding: 0 0 0 50px;\n                            }\n                            .selection-wrap {\n                                margin: 0 auto;\n                            }\n                            .account-selector .title {\n                                font-size: 48px;\n                            }\n                            .account-selector button {\n                                display: inline-block;\n                                padding: 10px 20px;\n                                border: none;\n                                font-size: 16px;\n                                color: #fff;\n                                text-align: center;\n                                text-shadow: 0 1px 0 rgba(198, 132, 6, 0.5);\n                                width: 250px;\n                                height: 48px;\n                                border-radius: 100px;\n                                background-image: linear-gradient(to top, #cc8804, #eba114 46%, #f9b300);\n                                margin: 0 5px 20px 5px;\n                                cursor: pointer;\n                            }\n                            .account-selector button.tve-btn {\n                                display: block;\n                                margin: 0 auto 10px auto;\n                                background-image: linear-gradient(to bottom, #0f73d7, #0066cc 47%, #045cb4);\n                            }\n                            .account-selector button.eplus-btn {\n                                display: block;\n                                margin: 0 auto 10px auto;\n                            }\n                            .account-selector a {\n                                color: #f9b300;\n                                cursor: pointer;\n                                margin-right: 20px;\n                            }\n                            .account-selector .head-section {\n                                height: 50px;\n                                padding-top: 28px;\n                            }\n\n                            .account-selector .head-section .logo {\n                                float: left;\n                                width: 100px;\n                                height: auto;\n                            }\n                            .account-selector .head-section .login-label {\n                                float: right;\n                                margin-right: 20px;\n                            }\n                            .account-selector .head-section .login-btn {\n                                margin-right: 0;\n                            }\n                            .account-selector .head-section .login-btn:hover {\n                                text-decoration: underline;\n                            }\n                        '
                }]
            }), modeKnown && _jsx('div', {
                className: 'account-selector'
            }, void 0, _jsx('section', {
                className: 'head-section'
            }, void 0, _jsx('a', {
                onClick: this.navigateToESPNPlus
            }, void 0, _jsx('img', {
                className: 'logo',
                src: 'https://secure.espncdn.com/espn360/images/affiliates/svg/ESPN_PLUS/ESPN-PLUS_CLR-NEG.svg',
                alt: 'ESPN+'
            })), loginLabel), _jsx('h1', {
                className: 'title'
            }, void 0, title), _jsx('section', {
                className: 'selection-wrap'
            }, void 0, mode === AccountSelectorComponent.MODE.ACCOUNT_SELECTOR && _jsx('div', {}, void 0, _jsx('button', {
                className: 'tve-btn',
                onClick: this.onTVEClick
            }, void 0, 'Log In with TV Provider'), _jsx('button', {
                className: 'eplus-btn',
                onClick: this.onLogin
            }, void 0, 'Log In to ESPN Account'), _jsx('button', {
                className: 'eplus-btn',
                onClick: this.onPurchaseClick
            }, void 0, label)), notEntitledForContent && _jsx('div', {}, void 0, _jsx('button', {
                onClick: this.onPurchaseClick
            }, void 0, label), _jsx('a', {
                onClick: this.processRedirectBySkip,
                style: { marginLeft: 20 }
            }, void 0, 'Skip Purchase')))));
        }
    }]);

    return AccountSelectorComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

AccountSelectorComponent.MODE = {
    UNKNOWN: -1,
    ACCOUNT_SELECTOR: 0,
    PURCHASE_NHL: 1,
    PURCHASE_MLB_BUNDLE: 2,
    PURCHASE_MLB_ADDON: 3,
    PURCHASE_BASE: 4,
    PURCHASE_BASE_MATCHUP: 5
};

AccountSelectorComponent.TITLE = (_AccountSelectorCompo = {}, _defineProperty(_AccountSelectorCompo, AccountSelectorComponent.MODE.UNKNOWN, ''), _defineProperty(_AccountSelectorCompo, AccountSelectorComponent.MODE.ACCOUNT_SELECTOR, 'Account Selector'), _defineProperty(_AccountSelectorCompo, AccountSelectorComponent.MODE.PURCHASE_NHL, 'Add NHL.TV to ESPN+'), _defineProperty(_AccountSelectorCompo, AccountSelectorComponent.MODE.PURCHASE_MLB_BUNDLE, 'MLB.TV & ESPN+'), _defineProperty(_AccountSelectorCompo, AccountSelectorComponent.MODE.PURCHASE_MLB_ADDON, 'Add MLB.TV to ESPN+'), _defineProperty(_AccountSelectorCompo, AccountSelectorComponent.MODE.PURCHASE_BASE, 'More Sports. More Leagues.'), _defineProperty(_AccountSelectorCompo, AccountSelectorComponent.MODE.PURCHASE_BASE_MATCHUP, 'Matchup Paywall'), _AccountSelectorCompo);

AccountSelectorComponent.LABEL = (_AccountSelectorCompo2 = {}, _defineProperty(_AccountSelectorCompo2, AccountSelectorComponent.MODE.UNKNOWN, ''), _defineProperty(_AccountSelectorCompo2, AccountSelectorComponent.MODE.ACCOUNT_SELECTOR, 'Start My 7 Day Trial'), _defineProperty(_AccountSelectorCompo2, AccountSelectorComponent.MODE.PURCHASE_NHL, '$24.99/monthly'), _defineProperty(_AccountSelectorCompo2, AccountSelectorComponent.MODE.PURCHASE_MLB_BUNDLE, '$29.98/monthly'), _defineProperty(_AccountSelectorCompo2, AccountSelectorComponent.MODE.PURCHASE_MLB_ADDON, '$29.98/monthly'), _defineProperty(_AccountSelectorCompo2, AccountSelectorComponent.MODE.PURCHASE_BASE, '$4.99/monthly'), _defineProperty(_AccountSelectorCompo2, AccountSelectorComponent.MODE.PURCHASE_BASE_MATCHUP, 'Start My 7 Day Trial'), _AccountSelectorCompo2);

var mapStateToProps = function mapStateToProps(state) {
    var oneIdState = Object(__WEBPACK_IMPORTED_MODULE_11__selectors_oneIdSelector__["a" /* default */])(state);
    return {
        oneIdEnv: Object(__WEBPACK_IMPORTED_MODULE_10__selectors_appSelector__["y" /* oneIdEnvSelector */])(state),
        isLoggedIn: Object(__WEBPACK_IMPORTED_MODULE_11__selectors_oneIdSelector__["f" /* oneIdLoggedInSelector */])(state),
        entitlements: Object(__WEBPACK_IMPORTED_MODULE_11__selectors_oneIdSelector__["d" /* oneIdEntitlementsSelector */])(state),
        oneIdData: oneIdState && oneIdState.data,
        userAuth: Object(__WEBPACK_IMPORTED_MODULE_12__selectors_authenticationSelectors__["r" /* userAuthSelector */])(state)
    };
};

/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(AccountSelectorComponent));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDeviceTypeFromUA;
function getDeviceTypeFromUA() {
    var device = null;
    if (typeof window !== 'undefined') {
        var _window = window,
            navigator = _window.navigator;

        if (typeof navigator !== 'undefined') {
            var _navigator$userAgent = navigator.userAgent,
                userAgent = _navigator$userAgent === undefined ? '' : _navigator$userAgent;

            var lowerUa = userAgent.toLowerCase();

            device = 'unknown';
            if (lowerUa.match(/windows phone/) || lowerUa.match(/windows/) && lowerUa.match(/tablet/)) {
                device = 'windowsphone';
            } else if (userAgent.match(/iPad/i) || userAgent.match(/iP(od|hone)/i)) {
                device = 'ios';
            } else if (userAgent.match(/Android/i)) {
                device = "android";
            }
        }
    }
    return device;
}

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isSafariBrowser;
function isSafariBrowser() {
    var isSafari = false;
    if (typeof window !== 'undefined' && window.navigator) {
        var _window = window,
            navigator = _window.navigator;

        isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') == -1 && navigator.userAgent.indexOf('FxiOS') == -1;
    }

    return isSafari;
}

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAndroidVersionFromUserAgent;
function getAndroidVersionFromUserAgent() {
    var androidVersion = void 0;
    if (typeof window !== 'undefined') {
        var userAgent = window.navigator.userAgent;

        if (userAgent.indexOf("Android") >= 0) {
            androidVersion = parseFloat(userAgent.slice(userAgent.indexOf("Android") + 8));
        }
    }
    return androidVersion;
};

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sortByRank;
/**
 * sortByRank - Utilizes the rank object property to sort in ascending order.
 *
 * @param {Object} firstElement - First object to compare via rank property
 * @param {Object} secondElement - Second object to compare via rank property
 *
 * @return {Integer} - Returns the proper integer value to sort elements.
 */
function sortByRank(firstElement, secondElement) {
  var firstRank = firstElement.rank;
  var secondRank = secondElement.rank;

  return firstRank === secondRank ? 0 : firstRank < secondRank ? -1 : 1; // eslint-disable-line no-nested-ternary
}

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAdsConfigByEdition;
/**
 * getAdsConfigByEdition - Returns the proper edition adsConfig object from the external `app-configurations`
 * JSON; defaults to an empty object for easier destructuring.
 *
 * @param {string} edition - Top level app edition obtained from editionMapping
 * @param {object} adsConfig = {} - External adsConfig object supporting multiple editions
 *
 * @return {object} - Config object mapped to `edition`
 */
function getAdsConfigByEdition(edition) {
    var adsConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    // catches null or undefined
    if (!edition || !adsConfig) {
        return {};
    }

    if (adsConfig[edition]) {
        return adsConfig[edition];
    }

    if (edition === 'us' && adsConfig.domestic) {
        return adsConfig.domestic;
    }

    // no mapping found from external config object
    return {};
}

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getPrerollConfigByEdition;
/**
 * getPrerollConfigByEdition - Returns the proper edition prerollConfig object from the external `app-configurations`
 * JSON; defaults to an empty object for easier destructuring.
 *
 * @param {string} edition - edition obtained from editionSelector()
 * @param {object} prerollConfig = {} - External app-configurations prerollConfig object supporting
 * multiple editions
 *
 * @return {object} - Config object containing contentType rules (`intervals`, `savePrerollHistory`)
 */
function getPrerollConfigByEdition(edition) {
    var prerollConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    // catches null or undefined
    if (!edition || !prerollConfig) {
        return {};
    }

    if (prerollConfig && prerollConfig[edition] && prerollConfig[edition].contentTypeRules) {
        return prerollConfig[edition].contentTypeRules;
    }

    return {};
}

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAdsConfigByAdProvider;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * getAdsConfigByAdProvider - Returns the proper adsConfig object from the external `app-configurations`
 * JSON containing Ad Provider specific properties; defaults to an empty object for easier destructuring.
 *
 * @param {string} provider - Video Ads Provider either `freewheel` or `google`
 * @param {object} adsConfig - External adsConfig object supporting multiple editions
 *
 * @return {object} - Config object containing client specific properties for `freewheel` or `google`
 */
function getAdsConfigByAdProvider(provider, adsConfig) {
    var activeAdProvider = provider || adsConfig && adsConfig.activeAdProvider;
    var config = adsConfig || {};
    var defaultProvider = 'google';

    if (activeAdProvider && config[activeAdProvider]) {
        return _extends({
            activeAdProvider: activeAdProvider
        }, config, config[activeAdProvider]);
    }

    // Safety to ensure we return `freewheel` as the default
    if (config[defaultProvider]) {
        return _extends({
            activeAdProvider: defaultProvider
        }, config, config[defaultProvider]);
    }

    return {};
}

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hasTier;
function hasTier() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        tier = _ref.tier;

    var tierType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    return typeof tier === 'string' && tierType !== '' && tier.trim().toLowerCase() === tierType;
}

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hasObj;
function hasObj(obj, strProps) {
  var props = strProps.split('.');
  for (var i = 0, l = props.length; i < l; i++) {
    if (!obj || !obj.hasOwnProperty(props[i])) {
      return false;
    }
    obj = obj[props[i]];
  }
  return true;
}

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./app/lib/url-adapter/isStitcherUrl.js
function isStitcherUrl() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    return url.indexOf('/stitcher/') !== -1;
}
// CONCATENATED MODULE: ./app/lib/url-adapter/isArtworkUrl.js


function isArtworkUrl() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    return url.indexOf('artwork.') !== -1 && !isStitcherUrl(url);
}
// CONCATENATED MODULE: ./app/lib/url-adapter/isCombinerUrl.js


function isCombinerUrl() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    return url.indexOf('/combiner/') !== -1 && !isStitcherUrl(url);
}
// CONCATENATED MODULE: ./app/lib/url-adapter/canUseCombiner.js
function canUseCombiner() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    return url.indexOf('espncdn.com') !== -1;
}
// EXTERNAL MODULE: ./app/lib/format/queryString.js
var queryString = __webpack_require__(18);

// CONCATENATED MODULE: ./app/lib/url-adapter/index.js
/* unused harmony export toSecureCombinerUrl */
/* unused harmony export convertToCombinerUrl */
/* unused harmony export convertToCombinerQueryString */
/* harmony export (immutable) */ __webpack_exports__["b"] = removeDimensions;
/* unused harmony export removeParam */
/* harmony export (immutable) */ __webpack_exports__["a"] = getImageUrlWithParams;
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







// This is the threshold in which we shouldn't request a resized image, but the natural one instead

var NATURAL_THRESHOLD = 1800;

function toSecureCombinerUrl(url) {
    if (isCombinerUrl(url)) {
        return url.replace('http://a.espncdn.com', 'https://secure.espncdn.com');
    }
    return url;
}

/**
 * Converts an eligible url to a combiner url
 * @param {string} url
 */
function convertToCombinerUrl(url) {
    if (url && !isCombinerUrl(url) && !isStitcherUrl(url)) {
        return url.replace(/(http:\/\/a\.espncdn\.com|https:\/\/secure\.espncdn\.com)/, 'https://secure.espncdn.com/combiner/i?img=');
    }
    // TODO: remove once page api starts to return secure combiner url
    return toSecureCombinerUrl(url);
}

/**
 * For now, the only params to replace are width and height.  If more params are needed, a more algorithmic
 * approach should be used
 * @param {string} query - Query string
 */
function convertToCombinerQueryString(query) {
    return query.replace('width=', 'w=').replace('height=', 'h=');
}

/**
 * Removes all sizing dimension parameters from an image
 * @param {string} url
 */
function removeDimensions(url) {
    if (url && typeof url === 'string') {
        return url.replace(/(?:width|height|[wh])=\d*&?/g, '');
    }
    return url;
}

/**
 * Removes a given parameter from the url
 * @param {string} url
 * @param {string} param
 */
function removeParam() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var param = arguments[1];

    if (param) {
        var paramRegex = new RegExp(param + '=[a-zA-Z0-9_]*', 'g');
        return url.replace(paramRegex, '');
    }
    return url;
}

/**
 * This function will replace/remove dimensions of an image if specified in params.
 * It will also add any other params specified.
 * Note: This will add any parameters that are not height/width dimensions
 * @param {string} urlArg
 * @param {object} params - Supports { width, cquality, height }
 */
function getImageUrlWithParams(urlArg) {
    var paramsArg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!isArtworkUrl(urlArg) && !canUseCombiner(urlArg)) {
        return urlArg;
    }
    var url = !isArtworkUrl(urlArg) ? convertToCombinerUrl(urlArg) : urlArg;

    var params = paramsArg;
    var _params = params,
        width = _params.width,
        height = _params.height;

    // if the dimensions are altered, remove all existing dimension params

    if (width || height) {
        url = removeDimensions(url);

        // if the width of the image is larger than a defined threshold, just use the natural image
        if (isCombinerUrl(url) && width >= NATURAL_THRESHOLD) {
            // remove width by destructure and spread
            var _params2 = params,
                omittedWidth = _params2.width,
                cleansedParams = _objectWithoutProperties(_params2, ['width']);

            params = cleansedParams;
        }
    }

    var qs = Object(queryString["a" /* default */])(params, false, url.indexOf('?') > -1);
    if (isCombinerUrl(url)) {
        qs = convertToCombinerQueryString(qs);
    }
    return '' + url + qs;
}

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlMessageFormat = __webpack_require__(693)['default'];

// Add all locale data to `IntlMessageFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(700);

// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlMessageFormat;
exports['default'] = exports;


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports.extend = extend;
var hop = Object.prototype.hasOwnProperty;

function extend(obj) {
    var sources = Array.prototype.slice.call(arguments, 1),
        i, len, source, key;

    for (i = 0, len = sources.length; i < len; i += 1) {
        source = sources[i];
        if (!source) { continue; }

        for (key in source) {
            if (hop.call(source, key)) {
                obj[key] = source[key];
            }
        }
    }

    return obj;
}
exports.hop = hop;

//# sourceMappingURL=utils.js.map

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(4);

// EXTERNAL MODULE: ./app/webapp/page/buckets/BucketHeaderContainer.js + 1 modules
var BucketHeaderContainer = __webpack_require__(339);

// EXTERNAL MODULE: ./app/common/injectIntl.js
var injectIntl = __webpack_require__(20);

// EXTERNAL MODULE: ./app/common/selectors/bootstrapSelector.js
var bootstrapSelector = __webpack_require__(29);

// EXTERNAL MODULE: ./app/common/selectors/appSelector.js + 1 modules
var appSelector = __webpack_require__(3);

// EXTERNAL MODULE: ./app/common/selectors/pageSelector.js
var pageSelector = __webpack_require__(13);

// EXTERNAL MODULE: ./app/common/selectors/heroSelector.js
var heroSelector = __webpack_require__(56);

// EXTERNAL MODULE: ./app/common/selectors/analyticsSelectors.js
var analyticsSelectors = __webpack_require__(54);

// EXTERNAL MODULE: ./node_modules/reselect/lib/index.js
var lib = __webpack_require__(9);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./app/common/selectors/scheduleModuleBucketsSelector.js


var scheduleModuleSelector = function scheduleModuleSelector(_ref) {
    var _ref$scheduleModule = _ref.scheduleModule,
        scheduleModule = _ref$scheduleModule === undefined ? {} : _ref$scheduleModule;
    return scheduleModule;
};

/* harmony default export */ var scheduleModuleBucketsSelector = (Object(lib["createSelector"])(scheduleModuleSelector, function (_ref2) {
    var _ref2$buckets = _ref2.buckets,
        buckets = _ref2$buckets === undefined ? [] : _ref2$buckets;
    return buckets;
}));

var scheduleModuleNameSelector = Object(lib["createSelector"])(scheduleModuleSelector, function (_ref3) {
    var _ref3$name = _ref3.name,
        name = _ref3$name === undefined ? 'scheduleModule' : _ref3$name;
    return name;
});
// EXTERNAL MODULE: ./app/enums.js
var enums = __webpack_require__(1);

// EXTERNAL MODULE: ./app/common/Logo.js
var Logo = __webpack_require__(219);

// EXTERNAL MODULE: ./app/lib/omniture/index.js
var omniture = __webpack_require__(34);

// CONCATENATED MODULE: ./app/common/selectors/appBaseUrlSelector.js



/* harmony default export */ var appBaseUrlSelector = (Object(lib["createSelector"])(appSelector["j" /* default */], function (_ref) {
    var _ref$location = _ref.location,
        location = _ref$location === undefined ? {} : _ref$location;
    var host = location.host,
        protocol = location.protocol,
        baseUrl = location.baseUrl;

    return protocol + '://' + host + baseUrl;
}));
// EXTERNAL MODULE: ./app/lib/format/queryString.js
var queryString = __webpack_require__(18);

// EXTERNAL MODULE: ./app/common/selectors/routingSelector.js
var routingSelector = __webpack_require__(23);

// CONCATENATED MODULE: ./app/common/selectors/currentUrlSelector.js





/* harmony default export */ var currentUrlSelector = (Object(lib["createSelector"])(appSelector["j" /* default */], routingSelector["a" /* default */], function (_ref, _ref2) {
    var _ref$location = _ref.location,
        location = _ref$location === undefined ? {} : _ref$location;
    var _ref2$locationBeforeT = _ref2.locationBeforeTransitions,
        locationBeforeTransitions = _ref2$locationBeforeT === undefined ? {} : _ref2$locationBeforeT;
    var host = location.host,
        protocol = location.protocol,
        baseUrl = location.baseUrl,
        origQuery = location.query;

    var _ref3 = locationBeforeTransitions || {},
        _ref3$basename = _ref3.basename,
        basename = _ref3$basename === undefined ? baseUrl : _ref3$basename,
        _ref3$pathname = _ref3.pathname,
        pathname = _ref3$pathname === undefined ? '/' : _ref3$pathname,
        _ref3$query = _ref3.query,
        query = _ref3$query === undefined ? origQuery : _ref3$query;

    return protocol + '://' + host + basename + pathname + Object(queryString["a" /* default */])(query);
}));
// EXTERNAL MODULE: ./app/common/selectors/providerSelector.js
var providerSelector = __webpack_require__(53);

// EXTERNAL MODULE: ./app/common/selectors/authenticationSelectors.js
var authenticationSelectors = __webpack_require__(10);

// CONCATENATED MODULE: ./app/common/social/EmailShare.js
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();





var shareBaseUrl = 'mailto:';

var EmailShare_EmailShare = function EmailShare(_ref) {
    var appBaseUrl = _ref.appBaseUrl,
        content = _ref.content;
    var id = content.id,
        subject = content.name;

    var query = Object(queryString["a" /* default */])({
        body: appBaseUrl + '?id=' + id,
        subject: subject
    }, true);
    var shareUrl = '' + shareBaseUrl + query;

    return _jsx('a', {
        className: 'btn-social sm icon-font-before icon-email-solid-before',
        'data-notrack': 'true',
        'data-route': 'false',
        href: shareUrl
    });
};

/* harmony default export */ var social_EmailShare = (EmailShare_EmailShare);
// CONCATENATED MODULE: ./app/common/social/FacebookShare.js
var FacebookShare__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();





var FacebookShare_shareBaseUrl = 'https://www.facebook.com/sharer/sharer.php';

var FacebookShare_FacebookShare = function FacebookShare(_ref) {
    var appBaseUrl = _ref.appBaseUrl,
        content = _ref.content,
        lang = _ref.lang,
        country = _ref.country;
    var id = content.id,
        title = content.name;

    var langParam = lang && lang !== '' ? '&lang=' + lang : '';
    var countryParam = country && country !== '' ? '&country=' + country.toLowerCase() : '';
    var query = Object(queryString["a" /* default */])({
        title: title,
        u: appBaseUrl + '?id=' + id + langParam + countryParam
    }, true);
    var shareUrl = '' + FacebookShare_shareBaseUrl + query;

    return FacebookShare__jsx('a', {
        className: 'btn-social sm icon-font-before icon-facebook-solid-before',
        'data-notrack': 'true',
        'data-route': 'false',
        href: shareUrl
    });
};

/* harmony default export */ var social_FacebookShare = (FacebookShare_FacebookShare);
// CONCATENATED MODULE: ./app/common/social/TwitterShare.js
var TwitterShare__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();





var TwitterShare_shareBaseUrl = 'https://twitter.com/intent/tweet';

var TwitterShare_TwitterShare = function TwitterShare(_ref) {
    var appBaseUrl = _ref.appBaseUrl,
        content = _ref.content,
        currentUrl = _ref.currentUrl;
    var id = content.id,
        text = content.name;

    var query = Object(queryString["a" /* default */])({
        lang: 'en',
        original_referer: currentUrl,
        text: text,
        url: appBaseUrl + '?id=' + id
    }, true);
    var shareUrl = '' + TwitterShare_shareBaseUrl + query;

    return TwitterShare__jsx('a', {
        className: 'btn-social sm icon-font-before icon-twitter-solid-before',
        'data-notrack': 'true',
        'data-route': 'false',
        href: shareUrl
    });
};

/* harmony default export */ var social_TwitterShare = (TwitterShare_TwitterShare);
// CONCATENATED MODULE: ./app/common/social/SharePalette.js
var SharePalette__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint react/no-unused-prop-types: 0 */














var shareOutlets = [{ key: 'email', Component: social_EmailShare }, { key: 'facebook', Component: social_FacebookShare }, { key: 'twitter', Component: social_TwitterShare }];

// curry the tracking to bind to presentational click handlers
var SharePalette_generateClickHandler = function generateClickHandler(content, page, provider, socialPlatform, userAuth, entitlementsTracking, isDomestic) {
    return function (event) {
        if (event.preventDefault) {
            event.preventDefault();
        }

        Object(omniture["r" /* trackSocialShareClick */])(content, page, provider, socialPlatform, userAuth, entitlementsTracking, isDomestic);
    };
};

/**
 * The pageShell provided JS provides share functionality, by binding click handlers to the rendered DOM of this components.
 * The implementation of share functionality pprevents React Synthetic Events from firing. As a result, we are maintaining
 * event listeners on the references to the DOM elements.
 *
 * Here is the external JavaScript from the pageShell: https://code.espn.com/webdev/score/blob/develop/static/js/helpers/social_clicks.js
 */

var SharePalette_SharePalette = function (_Component) {
    _inherits(SharePalette, _Component);

    function SharePalette(props) {
        _classCallCheck(this, SharePalette);

        var _this = _possibleConstructorReturn(this, (SharePalette.__proto__ || Object.getPrototypeOf(SharePalette)).call(this, props));

        _this.clickHandlers = {}; // reference to click handlers so we may unbind
        _this.removeClickHandlers = _this.removeClickHandlers.bind(_this);
        _this.setupClickHandlers = _this.setupClickHandlers.bind(_this);
        return _this;
    }

    _createClass(SharePalette, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setupClickHandlers();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            // update event listeners with latest data from store
            this.removeClickHandlers();
            this.setupClickHandlers(nextProps);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.removeClickHandlers();
        }
    }, {
        key: 'setupClickHandlers',
        value: function setupClickHandlers() {
            var _this2 = this;

            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
            var content = props.content,
                page = props.page,
                provider = props.provider,
                userAuth = props.userAuth,
                entitlementsTracking = props.entitlementsTracking,
                isDomestic = props.isDomestic;

            shareOutlets.forEach(function (outlet) {
                _this2.clickHandlers[outlet.key] = SharePalette_generateClickHandler(content, page, provider, outlet.key, userAuth, entitlementsTracking, isDomestic);
                _this2.refs[outlet.key].addEventListener('click', _this2.clickHandlers[outlet.key]);
            });
        }
    }, {
        key: 'removeClickHandlers',
        value: function removeClickHandlers() {
            var _this3 = this;

            Object.keys(this.clickHandlers).forEach(function (key) {
                _this3.refs[key].removeEventListener('click', _this3.clickHandlers[key]);
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            return SharePalette__jsx('div', {
                className: 'shareMenu',
                style: { display: this.props.intlApp ? 'none' : 'block' }
            }, void 0, SharePalette__jsx('span', {
                className: 'shareMenu__toggle icon-font-after icon-share-solid-after'
            }), SharePalette__jsx('ul', {
                className: 'shareMenu__list'
            }, void 0, shareOutlets.map(function (outlet) {
                return react_default.a.createElement(
                    'li',
                    { ref: outlet.key, key: 'social-share-' + outlet.key },
                    react_default.a.createElement(outlet.Component, _this4.props)
                );
            })));
        }
    }]);

    return SharePalette;
}(react["Component"]);

var SharePalette_mapStateToProps = function mapStateToProps(state) {
    return {
        appBaseUrl: appBaseUrlSelector(state),
        currentUrl: currentUrlSelector(state),
        country: Object(appSelector["h" /* countrySelector */])(state),
        page: Object(pageSelector["c" /* default */])(state),
        provider: Object(providerSelector["a" /* default */])(state),
        userAuth: Object(authenticationSelectors["r" /* userAuthSelector */])(state),
        entitlementsTracking: Object(analyticsSelectors["c" /* entitlementsTrackingSelector */])(state),
        intlApp: Object(appSelector["p" /* intlAppSelector */])(state),
        lang: Object(appSelector["q" /* intlSelector */])(state).lang,
        isDomestic: Object(appSelector["s" /* isDomesticSelector */])(state)
    };
};

/* harmony default export */ var social_SharePalette = (Object(es["b" /* connect */])(SharePalette_mapStateToProps)(SharePalette_SharePalette));
// EXTERNAL MODULE: ./app/webapp/alert/UpcomingAlert.js + 1 modules
var UpcomingAlert = __webpack_require__(340);

// EXTERNAL MODULE: ./app/webapp/common/playable.js + 2 modules
var playable = __webpack_require__(64);

// EXTERNAL MODULE: ./app/lib/format/getMinutesUntilStart.js
var getMinutesUntilStart = __webpack_require__(202);

// EXTERNAL MODULE: ./app/lib/format/dateFormat.js
var dateFormat = __webpack_require__(33);

// CONCATENATED MODULE: ./app/webapp/scheduleModule/ScheduleEventCard.js
var ScheduleEventCard__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var ScheduleEventCard__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ScheduleEventCard__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ScheduleEventCard__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ScheduleEventCard__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var DEFAULT_DISPLAY_ALERT_UNTIL = 30; // minutes prior to the event startTime
var IS_BLACKED_OUT_MESSAGE = 'Not available in your area';

var ScheduleEventCard_ScheduleEventCard = function (_Component) {
    ScheduleEventCard__inherits(ScheduleEventCard, _Component);

    function ScheduleEventCard(props) {
        ScheduleEventCard__classCallCheck(this, ScheduleEventCard);

        var _this = ScheduleEventCard__possibleConstructorReturn(this, (ScheduleEventCard.__proto__ || Object.getPrototypeOf(ScheduleEventCard)).call(this, props));

        _this.state = {
            displayAlert: false
        };
        _this.toggleAlert = _this.toggleAlert.bind(_this);
        return _this;
    }

    ScheduleEventCard__createClass(ScheduleEventCard, [{
        key: 'getAlertEl',
        value: function getAlertEl(displayTime) {
            var content = this.props.content;

            if (this.state.displayAlert) {
                return ScheduleEventCard__jsx(UpcomingAlert["a" /* default */], {
                    align: 'center',
                    animation: 'slide',
                    content: content,
                    displayTime: displayTime,
                    onClick: this.toggleAlert,
                    onClose: this.toggleAlert
                });
            }
            return null;
        }
    }, {
        key: 'getDisplayTime',
        value: function getDisplayTime() {
            var _props = this.props,
                utc = _props.content.utc,
                dateFormatStr = _props.dateFormat,
                userLocation = _props.userLocation,
                nextDayString = _props.nextDayString;

            var timeZone = userLocation && userLocation.timeZone;

            return dateFormat["a" /* default */].getDateTimeString(utc, dateFormatStr, timeZone, 'schedule-event', nextDayString);
        }
    }, {
        key: 'shouldAlertOnClick',
        value: function shouldAlertOnClick() {
            var _props2 = this.props,
                content = _props2.content,
                alertThreshold = _props2.alertThreshold;

            if (content.status === enums["n" /* ContentStatus */].UPCOMING) {
                var minUntilStart = Object(getMinutesUntilStart["a" /* default */])(content);
                return minUntilStart <= 0 || minUntilStart >= alertThreshold;
            }
            return false;
        }
    }, {
        key: 'toggleAlert',
        value: function toggleAlert(event) {
            event.preventDefault();
            this.setState({ displayAlert: !this.state.displayAlert });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props3 = this.props,
                content = _props3.content,
                clickHandler = _props3.clickHandler,
                userIsBlackedOut = _props3.userIsBlackedOut,
                showLock = _props3.showLock;
            var id = content.id,
                name = content.name,
                sourceArg = content.source,
                subtitleArg = content.subtitle;

            var source = sourceArg;
            var subtitle = subtitleArg;
            if (!source && subtitle) {
                var tmpArr = subtitle.split(' • ');
                source = tmpArr.shift();
                subtitle = tmpArr.join(' • ');
            }

            var footerText = subtitle;
            var subtitleClickHandler = null;

            if (userIsBlackedOut) {
                footerText = IS_BLACKED_OUT_MESSAGE;
                // it wasn't working before and not sure if the blackout map will always work, so disabled
                // subtitleClickHandler = blackoutClickHandler;
            }

            var keyClass = showLock ? ' icon-lock-solid-before' : '';
            var displayTime = this.getDisplayTime();
            // don't use the injected clickHandler if we should alert instead
            var handleClick = this.shouldAlertOnClick() ? this.toggleAlert : clickHandler;

            return ScheduleEventCard__jsx('article', {
                className: 'contentItem contentItem--module contentItem--hasAlert',
                'data-id': id
            }, void 0, this.getAlertEl(displayTime), ScheduleEventCard__jsx('header', {
                className: 'contentItem__header contentItem__header--module'
            }, void 0, ScheduleEventCard__jsx('div', {
                href: '#',
                className: 'contentItem__header__wrapper'
            }, void 0, ScheduleEventCard__jsx(Logo["a" /* default */], {
                iconHref: content.iconHref,
                className: 'contentItem__logo'
            }))), ScheduleEventCard__jsx('a', {
                onClick: handleClick
            }, void 0, ScheduleEventCard__jsx('section', {
                className: 'contentItem__content contentItem__content--module'
            }, void 0, ScheduleEventCard__jsx('div', {
                className: 'collection_item_meta icon-font-before' + keyClass
            }, void 0, ScheduleEventCard__jsx('div', {
                className: 'collection_item_truncate'
            }, void 0, ScheduleEventCard__jsx('span', {}, void 0, displayTime), ScheduleEventCard__jsx('span', {}, void 0, source))), ScheduleEventCard__jsx('h1', {
                className: 'contentItem__title'
            }, void 0, name))), ScheduleEventCard__jsx('footer', {
                className: 'contentItem__footer contentItem__footer--module'
            }, void 0, ScheduleEventCard__jsx('div', {
                onClick: subtitleClickHandler,
                className: 'metaData'
            }, void 0, ScheduleEventCard__jsx('span', {}, void 0, footerText)), ScheduleEventCard__jsx(social_SharePalette, {
                content: content
            })));
        }
    }]);

    return ScheduleEventCard;
}(react["Component"]);

ScheduleEventCard_ScheduleEventCard.defaultProps = {
    alertThreshold: DEFAULT_DISPLAY_ALERT_UNTIL
};


/* harmony default export */ var scheduleModule_ScheduleEventCard = (Object(playable["a" /* default */])(ScheduleEventCard_ScheduleEventCard));
// CONCATENATED MODULE: ./app/webapp/scheduleModule/ScheduleModuleContainer.js
/* unused harmony export ScheduleModule */
var ScheduleModuleContainer__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }














var CONTENT_LIMIT = 4;

var ScheduleModuleContainer_ScheduleModule = function ScheduleModule(_ref) {
    var buckets = _ref.buckets,
        scheduleModuleName = _ref.scheduleModuleName,
        _ref$contentLimit = _ref.contentLimit,
        contentLimit = _ref$contentLimit === undefined ? CONTENT_LIMIT : _ref$contentLimit,
        _ref$bootstrap$schedu = _ref.bootstrap.scheduleModule,
        scheduleModule = _ref$bootstrap$schedu === undefined ? {} : _ref$bootstrap$schedu,
        page = _ref.page,
        hero = _ref.hero,
        placementPrefix = _ref.placementPrefix,
        messages = _ref.messages,
        formatMessage = _ref.intl.formatMessage,
        intlDateFormat = _ref.intlDateFormat;
    var noHero = page.noHero;

    var classes = 'contentCollection contentCollection--watchSchedule sub-module';
    var headerTitle = formatMessage(messages['schedule.module.header.live']); // should never actually use this default
    var logo = void 0;
    var alertThreshold = void 0;
    var schedPageHref = 'schedule';
    var placement = placementPrefix; // nielsen placement
    var targetBucket = void 0;
    var unSortedContents = [];

    if (buckets.length === 1) {
        var bucket = buckets[0];
        var _bucket$tags = bucket.tags,
            origTags = _bucket$tags === undefined ? [] : _bucket$tags;

        var tags = [].concat(_toConsumableArray(origTags));
        var upcomingTagIndex = tags.indexOf(enums["l" /* BucketStatus */].WEB_UPCOMING);
        var liveTagIndex = tags.indexOf(enums["l" /* BucketStatus */].WEB_LIVE);
        if (upcomingTagIndex !== -1) {
            headerTitle = formatMessage(messages['schedule.module.header.upcoming.on']);
            tags.splice(upcomingTagIndex, 1);
        } else if (liveTagIndex !== -1) {
            headerTitle = formatMessage(messages['schedule.module.header.live']);
            tags.splice(liveTagIndex, 1);
        }

        var pageName = tags.pop();
        var scheduleModuleConfig = scheduleModule[scheduleModuleName];
        var channel = '';
        if (scheduleModuleConfig) {
            channel = scheduleModuleConfig.channel;
            logo = {
                src: scheduleModuleConfig.logo,
                alt: pageName
            };
        }
        alertThreshold = 0;
        placement += 'upcoming';
        schedPageHref += '?type=upcoming' + (channel ? '&channel=' + channel : '');
        targetBucket = bucket;
    }

    // page specific schedule module not found, now find the default live or upcoming schedule module feed
    if (!targetBucket) {
        buckets.some(function (bucket) {
            var _bucket$tags2 = bucket.tags,
                tags = _bucket$tags2 === undefined ? [] : _bucket$tags2;

            if ((noHero || hero && (hero.type === enums["o" /* ContentType */].VOD || hero.status === enums["n" /* ContentStatus */].REPLAY)) && tags.indexOf(enums["l" /* BucketStatus */].WEB_LIVE) !== -1) {
                headerTitle = formatMessage(messages['schedule.module.header.live']);
                placement += 'top-live';
                classes += ' live';
                targetBucket = bucket;
                return true;
            } else if ((noHero || hero && hero.type === enums["o" /* ContentType */].LISTING && hero.status !== enums["n" /* ContentStatus */].REPLAY) && tags.indexOf(enums["l" /* BucketStatus */].WEB_UPCOMING) !== -1) {
                headerTitle = formatMessage(messages['schedule.module.header.upcoming']);
                placement += 'upcoming';
                schedPageHref += '?type=upcoming';
                targetBucket = bucket;
                return true;
            }
            return false;
        });
    }

    if (targetBucket) {
        unSortedContents = targetBucket.contents;
    }

    var eventDateNextDayString = formatMessage(messages['schedule.module.eventDate.tomorrow']);

    var contents = unSortedContents.slice(0, contentLimit).sort(function (contentA, contentB) {
        var aDate = new Date(contentA.utc || contentA.time);
        var bDate = new Date(contentB.utc || contentB.time);
        return aDate.getTime() - bDate.getTime();
    });

    var cards = contents.map(function (content) {
        return ScheduleModuleContainer__jsx(scheduleModule_ScheduleEventCard, {
            content: content,
            placement: placement,
            dateFormat: intlDateFormat,
            alertThreshold: alertThreshold,
            formatMessage: formatMessage,
            messages: messages,
            nextDayString: eventDateNextDayString
        }, 'eventcard-' + content.name);
    });

    return contents.length > 0 ? ScheduleModuleContainer__jsx('section', {
        style: { zIndex: 300 },
        className: classes
    }, void 0, ScheduleModuleContainer__jsx(BucketHeaderContainer["a" /* default */], {
        appPageTitle: 'Schedule',
        name: headerTitle,
        logo: logo,
        link: schedPageHref
    }), cards) : null;
};

var ScheduleModuleContainer_mapStateToProps = function mapStateToProps(state) {
    return {
        buckets: scheduleModuleBucketsSelector(state),
        scheduleModuleName: scheduleModuleNameSelector(state),
        bootstrap: Object(bootstrapSelector["a" /* default */])(state),
        page: Object(pageSelector["c" /* default */])(state),
        hero: Object(heroSelector["a" /* default */])(state),
        placementPrefix: Object(analyticsSelectors["g" /* placementPrefixSelector */])(state),
        intlDateFormat: Object(appSelector["i" /* dateFormatSelector */])(state)
    };
};

/* harmony default export */ var ScheduleModuleContainer = __webpack_exports__["a"] = (Object(es["b" /* connect */])(ScheduleModuleContainer_mapStateToProps)(Object(injectIntl["a" /* default */])(ScheduleModuleContainer_ScheduleModule)));

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// CONCATENATED MODULE: ./app/common/BucketHeader.js
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var BucketHeader = function BucketHeader(_ref) {
    var title = _ref.title,
        _ref$logo = _ref.logo;
    _ref$logo = _ref$logo === undefined ? {} : _ref$logo;
    var src = _ref$logo.src,
        alt = _ref$logo.alt,
        seeAllText = _ref.seeAllText;
    return _jsx("div", {
        className: "collection__headerWrap"
    }, void 0, _jsx("h1", {}, void 0, title, src && _jsx("img", {
        className: "collection__headerWrap__logo",
        src: src,
        alt: alt
    })), _jsx("span", {
        className: "see-all"
    }, void 0, seeAllText));
};

/* harmony default export */ var common_BucketHeader = (BucketHeader);
// EXTERNAL MODULE: ./app/common/LinkWithFlags.js
var LinkWithFlags = __webpack_require__(147);

// EXTERNAL MODULE: ./app/common/injectIntl.js
var injectIntl = __webpack_require__(20);

// CONCATENATED MODULE: ./app/webapp/page/buckets/BucketHeaderContainer.js
var BucketHeaderContainer__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();






var BucketHeaderContainer_BucketHeaderContainer = function BucketHeaderContainer(_ref) {
    var className = _ref.className,
        displaySize = _ref.displaySize,
        formatMessage = _ref.intl.formatMessage,
        name = _ref.name,
        logo = _ref.logo,
        link = _ref.link,
        messages = _ref.messages,
        size = _ref.size;

    var title = '' + name + (displaySize && size ? ' (' + size + ')' : '');
    return BucketHeaderContainer__jsx('header', {
        className: className
    }, void 0, link ? BucketHeaderContainer__jsx(LinkWithFlags["a" /* default */], {
        to: link,
        className: 'collection_title_link',
        'data-route': 'false'
    }, void 0, BucketHeaderContainer__jsx(common_BucketHeader, {
        title: title,
        logo: logo,
        seeAllText: formatMessage(messages['page.bucket.header.seeAll'])
    })) : BucketHeaderContainer__jsx('span', {}, void 0, BucketHeaderContainer__jsx(common_BucketHeader, {
        title: title,
        logo: logo,
        seeAllText: ''
    })));
};

/* harmony default export */ var buckets_BucketHeaderContainer = __webpack_exports__["a"] = (Object(injectIntl["a" /* default */])(BucketHeaderContainer_BucketHeaderContainer));

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-intl/lib/index.es.js + 1 modules
var index_es = __webpack_require__(94);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(4);

// EXTERNAL MODULE: ./app/common/injectIntl.js
var injectIntl = __webpack_require__(20);

// EXTERNAL MODULE: ./app/common/PropTypes.js
var PropTypes = __webpack_require__(28);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(14);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// CONCATENATED MODULE: ./app/common/alert/Alert.js
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var classModifiers = {
    center: 'alert--center',
    fade: 'alert__animateFadeIn alert__animateFadeIn--run',
    slide: 'alert__animateSlideIn alert__animateSlideIn--run'
};

/**
 * Generic alert UI component
 */
var Alert_Alert = function Alert(_ref) {
    var align = _ref.align,
        animation = _ref.animation,
        className = _ref.className,
        message = _ref.message,
        style = _ref.style,
        onClose = _ref.onClose;

    var finalClassName = classnames_default()('alert', classModifiers[align], classModifiers[animation], className);
    return _jsx('div', {
        className: 'alert__isOverlay',
        style: style
    }, void 0, _jsx('div', {
        className: finalClassName
    }, void 0, message, _jsx('a', {
        onClick: onClose,
        className: 'alert_button--close icon-font-after icon-close-solid-after'
    })));
};

/* harmony default export */ var alert_Alert = (Alert_Alert);
// EXTERNAL MODULE: ./app/lib/format/dateFormat.js
var dateFormat = __webpack_require__(33);

// EXTERNAL MODULE: ./app/common/selectors/appSelector.js + 1 modules
var appSelector = __webpack_require__(3);

// EXTERNAL MODULE: ./app/common/selectors/authenticationSelectors.js
var authenticationSelectors = __webpack_require__(10);

// CONCATENATED MODULE: ./app/webapp/alert/UpcomingAlert.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var UpcomingAlert__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();












/**
 * Upcoming Alert UI component
 */
var UpcomingAlert_UpcomingAlert = function UpcomingAlert(_ref) {
    var align = _ref.align,
        animation = _ref.animation,
        className = _ref.className,
        content = _ref.content,
        displayTime = _ref.displayTime,
        dateFormatStr = _ref.dateFormatStr,
        messages = _ref.messages,
        moreText = _ref.moreText,
        onClose = _ref.onClose,
        style = _ref.style,
        userLocation = _ref.userLocation;
    var name = content.name,
        utc = content.utc,
        sourceArg = content.source,
        subtitle = content.subtitle;

    var timeZone = userLocation && userLocation.timeZone;
    var startTime = displayTime || dateFormat["a" /* default */].getDateTimeString(utc, dateFormatStr, timeZone);
    var source = sourceArg;
    if (!source && subtitle.indexOf(' • ') > -1) {
        var tmpArr = subtitle.split(' • ');
        source = tmpArr.shift();
    }
    var message = react_default.a.createElement(index_es["a" /* FormattedMessage */], _extends({}, messages['schedule.module.alert.upcoming'], {
        tagName: 'p',
        values: {
            name: name,
            startTime: UpcomingAlert__jsx('span', {}, void 0, startTime),
            source: source,
            moreText: moreText
        }
    }));
    return UpcomingAlert__jsx(alert_Alert, {
        align: align,
        animation: animation,
        className: className,
        message: message,
        style: style,
        onClose: onClose
    });
};

UpcomingAlert_UpcomingAlert.defaultProps = {
    content: {},
    moreText: ''
};

var UpcomingAlert_mapStateToProps = function mapStateToProps(state) {
    return {
        dateFormatStr: Object(appSelector["i" /* dateFormatSelector */])(state),
        userLocation: Object(authenticationSelectors["s" /* userLocationSelector */])(state)
    };
};

/* harmony default export */ var alert_UpcomingAlert = __webpack_exports__["a"] = (Object(es["b" /* connect */])(UpcomingAlert_mapStateToProps)(Object(injectIntl["a" /* default */])(UpcomingAlert_UpcomingAlert)));

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(715),
    createBaseEach = __webpack_require__(717);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(716);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(134),
    eq = __webpack_require__(109);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(289);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 345 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(314),
    baseKeysIn = __webpack_require__(732),
    isArrayLike = __webpack_require__(51);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(200),
    getTag = __webpack_require__(201),
    isArguments = __webpack_require__(111),
    isArray = __webpack_require__(32),
    isArrayLike = __webpack_require__(51),
    isBuffer = __webpack_require__(141),
    isPrototype = __webpack_require__(136),
    isTypedArray = __webpack_require__(142);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_util_canUseDOM__ = __webpack_require__(61);


var globalVideoElement = __WEBPACK_IMPORTED_MODULE_0__lib_util_canUseDOM__["a" /* default */] ? document.createElement('video') : null;

// click handlers will "prime" the video element to allow for "one-click play" by calling "load"
// we only want to do this once
if (__WEBPACK_IMPORTED_MODULE_0__lib_util_canUseDOM__["a" /* default */]) {
    globalVideoElement.prime = function () {
        if (!globalVideoElement.primed) {
            globalVideoElement.load();
            globalVideoElement.primed = true;
        }
    };
}

/* harmony default export */ __webpack_exports__["a"] = (globalVideoElement);

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-helmet/lib/Helmet.js
var Helmet = __webpack_require__(30);
var Helmet_default = /*#__PURE__*/__webpack_require__.n(Helmet);

// EXTERNAL MODULE: ./app/common/ads/InContentAd.js
var InContentAd = __webpack_require__(150);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(14);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./app/enums.js
var enums = __webpack_require__(1);

// EXTERNAL MODULE: ./app/common/PropTypes.js
var PropTypes = __webpack_require__(28);

// EXTERNAL MODULE: ./app/common/Logo.js
var Logo = __webpack_require__(219);

// CONCATENATED MODULE: ./app/common/page/search/SearchBucketsHeader.js
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var SearchBucketsHeader_SearchBucketsHeader = function SearchBucketsHeader(props) {
    if (props.logoUrl) {
        return _jsx('header', {
            className: 'section-header'
        }, void 0, _jsx(Logo["a" /* default */], {
            logoUrl: props.logoUrl,
            tags: props.tags,
            className: 'section-header_logo'
        }), _jsx('h1', {
            className: 'section-header_title'
        }, void 0, props.name));
    }

    return _jsx('header', {
        className: 'section-header'
    }, void 0, _jsx('h1', {
        className: 'section-header_title'
    }, void 0, props.name));
};

/* harmony default export */ var search_SearchBucketsHeader = (SearchBucketsHeader_SearchBucketsHeader);
// EXTERNAL MODULE: ./app/webapp/page/buckets/BucketHeaderContainer.js + 1 modules
var BucketHeaderContainer = __webpack_require__(339);

// CONCATENATED MODULE: ./app/common/page/buckets/CollectionBucketHeader.js
var CollectionBucketHeader__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var CollectionBucketHeader_CollectionBucketHeader = function CollectionBucketHeader(_ref) {
    var iconHref = _ref.iconHref,
        name = _ref.name;
    return CollectionBucketHeader__jsx('header', {
        className: 'section-header'
    }, void 0, iconHref ? CollectionBucketHeader__jsx(Logo["a" /* default */], {
        iconHref: iconHref,
        className: 'section-header_logo'
    }) : null, CollectionBucketHeader__jsx('h1', {
        className: 'section-header_title'
    }, void 0, name));
};

/* harmony default export */ var buckets_CollectionBucketHeader = (CollectionBucketHeader_CollectionBucketHeader);
// EXTERNAL MODULE: ./app/common/page/buckets/Tile.js + 1 modules
var Tile = __webpack_require__(350);

// CONCATENATED MODULE: ./app/common/page/buckets/Bucket.js
/* unused harmony export getBucketDimension */
/* unused harmony export generateBucketCss */
var Bucket__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _collectionRowClassMa, _ratioBreakPointMap;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }












var Bucket_getExpandableThresholds = function getExpandableThresholds() {
    var _ref;

    var maxToDisplay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 100;
    return _ref = {}, _defineProperty(_ref, enums["i" /* BucketLayout */].DEFAULT_EXPANDABLE, [4, maxToDisplay]), _defineProperty(_ref, enums["i" /* BucketLayout */].LARGE_EXPANDABLE, [8, maxToDisplay]), _ref;
};

var collectionRowClassMap = (_collectionRowClassMa = {}, _defineProperty(_collectionRowClassMa, enums["i" /* BucketLayout */].FiveTwo, 'dtc-watch__row--promos'), _defineProperty(_collectionRowClassMa, enums["i" /* BucketLayout */].TwoThree, 'dtc-watch__row--films'), _defineProperty(_collectionRowClassMa, enums["i" /* BucketLayout */].FourThree, 'dtc-watch__row--shows'), _collectionRowClassMa);

var dtcItemLayouts = [enums["i" /* BucketLayout */].FiveTwo, enums["i" /* BucketLayout */].TwoThree, enums["i" /* BucketLayout */].FourThree];

var featureLayouts = [enums["i" /* BucketLayout */]['feature-left'], enums["i" /* BucketLayout */]['feature-right'], enums["i" /* BucketLayout */].TAPESTRY_LEFT, enums["i" /* BucketLayout */].TAPESTRY_RIGHT];

var featureLeftLayout = [enums["i" /* BucketLayout */]['feature-left'], enums["i" /* BucketLayout */].TAPESTRY_LEFT];

var featureRightLayout = [enums["i" /* BucketLayout */]['feature-right'], enums["i" /* BucketLayout */].TAPESTRY_RIGHT];

var breakPointMqMap = {
    mobile: '@media screen and (max-width: 597px)',
    'mobile-lg': '@media screen and (min-width: 598px) and (max-width: 767px)',
    tablet: '@media screen and (min-width: 768px) and (max-width: 1023px)',
    desktop: '@media screen and (min-width: 1024px) and (max-width: 1259px)',
    'desktop-lg': '@media screen and (min-width: 1260px)'
};

var ratioBreakPointMap = (_ratioBreakPointMap = {}, _defineProperty(_ratioBreakPointMap, enums["j" /* BucketRatio */].SixteenNine, ['tablet', 'desktop', 'desktop-lg']), _defineProperty(_ratioBreakPointMap, enums["j" /* BucketRatio */].FourThree, ['mobile', 'mobile-lg', 'tablet', 'desktop', 'desktop-lg']), _defineProperty(_ratioBreakPointMap, enums["j" /* BucketRatio */].FiveTwo, ['tablet', 'desktop', 'desktop-lg']), _defineProperty(_ratioBreakPointMap, enums["j" /* BucketRatio */].TwoThree, ['mobile', 'mobile-lg', 'tablet', 'desktop', 'desktop-lg']), _ratioBreakPointMap);

/**
 * Calculates the dimension of bucket
 *
 * @param {string} ratio - tile ratio
 * @param {string} mq - media query break point
 * @param {number} contentLength - number of contents in bucket
 * @param {boolean} calculateRows - a flag to indicate whether we retrieve the maximum rows to display
 * @return {object} - dimension of bucket
 */
function getBucketDimension() {
    var ratio = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : enums["j" /* BucketRatio */].SixteenNine;
    var mq = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : enums["h" /* BreakPoints */].DESKTOP_LARGE;
    var contentLength = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var calculateRows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    var columns = enums["k" /* BucketRatioCols */][mq][ratio];
    var rows = void 0;
    if (columns) {
        if (calculateRows) {
            rows = Math.max(1, Math.floor(contentLength / columns));
        } else {
            rows = contentLength >= 2 * columns ? 2 : 1;
        }
    }
    return { rows: rows, columns: columns };
}

function generateBucketCss(row) {
    var ratio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : enums["j" /* BucketRatio */].SixteenNine;
    var pageType = arguments[2];

    // NOTE: For catalog template pages (i.e. /watch/series) we do not want to hide tiles via css
    // This prevents the bucketCssCache from saving upon client side route transitions.
    if (pageType === enums["y" /* PageType */].CATALOG) {
        return '';
    }

    var breakPoints = ratioBreakPointMap[ratio];
    var css = '';
    /* eslint-disable max-len */
    breakPoints.forEach(function (key) {
        var mediaFeatures = breakPointMqMap[key];
        if (!mediaFeatures) {
            return;
        }

        var col = enums["k" /* BucketRatioCols */][key][ratio];
        if (ratio === enums["j" /* BucketRatio */].SixteenNine) {
            css += '\n                ' + mediaFeatures + ' {\n                    .watch-home .collection--watch .collection_row--' + row + ' article.collection_item--one:nth-of-type(1n+' + (col * row + 1) + '){\n                        display:none;\n                    }\n                }\n            ';
        } else {
            var layoutKey = Object.keys(enums["j" /* BucketRatio */]).filter(function (ratioKey) {
                return enums["j" /* BucketRatio */][ratioKey] === ratio;
            })[0];
            var layoutType = enums["i" /* BucketLayout */][layoutKey];
            css += '\n                ' + mediaFeatures + ' {\n                    .watch-home .' + collectionRowClassMap[layoutType] + '.dtc-watch__row--' + row + ' .dtc-watch__item:nth-of-type(1n+' + (col * row + 1) + '){\n                        display:none;\n                    }\n                }\n            ';
        }
    });

    return css;
}

var Bucket_Bucket = function (_Component) {
    _inherits(Bucket, _Component);

    function Bucket(props) {
        _classCallCheck(this, Bucket);

        var _this = _possibleConstructorReturn(this, (Bucket.__proto__ || Object.getPrototypeOf(Bucket)).call(this, props));

        _this.getImageFormat = _this.getImageFormat.bind(_this);
        _this.getLayoutType = _this.getLayoutType.bind(_this);
        _this.getBucketLink = _this.getBucketLink.bind(_this);
        _this.isTileFeatured = _this.isTileFeatured.bind(_this);
        _this.isPagePreview = _this.isPagePreview.bind(_this);
        _this.shouldShowAllTiles = _this.shouldShowAllTiles.bind(_this);
        _this.showMoreClickHandler = _this.showMoreClickHandler.bind(_this);
        _this.state = {
            expanded: false
        };
        return _this;
    }

    /**
     * getImageFormat - Returns the proper image format that depends on the medata. Secondary
     * fallback value is derived from the contents.imageFormat. Final fallback is '16x9'
     *
     * @return {String}
     */


    _createClass(Bucket, [{
        key: 'getImageFormat',
        value: function getImageFormat() {
            var _props = this.props,
                contents = _props.contents,
                imageFormatBucket = _props.metadata.imageFormat;

            var _ref2 = contents[0] || {},
                imageFormatContent = _ref2.imageFormat;

            return imageFormatBucket || imageFormatContent || enums["j" /* BucketRatio */].SixteenNine;
        }

        /**
         * getLayoutType - Returns the type of layout to be used for the bucket. Utilizes the pageType
         * and imageFormat to obtain the proper value. It can be overwritten by the prop.layoutType.
         *
         * @param {string} pageType
         * @param {string} imageFormat
         *
         * @return {string}
         */

    }, {
        key: 'getLayoutType',
        value: function getLayoutType(pageType) {
            var imageFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
            var _props2 = this.props,
                layoutOverride = _props2.layoutOverride,
                layout = _props2.layout;

            var apiLayout = layout || '';
            var finalLayout = void 0;

            if (apiLayout !== '' && enums["i" /* BucketLayout */][apiLayout]) {
                // API match found (i.e. feature-left, feature-right)
                finalLayout = enums["i" /* BucketLayout */][apiLayout];
            } else if (imageFormat === enums["j" /* BucketRatio */].TwoThree) {
                finalLayout = enums["i" /* BucketLayout */].TwoThree;
            } else if (imageFormat === enums["j" /* BucketRatio */].FourThree) {
                finalLayout = enums["i" /* BucketLayout */].FourThree;
            } else if (imageFormat === enums["j" /* BucketRatio */].FiveTwo) {
                finalLayout = enums["i" /* BucketLayout */].FiveTwo;
            } else if (imageFormat === enums["j" /* BucketRatio */].SixteenNine) {
                finalLayout = enums["i" /* BucketLayout */].SixteenNine;
            } else {
                finalLayout = pageType === enums["y" /* PageType */].COLLECTION ? enums["i" /* BucketLayout */].COLLECTION : enums["i" /* BucketLayout */].DEFAULT;
            }

            // Override all predefined layouts; dependent on `this.props.layoutOverride`
            if (layoutOverride) {
                finalLayout = layoutOverride;
            }

            return finalLayout;
        }

        /**
         * getBucketLink - Returns the proper bucket link to be used based on the following conditions:
         * 1) If the page is on preview mode, it uses the props.name to generate the bucket link.
         * 2) If the props.link is defined and shouldShowAllTiles() is false, it uses the props.link value
         * @return {string} - Bucket URL
         */

    }, {
        key: 'getBucketLink',
        value: function getBucketLink() {
            var _props3 = this.props,
                link = _props3.link,
                name = _props3.name;

            var bucketLink = void 0;
            // TODO: Fix this when the correct url is coming back from the page api.
            // Also note the condition in !this.shouldShowAllTiles() below
            if (this.isPagePreview()) {
                bucketLink = '/' + name.toLowerCase();
            } else if (link && !this.shouldShowAllTiles()) {
                bucketLink = link;
            }

            return bucketLink;
        }

        /**
         * isPagePreview - Returns a boolean flag value that determine if the page is a preview page
         * based on the existence of `page_preview` in the tags prop.
         *
         * @return {boolean}
         */

    }, {
        key: 'isPagePreview',
        value: function isPagePreview() {
            var tags = this.props.tags;

            return tags && tags.indexOf('page_preview') !== -1;
        }

        /**
         * isTileFeatured - Returns a boolean flag value that verifies the existence of the contents
         * in addition to matching the index and layoutType.
         *
         * @param {number} index - current index of the array for the given tile
         * @param {string} layoutType - the type of layout to determine if the tile should be featured
         *
         * @return {boolean}
         */

    }, {
        key: 'isTileFeatured',
        value: function isTileFeatured(index, layoutType) {
            var featureLayoutsList = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
            var contents = this.props.contents;


            return contents && index === 0 && featureLayoutsList.indexOf(layoutType) !== -1;
        }

        /**
         * shouldShowAllTiles - Returns a boolean flag that only returns true if the pageType is `COLLECTION`
         * or if the layoutType is 1) TwoThree or 2) FourThree and the hideHeaderLink boolean is true.
         *
         * @return {boolean}
         */

    }, {
        key: 'shouldShowAllTiles',
        value: function shouldShowAllTiles() {
            var _props4 = this.props,
                hideHeaderLink = _props4.hideHeaderLink,
                pageType = _props4.pageType;

            var layoutType = this.getLayoutType(pageType, this.getImageFormat());

            return pageType === enums["y" /* PageType */].COLLECTION || (layoutType === enums["i" /* BucketLayout */].TwoThree || layoutType === enums["i" /* BucketLayout */].FourThree) && hideHeaderLink;
        }
    }, {
        key: 'showMoreClickHandler',
        value: function showMoreClickHandler() {
            this.setState({ expanded: !this.state.expanded });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props5 = this.props,
                bucketId = _props5.bucketId,
                contents = _props5.contents,
                groupId = _props5.groupId,
                iconHref = _props5.iconHref,
                _props5$metadata = _props5.metadata,
                totalCount = _props5$metadata.totalCount,
                displayCount = _props5$metadata.displayCount,
                name = _props5.name,
                pageType = _props5.pageType,
                tags = _props5.tags,
                tier = _props5.tier;

            var imageFormat = this.getImageFormat();
            var layoutType = this.getLayoutType(pageType, imageFormat);
            var layoutTypeHasDefinedShreshhold = {}.hasOwnProperty.call(enums["u" /* LayoutThresholds */], layoutType);
            var bucketLink = this.getBucketLink();
            var isFeaturedLeftLayout = featureLeftLayout.indexOf(layoutType) !== -1;
            var isFeaturedRightLayout = featureRightLayout.indexOf(layoutType) !== -1;
            // There are 2 reasons to distinguish between the legacy layout and ones introduced for DTC
            // 1. tiles in DTC layout is not playable, but navigable (5x2, 4x3 and 2x3)
            // 2. css class works differently
            var layoutVariant = dtcItemLayouts.indexOf(layoutType) !== -1 ? enums["v" /* LayoutVariant */].DTC : enums["v" /* LayoutVariant */].COLLECTION;
            var isDTCLayout = layoutVariant === enums["v" /* LayoutVariant */].DTC;
            var isTileNavigable = isDTCLayout;
            var displaySize = !this.isPagePreview() && !isTileNavigable;
            var layoutThreshold = void 0;
            var rows = void 0;

            if (layoutTypeHasDefinedShreshhold) {
                // use the static threshold for the `layoutType` when defined
                layoutThreshold = enums["u" /* LayoutThresholds */][layoutType];
            } else {
                // by default, `displayCount` matches with `totalCount` when not entered or
                // set larger than `totalCount` in admin console, use the default layout logic which is 1 row and
                // 2 when tiles are enough to fill 2 rows on non show/film pages.
                // Otherwise, calculate maximum rows that can fill up with tiles.
                var calculateRows = displayCount < totalCount;
                // retrieve the maximum `layoutThreshold` using the largest break point, then hide tiles accordingly with css
                // for the smaller break point, that's more performant than re-rendering the exact tiles per break points.

                var _getBucketDimension = getBucketDimension(imageFormat, 'desktop-lg', contents.length, calculateRows),
                    bucketRows = _getBucketDimension.rows,
                    columns = _getBucketDimension.columns;

                if (bucketRows && !this.shouldShowAllTiles()) {
                    rows = bucketRows;
                    // For catalog template pages such as show/film pages we want to show all content only when the `see all` link
                    // is not defined. Threshold should be calculated for all other page types
                    if (pageType === enums["y" /* PageType */].CATALOG) {
                        layoutThreshold = bucketLink ? bucketRows * columns : undefined;
                    } else {
                        layoutThreshold = bucketRows * columns;
                    }
                }
            }

            // Applying `*--showAll` class overrides the tile css to always appear on all break points
            var collectionRowClassName = classnames_default()(collectionRowClassMap[layoutType], layoutType === enums["i" /* BucketLayout */].SixteenNine && rows && 'collection_row--' + rows, isDTCLayout && rows && 'dtc-watch__row--' + rows, {
                collection_row: !isDTCLayout,
                'dtc-watch__row': isDTCLayout,
                'dtc-watch__row--showAll': isDTCLayout && this.shouldShowAllTiles(),
                'collection_row--collections': pageType === enums["y" /* PageType */].COLLECTION,
                'collection_row--showAll': pageType === enums["y" /* PageType */].COLLECTION
            });

            // Add classes based on the layoutType
            var collectionClassName = classnames_default()('collection', {
                'collection--watch': featureLayouts.indexOf(layoutType) === -1 && !isDTCLayout,
                'collection--featured-left': isFeaturedLeftLayout,
                'collection--featured-right': isFeaturedRightLayout
            });

            // Check tags to determine if bucket should be expandable
            var footer = void 0;
            var expandThresholds = Bucket_getExpandableThresholds(contents.length);
            var layoutTags = tags.filter(function (tag) {
                return Object.keys(expandThresholds).indexOf(tag) !== -1;
            });

            if (layoutTags.length > 0) {
                var expanded = this.state.expanded;

                var layoutTag = layoutTags[0];
                var minimumToDisplay = expandThresholds[layoutTag][0];
                var maximumToDisplay = expandThresholds[layoutTag][1];
                layoutThreshold = expanded ? maximumToDisplay : minimumToDisplay;

                if (contents.length > minimumToDisplay) {
                    var text = expanded ? 'Show Fewer' : 'Show More';
                    var footerClass = classnames_default()('showMore__link', 'icon-font-before', { active: expanded });
                    footer = Bucket__jsx('footer', {
                        className: 'showMore'
                    }, void 0, Bucket__jsx('a', {
                        onClick: this.showMoreClickHandler,
                        className: footerClass
                    }, void 0, Bucket__jsx('span', {}, void 0, text)));
                }
            }

            // `placement` is used for `playable` HOC
            var placement = 'home-' + name + '-grid';
            var header = Bucket__jsx(BucketHeaderContainer["a" /* default */], {
                className: 'collection_header',
                name: name,
                placement: placement,
                tier: tier,
                size: totalCount,
                link: bucketLink,
                displaySize: displaySize,
                isDTCLayout: isDTCLayout
            });

            switch (pageType) {
                case enums["y" /* PageType */].COLLECTION:
                    header = Bucket__jsx(buckets_CollectionBucketHeader, {
                        name: name,
                        iconHref: iconHref,
                        tags: tags
                    });
                    placement = 'collections-' + name + '-grid';
                    break;
                case enums["y" /* PageType */].FEATURES:
                    placement = 'features-' + name + '-grid';
                    break;
                case enums["y" /* PageType */].SEARCH:
                    placement = 'search-' + this.props.name + '-grid';
                    header = Bucket__jsx(search_SearchBucketsHeader, {
                        name: this.props.name,
                        logoUrl: this.props.logoUrl,
                        tags: this.props.tags
                    });
                    break;
                default:
                    break;
            }

            var collectionContents = layoutThreshold ? contents.slice(0, layoutThreshold) : contents;
            /* eslint-disable */
            var collectionRowChildren = collectionContents.map(function (content, index) {
                return Bucket__jsx(Tile["a" /* default */], {
                    bucketId: bucketId,
                    content: content,
                    groupId: groupId,
                    featured: _this2.isTileFeatured(index, layoutType, featureLayouts),
                    layoutType: layoutType,
                    isNavigable: isTileNavigable,
                    placement: placement,
                    bucketName: name,
                    tier: tier
                }, 'tile-' + bucketId + '-' + index + ':' + content.id + ':');
            });
            /* eslint-enable */

            // TODO: is there a better way to do this?
            if (pageType === enums["y" /* PageType */].COLLECTION) {
                collectionRowChildren.splice(6, 0, Bucket__jsx(InContentAd["a" /* default */], {
                    include: ['s'],
                    adClassName: 'ad-slot-incontent2',
                    refreshWhenVisible: true
                }, 'collection_row_in_content_ad'));
            }

            var bucket = null;
            if (collectionRowChildren && collectionRowChildren.length > 0) {
                // creates media query css for given ratio(layout) and # of rows on demand
                var bucketCss = imageFormat && rows && generateBucketCss(rows, imageFormat, pageType);
                bucket = Bucket__jsx('div', {
                    className: collectionClassName
                }, void 0, bucketCss && Bucket__jsx(Helmet_default.a, {
                    style: [{
                        cssText: bucketCss
                    }]
                }), header, Bucket__jsx('div', {
                    className: collectionRowClassName
                }, void 0, collectionRowChildren), footer);
            }

            return bucket;
        }
    }]);

    return Bucket;
}(react["Component"]);

Bucket_Bucket.defaultProps = {
    contents: [],
    metadata: {},
    name: '',
    tags: []
};

/* harmony default export */ var buckets_Bucket = __webpack_exports__["a"] = (Bucket_Bucket);

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(14);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./app/common/PropTypes.js
var PropTypes = __webpack_require__(28);

// EXTERNAL MODULE: ./app/webapp/common/Stamp.js
var Stamp = __webpack_require__(351);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(4);

// EXTERNAL MODULE: ./app/common/selectors/flagsSelector.js
var flagsSelector = __webpack_require__(47);

// EXTERNAL MODULE: ./app/lib/format/addQueryToUrl.js
var addQueryToUrl = __webpack_require__(70);

// CONCATENATED MODULE: ./app/common/AnchorWithFlags.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var AnchorWithFlags_AnchorWithFlags = function AnchorWithFlags(props) {
    var ownProps = props.ownProps,
        flags = props.flags,
        href = props.href;

    if (!href) {
        return react_default.a.createElement('span', ownProps);
    }
    var newProps = _extends({}, ownProps, {
        href: Object(addQueryToUrl["a" /* default */])(href, flags)
    });
    return react_default.a.createElement('a', newProps);
};

var AnchorWithFlags_mapStateToProps = function mapStateToProps(state, ownProps) {
    return {
        ownProps: ownProps,
        flags: Object(flagsSelector["a" /* persistentFlagsSelector */])(state)
    };
};

/* harmony default export */ var common_AnchorWithFlags = (Object(es["b" /* connect */])(AnchorWithFlags_mapStateToProps)(AnchorWithFlags_AnchorWithFlags));
// EXTERNAL MODULE: ./app/common/ResponsiveThumbnail.js
var ResponsiveThumbnail = __webpack_require__(222);

// EXTERNAL MODULE: ./app/webapp/common/playable.js + 2 modules
var playable = __webpack_require__(64);

// EXTERNAL MODULE: ./app/enums.js
var enums = __webpack_require__(1);

// EXTERNAL MODULE: ./app/webapp/lib/format/index.js
var format = __webpack_require__(151);

// CONCATENATED MODULE: ./app/common/page/buckets/Tile.js
/* unused harmony export BaseTile */
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();











var FEATURED_IMAGE_WIDTHS = [640, 900, 1200];
var IMAGE_WIDTHS = [280, 640, 1200];

var collectionItemOneLayouts = [enums["i" /* BucketLayout */].DEFAULT, enums["i" /* BucketLayout */].DEFAULT_UNLIMITED, enums["i" /* BucketLayout */]['feature-left'], enums["i" /* BucketLayout */]['feature-right'], enums["i" /* BucketLayout */].TAPESTRY_LEFT, // NOTE: will be deprecated
enums["i" /* BucketLayout */].TAPESTRY_RIGHT, // NOTE: will be deprecated
enums["i" /* BucketLayout */].SixteenNine];

var Tile_Tile = function Tile(_ref) {
    var clickHandler = _ref.clickHandler,
        content = _ref.content,
        featured = _ref.featured,
        playerHref = _ref.playerHref,
        layoutType = _ref.layoutType,
        isNavigable = _ref.isNavigable,
        userIsBlackedOut = _ref.userIsBlackedOut,
        selected = _ref.selected,
        showLock = _ref.showLock,
        userLocation = _ref.userLocation,
        tileClassNames = _ref.tileClassNames;
    var id = content.id,
        description = content.description,
        imageHref = content.imageHref,
        name = content.name,
        score = content.score,
        status = content.status;

    var formattedSubtitle = Object(format["a" /* contentSubtitle */])(content);
    var isContentUpcoming = status === enums["n" /* ContentStatus */].UPCOMING;
    var isContentLive = status === enums["n" /* ContentStatus */].LIVE;
    var isContentClickable = !isNavigable;

    var tileClassName = classnames_default()(tileClassNames, {
        collection_item: !isNavigable,
        'dtc-watch__item': isNavigable,
        'collection_item--one': collectionItemOneLayouts.indexOf(layoutType) !== -1 && !featured,
        'collection_item--three': layoutType === enums["i" /* BucketLayout */].COLLECTION,
        'collection_item--featured': featured
    });

    var metaDataClass = classnames_default()('collection_item_meta', 'icon-font-before', {
        'icon-lock-solid-before': showLock
    });

    var playButtonClass = classnames_default()({
        'button-play button-play--video': isContentClickable,
        'button-play--live': isContentClickable && isContentLive
    });

    var activeClass = classnames_default()('collection__link', {
        'collection__link--active': selected,
        'collection__link--upcoming': !isContentClickable && isContentUpcoming
    });

    // TODO: the "isNew" property doesn't actually exist yet
    var newStamp = content.isNew ? _jsx('div', {
        className: 'new'
    }, void 0, 'NEW') : '';
    var descriptionEl = featured && description ? _jsx('p', {
        className: 'collection_item_desc'
    }, void 0, description) : '';
    var href = void 0;
    var tileClickHandler = void 0;

    if (isContentClickable || isNavigable) {
        tileClickHandler = clickHandler;
        href = playerHref;
    }

    var subtitleEl = formattedSubtitle ? _jsx('span', {}, void 0, formattedSubtitle) : null;
    var timeZone = userLocation && userLocation.timeZone;
    return isNavigable ? _jsx(common_AnchorWithFlags, {
        'data-route': 'false',
        'data-id': id,
        'data-score': score,
        className: tileClassName,
        href: href,
        onClick: tileClickHandler
    }, void 0, _jsx('div', {
        className: 'dtc-watch__item__content'
    }, void 0, _jsx('img', {
        className: 'dtc-watch__film__image',
        src: imageHref,
        alt: name
    }))) : _jsx('article', {
        onClick: tileClickHandler,
        className: tileClassName,
        'data-id': id,
        'data-score': score
    }, void 0, _jsx(common_AnchorWithFlags, {
        'data-route': 'false',
        className: activeClass,
        href: href
    }, void 0, _jsx('figure', {
        className: 'collection_item_media'
    }, void 0, newStamp, _jsx('div', {
        className: 'media-wrapper media-wrapper--16x9'
    }, void 0, _jsx(ResponsiveThumbnail["a" /* default */], {
        src: imageHref,
        srcSetWidths: featured ? FEATURED_IMAGE_WIDTHS : IMAGE_WIDTHS,
        sizes: '33vw',
        alt: name
    }), _jsx('div', {
        className: playButtonClass
    }), _jsx(Stamp["a" /* default */], {
        timeZone: timeZone,
        content: content,
        userIsBlackedOut: userIsBlackedOut,
        isTile: true
    })), _jsx('figcaption', {}, void 0, _jsx('h1', {
        className: 'collection_item_title'
    }, void 0, name), _jsx('div', {
        className: metaDataClass
    }, void 0, _jsx('div', {
        className: 'collection_item_truncate'
    }, void 0, subtitleEl)), descriptionEl))));
};

/* harmony default export */ var buckets_Tile = __webpack_exports__["a"] = (Object(playable["a" /* default */])(Tile_Tile));


/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__enums__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_PropTypes__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_injectIntl__ = __webpack_require__(20);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();







var Stamp = function Stamp(_ref) {
    var isTile = _ref.isTile,
        content = _ref.content,
        formatMessage = _ref.intl.formatMessage,
        messages = _ref.messages,
        userIsBlackedOut = _ref.userIsBlackedOut;
    var type = content.type,
        status = content.status,
        duration = content.duration,
        shortDate = content.shortDate;

    var stampClass = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('media-duration', {
        'media-duration--item': isTile, // gotta pass in the parent doing the embedding because of this class, not cool
        'media-duration--live': status === __WEBPACK_IMPORTED_MODULE_2__enums__["n" /* ContentStatus */].LIVE,
        'media-duration--blackout': userIsBlackedOut
    });

    var stampContent = null;
    if (userIsBlackedOut) {
        stampContent = formatMessage(messages.blackout);
    } else if (type === __WEBPACK_IMPORTED_MODULE_2__enums__["o" /* ContentType */].VOD) {
        // TODO: DTC - remove fallback once `content` has `duration` for VOD
        stampContent = duration || content.streams[0].duration;
    } else {
        switch (status) {
            case __WEBPACK_IMPORTED_MODULE_2__enums__["n" /* ContentStatus */].LIVE:
                stampContent = formatMessage(messages.live);
                break;
            case __WEBPACK_IMPORTED_MODULE_2__enums__["n" /* ContentStatus */].UPCOMING:
                {
                    stampContent = shortDate;
                    break;
                }
            case __WEBPACK_IMPORTED_MODULE_2__enums__["n" /* ContentStatus */].REPLAY:
                // TODO: DTC - remove fallback once `content` has `duration` for VOD
                stampContent = duration || content.streams[0].duration;
                break;
            default:
                stampContent = duration || null;
        }
    }

    if (stampContent) {
        return _jsx('div', {
            className: stampClass
        }, void 0, stampContent);
    }
    return null;
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__common_injectIntl__["a" /* default */])(Stamp));

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = contentSubtitle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums__ = __webpack_require__(1);


function contentSubtitle(_ref) {
    var type = _ref.type,
        _ref$subtitle = _ref.subtitle,
        subtitle = _ref$subtitle === undefined ? '' : _ref$subtitle,
        _ref$streams = _ref.streams,
        streams = _ref$streams === undefined ? [] : _ref$streams;

    // no subtitle with non-auth vod
    if (type === __WEBPACK_IMPORTED_MODULE_0__enums__["o" /* ContentType */].VOD && streams[0] && !streams[0].authTypes) {
        return null;
    }

    return subtitle;
}

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = newRelicTrackEvent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cache_requestCache__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requestProxy__ = __webpack_require__(43);



function newRelicTrackEvent(payload) {
    var newrelicInsertKey = payload.newrelicInsertKey,
        newrelicAccountId = payload.newrelicAccountId,
        trackingData = payload.trackingData;

    var url = 'https://insights-collector.newrelic.com/v1/accounts/' + newrelicAccountId + '/events';

    return __WEBPACK_IMPORTED_MODULE_0__cache_requestCache__["a" /* default */].post(url).send(trackingData).set('X-Insert-Key', newrelicInsertKey).set('Accept', 'application/json').use(__WEBPACK_IMPORTED_MODULE_1__requestProxy__["a" /* default */]).then(function (res) {
        return JSON.stringify(res.body);
    }).catch(function (err) {
        return {
            "success": false,
            "err": err
        };
    });
}

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAppLink;
/* unused harmony export appReady */
/* unused harmony export sendLoadVideosMessage */
/* unused harmony export showWatchStreamByCmsId */
/* unused harmony export showWatchStreamByChannel */
/* unused harmony export navigateToPage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__format_getSiteUrlForPath__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__format_queryString__ = __webpack_require__(18);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/**
 * This library uses the native-bridge library to formulate ESPN App specific link language calls
 */

var nativeBridge = Object(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])();

var PROTOCOL = 'sportscenter://';
var DIRECTIVE = 'x-callback-url';
var BASE_URL = '' + PROTOCOL + DIRECTIVE;

function sendTakeActionMessage(action, urlParams) {
    if (nativeBridge && action && urlParams) {
        nativeBridge.sendMessage('takeAction', {
            url: escape(getAppLink(action, urlParams))
        });
    }
}

function getAppLink(action) {
    var urlParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var useProtocolOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var appLink = void 0;

    // NOTE: Only redirect with PROTOCOL -- `sportscenter://`
    // SEE: https://espnjira.disney.com/browse/WEWEB-2071
    if (useProtocolOnly) {
        return PROTOCOL;
    }

    if (action && urlParams) {
        var actionPath = '' + action + Object(__WEBPACK_IMPORTED_MODULE_2__format_queryString__["a" /* default */])(urlParams, true);
        appLink = BASE_URL + '/' + actionPath;
    }

    return appLink;
}

function appReady() {
    nativeBridge && nativeBridge.sendMessage('onLoadComplete');
}

function sendLoadVideosMessage() {
    var videos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var tracking = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (nativeBridge && videos.length > 0) {
        nativeBridge.sendMessage('loadVideos', { videos: videos, tracking: tracking });
    }
}

var showWatchStreamByCmsId = function showWatchStreamByCmsId(playID) {
    var tracking = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var imageHref = arguments[2];
    var name = arguments[3];
    var network = arguments[4];

    if (playID) {
        sendTakeActionMessage('showWatchStream', _extends({}, tracking, { playID: playID, imageHref: imageHref, name: name, network: network }));
    }
};

var showWatchStreamByChannel = function showWatchStreamByChannel(playChannel) {
    var tracking = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var imageHref = arguments[2];
    var name = arguments[3];
    var network = arguments[4];

    if (playChannel) {
        sendTakeActionMessage('showWatchStream', _extends({}, tracking, { playChannel: playChannel.toLowerCase(), imageHref: imageHref, name: name, network: network }));
    }
};

var navigateToPage = function navigateToPage(path, title) {
    var tracking = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (path) {
        // app teams request we pass a full URL
        var url = Object(__WEBPACK_IMPORTED_MODULE_1__format_getSiteUrlForPath__["a" /* default */])(path);
        sendTakeActionMessage('navigateToPage', _extends({}, tracking, { title: title, url: url }));
    }
};

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__alias_Stamp__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PropTypes__ = __webpack_require__(28);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();






// The description has the exact html for the Hero and Playback items, but different classnames
var HtmlClassMap = {
    HERO: {
        figcaption: 'hero_detail',
        wrapper: 'hero_detail-wrap',
        title: 'hero_title',
        meta: 'hero_meta',
        truncate: 'hero_truncate',
        network: 'hero_network',
        event: 'hero_event'
    },
    PLAYBACK: {
        figcaption: 'playback__figcaption',
        wrapper: 'playback__wrapper',
        title: 'playback__title',
        meta: 'playback__meta',
        truncate: 'playback_truncate',
        network: '',
        event: ''
    }
};

var ContentMetadataLarge = function ContentMetadataLarge(_ref) {
    var blurredImage = _ref.blurredImage,
        title = _ref.title,
        subtitle = _ref.subtitle,
        content = _ref.content,
        isHero = _ref.isHero,
        showLock = _ref.showLock,
        userIsBlackedOut = _ref.userIsBlackedOut;

    var context = isHero ? 'HERO' : 'PLAYBACK';
    var metaDataClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(HtmlClassMap[context].meta, 'icon-font-before', {
        'icon-lock-solid-before': showLock
    });

    return _jsx('figcaption', {
        className: HtmlClassMap[context].figcaption
    }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1__alias_Stamp__["a" /* default */], {
        content: content,
        userIsBlackedOut: userIsBlackedOut
    }), blurredImage, _jsx('div', {
        className: HtmlClassMap[context].wrapper
    }, void 0, _jsx('div', {
        className: HtmlClassMap[context].title
    }, void 0, title), _jsx('div', {
        className: metaDataClass
    }, void 0, _jsx('div', {
        className: HtmlClassMap[context].truncate
    }, void 0, subtitle && _jsx('span', {}, void 0, subtitle)))));
};

ContentMetadataLarge.defaultProps = {
    blurredImage: null,
    title: '',
    subtitle: ''
};

/* harmony default export */ __webpack_exports__["a"] = (ContentMetadataLarge);

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors_appSelector__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__selectors_pageSelector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__search_SearchResultAsList__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__enums__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__buckets_Bucket__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__injectIntl__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DownloadLink__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_apiAction__ = __webpack_require__(55);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var overflowStyle = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
};

var SearchResultsContainer = function (_Component) {
    _inherits(SearchResultsContainer, _Component);

    function SearchResultsContainer(props) {
        _classCallCheck(this, SearchResultsContainer);

        var _this = _possibleConstructorReturn(this, (SearchResultsContainer.__proto__ || Object.getPrototypeOf(SearchResultsContainer)).call(this, props));

        _this.appendScore = _this.appendScore.bind(_this);
        _this.fillBuckets = _this.fillBuckets.bind(_this);
        _this.changeSortOrder = _this.changeSortOrder.bind(_this);
        _this.state = { buckets: [] };
        return _this;
    }

    _createClass(SearchResultsContainer, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.scored && !this.props.scored || nextProps.searchTerm !== this.props.searchTerm) {
                var searchType = __WEBPACK_IMPORTED_MODULE_10__actions_apiAction__["a" /* SEARCH_TYPES */].search;
                if (__WEBPACK_IMPORTED_MODULE_5__enums__["y" /* PageType */].SID === nextProps.pageType) {
                    searchType = __WEBPACK_IMPORTED_MODULE_10__actions_apiAction__["a" /* SEARCH_TYPES */].listingsByCompetitor;
                }
                this.fillBuckets(nextProps.searchTerm, searchType);
            }
        }
    }, {
        key: 'getContainerHeader',
        value: function getContainerHeader() {
            var _props = this.props,
                messages = _props.messages,
                searchTerm = _props.searchTerm,
                pageType = _props.pageType;

            var downloadLink = void 0;

            if (pageType === __WEBPACK_IMPORTED_MODULE_5__enums__["y" /* PageType */].SID && searchTerm.length > 0) {
                var fileName = this.state.pageName + '-Schedule.csv';
                downloadLink = _jsx(__WEBPACK_IMPORTED_MODULE_9__DownloadLink__["a" /* default */], {
                    buckets: this.state.buckets,
                    text: 'Download Schedule',
                    fileName: fileName,
                    mimeType: 'text/csv'
                });
            }

            return _jsx('div', {
                className: 'search-results-header',
                style: { textAlign: 'center', padding: '16px' }
            }, void 0, _jsx('h1', {}, void 0, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */], _extends({}, messages['search.results.message'], {
                values: {
                    query: _jsx('strong', {
                        style: overflowStyle
                    }, void 0, searchTerm)
                }
            }))), downloadLink, _jsx('hr', {
                width: '98%'
            }));
        }
    }, {
        key: 'appendScore',
        value: function appendScore(contents) {
            if (this.props.apiEnv !== __WEBPACK_IMPORTED_MODULE_5__enums__["b" /* Api */].Env.DEV) {
                return contents;
            }
            return contents.map(function (content) {
                if (content.name) {
                    if (!content.name.match(/\(\d*\)/g)) {
                        content.name = '(' + content.score + ') - ' + content.name;
                    }
                }
                return content;
            });
        }
    }, {
        key: 'fillBuckets',
        value: function fillBuckets(query) {
            var queryType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_10__actions_apiAction__["a" /* SEARCH_TYPES */].search;

            var _this2 = this;

            var sortBy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'startTime';
            var sortOrder = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : __WEBPACK_IMPORTED_MODULE_5__enums__["D" /* SortOrder */].DESC;
            var _props2 = this.props,
                dispatch = _props2.dispatch,
                apiEnv = _props2.apiEnv;

            dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_apiAction__["i" /* getSearchResults */])(query, apiEnv, queryType, sortBy, sortOrder)).then(function (_ref) {
                var _ref$page = _ref.page,
                    _ref$page$buckets = _ref$page.buckets,
                    buckets = _ref$page$buckets === undefined ? [] : _ref$page$buckets,
                    pageName = _ref$page.name;
                return _this2.setState({ buckets: buckets, pageName: pageName });
            }).catch(function (err) {
                return console.warn(err);
            });
        }
    }, {
        key: 'changeSortOrder',
        value: function changeSortOrder(sortBy, sortOrder) {
            var searchTerm = this.props.searchTerm;

            this.fillBuckets(searchTerm, __WEBPACK_IMPORTED_MODULE_10__actions_apiAction__["a" /* SEARCH_TYPES */].listingsByCompetitor, sortBy, sortOrder);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            if (!this.props.enableSearch) {
                return null;
            }
            var pageType = this.props.pageType;

            var containerHeader = this.getContainerHeader();

            var bucketResults = void 0;
            var buckets = this.state.buckets || [];
            if (buckets.length > 0 && pageType !== __WEBPACK_IMPORTED_MODULE_5__enums__["y" /* PageType */].SID) {
                bucketResults = buckets.map(function (bucket, index) {
                    var id = bucket.id,
                        name = bucket.name,
                        metadata = bucket.metadata,
                        _bucket$contents = bucket.contents,
                        contents = _bucket$contents === undefined ? [] : _bucket$contents,
                        _bucket$tags = bucket.tags,
                        tags = _bucket$tags === undefined ? [] : _bucket$tags;

                    var tag = name === 'Videos' ? __WEBPACK_IMPORTED_MODULE_5__enums__["i" /* BucketLayout */].LARGE_EXPANDABLE : __WEBPACK_IMPORTED_MODULE_5__enums__["i" /* BucketLayout */].DEFAULT_EXPANDABLE;
                    return _jsx(__WEBPACK_IMPORTED_MODULE_7__buckets_Bucket__["a" /* default */], {
                        contents: _this3.appendScore(contents),
                        index: index,
                        layoutType: __WEBPACK_IMPORTED_MODULE_5__enums__["i" /* BucketLayout */].DEFAULT_UNLIMITED,
                        metadata: metadata,
                        name: name,
                        pageType: pageType,
                        tags: [tag].concat(_toConsumableArray(tags))
                    }, id + '-' + name);
                });
            } else if (pageType === __WEBPACK_IMPORTED_MODULE_5__enums__["y" /* PageType */].SID) {
                bucketResults = buckets.map(function (bucket) {
                    var _bucket$contents2 = bucket.contents,
                        contents = _bucket$contents2 === undefined ? [] : _bucket$contents2;

                    return _jsx(__WEBPACK_IMPORTED_MODULE_4__search_SearchResultAsList__["a" /* default */], {
                        contents: contents,
                        sortContents: _this3.changeSortOrder
                    });
                });
            }
            return _jsx('div', {
                className: 'search-result-container',
                style: { backgroundColor: 'white' }
            }, void 0, containerHeader, bucketResults);
        }
    }]);

    return SearchResultsContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
    return {
        apiEnv: Object(__WEBPACK_IMPORTED_MODULE_2__selectors_appSelector__["c" /* apiEnvSelector */])(state),
        enableSearch: Object(__WEBPACK_IMPORTED_MODULE_2__selectors_appSelector__["l" /* enableSearchSelector */])(state),
        scored: Object(__WEBPACK_IMPORTED_MODULE_3__selectors_pageSelector__["c" /* default */])(state).scored
    };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__injectIntl__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(SearchResultsContainer)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(4);

// EXTERNAL MODULE: ./app/enums.js
var enums = __webpack_require__(1);

// EXTERNAL MODULE: ./app/lib/util/isEmpty.js
var isEmpty = __webpack_require__(12);

// EXTERNAL MODULE: ./app/common/actions/authenticationActions.js
var authenticationActions = __webpack_require__(22);

// EXTERNAL MODULE: ./app/common/selectors/appSelector.js + 1 modules
var appSelector = __webpack_require__(3);

// EXTERNAL MODULE: ./app/common/selectors/pageSelector.js
var pageSelector = __webpack_require__(13);

// EXTERNAL MODULE: ./app/common/selectors/providerSelector.js
var providerSelector = __webpack_require__(53);

// EXTERNAL MODULE: ./node_modules/selectn/index.js
var selectn = __webpack_require__(112);
var selectn_default = /*#__PURE__*/__webpack_require__.n(selectn);

// CONCATENATED MODULE: ./app/lib/ui/isChromeOrSafari.js
function isChromeOrSafari() {
    if (typeof window !== 'undefined') {
        var isSafari = /safari|applewebkit/i.test(navigator.userAgent);
        var isChrome = !!window.chrome && !!window.chrome.webstore;
        return isSafari || isChrome;
    }
    return false;
}
// EXTERNAL MODULE: ./app/common/injectIntl.js
var injectIntl = __webpack_require__(20);

// CONCATENATED MODULE: ./app/webapp/branding/Logout.js
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var logoutStyle = {
    boxShadow: '0 0 6px rgba(0,0,0,0.2)'
};

var Logout = function Logout(_ref) {
    var handleLogout = _ref.handleLogout,
        message = _ref.message,
        buttonLabel = _ref.buttonLabel;
    return _jsx('div', {
        className: 'playback__logout',
        style: logoutStyle
    }, void 0, _jsx('h2', {}, void 0, message), _jsx('a', {
        className: 'button med stand-alone',
        onClick: handleLogout
    }, void 0, buttonLabel));
};

/* harmony default export */ var branding_Logout = (Logout);
// CONCATENATED MODULE: ./app/webapp/branding/ProviderSettings.js
var ProviderSettings__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();





var ProviderSettings_ProviderSettings = function ProviderSettings(_ref) {
    var displayLogout = _ref.displayLogout,
        handleLogin = _ref.handleLogin,
        handleLogout = _ref.handleLogout,
        providerInfo = _ref.providerInfo,
        messages = _ref.messages,
        formatMessage = _ref.intl.formatMessage;

    var logoutEl = displayLogout ? ProviderSettings__jsx(branding_Logout, {
        handleLogout: handleLogout,
        message: formatMessage(messages['signout.message'], { providerName: providerInfo.name }),
        buttonLabel: formatMessage(messages['signout.label'])
    }) : null;
    var logoutClass = displayLogout === true ? 'playback__settingsLink icon-font-before icon-caret-down-solid-before' : 'playback__settingsLink icon-font-before';

    return ProviderSettings__jsx('div', {
        className: 'playback__settings playback__settings--active'
    }, void 0, ProviderSettings__jsx('a', {
        className: logoutClass,
        onClick: handleLogin
    }, void 0, ProviderSettings__jsx('span', {
        className: 'playback__settingsText'
    }, void 0, formatMessage(messages['provider.dialog.title']))), logoutEl);
};

ProviderSettings_ProviderSettings.defaultProps = {
    providerInfo: {}
};

/* harmony default export */ var branding_ProviderSettings = (Object(injectIntl["a" /* default */])(ProviderSettings_ProviderSettings));
// CONCATENATED MODULE: ./app/webapp/branding/ProviderLogo.js
var ProviderLogo__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();






function BrandingElement(props) {
    if (!props.branding) {
        return null;
    }
    var _props$branding = props.branding,
        brandingName = _props$branding.name,
        brandingLogoUrl = _props$branding.logoUrl;

    return ProviderLogo__jsx('div', {}, void 0, ProviderLogo__jsx('a', {
        className: 'sportbrand__watch',
        onClick: function onClick(event) {
            event.preventDefault();
            window.location = '/watch/';
        }
    }, void 0, ProviderLogo__jsx('img', {
        src: brandingLogoUrl,
        className: 'imageLoaded',
        alt: brandingName
    })));
}


var ProviderLogo_ProviderLogo = function ProviderLogo(_ref) {
    var displayLogout = _ref.displayLogout,
        handleLogout = _ref.handleLogout,
        providerInfo = _ref.providerInfo,
        branding = _ref.branding;

    var imgSrc = selectn_default()('images.colorWithPositiveBackground.href', providerInfo) || selectn_default()('images.logo.href', providerInfo) || '';
    var webLink = selectn_default()('links.web.href', providerInfo) || '/watch';
    var target = '';
    var imgStyle = {
        borderLeftWidth: 0
    };
    // hack for browser inconsistencies of rendering svgs in images
    if (isChromeOrSafari()) {
        imgStyle.width = 'auto';
    }
    var providerImg = imgSrc ? ProviderLogo__jsx('img', {
        src: imgSrc,
        className: 'imageLoaded',
        style: imgStyle,
        alt: 'Provider'
    }) : null;
    if (providerImg !== null) {
        target = '_blank';
    }
    var loggedInClass = 'playback__header--loggedIn';
    return ProviderLogo__jsx('div', {
        className: 'sportbrand ' + loggedInClass
    }, void 0, ProviderLogo__jsx(BrandingElement, {
        branding: branding
    }), ProviderLogo__jsx('a', {
        className: 'playback__provider sportbrand__provider',
        target: target,
        href: webLink
    }, void 0, providerImg), ProviderLogo__jsx(branding_ProviderSettings, {
        displayLogout: displayLogout,
        handleLogout: handleLogout,
        providerInfo: providerInfo,
        providerName: providerInfo.name
    }));
};

ProviderLogo_ProviderLogo.defaultProps = {
    providerInfo: {}
};

/* harmony default export */ var branding_ProviderLogo = (ProviderLogo_ProviderLogo);
// EXTERNAL MODULE: ./app/common/LinkWithFlags.js
var LinkWithFlags = __webpack_require__(147);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(14);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// CONCATENATED MODULE: ./app/webapp/branding/ProviderLogoPlayback.js
var ProviderLogoPlayback__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();







function ProviderLogoPlayback_BrandingElement(props) {
    if (!props.branding) {
        var backArrowStyle = {
            fontSize: '16px',
            color: '#FFFFFF'
        };

        var backTextStyle = {
            font: 'SF UI Text Regular',
            fontSize: '14px',
            color: '#FFFFFF'
        };

        var backStyle = {
            marginBottom: '10px'
        };
        return ProviderLogoPlayback__jsx('a', {
            style: backStyle,
            onClick: function onClick() {
                return window.history.back();
            }
        }, void 0, ProviderLogoPlayback__jsx('span', {
            className: 'icon-font-before icon-caret-left-solid-before',
            style: backArrowStyle
        }), ProviderLogoPlayback__jsx('span', {
            style: backTextStyle
        }, void 0, 'Back'));
    }
    var _props$branding = props.branding,
        brandingName = _props$branding.name,
        brandingLogoUrl = _props$branding.logoUrl;

    return ProviderLogoPlayback__jsx('div', {
        className: 'playback__logo'
    }, void 0, ProviderLogoPlayback__jsx(LinkWithFlags["a" /* default */], {
        'data-route': 'false',
        className: 'playback__logo__link',
        to: '/'
    }, void 0, ProviderLogoPlayback__jsx('picture', {}, void 0, ProviderLogoPlayback__jsx('img', {
        src: brandingLogoUrl,
        className: 'imageLoaded',
        alt: brandingName,
        style: { width: 'auto', maxWidth: 150 }
    }))));
}


var ProviderLogoPlayback_ProviderLogoPlayback = function ProviderLogoPlayback(_ref) {
    var displayLogout = _ref.displayLogout,
        handleLogin = _ref.handleLogin,
        handleLogout = _ref.handleLogout,
        hideProviderLogo = _ref.hideProviderLogo,
        loggedIn = _ref.loggedIn,
        providerInfo = _ref.providerInfo,
        branding = _ref.branding;

    var headerClass = classnames_default()('playback__header', {
        'playback__header--loggedIn': loggedIn
    });
    var imgSrc = selectn_default()('images.colorWithNegativeBackground.href', providerInfo) || selectn_default()('images.logo.href', providerInfo) || '';
    var webLink = selectn_default()('links.web.href', providerInfo) || '/watch';
    var target = '';
    var providerLogoEl = null;
    var providerSettingsEl = null;
    var providerImg = imgSrc !== '' ? ProviderLogoPlayback__jsx('img', {
        src: imgSrc,
        className: 'imageLoaded',
        style: { verticalAlign: '2px' },
        alt: 'Provider'
    }) : null;

    if (providerImg !== null) {
        target = '_blank';
    }

    if (!hideProviderLogo) {
        // PageShell CSS enforces a `display: none` rule on provider logos.
        // To avoid clashes with PageShell CSS, we overwrite styles here via JS inline styles
        providerLogoEl = ProviderLogoPlayback__jsx('div', {
            className: 'playback__provider',
            style: { display: 'inline-block' }
        }, void 0, ProviderLogoPlayback__jsx('a', {
            className: 'playback__logo__link',
            target: target,
            href: webLink
        }, void 0, ProviderLogoPlayback__jsx('picture', {}, void 0, providerImg)));

        providerSettingsEl = ProviderLogoPlayback__jsx(branding_ProviderSettings, {
            displayLogout: displayLogout,
            handleLogin: handleLogin,
            handleLogout: handleLogout,
            providerInfo: providerInfo
        });
    }

    return ProviderLogoPlayback__jsx('header', {
        className: headerClass
    }, void 0, ProviderLogoPlayback__jsx(ProviderLogoPlayback_BrandingElement, {
        branding: branding
    }), providerLogoEl, providerSettingsEl);
};

ProviderLogoPlayback_ProviderLogoPlayback.defaultProps = {
    providerInfo: {}
};

/* harmony default export */ var branding_ProviderLogoPlayback = (ProviderLogoPlayback_ProviderLogoPlayback);
// CONCATENATED MODULE: ./app/webapp/branding/BrandingContainer.js
var BrandingContainer__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var BrandingContainer_BrandingContainer = function (_Component) {
    _inherits(BrandingContainer, _Component);

    function BrandingContainer(props, context) {
        _classCallCheck(this, BrandingContainer);

        var _this = _possibleConstructorReturn(this, (BrandingContainer.__proto__ || Object.getPrototypeOf(BrandingContainer)).call(this, props, context));

        _this.handleLogout = _this.handleLogout.bind(_this);
        _this.handleLogoutFromPlaybackPage = _this.handleLogoutFromPlaybackPage.bind(_this);
        _this.handleLogin = _this.handleLogin.bind(_this);
        return _this;
    }

    // for homepage, after user logs out, refresh page to avoid DOM maintainance (since player bundle manipulates DOM directly)


    _createClass(BrandingContainer, [{
        key: 'handleLogout',
        value: function handleLogout(event) {
            event.preventDefault();
            var _props = this.props,
                stream = _props.stream,
                dispatch = _props.dispatch;

            dispatch(Object(authenticationActions["C" /* createAndPerformLogoutAction */])(stream)).finally(function () {
                window.location = window.location;
            });
        }

        // from the playback page, we're able to logout without refreshing

    }, {
        key: 'handleLogoutFromPlaybackPage',
        value: function handleLogoutFromPlaybackPage(event) {
            event.preventDefault();
            var _props2 = this.props,
                stream = _props2.stream,
                dispatch = _props2.dispatch;

            dispatch(Object(authenticationActions["C" /* createAndPerformLogoutAction */])(stream));
        }
    }, {
        key: 'handleLogin',
        value: function handleLogin(event) {
            var _this2 = this;

            event.preventDefault();
            this.props.dispatch(Object(authenticationActions["D" /* createAndPerformStartAuthenticationAction */])(null)).then(function (isAuthenticated) {
                if (isAuthenticated === false) {
                    _this2.props.dispatch(Object(authenticationActions["N" /* createDisplayProviderDialogAction */])());
                }
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props3 = this.props,
                branding = _props3.branding,
                isDomestic = _props3.isDomestic,
                isMobile = _props3.isMobile,
                location = _props3.location,
                providerInfo = _props3.providerInfo,
                roadblock = _props3.roadblock,
                userAuth = _props3.userAuth;

            var loggedIn = userAuth.indexOf(enums["e" /* AuthTypes */].MVPD) !== -1 || userAuth.indexOf(enums["e" /* AuthTypes */].ISP) !== -1;
            var displayLogout = !Object(isEmpty["a" /* default */])(providerInfo) && userAuth.indexOf(enums["e" /* AuthTypes */].MVPD) !== -1;
            var isPlayerPage = location && location.pathname === '/player';
            var hideProviderLogo = isDomestic && isPlayerPage || roadblock && isMobile;
            // different logo for player page, watch logo also visible while authd
            if (isPlayerPage) {
                return BrandingContainer__jsx(branding_ProviderLogoPlayback, {
                    displayLogout: displayLogout,
                    handleLogin: this.handleLogin,
                    handleLogout: this.handleLogoutFromPlaybackPage,
                    hideProviderLogo: hideProviderLogo,
                    loggedIn: loggedIn,
                    providerInfo: providerInfo,
                    userAuth: userAuth,
                    branding: isDomestic ? null : branding
                });
            }

            if (hideProviderLogo) {
                return null;
            }

            return BrandingContainer__jsx(branding_ProviderLogo, {
                displayLogout: displayLogout,
                handleLogout: this.handleLogout,
                providerInfo: providerInfo,
                userAuth: userAuth,
                branding: isDomestic ? null : branding
            });
        }
    }]);

    return BrandingContainer;
}(react["Component"]);

BrandingContainer_BrandingContainer.defaultProps = {
    userAuth: [],
    providerInfo: {}
};

var BrandingContainer_mapStateToProps = function mapStateToProps(state) {
    var _state$app = state.app;
    _state$app = _state$app === undefined ? {} : _state$app;
    var _state$app$isMobile = _state$app.isMobile,
        isMobile = _state$app$isMobile === undefined ? false : _state$app$isMobile;
    var userAuth = state.authentication.authTypes;

    return {
        branding: Object(pageSelector["a" /* brandingSelector */])(state),
        isDomestic: Object(appSelector["s" /* isDomesticSelector */])(state),
        isMobile: isMobile,
        providerInfo: Object(providerSelector["a" /* default */])(state),
        roadblock: Object(appSelector["D" /* roadblockSelector */])(state),
        userAuth: userAuth
    };
};

/* harmony default export */ var branding_BrandingContainer = __webpack_exports__["a"] = (Object(es["b" /* connect */])(BrandingContainer_mapStateToProps)(BrandingContainer_BrandingContainer));

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(4);

// EXTERNAL MODULE: ./node_modules/react-router-redux/lib/index.js
var lib = __webpack_require__(69);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./app/common/injectIntl.js
var injectIntl = __webpack_require__(20);

// EXTERNAL MODULE: ./app/lib/format/apiDateFormatter.js
var apiDateFormatter = __webpack_require__(105);

// EXTERNAL MODULE: ./app/lib/format/dateFormat.js
var dateFormat = __webpack_require__(33);

// EXTERNAL MODULE: ./app/common/schedule/actions/index.js
var actions = __webpack_require__(95);

// EXTERNAL MODULE: ./app/common/Select.js
var Select = __webpack_require__(359);

// EXTERNAL MODULE: ./node_modules/lodash/findIndex.js
var findIndex = __webpack_require__(208);
var findIndex_default = /*#__PURE__*/__webpack_require__.n(findIndex);

// EXTERNAL MODULE: ./app/common/schedule/DateSlider.js
var DateSlider = __webpack_require__(745);

// EXTERNAL MODULE: ./app/common/schedule/StatusFilter.js
var StatusFilter = __webpack_require__(96);

// CONCATENATED MODULE: ./app/common/schedule/FilterGroup.js
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }










var FilterGroup_FilterGroup = function FilterGroup(_ref) {
    var _labels;

    var isIntl = _ref.isIntl,
        location = _ref.location,
        isResponsive = _ref.isResponsive,
        categories = _ref.categories,
        channels = _ref.channels,
        onDateSelectorChange = _ref.onDateSelectorChange,
        onStatusFilterChange = _ref.onStatusFilterChange,
        onSportsFilterChange = _ref.onSportsFilterChange,
        onNetworkFilterChange = _ref.onNetworkFilterChange,
        showSportOptions = _ref.showSportOptions,
        showNetworkOptions = _ref.showNetworkOptions,
        messages = _ref.messages,
        formatMessage = _ref.intl.formatMessage;

    var query = location.query;
    var statusDefaultSelection = query.type || StatusFilter["a" /* default */].Options.LIVE;
    var watchRegion = query.watchRegion;
    var sportOptions = showSportOptions ? [{ label: formatMessage(messages['schedule.allSports']), value: undefined, type: 'category' }].concat(categories.map(function (cat) {
        return { label: cat.name || cat.guid, value: cat.guid, type: cat.type, id: cat.id };
    })) : null;

    var networkOptions = showNetworkOptions ? [{ label: formatMessage(messages['schedule.allNetworks']), value: '' }].concat([].concat(_toConsumableArray(channels)).map(function (channel) {
        return {
            label: channel.name,
            value: channel.guid,
            id: channel.guid
        };
    })) : null;
    var sportDefaultSelection = sportOptions && findIndex_default()(sportOptions, function (option) {
        return option.value === query.categoryId;
    });
    var networkDefaultSelection = networkOptions && findIndex_default()(networkOptions, function (option) {
        return option.value === query.channel;
    });

    var hasDatesParam = query.dates && /^\d{8}/.test(query.dates); // This is meant to be for syndicated player
    var startDateStr = query.startDate;
    var sliderDateStr = void 0;
    var maxDaysInFuture = void 0;
    if (hasDatesParam) {
        var _query$dates$split = query.dates.split('-'),
            _query$dates$split2 = _slicedToArray(_query$dates$split, 2),
            start = _query$dates$split2[0],
            end = _query$dates$split2[1];

        var today = dateFormat["a" /* default */].dateToKey(new Date());
        startDateStr = today < start ? start : today;
        if (end && end > startDateStr) {
            var endDateStr = end;
            maxDaysInFuture = parseInt(endDateStr, 10) - parseInt(startDateStr, 10) + 1;
        }
        sliderDateStr = startDateStr;
    }
    var sliderDate = dateFormat["a" /* default */].paramToDate(sliderDateStr) || new Date();
    var dateSelector = statusDefaultSelection === StatusFilter["a" /* default */].Options.UPCOMING ? _jsx(DateSlider["a" /* default */], {
        date: sliderDate,
        onDateSelected: onDateSelectorChange,
        maxDaysInFuture: maxDaysInFuture,
        isResponsive: isResponsive,
        isIntl: isIntl,
        messages: messages,
        formatMessage: formatMessage,
        watchRegion: watchRegion
    }) : null;
    var replayDateSelector = null;
    if (statusDefaultSelection === StatusFilter["a" /* default */].Options.REPLAY) {
        var isReplaySlider = true;
        replayDateSelector = _jsx(DateSlider["a" /* default */], {
            date: sliderDate,
            onDateSelected: onDateSelectorChange,
            maxDaysInFuture: 0,
            maxDaysInPast: 30,
            isResponsive: isResponsive,
            isReplaySlider: isReplaySlider,
            isIntl: isIntl,
            messages: messages,
            formatMessage: formatMessage,
            watchRegion: watchRegion
        });
    }

    var needSeparator = sportOptions || networkOptions || replayDateSelector;

    return _jsx('div', {
        className: 'filter-group-wrap'
    }, void 0, _jsx(StatusFilter["a" /* default */], {
        selected: statusDefaultSelection,
        handleClick: onStatusFilterChange,
        labels: (_labels = {}, _defineProperty(_labels, StatusFilter["a" /* default */].Options.LIVE, formatMessage(messages['schedule.live'])), _defineProperty(_labels, StatusFilter["a" /* default */].Options.UPCOMING, formatMessage(messages['schedule.upcoming'])), _defineProperty(_labels, StatusFilter["a" /* default */].Options.REPLAY, formatMessage(messages['schedule.replay'])), _labels)
    }), _jsx('div', {
        className: needSeparator ? 'filters' : ''
    }, void 0, sportOptions ? _jsx(Select["a" /* default */], {
        defaultSelection: sportDefaultSelection,
        options: sportOptions,
        onChange: onSportsFilterChange
    }) : null, networkOptions ? _jsx(Select["a" /* default */], {
        defaultSelection: networkDefaultSelection,
        options: networkOptions,
        onChange: onNetworkFilterChange
    }) : null), _jsx('div', {
        className: 'replaydate-wrap'
    }, void 0, replayDateSelector), _jsx('div', {
        className: 'datepicker-wrap'
    }, void 0, dateSelector));
};

FilterGroup_FilterGroup.defaultProps = {
    categories: [],
    channels: [],
    showSportOptions: true,
    showNetworkOptions: true
};

/* harmony default export */ var schedule_FilterGroup = (FilterGroup_FilterGroup);
// EXTERNAL MODULE: ./app/common/selectors/appSelector.js + 1 modules
var appSelector = __webpack_require__(3);

// EXTERNAL MODULE: ./app/common/selectors/flagsSelector.js
var flagsSelector = __webpack_require__(47);

// EXTERNAL MODULE: ./app/common/selectors/routingSelector.js
var routingSelector = __webpack_require__(23);

// CONCATENATED MODULE: ./app/common/schedule/FilterGroupContainer.js
/* unused harmony export updateQuery */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// eslint-disable-next-line no-unused-vars













function updateQuery(dispatch, ownProps, newQuery) {
    var flags = ownProps.flags,
        location = ownProps.location,
        fetchAction = ownProps.fetchAction;
    var _location$query = location.query,
        query = _location$query === undefined ? {} : _location$query;

    query = _extends({}, query, newQuery, flags);
    dispatch(Object(lib["replace"])(_extends({}, location, { query: query })));
    dispatch(fetchAction(query));
}

var FilterGroupContainer_mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
    return {
        onSportsFilterChange: function onSportsFilterChange(option) {
            updateQuery(dispatch, ownProps, {
                categoryId: option.value ? option.value : undefined
            });
        },
        onReplayDateSelectorChange: function onReplayDateSelectorChange(option) {
            var startDate = new Date();
            var date = startDate.getDate();
            startDate.setDate(date - option.value);
            var endDate = new Date();

            updateQuery(dispatch, ownProps, {
                startDate: Object(apiDateFormatter["a" /* default */])(startDate),
                endDate: Object(apiDateFormatter["a" /* default */])(endDate)
            });
        },
        onNetworkFilterChange: function onNetworkFilterChange(option) {
            updateQuery(dispatch, ownProps, {
                channel: option.value || undefined
            });
        },
        onDateSelectorChange: function onDateSelectorChange(date) {
            updateQuery(dispatch, ownProps, {
                startDate: Object(apiDateFormatter["a" /* default */])(date)
            });
        },
        onStatusFilterChange: function onStatusFilterChange(status) {
            dispatch(Object(actions["l" /* setStatusFilter */])(status));

            var _ownProps$location$qu = ownProps.location.query;
            _ownProps$location$qu = _ownProps$location$qu === undefined ? {} : _ownProps$location$qu;
            var dates = _ownProps$location$qu.dates;

            var hasDatesParam = dates && /^\d{8}/.test(dates);
            var startDate = void 0;
            var endDate = void 0;
            if (status === 'upcoming' && hasDatesParam) {
                // for syndicated player
                var start = dates.split('-')[0];
                var today = dateFormat["a" /* default */].dateToKey(new Date());
                startDate = start > today ? start : today;
            }

            updateQuery(dispatch, ownProps, {
                type: status,
                startDate: startDate,
                endDate: endDate
            });
        }
    };
};

var FilterGroupContainer_mapStateToProps = function mapStateToProps(state) {
    var _routingSelector = Object(routingSelector["a" /* default */])(state),
        locationBeforeTransitions = _routingSelector.locationBeforeTransitions;

    var _ref = locationBeforeTransitions || {},
        _ref$pathname = _ref.pathname,
        pathname = _ref$pathname === undefined ? '' : _ref$pathname;

    var isResponsive = pathname !== '/syndicated/player';
    return {
        isIntl: Object(appSelector["u" /* isIntlSelector */])(state),
        flags: Object(flagsSelector["a" /* persistentFlagsSelector */])(state),
        isResponsive: isResponsive
    };
};

var FilterGroupContainer = Object(es["b" /* connect */])(FilterGroupContainer_mapStateToProps, FilterGroupContainer_mapDispatchToProps)(Object(injectIntl["a" /* default */])(schedule_FilterGroup));

FilterGroupContainer.defaultProps = {
    fetchAction: actions["j" /* fetchSchedule */]
};

FilterGroupContainer.propTypes = {
    fetchAction: react["PropTypes"].func
};

/* harmony default export */ var schedule_FilterGroupContainer = __webpack_exports__["a"] = (FilterGroupContainer);

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Select = function (_Component) {
    _inherits(Select, _Component);

    function Select(props) {
        _classCallCheck(this, Select);

        var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

        _this.handleClick = _this.handleClick.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.state = { selected: _this.getDefaultSelection() };
        return _this;
    }

    /**
     * componentWillReceiveProps has been deprecate since React 16.3.
     * It needs to be replaced with getDerivedStateFromProps if we update
     * to React 16.3+
     */


    _createClass(Select, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.defaultSelection !== this.props.defaultSelection) {
                this.setState({ selected: nextProps.defaultSelection });
            }
        }
    }, {
        key: 'getDefaultSelection',
        value: function getDefaultSelection() {
            var defaultSelection = this.props.defaultSelection;

            return defaultSelection >= 0 ? defaultSelection : 0;
        }
    }, {
        key: 'handleClick',
        value: function handleClick(index, option, event) {
            this.setState({ selected: index });
            this.props.onChange(option);
            event.preventDefault();
            event.stopPropagation();
        }
    }, {
        key: 'handleChange',
        value: function handleChange(event) {
            var index = null;
            var eventValue = event.target.value;

            var selectedValue = eventValue && eventValue.toString();
            var _props = this.props,
                options = _props.options,
                onChange = _props.onChange;

            index = options.map(function (_ref) {
                var value = _ref.value,
                    label = _ref.label;
                return value || label;
            }).indexOf(selectedValue);

            if (index !== null) {
                /**
                 * first option value in the dropdown is -1, option[-1] returns undefined,
                 * so we need to reset it to 0 to avoid array out of bounds exception.
                 * We can't setState selected to 0 directly, since setState({selected: -1}) will trigger
                 * companonent rerender, in app/espnapp/schedule/ScheduleCategorySection.js which is
                 * what we expected
                 */
                var option = index > 0 ? options[index] : options[0];
                this.setState({ selected: index });
                onChange(option);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props2 = this.props,
                _props2$options = _props2.options,
                options = _props2$options === undefined ? [] : _props2$options,
                menuSizeClass = _props2.menuSizeClass,
                name = _props2.name;
            var selected = this.state.selected;

            var menuClassName = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('dropdown-menu', menuSizeClass);
            var selectedOption = selected > 0 ? options[selected] : options[0];

            return _jsx('span', {
                className: 'dropdown-wrapper-container'
            }, void 0, _jsx('div', {
                className: 'dropdown-wrapper display-desktop hoverable',
                'data-behavior': 'button_dropdown'
            }, void 0, _jsx('button', {
                type: 'button',
                className: 'button-filter med dropdown-toggle'
            }, void 0, selectedOption.label), _jsx('ul', {
                className: menuClassName,
                role: 'menu'
            }, void 0, options.map(function (option, index) {
                return _jsx('li', {}, 'select-' + option.label + '-' + option.id, _jsx('a', {
                    onClick: function onClick(event) {
                        _this2.handleClick(index, option, event);
                    }
                }, void 0, option.label));
            }))), _jsx('div', {
                className: 'dropdown-wrapper display-mobile mobile-dropdown'
            }, void 0, _jsx('span', {
                className: 'mobile-arrow'
            }), _jsx('select', {
                onChange: this.handleChange,
                value: selectedOption.value,
                name: name
            }, void 0, options.map(function (opt) {
                return _jsx('option', {
                    value: opt.value || opt.label
                }, 'selectmobile-' + opt.label + '-' + opt.id, opt.label);
            }))));
        }
    }]);

    return Select;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Select.defaultProps = {
    onChange: function onChange() {},
    menuSizeClass: 'med',
    defaultSelection: 0
};

/* harmony default export */ __webpack_exports__["a"] = (Select);

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPacRimOrCarib;
function isPacRimOrCarib(regionCode) {
    return regionCode === 'pacrim' || regionCode === 'caribbean';
}

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_groupBy__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_groupBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_groupBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_uniqBy__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_format_apiDateFormatter__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_format_dateFormat__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__injectIntl__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__selectors_appSelector__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__selectors_authenticationSelectors__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__selectors_darkThemeSelector__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__alias_ScheduleCategorySection__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__StatusFilter__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__isPacRimOrCarib__ = __webpack_require__(360);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();


















var compareObjectsByName = function compareObjectsByName(noCategoryMapping) {
    return function (objA, objB) {
        var aName = objA.name.trim().toLowerCase();
        var bName = objB.name.trim().toLowerCase();

        if (aName === noCategoryMapping) {
            return 1;
        }
        if (bName === noCategoryMapping) {
            return -1;
        }
        if (aName > bName) {
            return 1;
        } else if (aName < bName) {
            return -1;
        }
        return 0;
    };
};

var getTranslatedTab = function getTranslatedTab(messages, formatMessageFn) {
    return function () {
        var selectedTab = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

        var key = 'schedule.' + selectedTab.toLowerCase();
        if (type === 'selectedTabError') {
            key = key + '.selectedTabError';
        }

        var translatedSelectedTab = formatMessageFn(messages[key]) || '';

        if (translatedSelectedTab === '') {
            return selectedTab;
        }

        return translatedSelectedTab;
    };
};

var getTranslatedDate = function getTranslatedDate(date, formatMessage, messages, lang) {
    if (lang === 'en') {
        return date;
    }
    try {
        var arr = date.split(' ');
        var weekDay = arr[0].replace(',', '');
        weekDay = formatMessage(messages['schedule.calendar.day.' + weekDay]);
        var month = formatMessage(messages['schedule.calendar.month.' + arr[3]]);
        return weekDay + ' ' + arr[1] + ' ' + arr[2] + ' ' + month;
    } catch (err) {
        console.error(err.messages);
        return date;
    }
};

var ScheduleCategoryContainer = function ScheduleCategoryContainer(_ref) {
    var listings = _ref.listings,
        preauthorizedResources = _ref.preauthorizedResources,
        selectedTab = _ref.selectedTab,
        startDateValue = _ref.startDateValue,
        userAuth = _ref.userAuth,
        showSectionCaption = _ref.showSectionCaption,
        darkTheme = _ref.darkTheme,
        formatMessage = _ref.intl.formatMessage,
        messages = _ref.messages,
        intlDateFormat = _ref.intlDateFormat,
        upcomingDateFormat = _ref.upcomingDateFormat,
        bucketName = _ref.bucketName,
        _ref$lang = _ref.lang,
        lang = _ref$lang === undefined ? 'en' : _ref$lang,
        watchRegion = _ref.watchRegion;

    if (listings.length === 0) {
        // Utility function used to tranlate specific tab by type
        var translateTab = getTranslatedTab(messages, formatMessage);
        var translatedSelectedTab = translateTab(selectedTab, 'selectedTabError');
        var otherTabs = [__WEBPACK_IMPORTED_MODULE_13__StatusFilter__["a" /* default */].Options.LIVE, __WEBPACK_IMPORTED_MODULE_13__StatusFilter__["a" /* default */].Options.UPCOMING, __WEBPACK_IMPORTED_MODULE_13__StatusFilter__["a" /* default */].Options.REPLAY].filter(function (tab) {
            return tab !== selectedTab;
        });

        return _jsx('p', {}, void 0, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], _extends({}, messages['schedule.message.empty'], {
            values: {
                br: _jsx('br', {}),
                selectedTab: translatedSelectedTab,
                otherTabs1: translateTab(otherTabs[0]).toLocaleLowerCase(),
                otherTabs2: translateTab(otherTabs[1]).toLocaleLowerCase()
            }
        })));
    }

    var renderTableCaption = function renderTableCaption(dateValue, formatOfDate) {
        var showCaption = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        /**
         * For isIntl, formatOfDate value is 'date15' as 'Weekday, number de month',
         * and formatOfDate default value is 'date10' as 'dddd, MMMM Do' for US.
         * We will check if watchRegion is PacRim or caribbean, and if it is true,
         * use 'date16' date formate as 'dddd, Do MMMM'
         */
        var date = void 0;
        if (Object(__WEBPACK_IMPORTED_MODULE_14__isPacRimOrCarib__["a" /* default */])(watchRegion)) {
            date = __WEBPACK_IMPORTED_MODULE_7__lib_format_dateFormat__["a" /* default */].dateFormat(dateValue, 'date16');
        } else {
            var isNLEdition = lang && lang.toLowerCase() === 'nl';
            date = __WEBPACK_IMPORTED_MODULE_7__lib_format_dateFormat__["a" /* default */].dateFormat(dateValue, formatOfDate);
            date = getTranslatedDate(date, formatMessage, messages, lang);
            if (isNLEdition) {
                date = date.replace('de', '').toLocaleLowerCase();
            }
        }
        // Handles the removal of `text-transform: capitalize` enforced by pageShell.css for Brazil
        var dateStyles = formatOfDate === 'date15' ? { textTransform: 'none' } : {};

        return showCaption === true && _jsx('h2', {
            style: dateStyles,
            className: 'table-caption'
        }, void 0, date);
    };

    // TODO: roll back to use `id` as key once category id is populated for E+ content from graphql
    var categories = __WEBPACK_IMPORTED_MODULE_4_lodash_uniqBy___default()(listings.map(function (listing) {
        return listing.categories[0];
    }), 'name').sort(compareObjectsByName(__WEBPACK_IMPORTED_MODULE_5__constants__["l" /* NO_CATEGORY_ID_MAPPINGS */][lang]));
    var listingsGroupedByCategory = __WEBPACK_IMPORTED_MODULE_3_lodash_groupBy___default()(listings, function (listing) {
        return listing.categories[0].name;
    });
    var sections = categories.map(function (category) {
        var categoryListings = listingsGroupedByCategory[category.name];
        return _jsx(__WEBPACK_IMPORTED_MODULE_12__alias_ScheduleCategorySection__["a" /* default */], {
            category: category,
            listings: categoryListings,
            userAuth: userAuth,
            selectedTab: selectedTab,
            preauthorizedResources: preauthorizedResources,
            defaultLabel: formatMessage(messages['schedule.allLeagues']),
            blackoutMessage: formatMessage(messages['schedule.blackout']),
            dateFormat: intlDateFormat,
            showSectionCaption: showSectionCaption,
            darkTheme: darkTheme,
            bucketName: bucketName
        }, 'sched-category-' + category.name);
    });

    return _jsx('div', {}, void 0, renderTableCaption(startDateValue, upcomingDateFormat, selectedTab === __WEBPACK_IMPORTED_MODULE_13__StatusFilter__["a" /* default */].Options.UPCOMING), _jsx('div', {}, void 0, sections));
};

ScheduleCategoryContainer.defaultProps = {
    selectedTab: __WEBPACK_IMPORTED_MODULE_13__StatusFilter__["a" /* default */].Options.LIVE,
    preauthorizedResources: [],
    startDateValue: Object(__WEBPACK_IMPORTED_MODULE_6__lib_format_apiDateFormatter__["a" /* default */])(new Date())
};

var mapStateToProps = function mapStateToProps(state) {
    return {
        preauthorizedResources: Object(__WEBPACK_IMPORTED_MODULE_10__selectors_authenticationSelectors__["o" /* preauthorizedResourcesSelector */])(state),
        intlDateFormat: Object(__WEBPACK_IMPORTED_MODULE_9__selectors_appSelector__["i" /* dateFormatSelector */])(state),
        upcomingDateFormat: Object(__WEBPACK_IMPORTED_MODULE_9__selectors_appSelector__["I" /* upcomingScheduleDateFormatSelector */])(state),
        darkTheme: Object(__WEBPACK_IMPORTED_MODULE_11__selectors_darkThemeSelector__["a" /* default */])(state),
        lang: Object(__WEBPACK_IMPORTED_MODULE_9__selectors_appSelector__["q" /* intlSelector */])(state).lang
    };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(Object(__WEBPACK_IMPORTED_MODULE_8__injectIntl__["a" /* default */])(ScheduleCategoryContainer)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(134),
    createAggregator = __webpack_require__(746);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */
var groupBy = createAggregator(function(result, value, key) {
  if (hasOwnProperty.call(result, key)) {
    result[key].push(value);
  } else {
    baseAssignValue(result, key, [value]);
  }
});

module.exports = groupBy;


/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__routingSelector__ = __webpack_require__(23);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_1__routingSelector__["a" /* default */], function (_ref) {
    var darkmode = _ref.locationBeforeTransitions.query.darkmode;
    return darkmode === 'true';
}));

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(750);



/***/ }),
/* 365 */
/***/ (function(module, exports) {

/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  return (/input|select|textarea|button|object/.test(nodeName) ?
    !element.disabled :
    "a" === nodeName ?
      element.href || isTabIndexNotNaN :
      isTabIndexNotNaN) && visible(element);
}

function hidden(el) {
  return (el.offsetWidth <= 0 && el.offsetHeight <= 0) ||
    el.style.display === 'none';
}

function visible(element) {
  while (element) {
    if (element === document.body) break;
    if (hidden(element)) return false;
    element = element.parentNode;
  }
  return true;
}

function tabbable(element) {
  var tabIndex = element.getAttribute('tabindex');
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll('*'), 0).filter(function(el) {
    return tabbable(el);
  });
}

module.exports = findTabbableDescendants;



/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.2.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var baseAssign = __webpack_require__(755),
    createAssigner = __webpack_require__(760),
    keys = __webpack_require__(367);

/**
 * A specialized version of `_.assign` for customizing assigned values without
 * support for argument juggling, multiple sources, and `this` binding `customizer`
 * functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 */
function assignWith(object, source, customizer) {
  var index = -1,
      props = keys(source),
      length = props.length;

  while (++index < length) {
    var key = props[index],
        value = object[key],
        result = customizer(value, source[key], key, object, source);

    if ((result === result ? (result !== value) : (value === value)) ||
        (value === undefined && !(key in object))) {
      object[key] = result;
    }
  }
  return object;
}

/**
 * Assigns own enumerable properties of source object(s) to the destination
 * object. Subsequent sources overwrite property assignments of previous sources.
 * If `customizer` is provided it is invoked to produce the assigned values.
 * The `customizer` is bound to `thisArg` and invoked with five arguments:
 * (objectValue, sourceValue, key, object, source).
 *
 * **Note:** This method mutates `object` and is based on
 * [`Object.assign`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.assign).
 *
 * @static
 * @memberOf _
 * @alias extend
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {*} [thisArg] The `this` binding of `customizer`.
 * @returns {Object} Returns `object`.
 * @example
 *
 * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
 * // => { 'user': 'fred', 'age': 40 }
 *
 * // using a customizer callback
 * var defaults = _.partialRight(_.assign, function(value, other) {
 *   return _.isUndefined(value) ? other : value;
 * });
 *
 * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
 * // => { 'user': 'barney', 'age': 36 }
 */
var assign = createAssigner(function(object, source, customizer) {
  return customizer
    ? assignWith(object, source, customizer)
    : baseAssign(object, source);
});

module.exports = assign;


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.1.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var getNative = __webpack_require__(757),
    isArguments = __webpack_require__(758),
    isArray = __webpack_require__(759);

/** Used to detect unsigned integer values. */
var reIsUint = /^\d+$/;

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/* Native method references for those with the same name as other `lodash` methods. */
var nativeKeys = getNative(Object, 'keys');

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Checks if `value` is array-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value));
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
  length = length == null ? MAX_SAFE_INTEGER : length;
  return value > -1 && value % 1 == 0 && value < length;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * A fallback implementation of `Object.keys` which creates an array of the
 * own enumerable property names of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function shimKeys(object) {
  var props = keysIn(object),
      propsLength = props.length,
      length = propsLength && object.length;

  var allowIndexes = !!length && isLength(length) &&
    (isArray(object) || isArguments(object));

  var index = -1,
      result = [];

  while (++index < propsLength) {
    var key = props[index];
    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
var keys = !nativeKeys ? shimKeys : function(object) {
  var Ctor = object == null ? undefined : object.constructor;
  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
      (typeof object != 'function' && isArrayLike(object))) {
    return shimKeys(object);
  }
  return isObject(object) ? nativeKeys(object) : [];
};

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  if (object == null) {
    return [];
  }
  if (!isObject(object)) {
    object = Object(object);
  }
  var length = object.length;
  length = (length && isLength(length) &&
    (isArray(object) || isArguments(object)) && length) || 0;

  var Ctor = object.constructor,
      index = -1,
      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
      result = Array(length),
      skipIndexes = length > 0;

  while (++index < length) {
    result[index] = (index + '');
  }
  for (var key in object) {
    if (!(skipIndexes && isIndex(key, length)) &&
        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = keys;


/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(4);

// EXTERNAL MODULE: ./app/common/injectIntl.js
var injectIntl = __webpack_require__(20);

// CONCATENATED MODULE: ./app/common/search/SearchFilter.js
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var SearchFilter = function SearchFilter(_ref) {
    var placeholder = _ref.placeholder,
        handleChange = _ref.handleChange,
        handleInputFocus = _ref.handleInputFocus;
    return _jsx("section", {
        className: "search-section icon-font-before icon-search-solid-before search-section--provider"
    }, void 0, _jsx("input", {
        name: "search-section",
        type: "text",
        autoComplete: "off",
        placeholder: placeholder,
        onChange: handleChange,
        onFocus: handleInputFocus
    }));
};

/* harmony default export */ var search_SearchFilter = (SearchFilter);
// CONCATENATED MODULE: ./app/common/chooseProvider/Provider.js
var Provider__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var Provider = function Provider(_ref) {
    var provider = _ref.provider,
        providerSelect = _ref.providerSelect;
    var id = provider.id,
        name = provider.name,
        appLink = provider.appLink;

    var clickHandler = void 0;
    var href = appLink;
    if (providerSelect) {
        clickHandler = function clickHandler(event) {
            event.preventDefault();return providerSelect(provider);
        };
        href = null;
    }
    return Provider__jsx('li', {}, id, Provider__jsx('a', {
        href: href,
        onClick: clickHandler
    }, void 0, name));
};

/* harmony default export */ var chooseProvider_Provider = (Provider);
// CONCATENATED MODULE: ./app/common/chooseProvider/ProviderList.js
var ProviderList__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var headerStyle = {
    cursor: 'default',
    fontSize: '13px'
};

var ProviderList_ProviderList = function ProviderList(_ref) {
    var filter = _ref.filter,
        providers = _ref.providers,
        providerSelect = _ref.providerSelect,
        header = _ref.header;

    var listHeader = header && !filter ? ProviderList__jsx('li', {
        className: 'watchProvider__list-header'
    }, void 0, ProviderList__jsx('a', {
        style: headerStyle
    }, void 0, header)) : null;
    return ProviderList__jsx('ul', {
        className: 'watchProvider__list-items'
    }, void 0, listHeader, providers.filter(function (provider) {
        return provider.name.toLowerCase().indexOf(filter.toLowerCase()) >= 0;
    }).map(function (provider) {
        return ProviderList__jsx(chooseProvider_Provider, {
            provider: provider,
            providerSelect: providerSelect
        }, provider.id);
    }));
};

ProviderList_ProviderList.defaultProps = {
    providers: []
};

/* harmony default export */ var chooseProvider_ProviderList = (ProviderList_ProviderList);
// CONCATENATED MODULE: ./app/common/chooseProvider/Tier1Provider.js
var Tier1Provider__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var intlImgStyle = {
    maxWidth: '65%',
    maxHeight: '55%',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
};

var intlAnchorStyle = {
    height: '50px',
    display: 'block'
};

var Tier1Provider = function Tier1Provider(_ref) {
    var isIntl = _ref.isIntl,
        provider = _ref.provider,
        providerSelect = _ref.providerSelect;
    var _provider$images$pick = provider.images.picker.href,
        providerImageUrl = _provider$images$pick === undefined ? '' : _provider$images$pick,
        appLink = provider.appLink;

    var clickHandler = void 0;
    var href = appLink;
    var anchorStyle = void 0;
    var imgStyle = void 0;
    if (providerSelect) {
        clickHandler = function clickHandler(event) {
            event.preventDefault();return providerSelect(provider);
        };
        href = null;
    }
    // Override style for intl tier one providers
    if (isIntl) {
        anchorStyle = intlAnchorStyle;
        imgStyle = intlImgStyle;
    }

    return Tier1Provider__jsx('li', {
        onClick: clickHandler
    }, void 0, Tier1Provider__jsx('a', {
        style: anchorStyle,
        href: href
    }, void 0, Tier1Provider__jsx('img', {
        style: imgStyle,
        src: providerImageUrl,
        alt: provider.name
    })));
};

/* harmony default export */ var chooseProvider_Tier1Provider = (Tier1Provider);
// CONCATENATED MODULE: ./app/common/chooseProvider/Tier1ProviderGrid.js
var Tier1ProviderGrid__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var Tier1ProviderGrid_Tier1ProviderGrid = function Tier1ProviderGrid(_ref) {
    var isIntl = _ref.isIntl,
        providers = _ref.providers,
        providerSelect = _ref.providerSelect;
    return Tier1ProviderGrid__jsx('ul', {
        className: 'watchProvider__list-items--is-premier'
    }, void 0, providers.map(function (provider) {
        return Tier1ProviderGrid__jsx(chooseProvider_Tier1Provider, {
            isIntl: isIntl,
            provider: provider,
            providerSelect: providerSelect
        }, 'tier1provider' + provider.name);
    }));
};

/* harmony default export */ var chooseProvider_Tier1ProviderGrid = (Tier1ProviderGrid_Tier1ProviderGrid);
// CONCATENATED MODULE: ./app/common/chooseProvider/DMVPDButton.js
var DMVPDButton__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var DMVPDButton = function DMVPDButton(_ref) {
    var text = _ref.text,
        _ref$link = _ref.link,
        link = _ref$link === undefined ? 'http://www.espninstantaccess.com' : _ref$link;
    return DMVPDButton__jsx('section', {
        className: 'watchProvider__btn'
    }, void 0, DMVPDButton__jsx('a', {
        className: 'button-alt full-width lg',
        target: '_blank',
        rel: 'noopener noreferrer',
        href: link
    }, void 0, DMVPDButton__jsx('span', {}, void 0, text)));
};

/* harmony default export */ var chooseProvider_DMVPDButton = (DMVPDButton);
// EXTERNAL MODULE: ./app/lib/util/sortByRank.js
var sortByRank = __webpack_require__(329);

// EXTERNAL MODULE: ./app/common/selectors/providerSelector.js
var providerSelector = __webpack_require__(53);

// EXTERNAL MODULE: ./app/common/selectors/appSelector.js + 1 modules
var appSelector = __webpack_require__(3);

// CONCATENATED MODULE: ./app/common/chooseProvider/ProviderDialog.js
var ProviderDialog__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/no-danger */












/**
 * getTier1Providers - Returns a list of filtered providers whose tier property is 1.
 * For international providers, the list is sorted by rank.
 *
 * @param {Array} providers - Array of provider objects to be filtered
 * @param {boolean} isIntl = false - Flag to determine if app is international
 *
 * @return {Array} - Array of filtered/sorted providers
 */
function getTier1Providers(providers) {
    var isIntl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var tierOneProviders = providers.filter(function (provider) {
        return provider.tier === 1;
    });
    // Tier 1 Providers will only be sorted if 1) isInternational 2) the `rank` property is defined
    return isIntl === true ? tierOneProviders.sort(sortByRank["a" /* default */]) : tierOneProviders;
}

var ProviderDialog_ProviderDialog = function (_Component) {
    _inherits(ProviderDialog, _Component);

    function ProviderDialog(props) {
        _classCallCheck(this, ProviderDialog);

        var _this = _possibleConstructorReturn(this, (ProviderDialog.__proto__ || Object.getPrototypeOf(ProviderDialog)).call(this, props));

        _this.state = { searchFilter: '', showTierOne: true };
        _this.onFilterInputChange = _this.onFilterInputChange.bind(_this);
        _this.onFilterInputFocus = _this.onFilterInputFocus.bind(_this);
        return _this;
    }

    _createClass(ProviderDialog, [{
        key: 'onFilterInputChange',
        value: function onFilterInputChange(event) {
            var searchFilter = event.target.value;
            var isESPNApp = this.props.isESPNApp;
            // Show tier one if is web picker or if user has backspaced and search filter is empty

            var showTierOne = !isESPNApp || searchFilter === '';
            this.setState({ searchFilter: searchFilter, showTierOne: showTierOne });
        }
    }, {
        key: 'onFilterInputFocus',
        value: function onFilterInputFocus() {
            if (this.props.isESPNApp) {
                this.setState({ showTierOne: false, searchFilter: 'zzzzz' });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                messages = _props.messages,
                faqUrl = _props.faqUrl,
                upsellUrl = _props.upsellUrl,
                formatMessage = _props.intl.formatMessage,
                providers = _props.providers,
                providerSelect = _props.providerSelect,
                showDMVPDUpsell = _props.showDMVPDUpsell,
                showTierOneProviders = _props.showTierOneProviders,
                isESPNApp = _props.isESPNApp,
                isIntl = _props.isIntl,
                providerStyle = _props.providerStyle,
                providerClass = _props.providerClass;

            // FIXME: Supposed to use `FormattedMessage` from `react-intl` but can't use it because of css `>span`

            var description = formatMessage(messages['provider.dialog.description'], {
                noCost: '<span>' + formatMessage(messages['provider.dialog.description.noCost']) + '</span>',
                faq: '<a target="_blank" href="' + faqUrl + '" class="watchProvider__link">\n                ' + formatMessage(messages['provider.dialog.faq.label']) + '</a>',
                help: '<a target="_blank" href="' + formatMessage(messages['provider.dialog.help.link']) + '" class="watchProvider__link">\n                ' + formatMessage(messages['provider.dialog.help.label']) + '</a>'
            });
            var tier1Providers = getTier1Providers(providers, isIntl);
            var tier1Grid = showTierOneProviders && tier1Providers.length > 0 ? ProviderDialog__jsx('div', {}, void 0, ProviderDialog__jsx(chooseProvider_Tier1ProviderGrid, {
                isIntl: isIntl,
                providers: tier1Providers,
                providerSelect: providerSelect
            })) : null;

            var preSearch = void 0;
            var postSearch = void 0;
            var modalTitle = void 0;
            var tierOne = void 0;
            var subtitle = void 0;
            var searchFilter = ProviderDialog__jsx(search_SearchFilter, {
                handleChange: this.onFilterInputChange,
                handleInputFocus: this.onFilterInputFocus,
                placeholder: formatMessage(messages['search.filter.placeholder'])
            });

            if (isESPNApp) {
                preSearch = searchFilter;
                subtitle = formatMessage(messages['provider.dialog.subtitle']);
            } else {
                modalTitle = ProviderDialog__jsx('h1', {
                    className: 'watchProvider__title'
                }, void 0, ProviderDialog__jsx('span', {}, void 0, formatMessage(messages['provider.dialog.title'])));
                postSearch = searchFilter;
            }

            var dmvpdButton = showDMVPDUpsell ? ProviderDialog__jsx(chooseProvider_DMVPDButton, {
                text: formatMessage(messages['provider.dialog.button.text']),
                link: upsellUrl
            }) : null;

            if (this.state.showTierOne) {
                tierOne = ProviderDialog__jsx('div', {}, void 0, ProviderDialog__jsx('p', {
                    className: 'watchProvider__desc',
                    dangerouslySetInnerHTML: { __html: description }
                }), tier1Grid, dmvpdButton);
            }

            return ProviderDialog__jsx('div', {}, void 0, modalTitle, ProviderDialog__jsx('div', {
                style: providerStyle,
                className: providerClass
            }, void 0, preSearch, tierOne, postSearch, ProviderDialog__jsx(chooseProvider_ProviderList, {
                filter: this.state.searchFilter,
                header: subtitle,
                providers: providers,
                providerSelect: providerSelect
            })));
        }
    }]);

    return ProviderDialog;
}(react["Component"]);

ProviderDialog_ProviderDialog.defaultProps = {
    providers: [],
    showProviderDialog: false,
    isESPNApp: false,
    isIntl: false,
    showTierOneProviders: true
};

var ProviderDialog_mapStateToProps = function mapStateToProps(state) {
    return {
        providers: Object(providerSelector["c" /* providersSelector */])(state),
        isESPNApp: Object(appSelector["t" /* isESPNAppSelector */])(state),
        isIntl: Object(appSelector["u" /* isIntlSelector */])(state),
        showDMVPDUpsell: Object(appSelector["E" /* showDMVPDUpsellSelector */])(state),
        upsellUrl: Object(appSelector["J" /* upsellUrlSelector */])(state),
        faqUrl: Object(appSelector["m" /* faqUrlSelector */])(state)
    };
};

/* harmony default export */ var chooseProvider_ProviderDialog = __webpack_exports__["a"] = (Object(es["b" /* connect */])(ProviderDialog_mapStateToProps)(Object(injectIntl["a" /* default */])(ProviderDialog_ProviderDialog)));

/***/ }),
/* 369 */
/***/ (function(module, exports) {

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */
function each(collection, fn) {
    var i      = 0,
        length = collection.length,
        cont;

    for(i; i < length; i++) {
        cont = fn(collection[i], i);
        if(cont === false) {
            break; //allow early exit
        }
    }
}

/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */
function isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}

/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */
function isFunction(target) {
    return typeof target === 'function';
}

module.exports = {
    isFunction : isFunction,
    isArray : isArray,
    each : each
};


/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = domainCheck;
/* harmony export (immutable) */ __webpack_exports__["b"] = updateAdobeAuthentication;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_actions_authenticationActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_selectors_selectedContentSelector__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_selectors_selectedStreamSelector__ = __webpack_require__(62);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/* eslint-disable import/prefer-default-export */





function domainCheck(key) {
    // client only action
    return function () {
        return new __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a(function (resolve, reject) {
            var script = document.createElement('script');
            script.src = 'https://broadband.espn.com/espn3/auth/watchespn/userData?format=json&product=syndicated&rand=' + Date.now() + '&key=' + key;
            script.async = true;
            script.onload = function () {
                resolve(window.ud || {});
            };
            script.onerror = function (err) {
                reject(err);
            };
            document.body.appendChild(script);
        });
    };
}

function updateAdobeAuthentication() {
    var _this = this;

    return function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
            var state, content, stream, isAuthenticated, info, providersFromApi, providerInfo;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            state = getState();
                            content = Object(__WEBPACK_IMPORTED_MODULE_2__common_selectors_selectedContentSelector__["a" /* default */])(state);
                            stream = Object(__WEBPACK_IMPORTED_MODULE_3__common_selectors_selectedStreamSelector__["a" /* default */])(state);
                            _context.next = 5;
                            return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__common_actions_authenticationActions__["D" /* createAndPerformStartAuthenticationAction */])({ content: content, stream: stream }));

                        case 5:
                            isAuthenticated = _context.sent;

                            if (!isAuthenticated) {
                                _context.next = 13;
                                break;
                            }

                            _context.next = 9;
                            return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__common_actions_authenticationActions__["Y" /* getAdobePassAuthenticationInfo */])());

                        case 9:
                            info = _context.sent;
                            providersFromApi = state.providerDialog.providers;
                            providerInfo = providersFromApi.filter(function (_ref2) {
                                var abbreviation = _ref2.abbreviation;
                                return abbreviation === info.mvpd;
                            }).shift();

                            if (providerInfo) {
                                dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__common_actions_authenticationActions__["O" /* createGetAuthenticationInfoAction */])(providerInfo));
                            }

                        case 13:
                            return _context.abrupt('return', isAuthenticated);

                        case 14:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function (_x, _x2) {
            return _ref.apply(this, arguments);
        };
    }();
}

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return domainAuthStatus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__enums__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_PropTypes__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_auth_authStateKnown__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_util_isEmpty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_ResponsiveThumbnail__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_authenticationAware__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_actions_appActions__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__player_actions__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_actions_authenticationActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ProviderDialog__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ConnectedPlayer__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__style__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__alias_Playable__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__SyndicatedPlayerAPIProxy__ = __webpack_require__(373);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var SELF = __WEBPACK_IMPORTED_MODULE_2__enums__["G" /* SyndicatedPlayerLoginOptions */].SELF,
    NEW_WINDOW = __WEBPACK_IMPORTED_MODULE_2__enums__["G" /* SyndicatedPlayerLoginOptions */].NEW_WINDOW,
    NEW_WINDOW_MANAGED = __WEBPACK_IMPORTED_MODULE_2__enums__["G" /* SyndicatedPlayerLoginOptions */].NEW_WINDOW_MANAGED;

var IMAGE_WIDTHS = [400, 640, 1200, 1800];

var domainAuthStatus = {
    UNKNOWN: 0,
    NOT_ALLOWED: 1,
    ALLOWED: 2
};

var SyndicatedPlayer = function (_PureComponent) {
    _inherits(SyndicatedPlayer, _PureComponent);

    function SyndicatedPlayer(props) {
        _classCallCheck(this, SyndicatedPlayer);

        var _this = _possibleConstructorReturn(this, (SyndicatedPlayer.__proto__ || Object.getPrototypeOf(SyndicatedPlayer)).call(this, props));

        _this.onContinueClick = _this.onContinueClick.bind(_this);
        _this.onReloadClick = _this.onReloadClick.bind(_this);
        _this.state = {
            isAuthenticated: false,
            authRetry: props.authRetry,
            xdomainBlocked: props.xdomainBlocked
        };
        return _this;
    }

    _createClass(SyndicatedPlayer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.apiProxy = new __WEBPACK_IMPORTED_MODULE_15__SyndicatedPlayerAPIProxy__["a" /* default */](this);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.apiProxy.componentWillReceiveProps(nextProps);
            var nextCanPlayContent = nextProps.canPlayContent,
                nextUserAuth = nextProps.userAuth,
                nextErrorMessage = nextProps.errorMessage;
            var _props = this.props,
                dispatch = _props.dispatch,
                canPlayContent = _props.canPlayContent,
                userAuth = _props.userAuth,
                query = _props.location.query;

            if (query[__WEBPACK_IMPORTED_MODULE_2__enums__["t" /* Flags */].AUTO_DISPLAY_PROVIDER_DIALOG] === 'true' && !nextErrorMessage && !Object(__WEBPACK_IMPORTED_MODULE_4__lib_auth_authStateKnown__["a" /* default */])(userAuth) && Object(__WEBPACK_IMPORTED_MODULE_4__lib_auth_authStateKnown__["a" /* default */])(nextUserAuth) && nextUserAuth.indexOf('mvpd') === -1) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__common_actions_authenticationActions__["N" /* createDisplayProviderDialogAction */])());
            }
            if (!nextCanPlayContent && canPlayContent) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__common_actions_appActions__["A" /* contentUnSelect */])());
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__player_actions__["p" /* createClearPlayingStreamAction */])());
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__player_actions__["x" /* createResetPlayerAction */])());
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__common_actions_authenticationActions__["H" /* createCloseProviderDialogAction */])(false));
                if (this.state.isAuthenticated || this.state.authRetry) {
                    this.setState({ isAuthenticated: false, authRetry: false });
                }
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(_ref) {
            var prevContent = _ref.content;
            var _props2 = this.props,
                canPlayContent = _props2.canPlayContent,
                content = _props2.content,
                clickHandler = _props2.clickHandler,
                embedded = _props2.player.embedded;

            if (canPlayContent && embedded && prevContent.id !== content.id) {
                clickHandler();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.apiProxy.destroy();
        }
    }, {
        key: 'onContinueClick',
        value: function onContinueClick(event, providerInfo) {
            var _props3 = this.props,
                loginOption = _props3.loginOption,
                providerSelect = _props3.providerSelect;


            if (loginOption === NEW_WINDOW) {
                return;
            }

            event.preventDefault();

            this.providerInfo = providerInfo;

            if (loginOption === SELF) {
                providerSelect(providerInfo);
            } else if (loginOption === NEW_WINDOW_MANAGED) {
                var loginWindow = window.open(event.currentTarget.href, 'AdobePassProxyLogin');
                if (!loginWindow) {
                    console.warn('login proxy page blocked');
                    return;
                }
                this.loginWindow = loginWindow;
            }
        }
    }, {
        key: 'onReloadClick',
        value: function onReloadClick() {
            this.recheckAccess();
        }
    }, {
        key: 'onAuthSuccess',
        value: function onAuthSuccess() {
            this.setState({
                isAuthenticated: true,
                authRetry: false,
                xdomainBlocked: false
            });
        }
    }, {
        key: 'onLoginClose',
        value: function onLoginClose() {
            this.loginWindow = null;
        }
    }, {
        key: 'onXDomainCheckFail',
        value: function onXDomainCheckFail() {
            this.props.providerSelect(this.providerInfo);
        }
    }, {
        key: 'parentHost',
        value: function parentHost(host) {
            var onParentHost = this.props.onParentHost;

            if (onParentHost) {
                onParentHost(host);
            }
        }
    }, {
        key: 'recheckAccess',
        value: function recheckAccess() {
            // eslint-disable-line class-methods-use-this
            this.apiProxy.reload();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                isAuthenticated = _state.isAuthenticated,
                authRetry = _state.authRetry,
                xdomainBlocked = _state.xdomainBlocked;
            var _props4 = this.props,
                _props4$providerDialo = _props4.providerDialog,
                providers = _props4$providerDialo.providers,
                display = _props4$providerDialo.display,
                _props4$content = _props4.content,
                name = _props4$content.name,
                status = _props4$content.status,
                imageHref = _props4$content.imageHref,
                playingStream = _props4.playingStream,
                branding = _props4.branding,
                location = _props4.location,
                embedded = _props4.player.embedded,
                canPlayContent = _props4.canPlayContent,
                domainAuth = _props4.domainAuth,
                errorMessage = _props4.errorMessage,
                adobePassLogout = _props4.adobePassLogout,
                clickHandler = _props4.clickHandler,
                onSocialOpened = _props4.onSocialOpened,
                onSocialClosed = _props4.onSocialClosed,
                onCaptionOpened = _props4.onCaptionOpened,
                onCaptionClosed = _props4.onCaptionClosed,
                providerSelect = _props4.providerSelect;

            var showProviderDialog = display || authRetry;
            if (domainAuth === domainAuthStatus.UNKNOWN) {
                return null;
            }

            var playButtonClasses = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('button-play', 'button-play--video', {
                'button-play--live': status === __WEBPACK_IMPORTED_MODULE_2__enums__["n" /* ContentStatus */].LIVE
            });
            var dialogViewItem = [];
            // `canPlayContent` will never be `true` when domain is not whitelisted
            // since it doesn't perform `createSmartAdobePassInitializeAction`
            if (!canPlayContent || !embedded || Object(__WEBPACK_IMPORTED_MODULE_5__lib_util_isEmpty__["a" /* default */])(playingStream)) {
                dialogViewItem.push(_jsx(__WEBPACK_IMPORTED_MODULE_6__common_ResponsiveThumbnail__["a" /* default */], {
                    className: 'hero_img',
                    style: showProviderDialog ? { position: 'absolute', opacity: 0.2 } : {},
                    src: imageHref,
                    srcSetWidths: IMAGE_WIDTHS,
                    sizes: '100vw',
                    alt: name,
                    cquality: 95
                }));
            }
            var el = void 0;
            if (errorMessage) {
                el = _jsx('div', {
                    style: __WEBPACK_IMPORTED_MODULE_13__style__["a" /* default */].message
                }, void 0, errorMessage);
            } else if (showProviderDialog) {
                el = _jsx(__WEBPACK_IMPORTED_MODULE_11__ProviderDialog__["a" /* default */], {
                    providers: providers,
                    branding: branding,
                    isAuthenticated: isAuthenticated,
                    onContinueClick: this.onContinueClick,
                    onReloadClick: this.onReloadClick,
                    providerSelect: providerSelect,
                    authRetry: authRetry,
                    xdomainBlocked: xdomainBlocked
                });
            } else {
                el = _jsx('div', {
                    className: playButtonClasses
                });
            }
            dialogViewItem.push(el);

            var needPlayer = canPlayContent && !errorMessage;
            var isAuthenticatableScreen = !errorMessage && !showProviderDialog && !embedded;

            var dialogView = _jsx('div', {
                style: __WEBPACK_IMPORTED_MODULE_13__style__["a" /* default */].dialogContainer
            }, void 0, dialogViewItem, needPlayer && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__ConnectedPlayer__["a" /* default */], {
                ref: function ref(player) {
                    _this2.connectedPlayer = player;
                },
                playerPlacement: __WEBPACK_IMPORTED_MODULE_2__enums__["B" /* PlayerPlacement */].HERO,
                branding: branding,
                location: location,
                render: embedded,
                handleLogout: adobePassLogout,
                onSocialOpened: onSocialOpened,
                onSocialClosed: onSocialClosed,
                onCaptionOpened: onCaptionOpened,
                onCaptionClosed: onCaptionClosed
            }));

            return _jsx('div', {
                className: 'playback-container hero_wrapper',
                style: __WEBPACK_IMPORTED_MODULE_13__style__["a" /* default */].container,
                onClick: isAuthenticatableScreen && clickHandler
            }, void 0, dialogView);
        }
    }]);

    return SyndicatedPlayer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__common_authenticationAware__["a" /* default */])()(Object(__WEBPACK_IMPORTED_MODULE_14__alias_Playable__["a" /* default */])(SyndicatedPlayer)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(35),
    now = __webpack_require__(786),
    toNumber = __webpack_require__(318);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_format_normalizeQueryString__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_util_isEmpty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_page_actions__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_actions_listingsActions__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_actions_appActions__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__player_actions__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_page_AdobePassProxyLogin__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SyndicatedPlayer__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_video_player__ = __webpack_require__(115);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }














var PARTNER = 'watchespn';
var DOMAIN = 'syndicated-api';

var AdobePassEnv = __WEBPACK_IMPORTED_MODULE_0__enums__["a" /* AdobePass */].Env;

var SyndicatedPlayerAPIProxy = function () {
    function SyndicatedPlayerAPIProxy(component) {
        _classCallCheck(this, SyndicatedPlayerAPIProxy);

        var props = component.props;
        var adobePassLogout = props.adobePassLogout,
            _props$location$query = props.location.query;
        _props$location$query = _props$location$query === undefined ? {} : _props$location$query;
        var referrerQuery = _props$location$query.referrer;


        this.targetWindow = window.parent;
        var _document = document,
            _document$referrer = _document.referrer,
            referrer = _document$referrer === undefined ? '' : _document$referrer;
        // `referrerQuery` is for when it's self-reload and lose the original `document.referrer`.

        var originResult = /https?:\/\/[^\/]+/.exec(referrerQuery || referrer);
        // try to specify the target origin, but you won't be able to know the parent location in old IE.
        this.targetOrigin = originResult && originResult[0] || '*';
        this.component = component;
        var _component$props$loca = this.component.props.location.query.instanceId,
            instanceId = _component$props$loca === undefined ? '' : _component$props$loca;

        this.instanceId = instanceId;
        this.adobePassLogout = adobePassLogout.bind(this);
        this._onPostMessage = this._onPostMessage.bind(this);
        this._onPlaying = this._onPlaying.bind(this);
        this._onPlay = this._onPlay.bind(this);
        this._onPause = this._onPause.bind(this);
        this._onAdPodStarted = this._onAdPodStarted.bind(this);
        this._onAdPodEnded = this._onAdPodEnded.bind(this);
        this._onAdStarted = this._onAdStarted.bind(this);
        this._onAdEnded = this._onAdEnded.bind(this);
        this._onProgramChange = this._onProgramChange.bind(this);
        this._onContentLoaded = this._onContentLoaded.bind(this);
        this._onContentEnded = this._onContentEnded.bind(this);
        this._onError = this._onError.bind(this);
        this._unsubscribe = this._subscribeMessage();
        this._publish(SyndicatedPlayerAPIProxy.Events.BRIDGE_READY);
    }

    _createClass(SyndicatedPlayerAPIProxy, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var nextDomainAuth = nextProps.domainAuth,
                nextProviderInfo = nextProps.providerInfo,
                nextDisplay = nextProps.providerDialog.display,
                nextEmbedded = nextProps.player.embedded,
                nextQuery = nextProps.query,
                nextContent = nextProps.content;
            var _component$props = this.component.props,
                query = _component$props.query,
                domainAuth = _component$props.domainAuth,
                providerInfo = _component$props.providerInfo,
                display = _component$props.providerDialog.display,
                embedded = _component$props.player.embedded;

            if (domainAuth === __WEBPACK_IMPORTED_MODULE_9__SyndicatedPlayer__["b" /* domainAuthStatus */].UNKNOWN && nextDomainAuth !== domainAuth) {
                this._publish(SyndicatedPlayerAPIProxy.Events.READY, { blocked: nextDomainAuth === __WEBPACK_IMPORTED_MODULE_9__SyndicatedPlayer__["b" /* domainAuthStatus */].NOT_ALLOWED });
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_2__lib_util_isEmpty__["a" /* default */])(providerInfo) && !Object(__WEBPACK_IMPORTED_MODULE_2__lib_util_isEmpty__["a" /* default */])(nextProviderInfo)) {
                this._publish(SyndicatedPlayerAPIProxy.Events.PROVIDER_SELECTED, { provider: this.getSelectedProvider(nextProps) });
            } else if (!Object(__WEBPACK_IMPORTED_MODULE_2__lib_util_isEmpty__["a" /* default */])(providerInfo) && Object(__WEBPACK_IMPORTED_MODULE_2__lib_util_isEmpty__["a" /* default */])(nextProviderInfo)) {
                this._publish(SyndicatedPlayerAPIProxy.Events.PROVIDER_LOGOUT);
            }
            if (nextDisplay && !display) {
                this._publish(SyndicatedPlayerAPIProxy.Events.PROVIDER_SCREEN_SHOWN);
            }
            if (nextEmbedded && !embedded && !this._playerUnsubscribe) {
                this._addPlayerListeners();
            } else if (!nextEmbedded && embedded && this._playerUnsubscribe) {
                this._removePlayerListeners();
            }
            // This should only be triggered when the `id` URL query is updated by schedule link click
            // When content is switched through API, content changes first followed by URL query update,
            // so it doesn't hit this condition
            if (!this._selecting && nextQuery.id && nextQuery.id !== query.id) {
                this.selectEventById(nextQuery.id);
                this._selecting = true;
            } else if (this._selecting && nextQuery.id && nextContent.id && nextQuery.id === '' + nextContent.id && nextQuery.id === query.id) {
                this._selecting = false;
            }
        }
    }, {
        key: 'parentHost',
        value: function parentHost(host) {
            // this is called from the parent window in response to `BRIDGE_READY` event from the player,
            // when this is called, we assume the parent is handling the postMessage the player is sending
            // so it can also handle reloading the iframe when the mvpd login completes.
            this.hasBridgedParent = true;
            this.component.parentHost(host);
        }
    }, {
        key: '_addPlayerListeners',
        value: function _addPlayerListeners() {
            var _this = this;

            if (!this.videoPlayer) {
                return;
            }
            var player = this.videoPlayer.player;
            if (player) {
                player.on(__WEBPACK_IMPORTED_MODULE_0__enums__["A" /* PlayerEvents */].ESPN_PLAYING, this._onPlaying);
                player.on(__WEBPACK_IMPORTED_MODULE_0__enums__["A" /* PlayerEvents */].ESPN_PLAY, this._onPlay);
                player.on(__WEBPACK_IMPORTED_MODULE_0__enums__["A" /* PlayerEvents */].ESPN_PAUSE, this._onPause);
                player.on(__WEBPACK_IMPORTED_MODULE_0__enums__["A" /* PlayerEvents */].ESPN_AD_POD_STARTED, this._onAdPodStarted);
                player.on(__WEBPACK_IMPORTED_MODULE_0__enums__["A" /* PlayerEvents */].ESPN_AD_POD_ENDED, this._onAdPodEnded);
                player.on(__WEBPACK_IMPORTED_MODULE_0__enums__["A" /* PlayerEvents */].ESPN_AD_STARTED, this._onAdStarted);
                player.on(__WEBPACK_IMPORTED_MODULE_0__enums__["A" /* PlayerEvents */].ESPN_AD_ENDED, this._onAdEnded);
                player.on(__WEBPACK_IMPORTED_MODULE_0__enums__["A" /* PlayerEvents */].ESPN_PROGRAM_CHANGE, this._onProgramChange);
                player.on(__WEBPACK_IMPORTED_MODULE_0__enums__["A" /* PlayerEvents */].ESPN_CONTENT_LOADED, this._onContentLoaded);
                player.on(__WEBPACK_IMPORTED_MODULE_0__enums__["A" /* PlayerEvents */].ESPN_CONTENT_ENDED, this._onContentEnded);
                player.on(__WEBPACK_IMPORTED_MODULE_0__enums__["A" /* PlayerEvents */].ESPN_ERROR, this._onError);
            }
            this._playerUnsubscribe = function () {
                if (!_this.videoPlayer) {
                    return;
                }
                player = _this.videoPlayer.player;
                if (player) {
                    player.off(__WEBPACK_IMPORTED_MODULE_0__enums__["A" /* PlayerEvents */].ESPN_PLAYING, _this._onPlaying);
                    player.off(__WEBPACK_IMPORTED_MODULE_0__enums__["A" /* PlayerEvents */].ESPN_PLAY, _this._onPlay);
                    player.off(__WEBPACK_IMPORTED_MODULE_0__enums__["A" /* PlayerEvents */].ESPN_PAUSE, _this._onPause);
                    player.off(__WEBPACK_IMPORTED_MODULE_0__enums__["A" /* PlayerEvents */].ESPN_AD_POD_STARTED, _this._onAdPodStarted);
                    player.off(__WEBPACK_IMPORTED_MODULE_0__enums__["A" /* PlayerEvents */].ESPN_AD_POD_ENDED, _this._onAdPodEnded);
                    player.off(__WEBPACK_IMPORTED_MODULE_0__enums__["A" /* PlayerEvents */].ESPN_AD_STARTED, _this._onAdStarted);
                    player.off(__WEBPACK_IMPORTED_MODULE_0__enums__["A" /* PlayerEvents */].ESPN_AD_ENDED, _this._onAdEnded);
                    player.off(__WEBPACK_IMPORTED_MODULE_0__enums__["A" /* PlayerEvents */].ESPN_PROGRAM_CHANGE, _this._onProgramChange);
                    player.off(__WEBPACK_IMPORTED_MODULE_0__enums__["A" /* PlayerEvents */].ESPN_CONTENT_LOADED, _this._onContentLoaded);
                    player.off(__WEBPACK_IMPORTED_MODULE_0__enums__["A" /* PlayerEvents */].ESPN_CONTENT_ENDED, _this._onContentEnded);
                    player.off(__WEBPACK_IMPORTED_MODULE_0__enums__["A" /* PlayerEvents */].ESPN_ERROR, _this._onError);
                }
            };
        }
    }, {
        key: '_removePlayerListeners',
        value: function _removePlayerListeners() {
            if (this._playerUnsubscribe) {
                this._playerUnsubscribe();
                this._playerUnsubscribe = null;
            }
        }
    }, {
        key: '_updateHeroByQuery',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(queryArg, autoplayArg, thumbnail) {
                var query, _component$props2, dispatch, _component$props2$pag, pageId, pageName, embedded, autoStart, content, payload, _ref2, _ref2$page, edition, heroContent, connectedPlayer, autoplay, hasAutoplay;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                query = Object(__WEBPACK_IMPORTED_MODULE_1__lib_format_normalizeQueryString__["a" /* default */])(queryArg);
                                _component$props2 = this.component.props, dispatch = _component$props2.dispatch, _component$props2$pag = _component$props2.page, pageId = _component$props2$pag.id, pageName = _component$props2$pag.name, embedded = _component$props2.player.embedded, autoStart = _component$props2.query.autoStart, content = _component$props2.content;

                                dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_page_actions__["r" /* createRequestPageAction */])(pageId));
                                dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_page_actions__["n" /* completePageLoad */])());
                                _context.next = 6;
                                return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_page_actions__["t" /* fetchEventOrVideoByQuery */])(query));

                            case 6:
                                payload = _context.sent;

                                dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__common_actions_appActions__["A" /* contentUnSelect */])());
                                dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__common_actions_appActions__["P" /* streamUnSelect */])());
                                _ref2 = payload || {}, _ref2$page = _ref2.page;
                                _ref2$page = _ref2$page === undefined ? {} : _ref2$page;
                                edition = _ref2$page.edition, heroContent = _ref2$page.contents;

                                if (thumbnail) {
                                    heroContent.imageHref = thumbnail;
                                }

                                if (heroContent && content && heroContent.id !== content.id) {
                                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__common_actions_appActions__["z" /* contentSelect */])(heroContent));
                                }

                                if (!(embedded && autoplayArg === false)) {
                                    _context.next = 19;
                                    break;
                                }

                                connectedPlayer = this.connectedPlayer;

                                if (!connectedPlayer) {
                                    _context.next = 19;
                                    break;
                                }

                                _context.next = 19;
                                return connectedPlayer.unembedPlayer();

                            case 19:
                                dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common_page_actions__["q" /* createReceivePageAction */])({
                                    id: pageId,
                                    name: pageName,
                                    edition: edition,
                                    heroContent: heroContent,
                                    isFinal: true
                                }));

                                autoplay = autoplayArg;

                                if (autoplay == null) {
                                    if (embedded) {
                                        autoplay = true;
                                    } else if (autoStart === 'false') {
                                        autoplay = false;
                                    }
                                }
                                hasAutoplay = autoplay != null;

                                if (hasAutoplay) {
                                    // TODO: clarify the difference between `autoEmbed` and `autoplay`
                                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__player_actions__["o" /* createAutoplayUpdatedAction */])(autoplay));
                                }
                                dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__common_actions_appActions__["Q" /* updateRoute */])(hasAutoplay ? _extends({}, query, { autoStart: autoplay }) : query));

                            case 25:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function _updateHeroByQuery(_x, _x2, _x3) {
                return _ref.apply(this, arguments);
            }

            return _updateHeroByQuery;
        }()
    }, {
        key: 'playVideo',
        value: function playVideo() {
            if (!this.videoPlayer) {
                return;
            }
            this.videoPlayer.play();
        }
    }, {
        key: 'pauseVideo',
        value: function pauseVideo() {
            if (!this.videoPlayer) {
                return;
            }
            this.videoPlayer.pause();
        }
    }, {
        key: 'muteStream',
        value: function muteStream() {
            if (!this.videoPlayer || !this.videoPlayer.mute) {
                return;
            }
            this.videoPlayer.mute();
        }
    }, {
        key: 'unMuteStream',
        value: function unMuteStream() {
            if (!this.videoPlayer || !this.videoPlayer.unmute) {
                return;
            }
            this.videoPlayer.unmute();
        }
    }, {
        key: 'selectById',
        value: function selectById(id, autoplay) {
            var thumbnail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

            if (!id) {
                return;
            }
            this._updateHeroByQuery({ id: id }, autoplay, thumbnail);
        }
    }, {
        key: 'selectByEventId',
        value: function selectByEventId(eventId, autoplay) {
            var thumbnail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

            if (!eventId) {
                return;
            }
            this._updateHeroByQuery({ eventId: eventId }, autoplay, thumbnail);
        }
    }, {
        key: 'selectEventByNetworkName',
        value: function selectEventByNetworkName(network) {
            var thumbnail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

            if (!network) {
                return;
            }
            this._updateHeroByQuery({ network: network }, undefined, thumbnail);
        }

        /*
        selectByAiringId(
        token,
        tokenType,
        sessionId,
        viewContentReference,
        airingId,
        pricePlanId,
        errorCode = null, errorMessage = null, degradation = null, autoplay = false, thumbnail = '') {
        // TODO: figure out if we need it or not
        }
        */

    }, {
        key: 'selectEventById',
        value: function selectEventById(id) {
            var thumbnail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

            this.selectById(id, undefined, thumbnail);
        }
    }, {
        key: 'selectEventByGameIdLeague',
        value: function selectEventByGameIdLeague(gameId) {
            var _this2 = this;

            var league = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
            var thumbnail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
            var dispatch = this.component.props.dispatch;

            dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__common_actions_listingsActions__["a" /* getEventByQuery */])({ eventId: gameId, league: league })).then(function (content) {
                if (!content) {
                    return;
                }
                _this2.selectById(content.id, true, thumbnail);
            });
        }
    }, {
        key: 'selectEventByExternalId',
        value: function selectEventByExternalId(gameId, sport, leagueName) {
            this.selectEventByGameIdLeague(gameId, leagueName);
        }
    }, {
        key: 'setVideoPosition',
        value: function setVideoPosition(positionInSec) {
            if (!this.videoPlayer || !this.videoPlayer.currentTime) {
                return;
            }
            this.videoPlayer.currentTime(positionInSec);
        }
    }, {
        key: 'getVideoPosition',
        value: function getVideoPosition() {
            if (!this.videoPlayer || !this.videoPlayer.currentTime) {
                return 0;
            }
            return this.videoPlayer.currentTime() || 0;
        }

        /*
        getFeedById(id) {
            // TODO: figure out if we need it or not
        }
        */

    }, {
        key: 'enterFullScreen',
        value: function enterFullScreen() {
            if (!this.videoPlayer || !this.videoPlayer.requestFullscreen) {
                return;
            }
            this.videoPlayer.requestFullscreen();
        }
    }, {
        key: 'exitFullScreen',
        value: function exitFullScreen() {
            if (!this.videoPlayer || !this.videoPlayer.exitFullscreen) {
                return;
            }
            this.videoPlayer.exitFullscreen();
        }

        /*
        sendMetric(metric) {
          // TODO: figure out if we need it or not
        }
        */

        /*
        getMetadataById(key) {
          // TODO: figure out if we need it or not
        }
        */

    }, {
        key: 'getAffiliate',
        value: function getAffiliate() {
            var _component$props$prov = this.component.props.providerInfo,
                providerInfo = _component$props$prov === undefined ? {} : _component$props$prov;

            if (Object(__WEBPACK_IMPORTED_MODULE_2__lib_util_isEmpty__["a" /* default */])(providerInfo)) {
                return null;
            }
            return {
                id: providerInfo.abbreviation,
                name: providerInfo.name,
                websiteUrl: providerInfo.links.web.href,
                imageUrl: providerInfo.images.logo.href
            };
        }
    }, {
        key: 'getSelectedProvider',
        value: function getSelectedProvider() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.component.props;

            // TODO: `espn3Only` prop is returned from http://broadband.espn.com/espn3/auth/watchespn/userData
            var _props$providerInfo = props.providerInfo,
                providerInfo = _props$providerInfo === undefined ? {} : _props$providerInfo;

            if (Object(__WEBPACK_IMPORTED_MODULE_2__lib_util_isEmpty__["a" /* default */])(providerInfo)) {
                return null;
            }
            return {
                adobePassProviderId: providerInfo.abbreviation,
                displayName: providerInfo.name,
                providerHomepageUrl: providerInfo.links.web.href,
                providerLogoUrl: providerInfo.images.logo.href,
                name: providerInfo.abbreviation
            };
        }
    }, {
        key: 'getAuthenticationStatus',
        value: function getAuthenticationStatus() {
            var _component$props3 = this.component.props,
                authStatus = _component$props3.authStatus,
                _component$props3$pro = _component$props3.providerInfo,
                providerInfo = _component$props3$pro === undefined ? {} : _component$props3$pro;

            if (authStatus === 'not authenticated') {
                return {
                    name: 'invalid',
                    type: 'none'
                };
            }

            return {
                name: providerInfo.name,
                type: authStatus === 'authenticated' ? 'tve' : 'ip'
            };
        }
    }, {
        key: 'recheckAccess',
        value: function recheckAccess() {
            if (this.targetWindow && this.targetWindow !== window) {
                this._publish(SyndicatedPlayerAPIProxy.Events.RECHECK_ACCESS, { href: window.location.href });
            } else {
                this.component.recheckAccess();
            }
        }

        /*
        getPlayingEvents() {
          // TODO: figure out if we need it or not
        }
        */

    }, {
        key: '_onPlaying',
        value: function _onPlaying() {
            this._publish(SyndicatedPlayerAPIProxy.Events.PLAYING);
        }
    }, {
        key: '_onPlay',
        value: function _onPlay() {
            this._publish(SyndicatedPlayerAPIProxy.Events.PLAY);
        }
    }, {
        key: '_onPause',
        value: function _onPause() {
            this._publish(SyndicatedPlayerAPIProxy.Events.PAUSE);
        }
    }, {
        key: '_onAdPodStarted',
        value: function _onAdPodStarted(_, payload) {
            this._publish(SyndicatedPlayerAPIProxy.Events.AD_POD_STARTED, payload);
        }
    }, {
        key: '_onAdPodEnded',
        value: function _onAdPodEnded(_, payload) {
            this._publish(SyndicatedPlayerAPIProxy.Events.AD_POD_ENDED, payload);
        }
    }, {
        key: '_onAdStarted',
        value: function _onAdStarted(_, payload) {
            this._publish(SyndicatedPlayerAPIProxy.Events.AD_STARTED, payload);
        }
    }, {
        key: '_onAdEnded',
        value: function _onAdEnded(_, payload) {
            this._publish(SyndicatedPlayerAPIProxy.Events.AD_ENDED, payload);
        }
    }, {
        key: '_onProgramChange',
        value: function _onProgramChange(_, mediainfo) {
            // guard against program change called with the same id
            // `playingStream` is passed by `playable` HOC
            var _component$props$play = this.component.props.playingStream,
                playingStream = _component$props$play === undefined ? {} : _component$props$play;

            if (playingStream.id === mediainfo.id) {
                return;
            }
            this._publish(SyndicatedPlayerAPIProxy.Events.PROGRAM_CHANGE, mediainfo);
        }
    }, {
        key: '_onContentLoaded',
        value: function _onContentLoaded(_) {
            var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
                _ref3$mediainfo = _ref3.mediainfo,
                mediainfo = _ref3$mediainfo === undefined ? {} : _ref3$mediainfo;

            this._publish(SyndicatedPlayerAPIProxy.Events.CONTENT_LOADED, mediainfo);
        }
    }, {
        key: '_onContentEnded',
        value: function _onContentEnded() {
            this._publish(SyndicatedPlayerAPIProxy.Events.CONTENT_ENDED);
        }
    }, {
        key: '_onError',
        value: function _onError(_, payload) {
            this._publish(SyndicatedPlayerAPIProxy.Events.ERROR, payload);
        }
    }, {
        key: '_onPostMessage',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(event) {
                var _this3 = this;

                var data, _data, type, tId, status, params, entitlementToken, _type$split, _type$split2, partner, domain, apiName, args, payload, val, _component$props4, dispatch, _component$props4$ado, adobePassEnv, isAuthenticated;

                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!(typeof event.data !== 'string')) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 2:
                                data = void 0;

                                try {
                                    data = JSON.parse(event.data);
                                } catch (err) {
                                    data = {};
                                }

                                _data = data, type = _data.type, tId = _data.tId, status = _data.status, params = _data.params, entitlementToken = _data.entitlementToken;

                                if (type) {
                                    _context2.next = 7;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 7:
                                _type$split = type.split(':'), _type$split2 = _slicedToArray(_type$split, 3), partner = _type$split2[0], domain = _type$split2[1], apiName = _type$split2[2];

                                if (!(partner !== 'watchespn')) {
                                    _context2.next = 10;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 10:
                                if (!(domain === 'syndicated-api')) {
                                    _context2.next = 14;
                                    break;
                                }

                                if (this[apiName]) {
                                    args = Array.isArray(data.payload) ? data.payload : [data.payload];
                                    payload = this[apiName].apply(this, _toConsumableArray(args));

                                    if (SyndicatedPlayerAPIProxy.Getter.indexOf(apiName) !== -1) {
                                        if (payload && typeof payload.then === 'function') {
                                            payload.then(function (value) {
                                                _this3._publish(type, value, tId);
                                            });
                                        } else {
                                            this._publish(type, payload, tId);
                                        }
                                    }
                                }
                                _context2.next = 35;
                                break;

                            case 14:
                                if (!(domain === 'adobepass-login' && type === __WEBPACK_IMPORTED_MODULE_8__common_page_AdobePassProxyLogin__["a" /* AdobePassProxyLoginComponent */].EVENT_LOADED)) {
                                    _context2.next = 19;
                                    break;
                                }

                                val = window.localStorage.getItem(__WEBPACK_IMPORTED_MODULE_8__common_page_AdobePassProxyLogin__["a" /* AdobePassProxyLoginComponent */].XD_LOCALSTORAGE_KEY);

                                if (val !== __WEBPACK_IMPORTED_MODULE_8__common_page_AdobePassProxyLogin__["a" /* AdobePassProxyLoginComponent */].XD_LOCALSTORAGE_VAL) {
                                    // enable this to auto-kick off self window login flow when xdomain storage failure is detected
                                    /*
                                    if (!this.component.loginWindow) {
                                        return;
                                    }
                                    const origin = `${window.location.protocol}//${window.location.host}`;
                                    this.component.loginWindow.postMessage(JSON.stringify({
                                        type: AdobePassProxyLoginComponent.EVENT_CLOSE_REQUEST,
                                        params: -1
                                    }), origin);
                                    */
                                    this._xdomainBlocked = true;
                                }
                                _context2.next = 35;
                                break;

                            case 19:
                                if (!(domain === 'adobepass-login' && type === __WEBPACK_IMPORTED_MODULE_8__common_page_AdobePassProxyLogin__["a" /* AdobePassProxyLoginComponent */].EVENT_CLOSED)) {
                                    _context2.next = 24;
                                    break;
                                }

                                this.component.onLoginClose();
                                // when the login screen is closed as a result of the request made due to xdomain storage failure is detected,
                                // kick off the login flow using the self window
                                if (params === -1) {
                                    this.component.onXDomainCheckFail();
                                }
                                _context2.next = 35;
                                break;

                            case 24:
                                if (!(domain === 'adobepass-login' && type === __WEBPACK_IMPORTED_MODULE_8__common_page_AdobePassProxyLogin__["a" /* AdobePassProxyLoginComponent */].EVENT_AUTHENTICATE && status === 'success')) {
                                    _context2.next = 35;
                                    break;
                                }

                                _component$props4 = this.component.props, dispatch = _component$props4.dispatch, _component$props4$ado = _component$props4.adobePassEnv, adobePassEnv = _component$props4$ado === undefined ? AdobePassEnv.PROD : _component$props4$ado;


                                this.authSuccess = true;

                                if (entitlementToken && this._xdomainBlocked) {
                                    try {
                                        // update `entitlementToken` in the player window
                                        window.localStorage.setItem('entitlementToken', entitlementToken);
                                        // update `entitlementToken` in the AccessEnabler Proxy window, which is the source of truth
                                        // FIXME: this is a hack to get around cross domain localStorage restriction in Safari
                                        if (window.accessEnablerProxy && window.accessEnablerProxy.contentWindow) {
                                            window.accessEnablerProxy.contentWindow.postMessage({
                                                id: 'c.a.p.pm.s.espn',
                                                operation: 'setItem',
                                                params: ['entitlementToken', entitlementToken]
                                            }, adobePassEnv === AdobePassEnv.STAGING ? 'https://sp.auth-staging.adobe.com' : 'https://sp.auth.adobe.com');
                                        }
                                    } catch (err) {
                                        console.error(err);
                                    }
                                }

                                // This needs to be executed before publishing `AUTHENTICATION_SUCCESS` event
                                // Xfinity/Comcast will redirect the page to their login complete page when this(full authentication) is executed
                                _context2.next = 30;
                                return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["b" /* updateAdobeAuthentication */])());

                            case 30:
                                isAuthenticated = _context2.sent;


                                if (this.targetWindow && this.targetWindow !== window) {
                                    // TODO: remove reload logic from `watchespn-syndicated-player` module
                                    // so that `authRetry` message logic can be executed
                                    this._publish(SyndicatedPlayerAPIProxy.Events.AUTHENTICATION_SUCCESS, {
                                        href: window.location.href,
                                        provider: this.getSelectedProvider(),
                                        authenticationStatus: this.getAuthenticationStatus()
                                    });
                                }

                                this.component.onLoginClose();

                                if (isAuthenticated) {
                                    this.component.onAuthSuccess();
                                }

                                if (this._xdomainBlocked) {
                                    // This can happen when `Cookie and website data` setting is set anything other than `Always Allow` in Safari
                                    this.reload(true, this._xdomainBlocked);
                                }

                            case 35:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function _onPostMessage(_x12) {
                return _ref4.apply(this, arguments);
            }

            return _onPostMessage;
        }()
    }, {
        key: 'reload',
        value: function reload() {
            var authFailed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            var xdomainBlocked = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            // eslint-disable-line class-methods-use-this
            // not recommended to use as this can cause other services which uses `postMessage`
            // to error out when they don't check the referrer origin change
            // currently reload button triggers this as a fallback when the automatic playback doesn't happen after login
            var qs = '';
            if (window.location.search.indexOf('referrer') === -1) {
                qs = (window.location.search.indexOf('?') === -1 ? '?' : '&') + 'referrer=' + encodeURIComponent(document.referrer);
            }
            if (authFailed && window.location.search.indexOf(__WEBPACK_IMPORTED_MODULE_0__enums__["t" /* Flags */].AUTH_RETRY) === -1) {
                qs += '&' + __WEBPACK_IMPORTED_MODULE_0__enums__["t" /* Flags */].AUTH_RETRY + '=true';
            }
            if (xdomainBlocked && window.location.search.indexOf(__WEBPACK_IMPORTED_MODULE_0__enums__["t" /* Flags */].XDOMAIN_BLOCKED) === -1) {
                qs += '&' + __WEBPACK_IMPORTED_MODULE_0__enums__["t" /* Flags */].XDOMAIN_BLOCKED + '=true';
            }
            var reloadUrl = '' + window.location.href + qs;
            window.location.href = reloadUrl;
        }
    }, {
        key: '_publish',
        value: function _publish(type, payload, tId) {
            if (!this.targetWindow || this.targetWindow === window) {
                return;
            }
            var event = {
                type: type,
                tId: tId,
                payload: payload
            };
            try {
                this.targetWindow.postMessage(PARTNER + ':' + DOMAIN + ':' + this.instanceId + JSON.stringify(event), this.targetOrigin);
            } catch (err) {
                console.error(err);
            }
        }
    }, {
        key: '_subscribeMessage',
        value: function _subscribeMessage() {
            window.addEventListener('message', this._onPostMessage);
            return function _unsubscribe() {
                window.removeEventListener('message', this._onPostMessage);
            };
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            if (this._unsubscribe) {
                this._unsubscribe();
            }
        }
    }, {
        key: 'connectedPlayer',
        get: function get() {
            var connectedPlayerWrapper = this.component.connectedPlayer;

            var player = void 0;
            if (connectedPlayerWrapper) {
                // we assume `ConnectedPlayer` always use `connectPlayer` HoC which uses redux `connect`.
                var connectedPlayer = connectedPlayerWrapper.getWrappedInstance();
                if (connectedPlayer) {
                    // get the instance from injectIntl HoC or maybe not using HoC any more
                    player = connectedPlayer.getWrappedInstance() || connectedPlayer;
                }
            }
            return player;
        }
    }, {
        key: 'videoPlayer',
        get: function get() {
            var playerBundleInstance = void 0;
            if (this.connectedPlayer) {
                playerBundleInstance = this.connectedPlayer.videoPlayer && this.connectedPlayer.videoPlayer.getPlayer(__WEBPACK_IMPORTED_MODULE_10__common_video_player__["a" /* default */].PlayerTech.BRIGHTCOVE);
            }
            return playerBundleInstance;
        }
    }]);

    return SyndicatedPlayerAPIProxy;
}();

var API = {
    PLAY: 'playVideo',
    PAUSE: 'pauseVideo',
    MUTE: 'muteStream',
    UNMUTE: 'unMuteStream',
    SET_CURRENT_TIME: 'setVideoPosition',
    GET_CURRENT_TIME: 'getVideoPosition',
    ENTER_FULLSCREEN: 'enterFullScreen',
    EXIT_FULLSCREEN: 'exitFullScreen',
    SELECT_BY_ID: 'selectById',
    SELECT_BY_EVENT_ID: 'selectByEventId',
    SELECT_EVENT_BY_ID: 'selectEventById',
    SELECT_EVENT_BY_NETWORK_NAME: 'selectEventByNetworkName',
    SELECT_EVENT_BY_GAME_ID: 'selectEventByGameIdLeague',
    SELECT_EVENT_BY_EXTERNAL_ID: 'selectEventByExternalId',
    RECHECK_ACCESS: 'recheckAccess',
    ADOBE_PASS_LOGOUT: 'adobePassLogout',
    PARENT_HOST: 'parentHost',
    GET_AFFILIATE: 'getAffiliate',
    GET_SELECTED_PROVIDER: 'getSelectedProvider',
    GET_AUTH_STATUS: 'getAuthenticationStatus'
};

var Events = {
    BRIDGE_READY: 'bridgeReady',
    READY: 'ready',
    PROVIDER_SELECTED: 'providerSelected',
    PROVIDER_LOGOUT: 'providerLogout',
    PROVIDER_SCREEN_SHOWN: 'providerScreenShown',
    AUTHENTICATION_SUCCESS: 'authenticationSuccessful',
    RECHECK_ACCESS: 'recheckAccess',
    PLAYING: 'playing',
    PLAY: 'play',
    PAUSE: 'pause',
    AD_POD_STARTED: 'adPodStarted',
    AD_POD_ENDED: 'adPodEnded',
    AD_STARTED: 'adStarted',
    AD_ENDED: 'adEnded',
    PROGRAM_CHANGE: 'programChange',
    CONTENT_LOADED: 'contentLoaded',
    CONTENT_ENDED: 'contentEnded',
    ERROR: 'error'
};

SyndicatedPlayerAPIProxy.PARTNER = PARTNER;
SyndicatedPlayerAPIProxy.DOMAIN = DOMAIN;

Object.keys(API).forEach(function (key) {
    SyndicatedPlayerAPIProxy[key] = PARTNER + ':' + DOMAIN + ':' + API[key];
});

SyndicatedPlayerAPIProxy.Events = {};
Object.keys(Events).forEach(function (key) {
    SyndicatedPlayerAPIProxy.Events[key] = PARTNER + ':' + DOMAIN + ':' + Events[key];
});

SyndicatedPlayerAPIProxy.Getter = [API.GET_CURRENT_TIME, API.GET_AFFILIATE, API.GET_SELECTED_PROVIDER, API.GET_AUTH_STATUS];

/* harmony default export */ __webpack_exports__["a"] = (SyndicatedPlayerAPIProxy);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {/* unused harmony export getRedirectUrl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdobePassProxyLoginComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bluebird__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_authenticationActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__enums__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_format_queryString__ = __webpack_require__(18);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










function sendMessage(data) {
    if (!window.opener) {
        return;
    }
    var origin = window.location.protocol + '//' + window.location.host;
    window.opener.postMessage(JSON.stringify(data), origin);
}

function getRedirectUrl() {
    var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var redirectUrl = arguments[1];
    var syndicated = arguments[2];
    var id = query.id,
        network = query.network;

    if (!redirectUrl && !syndicated) {
        // If the `id` or `network` query parameters are defined, go directly to the /player route to play the asset via `id`
        if (id || network) {
            return 'http://' + window.location.host + '/watch/player' + Object(__WEBPACK_IMPORTED_MODULE_6__lib_format_queryString__["a" /* default */])(query);
        }
        // NOTE: We might not have an `id` coming from an 3rd party provider.
        // In this case, we want to redirect users to the main /watch homepage
        // SEE: https://espnjira.disney.com/browse/WEWEB-2333
        return 'http://' + window.location.host + '/watch' + Object(__WEBPACK_IMPORTED_MODULE_6__lib_format_queryString__["a" /* default */])(query);
    }

    return redirectUrl;
}

var AdobePassProxyLoginComponent = function (_PureComponent) {
    _inherits(AdobePassProxyLoginComponent, _PureComponent);

    function AdobePassProxyLoginComponent() {
        _classCallCheck(this, AdobePassProxyLoginComponent);

        return _possibleConstructorReturn(this, (AdobePassProxyLoginComponent.__proto__ || Object.getPrototypeOf(AdobePassProxyLoginComponent)).apply(this, arguments));
    }

    _createClass(AdobePassProxyLoginComponent, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.addEventListener('message', this._onPostMessage);

            try {
                window.localStorage.setItem(AdobePassProxyLoginComponent.XD_LOCALSTORAGE_KEY, AdobePassProxyLoginComponent.XD_LOCALSTORAGE_VAL);
            } catch (err) {
                console.error(err);
            }

            sendMessage({
                type: AdobePassProxyLoginComponent.EVENT_LOADED
            });

            var _props = this.props,
                dispatch = _props.dispatch,
                _props$location$query = _props.location.query,
                channel = _props$location$query.channel,
                id = _props$location$query.id,
                mvpd = _props$location$query.mvpd,
                networkQuery = _props$location$query.network,
                redirectUrlQuery = _props$location$query.redirectUrl,
                syndicated = _props$location$query.syndicated;


            var network = networkQuery || channel;
            var redirectUrl = getRedirectUrl({ id: id, network: network }, redirectUrlQuery, syndicated);
            var authenticator = dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_authenticationActions__["G" /* createAuthenticator */])(__WEBPACK_IMPORTED_MODULE_5__enums__["f" /* AuthenticatorType */].ADOBE));

            authenticator.initialize().then(function () {
                return authenticator.authenticate();
            }).then(function (isAuthenticated) {
                if (!isAuthenticated) {
                    return __WEBPACK_IMPORTED_MODULE_3_bluebird___default.a.resolve({});
                }
                return authenticator.getAuthenticationInfo();
            }).then(function (_ref) {
                var currentMvpd = _ref.mvpd;

                // User is not authenticated, initialize the Auth flow for the provider via `mvpd`
                if (!currentMvpd) {
                    return authenticator.selectProvider({
                        ID: mvpd
                    });
                }

                // Attempting to auth with a different provider than currently authd as
                if (currentMvpd !== mvpd) {
                    return authenticator.deauthenticate().then(function () {
                        window.location.href = window.location.href;
                    });
                }

                // if a redirectUrl exists, this indicates we are being linked to by an external site
                if (redirectUrl && !syndicated) {
                    window.location.href = redirectUrl;
                    return null;
                }

                // user is authd successfully for syndicated player.  message parent window and close self
                var entitlementToken = void 0;
                try {
                    entitlementToken = window.localStorage.getItem('entitlementToken');
                } catch (err) {
                    console.error(err);
                }

                sendMessage({
                    type: AdobePassProxyLoginComponent.EVENT_AUTHENTICATE,
                    entitlementToken: entitlementToken,
                    status: 'success'
                });

                window.close();
                return null;
            });
        }
    }, {
        key: '_onPostMessage',
        value: function _onPostMessage(event) {
            // eslint-disable-line class-methods-use-this
            if (typeof event.data !== 'string') {
                return;
            }

            var data = void 0;
            try {
                data = JSON.parse(event.data);
            } catch (err) {
                data = {};
            }

            var _data = data,
                type = _data.type,
                params = _data.params;

            if (type === AdobePassProxyLoginComponent.EVENT_CLOSE_REQUEST) {
                sendMessage({
                    type: AdobePassProxyLoginComponent.EVENT_CLOSED,
                    params: params
                });
                window.close();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _jsx(__WEBPACK_IMPORTED_MODULE_2_react_helmet___default.a, {
                meta: [{ name: 'robots', content: 'noindex, nofollow' }]
            });
        }
    }]);

    return AdobePassProxyLoginComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

AdobePassProxyLoginComponent.XD_LOCALSTORAGE_KEY = '@watch/XD';
AdobePassProxyLoginComponent.XD_LOCALSTORAGE_VAL = 'xdomain';
AdobePassProxyLoginComponent.EVENT_LOADED = 'watchespn:adobepass-login:loaded';
AdobePassProxyLoginComponent.EVENT_AUTHENTICATE = 'watchespn:adobepass-login:authentication';
AdobePassProxyLoginComponent.EVENT_CLOSED = 'watchespn:adobepass-login:closed';
AdobePassProxyLoginComponent.EVENT_CLOSE_REQUEST = 'watchespn:adobepass-login:closeRequest';

/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])()(AdobePassProxyLoginComponent));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = subscribeToStore;
/* unused harmony export unsubscribeFromStore */
function subscribeToStore(store) {
    var observers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    var unsubscribes = [];
    observers.forEach(function (observer) {
        unsubscribes.push(observer(store));
    });

    return function () {
        return unsubscribeFromStore(unsubscribes);
    };
}

function unsubscribeFromStore() {
    var unsubscribes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    unsubscribes.map(function (unsubscribe) {
        return unsubscribe();
    });
}

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./app/lib/omniture/index.js
var omniture = __webpack_require__(34);

// EXTERNAL MODULE: ./app/common/selectors/analyticsSelectors.js
var analyticsSelectors = __webpack_require__(54);

// EXTERNAL MODULE: ./app/lib/auth/authStateKnown.js
var authStateKnown = __webpack_require__(77);

// EXTERNAL MODULE: ./app/enums.js
var enums = __webpack_require__(1);

// CONCATENATED MODULE: ./app/lib/auth/providerInfoKnown.js


function providerInfoKnown(userAuth, adobePassInfo, ipInfo) {
    if (userAuth.length === 0 || userAuth.indexOf(enums["e" /* AuthTypes */].MVPD) === -1 && userAuth.indexOf(enums["e" /* AuthTypes */].ISP) === -1) {
        return true;
    } else if (userAuth.indexOf(enums["e" /* AuthTypes */].MVPD) !== -1) {
        return !!adobePassInfo;
    } else if (userAuth.indexOf(enums["e" /* AuthTypes */].ISP) !== -1) {
        return !!ipInfo;
    }
    return false;
};
// EXTERNAL MODULE: ./app/lib/util/isEmpty.js
var isEmpty = __webpack_require__(12);

// EXTERNAL MODULE: ./app/lib/observe/observeStore.js
var observeStore = __webpack_require__(377);

// CONCATENATED MODULE: ./app/lib/observe/trackingObserver.js
/* harmony export (immutable) */ __webpack_exports__["a"] = trackingObserver;








var initialPageTracked = false;
function trackingObserver(store) {
    return Object(observeStore["a" /* default */])(store, analyticsSelectors["f" /* pageTrackingSelector */], function () {
        var currentTracking = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { page: {} };
        var nextTracking = arguments[1];
        var isDomestic = nextTracking.isDomestic,
            adobePassInfo = nextTracking.adobePassInfo,
            analytics = nextTracking.analytics,
            app = nextTracking.app,
            ipInfo = nextTracking.ipInfo,
            page = nextTracking.page,
            userAuth = nextTracking.userAuth,
            subscriptions = nextTracking.subscriptions,
            oneIdLoggedIn = nextTracking.oneIdLoggedIn,
            entitlementsTracking = nextTracking.entitlementsTracking,
            promoTracking = nextTracking.promoTracking,
            adobePassMetadata = nextTracking.adobePassMetadata;

        // this one makes sure we don't track the same page twice

        if (initialPageTracked && currentTracking.page.name === page.name) {
            return;
        }

        if (analytics && (Object(authStateKnown["a" /* default */])(userAuth) || !userAuth.length) && page.name && providerInfoKnown(userAuth, adobePassInfo, ipInfo) && (!isDomestic || (subscriptions || !oneIdLoggedIn) && !Object(isEmpty["a" /* default */])(entitlementsTracking)) || page.autoPageViewTrack) {
            var provider = adobePassInfo || ipInfo || {};
            Object(omniture["o" /* trackPage */])({ app: app, page: page, provider: provider, userAuth: userAuth, entitlementsTracking: entitlementsTracking, promoTracking: promoTracking, adobePassMetadata: adobePassMetadata, isDomestic: isDomestic });
            initialPageTracked = true;
        }
    });
};

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = observeStore;
function observeStore(store, select, onChange) {
    var getState = store.getState,
        dispatch = store.dispatch;

    var currentState = void 0;

    function handleChange() {
        var nextState = select(getState());
        if (nextState !== currentState) {
            onChange(currentState, nextState, dispatch);
            currentState = nextState;
        }
    }

    var unsubscribe = store.subscribe(handleChange);
    handleChange();
    return unsubscribe;
};

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export loadingClassName */
/* harmony export (immutable) */ __webpack_exports__["b"] = uiLoadingStart;
/* harmony export (immutable) */ __webpack_exports__["a"] = uiLoadingComplete;
/* unused harmony export disableUserInteraction */
/* unused harmony export enableUserInteraction */
var disableUserInteractionHandler = function disableUserInteractionHandler(event) {
    event.stopPropagation();
    event.preventDefault();
};

var loadingClassName = 'watch-loading';

function uiLoadingStart() {
    if (true) {
        var _ref = document || {},
            _ref$body = _ref.body;

        _ref$body = _ref$body === undefined ? {} : _ref$body;
        var className = _ref$body.className;

        document.body.className = className.replace(loadingClassName, '') + ' ' + loadingClassName;
    }
}

function uiLoadingComplete() {
    if (true) {
        var _ref2 = document || {},
            _ref2$body = _ref2.body;

        _ref2$body = _ref2$body === undefined ? {} : _ref2$body;
        var className = _ref2$body.className;

        document.body.className = className.replace(loadingClassName, '');
        enableUserInteraction();
    }
}

function disableUserInteraction() {
    if (true) {
        ['click', 'touchstart'].forEach(function (eventName) {
            document.body.addEventListener(eventName, disableUserInteractionHandler);
        });
    }
}

function enableUserInteraction() {
    if (true) {
        ['click', 'touchstart'].forEach(function (eventName) {
            document.body.removeEventListener(eventName, disableUserInteractionHandler);
        });
    }
}

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(4);

// EXTERNAL MODULE: ./node_modules/react-intl/lib/index.es.js + 1 modules
var index_es = __webpack_require__(94);

// CONCATENATED MODULE: ./app/lib/i18n/en-us.js
var messages = {
    // branding
    'branding.name': 'WatchESPN',
    // meta
    'meta.keywords': 'watchespn, watch espn, watchespn mobile, watchespn xbox live, live sports, watch live sports, ' + 'watch espn online, watch espn on xbox, watch espn on mobile phone, espn, espn2, espn3, espnu',
    'meta.title.home': 'WatchESPN: Live Sports, Game Replays, Video Highlights',
    'meta.description.home': 'Stream live sports, watch game replays, get video highlights, and access featured ESPN ' + 'content on your computer, mobile device, and TV on ESPN.com and the ESPN app.',
    'meta.title.schedule': 'Schedule: Live, Upcoming, Replays - WatchESPN',
    'meta.description.schedule': 'Get live, upcoming, and replay schedule information for your favorite sports and shows ' + 'across every ESPN network on WatchESPN.',
    'meta.title.features': 'Featured Videos - WatchESPN',
    'meta.description.features': 'Watch featured news clips, game highlights, and special ESPN programming on WatchESPN.',
    'meta.title.collection': '{name} - WatchESPN',
    'meta.description.collection': 'Watch videos from the {name} collection on WatchESPN.',
    'meta.title.player': '{name} - WatchESPN',
    'meta.description.player.vod': 'Watch the {name} video on WatchESPN.',
    'meta.description.player.listing': 'Watch {name} on WatchESPN.',
    'meta.title.activate': 'Activate - WatchESPN',
    'meta.description.activate': 'Activate your device',
    'meta.title.subscribe': 'Subscribe - WatchESPN',
    'meta.description.subscribe': 'Subscribe your device',
    'meta.title.feedback': 'Provide Feedback - WatchESPN',
    'meta.description.feedback': 'Provide feedback on WatchESPN, the service that provides full access on your computer, mobile devices and Xbox Live to all live sports events, replays and programs on the ESPN networks.',
    // page
    'page.bucket.header.seeAll': "See All",
    // schedule
    'schedule.header': 'Schedule',
    'schedule.live': 'Live Now',
    'schedule.live.selectedTabError': 'live',
    'schedule.upcoming': 'Upcoming',
    'schedule.upcoming.selectedTabError': 'upcoming',
    'schedule.replay': 'Replay',
    'schedule.replay.selectedTabError': 'replay',
    'schedule.allSports': 'All Sports',
    'schedule.allNetworks': 'All Networks',
    'schedule.allLeagues': 'All Leagues',
    'schedule.replay.all': 'All',
    'schedule.replay.today': 'Today',
    'schedule.replay.last7Days': 'Last 7 days',
    'schedule.replay.last14Days': 'Last 14 days',
    'schedule.replay.last30Days': 'Last 30 days',
    'schedule.blackout': 'Subject to blackout',
    'schedule.message.empty': 'There are currently no {selectedTab} events for this selection.{br}Please check {otherTabs1} or {otherTabs2} or clear all filters.',
    // schedule module
    'schedule.module.header.live': 'Top Live',
    'schedule.module.header.upcoming': 'Upcoming',
    'schedule.module.header.upcoming.on': 'Upcoming on',
    'schedule.module.alert.upcoming': '{name} is scheduled to begin at {startTime} on {source}. {moreText}',
    'schedule.module.alert.moreText': 'Please enjoy {name} while you wait.',
    'schedule.module.eventDate.tomorrow': 'Tomorrow',
    // calendar months
    'schedule.calendar.month.January': 'January',
    'schedule.calendar.month.February': 'February',
    'schedule.calendar.month.March': 'March',
    'schedule.calendar.month.April': 'April',
    'schedule.calendar.month.May': 'May',
    'schedule.calendar.month.June': 'June',
    'schedule.calendar.month.July': 'July',
    'schedule.calendar.month.August': 'August',
    'schedule.calendar.month.September': 'September',
    'schedule.calendar.month.October': 'October',
    'schedule.calendar.month.November': 'November',
    'schedule.calendar.month.December': 'December',
    // calendar short days
    'schedule.calendar.day.Mon': 'MON',
    'schedule.calendar.day.Tue': 'TUE',
    'schedule.calendar.day.Wed': 'WED',
    'schedule.calendar.day.Thu': 'THU',
    'schedule.calendar.day.Fri': 'FRI',
    'schedule.calendar.day.Sat': 'SAT',
    'schedule.calendar.day.Sun': 'SUN',
    // calendar long days
    'schedule.calendar.day.Monday': 'Monday',
    'schedule.calendar.day.Tuesday': 'Tuesday',
    'schedule.calendar.day.Wednesday': 'Wednesday',
    'schedule.calendar.day.Thursday': 'Thursday',
    'schedule.calendar.day.Friday': 'Friday',
    'schedule.calendar.day.Saturday': 'Saturday',
    'schedule.calendar.day.Sunday': 'Sunday',
    // search
    'search.placeholder': 'Find your team, event, or show...',
    'search.results.message': 'Search results for {query}',
    // player
    'player.error.defaultMessage': 'This network is not included in your current television subscription. Please contact your provider to upgrade.',
    'player.error.recommendMobileWeb': 'The device is unable to play this video within the app.  Please try visiting espn.com/watch with the latest version of your browser on this device.',
    'player.error.unexpectedMessage': 'An unexpected error occurred during authorization. Please refresh the page to try again.',
    'player.menu.logout': 'Log Out of {providerName}',
    'player.feeds.title': 'Choose Broadcast',
    // provider dialog
    'search.filter.placeholder': 'Search All Providers',
    'provider.dialog.title': 'Choose Provider',
    'provider.dialog.subtitle': 'All Providers (A-Z):',
    'provider.dialog.description': 'Stream ESPN now by signing in with your TV provider. Having trouble? Check {faq} or {help}.',
    'provider.dialog.description.noCost': 'no additional cost',
    'provider.dialog.button.text': 'Get A TV Provider',
    'provider.dialog.faq.label': 'FAQs',
    'provider.dialog.help.link': 'http://www.espninstantaccess.com/',
    'provider.dialog.help.label': 'Get Help',
    'provider.dialog.call': '888-549-ESPN',
    // sign out
    'signout.message': 'Do you want to sign out of your {providerName} account?',
    'signout.label': 'Sign Out',
    // feedback
    'feedback.title': 'Don\'t want to chat? Submit feedback via email.',
    'feedback.caption': 'Provide your e-mail address if you\'d like us to follow up with you directly.',
    'feedback.category': 'Choose Category',
    'feedback.category.select': 'Select a category',
    'feedback.category.userExperience': 'User Experience',
    'feedback.category.videoPerformance': 'Video Performance',
    'feedback.category.programming': 'Programming',
    'feedback.category.other': 'Other',
    'feedback.email': 'E-mail',
    'feedback.provider': 'Cable / Internet Providers',
    'feedback.provider.default': 'Choose Provider',
    'feedback.platform': 'Platform',
    'feedback.desktoplaptop': 'Desktop/laptop',
    'feedback.iphone': 'iPhone',
    'feedback.ipad': 'iPad',
    'feedback.androidphone': 'Android Phone',
    'feedback.androidtablet': 'Android Tablet',
    'feedback.xbox': 'Xbox One',
    'feedback.playstation': 'PlayStation',
    'feedback.appletv': 'Apple TV',
    'feedback.androidtv': 'Android TV',
    'feedback.amazonfiretv': 'Amazon FireTV',
    'feedback.chromecast': 'Chromecast',
    'feedback.roku': 'Roku',
    'feedback.comments': 'Comments',
    'feedback.send': 'Send feedback',
    'feedback.thankYou': 'Thank you for posting your feedback.',
    'feedback.error.category': 'Please select a type of issue.',
    'feedback.error.email': 'Please enter your e-mail address.',
    'feedback.error.comments': 'Please enter your comment.',
    // misc
    'live': 'LIVE',
    'blackout': 'Blackout',
    // espnapp
    'espnapp.systemAlert.upcoming': 'This event has not started yet. Tune in at {time} to watch.',
    // syndicated player
    'syndicated.player.dialog': 'Live programming on WatchESPN is available for no additional cost from selected television and broadcast providers. Please choose your provider from the list below to sign in and see the ESPN networks you can watch:',
    'syndicated.player.dialog.label.continute': 'Continue',
    'syndicated.player.dialog.label.recheck': 'Recheck access',
    'syndicated.player.dialog.message.auth-success': 'You are logged in, playback will start shortly.',
    'syndicated.player.dialog.message.auth-retry': 'If playback does not begin in 5 seconds, please refresh your browser. This may take up to a minute.',
    'syndicated.player.dialog.message.xdomain': 'Your browser appears to block storing data that\'s required for the playback, change your browser setting to allow storing 3rd party data.',
    'syndicated.player.branding.tooltip': 'View this video on {brandingName}',
    'syndicated.player.domain.error': 'You are not allowed to access WatchESPN from this website. Please visit WatchESPN.com to see if you have access to this game.',
    'syndicated.player.message.upcoming': 'This event has not started yet. Please check back once the event has begun.',
    'syndicated.player.message.no-events': 'No events available.',
    'syndicated.player.message.geo': 'This video is not currently available to view in your location.',
    // unsupported error due to possible COUNTRY_AND_EDITION_CONFLICT Page API Error
    'unsupported.error.message': 'This content is not available in this country.'
};

/* harmony default export */ var en_us = (messages);
// CONCATENATED MODULE: ./app/lib/i18n/es.js
var es_messages = {
    // branding
    'branding.name': 'ESPN Play',
    // meta
    'meta.keywords': 'spn, espn3, espn 3, espnplay, espn play, partidos, eventos, programas, shows, en vivo, tv online, ' + 'en directo, ver online, on demand, pc, computadora, computador, m&oacute;vil, celular, smartphone, iphone, android, ' + 'tablet, ipad, abierto de australia, australian open, x games, nba, liga de espa&ntilde;a, liga bbva, futbol de Espa&ntilde;a, ' + 'ncaa, seria a italia, premier league, champions league, liga de campeones, UEFA, 6 naciones rugby',
    'meta.title.home': 'ESPN Play: Deportes en Vivo, Repeticiones, Highlights',
    'meta.description.home': 'Mira eventos en vivo, repeticiones, highlights y ten acceso a todo el contenido de ESPN ' + 'desde tu PC, dispositivo móvil y SmartTV a través de ESPN.com y la ESPN App',
    'meta.title.schedule': 'Agenda: en Vivo, Próximamente, Repeticiones – ESPN Play',
    'meta.description.schedule': 'Recibe notificaciones cuando tus eventos y shows favoritos estén próximos a comenzar o en vivo',
    'meta.title.features': 'Videos Destacados – ESPN Play',
    'meta.description.features': 'Disfruta clips sobre noticias destacadas, highlights de partidos y programación especial de ESPN en ESPN Play',
    'meta.title.collection': '{name} - ESPN Play',
    'meta.description.collection': 'Mira videos de la colección {name} en ESPN Play',
    'meta.title.player': '{name} - ESPN Play',
    'meta.description.player.vod': 'Mira el video {name} en ESPN Play',
    'meta.description.player.listing': 'Mira {name} en ESPN Play',
    'meta.title.activate': 'Activar – ESPN Play',
    'meta.description.activate': 'Activa tu dispositivo',
    'meta.title.subscribe': 'Suscríbete  – ESPN Play',
    'meta.description.subscribe': 'Activa tu dispositivo',
    'meta.title.feedback': 'Envíanos tu feedback - ESPN Play',
    'meta.description.feedback': 'Envíanos tu feedback sobre ESPN Play, el servicio que permite disfrutar desde tu PC y dispositivo móvil de tus deportes y programas de ESPN favoritos.',
    // page
    'page.bucket.header.seeAll': "Ver todos",
    // schedule
    'schedule.header': 'Programación',
    'schedule.live': 'En Vivo',
    'schedule.live.selectedTabError': 'en vivo',
    'schedule.upcoming': 'Próximamente',
    'schedule.upcoming.selectedTabError': 'Próximos',
    'schedule.replay': 'Repeticiones',
    'schedule.replay.selectedTabError': 'en Repeticiones',
    'schedule.allSports': 'Deportes',
    'schedule.allNetworks': 'Señales de TV',
    'schedule.allLeagues': 'Ligas',
    'schedule.replay.all': 'Todo',
    'schedule.replay.today': 'Hoy',
    'schedule.replay.last7Days': 'Últimos 7 días',
    'schedule.replay.last14Days': 'Últimos 14 días',
    'schedule.replay.last30Days': 'Últimos 30 días',
    'schedule.blackout': 'Subject to blackout', // TODO: Get Translation if needed
    'schedule.message.empty': 'Actualmente no hay eventos {selectedTab} disponibles para su selección.{br}Por favor revise {otherTabs1} o {otherTabs2} o elimine todos los filtros.',
    // schedule module
    'schedule.module.header.live': 'Destacados en Vivo',
    'schedule.module.header.upcoming': 'Próximamente',
    'schedule.module.header.upcoming.on': 'Próximamente',
    'schedule.module.alert.upcoming': '{name} comenzará a las {startTime} por {source}.',
    'schedule.module.alert.moreText': ' ',
    'schedule.module.eventDate.tomorrow': 'Mañana',
    // calendar months
    'schedule.calendar.month.January': 'Enero',
    'schedule.calendar.month.February': 'Febrero',
    'schedule.calendar.month.March': 'Marzo',
    'schedule.calendar.month.April': 'Abril',
    'schedule.calendar.month.May': 'Mayo',
    'schedule.calendar.month.June': 'Junio',
    'schedule.calendar.month.July': 'Julio',
    'schedule.calendar.month.August': 'Agosto',
    'schedule.calendar.month.September': 'Septiembre',
    'schedule.calendar.month.October': 'Octubre',
    'schedule.calendar.month.November': 'Noviembre',
    'schedule.calendar.month.December': 'Diciembre',
    // calendar short days
    'schedule.calendar.day.Mon': 'LUN',
    'schedule.calendar.day.Tue': 'MAR',
    'schedule.calendar.day.Wed': 'MIÉ',
    'schedule.calendar.day.Thu': 'JUE',
    'schedule.calendar.day.Fri': 'VIE',
    'schedule.calendar.day.Sat': 'SÁB',
    'schedule.calendar.day.Sun': 'DOM',
    // calendar long days
    'schedule.calendar.day.Monday': 'Lunes',
    'schedule.calendar.day.Tuesday': 'Martes',
    'schedule.calendar.day.Wednesday': 'Miércoles',
    'schedule.calendar.day.Thursday': 'Jueves',
    'schedule.calendar.day.Friday': 'Viernes',
    'schedule.calendar.day.Saturday': 'Sábado',
    'schedule.calendar.day.Sunday': 'Domingo',
    // search
    'search.placeholder': 'Buscar: encuentra tus equipos, eventos o shows favoritos',
    'search.results.message': 'Resultados de búsqueda para {query}',
    // player
    'player.error.defaultMessage': 'Esta señal no es parte del paquete de TV al que estás suscrito. Contacta a tu operador de cable.',
    'player.error.recommendMobileWeb': 'Esta aplicación no es compatible con tu dispositivo actualmente. Por favor ingresa a espn.com/watch y disfruta de todo nuestro contenido.',
    'player.error.unexpectedMessage': 'Ha ocurrido un error inesperado durante el login. Por favor actualiza la página y prueba nuevamente.',
    'player.menu.logout': 'Log Out of {providerName}',
    'player.feeds.title': 'Elige tu transmisión',
    // provider dialog
    'search.filter.placeholder': 'Buscar',
    'provider.dialog.title': 'Elige tu proveedor de cable',
    'provider.dialog.subtitle': 'Todos los proveedores (A-Z):',
    'provider.dialog.description': 'ESPN Play está disponible para los usuarios de los siguientes operadores de cable. ¿Necesitas ayuda? Ir a {faq}',
    'provider.dialog.description.noCost': 'Sin costo adicional',
    'provider.dialog.button.text': 'Elige un proveedor de cable',
    'provider.dialog.faq.label': 'preguntas frecuentes',
    'provider.dialog.help.link': '/watch/feedback', // Deprecated as of 04/26/20; removed from dialog.description
    'provider.dialog.help.label': 'contáctenos',
    'provider.dialog.call': '888-549-ESPN',
    // sign out
    'signout.message': '¿Quieres cerrar tu sesión?',
    'signout.label': 'desconectarse',
    // feedback
    'feedback.title': 'Envía tus comentarios vía e-mail.',
    'feedback.caption': 'Déjanos tu dirección de e-mail si quieres que te contactemos directamente.',
    'feedback.category': 'Elige una categoría',
    'feedback.category.select': 'Elige una categoría',
    'feedback.category.userExperience': 'Experiencia del usuario',
    'feedback.category.videoPerformance': 'Performance de videos',
    'feedback.category.programming': 'Programación',
    'feedback.category.other': 'Otros',
    'feedback.email': 'E-mail',
    'feedback.provider': 'Cableoperador / Proveedor de internet',
    'feedback.provider.default': 'Elige tu proveedor',
    'feedback.platform': 'Plataforma',
    'feedback.desktoplaptop': 'Computador/portatil',
    'feedback.iphone': 'iPhone',
    'feedback.ipad': 'iPad',
    'feedback.androidphone': 'Android Móvil',
    'feedback.androidtablet': 'Android Tablet',
    'feedback.xbox': 'Xbox One',
    'feedback.playstation': 'PlayStation',
    'feedback.appletv': 'Apple TV',
    'feedback.androidtv': 'Android TV',
    'feedback.amazonfiretv': 'Amazon FireTV',
    'feedback.chromecast': 'Chromecast',
    'feedback.roku': 'Roku',
    'feedback.comments': 'Comentarios',
    'feedback.send': 'Enviar comentarios',
    'feedback.thankYou': 'Gracias por tu dejarnos tu feedback.',
    'feedback.error.category': 'Selecciona el tipo de inconveniente.',
    'feedback.error.email': 'Ingresa tu dirección de e-mail.',
    'feedback.error.comments': 'Escribe tu comentario.',
    // misc
    'live': 'EN VIVO',
    'blackout': 'Blackout',
    // espnapp
    'espnapp.systemAlert.upcoming': 'This event has not started yet. Tune in at {time} to watch.',
    // syndicated player
    'syndicated.player.dialog': 'Live programming on WatchESPN is available for no additional cost from selected television and broadcast providers. Please choose your provider from the list below to sign in and see the ESPN networks you can watch:',
    'syndicated.player.dialog.label.continute': 'Continue',
    'syndicated.player.dialog.label.recheck': 'Recheck access',
    'syndicated.player.dialog.message.auth-success': 'You are logged in, playback will start shortly.',
    'syndicated.player.dialog.message.auth-retry': 'If playback does not begin in 5 seconds, please refresh your browser. This may take up to a minute.',
    'syndicated.player.dialog.message.xdomain': 'Your browser appears to block storing data that\'s required for the playback, change your browser setting to allow storing 3rd party data.',
    'syndicated.player.branding.tooltip': 'View this video on {brandingName}',
    'syndicated.player.domain.error': 'No tienes acceso a ESPN Play desde este sitio. Por favor visita ESPNPlay.com para verificar tu acceso a este partido.',
    'syndicated.player.message.upcoming': 'This event has not started yet. Please check back once the event has begun.',
    'syndicated.player.message.no-events': 'No events available.',
    'syndicated.player.message.geo': 'El vídeo no está disponible en tu país.',
    // unsupported error due to possible COUNTRY_AND_EDITION_CONFLICT Page API Error
    'unsupported.error.message': 'Este contenido no está disponible en el país donde se encuentra actualmente.'
};

/* harmony default export */ var i18n_es = (es_messages);
// CONCATENATED MODULE: ./app/lib/i18n/pt.js
var pt_messages = {
    // branding
    'branding.name': 'WatchESPN',
    // meta
    'meta.keywords': 'watchespn, watch espn, watchespn mobile, watchespn xbox live, live sports, watch live sports, ' + 'watch espn online, watch espn on xbox, watch espn on mobile phone, espn, espn2, espn3, espnu',
    'meta.title.home': 'WatchESPN: Esportes ao vivo, Reprise dos jogos, Destaques em vídeo',
    'meta.description.home': 'Assista eventos esportivos, reprises, destaques dos melhores jogos acessando o conteúdo ESPN seu computador, celular, TV no ESPN.com e no ESPN App.',
    'meta.title.schedule': 'Agenda: Ao vivo, Próximos, Reprises - WatchESPN',
    'meta.description.schedule': 'Obtenha informações e datas do seus esportes e programas favoritos, ao vivo, próximos eventos e reprises' + 'através todos os canais ESPN pelo WatchESPN.',
    'meta.title.features': 'Vídeos em destaque - WatchESPN',
    'meta.description.features': 'Assista novos vídeos em destaque, melhores momentos dos jogos e uma programação especial da ESPN pelo WatchESPN.',
    'meta.title.collection': '{name} - WatchESPN',
    'meta.description.collection': 'Assista vídeos da categoria {name} no WatchESPN.',
    'meta.title.player': '{name} - WatchESPN',
    'meta.description.player.vod': 'Assista ao vídeo {name} no WatchESPN.',
    'meta.description.player.listing': 'Assista {name} no WatchESPN.',
    'meta.title.activate': 'Ativar - WatchESPN',
    'meta.description.activate': 'Ativar seu aparelho',
    'meta.title.subscribe': 'Ativar - WatchESPN',
    'meta.description.subscribe': 'Ativar seu aparelho',
    'meta.title.feedback': 'Envie o seu feedback - WatchESPN',
    'meta.description.feedback': 'Envie o seu feedback para o WatchESPN, o serviço que permite acesso completo aos eventos ao vivo de esportes, reprises e programas da ESPN no seu computador e smartphones.',
    // page
    'page.bucket.header.seeAll': "Ver mais",
    // schedule
    'schedule.header': 'Agenda',
    'schedule.live': 'Agora',
    'schedule.live.selectedTabError': 'Agora',
    'schedule.upcoming': 'Próximos',
    'schedule.upcoming.selectedTabError': 'Próximos',
    'schedule.replay': 'Reprise',
    'schedule.replay.selectedTabError': 'Reprise',
    'schedule.allSports': 'Todos os esportes',
    'schedule.allNetworks': 'Todos os canais',
    'schedule.allLeagues': 'Todas as ligas',
    'schedule.replay.all': 'Tudo',
    'schedule.replay.today': 'Hoje',
    'schedule.replay.last7Days': 'Últimos 7 dias',
    'schedule.replay.last14Days': 'Últimos 14 dias',
    'schedule.replay.last30Days': 'Últimos 30 dias',
    'schedule.blackout': 'Subject to blackout', // TODO: Get Translation if needed
    'schedule.message.empty': 'Não existe nenhuma evento {selectedTab} para essa seleção.{br}Por favor cheque {otherTabs1} ou {otherTabs2} ou limpe todos os filtros.',
    // schedule module
    'schedule.module.header.live': 'Destaques ao vivo',
    'schedule.module.header.upcoming': 'Próximos',
    'schedule.module.header.upcoming.on': 'Próximos',
    'schedule.module.alert.upcoming': '{name} está programado para começar às {startTime} no {source}.',
    'schedule.module.alert.moreText': ' ',
    'schedule.module.eventDate.tomorrow': 'Amanhã',
    // calendar months
    'schedule.calendar.month.January': 'Janeiro',
    'schedule.calendar.month.February': 'Fevereiro',
    'schedule.calendar.month.March': 'Março',
    'schedule.calendar.month.April': 'Abril',
    'schedule.calendar.month.May': 'Maio',
    'schedule.calendar.month.June': 'Junho',
    'schedule.calendar.month.July': 'Julho',
    'schedule.calendar.month.August': 'Agosto',
    'schedule.calendar.month.September': 'Setembro',
    'schedule.calendar.month.October': 'Outubro',
    'schedule.calendar.month.November': 'Novembro',
    'schedule.calendar.month.December': 'Dezembro',
    // calendar short days
    'schedule.calendar.day.Mon': 'SEG',
    'schedule.calendar.day.Tue': 'TER',
    'schedule.calendar.day.Wed': 'QUA',
    'schedule.calendar.day.Thu': 'QUI',
    'schedule.calendar.day.Fri': 'SEX',
    'schedule.calendar.day.Sat': 'SÁB',
    'schedule.calendar.day.Sun': 'DOM',
    // calendar long days
    'schedule.calendar.day.Monday': 'Segunda-feira',
    'schedule.calendar.day.Tuesday': 'Terça-feira',
    'schedule.calendar.day.Wednesday': 'Quarta-feira',
    'schedule.calendar.day.Thursday': 'Quinta-feira',
    'schedule.calendar.day.Friday': 'Sexta-feira',
    'schedule.calendar.day.Saturday': 'Sábado',
    'schedule.calendar.day.Sunday': 'Domingo',
    // search
    'search.placeholder': 'Busca: Encontre seu time, evento ou programa...',
    'search.results.message': 'Resultados da busca por {query}',
    // player
    'player.error.defaultMessage': 'Esse canal não está incluído no seu pacote atual de assinatura. Por favor entre em contato com o seu provedor para atualizar.',
    'player.error.recommendMobileWeb': 'Esse aplicativo não é suportado nesse aparelho. Se você abrir o seu navegador e ir para espn.com/watch você poderá acessar o conteúdo normalmente.',
    'player.error.unexpectedMessage': 'Um erro inesperado aconteceu durante a autorização. Por favor recarregue a página para tentar novamente.',
    'player.menu.logout': 'Log Out of {providerName}',
    'player.feeds.title': 'Escolha o Canal',
    // provider dialog
    'search.filter.placeholder': 'Buscar',
    'provider.dialog.title': 'Escolha o seu provedor',
    'provider.dialog.subtitle': 'Todos os provedores (A-Z):',
    'provider.dialog.description': 'Aqui você assiste eventos e programas AO VIVO, filmes, séries, documentários e conteúdos exclusivos no seu computador, tablet ou smartphone. ' + 'Precisa de ajuda? Veja {faq}.',
    'provider.dialog.description.noCost': 'sem custo adicional', // Deprecated as of 09/2018; description was updated WI-545
    'provider.dialog.button.text': 'Ainda não tem ESPN? Clique aqui!',
    'provider.dialog.faq.label': 'perguntas frequentes',
    'provider.dialog.help.link': '/watch/feedback', // Deprecated as of 07/05/18; removed from dialog.description
    'provider.dialog.help.label': 'contato', // Deprecated as of 07/05/18; removed from dialog.description
    'provider.dialog.call': '888-549-ESPN',
    // sign out
    'signout.message': 'Você deseja sair da sua conta {providerName}?',
    'signout.label': 'Sair',
    // feedback
    'feedback.title': 'Envie o seu comentário por email.',
    'feedback.caption': 'Forneça o seu email se você quiser que a ESPN entre em contato diretamente.',
    'feedback.category': 'Escolha uma categoria',
    'feedback.category.select': 'Selecione uma categoria',
    'feedback.category.userExperience': 'Experiencia do usuario',
    'feedback.category.videoPerformance': 'Performance nos vídeos',
    'feedback.category.programming': 'Programação',
    'feedback.category.other': 'Outros',
    'feedback.email': 'E-mail',
    'feedback.provider': 'TV a cabo / Provedores de internet',
    'feedback.provider.default': 'Escolher provedor de acesso',
    'feedback.platform': 'Plataforma',
    'feedback.desktoplaptop': 'Desktop/notebook',
    'feedback.iphone': 'iPhone',
    'feedback.ipad': 'iPad',
    'feedback.androidphone': 'Telefone Android',
    'feedback.androidtablet': 'Tablet Android',
    'feedback.xbox': 'Xbox One',
    'feedback.playstation': 'PlayStation',
    'feedback.appletv': 'Apple TV',
    'feedback.androidtv': 'Android TV',
    'feedback.amazonfiretv': 'Amazon FireTV',
    'feedback.chromecast': 'Chromecast',
    'feedback.roku': 'Roku',
    'feedback.comments': 'Comentários',
    'feedback.send': 'Enviar comentários',
    'feedback.thankYou': 'Obrigado pelo seu feedback',
    'feedback.error.category': 'Por favor selecione o tipo do assunto',
    'feedback.error.email': 'Por favor preencha o seu e-mail',
    'feedback.error.comments': 'Por favor preencha o seu comentário',
    // misc
    'live': 'NO AR',
    'blackout': 'Blackout',
    // espnapp
    'espnapp.systemAlert.upcoming': 'This event has not started yet. Tune in at {time} to watch.',
    // syndicated player
    'syndicated.player.dialog': 'Live programming on WatchESPN is available for no additional cost from selected television and broadcast providers. Please choose your provider from the list below to sign in and see the ESPN networks you can watch:',
    'syndicated.player.dialog.label.continute': 'Continue',
    'syndicated.player.dialog.label.recheck': 'Recheck access',
    'syndicated.player.dialog.message.auth-success': 'You are logged in, playback will start shortly.',
    'syndicated.player.dialog.message.auth-retry': 'If playback does not begin in 5 seconds, please refresh your browser. This may take up to a minute.',
    'syndicated.player.dialog.message.xdomain': 'Your browser appears to block storing data that\'s required for the playback, change your browser setting to allow storing 3rd party data.',
    'syndicated.player.branding.tooltip': 'View this video on {brandingName}',
    'syndicated.player.domain.error': 'You are not allowed to access WatchESPN from this website. Please visit WatchESPN.com to see if you have access to this game.',
    'syndicated.player.message.upcoming': 'This event has not started yet. Please check back once the event has begun.',
    'syndicated.player.message.no-events': 'No events available.',
    'syndicated.player.message.geo': 'Vídeo não está disponível no seu país.',
    // unsupported error due to possible COUNTRY_AND_EDITION_CONFLICT Page API Error
    'unsupported.error.message': 'Este conteúdo não está disponível no país em que você está atualmente.'
};

/* harmony default export */ var pt = (pt_messages);
// CONCATENATED MODULE: ./app/lib/i18n/nl.js
var nl_messages = {
    // branding
    'branding.name': 'WatchESPN',
    // meta
    'meta.keywords': 'watchespn, watch espn, watchespn mobile, watchespn xbox live, live sports, kijk live sport, ' + 'kijk espn online, kijk espn on xbox, kijk espn op je smartphone, espn, espn2, espn3, espnu',
    'meta.title.home': 'WatchESPN: Live Sport, herhalingen, Samenvattingen',
    'meta.description.home': 'Stream live sport, bekijk wedstrijd herhalingen, ontvang samenvattingen en toegang tot de ' + 'ESPN programmering op jouw computer, mobiele telefoon, en TV met WatchESPN.',
    'meta.title.schedule': 'Schema: Live, Volgende, Herhalingen - WatchESPN',
    'meta.description.schedule': 'Ontvang het schema voor live, komende, en herhalingen van jouw favoriete sporten en shows op elk ESPN netwerk op WatchESPN.',
    'meta.title.features': 'Aanbevolen Video\'s - WatchESPN',
    'meta.description.features': 'Bekijk uitgelichte nieuwsclips, samenvattingen en speciale ESPN programmering op WatchESPN.',
    'meta.title.collection': '{name} - WatchESPN',
    'meta.description.collection': 'Bekijk video\'s van de {name} collectie op WatchESPN.',
    'meta.title.player': '{name} - WatchESPN',
    'meta.description.player.vod': 'Bekijk de {name} video op WatchESPN.',
    'meta.description.player.listing': 'Bekijk {name} op WatchESPN.',
    'meta.title.activate': 'Activeer - Watch ESPN',
    'meta.description.activate': 'Activeer jouw device',
    'meta.title.subscribe': 'Abonneer - WatchESPN',
    'meta.description.subscribe': 'Abonneer jouw device',
    'meta.title.feedback': 'Geef Feedback - WatchESPN',
    'meta.description.feedback': 'Geef feedback op WatchESPN; de service die je toegang geeft op jouw PC, mobiele apparaten en Xbox Live voor alle live sport events, herhalingen en programma\'s op ESPN',
    // page
    'page.bucket.header.seeAll': 'Toon Alles',
    // schedule
    'schedule.header': 'Programma',
    'schedule.live': 'Live',
    'schedule.live.selectedTabError': 'Live',
    'schedule.upcoming': 'Straks',
    'schedule.upcoming.selectedTabError': 'aanstaande',
    'schedule.replay': 'Herhalingen',
    'schedule.replay.selectedTabError': 'herhalingen',
    'schedule.allSports': 'Alle Sporten',
    'schedule.allNetworks': 'Alle Kanalen',
    'schedule.allLeagues': 'Alle Competities',
    'schedule.replay.all': 'Alles',
    'schedule.replay.today': 'Vandaag',
    'schedule.replay.last7Days': 'Laatste 7 dagen',
    'schedule.replay.last14Days': 'Laatste 14 dagen',
    'schedule.replay.last30Days': 'Laatste 30 dagen',
    'schedule.blackout': 'Onder voorbehoud van black-out',
    'schedule.message.empty': 'Er zijn op dit moment geen {selectedTab} programma\'s voor deze selectie. Controleer {otherTabs1} of {otherTabs2} of verwijder alle filters.',
    // schedule module
    'schedule.module.header.live': 'Top Live',
    'schedule.module.header.upcoming': 'Straks',
    'schedule.module.header.upcoming.on': 'Straks op',
    'schedule.module.alert.upcoming': '{name} staat gepland om te beginnen om {startTime} op {source}. {moreText}',
    'schedule.module.alert.moreText': 'Geniet van {name} terwijl je wacht.',
    'schedule.module.eventDate.tomorrow': 'Morgen',
    // calendar months
    'schedule.calendar.month.January': 'Januari',
    'schedule.calendar.month.February': 'Februari',
    'schedule.calendar.month.March': 'Maart',
    'schedule.calendar.month.April': 'April',
    'schedule.calendar.month.May': 'Mei',
    'schedule.calendar.month.June': 'Juni',
    'schedule.calendar.month.July': 'Juli',
    'schedule.calendar.month.August': 'Augustus',
    'schedule.calendar.month.September': 'September',
    'schedule.calendar.month.October': 'Oktober',
    'schedule.calendar.month.November': 'November',
    'schedule.calendar.month.December': 'December',
    // calendar short days
    'schedule.calendar.day.Mon': 'Maa',
    'schedule.calendar.day.Tue': 'Din',
    'schedule.calendar.day.Wed': 'Woe',
    'schedule.calendar.day.Thu': 'Don',
    'schedule.calendar.day.Fri': 'Vrij',
    'schedule.calendar.day.Sat': 'Zat',
    'schedule.calendar.day.Sun': 'Zon',
    // calendar long days
    'schedule.calendar.day.Monday': 'Maandag',
    'schedule.calendar.day.Tuesday': 'Dinsdag',
    'schedule.calendar.day.Wednesday': 'Woensdag',
    'schedule.calendar.day.Thursday': 'Donderdag',
    'schedule.calendar.day.Friday': 'Vrijdag',
    'schedule.calendar.day.Saturday': 'Zaterdag',
    'schedule.calendar.day.Sunday': 'Zondag',
    // search
    'search.placeholder': 'Vind jouw team, evenement of programma...',
    'search.results.message': 'Zoek uitslagen voor {query}',
    // player
    'player.error.defaultMessage': 'Dit netwerk valt niet onder jouw huidige televisie abonnement. Neem contact op met je provider voor een upgrade.',
    'player.error.recommendMobileWeb': 'Dit device kan deze video niet afspelen in de app. Bezoek espn.com/watch met de laatste versie van je browser op dit device.',
    'player.error.unexpectedMessage': 'Er is een onverwachte fout opgetreden, Ververs de pagina en probeer opnieuw.',
    'player.menu.logout': 'Log Uit op {providerName}',
    'player.feeds.title': 'Kies een Uitzending',
    // provider dialog
    'search.filter.placeholder': 'Zoek Alle Providers',
    'provider.dialog.title': 'Kies een Provider',
    'provider.dialog.subtitle': 'Alle Providers (A-Z):',
    'provider.dialog.description': 'Stream ESPN nu door je aan te melden bij jouw TV provider. Problemen? Ga naar {faq} of {help}.',
    'provider.dialog.description.noCost': 'Geen extra kosten',
    'provider.dialog.button.text': 'Selecteer Een TV Provider',
    'provider.dialog.faq.label': 'FAQs',
    'provider.dialog.help.link': ' /watch/feedback', // Deprecated as of 04/26/20; removed from dialog.description
    'provider.dialog.help.label': 'Ontvang Hulp',
    'provider.dialog.call': '888-549-ESPN',
    // sign out
    'signout.message': 'Wil je uitloggen op jouw {providerName} account?',
    'signout.label': 'Log Uit',
    // feedback
    'feedback.title': 'Geen zin om te chatten? stuur je feedback via de mail.',
    'feedback.caption': 'Lever je email adres als je wilt dat we direct contact met je opnemen.',
    'feedback.category': 'Kies een Categorie',
    'feedback.category.select': 'Selecteer een Categorie',
    'feedback.category.userExperience': 'Gebruikerservaring',
    'feedback.category.videoPerformance': 'Video Prestaties',
    'feedback.category.programming': 'Programmering',
    'feedback.category.other': 'Anders',
    'feedback.email': 'E-mail',
    'feedback.provider': 'Kabel / Internet Providers',
    'feedback.provider.default': 'Kies een Provider',
    'feedback.platform': 'Platform',
    'feedback.desktoplaptop': 'Desktop/laptop',
    'feedback.iphone': 'iPhone',
    'feedback.ipad': 'iPad',
    'feedback.androidphone': 'Android Telefoon',
    'feedback.androidtablet': 'Android Tablet',
    'feedback.xbox': 'Xbox One',
    'feedback.playstation': 'PlayStation',
    'feedback.appletv': 'Apple TV',
    'feedback.androidtv': 'Android TV',
    'feedback.amazonfiretv': 'Amazon FireTV',
    'feedback.chromecast': 'Chromecast',
    'feedback.roku': 'Roku',
    'feedback.comments': 'Opmerkingen',
    'feedback.send': 'Verstuur Feedback',
    'feedback.thankYou': 'Bedankt voor het plaatsen van je feedback.',
    'feedback.error.category': 'Selecteer een bepaald type probleem.',
    'feedback.error.email': 'Vul hier je emailadres in.',
    'feedback.error.comments': 'Vul hier je opmerking in.',
    // misc
    live: 'LIVE',
    blackout: 'Blackout',
    // espnapp
    'espnapp.systemAlert.upcoming': 'Dit evenement is nog niet begonnen. Kom terug om {time} om dit te bekijken.',
    // syndicated player
    'syndicated.player.dialog': 'Live programmering op WatchESPN is beschikbaar zonder additionele kosten voor geselecteerde TV providers. Selecteer alsjeblieft jouw provider om in te loggen en te zien welke ESPN netwerken je kan kijken:',
    'syndicated.player.dialog.label.continute': 'Doorgaan',
    'syndicated.player.dialog.label.recheck': 'Controleer toegang',
    'syndicated.player.dialog.message.auth-success': 'Je bent ingelogd, je video begint zo snel mogelijk.',
    'syndicated.player.dialog.message.auth-retry': 'Als de video niet in 5 seconden begint, refresh je browser. Het kan maximaal een minuut duren.',
    'syndicated.player.dialog.message.xdomain': 'Je browser lijkt het opslaan van data te blokkeren wat nodig is om de video af te spelen. Pas je browser-instellingen aan om 3rd party data toe te staan.',
    'syndicated.player.branding.tooltip': 'Bekijk deze video op {brandingName}',
    'syndicated.player.domain.error': 'Het is voor jou niet toegestaan om WatchESPN vanaf deze website te bezoeken. Bezoek WatchESPN.com om te kijken of je toegang hebt tot deze wedstrijd.',
    'syndicated.player.message.upcoming': 'Dit evenement is nog niet begonnen. Kom terug wanneer dit evenement begonnen is.',
    'syndicated.player.message.no-events': 'Geen evenementen beschikbaar.',
    'syndicated.player.message.geo': 'deze video is niet meer beschikbaar om te bekijken vanaf jouw locatie.',
    // unsupported error due to possible COUNTRY_AND_EDITION_CONFLICT Page API Error
    'unsupported.error.message': 'Deze inhoud is niet beschikbaar in dit land.'
};

/* harmony default export */ var nl = (nl_messages);
// CONCATENATED MODULE: ./app/lib/i18n/index.js





var langMap = {
    'en-us': en_us,
    en: en_us,
    es: i18n_es,
    pt: pt,
    nl: nl
};

var i18n_messages = Object.keys(en_us).reduce(function (acc, id) {
    acc[id] = {
        id: id,
        description: id,
        defaultMessage: en_us[id]
    };
    return acc;
}, {});

var langs = function langs(locale) {
    return langMap[locale] || langMap['en'];
};

function isLangSupported(locale) {
    return supportedLangs().indexOf(locale) !== -1;
}

function supportedLangs() {
    return Object.keys(langMap);
}
// EXTERNAL MODULE: ./app/common/selectors/appSelector.js + 1 modules
var appSelector = __webpack_require__(3);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(106);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./node_modules/moment/locale/es.js
var locale_es = __webpack_require__(797);
var es_default = /*#__PURE__*/__webpack_require__.n(locale_es);

// EXTERNAL MODULE: ./node_modules/moment/locale/pt-br.js
var pt_br = __webpack_require__(798);
var pt_br_default = /*#__PURE__*/__webpack_require__.n(pt_br);

// CONCATENATED MODULE: ./app/common/IntlProvider.js
/* unused harmony export ConnectedIntlProvider */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










// override default locale config
moment_default.a.updateLocale('es', {
    ordinal: function ordinal(number) {
        return number === 1 ? number + '\xBA' : '' + number;
    }
});

var IntlProvider_ConnectedIntlProvider = function (_Component) {
    _inherits(ConnectedIntlProvider, _Component);

    function ConnectedIntlProvider(props) {
        _classCallCheck(this, ConnectedIntlProvider);

        // set locale globally
        // we explicitly bundle only `pt-br` locale
        var _this = _possibleConstructorReturn(this, (ConnectedIntlProvider.__proto__ || Object.getPrototypeOf(ConnectedIntlProvider)).call(this, props));

        var locale = props.lang === 'pt' ? 'pt-br' : props.lang;
        moment_default.a.locale(locale);
        return _this;
    }

    _createClass(ConnectedIntlProvider, [{
        key: 'getChildContext',
        value: function getChildContext() {
            return {
                messages: _extends({}, i18n_messages)
            };
        }
    }, {
        key: 'render',
        value: function render() {
            return react_default.a.createElement(index_es["b" /* IntlProvider */], _extends({}, this.props, { locale: this.props.lang }));
        }
    }]);

    return ConnectedIntlProvider;
}(react["Component"]);

IntlProvider_ConnectedIntlProvider.contextTypes = {
    messages: react["PropTypes"].object
};

IntlProvider_ConnectedIntlProvider.childContextTypes = {
    messages: react["PropTypes"].object.isRequired
};

var IntlProvider_mapStateToProps = function mapStateToProps(state) {
    var intl = Object(appSelector["q" /* intlSelector */])(state);
    return _extends({}, intl, {
        key: intl.lang
    });
};

/* harmony default export */ var IntlProvider = __webpack_exports__["a"] = (Object(es["b" /* connect */])(IntlProvider_mapStateToProps)(IntlProvider_ConnectedIntlProvider));

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(381);
module.exports = __webpack_require__(382);


/***/ }),
/* 381 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/bluebird/js/browser/bluebird.js
var bluebird = __webpack_require__(11);
var bluebird_default = /*#__PURE__*/__webpack_require__.n(bluebird);

// CONCATENATED MODULE: ./app/polyfills.js


bluebird_default.a.config({
    warnings: 'production' !== 'production'
});

if (!window.Promise) {
    window.Promise = bluebird_default.a;
}
// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(81);
var react_dom_default = /*#__PURE__*/__webpack_require__.n(react_dom);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(4);

// EXTERNAL MODULE: ./node_modules/react-router/lib/index.js
var lib = __webpack_require__(85);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/react-router-scroll/lib/index.js
var react_router_scroll_lib = __webpack_require__(522);
var react_router_scroll_lib_default = /*#__PURE__*/__webpack_require__.n(react_router_scroll_lib);

// EXTERNAL MODULE: ./app/lib/omniture/index.js
var omniture = __webpack_require__(34);

// EXTERNAL MODULE: ./app/common/selectors/routingSelector.js
var routingSelector = __webpack_require__(23);

// EXTERNAL MODULE: ./node_modules/react-router-redux/lib/index.js
var react_router_redux_lib = __webpack_require__(69);
var react_router_redux_lib_default = /*#__PURE__*/__webpack_require__.n(react_router_redux_lib);

// EXTERNAL MODULE: ./node_modules/superagent-bluebird-promise/index.js
var superagent_bluebird_promise = __webpack_require__(274);
var superagent_bluebird_promise_default = /*#__PURE__*/__webpack_require__.n(superagent_bluebird_promise);

// CONCATENATED MODULE: ./app/lib/api/request.js


/* harmony default export */ var request = (superagent_bluebird_promise_default.a);
// EXTERNAL MODULE: ./app/enums.js
var enums = __webpack_require__(1);

// CONCATENATED MODULE: ./app/lib/api/AdobeClientlessAPI.js
var _ENVIRONMENT_CONFIGUR;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var AdobePassEnv = enums["a" /* AdobePass */].Env;


var REQUESTOR_ID = 'ESPN';

var ENVIRONMENT_CONFIGURATION = (_ENVIRONMENT_CONFIGUR = {}, _defineProperty(_ENVIRONMENT_CONFIGUR, AdobePassEnv.STAGING, {
    baseUrl: 'https://api.auth-staging.adobe.com'
}), _defineProperty(_ENVIRONMENT_CONFIGUR, AdobePassEnv.PROD, {
    baseUrl: 'https://api.auth.adobe.com'
}), _ENVIRONMENT_CONFIGUR);

var SERVICE_PATH = {
    reggie: '/reggie/v1',
    sp: '/api/v1'
};

var ENDPOINTS = {
    config: '/config',
    checkRegCode: '/regcode',
    checkAuthN: '/checkauthn',
    authenticate: '/authenticate'
};

function getBaseUrl() {
    var env = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : AdobePassEnv.PROD;

    // In the event the query parameter `passenv` value does not match the ENVIRONMENT_CONFIGURATION
    // object, we want to default to the `production` baseUrl
    var defaultEnv = AdobePassEnv.PROD;
    return ENVIRONMENT_CONFIGURATION[env].baseUrl || ENVIRONMENT_CONFIGURATION[defaultEnv].baseUrl;
}

function getSpUrl(env) {
    return '' + getBaseUrl(env) + SERVICE_PATH.sp;
}

function getReggieUrl(env) {
    return '' + getBaseUrl(env) + SERVICE_PATH.reggie;
}

function getConfig() {
    var url = '' + getSpUrl() + ENDPOINTS.config + '/' + REQUESTOR_ID;
    return request.get(url).set('Accept', 'application/json').then(function (_ref) {
        var body = _ref.body;
        return body;
    }).catch(function (err) {
        return err;
    });
}

function checkRegCode(regCode, env) {
    var url = getReggieUrl(env) + '/' + REQUESTOR_ID + ENDPOINTS.checkRegCode + '/' + regCode;
    return request.get(url).set('Accept', 'application/json').then(function (_ref2) {
        var body = _ref2.body;
        return body;
    }).catch(function (err) {
        return err;
    });
}

// Not currently used although recommended by Adobe to call before success page
// http://tve.helpdocsonline.com/clientless-api-reference$$check_authn_token
function checkAuthN(regCode) {
    var url = '' + getSpUrl() + ENDPOINTS.checkAuthN + '/' + regCode + '?requestor=' + REQUESTOR_ID;
    return request.get(url).set('Accept', 'application/json').then(function (_ref3) {
        var status = _ref3.status;
        return status === 200;
    }).catch(function () {
        return false;
    });
}

function getAuthSuccessUrl(_ref4) {
    var mvpd = _ref4.mvpd,
        deviceType = _ref4.deviceType,
        _ref4$baseUrl = _ref4.baseUrl,
        baseUrl = _ref4$baseUrl === undefined ? window.location.href : _ref4$baseUrl;

    return '' + baseUrl + (baseUrl.indexOf('?') === -1 ? '?' : '&') + 'mvpd=' + mvpd + '&authSystem=adobepass&deviceType=' + deviceType + '&authSuccess=true';
}

function getAuthErrorUrl(_ref5) {
    var _ref5$baseUrl = _ref5.baseUrl,
        baseUrl = _ref5$baseUrl === undefined ? window.location.href : _ref5$baseUrl;

    return '' + baseUrl + (baseUrl.indexOf('?') === -1 ? '?' : '&') + 'error=true';
}

function getAuthenticateUrl(_ref6) {
    var regCode = _ref6.regCode,
        mvpd = _ref6.mvpd,
        deviceType = _ref6.deviceType,
        _ref6$baseUrl = _ref6.baseUrl,
        baseUrl = _ref6$baseUrl === undefined ? window.location.href : _ref6$baseUrl,
        adobePassEnv = _ref6.adobePassEnv;

    var redirectUrl = getAuthSuccessUrl({ mvpd: mvpd, deviceType: deviceType, baseUrl: baseUrl });
    var qs = 'reg_code=' + regCode + '&noflash=true&mso_id=' + mvpd + '&requestor_id=' + REQUESTOR_ID + '&domain_name=adobe.com&redirect_url=' + encodeURIComponent(redirectUrl);
    var url = '' + getSpUrl(adobePassEnv) + ENDPOINTS.authenticate + '?' + qs;

    return url;
}
// EXTERNAL MODULE: ./app/lib/format/removeQueryFromUrl.js
var removeQueryFromUrl = __webpack_require__(276);

// EXTERNAL MODULE: ./app/common/actions/appActions.js
var appActions = __webpack_require__(19);

// EXTERNAL MODULE: ./app/lib/oneId/index.js
var oneId = __webpack_require__(52);

// CONCATENATED MODULE: ./app/webapp/page/Activate/constants.js
var constants_deviceName = {
    androidtv: 'Android TV',
    appletv: 'Apple TV',
    tvOS: 'Apple TV',
    firetv: 'Fire TV',
    roku: 'Roku',
    ps3: 'PS3',
    ps4: 'PS4',
    xbox: 'Xbox',
    xboxone: 'Xbox One'
};

var INVALID_MESSAGE = 'Invalid activate code!';
var DEFAULT_VALUE = 'initialValue'; // empty value might hit the affilites w/o abbreviation in the console

var WEB_STAGE_ONE_ID_API_PATH = 'https://stg.registerdisney.go.com/jgc/v6/client/ESPN-ONESITE.WEB-STAGE';
var WEB_PROD_ONE_ID_API_PATH = 'https://registerdisney.go.com/jgc/v6/client/ESPN-ONESITE.WEB-PROD';
var WEB_ESPN_PLUS_PURCHASE_PATH_QA = 'https://qa-secure.web.plus.espn.com/billing/purchase';
var WEB_ESPN_PLUS_PURCHASE_PATH_PROD = 'https://secure.web.plus.espn.com/billing/purchase';

/* harmony default export */ var constants = (constants_deviceName);
// CONCATENATED MODULE: ./app/webapp/page/Activate/util/getSuccessText.js


/* harmony default export */ var getSuccessText = (function (authSystem, deviceType) {
    var device = constants[deviceType] || 'device';
    if (authSystem === 'adobepass') {
        return 'Your ' + device + ' is Activated';
    }
    return 'Your ' + device + ' has been connected to your ESPN account';
});
// CONCATENATED MODULE: ./app/webapp/page/Activate/util/isAdobeRegCode.js
/**
 * Returns true if the code is an Adobe Reg code (has alpha chars, and is of length 7)
 * @param {string} code - Either a OneID or Adobe Reg Code
 */
/* harmony default export */ var isAdobeRegCode = (function () {
  var code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return (/[A-Za-z]/.test(code) && code.length === 7
  );
});
// CONCATENATED MODULE: ./app/webapp/page/Activate/util/isOneIdRegCode.js
/**
 * Returns true if the code is alphanumeric and of length 6
 * @param {string} code - Either a OneID or Adobe Reg Code
 */
/* harmony default export */ var isOneIdRegCode = (function () {
  var code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return (/^[a-z0-9]+$/i.test(code) && code.length === 6
  );
});
// EXTERNAL MODULE: ./app/webapp/page/Activate/util/generateCommerceFlowUrl.js
var generateCommerceFlowUrl = __webpack_require__(691);

// CONCATENATED MODULE: ./app/webapp/page/Activate/util/isSubscribeInEntitlementPath.js
/**
 * isSubscribeInEntitlementPath - Returns a boolean value if the path is an exact subscribe math
 *
 * @param {string} path - String representing the entitlementPath
 *
 * @return {boolean} - Returns true or false
 */
/* harmony default export */ var isSubscribeInEntitlementPath = (function () {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return typeof path === 'string' && path.trim().toLowerCase() === 'subscribe';
});
// CONCATENATED MODULE: ./app/webapp/page/Activate/util/getMarkettingOptInStatus.js
function getMarkettingOptInStatus() {
    var oneIdData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _oneIdData$marketing = oneIdData.marketing,
        marketing = _oneIdData$marketing === undefined ? [] : _oneIdData$marketing,
        _oneIdData$token = oneIdData.token;
    _oneIdData$token = _oneIdData$token === undefined ? {} : _oneIdData$token;
    var swid = _oneIdData$token.swid,
        accessToken = _oneIdData$token.access_token;

    if (marketing.length) {
        var ePlusMarketingOptIns = marketing.filter(function (opt) {
            return opt.code === 'ESPN+_L' && opt.status !== 'declined' && opt.status !== 'accepted';
        });
        if (swid && accessToken && ePlusMarketingOptIns.length) {
            return {
                swid: swid,
                accessToken: accessToken,
                shouldUpdateOptIns: true
            };
        }
    }
    return { shouldUpdateOptIns: false };
}
// CONCATENATED MODULE: ./app/webapp/page/Activate/util/index.js






// EXTERNAL MODULE: ./app/lib/api/cache/requestCache.js
var requestCache = __webpack_require__(42);

// EXTERNAL MODULE: ./app/lib/api/requestProxy.js
var requestProxy = __webpack_require__(43);

// CONCATENATED MODULE: ./app/lib/api/oneIdApi.js
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




function getOneIdApiKey(oneIdClientUrl) {
    var url = oneIdClientUrl + '/api-key';
    return requestCache["a" /* default */].post(url).use(requestProxy["a" /* default */]).then(function (res) {
        var oneIdApiKey = void 0;
        if (res.status === 200) {
            var error = res.body.error,
                _res$headers = res.headers,
                headers = _res$headers === undefined ? {} : _res$headers;
            /**
             * if getApiKey successfully, oneId api return body as follow
             *  {
                    "data": null,
                    "error": null
                }
             */

            if (error === null && headers["api-key"] !== null && headers["api-key"] !== undefined) {
                oneIdApiKey = headers["api-key"];
            }
        }
        return oneIdApiKey;
    }).catch(function (err) {
        return undefined;
    });
}

// oneId getGuess info doesn't return email for privacy reason, so we need to retrieve it for optIns update
function getOneIdEmail(oneIdClientUrl, swid, accessToken) {
    var url = oneIdClientUrl + '/guest/' + swid;
    return Object(requestCache["a" /* default */])(url).set('Authorization', 'BEARER ' + accessToken).set('Accept', 'application/json').use(requestProxy["a" /* default */]).then(function (res) {
        if (res && res.status === 200) {
            var _res$body = res.body;
            _res$body = _res$body === undefined ? {} : _res$body;
            var _res$body$data = _res$body.data;
            _res$body$data = _res$body$data === undefined ? {} : _res$body$data;
            var _res$body$data$profil = _res$body$data.profile;
            _res$body$data$profil = _res$body$data$profil === undefined ? {} : _res$body$data$profil;
            var email = _res$body$data$profil.email;

            if (email) {
                return {
                    email: email,
                    isSuccess: true
                };
            }
        }
        return { isSuccess: false };
    }).catch(function (err) {
        return { isSuccess: false };
    });
}

var updateOneIdMarkettingOptIn = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(oneIdClientUrl, oneIdApiKey, email) {
        var url, payload;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        url = oneIdClientUrl + '/marketing/options';
                        payload = {
                            "email": email,
                            "source": "ESPN watch web opt-in",
                            "options": {
                                "ESPN+_L": true
                            },
                            "textIDsMap": {
                                "ESPN+_L": ""
                            }
                        };
                        return _context.abrupt('return', requestCache["a" /* default */].post(url).send(payload).set('Authorization', 'APIKEY ' + oneIdApiKey).set('Content-Type', 'application/json').set('Accept', 'application/json').use(requestProxy["a" /* default */]).then(function (res) {
                            var _ref2 = res || {},
                                _ref2$body = _ref2.body;

                            _ref2$body = _ref2$body === undefined ? {} : _ref2$body;
                            var error = _ref2$body.error,
                                status = _ref2.status;

                            if (status === 200) {

                                if (error === null) {
                                    return { isSuccess: true, err: null };
                                }
                            }
                            return {
                                isSuccess: false,
                                err: 'status code: ' + res.status + ' errMsg: ' + error
                            };
                        }).catch(function (err) {
                            return {
                                "isSuccess": false,
                                err: "updateOneIdMarkettingOptIn failed on catch"
                            };
                        }));

                    case 3:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function updateOneIdMarkettingOptIn(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
    };
}();
// CONCATENATED MODULE: ./app/webapp/page/Activate/actions.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function actions__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new bluebird_default.a(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return bluebird_default.a.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }













var GET_CONFIG = 'GET_CONFIG';
var REG_CODE_UPDATE = 'REG_CODE_UPDATE';
var AUTHENTICATE = 'AUTHENTICATE';
var GENERIC_ERROR = 'GENERIC_ERROR';
var INVALID_ERROR = 'INVALID_ERROR';
var START_SUBMIT = 'START_SUBMIT';
var COMPLETE_SUBMIT = 'COMPLETE_SUBMIT';
var EPLUS_MARKETTING_OPT_IN_UPDATE = 'EPLUS_MARKETTING_OPT_IN_UPDATE';

function createGetConfigAction(mvpd, message) {
    return {
        type: GET_CONFIG,
        mvpd: mvpd,
        message: message
    };
}

function createAuthenticateAction(authUrl, authSuccessUrl, authErrorUrl, useIframe) {
    return {
        type: AUTHENTICATE,
        authUrl: authUrl,
        authSuccessUrl: authSuccessUrl,
        authErrorUrl: authErrorUrl,
        useIframe: useIframe
    };
}

function createGenericErrorAction(message, providerId) {
    return {
        type: GENERIC_ERROR,
        message: message,
        providerId: providerId
    };
}

function createInvalidErrorAction(message, providerId) {
    return {
        type: INVALID_ERROR,
        message: message,
        providerId: providerId
    };
}

// Actions
function regCodeUpdate(code) {
    return {
        type: REG_CODE_UPDATE,
        code: code
    };
}

function startSubmit() {
    return {
        type: START_SUBMIT
    };
}

function completeSubmit() {
    return {
        type: COMPLETE_SUBMIT
    };
}

function updateOneIdMarkettingOptInAction(payload) {
    return {
        type: EPLUS_MARKETTING_OPT_IN_UPDATE,
        payload: payload
    };
}

function getClientlessConfig() {
    return function (dispatch) {
        return getConfig().then(function (response) {
            var _response$requestor = response.requestor;
            _response$requestor = _response$requestor === undefined ? {} : _response$requestor;
            var _response$requestor$m = _response$requestor.mvpds;
            _response$requestor$m = _response$requestor$m === undefined ? {} : _response$requestor$m;
            var _response$requestor$m2 = _response$requestor$m.mvpd,
                mvpd = _response$requestor$m2 === undefined ? [] : _response$requestor$m2,
                message = response.message;

            return dispatch(createGetConfigAction(mvpd, message));
        });
    };
}

function checkAdobeRegCode(regCode, env) {
    var _this = this;

    return function () {
        var _ref = actions__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
            var _ref2, _ref2$info, deviceType, message;

            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return checkRegCode(regCode, env);

                        case 2:
                            _ref2 = _context.sent;
                            _ref2$info = _ref2.info;
                            _ref2$info = _ref2$info === undefined ? {} : _ref2$info;
                            deviceType = _ref2$info.deviceType, message = _ref2.message;

                            if (!message) {
                                _context.next = 8;
                                break;
                            }

                            throw new Error(message);

                        case 8:
                            dispatch(Object(react_router_redux_lib["push"])({
                                pathname: '/activate',
                                query: {
                                    deviceType: deviceType,
                                    regCode: regCode,
                                    chooseProvider: true
                                }
                            }));

                        case 9:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function (_x) {
            return _ref.apply(this, arguments);
        };
    }();
}

function launchLicensePlateOnSuccess(oneIdClientUrl, swid, accessToken) {
    var _this2 = this;

    return function () {
        var _ref3 = actions__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
            var oneIdApiKey, _ref4, isSuccess, email, res;

            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.prev = 0;
                            _context2.next = 3;
                            return getOneIdApiKey(oneIdClientUrl);

                        case 3:
                            oneIdApiKey = _context2.sent;

                            if (!oneIdApiKey) {
                                _context2.next = 15;
                                break;
                            }

                            _context2.next = 7;
                            return getOneIdEmail(oneIdClientUrl, swid, accessToken);

                        case 7:
                            _ref4 = _context2.sent;
                            isSuccess = _ref4.isSuccess;
                            email = _ref4.email;

                            if (!isSuccess) {
                                _context2.next = 15;
                                break;
                            }

                            _context2.next = 13;
                            return updateOneIdMarkettingOptIn(oneIdClientUrl, oneIdApiKey, email);

                        case 13:
                            res = _context2.sent;

                            dispatch(updateOneIdMarkettingOptInAction({
                                isSuccess: res.isSuccess,
                                err: res.err
                            }));

                        case 15:
                            _context2.next = 20;
                            break;

                        case 17:
                            _context2.prev = 17;
                            _context2.t0 = _context2['catch'](0);

                            dispatch(updateOneIdMarkettingOptInAction({
                                err: _context2.t0,
                                isSuccess: false
                            }));

                        case 20:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2, [[0, 17]]);
        }));

        return function (_x2) {
            return _ref3.apply(this, arguments);
        };
    }();
}

function checkOneIdRegCode(deviceType, pairingCode, commerceUrlsConfig, qs) {
    var _this3 = this;

    return function () {
        var _ref5 = actions__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch, getState) {
            var _getState, _getState$app$env, env, lang, country, urls, dataBag, entitlementPath, correlationId, packages, entitlements, dataBagDevice, commercePath, deviceName, commerceBase, commerceUrl, packagesList, generateCommerceUrl, isSubscribePath;

            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.prev = 0;
                            _getState = getState(), _getState$app$env = _getState.app.env, env = _getState$app$env === undefined ? '' : _getState$app$env;
                            lang = commerceUrlsConfig.lang, country = commerceUrlsConfig.country, urls = commerceUrlsConfig.urls;
                            _context3.next = 5;
                            return oneId["e" /* getLicensePlateDataBag */]({ pairingCode: pairingCode });

                        case 5:
                            _context3.t0 = _context3.sent;

                            if (_context3.t0) {
                                _context3.next = 8;
                                break;
                            }

                            _context3.t0 = {};

                        case 8:
                            dataBag = _context3.t0;
                            entitlementPath = dataBag.entitlementPath, correlationId = dataBag.correlationId, packages = dataBag.packages, entitlements = dataBag.entitlements, dataBagDevice = dataBag.deviceType, commercePath = dataBag.commercePath;
                            deviceName = dataBagDevice || deviceType;
                            _context3.next = 13;
                            return oneId["f" /* launchLicensePlate */]({
                                deviceName: deviceName,
                                authenticationFlow: entitlementPath,
                                correlationId: correlationId,
                                pairingCode: pairingCode
                            });

                        case 13:

                            // when it reaches here, that means activation code (License Plate) was submitted successfully.
                            commerceBase = env !== enums["c" /* AppEnvs */].prod ? WEB_ESPN_PLUS_PURCHASE_PATH_QA : WEB_ESPN_PLUS_PURCHASE_PATH_PROD;
                            commerceUrl = commercePath ? commerceBase + '/' + commercePath + '?start=login' : null;

                            // if commerceUrl is empty, generate commerceUrl from urls mapping that is set in app-configurations

                            if (!commerceUrl) {
                                packagesList = packages || entitlements;
                                generateCommerceUrl = Object(generateCommerceFlowUrl["a" /* default */])(urls, packagesList, deviceName, lang, country);
                                isSubscribePath = isSubscribeInEntitlementPath(entitlementPath);

                                // If `subscribe` is in the entitlementPath property and
                                // generateCommerceUrl is not empty, set commerceUrl.

                                if (isSubscribePath && generateCommerceUrl !== '') {
                                    commerceUrl = generateCommerceUrl;
                                }
                            }

                            // from the external config file; redirect only if window.location is available
                            if (commerceUrl && window && window.location && window.location.href) {
                                window.location.href = commerceUrl;
                            } else {
                                dispatch(Object(react_router_redux_lib["push"])({
                                    pathname: '/activate',
                                    query: _extends({}, qs, {
                                        authSuccess: true,
                                        deviceType: deviceName
                                    })
                                }));
                            }
                            _context3.next = 22;
                            break;

                        case 19:
                            _context3.prev = 19;
                            _context3.t1 = _context3['catch'](0);
                            throw _context3.t1;

                        case 22:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3, [[0, 19]]);
        }));

        return function (_x3, _x4) {
            return _ref5.apply(this, arguments);
        };
    }();
}

function clientlessAuthenticate(_ref6) {
    var regCode = _ref6.regCode,
        mvpd = _ref6.mvpd,
        deviceType = _ref6.deviceType,
        provider = _ref6.provider,
        _ref6$baseUrl = _ref6.baseUrl,
        origBaseUrl = _ref6$baseUrl === undefined ? window.location.href : _ref6$baseUrl,
        adobePassEnv = _ref6.adobePassEnv;

    return function (dispatch) {
        var baseUrl = Object(removeQueryFromUrl["a" /* default */])(origBaseUrl, 'chooseProvider,deviceType,regCode');
        var authUrl = getAuthenticateUrl({ regCode: regCode, mvpd: mvpd, deviceType: deviceType, baseUrl: baseUrl, adobePassEnv: adobePassEnv });
        var authSuccessUrl = getAuthSuccessUrl({ mvpd: mvpd, deviceType: deviceType, baseUrl: baseUrl });
        var authErrorUrl = getAuthErrorUrl({ baseUrl: baseUrl });
        var useIframe = provider.iFrameRequired && provider.iFrameRequired.value && window.innerWidth > 500;

        dispatch(createAuthenticateAction(authUrl, authSuccessUrl, authErrorUrl, useIframe));

        try {
            if (useIframe) {
                // open url in an iframe (use modal)
                dispatch(Object(appActions["C" /* displayModalMessage */])(enums["w" /* ModalType */].IFRAME_AUTH, {
                    src: authUrl,
                    width: provider.iFrameWidth && provider.iFrameWidth.value || 500,
                    height: provider.iFrameHeight && provider.iFrameHeight.value || 500
                }));
            } else {
                window.location.href = authUrl;
            }
        } catch (err) {
            return bluebird_default.a.reject(err);
        }

        return bluebird_default.a.resolve(authUrl);
    };
}
// CONCATENATED MODULE: ./app/common/middlewares/trackingMiddleware.js
/**
 * This middleware sends tracking calls based on actions being dispatched
 */





/* harmony default export */ var trackingMiddleware = (function (store) {
    return function (next) {
        return function (action) {
            var state = store.getState();
            var _state$providerDialog = state.providerDialog;
            _state$providerDialog = _state$providerDialog === undefined ? {} : _state$providerDialog;
            var _state$providerDialog2 = _state$providerDialog.providers,
                providers = _state$providerDialog2 === undefined ? [] : _state$providerDialog2;

            var _routingSelector = Object(routingSelector["a" /* default */])(state),
                _routingSelector$loca = _routingSelector.locationBeforeTransitions.query,
                device = _routingSelector$loca.device,
                deviceType = _routingSelector$loca.deviceType;

            var type = action.type,
                providerId = action.providerId;

            var trackingDevice = device || deviceType;
            var trackingProvider = providers.filter(function (provider) {
                return provider.abbreviation === providerId;
            }).shift();

            if (type === GENERIC_ERROR || type === INVALID_ERROR) {
                Object(omniture["g" /* trackActivateCodeInvalid */])(trackingDevice, trackingProvider);
            }

            return next(action);
        };
    };
});
// EXTERNAL MODULE: ./node_modules/react-intl/lib/index.es.js + 1 modules
var index_es = __webpack_require__(94);

// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__(16);
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// EXTERNAL MODULE: ./app/lib/ui/docReady.js
var docReady = __webpack_require__(709);

// EXTERNAL MODULE: ./node_modules/redux/es/index.js + 14 modules
var redux_es = __webpack_require__(180);

// EXTERNAL MODULE: ./node_modules/redux-thunk/lib/index.js
var redux_thunk_lib = __webpack_require__(710);
var redux_thunk_lib_default = /*#__PURE__*/__webpack_require__.n(redux_thunk_lib);

// CONCATENATED MODULE: ./app/webapp/page/Activate/reducer.js
var reducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var reducer_initialState = {
    config: {},
    regCode: {},
    authenticate: {},
    genericError: '',
    invalidError: '',
    optInUpdate: {}
};

function activationReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
        case GET_CONFIG:
            return reducer__extends({}, state, {
                config: {
                    mvpd: action.mvpd,
                    message: action.message
                }
            });
        case AUTHENTICATE:
            return reducer__extends({}, state, {
                authenticate: {
                    authUrl: action.authUrl,
                    authSuccessUrl: action.authSuccessUrl,
                    authErrorUrl: action.authErrorUrl,
                    useIframe: action.useIframe
                }
            });
        case GENERIC_ERROR:
            return reducer__extends({}, state, {
                genericError: action.message
            });
        case INVALID_ERROR:
            return reducer__extends({}, state, {
                invalidError: action.message
            });
        case REG_CODE_UPDATE:
            return reducer__extends({}, state, {
                invalidError: null,
                genericError: null,
                regCode: reducer__extends({}, state.regCode, {
                    code: action.code
                })
            });
        case START_SUBMIT:
            return reducer__extends({}, state, {
                submitting: true
            });
        case COMPLETE_SUBMIT:
            return reducer__extends({}, state, {
                submitting: false
            });
        case EPLUS_MARKETTING_OPT_IN_UPDATE:
            return reducer__extends({}, state, {
                optInUpdate: {
                    isSuccess: action.payload.isSuccess,
                    err: action.payload.err
                }
            });
        default:
            return state;
    }
}
// EXTERNAL MODULE: ./app/common/page/actions/index.js
var page_actions = __webpack_require__(17);

// EXTERNAL MODULE: ./app/common/schedule/actions/index.js
var schedule_actions = __webpack_require__(95);

// EXTERNAL MODULE: ./app/common/ads/actions/index.js
var ads_actions = __webpack_require__(92);

// CONCATENATED MODULE: ./app/common/ads/reducers/index.js
var reducers__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





function adsReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { configured: false, initialized: false };
    var action = arguments[1];

    switch (action.type) {
        case ads_actions["a" /* ADS_CONFIG */]:
            return reducers__extends({}, state, { id: action.id, config: action.config, configured: true, initialized: false });

        case ads_actions["b" /* ADS_CONFIG_INVALIDATED */]:
            return reducers__extends({}, state, { id: null, configured: false, initialized: false });

        case ads_actions["c" /* ADS_INITIALIZED */]:
            return reducers__extends({}, state, { initialized: true });

        case page_actions["j" /* REQUEST_PAGE */]:
            return reducers__extends({}, state, { id: null, configured: false, initialized: false });

        case page_actions["f" /* RECEIVE_PAGE */]:
            return reducers__extends({}, state, { id: action.id });

        case schedule_actions["f" /* SET_SPORTS_FILTER */]:
            return reducers__extends({}, state, {
                config: reducers__extends({}, state.config, { kvps: reducers__extends({}, state.config.kvps, { sp: action.label.toLowerCase() }) }),
                refresh: true
            });

        case ads_actions["d" /* ADS_REFRESHED */]:
            return reducers__extends({}, state, { refresh: false });

        default:
            return state;
    }
}
// CONCATENATED MODULE: ./app/common/page/reducers/index.js
var page_reducers__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }




function getHero(state, _ref) {
    var _ref$buckets = _ref.buckets,
        buckets = _ref$buckets === undefined ? [] : _ref$buckets,
        heroContent = _ref.heroContent,
        noHero = _ref.noHero;

    // Use the "concrete" hero if it already exists (this is if the id was passed in directly to the page)
    // If the new hero content also has the `concrete` flag, replace the hero
    if (state.hero && state.hero.concrete && (!heroContent || !heroContent.concrete)) {
        return state.hero;
    }

    // If the hero content was retrieved as part of the page load action, use it.
    if (heroContent) {
        return heroContent;
    }

    // If there's no buckets, there's no content to make the hero.
    if (buckets.length === 0 || noHero) {
        return undefined;
    }

    // Find the bucket index that contains the top scored item.
    var playableBuckets = buckets.filter(function (bucket) {
        var bucketContents = bucket.contents;
        return bucketContents.length > 0 && (bucketContents[0].type === enums["o" /* ContentType */].LISTING || bucketContents[0].type === enums["o" /* ContentType */].VOD);
    });
    var topBucketIndex = playableBuckets.map(function (bucket, index) {
        return { score: bucket.contents[0].score || 0, index: index };
    }).sort(function (itemA, itemB) {
        return itemB.score - itemA.score;
    }).map(function (object) {
        return object.index;
    }).shift();
    // If no top bucket index was found, then there's no hero.
    // This could happen if the buckets array exists, but the contents were all empty.
    if (topBucketIndex === undefined || !playableBuckets[topBucketIndex]) {
        return undefined;
    }

    // Build and return the hero bucket.
    return playableBuckets[topBucketIndex].contents[0];
}

function reinsertBuckets(state, buckets) {
    return buckets.reduce(function (prev, bucket) {
        var index = state.buckets.map(function (buck) {
            return buck.id;
        }).indexOf(bucket.id);
        return [].concat(_toConsumableArray(prev.slice(0, index)), [bucket], _toConsumableArray(prev.slice(index + 1)));
    }, state.buckets);
}

function replaceBuckets(state, replacementBuckets) {
    // calling state.buckets.map throws error when state.buckets is empty. We need to do the check before mapping
    if (state.buckets && state.buckets.length) {
        return state.buckets.map(function (bucket) {
            var newBucket = bucket;
            replacementBuckets.forEach(function (replacementBucket) {
                if (bucket.id === replacementBucket.id) {
                    newBucket = replacementBucket;
                }
            });
            // the __replaced property is used when we first get to the player page from a bucket
            // delete it when we replace buckets so that TabContainer doesn't use it to select a tab
            // #TODO: we can probably accomplish the initial replacement without this flag
            delete newBucket.__replaced;
            return newBucket;
        });
    }
    return state.buckets;
}

function completeScoring(state, action) {
    var buckets = action.buckets || [];
    if (buckets.length === 0) {
        return page_reducers__extends({}, state, { scored: true });
    }

    var scoredBuckets = reinsertBuckets(state, buckets);
    var hero = getHero(state, { buckets: scoredBuckets, heroContent: action.heroContent, noHero: state.noHero });
    return page_reducers__extends({}, state, { scoredBuckets: scoredBuckets, hero: hero, scored: true });
}

function reducers_page() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case page_actions["a" /* CLEAR_PAGE */]:
            return {};

        case page_actions["d" /* INVALIDATE_PAGE */]:
            return page_reducers__extends({}, state, { didInvalidate: true });

        case page_actions["g" /* REFRESH_BUCKETS */]:
            return page_reducers__extends({}, state, {
                buckets: replaceBuckets(state, action.buckets)
            });

        case page_actions["h" /* REPLACE_BUCKETS */]:
            return page_reducers__extends({}, state, {
                buckets: action.buckets
            });

        case page_actions["j" /* REQUEST_PAGE */]:
            return page_reducers__extends({}, state, {
                id: action.id,
                isFetching: true,
                didInvalidate: false,
                requestedTime: action.requestedTime,
                scored: false,
                isFinal: false
            });

        case page_actions["f" /* RECEIVE_PAGE */]:
            // ignore the payload that's from the different routes
            if (state.id !== action.id) {
                return state;
            }
            return page_reducers__extends({}, state, {
                id: action.id,
                name: action.name,
                image: action.image,
                icon: action.icon,
                description: action.description,
                header: action.header,
                edition: action.edition,
                lang: action.lang,
                isFetching: false,
                didInvalidate: false,
                buckets: action.buckets,
                receivedTime: action.receivedTime,
                tracking: action.tracking,
                hero: getHero(state, action),
                carouselBucket: action.carouselBucket,
                error: action.error,
                isFinal: action.isFinal,
                noHero: action.noHero
            });

        case page_actions["i" /* REPLACE_HERO */]:
            return page_reducers__extends({}, state, {
                hero: action.content || state.hero
            });

        case page_actions["c" /* COMPLETE_PAGE_LOAD */]:
            return completeScoring(state, action);

        case page_actions["l" /* START_GET_COMPETITORS */]:
            return page_reducers__extends({}, state, { loading: true });

        case page_actions["b" /* COMPLETE_GET_COMPETITORS */]:
            return page_reducers__extends({}, state, { competitors: action.competitors, loading: false });

        case page_actions["e" /* PAGE_INFO_SET */]:
            return page_reducers__extends({}, state, {
                name: action.name,
                id: action.id,
                isFinal: action.isFinal,
                autoPageViewTrack: action.autoPageViewTrack
            });

        case page_actions["k" /* SET_STATE */]:
            return page_reducers__extends({}, state, {
                isFinal: action.isFinal
            });

        default:
            return state;
    }
}
// EXTERNAL MODULE: ./app/webapp/player/actions/index.js + 2 modules
var player_actions = __webpack_require__(97);

// CONCATENATED MODULE: ./app/webapp/player/reducers/index.js
var player_reducers__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function reducers__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



function player_reducers_page() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        autoEmbedTimerComplete: false,
        embedding: false,
        embedded: false,
        ready: false,
        error: false,
        feeds: {}
    };
    var action = arguments[1];

    switch (action.type) {
        case player_actions["a" /* AUTHORIZATION_ERROR */]:
            return player_reducers__extends({}, state, { error: true, message: action.message });
        case player_actions["b" /* AUTOEMBED_TIMER_COMPLETE */]:
            return player_reducers__extends({}, state, { autoEmbedTimerComplete: true });
        case player_actions["c" /* AUTOPLAY_UPDATED */]:
            return player_reducers__extends({}, state, { autoEmbed: action.autoplay });
        case player_actions["l" /* STREAM_PLAYING */]:
            return player_reducers__extends({}, state, { error: action.error });
        case player_actions["i" /* PLAYER_READY */]:
            return player_reducers__extends({}, state, { autoEmbed: action.autoEmbed, ready: action.ready });
        case player_actions["h" /* PLAYER_EMBEDDING */]:
            return player_reducers__extends({}, state, { embedding: action.embedding });
        case player_actions["g" /* PLAYER_EMBEDDED */]:
            return player_reducers__extends({}, state, { embedded: action.embedded });
        case player_actions["j" /* REGISTER_PLAYER */]:
            return player_reducers__extends({}, state, { ready: action.ready });
        case player_actions["k" /* RESET_PLAYER */]:
            return player_reducers__extends({}, state, {
                autoEmbedTimerComplete: false,
                embedding: false,
                embedded: false,
                ready: false,
                error: false
            });
        case player_actions["f" /* FEED_SELECT */]:
            if (!action.content || !action.content.id) {
                return state;
            }
            return player_reducers__extends({}, state, {
                feeds: player_reducers__extends({}, state.feeds, reducers__defineProperty({}, action.content.id, action.streamId))
            });
        case player_actions["e" /* FEED_RESET */]:
            return player_reducers__extends({}, state, { feeds: {} });
        default:
            return state;
    }
}
// EXTERNAL MODULE: ./app/lib/api/index.js + 9 modules
var api = __webpack_require__(88);

// EXTERNAL MODULE: ./app/common/selectors/appSelector.js + 1 modules
var appSelector = __webpack_require__(3);

// EXTERNAL MODULE: ./app/common/selectors/apiParamsSelector.js
var apiParamsSelector = __webpack_require__(114);

// CONCATENATED MODULE: ./app/common/actions/clientActions.js




var START_GET_NETWORKS = 'START_GET_NETWORKS';
var COMPLETE_GET_NETWORKS = 'COMPLETE_GET_NETWORKS';

function startGetNetworks() {
    return {
        type: START_GET_NETWORKS,
        startTime: Date.now()
    };
}

function completeGetNetworks(networks) {
    return {
        type: COMPLETE_GET_NETWORKS,
        completeTime: Date.now(),
        networks: networks
    };
}

function fetchNetworks() {
    return function (dispatch, getState) {
        var state = getState();
        var apiEnv = Object(appSelector["c" /* apiEnvSelector */])(state);
        var params = Object(apiParamsSelector["a" /* collectionParamsSelector */])(state);
        dispatch(startGetNetworks());
        return api["d" /* PageAPI */].getNetworks(apiEnv, params).then(function (networks) {
            dispatch(completeGetNetworks(networks || []));
            return networks;
        });
    };
}
// EXTERNAL MODULE: ./app/common/schedule/StatusFilter.js
var StatusFilter = __webpack_require__(96);

// CONCATENATED MODULE: ./app/common/schedule/reducers/index.js
var schedule_reducers__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var today = new Date();

function scheduleReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        statusFilterValue: StatusFilter["a" /* default */].Options.LIVE,
        dateFilterEndValue: today,
        dateFilterStartValue: today,
        sportsFilterValue: '',
        sportsFilterType: 'category',
        networkFilter: ''
    };
    var action = arguments[1];

    switch (action.type) {

        case COMPLETE_GET_NETWORKS:
            return schedule_reducers__extends({}, state, { channels: action.networks });

        case schedule_actions["a" /* COMPLETE_GET_CATEGORIES */]:
            return schedule_reducers__extends({}, state, { categories: action.categories });

        case schedule_actions["h" /* START_GET_SCHEDULE */]:
            return schedule_reducers__extends({}, state, { loading: true });

        case schedule_actions["b" /* COMPLETE_GET_SCHEDULE */]:
            return schedule_reducers__extends({}, state, { listings: action.listings, loading: false });

        case schedule_actions["g" /* SET_STATUS_FILTER */]:
            return schedule_reducers__extends({}, state, { statusFilterValue: action.status });

        case schedule_actions["d" /* SET_NETWORK_FILTER */]:
            return schedule_reducers__extends({}, state, { networkFilter: action.value, networkFilterLabel: action.label });

        case schedule_actions["f" /* SET_SPORTS_FILTER */]:
            return schedule_reducers__extends({}, state, {
                sportsFilterValue: action.value,
                sportsFilterType: action.filterType,
                sportsFilterLabel: action.label
            });

        case schedule_actions["c" /* SET_DATE_FILTER */]:
            return schedule_reducers__extends({}, state, { dateFilterStartValue: action.date, dateFilterEndValue: action.date });

        case schedule_actions["e" /* SET_REPLAY_DATE_FILTER */]:
            return schedule_reducers__extends({}, state, { dateFilterStartValue: action.startDate, dateFilterEndValue: action.endDate });

        default:
            return state;
    }
}
// EXTERNAL MODULE: ./app/common/scheduleModule/actions/index.js
var scheduleModule_actions = __webpack_require__(63);

// CONCATENATED MODULE: ./app/common/scheduleModule/reducers/index.js
var scheduleModule_reducers__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function reducers_completeScoring(state, action) {
    var buckets = action.buckets || [];
    if (buckets.length === 0) {
        return scheduleModule_reducers__extends({}, state, { scored: true });
    }
    return scheduleModule_reducers__extends({}, state, { buckets: buckets, scored: true });
}

function scheduleModuleReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case scheduleModule_actions["c" /* SCORE_SCHEDULE_MODULE_DATA */]:
            return reducers_completeScoring(state, action);
        case scheduleModule_actions["a" /* RECEIVE_SCHEDULE_MODULE_DATA */]:
            return scheduleModule_reducers__extends({}, state, {
                name: action.name,
                buckets: action.buckets,
                receivedTime: action.receivedTime
            });
        case scheduleModule_actions["b" /* REQUEST_SCHEDULE_MODULE_DATA */]:
            return scheduleModule_reducers__extends({}, state, {
                lang: action.lang,
                query: action.query,
                requestedTime: action.requestedTime,
                scored: false
            });
        default:
            return state;
    }
}
// CONCATENATED MODULE: ./app/common/reducers/appReducer.js
var appReducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




function appReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        isMobile: false,
        selectedContent: {},
        selectedStream: {},
        playingStream: {},
        previousContent: {},
        bootstrap: {},
        selectedAiringId: undefined,
        pickerStreams: []
    };
    var action = arguments[1];

    switch (action.type) {
        case appActions["b" /* APP_RENDERED */]:
            return appReducer__extends({}, state, { rendered: true });
        case appActions["a" /* ANALYTICS_READY */]:
            return appReducer__extends({}, state, { analytics: action.initData });
        case player_actions["d" /* CLEAR_PLAYING_STREAM */]:
            return appReducer__extends({}, state, { playingStream: {} });
        case appActions["c" /* CLOSE_MODAL_MESSAGE */]:
            return appReducer__extends({}, state, {
                showModalMessage: false,
                messageType: '',
                messageData: undefined,
                lastMessageType: state.messageType,
                lastMessageData: state.messageData
            });
        case appActions["d" /* CONTENT_SELECT */]:
            return appReducer__extends({}, state, { previousContent: state.selectedContent, selectedContent: action.content });
        case appActions["e" /* CONTENT_UNSELECT */]:
            return appReducer__extends({}, state, { selectedContent: {} });
        case appActions["u" /* STREAM_SELECTING */]:
            return appReducer__extends({}, state, { selectingStream: action.stream });
        case appActions["t" /* STREAM_SELECT */]:
            return appReducer__extends({}, state, { selectingStream: undefined, selectedStream: action.stream, playbackMeta: action.playbackMeta });
        case appActions["v" /* STREAM_UNSELECT */]:
            return appReducer__extends({}, state, { selectingStream: undefined, selectedStream: {}, playbackMeta: undefined });
        case player_actions["l" /* STREAM_PLAYING */]:
            return appReducer__extends({}, state, { playingStream: action.stream });
        case appActions["f" /* DISPLAY_MODAL_MESSAGE */]:
            return appReducer__extends({}, state, { showModalMessage: true, messageType: action.messageType, messageData: action.messageData });
        case appActions["h" /* FETCH_EXTERNAL_CONFIG */]:
            return appReducer__extends({}, state, { bootstrap: action.bootstrap });
        case appActions["g" /* FETCH_EMBEDDED_OPTIONS */]:
            return appReducer__extends({}, state, { options: action.options });
        case appActions["i" /* INIT_APP_DATA */]:
            return appReducer__extends({}, state, {
                appName: action.appName,
                adobePassEnv: action.adobePassEnv,
                apiEnv: action.apiEnv,
                configEnv: action.configEnv,
                country: action.country,
                device: action.device,
                env: action.env,
                isMobile: action.isMobile,
                lang: action.lang,
                sourceLang: action.sourceLang,
                location: action.location,
                messages: action.messages,
                enableSearch: action.enableSearch,
                packageId: action.packageId,
                tier: action.tier,
                edition: action.edition,
                webview: action.webview,
                renderTemplateType: action.renderTemplateType,
                newrelicInsertKey: action.newrelicInsertKey,
                newrelicAccountId: action.newrelicAccountId
            });
        case appActions["j" /* MEDIA_QUERY */]:
            return appReducer__extends({}, state, { mq: action.mq });
        case appActions["m" /* PACKAGE_ID */]:
            return appReducer__extends({}, state, { packageId: action.packageId });
        case appActions["n" /* PACKAGE_TIER */]:
            return appReducer__extends({}, state, { tier: action.tier });
        case appActions["q" /* PICKER_STREAMS_SELECT */]:
            return appReducer__extends({}, state, { pickerStreams: action.pickerStreams, pickerStreamsEventId: action.pickerStreamsEventId });
        case appActions["s" /* PICKER_STREAMS_UNSELECT */]:
            return appReducer__extends({}, state, { pickerStreams: [], pickerStreamsEventId: undefined });
        case appActions["r" /* PICKER_STREAMS_SELECT_ERROR */]:
            return appReducer__extends({}, state, { pickerStreamsError: action.error });
        case appActions["l" /* OPEN_PICKER_SUCCESS */]:
            return appReducer__extends({}, state, {
                openPicker: {
                    isSuccess: true,
                    id: action.payload.id,
                    retryTime: action.payload.retryTime
                }
            });
        case appActions["k" /* OPEN_PICKER_ERROR */]:
            return appReducer__extends({}, state, { openPicker: { isSuccess: false, error: action.error } });
        case appActions["o" /* PICKER_AUTO_SELECT */]:
            return appReducer__extends({}, state, { pickerAutoSelectStream: action.stream });
        case appActions["p" /* PICKER_STATE_CLEAR */]:
            {
                return appReducer__extends({}, state, { openPicker: {}, pickerAutoSelectStream: {} });
            }
        default:
            return state;
    }
}
// EXTERNAL MODULE: ./app/constants.js
var app_constants = __webpack_require__(8);

// EXTERNAL MODULE: ./app/lib/util/localStorage.js
var localStorage = __webpack_require__(44);

// EXTERNAL MODULE: ./app/common/actions/authenticationActions.js
var authenticationActions = __webpack_require__(22);

// EXTERNAL MODULE: ./app/common/actions/oneIdActions.js
var oneIdActions = __webpack_require__(36);

// CONCATENATED MODULE: ./app/common/reducers/authenticationReducer.js
var authenticationReducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function authenticationReducer__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function authenticationReducer__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }







function addAuthType(authTypes, authType) {
    // don't add multiple authtypes
    if (authTypes.indexOf(authType) !== -1) {
        return [].concat(authenticationReducer__toConsumableArray(authTypes));
    }

    return [].concat(authenticationReducer__toConsumableArray(authTypes), [authType]);
}

function removeAuthType(authTypes, authType) {
    var index = authTypes.indexOf(authType);
    if (index === -1) {
        return [].concat(authenticationReducer__toConsumableArray(authTypes));
    }
    return [].concat(authenticationReducer__toConsumableArray(authTypes.slice(0, index)), authenticationReducer__toConsumableArray(authTypes.slice(index + 1)));
}

function authTypesReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var action = arguments[1];

    var authTypes = state;
    if (action.authType === enums["e" /* AuthTypes */].BAM) {
        Object.keys(enums["s" /* Entitlements */]).forEach(function (entitlement) {
            authTypes = removeAuthType(authTypes, 'unknown_' + entitlement);
        });

        if (action.directive === 'add') {
            var _action$entitlements = action.entitlements,
                entitlements = _action$entitlements === undefined ? [] : _action$entitlements,
                hasTDAEntitlement = action.hasTDAEntitlement;

            if (entitlements.length) {
                entitlements.forEach(function (entitlement) {
                    authTypes = addAuthType(authTypes, entitlement);
                });
            }
            if (hasTDAEntitlement) {
                authTypes = addAuthType(authTypes, enums["s" /* Entitlements */].ESPN_TDA);
            }
        } else {
            Object.keys(enums["s" /* Entitlements */]).forEach(function (entitlement) {
                authTypes = removeAuthType(authTypes, entitlement);
            });
        }

        return authTypes;
    }

    authTypes = removeAuthType(authTypes, 'unknown_' + action.authType);

    if (action.directive === 'add') {
        authTypes = addAuthType(authTypes, action.authType);
    } else {
        authTypes = removeAuthType(authTypes, action.authType);
    }

    return authTypes;
}

function bamReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case authenticationActions["z" /* START_CHECK_BAM_AUTHENTICATION */]:
            return authenticationReducer__extends({}, state, {
                initialization: {
                    initializing: true,
                    startTime: action.startTime
                }
            });
        case authenticationActions["g" /* COMPLETE_CHECK_BAM_AUTHENTICATION */]:
            return authenticationReducer__extends({}, state, {
                initialization: {
                    initializing: false,
                    completeTime: action.completeTime
                }
            });
        case authenticationActions["m" /* GET_BAM_AUTHENTICATION_INFO */]:
            return authenticationReducer__extends({}, state, {
                subscriptions: action.subscriptions
            });
        case authenticationActions["n" /* GET_BAM_SESSION_TOKEN */]:
            return authenticationReducer__extends({}, state, {
                session: action.session
            });
        case authenticationActions["o" /* GET_GEOLOCATION */]:
            if (!Object(localStorage["a" /* get */])(app_constants["e" /* GEO_LOCATION_KEY */]) && action.geo) {
                Object(localStorage["d" /* set */])(app_constants["e" /* GEO_LOCATION_KEY */], action.geo, 24 * 60 * 60);
            }
            return authenticationReducer__extends({}, state, {
                geo: action.geo
            });
        case authenticationActions["s" /* GET_USER_TRACKING */]:
            return authenticationReducer__extends({}, state, {
                userTracking: action.userTracking
            });
        default:
            return state;
    }
}

function ipReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case authenticationActions["A" /* START_CHECK_IP_AUTHENTICATION */]:
            return authenticationReducer__extends({}, state, {
                initialization: {
                    initializing: true,
                    startTime: action.startTime
                }
            });
        case authenticationActions["h" /* COMPLETE_CHECK_IP_AUTHENTICATION */]:
            return authenticationReducer__extends({}, state, {
                initialization: {
                    initializing: false,
                    completeTime: action.completeTime
                }
            });
        case authenticationActions["p" /* GET_IP_AUTHENTICATION_INFO */]:
            return authenticationReducer__extends({}, state, {
                info: action.info
            });
        case authenticationActions["q" /* GET_LOCATION */]:
            return authenticationReducer__extends({}, state, {
                location: action.location
            });
        default:
            return state;
    }
}

function adobePassReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case authenticationActions["v" /* START_ADOBEPASS_INITIALIZE */]:
            return authenticationReducer__extends({}, state, {
                initialization: {
                    initializing: true,
                    startTime: action.startTime
                }
            });
        case authenticationActions["c" /* COMPLETE_ADOBEPASS_INITIALIZE */]:
            return authenticationReducer__extends({}, state, {
                initialization: {
                    initializing: false,
                    completeTime: action.completeTime
                }
            });
        case authenticationActions["y" /* START_CHECK_AUTHENTICATION */]:
            return authenticationReducer__extends({}, state, {
                checkAuthentication: {
                    checkingAuthentication: true,
                    startTime: action.startTime
                }
            });
        case authenticationActions["f" /* COMPLETE_CHECK_AUTHENTICATION */]:
            return authenticationReducer__extends({}, state, {
                checkAuthentication: {
                    checkingAuthentication: false,
                    mvpd: action.mvpd,
                    completeTime: action.completeTime
                },
                isAuthenticated: action.isAuthenticated
            });
        case authenticationActions["w" /* START_AUTHENTICATION */]:
            return authenticationReducer__extends({}, state, {
                authentication: authenticationReducer__extends({}, state.authentication, {
                    authenticating: true,
                    startTime: action.startTime
                })
            });
        case authenticationActions["d" /* COMPLETE_AUTHENTICATION */]:
            return authenticationReducer__extends({}, state, {
                authentication: authenticationReducer__extends({}, state.authentication, {
                    authenticating: false,
                    mvpd: action.mvpd,
                    completeTime: action.completeTime
                }),
                isAuthenticated: action.isAuthenticated
            });
        case authenticationActions["x" /* START_AUTHORIZATION */]:
            return authenticationReducer__extends({}, state, {
                authorization: {
                    authorizing: true,
                    resourceId: action.resourceId,
                    startTime: action.startTime
                }
            });
        case authenticationActions["e" /* COMPLETE_AUTHORIZATION */]:
            return authenticationReducer__extends({}, state, {
                authorization: {
                    authorizing: false,
                    resourceId: action.resourceId,
                    token: action.token,
                    completeTime: action.completeTime
                },
                isAuthorized: action.token && action.token.length > 0 && action.resourceId && action.resourceId.length > 0 || false
            });
        case authenticationActions["i" /* COMPLETE_LOGOUT */]:
            return authenticationReducer__extends({}, state, {
                info: {},
                isAuthenticated: false
            });
        case authenticationActions["l" /* GET_AUTHENTICATION_INFO */]:
            if (action.info && action.info.abbreviation) {
                Object(localStorage["d" /* set */])(app_constants["i" /* MVPD_PREVIOUS_KEY */], action.info.abbreviation);
            }
            return authenticationReducer__extends({}, state, {
                info: action.info
            });
        case authenticationActions["r" /* GET_METADATA */]:
            {
                var newMetaData = {};
                if (typeof action.key === 'string') {
                    newMetaData[action.key] = action.value;
                }
                return authenticationReducer__extends({}, state, {
                    metadata: authenticationReducer__extends({}, state.metadata, authenticationReducer__defineProperty({}, action.key, action.value))
                });
            }
        case authenticationActions["j" /* COMPLETE_PREAUTH_CHECK */]:
            {
                return authenticationReducer__extends({}, state, {
                    preauthorizedResources: action.resources
                });
            }
        case authenticationActions["a" /* ADOBEPASS_ERROR_EVENT */]:
            {
                return authenticationReducer__extends({}, state, {
                    error: action.error
                });
            }
        default:
            return state;
    }
}

function authenticationReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { authTypes: app_constants["z" /* unknownAuthStates */] };
    var action = arguments[1];

    switch (action.type) {
        case authenticationActions["z" /* START_CHECK_BAM_AUTHENTICATION */]:
        case authenticationActions["g" /* COMPLETE_CHECK_BAM_AUTHENTICATION */]:
        case authenticationActions["n" /* GET_BAM_SESSION_TOKEN */]:
        case authenticationActions["o" /* GET_GEOLOCATION */]:
        case authenticationActions["s" /* GET_USER_TRACKING */]:
        case authenticationActions["m" /* GET_BAM_AUTHENTICATION_INFO */]:
            return authenticationReducer__extends({}, state, {
                bam: bamReducer(state.bam, action)
            });
        case authenticationActions["A" /* START_CHECK_IP_AUTHENTICATION */]:
        case authenticationActions["q" /* GET_LOCATION */]:
        case authenticationActions["p" /* GET_IP_AUTHENTICATION_INFO */]:
            return authenticationReducer__extends({}, state, {
                ip: ipReducer(state.ip, action)
            });
        case authenticationActions["h" /* COMPLETE_CHECK_IP_AUTHENTICATION */]:
            return authenticationReducer__extends({}, state, {
                ip: ipReducer(state.ip, action),
                authTypes: authTypesReducer(state.authTypes, action)
            });
        case authenticationActions["v" /* START_ADOBEPASS_INITIALIZE */]:
        case authenticationActions["c" /* COMPLETE_ADOBEPASS_INITIALIZE */]:
        case authenticationActions["y" /* START_CHECK_AUTHENTICATION */]:
        case authenticationActions["w" /* START_AUTHENTICATION */]:
        case authenticationActions["x" /* START_AUTHORIZATION */]:
        case authenticationActions["e" /* COMPLETE_AUTHORIZATION */]:
        case authenticationActions["l" /* GET_AUTHENTICATION_INFO */]:
        case authenticationActions["r" /* GET_METADATA */]:
        case authenticationActions["j" /* COMPLETE_PREAUTH_CHECK */]:
        case authenticationActions["a" /* ADOBEPASS_ERROR_EVENT */]:
            return authenticationReducer__extends({}, state, {
                adobePass: adobePassReducer(state.adobePass, action)
            });
        case authenticationActions["f" /* COMPLETE_CHECK_AUTHENTICATION */]:
        case authenticationActions["d" /* COMPLETE_AUTHENTICATION */]:
        case authenticationActions["i" /* COMPLETE_LOGOUT */]:
            return authenticationReducer__extends({}, state, {
                adobePass: adobePassReducer(state.adobePass, action),
                authTypes: authTypesReducer(state.authTypes, action)
            });
        case oneIdActions["b" /* COMPLETE_CHECK_ONEID_AUTHENTICATION */]:
        case oneIdActions["a" /* CLEAR_GUEST */]:
            return authenticationReducer__extends({}, state, {
                bamSubReady: action.bamSubReady,
                hasSuperBundle: action.hasSuperBundle,
                authTypes: authTypesReducer(state.authTypes, action)
            });
        default:
            return state;
    }
}
// EXTERNAL MODULE: ./app/common/actions/fanActions.js
var fanActions = __webpack_require__(216);

// CONCATENATED MODULE: ./app/common/reducers/fanReducer.js
var fanReducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function fanReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case fanActions["a" /* COMPLETE_GET_FAN */]:
            return fanReducer__extends({}, state, action.fan);
        default:
            return state;
    }
}
// EXTERNAL MODULE: ./app/common/actions/networkActions.js
var networkActions = __webpack_require__(711);

// CONCATENATED MODULE: ./app/common/reducers/networksReducer.js
var networksReducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function networksReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case networkActions["a" /* COMPLETE_GET_NETWORKS */]:
            return networksReducer__extends({}, state, {
                data: action.networks,
                completeTime: action.completeTime
            });
        default:
            return state;
    }
}
// CONCATENATED MODULE: ./app/common/reducers/lastActionReducer.js
function lastAction() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    return action;
}
// CONCATENATED MODULE: ./app/common/reducers/oneIdReducer.js
var oneIdReducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function oneIdReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case oneIdActions["c" /* COMPLETE_CHECK_SWID_AUTHENTICATION */]:
            return oneIdReducer__extends({}, state, {
                swid: action.swid,
                isLoggedIn: action.isAuthenticated
            });
        case oneIdActions["d" /* GET_GUEST */]:
            return oneIdReducer__extends({}, state, {
                data: action.data,
                completeTime: action.completeTime
            });
        case oneIdActions["a" /* CLEAR_GUEST */]:
            return oneIdReducer__extends({}, state, {
                data: {},
                completeTime: undefined
            });
        case oneIdActions["f" /* LOGIN_START */]:
            return oneIdReducer__extends({}, state, {
                loginParams: action.params
            });
        case oneIdActions["e" /* LOGIN_CLOSED */]:
        case oneIdActions["b" /* COMPLETE_CHECK_ONEID_AUTHENTICATION */]:
            return oneIdReducer__extends({}, state, {
                loginParams: undefined
            });
        default:
            return state;
    }
}
// CONCATENATED MODULE: ./app/common/reducers/providerDialogReducer.js
var providerDialogReducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var defaultState = {
    providers: [],
    display: false
};

function providerDialogReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];

    switch (action.type) {
        case authenticationActions["u" /* REQUEST_PROVIDERS */]:
            return providerDialogReducer__extends({}, state, { reqStartTime: action.startTime });
        case authenticationActions["t" /* RECEIVE_PROVIDERS */]:
            return providerDialogReducer__extends({}, state, {
                providers: action.providers,
                reqCompleteTime: action.completeTime
            });
        case authenticationActions["k" /* DISPLAY_PROVIDER_DIALOG */]:
            return providerDialogReducer__extends({}, state, { display: true });
        case authenticationActions["b" /* CLOSE_PROVIDER_DIALOG */]:
            return providerDialogReducer__extends({}, state, { display: false });
        default:
            return state;
    }
}
// EXTERNAL MODULE: ./node_modules/loglevel/lib/loglevel.js
var loglevel = __webpack_require__(73);
var loglevel_default = /*#__PURE__*/__webpack_require__.n(loglevel);

// EXTERNAL MODULE: ./app/lib/metrics/newRelicEventBus.js
var newRelicEventBus = __webpack_require__(137);

// EXTERNAL MODULE: ./app/lib/api/cache/fallbackCache.js
var fallbackCache = __webpack_require__(74);

// CONCATENATED MODULE: ./app/lib/api/NetworkImageData.js







var log = loglevel_default.a.getLogger('NetworkImageData');

var DEFAULT_EXPIRATION = 600; // 10 minutes
var DEFAULT_TIMEOUT = 5000;
var NETWORK_IMAGE_DATA_URL = config["secureCdnHost"] + '/connected-devices/images/data.json';

function getUrl() {
    var url = NETWORK_IMAGE_DATA_URL;
    if (false) {
        // use non ssl domain for server side
        url = url.replace(secureCdnHost, 'http://proxy.espn.com');
    }
    return url;
}

function get() {
    var url = getUrl();
    return requestCache["a" /* default */].get(url).expiration(DEFAULT_EXPIRATION).use(requestProxy["a" /* default */]).timeout(DEFAULT_TIMEOUT).then(function (_ref) {
        var body = _ref.body;

        fallbackCache["a" /* default */].set(url, body);
        return body;
    }).catch(function (err) {
        log.error('load network image data: ' + url, err.originalError);
        newRelicEventBus["b" /* newRelicEmitter */].emit(newRelicEventBus["a" /* UNFULFILLED_PROMISE_EVENT */], err);
        return fallbackCache["a" /* default */].get(url).then(function (networkImageData) {
            if (!networkImageData) {
                return networkImageData;
            }
            return {};
        });
    });
}
// CONCATENATED MODULE: ./app/common/NetworkLogo/actions.js


var LOAD_NETWORK_IMAGE_DATA = 'LOAD_NETWORK_IMAGE_DATA';

function loadNetworkImageData() {
    return function (dispatch) {
        return get().then(function (networkImageData) {
            dispatch({
                type: LOAD_NETWORK_IMAGE_DATA,
                payload: networkImageData
            });
        });
    };
}
// CONCATENATED MODULE: ./app/common/NetworkLogo/reducers/index.js
var NetworkLogo_reducers__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function networkImageData() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case LOAD_NETWORK_IMAGE_DATA:
            return NetworkLogo_reducers__extends({}, state, {
                payload: action.payload
            });
        default:
            return NetworkLogo_reducers__extends({}, state);
    }
}
// CONCATENATED MODULE: ./app/common/reducers/index.js


















var rootReducer = Object(redux_es["c" /* combineReducers */])({
    ads: adsReducer,
    app: appReducer,
    authentication: authenticationReducer,
    fan: fanReducer,
    lastAction: lastAction,
    oneId: oneIdReducer,
    page: reducers_page,
    player: player_reducers_page,
    providerDialog: providerDialogReducer,
    routing: react_router_redux_lib["routerReducer"],
    schedule: scheduleReducer,
    scheduleModule: scheduleModuleReducer,
    networks: networksReducer,
    activation: activationReducer,
    networkImageData: networkImageData
});

/* harmony default export */ var reducers = (rootReducer);
// CONCATENATED MODULE: ./app/store.js
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function store__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }







function configureStore() {
    var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { app: {} };
    var history = arguments[1];
    var customMiddleware = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    var middleware = [redux_thunk_lib_default.a, Object(react_router_redux_lib["routerMiddleware"])(history)].concat(customMiddleware);
    if (false) {
        // turn this off by default
        // const createLogger = require('redux-logger');
        // middleware.push(createLogger());
    }

    var store = Object(redux_es["e" /* createStore */])(reducers, initialState, Object(redux_es["d" /* compose */])(redux_es["a" /* applyMiddleware */].apply(undefined, store__toConsumableArray(middleware)), (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && typeof window.devToolsExtension !== 'undefined' && initialState.app.env !== enums["c" /* AppEnvs */].PROD ? window.devToolsExtension() : function (func) {
        return func;
    }));

    if (false) {
        // Enable Webpack hot module replacement for reducers
        module.hot.accept('common/reducers', function () {
            var nextReducer = require('./common/reducers');
            store.replaceReducer(nextReducer);
        });
    }

    return store;
}

/* harmony default export */ var app_store = (configureStore);
// EXTERNAL MODULE: ./app/common/ads/BannerAd.js
var BannerAd = __webpack_require__(76);

// EXTERNAL MODULE: ./app/common/page/buckets/BucketListContainer.js
var BucketListContainer = __webpack_require__(98);

// EXTERNAL MODULE: ./app/common/page/common/MainContainer.js
var MainContainer = __webpack_require__(57);

// EXTERNAL MODULE: ./app/common/page/common/TopLayoutContainer.js + 2 modules
var TopLayoutContainer = __webpack_require__(152);

// CONCATENATED MODULE: ./app/common/page/Features.js
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();










var Features_Features = function Features() {
    var bannerAd = [_jsx(BannerAd["a" /* default */], {}, 'banner_ad')];
    return _jsx(MainContainer["a" /* default */], {
        className: 'watch-home',
        pre: bannerAd
    }, void 0, _jsx(TopLayoutContainer["a" /* default */], {}), _jsx('div', {
        className: 'layout-full layout-full--watch'
    }, void 0, _jsx('section', {
        className: 'col-a'
    }, void 0, _jsx(BucketListContainer["a" /* default */], {
        pageType: enums["y" /* PageType */].FEATURES
    }, 'bucket_list_container'))));
};

Features_Features.loadActions = [function (params, query, lang) {
    return Object(page_actions["o" /* createFetchPageAction */])(params.pageName, params, query, lang);
}, function (params, query, lang) {
    return Object(scheduleModule_actions["d" /* fetchScheduleModule */])(lang);
}];

/* harmony default export */ var page_Features = (Features_Features);
// EXTERNAL MODULE: ./app/common/selectors/analyticsSelectors.js
var analyticsSelectors = __webpack_require__(54);

// EXTERNAL MODULE: ./app/common/page/search/SearchResultsContainer.js
var SearchResultsContainer = __webpack_require__(356);

// EXTERNAL MODULE: ./app/common/search/SearchContainer.js + 3 modules
var SearchContainer = __webpack_require__(154);

// CONCATENATED MODULE: ./app/common/page/Search.js
var Search__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();












var Search_bannerAd = [Search__jsx(BannerAd["a" /* default */], {}, 'banner_ad')];

var Search_Search = function Search(_ref) {
    var _ref$params$searchTer = _ref.params.searchTerm,
        searchTerm = _ref$params$searchTer === undefined ? '' : _ref$params$searchTer,
        entitlementsTracking = _ref.entitlementsTracking;
    return Search__jsx(MainContainer["a" /* default */], {
        pre: Search_bannerAd
    }, void 0, Search__jsx('section', {
        className: 'layout-full'
    }, void 0, Search__jsx(SearchContainer["a" /* default */], {
        entitlementsTracking: entitlementsTracking,
        pageType: enums["y" /* PageType */].SEARCH,
        enabled: true
    })), Search__jsx('section', {
        className: 'layout-bc layout-bc--watch'
    }, void 0, Search__jsx(SearchResultsContainer["a" /* default */], {
        searchTerm: searchTerm
    })));
};

Search_Search.loadActions = [function (params, query) {
    return Object(ads_actions["g" /* initAdsConfig */])('search', null, {}, query);
}, function () {
    return Object(page_actions["y" /* setPageInfo */])('search', 'Search', false);
}];

var Search_mapStateToProps = function mapStateToProps(state) {
    return {
        entitlementsTracking: Object(analyticsSelectors["c" /* entitlementsTrackingSelector */])(state)
    };
};

/* harmony default export */ var page_Search = (Object(es["b" /* connect */])(Search_mapStateToProps)(Search_Search));
// CONCATENATED MODULE: ./app/webapp/page/Sid.js
var Sid__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();










var Sid_Sid = function Sid(_ref) {
    var _ref$params$team = _ref.params.team,
        team = _ref$params$team === undefined ? '' : _ref$params$team,
        apiEnv = _ref.apiEnv;
    return Sid__jsx(MainContainer["a" /* default */], {}, void 0, Sid__jsx('section', {
        className: 'layout-full'
    }, void 0, Sid__jsx(SearchContainer["a" /* default */], {
        apiEnv: apiEnv,
        pageType: enums["y" /* PageType */].SID,
        showFooter: false,
        enabled: true
    })), Sid__jsx('section', {
        className: 'layout-bc layout-bc--watch'
    }, void 0, Sid__jsx(SearchResultsContainer["a" /* default */], {
        searchTerm: team,
        pageType: enums["y" /* PageType */].SID
    })));
};

Sid_Sid.loadActions = [function () {
    return Object(page_actions["s" /* fetchAllCompetitors */])();
}, function () {
    return Object(page_actions["y" /* setPageInfo */])('sid', 'SID', false);
}];

var Sid_mapStateToProps = function mapStateToProps(state) {
    return {
        apiEnv: Object(appSelector["c" /* apiEnvSelector */])(state)
    };
};

/* harmony default export */ var page_Sid = (Object(es["b" /* connect */])(Sid_mapStateToProps)(Sid_Sid));
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/index.js
var hoist_non_react_statics = __webpack_require__(104);
var hoist_non_react_statics_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics);

// CONCATENATED MODULE: ./app/common/refreshable.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * This HoC allows the WrappedComponent to specify refreshInterval, and refresh callback
 * as static properties of the Component, it can also receive these values as props.
 * It uses lifecycle methods to set up and tear down refresh logic which will execute the
 * "onRefresh" callback
 */
/* harmony default export */ var refreshable = (function (WrappedComponent) {
    var Refreshable = function (_Component) {
        _inherits(Refreshable, _Component);

        function Refreshable(props) {
            _classCallCheck(this, Refreshable);

            var _this = _possibleConstructorReturn(this, (Refreshable.__proto__ || Object.getPrototypeOf(Refreshable)).call(this, props));

            _this.refreshId = null;

            _this.interval = WrappedComponent.refreshInterval;
            _this.onRefresh = WrappedComponent.onRefresh;
            return _this;
        }

        _createClass(Refreshable, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
                var _this2 = this;

                var _props = this.props,
                    _props$interval = _props.interval,
                    interval = _props$interval === undefined ? this.interval : _props$interval,
                    _props$onRefresh = _props.onRefresh,
                    onRefresh = _props$onRefresh === undefined ? this.onRefresh : _props$onRefresh;


                if (interval) {
                    this.refreshId = setInterval(function () {
                        if (onRefresh) {
                            onRefresh(_this2.props);
                        }
                    }, interval * 1000);
                }
            }
        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (this.refreshId) {
                    clearInterval(this.refreshId);
                }
            }
        }, {
            key: 'render',
            value: function render() {
                return react_default.a.createElement(WrappedComponent, this.props);
            }
        }]);

        return Refreshable;
    }(react["Component"]);

    var mapStateToProps = function mapStateToProps(_ref) {
        var lang = _ref.app.lang;
        return {
            lang: lang
        };
    };

    return Object(es["b" /* connect */])(mapStateToProps)(hoist_non_react_statics_default()(Refreshable, WrappedComponent));
});
// EXTERNAL MODULE: ./app/common/selectors/pageSelector.js
var pageSelector = __webpack_require__(13);

// EXTERNAL MODULE: ./app/common/selectors/authenticationSelectors.js
var authenticationSelectors = __webpack_require__(10);

// EXTERNAL MODULE: ./app/common/page/buckets/Tile.js + 1 modules
var Tile = __webpack_require__(350);

// EXTERNAL MODULE: ./app/common/ads/InContentAd.js
var InContentAd = __webpack_require__(150);

// CONCATENATED MODULE: ./app/webapp/drawer/TabPane.js
var TabPane__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();





var placementPrefix = 'playback-page-recommended-';

var TabPane_TabPane = function TabPane(_ref) {
    var active = _ref.active,
        bucketId = _ref.bucketId,
        contents = _ref.contents,
        name = _ref.name,
        showAds = _ref.showAds,
        tabIndex = _ref.tabIndex;

    var ad = showAds ? TabPane__jsx(InContentAd["a" /* default */], {
        exclude: ['m'],
        refreshWhenVisible: true
    }, 'ad_incontent') : null;
    var items = contents.map(function (content) {
        return TabPane__jsx(Tile["a" /* default */], {
            content: content,
            bucketId: bucketId,
            placement: '' + placementPrefix + name,
            bucketName: name
        }, 'tabPane' + tabIndex + ':' + content.id + ':' + content.name);
    });
    if (ad) {
        items.splice(3, 0, ad);
    }
    return TabPane__jsx('div', {
        className: 'tab-pane ' + (active ? 'active' : '')
    }, void 0, TabPane__jsx('div', {
        className: 'collection collection--watch'
    }, void 0, TabPane__jsx('div', {
        className: 'collection_row'
    }, void 0, items)));
};

TabPane_TabPane.defaultProps = {
    active: false,
    contents: [],
    name: 'unknown',
    showAds: false
};

/* harmony default export */ var drawer_TabPane = (TabPane_TabPane);
// CONCATENATED MODULE: ./app/webapp/drawer/TabContainer.js
var TabContainer__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var TabContainer__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function TabContainer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TabContainer__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function TabContainer__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var TabContainer_TabContainer = function (_Component) {
    TabContainer__inherits(TabContainer, _Component);

    function TabContainer(props) {
        TabContainer__classCallCheck(this, TabContainer);

        var _this = TabContainer__possibleConstructorReturn(this, (TabContainer.__proto__ || Object.getPrototypeOf(TabContainer)).call(this, props));

        _this.state = { activeTab: 0 };
        _this.onTabSelect = _this.onTabSelect.bind(_this);
        _this.inferSelectedBucket = _this.inferSelectedBucket.bind(_this);
        return _this;
    }

    TabContainer__createClass(TabContainer, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.inferSelectedBucket(this.props.buckets);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.buckets !== nextProps.buckets) {
                this.inferSelectedBucket(nextProps.buckets);
            }
        }
    }, {
        key: 'onTabSelect',
        value: function onTabSelect(tabIndex) {
            this.setState({ activeTab: tabIndex });
        }
    }, {
        key: 'inferSelectedBucket',
        value: function inferSelectedBucket() {
            var buckets = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

            var index = buckets.map(function (bucket) {
                return bucket.__replaced;
            }).indexOf(true);
            if (index > 0) {
                this.setState({ activeTab: index });
            }
        }
    }, {
        key: 'isLoggedInProvider',
        value: function isLoggedInProvider() {
            var authTypes = this.props.authTypes;

            return Array.isArray(authTypes) && authTypes.indexOf('mvpd') !== -1;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var tabControls = [];
            var tabPanes = [];
            var showAds = this.props.isIntl && this.isLoggedInProvider();

            this.props.buckets.filter(function (bucket) {
                return bucket.type !== 'hero';
            }).forEach(function (bucket, tabIndex) {
                var active = _this2.state.activeTab === tabIndex;
                var tabControl = TabContainer__jsx('li', {
                    onClick: function onClick() {
                        return _this2.onTabSelect(tabIndex);
                    },
                    className: active ? 'active' : ''
                }, 'tabControl-' + bucket.id, TabContainer__jsx('span', {}, void 0, bucket.name));

                tabControls.push(tabControl);
                if (active) {
                    tabPanes.push(TabContainer__jsx(drawer_TabPane, {
                        active: active,
                        name: bucket.name,
                        bucketId: bucket.id,
                        contents: bucket.contents,
                        tabIndex: tabIndex,
                        showAds: showAds
                    }, 'tabPane-' + bucket.id));
                }
            });

            return TabContainer__jsx('div', {
                className: 'playback__content'
            }, void 0, TabContainer__jsx('div', {
                className: 'tab-wrap'
            }, void 0, TabContainer__jsx('ul', {
                className: 'tabs alt',
                'data-behavior': 'tabs_transform'
            }, void 0, tabControls)), TabContainer__jsx('div', {
                className: 'tab-content'
            }, void 0, tabPanes));
        }
    }]);

    return TabContainer;
}(react["Component"]);

TabContainer_TabContainer.defaultProps = {
    buckets: [],
    authTypes: []
};

var TabContainer_mapStateToProps = function mapStateToProps(state) {
    var page = Object(pageSelector["c" /* default */])(state) || {};

    var _authenticationSelect = Object(authenticationSelectors["i" /* authenticationSelector */])(state),
        _authenticationSelect2 = _authenticationSelect.authTypes,
        authTypes = _authenticationSelect2 === undefined ? [] : _authenticationSelect2;

    return {
        buckets: page.buckets,
        isIntl: Object(appSelector["u" /* isIntlSelector */])(state),
        authTypes: authTypes
    };
};

/* harmony default export */ var drawer_TabContainer = (Object(es["b" /* connect */])(TabContainer_mapStateToProps)(TabContainer_TabContainer));
// CONCATENATED MODULE: ./app/webapp/drawer/Drawer.js
var Drawer__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var Drawer_Drawer = function Drawer() {
    return Drawer__jsx('div', {
        className: 'playback__columnB nocontent'
    }, void 0, Drawer__jsx('section', {
        className: 'playback__container'
    }, void 0, Drawer__jsx('input', {
        type: 'checkbox',
        id: 'playback__toggle',
        role: 'button'
    }), Drawer__jsx('label', {
        htmlFor: 'playback__toggle',
        className: 'playback__toggle icon-font-after icon-font-after'
    }), Drawer__jsx(drawer_TabContainer, {})));
};

/* harmony default export */ var drawer_Drawer = (Drawer_Drawer);
// EXTERNAL MODULE: ./app/common/PropTypes.js
var PropTypes = __webpack_require__(28);

// EXTERNAL MODULE: ./app/lib/auth/isContentLocked.js
var isContentLocked = __webpack_require__(220);

// EXTERNAL MODULE: ./app/lib/util/isEmpty.js
var isEmpty = __webpack_require__(12);

// EXTERNAL MODULE: ./app/common/selectors/heroSelector.js
var heroSelector = __webpack_require__(56);

// EXTERNAL MODULE: ./app/common/selectors/selectedStreamSelector.js
var selectedStreamSelector = __webpack_require__(62);

// EXTERNAL MODULE: ./app/common/selectors/playingStreamSelector.js
var playingStreamSelector = __webpack_require__(148);

// EXTERNAL MODULE: ./app/webapp/branding/BrandingContainer.js + 5 modules
var BrandingContainer = __webpack_require__(357);

// EXTERNAL MODULE: ./app/common/page/hero/ContentMetadataLarge.js
var ContentMetadataLarge = __webpack_require__(355);

// EXTERNAL MODULE: ./app/webapp/player/connectPlayer.js
var connectPlayer = __webpack_require__(223);

// EXTERNAL MODULE: ./app/webapp/alert/UpcomingAlert.js + 1 modules
var UpcomingAlert = __webpack_require__(340);

// EXTERNAL MODULE: ./app/webapp/player/util/index.js + 9 modules
var util = __webpack_require__(217);

// EXTERNAL MODULE: ./app/common/injectIntl.js
var injectIntl = __webpack_require__(20);

// CONCATENATED MODULE: ./app/webapp/page/hero/HeroPlaybackPage.js
var HeroPlaybackPage__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var HeroPlaybackPage__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function HeroPlaybackPage__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function HeroPlaybackPage__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function HeroPlaybackPage__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










/**
 * This UI component has a player connected to it.
 * Due to the fact that the connectPlayer function expects a component with a "ref" to "playerElement",
 * the "alertable" HOC can not be used to manage the UpcomingAlert's state.
 */

var HeroPlaybackPage_HeroPlaybackPage = function (_Component) {
    HeroPlaybackPage__inherits(HeroPlaybackPage, _Component);

    function HeroPlaybackPage(props) {
        HeroPlaybackPage__classCallCheck(this, HeroPlaybackPage);

        var _this = HeroPlaybackPage__possibleConstructorReturn(this, (HeroPlaybackPage.__proto__ || Object.getPrototypeOf(HeroPlaybackPage)).call(this, props));

        _this.state = {
            displayAlert: false
        };
        _this.onClose = _this.onClose.bind(_this);
        _this.getAlertEl = _this.getAlertEl.bind(_this);
        return _this;
    }

    HeroPlaybackPage__createClass(HeroPlaybackPage, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            if (this.showAlertOnMount()) {
                this.setState({ displayAlert: true });
            }
        }
    }, {
        key: 'onClose',
        value: function onClose() {
            this.setState({ displayAlert: false });
        }
    }, {
        key: 'getAlertEl',
        value: function getAlertEl() {
            var _props = this.props,
                alertContent = _props.alertContent,
                selectedStream = _props.selectedStream,
                playingStream = _props.playingStream,
                messages = _props.messages,
                formatMessage = _props.intl.formatMessage;

            var stream = playingStream || selectedStream;
            if (this.state.displayAlert) {
                var moreText = !Object(isEmpty["a" /* default */])(stream) ? formatMessage(messages['schedule.module.alert.moreText'], { name: stream.name }) : '';
                return HeroPlaybackPage__jsx(UpcomingAlert["a" /* default */], {
                    animate: 'fade',
                    content: alertContent,
                    moreText: moreText,
                    style: { position: 'absolute', top: '0px', zIndex: 1000050 },
                    onClose: this.onClose
                });
            }
            return null;
        }
    }, {
        key: 'showAlertOnMount',
        value: function showAlertOnMount() {
            var alertContent = this.props.alertContent;

            if (!Object(isEmpty["a" /* default */])(alertContent)) {
                return true;
            }
            return false;
        }
    }, {
        key: 'render',
        value: function render() {
            return HeroPlaybackPage__jsx('div', {
                className: 'media-wrapper media-wrapper--embed espnplayerwrapper',
                style: Object(util["c" /* getPlayerBackgroundStyle */])(this.props.selectedContent)
            }, void 0, this.getAlertEl(), HeroPlaybackPage__jsx('div', {}, void 0, react_default.a.createElement(
                'div',
                { ref: 'playerContainer', id: 'watchespn-player-container' },
                '\xA0'
            )));
        }
    }]);

    return HeroPlaybackPage;
}(react["Component"]);

/* harmony default export */ var hero_HeroPlaybackPage = (Object(connectPlayer["a" /* default */])(HeroPlaybackPage_HeroPlaybackPage));

// EXTERNAL MODULE: ./app/webapp/lib/format/index.js
var format = __webpack_require__(151);

// CONCATENATED MODULE: ./app/webapp/page/hero/HeroPlaybackPageContainer.js
var HeroPlaybackPageContainer__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



















var formatVideoTitle = function formatVideoTitle(currentContent, currentStream) {
    var title = currentContent.name;

    if (currentContent && currentStream) {
        if (currentContent.isEvent) {
            if (currentContent.streams && currentContent.streams.length > 1) {
                if (currentStream.authTypes && currentStream.authTypes.indexOf('direct') !== -1) {
                    title = currentContent.name;
                } else {
                    title = currentStream.name !== currentContent.name ? currentStream.name : currentContent.name;
                }
            } else {
                // Single event stream
                title = currentContent.name;
            }
        }
    }

    return title;
};

var HeroPlaybackPageContainer_HeroPlaybackPageContainer = function HeroPlaybackPageContainer(_ref) {
    var alertContent = _ref.alertContent,
        content = _ref.content,
        stream = _ref.stream,
        location = _ref.location,
        placement = _ref.placement,
        bucketId = _ref.bucketId,
        bucketName = _ref.bucketName,
        pageId = _ref.pageId,
        pageName = _ref.pageName,
        userInitiated = _ref.userInitiated,
        showLock = _ref.showLock,
        userLocation = _ref.userLocation,
        isIntl = _ref.isIntl,
        intlDateFormat = _ref.intlDateFormat;
    var description = content.description;

    var title = formatVideoTitle(content, stream);
    var streamSubtitle = stream && stream.content && stream.content.subtitle;
    // Use the current stream content and sanitize the text; default to the content subtitle
    var formattedSubtitle = streamSubtitle || Object(format["a" /* contentSubtitle */])(content);
    var subtitle = formattedSubtitle; // for VOD, this will be null and render nothing
    if (formattedSubtitle && description) {
        subtitle = formattedSubtitle + ' - ' + description;
    }
    var bannerAd = isIntl ? HeroPlaybackPageContainer__jsx(BannerAd["a" /* default */], {
        exclude: ['l', 'xl']
    }) : null;

    return HeroPlaybackPageContainer__jsx('div', {
        className: 'playback__columnA'
    }, void 0, HeroPlaybackPageContainer__jsx('figure', {
        className: 'playback__media'
    }, void 0, HeroPlaybackPageContainer__jsx(BrandingContainer["a" /* default */], {
        location: location,
        stream: stream
    }), HeroPlaybackPageContainer__jsx(hero_HeroPlaybackPage, {
        alertContent: alertContent,
        disableAuthPrompt: false,
        initialAutoEmbedCountDown: 0,
        location: location,
        playerPlacement: enums["B" /* PlayerPlacement */].PLAYER,
        placement: placement,
        bucketId: bucketId,
        bucketName: bucketName,
        pageId: pageId,
        pageName: pageName,
        userInitiated: userInitiated,
        userLocation: userLocation,
        dateFormat: intlDateFormat
    }), HeroPlaybackPageContainer__jsx(ContentMetadataLarge["a" /* default */], {
        showLock: showLock,
        title: title,
        subtitle: subtitle,
        content: content
    })), bannerAd);
};

HeroPlaybackPageContainer_HeroPlaybackPageContainer.defaultProps = {
    adobePass: {},
    content: {}
};

var HeroPlaybackPageContainer_mapStateToProps = function mapStateToProps(state) {
    var userAuth = Object(authenticationSelectors["r" /* userAuthSelector */])(state);
    var preauthorizedResources = Object(authenticationSelectors["o" /* preauthorizedResourcesSelector */])(state);
    var selectedStream = Object(selectedStreamSelector["a" /* default */])(state);
    var playingStream = Object(playingStreamSelector["a" /* default */])(state);
    var stream = !Object(isEmpty["a" /* default */])(playingStream) ? playingStream : selectedStream;
    // TODO: DTC - use `stream.content` once `content` has `duration` for VOD
    // so that content metadata doesn't change every time when a new content is selected when user is not authed
    var content = /* stream ? stream.content : */Object(heroSelector["a" /* default */])(state);
    return {
        content: content,
        stream: stream,
        isIntl: Object(appSelector["u" /* isIntlSelector */])(state),
        intlDateFormat: Object(appSelector["i" /* dateFormatSelector */])(state),
        userAuth: userAuth,
        userLocation: Object(authenticationSelectors["s" /* userLocationSelector */])(state),
        showLock: Object(isContentLocked["a" /* default */])(content, userAuth, preauthorizedResources)
    };
};

/* harmony default export */ var hero_HeroPlaybackPageContainer = (Object(es["b" /* connect */])(HeroPlaybackPageContainer_mapStateToProps)(HeroPlaybackPageContainer_HeroPlaybackPageContainer));
// CONCATENATED MODULE: ./app/webapp/page/Player.js
var Player__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();








var Player_Player = function Player(_ref) {
    var _ref$location = _ref.location,
        location = _ref$location === undefined ? {} : _ref$location,
        isMobile = _ref.isMobile;

    // if the player was routed to with an alert, pass it on down
    var _ref2 = location.state || {},
        alertContent = _ref2.alertContent,
        placement = _ref2.placement,
        bucketId = _ref2.bucketId,
        bucketName = _ref2.bucketName,
        pageId = _ref2.pageId,
        pageName = _ref2.pageName,
        userInitiated = _ref2.userInitiated;

    // Some styles of the playback page depend on a 'no-touch' parent class.  This assumed


    var mobileClass = isMobile === false ? 'no-touch' : '';
    return Player__jsx('section', {
        id: 'playback',
        className: mobileClass
    }, void 0, Player__jsx(hero_HeroPlaybackPageContainer, {
        alertContent: alertContent,
        location: location,
        placement: placement,
        bucketId: bucketId,
        bucketName: bucketName,
        pageId: pageId,
        pageName: pageName,
        userInitiated: userInitiated
    }), Player__jsx(drawer_Drawer, {}));
};

Player_Player.loadActions = [function (pathParams, query, lang) {
    return Object(page_actions["o" /* createFetchPageAction */])('player', pathParams, query, lang);
}];

Player_Player.refreshInterval = 300; // 5 mins
Player_Player.onRefresh = function (_ref3) {
    var dispatch = _ref3.dispatch;

    dispatch(Object(page_actions["v" /* refreshBuckets */])('player'));
};

var Player_mapStateToProps = function mapStateToProps(state) {
    return {
        isMobile: state.app.isMobile || false
    };
};

/* harmony default export */ var page_Player = (Object(es["b" /* connect */])(Player_mapStateToProps)(refreshable(Player_Player)));
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(14);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// CONCATENATED MODULE: ./app/common/schedule/SectionHeader.js
var SectionHeader__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var SectionHeader_SectionHeader = function SectionHeader(_ref) {
    var title = _ref.title,
        mq = _ref.mq,
        isMobile = _ref.isMobile;

    var searchContainerEl = mq !== 'mobile' && !isMobile ? SectionHeader__jsx(SearchContainer["a" /* default */], {}) : null;
    return SectionHeader__jsx('header', {
        className: 'section-header'
    }, void 0, SectionHeader__jsx('h1', {
        className: 'section-header_title'
    }, void 0, title), searchContainerEl);
};

/* harmony default export */ var schedule_SectionHeader = (SectionHeader_SectionHeader);
// EXTERNAL MODULE: ./app/common/schedule/FilterGroupContainer.js + 1 modules
var FilterGroupContainer = __webpack_require__(358);

// EXTERNAL MODULE: ./app/common/schedule/ScheduleCategoryContainer.js
var ScheduleCategoryContainer = __webpack_require__(361);

// EXTERNAL MODULE: ./config/appNames.js
var appNames = __webpack_require__(309);
var appNames_default = /*#__PURE__*/__webpack_require__.n(appNames);

// EXTERNAL MODULE: ./app/common/selectors/darkThemeSelector.js
var darkThemeSelector = __webpack_require__(363);

// CONCATENATED MODULE: ./app/common/page/Schedule.js
var Schedule__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




















var Schedule_Schedule = function Schedule(props) {
    var appName = props.appName,
        categories = props.categories,
        channels = props.channels,
        isMobile = props.isMobile,
        location = props.location,
        listings = props.listings,
        loading = props.loading,
        mq = props.mq,
        selectedTab = props.selectedTab,
        userAuth = props.userAuth,
        messages = props.messages,
        formatMessage = props.intl.formatMessage,
        darkTheme = props.darkTheme;

    var bannerAd = [Schedule__jsx(BannerAd["a" /* default */], {}, 'banner_ad')];
    var tabClassname = classnames_default()('watch-tab', { loading: loading });

    // Make schedule go full width for ESPN App since there is no ad, and remove redundant title
    var colBStyle = {};
    var sectionHeaderTitle = formatMessage(messages['schedule.header']);
    if (appName === appNames_default.a.ESPNAPP) {
        colBStyle = { width: '100%' };
        sectionHeaderTitle = '';
    }

    var appearance = darkTheme ? 'dark' : 'light';

    return Schedule__jsx(MainContainer["a" /* default */], {
        pre: bannerAd
    }, void 0, Schedule__jsx('section', {
        'data-appearance': appearance,
        className: 'layout-bc layout-bc--watch'
    }, void 0, Schedule__jsx('section', {
        className: 'col-b',
        style: colBStyle
    }, void 0, Schedule__jsx('article', {
        className: 'watch-schedule'
    }, void 0, Schedule__jsx(schedule_SectionHeader, {
        title: sectionHeaderTitle,
        mq: mq,
        isMobile: isMobile
    }, 'section_header'), Schedule__jsx(FilterGroupContainer["a" /* default */], {
        channels: channels,
        categories: categories,
        location: location
    }), Schedule__jsx('div', {
        className: 'content'
    }, void 0, Schedule__jsx('div', {
        id: 'tabLive',
        className: tabClassname,
        style: { display: 'block' }
    }, void 0, Schedule__jsx(ScheduleCategoryContainer["a" /* default */], {
        listings: listings,
        userAuth: userAuth,
        selectedTab: selectedTab,
        isMobile: isMobile,
        startDateValue: location.query.startDate,
        bucketName: location.query.type || 'live',
        watchRegion: location.query.watchRegion
    })))), Schedule__jsx(InContentAd["a" /* default */], {
        include: ['s'],
        adClassName: 'ad-slot-incontent2',
        refreshWhenVisible: true
    })), Schedule__jsx('section', {
        className: 'col-c'
    }, void 0, Schedule__jsx(InContentAd["a" /* default */], {
        exclude: ['s', 'm']
    }))));
};

Schedule_Schedule.defaultProps = {
    selectedTab: StatusFilter["a" /* default */].Options.LIVE,
    isMobile: false
};

Schedule_Schedule.loadActions = [function () {
    return Object(schedule_actions["i" /* fetchCategories */])();
}, fetchNetworks, function (params, _ref) {
    var _ref$type = _ref.type,
        type = _ref$type === undefined ? StatusFilter["a" /* default */].Options.LIVE : _ref$type;
    return Object(schedule_actions["l" /* setStatusFilter */])(type);
}, function (params, _ref2) {
    var _ref2$type = _ref2.type,
        type = _ref2$type === undefined ? StatusFilter["a" /* default */].Options.LIVE : _ref2$type,
        categoryId = _ref2.categoryId,
        channel = _ref2.channel,
        startDate = _ref2.startDate,
        endDate = _ref2.endDate;
    return Object(schedule_actions["j" /* fetchSchedule */])({ type: type, categoryId: categoryId, channel: channel, startDate: startDate, endDate: endDate });
}, function (params, query) {
    return Object(ads_actions["g" /* initAdsConfig */])('schedule', null, {}, query);
}, function () {
    return Object(page_actions["y" /* setPageInfo */])('schedule', 'Schedule', false);
}];

var Schedule_mapStateToProps = function mapStateToProps(state) {
    var app = state.app,
        schedule = state.schedule;

    return {
        appName: app.appName,
        categories: schedule.categories || [],
        channels: schedule.channels || [],
        listings: schedule.listings || [],
        userAuth: Object(authenticationSelectors["r" /* userAuthSelector */])(state),
        loading: schedule.loading,
        mq: app.mq,
        selectedTab: schedule.statusFilterValue,
        isMobile: app.isMobile,
        darkTheme: Object(darkThemeSelector["a" /* default */])(state)
    };
};

/* harmony default export */ var page_Schedule = (Object(es["b" /* connect */])(Schedule_mapStateToProps)(Object(injectIntl["a" /* default */])(Schedule_Schedule)));
// CONCATENATED MODULE: ./app/webapp/page/ShortStopLive.js
var ShortStopLive__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();









var ShortStopLive_ShortStopLive = function ShortStopLive() {
    return ShortStopLive__jsx(MainContainer["a" /* default */], {
        className: 'watch-home'
    }, void 0, ShortStopLive__jsx(TopLayoutContainer["a" /* default */], {}), ShortStopLive__jsx('div', {
        className: 'layout-full layout-full--watch'
    }, void 0, ShortStopLive__jsx('section', {
        className: 'col-a'
    }, void 0, ShortStopLive__jsx(BucketListContainer["a" /* default */], {
        pageType: enums["y" /* PageType */].HOME
    }))));
};

ShortStopLive_ShortStopLive.loadActions = [function (params, query, lang) {
    return Object(page_actions["o" /* createFetchPageAction */])('shortstoplive', params, query, lang);
}, function (params, query, lang) {
    return Object(scheduleModule_actions["d" /* fetchScheduleModule */])(lang);
}];

/* harmony default export */ var page_ShortStopLive = (ShortStopLive_ShortStopLive);
// EXTERNAL MODULE: ./node_modules/react-helmet/lib/Helmet.js
var Helmet = __webpack_require__(30);
var Helmet_default = /*#__PURE__*/__webpack_require__.n(Helmet);

// CONCATENATED MODULE: ./app/webapp/page/Activate/Success.js
var Success__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var Success_Success = function Success(_ref) {
    var authSystem = _ref.authSystem,
        deviceType = _ref.deviceType;
    return Success__jsx('div', {}, void 0, Success__jsx('header', {
        className: 'dtc-auth__header',
        id: 'page-title'
    }, void 0, Success__jsx('h1', {
        className: 'dtc-auth__header__title'
    }, void 0, 'Success!')), Success__jsx('section', {
        className: 'dtc-auth__section dtc-auth__section--success',
        id: 'enter-code'
    }, void 0, Success__jsx('svg', {
        className: 'dtc-checkmark',
        xmlns: 'http://www.w3.org/2000/svg',
        viewBox: '0 0 52 52'
    }, void 0, Success__jsx('circle', {
        className: 'dtc-checkmark__circle',
        cx: '26',
        cy: '26',
        r: '25',
        fill: 'none'
    }), Success__jsx('path', {
        className: 'dtc-checkmark__check',
        fill: 'none',
        d: 'M14.1 27.2l7.1 7.2 16.7-16.8'
    })), Success__jsx('p', {}, void 0, getSuccessText(authSystem, deviceType))));
};

/* harmony default export */ var Activate_Success = (Success_Success);
// CONCATENATED MODULE: ./app/webapp/page/Activate/Error.js
var Error__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var Error_Error = function Error() {
    return Error__jsx("div", {}, void 0, Error__jsx("header", {
        className: "section error",
        id: "page-title"
    }, void 0, Error__jsx("h1", {}, void 0, "Activation Error")), Error__jsx("section", {
        className: "section error",
        id: "enter-code"
    }, void 0, Error__jsx("h2", {}, void 0, "Your device could not be activated!"), Error__jsx("p", {}, void 0, "Please verify the code you entered matches the code on your device and try again."), Error__jsx("p", {}, void 0, "If you continue to receive this message please try generating a new code on the device.")));
};

/* harmony default export */ var Activate_Error = (Error_Error);
// CONCATENATED MODULE: ./app/webapp/page/Activate/Activation.js
var Activation__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var Activation__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Activation__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Activation__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function Activation__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Activation__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Activation__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var Activation_ActivationComponent = function (_Component) {
    Activation__inherits(ActivationComponent, _Component);

    function ActivationComponent(props) {
        Activation__classCallCheck(this, ActivationComponent);

        var _this = Activation__possibleConstructorReturn(this, (ActivationComponent.__proto__ || Object.getPrototypeOf(ActivationComponent)).call(this, props));

        _this.state = {
            isAdobeRegCode: false,
            regCode: _this.props.regCode.toUpperCase(),
            regCodeError: false
        };
        _this.onCodeChange = _this.onCodeChange.bind(_this);
        _this.onCodeKeyUp = _this.onCodeKeyUp.bind(_this);
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.renderHeading = _this.renderHeading.bind(_this);
        return _this;
    }

    Activation__createClass(ActivationComponent, [{
        key: 'onCodeChange',
        value: function onCodeChange(event) {
            var regCode = event.target.value.toUpperCase();
            this.props.dispatch(regCodeUpdate(regCode));
            this.setState({
                regCode: regCode,
                regCodeError: false
            });
        }
    }, {
        key: 'onCodeKeyUp',
        value: function onCodeKeyUp(event) {
            if (event.which === 13) {
                this.onSubmit();
            }
        }
    }, {
        key: 'onSubmit',
        value: function () {
            var _ref = Activation__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var regCode, _props, adobePassEnv, deviceType, dispatch, submitting, commerceUrlsConfig, query, regCodeError;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                regCode = this.state.regCode;
                                _props = this.props, adobePassEnv = _props.adobePassEnv, deviceType = _props.deviceType, dispatch = _props.dispatch, submitting = _props.submitting, commerceUrlsConfig = _props.commerceUrlsConfig, query = _props.query;

                                if (!submitting) {
                                    _context.next = 4;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 4:
                                regCodeError = !regCode;

                                if (!regCodeError) {
                                    _context.next = 8;
                                    break;
                                }

                                this.setState({ regCodeError: regCodeError });
                                return _context.abrupt('return');

                            case 8:

                                dispatch(startSubmit());
                                _context.prev = 9;

                                if (!isAdobeRegCode(regCode)) {
                                    _context.next = 15;
                                    break;
                                }

                                _context.next = 13;
                                return dispatch(checkAdobeRegCode(regCode, adobePassEnv));

                            case 13:
                                _context.next = 21;
                                break;

                            case 15:
                                if (!isOneIdRegCode(regCode)) {
                                    _context.next = 20;
                                    break;
                                }

                                _context.next = 18;
                                return dispatch(checkOneIdRegCode(deviceType, regCode, commerceUrlsConfig, query));

                            case 18:
                                _context.next = 21;
                                break;

                            case 20:
                                dispatch(createInvalidErrorAction(INVALID_MESSAGE));

                            case 21:
                                _context.next = 26;
                                break;

                            case 23:
                                _context.prev = 23;
                                _context.t0 = _context['catch'](9);

                                if (oneId["a" /* Error */].CANCEL_BY_USER !== _context.t0) {
                                    if (oneId["a" /* Error */].UNKNOWN_ERROR === _context.t0) {
                                        dispatch(createGenericErrorAction(_context.t0));
                                    } else {
                                        dispatch(createInvalidErrorAction(_context.t0.message || INVALID_MESSAGE));
                                    }
                                }

                            case 26:
                                dispatch(completeSubmit());

                            case 27:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[9, 23]]);
            }));

            function onSubmit() {
                return _ref.apply(this, arguments);
            }

            return onSubmit;
        }()
    }, {
        key: 'renderHeading',
        value: function renderHeading() {
            var activatePageType = this.props.activatePageType;

            var text = activatePageType === 'subscribe' ? 'Complete Your Subscription' : 'Activate Device';
            return Activation__jsx('h1', {
                className: 'dtc-auth__header__title'
            }, void 0, text);
        }
    }, {
        key: 'renderErrorMessage',
        value: function renderErrorMessage(hasError) {
            if (!hasError) {
                return null;
            }
            var _props2 = this.props,
                genericError = _props2.genericError,
                invalidError = _props2.invalidError;
            var regCodeError = this.state.regCodeError;


            if (genericError) {
                return Activation__jsx('div', {
                    id: 'generic-error',
                    className: 'dtc-form__error'
                }, void 0, Activation__jsx('p', {}, void 0, 'An error occurred. Please try again later.'));
            } else if (!genericError && invalidError) {
                return Activation__jsx('div', {
                    id: 'invalid-activation-code',
                    className: 'dtc-form__error'
                }, void 0, Activation__jsx('p', {}, void 0, 'Invalid activation code!'));
            } else if (!genericError && regCodeError) {
                return Activation__jsx('div', {
                    id: 'no-activation-code',
                    className: 'dtc-form__error'
                }, void 0, Activation__jsx('p', {}, void 0, 'Please enter an activation code.'));
            }
            return null;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props3 = this.props,
                genericError = _props3.genericError,
                invalidError = _props3.invalidError,
                activatePageType = _props3.activatePageType;
            var _state = this.state,
                regCode = _state.regCode,
                regCodeError = _state.regCodeError;


            var errorClassName = '';

            var isDisabled = regCode ? '' : 'dtc-btn--disabled';
            var isSubscribeActivation = activatePageType === 'subscribe';
            var hasError = genericError || invalidError || regCodeError;
            if (hasError) {
                errorClassName = 'dtc-form__control--error';
            }

            var buttonClasses = classnames_default()({
                'dtc-btn': !isSubscribeActivation,
                'dtc-btn--disabled': !regCode,
                'btn btn-primary': isSubscribeActivation
            });

            return Activation__jsx('div', {}, void 0, Activation__jsx('header', {
                className: 'dtc-auth__header',
                id: 'page-title'
            }, void 0, this.renderHeading()), Activation__jsx('section', {
                className: 'dtc-auth__section',
                id: 'enter-code'
            }, void 0, Activation__jsx('h2', {
                className: 'dtc-auth__section__title'
            }, void 0, 'Enter the code displayed on your TV screen.'), react_default.a.createElement('input', {
                className: 'dtc-form__control ' + errorClassName,
                ref: function ref(input) {
                    _this2.txtRegCode = input;
                },
                id: 'txtRegCode',
                name: 'txtRegCode',
                type: 'text',
                maxLength: '7',
                placeholder: 'Enter Activation Code',
                value: this.state.regCode,
                onChange: this.onCodeChange,
                onKeyUp: this.onCodeKeyUp
            }), this.renderErrorMessage(hasError)), Activation__jsx('section', {
                className: 'section',
                id: 'authenticate'
            }, void 0, Activation__jsx('button', {
                id: 'cont-btn',
                name: 'submit',
                type: 'submit',
                className: buttonClasses,
                onClick: this.onSubmit,
                disabled: isDisabled
            }, void 0, 'Continue')));
        }
    }]);

    return ActivationComponent;
}(react["Component"]);

Activation_ActivationComponent.defaultProps = {
    providers: [],
    regCode: ''
};

var Activation_mapStateToProps = function mapStateToProps(state) {
    var _state$providerDialog = state.providerDialog;
    _state$providerDialog = _state$providerDialog === undefined ? {} : _state$providerDialog;
    var _state$providerDialog2 = _state$providerDialog.providers,
        providers = _state$providerDialog2 === undefined ? [] : _state$providerDialog2,
        _state$activation = state.activation,
        _state$activation$gen = _state$activation.genericError,
        genericError = _state$activation$gen === undefined ? {} : _state$activation$gen,
        invalidError = _state$activation.invalidError,
        submitting = _state$activation.submitting,
        _state$app = state.app,
        app = _state$app === undefined ? {} : _state$app;
    var country = app.country,
        lang = app.lang,
        _app$location = app.location;
    _app$location = _app$location === undefined ? {} : _app$location;
    var _app$location$query = _app$location.query,
        query = _app$location$query === undefined ? {} : _app$location$query,
        _app$bootstrap = app.bootstrap;
    _app$bootstrap = _app$bootstrap === undefined ? {} : _app$bootstrap;
    var _app$bootstrap$bam = _app$bootstrap.bam;
    _app$bootstrap$bam = _app$bootstrap$bam === undefined ? {} : _app$bootstrap$bam;
    var commerceUrls = _app$bootstrap$bam.commerceUrls;


    return {
        genericError: genericError,
        invalidError: invalidError,
        providers: providers,
        submitting: submitting,
        query: query,
        commerceUrlsConfig: Activation__extends({ urls: commerceUrls }, { lang: lang, country: country })
    };
};

/* harmony default export */ var Activation = (Object(es["b" /* connect */])(Activation_mapStateToProps)(Activation_ActivationComponent));
// EXTERNAL MODULE: ./app/webapp/modal/messaging/MessagingContainer.js + 7 modules
var MessagingContainer = __webpack_require__(155);

// EXTERNAL MODULE: ./app/common/chooseProvider/ProviderDialog.js + 6 modules
var ProviderDialog = __webpack_require__(368);

// EXTERNAL MODULE: ./app/common/selectors/oneIdSelector.js
var oneIdSelector = __webpack_require__(27);

// CONCATENATED MODULE: ./app/webapp/page/Activate/index.js
var Activate__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Activate__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Activate__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Activate__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Activate__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
























var shellVersion = config_default.a.shellVersion,
    Activate_secureCdnHost = config_default.a.secureCdnHost;
var OneIdJs = oneId["b" /* OneIdJs */];


var HELP_LINK = 'https://es.pn/2X3h2Cu';
var HELP_LINK_TARGET = '_blank';
var HELP_ADDITIONAL_SUPPORT_LINK = 'https://es.pn/344OwSk';
var CUSTOMER_CARE_LINK = 'https://support.espn.com/hc/';

var Activate_ActivateComponent = function (_Component) {
    Activate__inherits(ActivateComponent, _Component);

    function ActivateComponent(props) {
        Activate__classCallCheck(this, ActivateComponent);

        var _this = Activate__possibleConstructorReturn(this, (ActivateComponent.__proto__ || Object.getPrototypeOf(ActivateComponent)).call(this, props));

        _this.state = {
            isAuthSuccess: false,
            isOptInChecked: false
        };
        _this.renderBrandingLogo = _this.renderBrandingLogo.bind(_this);
        _this.pageName = _this.getPageName();
        return _this;
    }

    Activate__createClass(ActivateComponent, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                _props$app$lang = _props.app.lang,
                lang = _props$app$lang === undefined ? '' : _props$app$lang,
                _props$location$query = _props.location.query,
                authSuccess = _props$location$query.authSuccess,
                device = _props$location$query.device,
                deviceType = _props$location$query.deviceType,
                mvpd = _props$location$query.mvpd,
                providers = _props.providers,
                dispatch = _props.dispatch;


            var trackingDevice = device || deviceType;
            if (authSuccess) {
                var trackingProvider = providers.filter(function (provider) {
                    return provider.abbreviation === mvpd;
                })[0];
                Object(omniture["i" /* trackActivateSuccess */])(trackingDevice, trackingProvider);
            } else {
                Object(omniture["h" /* trackActivatePage */])(lang, trackingDevice);
            }

            oneId["k" /* on */]('login', dispatch(Object(oneIdActions["l" /* getGuest */])()));
            oneId["k" /* on */]('logout', dispatch(Object(oneIdActions["i" /* clearGuest */])()));
            dispatch(Object(page_actions["y" /* setPageInfo */])(this.pageName, 'Device Activation', false));
        }

        /**
         * componentWillReceiveProps has been deprecate since React 16.3.
         * It needs to be replaced with getDerivedStateFromProps if we update
         * to React 16.3+. Currently watch web is using React version 15.4.2.
         * We haven't updated to the newest version since watch web is being redesigned.
         */

    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _nextProps$location$q = nextProps.location.query;
            _nextProps$location$q = _nextProps$location$q === undefined ? {} : _nextProps$location$q;
            var authSuccess = _nextProps$location$q.authSuccess,
                oneidenv = _nextProps$location$q.oneidenv,
                data = nextProps.oneId.data;
            var dispatch = this.props.dispatch;


            if (!Object(isEmpty["a" /* default */])(data) && !this.state.isOptInChecked) {
                var optInStatus = getMarkettingOptInStatus(data);
                var shouldUpdateOptIns = optInStatus.shouldUpdateOptIns,
                    swid = optInStatus.swid,
                    accessToken = optInStatus.accessToken;

                if (shouldUpdateOptIns) {
                    var oneIdClientUrl = oneidenv === 'staging' ? WEB_STAGE_ONE_ID_API_PATH : WEB_PROD_ONE_ID_API_PATH;
                    // dispatch action to update marketing opt-ins
                    dispatch(launchLicensePlateOnSuccess(oneIdClientUrl, swid, accessToken));
                }
                this.setState({ isOptInChecked: true });
            }

            if (authSuccess && !this.state.isAuthSuccess) {
                this.setState({ isAuthSuccess: true });
                // get guest info that will be needed for launchLicensePlateOnSuccess action
                dispatch(Object(oneIdActions["l" /* getGuest */])());
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            var dispatch = this.props.dispatch;

            oneId["j" /* off */]('login', dispatch(Object(oneIdActions["l" /* getGuest */])()));
            oneId["j" /* off */]('logout', dispatch(Object(oneIdActions["i" /* clearGuest */])()));
        }
    }, {
        key: 'getPageName',
        value: function getPageName() {
            var _props$location$pathn = this.props.location.pathname,
                pathname = _props$location$pathn === undefined ? 'activate' : _props$location$pathn;

            return pathname.substr(pathname.lastIndexOf('/') + 1);
        }
    }, {
        key: 'getStyleAssets',
        value: function getStyleAssets() {
            var pageName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
            // eslint-disable-line
            var styleList = [{ id: 'font-link', rel: 'stylesheet', href: Activate_secureCdnHost + '/redesign/fonts/base64-benton-woff.css' }, { rel: 'stylesheet', href: Activate_secureCdnHost + '/redesign/' + shellVersion + '/css/secure/shell-desktop.css' }, { rel: 'stylesheet', href: Activate_secureCdnHost + '/redesign/' + shellVersion + '/css/secure/page-shell.css' }, { rel: 'stylesheet', href: Activate_secureCdnHost + '/redesign/' + shellVersion + '/css/secure/watch.css' }, { rel: 'stylesheet', href: Activate_secureCdnHost + '/redesign/' + shellVersion + '/css/secure/watch-provider.css' }];

            // Only add OneId styles for /subscribe
            if (pageName === 'subscribe') {
                styleList.push({
                    rel: 'stylesheet', href: 'https://static.web.plus.espn.com/disneyid/styles/oneid-web.min.css'
                });
            }

            return styleList;
        }
    }, {
        key: 'renderBrandingLogo',
        value: function renderBrandingLogo() {
            var pageName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
            // eslint-disable-line
            var src = pageName === 'subscribe' ? 'https://secure.espncdn.com/espn360/images/affiliates/svg/ESPN_PLUS/ESPN-PLUS_CLR-POS.svg' : 'https://a.espncdn.com/redesign/assets/img/espn-logo-gray.svg';
            return Activate__jsx('img', {
                src: src,
                alt: '',
                className: 'dtc-auth__logo'
            });
        }
    }, {
        key: 'renderContent',
        value: function renderContent() {
            var _props2 = this.props,
                dispatch = _props2.dispatch,
                _props2$location = _props2.location;
            _props2$location = _props2$location === undefined ? {} : _props2$location;
            var _props2$location$quer = _props2$location.query;
            _props2$location$quer = _props2$location$quer === undefined ? {} : _props2$location$quer;
            var authSuccess = _props2$location$quer.authSuccess,
                authSystem = _props2$location$quer.authSystem,
                chooseProvider = _props2$location$quer.chooseProvider,
                deviceParam = _props2$location$quer.device,
                deviceType = _props2$location$quer.deviceType,
                error = _props2$location$quer.error,
                regCode = _props2$location$quer.regCode,
                adobePassEnv = _props2.adobePassEnv;

            var device = deviceParam || deviceType;

            var content = null;
            if (error === 'true') {
                content = Activate__jsx(Activate_Error, {});
            } else if (authSuccess === 'true') {
                content = Activate__jsx(Activate_Success, {
                    authSystem: authSystem,
                    deviceType: device
                });
            } else if (chooseProvider) {
                content = Activate__jsx('section', {
                    className: 'watchProvider--modal',
                    style: { minHeight: '800px' }
                }, void 0, Activate__jsx(ProviderDialog["a" /* default */], {
                    providerSelect: function providerSelect(provider) {
                        dispatch(clientlessAuthenticate({
                            regCode: regCode,
                            mvpd: provider.abbreviation,
                            deviceType: deviceType,
                            provider: provider,
                            baseUrl: window.location.href,
                            adobePassEnv: adobePassEnv
                        }));
                    }
                }));
            } else {
                content = Activate__jsx(Activation, {
                    adobePassEnv: adobePassEnv,
                    activatePageType: this.pageName,
                    deviceType: device,
                    regCode: regCode
                });
            }
            return content;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props3 = this.props,
                _props3$location = _props3.location;
            _props3$location = _props3$location === undefined ? {} : _props3$location;
            var _props3$location$quer = _props3$location.query;
            _props3$location$quer = _props3$location$quer === undefined ? {} : _props3$location$quer;
            var chooseProvider = _props3$location$quer.chooseProvider,
                authSystem = _props3$location$quer.authSystem,
                oneIdEnv = _props3.oneIdEnv,
                showHelpModule = _props3.showHelpModule;

            var containerClass = chooseProvider ? 'dtc-auth__container--providerDialog' : 'dtc-auth__container--activation';
            var content = this.renderContent();

            /**
             * Avoid putting the module on the TVE auth success page.
             * if authSystem equals to 'adobepass', that means success page is for TVE screen,
             * then we don't show help module
             */
            var renderHelpModule = showHelpModule && !chooseProvider && authSystem !== 'adobepass';

            return Activate__jsx('div', {}, void 0, Activate__jsx(Helmet_default.a, {
                script: [{
                    src: OneIdJs[oneIdEnv]
                }],
                link: this.getStyleAssets(this.pageName),
                style: [{
                    cssText: '\n                                body {\n                                    background: #edeef0;\n                                    font: normal 12px/18px helvetica, arial, sans-serif;\n                                    min-width: 100%;\n                                }\n                                @media screen and (max-width: 767px) {\n                                    #content.container {\n                                        width: 290px;\n                                    }\n                                }\n                            '
                }]
            }), Activate__jsx(MessagingContainer["a" /* default */], {}), Activate__jsx('div', {
                id: 'dtc-auth__container',
                className: 'dtc-auth__container ' + containerClass
            }, void 0, this.renderBrandingLogo(this.pageName), Activate__jsx('div', {
                id: 'dtc-auth__content',
                className: 'dtc-auth__content'
            }, void 0, content, renderHelpModule && Activate__jsx('div', {
                className: 'dtc-auth-help'
            }, void 0, Activate__jsx('div', {
                className: 'dtc-auth-help__content'
            }, void 0, Activate__jsx('img', {
                className: 'dtc-auth-help__espn-plus-logo',
                alt: 'ESPN+',
                src: 'https://secure.espncdn.com/espn360/images/affiliates/svg/ESPN_PLUS/ESPN-PLUS_CLR-POS.svg'
            }), Activate__jsx('p', {
                className: 'dtc-auth-help__purchased'
            }, void 0, 'Purchased on phone & need help?'), Activate__jsx('a', {
                href: HELP_LINK,
                target: HELP_LINK_TARGET
            }, void 0, 'Learn how to access your ESPN+ subscription on your TV.'), Activate__jsx('p', {
                className: 'dtc-auth-help__additional-support'
            }, void 0, 'For additional support:', Activate__jsx('a', {
                href: HELP_ADDITIONAL_SUPPORT_LINK,
                target: HELP_LINK_TARGET
            }, void 0, 'ESPN+ FAQ')))), Activate__jsx('div', {
                id: 'footer',
                className: 'dtc-auth__footer'
            }, void 0, Activate__jsx('a', {
                className: 'dtc-auth__footer__link',
                href: 'https://www.espn.com'
            }, void 0, 'ESPN.com'), Activate__jsx('a', {
                className: 'dtc-auth__footer__link',
                href: CUSTOMER_CARE_LINK,
                target: HELP_LINK_TARGET
            }, void 0, 'Customer Care')))));
        }
    }]);

    return ActivateComponent;
}(react["Component"]);

Activate_ActivateComponent.defaultProps = {
    providers: []
};

Activate_ActivateComponent.loadActions = [appActions["D" /* fetchExternalConfig */], function (_, query) {
    return Object(authenticationActions["Z" /* getProviders */])({ country: 'US', platform: query.device });
}];

var Activate_mapStateToProps = function mapStateToProps(state) {
    var _state$providerDialog = state.providerDialog;
    _state$providerDialog = _state$providerDialog === undefined ? {} : _state$providerDialog;
    var _state$providerDialog2 = _state$providerDialog.providers,
        providers = _state$providerDialog2 === undefined ? [] : _state$providerDialog2;


    return {
        providers: providers,
        app: Object(appSelector["j" /* default */])(state),
        oneIdEnv: Object(appSelector["y" /* oneIdEnvSelector */])(state),
        showHelpModule: Object(appSelector["F" /* showHelpModuleSelector */])(state),
        adobePassEnv: Object(appSelector["b" /* adobePassEnvSelector */])(state),
        oneId: Object(oneIdSelector["a" /* default */])(state)
    };
};

/* harmony default export */ var Activate = (Object(es["b" /* connect */])(Activate_mapStateToProps)(Activate_ActivateComponent));
// EXTERNAL MODULE: ./app/lib/format/dateFormat.js
var dateFormat = __webpack_require__(33);

// EXTERNAL MODULE: ./app/lib/util/canUseDOM.js
var canUseDOM = __webpack_require__(61);

// CONCATENATED MODULE: ./app/webapp/page/Feedback.js
var Feedback__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var Feedback__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Feedback__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Feedback__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Feedback__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Feedback__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Feedback__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable no-alert */













var styles = {
    container: {
        padding: 20,
        color: '#ddd',
        fontFamily: 'Arial',
        fontSize: 14
    },
    title: {
        display: 'block',
        marginBottom: 10,
        fontWeight: 'bold'
    },
    caption: {
        display: 'block',
        marginBottom: 20
    },
    alignRight: {
        textAlign: 'right'
    },
    requiredInput: {
        background: '#ffffcc',
        width: 290,
        height: 20,
        margin: 0,
        padding: 3,
        border: 'none'
    }
};

var Feedback_Feedback = function (_PureComponent) {
    Feedback__inherits(Feedback, _PureComponent);

    function Feedback(props) {
        Feedback__classCallCheck(this, Feedback);

        var _this = Feedback__possibleConstructorReturn(this, (Feedback.__proto__ || Object.getPrototypeOf(Feedback)).call(this, props));

        _this.state = {
            commentType: '',
            email: '',
            commentBody: '',
            platform: '',
            submitted: false
        };
        _this.onFormChange = _this.onFormChange.bind(_this);
        _this.onSubmit = _this.onSubmit.bind(_this);
        return _this;
    }

    Feedback__createClass(Feedback, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var dispatch = this.props.dispatch;

            dispatch(Object(oneIdActions["h" /* checkSWIDAuthentication */])());
            dispatch(Object(authenticationActions["S" /* createGetLocationFromUserDataAction */])());
        }
    }, {
        key: 'onFormChange',
        value: function onFormChange(event) {
            var state = event.target.getAttribute('data-state');
            this.setState(Feedback__defineProperty({}, state, event.target.value));
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit(event) {
            var _props = this.props,
                messages = _props.messages,
                formatMessage = _props.intl.formatMessage;

            var validationError = this.validationError;
            if (validationError) {
                event.preventDefault();
                var message = formatMessage(messages['feedback.error.' + validationError]);
                alert(message);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                commentType = _state.commentType,
                email = _state.email,
                commentBody = _state.commentBody,
                platform = _state.platform,
                submitted = _state.submitted;
            var _props2 = this.props,
                _props2$currentLocati = _props2.currentLocation,
                origin = _props2$currentLocati.origin,
                pathname = _props2$currentLocati.pathname,
                search = _props2$currentLocati.search,
                hash = _props2$currentLocati.hash,
                query = _props2$currentLocati.query,
                _props2$swid = _props2.swid,
                swid = _props2$swid === undefined ? '{}' : _props2$swid,
                _props2$userLocation = _props2.userLocation,
                userLocation = _props2$userLocation === undefined ? {} : _props2$userLocation,
                providers = _props2.providers,
                isDomestic = _props2.isDomestic,
                messages = _props2.messages,
                formatMessage = _props2.intl.formatMessage;
            var _userLocation$country = userLocation.country,
                country = _userLocation$country === undefined ? '' : _userLocation$country,
                _userLocation$city = userLocation.city,
                city = _userLocation$city === undefined ? '' : _userLocation$city,
                _userLocation$ip = userLocation.ip,
                ip = _userLocation$ip === undefined ? '' : _userLocation$ip;

            var inputs = [];
            if (canUseDOM["a" /* default */]) {
                var date = dateFormat["a" /* default */].getDateTimeString(new Date(), 'dateTime4', 'America/New_York');
                var affIP = 'invalid';
                var channel = 'N/A';
                var userAgent = navigator.userAgent;
                var comment = 'Comment type: ' + commentType + '\n            Email: ' + email + '\n            Date: ' + date + '\n            Feedback source: watchespn\n            JavaScript: on\n            Cookies: ' + (document.cookie.length > 0 ? 'on' : 'off') + '\n            Screen: ' + screen.width + 'x' + screen.height + '\n            IP: ' + ip + '\n            Affiliate ' + affIP + '\n            MVPD/Authentication:\n            Country: ' + country + '\n            City: ' + city + '\n            User agent: ' + userAgent + '\n            Platform: ' + platform + '\n            SWID: ' + swid + '\n\n            Comment: ' + commentBody;

                inputs = [Feedback__jsx('input', {
                    type: 'hidden',
                    name: 'orgid',
                    value: '00D4000000080H6'
                }), Feedback__jsx('input', {
                    type: 'hidden',
                    name: 'retURL',
                    value: '' + origin + pathname + search + (search ? '&' : '?') + 'submitted=true' + hash
                }), Feedback__jsx('input', {
                    id: '00N40000001cOWA',
                    name: '00N40000001cOWA',
                    type: 'hidden',
                    value: affIP,
                    maxLength: '100'
                }), Feedback__jsx('input', {
                    id: '00N40000002GQZZ',
                    name: '00N40000002GQZZ',
                    type: 'hidden',
                    value: channel,
                    maxLength: '30'
                }), Feedback__jsx('input', {
                    id: '00N40000001cOWK',
                    name: '00N40000001cOWK',
                    type: 'hidden',
                    value: userAgent,
                    maxLength: '100'
                }), Feedback__jsx('input', {
                    id: '00N40000001Tm8o',
                    name: '00N40000001Tm8o',
                    type: 'hidden',
                    value: 'Desktop WatchESPN'
                }), Feedback__jsx('input', {
                    id: '00N40000001thXQ',
                    name: '00N40000001thXQ',
                    type: 'hidden',
                    value: comment
                }), Feedback__jsx('input', {
                    id: '00N40000001vpue',
                    name: '00N40000001vpue',
                    type: 'hidden',
                    value: swid
                }), Feedback__jsx('input', {
                    id: 'type',
                    name: 'type',
                    type: 'hidden',
                    value: 'Desktop WatchESPN'
                }), Feedback__jsx('input', {
                    id: 'subject',
                    name: 'subject',
                    type: 'hidden',
                    value: 'WatchESPN Desktop Feedback'
                })];
            }

            var providerOptions = providers.map(function (_ref) {
                var name = _ref.name,
                    abbreviation = _ref.abbreviation;
                return Feedback__jsx('option', {
                    value: abbreviation
                }, void 0, name);
            });
            providerOptions.unshift(Feedback__jsx('option', {
                value: 'default'
            }, void 0, '----- ' + formatMessage(messages['feedback.provider.default']) + ' -----'));
            return Feedback__jsx('div', {
                style: styles.container
            }, void 0, Feedback__jsx(Helmet_default.a, {
                meta: [{ name: 'robots', content: 'noindex, nofollow' }],
                style: [{
                    cssText: '\n                            body {\n                                margin: 0;\n                                padding: 0;\n                                background: #000;\n                            }\n                        '
                }],
                script: isDomestic ? [{ innerHTML: '\n                            (function() {\n                                function onZopimLoad() {\n                                    if ($zopim) {\n                                        $zopim.livechat.window.onShow(function() {\n                                            $zopim.livechat.window.hide();\n                                            $zopim.livechat.window.openPopout();\n                                        });\n                                    }\n                                }\n\n                                window.$zopim || (function(d, s) {\n                                    var z = $zopim = function(c) {\n                                            z._.push(c)\n                                        },\n                                        $ = z.s = d.createElement(s),\n                                        e = d.getElementsByTagName(s)[0];\n                                    z.set = function(o) {\n                                        z.set._.push(o)\n                                    };\n                                    z._ = [];\n                                    z.set._ = [];\n                                    $.async = !0;\n                                    $.setAttribute("charset", "utf-8");\n                                    $.src = "//v2.zopim.com/?3X1YqOhMC21Mp5TuhBplWWY473rBk06l";\n                                    z.t = +new Date;\n                                    $.type = "text/javascript";\n                                    $.onload = onZopimLoad;\n                                    e.parentNode.insertBefore($, e)\n                                })(document, "script");\n                            })();\n                        ' }] : []
            }), submitted || query.submitted ? Feedback__jsx('div', {}, void 0, Feedback__jsx('span', {
                style: styles.caption
            }, void 0, formatMessage(messages['feedback.thankYou']))) : Feedback__jsx('div', {}, void 0, Feedback__jsx('span', {
                style: styles.title
            }, void 0, formatMessage(messages['feedback.title'])), Feedback__jsx('span', {
                style: styles.caption
            }, void 0, formatMessage(messages['feedback.caption'])), Feedback__jsx('form', {
                name: 'postFeedback',
                action: 'https://www.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8',
                method: 'post',
                onSubmit: this.onSubmit
            }, void 0, inputs, Feedback__jsx('table', {
                cellPadding: '4',
                cellSpacing: '0'
            }, void 0, Feedback__jsx('tbody', {}, void 0, Feedback__jsx('tr', {}, void 0, Feedback__jsx('td', {
                style: styles.alignRight
            }, void 0, formatMessage(messages['feedback.category']), ':'), Feedback__jsx('td', {}, void 0, react_default.a.createElement(
                'select',
                {
                    ref: function ref(select) {
                        _this2.categorySelect = select;
                    },
                    id: '00N400000034PSb',
                    name: '00N400000034PSb',
                    size: '1',
                    style: styles.requiredInput,
                    defaultValue: '',
                    'data-state': 'commentType',
                    onChange: this.onFormChange
                },
                Feedback__jsx('option', {
                    value: ''
                }, void 0, formatMessage(messages['feedback.category.select'])),
                Feedback__jsx('option', {
                    value: '0001'
                }, void 0, formatMessage(messages['feedback.category.userExperience'])),
                Feedback__jsx('option', {
                    value: '0002'
                }, void 0, formatMessage(messages['feedback.category.videoPerformance'])),
                Feedback__jsx('option', {
                    value: '0003'
                }, void 0, formatMessage(messages['feedback.category.programming'])),
                Feedback__jsx('option', {
                    value: '0004'
                }, void 0, formatMessage(messages['feedback.category.other']))
            ))), Feedback__jsx('tr', {}, void 0, Feedback__jsx('td', {
                style: styles.alignRight
            }, void 0, formatMessage(messages['feedback.email']), ':'), Feedback__jsx('td', {}, void 0, react_default.a.createElement('input', {
                ref: function ref(input) {
                    _this2.emailInput = input;
                },
                type: 'text',
                style: styles.requiredInput,
                id: 'email',
                name: 'email',
                size: '30',
                maxLength: '40',
                value: email,
                'data-state': 'email',
                onChange: this.onFormChange
            }))), Feedback__jsx('tr', {}, void 0, Feedback__jsx('td', {
                style: styles.alignRight
            }, void 0, formatMessage(messages['feedback.provider']), ':'), Feedback__jsx('td', {}, void 0, Feedback__jsx('select', {
                id: '00N40000002G61X',
                name: '00N40000002G61X',
                size: '1',
                defaultValue: 'default'
            }, void 0, providerOptions))), Feedback__jsx('tr', {}, void 0, Feedback__jsx('td', {
                style: styles.alignRight
            }, void 0, formatMessage(messages['feedback.platform']), ':'), Feedback__jsx('td', {}, void 0, Feedback__jsx('select', {
                size: '1',
                defaultValue: 'Desktop/laptop',
                'data-state': 'platform',
                onChange: this.onFormChange
            }, void 0, Feedback__jsx('option', {
                value: 'Desktop/laptop'
            }, void 0, formatMessage(messages['feedback.desktoplaptop'])), Feedback__jsx('option', {
                value: 'iPhone'
            }, void 0, formatMessage(messages['feedback.iphone'])), Feedback__jsx('option', {
                value: 'iPad'
            }, void 0, formatMessage(messages['feedback.ipad'])), Feedback__jsx('option', {
                value: 'Android Phone'
            }, void 0, formatMessage(messages['feedback.androidphone'])), Feedback__jsx('option', {
                value: 'Android Tablet'
            }, void 0, formatMessage(messages['feedback.androidtablet'])), Feedback__jsx('option', {
                value: 'Xbox One'
            }, void 0, formatMessage(messages['feedback.xbox'])), Feedback__jsx('option', {
                value: 'PlayStation'
            }, void 0, formatMessage(messages['feedback.playstation'])), Feedback__jsx('option', {
                value: 'Apple TV'
            }, void 0, formatMessage(messages['feedback.appletv'])), Feedback__jsx('option', {
                value: 'Android TV'
            }, void 0, formatMessage(messages['feedback.androidtv'])), Feedback__jsx('option', {
                value: 'Amazon FireTV'
            }, void 0, formatMessage(messages['feedback.amazonfiretv'])), Feedback__jsx('option', {
                value: 'Chromecast'
            }, void 0, formatMessage(messages['feedback.chromecast'])), Feedback__jsx('option', {
                value: 'Roku'
            }, void 0, formatMessage(messages['feedback.roku']))))), Feedback__jsx('tr', {}, void 0, Feedback__jsx('td', {
                style: Feedback__extends({}, styles.alignRight, { verticalAlign: 'top' })
            }, void 0, formatMessage(messages['feedback.comments']), ':'), Feedback__jsx('td', {}, void 0, react_default.a.createElement('textarea', {
                ref: function ref(input) {
                    _this2.commentText = input;
                },
                id: 'description',
                name: 'description',
                style: Feedback__extends({}, styles.requiredInput, { height: 60 }),
                cols: '28',
                rows: '3',
                wrap: 'virtual',
                value: commentBody,
                'data-state': 'commentBody',
                onChange: this.onFormChange
            }))), Feedback__jsx('tr', {}, void 0, Feedback__jsx('td', {}), Feedback__jsx('td', {}, void 0, Feedback__jsx('input', {
                type: 'submit',
                value: formatMessage(messages['feedback.send'])
            }))))))));
        }
    }, {
        key: 'validationError',
        get: function get() {
            if (!this.categorySelect.value) {
                return 'category';
            }
            if (!/^.+@.+\..+$/.test(this.emailInput.value)) {
                return 'email';
            }
            if (!this.commentText.value) {
                return 'comments';
            }
            return false;
        }
    }]);

    return Feedback;
}(react["PureComponent"]);

Feedback_Feedback.loadActions = [function () {
    return Object(authenticationActions["Z" /* getProviders */])();
}, function () {
    return Object(page_actions["y" /* setPageInfo */])('feedback', 'Feedback');
}];

var Feedback_mapStateToProps = function mapStateToProps(state) {
    var _state$oneId = state.oneId;
    _state$oneId = _state$oneId === undefined ? {} : _state$oneId;
    var swid = _state$oneId.swid;

    var userLocation = Object(authenticationSelectors["s" /* userLocationSelector */])(state);
    var _state$providerDialog = state.providerDialog;
    _state$providerDialog = _state$providerDialog === undefined ? {} : _state$providerDialog;
    var _state$providerDialog2 = _state$providerDialog.providers,
        providers = _state$providerDialog2 === undefined ? [] : _state$providerDialog2;

    var currentLocation = Object(appSelector["w" /* locationSelector */])(state);
    var isDomestic = Object(appSelector["s" /* isDomesticSelector */])(state);
    return {
        currentLocation: currentLocation,
        swid: swid,
        userLocation: userLocation,
        providers: providers,
        isDomestic: isDomestic
    };
};

/* harmony default export */ var page_Feedback = (Object(es["b" /* connect */])(Feedback_mapStateToProps)(Object(injectIntl["a" /* default */])(Feedback_Feedback)));
// EXTERNAL MODULE: ./node_modules/lodash/uniq.js
var uniq = __webpack_require__(93);
var uniq_default = /*#__PURE__*/__webpack_require__.n(uniq);

// EXTERNAL MODULE: ./app/webapp/lib/format/contentSubtitle.js
var contentSubtitle = __webpack_require__(352);

// CONCATENATED MODULE: ./app/lib/ui/openFeedbackPage.js
function openFeedbackPage() {
    window.open('http://broadband.espn.com/espn360/watchespn/feedback', 'feedback', 'status=no,height=450,width=525,scrollbars=yes');
}
// EXTERNAL MODULE: ./app/lib/util/getDeviceTypeFromUA.js
var getDeviceTypeFromUA = __webpack_require__(326);

// EXTERNAL MODULE: ./app/lib/util/isSafariBrowser.js
var isSafariBrowser = __webpack_require__(327);

// EXTERNAL MODULE: ./app/lib/auth/authStateKnown.js
var authStateKnown = __webpack_require__(77);

// EXTERNAL MODULE: ./app/lib/auth/canPlayStream.js
var canPlayStream = __webpack_require__(117);

// EXTERNAL MODULE: ./app/lib/auth/streamHasAuthType.js
var streamHasAuthType = __webpack_require__(45);

// EXTERNAL MODULE: ./app/lib/auth/streamHasDTCPackage.js
var streamHasDTCPackage = __webpack_require__(143);

// EXTERNAL MODULE: ./app/lib/auth/getContentId.js
var getContentId = __webpack_require__(60);

// EXTERNAL MODULE: ./app/lib/format/queryString.js
var queryString = __webpack_require__(18);

// EXTERNAL MODULE: ./app/lib/format/getMobileGameCastUrlForContent.js
var getMobileGameCastUrlForContent = __webpack_require__(296);

// EXTERNAL MODULE: ./app/lib/native-bridge/espnapp.js
var espnapp = __webpack_require__(354);

// CONCATENATED MODULE: ./app/webapp/page/Roadblock.js
var Roadblock__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Roadblock__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var Roadblock__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Roadblock__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Roadblock__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function Roadblock__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Roadblock__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Roadblock__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

































var Roadblock_OneIdJs = oneId["b" /* OneIdJs */];
var Roadblock_shellVersion = config_default.a.shellVersion,
    Roadblock_secureCdnHost = config_default.a.secureCdnHost,
    devStyles = config_default.a.devStyles;


var STYLE_HREF = Roadblock_secureCdnHost + '/redesign/' + Roadblock_shellVersion + '/css';
if (devStyles) {
    STYLE_HREF = 'http://localhost:8080/static/css';
}

var appStore = {
    ios: {
        link: 'https://itunes.apple.com/us/app/espn-live-sports-scores/id317469184?mt=8',
        iconHref: Roadblock_secureCdnHost + '/watchespn/images/roadblock/app_store_button.png'
    },
    android: {
        link: 'https://play.google.com/store/apps/details?id=com.espn.score_center&hl=en',
        iconHref: Roadblock_secureCdnHost + '/watchespn/images/roadblock/android_app_store_button.png'
    }
};

var classes = {
    container: 'watch__roadblock',
    logo: 'watch__roadblock-logo',
    pageTitle: 'watch__roadblock_page-title',
    roadblockText: 'watch__roadblock-text',
    mainFeature: 'watch__roadblock-main-feature',
    inner: 'watch__roadblock-inner',
    eventName: 'watch__roadblock-event-name',
    eventTitle: 'watch__roadblock-event-title',
    eventMeta: 'watch__roadblock-event-meta',
    main: 'watch__roadblock-main',
    fullSite: 'watch__roadblock-full-site',
    footer: 'watch__roadblock-footer',
    footerA: 'watch__roadblock-footer-a',
    submitButton: 'watch__roadblock-submit-btn',
    windowsphone: 'watch__roadblock-windowsphone'
};

var Roadblock_Roadblock = function (_Component) {
    Roadblock__inherits(Roadblock, _Component);

    function Roadblock(props) {
        Roadblock__classCallCheck(this, Roadblock);

        var _this = Roadblock__possibleConstructorReturn(this, (Roadblock.__proto__ || Object.getPrototypeOf(Roadblock)).call(this, props));

        _this.state = {
            initialModal: false
        };
        _this.handleLaunchClick = _this.handleLaunchClick.bind(_this);
        return _this;
    }

    Roadblock__createClass(Roadblock, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.setState({
                deviceType: Object(getDeviceTypeFromUA["a" /* default */])(),
                isSafari: Object(isSafariBrowser["a" /* default */])()
            });
        }
    }, {
        key: 'componentDidMount',
        value: function () {
            var _ref = Roadblock__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var dispatch;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                dispatch = this.props.dispatch;
                                _context.next = 3;
                                return dispatch(Object(oneIdActions["g" /* checkOneIDAuthentication */])());

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function componentDidMount() {
                return _ref.apply(this, arguments);
            }

            return componentDidMount;
        }()
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var initialModal = this.state.initialModal;

            if (!initialModal) {
                var actionTriggered = this.createDTCPaywallAction(nextProps);
                if (actionTriggered) {
                    this.setState({ initialModal: true });
                }
            }
        }
    }, {
        key: 'createDTCPaywallAction',
        value: function createDTCPaywallAction() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
            var dispatch = props.dispatch,
                hero = props.hero,
                oneIdInitialized = props.oneIdInitialized,
                userAuth = props.userAuth;
            var _hero$streams = hero.streams,
                streams = _hero$streams === undefined ? [] : _hero$streams;

            if (oneIdInitialized && (Object(authStateKnown["a" /* default */])(userAuth) || !userAuth.length)) {
                var requiredAuths = uniq_default()(streams.reduce(function (acc, _ref2) {
                    var authTypes = _ref2.authTypes;
                    return acc.concat(authTypes);
                }, []));
                if (requiredAuths.every(function (authType) {
                    return authType === enums["e" /* AuthTypes */].BAM;
                })) {
                    // DTC-only content
                    var stream = streams[0];
                    if (!Object(canPlayStream["a" /* default */])(stream, userAuth, false)) {
                        dispatch(Object(authenticationActions["M" /* createDTCPaywallAction */])({
                            containerId: app_constants["a" /* BAM_PAYWALL_IFRAME_ID */],
                            content: hero,
                            stream: stream
                        }));
                        return true;
                    }
                }
            }
            return false;
        }
    }, {
        key: 'handleLaunchClick',
        value: function handleLaunchClick() {
            var actionTriggered = this.createDTCPaywallAction();
            if (actionTriggered) {
                return;
            }

            var _props = this.props,
                hero = _props.hero,
                locationBeforeTransitions = _props.routing.locationBeforeTransitions;

            var _ref3 = locationBeforeTransitions || {},
                _ref3$query = _ref3.query,
                query = _ref3$query === undefined ? {} : _ref3$query;

            var imageHref = hero.imageHref,
                name = hero.name,
                _hero$streams2 = hero.streams,
                streams = _hero$streams2 === undefined ? [] : _hero$streams2,
                status = hero.status;

            var contentId = Object(getContentId["a" /* default */])(hero);

            var _ref4 = streams[0] || {},
                _ref4$source = _ref4.source;

            _ref4$source = _ref4$source === undefined ? {} : _ref4$source;
            var sourceId = _ref4$source.id,
                sourceType = _ref4$source.type,
                sourceName = _ref4$source.name;
            var isSafari = this.state.isSafari;

            var isBranchLinkInParams = false;
            var updateAppLink = false;
            var deviceType = this.state.deviceType;

            var params = {
                imageHref: imageHref,
                name: name,
                network: sourceName
            };
            if (query.deviceType) {
                deviceType = query.deviceType;
            }
            // See: https://espnjira.disney.com/browse/WEWEB-2071
            if (query._branch_match_id && query._branch_match_id !== '') {
                isBranchLinkInParams = true;
            }
            // See: https://espnjira.disney.com/browse/WEWEB-2500
            if (deviceType === 'android' && query['om-navmethod'] && query['om-navmethod'] === 'espn:ufc:gamehq') {
                updateAppLink = true;
            }

            // https://confluence.espn.com/pages/viewpage.action?title=ESPN+App+Deep+Linking&spaceKey=CD#ESPNAppDeepLinking-PlayWatchESPNVideos(LiveandReplay)
            if (sourceId && status !== enums["n" /* ContentStatus */].REPLAY && sourceType === enums["E" /* SourceType */].LINEAR) {
                // linear content (that is not instant turnaround) - play by channel so stale content doesn't error
                params = Roadblock__extends({}, params, {
                    playChannel: sourceId.toLowerCase()
                });
            } else if (contentId.eventId) {
                params = Roadblock__extends({}, params, {
                    playGameID: contentId.eventId
                });
            } else {
                // replays - play by cmsId
                params = Roadblock__extends({}, params, {
                    playID: contentId.id
                });
            }

            var isIosDevice = typeof deviceType === 'string' && deviceType === 'ios';
            var shouldUseProtocolOnly = isIosDevice && isSafari && isBranchLinkInParams;
            var url = Object(espnapp["a" /* getAppLink */])('showWatchStream', params, shouldUseProtocolOnly);
            if (updateAppLink) {
                url = 'android-app://com.espn.score_center/' + url;
            }

            window.location = url;
        }
    }, {
        key: 'renderRoadblockLinks',
        value: function renderRoadblockLinks() {
            var deviceType = this.state.deviceType;
            var locationBeforeTransitions = this.props.routing.locationBeforeTransitions;

            var _ref5 = locationBeforeTransitions || {},
                _ref5$query = _ref5.query,
                query = _ref5$query === undefined ? {} : _ref5$query;

            if (query.deviceType) {
                // override default detection
                deviceType = query.deviceType;
            }

            if (!deviceType) {
                return null;
            }

            var storeProps = appStore[deviceType];
            return storeProps ? Roadblock__jsx('div', {}, void 0, Roadblock__jsx('span', {
                className: 'strong ' + classes.roadblockText
            }, void 0, 'Download the ESPN App'), Roadblock__jsx('div', {}, void 0, Roadblock__jsx('p', {
                className: deviceType === 'windowsphone' ? classes.windowsphone : ''
            }, void 0, Roadblock__jsx('a', {
                className: 'storeLink',
                href: storeProps.link
            }, void 0, Roadblock__jsx('img', {
                width: '150',
                src: storeProps.iconHref,
                alt: 'App Store Badge'
            })))), Roadblock__jsx('span', {
                className: classes.roadblockText
            }, void 0, 'Already have the ESPN App?'), Roadblock__jsx('p', {}, void 0, Roadblock__jsx('a', {
                className: 'blue ' + classes.submitButton,
                onClick: this.handleLaunchClick
            }, void 0, 'Launch App'))) : Roadblock__jsx('span', {
                className: classes.roadblockText
            }, void 0, 'The ESPN App is not available on your device.');
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                hero = _props2.hero,
                _props2$playbackMeta = _props2.playbackMeta;
            _props2$playbackMeta = _props2$playbackMeta === undefined ? {} : _props2$playbackMeta;
            var tracking = _props2$playbackMeta.tracking,
                locationBeforeTransitions = _props2.routing.locationBeforeTransitions,
                oneIdEnvArg = _props2.oneIdEnv;

            var _ref6 = locationBeforeTransitions || {},
                _ref6$query = _ref6.query,
                query = _ref6$query === undefined ? {} : _ref6$query;

            var imageHref = hero.imageHref,
                name = hero.name,
                _hero$streams3 = hero.streams,
                streams = _hero$streams3 === undefined ? [] : _hero$streams3;

            var stream = streams[0] || {};
            var formattedSubtitle = Object(contentSubtitle["a" /* default */])(hero);
            var qs = Object(queryString["a" /* default */])(Roadblock__extends({}, query, Roadblock__defineProperty({}, enums["t" /* Flags */].FROM_ROADBLOCK, true)));
            var fullSiteLink = '/watch' + qs;
            var mobileGameCastUrl = Object(getMobileGameCastUrlForContent["a" /* default */])(hero, tracking);
            var oneIdEnv = oneIdEnvArg;
            if (query[enums["t" /* Flags */].DISNEY_ENV] === 'stg') {
                oneIdEnv = enums["x" /* OneIdEnv */].STAGING;
            }

            var logo = Roadblock__jsx('img', {
                alt: 'ESPN',
                width: '200',
                src: Roadblock_secureCdnHost + '/watchespn/images/roadblock/espn@2x.png'
            });
            if (Object(streamHasAuthType["a" /* default */])(stream, enums["e" /* AuthTypes */].BAM)) {
                if (Object(streamHasDTCPackage["a" /* default */])(stream, enums["s" /* Entitlements */].ESPN_PLUS_MLB)) {
                    logo = Roadblock__jsx('img', {
                        alt: 'MLB.TV',
                        width: '250',
                        height: '18',
                        src: Roadblock_secureCdnHost + '/watchespn/images/roadblock/mlb@2x.png'
                    });
                } else if (Object(streamHasDTCPackage["a" /* default */])(stream, enums["s" /* Entitlements */].ESPN_PLUS_NHL)) {
                    logo = Roadblock__jsx('img', {
                        alt: 'NHL.TV',
                        width: '250',
                        src: Roadblock_secureCdnHost + '/watchespn/images/roadblock/nhl@2x.png'
                    });
                } else {
                    logo = Roadblock__jsx('img', {
                        alt: 'ESPN+',
                        width: '200',
                        src: Roadblock_secureCdnHost + '/watchespn/images/roadblock/espn-plus@2x.png'
                    });
                }
            }

            return Roadblock__jsx('div', {
                className: classes.container
            }, void 0, Roadblock__jsx(Helmet_default.a, {
                meta: [{
                    name: 'viewport',
                    content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
                }],
                link: [{ rel: 'stylesheet', href: STYLE_HREF + '/page-shell.css' }, { rel: 'stylesheet', href: STYLE_HREF + '/watch-provider.css' }],
                style: [{
                    cssText: '\n                            body {\n                                margin: 0;\n                                background: #fff !important;\n                                font: normal 12px/18px BentonSans, helvetica, arial, sans-serif;\n                                min-width: 100%;\n                            }\n                            #' + app_constants["a" /* BAM_PAYWALL_IFRAME_ID */] + ' iframe {\n                                width: 100%;\n                                height: 100%;\n                                border: none;\n                            }\n                            .' + classes.eventName + ' {\n                                padding-left: 5px;\n                            }\n                            .' + classes.logo + ' {\n                                text-align: center;\n                            }\n                            .' + classes.logo + ' img { margin: 20px auto; }\n                            .' + classes.pageTitle + ' {\n                                margin-bottom: 20px;\n                            }\n                            .' + classes.roadblockText + ' {\n                                display: block;\n                                color: #262626 !important;\n                                font-size: 16px;\n                            }\n                            .' + classes.container + ' {\n                                width: 295px !important;\n                                background: #fff !important;\n                                margin: 0 auto;\n                                border-radius: 12px;\n                                text-align: center;\n                                -moz-border-radius: 0 !important;\n                                -webkit-border-radius: 0 !important;\n                                box-shadow: none !important;\n                                -webkit-box-shadow: none !important;\n                            }\n                            .' + classes.submitButton + ' {\n                                display: block;\n                                position: relative;\n                                width: 80% !important;\n                                margin: 0 auto;\n                                background: #2d66eb;\n                                border: 1px solid white;\n                                border-radius: 40px;\n                                box-shadow: none;\n                                line-height: 45px;\n                                color: #eee;\n                                cursor: pointer;\n                                text-align: center;\n                                text-transform: none;\n                                text-shadow: none;\n                                text-decoration: none;\n                                font-family: BentonSansMedium, helvetica, sans-serif;\n                                font-size: 18px;\n                                font-weight: 600;\n                                height: 45px;\n                            }\n\n                            .' + classes.submitButton + '.blue {\n                                border: 1px solid #2D66EB !important;\n                                background: #fff;\n                                color: #2D66EB;\n                            }\n                            .' + classes.submitButton + ':hover {text-decoration: none !important;}\n\n                            .' + classes.main + ' a {\n                                cursor: pointer;\n                            }\n                            .' + classes.main + ' a:hover {text-decoration: underline;}\n\n                            .' + classes.main + ' p {\n                                text-align: center;\n                                margin: 10px 0 25px 0;\n                            }\n                            .' + classes.main + ' .' + classes.fullSite + ' {\n                                color: #2d66eb;\n                                font-size: 14px;\n                                font-family: BentonSans, helvetica, arial, sans-serif;\n                                text-decoration: none;\n                            }\n                            .' + classes.footer + ' {\n                                display: flex;\n                                justify-content: space-between;\n                            }\n\n                            .' + classes.footer + ' a {\n                                color: #0066CC !important;\n                                flex-grow: 1;\n                                padding: 4px 0;\n                            }\n\n                            .' + classes.footer + ' a:first-child{\n                                font-weight: 600;\n                            }\n\n                            .' + classes.footer + ' a + a{\n                                border-left: 1px #dcdddf solid;\n                            }\n\n                            .' + classes.mainFeature + ' {\n                                position: relative;\n                                overflow: visible;\n                                width: 100%;\n                                left: 0;\n                                margin-bottom: 30px;\n                            }\n\n                            .' + classes.mainFeature + ' figure {\n                                border: none !important;\n                            }\n\n                            .' + classes.mainFeature + ' figure img{\n                                max-width: 100%;\n                                border-radius: 10px;\n                                box-shadow: 0 4px 24px rgba(0,0,0,0.16);\n                                margin-bottom: 12px;\n                                overflow: hidden;\n                            }\n\n                            .' + classes.mainFeature + ' figure figcaption {\n                                bottom: auto;\n                                display: block;\n                                font-size: 12px;\n                                left: auto;\n                                line-height: 1.2;\n                                position: relative;\n                                text-align: left;\n                            }\n\n                            .' + classes.eventTitle + ' {\n                                color: #151617;\n                                font-weight: 600;\n                            }\n                            .' + classes.eventMeta + ' {\n                                border-bottom: 1px #DCDDDF dotted;\n                                color: #a5a6a7;\n                                margin-top: 4px;\n                                padding-bottom: 12px;\n                            }\n                            .' + classes.eventMeta + ' span + span{\n                                margin-left: 4px;\n                            }\n                            .' + classes.eventMeta + ' span + span:before{\n                                color: #cbccce;\n                                content: \'\u2022\';\n                                margin-right: 4px;\n                            }\n\n\n                            .' + classes.inner + ' {\n                                width: 100%;\n                                display: table;\n                                text-align: left;\n                                background: rgba(0, 0, 0, 0.6) no-repeat;\n                                min-height: 25px;\n                            }\n                            .' + classes.inner + ' span {\n                                display: table-cell;\n                                vertical-align: middle;\n                                margin-left: 10px;\n                                padding: 10px;\n                                font-size: 1.2em;\n                                line-height: 1.2em;\n                                color: #fff;\n                            }\n                            .' + classes.windowsphone + ' {\n                                width: 200px;\n                                height: 63px;\n                                margin: 10px auto 25px auto !important;\n                                padding-top: 10px;\n                                border: solid 1pt #515151;\n                                background: #000;\n                            }\n\n                            .strong{\n                                font-weight: 600;\n                            }\n\n                            .lightbox-container .lightbox-watch.watch-provider-modal.lightbox-paywall .btn-close {\n                                padding: 0;\n                            }\n                            .lightbox-container .lightbox-watch.watch-provider-modal.lightbox-paywall .btn-close:before {\n                                color: #fff;\n                                line-height: 36px;\n                            }\n                        '
                }],
                script: [{
                    src: Roadblock_OneIdJs[oneIdEnv]
                }]
            }), Roadblock__jsx('div', {
                className: classes.logo
            }, void 0, logo), Roadblock__jsx('header', {
                className: 'strong ' + classes.roadblockText + ' ' + classes.pageTitle
            }, void 0, 'To stream this event on your phone,', Roadblock__jsx('br', {}), 'you need the ESPN App.'), Roadblock__jsx('section', {
                className: classes.mainFeature
            }, void 0, Roadblock__jsx('figure', {}, void 0, Roadblock__jsx('img', {
                src: imageHref,
                alt: name
            }), Roadblock__jsx('figcaption', {}, void 0, Roadblock__jsx('div', {
                className: classes.eventTitle
            }, void 0, name), Roadblock__jsx('div', {
                className: classes.eventMeta
            }, void 0, Roadblock__jsx('span', {}, void 0, formattedSubtitle))))), Roadblock__jsx('section', {
                className: 'section ' + classes.main
            }, void 0, this.renderRoadblockLinks(), mobileGameCastUrl ? Roadblock__jsx('p', {}, void 0, Roadblock__jsx('a', {
                className: classes.fullSite,
                href: mobileGameCastUrl
            }, void 0, 'Follow on GameCast \xBB')) : null, Roadblock__jsx('p', {
                style: { display: 'none' }
            }, void 0, Roadblock__jsx('a', {
                className: classes.fullSite,
                href: fullSiteLink
            }, void 0, 'View Full Site'))), Roadblock__jsx('div', {
                className: classes.footer
            }, void 0, Roadblock__jsx('a', {
                href: 'http://www.espn.com'
            }, void 0, 'ESPN.com'), Roadblock__jsx('a', {
                className: classes.footerA,
                href: '/watch/schedule'
            }, void 0, 'Schedule'), Roadblock__jsx('a', {
                className: classes.footerA,
                href: '//support.espn.com/hc/en-us/categories/115000435812-Streaming-on-ESPN',
                rel: 'nofollow'
            }, void 0, 'FAQs'), Roadblock__jsx('a', {
                className: classes.footerA,
                onClick: openFeedbackPage
            }, void 0, 'Customer Care')), Roadblock__jsx(MessagingContainer["a" /* default */], {}));
        }
    }]);

    return Roadblock;
}(react["Component"]);

Roadblock_Roadblock.loadActions = [appActions["D" /* fetchExternalConfig */], function (pathParams, query) {
    return function (dispatch) {
        var id = 'roadblock';
        var name = 'Roadblock';
        dispatch(Object(authenticationActions["K" /* createCompleteCheckIpAuthenticationAction */])(false));
        dispatch(Object(authenticationActions["I" /* createCompleteCheckAuthenticationAction */])(false));
        return dispatch(Object(page_actions["A" /* singleEventPage */])(id, name, query));
    };
}];

var Roadblock_mapStateToProps = function mapStateToProps(state) {
    return {
        hero: Object(heroSelector["a" /* default */])(state),
        playbackMeta: Object(appSelector["A" /* playbackMetaSelector */])(state),
        routing: Object(routingSelector["a" /* default */])(state),
        userAuth: Object(authenticationSelectors["r" /* userAuthSelector */])(state),
        oneIdEnv: Object(appSelector["y" /* oneIdEnvSelector */])(state),
        oneIdInitialized: Object(oneIdSelector["e" /* oneIdInitializedSelector */])(state)
    };
};

/* harmony default export */ var page_Roadblock = (Object(es["b" /* connect */])(Roadblock_mapStateToProps)(Roadblock_Roadblock));
// CONCATENATED MODULE: ./app/webapp/page/UnsupportedPage.js
var UnsupportedPage__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var UnsupportedPage__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function UnsupportedPage__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function UnsupportedPage__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function UnsupportedPage__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var UnsupportedPage_shellVersion = config_default.a.shellVersion,
    UnsupportedPage_secureCdnHost = config_default.a.secureCdnHost,
    UnsupportedPage_devStyles = config_default.a.devStyles;


var UnsupportedPage_STYLE_HREF = UnsupportedPage_secureCdnHost + '/redesign/' + UnsupportedPage_shellVersion + '/css';
if (UnsupportedPage_devStyles) {
    UnsupportedPage_STYLE_HREF = 'http://localhost:8080/static/css';
}

var UnsupportedPage_classes = {
    container: 'watch__roadblock',
    logo: 'watch__roadblock-logo',
    pageTitle: 'watch__roadblock_page-title',
    roadblockText: 'watch__roadblock-text',
    main: 'watch__roadblock-main',
    fullSite: 'watch__roadblock-full-site',
    footer: 'watch__roadblock-footer',
    footerA: 'watch__roadblock-footer-a'
};

var UnsupportedPage_UnsupportedPage = function (_PureComponent) {
    UnsupportedPage__inherits(UnsupportedPage, _PureComponent);

    function UnsupportedPage(props) {
        UnsupportedPage__classCallCheck(this, UnsupportedPage);

        var _this = UnsupportedPage__possibleConstructorReturn(this, (UnsupportedPage.__proto__ || Object.getPrototypeOf(UnsupportedPage)).call(this, props));

        _this.state = {};
        return _this;
    }

    UnsupportedPage__createClass(UnsupportedPage, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                messages = _props.messages,
                formatMessage = _props.intl.formatMessage;


            var logo = UnsupportedPage__jsx('img', {
                alt: 'ESPN',
                width: '200',
                src: UnsupportedPage_secureCdnHost + '/watchespn/images/roadblock/espn@2x.png'
            });

            return UnsupportedPage__jsx('div', {
                className: UnsupportedPage_classes.container
            }, void 0, UnsupportedPage__jsx(Helmet_default.a, {
                meta: [{
                    name: 'viewport',
                    content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
                }],
                link: [{ rel: 'stylesheet', href: UnsupportedPage_STYLE_HREF + '/page-shell.css' }, { rel: 'stylesheet', href: UnsupportedPage_STYLE_HREF + '/watch-provider.css' }],
                style: [{
                    cssText: '\n                            body {\n                                margin: 0;\n                                background: #fff !important;\n                                font: normal 12px/18px BentonSans, helvetica, arial, sans-serif;\n                                min-width: 100%;\n                            }\n                            .' + UnsupportedPage_classes.logo + ' {\n                                text-align: center;\n                            }\n                            .' + UnsupportedPage_classes.logo + ' img { margin: 20px auto; }\n                            .' + UnsupportedPage_classes.pageTitle + ' {\n                                margin-bottom: 20px;\n                            }\n                            .' + UnsupportedPage_classes.roadblockText + ' {\n                                display: block;\n                                color: #262626 !important;\n                                font-size: 16px;\n                            }\n                            .' + UnsupportedPage_classes.container + ' {\n                                width: 295px !important;\n                                background: #fff !important;\n                                margin: 0 auto;\n                                border-radius: 12px;\n                                text-align: center;\n                                -moz-border-radius: 0 !important;\n                                -webkit-border-radius: 0 !important;\n                                box-shadow: none !important;\n                                -webkit-box-shadow: none !important;\n                            }\n                            .' + UnsupportedPage_classes.main + ' a {\n                                cursor: pointer;\n                            }\n                            .' + UnsupportedPage_classes.main + ' a:hover {text-decoration: underline;}\n\n                            .' + UnsupportedPage_classes.main + ' p {\n                                text-align: center;\n                                margin: 10px 0 25px 0;\n                            }\n                            .' + UnsupportedPage_classes.main + ' .' + UnsupportedPage_classes.fullSite + ' {\n                                color: #2d66eb;\n                                font-size: 14px;\n                                font-family: BentonSans, helvetica, arial, sans-serif;\n                                text-decoration: none;\n                            }\n                            .' + UnsupportedPage_classes.footer + ' {\n                                display: flex;\n                                justify-content: space-between;\n                            }\n                            .' + UnsupportedPage_classes.footer + ' a {\n                                color: #0066CC !important;\n                                flex-grow: 1;\n                                padding: 4px 0;\n                            }\n                            .' + UnsupportedPage_classes.footer + ' a:first-child{\n                                font-weight: 600;\n                            }\n                            .' + UnsupportedPage_classes.footer + ' a + a{\n                                border-left: 1px #dcdddf solid;\n                            }\n                            .strong{\n                                font-weight: 600;\n                            }\n                        '
                }]
            }), UnsupportedPage__jsx('div', {
                className: UnsupportedPage_classes.logo
            }, void 0, logo), UnsupportedPage__jsx('header', {
                className: 'strong ' + UnsupportedPage_classes.roadblockText + ' ' + UnsupportedPage_classes.pageTitle
            }, void 0, formatMessage(messages['unsupported.error.message'])), UnsupportedPage__jsx('div', {
                className: UnsupportedPage_classes.footer
            }, void 0, UnsupportedPage__jsx('a', {
                href: 'http://www.espn.com'
            }, void 0, 'ESPN.com'), UnsupportedPage__jsx('a', {
                className: UnsupportedPage_classes.footerA,
                href: '/watch/schedule'
            }, void 0, 'Schedule'), UnsupportedPage__jsx('a', {
                className: UnsupportedPage_classes.footerA,
                href: '//support.espn.com/en_US/WatchESPN',
                rel: 'nofollow'
            }, void 0, 'FAQs'), UnsupportedPage__jsx('a', {
                className: UnsupportedPage_classes.footerA,
                onClick: openFeedbackPage
            }, void 0, 'Customer Care')));
        }
    }]);

    return UnsupportedPage;
}(react["PureComponent"]);

UnsupportedPage_UnsupportedPage.loadActions = [function () {
    return Object(page_actions["y" /* setPageInfo */])('unsupported', 'Unsupported');
}];

/* harmony default export */ var page_UnsupportedPage = (Object(injectIntl["a" /* default */])(UnsupportedPage_UnsupportedPage));
// EXTERNAL MODULE: ./node_modules/reselect/lib/index.js
var reselect_lib = __webpack_require__(9);
var reselect_lib_default = /*#__PURE__*/__webpack_require__.n(reselect_lib);

// CONCATENATED MODULE: ./app/common/selectors/carouselSelector.js



/* harmony default export */ var carouselSelector = (Object(reselect_lib["createSelector"])(pageSelector["c" /* default */], function (_ref) {
  var _ref$carouselBucket = _ref.carouselBucket,
      carouselBucket = _ref$carouselBucket === undefined ? {} : _ref$carouselBucket;
  return carouselBucket;
}));
// EXTERNAL MODULE: ./app/common/selectors/flagsSelector.js
var flagsSelector = __webpack_require__(47);

// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var react_slick_lib = __webpack_require__(766);
var react_slick_lib_default = /*#__PURE__*/__webpack_require__.n(react_slick_lib);

// CONCATENATED MODULE: ./app/common/page/carousel/NextNavButton.js
var NextNavButton__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var NextNavButton = function NextNavButton(_ref) {
    var key = _ref.key,
        style = _ref.style,
        onClick = _ref.onClick;
    return NextNavButton__jsx("a", {
        className: "dtc-watch__carouselNext icon-font-before icon-caret-right-solid-before",
        style: style,
        onClick: onClick
    }, key);
};

/* harmony default export */ var carousel_NextNavButton = (NextNavButton);
// CONCATENATED MODULE: ./app/common/page/carousel/PrevNavButton.js
var PrevNavButton__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var PrevNavButton = function PrevNavButton(_ref) {
    var key = _ref.key,
        style = _ref.style,
        onClick = _ref.onClick;
    return PrevNavButton__jsx("a", {
        className: "dtc-watch__carouselPrev icon-font-before icon-caret-left-solid-before",
        style: style,
        onClick: onClick
    }, key);
};

/* harmony default export */ var carousel_PrevNavButton = (PrevNavButton);
// CONCATENATED MODULE: ./app/common/page/carousel/Carousel.js
var Carousel__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Carousel__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Carousel__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Carousel__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Carousel__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Carousel_Carousel = function (_PureComponent) {
    Carousel__inherits(Carousel, _PureComponent);

    function Carousel(props) {
        Carousel__classCallCheck(this, Carousel);

        var _this = Carousel__possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, props));

        _this.state = {
            initialized: false
        };
        _this.onClick = _this.onClick.bind(_this);
        return _this;
    }

    Carousel__createClass(Carousel, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setInitialized();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.setInitialized();
        }
    }, {
        key: 'onClick',
        value: function onClick(event) {
            if (event) {
                event.preventDefault();
            }
            var _props = this.props,
                contents = _props.contents,
                onClick = _props.onClick;

            var contentId = event.currentTarget.getAttribute('data-id');
            var content = contents.filter(function (_ref) {
                var id = _ref.id;
                return id === contentId;
            })[0];
            if (onClick) {
                onClick(content);
            }
        }
    }, {
        key: 'setInitialized',
        value: function setInitialized() {
            if (!this.sliderContainer) {
                return;
            }
            this.sliderContainer.classList.remove('carousel-loading');
            // a little hack to trigger `update` function on `react-slick` to calculate `sliderWidth`
            // right after the carousel gets visible
            if (!this.state.initialized) {
                this.setState({ // eslint-disable-line react/no-did-mount-set-state
                    initialized: true
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var contents = this.props.contents;

            if (!contents.length) {
                return null;
            }
            var isSingleItem = contents.length === 1;
            var settings = {
                autoplay: true,
                autoplaySpeed: 6000,
                pauseOnFocus: true,
                pauseOnHover: true,
                speed: 400,
                swipe: true,
                pauseOnDotsHover: true,
                arrows: !isSingleItem,
                dots: !isSingleItem,
                className: classnames_default()('dtc-watch__carousel', { 'dtc-watch__carousel--single': isSingleItem }),
                dotsClass: 'dtc_carousel__dots',
                prevArrow: Carousel__jsx(carousel_PrevNavButton, {}),
                nextArrow: Carousel__jsx(carousel_NextNavButton, {}),
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        arrows: false
                    }
                }]
            };

            var items = contents.map(function (_ref2) {
                var id = _ref2.id,
                    name = _ref2.name,
                    imageHref = _ref2.imageHref;
                return Carousel__jsx('div', {
                    className: 'dtc-watch__carousel__item'
                }, imageHref, Carousel__jsx('a', {
                    'data-id': id,
                    onClick: _this2.onClick
                }, void 0, Carousel__jsx('img', {
                    src: imageHref,
                    alt: name
                })));
            });

            return react_default.a.createElement(
                'div',
                {
                    ref: function ref(ele) {
                        _this2.sliderContainer = ele;
                    },
                    className: 'dtc-watch__carousel--container carousel-loading'
                },
                react_default.a.createElement(
                    react_slick_lib_default.a,
                    settings,
                    items
                )
            );
        }
    }]);

    return Carousel;
}(react["PureComponent"]);

Carousel_Carousel.defaultProps = {
    contents: []
};

/* harmony default export */ var carousel_Carousel = (Carousel_Carousel);
// EXTERNAL MODULE: ./app/lib/format/convertQueryStringToObject.js
var convertQueryStringToObject = __webpack_require__(278);

// CONCATENATED MODULE: ./app/common/page/Originals.js
var Originals__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Originals__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var Originals__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Originals__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Originals__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Originals__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var Originals_Originals = function (_PureComponent) {
    Originals__inherits(Originals, _PureComponent);

    function Originals(props) {
        Originals__classCallCheck(this, Originals);

        var _this = Originals__possibleConstructorReturn(this, (Originals.__proto__ || Object.getPrototypeOf(Originals)).call(this, props));

        _this.onClick = _this.onClick.bind(_this);
        return _this;
    }

    Originals__createClass(Originals, [{
        key: 'onClick',
        value: function onClick() {
            var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var _content$links = content.links;
            _content$links = _content$links === undefined ? {} : _content$links;
            var _content$links$web = _content$links.web,
                web = _content$links$web === undefined ? '' : _content$links$web;

            var result = /https?:\/\/[^\/]+\/watch([^\?]+)(.*)$/.exec(web);
            if (!result || !result[1]) {
                return;
            }
            var pathname = result[1];
            var qs = result[2];
            if (qs) {
                qs = Object(convertQueryStringToObject["a" /* default */])(qs.substr(1));
            }
            var _props = this.props,
                flags = _props.flags,
                router = _props.router;


            var query = Originals__extends({}, qs, flags);

            router.push({
                pathname: pathname,
                query: query
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props$carousel = this.props.carousel;
            _props$carousel = _props$carousel === undefined ? {} : _props$carousel;
            var contents = _props$carousel.contents;

            var bannerAd = [Originals__jsx(BannerAd["a" /* default */], {}, 'banner_ad')];
            return Originals__jsx(MainContainer["a" /* default */], {
                className: 'watch-home',
                pre: bannerAd
            }, void 0, Originals__jsx('div', {
                className: 'layout-full layout-full--watch'
            }, void 0, Originals__jsx('section', {
                className: 'col-a'
            }, void 0, Originals__jsx(carousel_Carousel, {
                contents: contents,
                onClick: this.onClick
            }), Originals__jsx(BucketListContainer["a" /* default */], {
                pageType: enums["y" /* PageType */].ORIGINALS
            }, 'bucket_list_container'))));
        }
    }]);

    return Originals;
}(react["PureComponent"]);

Originals_Originals.loadActions = [function (params, query, lang) {
    return Object(page_actions["o" /* createFetchPageAction */])('originals', params, query, lang);
}];

var Originals_mapStateToProps = function mapStateToProps(state) {
    return {
        carousel: carouselSelector(state),
        flags: Object(flagsSelector["a" /* persistentFlagsSelector */])(state)
    };
};

/* harmony default export */ var page_Originals = (Object(lib["withRouter"])(Object(es["b" /* connect */])(Originals_mapStateToProps)(Originals_Originals)));
// CONCATENATED MODULE: ./app/common/page/hero/SuperHero/index.js
var SuperHero__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();








var SuperHero_SuperHero = function SuperHero(_ref) {
    var name = _ref.name,
        description = _ref.description,
        director = _ref.director,
        image = _ref.image,
        logoImage = _ref.logoImage,
        subtitle = _ref.subtitle,
        content = _ref.content,
        clickHandlerArg = _ref.clickHandler;

    // TODO: DTC - Temp solution. Fields shouldn't come without escaped values from the PageAPI
    var heroEvent = subtitle ? subtitle.replace(/\\u2022/g, '•') : '';
    var clickHandler = !Object(isEmpty["a" /* default */])(content) && clickHandlerArg;
    var playButtonClasses = classnames_default()('button-play', 'button-play--video', {
        'button-play--live': !Object(isEmpty["a" /* default */])(content) && content.status === enums["n" /* ContentStatus */].LIVE
    });
    return SuperHero__jsx('article', {
        className: 'hero--super hero--dtc'
    }, void 0, SuperHero__jsx('figure', {
        className: 'hero_wrapper'
    }, void 0, clickHandler ? SuperHero__jsx('a', {
        className: 'col-a',
        onClick: clickHandler
    }, void 0, SuperHero__jsx('picture', {}, void 0, SuperHero__jsx('img', {
        className: 'hero_img',
        src: image,
        alt: name
    })), SuperHero__jsx('div', {
        className: playButtonClasses
    })) : SuperHero__jsx('span', {
        className: 'col-a'
    }, void 0, SuperHero__jsx('picture', {}, void 0, SuperHero__jsx('img', {
        className: 'hero_img',
        src: image,
        alt: name
    })))), SuperHero__jsx('figcaption', {
        className: 'dtc_hero__detail'
    }, void 0, logoImage && SuperHero__jsx('div', {
        className: 'dtc_hero__logo'
    }, void 0, SuperHero__jsx('img', {
        className: 'dtc_hero__logo__img',
        src: logoImage,
        alt: name
    })), SuperHero__jsx('div', {
        className: 'dtc_hero__meta'
    }, void 0, SuperHero__jsx('div', {
        className: 'dtc_hero__truncate'
    }, void 0, SuperHero__jsx('span', {
        className: 'dtc_hero__event'
    }, void 0, heroEvent))), SuperHero__jsx('div', {
        className: 'dtc_hero__title'
    }, void 0, name), SuperHero__jsx('div', {
        className: 'dtc_hero__description'
    }, void 0, description), SuperHero__jsx('div', {
        className: 'dtc_hero__author'
    }, void 0, director)));
};

/* harmony default export */ var hero_SuperHero = (SuperHero_SuperHero);
// EXTERNAL MODULE: ./app/webapp/common/playable.js + 2 modules
var playable = __webpack_require__(64);

// CONCATENATED MODULE: ./app/common/page/Catalog.js
var Catalog__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }














var PlayableSuperHero = Object(playable["a" /* default */])(hero_SuperHero);

var Catalog_Catalog = function Catalog(_ref) {
    var page = _ref.page,
        hero = _ref.hero;
    var _page$header = page.header;
    _page$header = _page$header === undefined ? {} : _page$header;
    var _page$header$name = _page$header.name,
        name = _page$header$name === undefined ? '' : _page$header$name,
        _page$header$descript = _page$header.description,
        description = _page$header$descript === undefined ? '' : _page$header$descript,
        _page$header$subtitle = _page$header.subtitle,
        subtitle = _page$header$subtitle === undefined ? '' : _page$header$subtitle,
        _page$header$subtitle2 = _page$header.subtitleTwo,
        subtitleTwo = _page$header$subtitle2 === undefined ? '' : _page$header$subtitle2,
        _page$header$backgrou = _page$header.backgroundImage,
        backgroundImage = _page$header$backgrou === undefined ? {} : _page$header$backgrou,
        _page$header$image = _page$header.image,
        image = _page$header$image === undefined ? {} : _page$header$image,
        _page$header$logoImag = _page$header.logoImage,
        logoImage = _page$header$logoImag === undefined ? {} : _page$header$logoImag,
        _page$buckets = page.buckets,
        buckets = _page$buckets === undefined ? [] : _page$buckets;

    var bannerAd = null; // [<BannerAd key="banner_ad" />];
    var bucket = buckets[0] || {};
    var bucketId = bucket.metadata && bucket.metadata.bucketId || bucket.id;
    var bucketName = bucket.name;
    var superHero = !Object(isEmpty["a" /* default */])(hero) && hero.streams && hero.streams.length ? Catalog__jsx(PlayableSuperHero, {
        name: name,
        description: description,
        subtitle: subtitle,
        director: subtitleTwo,
        image: backgroundImage.href,
        content: hero,
        bucketId: bucketId,
        bucketName: bucketName
    }) : Catalog__jsx(hero_SuperHero, {
        name: name,
        description: description,
        subtitle: subtitle,
        director: subtitleTwo,
        image: backgroundImage.href,
        icon: image.href,
        logoImage: logoImage.href
    });
    return Catalog__jsx(MainContainer["a" /* default */], {
        className: 'watch-home',
        pre: bannerAd
    }, void 0, Catalog__jsx('div', {
        className: 'layout-full layout-full--watch'
    }, void 0, Catalog__jsx('section', {
        className: 'col-a'
    }, void 0, superHero, Catalog__jsx(BucketListContainer["a" /* default */], {
        renderHeroInBucket: true,
        hideHeaderLink: true,
        pageType: enums["y" /* PageType */].CATALOG
    }, 'bucket_list_container'))));
};

var Catalog_mapStateToProps = function mapStateToProps(state) {
    return {
        page: Object(pageSelector["c" /* default */])(state),
        hero: Object(heroSelector["a" /* default */])(state)
    };
};

Catalog_Catalog.loadActions = [function (params, query, lang) {
    var pageName = params.pageName,
        restOfParams = _objectWithoutProperties(params, ['pageName']);

    return Object(page_actions["o" /* createFetchPageAction */])(pageName, restOfParams, query, lang);
}];

/* harmony default export */ var page_Catalog = (Object(es["b" /* connect */])(Catalog_mapStateToProps)(Catalog_Catalog));
// EXTERNAL MODULE: ./app/webapp/page/SyndicatedPlayerPage.js
var SyndicatedPlayerPage = __webpack_require__(782);

// EXTERNAL MODULE: ./app/webapp/page/SyndicatedPlayerExample.js
var SyndicatedPlayerExample = __webpack_require__(789);

// EXTERNAL MODULE: ./app/common/selectors/providerSelector.js
var providerSelector = __webpack_require__(53);

// EXTERNAL MODULE: ./app/common/LinkWithFlags.js
var LinkWithFlags = __webpack_require__(147);

// CONCATENATED MODULE: ./app/webapp/page/AffiliatePageExample.js
var AffiliatePageExample__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var AffiliatePageExample__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function AffiliatePageExample__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AffiliatePageExample__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function AffiliatePageExample__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var AffiliatePageExample_shellVersion = config_default.a.shellVersion,
    cdnHost = config_default.a.cdnHost,
    AffiliatePageExample_devStyles = config_default.a.devStyles;


var BASE_HREF = cdnHost + '/redesign/' + AffiliatePageExample_shellVersion;
var AffiliatePageExample_STYLE_HREF = BASE_HREF + '/css';
if (AffiliatePageExample_devStyles) {
    AffiliatePageExample_STYLE_HREF = 'http://localhost:8080/static/css';
}

var containerStyle = {
    padding: 20
};

var DEF_PROVIDER_VALUE = 'default';

var AffiliatePageExample_AffiliatePageExample = function (_PureComponent) {
    AffiliatePageExample__inherits(AffiliatePageExample, _PureComponent);

    function AffiliatePageExample(props) {
        AffiliatePageExample__classCallCheck(this, AffiliatePageExample);

        var _this = AffiliatePageExample__possibleConstructorReturn(this, (AffiliatePageExample.__proto__ || Object.getPrototypeOf(AffiliatePageExample)).call(this, props));

        _this.state = {
            mvpd: DEF_PROVIDER_VALUE,
            network: ''
        };
        _this.onProviderChange = _this.onProviderChange.bind(_this);
        _this.onNetworkChange = _this.onNetworkChange.bind(_this);
        _this.onLinkClick = _this.onLinkClick.bind(_this);
        _this.selectByNetwork = _this.selectByNetwork.bind(_this);
        return _this;
    }

    AffiliatePageExample__createClass(AffiliatePageExample, [{
        key: 'onProviderChange',
        value: function onProviderChange(event) {
            this.setState({
                mvpd: event.target.value
            });
        }
    }, {
        key: 'onNetworkChange',
        value: function onNetworkChange(event) {
            this.setState({
                network: event.target.value
            });
        }
    }, {
        key: 'onLinkClick',
        value: function onLinkClick(event) {
            if (this.state.mvpd === DEF_PROVIDER_VALUE) {
                event.preventDefault();
                this.warn();
            }
        }
    }, {
        key: 'warn',
        value: function warn() {
            // eslint-disable-line class-methods-use-this
            alert('Select a provider'); // eslint-disable-line no-alert
        }
    }, {
        key: 'selectByNetwork',
        value: function selectByNetwork() {
            var _state = this.state,
                mvpd = _state.mvpd,
                network = _state.network;

            if (mvpd === DEF_PROVIDER_VALUE) {
                this.warn();
                return;
            }

            window.open('/watch/mvpd/login?mvpd=' + mvpd + '&network=' + network);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state2 = this.state,
                mvpd = _state2.mvpd,
                network = _state2.network;

            var _props = this.props,
                _props$page$buckets = _slicedToArray(_props.page.buckets, 1),
                _props$page$buckets$ = _props$page$buckets[0],
                bucket = _props$page$buckets$ === undefined ? {} : _props$page$buckets$,
                providers = _props.providers;

            var _bucket$contents = bucket.contents,
                contents = _bucket$contents === undefined ? [] : _bucket$contents;


            var providerOptions = providers.map(function (_ref) {
                var name = _ref.name,
                    abbreviation = _ref.abbreviation;
                return AffiliatePageExample__jsx('option', {
                    value: abbreviation
                }, void 0, name);
            });
            providerOptions.unshift(AffiliatePageExample__jsx('option', {
                value: DEF_PROVIDER_VALUE
            }, void 0, '----- Choose Provider -----'));

            return AffiliatePageExample__jsx('div', {
                style: containerStyle
            }, void 0, AffiliatePageExample__jsx(Helmet_default.a, {
                meta: [{ name: 'robots', content: 'noindex, nofollow' }],
                link: [{ rel: 'stylesheet', href: AffiliatePageExample_STYLE_HREF + '/page.css' }],
                style: [{
                    cssText: '\n                            body {\n                                font-family: sans-serif;\n                            }\n                            h1 { font-size: 24px; }\n                            h2 { font-size: 20px; }\n                            h3 { font-size: 18px; }\n                        '
                }]
            }), AffiliatePageExample__jsx('h1', {}, void 0, 'Affiliate Page Test'), AffiliatePageExample__jsx('div', {
                style: { marginTop: 20 }
            }, void 0, AffiliatePageExample__jsx('select', {
                id: 'providerList',
                defaultValue: mvpd,
                style: { width: 200 },
                onChange: this.onProviderChange
            }, void 0, providerOptions)), AffiliatePageExample__jsx('div', {
                style: { marginTop: 20 }
            }, void 0, AffiliatePageExample__jsx('button', {
                onClick: this.selectByNetwork
            }, void 0, 'Network'), AffiliatePageExample__jsx('input', {
                type: 'text',
                value: network,
                onChange: this.onNetworkChange
            })), AffiliatePageExample__jsx('div', {
                style: containerStyle
            }, void 0, AffiliatePageExample__jsx('ul', {}, void 0, contents.map(function (_ref2) {
                var id = _ref2.id,
                    name = _ref2.name;
                return AffiliatePageExample__jsx('li', {
                    'data-id': id,
                    style: { listStyleType: 'circle' }
                }, id, AffiliatePageExample__jsx(LinkWithFlags["a" /* default */], {
                    to: { pathname: '/mvpd/login', query: { id: id, mvpd: mvpd } },
                    target: '_blank',
                    onClick: _this2.onLinkClick
                }, void 0, name));
            }))));
        }
    }]);

    return AffiliatePageExample;
}(react["PureComponent"]);

AffiliatePageExample_AffiliatePageExample.defaultProps = {
    providers: []
};

AffiliatePageExample_AffiliatePageExample.loadActions = [function (params, query, lang) {
    return Object(page_actions["o" /* createFetchPageAction */])('home', params, query, lang);
}, function (_, query) {
    return Object(authenticationActions["Z" /* getProviders */])({ platform: query.device });
}];

var AffiliatePageExample_mapStateToProps = function mapStateToProps(state) {
    return {
        page: Object(pageSelector["c" /* default */])(state),
        providers: Object(providerSelector["c" /* providersSelector */])(state)
    };
};

/* harmony default export */ var page_AffiliatePageExample = (Object(es["b" /* connect */])(AffiliatePageExample_mapStateToProps)(AffiliatePageExample_AffiliatePageExample));
// EXTERNAL MODULE: ./app/common/page/AdobePassProxyLogin.js
var AdobePassProxyLogin = __webpack_require__(374);

// EXTERNAL MODULE: ./app/common/page/AccountSelector.js
var AccountSelector = __webpack_require__(325);

// CONCATENATED MODULE: ./app/common/RootApplicationShell.js
var RootApplicationShell__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();








var RootApplicationShell_secureCdnHost = config_default.a.secureCdnHost,
    RootApplicationShell_cdnHost = config_default.a.cdnHost;


var RootApplicationShell_RootApplicationShell = function RootApplicationShell(_ref) {
    var children = _ref.children,
        _ref$meta = _ref.meta;
    _ref$meta = _ref$meta === undefined ? {} : _ref$meta;
    var title = _ref$meta.title,
        description = _ref$meta.description,
        keywords = _ref$meta.keywords,
        canonicalUrl = _ref$meta.canonicalUrl,
        socialDescription = _ref$meta.socialDescription,
        socialTitle = _ref$meta.socialTitle,
        socialUrl = _ref$meta.socialUrl,
        socialImageUrl = _ref$meta.socialImageUrl,
        noIndex = _ref$meta.noIndex;

    var metaTag = [{ 'http-equiv': 'content-type', content: 'text/html; charset=UTF-8' }, { 'http-equiv': 'x-ua-compatible', content: 'IE=edge,chrome=1' }, { name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no' }, { name: 'title', content: title }, { name: 'description', content: description }, { name: 'news_keywords', content: keywords }, { name: 'keywords', content: keywords }, { name: 'medium', content: 'index' }, { property: 'fb:app_id', content: '116656161708917' }, { property: 'og:site_name', content: 'ESPN.com' }, { property: 'og:url', content: socialUrl }, { property: 'og:title', content: socialTitle }, { property: 'og:description', content: socialDescription }, { property: 'og:image', content: socialImageUrl }, { property: 'og:type', content: 'website' }, { name: 'twitter:site', content: 'espn' }, { name: 'twitter:url', content: socialUrl }, { name: 'twitter:title', content: socialTitle }, { name: 'twitter:description', content: socialDescription }, { name: 'twitter:image', content: socialImageUrl }, { name: 'twitter:card', content: 'summary' }, { name: 'twitter:app:name:iphone', content: 'ESPN' }, { name: 'twitter:app:id:iphone', content: '317469184' }, { name: 'twitter:app:name:googleplay', content: 'ESPN' }, { name: 'twitter:app:id:googleplay', content: 'com.espn.score_center' }];

    if (noIndex) {
        metaTag.unshift({ name: 'robots', content: 'noindex, nofollow' });
    }

    return RootApplicationShell__jsx('div', {
        className: 'watch-root'
    }, void 0, RootApplicationShell__jsx(Helmet_default.a, {
        title: title,
        link: [{ rel: 'canonical', href: canonicalUrl }, { rel: 'mask-icon', href: RootApplicationShell_secureCdnHost + '/prod/assets/icons/E.svg', color: '#990000', sizes: 'any' }, { rel: 'shortcut icon', href: RootApplicationShell_secureCdnHost + '/favicon.ico' }, { rel: 'dns-prefetch', href: RootApplicationShell_cdnHost }, { rel: 'dns-prefetch', href: RootApplicationShell_secureCdnHost }, { rel: 'preconnect', href: RootApplicationShell_cdnHost, crossorigin: '' }, { rel: 'preconnect', href: RootApplicationShell_secureCdnHost, crossorigin: '' }, {
            rel: 'apple-touch-icon',
            href: RootApplicationShell_secureCdnHost + '/wireless/mw5/r1/images/bookmark-icons/espn_icon-57x57.min.png'
        }, {
            rel: 'apple-touch-icon-precomposed',
            href: RootApplicationShell_secureCdnHost + '/wireless/mw5/r1/images/bookmark-icons/espn_icon-57x57.min.png'
        }, {
            rel: 'apple-touch-icon-precomposed',
            sizes: '72x72',
            href: RootApplicationShell_secureCdnHost + '/wireless/mw5/r1/images/bookmark-icons/espn_icon-72x72.min.png'
        }, {
            rel: 'apple-touch-icon-precomposed',
            sizes: '114x114',
            href: RootApplicationShell_secureCdnHost + '/wireless/mw5/r1/images/bookmark-icons/espn_icon-114x114.min.png'
        }, {
            rel: 'apple-touch-icon-precomposed',
            sizes: '152x152',
            href: RootApplicationShell_secureCdnHost + '/wireless/mw5/r1/images/bookmark-icons/espn_icon-152x152.min.png'
        }],
        meta: metaTag,
        script: [{
            type: 'application/ld+json',
            innerHTML: '{\n                        "@context": "http://schema.org",\n                        "@type":    "WebSite",\n                        "name":     "ESPN",\n                        "url":      "http://www.espn.com/"\n                    }'
        }]
    }), children);
};

var RootApplicationShell_mapStateToProps = function mapStateToProps(state, props) {
    return {
        meta: Object(pageSelector["e" /* metaSelector */])(state, props)
    };
};

/* harmony default export */ var common_RootApplicationShell = (Object(injectIntl["a" /* default */])(Object(es["b" /* connect */])(RootApplicationShell_mapStateToProps)(RootApplicationShell_RootApplicationShell)));
// EXTERNAL MODULE: ./app/lib/observe/index.js
var observe = __webpack_require__(375);

// EXTERNAL MODULE: ./app/lib/observe/trackingObserver.js + 1 modules
var trackingObserver = __webpack_require__(376);

// EXTERNAL MODULE: ./app/lib/format/getI18nInclude.js
var getI18nInclude = __webpack_require__(295);

// CONCATENATED MODULE: ./server/templates/dotComAnalyticsStub.js


/* harmony default export */ var dotComAnalyticsStub = ({
    omniture: {
        countryRegion: 'en-us',
        hier1: 'watch:index',
        section: 'watch',
        pageName: 'watch:index',
        sections: 'watch:index',
        site: 'espn',
        premium: 'premium-no',
        convrSport: 'watch',
        pageURL: 'www.espn.com/watch/index',
        lang: 'en_us',
        contentType: 'index',
        sport: 'watch',
        account: 'wdgespcom',
        siteType: 'full',
        prop58: 'isIndex=true'
    },
    chartbeat: {
        loadPubJS: false,
        path: '/watch/index',
        zone: 'www.espn.com.us.watch',
        domain: 'www.espn.com',
        loadVidJS: true,
        title: 'WatchESPN: Live Sports, Game Replays, Video Highlights',
        sections: 'watch',
        authors: 'index'
    },
    nielsen: app_constants["t" /* dotComNielsenData */],
    ABTest: {
        isOptimizied: true,
        environment: 'prod',
        tScript: 'http://a.espncdn.com/prod/scripts/analytics/target.20.r2.js',
        abtestUser: 0,
        oScript: 'http://cdn.optimizely.com/js/310987714.js',
        targetURLs: [{
            regexp: '(/)',
            site: 'espn.co.uk',
            flag: false
        }, {
            regexp: '(/.*)',
            site: 'www.espn.com',
            flag: false
        }],
        domain: 'www.espn.com',
        host: 'espn.com',
        raw: '{\'fastcast\':{\'placements\':{\'/nba/index\':\'true\',\'^/.+$\':\'false\',\'/ncf/index\':\'true\'},\'enabled\':false,\'script\':\'http://a.espncdn.com/combiner/c?js=analytics/espn.fastcastTracking.4.js\'},\'optimizely\':{\'oldscript\':\'http://a.espncdn.com/sports/optimizely.js\',\'placements\':[{\'regexp\':\'(/)\',\'site\':\'espn.co.uk\',\'flag\':true},{\'regexp\':\'(/.*)\',\'site\':\'www.espn.com\',\'flag\':true},{\'regexp\':\'(/.*)\',\'site\':\'www.espnqa.com\',\'flag\':true}],\'enabled\':true,\'script\':\'http://cdn.optimizely.com/js/310987714.js\'},\'target\':{\'placements\':[{\'regexp\':\'(/)\',\'site\':\'espn.co.uk\',\'flag\':false},{\'regexp\':\'(/.*)\',\'site\':\'www.espn.com\',\'flag\':false}],\'enabled\':false,\'script\':\'http://a.espncdn.com/prod/scripts/analytics/target.20.r2.js\'}}',
        optimizely: true,
        target: false,
        optimizelyURLs: [{
            regexp: '(/)',
            site: 'espn.co.uk',
            flag: true
        }, {
            regexp: '(/.*)',
            site: 'www.espn.com',
            flag: true
        }, {
            regexp: '(/.*)',
            site: 'www.espnqa.com',
            flag: true
        }]
    },
    isFeaturePhone: false,
    device: 'desktop',
    cto: true
});
// CONCATENATED MODULE: ./app/webapp/subShell/BasicShell.js
var BasicShell__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var BasicShell__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function BasicShell__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function BasicShell__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function BasicShell__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var BasicShell_shellVersion = config_default.a.shellVersion,
    BasicShell_secureCdnHost = config_default.a.secureCdnHost;

var BasicShell_BASE_HREF = BasicShell_secureCdnHost + '/redesign/' + BasicShell_shellVersion;

var BasicShell_BasicShell = function (_PureComponent) {
    BasicShell__inherits(BasicShell, _PureComponent);

    function BasicShell() {
        BasicShell__classCallCheck(this, BasicShell);

        return BasicShell__possibleConstructorReturn(this, (BasicShell.__proto__ || Object.getPrototypeOf(BasicShell)).apply(this, arguments));
    }

    BasicShell__createClass(BasicShell, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var store = this.context.store;

            this.unsubscribeFromStore = Object(observe["a" /* subscribeToStore */])(store, [trackingObserver["a" /* default */]]);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.unsubscribeFromStore) {
                this.unsubscribeFromStore();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props$app = this.props.app,
                device = _props$app.device,
                isMobile = _props$app.isMobile;

            return BasicShell__jsx('div', {}, void 0, BasicShell__jsx(Helmet_default.a, {
                script: [{
                    src: BasicShell_BASE_HREF + '/js/espn-head.js'
                }, {
                    innerHTML: '\n                            var espn = espn || {};\n                            espn.build = \'' + BasicShell_shellVersion + '\';\n                            var espn_ui = window.espn_ui || {};\n                            espn_ui.deviceType = "' + device + '";\n                            espn_ui.device = {\n                                isMobile: ' + isMobile + '\n                            };\n                            espn.track = espn.track || {};\n                            espn.track.data = ' + JSON.stringify(dotComAnalyticsStub) + ';\n                        '
                }, {
                    src: Object(getI18nInclude["a" /* default */])()
                }]
            }), react_default.a.Children.only(this.props.children), BasicShell__jsx('script', {
                src: BasicShell_BASE_HREF + '/js/espn-critical.js'
            }), BasicShell__jsx('script', {
                src: BasicShell_BASE_HREF + '/js/espn-analytics.js'
            }));
        }
    }]);

    return BasicShell;
}(react["PureComponent"]);

BasicShell_BasicShell.contextTypes = {
    store: react["PropTypes"].object
};

BasicShell_BasicShell.renderTemplate = enums["C" /* RenderTemplateTypes */].BASIC;

var BasicShell_mapStateToProps = function mapStateToProps(state) {
    return {
        app: Object(appSelector["j" /* default */])(state)
    };
};

/* harmony default export */ var subShell_BasicShell = (Object(es["b" /* connect */])(BasicShell_mapStateToProps)(BasicShell_BasicShell));
// EXTERNAL MODULE: ./app/webapp/subShell/PageShell.js
var PageShell = __webpack_require__(790);

// EXTERNAL MODULE: ./app/common/ads/AdContainer.js
var AdContainer = __webpack_require__(218);

// CONCATENATED MODULE: ./app/common/ads/OverlayAd.js
var OverlayAd__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var OverlayAd_OverlayAd = function OverlayAd(props) {
    return react_default.a.createElement(AdContainer["a" /* default */], OverlayAd__extends({
        className: 'ad-wrapper',
        kvps: { pos: 'outofpage' },
        slotType: 'outofpage',
        isOutOfPage: true
    }, props));
};

OverlayAd_OverlayAd.defaultProps = {
    refreshOnLoad: false
};

/* harmony default export */ var ads_OverlayAd = (OverlayAd_OverlayAd);
// CONCATENATED MODULE: ./app/common/createLandingPage.js
var createLandingPage__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();














// create landing page(e.g. home, espnplus, product)
function createLandingPage() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$pageName = options.pageName,
        pageName = _options$pageName === undefined ? 'home' : _options$pageName;


    var LandingPage = function LandingPage(_ref) {
        var isIntl = _ref.isIntl,
            showOneIdLogin = _ref.showOneIdLogin,
            isLoggedIn = _ref.isLoggedIn;

        var showLogin = !isLoggedIn && showOneIdLogin;
        // NOTE: Display Overlay Ads on `home`, `espnplus` pages generated by createLandingPage
        var bannerAd = isIntl ? [createLandingPage__jsx(BannerAd["a" /* default */], {}, 'banner_ad')] : [createLandingPage__jsx(ads_OverlayAd, {}, 'overlay_ad')];
        return createLandingPage__jsx(MainContainer["a" /* default */], {
            className: 'watch-home',
            pre: bannerAd,
            showLogin: showLogin
        }, void 0, createLandingPage__jsx(TopLayoutContainer["a" /* default */], {}), createLandingPage__jsx('div', {
            className: 'layout-full layout-full--watch'
        }, void 0, createLandingPage__jsx('section', {
            className: 'col-a'
        }, void 0, createLandingPage__jsx(BucketListContainer["a" /* default */], {
            pageType: enums["y" /* PageType */].HOME
        }))));
    };

    LandingPage.loadActions = [function (params, query, lang) {
        return Object(page_actions["o" /* createFetchPageAction */])(pageName, params, query, lang);
    }, function (params, query, lang) {
        return Object(scheduleModule_actions["d" /* fetchScheduleModule */])(lang);
    }];

    LandingPage.refreshInterval = 65; // 1 min and 5 seconds

    LandingPage.onRefresh = function (_ref2) {
        var dispatch = _ref2.dispatch,
            routeParams = _ref2.routeParams,
            lang = _ref2.lang,
            _ref2$location$query = _ref2.location.query,
            query = _ref2$location$query === undefined ? {} : _ref2$location$query;

        dispatch(Object(page_actions["o" /* createFetchPageAction */])(pageName, routeParams, query, lang)).then(function () {
            dispatch(Object(page_actions["scorePage"])());
        });
        dispatch(Object(scheduleModule_actions["d" /* fetchScheduleModule */])(lang)).then(function () {
            dispatch(Object(scheduleModule_actions["e" /* scoreScheduleModule */])());
        });
    };

    var mapStateToProps = function mapStateToProps(state) {
        return {
            isIntl: Object(appSelector["u" /* isIntlSelector */])(state),
            showOneIdLogin: Object(appSelector["G" /* showOneIdLoginSelector */])(state),
            isLoggedIn: Object(oneIdSelector["f" /* oneIdLoggedInSelector */])(state)
        };
    };

    return Object(es["b" /* connect */])(mapStateToProps)(LandingPage);
}
// EXTERNAL MODULE: ./app/common/createCollection.js
var createCollection = __webpack_require__(799);

// CONCATENATED MODULE: ./app/webapp/routes.js
var routes__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();


























function createRoutes() {
    return [routes__jsx(lib["Route"], {
        path: '/',
        component: common_RootApplicationShell
    }, void 0, routes__jsx(lib["Route"], {
        component: subShell_BasicShell
    }, 'route_0', routes__jsx(lib["Route"], {
        path: 'activate',
        component: Activate
    }), routes__jsx(lib["Route"], {
        path: 'subscribe',
        component: Activate
    }), routes__jsx(lib["Route"], {
        path: 'feedback',
        component: page_Feedback
    }), routes__jsx(lib["Route"], {
        path: 'roadblock',
        component: page_Roadblock
    }), routes__jsx(lib["Route"], {
        path: 'unsupported',
        component: page_UnsupportedPage
    }), routes__jsx(lib["Route"], {
        path: 'syndicated/player',
        component: SyndicatedPlayerPage["a" /* default */]
    }), routes__jsx(lib["Route"], {
        path: 'syndicated/player/example',
        component: SyndicatedPlayerExample["a" /* default */]
    }), routes__jsx(lib["Route"], {
        path: 'affiliate/example',
        component: page_AffiliatePageExample
    }), routes__jsx(lib["Route"], {
        path: 'mvpd/login',
        component: AdobePassProxyLogin["b" /* default */]
    }), routes__jsx(lib["Route"], {
        path: 'account-selector',
        component: AccountSelector["b" /* default */]
    })), routes__jsx(lib["Route"], {
        component: PageShell["a" /* default */]
    }, 'route_1', routes__jsx(lib["IndexRoute"], {
        component: createLandingPage({ pageName: 'home' })
    }), routes__jsx(lib["Route"], {
        path: '_/*',
        component: createLandingPage({ pageName: 'home' })
    }), routes__jsx(lib["Route"], {
        path: 'collections/:id(/g/:groupId)(/:junk)',
        component: Object(createCollection["a" /* default */])()
    }), routes__jsx(lib["Route"], {
        path: 'originals',
        component: page_Originals
    }), routes__jsx(lib["Route"], {
        path: 'espnplus',
        component: createLandingPage({ pageName: 'espnplus' })
    }), routes__jsx(lib["Route"], {
        path: 'product/:id(/g/:groupId)(/:junk)',
        component: Object(createCollection["a" /* default */])({ pageName: 'product' })
    }), routes__jsx(lib["Route"], {
        path: 'program/:id(/g/:groupId)(/:junk)',
        component: Object(createCollection["a" /* default */])({ pageName: 'program' })
    }), routes__jsx(lib["Route"], {
        path: 'schedule',
        component: page_Schedule
    }), routes__jsx(lib["Route"], {
        path: 'player',
        component: page_Player
    }), routes__jsx(lib["Route"], {
        path: 'shortstoplive',
        component: page_ShortStopLive
    }), routes__jsx(lib["Route"], {
        path: 'search(/:searchTerm)',
        component: page_Search
    }), routes__jsx(lib["Route"], {
        path: 'sid(/:team)',
        component: page_Sid
    }), routes__jsx(lib["Route"], {
        path: ':pageName/:id(/:junk)',
        component: page_Catalog
    }), routes__jsx(lib["Route"], {
        path: ':pageName',
        component: page_Features
    })))];
}

/* harmony default export */ var webapp_routes = (createRoutes);
// CONCATENATED MODULE: ./server/fetchComponentData.js



/**
 * This function fire offs redux actions when a route component is initially mounted or updated.  This generally retrieves
 * the initial data needed for the page.
 * @param {function} dispatch - Redux dispatch method to fire off actions
 * @param {array} components - The components initially rendered by the router.  Typically PageShell and a child component based
 * on the route (Home, Features, Schedule or Collection)
 * @param {object} [pathParams] - Optional path parameters extracted by react-router
 * @param {objeect} [query] - Optional url query parameters
 * @param {string} [lang] - Optional lang originating from client and passed into the PageAPI
 * @param {array} [actions] - Optional array of ancillary actions to be fired
 * @param {string} [preActions] - Optional array of actions that should occur before all other actions are fired
 */

/* harmony default export */ var fetchComponentData = (function (dispatch) {
    var components = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var pathParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var query = arguments[3];
    var lang = arguments[4];
    var actions = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
    var preActionsArg = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];

    var loadActions = components.reduce(function (prev, current) {
        return prev.concat(current && current.loadActions || []);
    }, actions);
    var preActions = components.reduce(function (prev, current) {
        return prev.concat(current && current.preActions || []);
    }, preActionsArg);

    preActions = uniq_default()(preActions);
    loadActions = uniq_default()(loadActions);
    var prePromises = preActions.map(function (preAction) {
        return dispatch(preAction());
    });
    return bluebird_default.a.all(prePromises).finally(function () {
        var promises = loadActions.map(function (action) {
            return dispatch(action(pathParams, query, lang));
        });
        return bluebird_default.a.all(promises);
    });
});
// EXTERNAL MODULE: ./app/lib/format/normalizeQueryString.js
var normalizeQueryString = __webpack_require__(203);

// CONCATENATED MODULE: ./app/common/ComponentDataContainer.js
var ComponentDataContainer__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ComponentDataContainer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ComponentDataContainer__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ComponentDataContainer__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// eslint-disable-next-line no-unused-vars




var ComponentDataContainer_ComponentDataContainer = function (_Component) {
    ComponentDataContainer__inherits(ComponentDataContainer, _Component);

    function ComponentDataContainer() {
        ComponentDataContainer__classCallCheck(this, ComponentDataContainer);

        return ComponentDataContainer__possibleConstructorReturn(this, (ComponentDataContainer.__proto__ || Object.getPrototypeOf(ComponentDataContainer)).apply(this, arguments));
    }

    ComponentDataContainer__createClass(ComponentDataContainer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var routerProps = this.props.routerProps;

            this.onUpdate(routerProps);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            var routerProps = this.props.routerProps;

            var prevRouterProps = prevProps.routerProps;
            this.onUpdate(routerProps, prevRouterProps);
        }
    }, {
        key: 'onUpdate',
        value: function onUpdate(routerProps) {
            var prevRouterProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            if (window.__INITIAL_STATE__ !== null && routerProps.ssr) {
                window.__INITIAL_STATE__ = null;
                return;
            }

            // don't update if the route hasn't changed
            if (prevRouterProps.location && prevRouterProps.location.pathname === routerProps.location.pathname) {
                return;
            }

            // this `dispatch is passed from client.js
            var _props = this.props,
                dispatch = _props.dispatch,
                onDefLoadStart = _props.onLoadStart,
                onDefComplete = _props.onComplete;
            var _routerProps$componen = routerProps.components,
                components = _routerProps$componen === undefined ? [] : _routerProps$componen,
                _routerProps$params = routerProps.params,
                params = _routerProps$params === undefined ? {} : _routerProps$params,
                _routerProps$location = routerProps.location;
            _routerProps$location = _routerProps$location === undefined ? {} : _routerProps$location;
            var _routerProps$location2 = _routerProps$location.query,
                query = _routerProps$location2 === undefined ? {} : _routerProps$location2,
                lang = routerProps.lang;
            // grab the ones that's defined in the deepest child

            var _components$reduce = components.reduce(function (acc, current) {
                if (current.onLoadStart) {
                    acc.onLoadStart = current.onLoadStart;
                }
                if (current.onComplete) {
                    acc.onComplete = current.onComplete;
                }
                return acc;
            }, { onLoadStart: onDefLoadStart, onComplete: onDefComplete }),
                onLoadStart = _components$reduce.onLoadStart,
                onComplete = _components$reduce.onComplete;

            onLoadStart(dispatch);
            fetchComponentData(dispatch, components, params, Object(normalizeQueryString["a" /* default */])(query), lang).then(function () {
                return onComplete(dispatch);
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return this.props.children;
        }
    }]);

    return ComponentDataContainer;
}(react["Component"]);

ComponentDataContainer_ComponentDataContainer.defaultProps = {
    onLoadStart: function onLoadStart() {},
    onComplete: function onComplete() {}
};

/* harmony default export */ var common_ComponentDataContainer = (ComponentDataContainer_ComponentDataContainer);
// EXTERNAL MODULE: ./app/common/IntlProvider.js + 5 modules
var IntlProvider = __webpack_require__(379);

// CONCATENATED MODULE: ./app/webapp/client.js
var client__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var client__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






















if (false) {
    var _require = require('why-did-you-update'),
        whyDidYouUpdate = _require.whyDidYouUpdate;

    whyDidYouUpdate(React);
}

// since we are using the same bundle for qa and prod, we need to define the "publicPath"
// for webpack at runtime.  The alternative is building a bundle for each environment
// http://webpack.github.io/docs/configuration.html#output-publicpath
/* eslint-disable */
if (window.watchGlobals) {
    __webpack_require__.p = (window.location.protocol === 'https:' ? window.watchGlobals.secureCdnPath : window.watchGlobals.cdnPath) + '/';
}
/* eslint-enable */

var client_initialState = window && window.__INITIAL_STATE__;
var localeData = window && window.ReactIntlLocaleData;
var enhancedBrowserHistory = Object(lib["useRouterHistory"])(function () {
    return lib["browserHistory"];
})({
    basename: '/watch'
});

var client_store = app_store(client_initialState, enhancedBrowserHistory, [trackingMiddleware]);
var client_history = Object(react_router_redux_lib["syncHistoryWithStore"])(enhancedBrowserHistory, client_store);
var client_dispatch = client_store.dispatch;


function loadActionsRouterMiddleware() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return {
        renderRouterContext: function renderRouterContext(child, routerProps) {
            return react_default.a.createElement(
                common_ComponentDataContainer,
                client__extends({ routerProps: routerProps }, props),
                child
            );
        }
    };
}

function renderApp() {
    var renderWithMiddleware = Object(lib["applyRouterMiddleware"])(react_router_scroll_lib_default()(), loadActionsRouterMiddleware({
        dispatch: client_dispatch
    }));
    var routes = webapp_routes();
    var appContainer = document.getElementById(config_default.a.uid);
    var state = client_store.getState();
    var lang = state.app.lang;

    var ssr = Object(appSelector["H" /* ssrSelector */])(state);
    var analyticsConstants = Object(analyticsSelectors["a" /* analyticsConstantsSelector */])(state);

    if (localeData && localeData[lang]) {
        Object(index_es["c" /* addLocaleData */])(localeData[lang]);
    }

    Object(omniture["f" /* init */])(analyticsConstants);

    if (appContainer) {
        Object(react_dom["render"])(client__jsx(es["a" /* Provider */], {
            store: client_store
        }, void 0, client__jsx(IntlProvider["a" /* default */], {}, void 0, client__jsx(lib["Router"], {
            history: client_history,
            render: renderWithMiddleware,
            lang: lang,
            ssr: ssr
        }, void 0, routes))), appContainer, function () {
            client_dispatch(Object(appActions["x" /* appRendered */])());
        });
    }
}

window._reactInMem = true;
// Overwriting from espn-head.js to enable error logging for Beta period
if (window.newrelic && config_default.a.isBeta) {
    window.newrelic.setErrorHandler(function () {
        return false;
    });
}

Object(docReady["a" /* default */])(function () {
    if (!window.Intl) {
        __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 803)).then(renderApp).catch(function () {
            // console.error(err);
            renderApp();
        });
    } else {
        renderApp();
    }
});

window.debug = window.debug || {};
window.debug.setLevel = function () {};

/***/ }),
/* 383 */
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),
/* 384 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 385 */
/***/ (function(module, exports) {

module.exports = now

function now() {
    return new Date().getTime()
}


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(387);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24), __webpack_require__(48)))

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var PooledClass = __webpack_require__(389);
var ReactElement = __webpack_require__(80);

var emptyFunction = __webpack_require__(37);
var traverseAllChildren = __webpack_require__(390);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(79);

var invariant = __webpack_require__(5);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(79);

var ReactCurrentOwner = __webpack_require__(49);
var REACT_ELEMENT_TYPE = __webpack_require__(227);

var getIteratorFn = __webpack_require__(228);
var invariant = __webpack_require__(5);
var KeyEscapeUtils = __webpack_require__(391);
var warning = __webpack_require__(6);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(15);

var ReactComponent = __webpack_require__(158);
var ReactNoopUpdateQueue = __webpack_require__(159);

var emptyObject = __webpack_require__(99);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = ReactPureComponent;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(79),
    _assign = __webpack_require__(15);

var ReactComponent = __webpack_require__(158);
var ReactElement = __webpack_require__(80);
var ReactPropTypeLocationNames = __webpack_require__(229);
var ReactNoopUpdateQueue = __webpack_require__(159);

var emptyObject = __webpack_require__(99);
var invariant = __webpack_require__(5);
var warning = __webpack_require__(6);

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

/**
 * Policies that describe methods in `ReactClassInterface`.
 */


var injectedMixins = [];

/**
 * Composite components are higher-level components that compose other composite
 * or host components.
 *
 * To create a new type of `ReactClass`, pass a specification of
 * your new class to `React.createClass`. The only requirement of your class
 * specification is that you implement a `render` method.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return <div>Hello World</div>;
 *     }
 *   });
 *
 * The class specification supports a specific protocol of methods that have
 * special meaning (e.g. `render`). See `ReactClassInterface` for
 * more the comprehensive protocol. Any other properties and methods in the
 * class specification will be available on the prototype.
 *
 * @interface ReactClassInterface
 * @internal
 */
var ReactClassInterface = {

  /**
   * An array of Mixin objects to include when defining your component.
   *
   * @type {array}
   * @optional
   */
  mixins: 'DEFINE_MANY',

  /**
   * An object containing properties and methods that should be defined on
   * the component's constructor instead of its prototype (static methods).
   *
   * @type {object}
   * @optional
   */
  statics: 'DEFINE_MANY',

  /**
   * Definition of prop types for this component.
   *
   * @type {object}
   * @optional
   */
  propTypes: 'DEFINE_MANY',

  /**
   * Definition of context types for this component.
   *
   * @type {object}
   * @optional
   */
  contextTypes: 'DEFINE_MANY',

  /**
   * Definition of context types this component sets for its children.
   *
   * @type {object}
   * @optional
   */
  childContextTypes: 'DEFINE_MANY',

  // ==== Definition methods ====

  /**
   * Invoked when the component is mounted. Values in the mapping will be set on
   * `this.props` if that prop is not specified (i.e. using an `in` check).
   *
   * This method is invoked before `getInitialState` and therefore cannot rely
   * on `this.state` or use `this.setState`.
   *
   * @return {object}
   * @optional
   */
  getDefaultProps: 'DEFINE_MANY_MERGED',

  /**
   * Invoked once before the component is mounted. The return value will be used
   * as the initial value of `this.state`.
   *
   *   getInitialState: function() {
   *     return {
   *       isOn: false,
   *       fooBaz: new BazFoo()
   *     }
   *   }
   *
   * @return {object}
   * @optional
   */
  getInitialState: 'DEFINE_MANY_MERGED',

  /**
   * @return {object}
   * @optional
   */
  getChildContext: 'DEFINE_MANY_MERGED',

  /**
   * Uses props from `this.props` and state from `this.state` to render the
   * structure of the component.
   *
   * No guarantees are made about when or how often this method is invoked, so
   * it must not have side effects.
   *
   *   render: function() {
   *     var name = this.props.name;
   *     return <div>Hello, {name}!</div>;
   *   }
   *
   * @return {ReactComponent}
   * @nosideeffects
   * @required
   */
  render: 'DEFINE_ONCE',

  // ==== Delegate methods ====

  /**
   * Invoked when the component is initially created and about to be mounted.
   * This may have side effects, but any external subscriptions or data created
   * by this method must be cleaned up in `componentWillUnmount`.
   *
   * @optional
   */
  componentWillMount: 'DEFINE_MANY',

  /**
   * Invoked when the component has been mounted and has a DOM representation.
   * However, there is no guarantee that the DOM node is in the document.
   *
   * Use this as an opportunity to operate on the DOM when the component has
   * been mounted (initialized and rendered) for the first time.
   *
   * @param {DOMElement} rootNode DOM element representing the component.
   * @optional
   */
  componentDidMount: 'DEFINE_MANY',

  /**
   * Invoked before the component receives new props.
   *
   * Use this as an opportunity to react to a prop transition by updating the
   * state using `this.setState`. Current props are accessed via `this.props`.
   *
   *   componentWillReceiveProps: function(nextProps, nextContext) {
   *     this.setState({
   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
   *     });
   *   }
   *
   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
   * transition may cause a state change, but the opposite is not true. If you
   * need it, you are probably looking for `componentWillUpdate`.
   *
   * @param {object} nextProps
   * @optional
   */
  componentWillReceiveProps: 'DEFINE_MANY',

  /**
   * Invoked while deciding if the component should be updated as a result of
   * receiving new props, state and/or context.
   *
   * Use this as an opportunity to `return false` when you're certain that the
   * transition to the new props/state/context will not require a component
   * update.
   *
   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
   *     return !equal(nextProps, this.props) ||
   *       !equal(nextState, this.state) ||
   *       !equal(nextContext, this.context);
   *   }
   *
   * @param {object} nextProps
   * @param {?object} nextState
   * @param {?object} nextContext
   * @return {boolean} True if the component should update.
   * @optional
   */
  shouldComponentUpdate: 'DEFINE_ONCE',

  /**
   * Invoked when the component is about to update due to a transition from
   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
   * and `nextContext`.
   *
   * Use this as an opportunity to perform preparation before an update occurs.
   *
   * NOTE: You **cannot** use `this.setState()` in this method.
   *
   * @param {object} nextProps
   * @param {?object} nextState
   * @param {?object} nextContext
   * @param {ReactReconcileTransaction} transaction
   * @optional
   */
  componentWillUpdate: 'DEFINE_MANY',

  /**
   * Invoked when the component's DOM representation has been updated.
   *
   * Use this as an opportunity to operate on the DOM when the component has
   * been updated.
   *
   * @param {object} prevProps
   * @param {?object} prevState
   * @param {?object} prevContext
   * @param {DOMElement} rootNode DOM element representing the component.
   * @optional
   */
  componentDidUpdate: 'DEFINE_MANY',

  /**
   * Invoked when the component is about to be removed from its parent and have
   * its DOM representation destroyed.
   *
   * Use this as an opportunity to deallocate any external resources.
   *
   * NOTE: There is no `componentDidUnmount` since your component will have been
   * destroyed by that point.
   *
   * @optional
   */
  componentWillUnmount: 'DEFINE_MANY',

  // ==== Advanced methods ====

  /**
   * Updates the component's currently mounted DOM representation.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   * @overridable
   */
  updateComponent: 'OVERRIDE_BASE'

};

/**
 * Mapping from class specification keys to special processing functions.
 *
 * Although these are declared like instance properties in the specification
 * when defining classes using `React.createClass`, they are actually static
 * and are accessible on the constructor instead of the prototype. Despite
 * being static, they must be defined outside of the "statics" key under
 * which all other static methods are defined.
 */
var RESERVED_SPEC_KEYS = {
  displayName: function (Constructor, displayName) {
    Constructor.displayName = displayName;
  },
  mixins: function (Constructor, mixins) {
    if (mixins) {
      for (var i = 0; i < mixins.length; i++) {
        mixSpecIntoComponent(Constructor, mixins[i]);
      }
    }
  },
  childContextTypes: function (Constructor, childContextTypes) {
    if (false) {
      validateTypeDef(Constructor, childContextTypes, 'childContext');
    }
    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
  },
  contextTypes: function (Constructor, contextTypes) {
    if (false) {
      validateTypeDef(Constructor, contextTypes, 'context');
    }
    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
  },
  /**
   * Special case getDefaultProps which should move into statics but requires
   * automatic merging.
   */
  getDefaultProps: function (Constructor, getDefaultProps) {
    if (Constructor.getDefaultProps) {
      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
    } else {
      Constructor.getDefaultProps = getDefaultProps;
    }
  },
  propTypes: function (Constructor, propTypes) {
    if (false) {
      validateTypeDef(Constructor, propTypes, 'prop');
    }
    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
  },
  statics: function (Constructor, statics) {
    mixStaticSpecIntoComponent(Constructor, statics);
  },
  autobind: function () {} };

function validateTypeDef(Constructor, typeDef, location) {
  for (var propName in typeDef) {
    if (typeDef.hasOwnProperty(propName)) {
      // use a warning instead of an invariant so components
      // don't show up in prod but only in __DEV__
       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
    }
  }
}

function validateMethodOverride(isAlreadyDefined, name) {
  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;

  // Disallow overriding of base class methods unless explicitly allowed.
  if (ReactClassMixin.hasOwnProperty(name)) {
    !(specPolicy === 'OVERRIDE_BASE') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
  }

  // Disallow defining methods more than once unless explicitly allowed.
  if (isAlreadyDefined) {
    !(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
  }
}

/**
 * Mixin helper which handles policy validation and reserved
 * specification keys when building React classes.
 */
function mixSpecIntoComponent(Constructor, spec) {
  if (!spec) {
    if (false) {
      var typeofSpec = typeof spec;
      var isMixinValid = typeofSpec === 'object' && spec !== null;

      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
    }

    return;
  }

  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;

  var proto = Constructor.prototype;
  var autoBindPairs = proto.__reactAutoBindPairs;

  // By handling mixins before any other properties, we ensure the same
  // chaining order is applied to methods with DEFINE_MANY policy, whether
  // mixins are listed before or after these methods in the spec.
  if (spec.hasOwnProperty(MIXINS_KEY)) {
    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
  }

  for (var name in spec) {
    if (!spec.hasOwnProperty(name)) {
      continue;
    }

    if (name === MIXINS_KEY) {
      // We have already handled mixins in a special case above.
      continue;
    }

    var property = spec[name];
    var isAlreadyDefined = proto.hasOwnProperty(name);
    validateMethodOverride(isAlreadyDefined, name);

    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
      RESERVED_SPEC_KEYS[name](Constructor, property);
    } else {
      // Setup methods on prototype:
      // The following member methods should not be automatically bound:
      // 1. Expected ReactClass methods (in the "interface").
      // 2. Overridden methods (that were mixed in).
      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
      var isFunction = typeof property === 'function';
      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;

      if (shouldAutoBind) {
        autoBindPairs.push(name, property);
        proto[name] = property;
      } else {
        if (isAlreadyDefined) {
          var specPolicy = ReactClassInterface[name];

          // These cases should already be caught by validateMethodOverride.
          !(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY')) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;

          // For methods which are defined more than once, call the existing
          // methods before calling the new property, merging if appropriate.
          if (specPolicy === 'DEFINE_MANY_MERGED') {
            proto[name] = createMergedResultFunction(proto[name], property);
          } else if (specPolicy === 'DEFINE_MANY') {
            proto[name] = createChainedFunction(proto[name], property);
          }
        } else {
          proto[name] = property;
          if (false) {
            // Add verbose displayName to the function, which helps when looking
            // at profiling tools.
            if (typeof property === 'function' && spec.displayName) {
              proto[name].displayName = spec.displayName + '_' + name;
            }
          }
        }
      }
    }
  }
}

function mixStaticSpecIntoComponent(Constructor, statics) {
  if (!statics) {
    return;
  }
  for (var name in statics) {
    var property = statics[name];
    if (!statics.hasOwnProperty(name)) {
      continue;
    }

    var isReserved = name in RESERVED_SPEC_KEYS;
    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;

    var isInherited = name in Constructor;
    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
    Constructor[name] = property;
  }
}

/**
 * Merge two objects, but throw if both contain the same key.
 *
 * @param {object} one The first object, which is mutated.
 * @param {object} two The second object
 * @return {object} one after it has been mutated to contain everything in two.
 */
function mergeIntoWithNoDuplicateKeys(one, two) {
  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;

  for (var key in two) {
    if (two.hasOwnProperty(key)) {
      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
      one[key] = two[key];
    }
  }
  return one;
}

/**
 * Creates a function that invokes two functions and merges their return values.
 *
 * @param {function} one Function to invoke first.
 * @param {function} two Function to invoke second.
 * @return {function} Function that invokes the two argument functions.
 * @private
 */
function createMergedResultFunction(one, two) {
  return function mergedResult() {
    var a = one.apply(this, arguments);
    var b = two.apply(this, arguments);
    if (a == null) {
      return b;
    } else if (b == null) {
      return a;
    }
    var c = {};
    mergeIntoWithNoDuplicateKeys(c, a);
    mergeIntoWithNoDuplicateKeys(c, b);
    return c;
  };
}

/**
 * Creates a function that invokes two functions and ignores their return vales.
 *
 * @param {function} one Function to invoke first.
 * @param {function} two Function to invoke second.
 * @return {function} Function that invokes the two argument functions.
 * @private
 */
function createChainedFunction(one, two) {
  return function chainedFunction() {
    one.apply(this, arguments);
    two.apply(this, arguments);
  };
}

/**
 * Binds a method to the component.
 *
 * @param {object} component Component whose method is going to be bound.
 * @param {function} method Method to be bound.
 * @return {function} The bound method.
 */
function bindAutoBindMethod(component, method) {
  var boundMethod = method.bind(component);
  if (false) {
    boundMethod.__reactBoundContext = component;
    boundMethod.__reactBoundMethod = method;
    boundMethod.__reactBoundArguments = null;
    var componentName = component.constructor.displayName;
    var _bind = boundMethod.bind;
    boundMethod.bind = function (newThis) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      // User is trying to bind() an autobound method; we effectively will
      // ignore the value of "this" that the user is trying to use, so
      // let's warn.
      if (newThis !== component && newThis !== null) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
      } else if (!args.length) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
        return boundMethod;
      }
      var reboundMethod = _bind.apply(boundMethod, arguments);
      reboundMethod.__reactBoundContext = component;
      reboundMethod.__reactBoundMethod = method;
      reboundMethod.__reactBoundArguments = args;
      return reboundMethod;
    };
  }
  return boundMethod;
}

/**
 * Binds all auto-bound methods in a component.
 *
 * @param {object} component Component whose method is going to be bound.
 */
function bindAutoBindMethods(component) {
  var pairs = component.__reactAutoBindPairs;
  for (var i = 0; i < pairs.length; i += 2) {
    var autoBindKey = pairs[i];
    var method = pairs[i + 1];
    component[autoBindKey] = bindAutoBindMethod(component, method);
  }
}

/**
 * Add more to the ReactClass base class. These are all legacy features and
 * therefore not already part of the modern ReactComponent.
 */
var ReactClassMixin = {

  /**
   * TODO: This will be deprecated because state should always keep a consistent
   * type signature and the only use case for this, is to avoid that.
   */
  replaceState: function (newState, callback) {
    this.updater.enqueueReplaceState(this, newState);
    if (callback) {
      this.updater.enqueueCallback(this, callback, 'replaceState');
    }
  },

  /**
   * Checks whether or not this composite component is mounted.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function () {
    return this.updater.isMounted(this);
  }
};

var ReactClassComponent = function () {};
_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);

/**
 * Module for creating composite components.
 *
 * @class ReactClass
 */
var ReactClass = {

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  createClass: function (spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function (props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (initialState === undefined && this.getInitialState._isMockFunction) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, spec);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  },

  injection: {
    injectMixin: function (mixin) {
      injectedMixins.push(mixin);
    }
  }

};

module.exports = ReactClass;

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactElement = __webpack_require__(80);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 * This is also accessible via `React.DOM`.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactElement = __webpack_require__(80);
var ReactPropTypeLocationNames = __webpack_require__(229);
var ReactPropTypesSecret = __webpack_require__(396);

var emptyFunction = __webpack_require__(37);
var getIteratorFn = __webpack_require__(228);
var warning = __webpack_require__(6);

/**
 * Collection of methods that allow declaration and validation of props that are
 * supplied to React components. Example usage:
 *
 *   var Props = require('ReactPropTypes');
 *   var MyArticle = React.createClass({
 *     propTypes: {
 *       // An optional string prop named "description".
 *       description: Props.string,
 *
 *       // A required enum prop named "category".
 *       category: Props.oneOf(['News','Photos']).isRequired,
 *
 *       // A prop named "dialog" that requires an instance of Dialog.
 *       dialog: Props.instanceOf(Dialog).isRequired
 *     },
 *     render: function() { ... }
 *   });
 *
 * A more formal specification of how these methods are used:
 *
 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
 *   decl := ReactPropTypes.{type}(.isRequired)?
 *
 * Each and every declaration produces a function with the same signature. This
 * allows the creation of custom validation functions. For example:
 *
 *  var MyLink = React.createClass({
 *    propTypes: {
 *      // An optional string or URI prop named "href".
 *      href: function(props, propName, componentName) {
 *        var propValue = props[propName];
 *        if (propValue != null && typeof propValue !== 'string' &&
 *            !(propValue instanceof URI)) {
 *          return new Error(
 *            'Expected a string or an URI for ' + propName + ' in ' +
 *            componentName
 *          );
 *        }
 *      }
 *    },
 *    render: function() {...}
 *  });
 *
 * @internal
 */

var ANONYMOUS = '<<anonymous>>';

var ReactPropTypes = {
  array: createPrimitiveTypeChecker('array'),
  bool: createPrimitiveTypeChecker('boolean'),
  func: createPrimitiveTypeChecker('function'),
  number: createPrimitiveTypeChecker('number'),
  object: createPrimitiveTypeChecker('object'),
  string: createPrimitiveTypeChecker('string'),
  symbol: createPrimitiveTypeChecker('symbol'),

  any: createAnyTypeChecker(),
  arrayOf: createArrayOfTypeChecker,
  element: createElementTypeChecker(),
  instanceOf: createInstanceTypeChecker,
  node: createNodeChecker(),
  objectOf: createObjectOfTypeChecker,
  oneOf: createEnumTypeChecker,
  oneOfType: createUnionTypeChecker,
  shape: createShapeTypeChecker
};

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
/*eslint-disable no-self-compare*/
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    return x !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}
/*eslint-enable no-self-compare*/

/**
 * We use an Error-like object for backward compatibility as people may call
 * PropTypes directly and inspect their output. However we don't use real
 * Errors anymore. We don't inspect their stack anyway, and creating them
 * is prohibitively expensive if they are created too often, such as what
 * happens in oneOfType() for any type before the one that matched.
 */
function PropTypeError(message) {
  this.message = message;
  this.stack = '';
}
// Make `instanceof Error` still work for returned errors.
PropTypeError.prototype = Error.prototype;

function createChainableTypeChecker(validate) {
  if (false) {
    var manualPropTypeCallCache = {};
  }
  function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
    componentName = componentName || ANONYMOUS;
    propFullName = propFullName || propName;
    if (false) {
      if (secret !== ReactPropTypesSecret && typeof console !== 'undefined') {
        var cacheKey = componentName + ':' + propName;
        if (!manualPropTypeCallCache[cacheKey]) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'You are manually calling a React.PropTypes validation ' + 'function for the `%s` prop on `%s`. This is deprecated ' + 'and will not work in production with the next major version. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.', propFullName, componentName) : void 0;
          manualPropTypeCallCache[cacheKey] = true;
        }
      }
    }
    if (props[propName] == null) {
      var locationName = ReactPropTypeLocationNames[location];
      if (isRequired) {
        if (props[propName] === null) {
          return new PropTypeError('The ' + locationName + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
        }
        return new PropTypeError('The ' + locationName + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
      }
      return null;
    } else {
      return validate(props, propName, componentName, location, propFullName);
    }
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}

function createPrimitiveTypeChecker(expectedType) {
  function validate(props, propName, componentName, location, propFullName, secret) {
    var propValue = props[propName];
    var propType = getPropType(propValue);
    if (propType !== expectedType) {
      var locationName = ReactPropTypeLocationNames[location];
      // `propValue` being instance of, say, date/regexp, pass the 'object'
      // check, but we can offer a more precise error message here rather than
      // 'of type `object`'.
      var preciseType = getPreciseType(propValue);

      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createAnyTypeChecker() {
  return createChainableTypeChecker(emptyFunction.thatReturns(null));
}

function createArrayOfTypeChecker(typeChecker) {
  function validate(props, propName, componentName, location, propFullName) {
    if (typeof typeChecker !== 'function') {
      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
    }
    var propValue = props[propName];
    if (!Array.isArray(propValue)) {
      var locationName = ReactPropTypeLocationNames[location];
      var propType = getPropType(propValue);
      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
    }
    for (var i = 0; i < propValue.length; i++) {
      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
      if (error instanceof Error) {
        return error;
      }
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createElementTypeChecker() {
  function validate(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    if (!ReactElement.isValidElement(propValue)) {
      var locationName = ReactPropTypeLocationNames[location];
      var propType = getPropType(propValue);
      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createInstanceTypeChecker(expectedClass) {
  function validate(props, propName, componentName, location, propFullName) {
    if (!(props[propName] instanceof expectedClass)) {
      var locationName = ReactPropTypeLocationNames[location];
      var expectedClassName = expectedClass.name || ANONYMOUS;
      var actualClassName = getClassName(props[propName]);
      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createEnumTypeChecker(expectedValues) {
  if (!Array.isArray(expectedValues)) {
     false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
    return emptyFunction.thatReturnsNull;
  }

  function validate(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    for (var i = 0; i < expectedValues.length; i++) {
      if (is(propValue, expectedValues[i])) {
        return null;
      }
    }

    var locationName = ReactPropTypeLocationNames[location];
    var valuesString = JSON.stringify(expectedValues);
    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
  }
  return createChainableTypeChecker(validate);
}

function createObjectOfTypeChecker(typeChecker) {
  function validate(props, propName, componentName, location, propFullName) {
    if (typeof typeChecker !== 'function') {
      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
    }
    var propValue = props[propName];
    var propType = getPropType(propValue);
    if (propType !== 'object') {
      var locationName = ReactPropTypeLocationNames[location];
      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
    }
    for (var key in propValue) {
      if (propValue.hasOwnProperty(key)) {
        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createUnionTypeChecker(arrayOfTypeCheckers) {
  if (!Array.isArray(arrayOfTypeCheckers)) {
     false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
    return emptyFunction.thatReturnsNull;
  }

  function validate(props, propName, componentName, location, propFullName) {
    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
        return null;
      }
    }

    var locationName = ReactPropTypeLocationNames[location];
    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
  }
  return createChainableTypeChecker(validate);
}

function createNodeChecker() {
  function validate(props, propName, componentName, location, propFullName) {
    if (!isNode(props[propName])) {
      var locationName = ReactPropTypeLocationNames[location];
      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createShapeTypeChecker(shapeTypes) {
  function validate(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    var propType = getPropType(propValue);
    if (propType !== 'object') {
      var locationName = ReactPropTypeLocationNames[location];
      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
    }
    for (var key in shapeTypes) {
      var checker = shapeTypes[key];
      if (!checker) {
        continue;
      }
      var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
      if (error) {
        return error;
      }
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function isNode(propValue) {
  switch (typeof propValue) {
    case 'number':
    case 'string':
    case 'undefined':
      return true;
    case 'boolean':
      return !propValue;
    case 'object':
      if (Array.isArray(propValue)) {
        return propValue.every(isNode);
      }
      if (propValue === null || ReactElement.isValidElement(propValue)) {
        return true;
      }

      var iteratorFn = getIteratorFn(propValue);
      if (iteratorFn) {
        var iterator = iteratorFn.call(propValue);
        var step;
        if (iteratorFn !== propValue.entries) {
          while (!(step = iterator.next()).done) {
            if (!isNode(step.value)) {
              return false;
            }
          }
        } else {
          // Iterator will provide entry [k,v] tuples rather than values.
          while (!(step = iterator.next()).done) {
            var entry = step.value;
            if (entry) {
              if (!isNode(entry[1])) {
                return false;
              }
            }
          }
        }
      } else {
        return false;
      }

      return true;
    default:
      return false;
  }
}

function isSymbol(propType, propValue) {
  // Native Symbol.
  if (propType === 'symbol') {
    return true;
  }

  // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
  if (propValue['@@toStringTag'] === 'Symbol') {
    return true;
  }

  // Fallback for non-spec compliant Symbols which are polyfilled.
  if (typeof Symbol === 'function' && propValue instanceof Symbol) {
    return true;
  }

  return false;
}

// Equivalent of `typeof` but with special handling for array and regexp.
function getPropType(propValue) {
  var propType = typeof propValue;
  if (Array.isArray(propValue)) {
    return 'array';
  }
  if (propValue instanceof RegExp) {
    // Old webkits (at least until Android 4.0) return 'function' rather than
    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
    // passes PropTypes.object.
    return 'object';
  }
  if (isSymbol(propType, propValue)) {
    return 'symbol';
  }
  return propType;
}

// This handles more types than `getPropType`. Only used for error messages.
// See `createPrimitiveTypeChecker`.
function getPreciseType(propValue) {
  var propType = getPropType(propValue);
  if (propType === 'object') {
    if (propValue instanceof Date) {
      return 'date';
    } else if (propValue instanceof RegExp) {
      return 'regexp';
    }
  }
  return propType;
}

// Returns class name of the object, if any.
function getClassName(propValue) {
  if (!propValue.constructor || !propValue.constructor.name) {
    return ANONYMOUS;
  }
  return propValue.constructor.name;
}

module.exports = ReactPropTypes;

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.4.2';

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */


var _prodInvariant = __webpack_require__(79);

var ReactElement = __webpack_require__(80);

var invariant = __webpack_require__(5);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/



var ReactDOMComponentTree = __webpack_require__(21);
var ReactDefaultInjection = __webpack_require__(400);
var ReactMount = __webpack_require__(252);
var ReactReconciler = __webpack_require__(83);
var ReactUpdates = __webpack_require__(40);
var ReactVersion = __webpack_require__(472);

var findDOMNode = __webpack_require__(473);
var getHostComponentFromComposite = __webpack_require__(253);
var renderSubtreeIntoContainer = __webpack_require__(474);
var warning = __webpack_require__(6);

ReactDefaultInjection.inject();

var ReactDOM = {
  findDOMNode: findDOMNode,
  render: ReactMount.render,
  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
  version: ReactVersion,

  /* eslint-disable camelcase */
  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
};

// Inject the runtime into a devtools global hook regardless of browser.
// Allows for debugging when the hook is injected on the page.
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
    ComponentTree: {
      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
      getNodeFromInstance: function (inst) {
        // inst is an internal instance (but could be a composite)
        if (inst._renderedComponent) {
          inst = getHostComponentFromComposite(inst);
        }
        if (inst) {
          return ReactDOMComponentTree.getNodeFromInstance(inst);
        } else {
          return null;
        }
      }
    },
    Mount: ReactMount,
    Reconciler: ReactReconciler
  });
}

if (false) {
  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {

    // First check if devtools is not installed
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
      // If we're in Chrome or Firefox, provide a download link if not installed.
      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
        // Firefox does not have the issue with devtools loaded over file://
        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
      }
    }

    var testFunc = function testFn() {};
    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;

    // If we're in IE8, check to see if we are in compatibility mode and provide
    // information on preventing compatibility mode
    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;

    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;

    var expectedFeatures = [
    // shims
    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];

    for (var i = 0; i < expectedFeatures.length; i++) {
      if (!expectedFeatures[i]) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
        break;
      }
    }
  }
}

if (false) {
  var ReactInstrumentation = require('./ReactInstrumentation');
  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');

  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
}

module.exports = ReactDOM;

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ARIADOMPropertyConfig = __webpack_require__(401);
var BeforeInputEventPlugin = __webpack_require__(402);
var ChangeEventPlugin = __webpack_require__(406);
var DefaultEventPluginOrder = __webpack_require__(409);
var EnterLeaveEventPlugin = __webpack_require__(410);
var HTMLDOMPropertyConfig = __webpack_require__(411);
var ReactComponentBrowserEnvironment = __webpack_require__(412);
var ReactDOMComponent = __webpack_require__(418);
var ReactDOMComponentTree = __webpack_require__(21);
var ReactDOMEmptyComponent = __webpack_require__(443);
var ReactDOMTreeTraversal = __webpack_require__(444);
var ReactDOMTextComponent = __webpack_require__(445);
var ReactDefaultBatchingStrategy = __webpack_require__(446);
var ReactEventListener = __webpack_require__(447);
var ReactInjection = __webpack_require__(449);
var ReactReconcileTransaction = __webpack_require__(450);
var SVGDOMPropertyConfig = __webpack_require__(456);
var SelectEventPlugin = __webpack_require__(457);
var SimpleEventPlugin = __webpack_require__(458);

var alreadyInjected = false;

function inject() {
  if (alreadyInjected) {
    // TODO: This is currently true because these injections are shared between
    // the client and the server package. They should be built independently
    // and not share any injection state. Then this problem will be solved.
    return;
  }
  alreadyInjected = true;

  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);

  /**
   * Inject modules for resolving DOM hierarchy and plugin ordering.
   */
  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);

  /**
   * Some important event plugins included by default (without having to require
   * them).
   */
  ReactInjection.EventPluginHub.injectEventPluginsByName({
    SimpleEventPlugin: SimpleEventPlugin,
    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
    ChangeEventPlugin: ChangeEventPlugin,
    SelectEventPlugin: SelectEventPlugin,
    BeforeInputEventPlugin: BeforeInputEventPlugin
  });

  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);

  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);

  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
    return new ReactDOMEmptyComponent(instantiate);
  });

  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);

  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
}

module.exports = {
  inject: inject
};

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ARIADOMPropertyConfig = {
  Properties: {
    // Global States and Properties
    'aria-current': 0, // state
    'aria-details': 0,
    'aria-disabled': 0, // state
    'aria-hidden': 0, // state
    'aria-invalid': 0, // state
    'aria-keyshortcuts': 0,
    'aria-label': 0,
    'aria-roledescription': 0,
    // Widget Attributes
    'aria-autocomplete': 0,
    'aria-checked': 0,
    'aria-expanded': 0,
    'aria-haspopup': 0,
    'aria-level': 0,
    'aria-modal': 0,
    'aria-multiline': 0,
    'aria-multiselectable': 0,
    'aria-orientation': 0,
    'aria-placeholder': 0,
    'aria-pressed': 0,
    'aria-readonly': 0,
    'aria-required': 0,
    'aria-selected': 0,
    'aria-sort': 0,
    'aria-valuemax': 0,
    'aria-valuemin': 0,
    'aria-valuenow': 0,
    'aria-valuetext': 0,
    // Live Region Attributes
    'aria-atomic': 0,
    'aria-busy': 0,
    'aria-live': 0,
    'aria-relevant': 0,
    // Drag-and-Drop Attributes
    'aria-dropeffect': 0,
    'aria-grabbed': 0,
    // Relationship Attributes
    'aria-activedescendant': 0,
    'aria-colcount': 0,
    'aria-colindex': 0,
    'aria-colspan': 0,
    'aria-controls': 0,
    'aria-describedby': 0,
    'aria-errormessage': 0,
    'aria-flowto': 0,
    'aria-labelledby': 0,
    'aria-owns': 0,
    'aria-posinset': 0,
    'aria-rowcount': 0,
    'aria-rowindex': 0,
    'aria-rowspan': 0,
    'aria-setsize': 0
  },
  DOMAttributeNames: {},
  DOMPropertyNames: {}
};

module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(100);
var ExecutionEnvironment = __webpack_require__(31);
var FallbackCompositionState = __webpack_require__(403);
var SyntheticCompositionEvent = __webpack_require__(404);
var SyntheticInputEvent = __webpack_require__(405);

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
var START_KEYCODE = 229;

var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;

var documentMode = null;
if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
}

// Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.
var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();

// In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.
var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);

/**
 * Opera <= 12 includes TextEvent in window, but does not fire
 * text input events. Rely on keypress instead.
 */
function isPresto() {
  var opera = window.opera;
  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
}

var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

// Events and their corresponding property names.
var eventTypes = {
  beforeInput: {
    phasedRegistrationNames: {
      bubbled: 'onBeforeInput',
      captured: 'onBeforeInputCapture'
    },
    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
  },
  compositionEnd: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionEnd',
      captured: 'onCompositionEndCapture'
    },
    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionStart: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionStart',
      captured: 'onCompositionStartCapture'
    },
    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionUpdate: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionUpdate',
      captured: 'onCompositionUpdateCapture'
    },
    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  }
};

// Track whether we've ever handled a keypress on the space key.
var hasSpaceKeypress = false;

/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */
function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}

/**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */
function getCompositionEventType(topLevelType) {
  switch (topLevelType) {
    case 'topCompositionStart':
      return eventTypes.compositionStart;
    case 'topCompositionEnd':
      return eventTypes.compositionEnd;
    case 'topCompositionUpdate':
      return eventTypes.compositionUpdate;
  }
}

/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionStart(topLevelType, nativeEvent) {
  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
}

/**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionEnd(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topKeyUp':
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
    case 'topKeyDown':
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;
    case 'topKeyPress':
    case 'topMouseDown':
    case 'topBlur':
      // Events are not possible without cancelling IME.
      return true;
    default:
      return false;
  }
}

/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */
function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;
  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }
  return null;
}

// Track the current IME composition fallback object, if any.
var currentComposition = null;

/**
 * @return {?object} A SyntheticCompositionEvent.
 */
function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(topLevelType);
  } else if (!currentComposition) {
    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
      eventType = eventTypes.compositionStart;
    }
  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
    eventType = eventTypes.compositionEnd;
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!currentComposition && eventType === eventTypes.compositionStart) {
      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
    } else if (eventType === eventTypes.compositionEnd) {
      if (currentComposition) {
        fallbackData = currentComposition.getData();
      }
    }
  }

  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);

  if (fallbackData) {
    // Inject data generated from fallback path into the synthetic event.
    // This matches the property of native CompositionEventInterface.
    event.data = fallbackData;
  } else {
    var customData = getDataFromCustomEvent(nativeEvent);
    if (customData !== null) {
      event.data = customData;
    }
  }

  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */
function getNativeBeforeInputChars(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topCompositionEnd':
      return getDataFromCustomEvent(nativeEvent);
    case 'topKeyPress':
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;
      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case 'topTextInput':
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data;

      // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to blacklist it.
      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}

/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */
function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  // If composition event is available, we extract a string only at
  // compositionevent, otherwise extract it at fallback events.
  if (currentComposition) {
    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
      var chars = currentComposition.getData();
      FallbackCompositionState.release(currentComposition);
      currentComposition = null;
      return chars;
    }
    return null;
  }

  switch (topLevelType) {
    case 'topPaste':
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;
    case 'topKeyPress':
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
        return String.fromCharCode(nativeEvent.which);
      }
      return null;
    case 'topCompositionEnd':
      return useFallbackCompositionData ? null : nativeEvent.data;
    default:
      return null;
  }
}

/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */
function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
  }

  // If no characters are being inserted, no BeforeInput event should
  // be fired.
  if (!chars) {
    return null;
  }

  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);

  event.data = chars;
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */
var BeforeInputEventPlugin = {

  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
  }
};

module.exports = BeforeInputEventPlugin;

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(15);

var PooledClass = __webpack_require__(65);

var getTextContentAccessor = __webpack_require__(233);

/**
 * This helper class stores information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 * @param {DOMEventTarget} root
 */
function FallbackCompositionState(root) {
  this._root = root;
  this._startText = this.getText();
  this._fallbackText = null;
}

_assign(FallbackCompositionState.prototype, {
  destructor: function () {
    this._root = null;
    this._startText = null;
    this._fallbackText = null;
  },

  /**
   * Get current text of input.
   *
   * @return {string}
   */
  getText: function () {
    if ('value' in this._root) {
      return this._root.value;
    }
    return this._root[getTextContentAccessor()];
  },

  /**
   * Determine the differing substring between the initially stored
   * text content and the current content.
   *
   * @return {string}
   */
  getData: function () {
    if (this._fallbackText) {
      return this._fallbackText;
    }

    var start;
    var startValue = this._startText;
    var startLength = startValue.length;
    var end;
    var endValue = this.getText();
    var endLength = endValue.length;

    for (start = 0; start < startLength; start++) {
      if (startValue[start] !== endValue[start]) {
        break;
      }
    }

    var minEnd = startLength - start;
    for (end = 1; end <= minEnd; end++) {
      if (startValue[startLength - end] !== endValue[endLength - end]) {
        break;
      }
    }

    var sliceTail = end > 1 ? 1 - end : undefined;
    this._fallbackText = endValue.slice(start, sliceTail);
    return this._fallbackText;
  }
});

PooledClass.addPoolingTo(FallbackCompositionState);

module.exports = FallbackCompositionState;

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(50);

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */
var CompositionEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);

module.exports = SyntheticCompositionEvent;

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(50);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
var InputEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);

module.exports = SyntheticInputEvent;

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(101);
var EventPropagators = __webpack_require__(100);
var ExecutionEnvironment = __webpack_require__(31);
var ReactDOMComponentTree = __webpack_require__(21);
var ReactUpdates = __webpack_require__(40);
var SyntheticEvent = __webpack_require__(50);

var getEventTarget = __webpack_require__(163);
var isEventSupported = __webpack_require__(164);
var isTextInputElement = __webpack_require__(236);

var eventTypes = {
  change: {
    phasedRegistrationNames: {
      bubbled: 'onChange',
      captured: 'onChangeCapture'
    },
    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
  }
};

/**
 * For IE shims
 */
var activeElement = null;
var activeElementInst = null;
var activeElementValue = null;
var activeElementValueProp = null;

/**
 * SECTION: handle `change` event
 */
function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

var doesChangeEventBubble = false;
if (ExecutionEnvironment.canUseDOM) {
  // See `handleChange` comment below
  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
}

function manualDispatchChangeEvent(nativeEvent) {
  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
  EventPropagators.accumulateTwoPhaseDispatches(event);

  // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.
  ReactUpdates.batchedUpdates(runEventInBatch, event);
}

function runEventInBatch(event) {
  EventPluginHub.enqueueEvents(event);
  EventPluginHub.processEventQueue(false);
}

function startWatchingForChangeEventIE8(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
}

function stopWatchingForChangeEventIE8() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
  activeElement = null;
  activeElementInst = null;
}

function getTargetInstForChangeEvent(topLevelType, targetInst) {
  if (topLevelType === 'topChange') {
    return targetInst;
  }
}
function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForChangeEventIE8();
    startWatchingForChangeEventIE8(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForChangeEventIE8();
  }
}

/**
 * SECTION: handle `input` event
 */
var isInputEventSupported = false;
if (ExecutionEnvironment.canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events.
  // IE10+ fire input events to often, such when a placeholder
  // changes or when an input with a placeholder is focused.
  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 11);
}

/**
 * (For IE <=11) Replacement getter/setter for the `value` property that gets
 * set on the active element.
 */
var newValueProp = {
  get: function () {
    return activeElementValueProp.get.call(this);
  },
  set: function (val) {
    // Cast to a string so we can do equality checks.
    activeElementValue = '' + val;
    activeElementValueProp.set.call(this, val);
  }
};

/**
 * (For IE <=11) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */
function startWatchingForValueChange(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElementValue = target.value;
  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');

  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
  // on DOM elements
  Object.defineProperty(activeElement, 'value', newValueProp);
  if (activeElement.attachEvent) {
    activeElement.attachEvent('onpropertychange', handlePropertyChange);
  } else {
    activeElement.addEventListener('propertychange', handlePropertyChange, false);
  }
}

/**
 * (For IE <=11) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */
function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }

  // delete restores the original property definition
  delete activeElement.value;

  if (activeElement.detachEvent) {
    activeElement.detachEvent('onpropertychange', handlePropertyChange);
  } else {
    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
  }

  activeElement = null;
  activeElementInst = null;
  activeElementValue = null;
  activeElementValueProp = null;
}

/**
 * (For IE <=11) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */
function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }
  var value = nativeEvent.srcElement.value;
  if (value === activeElementValue) {
    return;
  }
  activeElementValue = value;

  manualDispatchChangeEvent(nativeEvent);
}

/**
 * If a `change` event should be fired, returns the target's ID.
 */
function getTargetInstForInputEvent(topLevelType, targetInst) {
  if (topLevelType === 'topInput') {
    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
    // what we want so fall through here and trigger an abstract event
    return targetInst;
  }
}

function handleEventsForInputEventIE(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // In IE8, we can capture almost all .value changes by adding a
    // propertychange handler and looking for events with propertyName
    // equal to 'value'
    // In IE9-11, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForValueChange();
  }
}

// For IE8 and IE9.
function getTargetInstForInputEventIE(topLevelType, targetInst) {
  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    if (activeElement && activeElement.value !== activeElementValue) {
      activeElementValue = activeElement.value;
      return activeElementInst;
    }
  }
}

/**
 * SECTION: handle `click` event
 */
function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetInstForClickEvent(topLevelType, targetInst) {
  if (topLevelType === 'topClick') {
    return targetInst;
  }
}

/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */
var ChangeEventPlugin = {

  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    var getTargetInstFunc, handleEventFunc;
    if (shouldUseChangeEvent(targetNode)) {
      if (doesChangeEventBubble) {
        getTargetInstFunc = getTargetInstForChangeEvent;
      } else {
        handleEventFunc = handleEventsForChangeEventIE8;
      }
    } else if (isTextInputElement(targetNode)) {
      if (isInputEventSupported) {
        getTargetInstFunc = getTargetInstForInputEvent;
      } else {
        getTargetInstFunc = getTargetInstForInputEventIE;
        handleEventFunc = handleEventsForInputEventIE;
      }
    } else if (shouldUseClickEvent(targetNode)) {
      getTargetInstFunc = getTargetInstForClickEvent;
    }

    if (getTargetInstFunc) {
      var inst = getTargetInstFunc(topLevelType, targetInst);
      if (inst) {
        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
        event.type = 'change';
        EventPropagators.accumulateTwoPhaseDispatches(event);
        return event;
      }
    }

    if (handleEventFunc) {
      handleEventFunc(topLevelType, targetNode, targetInst);
    }
  }

};

module.exports = ChangeEventPlugin;

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactOwner = __webpack_require__(408);

var ReactRef = {};

function attachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(component.getPublicInstance());
  } else {
    // Legacy ref
    ReactOwner.addComponentAsRefTo(component, ref, owner);
  }
}

function detachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(null);
  } else {
    // Legacy ref
    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
  }
}

ReactRef.attachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    attachRef(ref, instance, element._owner);
  }
};

ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
  // If either the owner or a `ref` has changed, make sure the newest owner
  // has stored a reference to `this`, and the previous owner (if different)
  // has forgotten the reference to `this`. We use the element instead
  // of the public this.props because the post processing cannot determine
  // a ref. The ref conceptually lives on the element.

  // TODO: Should this even be possible? The owner cannot change because
  // it's forbidden by shouldUpdateReactComponent. The ref can change
  // if you swap the keys of but not the refs. Reconsider where this check
  // is made. It probably belongs where the key checking and
  // instantiateReactComponent is done.

  var prevRef = null;
  var prevOwner = null;
  if (prevElement !== null && typeof prevElement === 'object') {
    prevRef = prevElement.ref;
    prevOwner = prevElement._owner;
  }

  var nextRef = null;
  var nextOwner = null;
  if (nextElement !== null && typeof nextElement === 'object') {
    nextRef = nextElement.ref;
    nextOwner = nextElement._owner;
  }

  return prevRef !== nextRef ||
  // If owner changes but we have an unchanged function ref, don't update refs
  typeof nextRef === 'string' && nextOwner !== prevOwner;
};

ReactRef.detachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    detachRef(ref, instance, element._owner);
  }
};

module.exports = ReactRef;

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(7);

var invariant = __webpack_require__(5);

/**
 * @param {?object} object
 * @return {boolean} True if `object` is a valid owner.
 * @final
 */
function isValidOwner(object) {
  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
}

/**
 * ReactOwners are capable of storing references to owned components.
 *
 * All components are capable of //being// referenced by owner components, but
 * only ReactOwner components are capable of //referencing// owned components.
 * The named reference is known as a "ref".
 *
 * Refs are available when mounted and updated during reconciliation.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return (
 *         <div onClick={this.handleClick}>
 *           <CustomComponent ref="custom" />
 *         </div>
 *       );
 *     },
 *     handleClick: function() {
 *       this.refs.custom.handleClick();
 *     },
 *     componentDidMount: function() {
 *       this.refs.custom.initialize();
 *     }
 *   });
 *
 * Refs should rarely be used. When refs are used, they should only be done to
 * control data that is not handled by React's data flow.
 *
 * @class ReactOwner
 */
var ReactOwner = {
  /**
   * Adds a component by ref to an owner component.
   *
   * @param {ReactComponent} component Component to reference.
   * @param {string} ref Name by which to refer to the component.
   * @param {ReactOwner} owner Component on which to record the ref.
   * @final
   * @internal
   */
  addComponentAsRefTo: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
    owner.attachRef(ref, component);
  },

  /**
   * Removes a component by ref from an owner component.
   *
   * @param {ReactComponent} component Component to dereference.
   * @param {string} ref Name of the ref to remove.
   * @param {ReactOwner} owner Component on which the ref is recorded.
   * @final
   * @internal
   */
  removeComponentAsRefFrom: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
    var ownerPublicInstance = owner.getPublicInstance();
    // Check that `component`'s owner is still alive and that `component` is still the current ref
    // because we do not want to detach the ref if another component stole it.
    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
      owner.detachRef(ref);
    }
  }

};

module.exports = ReactOwner;

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */

var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];

module.exports = DefaultEventPluginOrder;

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(100);
var ReactDOMComponentTree = __webpack_require__(21);
var SyntheticMouseEvent = __webpack_require__(119);

var eventTypes = {
  mouseEnter: {
    registrationName: 'onMouseEnter',
    dependencies: ['topMouseOut', 'topMouseOver']
  },
  mouseLeave: {
    registrationName: 'onMouseLeave',
    dependencies: ['topMouseOut', 'topMouseOver']
  }
};

var EnterLeaveEventPlugin = {

  eventTypes: eventTypes,

  /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
      return null;
    }
    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
      // Must not be a mouse in or mouse out - ignoring.
      return null;
    }

    var win;
    if (nativeEventTarget.window === nativeEventTarget) {
      // `nativeEventTarget` is probably a window object.
      win = nativeEventTarget;
    } else {
      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
      var doc = nativeEventTarget.ownerDocument;
      if (doc) {
        win = doc.defaultView || doc.parentWindow;
      } else {
        win = window;
      }
    }

    var from;
    var to;
    if (topLevelType === 'topMouseOut') {
      from = targetInst;
      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
    } else {
      // Moving to a node from outside the window.
      from = null;
      to = targetInst;
    }

    if (from === to) {
      // Nothing pertains to our managed components.
      return null;
    }

    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);

    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
    leave.type = 'mouseleave';
    leave.target = fromNode;
    leave.relatedTarget = toNode;

    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
    enter.type = 'mouseenter';
    enter.target = toNode;
    enter.relatedTarget = fromNode;

    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);

    return [leave, enter];
  }

};

module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(82);

var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

var HTMLDOMPropertyConfig = {
  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
  Properties: {
    /**
     * Standard Properties
     */
    accept: 0,
    acceptCharset: 0,
    accessKey: 0,
    action: 0,
    allowFullScreen: HAS_BOOLEAN_VALUE,
    allowTransparency: 0,
    alt: 0,
    // specifies target context for links with `preload` type
    as: 0,
    async: HAS_BOOLEAN_VALUE,
    autoComplete: 0,
    // autoFocus is polyfilled/normalized by AutoFocusUtils
    // autoFocus: HAS_BOOLEAN_VALUE,
    autoPlay: HAS_BOOLEAN_VALUE,
    capture: HAS_BOOLEAN_VALUE,
    cellPadding: 0,
    cellSpacing: 0,
    charSet: 0,
    challenge: 0,
    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    cite: 0,
    classID: 0,
    className: 0,
    cols: HAS_POSITIVE_NUMERIC_VALUE,
    colSpan: 0,
    content: 0,
    contentEditable: 0,
    contextMenu: 0,
    controls: HAS_BOOLEAN_VALUE,
    coords: 0,
    crossOrigin: 0,
    data: 0, // For `<object />` acts as `src`.
    dateTime: 0,
    'default': HAS_BOOLEAN_VALUE,
    defer: HAS_BOOLEAN_VALUE,
    dir: 0,
    disabled: HAS_BOOLEAN_VALUE,
    download: HAS_OVERLOADED_BOOLEAN_VALUE,
    draggable: 0,
    encType: 0,
    form: 0,
    formAction: 0,
    formEncType: 0,
    formMethod: 0,
    formNoValidate: HAS_BOOLEAN_VALUE,
    formTarget: 0,
    frameBorder: 0,
    headers: 0,
    height: 0,
    hidden: HAS_BOOLEAN_VALUE,
    high: 0,
    href: 0,
    hrefLang: 0,
    htmlFor: 0,
    httpEquiv: 0,
    icon: 0,
    id: 0,
    inputMode: 0,
    integrity: 0,
    is: 0,
    keyParams: 0,
    keyType: 0,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: HAS_BOOLEAN_VALUE,
    low: 0,
    manifest: 0,
    marginHeight: 0,
    marginWidth: 0,
    max: 0,
    maxLength: 0,
    media: 0,
    mediaGroup: 0,
    method: 0,
    min: 0,
    minLength: 0,
    // Caution; `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`.
    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    name: 0,
    nonce: 0,
    noValidate: HAS_BOOLEAN_VALUE,
    open: HAS_BOOLEAN_VALUE,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: HAS_BOOLEAN_VALUE,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 0,
    readOnly: HAS_BOOLEAN_VALUE,
    referrerPolicy: 0,
    rel: 0,
    required: HAS_BOOLEAN_VALUE,
    reversed: HAS_BOOLEAN_VALUE,
    role: 0,
    rows: HAS_POSITIVE_NUMERIC_VALUE,
    rowSpan: HAS_NUMERIC_VALUE,
    sandbox: 0,
    scope: 0,
    scoped: HAS_BOOLEAN_VALUE,
    scrolling: 0,
    seamless: HAS_BOOLEAN_VALUE,
    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    shape: 0,
    size: HAS_POSITIVE_NUMERIC_VALUE,
    sizes: 0,
    span: HAS_POSITIVE_NUMERIC_VALUE,
    spellCheck: 0,
    src: 0,
    srcDoc: 0,
    srcLang: 0,
    srcSet: 0,
    start: HAS_NUMERIC_VALUE,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 0,
    target: 0,
    title: 0,
    // Setting .type throws on non-<input> tags
    type: 0,
    useMap: 0,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,

    /**
     * RDFa Properties
     */
    about: 0,
    datatype: 0,
    inlist: 0,
    prefix: 0,
    // property is also supported for OpenGraph in meta tags.
    property: 0,
    resource: 0,
    'typeof': 0,
    vocab: 0,

    /**
     * Non-standard Properties
     */
    // autoCapitalize and autoCorrect are supported in Mobile Safari for
    // keyboard hints.
    autoCapitalize: 0,
    autoCorrect: 0,
    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
    autoSave: 0,
    // color is for Safari mask-icon link
    color: 0,
    // itemProp, itemScope, itemType are for
    // Microdata support. See http://schema.org/docs/gs.html
    itemProp: 0,
    itemScope: HAS_BOOLEAN_VALUE,
    itemType: 0,
    // itemID and itemRef are for Microdata support as well but
    // only specified in the WHATWG spec document. See
    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
    itemID: 0,
    itemRef: 0,
    // results show looking glass icon and recent searches on input
    // search fields in WebKit/Blink
    results: 0,
    // IE-only attribute that specifies security restrictions on an iframe
    // as an alternative to the sandbox attribute on IE<10
    security: 0,
    // IE-only attribute that controls focus behavior
    unselectable: 0
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  },
  DOMPropertyNames: {}
};

module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMChildrenOperations = __webpack_require__(166);
var ReactDOMIDOperations = __webpack_require__(417);

/**
 * Abstracts away all functionality of the reconciler that requires knowledge of
 * the browser context. TODO: These callers should be refactored to avoid the
 * need for this injection.
 */
var ReactComponentBrowserEnvironment = {

  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup

};

module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var DOMLazyTree = __webpack_require__(84);
var ExecutionEnvironment = __webpack_require__(31);

var createNodesFromMarkup = __webpack_require__(414);
var emptyFunction = __webpack_require__(37);
var invariant = __webpack_require__(5);

var Danger = {

  /**
   * Replaces a node with a string of markup at its current position within its
   * parent. The markup must render into a single root node.
   *
   * @param {DOMElement} oldChild Child node to replace.
   * @param {string} markup Markup to render in place of the child node.
   * @internal
   */
  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;

    if (typeof markup === 'string') {
      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
      oldChild.parentNode.replaceChild(newChild, oldChild);
    } else {
      DOMLazyTree.replaceChildWithTree(oldChild, markup);
    }
  }

};

module.exports = Danger;

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/*eslint-disable fb-www/unsafe-html*/

var ExecutionEnvironment = __webpack_require__(31);

var createArrayFromMixed = __webpack_require__(415);
var getMarkupWrap = __webpack_require__(416);
var invariant = __webpack_require__(5);

/**
 * Dummy container used to render all markup.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Pattern used by `getNodeName`.
 */
var nodeNamePattern = /^\s*<(\w+)/;

/**
 * Extracts the `nodeName` of the first element in a string of markup.
 *
 * @param {string} markup String of markup.
 * @return {?string} Node name of the supplied markup.
 */
function getNodeName(markup) {
  var nodeNameMatch = markup.match(nodeNamePattern);
  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
}

/**
 * Creates an array containing the nodes rendered from the supplied markup. The
 * optionally supplied `handleScript` function will be invoked once for each
 * <script> element that is rendered. If no `handleScript` function is supplied,
 * an exception is thrown if any <script> elements are rendered.
 *
 * @param {string} markup A string of valid HTML markup.
 * @param {?function} handleScript Invoked once for each rendered <script>.
 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
 */
function createNodesFromMarkup(markup, handleScript) {
  var node = dummyNode;
  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
  var nodeName = getNodeName(markup);

  var wrap = nodeName && getMarkupWrap(nodeName);
  if (wrap) {
    node.innerHTML = wrap[1] + markup + wrap[2];

    var wrapDepth = wrap[0];
    while (wrapDepth--) {
      node = node.lastChild;
    }
  } else {
    node.innerHTML = markup;
  }

  var scripts = node.getElementsByTagName('script');
  if (scripts.length) {
    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
    createArrayFromMixed(scripts).forEach(handleScript);
  }

  var nodes = Array.from(node.childNodes);
  while (node.lastChild) {
    node.removeChild(node.lastChild);
  }
  return nodes;
}

module.exports = createNodesFromMarkup;

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var invariant = __webpack_require__(5);

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;

  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;

  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;

  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/*eslint-disable fb-www/unsafe-html */

var ExecutionEnvironment = __webpack_require__(31);

var invariant = __webpack_require__(5);

/**
 * Dummy container used to detect which wraps are necessary.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Some browsers cannot use `innerHTML` to render certain elements standalone,
 * so we wrap them, render the wrapped nodes, then extract the desired node.
 *
 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
 */

var shouldWrap = {};

var selectWrap = [1, '<select multiple="true">', '</select>'];
var tableWrap = [1, '<table>', '</table>'];
var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];

var markupWrap = {
  '*': [1, '?<div>', '</div>'],

  'area': [1, '<map>', '</map>'],
  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  'legend': [1, '<fieldset>', '</fieldset>'],
  'param': [1, '<object>', '</object>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],

  'optgroup': selectWrap,
  'option': selectWrap,

  'caption': tableWrap,
  'colgroup': tableWrap,
  'tbody': tableWrap,
  'tfoot': tableWrap,
  'thead': tableWrap,

  'td': trWrap,
  'th': trWrap
};

// Initialize the SVG elements since we know they'll always need to be wrapped
// consistently. If they are created inside a <div> they will be initialized in
// the wrong namespace (and will not display).
var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
svgElements.forEach(function (nodeName) {
  markupWrap[nodeName] = svgWrap;
  shouldWrap[nodeName] = true;
});

/**
 * Gets the markup wrap configuration for the supplied `nodeName`.
 *
 * NOTE: This lazily detects which wraps are necessary for the current browser.
 *
 * @param {string} nodeName Lowercase `nodeName`.
 * @return {?array} Markup wrap configuration, if applicable.
 */
function getMarkupWrap(nodeName) {
  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
  if (!markupWrap.hasOwnProperty(nodeName)) {
    nodeName = '*';
  }
  if (!shouldWrap.hasOwnProperty(nodeName)) {
    if (nodeName === '*') {
      dummyNode.innerHTML = '<link />';
    } else {
      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
    }
    shouldWrap[nodeName] = !dummyNode.firstChild;
  }
  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
}

module.exports = getMarkupWrap;

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMChildrenOperations = __webpack_require__(166);
var ReactDOMComponentTree = __webpack_require__(21);

/**
 * Operations used to process updates to DOM nodes.
 */
var ReactDOMIDOperations = {

  /**
   * Updates a component's children by processing a series of updates.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
    DOMChildrenOperations.processUpdates(node, updates);
  }
};

module.exports = ReactDOMIDOperations;

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* global hasOwnProperty:true */



var _prodInvariant = __webpack_require__(7),
    _assign = __webpack_require__(15);

var AutoFocusUtils = __webpack_require__(419);
var CSSPropertyOperations = __webpack_require__(420);
var DOMLazyTree = __webpack_require__(84);
var DOMNamespaces = __webpack_require__(167);
var DOMProperty = __webpack_require__(82);
var DOMPropertyOperations = __webpack_require__(241);
var EventPluginHub = __webpack_require__(101);
var EventPluginRegistry = __webpack_require__(160);
var ReactBrowserEventEmitter = __webpack_require__(122);
var ReactDOMComponentFlags = __webpack_require__(230);
var ReactDOMComponentTree = __webpack_require__(21);
var ReactDOMInput = __webpack_require__(430);
var ReactDOMOption = __webpack_require__(432);
var ReactDOMSelect = __webpack_require__(242);
var ReactDOMTextarea = __webpack_require__(433);
var ReactInstrumentation = __webpack_require__(38);
var ReactMultiChild = __webpack_require__(434);
var ReactServerRenderingTransaction = __webpack_require__(441);

var emptyFunction = __webpack_require__(37);
var escapeTextContentForBrowser = __webpack_require__(121);
var invariant = __webpack_require__(5);
var isEventSupported = __webpack_require__(164);
var shallowEqual = __webpack_require__(171);
var validateDOMNesting = __webpack_require__(175);
var warning = __webpack_require__(6);

var Flags = ReactDOMComponentFlags;
var deleteListener = EventPluginHub.deleteListener;
var getNode = ReactDOMComponentTree.getNodeFromInstance;
var listenTo = ReactBrowserEventEmitter.listenTo;
var registrationNameModules = EventPluginRegistry.registrationNameModules;

// For quickly matching children type, to test if can be treated as content.
var CONTENT_TYPES = { 'string': true, 'number': true };

var STYLE = 'style';
var HTML = '__html';
var RESERVED_PROPS = {
  children: null,
  dangerouslySetInnerHTML: null,
  suppressContentEditableWarning: null
};

// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
var DOC_FRAGMENT_TYPE = 11;

function getDeclarationErrorAddendum(internalInstance) {
  if (internalInstance) {
    var owner = internalInstance._currentElement._owner || null;
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' This DOM node was rendered by `' + name + '`.';
      }
    }
  }
  return '';
}

function friendlyStringify(obj) {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return '[' + obj.map(friendlyStringify).join(', ') + ']';
    } else {
      var pairs = [];
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
        }
      }
      return '{' + pairs.join(', ') + '}';
    }
  } else if (typeof obj === 'string') {
    return JSON.stringify(obj);
  } else if (typeof obj === 'function') {
    return '[function object]';
  }
  // Differs from JSON.stringify in that undefined because undefined and that
  // inf and nan don't become null
  return String(obj);
}

var styleMutationWarning = {};

function checkAndWarnForMutatedStyle(style1, style2, component) {
  if (style1 == null || style2 == null) {
    return;
  }
  if (shallowEqual(style1, style2)) {
    return;
  }

  var componentName = component._tag;
  var owner = component._currentElement._owner;
  var ownerName;
  if (owner) {
    ownerName = owner.getName();
  }

  var hash = ownerName + '|' + componentName;

  if (styleMutationWarning.hasOwnProperty(hash)) {
    return;
  }

  styleMutationWarning[hash] = true;

   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
}

/**
 * @param {object} component
 * @param {?object} props
 */
function assertValidProps(component, props) {
  if (!props) {
    return;
  }
  // Note the use of `==` which checks for null or undefined.
  if (voidElementTags[component._tag]) {
    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
  }
  if (props.dangerouslySetInnerHTML != null) {
    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
  }
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
  }
  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
}

function enqueuePutListener(inst, registrationName, listener, transaction) {
  if (transaction instanceof ReactServerRenderingTransaction) {
    return;
  }
  if (false) {
    // IE8 has no API for event capturing and the `onScroll` event doesn't
    // bubble.
    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
  }
  var containerInfo = inst._hostContainerInfo;
  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
  listenTo(registrationName, doc);
  transaction.getReactMountReady().enqueue(putListener, {
    inst: inst,
    registrationName: registrationName,
    listener: listener
  });
}

function putListener() {
  var listenerToPut = this;
  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
}

function inputPostMount() {
  var inst = this;
  ReactDOMInput.postMountWrapper(inst);
}

function textareaPostMount() {
  var inst = this;
  ReactDOMTextarea.postMountWrapper(inst);
}

function optionPostMount() {
  var inst = this;
  ReactDOMOption.postMountWrapper(inst);
}

var setAndValidateContentChildDev = emptyFunction;
if (false) {
  setAndValidateContentChildDev = function (content) {
    var hasExistingContent = this._contentDebugID != null;
    var debugID = this._debugID;
    // This ID represents the inlined child that has no backing instance:
    var contentDebugID = -debugID;

    if (content == null) {
      if (hasExistingContent) {
        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
      }
      this._contentDebugID = null;
      return;
    }

    validateDOMNesting(null, String(content), this, this._ancestorInfo);
    this._contentDebugID = contentDebugID;
    if (hasExistingContent) {
      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
    } else {
      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
    }
  };
}

// There are so many media events, it makes sense to just
// maintain a list rather than create a `trapBubbledEvent` for each
var mediaEvents = {
  topAbort: 'abort',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTimeUpdate: 'timeupdate',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting'
};

function trapBubbledEventsLocal() {
  var inst = this;
  // If a component renders to null or if another component fatals and causes
  // the state of the tree to be corrupted, `node` here can be null.
  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
  var node = getNode(inst);
  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;

  switch (inst._tag) {
    case 'iframe':
    case 'object':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'video':
    case 'audio':

      inst._wrapperState.listeners = [];
      // Create listener for each media event
      for (var event in mediaEvents) {
        if (mediaEvents.hasOwnProperty(event)) {
          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
        }
      }
      break;
    case 'source':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
      break;
    case 'img':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'form':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
      break;
    case 'input':
    case 'select':
    case 'textarea':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
      break;
  }
}

function postUpdateSelectWrapper() {
  ReactDOMSelect.postUpdateWrapper(this);
}

// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special-case tags.

var omittedCloseTags = {
  'area': true,
  'base': true,
  'br': true,
  'col': true,
  'embed': true,
  'hr': true,
  'img': true,
  'input': true,
  'keygen': true,
  'link': true,
  'meta': true,
  'param': true,
  'source': true,
  'track': true,
  'wbr': true
};

var newlineEatingTags = {
  'listing': true,
  'pre': true,
  'textarea': true
};

// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = _assign({
  'menuitem': true
}, omittedCloseTags);

// We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name

var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
var validatedTagCache = {};
var hasOwnProperty = {}.hasOwnProperty;

function validateDangerousTag(tag) {
  if (!hasOwnProperty.call(validatedTagCache, tag)) {
    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
    validatedTagCache[tag] = true;
  }
}

function isCustomComponent(tagName, props) {
  return tagName.indexOf('-') >= 0 || props.is != null;
}

var globalIdCounter = 1;

/**
 * Creates a new React class that is idempotent and capable of containing other
 * React components. It accepts event listeners and DOM properties that are
 * valid according to `DOMProperty`.
 *
 *  - Event listeners: `onClick`, `onMouseDown`, etc.
 *  - DOM properties: `className`, `name`, `title`, etc.
 *
 * The `style` property functions differently from the DOM API. It accepts an
 * object mapping of style properties to values.
 *
 * @constructor ReactDOMComponent
 * @extends ReactMultiChild
 */
function ReactDOMComponent(element) {
  var tag = element.type;
  validateDangerousTag(tag);
  this._currentElement = element;
  this._tag = tag.toLowerCase();
  this._namespaceURI = null;
  this._renderedChildren = null;
  this._previousStyle = null;
  this._previousStyleCopy = null;
  this._hostNode = null;
  this._hostParent = null;
  this._rootNodeID = 0;
  this._domID = 0;
  this._hostContainerInfo = null;
  this._wrapperState = null;
  this._topLevelWrapper = null;
  this._flags = 0;
  if (false) {
    this._ancestorInfo = null;
    setAndValidateContentChildDev.call(this, null);
  }
}

ReactDOMComponent.displayName = 'ReactDOMComponent';

ReactDOMComponent.Mixin = {

  /**
   * Generates root tag markup then recurses. This method has side effects and
   * is not idempotent.
   *
   * @internal
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?ReactDOMComponent} the parent component instance
   * @param {?object} info about the host container
   * @param {object} context
   * @return {string} The computed markup.
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    this._rootNodeID = globalIdCounter++;
    this._domID = hostContainerInfo._idCounter++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var props = this._currentElement.props;

    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        this._wrapperState = {
          listeners: null
        };
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'input':
        ReactDOMInput.mountWrapper(this, props, hostParent);
        props = ReactDOMInput.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'option':
        ReactDOMOption.mountWrapper(this, props, hostParent);
        props = ReactDOMOption.getHostProps(this, props);
        break;
      case 'select':
        ReactDOMSelect.mountWrapper(this, props, hostParent);
        props = ReactDOMSelect.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'textarea':
        ReactDOMTextarea.mountWrapper(this, props, hostParent);
        props = ReactDOMTextarea.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
    }

    assertValidProps(this, props);

    // We create tags in the namespace of their parent container, except HTML
    // tags get no namespace.
    var namespaceURI;
    var parentTag;
    if (hostParent != null) {
      namespaceURI = hostParent._namespaceURI;
      parentTag = hostParent._tag;
    } else if (hostContainerInfo._tag) {
      namespaceURI = hostContainerInfo._namespaceURI;
      parentTag = hostContainerInfo._tag;
    }
    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
      namespaceURI = DOMNamespaces.html;
    }
    if (namespaceURI === DOMNamespaces.html) {
      if (this._tag === 'svg') {
        namespaceURI = DOMNamespaces.svg;
      } else if (this._tag === 'math') {
        namespaceURI = DOMNamespaces.mathml;
      }
    }
    this._namespaceURI = namespaceURI;

    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo._tag) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(this._tag, null, this, parentInfo);
      }
      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
    }

    var mountImage;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var el;
      if (namespaceURI === DOMNamespaces.html) {
        if (this._tag === 'script') {
          // Create the script via .innerHTML so its "parser-inserted" flag is
          // set to true and it does not execute
          var div = ownerDocument.createElement('div');
          var type = this._currentElement.type;
          div.innerHTML = '<' + type + '></' + type + '>';
          el = div.removeChild(div.firstChild);
        } else if (props.is) {
          el = ownerDocument.createElement(this._currentElement.type, props.is);
        } else {
          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
          // See discussion in https://github.com/facebook/react/pull/6896
          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
          el = ownerDocument.createElement(this._currentElement.type);
        }
      } else {
        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
      }
      ReactDOMComponentTree.precacheNode(this, el);
      this._flags |= Flags.hasCachedChildNodes;
      if (!this._hostParent) {
        DOMPropertyOperations.setAttributeForRoot(el);
      }
      this._updateDOMProperties(null, props, transaction);
      var lazyTree = DOMLazyTree(el);
      this._createInitialChildren(transaction, props, context, lazyTree);
      mountImage = lazyTree;
    } else {
      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
      var tagContent = this._createContentMarkup(transaction, props, context);
      if (!tagContent && omittedCloseTags[this._tag]) {
        mountImage = tagOpen + '/>';
      } else {
        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
      }
    }

    switch (this._tag) {
      case 'input':
        transaction.getReactMountReady().enqueue(inputPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'textarea':
        transaction.getReactMountReady().enqueue(textareaPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'select':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'button':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'option':
        transaction.getReactMountReady().enqueue(optionPostMount, this);
        break;
    }

    return mountImage;
  },

  /**
   * Creates markup for the open tag and all attributes.
   *
   * This method has side effects because events get registered.
   *
   * Iterating over object properties is faster than iterating over arrays.
   * @see http://jsperf.com/obj-vs-arr-iteration
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @return {string} Markup of opening tag.
   */
  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
    var ret = '<' + this._currentElement.type;

    for (var propKey in props) {
      if (!props.hasOwnProperty(propKey)) {
        continue;
      }
      var propValue = props[propKey];
      if (propValue == null) {
        continue;
      }
      if (registrationNameModules.hasOwnProperty(propKey)) {
        if (propValue) {
          enqueuePutListener(this, propKey, propValue, transaction);
        }
      } else {
        if (propKey === STYLE) {
          if (propValue) {
            if (false) {
              // See `_updateDOMProperties`. style block
              this._previousStyle = propValue;
            }
            propValue = this._previousStyleCopy = _assign({}, props.style);
          }
          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
        }
        var markup = null;
        if (this._tag != null && isCustomComponent(this._tag, props)) {
          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
          }
        } else {
          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
        }
        if (markup) {
          ret += ' ' + markup;
        }
      }
    }

    // For static pages, no need to put React ID and checksum. Saves lots of
    // bytes.
    if (transaction.renderToStaticMarkup) {
      return ret;
    }

    if (!this._hostParent) {
      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
    }
    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
    return ret;
  },

  /**
   * Creates markup for the content between the tags.
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @param {object} context
   * @return {string} Content markup.
   */
  _createContentMarkup: function (transaction, props, context) {
    var ret = '';

    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        ret = innerHTML.__html;
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        ret = escapeTextContentForBrowser(contentToUse);
        if (false) {
          setAndValidateContentChildDev.call(this, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        ret = mountImages.join('');
      }
    }
    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
      // text/html ignores the first character in these tags if it's a newline
      // Prefer to break application/xml over text/html (for now) by adding
      // a newline specifically to get eaten by the parser. (Alternately for
      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
      // \r is normalized out by HTMLTextAreaElement#value.)
      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
      // See: Parsing of "textarea" "listing" and "pre" elements
      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
      return '\n' + ret;
    } else {
      return ret;
    }
  },

  _createInitialChildren: function (transaction, props, context, lazyTree) {
    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      // TODO: Validate that text is allowed as a child of this node
      if (contentToUse != null) {
        // Avoid setting textContent when the text is empty. In IE11 setting
        // textContent on a text area will cause the placeholder to not
        // show within the textarea until it has been focused and blurred again.
        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
        if (contentToUse !== '') {
          if (false) {
            setAndValidateContentChildDev.call(this, contentToUse);
          }
          DOMLazyTree.queueText(lazyTree, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        for (var i = 0; i < mountImages.length; i++) {
          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
        }
      }
    }
  },

  /**
   * Receives a next element and updates the component.
   *
   * @internal
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   */
  receiveComponent: function (nextElement, transaction, context) {
    var prevElement = this._currentElement;
    this._currentElement = nextElement;
    this.updateComponent(transaction, prevElement, nextElement, context);
  },

  /**
   * Updates a DOM component after it has already been allocated and
   * attached to the DOM. Reconciles the root DOM node, then recurses.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevElement
   * @param {ReactElement} nextElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevElement, nextElement, context) {
    var lastProps = prevElement.props;
    var nextProps = this._currentElement.props;

    switch (this._tag) {
      case 'input':
        lastProps = ReactDOMInput.getHostProps(this, lastProps);
        nextProps = ReactDOMInput.getHostProps(this, nextProps);
        break;
      case 'option':
        lastProps = ReactDOMOption.getHostProps(this, lastProps);
        nextProps = ReactDOMOption.getHostProps(this, nextProps);
        break;
      case 'select':
        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
        break;
      case 'textarea':
        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
        break;
    }

    assertValidProps(this, nextProps);
    this._updateDOMProperties(lastProps, nextProps, transaction);
    this._updateDOMChildren(lastProps, nextProps, transaction, context);

    switch (this._tag) {
      case 'input':
        // Update the wrapper around inputs *after* updating props. This has to
        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
        // raise warnings and prevent the new value from being assigned.
        ReactDOMInput.updateWrapper(this);
        break;
      case 'textarea':
        ReactDOMTextarea.updateWrapper(this);
        break;
      case 'select':
        // <select> value update needs to occur after <option> children
        // reconciliation
        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
        break;
    }
  },

  /**
   * Reconciles the properties by detecting differences in property values and
   * updating the DOM as necessary. This function is probably the single most
   * critical path for performance optimization.
   *
   * TODO: Benchmark whether checking for changed values in memory actually
   *       improves performance (especially statically positioned elements).
   * TODO: Benchmark the effects of putting this at the top since 99% of props
   *       do not change for a given reconciliation.
   * TODO: Benchmark areas that can be improved with caching.
   *
   * @private
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {?DOMElement} node
   */
  _updateDOMProperties: function (lastProps, nextProps, transaction) {
    var propKey;
    var styleName;
    var styleUpdates;
    for (propKey in lastProps) {
      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
        continue;
      }
      if (propKey === STYLE) {
        var lastStyle = this._previousStyleCopy;
        for (styleName in lastStyle) {
          if (lastStyle.hasOwnProperty(styleName)) {
            styleUpdates = styleUpdates || {};
            styleUpdates[styleName] = '';
          }
        }
        this._previousStyleCopy = null;
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (lastProps[propKey]) {
          // Only call deleteListener if there was a listener previously or
          // else willDeleteListener gets called when there wasn't actually a
          // listener (e.g., onClick={null})
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, lastProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
      }
    }
    for (propKey in nextProps) {
      var nextProp = nextProps[propKey];
      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
        continue;
      }
      if (propKey === STYLE) {
        if (nextProp) {
          if (false) {
            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
            this._previousStyle = nextProp;
          }
          nextProp = this._previousStyleCopy = _assign({}, nextProp);
        } else {
          this._previousStyleCopy = null;
        }
        if (lastProp) {
          // Unset styles on `lastProp` but not on `nextProp`.
          for (styleName in lastProp) {
            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = '';
            }
          }
          // Update styles that changed since `lastProp`.
          for (styleName in nextProp) {
            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = nextProp[styleName];
            }
          }
        } else {
          // Relies on `updateStylesByID` not mutating `styleUpdates`.
          styleUpdates = nextProp;
        }
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (nextProp) {
          enqueuePutListener(this, propKey, nextProp, transaction);
        } else if (lastProp) {
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, nextProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        var node = getNode(this);
        // If we're updating to null or undefined, we should remove the property
        // from the DOM node instead of inadvertently setting to a string. This
        // brings us in line with the same behavior we have on initial render.
        if (nextProp != null) {
          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
        } else {
          DOMPropertyOperations.deleteValueForProperty(node, propKey);
        }
      }
    }
    if (styleUpdates) {
      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
    }
  },

  /**
   * Reconciles the children with the various properties that affect the
   * children content.
   *
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   */
  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;

    // Note the use of `!=` which checks for null or undefined.
    var lastChildren = lastContent != null ? null : lastProps.children;
    var nextChildren = nextContent != null ? null : nextProps.children;

    // If we're switching from children to content/html or vice versa, remove
    // the old content
    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
    if (lastChildren != null && nextChildren == null) {
      this.updateChildren(null, transaction, context);
    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
      this.updateTextContent('');
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    }

    if (nextContent != null) {
      if (lastContent !== nextContent) {
        this.updateTextContent('' + nextContent);
        if (false) {
          setAndValidateContentChildDev.call(this, nextContent);
        }
      }
    } else if (nextHtml != null) {
      if (lastHtml !== nextHtml) {
        this.updateMarkup('' + nextHtml);
      }
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    } else if (nextChildren != null) {
      if (false) {
        setAndValidateContentChildDev.call(this, null);
      }

      this.updateChildren(nextChildren, transaction, context);
    }
  },

  getHostNode: function () {
    return getNode(this);
  },

  /**
   * Destroys all event registrations for this instance. Does not remove from
   * the DOM. That must be done by the parent.
   *
   * @internal
   */
  unmountComponent: function (safely) {
    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        var listeners = this._wrapperState.listeners;
        if (listeners) {
          for (var i = 0; i < listeners.length; i++) {
            listeners[i].remove();
          }
        }
        break;
      case 'html':
      case 'head':
      case 'body':
        /**
         * Components like <html> <head> and <body> can't be removed or added
         * easily in a cross-browser way, however it's valuable to be able to
         * take advantage of React's reconciliation for styling and <title>
         * management. So we just document it and throw in dangerous cases.
         */
         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
        break;
    }

    this.unmountChildren(safely);
    ReactDOMComponentTree.uncacheNode(this);
    EventPluginHub.deleteAllListeners(this);
    this._rootNodeID = 0;
    this._domID = 0;
    this._wrapperState = null;

    if (false) {
      setAndValidateContentChildDev.call(this, null);
    }
  },

  getPublicInstance: function () {
    return getNode(this);
  }

};

_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);

module.exports = ReactDOMComponent;

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentTree = __webpack_require__(21);

var focusNode = __webpack_require__(239);

var AutoFocusUtils = {
  focusDOMComponent: function () {
    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
  }
};

module.exports = AutoFocusUtils;

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var CSSProperty = __webpack_require__(240);
var ExecutionEnvironment = __webpack_require__(31);
var ReactInstrumentation = __webpack_require__(38);

var camelizeStyleName = __webpack_require__(421);
var dangerousStyleValue = __webpack_require__(423);
var hyphenateStyleName = __webpack_require__(424);
var memoizeStringOnly = __webpack_require__(426);
var warning = __webpack_require__(6);

var processStyleName = memoizeStringOnly(function (styleName) {
  return hyphenateStyleName(styleName);
});

var hasShorthandPropertyBug = false;
var styleFloatAccessor = 'cssFloat';
if (ExecutionEnvironment.canUseDOM) {
  var tempStyle = document.createElement('div').style;
  try {
    // IE8 throws "Invalid argument." if resetting shorthand style properties.
    tempStyle.font = '';
  } catch (e) {
    hasShorthandPropertyBug = true;
  }
  // IE8 only supports accessing cssFloat (standard) as styleFloat
  if (document.documentElement.style.cssFloat === undefined) {
    styleFloatAccessor = 'styleFloat';
  }
}

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function (name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function (name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function (owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function (name, value, component) {
    var owner;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
 * Operations for dealing with CSS properties.
 */
var CSSPropertyOperations = {

  /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */
  createMarkupForStyles: function (styles, component) {
    var serialized = '';
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var styleValue = styles[styleName];
      if (false) {
        warnValidStyle(styleName, styleValue, component);
      }
      if (styleValue != null) {
        serialized += processStyleName(styleName) + ':';
        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
      }
    }
    return serialized || null;
  },

  /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   * @param {ReactDOMComponent} component
   */
  setValueForStyles: function (node, styles, component) {
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: component._debugID,
        type: 'update styles',
        payload: styles
      });
    }

    var style = node.style;
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      if (false) {
        warnValidStyle(styleName, styles[styleName], component);
      }
      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
      if (styleName === 'float' || styleName === 'cssFloat') {
        styleName = styleFloatAccessor;
      }
      if (styleValue) {
        style[styleName] = styleValue;
      } else {
        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
        if (expansion) {
          // Shorthand property that IE8 won't like unsetting, so unset each
          // component to placate it
          for (var individualStyleName in expansion) {
            style[individualStyleName] = '';
          }
        } else {
          style[styleName] = '';
        }
      }
    }
  }

};

module.exports = CSSPropertyOperations;

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var camelize = __webpack_require__(422);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var CSSProperty = __webpack_require__(240);
var warning = __webpack_require__(6);

var isUnitlessNumber = CSSProperty.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

module.exports = dangerousStyleValue;

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(425);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var escapeTextContentForBrowser = __webpack_require__(121);

/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */
function quoteAttributeValueForBrowser(value) {
  return '"' + escapeTextContentForBrowser(value) + '"';
}

module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(101);

function runEventQueueInBatch(events) {
  EventPluginHub.enqueueEvents(events);
  EventPluginHub.processEventQueue(false);
}

var ReactEventEmitterMixin = {

  /**
   * Streams a fired top-level event to `EventPluginHub` where plugins have the
   * opportunity to create `ReactEvent`s to be dispatched.
   */
  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
    runEventQueueInBatch(events);
  }
};

module.exports = ReactEventEmitterMixin;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(31);

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

/**
 * A list of event names to a configurable list of vendor prefixes.
 */
var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};

/**
 * Event names that have already been detected and prefixed (if applicable).
 */
var prefixedEventNames = {};

/**
 * Element to check for prefixes on.
 */
var style = {};

/**
 * Bootstrap if a DOM exists.
 */
if (ExecutionEnvironment.canUseDOM) {
  style = document.createElement('div').style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.
  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  }

  // Same as above
  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}

/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return '';
}

module.exports = getVendorPrefixedEventName;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7),
    _assign = __webpack_require__(15);

var DOMPropertyOperations = __webpack_require__(241);
var LinkedValueUtils = __webpack_require__(169);
var ReactDOMComponentTree = __webpack_require__(21);
var ReactUpdates = __webpack_require__(40);

var invariant = __webpack_require__(5);
var warning = __webpack_require__(6);

var didWarnValueLink = false;
var didWarnCheckedLink = false;
var didWarnValueDefaultValue = false;
var didWarnCheckedDefaultChecked = false;
var didWarnControlledToUncontrolled = false;
var didWarnUncontrolledToControlled = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMInput.updateWrapper(this);
  }
}

function isControlled(props) {
  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
  return usesChecked ? props.checked != null : props.value != null;
}

/**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */
var ReactDOMInput = {
  getHostProps: function (inst, props) {
    var value = LinkedValueUtils.getValue(props);
    var checked = LinkedValueUtils.getChecked(props);

    var hostProps = _assign({
      // Make sure we set .type before any other properties (setting .value
      // before .type means .value is lost in IE11 and below)
      type: undefined,
      // Make sure we set .step before .value (setting .value before .step
      // means .value is rounded on mount, based upon step precision)
      step: undefined,
      // Make sure we set .min & .max before .value (to ensure proper order
      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
      min: undefined,
      max: undefined
    }, props, {
      defaultChecked: undefined,
      defaultValue: undefined,
      value: value != null ? value : inst._wrapperState.initialValue,
      checked: checked != null ? checked : inst._wrapperState.initialChecked,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);

      var owner = inst._currentElement._owner;

      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnCheckedLink = true;
      }
      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnCheckedDefaultChecked = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnValueDefaultValue = true;
      }
    }

    var defaultValue = props.defaultValue;
    inst._wrapperState = {
      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
      initialValue: props.value != null ? props.value : defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst)
    };

    if (false) {
      inst._wrapperState.controlled = isControlled(props);
    }
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    if (false) {
      var controlled = isControlled(props);
      var owner = inst._currentElement._owner;

      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnUncontrolledToControlled = true;
      }
      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnControlledToUncontrolled = true;
      }
    }

    // TODO: Shouldn't this be getChecked(props)?
    var checked = props.checked;
    if (checked != null) {
      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {

      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      var newValue = '' + value;

      // To avoid side effects (such as losing text selection), only set value if changed
      if (newValue !== node.value) {
        node.value = newValue;
      }
    } else {
      if (props.value == null && props.defaultValue != null) {
        // In Chrome, assigning defaultValue to certain input types triggers input validation.
        // For number inputs, the display value loses trailing decimal points. For email inputs,
        // Chrome raises "The specified value <x> is not a valid email address".
        //
        // Here we check to see if the defaultValue has actually changed, avoiding these problems
        // when the user is inputting text
        //
        // https://github.com/facebook/react/issues/7253
        if (node.defaultValue !== '' + props.defaultValue) {
          node.defaultValue = '' + props.defaultValue;
        }
      }
      if (props.checked == null && props.defaultChecked != null) {
        node.defaultChecked = !!props.defaultChecked;
      }
    }
  },

  postMountWrapper: function (inst) {
    var props = inst._currentElement.props;

    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);

    // Detach value from defaultValue. We won't do anything if we're working on
    // submit or reset inputs as those values & defaultValues are linked. They
    // are not resetable nodes so this operation doesn't matter and actually
    // removes browser-default values (eg "Submit Query") when no value is
    // provided.

    switch (props.type) {
      case 'submit':
      case 'reset':
        break;
      case 'color':
      case 'date':
      case 'datetime':
      case 'datetime-local':
      case 'month':
      case 'time':
      case 'week':
        // This fixes the no-show issue on iOS Safari and Android Chrome:
        // https://github.com/facebook/react/issues/7233
        node.value = '';
        node.value = node.defaultValue;
        break;
      default:
        node.value = node.value;
        break;
    }

    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
    // this is needed to work around a chrome bug where setting defaultChecked
    // will sometimes influence the value of checked (even after detachment).
    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
    // We need to temporarily unset name to avoid disrupting radio button groups.
    var name = node.name;
    if (name !== '') {
      node.name = '';
    }
    node.defaultChecked = !node.defaultChecked;
    node.defaultChecked = !node.defaultChecked;
    if (name !== '') {
      node.name = name;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;

  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  // Here we use asap to wait until all updates have propagated, which
  // is important when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  ReactUpdates.asap(forceUpdateIfMounted, this);

  var name = props.name;
  if (props.type === 'radio' && name != null) {
    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    }

    // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form, let's just use the global
    // `querySelectorAll` to ensure we don't miss anything.
    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];
      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      }
      // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React radio buttons with non-React ones.
      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
      // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.
      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
    }
  }

  return returnValue;
}

module.exports = ReactDOMInput;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(15);

var React = __webpack_require__(78);
var ReactDOMComponentTree = __webpack_require__(21);
var ReactDOMSelect = __webpack_require__(242);

var warning = __webpack_require__(6);
var didWarnInvalidOptionChildren = false;

function flattenChildren(children) {
  var content = '';

  // Flatten children and warn if they aren't strings or numbers;
  // invalid types are ignored.
  React.Children.forEach(children, function (child) {
    if (child == null) {
      return;
    }
    if (typeof child === 'string' || typeof child === 'number') {
      content += child;
    } else if (!didWarnInvalidOptionChildren) {
      didWarnInvalidOptionChildren = true;
       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
    }
  });

  return content;
}

/**
 * Implements an <option> host component that warns when `selected` is set.
 */
var ReactDOMOption = {
  mountWrapper: function (inst, props, hostParent) {
    // TODO (yungsters): Remove support for `selected` in <option>.
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
    }

    // Look up whether this option is 'selected'
    var selectValue = null;
    if (hostParent != null) {
      var selectParent = hostParent;

      if (selectParent._tag === 'optgroup') {
        selectParent = selectParent._hostParent;
      }

      if (selectParent != null && selectParent._tag === 'select') {
        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
      }
    }

    // If the value is null (e.g., no specified value or after initial mount)
    // or missing (e.g., for <datalist>), we don't change props.selected
    var selected = null;
    if (selectValue != null) {
      var value;
      if (props.value != null) {
        value = props.value + '';
      } else {
        value = flattenChildren(props.children);
      }
      selected = false;
      if (Array.isArray(selectValue)) {
        // multiple
        for (var i = 0; i < selectValue.length; i++) {
          if ('' + selectValue[i] === value) {
            selected = true;
            break;
          }
        }
      } else {
        selected = '' + selectValue === value;
      }
    }

    inst._wrapperState = { selected: selected };
  },

  postMountWrapper: function (inst) {
    // value="" should make a value attribute (#6219)
    var props = inst._currentElement.props;
    if (props.value != null) {
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      node.setAttribute('value', props.value);
    }
  },

  getHostProps: function (inst, props) {
    var hostProps = _assign({ selected: undefined, children: undefined }, props);

    // Read state only from initial mount because <select> updates value
    // manually; we need the initial state only for server rendering
    if (inst._wrapperState.selected != null) {
      hostProps.selected = inst._wrapperState.selected;
    }

    var content = flattenChildren(props.children);

    if (content) {
      hostProps.children = content;
    }

    return hostProps;
  }

};

module.exports = ReactDOMOption;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7),
    _assign = __webpack_require__(15);

var LinkedValueUtils = __webpack_require__(169);
var ReactDOMComponentTree = __webpack_require__(21);
var ReactUpdates = __webpack_require__(40);

var invariant = __webpack_require__(5);
var warning = __webpack_require__(6);

var didWarnValueLink = false;
var didWarnValDefaultVal = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMTextarea.updateWrapper(this);
  }
}

/**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
var ReactDOMTextarea = {
  getHostProps: function (inst, props) {
    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;

    // Always set children to the same thing. In IE9, the selection range will
    // get reset if `textContent` is mutated.  We could add a check in setTextContent
    // to only set the value if/when the value differs from the node value (which would
    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
    // The value can be a boolean or object so that's why it's forced to be a string.
    var hostProps = _assign({}, props, {
      value: undefined,
      defaultValue: undefined,
      children: '' + inst._wrapperState.initialValue,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
        didWarnValDefaultVal = true;
      }
    }

    var value = LinkedValueUtils.getValue(props);
    var initialValue = value;

    // Only bother fetching default value if we're going to use it
    if (value == null) {
      var defaultValue = props.defaultValue;
      // TODO (yungsters): Remove support for children content in <textarea>.
      var children = props.children;
      if (children != null) {
        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
        }
        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
        if (Array.isArray(children)) {
          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
          children = children[0];
        }

        defaultValue = '' + children;
      }
      if (defaultValue == null) {
        defaultValue = '';
      }
      initialValue = defaultValue;
    }

    inst._wrapperState = {
      initialValue: '' + initialValue,
      listeners: null,
      onChange: _handleChange.bind(inst)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      var newValue = '' + value;

      // To avoid side effects (such as losing text selection), only set value if changed
      if (newValue !== node.value) {
        node.value = newValue;
      }
      if (props.defaultValue == null) {
        node.defaultValue = newValue;
      }
    }
    if (props.defaultValue != null) {
      node.defaultValue = props.defaultValue;
    }
  },

  postMountWrapper: function (inst) {
    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var textContent = node.textContent;

    // Only set node.value if textContent is equal to the expected
    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
    // will populate textContent as well.
    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
    if (textContent === inst._wrapperState.initialValue) {
      node.value = textContent;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);
  ReactUpdates.asap(forceUpdateIfMounted, this);
  return returnValue;
}

module.exports = ReactDOMTextarea;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var ReactComponentEnvironment = __webpack_require__(170);
var ReactInstanceMap = __webpack_require__(103);
var ReactInstrumentation = __webpack_require__(38);

var ReactCurrentOwner = __webpack_require__(49);
var ReactReconciler = __webpack_require__(83);
var ReactChildReconciler = __webpack_require__(435);

var emptyFunction = __webpack_require__(37);
var flattenChildren = __webpack_require__(440);
var invariant = __webpack_require__(5);

/**
 * Make an update for markup to be rendered and inserted at a supplied index.
 *
 * @param {string} markup Markup that renders into an element.
 * @param {number} toIndex Destination index.
 * @private
 */
function makeInsertMarkup(markup, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'INSERT_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for moving an existing element to another index.
 *
 * @param {number} fromIndex Source index of the existing element.
 * @param {number} toIndex Destination index of the element.
 * @private
 */
function makeMove(child, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'MOVE_EXISTING',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: ReactReconciler.getHostNode(child),
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for removing an element at an index.
 *
 * @param {number} fromIndex Index of the element to remove.
 * @private
 */
function makeRemove(child, node) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'REMOVE_NODE',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: node,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the markup of a node.
 *
 * @param {string} markup Markup that renders into an element.
 * @private
 */
function makeSetMarkup(markup) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'SET_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the text content.
 *
 * @param {string} textContent Text content to set.
 * @private
 */
function makeTextContent(textContent) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'TEXT_CONTENT',
    content: textContent,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Push an update, if any, onto the queue. Creates a new queue if none is
 * passed and always returns the queue. Mutative.
 */
function enqueue(queue, update) {
  if (update) {
    queue = queue || [];
    queue.push(update);
  }
  return queue;
}

/**
 * Processes any enqueued updates.
 *
 * @private
 */
function processQueue(inst, updateQueue) {
  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
}

var setChildrenForInstrumentation = emptyFunction;
if (false) {
  var getDebugID = function (inst) {
    if (!inst._debugID) {
      // Check for ART-like instances. TODO: This is silly/gross.
      var internal;
      if (internal = ReactInstanceMap.get(inst)) {
        inst = internal;
      }
    }
    return inst._debugID;
  };
  setChildrenForInstrumentation = function (children) {
    var debugID = getDebugID(this);
    // TODO: React Native empty components are also multichild.
    // This means they still get into this method but don't have _debugID.
    if (debugID !== 0) {
      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
        return children[key]._debugID;
      }) : []);
    }
  };
}

/**
 * ReactMultiChild are capable of reconciling multiple children.
 *
 * @class ReactMultiChild
 * @internal
 */
var ReactMultiChild = {

  /**
   * Provides common functionality for components that must reconcile multiple
   * children. This is used by `ReactDOMComponent` to mount, update, and
   * unmount child components.
   *
   * @lends {ReactMultiChild.prototype}
   */
  Mixin: {

    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
      if (false) {
        var selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
        }
      }
      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
    },

    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
      var nextChildren;
      var selfDebugID = 0;
      if (false) {
        selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
          return nextChildren;
        }
      }
      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
      return nextChildren;
    },

    /**
     * Generates a "mount image" for each of the supplied children. In the case
     * of `ReactDOMComponent`, a mount image is a string of markup.
     *
     * @param {?object} nestedChildren Nested child maps.
     * @return {array} An array of mounted representations.
     * @internal
     */
    mountChildren: function (nestedChildren, transaction, context) {
      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
      this._renderedChildren = children;

      var mountImages = [];
      var index = 0;
      for (var name in children) {
        if (children.hasOwnProperty(name)) {
          var child = children[name];
          var selfDebugID = 0;
          if (false) {
            selfDebugID = getDebugID(this);
          }
          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
          child._mountIndex = index++;
          mountImages.push(mountImage);
        }
      }

      if (false) {
        setChildrenForInstrumentation.call(this, children);
      }

      return mountImages;
    },

    /**
     * Replaces any rendered children with a text content string.
     *
     * @param {string} nextContent String of content.
     * @internal
     */
    updateTextContent: function (nextContent) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      // Set new text content.
      var updates = [makeTextContent(nextContent)];
      processQueue(this, updates);
    },

    /**
     * Replaces any rendered children with a markup string.
     *
     * @param {string} nextMarkup String of markup.
     * @internal
     */
    updateMarkup: function (nextMarkup) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      var updates = [makeSetMarkup(nextMarkup)];
      processQueue(this, updates);
    },

    /**
     * Updates the rendered children with new children.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @internal
     */
    updateChildren: function (nextNestedChildrenElements, transaction, context) {
      // Hook used by React ART
      this._updateChildren(nextNestedChildrenElements, transaction, context);
    },

    /**
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @final
     * @protected
     */
    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
      var prevChildren = this._renderedChildren;
      var removedNodes = {};
      var mountImages = [];
      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
      if (!nextChildren && !prevChildren) {
        return;
      }
      var updates = null;
      var name;
      // `nextIndex` will increment for each child in `nextChildren`, but
      // `lastIndex` will be the last index visited in `prevChildren`.
      var nextIndex = 0;
      var lastIndex = 0;
      // `nextMountIndex` will increment for each newly mounted child.
      var nextMountIndex = 0;
      var lastPlacedNode = null;
      for (name in nextChildren) {
        if (!nextChildren.hasOwnProperty(name)) {
          continue;
        }
        var prevChild = prevChildren && prevChildren[name];
        var nextChild = nextChildren[name];
        if (prevChild === nextChild) {
          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
          prevChild._mountIndex = nextIndex;
        } else {
          if (prevChild) {
            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
            // The `removedNodes` loop below will actually remove the child.
          }
          // The child must be instantiated before it's mounted.
          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
          nextMountIndex++;
        }
        nextIndex++;
        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
      }
      // Remove children that are no longer present.
      for (name in removedNodes) {
        if (removedNodes.hasOwnProperty(name)) {
          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
        }
      }
      if (updates) {
        processQueue(this, updates);
      }
      this._renderedChildren = nextChildren;

      if (false) {
        setChildrenForInstrumentation.call(this, nextChildren);
      }
    },

    /**
     * Unmounts all rendered children. This should be used to clean up children
     * when this component is unmounted. It does not actually perform any
     * backend operations.
     *
     * @internal
     */
    unmountChildren: function (safely) {
      var renderedChildren = this._renderedChildren;
      ReactChildReconciler.unmountChildren(renderedChildren, safely);
      this._renderedChildren = null;
    },

    /**
     * Moves a child component to the supplied index.
     *
     * @param {ReactComponent} child Component to move.
     * @param {number} toIndex Destination index of the element.
     * @param {number} lastIndex Last index visited of the siblings of `child`.
     * @protected
     */
    moveChild: function (child, afterNode, toIndex, lastIndex) {
      // If the index of `child` is less than `lastIndex`, then it needs to
      // be moved. Otherwise, we do not need to move it because a child will be
      // inserted or moved before `child`.
      if (child._mountIndex < lastIndex) {
        return makeMove(child, afterNode, toIndex);
      }
    },

    /**
     * Creates a child component.
     *
     * @param {ReactComponent} child Component to create.
     * @param {string} mountImage Markup to insert.
     * @protected
     */
    createChild: function (child, afterNode, mountImage) {
      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
    },

    /**
     * Removes a child component.
     *
     * @param {ReactComponent} child Child to remove.
     * @protected
     */
    removeChild: function (child, node) {
      return makeRemove(child, node);
    },

    /**
     * Mounts a child with the supplied name.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to mount.
     * @param {string} name Name of the child.
     * @param {number} index Index at which to insert the child.
     * @param {ReactReconcileTransaction} transaction
     * @private
     */
    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
      child._mountIndex = index;
      return this.createChild(child, afterNode, mountImage);
    },

    /**
     * Unmounts a rendered child.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to unmount.
     * @private
     */
    _unmountChild: function (child, node) {
      var update = this.removeChild(child, node);
      child._mountIndex = null;
      return update;
    }

  }

};

module.exports = ReactMultiChild;

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactReconciler = __webpack_require__(83);

var instantiateReactComponent = __webpack_require__(243);
var KeyEscapeUtils = __webpack_require__(173);
var shouldUpdateReactComponent = __webpack_require__(172);
var traverseAllChildren = __webpack_require__(247);
var warning = __webpack_require__(6);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && Object({"NODE_ENV":"production"}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(248);
}

function instantiateChild(childInstances, child, name, selfDebugID) {
  // We found a component instance.
  var keyUnique = childInstances[name] === undefined;
  if (false) {
    if (!ReactComponentTreeHook) {
      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
    }
    if (!keyUnique) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
    }
  }
  if (child != null && keyUnique) {
    childInstances[name] = instantiateReactComponent(child, true);
  }
}

/**
 * ReactChildReconciler provides helpers for initializing or updating a set of
 * children. Its output is suitable for passing it onto ReactMultiChild which
 * does diffed reordering and insertion.
 */
var ReactChildReconciler = {
  /**
   * Generates a "mount image" for each of the supplied children. In the case
   * of `ReactDOMComponent`, a mount image is a string of markup.
   *
   * @param {?object} nestedChildNodes Nested child maps.
   * @return {?object} A set of child instances.
   * @internal
   */
  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // 0 in production and for roots
  ) {
    if (nestedChildNodes == null) {
      return null;
    }
    var childInstances = {};

    if (false) {
      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
        return instantiateChild(childInsts, child, name, selfDebugID);
      }, childInstances);
    } else {
      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
    }
    return childInstances;
  },

  /**
   * Updates the rendered children and returns a new set of children.
   *
   * @param {?object} prevChildren Previously initialized set of children.
   * @param {?object} nextChildren Flat child element maps.
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @return {?object} A new set of child instances.
   * @internal
   */
  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID // 0 in production and for roots
  ) {
    // We currently don't have a way to track moves here but if we use iterators
    // instead of for..in we can zip the iterators and check if an item has
    // moved.
    // TODO: If nothing has changed, return the prevChildren object so that we
    // can quickly bailout if nothing has changed.
    if (!nextChildren && !prevChildren) {
      return;
    }
    var name;
    var prevChild;
    for (name in nextChildren) {
      if (!nextChildren.hasOwnProperty(name)) {
        continue;
      }
      prevChild = prevChildren && prevChildren[name];
      var prevElement = prevChild && prevChild._currentElement;
      var nextElement = nextChildren[name];
      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
        nextChildren[name] = prevChild;
      } else {
        if (prevChild) {
          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
          ReactReconciler.unmountComponent(prevChild, false);
        }
        // The child must be instantiated before it's mounted.
        var nextChildInstance = instantiateReactComponent(nextElement, true);
        nextChildren[name] = nextChildInstance;
        // Creating mount image now ensures refs are resolved in right order
        // (see https://github.com/facebook/react/pull/7101 for explanation).
        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
        mountImages.push(nextChildMountImage);
      }
    }
    // Unmount children that are no longer present.
    for (name in prevChildren) {
      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
        prevChild = prevChildren[name];
        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
        ReactReconciler.unmountComponent(prevChild, false);
      }
    }
  },

  /**
   * Unmounts all rendered children. This should be used to clean up children
   * when this component is unmounted.
   *
   * @param {?object} renderedChildren Previously initialized set of children.
   * @internal
   */
  unmountChildren: function (renderedChildren, safely) {
    for (var name in renderedChildren) {
      if (renderedChildren.hasOwnProperty(name)) {
        var renderedChild = renderedChildren[name];
        ReactReconciler.unmountComponent(renderedChild, safely);
      }
    }
  }

};

module.exports = ReactChildReconciler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)))

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7),
    _assign = __webpack_require__(15);

var React = __webpack_require__(78);
var ReactComponentEnvironment = __webpack_require__(170);
var ReactCurrentOwner = __webpack_require__(49);
var ReactErrorUtils = __webpack_require__(162);
var ReactInstanceMap = __webpack_require__(103);
var ReactInstrumentation = __webpack_require__(38);
var ReactNodeTypes = __webpack_require__(244);
var ReactReconciler = __webpack_require__(83);

if (false) {
  var checkReactTypeSpec = require('./checkReactTypeSpec');
}

var emptyObject = __webpack_require__(99);
var invariant = __webpack_require__(5);
var shallowEqual = __webpack_require__(171);
var shouldUpdateReactComponent = __webpack_require__(172);
var warning = __webpack_require__(6);

var CompositeTypes = {
  ImpureClass: 0,
  PureClass: 1,
  StatelessFunctional: 2
};

function StatelessComponent(Component) {}
StatelessComponent.prototype.render = function () {
  var Component = ReactInstanceMap.get(this)._currentElement.type;
  var element = Component(this.props, this.context, this.updater);
  warnIfInvalidElement(Component, element);
  return element;
};

function warnIfInvalidElement(Component, element) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
  }
}

function shouldConstruct(Component) {
  return !!(Component.prototype && Component.prototype.isReactComponent);
}

function isPureComponent(Component) {
  return !!(Component.prototype && Component.prototype.isPureReactComponent);
}

// Separated into a function to contain deoptimizations caused by try/finally.
function measureLifeCyclePerf(fn, debugID, timerType) {
  if (debugID === 0) {
    // Top-level wrappers (see ReactMount) and empty components (see
    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
    // Both are implementation details that should go away in the future.
    return fn();
  }

  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
  try {
    return fn();
  } finally {
    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
  }
}

/**
 * ------------------ The Life-Cycle of a Composite Component ------------------
 *
 * - constructor: Initialization of state. The instance is now retained.
 *   - componentWillMount
 *   - render
 *   - [children's constructors]
 *     - [children's componentWillMount and render]
 *     - [children's componentDidMount]
 *     - componentDidMount
 *
 *       Update Phases:
 *       - componentWillReceiveProps (only called if parent updated)
 *       - shouldComponentUpdate
 *         - componentWillUpdate
 *           - render
 *           - [children's constructors or receive props phases]
 *         - componentDidUpdate
 *
 *     - componentWillUnmount
 *     - [children's componentWillUnmount]
 *   - [children destroyed]
 * - (destroyed): The instance is now blank, released by React and ready for GC.
 *
 * -----------------------------------------------------------------------------
 */

/**
 * An incrementing ID assigned to each component when it is mounted. This is
 * used to enforce the order in which `ReactUpdates` updates dirty components.
 *
 * @private
 */
var nextMountID = 1;

/**
 * @lends {ReactCompositeComponent.prototype}
 */
var ReactCompositeComponent = {

  /**
   * Base constructor for all composite component.
   *
   * @param {ReactElement} element
   * @final
   * @internal
   */
  construct: function (element) {
    this._currentElement = element;
    this._rootNodeID = 0;
    this._compositeType = null;
    this._instance = null;
    this._hostParent = null;
    this._hostContainerInfo = null;

    // See ReactUpdateQueue
    this._updateBatchNumber = null;
    this._pendingElement = null;
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    this._renderedNodeType = null;
    this._renderedComponent = null;
    this._context = null;
    this._mountOrder = 0;
    this._topLevelWrapper = null;

    // See ReactUpdates and ReactUpdateQueue.
    this._pendingCallbacks = null;

    // ComponentWillUnmount shall only be called once
    this._calledComponentWillUnmount = false;

    if (false) {
      this._warnedAboutRefsInRender = false;
    }
  },

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} hostParent
   * @param {?object} hostContainerInfo
   * @param {?object} context
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var _this = this;

    this._context = context;
    this._mountOrder = nextMountID++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var publicProps = this._currentElement.props;
    var publicContext = this._processContext(context);

    var Component = this._currentElement.type;

    var updateQueue = transaction.getUpdateQueue();

    // Initialize the public class
    var doConstruct = shouldConstruct(Component);
    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
    var renderedElement;

    // Support functional components
    if (!doConstruct && (inst == null || inst.render == null)) {
      renderedElement = inst;
      warnIfInvalidElement(Component, renderedElement);
      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
      inst = new StatelessComponent(Component);
      this._compositeType = CompositeTypes.StatelessFunctional;
    } else {
      if (isPureComponent(Component)) {
        this._compositeType = CompositeTypes.PureClass;
      } else {
        this._compositeType = CompositeTypes.ImpureClass;
      }
    }

    if (false) {
      // This will throw later in _renderValidatedComponent, but add an early
      // warning now to help debugging
      if (inst.render == null) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
      }

      var propsMutated = inst.props !== publicProps;
      var componentName = Component.displayName || Component.name || 'Component';

      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
    }

    // These should be set up in the constructor, but as a convenience for
    // simpler class abstractions, we set them up after the fact.
    inst.props = publicProps;
    inst.context = publicContext;
    inst.refs = emptyObject;
    inst.updater = updateQueue;

    this._instance = inst;

    // Store a reference from the instance back to the internal representation
    ReactInstanceMap.set(inst, this);

    if (false) {
      // Since plain JS classes are defined without any special initialization
      // logic, we can not catch common errors early. Therefore, we have to
      // catch them here, at initialization time, instead.
      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
    }

    var initialState = inst.state;
    if (initialState === undefined) {
      inst.state = initialState = null;
    }
    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;

    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    var markup;
    if (inst.unstable_handleError) {
      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } else {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }

    if (inst.componentDidMount) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(function () {
            return inst.componentDidMount();
          }, _this._debugID, 'componentDidMount');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
      }
    }

    return markup;
  },

  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
    if (false) {
      ReactCurrentOwner.current = this;
      try {
        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
    }
  },

  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
    var Component = this._currentElement.type;

    if (doConstruct) {
      if (false) {
        return measureLifeCyclePerf(function () {
          return new Component(publicProps, publicContext, updateQueue);
        }, this._debugID, 'ctor');
      } else {
        return new Component(publicProps, publicContext, updateQueue);
      }
    }

    // This can still be an instance in case of factory components
    // but we'll count this as time spent rendering as the more common case.
    if (false) {
      return measureLifeCyclePerf(function () {
        return Component(publicProps, publicContext, updateQueue);
      }, this._debugID, 'render');
    } else {
      return Component(publicProps, publicContext, updateQueue);
    }
  },

  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var markup;
    var checkpoint = transaction.checkpoint();
    try {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } catch (e) {
      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
      transaction.rollback(checkpoint);
      this._instance.unstable_handleError(e);
      if (this._pendingStateQueue) {
        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
      }
      checkpoint = transaction.checkpoint();

      this._renderedComponent.unmountComponent(true);
      transaction.rollback(checkpoint);

      // Try again - we've informed the component about the error, so they can render an error message this time.
      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }
    return markup;
  },

  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var inst = this._instance;

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (inst.componentWillMount) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillMount();
        }, debugID, 'componentWillMount');
      } else {
        inst.componentWillMount();
      }
      // When mounting, calls to `setState` by `componentWillMount` will set
      // `this._pendingStateQueue` without triggering a re-render.
      if (this._pendingStateQueue) {
        inst.state = this._processPendingState(inst.props, inst.context);
      }
    }

    // If not a stateless component, we now render
    if (renderedElement === undefined) {
      renderedElement = this._renderValidatedComponent();
    }

    var nodeType = ReactNodeTypes.getType(renderedElement);
    this._renderedNodeType = nodeType;
    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
    );
    this._renderedComponent = child;

    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);

    if (false) {
      if (debugID !== 0) {
        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
      }
    }

    return markup;
  },

  getHostNode: function () {
    return ReactReconciler.getHostNode(this._renderedComponent);
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (safely) {
    if (!this._renderedComponent) {
      return;
    }

    var inst = this._instance;

    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
      inst._calledComponentWillUnmount = true;

      if (safely) {
        var name = this.getName() + '.componentWillUnmount()';
        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
      } else {
        if (false) {
          measureLifeCyclePerf(function () {
            return inst.componentWillUnmount();
          }, this._debugID, 'componentWillUnmount');
        } else {
          inst.componentWillUnmount();
        }
      }
    }

    if (this._renderedComponent) {
      ReactReconciler.unmountComponent(this._renderedComponent, safely);
      this._renderedNodeType = null;
      this._renderedComponent = null;
      this._instance = null;
    }

    // Reset pending fields
    // Even if this component is scheduled for another update in ReactUpdates,
    // it would still be ignored because these fields are reset.
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;
    this._pendingCallbacks = null;
    this._pendingElement = null;

    // These fields do not really need to be reset since this object is no
    // longer accessible.
    this._context = null;
    this._rootNodeID = 0;
    this._topLevelWrapper = null;

    // Delete the reference from the instance to this internal representation
    // which allow the internals to be properly cleaned up even if the user
    // leaks a reference to the public instance.
    ReactInstanceMap.remove(inst);

    // Some existing components rely on inst.props even after they've been
    // destroyed (in event handlers).
    // TODO: inst.props = null;
    // TODO: inst.state = null;
    // TODO: inst.context = null;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _maskContext: function (context) {
    var Component = this._currentElement.type;
    var contextTypes = Component.contextTypes;
    if (!contextTypes) {
      return emptyObject;
    }
    var maskedContext = {};
    for (var contextName in contextTypes) {
      maskedContext[contextName] = context[contextName];
    }
    return maskedContext;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`, and asserts that they are valid.
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _processContext: function (context) {
    var maskedContext = this._maskContext(context);
    if (false) {
      var Component = this._currentElement.type;
      if (Component.contextTypes) {
        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
      }
    }
    return maskedContext;
  },

  /**
   * @param {object} currentContext
   * @return {object}
   * @private
   */
  _processChildContext: function (currentContext) {
    var Component = this._currentElement.type;
    var inst = this._instance;
    var childContext;

    if (inst.getChildContext) {
      if (false) {
        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
        try {
          childContext = inst.getChildContext();
        } finally {
          ReactInstrumentation.debugTool.onEndProcessingChildContext();
        }
      } else {
        childContext = inst.getChildContext();
      }
    }

    if (childContext) {
      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
      if (false) {
        this._checkContextTypes(Component.childContextTypes, childContext, 'childContext');
      }
      for (var name in childContext) {
        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
      }
      return _assign({}, currentContext, childContext);
    }
    return currentContext;
  },

  /**
   * Assert that the context types are valid
   *
   * @param {object} typeSpecs Map of context field to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @private
   */
  _checkContextTypes: function (typeSpecs, values, location) {
    if (false) {
      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
    }
  },

  receiveComponent: function (nextElement, transaction, nextContext) {
    var prevElement = this._currentElement;
    var prevContext = this._context;

    this._pendingElement = null;

    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
  },

  /**
   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
   * is set, update the component.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (transaction) {
    if (this._pendingElement != null) {
      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
    } else {
      this._updateBatchNumber = null;
    }
  },

  /**
   * Perform an update to a mounted component. The componentWillReceiveProps and
   * shouldComponentUpdate methods are called, then (assuming the update isn't
   * skipped) the remaining update lifecycle methods are called and the DOM
   * representation is updated.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevParentElement
   * @param {ReactElement} nextParentElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
    var inst = this._instance;
    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;

    var willReceive = false;
    var nextContext;

    // Determine if the context has changed or not
    if (this._context === nextUnmaskedContext) {
      nextContext = inst.context;
    } else {
      nextContext = this._processContext(nextUnmaskedContext);
      willReceive = true;
    }

    var prevProps = prevParentElement.props;
    var nextProps = nextParentElement.props;

    // Not a simple state update but a props update
    if (prevParentElement !== nextParentElement) {
      willReceive = true;
    }

    // An update here will schedule an update but immediately set
    // _pendingStateQueue which will ensure that any state updates gets
    // immediately reconciled instead of waiting for the next batch.
    if (willReceive && inst.componentWillReceiveProps) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillReceiveProps(nextProps, nextContext);
        }, this._debugID, 'componentWillReceiveProps');
      } else {
        inst.componentWillReceiveProps(nextProps, nextContext);
      }
    }

    var nextState = this._processPendingState(nextProps, nextContext);
    var shouldUpdate = true;

    if (!this._pendingForceUpdate) {
      if (inst.shouldComponentUpdate) {
        if (false) {
          shouldUpdate = measureLifeCyclePerf(function () {
            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
          }, this._debugID, 'shouldComponentUpdate');
        } else {
          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
        }
      } else {
        if (this._compositeType === CompositeTypes.PureClass) {
          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
        }
      }
    }

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
    }

    this._updateBatchNumber = null;
    if (shouldUpdate) {
      this._pendingForceUpdate = false;
      // Will set `this.props`, `this.state` and `this.context`.
      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
    } else {
      // If it's determined that a component should not update, we still want
      // to set props and state but we shortcut the rest of the update.
      this._currentElement = nextParentElement;
      this._context = nextUnmaskedContext;
      inst.props = nextProps;
      inst.state = nextState;
      inst.context = nextContext;
    }
  },

  _processPendingState: function (props, context) {
    var inst = this._instance;
    var queue = this._pendingStateQueue;
    var replace = this._pendingReplaceState;
    this._pendingReplaceState = false;
    this._pendingStateQueue = null;

    if (!queue) {
      return inst.state;
    }

    if (replace && queue.length === 1) {
      return queue[0];
    }

    var nextState = _assign({}, replace ? queue[0] : inst.state);
    for (var i = replace ? 1 : 0; i < queue.length; i++) {
      var partial = queue[i];
      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
    }

    return nextState;
  },

  /**
   * Merges new props and state, notifies delegate methods of update and
   * performs update.
   *
   * @param {ReactElement} nextElement Next element
   * @param {object} nextProps Next public object to set as properties.
   * @param {?object} nextState Next object to set as state.
   * @param {?object} nextContext Next public object to set as context.
   * @param {ReactReconcileTransaction} transaction
   * @param {?object} unmaskedContext
   * @private
   */
  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
    var _this2 = this;

    var inst = this._instance;

    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
    var prevProps;
    var prevState;
    var prevContext;
    if (hasComponentDidUpdate) {
      prevProps = inst.props;
      prevState = inst.state;
      prevContext = inst.context;
    }

    if (inst.componentWillUpdate) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillUpdate(nextProps, nextState, nextContext);
        }, this._debugID, 'componentWillUpdate');
      } else {
        inst.componentWillUpdate(nextProps, nextState, nextContext);
      }
    }

    this._currentElement = nextElement;
    this._context = unmaskedContext;
    inst.props = nextProps;
    inst.state = nextState;
    inst.context = nextContext;

    this._updateRenderedComponent(transaction, unmaskedContext);

    if (hasComponentDidUpdate) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
      }
    }
  },

  /**
   * Call the component's `render` method and update the DOM accordingly.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  _updateRenderedComponent: function (transaction, context) {
    var prevComponentInstance = this._renderedComponent;
    var prevRenderedElement = prevComponentInstance._currentElement;
    var nextRenderedElement = this._renderValidatedComponent();

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
    } else {
      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
      ReactReconciler.unmountComponent(prevComponentInstance, false);

      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
      this._renderedNodeType = nodeType;
      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
      );
      this._renderedComponent = child;

      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);

      if (false) {
        if (debugID !== 0) {
          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
        }
      }

      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
    }
  },

  /**
   * Overridden in shallow rendering.
   *
   * @protected
   */
  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
  },

  /**
   * @protected
   */
  _renderValidatedComponentWithoutOwnerOrContext: function () {
    var inst = this._instance;
    var renderedElement;

    if (false) {
      renderedElement = measureLifeCyclePerf(function () {
        return inst.render();
      }, this._debugID, 'render');
    } else {
      renderedElement = inst.render();
    }

    if (false) {
      // We allow auto-mocks to proceed as if they're returning null.
      if (renderedElement === undefined && inst.render._isMockFunction) {
        // This is probably bad practice. Consider warning here and
        // deprecating this convenience.
        renderedElement = null;
      }
    }

    return renderedElement;
  },

  /**
   * @private
   */
  _renderValidatedComponent: function () {
    var renderedElement;
    if ("production" !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
      ReactCurrentOwner.current = this;
      try {
        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
    }
    !(
    // TODO: An `isValidNode` function would probably be more appropriate
    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;

    return renderedElement;
  },

  /**
   * Lazily allocates the refs object and stores `component` as `ref`.
   *
   * @param {string} ref Reference name.
   * @param {component} component Component to store as `ref`.
   * @final
   * @private
   */
  attachRef: function (ref, component) {
    var inst = this.getPublicInstance();
    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
    var publicComponentInstance = component.getPublicInstance();
    if (false) {
      var componentName = component && component.getName ? component.getName() : 'a component';
      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
    }
    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
    refs[ref] = publicComponentInstance;
  },

  /**
   * Detaches a reference name.
   *
   * @param {string} ref Name to dereference.
   * @final
   * @private
   */
  detachRef: function (ref) {
    var refs = this.getPublicInstance().refs;
    delete refs[ref];
  },

  /**
   * Get a text description of the component that can be used to identify it
   * in error messages.
   * @return {string} The name or null.
   * @internal
   */
  getName: function () {
    var type = this._currentElement.type;
    var constructor = this._instance && this._instance.constructor;
    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
  },

  /**
   * Get the publicly accessible representation of this component - i.e. what
   * is exposed by refs and returned by render. Can be null for stateless
   * components.
   *
   * @return {ReactComponent} the public component instance.
   * @internal
   */
  getPublicInstance: function () {
    var inst = this._instance;
    if (this._compositeType === CompositeTypes.StatelessFunctional) {
      return null;
    }
    return inst;
  },

  // Stub
  _instantiateReactComponent: null

};

module.exports = ReactCompositeComponent;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var nextDebugID = 1;

function getNextDebugID() {
  return nextDebugID++;
}

module.exports = getNextDebugID;

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var KeyEscapeUtils = __webpack_require__(173);
var traverseAllChildren = __webpack_require__(247);
var warning = __webpack_require__(6);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && Object({"NODE_ENV":"production"}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(248);
}

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 * @param {number=} selfDebugID Optional debugID of the current internal instance.
 */
function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
  // We found a component instance.
  if (traverseContext && typeof traverseContext === 'object') {
    var result = traverseContext;
    var keyUnique = result[name] === undefined;
    if (false) {
      if (!ReactComponentTreeHook) {
        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
      }
      if (!keyUnique) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
      }
    }
    if (keyUnique && child != null) {
      result[name] = child;
    }
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children, selfDebugID) {
  if (children == null) {
    return children;
  }
  var result = {};

  if (false) {
    traverseAllChildren(children, function (traverseContext, child, name) {
      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
    }, result);
  } else {
    traverseAllChildren(children, flattenSingleChildIntoContext, result);
  }
  return result;
}

module.exports = flattenChildren;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)))

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(15);

var PooledClass = __webpack_require__(65);
var Transaction = __webpack_require__(118);
var ReactInstrumentation = __webpack_require__(38);
var ReactServerUpdateQueue = __webpack_require__(442);

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

var noopCallbackQueue = {
  enqueue: function () {}
};

/**
 * @class ReactServerRenderingTransaction
 * @param {boolean} renderToStaticMarkup
 */
function ReactServerRenderingTransaction(renderToStaticMarkup) {
  this.reinitializeTransaction();
  this.renderToStaticMarkup = renderToStaticMarkup;
  this.useCreateElement = false;
  this.updateQueue = new ReactServerUpdateQueue(this);
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array} Empty list of operation wrap procedures.
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return noopCallbackQueue;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return this.updateQueue;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {},

  checkpoint: function () {},

  rollback: function () {}
};

_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactServerRenderingTransaction);

module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReactUpdateQueue = __webpack_require__(174);

var warning = __webpack_require__(6);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the update queue used for server rendering.
 * It delegates to ReactUpdateQueue while server rendering is in progress and
 * switches to ReactNoopUpdateQueue after the transaction has completed.
 * @class ReactServerUpdateQueue
 * @param {Transaction} transaction
 */

var ReactServerUpdateQueue = function () {
  function ReactServerUpdateQueue(transaction) {
    _classCallCheck(this, ReactServerUpdateQueue);

    this.transaction = transaction;
  }

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */


  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
    return false;
  };

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
    }
  };

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
    } else {
      warnNoop(publicInstance, 'forceUpdate');
    }
  };

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} completeState Next state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
    } else {
      warnNoop(publicInstance, 'replaceState');
    }
  };

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} partialState Next partial state to be merged with state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
    } else {
      warnNoop(publicInstance, 'setState');
    }
  };

  return ReactServerUpdateQueue;
}();

module.exports = ReactServerUpdateQueue;

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(15);

var DOMLazyTree = __webpack_require__(84);
var ReactDOMComponentTree = __webpack_require__(21);

var ReactDOMEmptyComponent = function (instantiate) {
  // ReactCompositeComponent uses this:
  this._currentElement = null;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;
  this._hostContainerInfo = null;
  this._domID = 0;
};
_assign(ReactDOMEmptyComponent.prototype, {
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var domID = hostContainerInfo._idCounter++;
    this._domID = domID;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var nodeValue = ' react-empty: ' + this._domID + ' ';
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var node = ownerDocument.createComment(nodeValue);
      ReactDOMComponentTree.precacheNode(this, node);
      return DOMLazyTree(node);
    } else {
      if (transaction.renderToStaticMarkup) {
        // Normally we'd insert a comment node, but since this is a situation
        // where React won't take over (static pages), we can simply return
        // nothing.
        return '';
      }
      return '<!--' + nodeValue + '-->';
    }
  },
  receiveComponent: function () {},
  getHostNode: function () {
    return ReactDOMComponentTree.getNodeFromInstance(this);
  },
  unmountComponent: function () {
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var invariant = __webpack_require__(5);

/**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */
function getLowestCommonAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  var depthA = 0;
  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
    depthA++;
  }
  var depthB = 0;
  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
    depthB++;
  }

  // If A is deeper, crawl up.
  while (depthA - depthB > 0) {
    instA = instA._hostParent;
    depthA--;
  }

  // If B is deeper, crawl up.
  while (depthB - depthA > 0) {
    instB = instB._hostParent;
    depthB--;
  }

  // Walk in lockstep until we find a match.
  var depth = depthA;
  while (depth--) {
    if (instA === instB) {
      return instA;
    }
    instA = instA._hostParent;
    instB = instB._hostParent;
  }
  return null;
}

/**
 * Return if A is an ancestor of B.
 */
function isAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;

  while (instB) {
    if (instB === instA) {
      return true;
    }
    instB = instB._hostParent;
  }
  return false;
}

/**
 * Return the parent instance of the passed-in instance.
 */
function getParentInstance(inst) {
  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;

  return inst._hostParent;
}

/**
 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
 */
function traverseTwoPhase(inst, fn, arg) {
  var path = [];
  while (inst) {
    path.push(inst);
    inst = inst._hostParent;
  }
  var i;
  for (i = path.length; i-- > 0;) {
    fn(path[i], 'captured', arg);
  }
  for (i = 0; i < path.length; i++) {
    fn(path[i], 'bubbled', arg);
  }
}

/**
 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
 * should would receive a `mouseEnter` or `mouseLeave` event.
 *
 * Does not invoke the callback on the nearest common ancestor because nothing
 * "entered" or "left" that element.
 */
function traverseEnterLeave(from, to, fn, argFrom, argTo) {
  var common = from && to ? getLowestCommonAncestor(from, to) : null;
  var pathFrom = [];
  while (from && from !== common) {
    pathFrom.push(from);
    from = from._hostParent;
  }
  var pathTo = [];
  while (to && to !== common) {
    pathTo.push(to);
    to = to._hostParent;
  }
  var i;
  for (i = 0; i < pathFrom.length; i++) {
    fn(pathFrom[i], 'bubbled', argFrom);
  }
  for (i = pathTo.length; i-- > 0;) {
    fn(pathTo[i], 'captured', argTo);
  }
}

module.exports = {
  isAncestor: isAncestor,
  getLowestCommonAncestor: getLowestCommonAncestor,
  getParentInstance: getParentInstance,
  traverseTwoPhase: traverseTwoPhase,
  traverseEnterLeave: traverseEnterLeave
};

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7),
    _assign = __webpack_require__(15);

var DOMChildrenOperations = __webpack_require__(166);
var DOMLazyTree = __webpack_require__(84);
var ReactDOMComponentTree = __webpack_require__(21);

var escapeTextContentForBrowser = __webpack_require__(121);
var invariant = __webpack_require__(5);
var validateDOMNesting = __webpack_require__(175);

/**
 * Text nodes violate a couple assumptions that React makes about components:
 *
 *  - When mounting text into the DOM, adjacent text nodes are merged.
 *  - Text nodes cannot be assigned a React root ID.
 *
 * This component is used to wrap strings between comment nodes so that they
 * can undergo the same reconciliation that is applied to elements.
 *
 * TODO: Investigate representing React components in the DOM with text nodes.
 *
 * @class ReactDOMTextComponent
 * @extends ReactComponent
 * @internal
 */
var ReactDOMTextComponent = function (text) {
  // TODO: This is really a ReactText (ReactNode), not a ReactElement
  this._currentElement = text;
  this._stringText = '' + text;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;

  // Properties
  this._domID = 0;
  this._mountIndex = 0;
  this._closingComment = null;
  this._commentNodes = null;
};

_assign(ReactDOMTextComponent.prototype, {

  /**
   * Creates the markup for this text node. This node is not intended to have
   * any features besides containing text content.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {string} Markup for this text node.
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo != null) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(null, this._stringText, this, parentInfo);
      }
    }

    var domID = hostContainerInfo._idCounter++;
    var openingValue = ' react-text: ' + domID + ' ';
    var closingValue = ' /react-text ';
    this._domID = domID;
    this._hostParent = hostParent;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var openingComment = ownerDocument.createComment(openingValue);
      var closingComment = ownerDocument.createComment(closingValue);
      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
      if (this._stringText) {
        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
      }
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
      ReactDOMComponentTree.precacheNode(this, openingComment);
      this._closingComment = closingComment;
      return lazyTree;
    } else {
      var escapedText = escapeTextContentForBrowser(this._stringText);

      if (transaction.renderToStaticMarkup) {
        // Normally we'd wrap this between comment nodes for the reasons stated
        // above, but since this is a situation where React won't take over
        // (static pages), we can simply return the text as it is.
        return escapedText;
      }

      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
    }
  },

  /**
   * Updates this component by updating the text content.
   *
   * @param {ReactText} nextText The next text content
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  receiveComponent: function (nextText, transaction) {
    if (nextText !== this._currentElement) {
      this._currentElement = nextText;
      var nextStringText = '' + nextText;
      if (nextStringText !== this._stringText) {
        // TODO: Save this as pending props and use performUpdateIfNecessary
        // and/or updateComponent to do the actual update for consistency with
        // other component types?
        this._stringText = nextStringText;
        var commentNodes = this.getHostNode();
        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
      }
    }
  },

  getHostNode: function () {
    var hostNode = this._commentNodes;
    if (hostNode) {
      return hostNode;
    }
    if (!this._closingComment) {
      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
      var node = openingComment.nextSibling;
      while (true) {
        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
          this._closingComment = node;
          break;
        }
        node = node.nextSibling;
      }
    }
    hostNode = [this._hostNode, this._closingComment];
    this._commentNodes = hostNode;
    return hostNode;
  },

  unmountComponent: function () {
    this._closingComment = null;
    this._commentNodes = null;
    ReactDOMComponentTree.uncacheNode(this);
  }

});

module.exports = ReactDOMTextComponent;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(15);

var ReactUpdates = __webpack_require__(40);
var Transaction = __webpack_require__(118);

var emptyFunction = __webpack_require__(37);

var RESET_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: function () {
    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
  }
};

var FLUSH_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
};

var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

function ReactDefaultBatchingStrategyTransaction() {
  this.reinitializeTransaction();
}

_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  }
});

var transaction = new ReactDefaultBatchingStrategyTransaction();

var ReactDefaultBatchingStrategy = {
  isBatchingUpdates: false,

  /**
   * Call the provided function in a context within which calls to `setState`
   * and friends are batched such that components aren't updated unnecessarily.
   */
  batchedUpdates: function (callback, a, b, c, d, e) {
    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

    // The code is written this way to avoid extra allocations
    if (alreadyBatchingUpdates) {
      return callback(a, b, c, d, e);
    } else {
      return transaction.perform(callback, null, a, b, c, d, e);
    }
  }
};

module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(15);

var EventListener = __webpack_require__(249);
var ExecutionEnvironment = __webpack_require__(31);
var PooledClass = __webpack_require__(65);
var ReactDOMComponentTree = __webpack_require__(21);
var ReactUpdates = __webpack_require__(40);

var getEventTarget = __webpack_require__(163);
var getUnboundedScrollPosition = __webpack_require__(448);

/**
 * Find the deepest React component completely containing the root of the
 * passed-in instance (for use when entire React trees are nested within each
 * other). If React trees are not nested, returns null.
 */
function findParent(inst) {
  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
  // traversal, but caching is difficult to do correctly without using a
  // mutation observer to listen for all DOM changes.
  while (inst._hostParent) {
    inst = inst._hostParent;
  }
  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
  var container = rootNode.parentNode;
  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
}

// Used to store ancestor hierarchy in top level callback
function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
  this.topLevelType = topLevelType;
  this.nativeEvent = nativeEvent;
  this.ancestors = [];
}
_assign(TopLevelCallbackBookKeeping.prototype, {
  destructor: function () {
    this.topLevelType = null;
    this.nativeEvent = null;
    this.ancestors.length = 0;
  }
});
PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);

function handleTopLevelImpl(bookKeeping) {
  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);

  // Loop through the hierarchy, in case there's any nested components.
  // It's important that we build the array of ancestors before calling any
  // event handlers, because event handlers can modify the DOM, leading to
  // inconsistencies with ReactMount's node cache. See #1105.
  var ancestor = targetInst;
  do {
    bookKeeping.ancestors.push(ancestor);
    ancestor = ancestor && findParent(ancestor);
  } while (ancestor);

  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
    targetInst = bookKeeping.ancestors[i];
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

function scrollValueMonitor(cb) {
  var scrollPosition = getUnboundedScrollPosition(window);
  cb(scrollPosition);
}

var ReactEventListener = {
  _enabled: true,
  _handleTopLevel: null,

  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

  setHandleTopLevel: function (handleTopLevel) {
    ReactEventListener._handleTopLevel = handleTopLevel;
  },

  setEnabled: function (enabled) {
    ReactEventListener._enabled = !!enabled;
  },

  isEnabled: function () {
    return ReactEventListener._enabled;
  },

  /**
   * Traps top-level events by using event bubbling.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  /**
   * Traps a top-level event by using event capturing.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  monitorScrollValue: function (refresh) {
    var callback = scrollValueMonitor.bind(null, refresh);
    EventListener.listen(window, 'scroll', callback);
  },

  dispatchEvent: function (topLevelType, nativeEvent) {
    if (!ReactEventListener._enabled) {
      return;
    }

    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
    try {
      // Event queue being processed in the same cycle allows
      // `preventDefault`.
      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
    } finally {
      TopLevelCallbackBookKeeping.release(bookKeeping);
    }
  }
};

module.exports = ReactEventListener;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(82);
var EventPluginHub = __webpack_require__(101);
var EventPluginUtils = __webpack_require__(161);
var ReactComponentEnvironment = __webpack_require__(170);
var ReactEmptyComponent = __webpack_require__(245);
var ReactBrowserEventEmitter = __webpack_require__(122);
var ReactHostComponent = __webpack_require__(246);
var ReactUpdates = __webpack_require__(40);

var ReactInjection = {
  Component: ReactComponentEnvironment.injection,
  DOMProperty: DOMProperty.injection,
  EmptyComponent: ReactEmptyComponent.injection,
  EventPluginHub: EventPluginHub.injection,
  EventPluginUtils: EventPluginUtils.injection,
  EventEmitter: ReactBrowserEventEmitter.injection,
  HostComponent: ReactHostComponent.injection,
  Updates: ReactUpdates.injection
};

module.exports = ReactInjection;

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(15);

var CallbackQueue = __webpack_require__(234);
var PooledClass = __webpack_require__(65);
var ReactBrowserEventEmitter = __webpack_require__(122);
var ReactInputSelection = __webpack_require__(250);
var ReactInstrumentation = __webpack_require__(38);
var Transaction = __webpack_require__(118);
var ReactUpdateQueue = __webpack_require__(174);

/**
 * Ensures that, when possible, the selection range (currently selected text
 * input) is not disturbed by performing the transaction.
 */
var SELECTION_RESTORATION = {
  /**
   * @return {Selection} Selection information.
   */
  initialize: ReactInputSelection.getSelectionInformation,
  /**
   * @param {Selection} sel Selection information returned from `initialize`.
   */
  close: ReactInputSelection.restoreSelection
};

/**
 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
 * high level DOM manipulations (like temporarily removing a text input from the
 * DOM).
 */
var EVENT_SUPPRESSION = {
  /**
   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
   * the reconciliation.
   */
  initialize: function () {
    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
    ReactBrowserEventEmitter.setEnabled(false);
    return currentlyEnabled;
  },

  /**
   * @param {boolean} previouslyEnabled Enabled status of
   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
   *   restores the previous value.
   */
  close: function (previouslyEnabled) {
    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
  }
};

/**
 * Provides a queue for collecting `componentDidMount` and
 * `componentDidUpdate` callbacks during the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  /**
   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
   */
  close: function () {
    this.reactMountReady.notifyAll();
  }
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

/**
 * Currently:
 * - The order that these are listed in the transaction is critical:
 * - Suppresses events.
 * - Restores selection range.
 *
 * Future:
 * - Restore document/overflow scroll positions that were unintentionally
 *   modified via DOM insertions above the top viewport boundary.
 * - Implement/integrate with customized constraint based layout system and keep
 *   track of which dimensions must be remeasured.
 *
 * @class ReactReconcileTransaction
 */
function ReactReconcileTransaction(useCreateElement) {
  this.reinitializeTransaction();
  // Only server-side rendering really needs this option (see
  // `ReactServerRendering`), but server-side uses
  // `ReactServerRenderingTransaction` instead. This option is here so that it's
  // accessible and defaults to false when `ReactDOMComponent` and
  // `ReactDOMTextComponent` checks it in `mountComponent`.`
  this.renderToStaticMarkup = false;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = useCreateElement;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array<object>} List of operation wrap procedures.
   *   TODO: convert to array<TransactionWrapper>
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return ReactUpdateQueue;
  },

  /**
   * Save current transaction state -- if the return value from this method is
   * passed to `rollback`, the transaction will be reset to that state.
   */
  checkpoint: function () {
    // reactMountReady is the our only stateful wrapper
    return this.reactMountReady.checkpoint();
  },

  rollback: function (checkpoint) {
    this.reactMountReady.rollback(checkpoint);
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactReconcileTransaction);

module.exports = ReactReconcileTransaction;

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(31);

var getNodeForCharacterOffset = __webpack_require__(452);
var getTextContentAccessor = __webpack_require__(233);

/**
 * While `isCollapsed` is available on the Selection object and `collapsed`
 * is available on the Range object, IE11 sometimes gets them wrong.
 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
 */
function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
  return anchorNode === focusNode && anchorOffset === focusOffset;
}

/**
 * Get the appropriate anchor and focus node/offset pairs for IE.
 *
 * The catch here is that IE's selection API doesn't provide information
 * about whether the selection is forward or backward, so we have to
 * behave as though it's always forward.
 *
 * IE text differs from modern selection in that it behaves as though
 * block elements end with a new line. This means character offsets will
 * differ between the two APIs.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getIEOffsets(node) {
  var selection = document.selection;
  var selectedRange = selection.createRange();
  var selectedLength = selectedRange.text.length;

  // Duplicate selection so we can move range without breaking user selection.
  var fromStart = selectedRange.duplicate();
  fromStart.moveToElementText(node);
  fromStart.setEndPoint('EndToStart', selectedRange);

  var startOffset = fromStart.text.length;
  var endOffset = startOffset + selectedLength;

  return {
    start: startOffset,
    end: endOffset
  };
}

/**
 * @param {DOMElement} node
 * @return {?object}
 */
function getModernOffsets(node) {
  var selection = window.getSelection && window.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode;
  var anchorOffset = selection.anchorOffset;
  var focusNode = selection.focusNode;
  var focusOffset = selection.focusOffset;

  var currentRange = selection.getRangeAt(0);

  // In Firefox, range.startContainer and range.endContainer can be "anonymous
  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
  // divs do not seem to expose properties, triggering a "Permission denied
  // error" if any of its properties are accessed. The only seemingly possible
  // way to avoid erroring is to access a property that typically works for
  // non-anonymous divs and catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
  try {
    /* eslint-disable no-unused-expressions */
    currentRange.startContainer.nodeType;
    currentRange.endContainer.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  // If the node and offset values are the same, the selection is collapsed.
  // `Selection.isCollapsed` is available natively, but IE sometimes gets
  // this value wrong.
  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);

  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

  var tempRange = currentRange.cloneRange();
  tempRange.selectNodeContents(node);
  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);

  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
  var end = start + rangeLength;

  // Detect whether the selection is backward.
  var detectionRange = document.createRange();
  detectionRange.setStart(anchorNode, anchorOffset);
  detectionRange.setEnd(focusNode, focusOffset);
  var isBackward = detectionRange.collapsed;

  return {
    start: isBackward ? end : start,
    end: isBackward ? start : end
  };
}

/**
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setIEOffsets(node, offsets) {
  var range = document.selection.createRange().duplicate();
  var start, end;

  if (offsets.end === undefined) {
    start = offsets.start;
    end = start;
  } else if (offsets.start > offsets.end) {
    start = offsets.end;
    end = offsets.start;
  } else {
    start = offsets.start;
    end = offsets.end;
  }

  range.moveToElementText(node);
  range.moveStart('character', start);
  range.setEndPoint('EndToStart', range);
  range.moveEnd('character', end - start);
  range.select();
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setModernOffsets(node, offsets) {
  if (!window.getSelection) {
    return;
  }

  var selection = window.getSelection();
  var length = node[getTextContentAccessor()].length;
  var start = Math.min(offsets.start, length);
  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);

  // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.
  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    var range = document.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);

var ReactDOMSelection = {
  /**
   * @param {DOMElement} node
   */
  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

  /**
   * @param {DOMElement|DOMTextNode} node
   * @param {object} offsets
   */
  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
};

module.exports = ReactDOMSelection;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */

function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */
function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }
    node = node.parentNode;
  }
}

/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === 3) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

module.exports = getNodeForCharacterOffset;

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(454);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(455);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var NS = {
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace'
};

// We use attributes for everything SVG so let's avoid some duplication and run
// code instead.
// The following are all specified in the HTML config already so we exclude here.
// - class (as className)
// - color
// - height
// - id
// - lang
// - max
// - media
// - method
// - min
// - name
// - style
// - target
// - type
// - width
var ATTRS = {
  accentHeight: 'accent-height',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 'alignment-baseline',
  allowReorder: 'allowReorder',
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 'arabic-form',
  ascent: 0,
  attributeName: 'attributeName',
  attributeType: 'attributeType',
  autoReverse: 'autoReverse',
  azimuth: 0,
  baseFrequency: 'baseFrequency',
  baseProfile: 'baseProfile',
  baselineShift: 'baseline-shift',
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 'calcMode',
  capHeight: 'cap-height',
  clip: 0,
  clipPath: 'clip-path',
  clipRule: 'clip-rule',
  clipPathUnits: 'clipPathUnits',
  colorInterpolation: 'color-interpolation',
  colorInterpolationFilters: 'color-interpolation-filters',
  colorProfile: 'color-profile',
  colorRendering: 'color-rendering',
  contentScriptType: 'contentScriptType',
  contentStyleType: 'contentStyleType',
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 'diffuseConstant',
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 'dominant-baseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 'edgeMode',
  elevation: 0,
  enableBackground: 'enable-background',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 'externalResourcesRequired',
  fill: 0,
  fillOpacity: 'fill-opacity',
  fillRule: 'fill-rule',
  filter: 0,
  filterRes: 'filterRes',
  filterUnits: 'filterUnits',
  floodColor: 'flood-color',
  floodOpacity: 'flood-opacity',
  focusable: 0,
  fontFamily: 'font-family',
  fontSize: 'font-size',
  fontSizeAdjust: 'font-size-adjust',
  fontStretch: 'font-stretch',
  fontStyle: 'font-style',
  fontVariant: 'font-variant',
  fontWeight: 'font-weight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 'glyph-name',
  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
  glyphOrientationVertical: 'glyph-orientation-vertical',
  glyphRef: 'glyphRef',
  gradientTransform: 'gradientTransform',
  gradientUnits: 'gradientUnits',
  hanging: 0,
  horizAdvX: 'horiz-adv-x',
  horizOriginX: 'horiz-origin-x',
  ideographic: 0,
  imageRendering: 'image-rendering',
  'in': 0,
  in2: 0,
  intercept: 0,
  k: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  kernelMatrix: 'kernelMatrix',
  kernelUnitLength: 'kernelUnitLength',
  kerning: 0,
  keyPoints: 'keyPoints',
  keySplines: 'keySplines',
  keyTimes: 'keyTimes',
  lengthAdjust: 'lengthAdjust',
  letterSpacing: 'letter-spacing',
  lightingColor: 'lighting-color',
  limitingConeAngle: 'limitingConeAngle',
  local: 0,
  markerEnd: 'marker-end',
  markerMid: 'marker-mid',
  markerStart: 'marker-start',
  markerHeight: 'markerHeight',
  markerUnits: 'markerUnits',
  markerWidth: 'markerWidth',
  mask: 0,
  maskContentUnits: 'maskContentUnits',
  maskUnits: 'maskUnits',
  mathematical: 0,
  mode: 0,
  numOctaves: 'numOctaves',
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 'overline-position',
  overlineThickness: 'overline-thickness',
  paintOrder: 'paint-order',
  panose1: 'panose-1',
  pathLength: 'pathLength',
  patternContentUnits: 'patternContentUnits',
  patternTransform: 'patternTransform',
  patternUnits: 'patternUnits',
  pointerEvents: 'pointer-events',
  points: 0,
  pointsAtX: 'pointsAtX',
  pointsAtY: 'pointsAtY',
  pointsAtZ: 'pointsAtZ',
  preserveAlpha: 'preserveAlpha',
  preserveAspectRatio: 'preserveAspectRatio',
  primitiveUnits: 'primitiveUnits',
  r: 0,
  radius: 0,
  refX: 'refX',
  refY: 'refY',
  renderingIntent: 'rendering-intent',
  repeatCount: 'repeatCount',
  repeatDur: 'repeatDur',
  requiredExtensions: 'requiredExtensions',
  requiredFeatures: 'requiredFeatures',
  restart: 0,
  result: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  seed: 0,
  shapeRendering: 'shape-rendering',
  slope: 0,
  spacing: 0,
  specularConstant: 'specularConstant',
  specularExponent: 'specularExponent',
  speed: 0,
  spreadMethod: 'spreadMethod',
  startOffset: 'startOffset',
  stdDeviation: 'stdDeviation',
  stemh: 0,
  stemv: 0,
  stitchTiles: 'stitchTiles',
  stopColor: 'stop-color',
  stopOpacity: 'stop-opacity',
  strikethroughPosition: 'strikethrough-position',
  strikethroughThickness: 'strikethrough-thickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 'stroke-dasharray',
  strokeDashoffset: 'stroke-dashoffset',
  strokeLinecap: 'stroke-linecap',
  strokeLinejoin: 'stroke-linejoin',
  strokeMiterlimit: 'stroke-miterlimit',
  strokeOpacity: 'stroke-opacity',
  strokeWidth: 'stroke-width',
  surfaceScale: 'surfaceScale',
  systemLanguage: 'systemLanguage',
  tableValues: 'tableValues',
  targetX: 'targetX',
  targetY: 'targetY',
  textAnchor: 'text-anchor',
  textDecoration: 'text-decoration',
  textRendering: 'text-rendering',
  textLength: 'textLength',
  to: 0,
  transform: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 'underline-position',
  underlineThickness: 'underline-thickness',
  unicode: 0,
  unicodeBidi: 'unicode-bidi',
  unicodeRange: 'unicode-range',
  unitsPerEm: 'units-per-em',
  vAlphabetic: 'v-alphabetic',
  vHanging: 'v-hanging',
  vIdeographic: 'v-ideographic',
  vMathematical: 'v-mathematical',
  values: 0,
  vectorEffect: 'vector-effect',
  version: 0,
  vertAdvY: 'vert-adv-y',
  vertOriginX: 'vert-origin-x',
  vertOriginY: 'vert-origin-y',
  viewBox: 'viewBox',
  viewTarget: 'viewTarget',
  visibility: 0,
  widths: 0,
  wordSpacing: 'word-spacing',
  writingMode: 'writing-mode',
  x: 0,
  xHeight: 'x-height',
  x1: 0,
  x2: 0,
  xChannelSelector: 'xChannelSelector',
  xlinkActuate: 'xlink:actuate',
  xlinkArcrole: 'xlink:arcrole',
  xlinkHref: 'xlink:href',
  xlinkRole: 'xlink:role',
  xlinkShow: 'xlink:show',
  xlinkTitle: 'xlink:title',
  xlinkType: 'xlink:type',
  xmlBase: 'xml:base',
  xmlns: 0,
  xmlnsXlink: 'xmlns:xlink',
  xmlLang: 'xml:lang',
  xmlSpace: 'xml:space',
  y: 0,
  y1: 0,
  y2: 0,
  yChannelSelector: 'yChannelSelector',
  z: 0,
  zoomAndPan: 'zoomAndPan'
};

var SVGDOMPropertyConfig = {
  Properties: {},
  DOMAttributeNamespaces: {
    xlinkActuate: NS.xlink,
    xlinkArcrole: NS.xlink,
    xlinkHref: NS.xlink,
    xlinkRole: NS.xlink,
    xlinkShow: NS.xlink,
    xlinkTitle: NS.xlink,
    xlinkType: NS.xlink,
    xmlBase: NS.xml,
    xmlLang: NS.xml,
    xmlSpace: NS.xml
  },
  DOMAttributeNames: {}
};

Object.keys(ATTRS).forEach(function (key) {
  SVGDOMPropertyConfig.Properties[key] = 0;
  if (ATTRS[key]) {
    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
  }
});

module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(100);
var ExecutionEnvironment = __webpack_require__(31);
var ReactDOMComponentTree = __webpack_require__(21);
var ReactInputSelection = __webpack_require__(250);
var SyntheticEvent = __webpack_require__(50);

var getActiveElement = __webpack_require__(251);
var isTextInputElement = __webpack_require__(236);
var shallowEqual = __webpack_require__(171);

var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;

var eventTypes = {
  select: {
    phasedRegistrationNames: {
      bubbled: 'onSelect',
      captured: 'onSelectCapture'
    },
    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
  }
};

var activeElement = null;
var activeElementInst = null;
var lastSelection = null;
var mouseDown = false;

// Track whether a listener exists for this plugin. If none exist, we do
// not extract events. See #3639.
var hasListener = false;

/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getSelection(node) {
  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else if (window.getSelection) {
    var selection = window.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  } else if (document.selection) {
    var range = document.selection.createRange();
    return {
      parentElement: range.parentElement(),
      text: range.text,
      top: range.boundingTop,
      left: range.boundingLeft
    };
  }
}

/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @return {?SyntheticEvent}
 */
function constructSelectEvent(nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
    return null;
  }

  // Only fire when selection has actually changed.
  var currentSelection = getSelection(activeElement);
  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;

    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);

    syntheticEvent.type = 'select';
    syntheticEvent.target = activeElement;

    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

    return syntheticEvent;
  }

  return null;
}

/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */
var SelectEventPlugin = {

  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (!hasListener) {
      return null;
    }

    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    switch (topLevelType) {
      // Track the input node that has focus.
      case 'topFocus':
        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
          activeElement = targetNode;
          activeElementInst = targetInst;
          lastSelection = null;
        }
        break;
      case 'topBlur':
        activeElement = null;
        activeElementInst = null;
        lastSelection = null;
        break;

      // Don't fire the event while the user is dragging. This matches the
      // semantics of the native select event.
      case 'topMouseDown':
        mouseDown = true;
        break;
      case 'topContextMenu':
      case 'topMouseUp':
        mouseDown = false;
        return constructSelectEvent(nativeEvent, nativeEventTarget);

      // Chrome and IE fire non-standard event when selection is changed (and
      // sometimes when it hasn't). IE's event fires out of order with respect
      // to key and input events on deletion, so we discard it.
      //
      // Firefox doesn't support selectionchange, so check selection status
      // after each key entry. The selection changes after keydown and before
      // keyup, but we check on keydown as well in the case of holding down a
      // key, when multiple keydown events are fired but only one keyup is.
      // This is also our approach for IE handling, for the reason above.
      case 'topSelectionChange':
        if (skipSelectionChangeEvent) {
          break;
        }
      // falls through
      case 'topKeyDown':
      case 'topKeyUp':
        return constructSelectEvent(nativeEvent, nativeEventTarget);
    }

    return null;
  },

  didPutListener: function (inst, registrationName, listener) {
    if (registrationName === 'onSelect') {
      hasListener = true;
    }
  }
};

module.exports = SelectEventPlugin;

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(7);

var EventListener = __webpack_require__(249);
var EventPropagators = __webpack_require__(100);
var ReactDOMComponentTree = __webpack_require__(21);
var SyntheticAnimationEvent = __webpack_require__(459);
var SyntheticClipboardEvent = __webpack_require__(460);
var SyntheticEvent = __webpack_require__(50);
var SyntheticFocusEvent = __webpack_require__(461);
var SyntheticKeyboardEvent = __webpack_require__(462);
var SyntheticMouseEvent = __webpack_require__(119);
var SyntheticDragEvent = __webpack_require__(464);
var SyntheticTouchEvent = __webpack_require__(465);
var SyntheticTransitionEvent = __webpack_require__(466);
var SyntheticUIEvent = __webpack_require__(102);
var SyntheticWheelEvent = __webpack_require__(467);

var emptyFunction = __webpack_require__(37);
var getEventCharCode = __webpack_require__(176);
var invariant = __webpack_require__(5);

/**
 * Turns
 * ['abort', ...]
 * into
 * eventTypes = {
 *   'abort': {
 *     phasedRegistrationNames: {
 *       bubbled: 'onAbort',
 *       captured: 'onAbortCapture',
 *     },
 *     dependencies: ['topAbort'],
 *   },
 *   ...
 * };
 * topLevelEventsToDispatchConfig = {
 *   'topAbort': { sameConfig }
 * };
 */
var eventTypes = {};
var topLevelEventsToDispatchConfig = {};
['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
  var onEvent = 'on' + capitalizedEvent;
  var topEvent = 'top' + capitalizedEvent;

  var type = {
    phasedRegistrationNames: {
      bubbled: onEvent,
      captured: onEvent + 'Capture'
    },
    dependencies: [topEvent]
  };
  eventTypes[event] = type;
  topLevelEventsToDispatchConfig[topEvent] = type;
});

var onClickListeners = {};

function getDictionaryKey(inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
}

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

var SimpleEventPlugin = {

  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
    if (!dispatchConfig) {
      return null;
    }
    var EventConstructor;
    switch (topLevelType) {
      case 'topAbort':
      case 'topCanPlay':
      case 'topCanPlayThrough':
      case 'topDurationChange':
      case 'topEmptied':
      case 'topEncrypted':
      case 'topEnded':
      case 'topError':
      case 'topInput':
      case 'topInvalid':
      case 'topLoad':
      case 'topLoadedData':
      case 'topLoadedMetadata':
      case 'topLoadStart':
      case 'topPause':
      case 'topPlay':
      case 'topPlaying':
      case 'topProgress':
      case 'topRateChange':
      case 'topReset':
      case 'topSeeked':
      case 'topSeeking':
      case 'topStalled':
      case 'topSubmit':
      case 'topSuspend':
      case 'topTimeUpdate':
      case 'topVolumeChange':
      case 'topWaiting':
        // HTML Events
        // @see http://www.w3.org/TR/html5/index.html#events-0
        EventConstructor = SyntheticEvent;
        break;
      case 'topKeyPress':
        // Firefox creates a keypress event for function keys too. This removes
        // the unwanted keypress events. Enter is however both printable and
        // non-printable. One would expect Tab to be as well (but it isn't).
        if (getEventCharCode(nativeEvent) === 0) {
          return null;
        }
      /* falls through */
      case 'topKeyDown':
      case 'topKeyUp':
        EventConstructor = SyntheticKeyboardEvent;
        break;
      case 'topBlur':
      case 'topFocus':
        EventConstructor = SyntheticFocusEvent;
        break;
      case 'topClick':
        // Firefox creates a click event on right mouse clicks. This removes the
        // unwanted click events.
        if (nativeEvent.button === 2) {
          return null;
        }
      /* falls through */
      case 'topDoubleClick':
      case 'topMouseDown':
      case 'topMouseMove':
      case 'topMouseUp':
      // TODO: Disabled elements should not respond to mouse events
      /* falls through */
      case 'topMouseOut':
      case 'topMouseOver':
      case 'topContextMenu':
        EventConstructor = SyntheticMouseEvent;
        break;
      case 'topDrag':
      case 'topDragEnd':
      case 'topDragEnter':
      case 'topDragExit':
      case 'topDragLeave':
      case 'topDragOver':
      case 'topDragStart':
      case 'topDrop':
        EventConstructor = SyntheticDragEvent;
        break;
      case 'topTouchCancel':
      case 'topTouchEnd':
      case 'topTouchMove':
      case 'topTouchStart':
        EventConstructor = SyntheticTouchEvent;
        break;
      case 'topAnimationEnd':
      case 'topAnimationIteration':
      case 'topAnimationStart':
        EventConstructor = SyntheticAnimationEvent;
        break;
      case 'topTransitionEnd':
        EventConstructor = SyntheticTransitionEvent;
        break;
      case 'topScroll':
        EventConstructor = SyntheticUIEvent;
        break;
      case 'topWheel':
        EventConstructor = SyntheticWheelEvent;
        break;
      case 'topCopy':
      case 'topCut':
      case 'topPaste':
        EventConstructor = SyntheticClipboardEvent;
        break;
    }
    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
    EventPropagators.accumulateTwoPhaseDispatches(event);
    return event;
  },

  didPutListener: function (inst, registrationName, listener) {
    // Mobile Safari does not fire properly bubble click events on
    // non-interactive elements, which means delegated click listeners do not
    // fire. The workaround for this bug involves attaching an empty click
    // listener on the target node.
    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      if (!onClickListeners[key]) {
        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
      }
    }
  },

  willDeleteListener: function (inst, registrationName) {
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      onClickListeners[key].remove();
      delete onClickListeners[key];
    }
  }

};

module.exports = SimpleEventPlugin;

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(50);

/**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */
var AnimationEventInterface = {
  animationName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);

module.exports = SyntheticAnimationEvent;

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(50);

/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */
var ClipboardEventInterface = {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

module.exports = SyntheticClipboardEvent;

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(102);

/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var FocusEventInterface = {
  relatedTarget: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

module.exports = SyntheticFocusEvent;

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(102);

var getEventCharCode = __webpack_require__(176);
var getEventKey = __webpack_require__(463);
var getEventModifierState = __webpack_require__(165);

/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var KeyboardEventInterface = {
  key: getEventKey,
  location: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  repeat: null,
  locale: null,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.

    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.

    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var getEventCharCode = __webpack_require__(176);

/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var normalizeKey = {
  'Esc': 'Escape',
  'Spacebar': ' ',
  'Left': 'ArrowLeft',
  'Up': 'ArrowUp',
  'Right': 'ArrowRight',
  'Down': 'ArrowDown',
  'Del': 'Delete',
  'Win': 'OS',
  'Menu': 'ContextMenu',
  'Apps': 'ContextMenu',
  'Scroll': 'ScrollLock',
  'MozPrintableKey': 'Unidentified'
};

/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var translateToKey = {
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  45: 'Insert',
  46: 'Delete',
  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
  144: 'NumLock',
  145: 'ScrollLock',
  224: 'Meta'
};

/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */
function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.

    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
    if (key !== 'Unidentified') {
      return key;
    }
  }

  // Browser does not implement `key`, polyfill as much of it as we can.
  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent);

    // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.
    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }
  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }
  return '';
}

module.exports = getEventKey;

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticMouseEvent = __webpack_require__(119);

/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var DragEventInterface = {
  dataTransfer: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

module.exports = SyntheticDragEvent;

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(102);

var getEventModifierState = __webpack_require__(165);

/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */
var TouchEventInterface = {
  touches: null,
  targetTouches: null,
  changedTouches: null,
  altKey: null,
  metaKey: null,
  ctrlKey: null,
  shiftKey: null,
  getModifierState: getEventModifierState
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

module.exports = SyntheticTouchEvent;

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(50);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */
var TransitionEventInterface = {
  propertyName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);

module.exports = SyntheticTransitionEvent;

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticMouseEvent = __webpack_require__(119);

/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var WheelEventInterface = {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX :
    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY :
    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY :
    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: null,

  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticMouseEvent}
 */
function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

module.exports = SyntheticWheelEvent;

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var validateDOMNesting = __webpack_require__(175);

var DOC_NODE_TYPE = 9;

function ReactDOMContainerInfo(topLevelWrapper, node) {
  var info = {
    _topLevelWrapper: topLevelWrapper,
    _idCounter: 1,
    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
    _node: node,
    _tag: node ? node.nodeName.toLowerCase() : null,
    _namespaceURI: node ? node.namespaceURI : null
  };
  if (false) {
    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
  }
  return info;
}

module.exports = ReactDOMContainerInfo;

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMFeatureFlags = {
  useCreateElement: true,
  useFiber: false
};

module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var adler32 = __webpack_require__(471);

var TAG_END = /\/?>/;
var COMMENT_START = /^<\!\-\-/;

var ReactMarkupChecksum = {
  CHECKSUM_ATTR_NAME: 'data-react-checksum',

  /**
   * @param {string} markup Markup string
   * @return {string} Markup string with checksum attribute attached
   */
  addChecksumToMarkup: function (markup) {
    var checksum = adler32(markup);

    // Add checksum (handle both parent tags, comments and self-closing tags)
    if (COMMENT_START.test(markup)) {
      return markup;
    } else {
      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
    }
  },

  /**
   * @param {string} markup to use
   * @param {DOMElement} element root React element
   * @returns {boolean} whether or not the markup is the same
   */
  canReuseMarkup: function (markup, element) {
    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
    var markupChecksum = adler32(markup);
    return markupChecksum === existingChecksum;
  }
};

module.exports = ReactMarkupChecksum;

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var MOD = 65521;

// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function adler32(data) {
  var a = 1;
  var b = 0;
  var i = 0;
  var l = data.length;
  var m = l & ~0x3;
  while (i < m) {
    var n = Math.min(i + 4096, m);
    for (; i < n; i += 4) {
      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
    }
    a %= MOD;
    b %= MOD;
  }
  for (; i < l; i++) {
    b += a += data.charCodeAt(i);
  }
  a %= MOD;
  b %= MOD;
  return a | b << 16;
}

module.exports = adler32;

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.4.2';

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var ReactCurrentOwner = __webpack_require__(49);
var ReactDOMComponentTree = __webpack_require__(21);
var ReactInstanceMap = __webpack_require__(103);

var getHostComponentFromComposite = __webpack_require__(253);
var invariant = __webpack_require__(5);
var warning = __webpack_require__(6);

/**
 * Returns the DOM node rendered by this element.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
 *
 * @param {ReactComponent|DOMElement} componentOrElement
 * @return {?DOMElement} The root node of this element.
 */
function findDOMNode(componentOrElement) {
  if (false) {
    var owner = ReactCurrentOwner.current;
    if (owner !== null) {
      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
      owner._warnedAboutRefsInRender = true;
    }
  }
  if (componentOrElement == null) {
    return null;
  }
  if (componentOrElement.nodeType === 1) {
    return componentOrElement;
  }

  var inst = ReactInstanceMap.get(componentOrElement);
  if (inst) {
    inst = getHostComponentFromComposite(inst);
    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
  }

  if (typeof componentOrElement.render === 'function') {
     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
  } else {
     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
  }
}

module.exports = findDOMNode;

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactMount = __webpack_require__(252);

module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(476);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var ReactIs = __webpack_require__(179);
var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};

var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};

var TYPE_STATICS = {};
TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;

function getStatics(component) {
    if (ReactIs.isMemo(component)) {
        return MEMO_STATICS;
    }
    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.9.0
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.suspense_list"):
60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.fundamental"):60117,w=b?Symbol.for("react.responder"):60118;function x(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case t:case r:case d:return u}}}function y(a){return x(a)===m}exports.typeOf=x;exports.AsyncMode=l;
exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===v||a.$$typeof===w)};exports.isAsyncMode=function(a){return y(a)||x(a)===l};exports.isConcurrentMode=y;exports.isContextConsumer=function(a){return x(a)===k};exports.isContextProvider=function(a){return x(a)===h};
exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return x(a)===n};exports.isFragment=function(a){return x(a)===e};exports.isLazy=function(a){return x(a)===t};exports.isMemo=function(a){return x(a)===r};exports.isPortal=function(a){return x(a)===d};exports.isProfiler=function(a){return x(a)===g};exports.isStrictMode=function(a){return x(a)===f};exports.isSuspense=function(a){return x(a)===p};


/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(24)))

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(482);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(24), __webpack_require__(481)(module)))

/***/ }),
/* 481 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createHashHistory = __webpack_require__(255);

var _createHashHistory2 = _interopRequireDefault(_createHashHistory);

var _useQueries = __webpack_require__(125);

var _useQueries2 = _interopRequireDefault(_useQueries);

var _invariant = __webpack_require__(25);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createTransitionManager = __webpack_require__(187);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _InternalPropTypes = __webpack_require__(66);

var _RouterContext = __webpack_require__(126);

var _RouterContext2 = _interopRequireDefault(_RouterContext);

var _RouteUtils = __webpack_require__(58);

var _RouterUtils = __webpack_require__(263);

var _routerWarning = __webpack_require__(26);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function isDeprecatedHistory(history) {
  return !history || !history.__v2_compatible__;
}

/* istanbul ignore next: sanity check */
function isUnsupportedHistory(history) {
  // v3 histories expose getCurrentLocation, but aren't currently supported.
  return history && history.getCurrentLocation;
}

var _React$PropTypes = _react2.default.PropTypes;
var func = _React$PropTypes.func;
var object = _React$PropTypes.object;

/**
 * A <Router> is a high-level API for automatically setting up
 * a router that renders a <RouterContext> with all the props
 * it needs each time the URL changes.
 */

var Router = _react2.default.createClass({
  displayName: 'Router',


  propTypes: {
    history: object,
    children: _InternalPropTypes.routes,
    routes: _InternalPropTypes.routes, // alias for children
    render: func,
    createElement: func,
    onError: func,
    onUpdate: func,

    // Deprecated:
    parseQueryString: func,
    stringifyQuery: func,

    // PRIVATE: For client-side rehydration of server match.
    matchContext: object
  },

  getDefaultProps: function getDefaultProps() {
    return {
      render: function render(props) {
        return _react2.default.createElement(_RouterContext2.default, props);
      }
    };
  },
  getInitialState: function getInitialState() {
    return {
      location: null,
      routes: null,
      params: null,
      components: null
    };
  },
  handleError: function handleError(error) {
    if (this.props.onError) {
      this.props.onError.call(this, error);
    } else {
      // Throw errors by default so we don't silently swallow them!
      throw error; // This error probably occurred in getChildRoutes or getComponents.
    }
  },
  componentWillMount: function componentWillMount() {
    var _this = this;

    var _props = this.props;
    var parseQueryString = _props.parseQueryString;
    var stringifyQuery = _props.stringifyQuery;

     false ? (0, _routerWarning2.default)(!(parseQueryString || stringifyQuery), '`parseQueryString` and `stringifyQuery` are deprecated. Please create a custom history. http://tiny.cc/router-customquerystring') : void 0;

    var _createRouterObjects = this.createRouterObjects();

    var history = _createRouterObjects.history;
    var transitionManager = _createRouterObjects.transitionManager;
    var router = _createRouterObjects.router;


    this._unlisten = transitionManager.listen(function (error, state) {
      if (error) {
        _this.handleError(error);
      } else {
        _this.setState(state, _this.props.onUpdate);
      }
    });

    this.history = history;
    this.router = router;
  },
  createRouterObjects: function createRouterObjects() {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext;
    }

    var history = this.props.history;
    var _props2 = this.props;
    var routes = _props2.routes;
    var children = _props2.children;


    !!isUnsupportedHistory(history) ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v3.x. ' + 'This version of React Router is not compatible with v3 history ' + 'objects. Please use history v2.x instead.') : (0, _invariant2.default)(false) : void 0;

    if (isDeprecatedHistory(history)) {
      history = this.wrapDeprecatedHistory(history);
    }

    var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
    var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
    var routingHistory = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);

    return { history: routingHistory, transitionManager: transitionManager, router: router };
  },
  wrapDeprecatedHistory: function wrapDeprecatedHistory(history) {
    var _props3 = this.props;
    var parseQueryString = _props3.parseQueryString;
    var stringifyQuery = _props3.stringifyQuery;


    var createHistory = void 0;
    if (history) {
       false ? (0, _routerWarning2.default)(false, 'It appears you have provided a deprecated history object to `<Router/>`, please use a history provided by ' + 'React Router with `import { browserHistory } from \'react-router\'` or `import { hashHistory } from \'react-router\'`. ' + 'If you are using a custom history please create it with `useRouterHistory`, see http://tiny.cc/router-usinghistory for details.') : void 0;
      createHistory = function createHistory() {
        return history;
      };
    } else {
       false ? (0, _routerWarning2.default)(false, '`Router` no longer defaults the history prop to hash history. Please use the `hashHistory` singleton instead. http://tiny.cc/router-defaulthistory') : void 0;
      createHistory = _createHashHistory2.default;
    }

    return (0, _useQueries2.default)(createHistory)({ parseQueryString: parseQueryString, stringifyQuery: stringifyQuery });
  },


  /* istanbul ignore next: sanity check */
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;

     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this._unlisten) this._unlisten();
  },
  render: function render() {
    var _state = this.state;
    var location = _state.location;
    var routes = _state.routes;
    var params = _state.params;
    var components = _state.components;
    var _props4 = this.props;
    var createElement = _props4.createElement;
    var render = _props4.render;

    var props = _objectWithoutProperties(_props4, ['createElement', 'render']);

    if (location == null) return null; // Async match

    // Only forward non-Router-specific props to routing context, as those are
    // the only ones that might be custom routing context props.
    Object.keys(Router.propTypes).forEach(function (propType) {
      return delete props[propType];
    });

    return render(_extends({}, props, {
      history: this.history,
      router: this.router,
      location: location,
      routes: routes,
      params: params,
      components: components,
      createElement: createElement
    }));
  }
});

exports.default = Router;
module.exports = exports['default'];

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

var objectKeys = __webpack_require__(258);
var isArguments = __webpack_require__(487);
var is = __webpack_require__(488);
var isRegex = __webpack_require__(489);
var flags = __webpack_require__(493);
var isDate = __webpack_require__(495);

var getTime = Date.prototype.getTime;

function deepEqual(actual, expected, options) {
  var opts = options || {};

  // 7.1. All identical values are equivalent, as determined by ===.
  if (opts.strict ? is(actual, expected) : actual === expected) {
    return true;
  }

  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
  if (!actual || !expected || (typeof actual !== 'object' && typeof expected !== 'object')) {
    return opts.strict ? is(actual, expected) : actual == expected;
  }

  /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */
  // eslint-disable-next-line no-use-before-define
  return objEquiv(actual, expected, opts);
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer(x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
    return false;
  }
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') {
    return false;
  }
  return true;
}

function objEquiv(a, b, opts) {
  /* eslint max-statements: [2, 50] */
  var i, key;
  if (typeof a !== typeof b) { return false; }
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) { return false; }

  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) { return false; }

  if (isArguments(a) !== isArguments(b)) { return false; }

  var aIsRegex = isRegex(a);
  var bIsRegex = isRegex(b);
  if (aIsRegex !== bIsRegex) { return false; }
  if (aIsRegex || bIsRegex) {
    return a.source === b.source && flags(a) === flags(b);
  }

  if (isDate(a) && isDate(b)) {
    return getTime.call(a) === getTime.call(b);
  }

  var aIsBuffer = isBuffer(a);
  var bIsBuffer = isBuffer(b);
  if (aIsBuffer !== bIsBuffer) { return false; }
  if (aIsBuffer || bIsBuffer) { // && would work too, because both are true or both false here
    if (a.length !== b.length) { return false; }
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) { return false; }
    }
    return true;
  }

  if (typeof a !== typeof b) { return false; }

  try {
    var ka = objectKeys(a);
    var kb = objectKeys(b);
  } catch (e) { // happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates hasOwnProperty)
  if (ka.length !== kb.length) { return false; }

  // the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  // ~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i]) { return false; }
  }
  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) { return false; }
  }

  return true;
}

module.exports = deepEqual;


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = __webpack_require__(259); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
var toStr = Object.prototype.toString;

var isStandardArguments = function isArguments(value) {
	if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
		return false;
	}
	return toStr.call(value) === '[object Arguments]';
};

var isLegacyArguments = function isArguments(value) {
	if (isStandardArguments(value)) {
		return true;
	}
	return value !== null &&
		typeof value === 'object' &&
		typeof value.length === 'number' &&
		value.length >= 0 &&
		toStr.call(value) !== '[object Array]' &&
		toStr.call(value.callee) === '[object Function]';
};

var supportsStandardArguments = (function () {
	return isStandardArguments(arguments);
}());

isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.is */

var NumberIsNaN = function (value) {
	return value !== value;
};

module.exports = function is(a, b) {
	if (a === 0 && b === 0) {
		return 1 / a === 1 / b;
	} else if (a === b) {
		return true;
	} else if (NumberIsNaN(a) && NumberIsNaN(b)) {
		return true;
	}
	return false;
};



/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = __webpack_require__(490);
var regexExec = RegExp.prototype.exec;
var gOPD = Object.getOwnPropertyDescriptor;

var tryRegexExecCall = function tryRegexExec(value) {
	try {
		var lastIndex = value.lastIndex;
		value.lastIndex = 0;

		regexExec.call(value);
		return true;
	} catch (e) {
		return false;
	} finally {
		value.lastIndex = lastIndex;
	}
};
var toStr = Object.prototype.toString;
var regexClass = '[object RegExp]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isRegex(value) {
	if (!value || typeof value !== 'object') {
		return false;
	}
	if (!hasToStringTag) {
		return toStr.call(value) === regexClass;
	}

	var descriptor = gOPD(value, 'lastIndex');
	var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
	if (!hasLastIndexDataProperty) {
		return false;
	}

	return tryRegexExecCall(value);
};


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(491);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(492);

module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(184);

var implementation = __webpack_require__(260);
var getPolyfill = __webpack_require__(261);
var shim = __webpack_require__(494);

var flagsBound = Function.call.bind(implementation);

define(flagsBound, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = flagsBound;


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var supportsDescriptors = __webpack_require__(184).supportsDescriptors;
var getPolyfill = __webpack_require__(261);
var gOPD = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var TypeErr = TypeError;
var getProto = Object.getPrototypeOf;
var regex = /a/;

module.exports = function shimFlags() {
	if (!supportsDescriptors || !getProto) {
		throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
	}
	var polyfill = getPolyfill();
	var proto = getProto(regex);
	var descriptor = gOPD(proto, 'flags');
	if (!descriptor || descriptor.get !== polyfill) {
		defineProperty(proto, 'flags', {
			configurable: true,
			enumerable: false,
			get: polyfill
		});
	}
	return polyfill;
};


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateObject(value) {
	try {
		getDay.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) { return false; }
	return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var _slice = Array.prototype.slice;
exports.loopAsync = loopAsync;

function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var sync = false,
      hasNext = false,
      doneArgs = undefined;

  function done() {
    isDone = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      doneArgs = [].concat(_slice.call(arguments));
      return;
    }

    callback.apply(this, arguments);
  }

  function next() {
    if (isDone) {
      return;
    }

    hasNext = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      return;
    }

    sync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work.call(this, currentTurn++, next, done);
    }

    sync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(this, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  }

  next();
}

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(41);

var _warning2 = _interopRequireDefault(_warning);

var _Actions = __webpack_require__(67);

var _PathUtils = __webpack_require__(68);

function createLocation() {
  var location = arguments.length <= 0 || arguments[0] === undefined ? '/' : arguments[0];
  var action = arguments.length <= 1 || arguments[1] === undefined ? _Actions.POP : arguments[1];
  var key = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];

  var _fourthArg = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];

  if (typeof location === 'string') location = _PathUtils.parsePath(location);

  if (typeof action === 'object') {
     false ? _warning2['default'](false, 'The state (2nd) argument to createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;

    location = _extends({}, location, { state: action });

    action = key || _Actions.POP;
    key = _fourthArg;
  }

  var pathname = location.pathname || '/';
  var search = location.search || '';
  var hash = location.hash || '';
  var state = location.state || null;

  return {
    pathname: pathname,
    search: search,
    hash: hash,
    state: state,
    action: action,
    key: key
  };
}

exports['default'] = createLocation;
module.exports = exports['default'];

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(499);

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str) {
	if (typeof str !== 'string') {
		return {};
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return {};
	}

	return str.split('&').reduce(function (ret, param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		key = decodeURIComponent(key);

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		if (!ret.hasOwnProperty(key)) {
			ret[key] = val;
		} else if (Array.isArray(ret[key])) {
			ret[key].push(val);
		} else {
			ret[key] = [ret[key], val];
		}

		return ret;
	}, {});
};

exports.stringify = function (obj) {
	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return key;
		}

		if (Array.isArray(val)) {
			return val.slice().sort().map(function (val2) {
				return strictUriEncode(key) + '=' + strictUriEncode(val2);
			}).join('&');
		}

		return strictUriEncode(key) + '=' + strictUriEncode(val);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _PatternUtils = __webpack_require__(86);

function routeParamsChanged(route, prevState, nextState) {
  if (!route.path) return false;

  var paramNames = (0, _PatternUtils.getParamNames)(route.path);

  return paramNames.some(function (paramName) {
    return prevState.params[paramName] !== nextState.params[paramName];
  });
}

/**
 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
 * the change from prevState to nextState. We leave routes if either
 * 1) they are not in the next state or 2) they are in the next state
 * but their params have changed (i.e. /users/123 => /users/456).
 *
 * leaveRoutes are ordered starting at the leaf route of the tree
 * we're leaving up to the common parent route. enterRoutes are ordered
 * from the top of the tree we're entering down to the leaf route.
 *
 * changeRoutes are any routes that didn't leave or enter during
 * the transition.
 */
function computeChangedRoutes(prevState, nextState) {
  var prevRoutes = prevState && prevState.routes;
  var nextRoutes = nextState.routes;

  var leaveRoutes = void 0,
      changeRoutes = void 0,
      enterRoutes = void 0;
  if (prevRoutes) {
    (function () {
      var parentIsLeaving = false;
      leaveRoutes = prevRoutes.filter(function (route) {
        if (parentIsLeaving) {
          return true;
        } else {
          var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
          if (isLeaving) parentIsLeaving = true;
          return isLeaving;
        }
      });

      // onLeave hooks start at the leaf route.
      leaveRoutes.reverse();

      enterRoutes = [];
      changeRoutes = [];

      nextRoutes.forEach(function (route) {
        var isNew = prevRoutes.indexOf(route) === -1;
        var paramsChanged = leaveRoutes.indexOf(route) !== -1;

        if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
      });
    })();
  } else {
    leaveRoutes = [];
    changeRoutes = [];
    enterRoutes = nextRoutes;
  }

  return {
    leaveRoutes: leaveRoutes,
    changeRoutes: changeRoutes,
    enterRoutes: enterRoutes
  };
}

exports.default = computeChangedRoutes;
module.exports = exports['default'];

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.runEnterHooks = runEnterHooks;
exports.runChangeHooks = runChangeHooks;
exports.runLeaveHooks = runLeaveHooks;

var _AsyncUtils = __webpack_require__(188);

var _routerWarning = __webpack_require__(26);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createTransitionHook(hook, route, asyncArity) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    hook.apply(route, args);

    if (hook.length < asyncArity) {
      var callback = args[args.length - 1];
      // Assume hook executes synchronously and
      // automatically call the callback.
      callback();
    }
  };
}

function getEnterHooks(routes) {
  return routes.reduce(function (hooks, route) {
    if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3));

    return hooks;
  }, []);
}

function getChangeHooks(routes) {
  return routes.reduce(function (hooks, route) {
    if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4));
    return hooks;
  }, []);
}

function runTransitionHooks(length, iter, callback) {
  if (!length) {
    callback();
    return;
  }

  var redirectInfo = void 0;
  function replace(location, deprecatedPathname, deprecatedQuery) {
    if (deprecatedPathname) {
       false ? (0, _routerWarning2.default)(false, '`replaceState(state, pathname, query) is deprecated; use `replace(location)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
      redirectInfo = {
        pathname: deprecatedPathname,
        query: deprecatedQuery,
        state: location
      };

      return;
    }

    redirectInfo = location;
  }

  (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
    iter(index, replace, function (error) {
      if (error || redirectInfo) {
        done(error, redirectInfo); // No need to continue.
      } else {
        next();
      }
    });
  }, callback);
}

/**
 * Runs all onEnter hooks in the given array of routes in order
 * with onEnter(nextState, replace, callback) and calls
 * callback(error, redirectInfo) when finished. The first hook
 * to use replace short-circuits the loop.
 *
 * If a hook needs to run asynchronously, it may use the callback
 * function. However, doing so will cause the transition to pause,
 * which could lead to a non-responsive UI if the hook is slow.
 */
function runEnterHooks(routes, nextState, callback) {
  var hooks = getEnterHooks(routes);
  return runTransitionHooks(hooks.length, function (index, replace, next) {
    hooks[index](nextState, replace, next);
  }, callback);
}

/**
 * Runs all onChange hooks in the given array of routes in order
 * with onChange(prevState, nextState, replace, callback) and calls
 * callback(error, redirectInfo) when finished. The first hook
 * to use replace short-circuits the loop.
 *
 * If a hook needs to run asynchronously, it may use the callback
 * function. However, doing so will cause the transition to pause,
 * which could lead to a non-responsive UI if the hook is slow.
 */
function runChangeHooks(routes, state, nextState, callback) {
  var hooks = getChangeHooks(routes);
  return runTransitionHooks(hooks.length, function (index, replace, next) {
    hooks[index](state, nextState, replace, next);
  }, callback);
}

/**
 * Runs all onLeave hooks in the given array of routes in order.
 */
function runLeaveHooks(routes, prevState) {
  for (var i = 0, len = routes.length; i < len; ++i) {
    if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
  }
}

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.default = isActive;

var _PatternUtils = __webpack_require__(86);

function deepEqual(a, b) {
  if (a == b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return deepEqual(item, b[index]);
    });
  }

  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
    for (var p in a) {
      if (!Object.prototype.hasOwnProperty.call(a, p)) {
        continue;
      }

      if (a[p] === undefined) {
        if (b[p] !== undefined) {
          return false;
        }
      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
        return false;
      } else if (!deepEqual(a[p], b[p])) {
        return false;
      }
    }

    return true;
  }

  return String(a) === String(b);
}

/**
 * Returns true if the current pathname matches the supplied one, net of
 * leading and trailing slash normalization. This is sufficient for an
 * indexOnly route match.
 */
function pathIsActive(pathname, currentPathname) {
  // Normalize leading slash for consistency. Leading slash on pathname has
  // already been normalized in isActive. See caveat there.
  if (currentPathname.charAt(0) !== '/') {
    currentPathname = '/' + currentPathname;
  }

  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
  // `/foo` as active, but in this case, we would already have failed the
  // match.
  if (pathname.charAt(pathname.length - 1) !== '/') {
    pathname += '/';
  }
  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
    currentPathname += '/';
  }

  return currentPathname === pathname;
}

/**
 * Returns true if the given pathname matches the active routes and params.
 */
function routeIsActive(pathname, routes, params) {
  var remainingPathname = pathname,
      paramNames = [],
      paramValues = [];

  // for...of would work here but it's probably slower post-transpilation.
  for (var i = 0, len = routes.length; i < len; ++i) {
    var route = routes[i];
    var pattern = route.path || '';

    if (pattern.charAt(0) === '/') {
      remainingPathname = pathname;
      paramNames = [];
      paramValues = [];
    }

    if (remainingPathname !== null && pattern) {
      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }

      if (remainingPathname === '') {
        // We have an exact match on the route. Just check that all the params
        // match.
        // FIXME: This doesn't work on repeated params.
        return paramNames.every(function (paramName, index) {
          return String(paramValues[index]) === String(params[paramName]);
        });
      }
    }
  }

  return false;
}

/**
 * Returns true if all key/value pairs in the given query are
 * currently active.
 */
function queryIsActive(query, activeQuery) {
  if (activeQuery == null) return query == null;

  if (query == null) return true;

  return deepEqual(query, activeQuery);
}

/**
 * Returns true if a <Link> to the given pathname/query combination is
 * currently active.
 */
function isActive(_ref, indexOnly, currentLocation, routes, params) {
  var pathname = _ref.pathname;
  var query = _ref.query;

  if (currentLocation == null) return false;

  // TODO: This is a bit ugly. It keeps around support for treating pathnames
  // without preceding slashes as absolute paths, but possibly also works
  // around the same quirks with basenames as in matchRoutes.
  if (pathname.charAt(0) !== '/') {
    pathname = '/' + pathname;
  }

  if (!pathIsActive(pathname, currentLocation.pathname)) {
    // The path check is necessary and sufficient for indexOnly, but otherwise
    // we still need to check the routes.
    if (indexOnly || !routeIsActive(pathname, routes, params)) {
      return false;
    }
  }

  return queryIsActive(query, currentLocation.query);
}
module.exports = exports['default'];

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _AsyncUtils = __webpack_require__(188);

var _makeStateWithLocation = __webpack_require__(262);

var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getComponentsForRoute(nextState, route, callback) {
  if (route.component || route.components) {
    callback(null, route.component || route.components);
    return;
  }

  var getComponent = route.getComponent || route.getComponents;
  if (!getComponent) {
    callback();
    return;
  }

  var location = nextState.location;

  var nextStateWithLocation = (0, _makeStateWithLocation2.default)(nextState, location);

  getComponent.call(route, nextStateWithLocation, callback);
}

/**
 * Asynchronously fetches all components needed for the given router
 * state and calls callback(error, components) when finished.
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getComponents method.
 */
function getComponents(nextState, callback) {
  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
    getComponentsForRoute(nextState, route, callback);
  }, callback);
}

exports.default = getComponents;
module.exports = exports['default'];

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.default = matchRoutes;

var _AsyncUtils = __webpack_require__(188);

var _makeStateWithLocation = __webpack_require__(262);

var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);

var _PatternUtils = __webpack_require__(86);

var _routerWarning = __webpack_require__(26);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _RouteUtils = __webpack_require__(58);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getChildRoutes(route, location, paramNames, paramValues, callback) {
  if (route.childRoutes) {
    return [null, route.childRoutes];
  }
  if (!route.getChildRoutes) {
    return [];
  }

  var sync = true,
      result = void 0;

  var partialNextState = {
    location: location,
    params: createParams(paramNames, paramValues)
  };

  var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);

  route.getChildRoutes(partialNextStateWithLocation, function (error, childRoutes) {
    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
    if (sync) {
      result = [error, childRoutes];
      return;
    }

    callback(error, childRoutes);
  });

  sync = false;
  return result; // Might be undefined.
}

function getIndexRoute(route, location, paramNames, paramValues, callback) {
  if (route.indexRoute) {
    callback(null, route.indexRoute);
  } else if (route.getIndexRoute) {
    var partialNextState = {
      location: location,
      params: createParams(paramNames, paramValues)
    };

    var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);

    route.getIndexRoute(partialNextStateWithLocation, function (error, indexRoute) {
      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
    });
  } else if (route.childRoutes) {
    (function () {
      var pathless = route.childRoutes.filter(function (childRoute) {
        return !childRoute.path;
      });

      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
          if (error || indexRoute) {
            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
            done(error, routes);
          } else {
            next();
          }
        });
      }, function (err, routes) {
        callback(null, routes);
      });
    })();
  } else {
    callback();
  }
}

function assignParams(params, paramNames, paramValues) {
  return paramNames.reduce(function (params, paramName, index) {
    var paramValue = paramValues && paramValues[index];

    if (Array.isArray(params[paramName])) {
      params[paramName].push(paramValue);
    } else if (paramName in params) {
      params[paramName] = [params[paramName], paramValue];
    } else {
      params[paramName] = paramValue;
    }

    return params;
  }, params);
}

function createParams(paramNames, paramValues) {
  return assignParams({}, paramNames, paramValues);
}

function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
  var pattern = route.path || '';

  if (pattern.charAt(0) === '/') {
    remainingPathname = location.pathname;
    paramNames = [];
    paramValues = [];
  }

  // Only try to match the path if the route actually has a pattern, and if
  // we're not just searching for potential nested absolute paths.
  if (remainingPathname !== null && pattern) {
    try {
      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }
    } catch (error) {
      callback(error);
    }

    // By assumption, pattern is non-empty here, which is the prerequisite for
    // actually terminating a match.
    if (remainingPathname === '') {
      var _ret2 = function () {
        var match = {
          routes: [route],
          params: createParams(paramNames, paramValues)
        };

        getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
          if (error) {
            callback(error);
          } else {
            if (Array.isArray(indexRoute)) {
              var _match$routes;

               false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
                return !route.path;
              }), 'Index routes should not have paths') : void 0;
              (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
            } else if (indexRoute) {
               false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
              match.routes.push(indexRoute);
            }

            callback(null, match);
          }
        });

        return {
          v: void 0
        };
      }();

      if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
    }
  }

  if (remainingPathname != null || route.childRoutes) {
    // Either a) this route matched at least some of the path or b)
    // we don't have to load this route's children asynchronously. In
    // either case continue checking for matches in the subtree.
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
      } else if (childRoutes) {
        // Check the child routes to see if any of them match.
        matchRoutes(childRoutes, location, function (error, match) {
          if (error) {
            callback(error);
          } else if (match) {
            // A child route matched! Augment the match and pass it up the stack.
            match.routes.unshift(route);
            callback(null, match);
          } else {
            callback();
          }
        }, remainingPathname, paramNames, paramValues);
      } else {
        callback();
      }
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

/**
 * Asynchronously matches the given location to a set of routes and calls
 * callback(error, state) when finished. The state object will have the
 * following properties:
 *
 * - routes       An array of routes that matched, in hierarchical order
 * - params       An object of URL parameters
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getChildRoutes method.
 */
function matchRoutes(routes, location, callback, remainingPathname) {
  var paramNames = arguments.length <= 4 || arguments[4] === undefined ? [] : arguments[4];
  var paramValues = arguments.length <= 5 || arguments[5] === undefined ? [] : arguments[5];

  if (remainingPathname === undefined) {
    // TODO: This is a little bit ugly, but it works around a quirk in history
    // that strips the leading slash from pathnames when using basenames with
    // trailing slashes.
    if (location.pathname.charAt(0) !== '/') {
      location = _extends({}, location, {
        pathname: '/' + location.pathname
      });
    }
    remainingPathname = location.pathname;
  }

  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
      if (error || match) {
        done(error, match);
      } else {
        next();
      }
    });
  }, callback);
}
module.exports = exports['default'];

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _PatternUtils = __webpack_require__(86);

/**
 * Extracts an object of params the given route cares about from
 * the given params object.
 */
function getRouteParams(route, params) {
  var routeParams = {};

  if (!route.path) return routeParams;

  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
    if (Object.prototype.hasOwnProperty.call(params, p)) {
      routeParams[p] = params[p];
    }
  });

  return routeParams;
}

exports.default = getRouteParams;
module.exports = exports['default'];

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Link = __webpack_require__(264);

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * An <IndexLink> is used to link to an <IndexRoute>.
 */
var IndexLink = _react2.default.createClass({
  displayName: 'IndexLink',
  render: function render() {
    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
  }
});

exports.default = IndexLink;
module.exports = exports['default'];

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = withRouter;

var _invariant = __webpack_require__(25);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoistNonReactStatics = __webpack_require__(104);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _PropTypes = __webpack_require__(181);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function withRouter(WrappedComponent, options) {
  var withRef = options && options.withRef;

  var WithRouter = _react2.default.createClass({
    displayName: 'WithRouter',

    contextTypes: { router: _PropTypes.routerShape },
    propTypes: { router: _PropTypes.routerShape },

    getWrappedInstance: function getWrappedInstance() {
      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;

      return this.wrappedInstance;
    },
    render: function render() {
      var _this = this;

      var router = this.props.router || this.context.router;
      var props = _extends({}, this.props, { router: router });

      if (withRef) {
        props.ref = function (c) {
          _this.wrappedInstance = c;
        };
      }

      return _react2.default.createElement(WrappedComponent, props);
    }
  });

  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
  WithRouter.WrappedComponent = WrappedComponent;

  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
}
module.exports = exports['default'];

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _routerWarning = __webpack_require__(26);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _invariant = __webpack_require__(25);

var _invariant2 = _interopRequireDefault(_invariant);

var _Redirect = __webpack_require__(265);

var _Redirect2 = _interopRequireDefault(_Redirect);

var _InternalPropTypes = __webpack_require__(66);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _React$PropTypes = _react2.default.PropTypes;
var string = _React$PropTypes.string;
var object = _React$PropTypes.object;

/**
 * An <IndexRedirect> is used to redirect from an indexRoute.
 */

var IndexRedirect = _react2.default.createClass({
  displayName: 'IndexRedirect',


  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
      } else {
         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    to: string.isRequired,
    query: object,
    state: object,
    onEnter: _InternalPropTypes.falsy,
    children: _InternalPropTypes.falsy
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
  }
});

exports.default = IndexRedirect;
module.exports = exports['default'];

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _routerWarning = __webpack_require__(26);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _invariant = __webpack_require__(25);

var _invariant2 = _interopRequireDefault(_invariant);

var _RouteUtils = __webpack_require__(58);

var _InternalPropTypes = __webpack_require__(66);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var func = _react2.default.PropTypes.func;

/**
 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
 * a JSX route config.
 */

var IndexRoute = _react2.default.createClass({
  displayName: 'IndexRoute',


  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
      } else {
         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    path: _InternalPropTypes.falsy,
    component: _InternalPropTypes.component,
    components: _InternalPropTypes.components,
    getComponent: func,
    getComponents: func
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
  }
});

exports.default = IndexRoute;
module.exports = exports['default'];

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _invariant = __webpack_require__(25);

var _invariant2 = _interopRequireDefault(_invariant);

var _RouteUtils = __webpack_require__(58);

var _InternalPropTypes = __webpack_require__(66);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _React$PropTypes = _react2.default.PropTypes;
var string = _React$PropTypes.string;
var func = _React$PropTypes.func;

/**
 * A <Route> is used to declare which components are rendered to the
 * page when the URL matches a given pattern.
 *
 * Routes are arranged in a nested tree structure. When a new URL is
 * requested, the tree is searched depth-first to find a route whose
 * path matches the URL.  When one is found, all routes in the tree
 * that lead to it are considered "active" and their components are
 * rendered into the DOM, nested in the same order as in the tree.
 */

var Route = _react2.default.createClass({
  displayName: 'Route',


  statics: {
    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
  },

  propTypes: {
    path: string,
    component: _InternalPropTypes.component,
    components: _InternalPropTypes.components,
    getComponent: func,
    getComponents: func
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
  }
});

exports.default = Route;
module.exports = exports['default'];

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _routerWarning = __webpack_require__(26);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _InternalPropTypes = __webpack_require__(66);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A mixin that adds the "history" instance variable to components.
 */
var History = {

  contextTypes: {
    history: _InternalPropTypes.history
  },

  componentWillMount: function componentWillMount() {
     false ? (0, _routerWarning2.default)(false, 'the `History` mixin is deprecated, please access `context.router` with your own `contextTypes`. http://tiny.cc/router-historymixin') : void 0;
    this.history = this.context.history;
  }
};

exports.default = History;
module.exports = exports['default'];

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _routerWarning = __webpack_require__(26);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _invariant = __webpack_require__(25);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var object = _react2.default.PropTypes.object;

/**
 * The Lifecycle mixin adds the routerWillLeave lifecycle method to a
 * component that may be used to cancel a transition or prompt the user
 * for confirmation.
 *
 * On standard transitions, routerWillLeave receives a single argument: the
 * location we're transitioning to. To cancel the transition, return false.
 * To prompt the user for confirmation, return a prompt message (string).
 *
 * During the beforeunload event (assuming you're using the useBeforeUnload
 * history enhancer), routerWillLeave does not receive a location object
 * because it isn't possible for us to know the location we're transitioning
 * to. In this case routerWillLeave must return a prompt message to prevent
 * the user from closing the window/tab.
 */

var Lifecycle = {

  contextTypes: {
    history: object.isRequired,
    // Nested children receive the route as context, either
    // set by the route component using the RouteContext mixin
    // or by some other ancestor.
    route: object
  },

  propTypes: {
    // Route components receive the route object as a prop.
    route: object
  },

  componentDidMount: function componentDidMount() {
     false ? (0, _routerWarning2.default)(false, 'the `Lifecycle` mixin is deprecated, please use `context.router.setRouteLeaveHook(route, hook)`. http://tiny.cc/router-lifecyclemixin') : void 0;
    !this.routerWillLeave ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin requires you to define a routerWillLeave method') : (0, _invariant2.default)(false) : void 0;

    var route = this.props.route || this.context.route;

    !route ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin must be used on either a) a <Route component> or ' + 'b) a descendant of a <Route component> that uses the RouteContext mixin') : (0, _invariant2.default)(false) : void 0;

    this._unlistenBeforeLeavingRoute = this.context.history.listenBeforeLeavingRoute(route, this.routerWillLeave);
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this._unlistenBeforeLeavingRoute) this._unlistenBeforeLeavingRoute();
  }
};

exports.default = Lifecycle;
module.exports = exports['default'];

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _routerWarning = __webpack_require__(26);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var object = _react2.default.PropTypes.object;

/**
 * The RouteContext mixin provides a convenient way for route
 * components to set the route in context. This is needed for
 * routes that render elements that want to use the Lifecycle
 * mixin to prevent transitions.
 */

var RouteContext = {

  propTypes: {
    route: object.isRequired
  },

  childContextTypes: {
    route: object.isRequired
  },

  getChildContext: function getChildContext() {
    return {
      route: this.props.route
    };
  },
  componentWillMount: function componentWillMount() {
     false ? (0, _routerWarning2.default)(false, 'The `RouteContext` mixin is deprecated. You can provide `this.props.route` on context with your own `contextTypes`. http://tiny.cc/router-routecontextmixin') : void 0;
  }
};

exports.default = RouteContext;
module.exports = exports['default'];

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _useQueries = __webpack_require__(125);

var _useQueries2 = _interopRequireDefault(_useQueries);

var _createTransitionManager = __webpack_require__(187);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _routerWarning = __webpack_require__(26);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Returns a new createHistory function that may be used to create
 * history objects that know about routing.
 *
 * Enhances history objects with the following methods:
 *
 * - listen((error, nextState) => {})
 * - listenBeforeLeavingRoute(route, (nextLocation) => {})
 * - match(location, (error, redirectLocation, nextState) => {})
 * - isActive(pathname, query, indexOnly=false)
 */
function useRoutes(createHistory) {
   false ? (0, _routerWarning2.default)(false, '`useRoutes` is deprecated. Please use `createTransitionManager` instead.') : void 0;

  return function () {
    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var routes = _ref.routes;

    var options = _objectWithoutProperties(_ref, ['routes']);

    var history = (0, _useQueries2.default)(createHistory)(options);
    var transitionManager = (0, _createTransitionManager2.default)(history, routes);
    return _extends({}, history, transitionManager);
  };
}

exports.default = useRoutes;
module.exports = exports['default'];

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _RouterContext = __webpack_require__(126);

var _RouterContext2 = _interopRequireDefault(_RouterContext);

var _routerWarning = __webpack_require__(26);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RoutingContext = _react2.default.createClass({
  displayName: 'RoutingContext',
  componentWillMount: function componentWillMount() {
     false ? (0, _routerWarning2.default)(false, '`RoutingContext` has been renamed to `RouterContext`. Please use `import { RouterContext } from \'react-router\'`. http://tiny.cc/router-routercontext') : void 0;
  },
  render: function render() {
    return _react2.default.createElement(_RouterContext2.default, this.props);
  }
});

exports.default = RoutingContext;
module.exports = exports['default'];

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Actions = __webpack_require__(67);

var _invariant = __webpack_require__(25);

var _invariant2 = _interopRequireDefault(_invariant);

var _createMemoryHistory = __webpack_require__(266);

var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);

var _createTransitionManager = __webpack_require__(187);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _RouteUtils = __webpack_require__(58);

var _RouterUtils = __webpack_require__(263);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * A high-level API to be used for server-side rendering.
 *
 * This function matches a location to a set of routes and calls
 * callback(error, redirectLocation, renderProps) when finished.
 *
 * Note: You probably don't want to use this in a browser unless you're using
 * server-side rendering with async routes.
 */
function match(_ref, callback) {
  var history = _ref.history;
  var routes = _ref.routes;
  var location = _ref.location;

  var options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);

  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;

  history = history ? history : (0, _createMemoryHistory2.default)(options);
  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));

  var unlisten = void 0;

  if (location) {
    // Allow match({ location: '/the/path', ... })
    location = history.createLocation(location);
  } else {
    // Pick up the location from the history via synchronous history.listen
    // call if needed.
    unlisten = history.listen(function (historyLocation) {
      location = historyLocation;
    });
  }

  var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
  history = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);

  transitionManager.match(location, function (error, redirectLocation, nextState) {
    callback(error, redirectLocation && router.createLocation(redirectLocation, _Actions.REPLACE), nextState && _extends({}, nextState, {
      history: history,
      router: router,
      matchContext: { history: history, transitionManager: transitionManager, router: router }
    }));

    // Defer removing the listener to here to prevent DOM histories from having
    // to unwind DOM event listeners unnecessarily, in case callback renders a
    // <Router> and attaches another history listener.
    if (unlisten) {
      unlisten();
    }
  });
}

exports.default = match;
module.exports = exports['default'];

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(41);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(25);

var _invariant2 = _interopRequireDefault(_invariant);

var _PathUtils = __webpack_require__(68);

var _Actions = __webpack_require__(67);

var _createHistory = __webpack_require__(257);

var _createHistory2 = _interopRequireDefault(_createHistory);

function createStateStorage(entries) {
  return entries.filter(function (entry) {
    return entry.state;
  }).reduce(function (memo, entry) {
    memo[entry.key] = entry.state;
    return memo;
  }, {});
}

function createMemoryHistory() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  if (Array.isArray(options)) {
    options = { entries: options };
  } else if (typeof options === 'string') {
    options = { entries: [options] };
  }

  var history = _createHistory2['default'](_extends({}, options, {
    getCurrentLocation: getCurrentLocation,
    finishTransition: finishTransition,
    saveState: saveState,
    go: go
  }));

  var _options = options;
  var entries = _options.entries;
  var current = _options.current;

  if (typeof entries === 'string') {
    entries = [entries];
  } else if (!Array.isArray(entries)) {
    entries = ['/'];
  }

  entries = entries.map(function (entry) {
    var key = history.createKey();

    if (typeof entry === 'string') return { pathname: entry, key: key };

    if (typeof entry === 'object' && entry) return _extends({}, entry, { key: key });

     true ?  false ? _invariant2['default'](false, 'Unable to create history entry from %s', entry) : _invariant2['default'](false) : undefined;
  });

  if (current == null) {
    current = entries.length - 1;
  } else {
    !(current >= 0 && current < entries.length) ?  false ? _invariant2['default'](false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : _invariant2['default'](false) : undefined;
  }

  var storage = createStateStorage(entries);

  function saveState(key, state) {
    storage[key] = state;
  }

  function readState(key) {
    return storage[key];
  }

  function getCurrentLocation() {
    var entry = entries[current];
    var basename = entry.basename;
    var pathname = entry.pathname;
    var search = entry.search;

    var path = (basename || '') + pathname + (search || '');

    var key = undefined,
        state = undefined;
    if (entry.key) {
      key = entry.key;
      state = readState(key);
    } else {
      key = history.createKey();
      state = null;
      entry.key = key;
    }

    var location = _PathUtils.parsePath(path);

    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
  }

  function canGo(n) {
    var index = current + n;
    return index >= 0 && index < entries.length;
  }

  function go(n) {
    if (n) {
      if (!canGo(n)) {
         false ? _warning2['default'](false, 'Cannot go(%s) there is not enough history', n) : undefined;
        return;
      }

      current += n;

      var currentLocation = getCurrentLocation();

      // change action to POP
      history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
    }
  }

  function finishTransition(location) {
    switch (location.action) {
      case _Actions.PUSH:
        current += 1;

        // if we are not on the top of stack
        // remove rest and push new
        if (current < entries.length) entries.splice(current);

        entries.push(location);
        saveState(location.key, location.state);
        break;
      case _Actions.REPLACE:
        entries[current] = location;
        saveState(location.key, location.state);
        break;
    }
  }

  return history;
}

exports['default'] = createMemoryHistory;
module.exports = exports['default'];

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _RouterContext = __webpack_require__(126);

var _RouterContext2 = _interopRequireDefault(_RouterContext);

var _routerWarning = __webpack_require__(26);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  if (false) {
    middlewares.forEach(function (middleware, index) {
      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
    });
  }

  var withContext = middlewares.map(function (middleware) {
    return middleware.renderRouterContext;
  }).filter(Boolean);
  var withComponent = middlewares.map(function (middleware) {
    return middleware.renderRouteComponent;
  }).filter(Boolean);

  var makeCreateElement = function makeCreateElement() {
    var baseCreateElement = arguments.length <= 0 || arguments[0] === undefined ? _react.createElement : arguments[0];
    return function (Component, props) {
      return withComponent.reduceRight(function (previous, renderRouteComponent) {
        return renderRouteComponent(previous, props);
      }, baseCreateElement(Component, props));
    };
  };

  return function (renderProps) {
    return withContext.reduceRight(function (previous, renderRouterContext) {
      return renderRouterContext(previous, renderProps);
    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
      createElement: makeCreateElement(renderProps.createElement)
    })));
  };
};

module.exports = exports['default'];

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createBrowserHistory = __webpack_require__(520);

var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);

var _createRouterHistory = __webpack_require__(269);

var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
module.exports = exports['default'];

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _invariant = __webpack_require__(25);

var _invariant2 = _interopRequireDefault(_invariant);

var _Actions = __webpack_require__(67);

var _PathUtils = __webpack_require__(68);

var _ExecutionEnvironment = __webpack_require__(124);

var _DOMUtils = __webpack_require__(182);

var _DOMStateStorage = __webpack_require__(183);

var _createDOMHistory = __webpack_require__(256);

var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);

/**
 * Creates and returns a history object that uses HTML5's history API
 * (pushState, replaceState, and the popstate event) to manage history.
 * This is the recommended method of managing history in browsers because
 * it provides the cleanest URLs.
 *
 * Note: In browsers that do not support the HTML5 history API full
 * page reloads will be used to preserve URLs.
 */
function createBrowserHistory() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Browser history needs a DOM') : _invariant2['default'](false) : undefined;

  var forceRefresh = options.forceRefresh;

  var isSupported = _DOMUtils.supportsHistory();
  var useRefresh = !isSupported || forceRefresh;

  function getCurrentLocation(historyState) {
    try {
      historyState = historyState || window.history.state || {};
    } catch (e) {
      historyState = {};
    }

    var path = _DOMUtils.getWindowPath();
    var _historyState = historyState;
    var key = _historyState.key;

    var state = undefined;
    if (key) {
      state = _DOMStateStorage.readState(key);
    } else {
      state = null;
      key = history.createKey();

      if (isSupported) window.history.replaceState(_extends({}, historyState, { key: key }), null);
    }

    var location = _PathUtils.parsePath(path);

    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
  }

  function startPopStateListener(_ref) {
    var transitionTo = _ref.transitionTo;

    function popStateListener(event) {
      if (event.state === undefined) return; // Ignore extraneous popstate events in WebKit.

      transitionTo(getCurrentLocation(event.state));
    }

    _DOMUtils.addEventListener(window, 'popstate', popStateListener);

    return function () {
      _DOMUtils.removeEventListener(window, 'popstate', popStateListener);
    };
  }

  function finishTransition(location) {
    var basename = location.basename;
    var pathname = location.pathname;
    var search = location.search;
    var hash = location.hash;
    var state = location.state;
    var action = location.action;
    var key = location.key;

    if (action === _Actions.POP) return; // Nothing to do.

    _DOMStateStorage.saveState(key, state);

    var path = (basename || '') + pathname + search + hash;
    var historyState = {
      key: key
    };

    if (action === _Actions.PUSH) {
      if (useRefresh) {
        window.location.href = path;
        return false; // Prevent location update.
      } else {
          window.history.pushState(historyState, null, path);
        }
    } else {
      // REPLACE
      if (useRefresh) {
        window.location.replace(path);
        return false; // Prevent location update.
      } else {
          window.history.replaceState(historyState, null, path);
        }
    }
  }

  var history = _createDOMHistory2['default'](_extends({}, options, {
    getCurrentLocation: getCurrentLocation,
    finishTransition: finishTransition,
    saveState: _DOMStateStorage.saveState
  }));

  var listenerCount = 0,
      stopPopStateListener = undefined;

  function listenBefore(listener) {
    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);

    var unlisten = history.listenBefore(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopPopStateListener();
    };
  }

  function listen(listener) {
    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);

    var unlisten = history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopPopStateListener();
    };
  }

  // deprecated
  function registerTransitionHook(hook) {
    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);

    history.registerTransitionHook(hook);
  }

  // deprecated
  function unregisterTransitionHook(hook) {
    history.unregisterTransitionHook(hook);

    if (--listenerCount === 0) stopPopStateListener();
  }

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen,
    registerTransitionHook: registerTransitionHook,
    unregisterTransitionHook: unregisterTransitionHook
  });
}

exports['default'] = createBrowserHistory;
module.exports = exports['default'];

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createHashHistory = __webpack_require__(255);

var _createHashHistory2 = _interopRequireDefault(_createHashHistory);

var _createRouterHistory = __webpack_require__(269);

var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
module.exports = exports['default'];

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = useScroll;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ScrollBehaviorContainer = __webpack_require__(523);

var _ScrollBehaviorContainer2 = _interopRequireDefault(_ScrollBehaviorContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useScroll(shouldUpdateScroll) {
  return {
    renderRouterContext: function renderRouterContext(child, props) {
      return _react2.default.createElement(
        _ScrollBehaviorContainer2.default,
        {
          shouldUpdateScroll: shouldUpdateScroll,
          routerProps: props
        },
        child
      );
    }
  };
}
module.exports = exports['default'];

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ScrollBehavior = __webpack_require__(524);

var _ScrollBehavior2 = _interopRequireDefault(_ScrollBehavior);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ScrollBehaviorContainer = function (_React$Component) {
  _inherits(ScrollBehaviorContainer, _React$Component);

  function ScrollBehaviorContainer() {
    _classCallCheck(this, ScrollBehaviorContainer);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  ScrollBehaviorContainer.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var routerProps = this.props.routerProps;


    this.scrollBehavior = new _ScrollBehavior2.default(routerProps.router, function () {
      return _this2.props.routerProps.location;
    });

    this.onUpdate(null, routerProps);
  };

  ScrollBehaviorContainer.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var routerProps = this.props.routerProps;

    var prevRouterProps = prevProps.routerProps;

    if (routerProps.location === prevRouterProps.location) {
      return;
    }

    this.onUpdate(prevRouterProps, routerProps);
  };

  ScrollBehaviorContainer.prototype.componentWillUnmount = function componentWillUnmount() {
    this.scrollBehavior.stop();
  };

  ScrollBehaviorContainer.prototype.onUpdate = function onUpdate(prevRouterProps, routerProps) {
    var shouldUpdateScroll = this.props.shouldUpdateScroll;


    var scrollPosition = void 0;
    if (!shouldUpdateScroll) {
      scrollPosition = true;
    } else {
      scrollPosition = shouldUpdateScroll.call(this.scrollBehavior, prevRouterProps, routerProps);
    }

    this.scrollBehavior.updateScroll(scrollPosition);
  };

  ScrollBehaviorContainer.prototype.render = function render() {
    return this.props.children;
  };

  return ScrollBehaviorContainer;
}(_react2.default.Component);

ScrollBehaviorContainer.propTypes = {
  shouldUpdateScroll: _react2.default.PropTypes.func,
  routerProps: _react2.default.PropTypes.object.isRequired,
  children: _react2.default.PropTypes.node.isRequired
};
exports.default = ScrollBehaviorContainer;
module.exports = exports['default'];

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _off = __webpack_require__(525);

var _off2 = _interopRequireDefault(_off);

var _on = __webpack_require__(526);

var _on2 = _interopRequireDefault(_on);

var _scrollLeft = __webpack_require__(527);

var _scrollLeft2 = _interopRequireDefault(_scrollLeft);

var _scrollTop = __webpack_require__(528);

var _scrollTop2 = _interopRequireDefault(_scrollTop);

var _requestAnimationFrame = __webpack_require__(529);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _Actions = __webpack_require__(67);

var _DOMStateStorage = __webpack_require__(183);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /* eslint-disable no-underscore-dangle */

// FIXME: Stop using this gross hack. This won't collide with any actual
// history location keys, but it's dirty to sneakily use the same storage here.
var KEY_PREFIX = 's/';

// Try at most this many times to scroll, to avoid getting stuck.
var MAX_SCROLL_ATTEMPTS = 2;

var ScrollBehavior = function () {
  function ScrollBehavior(history, getCurrentLocation) {
    var _this = this;

    _classCallCheck(this, ScrollBehavior);

    this._onScroll = function () {
      // It's possible that this scroll operation was triggered by what will be a
      // `POP` transition. Instead of updating the saved location immediately, we
      // have to enqueue the update, then potentially cancel it if we observe a
      // location update.
      if (_this._savePositionHandle === null) {
        _this._savePositionHandle = (0, _requestAnimationFrame2.default)(_this._savePosition);
      }

      if (_this._scrollTarget) {
        var _scrollTarget = _this._scrollTarget;
        var xTarget = _scrollTarget[0];
        var yTarget = _scrollTarget[1];

        var x = (0, _scrollLeft2.default)(window);
        var y = (0, _scrollTop2.default)(window);

        if (x === xTarget && y === yTarget) {
          _this._scrollTarget = null;
          _this._cancelCheckScroll();
        }
      }
    };

    this._savePosition = function () {
      _this._savePositionHandle = null;

      // We have to directly update `DOMStateStorage`, because actually updating
      // the location could cause e.g. React Router to re-render the entire page,
      // which would lead to observably bad scroll performance.
      (0, _DOMStateStorage.saveState)(_this._getKey(_this._getCurrentLocation()), [(0, _scrollLeft2.default)(window), (0, _scrollTop2.default)(window)]);
    };

    this._checkScrollPosition = function () {
      _this._checkScrollHandle = null;

      // We can only get here if scrollTarget is set. Every code path that unsets
      // scroll target also cancels the handle to avoid calling this handler.
      // Still, check anyway just in case.
      /* istanbul ignore if: paranoid guard */
      if (!_this._scrollTarget) {
        return;
      }

      var _scrollTarget2 = _this._scrollTarget;
      var x = _scrollTarget2[0];
      var y = _scrollTarget2[1];

      window.scrollTo(x, y);

      ++_this._numScrollAttempts;

      /* istanbul ignore if: paranoid guard */
      if (_this._numScrollAttempts >= MAX_SCROLL_ATTEMPTS) {
        _this._scrollTarget = null;
        return;
      }

      _this._checkScrollHandle = (0, _requestAnimationFrame2.default)(_this._checkScrollPosition);
    };

    this._history = history;
    this._getCurrentLocation = getCurrentLocation;

    // This helps avoid some jankiness in fighting against the browser's
    // default scroll behavior on `POP` transitions.
    /* istanbul ignore if: not supported by any browsers on Travis */
    if ('scrollRestoration' in window.history) {
      this._oldScrollRestoration = window.history.scrollRestoration;
      window.history.scrollRestoration = 'manual';
    } else {
      this._oldScrollRestoration = null;
    }

    this._savePositionHandle = null;
    this._checkScrollHandle = null;
    this._scrollTarget = null;
    this._numScrollAttempts = 0;

    // We have to listen to each scroll update rather than to just location
    // updates, because some browsers will update scroll position before
    // emitting the location change.
    (0, _on2.default)(window, 'scroll', this._onScroll);

    this._unlistenBefore = history.listenBefore(function () {
      if (_this._savePositionHandle !== null) {
        _requestAnimationFrame2.default.cancel(_this._savePositionHandle);
        _this._savePositionHandle = null;
      }
    });
  }

  ScrollBehavior.prototype.stop = function stop() {
    /* istanbul ignore if: not supported by any browsers on Travis */
    if (this._oldScrollRestoration) {
      window.history.scrollRestoration = this._oldScrollRestoration;
    }

    (0, _off2.default)(window, 'scroll', this._onScroll);
    this._cancelCheckScroll();

    this._unlistenBefore();
  };

  ScrollBehavior.prototype.updateScroll = function updateScroll(scrollPosition) {
    // Whatever we were doing before isn't relevant any more.
    this._cancelCheckScroll();

    if (scrollPosition && !Array.isArray(scrollPosition)) {
      this._scrollTarget = this._getDefaultScrollTarget();
    } else {
      this._scrollTarget = scrollPosition;
    }

    // Check the scroll position to see if we even need to scroll.
    this._onScroll();

    if (!this._scrollTarget) {
      return;
    }

    this._numScrollAttempts = 0;
    this._checkScrollPosition();
  };

  ScrollBehavior.prototype.readPosition = function readPosition(location) {
    return (0, _DOMStateStorage.readState)(this._getKey(location));
  };

  ScrollBehavior.prototype._getKey = function _getKey(location) {
    // Use fallback key when actual key is unavailable.
    var key = location.key || this._history.createPath(location);

    return '' + KEY_PREFIX + key;
  };

  ScrollBehavior.prototype._cancelCheckScroll = function _cancelCheckScroll() {
    if (this._checkScrollHandle !== null) {
      _requestAnimationFrame2.default.cancel(this._checkScrollHandle);
      this._checkScrollHandle = null;
    }
  };

  ScrollBehavior.prototype._getDefaultScrollTarget = function _getDefaultScrollTarget() {
    var location = this._getCurrentLocation();
    if (location.action === _Actions.PUSH) {
      return [0, 0];
    }

    return this.readPosition(location) || [0, 0];
  };

  return ScrollBehavior;
}();

exports.default = ScrollBehavior;
module.exports = exports['default'];

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var canUseDOM = __webpack_require__(189);
var off = function off() {};

if (canUseDOM) {

  off = (function () {

    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.removeEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.detachEvent('on' + eventName, handler);
    };
  })();
}

module.exports = off;

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var canUseDOM = __webpack_require__(189);
var on = function on() {};

if (canUseDOM) {
  on = (function () {

    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.addEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.attachEvent('on' + eventName, handler);
    };
  })();
}

module.exports = on;

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getWindow = __webpack_require__(270);

module.exports = function scrollTop(node, val) {
  var win = getWindow(node);

  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;

  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
};

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getWindow = __webpack_require__(270);

module.exports = function scrollTop(node, val) {
  var win = getWindow(node);

  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;

  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
};

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var canUseDOM = __webpack_require__(189);

var vendors = ['', 'webkit', 'moz', 'o', 'ms'],
    cancel = 'clearTimeout',
    raf = fallback,
    compatRaf;

var getKey = function getKey(vendor, k) {
  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
};

if (canUseDOM) {
  vendors.some(function (vendor) {
    var rafKey = getKey(vendor, 'request');

    if (rafKey in window) {
      cancel = getKey(vendor, 'cancel');
      return raf = function (cb) {
        return window[rafKey](cb);
      };
    }
  });
}

/* https://github.com/component/raf */
var prev = new Date().getTime();

function fallback(fn) {
  var curr = new Date().getTime(),
      ms = Math.max(0, 16 - (curr - prev)),
      req = setTimeout(fn, ms);

  prev = curr;
  return req;
}

compatRaf = function (cb) {
  return raf(cb);
};
compatRaf.cancel = function (id) {
  return window[cancel](id);
};

module.exports = compatRaf;

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

var AppEnvs = {
    prod: 'PROD',
    qa: 'QA',
    dev: 'DEV'
};

module.exports = function () {
    var env = Object({"NODE_ENV":"production"});
    var APP_ENV = env.APP_ENV || AppEnvs.dev;
    var UID = env.UID;
    var PORT = env.PORT;
    var HOST = env.HOST;
    var MEMCACHED_SERVERS = (env.MEMCACHED_SERVERS || '127.0.0.1:11211').split(',');
    var MEMCACHED_POOLSIZE = env.MEMCACHED_POOLSIZE;
    var MEMCACHED_TIMEOUT = env.MEMCACHED_TIMEOUT;
    var MEMCACHED_RETRIES = env.MEMCACHED_RETRIES;
    var MEMCACHED_FAILURES = env.MEMCACHED_FAILURES;
    var MEMCACHED_NAMESPACE = env.MEMCACHED_NAMESPACE;
    var SHELL_IMG_REF = env.SHELL_IMG_REF;
    // used only for page shell assets
    var SECURE_CDN_HOST = env.SECURE_CDN_HOST || 'https://a.espncdn.com';
    var CDN_HOST = env.CDN_HOST;
    var CDN_PATH = env.CDN_PATH;
    var DEV_STYLES = env.DEV_STYLES;
    var SCORETC_FRONTCHANNEL_HOST = env.SCORETC_FRONTCHANNEL_HOST;
    var SCORETC_BACKCHANNEL_HOST = env.SCORETC_BACKCHANNEL_HOST;
    var PKG_VERSION = '2.1.1-272';
    var BASE_ROUTE = env.BASE_ROUTE;

    // this hasn't been merged - https://github.disney.com/SEESPN/chef-repo/pull/758, so we handle differently
    // used only for vwatchwebnode bundle
    var SECURE_CDN_PATH = env.SECURE_CDN_PATH;
    if (!SECURE_CDN_PATH) {
        if (APP_ENV === AppEnvs.prod) {
            SECURE_CDN_PATH = CDN_PATH.replace(/https?:\/\/[^\/]+/, 'https://secure.espncdn.com');
        } else if (APP_ENV === AppEnvs.qa) {
            SECURE_CDN_PATH = CDN_PATH.replace(/https?:\/\/[^\/]+/, 'https://a-qa.espncdn.com');
        }
    }

    var HTTP_PROXY = env.HTTP_PROXY;
    if (HTTP_PROXY && !HTTP_PROXY.startsWith('http://')) {
        HTTP_PROXY = 'http://' + HTTP_PROXY;
    }

    var NO_PROXY = env.NO_PROXY;
    // add any new API hosts as regex here which won't work with the old proxy until we move to AWS
    var noProxyHosts = ['affiliate\\.api.*\\.espn\\.com', 'proxy\\.espn\\.com'];
    var noProxy = null;
    if (NO_PROXY) {
        noProxy = NO_PROXY;
        noProxy = noProxy.replace(/\*\./g, '.').replace(/\./g, '\\.'); // make the NO_PROXY values compatible with regex
        noProxy = noProxyHosts.reduce(function (acc, host) {
            return acc + '|' + host;
        }, noProxy);
        noProxy = 'https?:\\/\\/[^\\/]*(?:' + noProxy + ')'; // make the usable regex
    }

    // update running port 8000 to 80. Port 8000 has CORS issue with oneID registration
    return {
        uid: UID || 'app',
        port: PORT || (DEV_STYLES ? 80 : 8080),
        host: HOST || '0.0.0.0',
        baseRoute: BASE_ROUTE || '/watch',
        appEnv: APP_ENV,
        apiHost: {
            sCoreTcClient: SCORETC_FRONTCHANNEL_HOST || 'cdn.espn.com/core',
            sCoreTcServer: SCORETC_BACKCHANNEL_HOST || 'glue-bc.prod.espninfra.starwave.com/core'
        },
        devStyles: DEV_STYLES || false,
        legacyServiceUrl: 'http://www.espn.com/watchespn',
        cache: {
            servers: MEMCACHED_SERVERS,
            poolSize: parseInt(MEMCACHED_POOLSIZE, 10) || 100,
            timeout: parseInt(MEMCACHED_TIMEOUT, 10) || 1000,
            retries: parseInt(MEMCACHED_RETRIES, 10) || 1,
            failures: parseInt(MEMCACHED_FAILURES, 10) || 1,
            namespace: MEMCACHED_NAMESPACE || 'vwatchwebnode:'
        },
        shellVersion: '0.489.4',
        secureCdnHost: SECURE_CDN_HOST,
        cdnHost: CDN_HOST || 'http://a.espncdn.com',
        cdnPath: CDN_PATH ? CDN_PATH + '/' + PKG_VERSION : '/dist',
        secureCdnPath: SECURE_CDN_PATH ? SECURE_CDN_PATH + '/' + PKG_VERSION : '/dist',
        httpProxy: HTTP_PROXY || null,
        noProxy: noProxy,
        isBeta: false,
        clientNavigation: true,
        enableSearch: true,
        newrelicInsertKey: 'F2lp90YgLmEP4KO_hQUxwZeyg7hC9Wjs',
        newrelicAccountId: '459463'
    };
}();

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = syncHistoryWithStore;

var _reducer = __webpack_require__(272);

var defaultSelectLocationState = function defaultSelectLocationState(state) {
  return state.routing;
};

/**
 * This function synchronizes your history state with the Redux store.
 * Location changes flow from history to the store. An enhanced history is
 * returned with a listen method that responds to store updates for location.
 *
 * When this history is provided to the router, this means the location data
 * will flow like this:
 * history.push -> store.dispatch -> enhancedHistory.listen -> router
 * This ensures that when the store state changes due to a replay or other
 * event, the router will be updated appropriately and can transition to the
 * correct router state.
 */
function syncHistoryWithStore(history, store) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$selectLocationSt = _ref.selectLocationState,
      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;

  // Ensure that the reducer is mounted on the store and functioning properly.
  if (typeof selectLocationState(store.getState()) === 'undefined') {
    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
  }

  var initialLocation = void 0;
  var isTimeTraveling = void 0;
  var unsubscribeFromStore = void 0;
  var unsubscribeFromHistory = void 0;
  var currentLocation = void 0;

  // What does the store say about current location?
  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
    var locationState = selectLocationState(store.getState());
    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
  };

  // Init initialLocation with potential location in store
  initialLocation = getLocationInStore();

  // If the store is replayed, update the URL in the browser to match.
  if (adjustUrlOnReplay) {
    var handleStoreChange = function handleStoreChange() {
      var locationInStore = getLocationInStore(true);
      if (currentLocation === locationInStore || initialLocation === locationInStore) {
        return;
      }

      // Update address bar to reflect store state
      isTimeTraveling = true;
      currentLocation = locationInStore;
      history.transitionTo(_extends({}, locationInStore, {
        action: 'PUSH'
      }));
      isTimeTraveling = false;
    };

    unsubscribeFromStore = store.subscribe(handleStoreChange);
    handleStoreChange();
  }

  // Whenever location changes, dispatch an action to get it in the store
  var handleLocationChange = function handleLocationChange(location) {
    // ... unless we just caused that location change
    if (isTimeTraveling) {
      return;
    }

    // Remember where we are
    currentLocation = location;

    // Are we being called for the first time?
    if (!initialLocation) {
      // Remember as a fallback in case state is reset
      initialLocation = location;

      // Respect persisted location, if any
      if (getLocationInStore()) {
        return;
      }
    }

    // Tell the store to update by dispatching an action
    store.dispatch({
      type: _reducer.LOCATION_CHANGE,
      payload: location
    });
  };
  unsubscribeFromHistory = history.listen(handleLocationChange);

  // support history 3.x
  if (history.getCurrentLocation) {
    handleLocationChange(history.getCurrentLocation());
  }

  // The enhanced history uses store as source of truth
  return _extends({}, history, {
    // The listeners are subscribed to the store instead of history
    listen: function listen(listener) {
      // Copy of last location.
      var lastPublishedLocation = getLocationInStore(true);

      // Keep track of whether we unsubscribed, as Redux store
      // only applies changes in subscriptions on next dispatch
      var unsubscribed = false;
      var unsubscribeFromStore = store.subscribe(function () {
        var currentLocation = getLocationInStore(true);
        if (currentLocation === lastPublishedLocation) {
          return;
        }
        lastPublishedLocation = currentLocation;
        if (!unsubscribed) {
          listener(lastPublishedLocation);
        }
      });

      // History listeners expect a synchronous call. Make the first call to the
      // listener after subscribing to the store, in case the listener causes a
      // location change (e.g. when it redirects)
      listener(lastPublishedLocation);

      // Let user unsubscribe later
      return function () {
        unsubscribed = true;
        unsubscribeFromStore();
      };
    },


    // It also provides a way to destroy internal listeners
    unsubscribe: function unsubscribe() {
      if (adjustUrlOnReplay) {
        unsubscribeFromStore();
      }
      unsubscribeFromHistory();
    }
  });
}

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = routerMiddleware;

var _actions = __webpack_require__(273);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */
function routerMiddleware(history) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type !== _actions.CALL_HISTORY_METHOD) {
          return next(action);
        }

        var _action$payload = action.payload,
            method = _action$payload.method,
            args = _action$payload.args;

        history[method].apply(history, _toConsumableArray(args));
      };
    };
  };
}

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Expose `Emitter`.
 */

if (true) {
  module.exports = Emitter;
}

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }

  // Remove event specific arrays for event types that no
  // one is subscribed for to avoid memory leak.
  if (callbacks.length === 0) {
    delete this._callbacks['$' + event];
  }

  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};

  var args = new Array(arguments.length - 1)
    , callbacks = this._callbacks['$' + event];

  for (var i = 1; i < arguments.length; i++) {
    args[i - 1] = arguments[i];
  }

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module of mixed-in functions shared between node and client code
 */
var isObject = __webpack_require__(275);

/**
 * Clear previous timeout.
 *
 * @return {Request} for chaining
 * @api public
 */

exports.clearTimeout = function _clearTimeout(){
  this._timeout = 0;
  clearTimeout(this._timer);
  return this;
};

/**
 * Override default response body parser
 *
 * This function will be called to convert incoming data into request.body
 *
 * @param {Function}
 * @api public
 */

exports.parse = function parse(fn){
  this._parser = fn;
  return this;
};

/**
 * Override default request body serializer
 *
 * This function will be called to convert data set via .send or .attach into payload to send
 *
 * @param {Function}
 * @api public
 */

exports.serialize = function serialize(fn){
  this._serializer = fn;
  return this;
};

/**
 * Set timeout to `ms`.
 *
 * @param {Number} ms
 * @return {Request} for chaining
 * @api public
 */

exports.timeout = function timeout(ms){
  this._timeout = ms;
  return this;
};

/**
 * Promise support
 *
 * @param {Function} resolve
 * @param {Function} reject
 * @return {Request}
 */

exports.then = function then(resolve, reject) {
  if (!this._fullfilledPromise) {
    var self = this;
    this._fullfilledPromise = new Promise(function(innerResolve, innerReject){
      self.end(function(err, res){
        if (err) innerReject(err); else innerResolve(res);
      });
    });
  }
  return this._fullfilledPromise.then(resolve, reject);
}

/**
 * Allow for extension
 */

exports.use = function use(fn) {
  fn(this);
  return this;
}


/**
 * Get request header `field`.
 * Case-insensitive.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

exports.get = function(field){
  return this._header[field.toLowerCase()];
};

/**
 * Get case-insensitive header `field` value.
 * This is a deprecated internal API. Use `.get(field)` instead.
 *
 * (getHeader is no longer used internally by the superagent code base)
 *
 * @param {String} field
 * @return {String}
 * @api private
 * @deprecated
 */

exports.getHeader = exports.get;

/**
 * Set header `field` to `val`, or multiple fields with one object.
 * Case-insensitive.
 *
 * Examples:
 *
 *      req.get('/')
 *        .set('Accept', 'application/json')
 *        .set('X-API-Key', 'foobar')
 *        .end(callback);
 *
 *      req.get('/')
 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
 *        .end(callback);
 *
 * @param {String|Object} field
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

exports.set = function(field, val){
  if (isObject(field)) {
    for (var key in field) {
      this.set(key, field[key]);
    }
    return this;
  }
  this._header[field.toLowerCase()] = val;
  this.header[field] = val;
  return this;
};

/**
 * Remove header `field`.
 * Case-insensitive.
 *
 * Example:
 *
 *      req.get('/')
 *        .unset('User-Agent')
 *        .end(callback);
 *
 * @param {String} field
 */
exports.unset = function(field){
  delete this._header[field.toLowerCase()];
  delete this.header[field];
  return this;
};

/**
 * Write the field `name` and `val` for "multipart/form-data"
 * request bodies.
 *
 * ``` js
 * request.post('/upload')
 *   .field('foo', 'bar')
 *   .end(callback);
 * ```
 *
 * @param {String} name
 * @param {String|Blob|File|Buffer|fs.ReadStream} val
 * @return {Request} for chaining
 * @api public
 */
exports.field = function(name, val) {
  this._getFormData().append(name, val);
  return this;
};

/**
 * Abort the request, and clear potential timeout.
 *
 * @return {Request}
 * @api public
 */
exports.abort = function(){
  if (this._aborted) {
    return this;
  }
  this._aborted = true;
  this.xhr && this.xhr.abort(); // browser
  this.req && this.req.abort(); // node
  this.clearTimeout();
  this.emit('abort');
  return this;
};

/**
 * Enable transmission of cookies with x-domain requests.
 *
 * Note that for this to work the origin must not be
 * using "Access-Control-Allow-Origin" with a wildcard,
 * and also must set "Access-Control-Allow-Credentials"
 * to "true".
 *
 * @api public
 */

exports.withCredentials = function(){
  // This is browser-only functionality. Node side is no-op.
  this._withCredentials = true;
  return this;
};

/**
 * Set the max redirects to `n`. Does noting in browser XHR implementation.
 *
 * @param {Number} n
 * @return {Request} for chaining
 * @api public
 */

exports.redirects = function(n){
  this._maxRedirects = n;
  return this;
};

/**
 * Convert to a plain javascript object (not JSON string) of scalar properties.
 * Note as this method is designed to return a useful non-this value,
 * it cannot be chained.
 *
 * @return {Object} describing method, url, and data of this request
 * @api public
 */

exports.toJSON = function(){
  return {
    method: this.method,
    url: this.url,
    data: this._data,
    headers: this._header
  };
};

/**
 * Check if `obj` is a host object,
 * we don't want to serialize these :)
 *
 * TODO: future proof, move to compoent land
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */

exports._isHost = function _isHost(obj) {
  var str = {}.toString.call(obj);

  switch (str) {
    case '[object File]':
    case '[object Blob]':
    case '[object FormData]':
      return true;
    default:
      return false;
  }
}

/**
 * Send `data` as the request body, defaulting the `.type()` to "json" when
 * an object is given.
 *
 * Examples:
 *
 *       // manual json
 *       request.post('/user')
 *         .type('json')
 *         .send('{"name":"tj"}')
 *         .end(callback)
 *
 *       // auto json
 *       request.post('/user')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // manual x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send('name=tj')
 *         .end(callback)
 *
 *       // auto x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // defaults to x-www-form-urlencoded
 *      request.post('/user')
 *        .send('name=tobi')
 *        .send('species=ferret')
 *        .end(callback)
 *
 * @param {String|Object} data
 * @return {Request} for chaining
 * @api public
 */

exports.send = function(data){
  var obj = isObject(data);
  var type = this._header['content-type'];

  // merge
  if (obj && isObject(this._data)) {
    for (var key in data) {
      this._data[key] = data[key];
    }
  } else if ('string' == typeof data) {
    // default to x-www-form-urlencoded
    if (!type) this.type('form');
    type = this._header['content-type'];
    if ('application/x-www-form-urlencoded' == type) {
      this._data = this._data
        ? this._data + '&' + data
        : data;
    } else {
      this._data = (this._data || '') + data;
    }
  } else {
    this._data = data;
  }

  if (!obj || this._isHost(data)) return this;

  // default to json
  if (!type) this.type('json');
  return this;
};


/***/ }),
/* 535 */
/***/ (function(module, exports) {

// The node and browser modules expose versions of this with the
// appropriate constructor function bound as first argument
/**
 * Issue a request:
 *
 * Examples:
 *
 *    request('GET', '/users').end(callback)
 *    request('/users').end(callback)
 *    request('/users', callback)
 *
 * @param {String} method
 * @param {String|Function} url or callback
 * @return {Request}
 * @api public
 */

function request(RequestConstructor, method, url) {
  // callback
  if ('function' == typeof url) {
    return new RequestConstructor('GET', method).end(url);
  }

  // url first
  if (2 == arguments.length) {
    return new RequestConstructor('GET', method);
  }

  return new RequestConstructor(method, url);
}

module.exports = request;


/***/ }),
/* 536 */
/***/ (function(module, exports) {

function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = 536;

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

var basePick = __webpack_require__(538),
    flatRest = __webpack_require__(572);

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

module.exports = pick;


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

var basePickBy = __webpack_require__(539),
    hasIn = __webpack_require__(284);

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}

module.exports = basePick;


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(193),
    baseSet = __webpack_require__(568),
    castPath = __webpack_require__(127);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(108);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 541 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(543);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(544);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(195);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(546),
    ListCache = __webpack_require__(130),
    Map = __webpack_require__(197);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(547),
    hashDelete = __webpack_require__(552),
    hashGet = __webpack_require__(553),
    hashHas = __webpack_require__(554),
    hashSet = __webpack_require__(555);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(129);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(196),
    isMasked = __webpack_require__(549),
    isObject = __webpack_require__(35),
    toSource = __webpack_require__(281);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(550);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(39);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 551 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 552 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(129);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(129);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(129);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 556 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(131);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(131);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(131);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(131);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(132);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 562 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(132);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(132);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(132);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(567);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(108),
    arrayMap = __webpack_require__(133),
    isArray = __webpack_require__(32),
    isSymbol = __webpack_require__(128);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(282),
    castPath = __webpack_require__(127),
    isIndex = __webpack_require__(135),
    isObject = __webpack_require__(35),
    toKey = __webpack_require__(110);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 569 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(127),
    isArguments = __webpack_require__(111),
    isArray = __webpack_require__(32),
    isIndex = __webpack_require__(135),
    isLength = __webpack_require__(198),
    toKey = __webpack_require__(110);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(71),
    isObjectLike = __webpack_require__(59);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(573),
    overRest = __webpack_require__(287),
    setToString = __webpack_require__(288);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(285);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(108),
    isArguments = __webpack_require__(111),
    isArray = __webpack_require__(32);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 575 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(577),
    defineProperty = __webpack_require__(283),
    identity = __webpack_require__(199);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 577 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 578 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(200),
    getTag = __webpack_require__(201),
    isArrayLike = __webpack_require__(51),
    isString = __webpack_require__(584),
    stringSize = __webpack_require__(585);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/**
 * Gets the size of `collection` by returning its length for array-like
 * values or the number of own enumerable string keyed properties for objects.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @returns {number} Returns the collection size.
 * @example
 *
 * _.size([1, 2, 3]);
 * // => 3
 *
 * _.size({ 'a': 1, 'b': 2 });
 * // => 2
 *
 * _.size('pebbles');
 * // => 7
 */
function size(collection) {
  if (collection == null) {
    return 0;
  }
  if (isArrayLike(collection)) {
    return isString(collection) ? stringSize(collection) : collection.length;
  }
  var tag = getTag(collection);
  if (tag == mapTag || tag == setTag) {
    return collection.size;
  }
  return baseKeys(collection).length;
}

module.exports = size;


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(289);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(72),
    root = __webpack_require__(39);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(72),
    root = __webpack_require__(39);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(72),
    root = __webpack_require__(39);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(71),
    isArray = __webpack_require__(32),
    isObjectLike = __webpack_require__(59);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

var asciiSize = __webpack_require__(586),
    hasUnicode = __webpack_require__(587),
    unicodeSize = __webpack_require__(588);

/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */
function stringSize(string) {
  return hasUnicode(string)
    ? unicodeSize(string)
    : asciiSize(string);
}

module.exports = stringSize;


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(291);

/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
var asciiSize = baseProperty('length');

module.exports = asciiSize;


/***/ }),
/* 587 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 588 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
function unicodeSize(string) {
  var result = reUnicode.lastIndex = 0;
  while (reUnicode.test(string)) {
    ++result;
  }
  return result;
}

module.exports = unicodeSize;


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

var moment = module.exports = __webpack_require__(590);
moment.tz.load(__webpack_require__(592));


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(console) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
//! version : 0.5.26
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone

(function (root, factory) {
	"use strict";

	/*global define*/
	if (typeof module === 'object' && module.exports) {
		module.exports = factory(__webpack_require__(292)); // Node
	} else if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(292)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
	} else {
		factory(root.moment);                        // Browser
	}
}(this, function (moment) {
	"use strict";

	// Do not load moment-timezone a second time.
	// if (moment.tz !== undefined) {
	// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
	// 	return moment;
	// }

	var VERSION = "0.5.26",
		zones = {},
		links = {},
		names = {},
		guesses = {},
		cachedGuess;

	if (!moment || typeof moment.version !== 'string') {
		logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
	}

	var momentVersion = moment.version.split('.'),
		major = +momentVersion[0],
		minor = +momentVersion[1];

	// Moment.js version check
	if (major < 2 || (major === 2 && minor < 6)) {
		logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
	}

	/************************************
		Unpacking
	************************************/

	function charCodeToInt(charCode) {
		if (charCode > 96) {
			return charCode - 87;
		} else if (charCode > 64) {
			return charCode - 29;
		}
		return charCode - 48;
	}

	function unpackBase60(string) {
		var i = 0,
			parts = string.split('.'),
			whole = parts[0],
			fractional = parts[1] || '',
			multiplier = 1,
			num,
			out = 0,
			sign = 1;

		// handle negative numbers
		if (string.charCodeAt(0) === 45) {
			i = 1;
			sign = -1;
		}

		// handle digits before the decimal
		for (i; i < whole.length; i++) {
			num = charCodeToInt(whole.charCodeAt(i));
			out = 60 * out + num;
		}

		// handle digits after the decimal
		for (i = 0; i < fractional.length; i++) {
			multiplier = multiplier / 60;
			num = charCodeToInt(fractional.charCodeAt(i));
			out += num * multiplier;
		}

		return out * sign;
	}

	function arrayToInt (array) {
		for (var i = 0; i < array.length; i++) {
			array[i] = unpackBase60(array[i]);
		}
	}

	function intToUntil (array, length) {
		for (var i = 0; i < length; i++) {
			array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
		}

		array[length - 1] = Infinity;
	}

	function mapIndices (source, indices) {
		var out = [], i;

		for (i = 0; i < indices.length; i++) {
			out[i] = source[indices[i]];
		}

		return out;
	}

	function unpack (string) {
		var data = string.split('|'),
			offsets = data[2].split(' '),
			indices = data[3].split(''),
			untils  = data[4].split(' ');

		arrayToInt(offsets);
		arrayToInt(indices);
		arrayToInt(untils);

		intToUntil(untils, indices.length);

		return {
			name       : data[0],
			abbrs      : mapIndices(data[1].split(' '), indices),
			offsets    : mapIndices(offsets, indices),
			untils     : untils,
			population : data[5] | 0
		};
	}

	/************************************
		Zone object
	************************************/

	function Zone (packedString) {
		if (packedString) {
			this._set(unpack(packedString));
		}
	}

	Zone.prototype = {
		_set : function (unpacked) {
			this.name       = unpacked.name;
			this.abbrs      = unpacked.abbrs;
			this.untils     = unpacked.untils;
			this.offsets    = unpacked.offsets;
			this.population = unpacked.population;
		},

		_index : function (timestamp) {
			var target = +timestamp,
				untils = this.untils,
				i;

			for (i = 0; i < untils.length; i++) {
				if (target < untils[i]) {
					return i;
				}
			}
		},

		parse : function (timestamp) {
			var target  = +timestamp,
				offsets = this.offsets,
				untils  = this.untils,
				max     = untils.length - 1,
				offset, offsetNext, offsetPrev, i;

			for (i = 0; i < max; i++) {
				offset     = offsets[i];
				offsetNext = offsets[i + 1];
				offsetPrev = offsets[i ? i - 1 : i];

				if (offset < offsetNext && tz.moveAmbiguousForward) {
					offset = offsetNext;
				} else if (offset > offsetPrev && tz.moveInvalidForward) {
					offset = offsetPrev;
				}

				if (target < untils[i] - (offset * 60000)) {
					return offsets[i];
				}
			}

			return offsets[max];
		},

		abbr : function (mom) {
			return this.abbrs[this._index(mom)];
		},

		offset : function (mom) {
			logError("zone.offset has been deprecated in favor of zone.utcOffset");
			return this.offsets[this._index(mom)];
		},

		utcOffset : function (mom) {
			return this.offsets[this._index(mom)];
		}
	};

	/************************************
		Current Timezone
	************************************/

	function OffsetAt(at) {
		var timeString = at.toTimeString();
		var abbr = timeString.match(/\([a-z ]+\)/i);
		if (abbr && abbr[0]) {
			// 17:56:31 GMT-0600 (CST)
			// 17:56:31 GMT-0600 (Central Standard Time)
			abbr = abbr[0].match(/[A-Z]/g);
			abbr = abbr ? abbr.join('') : undefined;
		} else {
			// 17:56:31 CST
			// 17:56:31 GMT+0800 (台北標準時間)
			abbr = timeString.match(/[A-Z]{3,5}/g);
			abbr = abbr ? abbr[0] : undefined;
		}

		if (abbr === 'GMT') {
			abbr = undefined;
		}

		this.at = +at;
		this.abbr = abbr;
		this.offset = at.getTimezoneOffset();
	}

	function ZoneScore(zone) {
		this.zone = zone;
		this.offsetScore = 0;
		this.abbrScore = 0;
	}

	ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
		this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
		if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
			this.abbrScore++;
		}
	};

	function findChange(low, high) {
		var mid, diff;

		while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
			mid = new OffsetAt(new Date(low.at + diff));
			if (mid.offset === low.offset) {
				low = mid;
			} else {
				high = mid;
			}
		}

		return low;
	}

	function userOffsets() {
		var startYear = new Date().getFullYear() - 2,
			last = new OffsetAt(new Date(startYear, 0, 1)),
			offsets = [last],
			change, next, i;

		for (i = 1; i < 48; i++) {
			next = new OffsetAt(new Date(startYear, i, 1));
			if (next.offset !== last.offset) {
				change = findChange(last, next);
				offsets.push(change);
				offsets.push(new OffsetAt(new Date(change.at + 6e4)));
			}
			last = next;
		}

		for (i = 0; i < 4; i++) {
			offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
			offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
		}

		return offsets;
	}

	function sortZoneScores (a, b) {
		if (a.offsetScore !== b.offsetScore) {
			return a.offsetScore - b.offsetScore;
		}
		if (a.abbrScore !== b.abbrScore) {
			return a.abbrScore - b.abbrScore;
		}
		if (a.zone.population !== b.zone.population) {
			return b.zone.population - a.zone.population;
		}
		return b.zone.name.localeCompare(a.zone.name);
	}

	function addToGuesses (name, offsets) {
		var i, offset;
		arrayToInt(offsets);
		for (i = 0; i < offsets.length; i++) {
			offset = offsets[i];
			guesses[offset] = guesses[offset] || {};
			guesses[offset][name] = true;
		}
	}

	function guessesForUserOffsets (offsets) {
		var offsetsLength = offsets.length,
			filteredGuesses = {},
			out = [],
			i, j, guessesOffset;

		for (i = 0; i < offsetsLength; i++) {
			guessesOffset = guesses[offsets[i].offset] || {};
			for (j in guessesOffset) {
				if (guessesOffset.hasOwnProperty(j)) {
					filteredGuesses[j] = true;
				}
			}
		}

		for (i in filteredGuesses) {
			if (filteredGuesses.hasOwnProperty(i)) {
				out.push(names[i]);
			}
		}

		return out;
	}

	function rebuildGuess () {

		// use Intl API when available and returning valid time zone
		try {
			var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
			if (intlName && intlName.length > 3) {
				var name = names[normalizeName(intlName)];
				if (name) {
					return name;
				}
				logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
			}
		} catch (e) {
			// Intl unavailable, fall back to manual guessing.
		}

		var offsets = userOffsets(),
			offsetsLength = offsets.length,
			guesses = guessesForUserOffsets(offsets),
			zoneScores = [],
			zoneScore, i, j;

		for (i = 0; i < guesses.length; i++) {
			zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
			for (j = 0; j < offsetsLength; j++) {
				zoneScore.scoreOffsetAt(offsets[j]);
			}
			zoneScores.push(zoneScore);
		}

		zoneScores.sort(sortZoneScores);

		return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
	}

	function guess (ignoreCache) {
		if (!cachedGuess || ignoreCache) {
			cachedGuess = rebuildGuess();
		}
		return cachedGuess;
	}

	/************************************
		Global Methods
	************************************/

	function normalizeName (name) {
		return (name || '').toLowerCase().replace(/\//g, '_');
	}

	function addZone (packed) {
		var i, name, split, normalized;

		if (typeof packed === "string") {
			packed = [packed];
		}

		for (i = 0; i < packed.length; i++) {
			split = packed[i].split('|');
			name = split[0];
			normalized = normalizeName(name);
			zones[normalized] = packed[i];
			names[normalized] = name;
			addToGuesses(normalized, split[2].split(' '));
		}
	}

	function getZone (name, caller) {

		name = normalizeName(name);

		var zone = zones[name];
		var link;

		if (zone instanceof Zone) {
			return zone;
		}

		if (typeof zone === 'string') {
			zone = new Zone(zone);
			zones[name] = zone;
			return zone;
		}

		// Pass getZone to prevent recursion more than 1 level deep
		if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
			zone = zones[name] = new Zone();
			zone._set(link);
			zone.name = names[name];
			return zone;
		}

		return null;
	}

	function getNames () {
		var i, out = [];

		for (i in names) {
			if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
				out.push(names[i]);
			}
		}

		return out.sort();
	}

	function addLink (aliases) {
		var i, alias, normal0, normal1;

		if (typeof aliases === "string") {
			aliases = [aliases];
		}

		for (i = 0; i < aliases.length; i++) {
			alias = aliases[i].split('|');

			normal0 = normalizeName(alias[0]);
			normal1 = normalizeName(alias[1]);

			links[normal0] = normal1;
			names[normal0] = alias[0];

			links[normal1] = normal0;
			names[normal1] = alias[1];
		}
	}

	function loadData (data) {
		addZone(data.zones);
		addLink(data.links);
		tz.dataVersion = data.version;
	}

	function zoneExists (name) {
		if (!zoneExists.didShowError) {
			zoneExists.didShowError = true;
				logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
		}
		return !!getZone(name);
	}

	function needsOffset (m) {
		var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
		return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
	}

	function logError (message) {
		if (typeof console !== 'undefined' && typeof console.error === 'function') {
			console.error(message);
		}
	}

	/************************************
		moment.tz namespace
	************************************/

	function tz (input) {
		var args = Array.prototype.slice.call(arguments, 0, -1),
			name = arguments[arguments.length - 1],
			zone = getZone(name),
			out  = moment.utc.apply(null, args);

		if (zone && !moment.isMoment(input) && needsOffset(out)) {
			out.add(zone.parse(out), 'minutes');
		}

		out.tz(name);

		return out;
	}

	tz.version      = VERSION;
	tz.dataVersion  = '';
	tz._zones       = zones;
	tz._links       = links;
	tz._names       = names;
	tz.add          = addZone;
	tz.link         = addLink;
	tz.load         = loadData;
	tz.zone         = getZone;
	tz.zoneExists   = zoneExists; // deprecated in 0.1.0
	tz.guess        = guess;
	tz.names        = getNames;
	tz.Zone         = Zone;
	tz.unpack       = unpack;
	tz.unpackBase60 = unpackBase60;
	tz.needsOffset  = needsOffset;
	tz.moveInvalidForward   = true;
	tz.moveAmbiguousForward = false;

	/************************************
		Interface with Moment.js
	************************************/

	var fn = moment.fn;

	moment.tz = tz;

	moment.defaultZone = null;

	moment.updateOffset = function (mom, keepTime) {
		var zone = moment.defaultZone,
			offset;

		if (mom._z === undefined) {
			if (zone && needsOffset(mom) && !mom._isUTC) {
				mom._d = moment.utc(mom._a)._d;
				mom.utc().add(zone.parse(mom), 'minutes');
			}
			mom._z = zone;
		}
		if (mom._z) {
			offset = mom._z.utcOffset(mom);
			if (Math.abs(offset) < 16) {
				offset = offset / 60;
			}
			if (mom.utcOffset !== undefined) {
				var z = mom._z;
				mom.utcOffset(-offset, keepTime);
				mom._z = z;
			} else {
				mom.zone(offset, keepTime);
			}
		}
	};

	fn.tz = function (name, keepTime) {
		if (name) {
			if (typeof name !== 'string') {
				throw new Error('Time zone name must be a string, got ' + name + ' [' + typeof name + ']');
			}
			this._z = getZone(name);
			if (this._z) {
				moment.updateOffset(this, keepTime);
			} else {
				logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
			}
			return this;
		}
		if (this._z) { return this._z.name; }
	};

	function abbrWrap (old) {
		return function () {
			if (this._z) { return this._z.abbr(this); }
			return old.call(this);
		};
	}

	function resetZoneWrap (old) {
		return function () {
			this._z = null;
			return old.apply(this, arguments);
		};
	}

	function resetZoneWrap2 (old) {
		return function () {
			if (arguments.length > 0) this._z = null;
			return old.apply(this, arguments);
		};
	}

	fn.zoneName  = abbrWrap(fn.zoneName);
	fn.zoneAbbr  = abbrWrap(fn.zoneAbbr);
	fn.utc       = resetZoneWrap(fn.utc);
	fn.local     = resetZoneWrap(fn.local);
	fn.utcOffset = resetZoneWrap2(fn.utcOffset);

	moment.tz.setDefault = function(name) {
		if (major < 2 || (major === 2 && minor < 9)) {
			logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
		}
		moment.defaultZone = name ? getZone(name) : null;
		return moment;
	};

	// Cloning a moment should include the _z property.
	var momentProperties = moment.momentProperties;
	if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
		// moment 2.8.1+
		momentProperties.push('_z');
		momentProperties.push('_a');
	} else if (momentProperties) {
		// moment 2.7.0
		momentProperties._z = null;
	}

	// INJECT DATA

	return moment;
}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 591 */
/***/ (function(module, exports) {

function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = 591;

/***/ }),
/* 592 */
/***/ (function(module, exports) {

module.exports = {"version":"2019b","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5","Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|01212121212121212121212121212121213|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|0121|-2le00 4i6N0 2q00","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0","America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3","America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2","America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|012342525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 XQp0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|01212121212121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 LFB0 1cL0 3Cp0 1cL0 66N0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|01212121212121212121212121212121212121212121212121212121212121212121212121232121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 5Ip0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 Bb0 10N0 2bB0 8in0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|01203030303030303030303030303030304545450454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|01212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80","Antarctica/Macquarie|AEST AEDT -00 +11|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|010101010101010101010101010|-1c2w0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|0101010101010101010101010101010123232323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST HKT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +04 +03|-1U.U -20 -30 -40 -30|012121212121212121212121212121212121212121212121212121234343434342121212121212121212121212121212121212121212121212121212121212124|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSp0 CL0 mN0 1Vz0 1gN0 1pz0 5Rd0 1fz0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1jB0 18L0 1ip0 17z0 qdd0 xX0 3S10 Tz0 dA10 11z0 1o10 11z0 1qN0 11z0 1ze0 11B0 WM0 1qO0 WI0 1nX0 1rB0 10L0 11B0 1in0 17d0 1in0 2pX0 19E0 1fU0 16Q0 1iI0 16Q0 1iI0 1Vd0 pb0 3Kp0 14o0 1de0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|012121212121321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|PST PDT JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5","Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -9u -a0|0123141414141414135353|-2um8r.Q 97XV.Q 1m1zu kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rb0 1ld0 14n0 1zd0 On0 1zd0 On0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|30e2","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","EST|EST|50|0|","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Etc/GMT-0|GMT|0|0|","Etc/GMT-1|+01|-10|0|","Pacific/Port_Moresby|+10|-a0|0||25e4","Etc/GMT-11|+11|-b0|0|","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0|","Etc/GMT-14|+14|-e0|0|","Etc/GMT-2|+02|-20|0|","Etc/GMT-3|+03|-30|0|","Etc/GMT-4|+04|-40|0|","Etc/GMT-5|+05|-50|0|","Etc/GMT-6|+06|-60|0|","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0|","Pacific/Palau|+09|-90|0||21e3","Etc/GMT+1|-01|10|0|","Etc/GMT+10|-10|a0|0|","Etc/GMT+11|-11|b0|0|","Etc/GMT+12|-12|c0|0|","Etc/GMT+3|-03|30|0|","Etc/GMT+4|-04|40|0|","Etc/GMT+5|-05|50|0|","Etc/GMT+6|-06|60|0|","Etc/GMT+7|-07|70|0|","Etc/GMT+8|-08|80|0|","Etc/GMT+9|-09|90|0|","Etc/UTC|UTC|0|0|","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST CET CEST MSK MSD EEST EET +03|-10 -20 -20 -30 -30 -40 -30 -20 -30|0101010101010232454545454545454546767676767676767676767676767676767676767676787|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 Am0 Lb0 1en0 op0 1pNz0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1a00 1cM0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0|","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 +10 +09 -12 +12|-b0 -a0 -90 c0 -c0|012034|-1kln0 akp0 6Up0 12ry0 Wan0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","MST|MST|70|0|","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Chuuk|+10 +09|-a0 -90|01010|-2ewy0 axB0 RVX0 axd0|49e3","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B7X0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST +09 GDT ChST|-a0 -90 -b0 -a0|01020202020202020203|-18jK0 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4","Pacific/Honolulu|HST HDT HWT HPT HST|au 9u 9u 9u a0|0102304|-1thLu 8x0 lef0 8wWu iAu 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2","Pacific/Kosrae|+11 +09 +10 +12|-b0 -90 -a0 -c0|01021030|-2ewz0 axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2","Pacific/Majuro|+11 +09 +10 +12|-b0 -90 -a0 -c0|0102103|-2ewz0 axC0 HBy0 akp0 6RB0 12um0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3","Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11|-bc -bu -cu -b0|01213|-Kgbc W01G On0 1COp0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Pohnpei|+11 +09 +10|-b0 -90 -a0|010210|-2ewz0 axC0 HBy0 akp0 axd0|34e3","Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00"],"links":["Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Atikokan|America/Coral_Harbour","America/Chicago|US/Central","America/Curacao|America/Aruba","America/Curacao|America/Kralendijk","America/Curacao|America/Lower_Princes","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Los_Angeles|US/Pacific-New","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Cayman","America/Phoenix|US/Arizona","America/Port_of_Spain|America/Anguilla","America/Port_of_Spain|America/Antigua","America/Port_of_Spain|America/Dominica","America/Port_of_Spain|America/Grenada","America/Port_of_Spain|America/Guadeloupe","America/Port_of_Spain|America/Marigot","America/Port_of_Spain|America/Montserrat","America/Port_of_Spain|America/St_Barthelemy","America/Port_of_Spain|America/St_Kitts","America/Port_of_Spain|America/St_Lucia","America/Port_of_Spain|America/St_Thomas","America/Port_of_Spain|America/St_Vincent","America/Port_of_Spain|America/Tortola","America/Port_of_Spain|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UTC|Etc/UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UCT","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Chuuk|Pacific/Truk","Pacific/Chuuk|Pacific/Yap","Pacific/Easter|Chile/EasterIsland","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"]}

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * imports.
 */

var bind = Function.prototype.bind || __webpack_require__(594)

/*!
 * exports.
 */

module.exports = curry2

/**
 * Curry a binary function.
 *
 * @param {Function} fn
 * Binary function to curry.
 *
 * @param {Object} [self]
 * Function `this` context.
 *
 * @return {Function|*}
 * If partially applied, return unary function, otherwise, return result of full application.
 */

function curry2 (fn, self) {
  var out = function () {
    if (arguments.length === 0) return out

    return arguments.length > 1
      ? fn.apply(self, arguments)
      : bind.call(fn, self, arguments[0])
  }

  out.uncurry = function uncurry () {
    return fn
  }

  return out
}


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function(boundThis) {
  var f = this
    , ret

  if (arguments.length < 2)
    ret = function() {
      if (this instanceof ret) {
        var ret_ = f.apply(this, arguments)
        return Object(ret_) === ret_
          ? ret_
          : this
      }
      else
        return f.apply(boundThis, arguments)
    }
  else {
    var boundArgs = new Array(arguments.length - 1)
    for (var i = 1; i < arguments.length; i++)
      boundArgs[i - 1] = arguments[i]

    ret = function() {
      var boundLen = boundArgs.length
        , args = new Array(boundLen + arguments.length)
        , i
      for (i = 0; i < boundLen; i++)
        args[i] = boundArgs[i]
      for (i = 0; i < arguments.length; i++)
        args[boundLen + i] = arguments[i]

      if (this instanceof ret) {
        var ret_ = f.apply(this, args)
        return Object(ret_) === ret_
          ? ret_
          : this
      }
      else
        return f.apply(boundThis, args)
    }
  }

  ret.prototype = f.prototype
  return ret
}


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(console, process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(596);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = Object({"NODE_ENV":"production"}).DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(48)))

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(console) {
/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(597);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 597 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * exports.
 */

module.exports = brackets2dots;

/*!
 * regexp patterns.
 */

var REPLACE_BRACKETS = /\[([^\[\]]+)\]/g;
var LFT_RT_TRIM_DOTS = /^[.]*|[.]*$/g;

/**
 * Convert string with bracket notation to dot property notation.
 *
 * ### Examples:
 *
 *      brackets2dots('group[0].section.a.seat[3]')
 *      //=> 'group.0.section.a.seat.3'
 *
 *      brackets2dots('[0].section.a.seat[3]')
 *      //=> '0.section.a.seat.3'
 *
 *      brackets2dots('people[*].age')
 *      //=> 'people.*.age'
 *
 * @param  {String} string
 * original string
 *
 * @return {String}
 * dot/bracket-notation string
 */

function brackets2dots(string) {
  return ({}).toString.call(string) == '[object String]'
       ? string.replace(REPLACE_BRACKETS, '.$1').replace(LFT_RT_TRIM_DOTS, '')
       : ''
}


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toString = Object.prototype.toString

/**
 * Transform dot-delimited strings to array of strings.
 *
 * @param  {String} string
 * Dot-delimited string.
 *
 * @return {Array}
 * Array of strings.
 */

function dotsplit (string) {
  var idx = -1
  var str = compact(normalize(string).split('.'))
  var end = str.length
  var out = []

  while (++idx < end) {
    out.push(todots(str[idx]))
  }

  return out
}

/**
 * Replace escapes with a placeholder.
 *
 * @param  {String} string
 * Dot-delimited string.
 *
 * @return {String}
 * Dot-delimited string with placeholders in place of escapes.
 */

function normalize (string) {
  return (toString.call(string) === '[object String]' ? string : '').replace(/\\\./g, '\uffff')
}

/**
 * Drop empty values from array.
 *
 * @param  {Array} array
 * Array of strings.
 *
 * @return {Array}
 * Array of strings (empty values dropped).
 */

function compact (arr) {
  var idx = -1
  var end = arr.length
  var out = []

  while (++idx < end) {
    if (arr[idx]) out.push(arr[idx])
  }

  return out
}

/**
 * Change placeholder to dots.
 *
 * @param  {String} string
 * Dot-delimited string with placeholders.
 *
 * @return {String}
 * Dot-delimited string without placeholders.
 */

function todots (string) {
  return string.replace(/\uffff/g, '.')
}

/*!
 * exports.
 */

module.exports = dotsplit


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(204),
    arrayIncludes = __webpack_require__(298),
    arrayIncludesWith = __webpack_require__(300),
    arrayMap = __webpack_require__(133),
    baseUnary = __webpack_require__(301),
    cacheHas = __webpack_require__(205);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */
function baseIntersection(arrays, iteratee, comparator) {
  var includes = comparator ? arrayIncludesWith : arrayIncludes,
      length = arrays[0].length,
      othLength = arrays.length,
      othIndex = othLength,
      caches = Array(othLength),
      maxLength = Infinity,
      result = [];

  while (othIndex--) {
    var array = arrays[othIndex];
    if (othIndex && iteratee) {
      array = arrayMap(array, baseUnary(iteratee));
    }
    maxLength = nativeMin(array.length, maxLength);
    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
      ? new SetCache(othIndex && array)
      : undefined;
  }
  array = arrays[0];

  var index = -1,
      seen = caches[0];

  outer:
  while (++index < length && result.length < maxLength) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (!(seen
          ? cacheHas(seen, computed)
          : includes(result, computed, comparator)
        )) {
      othIndex = othLength;
      while (--othIndex) {
        var cache = caches[othIndex];
        if (!(cache
              ? cacheHas(cache, computed)
              : includes(arrays[othIndex], computed, comparator))
            ) {
          continue outer;
        }
      }
      if (seen) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseIntersection;


/***/ }),
/* 601 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 602 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(299),
    baseIsNaN = __webpack_require__(604),
    strictIndexOf = __webpack_require__(605);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 604 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 605 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLikeObject = __webpack_require__(303);

/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */
function castArrayLikeObject(value) {
  return isArrayLikeObject(value) ? value : [];
}

module.exports = castArrayLikeObject;


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

var utils = __webpack_require__(608);

/**
 * superagentCache constructor
 * @constructor
 * @param {superagent} agent (optional)
 * @param {cache module} cache (optional)
 * @param {object} defaults (optional)
 */
module.exports = function(agent, cache, defaults){

  var superagent = (agent) ? agent : __webpack_require__(609);

  if(!superagent.patchedBySuperagentCache){
    superagent.cache = (cache && cache.get) ? cache : new (__webpack_require__(612))(cache);
    superagent.defaults = defaults || {};
    superagent.pendingRequests = {};
    var Request = superagent.Request;
    var props = utils.resetProps(superagent.defaults);
    var supportedMethods = ['GET', 'HEAD', 'POST', 'PUT', 'PATCH', 'DELETE'];
    var cacheableMethods = ['GET', 'HEAD'];
    superagent.patchedBySuperagentCache = true;

    /**
     * Whether to execute an http query if the cache does not have the generated key
     * @param {boolean} doQuery
     */
    Request.prototype.doQuery = function(doQuery){
      props.doQuery = doQuery;
      return this;
    }

    /**
     * Remove the given params from the query object after executing an http query and before generating a cache key
     * @param {array of strings} pruneParams
     */
    Request.prototype.pruneParams = function(pruneParams){
      props.pruneParams = pruneParams;
      return this;
    }

    /**
     * Remove the given options from the headers object after executing an http query and before generating a cache key
     * @param {boolean} pruneOptions
     */
    Request.prototype.pruneOptions = function(pruneOptions){
      props.pruneOptions = pruneOptions;
      return this;
    }

    /**
     * Execute some logic on superagent's http response object before caching and returning it
     * @param {function} prune
     */
    Request.prototype.prune = function(prune){
      props.prune = prune;
      return this;
    }

    /**
     * Retrieve a top-level property from superagent's http response object before to cache and return
     * @param {string} responseProp
     */
    Request.prototype.responseProp = function(responseProp){
      props.responseProp = responseProp;
      return this;
    }

    /**
     * Set an expiration for this key that will override the configured cache's default expiration
     * @param {integer} expiration (seconds)
     */
    Request.prototype.expiration = function(expiration){
      props.expiration = expiration;
      return this;
    }

    /**
     * Whether to cache superagent's http response object when it "empty"--especially useful with .prune and .pruneParams
     * @param {boolean} cacheWhenEmpty
     */
    Request.prototype.cacheWhenEmpty = function(cacheWhenEmpty){
      props.cacheWhenEmpty = cacheWhenEmpty;
      return this;
    }

    /**
     * Whether to execute an http query regardless of whether the cache has the generated key
     * @param {boolean} forceUpdate
     */
    Request.prototype.forceUpdate = function(forceUpdate){
      props.forceUpdate = (typeof forceUpdate === 'boolean') ? forceUpdate : true;
      return this;
    }

    /**
     * Whether to execute identical network calls.
     * When used, calls made for resources that are already pending will not be made, but will
     * be responded to with the response from the already pending call.
     * @param {boolean} preventDuplicateCalls
     */
    Request.prototype.preventDuplicateCalls = function(preventDuplicateCalls){
      props.preventDuplicateCalls = (typeof preventDuplicateCalls === 'boolean') ? preventDuplicateCalls : true;
      return this;
    }

    /**
     * Initialize a background refresh for the generated key and value
     * @param {boolean | function} backgroundRefresh
     */
    Request.prototype.backgroundRefresh = function(backgroundRefresh){
      props.backgroundRefresh = (typeof backgroundRefresh !== 'undefined') ? backgroundRefresh : true;
      return this;
    }

    /**
     * Overwrites superagent's fake promise support and adds the generated cache key
     * Only applies if Request.prototype.promise is not set
     * Fixes this isse: https://github.com/jpodwys/superagent-cache/issues/38
     */
    if(!Request.prototype.promise){
      Request.prototype.then = function(fulfill, reject){
        return this.end(function (err, response, key) {
          err ? reject(err) : fulfill(response, key);
        });
      }
    }

    /**
     * An alias for the .end function because I use ._end and .end for other things
     */
    Request.prototype.execute = Request.prototype.end;

    /**
     * Wraps the .end function so that .resetProps gets called--callable so that no caching logic takes place
     */
    Request.prototype._end = function(cb){
      props = utils.resetProps(superagent.defaults);
      this.execute(cb);
    }

    /**
     * Execute all caching and http logic
     * @param {function} cb
     */
    Request.prototype.end = function(cb){
      var curProps = props;
      props = utils.resetProps(superagent.defaults);
      this.scRedirectsList = this.scRedirectsList || [];
      this.scRedirectsList = this.scRedirectsList.concat(this._redirectList);
      if(~supportedMethods.indexOf(this.method.toUpperCase())){
        var _this = this;
        var key = utils.keygen(superagent, this, curProps);
        if(~cacheableMethods.indexOf(this.method.toUpperCase())){
          superagent.cache.get(key, function (err, response){
            if(!err && response && !curProps.forceUpdate){
              utils.callbackExecutor(cb, err, response, key);
            }
            else{
              if(curProps.doQuery){
                if(curProps.preventDuplicateCalls){
                  if(!superagent.pendingRequests[key]){
                    superagent.pendingRequests[key] = [];
                  } else {
                    return superagent.pendingRequests[key].push(cb);
                  }
                }
                _this._end(function (err, response){
                  if(err){
                    utils.handlePendingRequests(curProps, superagent, key, err, response);
                    return utils.callbackExecutor(cb, err, response, key);
                  }
                  else if(!err && response){
                    response.redirects = _this.scRedirectsList;
                    if(curProps.prune){
                      response = curProps.prune(response);
                    }
                    else if(curProps.responseProp){
                      response = response[curProps.responseProp] || null;
                    }
                    else{
                      response = utils.gutResponse(response);
                    }
                    if(!utils.isEmpty(response) || curProps.cacheWhenEmpty){
                      var refresh = curProps.backgroundRefresh || null;
                      if(typeof refresh == 'boolean'){
                        refresh = utils.getBackgroundRefreshFunction(superagent, curProps);
                      }
                      superagent.cache.set(key, response, curProps.expiration, refresh, function (){
                        utils.handlePendingRequests(curProps, superagent, key, err, response);
                        return utils.callbackExecutor(cb, err, response, key);
                      });
                    }
                    else{
                      delete superagent.pendingRequests[key];
                      return utils.callbackExecutor(cb, err, response, key);
                    }
                  }
                });
              }
              else{
                return utils.callbackExecutor(cb, null, null, key);
              }
            }
          });
        }
        else{
          this._end(function (err, response){
            if(err){
              return utils.callbackExecutor(cb, err, response, key);
            }
            if(!err && response){
              var keyGet = key.replace('"method":"' + _this.method + '"', '"method":"GET"');
              var keyHead = key.replace('"method":"' + _this.method + '"', '"method":"HEAD"');
              superagent.cache.del([keyGet, keyHead], function (){
                utils.callbackExecutor(cb, err, response, key);
              });
            }
          });
        }
      }
      else{
        this._end(function (err, response){
          return utils.callbackExecutor(cb, err, response, undefined);
        });
      }
    }
  }

  if(!agent){
    return superagent;
  }

}


/***/ }),
/* 608 */
/***/ (function(module, exports) {

module.exports = {
  /**
   * Generate a cache key unique to this query
   * @param {superagent} agent
   * @param {object} reg
   * @param {object} cProps
   */
  keygen: function(agent, req, cProps){
    var cleanParams = null;
    var cleanOptions = null;
    var params = this.getQueryParams(req);
    var options = this.getHeaderOptions(req);
    if(cProps.pruneParams || cProps.pruneOptions){
      cleanParams = (cProps.pruneParams) ? this.pruneObj(this.cloneObject(params), cProps.pruneParams) : params;
      cleanOptions = (cProps.pruneOptions) ? this.pruneObj(this.cloneObject(options), cProps.pruneOptions, true) : options;
    }
    return JSON.stringify({
      nameSpace: agent.cache.nameSpace,
      method: req.method,
      uri: req.url,
      params: cleanParams || params || null,
      options: cleanOptions || options || null
    });
  },

  /**
   * Find and extract query params
   * @param {object} reg
   */
  getQueryParams: function(req){
    if(req && req.qs && !this.isEmpty(req.qs)){
      return req.qs;
    }
    else if(req && req.qsRaw){
      return this.arrayToObj(req.qsRaw);
    }
    else if(req && req.req){
      return this.stringToObj(req.req.path);
    }
    else if(req && req._query){
      return this.stringToObj(req._query.join('&'));
    }
    return null;
  },

  /**
   * Find and extract headers
   * @param {object} reg
   */
  getHeaderOptions: function(req){
    //I have to remove the User-Agent header ever since superagent 1.7.0
    if(req && req._header){
      return this.pruneObj(req._header, ['User-Agent', 'user-agent']);
    }
    else if(req && req.req && req.req._headers){
      return this.pruneObj(req.req._headers, ['User-Agent', 'user-agent']);
    }
    else if(req && req.header){
      return this.pruneObj(req.header, ['User-Agent', 'user-agent']);
    }
    return null;
  },

  /**
   * Convert an array to an object
   * @param {array} arr
   */
  arrayToObj: function(arr){
    if(arr && arr.length){
      var obj = {};
      for(var i = 0; i < arr.length; i++){
        var str = arr[i];
        var kvArray = str.split('&');
        for(var j = 0; j < kvArray.length; j++){
          var kvString = kvArray[j].split('=');
          obj[kvString[0]] = kvString[1];
        }
      }
      return obj;
    }
    return null;
  },

  /**
   * Convert a string to an object
   * @param {string} str
   */
  stringToObj: function(str){
    if(str){
      var obj = {};
      if(~str.indexOf('?')){
        var strs = str.split('?');
        str = strs[1];
      }
      var kvArray = str.split('&');
      for(var i = 0; i < kvArray.length; i++){
        var kvString = kvArray[i].split('=');
        obj[kvString[0]] = kvString[1];
      }
      return obj;
    }
    return null;
  },

  /**
   * Remove properties from an object
   * @param {object} obj
   * @param {array} props
   * @param {boolean} isOptions
   */
  pruneObj: function(obj, props, isOptions){
    for(var i = 0; i < props.length; i++){
      var prop = props[i];
      if(isOptions){
        delete obj[prop.toLowerCase()];
      }
      delete obj[prop];
    }
    return obj;
  },

  /**
   * Simplify superagent's http response object
   * @param {object} r
   */
  gutResponse: function(r){
    var newResponse = {};
    newResponse.body = r.body;
    newResponse.text = r.text;
    newResponse.headers = r.headers;
    newResponse.statusCode = r.statusCode;
    newResponse.status = r.status;
    newResponse.ok = r.ok;
    return newResponse;
  },

  /**
   * Determine whether a value is considered empty
   * @param {*} val
   */
  isEmpty: function(val){
    return (val === false || val === null || (typeof val == 'object' && Object.keys(val).length == 0));
  },

  /**
   * Return a clone of an object
   * @param {object} obj
   */
  cloneObject: function(obj){
    var newObj = {};
    for(var attr in obj) {
      if (obj.hasOwnProperty(attr)){
        newObj[attr] = obj[attr];
      }
    }
    return newObj;
  },

  handlePendingRequests: function(curProps, superagent, key, err, response){
    if(curProps.preventDuplicateCalls){
      if(superagent.pendingRequests[key] && (!this.isEmpty(response) || curProps.cacheWhenEmpty)){
        var self = this;
        var pendingRequests = superagent.pendingRequests[key];
        pendingRequests.forEach(function (cb){
          self.callbackExecutor(cb, err, response, key);
        });
      }
      delete superagent.pendingRequests[key];
    }
  },

  /**
   * Reset superagent-cache's default query properties using the defaults object
   * @param {object} d
   */
  resetProps: function(d){
    return {
      doQuery: (typeof d.doQuery === 'boolean') ? d.doQuery : true,
      cacheWhenEmpty: (typeof d.cacheWhenEmpty === 'boolean') ? d.cacheWhenEmpty : true,
      prune: d.prune,
      pruneParams: d.pruneParams,
      pruneOptions: d.pruneOptions,
      responseProp: d.responseProp,
      expiration: d.expiration,
      forceUpdate: d.forceUpdate,
      preventDuplicateCalls: d.preventDuplicateCalls,
      backgroundRefresh: d.backgroundRefresh
    };
  },

  /**
   * Generate a background refresh query identical to the current query
   * @param {superagent} agent
   * @param {object} curProps
   */
  getBackgroundRefreshFunction: function(agent, curProps){
    return function(key, cb){
      key = JSON.parse(key);
      var method = key.method.toLowerCase();
      var request = agent[method](key.uri)
        .doQuery(curProps.doQuery)
        .pruneParams(curProps.pruneParams)
        .pruneOptions(curProps.pruneOptions)
        .prune(curProps.prune)
        .responseProp(curProps.responseProp)
        .expiration(curProps.expiration)
        .cacheWhenEmpty(curProps.cacheWhenEmpty);
      if(key.params){
        request.query(key.params)
      }
      if(key.options){
        request.set(key.options);
      }
      request.end(cb);
    }
  },

  /**
   * Handle the varying number of callback output params
   * @param {function} cb
   * @param {object} err
   * @param {object} response
   * @param {string} key
   */
  callbackExecutor: function(cb, err, response, key){
    if(cb.length === 1){
      cb(response);
    }
    else if(cb.length > 1){
      cb(err, response, key);
    }
    else{
      throw new Error('UnsupportedCallbackException: Your .end() callback must pass at least one argument.');
    }
  }
}


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

var Emitter = __webpack_require__(610);
var reduce = __webpack_require__(611);

/**
 * Root reference for iframes.
 */

var root;
if (typeof window !== 'undefined') { // Browser window
  root = window;
} else if (typeof self !== 'undefined') { // Web Worker
  root = self;
} else { // Other environments
  root = this;
}

/**
 * Noop.
 */

function noop(){};

/**
 * Check if `obj` is a host object,
 * we don't want to serialize these :)
 *
 * TODO: future proof, move to compoent land
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */

function isHost(obj) {
  var str = {}.toString.call(obj);

  switch (str) {
    case '[object File]':
    case '[object Blob]':
    case '[object FormData]':
      return true;
    default:
      return false;
  }
}

/**
 * Determine XHR.
 */

request.getXHR = function () {
  if (root.XMLHttpRequest
      && (!root.location || 'file:' != root.location.protocol
          || !root.ActiveXObject)) {
    return new XMLHttpRequest;
  } else {
    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
  }
  return false;
};

/**
 * Removes leading and trailing whitespace, added to support IE.
 *
 * @param {String} s
 * @return {String}
 * @api private
 */

var trim = ''.trim
  ? function(s) { return s.trim(); }
  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };

/**
 * Check if `obj` is an object.
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */

function isObject(obj) {
  return obj === Object(obj);
}

/**
 * Serialize the given `obj`.
 *
 * @param {Object} obj
 * @return {String}
 * @api private
 */

function serialize(obj) {
  if (!isObject(obj)) return obj;
  var pairs = [];
  for (var key in obj) {
    if (null != obj[key]) {
      pushEncodedKeyValuePair(pairs, key, obj[key]);
        }
      }
  return pairs.join('&');
}

/**
 * Helps 'serialize' with serializing arrays.
 * Mutates the pairs array.
 *
 * @param {Array} pairs
 * @param {String} key
 * @param {Mixed} val
 */

function pushEncodedKeyValuePair(pairs, key, val) {
  if (Array.isArray(val)) {
    return val.forEach(function(v) {
      pushEncodedKeyValuePair(pairs, key, v);
    });
  }
  pairs.push(encodeURIComponent(key)
    + '=' + encodeURIComponent(val));
}

/**
 * Expose serialization method.
 */

 request.serializeObject = serialize;

 /**
  * Parse the given x-www-form-urlencoded `str`.
  *
  * @param {String} str
  * @return {Object}
  * @api private
  */

function parseString(str) {
  var obj = {};
  var pairs = str.split('&');
  var parts;
  var pair;

  for (var i = 0, len = pairs.length; i < len; ++i) {
    pair = pairs[i];
    parts = pair.split('=');
    obj[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
  }

  return obj;
}

/**
 * Expose parser.
 */

request.parseString = parseString;

/**
 * Default MIME type map.
 *
 *     superagent.types.xml = 'application/xml';
 *
 */

request.types = {
  html: 'text/html',
  json: 'application/json',
  xml: 'application/xml',
  urlencoded: 'application/x-www-form-urlencoded',
  'form': 'application/x-www-form-urlencoded',
  'form-data': 'application/x-www-form-urlencoded'
};

/**
 * Default serialization map.
 *
 *     superagent.serialize['application/xml'] = function(obj){
 *       return 'generated xml here';
 *     };
 *
 */

 request.serialize = {
   'application/x-www-form-urlencoded': serialize,
   'application/json': JSON.stringify
 };

 /**
  * Default parsers.
  *
  *     superagent.parse['application/xml'] = function(str){
  *       return { object parsed from str };
  *     };
  *
  */

request.parse = {
  'application/x-www-form-urlencoded': parseString,
  'application/json': JSON.parse
};

/**
 * Parse the given header `str` into
 * an object containing the mapped fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

function parseHeader(str) {
  var lines = str.split(/\r?\n/);
  var fields = {};
  var index;
  var line;
  var field;
  var val;

  lines.pop(); // trailing CRLF

  for (var i = 0, len = lines.length; i < len; ++i) {
    line = lines[i];
    index = line.indexOf(':');
    field = line.slice(0, index).toLowerCase();
    val = trim(line.slice(index + 1));
    fields[field] = val;
  }

  return fields;
}

/**
 * Check if `mime` is json or has +json structured syntax suffix.
 *
 * @param {String} mime
 * @return {Boolean}
 * @api private
 */

function isJSON(mime) {
  return /[\/+]json\b/.test(mime);
}

/**
 * Return the mime type for the given `str`.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

function type(str){
  return str.split(/ *; */).shift();
};

/**
 * Return header field parameters.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

function params(str){
  return reduce(str.split(/ *; */), function(obj, str){
    var parts = str.split(/ *= */)
      , key = parts.shift()
      , val = parts.shift();

    if (key && val) obj[key] = val;
    return obj;
  }, {});
};

/**
 * Initialize a new `Response` with the given `xhr`.
 *
 *  - set flags (.ok, .error, etc)
 *  - parse header
 *
 * Examples:
 *
 *  Aliasing `superagent` as `request` is nice:
 *
 *      request = superagent;
 *
 *  We can use the promise-like API, or pass callbacks:
 *
 *      request.get('/').end(function(res){});
 *      request.get('/', function(res){});
 *
 *  Sending data can be chained:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' })
 *        .end(function(res){});
 *
 *  Or passed to `.send()`:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' }, function(res){});
 *
 *  Or passed to `.post()`:
 *
 *      request
 *        .post('/user', { name: 'tj' })
 *        .end(function(res){});
 *
 * Or further reduced to a single call for simple cases:
 *
 *      request
 *        .post('/user', { name: 'tj' }, function(res){});
 *
 * @param {XMLHTTPRequest} xhr
 * @param {Object} options
 * @api private
 */

function Response(req, options) {
  options = options || {};
  this.req = req;
  this.xhr = this.req.xhr;
  // responseText is accessible only if responseType is '' or 'text' and on older browsers
  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
     ? this.xhr.responseText
     : null;
  this.statusText = this.req.xhr.statusText;
  this.setStatusProperties(this.xhr.status);
  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
  // getResponseHeader still works. so we get content-type even if getting
  // other headers fails.
  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
  this.setHeaderProperties(this.header);
  this.body = this.req.method != 'HEAD'
    ? this.parseBody(this.text ? this.text : this.xhr.response)
    : null;
}

/**
 * Get case-insensitive `field` value.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

Response.prototype.get = function(field){
  return this.header[field.toLowerCase()];
};

/**
 * Set header related properties:
 *
 *   - `.type` the content type without params
 *
 * A response of "Content-Type: text/plain; charset=utf-8"
 * will provide you with a `.type` of "text/plain".
 *
 * @param {Object} header
 * @api private
 */

Response.prototype.setHeaderProperties = function(header){
  // content-type
  var ct = this.header['content-type'] || '';
  this.type = type(ct);

  // params
  var obj = params(ct);
  for (var key in obj) this[key] = obj[key];
};

/**
 * Parse the given body `str`.
 *
 * Used for auto-parsing of bodies. Parsers
 * are defined on the `superagent.parse` object.
 *
 * @param {String} str
 * @return {Mixed}
 * @api private
 */

Response.prototype.parseBody = function(str){
  var parse = request.parse[this.type];
  return parse && str && (str.length || str instanceof Object)
    ? parse(str)
    : null;
};

/**
 * Set flags such as `.ok` based on `status`.
 *
 * For example a 2xx response will give you a `.ok` of __true__
 * whereas 5xx will be __false__ and `.error` will be __true__. The
 * `.clientError` and `.serverError` are also available to be more
 * specific, and `.statusType` is the class of error ranging from 1..5
 * sometimes useful for mapping respond colors etc.
 *
 * "sugar" properties are also defined for common cases. Currently providing:
 *
 *   - .noContent
 *   - .badRequest
 *   - .unauthorized
 *   - .notAcceptable
 *   - .notFound
 *
 * @param {Number} status
 * @api private
 */

Response.prototype.setStatusProperties = function(status){
  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
  if (status === 1223) {
    status = 204;
  }

  var type = status / 100 | 0;

  // status / class
  this.status = this.statusCode = status;
  this.statusType = type;

  // basics
  this.info = 1 == type;
  this.ok = 2 == type;
  this.clientError = 4 == type;
  this.serverError = 5 == type;
  this.error = (4 == type || 5 == type)
    ? this.toError()
    : false;

  // sugar
  this.accepted = 202 == status;
  this.noContent = 204 == status;
  this.badRequest = 400 == status;
  this.unauthorized = 401 == status;
  this.notAcceptable = 406 == status;
  this.notFound = 404 == status;
  this.forbidden = 403 == status;
};

/**
 * Return an `Error` representative of this response.
 *
 * @return {Error}
 * @api public
 */

Response.prototype.toError = function(){
  var req = this.req;
  var method = req.method;
  var url = req.url;

  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
  var err = new Error(msg);
  err.status = this.status;
  err.method = method;
  err.url = url;

  return err;
};

/**
 * Expose `Response`.
 */

request.Response = Response;

/**
 * Initialize a new `Request` with the given `method` and `url`.
 *
 * @param {String} method
 * @param {String} url
 * @api public
 */

function Request(method, url) {
  var self = this;
  Emitter.call(this);
  this._query = this._query || [];
  this.method = method;
  this.url = url;
  this.header = {};
  this._header = {};
  this.on('end', function(){
    var err = null;
    var res = null;

    try {
      res = new Response(self);
    } catch(e) {
      err = new Error('Parser is unable to parse the response');
      err.parse = true;
      err.original = e;
      // issue #675: return the raw response if the response parsing fails
      err.rawResponse = self.xhr && self.xhr.responseText ? self.xhr.responseText : null;
      return self.callback(err);
    }

    self.emit('response', res);

    if (err) {
      return self.callback(err, res);
    }

    if (res.status >= 200 && res.status < 300) {
      return self.callback(err, res);
    }

    var new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
    new_err.original = err;
    new_err.response = res;
    new_err.status = res.status;

    self.callback(new_err, res);
  });
}

/**
 * Mixin `Emitter`.
 */

Emitter(Request.prototype);

/**
 * Allow for extension
 */

Request.prototype.use = function(fn) {
  fn(this);
  return this;
}

/**
 * Set timeout to `ms`.
 *
 * @param {Number} ms
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.timeout = function(ms){
  this._timeout = ms;
  return this;
};

/**
 * Clear previous timeout.
 *
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.clearTimeout = function(){
  this._timeout = 0;
  clearTimeout(this._timer);
  return this;
};

/**
 * Abort the request, and clear potential timeout.
 *
 * @return {Request}
 * @api public
 */

Request.prototype.abort = function(){
  if (this.aborted) return;
  this.aborted = true;
  this.xhr.abort();
  this.clearTimeout();
  this.emit('abort');
  return this;
};

/**
 * Set header `field` to `val`, or multiple fields with one object.
 *
 * Examples:
 *
 *      req.get('/')
 *        .set('Accept', 'application/json')
 *        .set('X-API-Key', 'foobar')
 *        .end(callback);
 *
 *      req.get('/')
 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
 *        .end(callback);
 *
 * @param {String|Object} field
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.set = function(field, val){
  if (isObject(field)) {
    for (var key in field) {
      this.set(key, field[key]);
    }
    return this;
  }
  this._header[field.toLowerCase()] = val;
  this.header[field] = val;
  return this;
};

/**
 * Remove header `field`.
 *
 * Example:
 *
 *      req.get('/')
 *        .unset('User-Agent')
 *        .end(callback);
 *
 * @param {String} field
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.unset = function(field){
  delete this._header[field.toLowerCase()];
  delete this.header[field];
  return this;
};

/**
 * Get case-insensitive header `field` value.
 *
 * @param {String} field
 * @return {String}
 * @api private
 */

Request.prototype.getHeader = function(field){
  return this._header[field.toLowerCase()];
};

/**
 * Set Content-Type to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.xml = 'application/xml';
 *
 *      request.post('/')
 *        .type('xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 *      request.post('/')
 *        .type('application/xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 * @param {String} type
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.type = function(type){
  this.set('Content-Type', request.types[type] || type);
  return this;
};

/**
 * Force given parser
 *
 * Sets the body parser no matter type.
 *
 * @param {Function}
 * @api public
 */

Request.prototype.parse = function(fn){
  this._parser = fn;
  return this;
};

/**
 * Set Accept to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.json = 'application/json';
 *
 *      request.get('/agent')
 *        .accept('json')
 *        .end(callback);
 *
 *      request.get('/agent')
 *        .accept('application/json')
 *        .end(callback);
 *
 * @param {String} accept
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.accept = function(type){
  this.set('Accept', request.types[type] || type);
  return this;
};

/**
 * Set Authorization field value with `user` and `pass`.
 *
 * @param {String} user
 * @param {String} pass
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.auth = function(user, pass){
  var str = btoa(user + ':' + pass);
  this.set('Authorization', 'Basic ' + str);
  return this;
};

/**
* Add query-string `val`.
*
* Examples:
*
*   request.get('/shoes')
*     .query('size=10')
*     .query({ color: 'blue' })
*
* @param {Object|String} val
* @return {Request} for chaining
* @api public
*/

Request.prototype.query = function(val){
  if ('string' != typeof val) val = serialize(val);
  if (val) this._query.push(val);
  return this;
};

/**
 * Write the field `name` and `val` for "multipart/form-data"
 * request bodies.
 *
 * ``` js
 * request.post('/upload')
 *   .field('foo', 'bar')
 *   .end(callback);
 * ```
 *
 * @param {String} name
 * @param {String|Blob|File} val
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.field = function(name, val){
  if (!this._formData) this._formData = new root.FormData();
  this._formData.append(name, val);
  return this;
};

/**
 * Queue the given `file` as an attachment to the specified `field`,
 * with optional `filename`.
 *
 * ``` js
 * request.post('/upload')
 *   .attach(new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
 *   .end(callback);
 * ```
 *
 * @param {String} field
 * @param {Blob|File} file
 * @param {String} filename
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.attach = function(field, file, filename){
  if (!this._formData) this._formData = new root.FormData();
  this._formData.append(field, file, filename || file.name);
  return this;
};

/**
 * Send `data` as the request body, defaulting the `.type()` to "json" when
 * an object is given.
 *
 * Examples:
 *
 *       // manual json
 *       request.post('/user')
 *         .type('json')
 *         .send('{"name":"tj"}')
 *         .end(callback)
 *
 *       // auto json
 *       request.post('/user')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // manual x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send('name=tj')
 *         .end(callback)
 *
 *       // auto x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // defaults to x-www-form-urlencoded
  *      request.post('/user')
  *        .send('name=tobi')
  *        .send('species=ferret')
  *        .end(callback)
 *
 * @param {String|Object} data
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.send = function(data){
  var obj = isObject(data);
  var type = this.getHeader('Content-Type');

  // merge
  if (obj && isObject(this._data)) {
    for (var key in data) {
      this._data[key] = data[key];
    }
  } else if ('string' == typeof data) {
    if (!type) this.type('form');
    type = this.getHeader('Content-Type');
    if ('application/x-www-form-urlencoded' == type) {
      this._data = this._data
        ? this._data + '&' + data
        : data;
    } else {
      this._data = (this._data || '') + data;
    }
  } else {
    this._data = data;
  }

  if (!obj || isHost(data)) return this;
  if (!type) this.type('json');
  return this;
};

/**
 * Invoke the callback with `err` and `res`
 * and handle arity check.
 *
 * @param {Error} err
 * @param {Response} res
 * @api private
 */

Request.prototype.callback = function(err, res){
  var fn = this._callback;
  this.clearTimeout();
  fn(err, res);
};

/**
 * Invoke callback with x-domain error.
 *
 * @api private
 */

Request.prototype.crossDomainError = function(){
  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
  err.crossDomain = true;

  err.status = this.status;
  err.method = this.method;
  err.url = this.url;

  this.callback(err);
};

/**
 * Invoke callback with timeout error.
 *
 * @api private
 */

Request.prototype.timeoutError = function(){
  var timeout = this._timeout;
  var err = new Error('timeout of ' + timeout + 'ms exceeded');
  err.timeout = timeout;
  this.callback(err);
};

/**
 * Enable transmission of cookies with x-domain requests.
 *
 * Note that for this to work the origin must not be
 * using "Access-Control-Allow-Origin" with a wildcard,
 * and also must set "Access-Control-Allow-Credentials"
 * to "true".
 *
 * @api public
 */

Request.prototype.withCredentials = function(){
  this._withCredentials = true;
  return this;
};

/**
 * Initiate request, invoking callback `fn(res)`
 * with an instanceof `Response`.
 *
 * @param {Function} fn
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.end = function(fn){
  var self = this;
  var xhr = this.xhr = request.getXHR();
  var query = this._query.join('&');
  var timeout = this._timeout;
  var data = this._formData || this._data;

  // store callback
  this._callback = fn || noop;

  // state change
  xhr.onreadystatechange = function(){
    if (4 != xhr.readyState) return;

    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
    // result in the error "Could not complete the operation due to error c00c023f"
    var status;
    try { status = xhr.status } catch(e) { status = 0; }

    if (0 == status) {
      if (self.timedout) return self.timeoutError();
      if (self.aborted) return;
      return self.crossDomainError();
    }
    self.emit('end');
  };

  // progress
  var handleProgress = function(e){
    if (e.total > 0) {
      e.percent = e.loaded / e.total * 100;
    }
    e.direction = 'download';
    self.emit('progress', e);
  };
  if (this.hasListeners('progress')) {
    xhr.onprogress = handleProgress;
  }
  try {
    if (xhr.upload && this.hasListeners('progress')) {
      xhr.upload.onprogress = handleProgress;
    }
  } catch(e) {
    // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
    // Reported here:
    // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
  }

  // timeout
  if (timeout && !this._timer) {
    this._timer = setTimeout(function(){
      self.timedout = true;
      self.abort();
    }, timeout);
  }

  // querystring
  if (query) {
    query = request.serializeObject(query);
    this.url += ~this.url.indexOf('?')
      ? '&' + query
      : '?' + query;
  }

  // initiate request
  xhr.open(this.method, this.url, true);

  // CORS
  if (this._withCredentials) xhr.withCredentials = true;

  // body
  if ('GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !isHost(data)) {
    // serialize stuff
    var contentType = this.getHeader('Content-Type');
    var serialize = this._parser || request.serialize[contentType ? contentType.split(';')[0] : ''];
    if (!serialize && isJSON(contentType)) serialize = request.serialize['application/json'];
    if (serialize) data = serialize(data);
  }

  // set header fields
  for (var field in this.header) {
    if (null == this.header[field]) continue;
    xhr.setRequestHeader(field, this.header[field]);
  }

  // send stuff
  this.emit('request', this);

  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
  // We need null here if data is undefined
  xhr.send(typeof data !== 'undefined' ? data : null);
  return this;
};

/**
 * Faux promise support
 *
 * @param {Function} fulfill
 * @param {Function} reject
 * @return {Request}
 */

Request.prototype.then = function (fulfill, reject) {
  return this.end(function(err, res) {
    err ? reject(err) : fulfill(res);
  });
}

/**
 * Expose `Request`.
 */

request.Request = Request;

/**
 * Issue a request:
 *
 * Examples:
 *
 *    request('GET', '/users').end(callback)
 *    request('/users').end(callback)
 *    request('/users', callback)
 *
 * @param {String} method
 * @param {String|Function} url or callback
 * @return {Request}
 * @api public
 */

function request(method, url) {
  // callback
  if ('function' == typeof url) {
    return new Request('GET', method).end(url);
  }

  // url first
  if (1 == arguments.length) {
    return new Request('GET', method);
  }

  return new Request(method, url);
}

/**
 * GET `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} data or fn
 * @param {Function} fn
 * @return {Request}
 * @api public
 */

request.get = function(url, data, fn){
  var req = request('GET', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * HEAD `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} data or fn
 * @param {Function} fn
 * @return {Request}
 * @api public
 */

request.head = function(url, data, fn){
  var req = request('HEAD', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * DELETE `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Function} fn
 * @return {Request}
 * @api public
 */

function del(url, fn){
  var req = request('DELETE', url);
  if (fn) req.end(fn);
  return req;
};

request['del'] = del;
request['delete'] = del;

/**
 * PATCH `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} data
 * @param {Function} fn
 * @return {Request}
 * @api public
 */

request.patch = function(url, data, fn){
  var req = request('PATCH', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * POST `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} data
 * @param {Function} fn
 * @return {Request}
 * @api public
 */

request.post = function(url, data, fn){
  var req = request('POST', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * PUT `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} data or fn
 * @param {Function} fn
 * @return {Request}
 * @api public
 */

request.put = function(url, data, fn){
  var req = request('PUT', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * Expose `request`.
 */

module.exports = request;


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Expose `Emitter`.
 */

if (true) {
  module.exports = Emitter;
}

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }
  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};
  var args = [].slice.call(arguments, 1)
    , callbacks = this._callbacks['$' + event];

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};


/***/ }),
/* 611 */
/***/ (function(module, exports) {


/**
 * Reduce `arr` with `fn`.
 *
 * @param {Array} arr
 * @param {Function} fn
 * @param {Mixed} initial
 *
 * TODO: combatible error handling?
 */

module.exports = function(arr, fn, initial){  
  var idx = 0;
  var len = arr.length;
  var curr = arguments.length == 3
    ? initial
    : arr[idx++];

  while (idx < len) {
    curr = fn.call(null, curr, arr[idx], ++idx, arr);
  }
  
  return curr;
};

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(console) {/**
 * cacheModule constructor
 * @param config: {
 *    type:                           {string  | 'cache-module'}
 *    verbose:                        {boolean | false},
 *    defaultExpiration:              {integer | 900},
 *    readOnly:                       {boolean | false},
 *    checkOnPreviousEmpty:           {boolean | true},
 *    backgroundRefreshIntervalCheck: {boolean | true},
 *    backgroundRefreshInterval:      {integer | 60000},
 *    backgroundRefreshMinTtl:        {integer | 70000},
 *    storage:                        {string  | null},
 *    storageMock:                    {object  | null}
 * }
 */
function cacheModule(config){
  var self = this;
  config = config || {};
  self.type = config.type || 'cache-module';
  self.verbose = config.verbose || false;
  self.defaultExpiration = config.defaultExpiration || 900;
  self.readOnly = config.readOnly || false;
  self.checkOnPreviousEmpty = (typeof config.checkOnPreviousEmpty === 'boolean') ? config.checkOnPreviousEmpty : true;
  self.backgroundRefreshIntervalCheck = (typeof config.backgroundRefreshIntervalCheck === 'boolean') ? config.backgroundRefreshIntervalCheck : true;
  self.backgroundRefreshInterval = config.backgroundRefreshInterval || 60000;
  self.backgroundRefreshMinTtl = config.backgroundRefreshMinTtl || 70000;
  var store = null;
  var storageMock = config.storageMock || false;
  var backgroundRefreshEnabled = false;
  var browser = (typeof window !== 'undefined');
  var cache = {
    db: {},
    expirations: {},
    refreshKeys: {}
  };
  var storageKey;

  setupBrowserStorage();
  log(false, 'Cache-module client created with the following defaults:', {type: self.type, defaultExpiration: self.defaultExpiration, verbose: self.verbose, readOnly: self.readOnly});

  /**
   * Get the value associated with a given key
   * @param {string} key
   * @param {function} cb
   */
  self.get = function(key, cb){
    throwErrorIf((arguments.length < 2), 'ARGUMENT_EXCEPTION: .get() requires 2 arguments.');
    log(false, 'get() called:', {key: key});
    try {
      var now = Date.now();
      var expiration = cache.expirations[key];
      if(expiration > now){
        cb(null, cache.db[key]);
      }
      else{
        expire(key);
        cb(null, null);
      }
    } catch (err) {
      cb({name: 'GetException', message: err}, null);
    }
  }

  /**
   * Get multiple values given multiple keys
   * @param {array} keys
   * @param {function} cb
   * @param {integer} index
   */
  self.mget = function(keys, cb, index){
    throwErrorIf((arguments.length < 2), 'ARGUMENT_EXCEPTION: .mget() requires 2 arguments.');
    log(false, '.mget() called:', {keys: keys});
    var values = {};
    for(var i = 0; i < keys.length; i++){
      var key = keys[i];
      self.get(key, function(err, response){
        if(response !== null){
          values[key] = response;
        }
      });
    }
    cb(null, values, index);
  }

  /**
   * Associate a key and value and optionally set an expiration
   * @param {string} key
   * @param {string | object} value
   * @param {integer} expiration
   * @param {function} refresh
   * @param {function} cb
   */
  self.set = function(){
    throwErrorIf((arguments.length < 2), 'ARGUMENT_EXCEPTION: .set() requires at least 2 arguments.');
    var key = arguments[0];
    var value = arguments[1];
    var expiration = arguments[2] || null;
    var refresh = (arguments.length == 5) ? arguments[3] : null;
    var cb = (arguments.length == 5) ? arguments[4] : arguments[3];
    log(false, '.set() called:', {key: key, value: value});
    if(!self.readOnly){
      try {
        expiration = (expiration) ? (expiration * 1000) : (self.defaultExpiration * 1000);
        var exp = expiration + Date.now();
        cache.expirations[key] = exp;
        cache.db[key] = value;
        if(cb) cb();
        if(refresh){
          cache.refreshKeys[key] = {expiration: exp, lifeSpan: expiration, refresh: refresh};
          backgroundRefreshInit();
        }
        overwriteBrowserStorage();
      } catch (err) {
        log(true, '.set() failed for cache of type ' + self.type, {name: 'CacheModuleSetException', message: err});
      }
    }
  }

  /**
   * Associate multiple keys with multiple values and optionally set expirations per function and/or key
   * @param {object} obj
   * @param {integer} expiration
   * @param {function} cb
   */
  self.mset = function(obj, expiration, cb){
    throwErrorIf((arguments.length < 1), 'ARGUMENT_EXCEPTION: .mset() requires at least 1 argument.');
    log(false, '.mset() called:', {data: obj});
    for(var key in obj){
      if(obj.hasOwnProperty(key)){
        var tempExpiration = expiration || self.defaultExpiration;
        var value = obj[key];
        if(typeof value === 'object' && value.cacheValue){
          tempExpiration = value.expiration || tempExpiration;
          value = value.cacheValue;
        }
        self.set(key, value, tempExpiration);
      }
    }
    if(cb) cb();
  }

  /**
   * Delete the provided keys and their associated values
   * @param {array} keys
   * @param {function} cb
   */
  self.del = function(keys, cb){
    throwErrorIf((arguments.length < 1), 'ARGUMENT_EXCEPTION: .del() requires at least 1 argument.');
    log(false, '.del() called:', {keys: keys});
    if(typeof keys === 'object'){
      for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        delete cache.db[key];
        delete cache.expirations[key];
        delete cache.refreshKeys[key];
      }
      if(cb) cb(null, keys.length);
    }
    else{
      delete cache.db[keys];
      delete cache.expirations[keys];
      delete cache.refreshKeys[keys];
      if(cb) cb(null, 1); 
    }
    overwriteBrowserStorage();
  }

  /**
   * Flush all keys and values
   * @param {function} cb
   */
  self.flush = function(cb){
    log(false, '.flush() called');
    cache.db = {};
    cache.expirations = {};
    cache.refreshKeys = {};
    if(cb) cb();
    overwriteBrowserStorage();
  }

  /**
   * Enable browser storage if desired and available
   */
  function setupBrowserStorage(){
    if(browser || storageMock){
      if(storageMock){
        store = storageMock;
        storageKey = 'cache-module-storage-mock';
      }
      else{
        var storageType = (config.storage === 'local' || config.storage === 'session') ? config.storage : null;
        store = (storageType && typeof Storage !== void(0)) ? window[storageType + 'Storage'] : false;
        storageKey = (storageType) ? 'cache-module-' + storageType + '-storage' : null;
      }
      if(store){
        var db = store.getItem(storageKey);
        try {
          cache = JSON.parse(db) || cache;
        } catch (err) { /* Do nothing */ }
      }
      else{
        log(true, 'Browser storage is not supported by this browser. Defaulting to an in-memory cache.');
      }
    }
  }

  /**
   * Overwrite namespaced browser storage with current cache
   */
  function overwriteBrowserStorage(){
    if((browser && store) || storageMock){
      var db = cache;
      try {
        db = JSON.stringify(db);
      } catch (err) { /* Do nothing */ }
      store.setItem(storageKey, db);
    }
  }

  /**
   * Throw a given error if error is true
   * @param {boolean} error
   * @param {string} message
   */
  function throwErrorIf(error, message){
    if(error) throw new Error(message);
  }

  /**
   * Delete a given key from cache.db and cache.expirations but not from cache.refreshKeys
   * @param {string} key
   */
  function expire(key){
    delete cache.db[key];
    delete cache.expirations[key];
    overwriteBrowserStorage();
  }

  /**
   * Initialize background refresh
   */
  function backgroundRefreshInit(){
    if(!backgroundRefreshEnabled){
      backgroundRefreshEnabled = true;
      if(self.backgroundRefreshIntervalCheck){
        if(self.backgroundRefreshInterval > self.backgroundRefreshMinTtl){
          throw new Error('BACKGROUND_REFRESH_INTERVAL_EXCEPTION: backgroundRefreshInterval cannot be greater than backgroundRefreshMinTtl.');
        }
      }
      setInterval(backgroundRefresh, self.backgroundRefreshInterval);
    }
  }

  /**
   * Handle the refresh callback from the consumer, save the data to redis.
   *
   * @param {string} key The key used to save.
   * @param {Object} data refresh keys data.
   * @param {Error|null} err consumer callback failure.
   * @param {*} response The consumer response.
   */
  function handleRefreshResponse (key, data, err, response) {
    if(!err) {
      this.set(key, response, (data.lifeSpan / 1000), data.refresh, function(){});
    }
  }

  /**
   * Refreshes all keys that were set with a refresh function
   */
  function backgroundRefresh() {
    var keys = Object.keys(cache.refreshKeys);
    keys.forEach(function(key) {
      var data = cache.refreshKeys[key];
      if(data.expiration - Date.now() < this.backgroundRefreshMinTtl){
        data.refresh(key, handleRefreshResponse.bind(this, key, data));
      }
    }, self);
  }

  /**
   * Error logging logic
   * @param {boolean} isError
   * @param {string} message
   * @param {object} data
   */
  function log(isError, message, data){
    if(self.verbose || isError){
      if(data) console.log(self.type + ': ' + message, data);
      else console.log(self.type + message);
    }
  }
}

module.exports = cacheModule;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(console) {/**
 * cacheModule constructor
 * @param config: {
 *    type:                           {string  | 'cache-module'}
 *    verbose:                        {boolean | false},
 *    defaultExpiration:              {integer | 900},
 *    readOnly:                       {boolean | false},
 *    checkOnPreviousEmpty:           {boolean | true},
 *    backgroundRefreshIntervalCheck: {boolean | true},
 *    backgroundRefreshInterval:      {integer | 60000},
 *    backgroundRefreshMinTtl:        {integer | 70000},
 *    storage:                        {string  | null},
 *    storageMock:                    {object  | null}
 * }
 */
function cacheModule(config){
  var self = this;
  config = config || {};
  self.type = config.type || 'cache-module';
  self.verbose = config.verbose || false;
  self.defaultExpiration = config.defaultExpiration || 900;
  self.readOnly = config.readOnly || false;
  self.checkOnPreviousEmpty = (typeof config.checkOnPreviousEmpty === 'boolean') ? config.checkOnPreviousEmpty : true;
  self.backgroundRefreshIntervalCheck = (typeof config.backgroundRefreshIntervalCheck === 'boolean') ? config.backgroundRefreshIntervalCheck : true;
  self.backgroundRefreshInterval = config.backgroundRefreshInterval || 60000;
  self.backgroundRefreshMinTtl = config.backgroundRefreshMinTtl || 70000;
  var store = null;
  var storageMock = config.storageMock || false;
  var backgroundRefreshEnabled = false;
  var browser = (typeof window !== 'undefined');
  var cache = {
    db: {},
    expirations: {},
    refreshKeys: {}
  };
  var storageKey;

  setupBrowserStorage();
  log(false, 'Cache-module client created with the following defaults:', {type: self.type, defaultExpiration: self.defaultExpiration, verbose: self.verbose, readOnly: self.readOnly});

  /**
   * Get the value associated with a given key
   * @param {string} key
   * @param {function} cb
   */
  self.get = function(key, cb){
    throwErrorIf((arguments.length < 2), 'ARGUMENT_EXCEPTION: .get() requires 2 arguments.');
    log(false, 'get() called:', {key: key});
    try {
      var now = Date.now();
      var expiration = cache.expirations[key];
      if(expiration > now){
        cb(null, cache.db[key]);
      }
      else{
        expire(key);
        cb(null, null);
      }
    } catch (err) {
      cb({name: 'GetException', message: err}, null);
    }
  }

  /**
   * Get multiple values given multiple keys
   * @param {array} keys
   * @param {function} cb
   * @param {integer} index
   */
  self.mget = function(keys, cb, index){
    throwErrorIf((arguments.length < 2), 'ARGUMENT_EXCEPTION: .mget() requires 2 arguments.');
    log(false, '.mget() called:', {keys: keys});
    var values = {};
    for(var i = 0; i < keys.length; i++){
      var key = keys[i];
      self.get(key, function(err, response){
        if(response !== null){
          values[key] = response;
        }
      });
    }
    cb(null, values, index);
  }

  /**
   * Associate a key and value and optionally set an expiration
   * @param {string} key
   * @param {string | object} value
   * @param {integer} expiration
   * @param {function} refresh
   * @param {function} cb
   */
  self.set = function(){
    throwErrorIf((arguments.length < 2), 'ARGUMENT_EXCEPTION: .set() requires at least 2 arguments.');
    var key = arguments[0];
    var value = arguments[1];
    var expiration = arguments[2] || null;
    var refresh = (arguments.length == 5) ? arguments[3] : null;
    var cb = (arguments.length == 5) ? arguments[4] : arguments[3];
    log(false, '.set() called:', {key: key, value: value});
    if(!self.readOnly){
      try {
        expiration = (expiration) ? (expiration * 1000) : (self.defaultExpiration * 1000);
        var exp = expiration + Date.now();
        cache.expirations[key] = exp;
        cache.db[key] = value;
        if(cb) cb();
        if(refresh){
          cache.refreshKeys[key] = {expiration: exp, lifeSpan: expiration, refresh: refresh};
          backgroundRefreshInit();
        }
        overwriteBrowserStorage();
      } catch (err) {
        log(true, '.set() failed for cache of type ' + self.type, {name: 'CacheModuleSetException', message: err});
      }
    }
  }

  /**
   * Associate multiple keys with multiple values and optionally set expirations per function and/or key
   * @param {object} obj
   * @param {integer} expiration
   * @param {function} cb
   */
  self.mset = function(obj, expiration, cb){
    throwErrorIf((arguments.length < 1), 'ARGUMENT_EXCEPTION: .mset() requires at least 1 argument.');
    log(false, '.mset() called:', {data: obj});
    for(var key in obj){
      if(obj.hasOwnProperty(key)){
        var tempExpiration = expiration || self.defaultExpiration;
        var value = obj[key];
        if(typeof value === 'object' && value.cacheValue){
          tempExpiration = value.expiration || tempExpiration;
          value = value.cacheValue;
        }
        self.set(key, value, tempExpiration);
      }
    }
    if(cb) cb();
  }

  /**
   * Delete the provided keys and their associated values
   * @param {array} keys
   * @param {function} cb
   */
  self.del = function(keys, cb){
    throwErrorIf((arguments.length < 1), 'ARGUMENT_EXCEPTION: .del() requires at least 1 argument.');
    log(false, '.del() called:', {keys: keys});
    if(typeof keys === 'object'){
      for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        delete cache.db[key];
        delete cache.expirations[key];
        delete cache.refreshKeys[key];
      }
      if(cb) cb(null, keys.length);
    }
    else{
      delete cache.db[keys];
      delete cache.expirations[keys];
      delete cache.refreshKeys[keys];
      if(cb) cb(null, 1); 
    }
    overwriteBrowserStorage();
  }

  /**
   * Flush all keys and values
   * @param {function} cb
   */
  self.flush = function(cb){
    log(false, '.flush() called');
    cache.db = {};
    cache.expirations = {};
    cache.refreshKeys = {};
    if(cb) cb();
    overwriteBrowserStorage();
  }

  /**
   * Enable browser storage if desired and available
   */
  function setupBrowserStorage(){
    if(browser || storageMock){
      if(storageMock){
        store = storageMock;
        storageKey = 'cache-module-storage-mock';
      }
      else{
        var storageType = (config.storage === 'local' || config.storage === 'session') ? config.storage : null;
        store = (storageType && typeof Storage !== void(0)) ? window[storageType + 'Storage'] : false;
        storageKey = (storageType) ? self.type + '-' + storageType + '-storage' : null;
      }
      if(store){
        var db = store.getItem(storageKey);
        try {
          cache = JSON.parse(db) || cache;
        } catch (err) { /* Do nothing */ }
      }
      // If storageType is set but store is not, the desired storage mechanism was not available
      else if(storageType){
        log(true, 'Browser storage is not supported by this browser. Defaulting to an in-memory cache.');
      }
    }
  }

  /**
   * Overwrite namespaced browser storage with current cache
   */
  function overwriteBrowserStorage(){
    if((browser && store) || storageMock){
      var db = cache;
      try {
        db = JSON.stringify(db);
      } catch (err) { /* Do nothing */ }
      store.setItem(storageKey, db);
    }
  }

  /**
   * Throw a given error if error is true
   * @param {boolean} error
   * @param {string} message
   */
  function throwErrorIf(error, message){
    if(error) throw new Error(message);
  }

  /**
   * Delete a given key from cache.db and cache.expirations but not from cache.refreshKeys
   * @param {string} key
   */
  function expire(key){
    delete cache.db[key];
    delete cache.expirations[key];
    overwriteBrowserStorage();
  }

  /**
   * Initialize background refresh
   */
  function backgroundRefreshInit(){
    if(!backgroundRefreshEnabled){
      backgroundRefreshEnabled = true;
      if(self.backgroundRefreshIntervalCheck){
        if(self.backgroundRefreshInterval > self.backgroundRefreshMinTtl){
          throw new Error('BACKGROUND_REFRESH_INTERVAL_EXCEPTION: backgroundRefreshInterval cannot be greater than backgroundRefreshMinTtl.');
        }
      }
      setInterval(backgroundRefresh, self.backgroundRefreshInterval);
    }
  }

  /**
   * Handle the refresh callback from the consumer, save the data to redis.
   *
   * @param {string} key The key used to save.
   * @param {Object} data refresh keys data.
   * @param {Error|null} err consumer callback failure.
   * @param {*} response The consumer response.
   */
  function handleRefreshResponse (key, data, err, response) {
    if(!err) {
      this.set(key, response, (data.lifeSpan / 1000), data.refresh, function(){});
    }
  }

  /**
   * Refreshes all keys that were set with a refresh function
   */
  function backgroundRefresh() {
    var keys = Object.keys(cache.refreshKeys);
    keys.forEach(function(key) {
      var data = cache.refreshKeys[key];
      if(data.expiration - Date.now() < this.backgroundRefreshMinTtl){
        data.refresh(key, handleRefreshResponse.bind(this, key, data));
      }
    }, self);
  }

  /**
   * Error logging logic
   * @param {boolean} isError
   * @param {string} message
   * @param {object} data
   */
  function log(isError, message, data){
    if(self.verbose || isError){
      if(data) console.log(self.type + ': ' + message, data);
      else console.log(self.type + message);
    }
  }
}

module.exports = cacheModule;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(console) {var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var Memcached = __webpack_require__(615);
var snappy = __webpack_require__(631);

function memcachedCacheService(conf) {
    var config = conf || {};
    var verbose = config.verbose || false;
    var defaultExpiration = config.defaultExpiration || 900;
    var backgroundRefreshIntervalCheck = typeof config.backgroundRefreshIntervalCheck === 'boolean' ? config.backgroundRefreshIntervalCheck : true;
    var backgroundRefreshInterval = config.backgroundRefreshInterval || 60000;
    var backgroundRefreshMinTtl = config.backgroundRefreshMinTtl || 70000;
    var memcachedConfig = config.memcached;

    var refreshKeys = {};
    var backgroundRefreshEnabled = false;

    var memcached = new Memcached(memcachedConfig.servers, memcachedConfig);

    if (verbose) console.log('memcachedCacheService config', { defaultExpiration: defaultExpiration });

    /**
     * Initialize background refresh
     */
    function backgroundRefreshInit() {
        if (!backgroundRefreshEnabled) {
            backgroundRefreshEnabled = true;
            if (backgroundRefreshIntervalCheck) {
                if (backgroundRefreshInterval > backgroundRefreshMinTtl) {
                    throw new Error('BACKGROUND_REFRESH_INTERVAL_EXCEPTION:' + ' backgroundRefreshInterval cannot be greater than backgroundRefreshMinTtl.');
                }
            }
            setInterval(function () {
                backgroundRefresh();
            }, backgroundRefreshInterval);
        }
    }

    /**
     * Refreshes all keys that were set with a refresh function
     */
    function backgroundRefresh() {
        if (verbose) console.log('memcachedCacheService.backgroundRefresh');

        Object.keys(refreshKeys).forEach(function (key) {
            var data = refreshKeys[key];
            if (data.expiration - Date.now() < backgroundRefreshMinTtl) {
                data.refresh(key, function (err, response) {
                    if (!err) {
                        if (verbose) console.log('memcachedCacheService.backgroundRefresh', { key: key });
                        set(key, response, data.lifeSpan, data.refresh, function () {});
                    }
                });
            }
        });
    }

    function get(key) {
        var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

        return memcached.get(key, function (err, data) {
            if (verbose) console.log('memcachedCacheService.get', { key: key });
            if (err) {
                console.error(err);
                callback(err);
            } else if (!data) {
                callback(new Error('No data returned from memcached'));
            } else {
                snappy.uncompress(data, { asBuffer: false }, function (snappyErr, original) {
                    if (snappyErr) {
                        callback(snappyErr);
                        return;
                    }
                    var resp = void 0;
                    try {
                        resp = JSON.parse(original);
                    } catch (parseError) {
                        resp = original;
                    }
                    callback(snappyErr, resp);
                });
            }
        });
    }

    function set(key, value) {
        var _arguments = arguments;

        snappy.compress(JSON.stringify(value), function (compressionErr, compressedValue) {
            var expiration = _arguments[2] || null || defaultExpiration;
            var refresh = _arguments.length == 5 ? _arguments[3] : null;
            var callback = (_arguments.length == 5 ? _arguments[4] : _arguments[3]) || function () {};
            return memcached.set(key, compressedValue, expiration, function (err) {
                if (verbose) console.log('memcachedCacheService.set', { key: key, compressedValue: compressedValue, expiration: expiration, refresh: refresh });
                if (err) console.error(key, err);
                callback(err);

                if (refresh && !err) {
                    var exp = expiration * 1000 + Date.now();
                    refreshKeys[key] = { expiration: exp, lifeSpan: expiration, refresh: refresh };
                    backgroundRefreshInit();
                }
            });
        });
    }

    return {
        db: memcached,
        type: 'memcached',
        verbose: verbose,
        defaultExpiration: defaultExpiration,
        get: get,
        mget: memcached.getMulti,
        set: set,
        mset: function mset(obj, _ref, _ref2) {
            // TODO: implement this.

            var _ref4 = _slicedToArray(_ref, 1),
                expiration = _ref4[0];

            var _ref3 = _slicedToArray(_ref2, 1),
                callback = _ref3[0];
        },
        del: function del(keys) {
            var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

            if (verbose) console.log('memcachedCacheService.del', { keys: keys });

            if ((typeof keys === 'undefined' ? 'undefined' : _typeof(keys)) === 'object') {
                for (var i = 0; i < keys.length; i++) {
                    var key = keys[i];
                    memcached.del(key, callback);
                    delete refreshKeys[key];
                }
            } else {
                memcached.del(keys, callback);
                delete refreshKeys[keys];
            }

            delete refreshKeys[key];
        },
        flush: function flush() {
            var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

            if (verbose) console.log('memcachedCacheService.flush');
            refreshKeys = {};
            memcached.flush(callback);
        }
    };
}

module.exports = memcachedCacheService;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(616);

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console, Buffer) {

/**
 * Node's native modules
 */
var Stream = __webpack_require__(89).Stream
  , Socket = __webpack_require__(89).Socket;

/**
 * External or custom modules
 */
var HashRing = __webpack_require__(620)
  , Connection = __webpack_require__(625)
  , Jackpot = __webpack_require__(626)
  , Utils = __webpack_require__(306)
  , IssueLog = Connection.IssueLog;

/**
 * Variable lookups
 */
var curry = Utils.curry;

/**
 * Constructs a new memcached client
 *
 * @constructor
 * @param {Mixed} args Array, string or object with servers
 * @param {Object} options options
 * @api public
 */
function Client (args, options) {
  var servers = []
    , weights = {}
    , regular = 'localhost:11211'
    , key;

  // Parse down the connection arguments
  switch (Object.prototype.toString.call(args)) {
    case '[object Object]':
      weights = args;
      servers = Object.keys(args);
      break;

    case '[object Array]':
      servers = args.length ? args : [regular];
      break;

    default:
      servers.push(args || regular);
      break;
  }

  if (!servers.length) {
    throw new Error('No servers where supplied in the arguments');
  }

  // merge with global and user config
  Utils.merge(this, Client.config);
  Utils.merge(this, options);

  this.servers = servers;
  var compatibility = this.compatibility || this.compatiblity;
  this.HashRing = new HashRing(args, this.algorithm, {
    'compatibility': compatibility,
    'default port': compatibility === 'ketama' ? 11211 : null
  });
  this.connections = {};
  this.issues = [];
}

// Allows users to configure the memcached globally or per memcached client
Client.config = {
    maxKeySize: 250         // max key size allowed by Memcached
  , maxExpiration: 2592000  // max expiration duration allowed by Memcached
  , maxValue: 1048576       // max length of value allowed by Memcached
  , activeQueries: 0
  , maxQueueSize: -1
  , algorithm: 'md5'        // hashing algorithm that is used for key mapping
  , compatibility: 'ketama' // hashring compatibility

  , poolSize: 10            // maximal parallel connections
  , retries: 5              // Connection pool retries to pull connection from pool
  , factor: 3               // Connection pool retry exponential backoff factor
  , minTimeout: 1000        // Connection pool retry min delay before retrying
  , maxTimeout: 60000       // Connection pool retry max delay before retrying
  , randomize: false        // Connection pool retry timeout randomization

  , reconnect: 18000000     // if dead, attempt reconnect each xx ms
  , timeout: 5000           // after x ms the server should send a timeout if we can't connect
  , failures: 5             // Number of times a server can have an issue before marked dead
  , failuresTimeout: 300000   // Time after which `failures` will be reset to original value, since last failure
  , retry: 30000            // When a server has an error, wait this amount of time before retrying
  , idle: 5000              // Remove connection from pool when no I/O after `idle` ms
  , remove: false           // remove server if dead if false, we will attempt to reconnect
  , redundancy: false       // allows you do re-distribute the keys over a x amount of servers
  , keyCompression: true    // compress keys if they are to large (md5)
  , namespace: ''           // sentinel to prepend to all memcache keys for namespacing the entries
  , debug: false            // Output the commands and responses
};

// There some functions we don't want users to touch so we scope them
(function (nMemcached) {
  var LINEBREAK = '\r\n'
    , NOREPLY = ' noreply'
    , FLUSH = 1E3
    , BUFFER = 1E2
    , CONTINUE = 1E1
    , FLAG_JSON = 1<<1
    , FLAG_BINARY = 1<<2
    , FLAG_NUMERIC = 1<<3;

  nMemcached.prototype.__proto__ = __webpack_require__(138).EventEmitter.prototype;

  var memcached = nMemcached.prototype
    , privates = {}
    , undefined;

  // Creates or generates a new connection for the give server, the callback
  // will receive the connection if the operation was successful
  memcached.connect = function connect(server, callback) {
    // Default port to 11211
    if(!server.match(/(.+):(\d+)$/)) {
        server = server + ':11211';
    }

    // server is dead, bail out
    if (server in this.issues && this.issues[server].failed) {
        return callback(false, false);
    }

    // fetch from connection pool
    if (server in this.connections) {
      return this.connections[server].pull(callback);
    }

    // No connection factory created yet, so we must build one
    var serverTokens = server[0] === '/'
        ? server
        : /(.*):(\d+){1,}$/.exec(server).reverse()
      , memcached = this;

    // Pop original string from array
    if (Array.isArray(serverTokens)) serverTokens.pop();

    var sid = 0
      , manager;

    /**
     * Generate a new connection pool manager.
     */

    manager = new Jackpot(this.poolSize);
    manager.retries = memcached.retries;
    manager.factor = memcached.factor;
    manager.minTimeout = memcached.minTimeout;
    manager.maxTimeout = memcached.maxTimeout;
    manager.randomize = memcached.randomize;

    manager.setMaxListeners(0);

    manager.factory(function factory() {
      var S = Array.isArray(serverTokens)
          ? new Stream
          : new Socket
        , Manager = this
        , idleTimeout = function() {
            Manager.remove(this);
          }
        , streamError = function(e) {
            memcached.connectionIssue(e.toString(), S);
            Manager.remove(this);
        };

      // config the Stream
      S.streamID = sid++;
      S.setTimeout(memcached.timeout);
      S.setNoDelay(true);
      S.setEncoding('utf8');
      S.metaData = [];
      S.responseBuffer = "";
      S.bufferArray = [];
      S.serverAddress = server;
      S.tokens = [].concat(serverTokens);
      S.memcached = memcached;

      // Add the event listeners
      Utils.fuse(S, {
          close: function streamClose() {
            Manager.remove(this);
          }
        , data: curry(memcached, privates.buffer, S)
        , connect: function streamConnect() {
            // Jackpot handles any pre-connect timeouts by calling back
            // with the error object.
            this.setTimeout(this.memcached.idle, idleTimeout);
            // Jackpot handles any pre-connect errors, but does not handle errors
            // once a connection has been made, nor does Jackpot handle releasing
            // connections if an error occurs post-connect
            this.on('error', streamError);
          }
        , end: S.end
      });

      // connect the net.Stream (or net.Socket) [port, hostname]
      S.connect.apply(S, S.tokens);
      return S;
    });

    manager.on('error', function err(e) {
      if (memcached.debug) console.log('Connection error', e);
    });

    this.connections[server] = manager;

    // now that we have setup our connection factory we can allocate a new
    // connection
    this.connections[server].pull(callback);
  };

  // Exposes buffer to test-suite
  memcached.buffer = function buffer() {
    return privates.buffer.apply(this, arguments);
  };

  // Creates a multi stream, so it's easier to query agains multiple memcached
  // servers.
  memcached.multi = function memcachedMulti(keys, callback) {
    var map = {}
      , memcached = this
      , servers
      , i;

    // gets all servers based on the supplied keys,
    // or just gives all servers if we don't have keys
    if (keys) {
      keys.forEach(function fetchMultipleServers(key) {
        var server = memcached.servers.length === 1
          ? memcached.servers[0]
          : memcached.HashRing.get(key);

        if (map[server]){
          map[server].push(key);
        } else {
          map[server] = [key];
        }
      });

      // store the servers
      servers = Object.keys(map);
    } else {
      servers = this.servers;
    }

    i = servers.length;

    while (i--) {
       //memcached.delegateCallback(this, servers[i], map[servers[i]], i, servers.length, callback);
      callback.call(this, servers[i], map[servers[i]], i, servers.length);
    }
  };

  // Executes the command on the net.Stream, if no server is supplied it will
  // use the query.key to get the server from the HashRing
  memcached.command = function memcachedCommand(queryCompiler, server) {

      this.activeQueries++;
      var query = queryCompiler();

      if (this.activeQueries> this.maxQueueSize && this.maxQueueSize > 0){
          this.makeCallback(query.callback, "over queue limit", null);
          query = null;
          return;
      }

      // generate a regular query,
      var redundancy = this.redundancy && this.redundancy < this.servers.length
      , queryRedundancy = query.redundancyEnabled
      , memcached = this;

    // validate the arguments
    if (query.validate && !Utils.validateArg(query, this)) {
        this.activeQueries--;
        return;
    }

    // try to find the correct server for this query
    if (!server) {
      // no need to do a hashring lookup if we only have one server assigned to
      // us
      if (this.servers.length === 1) {
        server = this.servers[0];
      } else {
        if (redundancy && queryRedundancy) {
          redundancy = this.HashRing.createRange(query.key, (this.redundancy + 1), true);
          server = redundancy.shift();
        } else {
          server = this.HashRing.get(query.key);
        }
      }
    }

    // check if any server exists or and if the server is still alive
    // a server may not exist if the manager was never able to connect
    // to any server.
    if (!server || (server in this.issues && this.issues[server].failed)) {
      return query.callback && memcached.makeCallback(query.callback,new Error(['Server at', server, 'not available'].join(' ')));
    }

    this.connect(server, function allocateMemcachedConnection(error, S) {
      if (memcached.debug) {
        query.command.split(LINEBREAK).forEach(function errors(line) {
          console.log(S.streamID + ' << ' + line);
        });
      }

      // S not set if unable to connect to server
      if (!S) {
        var S = {
          serverAddress: server,
          tokens: server.split(':').reverse()
        }
        var message = error || 'Unable to connect to server';
        memcached.connectionIssue(message, S);
        return query.callback && memcached.makeCallback(query.callback,new Error(message));

      }

      // Other errors besides inability to connect to server
      if (error) {
        memcached.connectionIssue(error.toString(), S);
        return query.callback && memcached.makeCallback(query.callback,error);
      }

      if (S.readyState !== 'open') {
        var message = 'Connection readyState is set to ' + S.readyState;
        memcached.connectionIssue(message, S);
        return query.callback && memcached.makeCallback(query.callback,new Error(message));
      }

      // used for request timing
      query.start = Date.now();
      S.metaData.push(query);
      S.write(Utils.reallocString(query.command + LINEBREAK));
    });

    // if we have redundancy enabled and the query is used for redundancy, than
    // we are going loop over the servers, check if we can reach them, and
    // connect to the correct net connection. because all redundancy queries are
    // executed with "no reply" we do not need to store the callback as there
    // will be no value to parse.
    if (redundancy && queryRedundancy) {
      queryRedundancy = queryCompiler(queryRedundancy);

      redundancy.forEach(function each(server) {
        if (server in memcached.issues && memcached.issues[server].failed){
            return;
        }

        memcached.connect(server, function allocateMemcachedConnection(error, S) {
          if (!S || error || S.readyState !== 'open') return;
          S.write(queryRedundancy.command + LINEBREAK);
        });
      });
    }
  };

  // Logs all connection issues, and handles them off. Marking all requests as
  // cache misses.
  memcached.connectionIssue = function connectionIssue(error, S) {
    if (S && S.end) S.end();

    var issues
      , server = S.serverAddress
      , memcached = this;

    // check for existing issue logs, or create a new log
    if (server in this.issues) {
      issues = this.issues[server];
    } else {
      issues = this.issues[server] = new IssueLog({
          server: server
        , tokens: S.tokens
        , reconnect: this.reconnect
        , failures: this.failures
        , failuresTimeout: this.failuresTimeout
        , retry: this.retry
        , remove: this.remove
        , failOverServers: this.failOverServers || null
      });

      // proxy the events
      Utils.fuse(issues, {
          issue: function issue(details) {
            memcached.emit('issue', details);
          }
        , failure: function failure(details) {
            memcached.emit('failure', details);
          }
        , reconnecting: function reconnect(details) {
            memcached.emit('reconnecting', details);
          }
        , reconnected: function reconnected(details) {
            memcached.emit('reconnect', details);
          }
        , remove: function remove(details) {
            // emit event and remove servers
            memcached.emit('remove', details);
            memcached.connections[server].end();

            if (this.failOverServers && this.failOverServers.length) {
              memcached.HashRing.swap(server, this.failOverServers.shift());
            } else {
              memcached.HashRing.remove(server);
              memcached.emit('failure', details);
            }
          }
      });

      // bumpt the event listener limit
      issues.setMaxListeners(0);
    }

    // log the issue
    issues.log(error);
  };

  // Kills all active connections
  memcached.end = function endMemcached() {
    var memcached = this;

    Object.keys(this.connections).forEach(function closeConnection(key) {
      memcached.connections[key].free(0);
    });
  };

  // These do not need to be publicly available as it's one of the most important
  // parts of the whole client, the parser commands:
  privates.parsers = {
    // handle error responses
    'NOT_FOUND': function notfound(tokens, dataSet, err) {
      return [CONTINUE, false];
    }

  , 'NOT_STORED': function notstored(tokens, dataSet, err) {
      var errObj = new Error('Item is not stored');
      errObj.notStored = true;
      err.push(errObj);
      return [CONTINUE, false];
    }

  , 'ERROR': function error(tokens, dataSet, err) {
      err.push(new Error('Received an ERROR response'));
      return [FLUSH, false];
    }

  , 'CLIENT_ERROR': function clienterror(tokens, dataSet, err) {
      err.push(new Error(tokens.splice(1).join(' ')));
      return [CONTINUE, false];
    }

  , 'SERVER_ERROR': function servererror(tokens, dataSet, err, queue, S, memcached) {
      (memcached || this.memcached).connectionIssue(tokens.splice(1).join(' '), this);
      return [CONTINUE, false];
    }

    // keyword based responses
  , 'STORED': function stored(tokens, dataSet) {
      return [CONTINUE, true];
    }

  , 'TOUCHED': function touched(tokens, dataSet) {
        return [CONTINUE, true];
    }

  , 'DELETED': function deleted(tokens, dataSet) {
      return [CONTINUE, true];
    }

  , 'OK': function ok(tokens, dataSet) {
      return [CONTINUE, true];
    }

  , 'EXISTS': function exists(tokens, dataSet) {
      return [CONTINUE, false];
    }

  , 'END': function end(tokens, dataSet, err, queue) {
      if (!queue.length) queue.push(undefined);
      return [FLUSH, true];
    }

    // value parsing:
  , 'VALUE': function value(tokens, dataSet, err, queue) {
      var key = tokens[1]
        , flag = +tokens[2]
        , dataLen = tokens[3] // length of dataSet in raw bytes
        , cas = tokens[4]
        , multi = this.metaData[0] && this.metaData[0].multi || cas
          ? {}
          : false
        , tmp;

      // In parse data there is an '||' passing us the content of token
      // if dataSet is empty. This may be fine for other types of responses,
      // in the case of an empty string being stored in a key, it will
      // result in unexpected behavior:
      // https://github.com/3rd-Eden/node-memcached/issues/64
      if (dataLen === '0') {
        dataSet = '';
      }

      switch (flag) {
        case FLAG_JSON:
          dataSet = JSON.parse(dataSet);
          break;
        case FLAG_NUMERIC:
          dataSet = +dataSet;
          break;
        case FLAG_BINARY:
          tmp = new Buffer(dataSet.length);
          tmp.write(dataSet, 0, 'binary');
          dataSet = tmp;
          break;
        }

      // Add to queue as multiple get key key key key key returns multiple values
      if (!multi) {
        queue.push(dataSet);
      } else {
        multi[key] = dataSet;
        if (cas) multi.cas = cas;
        queue.push(multi);
      }

      return [BUFFER, false];
    }

  , 'INCRDECR': function incrdecr(tokens) {
      return [CONTINUE, +tokens[1]];
    }

  , 'STAT': function stat(tokens, dataSet, err, queue) {
      queue.push([tokens[1], /^\d+$/.test(tokens[2]) ? +tokens[2] : tokens[2]]);
      return [BUFFER, true];
    }

  , 'VERSION': function version(tokens, dataSet) {
      var versionTokens = /(\d+)(?:\.)(\d+)(?:\.)(\d+)$/.exec(tokens[1]);

      return [CONTINUE, {
        server: this.serverAddress
      , version: versionTokens[0]
      , major: versionTokens[1] || 0
      , minor: versionTokens[2] || 0
      , bugfix: versionTokens[3] || 0
      }];
    }

  , 'ITEM': function item(tokens, dataSet, err, queue) {
      queue.push({
        key: tokens[1]
      , b: +tokens[2].substr(1)
      , s: +tokens[4]
      });

      return [BUFFER, false];
    }
    // Amazon-specific memcached configuration information, used for node
    // auto-discovery.
  , 'CONFIG': function() {
      return [CONTINUE, this.bufferArray[0]];
    }
  };

  function resultSetIsEmpty(resultSet) {
    return !resultSet || (resultSet.length === 1 && !resultSet[0]);
  }

  // Parses down result sets
  privates.resultParsers = {
    // combines the stats array, in to an object
    'stats': function stats(resultSet) {
      var response = {};
      if (resultSetIsEmpty(resultSet)) return response;

      // add references to the retrieved server
      response.server = this.serverAddress;

      // Fill the object
      resultSet.forEach(function each(statSet) {
        if (statSet) response[statSet[0]] = statSet[1];
      });

      return response;
    }

    // the settings uses the same parse format as the regular stats
  , 'stats settings': function settings() {
      return privates.resultParsers.stats.apply(this, arguments);
    }

    // Group slabs by slab id
  , 'stats slabs': function slabs(resultSet) {
      var response = {};
      if (resultSetIsEmpty(resultSet)) return response;

      // add references to the retrieved server
      response.server = this.serverAddress;

      // Fill the object
      resultSet.forEach(function each(statSet) {
        if (statSet) {
          var identifier = statSet[0].split(':');

          if (!response[identifier[0]]) response[identifier[0]] = {};
          response[identifier[0]][identifier[1]] = statSet[1];
        }
      });

      return response;
    }

  , 'stats items': function items(resultSet) {
      var response = {};
      if (resultSetIsEmpty(resultSet)) return response;

      // add references to the retrieved server
      response.server = this.serverAddress;

      // Fill the object
      resultSet.forEach(function each(statSet) {
        if (statSet && statSet.length > 1) {
          var identifier = statSet[0].split(':');

          if (!response[identifier[1]]) response[identifier[1]] = {};
          response[identifier[1]][identifier[2]] = statSet[1];
        }
      });

      return response;
    }
  };

  // Generates a RegExp that can be used to check if a chunk is memcached response identifier
  privates.allCommands = new RegExp('^(?:' + Object.keys(privates.parsers).join('|') + '|\\d' + ')');
  privates.bufferedCommands = new RegExp('^(?:' + Object.keys(privates.parsers).join('|') + ')');

  // When working with large chunks of responses, node chunks it in to pieces.
  // So we might have half responses. So we are going to buffer up the buffer
  // and user our buffered buffer to query // against. Also when you execute
  // allot of .writes to the same stream, node will combine the responses in to
  // one response stream. With no indication where it had cut the data. So it
  // can be it cuts inside the value response, or even right in the middle of
  // a line-break, so we need to make sure, the last piece in the buffer is
  // a LINEBREAK because that is all what is sure about the Memcached Protocol,
  // all responds end with them.
  privates.buffer = function BufferBuffer(S, BufferStream) {
    S.responseBuffer += BufferStream;

    // only call transform the data once we are sure, 100% sure, that we valid
    // response ending
    if (S.responseBuffer.substr(S.responseBuffer.length - 2) === LINEBREAK) {
      S.responseBuffer = Utils.reallocString(S.responseBuffer);

      var chunks = S.responseBuffer.split(LINEBREAK);

      if (this.debug) {
        chunks.forEach(function each(line) {
          console.log(S.streamID + ' >> ' + line);
        });
      }

      // Fix zero-line endings in the middle
      var chunkLength = (chunks.length-1);
      if (chunks[chunkLength].length === 0) chunks.splice(chunkLength, 1);

      S.responseBuffer = ""; // clear!
      this.rawDataReceived(S, S.bufferArray = S.bufferArray.concat(chunks));
    }
  };

  memcached.delegateCallback = function(){
        this.activeQueries--;
        var master = arguments[0];
        var cb = arguments[arguments.length-1];
        var args = Array.prototype.slice.call(arguments, 1, arguments.length-1);
        cb.apply(master, args);
  };

  memcached.makeCallback = function(cb){
       this.activeQueries--;
       var args = Array.prototype.slice.call(arguments, 1);
       cb.apply(this, args); //loose first
  };

  // The actual parsers function that scan over the responseBuffer in search of
  // Memcached response identifiers. Once we have found one, we will send it to
  // the dedicated parsers that will transform the data in a human readable
  // format, deciding if we should queue it up, or send it to a callback fn.
  memcached.rawDataReceived = function rawDataReceived(S) {
    var queue = []
      , token
      , tokenSet
      , dataSet
      , resultSet
      , metaData
      , err = []
      , tmp;

    while(S.bufferArray.length && privates.allCommands.test(S.bufferArray[0])) {
      token = S.bufferArray.shift();
      tokenSet = token.split(' ');

      if (/^\d+$/.test(tokenSet[0])) {
          // special case for "config get cluster"
          // Amazon-specific memcached configuration information, see aws
          // documentation regarding adding auto-discovery to your client library.
          // Example response of a cache cluster containing three nodes:
          //   configversion\n
          //   hostname|ip-address|port hostname|ip-address|port hostname|ip-address|port\n\r\n
          if (/(([-.a-zA-Z0-9]+)\|(\b\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\b)\|(\d+))/.test(S.bufferArray[0])) {
              tokenSet.unshift('CONFIG');
          }
          // special case for digit only's these are responses from INCR and DECR
          else {
            tokenSet.unshift('INCRDECR');
          }
      }
      // special case for value, it's required that it has a second response!
      // add the token back, and wait for the next response, we might be
      // handling a big ass response here.
      if (tokenSet[0] === 'VALUE' && S.bufferArray.indexOf('END') === -1) {
        return S.bufferArray.unshift(token);
      }

      // check for dedicated parser
      if (privates.parsers[tokenSet[0]]) {

        // fetch the response content
        if (tokenSet[0] === 'VALUE') {
          dataSet = Utils.unescapeValue(S.bufferArray.shift());
        }

        resultSet = privates.parsers[tokenSet[0]].call(S, tokenSet, dataSet || token, err, queue, this);

        // check how we need to handle the resultSet response
        switch (resultSet.shift()) {
          case BUFFER:
            break;

          case FLUSH:
            metaData = S.metaData.shift();
            resultSet = queue;

            // if we have a callback, call it
            if (metaData && metaData.callback) {
              metaData.execution = Date.now() - metaData.start;
                this.delegateCallback(
                  metaData
                , err.length ? err : err[0]

                  // see if optional parsing needs to be applied to make the result set more readable
                , privates.resultParsers[metaData.type]
                    ? privates.resultParsers[metaData.type].call(S, resultSet, err)
                    : !Array.isArray(queue) || queue.length > 1 ? queue : queue[0]
                ,metaData.callback
              );
            }

            queue.length = err.length = 0;
            break;

          default:
            metaData = S.metaData.shift();

            if (metaData && metaData.callback) {
              metaData.execution = Date.now() - metaData.start;
              this.delegateCallback(metaData, err.length > 1 ? err : err[0], resultSet[0], metaData.callback);
            }

            err.length = 0;
            break;
        }
      } else {
        // handle unkown responses
        metaData = S.metaData.shift();
        if (metaData && metaData.callback){
          metaData.execution = Date.now() - metaData.start;
            this.delegateCallback(metaData, new Error('Unknown response from the memcached server: "' + token + '"'), false, metaData.callback);
        }
      }

      // cleanup
      dataSet = tokenSet = metaData = undefined;

      // check if we need to remove an empty item from the array, as splitting on /r/n might cause an empty
      // item at the end..
      if (S.bufferArray[0] === '') S.bufferArray.shift();
    }
  };

  // Small wrapper function that only executes errors when we have a callback
  privates.errorResponse = function errorResponse(error, callback) {
    if (typeof callback === 'function') {
        memcached.makeCallback(callback,error, false);
    }

    return false;
  };

  // This is where the actual Memcached API layer begins:
  memcached.touch = function touch(key, lifetime, callback) {
    var fullkey = this.namespace + key;
    this.command(function touchCommand() {
      return {
          key: fullkey
        , callback: callback
        , lifetime: lifetime
        , validate: [['key', String], ['lifetime', Number], ['callback', Function]]
        , type: 'touch'
        , command: ['touch', fullkey, lifetime].join(' ')
      };
    });
  };

  memcached.get = function get(key, callback) {
    if (Array.isArray(key)) return this.getMulti.apply(this, arguments);

    var fullkey = this.namespace + key;
    this.command(function getCommand(noreply) {
      return {
          key: fullkey
        , callback: callback
        , validate: [['key', String], ['callback', Function]]
        , type: 'get'
        , command: 'get ' + fullkey
      };
    });
  };

  // the difference between get and gets is that gets, also returns a cas value
  // and gets doesn't support multi-gets at this moment.
  memcached.gets = function get(key, callback) {
    var fullkey = this.namespace + key;
    this.command(function getCommand(noreply) {
      return {
          key: fullkey
        , callback: callback
        , validate: [['key', String], ['callback', Function]]
        , type: 'gets'
        , command: 'gets ' + fullkey
      };
    });
  };

  // Handles get's with multiple keys
  memcached.getMulti = function getMulti(keys, callback) {
    var memcached = this
      , responses = {}
      , errors = []
      , calls;

    if (memcached.namespace.length) keys = keys.map(function compile(key){
      return memcached.namespace + key;
    });

    // handle multiple responses and cache them untill we receive all.
    function handle(err, results) {
      if (err) {
        errors.push(err);
      }

      // add all responses to the array
      (Array.isArray(results) ? results : [results]).forEach(function each(value) {
        if (value && memcached.namespace.length) {
          var ns_key = Object.keys(value)[0]
            , newvalue = {};

          newvalue[ns_key.replace(memcached.namespace, '')] = value[ns_key];
          Utils.merge(responses, newvalue);
        } else {
          Utils.merge(responses, value);
        }
      });

      if (!--calls){
          callback(errors.length ? errors : undefined, responses);
      }
    }

    this.multi(keys, function multi(server, key, index, totals) {
      if (!calls) calls = totals;

      memcached.command(function getMultiCommand(noreply) {
        return {
            callback: handle
          , multi: true
          , type: 'get'
          , command: 'get ' + key.join(' ')
          , key: keys
          , validate: [['key', Array], ['callback', Function]]
        };
      }, server);
    });
  };

  // As all command nearly use the same syntax we are going to proxy them all to
  // this function to ease maintenance. This is possible because most set
  // commands will use the same syntax for the Memcached server. Some commands
  // do not require a lifetime and a flag, but the memcached server is smart
  // enough to ignore those.
  privates.setters = function setters(type, validate, key, value, lifetime, callback, cas) {
    var fullkey = this.namespace + key;
    var flag = 0
      , valuetype = typeof value
      , length;

    if (Buffer.isBuffer(value)) {
      flag = FLAG_BINARY;
      value = value.toString('binary');
    } else if (valuetype === 'number') {
      flag = FLAG_NUMERIC;
      value = value.toString();
    } else if (valuetype !== 'string') {
      flag = FLAG_JSON;
      value = JSON.stringify(value);
    }

    value = Utils.escapeValue(value);

    length = Buffer.byteLength(value);
    if (length > this.maxValue) {
      return privates.errorResponse(new Error('The length of the value is greater than ' + this.maxValue), callback);
    }

    this.command(function settersCommand(noreply) {
      return {
          key: fullkey
        , callback: callback
        , lifetime: lifetime
        , value: value
        , cas: cas
        , validate: validate
        , type: type
        , redundancyEnabled: false
        , command: [type, fullkey, flag, lifetime, length].join(' ') +
               (cas ? ' ' + cas : '') +
               (noreply ? NOREPLY : '') +
               LINEBREAK + value
      };
    });
  };

  // Curry the function and so we can tell the type our private set function
  memcached.set = curry(undefined, privates.setters
    , 'set'
    , [
          ['key', String]
        , ['value', String]
        , ['lifetime', Number]
        , ['callback', Function]
      ]
  );

  memcached.replace = curry(undefined, privates.setters
    , 'replace'
    , [
          ['key', String]
        , ['value', String]
        , ['lifetime', Number]
        , ['callback', Function]
      ]
  );

  memcached.add = curry(undefined, privates.setters
    , 'add'
    , [
          ['key', String]
        , ['value', String]
        , ['lifetime', Number]
        , ['callback', Function]
      ]
  );

  memcached.cas = function checkandset(key, value, cas, lifetime, callback) {
    privates.setters.call(this
      , 'cas'
      , [
            ['key', String]
          , ['value', String]
          , ['lifetime', Number]
          , ['callback', Function]
        ]
      , key
      , value
      , lifetime
      , callback
      , cas
    );
  };

  memcached.append = function append(key, value, callback) {
    privates.setters.call(this
      , 'append'
      , [
            ['key', String]
          , ['value', String]
          , ['lifetime', Number]
          , ['callback', Function]
        ]
      , key
      , value
      , 0
      , callback
    );
  };

  memcached.prepend = function prepend(key, value, callback) {
    privates.setters.call(this
      , 'prepend'
      , [
            ['key', String]
          , ['value', String]
          , ['lifetime', Number]
          , ['callback', Function]
        ]
      , key
      , value
      , 0
      , callback
    );
  };

  // Small handler for incr and decr's
  privates.incrdecr = function incrdecr(type, key, value, callback) {
    var fullkey = this.namespace + key;
    this.command(function incredecrCommand(noreply) {
      return {
          key: fullkey
        , callback: callback
        , value: value
        , validate: [
              ['key', String]
            , ['value', Number]
            , ['callback', Function]
          ]
        , type: type
        , redundancyEnabled: true
        , command: [type, fullkey, value].join(' ') +
               (noreply ? NOREPLY : '')
      };
    });
  };

  // Curry the function and so we can tell the type our private incrdecr
  memcached.increment = memcached.incr = curry(undefined, privates.incrdecr, 'incr');
  memcached.decrement = memcached.decr = curry(undefined, privates.incrdecr, 'decr');

  // Deletes the keys from the servers
  memcached.del = function del(key, callback){
    var fullkey = this.namespace + key;
    this.command(function deleteCommand(noreply) {
      return {
          key: fullkey
        , callback: callback
        , validate: [
              ['key', String]
            , ['callback', Function]
          ]
        , type: 'delete'
        , redundancyEnabled: true
        , command: 'delete ' + fullkey +
               (noreply ? NOREPLY : '')
      };
    });
  };
  memcached['delete'] = memcached.del;

  // Small wrapper that handle single keyword commands such as FLUSH ALL, VERSION and STAT
  privates.singles = function singles(type, callback) {
    var memcached = this
      , responses = []
      , errors
      , calls;

      // handle multiple servers
    function handle(err, results) {
      if (err) {
        errors = errors || [];
        errors.push(err);
      }
      if (results) responses = responses.concat(results);

      // multi calls should ALWAYS return an array!
      if (!--calls) {
          callback(errors && errors.length ? errors.pop() : undefined, responses);
      }
    }

    this.multi(false, function multi(server, keys, index, totals) {
      if (!calls) calls = totals;

      memcached.command(function singlesCommand(noreply) {
        return {
            callback: handle
          , type: type
          , command: type
        };
      }, server);
    });
  };

  // Curry the function and so we can tell the type our private singles
  memcached.version  = curry(undefined, privates.singles, 'version');
  memcached.flush = curry(undefined, privates.singles, 'flush_all');
  memcached.stats = curry(undefined, privates.singles, 'stats');
  memcached.settings = curry(undefined, privates.singles, 'stats settings');
  memcached.slabs = curry(undefined, privates.singles, 'stats slabs');
  memcached.items = curry(undefined, privates.singles, 'stats items');

  // aliases
  memcached.flushAll = memcached.flush;
  memcached.statsSettings = memcached.settings;
  memcached.statsSlabs = memcached.slabs;
  memcached.statsItems = memcached.items;


  // You need to use the items dump to get the correct server and slab settings
  // see simple_cachedump.js for an example
  memcached.cachedump = function cachedump(server, slabid, number, callback) {
    this.command(function cachedumpCommand(noreply) {
      return {
          callback: callback
        , number: number
        , slabid: slabid
        , validate: [
              ['number', Number]
            , ['slabid', Number]
            , ['callback', Function]
          ]
        , type: 'stats cachedump'
        , command: 'stats cachedump ' + slabid + ' ' + number
      };
    }, server);
  };
})(Client);

module.exports = Client;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(305).Buffer))

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 618 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 619 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {

var SimpleCache = __webpack_require__(621)
  , parse = __webpack_require__(623)
  , crypto = __webpack_require__(89);

/**
 * Generate the hash of the value.
 *
 * @api private
 */
function hashValueHash(a, b, c, d) {
  return ((a << 24) | (b << 16) | (c << 8) | d) >>> 0;
}

/**
 * Add a virtual node parser to the connection string parser.
 *
 * @param {Object} data server data
 * @param {Mixed} value optional value
 * @api private
 */
parse.extension('vnodes', function vnode(data, value) {
  if (typeof value === 'object' && !Array.isArray(value) && 'vnodes' in value) {
    data.vnodes = +value.vnodes || 0;
  } else {
    data.vnodes = 0;
  }
});

/**
 * HashRing implements consistent hashing so adding or removing servers of one
 * slot does not significantly change the mapping of the key to slots. The
 * consistent hashing algorithm is based on ketama or libketama.
 *
 * @constructor
 * @param {Mixed} server Servers that need to be added to the ring.
 * @param {Mixed} algorithm Either a Crypto compatible algorithm or custom hasher.
 * @param {Object} options Optional configuration and options for the ring.
 * @api public
 */
function HashRing(servers, algorithm, options) {
  options = options || {};

  //
  // These properties can be configured
  //
  this.vnode = 'vnode count' in options ? options['vnode count'] : 40;
  this.algorithm = algorithm || 'md5';

  //
  // if the default port is set, and a host uses it, then it is excluded from
  // the hash.
  //
  this.defaultport = options['default port'] || null;

  //
  // There's a slight difference between libketama and python's hash_ring
  // module, libketama creates 160 points per server:
  //
  //   40 hashes (vnodes) and 4 replicas per hash = 160 points per server.
  //
  // The hash_ring module only uses 120 points per server:
  //
  //   40 hashes (vnodes) and 3 replicas per hash = 120 points per server.
  //
  // And that's the only difference between the original ketama hash and the
  // hash_ring package. Small, but important.
  //
  this.replicas = options.compatibility
    ? (options.compatibility === 'hash_ring' ? 3 : 4)
    : ('replicas' in options ? +options.replicas : 4);

  //
  // Replica's cannot be 0 as it means we have nothing to iterate over when
  // creating the initial hash ring.
  //
  if (this.replicas <= 0) this.replicas = 1;

  // Private properties.
  var connections = parse(servers);

  this.ring = [];
  this.size = 0;
  this.vnodes = connections.vnodes;
  this.servers = connections.servers;

  // Set up a ache as we don't want to preform a hashing operation every single
  // time we lookup a key.
  this.cache = new SimpleCache({
    maxSize: 'max cache size' in  options ? options['max cache size'] : 5000
  });

  // Override the hashing function if people want to use a hashing algorithm
  // that is not supported by Node, for example if you want to MurMur hashing or
  // something else exotic.
  if ('function' === typeof this.algorithm) {
    this.hash = this.algorithm;
  }

  // Generate the continuum of the HashRing.
  this.continuum();
}

/**
 * Generates the continuum of server a.k.a. the Hash Ring based on their weights
 * and virtual nodes assigned.
 *
 * @returns {HashRing}
 * @api private
 */
HashRing.prototype.continuum = function generate() {
  var servers = this.servers
    , self = this
    , index = 0
    , total = 0;

  // No servers, bailout.
  if (!servers.length) return this;

  // Generate the total weight of all the servers.
  total = servers.reduce(function reduce(total, server) {
    return total + server.weight;
  }, 0);

  servers.forEach(function each(server) {
    var percentage = server.weight / total
      , vnodes = self.vnodes[server.string] || self.vnode
      , length = Math.floor(percentage * vnodes * servers.length)
      , key
      , x;

    // If you supply us with a custom vnode size, we will use that instead of
    // our computed distribution.
    if (vnodes !== self.vnode) length = vnodes;

    for (var i = 0; i < length; i++) {
      if (self.defaultport && server.port === self.defaultport) {
        x = self.digest(server.host +'-'+ i);
      } else {
        x = self.digest(server.string +'-'+ i);
      }

      for (var j = 0; j < self.replicas; j++) {
        key = hashValueHash(x[3 + j * 4], x[2 + j * 4], x[1 + j * 4], x[j * 4]);
        self.ring[index] = new Node(key, server.string);
        index++;
      }
    }
  });

  // Sort the keys using the continuum points compare that is used in ketama
  // hashing.
  this.ring = this.ring.sort(function sorted(a, b) {
    if (a.value === b.value) return 0;
    else if (a.value > b.value) return 1;

    return -1;
  });

  this.size = this.ring.length;
  return this;
};

/**
 * Find the correct node for the key which is closest to the point after what
 * the given key hashes to.
 *
 * @param {String} key Key who's server we need to figure out.
 * @returns {String} Server address.
 * @api public
 */
HashRing.prototype.get = function get(key) {
  var cache = this.cache.get(key);
  if (cache) return cache;

  var node = this.ring[this.find(this.hashValue(key))];
  if (!node) return undefined;

  this.cache.set(key, node.server);
  return node.server;
};

/**
 * Returns the position of the hashValue in the hashring.
 *
 * @param {Number} hashValue Find the nearest server close to this hash.
 * @returns {Number} Position of the server in the hash ring.
 * @api public
 */
HashRing.prototype.find = function find(hashValue) {
  var ring = this.ring
    , high = this.size
    , low = 0
    , middle
    , prev
    , mid;

  // Preform a search on the array to find the server with the next biggest
  // point after what the given key hashes to.
  while (true) {
    mid = (low + high) >> 1;

    if (mid === this.size) return 0;

    middle = ring[mid].value;
    prev = mid === 0 ? 0 : ring[mid - 1].value;

    if (hashValue <= middle && hashValue > prev) return mid;

    if (middle < hashValue) {
      low = mid + 1;
    } else {
      high = mid - 1;
    }

    if (low > high) return 0;
  }
};

/**
 * Generates a hash of the string.
 *
 * @param {String} key
 * @returns {String|Buffer} Hash, depends on node version.
 * @api private
 */
HashRing.prototype.hash = function hash(key) {
  return crypto.createHash(this.algorithm).update(key).digest();
};

/**
 * Digest hash so we can make a numeric representation from the hash.
 *
 * @param {String} key The key that needs to be hashed.
 * @returns {Array}
 * @api private
 */
HashRing.prototype.digest = function digest(key) {
  var hash = this.hash(key +'');

  // Support for Node 0.10 which returns buffers so we don't need to charAt
  // lookups.
  if ('string' !== typeof hash) return hash;

  return hash.split('').map(function charCode(char) {
    return char.charCodeAt(0);
  });
};

/**
 * Get the hashed value for the given key.
 *
 * @param {String} key
 * @returns {Number}
 * @api private
 */
HashRing.prototype.hashValue = function hasher(key) {
  var x = this.digest(key);

  return hashValueHash(x[3], x[2], x[1], x[0]);
};

/**
 * None ketama:
 *
 * The following changes are not ported from the ketama algorithm and are hash
 * ring specific. Add, remove or replace servers with as less disruption as
 * possible.
 */

/**
 * Get a range of different servers.
 *
 * @param {String} key
 * @param {Number} size Amount of servers it should return.
 * @param {Boolean} unique Return only unique keys.
 * @return {Array}
 * @api public
 */
HashRing.prototype.range = function range(key, size, unique) {
  if (!this.size) return [];

  size = size || this.servers.length;
  unique = unique || 'undefined' === typeof unique;

  var position = this.find(this.hashValue(key))
    , length = this.ring.length
    , servers = []
    , node;

  // Start searching for servers from the position of the key to the end of
  // HashRing.
  for (var i = position; i < length; i++) {
    node = this.ring[i];

    // Do we need to make sure that we retrieve a unique list of servers?
    if (unique) {
      if (!~servers.indexOf(node.server)) servers.push(node.server);
    } else {
      servers.push(node.server);
    }

    if (servers.length === size) return servers;
  }

  // Not enough results yet, so iterate from the start of the hash ring to the
  // position of the hash ring. So we reach full circle again.
  for (i = 0; i < position; i++) {
    node = this.ring[i];

    // Do we need to make sure that we retrieve a unique list of servers?
    if (unique) {
      if (!~servers.indexOf(node.server)) servers.push(node.server);
    } else {
      servers.push(node.server);
    }

    if (servers.length === size) return servers;
  }

  return servers;
};

/**
 * Returns the points per server.
 *
 * @param {String} server Optional server to filter down.
 * @returns {Object} server -> Array(points).
 * @api public
 */
HashRing.prototype.points = function points(servers) {
  servers = Array.isArray(servers) ? servers : Object.keys(this.vnodes);

  var nodes = Object.create(null)
    , node;

  servers.forEach(function servers(server) {
    nodes[server] = [];
  });

  for (var i = 0; i < this.size; i++) {
    node = this.ring[i];

    if (node.server in nodes) {
      nodes[node.server].push(node.value);
    }
  }

  return nodes;
};

/**
 * Hotswap identical servers with each other. This doesn't require the cache to
 * be completely nuked and the hash ring distribution to be re-calculated.
 *
 * Please note that removing the server and a new adding server could
 * potentially create a different distribution.
 *
 * @param {String} from The server that needs to be replaced.
 * @param {String} to The server that replaces the server.
 * @returns {HashRing}
 * @api public
 */
HashRing.prototype.swap = function swap(from, to) {
  var connection = parse(to).servers.pop()
    , self = this;

  this.ring.forEach(function forEach(node) {
    if (node.server === from) node.server = to;
  });

  this.cache.forEach(function forEach(value, key) {
    if (value === from) self.cache.set(key, to);
  }, this);

  // Update the virtual nodes
  this.vnodes[to] = this.vnodes[from];
  delete this.vnodes[from];

  // Update the servers
  this.servers = this.servers.map(function mapswap(server) {
    if (server.string === from) {
      server.string = to;
      server.host = connection.host;
      server.port = connection.port;
    }

    return server;
  });

  return this;
};

/**
 * Add a new server to ring without having to re-initialize the hashring. It
 * accepts the same arguments as you can use in the constructor.
 *
 * @param {Mixed} servers Servers that need to be added to the ring.
 * @returns {HashRing}
 * @api public
 */
HashRing.prototype.add = function add(servers) {
  var connections = Object.create(null);

  // Add the current servers to the set.
  this.servers.forEach(function forEach(server) {
    connections[server.string] = server;
  });

  parse(servers).servers.forEach(function forEach(server) {
    // Don't add duplicate servers
    if (server.string in connections) return;
    connections[server.string] = server;
  });

  // Now that we generated a complete set of servers, we can update the re-parse
  // the set and correctly added all the servers again.
  connections = parse(connections);
  this.vnodes = connections.vnodes;
  this.servers = connections.servers;

  // Rebuild the hash ring.
  this.reset();
  return this.continuum();
};

/**
 * Remove a server from the hashring.
 *
 * @param {Mixed} server The sever we want to remove.
 * @returns {HashRing}
 * @api public
 */
HashRing.prototype.remove = function remove(server) {
  var connection = parse(server).servers.pop();

  delete this.vnodes[connection.string];
  this.servers = this.servers.map(function map(server) {
    if (server.string === connection.string) return undefined;

    return server;
  }).filter(Boolean);

  // Rebuild the hash ring
  this.reset();
  return this.continuum();
};

/**
 * Checks if a given server exists in the hash ring.
 *
 * @param {String} server Server for whose existence we're checking
 * @returns {Boolean} Indication if we have that server.
 * @api public
 */
HashRing.prototype.has = function add(server) {
  for (var i = 0; i < this.ring.length; i++) {
    if (this.ring[i].server === server) return true;
  }

  return false;
};

/**
 * Reset the HashRing to clean up all references
 *
 * @returns {HashRing}
 * @api public
 */
HashRing.prototype.reset = function reset() {
  this.ring.length = 0;
  this.size = 0;
  this.cache.reset();

  return this;
};

/**
 * End the hashring and clean up all of it's references.
 *
 * @returns {HashRing}
 * @api public
 */
HashRing.prototype.end = function end() {
  this.reset();

  this.vnodes = {};
  this.servers.length = 0;

  return this;
};

/**
 * A single Node in our hash ring.
 *
 * @constructor
 * @param {Number} hashvalue
 * @param {String} server
 * @api private
 */
function Node(hashvalue, server) {
  this.value = hashvalue;
  this.server = server;
}

//
// Set up the legacy API aliases. These will be deprecated in the next release.
//
[
  { from: 'replaceServer' },
  { from: 'replace' },
  { from: 'removeServer', to: 'remove' },
  { from: 'addServer', to: 'add' },
  { from: 'getNode', to: 'get' },
  { from: 'getNodePosition', to: 'find' },
  { from: 'position', to: 'find' }
].forEach(function depricate(api) {
  var notified = false;

  HashRing.prototype[api.from] = function depricating() {
    if (!notified) {
      console.warn();
      console.warn('[depricated] HashRing#'+ api.from +' is removed.');

      // Not every API has a replacement API that should be used
      if (api.to) {
        console.warn('[depricated] use HashRing#'+ api.to +' as replacement.');
      } else {
        console.warn('[depricated] the API has no replacement');
      }

      console.warn();
      notified = true;
    }

    if (api.to) return HashRing.prototype[api.to].apply(this, arguments);
  };
});

/**
 * Expose the current version number.
 *
 * @type {String}
 * @public
 */
HashRing.version = __webpack_require__(624).version;

/**
 * Expose the module.
 *
 * @api public
 */
module.exports = HashRing;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(622);


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * LRU cache based on a double linked list
 */

function ListElement(before,next,key,value){
    this.before = before
    this.next = next
    this.key = key
    this.value = value
}

ListElement.prototype.setKey = function(key){
    this.key = key
}

ListElement.prototype.setValue = function(value){
    this.value = value
}


function Cache(options){
    if(!options)
        options = {}
    this.maxSize = options.maxSize 
    this.reset()
}


Cache.prototype.reset = function(){
    this.size = 0   
    this.cache = {}
    this.tail = undefined
    this.head = undefined
}


Cache.prototype.get = function(key,hit){
    var cacheVal = this.cache[key]
    /*
     * Define if the egt function should hit the value to move
     * it to the head of linked list  
     */
    hit = hit != undefined && hit != null ? hit : true;
    if(cacheVal && hit)
        this.hit(cacheVal)
    else
        return undefined
    return cacheVal.value
}

Cache.prototype.set = function(key,val,hit){
    var actual = this.cache[key]
    /*
     * Define if the set function should hit the value to move
     * it to the head of linked list  
     */
     hit = hit != undefined && hit != null ? hit : true;
    
    
    if(actual){
        actual.value = val
        if(hit) this.hit(actual)
    }else{
        var cacheVal
        if(this.size >= this.maxSize){
            var tailKey = this.tail.key 
            this.detach(this.tail)
            
            /*
             * If max is reached we'llreuse object to minimize GC impact 
             * when the objects are cached short time
             */
            cacheVal = this.cache[tailKey]
            delete this.cache[tailKey]

            cacheVal.next = undefined
            cacheVal.before = undefined
            
            /*
             * setters reuse the array object 
             */
            cacheVal.setKey(key)
            cacheVal.setValue(val)
        }

        cacheVal = cacheVal ? cacheVal : new ListElement(undefined,undefined,key,val)
        this.cache[key] = cacheVal
        this.attach(cacheVal)
    }
}

Cache.prototype.del = function(key){
    var val = this.cache[key]
    if(!val)
        return;
    this.detach(val)
    delete this.cache[key]
}

Cache.prototype.hit = function(cacheVal){
    //Send cacheVal to the head of list
    this.detach(cacheVal)
    this.attach(cacheVal)
}

Cache.prototype.attach = function(element){
    if(!element)
        return;
    element.before = undefined
    element.next = this.head
    this.head = element
    if(!element.next)
       this.tail = element
    else
        element.next.before = element
    this.size++ 
}

Cache.prototype.detach = function(element){
    if(!element)
        return;
    var before = element.before
    var next = element.next
    if(before){
        before.next = next
    }else{
        this.head = next
    }
    if(next){
        next.before = before
    }else{
        this.tail = before
    }
    this.size--
}

Cache.prototype.forEach = function(callback){
    var self = this
    Object.keys(this.cache).forEach(function(key){
        var val = self.cache[key]
        callback(val.value,key)
    })
}
module.exports=Cache


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Parser extensions, so extra values or default values can be added to the
 * returned values.
 *
 * @type {Array}
 * @private
 */
var extensions = {};

/**
 * Parse the server argument to a uniform format.
 *
 * @param {Mixed} args
 * @returns {Object}
 * @api private
 */
function parse(args) {
  var servers;

  if (arguments.length > 1) {
    servers = Array.prototype.slice.call(arguments, 0).map(function generate(server) {
      return address(server);
    });
  } else if (Array.isArray(args)) {
    servers = args.map(function generate(server) {
      return address(server);
    });
  } else if ('object' === typeof args) {
    servers = Object.keys(args).map(function generate(server) {
      return address(server, args[server]);
    });
  } else if (args) {
    servers = [args].map(function generate(server) {
      return address(server);
    });
  } else {
    servers = [];
  }

  // Setup the data structure that we are going to return
  var data = {
      servers: servers
    , length: servers.length
    , weights: servers.reduce(function reduce(memo, server) {
        memo[server.string] = server.weight;
        return memo;
      }, {})
    , regular: servers.map(function regular(server) {
        return server.string;
      })
  };

  // Reduce the parsed values to simple list
  Object.keys(extensions).forEach(function extensions(key) {
    data[key] = servers.reduce(function reduce(memo, server) {
      memo[server.string] = server[key];
      return memo;
    }, {});
  });

  return data;
}

/**
 * Add a extra parser to connection-parser.
 *
 * @param {Function} parser
 * @api public
 */
parse.extension = function extension(name, parser) {
  if (name in extensions) return parse;

  extensions[name] = parser;
};

/**
 * Transforms the server in to an Object containing the port number and the
 * hostname.
 *
 * @param {Mixed} server
 * @param {Mixed} value
 * @returns {Object}
 * @api private
 */
function address(server, value) {
  if ('string' !== typeof server) {
    server.string = server.host +':'+ server.port;
    server.weight = +server.weight || typeof value === 'object'
      ? +value.weight || 1
      : 1;

    return server;
  }

  // Parse down the value's even further
  var pattern = server.split(':')
    , data = {
          host: pattern[0]
        , port: +pattern[1]
        , string: server
        , weight: (typeof value === 'object' ? +value.weight : +value) || 1
      };

  // Iterate over the extensions for the last piece of crushing
  Object.keys(extensions).forEach(function each(key) {
    var parser = extensions[key]
      , res = parser(data, value);

    if (res) data = res;
  });

  return data;
}

// Attach the address parser before we expose the module
parse.address = address;

/**
 * Expose the module
 */
module.exports = parse;


/***/ }),
/* 624 */
/***/ (function(module, exports) {

module.exports = {"name":"hashring","version":"3.2.0","author":"Arnout Kazemier","description":"A consistent hashring compatible with ketama hashing and python's hash_ring","main":"./index.js","keywords":["hashring","hash ring","hashing","hashvalue","ketama","hash_ring","hash","consistent hashing","libketama"],"license":"MIT","bugs":"http://github.com/3rd-Eden/node-hashring/issues","homepage":"http://github.com/3rd-Eden/node-hashring/","repository":{"type":"git","url":"http://github.com/3rd-Eden/node-hashring.git"},"dependencies":{"connection-parse":"0.0.x","simple-lru-cache":"0.0.x"},"devDependencies":{"assume":"1.2.x","benchmark":"1.0.x","devnull":"0.0.x","istanbul":"0.3.x","mocha":"2.2.x","pre-commit":"1.1.x"},"scripts":{"100%":"istanbul check-coverage --statements 100 --functions 100 --lines 100 --branches 100","test":"mocha tests/api.test.js tests/distribution.test.js","watch":"mocha --watch tests/api.test.js tests/distribution.test.js","coverage":"istanbul cover ./node_modules/.bin/_mocha -- tests/api.test.js tests/distribution.test.js","test-travis":"istanbul cover node_modules/.bin/_mocha --report lcovonly -- tests/api.test.js tests/distribution.test.js"}}

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var EventEmitter = __webpack_require__(138).EventEmitter
  , spawn = __webpack_require__(89).spawn
  , Utils = __webpack_require__(306)
  , util = __webpack_require__(157);

exports.IssueLog = IssueLog;         // connection issue handling
exports.Available = ping;            // connection availablity

function ping (host, callback) {
  var isWin = process.platform.indexOf('win') === 0; // win32 or win64
  var arg = isWin ? '-n' : '-c';
  var pong = spawn('ping', [arg, '3', host]); // only ping 3 times

  pong.stdout.on('data', function stdoutdata (data) {
    callback(false, data.toString().split('\n')[0].substr(14));
    pong.kill();
  });

  pong.stderr.on('data', function stderrdata (data) {
    callback(new Error(data.toString().split('\n')[0].substr(14)), false);
    pong.kill();
  });
}

function IssueLog (args) {
  this.config = args;
  this.messages = [];
  this.failed = false;
  this.locked = false;
  this.isScheduledToReconnect = false;

  this.totalFailures = 0;
  this.retry = 0;
  this.totalReconnectsAttempted = 0;
  this.totalReconnectsSuccess = 0;

  Utils.merge(this, args);
  EventEmitter.call(this);
}

util.inherits(IssueLog, EventEmitter);
var issues = IssueLog.prototype;

issues.log = function log (message) {
  var issue = this;

  this.failed = true;
  this.messages.push(message || 'No message specified');

  // All failures must occur within `failuresTimeout` ms from the initial
  // failure in order for node to be disconnected or removed.
  if (this.failures && this.failures == this.config.failures)
    this.failuresResetId = setTimeout(issue.failuresReset.bind(issue), this.failuresTimeout);

  if (this.failures && !this.locked) {
    this.locked = true;
    setTimeout(issue.attemptRetry.bind(issue), this.retry);
    return this.emit('issue', this.details);
  }

  if (this.failuresResetId) clearTimeout(this.failuresResetId);

  if (this.remove) return this.emit('remove', this.details);

  if (!this.isScheduledToReconnect) {
      this.isScheduledToReconnect = true;
      setTimeout(issue.attemptReconnect.bind(issue), this.reconnect);
  }
};

issues.failuresReset = function failuresReset() {
  //this.failures = this.config.failures;
  Utils.merge(this, JSON.parse(JSON.stringify(this.config)));
};

Object.defineProperty(issues, 'details', {
  get: function getDetails () {
    var res = {};

    res.server = this.server;
    res.tokens = this.tokens;
    res.messages = this.messages;

    if (this.failures) {
      res.failures = this.failures;
      res.totalFailures = this.totalFailures;
    } else {
      res.totalReconnectsAttempted = this.totalReconnectsAttempted;
      res.totalReconnectsSuccess = this.totalReconnectsSuccess;
      res.totalReconnectsFailed = this.totalReconnectsAttempted - this.totalReconnectsSuccess;
      res.totalDownTime = (res.totalReconnectsFailed * this.reconnect) + (this.totalFailures * this.retry);
    }

    return res;
  }
});

issues.attemptRetry = function attemptRetry () {
  this.totalFailures++;
  this.failures--;
  this.failed = false;
  this.locked = false;
};

issues.attemptReconnect = function attemptReconnect () {
  var issue = this;
  this.totalReconnectsAttempted++;
  this.emit('reconnecting', this.details);

  // Ping the server
  ping(this.tokens[1], function pingpong (err) {
    // still no access to the server
    if (err) {
      issue.messages.push(err.message || 'No message specified');
      return setTimeout(issue.attemptReconnect.bind(issue), issue.reconnect);
    }

    issue.emit('reconnected', issue.details);

    issue.totalReconnectsSuccess++;
    issue.messages.length = 0;
    issue.failed = false;
    issue.isScheduledToReconnect = false;

    // we connected again, so we are going through the whole cycle again
    Utils.merge(issue, JSON.parse(JSON.stringify(issue.config)));
  });
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)))

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var retry = __webpack_require__(627)
  , ms = __webpack_require__(630);

/**
 * A net.Stream connection pool.
 *
 * @constructor
 * @param {Number} limit Size of the connection pool.
 * @param {Function} builder Stream factory.
 * @param {Object} options Configuration options.
 * @api public
 */
function Manager(limit, builder, options) {
  options = options || {};

  if ('object' === typeof builder) {
    options = builder;
    builder = null;
  }

  this.limit = +limit || 20;                        // Defaults to 20 connections max.
  this.pool = [];                                   // Contains the active connections.
  this.pending = 0;                                 // Connecting connections.
  this.generator = null;                            // Stream generator.
  this.retries = options.retries || 5;              // Max retries for each #pull.
  this.factor = options.factor || 3;                // Exponential backoff factor.
  this.minTimeout = ms(options.min || '1 seconds'); // Minimum delay.
  this.maxTimeout = ms(options.max || '60 seconds');// Maximum delay.
  this.randomize = 'randomize' in options           // Randomize the retry timeout.
    ? options.randomize
    : true;

  // Some stats that can be used for metrics.
  this.metrics = {
      allocations: 0
    , releases: 0
  };

  if (builder) this.factory(builder);
}

Manager.prototype.__proto__ = __webpack_require__(138).EventEmitter.prototype;

/**
 * Add a stream generator so we can generate streams for the pool.
 *
 * @param {Function} builder Function that pre-configures a stream.
 * @api public
 */
Manager.prototype.factory = function factory(builder) {
  if (typeof builder !== 'function') {
    throw new Error('The #factory requires a function.');
  }

  this.generator = builder;
  return this;
};

/**
 * Start listening to events that could influence the state of the connection.
 *
 * @param {net.Connection} net The connection.
 * @api private
 */
Manager.prototype.listen = function listen(net) {
  if (!net) return this;

  var self = this;

  /**
   * Simple helper function that allows us to automatically remove the
   * connection from the pool when we are unable to connect using it.
   *
   * @param {Error} err Optional error.
   * @api private
   */
  function regenerate(err) {
    net.destroySoon();

    self.remove(net);

    net.removeListener('timeout', regenerate);
    net.removeListener('error', regenerate);
    net.removeListener('end', regenerate);

    if (err) self.emit('error', err);
  }

  // Listen for events that would mess up the connection.
  net.once('timeout', regenerate)
     .once('error', regenerate)
     .once('end', regenerate);

  return this;
};

/**
 * A fault tolerant connection allocation wrapper.
 *
 * @param {Function} fn Callback that receives a working connection.
 * @api public
 */
Manager.prototype.pull = function pull(fn) {
  var operation = retry.operation({
          retries: this.retries
        , factor: this.factor
        , minTimeout: this.minTimeout
        , maxTimeout: this.maxTimeout
        , randomize: this.randomize
      })
    , self = this;

  /**
   * Small wrapper around pulling a connection.
   *
   * @param {Error} err Optional error argument.
   * @param {Socket} connection A working connection.
   * @api private
   */
  function allocate(err, connection) {
    if (operation.retry(err)) return;

    fn(err, connection);
  }

  operation.attempt(function attempt() {
    self.allocate(allocate);
  });

  return this;
};

/**
 * Allocate a new connection from the connection pool, this can be done async
 * that's why we use a error first callback pattern.
 *
 * @param {Function} fn
 * @api public
 */
Manager.prototype.allocate = function allocate(fn) {
  if (!this.generator) {
    fn(new Error('Specify a stream #factory'));
    return this;
  }

  /**
   * Two helper functions that allows us to correctly call the callback with
   * the correct arguments when we generate a new connection as the connection
   * should be emitting 'connect' before we can use it. But it can also emit
   * error if it fails to connect, or times in so doing.
   *
   * @param {Error} err Optional error argument.
   * @api private
   */
  function either(err) {
    this.removeListener('error', either);
    this.removeListener('connect', either);
    this.removeListener('timeout', timeout);

    // Add to the pool
    if (!err) self.pool.push(this);
    self.pending--;

    fn(err, this);
  }

  /**
   * Listen to timeout events.
   *
   * @api private
   */
  function timeout() {
    this.removeListener('timeout', timeout);
    self.pending--;
    fn(new Error('Timed out while trying to establish connection'), this);
  }

  var probabilities = []
    , self = this
    , total, i, probability, connection;

  i = total = this.pool.length;

  // increase the allocation metric
  this.metrics.allocations++;

  // check the current pool if we already have a few connections available, so
  // we don't have to generate a new connection
  while (i--) {
    connection = this.pool[i];
    probability = this.isAvailable(connection);

    // we are sure this connection works
    if (probability === 100) {
      fn(undefined, connection);
      return this;
    }

    // no accurate match, add it to the queue as we can get the most likely
    // available connection
    probabilities.push({
        probability: probability
      , connection: connection
    });
  }

  // we didn't find a confident match, see if we are allowed to generate a fresh
  // connection
  if ((this.pool.length + this.pending) < this.limit) {
    // determine if the function expects a callback or not, this can be done by
    // checking the length of the given function, as the amount of args accepted
    // equals the length..
    if (this.generator.length === 0) {
      connection = this.generator();

      if (connection) {
        this.pending++;
        this.listen(connection);

        connection.on('error', either)
                  .on('connect', either)
                  .on('timeout', timeout);

        return this;
      }
    } else {
      return this.generator(function generate(err, connection) {
        if (err) return fn(err);
        if (!connection) return fn(new Error('The #factory failed to generate a stream'));

        self.pending++;
        self.listen(connection);

        return connection.on('error', either)
                         .on('connect', either)
                         .on('timeout', timeout);
      });
    }
  }

  // o, dear, we got issues.. we didn't find a valid connection and we cannot
  // create more.. so we are going to check if we might have semi valid
  // connection by sorting the probabilities array and see if it has
  // a probability above 60
  probability = probabilities.sort(function sort(a, b) {
    return a.probability - b.probability;
  }).pop();

  if (probability && probability.probability >= 60) {
    fn(undefined, probability.connection);
    return this;
  }

  // well, that didn't work out, so assume failure
  fn(new Error('The connection pool is full'));
  return this;
};

/**
 * Check if a connection is available for writing.
 *
 * @param {net.Connection} net The connection.
 * @param {Boolean} ignore Ignore closed or dead connections.
 * @returns {Number} Probability that his connection is available or will be.
 * @api private
 */
Manager.prototype.isAvailable = function isAvailable(net, ignore) {
  var readyState = net.readyState
    , writable = readyState === 'open' || readyState === 'writeOnly'
    , writePending = net._pendingWriteReqs || 0
    , writeQueue = net._writeQueue || []
    , writes = writeQueue.length || writePending;

  // If the stream is writable and we don't have anything pending we are 100%
  // sure that this stream is available for writing.
  if (writable && writes === 0) return 100;

  // The connection is already closed or has been destroyed, why on earth are we
  // getting it then, remove it from the pool and return 0.
  if (readyState === 'closed' || net.destroyed) {
    this.remove(net);
    return 0;
  }

  // If the stream isn't writable we aren't that sure..
  if (!writable) return 0;

  // The connection is still opening, so we can write to it in the future.
  if (readyState === 'opening') return 70;

  // We have some writes, so we are going to subtract that amount from our 100.
  if (writes < 100) return 100 - writes;

  // We didn't find any reliable states of the stream, so we are going to
  // assume something random, because we have no clue, so generate a random
  // number between 0 - 70.
  return Math.floor(Math.random() * 70);
};

/**
 * Release the connection from the connection pool.
 *
 * @param {Stream} net The connection.
 * @param {Boolean} hard Switch between destroySoon or destroy.
 * @returns {Boolean} Was the removal successful
 * @api private
 */
Manager.prototype.release = function release(net, hard) {
  var index = this.pool.indexOf(net);
  if (index === -1) return false;

  // Check if the stream is still open.
  if (net) {
    if (!hard) net.destroySoon();
    else net.destroy();

    // Remove it from the pool.
    this.pool.splice(index, 1);

    // Increase the releases metric.
    this.metrics.releases++;
  }

  return true;
};

// Alias remove to release.
Manager.prototype.remove = Manager.prototype.release;

/**
 * Free dead connections from the pool.
 *
 * @param {Number} keep the amount of connection to keep open
 * @param {Boolean} hard destroy all connections instead of destroySoon
 * @api public
 */
Manager.prototype.free = function free(keep, hard) {
  // Default to 0 if no arguments are supplied.
  keep = +keep || 0;

  // Create a back-up of the pool as we will be removing items from the array
  // and this could cause memory / socket leaks as we are unable to close some
  // connections in the array as the index has moved.
  var pool = this.pool.slice(0)
    , saved = 0;

  for (var i = 0, length = pool.length; i < length; i++) {
    var connection = pool[i]
      , probability = this.isAvailable(connection);

    // This is still a healthy connection, so try we probably just want to keep it.
    if (keep && saved < keep && probability === 100) {
      saved++;
      continue;
    }

    this.release(connection, hard);
  }

  // Clear the back-up
  pool.length = 0;

  // See how much connections are still available.
  return this.emit('free', saved, this.pool.length);
};

/**
 * Iterate over the different connection.
 *
 * @param {Function} callback
 * @param {Mixed} context
 * @api public
 */
Manager.prototype.forEach = function forEach(callback, context) {
  this.pool.forEach(callback, context);
  return this;
};

/**
 * Close the connection pool.
 *
 * @param {Boolean} hard destroy all connections
 * @api public
 */
Manager.prototype.end = function end(hard) {
  this.free(0, hard);

  return this.emit('end');
};

module.exports = Manager;


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(628);

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

var RetryOperation = __webpack_require__(629);

exports.operation = function(options) {
  var timeouts = exports.timeouts(options);
  return new RetryOperation(timeouts);
};

exports.timeouts = function(options) {
  if (options instanceof Array) {
    return [].concat(options);
  }

  var opts = {
    retries: 10,
    factor: 2,
    minTimeout: 1 * 1000,
    maxTimeout: Infinity,
    randomize: false
  };
  for (var key in options) {
    opts[key] = options[key];
  }

  if (opts.minTimeout > opts.maxTimeout) {
    throw new Error('minTimeout is greater than maxTimeout');
  }

  var timeouts = [];
  for (var i = 0; i < opts.retries; i++) {
    timeouts.push(this._createTimeout(i, opts));
  }

  // sort the array numerically ascending
  timeouts.sort(function(a,b) {
    return a - b;
  });

  return timeouts;
};

exports._createTimeout = function(attempt, opts) {
  var random = (opts.randomize)
    ? (Math.random() + 1)
    : 1;

  var timeout = Math.round(random * opts.minTimeout * Math.pow(opts.factor, attempt));
  timeout = Math.min(timeout, opts.maxTimeout);

  return timeout;
};

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(console) {function RetryOperation(timeouts) {
  this._timeouts = timeouts;
  this._fn = null;
  this._errors = [];
  this._attempts = 1;
  this._operationTimeout = null;
  this._operationTimeoutCb = null;
  this._timeout = null;
}
module.exports = RetryOperation;

RetryOperation.prototype.retry = function(err) {
  if (this._timeout) {
    clearTimeout(this._timeout);
  }

  if (!err) {
    return false;
  }

  this._errors.push(err);

  var timeout = this._timeouts.shift();
  if (timeout === undefined) {
    return false;
  }

  this._attempts++;

  var self = this;
  setTimeout(function() {
    self._fn(self._attempts);

    if (self._operationTimeoutCb) {
      self._timeout = setTimeout(function() {
        self._operationTimeoutCb(self._attempts);
      }, self._operationTimeout);
    }
  }, timeout);

  return true;
};

RetryOperation.prototype.attempt = function(fn, timeoutOps) {
  this._fn = fn;

  if (timeoutOps) {
    if (timeoutOps.timeout) {
      this._operationTimeout = timeoutOps.timeout;
    }
    if (timeoutOps.cb) {
      this._operationTimeoutCb = timeoutOps.cb;
    }
  }

  this._fn(this._attempts);

  var self = this;
  if (this._operationTimeoutCb) {
    this._timeout = setTimeout(function() {
      self._operationTimeoutCb();
    }, self._operationTimeout);
  }
};

RetryOperation.prototype.try = function(fn) {
  console.log('Using RetryOperation.try() is deprecated');
  this.attempt(fn);
};

RetryOperation.prototype.start = function(fn) {
  console.log('Using RetryOperation.start() is deprecated');
  this.attempt(fn);
};

RetryOperation.prototype.start = RetryOperation.prototype.try;

RetryOperation.prototype.errors = function() {
  return this._errors;
};

RetryOperation.prototype.attempts = function() {
  return this._attempts;
};

RetryOperation.prototype.mainError = function() {
  if (this._errors.length === 0) {
    return null;
  }

  var counts = {};
  var mainError = null;
  var mainErrorCount = 0;

  for (var i = 0; i < this._errors.length; i++) {
    var error = this._errors[i];
    var message = error.message;
    var count = (counts[message] || 0) + 1;

    counts[message] = count;

    if (count >= mainErrorCount) {
      mainError = error;
      mainErrorCount = count;
    }
  }

  return mainError;
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} options
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options){
  if ('string' === typeof val) return parse(val);
  if (!options) return +val;

  return options.long
    ? long(val)
    : short(val);
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  var match = /^((?:\d+)?\.?\d+) *(ms|seconds?|s|minutes?|m|hours?|h|days?|d|years?|y)?$/i.exec(str);
  if (!match) return;
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 's':
      return n * s;
    case 'ms':
      return n;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function short(ms) {
  if (ms >= d) return Math.round(ms / d) + 'd';
  if (ms >= h) return Math.round(ms / h) + 'h';
  if (ms >= m) return Math.round(ms / m) + 'm';
  if (ms >= s) return Math.round(ms / s) + 's';
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function long(ms) {
  if (ms == d) return Math.round(ms / d) + ' day';
  if (ms > d) return Math.round(ms / d) + ' days';
  if (ms == h) return Math.round(ms / h) + ' hour';
  if (ms > h) return Math.round(ms / h) + ' hours';
  if (ms == m) return Math.round(ms / m) + ' minute';
  if (ms > m) return Math.round(ms / m) + ' minutes';
  if (ms == s) return Math.round(ms / s) + ' second';
  if (ms > s) return Math.round(ms / s) + ' seconds';
  return ms + ' ms';
}


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var binding = __webpack_require__(632)('binding');
var assert = __webpack_require__(225);

/**
 * Compress asyncronous.
 * If input isn't a string or buffer, automatically convert to buffer by using
 * JSON.stringify.
 */
exports.compress = function (input, callback) {
  if (!(typeof (input) === 'string' || Buffer.isBuffer(input))) {
    return callback(new Error('input must be a String or a Buffer'));
  }

  binding.compress(input, callback);
};

exports.compressSync = function (input) {
  assert(typeof (input) === 'string' || Buffer.isBuffer(input), 'input must be a String or a Buffer');

  return binding.compressSync(input);
};

/**
 * Asyncronous decide if a buffer is compressed in a correct way.
 */
exports.isValidCompressed = binding.isValidCompressed;

exports.isValidCompressedSync = binding.isValidCompressedSync;

/**
 * Asyncronous uncompress previously compressed data.
 * A parser can be attached. If no parser is attached, return buffer.
 */
exports.uncompress = function (compressed, opts, callback) {
  if (!callback) {
    callback = opts;
  }

  if (!Buffer.isBuffer(compressed)) {
    return callback(new Error('input must be a Buffer'));
  }

  binding.uncompress(compressed, uncompressOpts(opts), callback);
};

exports.uncompressSync = function (compressed, opts) {
  assert(Buffer.isBuffer(compressed), 'input must be a Buffer');

  return binding.uncompressSync(compressed, uncompressOpts(opts));
};

function uncompressOpts (opts) {
  return (opts && typeof opts.asBuffer === 'boolean') ? opts : {asBuffer: true};
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(305).Buffer))

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, __filename) {/**
 * Module dependencies.
 */

var fs = __webpack_require__(89),
  path = __webpack_require__(191),
  fileURLToPath = __webpack_require__(633),
  join = path.join,
  dirname = path.dirname,
  exists =
    (fs.accessSync &&
      function(path) {
        try {
          fs.accessSync(path);
        } catch (e) {
          return false;
        }
        return true;
      }) ||
    fs.existsSync ||
    path.existsSync,
  defaults = {
    arrow: Object({"NODE_ENV":"production"}).NODE_BINDINGS_ARROW || ' → ',
    compiled: Object({"NODE_ENV":"production"}).NODE_BINDINGS_COMPILED_DIR || 'compiled',
    platform: process.platform,
    arch: process.arch,
    nodePreGyp:
      'node-v' +
      process.versions.modules +
      '-' +
      process.platform +
      '-' +
      process.arch,
    version: process.versions.node,
    bindings: 'bindings.node',
    try: [
      // node-gyp's linked version in the "build" dir
      ['module_root', 'build', 'bindings'],
      // node-waf and gyp_addon (a.k.a node-gyp)
      ['module_root', 'build', 'Debug', 'bindings'],
      ['module_root', 'build', 'Release', 'bindings'],
      // Debug files, for development (legacy behavior, remove for node v0.9)
      ['module_root', 'out', 'Debug', 'bindings'],
      ['module_root', 'Debug', 'bindings'],
      // Release files, but manually compiled (legacy behavior, remove for node v0.9)
      ['module_root', 'out', 'Release', 'bindings'],
      ['module_root', 'Release', 'bindings'],
      // Legacy from node-waf, node <= 0.4.x
      ['module_root', 'build', 'default', 'bindings'],
      // Production "Release" buildtype binary (meh...)
      ['module_root', 'compiled', 'version', 'platform', 'arch', 'bindings'],
      // node-qbs builds
      ['module_root', 'addon-build', 'release', 'install-root', 'bindings'],
      ['module_root', 'addon-build', 'debug', 'install-root', 'bindings'],
      ['module_root', 'addon-build', 'default', 'install-root', 'bindings'],
      // node-pre-gyp path ./lib/binding/{node_abi}-{platform}-{arch}
      ['module_root', 'lib', 'binding', 'nodePreGyp', 'bindings']
    ]
  };

/**
 * The main `bindings()` function loads the compiled bindings for a given module.
 * It uses V8's Error API to determine the parent filename that this function is
 * being invoked from, which is then used to find the root directory.
 */

function bindings(opts) {
  // Argument surgery
  if (typeof opts == 'string') {
    opts = { bindings: opts };
  } else if (!opts) {
    opts = {};
  }

  // maps `defaults` onto `opts` object
  Object.keys(defaults).map(function(i) {
    if (!(i in opts)) opts[i] = defaults[i];
  });

  // Get the module root
  if (!opts.module_root) {
    opts.module_root = exports.getRoot(exports.getFileName());
  }

  // Ensure the given bindings name ends with .node
  if (path.extname(opts.bindings) != '.node') {
    opts.bindings += '.node';
  }

  // https://github.com/webpack/webpack/issues/4175#issuecomment-342931035
  var requireFunc =
     true
      ? require
      : require;

  var tries = [],
    i = 0,
    l = opts.try.length,
    n,
    b,
    err;

  for (; i < l; i++) {
    n = join.apply(
      null,
      opts.try[i].map(function(p) {
        return opts[p] || p;
      })
    );
    tries.push(n);
    try {
      b = opts.path ? requireFunc.resolve(n) : requireFunc(n);
      if (!opts.path) {
        b.path = n;
      }
      return b;
    } catch (e) {
      if (e.code !== 'MODULE_NOT_FOUND' &&
          e.code !== 'QUALIFIED_PATH_RESOLUTION_FAILED' &&
          !/not find/i.test(e.message)) {
        throw e;
      }
    }
  }

  err = new Error(
    'Could not locate the bindings file. Tried:\n' +
      tries
        .map(function(a) {
          return opts.arrow + a;
        })
        .join('\n')
  );
  err.tries = tries;
  throw err;
}
module.exports = exports = bindings;

/**
 * Gets the filename of the JavaScript file that invokes this function.
 * Used to help find the root directory of a module.
 * Optionally accepts an filename argument to skip when searching for the invoking filename
 */

exports.getFileName = function getFileName(calling_file) {
  var origPST = Error.prepareStackTrace,
    origSTL = Error.stackTraceLimit,
    dummy = {},
    fileName;

  Error.stackTraceLimit = 10;

  Error.prepareStackTrace = function(e, st) {
    for (var i = 0, l = st.length; i < l; i++) {
      fileName = st[i].getFileName();
      if (fileName !== __filename) {
        if (calling_file) {
          if (fileName !== calling_file) {
            return;
          }
        } else {
          return;
        }
      }
    }
  };

  // run the 'prepareStackTrace' function above
  Error.captureStackTrace(dummy);
  dummy.stack;

  // cleanup
  Error.prepareStackTrace = origPST;
  Error.stackTraceLimit = origSTL;

  // handle filename that starts with "file://"
  var fileSchema = 'file://';
  if (fileName.indexOf(fileSchema) === 0) {
    fileName = fileURLToPath(fileName);
  }

  return fileName;
};

/**
 * Gets the root directory of a module, given an arbitrary filename
 * somewhere in the module tree. The "root directory" is the directory
 * containing the `package.json` file.
 *
 *   In:  /home/nate/node-native-module/lib/index.js
 *   Out: /home/nate/node-native-module
 */

exports.getRoot = function getRoot(file) {
  var dir = dirname(file),
    prev;
  while (true) {
    if (dir === '.') {
      // Avoids an infinite loop in rare cases, like the REPL
      dir = process.cwd();
    }
    if (
      exists(join(dir, 'package.json')) ||
      exists(join(dir, 'node_modules'))
    ) {
      // Found the 'package.json' file or 'node_modules' dir; we're done
      return dir;
    }
    if (prev === dir) {
      // Got to the top
      throw new Error(
        'Could not find module root given file: "' +
          file +
          '". Do you have a `package.json` file? '
      );
    }
    // Try the parent dir next
    prev = dir;
    dir = join(dir, '..');
  }
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48), "/index.js"))

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var sep = __webpack_require__(191).sep || '/';

/**
 * Module exports.
 */

module.exports = fileUriToPath;

/**
 * File URI to Path function.
 *
 * @param {String} uri
 * @return {String} path
 * @api public
 */

function fileUriToPath (uri) {
  if ('string' != typeof uri ||
      uri.length <= 7 ||
      'file://' != uri.substring(0, 7)) {
    throw new TypeError('must pass in a file:// URI to convert to a file path');
  }

  var rest = decodeURI(uri.substring(7));
  var firstSlash = rest.indexOf('/');
  var host = rest.substring(0, firstSlash);
  var path = rest.substring(firstSlash + 1);

  // 2.  Scheme Definition
  // As a special case, <host> can be the string "localhost" or the empty
  // string; this is interpreted as "the machine from which the URL is
  // being interpreted".
  if ('localhost' == host) host = '';

  if (host) {
    host = sep + sep + host;
  }

  // 3.2  Drives, drive letters, mount points, file system root
  // Drive letters are mapped into the top of a file URI in various ways,
  // depending on the implementation; some applications substitute
  // vertical bar ("|") for the colon after the drive letter, yielding
  // "file:///c|/tmp/test.txt".  In some cases, the colon is left
  // unchanged, as in "file:///c:/tmp/test.txt".  In other cases, the
  // colon is simply omitted, as in "file:///c/tmp/test.txt".
  path = path.replace(/^(.+)\|/, '$1:');

  // for Windows, we need to invert the path separators from what a URI uses
  if (sep == '\\') {
    path = path.replace(/\//g, '\\');
  }

  if (/^.+\:/.test(path)) {
    // has Windows drive at beginning of path
  } else {
    // unix path…
    path = sep + path;
  }

  return host + path;
}


/***/ }),
/* 634 */
/***/ (function(module, exports) {

module.exports = {"$schemaref":"web-1.0.schema.json","degradation":{"serviceUrl":"https://www.espn.com/watchespn/degradation"},"iconMap":{"subcategories[0]?.leagueId eq 10":"http://a.espncdn.com/combiner/i?img=/i/teamlogos/leagues/500/mlb.png&w=100&h=100&transparent=true","subcategories[0]?.leagueId eq 28":"http://a.espncdn.com/combiner/i?img=/i/teamlogos/leagues/500/nfl.png&w=100&h=100&transparent=true","subcategories[0]?.leagueId eq 46":"http://a.espncdn.com/combiner/i?img=/i/teamlogos/leagues/500/nba.png&w=100&h=100&transparent=true","subcategories[0]?.leagueId eq 90":"http://a.espncdn.com/combiner/i?img=/i/teamlogos/leagues/500/nhl.png&w=100&h=100&transparent=true","program?.isStudio eq true":"audio02","categories[0]?.sportId eq 1 or categories[0]?.sportId eq 100":"baseball","categories[0]?.sportId eq 40":"basketball","categories[0]?.sportId eq 200":"cricket","categories[0]?.sportId eq 8367":"esports","categories[0]?.sportId eq 1000":"boxing","categories[0]?.sportId eq 20 and subcategories[0]?.leagueId eq 23":"football-college","categories[0]?.sportId eq 20":"football","categories[0]?.sportId eq 70":"hockey","categories[0]?.sportId eq 3520 and subcategories[0]?.leagueId eq 3520":"poker","categories[0]?.sportId eq 500":"lacrosse","categories[0]?.sportId eq 3301":"mma","categories[0]?.sportId eq 2000 and subcategories[0]?.leagueId eq 2020":"nascar","categories[0]?.sportId eq 300":"rugby","categories[0]?.sportId eq 600":"soccer","categories[0]?.sportId eq 850":"tennis","categories[0]?.sportId eq 1700":"track-field","categories[0]?.sportId eq 400":"volleyball","categories[0]?.sportId eq 3190 and subcategories[0]?.leagueId eq 8098":"xgames"},"gated":false}

/***/ }),
/* 635 */
/***/ (function(module, exports) {

module.exports = {"$schemaref":"web-1.0.schema.json","degradation":{"serviceUrl":"https://www.espn.com/watchespn/degradation"},"iconMap":{"subcategories[0]?.leagueId eq 10":"http://a.espncdn.com/combiner/i?img=/i/teamlogos/leagues/500/mlb.png&w=100&h=100&transparent=true","subcategories[0]?.leagueId eq 28":"http://a.espncdn.com/combiner/i?img=/i/teamlogos/leagues/500/nfl.png&w=100&h=100&transparent=true","subcategories[0]?.leagueId eq 46":"http://a.espncdn.com/combiner/i?img=/i/teamlogos/leagues/500/nba.png&w=100&h=100&transparent=true","subcategories[0]?.leagueId eq 90":"http://a.espncdn.com/combiner/i?img=/i/teamlogos/leagues/500/nhl.png&w=100&h=100&transparent=true","program?.isStudio eq true":"audio02","categories[0]?.sportId eq 1 or categories[0]?.sportId eq 100":"baseball","categories[0]?.sportId eq 40":"basketball","categories[0]?.sportId eq 200":"cricket","categories[0]?.sportId eq 8367":"esports","categories[0]?.sportId eq 1000":"boxing","categories[0]?.sportId eq 20 and subcategories[0]?.leagueId eq 23":"football-college","categories[0]?.sportId eq 20":"football","categories[0]?.sportId eq 70":"hockey","categories[0]?.sportId eq 3520 and subcategories[0]?.leagueId eq 3520":"poker","categories[0]?.sportId eq 500":"lacrosse","categories[0]?.sportId eq 3301":"mma","categories[0]?.sportId eq 2000 and subcategories[0]?.leagueId eq 2020":"nascar","categories[0]?.sportId eq 300":"rugby","categories[0]?.sportId eq 600":"soccer","categories[0]?.sportId eq 850":"tennis","categories[0]?.sportId eq 1700":"track-field","categories[0]?.sportId eq 400":"volleyball","categories[0]?.sportId eq 3190 and subcategories[0]?.leagueId eq 8098":"xgames"},"gated":false}

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(637),
    getMatchData = __webpack_require__(657),
    matchesStrictComparable = __webpack_require__(316);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(209),
    baseIsEqual = __webpack_require__(311);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(130);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 639 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 640 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 641 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(130),
    Map = __webpack_require__(197),
    MapCache = __webpack_require__(195);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(209),
    equalArrays = __webpack_require__(312),
    equalByTag = __webpack_require__(645),
    equalObjects = __webpack_require__(647),
    getTag = __webpack_require__(201),
    isArray = __webpack_require__(32),
    isBuffer = __webpack_require__(141),
    isTypedArray = __webpack_require__(142);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 644 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(108),
    Uint8Array = __webpack_require__(313),
    eq = __webpack_require__(109),
    equalArrays = __webpack_require__(312),
    mapToArray = __webpack_require__(646),
    setToArray = __webpack_require__(210);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 646 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(648);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(649),
    getSymbols = __webpack_require__(650),
    keys = __webpack_require__(140);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(286),
    isArray = __webpack_require__(32);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(651),
    stubArray = __webpack_require__(652);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 651 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 652 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 653 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 654 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(71),
    isLength = __webpack_require__(198),
    isObjectLike = __webpack_require__(59);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(280);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(107)(module)))

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(315),
    keys = __webpack_require__(140);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(311),
    get = __webpack_require__(659),
    hasIn = __webpack_require__(284),
    isKey = __webpack_require__(194),
    isStrictComparable = __webpack_require__(315),
    matchesStrictComparable = __webpack_require__(316),
    toKey = __webpack_require__(110);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(193);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(291),
    basePropertyDeep = __webpack_require__(661),
    isKey = __webpack_require__(194),
    toKey = __webpack_require__(110);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(193);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(318);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Authenticator = exports.IpAuthenticator = exports.AdobePassAuthenticator = undefined;

var _AdobePassAuthenticator = __webpack_require__(664);

var _AdobePassAuthenticator2 = _interopRequireDefault(_AdobePassAuthenticator);

var _IpAuthenticator = __webpack_require__(667);

var _IpAuthenticator2 = _interopRequireDefault(_IpAuthenticator);

var _Authenticator = __webpack_require__(211);

var _Authenticator2 = _interopRequireDefault(_Authenticator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.AdobePassAuthenticator = _AdobePassAuthenticator2.default;
exports.IpAuthenticator = _IpAuthenticator2.default;
exports.Authenticator = _Authenticator2.default;

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(320);

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = __webpack_require__(321);

var _lodash4 = _interopRequireDefault(_lodash3);

var _lodash5 = __webpack_require__(665);

var _lodash6 = _interopRequireDefault(_lodash5);

var _loglevel = __webpack_require__(666);

var _loglevel2 = _interopRequireDefault(_loglevel);

var _events = __webpack_require__(138);

var _events2 = _interopRequireDefault(_events);

var _Authenticator = __webpack_require__(211);

var _Authenticator2 = _interopRequireDefault(_Authenticator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// log.enableAll();
// log.setLevel('warn');

var chunk = function chunk(arr, size) {
    return arr.length ? [arr.slice(0, size)].concat(_toConsumableArray(chunk(arr.slice(size), size))) : [];
};

/**
 * Adobe Pass implementation of the abstract Authenticator class.
 * @class AdobePassAuthenticator
 * @augments Authenticator
 */
function AdobePassAuthenticator() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        elementId = _ref.elementId,
        _ref$redirectUrl = _ref.redirectUrl,
        redirectUrl = _ref$redirectUrl === undefined ? '' : _ref$redirectUrl,
        _ref$environment = _ref.environment,
        environment = _ref$environment === undefined ? AdobePassAuthenticator.Environment.PRODUCTION : _ref$environment,
        _ref$refreshless = _ref.refreshless,
        refreshless = _ref$refreshless === undefined ? false : _ref$refreshless,
        _ref$displayProviderD = _ref.displayProviderDialogImpl,
        displayProviderDialogImpl = _ref$displayProviderD === undefined ? function () {
        return new Promise();
    } : _ref$displayProviderD,
        _ref$errorEventHandle = _ref.errorEventHandlerName,
        errorEventHandlerName = _ref$errorEventHandle === undefined ? 'AEErrorHandler' : _ref$errorEventHandle;

    if (!(this instanceof AdobePassAuthenticator)) {
        return new AdobePassAuthenticator({
            elementId: elementId,
            redirectUrl: redirectUrl,
            environment: environment,
            refreshless: refreshless,
            displayProviderDialogImpl: displayProviderDialogImpl
        });
    }

    (0, _lodash2.default)(this, _events2.default.prototype, _Authenticator2.default.prototype);

    var REQUESTOR = 'ESPN';

    var JS_URLS = {};
    JS_URLS[AdobePassAuthenticator.Environment.PRODUCTION] = 'https://entitlement.auth.adobe.com/entitlement/v4/AccessEnabler.js';
    JS_URLS[AdobePassAuthenticator.Environment.STAGING] = 'https://entitlement.auth-staging.adobe.com/entitlement/v4/AccessEnabler.js';
    var JS_ELEMENT_ID = 'ae_js';

    var SOFTWARE_STATEMENTS = {};
    SOFTWARE_STATEMENTS[AdobePassAuthenticator.Environment.PRODUCTION] = 'eyJhbGciOiJSUzI1NiJ9.eyJzdWIiOiIyZGJmZWM4My03OWE1LTQyNzEtYTVmZC04NTZjYTMxMjRjNjMiLCJuYmYiOjE1NDAyMTI3NjEsImlzcyI6ImF1dGguYWRvYmUuY29tIiwiaWF0IjoxNTQwMjEyNzYxfQ.yaK3r4AI2uLVvsyN1GLzqzgzRlxMPtasSaiYYBV0wIstqih5tvjTmeoLmi8Xy9Kp_U7Md-bOffwiyK3srHkpUkhhwXLH2x6RPjmS1tPmhaG7-3LBcHTf2ySPvXhVf7cN4ngldawK4tdtLtsw6rF_JoZE2yaC6XbS2F51nXSFEDDnOQWIHEQRG3aYAj-38P2CLGf7g-Yfhbp5cKXeksHHQ90u3eOO4WH0EAjc9oO47h33U8KMEXxJbvjV5J8Va2G2fQSgLDZ013NBI3kQnE313qgqQh2feQILkyCENpB7g-TVBreAjOaH1fU471htSoGGYepcAXv-UDtpgitDiLy7CQ'; // eslint-disable-line
    SOFTWARE_STATEMENTS[AdobePassAuthenticator.Environment.STAGING] = 'eyJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJhMmRjNjgyMC1kZGNkLTQ4NGEtOTdlNS0xZjJiZmQzOGI4YzgiLCJuYmYiOjE1NDAyMjIwNTksImlzcyI6ImF1dGguYWRvYmUuY29tIiwiaWF0IjoxNTQwMjIyMDU5fQ.YgX4ecGCgLCaZS7uwRQYZ8UR5EwT7GIl-glFbwU122bO1JYZSmbIX8YJSfmYth_scyeg-15BYWNftV9lOcmCe8VwIsQMJMIZKaF8qSIj5OfuTOBpNZNBpDAp5dC3zG7Zp1xLe3z-T0Y18-0BGj2yhGcJxBz4gtLXQ30Bw0LEIJ89nXCQaXFTq9N6zhDzMfkFJNnSNEvEmvcQqB4bFPIqn2is8427oQDU4D0XYvvTtx9eb5hmzKc9MbBG-8KRBA62BqdHomA5UA4kBYJKpe-8B2hO07Adi2bZoo5wP_VLNAnAxANWNXaGQYHMDjHDrHbbvuKHBudHgKxAuKpIdC7UrA'; // eslint-disable-line
    var _softwareStatement = SOFTWARE_STATEMENTS[environment];

    var _accessEnablerJsUrl = JS_URLS[environment];
    var _redirectUrl = redirectUrl;
    var _accessEnabler = null;
    var _resolveInitialize = null;
    var _resolveAuthentication = null;
    var _resolveDeauthentication = null;
    var _resolveAuthorization = null;
    var _resolvePreauthorizes = [];
    var _resolveAuthenticationInfo = null;
    var _resolveMetadataStatus = {};
    var _resolveSelectProvider = null;
    var _errorEventCallback = null;

    var _isAuthenticated = false;

    function entitlementLoaded() {
        _accessEnabler.bind('errorEvent', errorEventHandlerName);

        var requestorConfigInfo = refreshless ? {
            callSetConfig: true,
            backgroundLogin: false,
            backgroundLogout: true
        } : null;
        _accessEnabler.setRequestor(REQUESTOR, null, requestorConfigInfo);
        if (_resolveInitialize) {
            _resolveInitialize(true);
        }
    }

    function setAuthenticationStatus(isAuthenticated, errorCode) {
        _loglevel2.default.debug('AdobePassAuthenticator.setAuthenticationStatus', isAuthenticated, errorCode);
        _isAuthenticated = !!isAuthenticated;

        if (_resolveAuthentication) {
            _resolveAuthentication(_isAuthenticated);
            _resolveAuthentication = null;
        }

        if (_resolveSelectProvider) {
            _resolveSelectProvider(_isAuthenticated);
            _resolveSelectProvider = null;
        }

        if (_resolveDeauthentication) {
            _resolveDeauthentication(_isAuthenticated);
            _resolveDeauthentication = null;
        }
    }

    function setMetadataStatus(key, encrypted, data) {
        _loglevel2.default.debug('AdobePassAuthenticator.setMetadataStatus', key, data);
        if (_resolveMetadataStatus[key]) {
            _resolveMetadataStatus[key](data);
        }
        _resolveMetadataStatus[key] = null;
    }

    function _displayProviderDialog(providers) {
        _loglevel2.default.debug('AdobePassAuthenticator.displayProviderDialog', providers);
        if (_resolveAuthentication) {
            _resolveAuthentication(_isAuthenticated);
            _resolveAuthentication = null;
        }
        displayProviderDialogImpl(providers);
        /*
        .then(function(provider) {
         _accessEnabler.setSelectedProvider(provider);
         });
         */
    }

    function setToken(resourceId, token) {
        _loglevel2.default.debug('Requested resource: ' + resourceId + ' tokenResult: ' + token);
        if (_resolveAuthorization) {
            _resolveAuthorization({ resourceId: resourceId, token: token });
        }
    }

    function tokenRequestFailed(resourceId, errorCode, errorDetails) {
        if (errorCode != null || errorDetails != null) {
            _loglevel2.default.error('Failure to authorize: ' + errorDetails);
            if (_resolveAuthorization) {
                _resolveAuthorization({ errorCode: errorCode, errorDetails: errorDetails });
            }
        }
    }

    function setConfig() /* configXml */{
        // log.debug('setConfig', configXml);
    }

    function sendTrackingData(trackingEventType, trackingData) {
        if (trackingEventType === 'authenticationDetection') {
            var data = {
                success: trackingData[0],
                mvpd: trackingData[1],
                guid: trackingData[2],
                isTokenCached: trackingData[3],
                deviceType: trackingData[4],
                clientType: trackingData[5],
                os: trackingData[6]
            };

            _loglevel2.default.debug('AdobePassAuthenticator.sendTrackingData', trackingEventType, data);
        }
    }

    function preauthorizedResources(authorizedResources) {
        _loglevel2.default.debug('AdobePassAuthenticator.preauthorizedResources', authorizedResources);

        var completion = _resolvePreauthorizes.shift();
        if (completion) completion(authorizedResources);
    }

    function embedJs() {
        var scriptTag = document.createElement('script');
        scriptTag.id = JS_ELEMENT_ID;
        scriptTag.type = 'text/javascript';
        scriptTag.async = true;
        scriptTag.src = _accessEnablerJsUrl;
        scriptTag.addEventListener('load', function () {
            _accessEnabler = new window.Adobe.AccessEnabler(_softwareStatement);
        });
        document.getElementsByTagName('head')[0].appendChild(scriptTag);
    }

    function selectedProvider(result) {
        var mvpd = result.MVPD,
            aeState = result.AE_State;

        if (_resolveAuthenticationInfo) _resolveAuthenticationInfo({ mvpd: mvpd, aeState: aeState });
    }

    function AEErrorHandler(errorData) {
        if (typeof _errorEventCallback === 'function') {
            _errorEventCallback(errorData);
        }
    }

    function bindCallbacks() {
        global.entitlementLoaded = entitlementLoaded;
        global.setAuthenticationStatus = setAuthenticationStatus;
        global.setMetadataStatus = setMetadataStatus;
        global.displayProviderDialog = _displayProviderDialog;
        global.setConfig = setConfig;
        global.sendTrackingData = sendTrackingData;
        global.preauthorizedResources = preauthorizedResources;
        global.selectedProvider = selectedProvider;
        global.setToken = setToken;
        global.tokenRequestFailed = tokenRequestFailed;
        global[errorEventHandlerName] = AEErrorHandler;
    }

    return (0, _lodash2.default)(this, {
        /**
         * Initializes the Adobe Pass client
         * @function initialize
         * @memberof AdobePassAuthenticator#
         * @param {Callback} callback
         * @returns {Promise.<null>}
         */
        initialize: function initialize(callback) {
            _loglevel2.default.debug('AdobePassAuthenticator.initialize');

            return new Promise(function (resolve) {
                _resolveInitialize = function _resolveInitialize(isInitialized) {
                    resolve(isInitialized);
                    if ((0, _lodash4.default)(callback)) {
                        callback(null, isInitialized);
                    }
                };
                bindCallbacks();
                embedJs();
            });
        },


        /**
         * @function isAuthenticated
         * @override
         * @memberof AdobePassAuthenticator#
         * @returns {Boolean}
         */
        isAuthenticated: function isAuthenticated() {
            return _isAuthenticated;
        },


        /**
         * @function setRedirectUrl
         * @override
         * @memberof AdobePassAuthenticator#
         * @param {String} a redirect url
         * @returns boolean
         */
        setRedirectUrl: function setRedirectUrl(url) {
            if (typeof url === 'string') {
                _redirectUrl = url;
                return true;
            }
            return false;
        },


        /**
         * @function checkAuthentication
         * @override
         * @memberof AdobePassAuthenticator#
         * @param {Callback} callback
         * @returns {Promise.<Boolean>}
         */
        checkAuthentication: function checkAuthentication(callback) {
            _loglevel2.default.debug('AdobePassAuthenticator.checkAuthentication');

            return new Promise(function (resolve) {
                _resolveAuthentication = function _resolveAuthentication(isAuthenticated) {
                    resolve(isAuthenticated);
                    if ((0, _lodash4.default)(callback)) {
                        callback(null, isAuthenticated);
                    }
                };
                _accessEnabler.checkAuthentication();
            });
        },


        /**
         * @function authenticate
         * @override
         * @memberof AdobePassAuthenticator#
         * @param {String} identity
         * @param {Callback} callback
         * @param {String} optional redirect url
         * @returns {Promise.<Boolean>}
         */
        authenticate: function authenticate(identity, callback) {
            var url = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _redirectUrl;

            _loglevel2.default.debug('AdobePassClient.authenticate ' + identity);

            return new Promise(function (resolve) {
                _resolveAuthentication = function _resolveAuthentication(isAuthenticated) {
                    resolve(isAuthenticated);
                    if ((0, _lodash4.default)(callback)) {
                        callback(null, isAuthenticated);
                    }
                };
                _accessEnabler.getAuthentication(url);
            });
        },


        /**
         * @function deauthenticate
         * @override
         * @memberof AdobePassAuthenticator#
         * @param {Callback} callback
         * @returns {Promise.<Boolean>}
         */
        deauthenticate: function deauthenticate(callback) {
            _loglevel2.default.debug('AdobePassAuthenticator.deauthenticate');

            return new Promise(function (resolve) {
                _resolveDeauthentication = function _resolveDeauthentication(isAuthenticated) {
                    resolve(isAuthenticated);
                    if ((0, _lodash4.default)(callback)) {
                        callback(null, isAuthenticated);
                    }
                };
                _accessEnabler.logout();
            });
        },


        /**
         * @function getAuthenticationInfo
         * @override
         * @memberof AdobePassAuthenticator#
         * @param {Callback} callback
         * @returns {Promise.<Boolean>}
         */
        getAuthenticationInfo: function getAuthenticationInfo(callback) {
            _loglevel2.default.debug('AdobePassAuthenticator.getAuthenticationInfo');

            var getAuthenticationInfoPromise = new Promise(function (resolve) {
                _resolveAuthenticationInfo = resolve;
            });
            _accessEnabler.getSelectedProvider();

            if ((0, _lodash4.default)(callback)) {
                callback(null, true);
            }

            return getAuthenticationInfoPromise;
        },


        /**
         * @function getMetadata
         * @override
         * @memberof AdobePassAuthenticator#
         * @param {Callback} callback
         * @returns {Promise.<Boolean>}
         */
        getMetadata: function getMetadata(key) {
            _loglevel2.default.debug('AdobePassAuthenticator.getMetadata');
            var getMetadataPromise = new Promise(function (resolve) {
                if (key) {
                    _resolveMetadataStatus[key] = resolve;
                } else {
                    resolve(null);
                }
            });
            if (key) {
                _accessEnabler.getMetadata(key);
            }
            return getMetadataPromise;
        },


        /**
         * @function authorize
         * @override
         * @memberof AdobePassAuthenticator#
         * @param {Callback} callback
         * @returns {Promise.<Boolean>}
         */
        authorize: function authorize(resource, callback) {
            _loglevel2.default.debug('AdobePassClient.authorize ' + resource);

            return new Promise(function (resolve) {
                _resolveAuthorization = function _resolveAuthorization(authzResponse) {
                    resolve(authzResponse);
                    if ((0, _lodash4.default)(callback)) {
                        callback(null, authzResponse);
                    }
                };
                _accessEnabler.getAuthorization(resource);
            });
        },


        /**
         * @function checkPreauthorizedResources
         * @memberof AdobePassAuthenticator#
         * @param {}
         * @returns {Promise.<Array>}
         */
        checkPreauthorizedResources: function checkPreauthorizedResources() {
            var _this = this;

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            var hasCallback = (0, _lodash4.default)(args[args.length - 1]);
            var resources = hasCallback ? args.slice(0, args.length - 1) : args;
            var callback = hasCallback ? args[args.length - 1] : null;

            if (_isAuthenticated !== true) {
                if ((0, _lodash4.default)(callback)) {
                    callback(null, []);
                }
                return Promise.resolve([]);
            }

            var completions = [];

            var groupedResources = chunk(resources, 5);

            var promises = groupedResources.map(function (resourceGroup) {
                return new Promise(function (resolve) {
                    var completion = function completion(preauthzResources) {
                        resolve(preauthzResources);
                    };

                    completions.push(completion);

                    _accessEnabler.checkPreauthorizedResources(resourceGroup);
                }).catch(function () {
                    return [];
                });
            });

            _resolvePreauthorizes = completions;

            return Promise.all(promises).then(function (results) {
                var result = results.reduce(function (acc, val) {
                    return acc.concat(val);
                }, []);

                result.forEach(function (resource) {
                    _this.emit(AdobePassAuthenticator.EventType.PREAUTHORIZED, resource);
                });

                (0, _lodash6.default)(resources, result).forEach(function (resource) {
                    _this.emit(AdobePassAuthenticator.EventType.NOT_PREAUTHORIZED, resource);
                });

                if ((0, _lodash4.default)(callback)) {
                    callback(null, result);
                }
                return result;
            });
        },
        selectProvider: function selectProvider(provider) {
            _accessEnabler.setSelectedProvider(provider.ID);
            return new Promise(function (resolve) {
                if (refreshless) {
                    _resolveSelectProvider = resolve;
                }
            });
        },
        onErrorEvent: function onErrorEvent(callback) {
            _errorEventCallback = callback;
        }
    });
}

AdobePassAuthenticator.Environment = {
    PRODUCTION: 'production',
    STAGING: 'staging'
};

AdobePassAuthenticator.EventType = {
    PREAUTHORIZED: 'preauthorized',
    NOT_PREAUTHORIZED: 'not_preauthorized'
};

AdobePassAuthenticator.AccessEnablerType = {
    JAVASCRIPT: 'js'
};

exports.default = AdobePassAuthenticator;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array ? array.length : 0;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  if (value !== value) {
    return baseFindIndex(array, baseIsNaN, fromIndex);
  }
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Checks if a cache value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order of result values is determined by the
 * order they occur in the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */
var difference = baseRest(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
    : [];
});

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

module.exports = difference;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(console) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
* loglevel - https://github.com/pimterry/loglevel
*
* Copyright (c) 2013 Tim Perry
* Licensed under the MIT license.
*/
(function (root, definition) {
    "use strict";
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        module.exports = definition();
    } else {
        root.log = definition();
    }
}(this, function () {
    "use strict";

    // Slightly dubious tricks to cut down minimized file size
    var noop = function() {};
    var undefinedType = "undefined";

    var logMethods = [
        "trace",
        "debug",
        "info",
        "warn",
        "error"
    ];

    // Cross-browser bind equivalent that works at least back to IE6
    function bindMethod(obj, methodName) {
        var method = obj[methodName];
        if (typeof method.bind === 'function') {
            return method.bind(obj);
        } else {
            try {
                return Function.prototype.bind.call(method, obj);
            } catch (e) {
                // Missing bind shim or IE8 + Modernizr, fallback to wrapping
                return function() {
                    return Function.prototype.apply.apply(method, [obj, arguments]);
                };
            }
        }
    }

    // Build the best logging method possible for this env
    // Wherever possible we want to bind, not wrap, to preserve stack traces
    function realMethod(methodName) {
        if (methodName === 'debug') {
            methodName = 'log';
        }

        if (typeof console === undefinedType) {
            return false; // No method possible, for now - fixed later by enableLoggingWhenConsoleArrives
        } else if (console[methodName] !== undefined) {
            return bindMethod(console, methodName);
        } else if (console.log !== undefined) {
            return bindMethod(console, 'log');
        } else {
            return noop;
        }
    }

    // These private functions always need `this` to be set properly

    function replaceLoggingMethods(level, loggerName) {
        /*jshint validthis:true */
        for (var i = 0; i < logMethods.length; i++) {
            var methodName = logMethods[i];
            this[methodName] = (i < level) ?
                noop :
                this.methodFactory(methodName, level, loggerName);
        }

        // Define log.log as an alias for log.debug
        this.log = this.debug;
    }

    // In old IE versions, the console isn't present until you first open it.
    // We build realMethod() replacements here that regenerate logging methods
    function enableLoggingWhenConsoleArrives(methodName, level, loggerName) {
        return function () {
            if (typeof console !== undefinedType) {
                replaceLoggingMethods.call(this, level, loggerName);
                this[methodName].apply(this, arguments);
            }
        };
    }

    // By default, we use closely bound real methods wherever possible, and
    // otherwise we wait for a console to appear, and then try again.
    function defaultMethodFactory(methodName, level, loggerName) {
        /*jshint validthis:true */
        return realMethod(methodName) ||
               enableLoggingWhenConsoleArrives.apply(this, arguments);
    }

    function Logger(name, defaultLevel, factory) {
      var self = this;
      var currentLevel;
      var storageKey = "loglevel";
      if (name) {
        storageKey += ":" + name;
      }

      function persistLevelIfPossible(levelNum) {
          var levelName = (logMethods[levelNum] || 'silent').toUpperCase();

          if (typeof window === undefinedType) return;

          // Use localStorage if available
          try {
              window.localStorage[storageKey] = levelName;
              return;
          } catch (ignore) {}

          // Use session cookie as fallback
          try {
              window.document.cookie =
                encodeURIComponent(storageKey) + "=" + levelName + ";";
          } catch (ignore) {}
      }

      function getPersistedLevel() {
          var storedLevel;

          if (typeof window === undefinedType) return;

          try {
              storedLevel = window.localStorage[storageKey];
          } catch (ignore) {}

          // Fallback to cookies if local storage gives us nothing
          if (typeof storedLevel === undefinedType) {
              try {
                  var cookie = window.document.cookie;
                  var location = cookie.indexOf(
                      encodeURIComponent(storageKey) + "=");
                  if (location !== -1) {
                      storedLevel = /^([^;]+)/.exec(cookie.slice(location))[1];
                  }
              } catch (ignore) {}
          }

          // If the stored level is not valid, treat it as if nothing was stored.
          if (self.levels[storedLevel] === undefined) {
              storedLevel = undefined;
          }

          return storedLevel;
      }

      /*
       *
       * Public logger API - see https://github.com/pimterry/loglevel for details
       *
       */

      self.name = name;

      self.levels = { "TRACE": 0, "DEBUG": 1, "INFO": 2, "WARN": 3,
          "ERROR": 4, "SILENT": 5};

      self.methodFactory = factory || defaultMethodFactory;

      self.getLevel = function () {
          return currentLevel;
      };

      self.setLevel = function (level, persist) {
          if (typeof level === "string" && self.levels[level.toUpperCase()] !== undefined) {
              level = self.levels[level.toUpperCase()];
          }
          if (typeof level === "number" && level >= 0 && level <= self.levels.SILENT) {
              currentLevel = level;
              if (persist !== false) {  // defaults to true
                  persistLevelIfPossible(level);
              }
              replaceLoggingMethods.call(self, level, name);
              if (typeof console === undefinedType && level < self.levels.SILENT) {
                  return "No console available for logging";
              }
          } else {
              throw "log.setLevel() called with invalid level: " + level;
          }
      };

      self.setDefaultLevel = function (level) {
          if (!getPersistedLevel()) {
              self.setLevel(level, false);
          }
      };

      self.enableAll = function(persist) {
          self.setLevel(self.levels.TRACE, persist);
      };

      self.disableAll = function(persist) {
          self.setLevel(self.levels.SILENT, persist);
      };

      // Initialize with the right level
      var initialLevel = getPersistedLevel();
      if (initialLevel == null) {
          initialLevel = defaultLevel == null ? "WARN" : defaultLevel;
      }
      self.setLevel(initialLevel, false);
    }

    /*
     *
     * Top-level API
     *
     */

    var defaultLogger = new Logger();

    var _loggersByName = {};
    defaultLogger.getLogger = function getLogger(name) {
        if (typeof name !== "string" || name === "") {
          throw new TypeError("You must supply a name when creating a logger.");
        }

        var logger = _loggersByName[name];
        if (!logger) {
          logger = _loggersByName[name] = new Logger(
            name, defaultLogger.getLevel(), defaultLogger.methodFactory);
        }
        return logger;
    };

    // Grab the current global log variable in case of overwrite
    var _log = (typeof window !== undefinedType) ? window.log : undefined;
    defaultLogger.noConflict = function() {
        if (typeof window !== undefinedType &&
               window.log === defaultLogger) {
            window.log = _log;
        }

        return defaultLogger;
    };

    defaultLogger.getLoggers = function getLoggers() {
        return _loggersByName;
    };

    return defaultLogger;
}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.USER_DATA_KEY = undefined;

var _lodash = __webpack_require__(320);

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = __webpack_require__(321);

var _lodash4 = _interopRequireDefault(_lodash3);

var _superagent = __webpack_require__(192);

var _superagent2 = _interopRequireDefault(_superagent);

var _Authenticator = __webpack_require__(211);

var _Authenticator2 = _interopRequireDefault(_Authenticator);

var _WebStorage = __webpack_require__(668);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var USER_DATA_KEY = exports.USER_DATA_KEY = '__userData'; /* eslint-disable no-console */

var STORAGE_TYPE = 'sessionStorage';

var USER_DATA_BASE_URL = 'https://broadband.espn.com/espn3/auth/watchespn/user';

function IpAuthenticator(_ref) {
    var _ref$partner = _ref.partner,
        partner = _ref$partner === undefined ? 'watchespn' : _ref$partner,
        _ref$platform = _ref.platform,
        platform = _ref$platform === undefined ? 'web' : _ref$platform,
        _ref$userDataServiceU = _ref.userDataServiceUrl,
        userDataServiceUrl = _ref$userDataServiceU === undefined ? USER_DATA_BASE_URL : _ref$userDataServiceU;

    if (!(this instanceof IpAuthenticator)) {
        return new IpAuthenticator({ partner: partner, platform: platform, userDataServiceUrl: userDataServiceUrl });
    }
    var userDataUrl = userDataServiceUrl + '?partner=' + partner + '&platform=' + platform;
    var _isAuthenticated = false;
    var userDataPromise = void 0;
    var ispAuthInfo = void 0;

    function getUserData() {
        var userData = (0, _WebStorage.getJson)(USER_DATA_KEY, STORAGE_TYPE);
        if (userData !== null) {
            userDataPromise = Promise.resolve(userData);
        } else if (!userDataPromise) {
            userDataPromise = new Promise(function (resolve, reject) {
                _superagent2.default.get(userDataUrl).end(function (err, res) {
                    if (res) {
                        var userDataResponse = JSON.parse(res.text);
                        (0, _WebStorage.setJson)(USER_DATA_KEY, userDataResponse, STORAGE_TYPE);
                        resolve(userDataResponse);
                    } else {
                        reject(err || new Error('Unknown error'));
                    }
                });
            }).catch(function (err) {
                console.log('Error getting UserData: ', err);
                userDataPromise = null;
                return undefined;
            });
        }
        return userDataPromise;
    }

    function checkIpAuth() {
        return getUserData().then(function (userData) {
            ispAuthInfo = userData && userData.user && userData.user.authentication && userData.user.authentication.isp;
            _isAuthenticated = ispAuthInfo !== undefined && ispAuthInfo.name !== 'espn';
            return _isAuthenticated;
        });
    }
    (0, _lodash2.default)(this, _Authenticator2.default);

    return (0, _lodash2.default)(this, {
        initialize: function initialize(callback) {
            return checkIpAuth().then(function () {
                if ((0, _lodash4.default)(callback)) {
                    callback(null, true);
                }
                return true;
            });
        },
        isAuthenticated: function isAuthenticated() {
            return _isAuthenticated;
        },
        checkAuthentication: function checkAuthentication(callback) {
            return checkIpAuth().then(function (isAuthenticated) {
                if ((0, _lodash4.default)(callback)) {
                    callback(null, isAuthenticated);
                }
                return isAuthenticated;
            });
        },
        authenticate: function authenticate(identity, callback) {
            return checkIpAuth().then(function (isAuthenticated) {
                if ((0, _lodash4.default)(callback)) {
                    callback(null, isAuthenticated);
                }
                return isAuthenticated;
            });
        },
        deauthenticate: function deauthenticate(callback) {
            _isAuthenticated = false;
            return Promise.resolve(_isAuthenticated).then(function (isAuthenticated) {
                if ((0, _lodash4.default)(callback)) {
                    callback(null, isAuthenticated);
                }
                return isAuthenticated;
            });
        },
        getAuthenticationInfo: function getAuthenticationInfo(callback) {
            return getUserData().then(function (userData) {
                var authenticationInfo = userData && userData.user && userData.user.authentication && userData.user.authentication.isp;
                var mvpd = authenticationInfo.name,
                    imgUrl = authenticationInfo.imageHref;

                var authInfo = mvpd !== 'espn' ? { mvpd: mvpd, imgUrl: imgUrl } : null;
                if ((0, _lodash4.default)(callback)) {
                    callback(null, authInfo);
                }
                return authInfo;
            });
        },
        getLocation: function getLocation(callback) {
            return getUserData().then(function (userData) {
                return userData && userData.user && userData.user.location;
            }).then(function (location) {
                if ((0, _lodash4.default)(callback)) {
                    callback(null, location);
                }
                return location;
            });
        }
    });
}

exports.default = IpAuthenticator;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable no-console */
function storageAvailable(type) {
    try {
        var storage = window[type];
        var key = '__storage_test__';
        storage.setItem(key, key);
        storage.removeItem(key);
        return true;
    } catch (err) {
        return false;
    }
}

function setJson(key, json) {
    var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'sessionStorage';

    if (storageAvailable(type)) {
        var storage = window[type];
        storage.setItem(key, JSON.stringify(json));
        return true;
    }
    return false;
}

function getJson(key) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'sessionStorage';

    var resp = null;
    if (storageAvailable(type)) {
        var storage = window[type];
        var value = storage.getItem(key);
        try {
            resp = JSON.parse(value);
        } catch (err) {
            console.log('Error parsing JSON: ', err);
        }
    }
    return resp;
}

exports.setJson = setJson;
exports.getJson = getJson;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {/* harmony export (immutable) */ __webpack_exports__["a"] = isAuthNTtlSaved;
/* harmony export (immutable) */ __webpack_exports__["d"] = saveInitialAuthNData;
/* harmony export (immutable) */ __webpack_exports__["c"] = saveAuthNTtl;
/* harmony export (immutable) */ __webpack_exports__["b"] = reset;
/* harmony export (immutable) */ __webpack_exports__["e"] = trackUntimelyLogout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__omniture__ = __webpack_require__(34);
/**
 * This module contains functions used to track when users are logged out sooner than we'd expect
 */



var INITIAL_AUTHN_DATA_STORAGE_KEY = '@watch:INITIAL_AUTHN_DATA';
var AUTHN_TTL_STORAGE_KEY = '@watch:TTL_AUTHN';

// make the numbers look pretty in omniture
function formatTimeInMillisToDays(time) {
    if (typeof time === 'number') {
        return (time / 1000 / 60 / 60 / 24).toFixed(2);
    }
    return 'unknown';
}

// public function to tell us if we've already saved their authNTtl (to prevent overriding it)
function isAuthNTtlSaved() {
    return !!localStorage.getItem(AUTHN_TTL_STORAGE_KEY);
}

// saves the time in which they authenticated, and which provider
function saveInitialAuthNData(_ref) {
    var name = _ref.name,
        abbreviation = _ref.abbreviation;

    if (localStorage) {
        localStorage.setItem(INITIAL_AUTHN_DATA_STORAGE_KEY, JSON.stringify({
            date: new Date(),
            provider: { name: name, abbreviation: abbreviation }
        }));
    }
}

// saves the expected TTL as returned from Adobe
function saveAuthNTtl(ttl) {
    if (localStorage && typeof ttl === 'number') {
        localStorage.setItem(AUTHN_TTL_STORAGE_KEY, new Date(ttl));
    }
}

// clear out all storage keys related to untimely logout tracking
function reset() {
    if (localStorage) {
        localStorage.removeItem(INITIAL_AUTHN_DATA_STORAGE_KEY);
        localStorage.removeItem(AUTHN_TTL_STORAGE_KEY);
    }
}

// get necessary items from localStorage and actually do the tracking
function trackUntimelyLogout(entitlementsTracking) {
    if (localStorage) {
        try {
            var initialAuthNDataString = localStorage.getItem(INITIAL_AUTHN_DATA_STORAGE_KEY);
            var authNTtl = localStorage.getItem(AUTHN_TTL_STORAGE_KEY);

            if (authNTtl && initialAuthNDataString) {
                var initialAuthNData = JSON.parse(initialAuthNDataString);
                var provider = initialAuthNData.provider || {};
                var initialLoginTime = new Date(initialAuthNData.date).getTime();
                var loginExpireTime = new Date(authNTtl).getTime();
                var currentTime = new Date().getTime();

                var actualLoginTime = formatTimeInMillisToDays(currentTime - initialLoginTime);
                var expectedLoginTime = formatTimeInMillisToDays(loginExpireTime - initialLoginTime);
                // if the login expiration has not yet reached, the user got logged out unexpectedly
                if (loginExpireTime > currentTime) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__omniture__["s" /* trackUntimelyLogout */])(actualLoginTime, expectedLoginTime, provider, entitlementsTracking);
                }
                reset();
            }
        } catch (ex) {
            console.error(ex);
        }
    }
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(290),
    noop = __webpack_require__(671),
    setToArray = __webpack_require__(210);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 671 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);


var networksSelector = function networksSelector(_ref) {
  var _ref$networks = _ref.networks,
      networks = _ref$networks === undefined ? {} : _ref$networks;
  return networks;
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(networksSelector, function (_ref2) {
  var data = _ref2.data;
  return data;
}));

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(674),
    isIterateeCall = __webpack_require__(324),
    toInteger = __webpack_require__(317);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */
function chunk(array, size, guard) {
  if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
    size = 1;
  } else {
    size = nativeMax(toInteger(size), 0);
  }
  var length = array == null ? 0 : array.length;
  if (!length || size < 1) {
    return [];
  }
  var index = 0,
      resIndex = 0,
      result = Array(nativeCeil(length / size));

  while (index < length) {
    result[resIndex++] = baseSlice(array, index, (index += size));
  }
  return result;
}

module.exports = chunk;


/***/ }),
/* 674 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(0);
var React__default = _interopDefault(React);
var shallowEqual = _interopDefault(__webpack_require__(676));

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }

  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }

  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect =
    /*#__PURE__*/
    function (_Component) {
      _inheritsLoose(SideEffect, _Component);

      function SideEffect() {
        return _Component.apply(this, arguments) || this;
      }

      // Try to use displayName of wrapped component
      // Expose canUseDOM so tests can monkeypatch it
      SideEffect.peek = function peek() {
        return state;
      };

      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      var _proto = SideEffect.prototype;

      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return !shallowEqual(nextProps, this.props);
      };

      _proto.componentWillMount = function componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      _proto.render = function render() {
        return React__default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(React.Component);

    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");

    _defineProperty(SideEffect, "canUseDOM", canUseDOM);

    return SideEffect;
  };
}

module.exports = withSideEffect;


/***/ }),
/* 676 */
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

var pSlice = Array.prototype.slice;
var objectKeys = __webpack_require__(678);
var isArguments = __webpack_require__(679);

var deepEqual = module.exports = function (actual, expected, opts) {
  if (!opts) opts = {};
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;

  } else if (actual instanceof Date && expected instanceof Date) {
    return actual.getTime() === expected.getTime();

  // 7.3. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
    return opts.strict ? actual === expected : actual == expected;

  // 7.4. For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else {
    return objEquiv(actual, expected, opts);
  }
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer (x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') return false;
  return true;
}

function objEquiv(a, b, opts) {
  var i, key;
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
    return false;
  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) return false;
  //~~~I've managed to break Object.keys through screwy arguments passing.
  //   Converting to array solves the problem.
  if (isArguments(a)) {
    if (!isArguments(b)) {
      return false;
    }
    a = pSlice.call(a);
    b = pSlice.call(b);
    return deepEqual(a, b, opts);
  }
  if (isBuffer(a)) {
    if (!isBuffer(b)) {
      return false;
    }
    if (a.length !== b.length) return false;
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  try {
    var ka = objectKeys(a),
        kb = objectKeys(b);
  } catch (e) {//happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length != kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) return false;
  }
  return typeof a === typeof b;
}


/***/ }),
/* 678 */
/***/ (function(module, exports) {

exports = module.exports = typeof Object.keys === 'function'
  ? Object.keys : shim;

exports.shim = shim;
function shim (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}


/***/ }),
/* 679 */
/***/ (function(module, exports) {

var supportsArgumentsClass = (function(){
  return Object.prototype.toString.call(arguments)
})() == '[object Arguments]';

exports = module.exports = supportsArgumentsClass ? supported : unsupported;

exports.supported = supported;
function supported(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
};

exports.unsupported = unsupported;
function unsupported(object){
  return object &&
    typeof object == 'object' &&
    typeof object.length == 'number' &&
    Object.prototype.hasOwnProperty.call(object, 'callee') &&
    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
    false;
};


/***/ }),
/* 680 */
/***/ (function(module, exports) {

exports.__esModule = true;
var TAG_NAMES = exports.TAG_NAMES = {
    HTML: "htmlAttributes",
    TITLE: "title",
    BASE: "base",
    META: "meta",
    LINK: "link",
    SCRIPT: "script",
    NOSCRIPT: "noscript",
    STYLE: "style"
};

var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
    NAME: "name",
    CHARSET: "charset",
    HTTPEQUIV: "http-equiv",
    REL: "rel",
    HREF: "href",
    PROPERTY: "property",
    SRC: "src",
    INNER_HTML: "innerHTML",
    CSS_TEXT: "cssText",
    ITEM_PROP: "itemprop"
};

var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
    "charset": "charSet",
    "http-equiv": "httpEquiv",
    "itemprop": "itemProp",
    "class": "className"
};

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty
  , prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */
function addListener(emitter, event, fn, context, once) {
  if (typeof fn !== 'function') {
    throw new TypeError('The listener must be a function');
  }

  var listener = new EE(fn, context || emitter, once)
    , evt = prefix ? prefix + event : event;

  if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
  else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
  else emitter._events[evt] = [emitter._events[evt], listener];

  return emitter;
}

/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */
function clearEvent(emitter, evt) {
  if (--emitter._eventsCount === 0) emitter._events = new Events();
  else delete emitter._events[evt];
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = []
    , events
    , name;

  if (this._eventsCount === 0) return names;

  for (name in (events = this._events)) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */
EventEmitter.prototype.listeners = function listeners(event) {
  var evt = prefix ? prefix + event : event
    , handlers = this._events[evt];

  if (!handlers) return [];
  if (handlers.fn) return [handlers.fn];

  for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
    ee[i] = handlers[i].fn;
  }

  return ee;
};

/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */
EventEmitter.prototype.listenerCount = function listenerCount(event) {
  var evt = prefix ? prefix + event : event
    , listeners = this._events[evt];

  if (!listeners) return 0;
  if (listeners.fn) return 1;
  return listeners.length;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  return addListener(this, event, fn, context, false);
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  return addListener(this, event, fn, context, true);
};

/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    clearEvent(this, evt);
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (
      listeners.fn === fn &&
      (!once || listeners.once) &&
      (!context || listeners.context === context)
    ) {
      clearEvent(this, evt);
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (
        listeners[i].fn !== fn ||
        (once && !listeners[i].once) ||
        (context && listeners[i].context !== context)
      ) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
    else clearEvent(this, evt);
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) clearEvent(this, evt);
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
if (true) {
  module.exports = EventEmitter;
}


/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PlayerBase__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Loader__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_util_perf__ = __webpack_require__(75);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable class-methods-use-this, no-return-assign */






var BAMPlayer = function (_PlayerBase) {
    _inherits(BAMPlayer, _PlayerBase);

    function BAMPlayer() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            sdkHost = _ref.sdkHost,
            _ref$env = _ref.env,
            env = _ref$env === undefined ? 'beta' : _ref$env,
            playerVersion = _ref.playerVersion,
            _ref$geoTimeoutInSeco = _ref.geoTimeoutInSeconds,
            geoTimeoutInSeconds = _ref$geoTimeoutInSeco === undefined ? 7 : _ref$geoTimeoutInSeco,
            loader = _ref.loader;

        _classCallCheck(this, BAMPlayer);

        var _this = _possibleConstructorReturn(this, (BAMPlayer.__proto__ || Object.getPrototypeOf(BAMPlayer)).call(this));

        _this._sdkHost = sdkHost;
        _this._playerVersion = playerVersion;
        _this._extensionConfig = { environment: env };
        _this._geoTimeoutInSeconds = geoTimeoutInSeconds;
        _this._loader = BAMPlayer.loader || loader;
        _this.getPlayerExtension = _this.getPlayerExtension.bind(_this);
        return _this;
    }

    _createClass(BAMPlayer, [{
        key: 'getPlayerExtension',
        value: function getPlayerExtension(BamVideoExtension) {
            if (!this._playerExtension) {
                this._playerExtension = new BamVideoExtension(this._extensionConfig); // eslint-disable-line new-cap
            }
            return this._playerExtension;
        }
    }, {
        key: 'createSDKWrapper',
        value: function createSDKWrapper() {
            var _this2 = this;

            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var geolocationKey = 'geolocation';
            var subscriptionsKey = 'subscriptions';
            var sessionTokenKey = 'sessionToken';
            var userTrackingKey = 'userTrackingInformation';
            var requests = options.requests,
                timeout = options.timeout,
                transactionId = options.transactionId;

            if (!BAMPlayer.SDKData[transactionId]) {
                BAMPlayer.SDKData[transactionId] = {};
            } else {
                var transactionData = BAMPlayer.SDKData[transactionId];
                if (transactionData[geolocationKey]) {
                    this.emit(BAMPlayer.Events.GEOLOCATION_READY, transactionData[geolocationKey]);
                }
                if (transactionData[subscriptionsKey]) {
                    this.emit(BAMPlayer.Events.SUBSCRIPTIONS_READY, transactionData[subscriptionsKey]);
                }
                if (transactionData[sessionTokenKey]) {
                    this.emit(BAMPlayer.Events.SESSIONTOKEN_READY, transactionData[sessionTokenKey]);
                }
                if (transactionData[userTrackingKey]) {
                    this.emit(BAMPlayer.Events.USER_TRACKING_INFORMATION_READY, transactionData[userTrackingKey]);
                }
                if (Object.keys(transactionData).length === 2) {
                    return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve();
                }
            }
            var context = requests.join();
            var pertName = 'BAMPlayer/createSDKWrapper_' + context;
            return BAMPlayer.SDKPromises[transactionId] || (BAMPlayer.SDKPromises[transactionId] = this.loadPlayer(context).then(function (playerExtension) {
                var eventBus = playerExtension.eventBus,
                    events = playerExtension.events;

                var geoEventName = events.get(BAMPlayer.Events.GEOLOCATION_READY);
                var subEventName = events.get(BAMPlayer.Events.SUBSCRIPTIONS_READY);
                var sessionTokenEventName = events.get(BAMPlayer.Events.SESSIONTOKEN_READY);
                var userTrackingEventName = events.get(BAMPlayer.Events.USER_TRACKING_INFORMATION_READY);
                var timer = void 0;
                var geoCallback = function geoCallback(event) {
                    __WEBPACK_IMPORTED_MODULE_4__lib_util_perf__["b" /* measureAndTime */](pertName);
                    window.clearTimeout(timer);
                    eventBus.off(geoEventName, geoCallback);
                    BAMPlayer.SDKData[transactionId][geolocationKey] = event;
                    _this2.emit(BAMPlayer.Events.GEOLOCATION_READY, event);
                };
                var subCallback = function subCallback(event) {
                    __WEBPACK_IMPORTED_MODULE_4__lib_util_perf__["b" /* measureAndTime */](pertName);
                    window.clearTimeout(timer);
                    eventBus.off(subEventName, subCallback);
                    BAMPlayer.SDKData[transactionId][subscriptionsKey] = event;
                    _this2.emit(BAMPlayer.Events.SUBSCRIPTIONS_READY, event);
                };
                var tokenCallback = function tokenCallback(event) {
                    __WEBPACK_IMPORTED_MODULE_4__lib_util_perf__["b" /* measureAndTime */](pertName);
                    window.clearTimeout(timer);
                    eventBus.off(sessionTokenEventName, tokenCallback);
                    BAMPlayer.SDKData[transactionId][sessionTokenKey] = event;
                    _this2.emit(BAMPlayer.Events.SESSIONTOKEN_READY, event);
                };

                var userTrackingCallback = function userTrackingCallback(event) {
                    __WEBPACK_IMPORTED_MODULE_4__lib_util_perf__["b" /* measureAndTime */](pertName);
                    window.clearTimeout(timer);
                    eventBus.off(userTrackingEventName, userTrackingCallback);
                    BAMPlayer.SDKData[transactionId][userTrackingKey] = event;
                    _this2.emit(BAMPlayer.Events.USER_TRACKING_INFORMATION_READY, event);
                };

                // TODO: DTC - BAM to reject promise when any error occurs
                if (timeout) {
                    timer = window.setTimeout(function () {
                        console.error('createSDKWrapper timed out after ' + _this2._geoTimeoutInSeconds + ' seconds');
                        __WEBPACK_IMPORTED_MODULE_4__lib_util_perf__["b" /* measureAndTime */](pertName);
                        eventBus.off(geoEventName, geoCallback);
                        eventBus.off(subEventName, subCallback);
                        eventBus.off(sessionTokenEventName, tokenCallback);
                        eventBus.off(userTrackingEventName, userTrackingCallback);

                        if (requests.indexOf(geolocationKey) > -1) {
                            var geoEvent = { error: 'timeout' };
                            BAMPlayer.SDKData[transactionId][geolocationKey] = geoEvent;
                            _this2.emit(BAMPlayer.Events.GEOLOCATION_READY, geoEvent);
                        }
                        if (requests.indexOf(subscriptionsKey) > -1) {
                            var subEvent = {
                                error: 'timeout',
                                body: { subscriptions: [] }
                            };
                            BAMPlayer.SDKData[transactionId][subscriptionsKey] = subEvent;
                            _this2.emit(BAMPlayer.Events.SUBSCRIPTIONS_READY, subEvent);
                        }
                        if (requests.indexOf(sessionTokenKey) > -1) {
                            var tokenEvent = {
                                error: 'timeout',
                                body: { token: null }
                            };
                            BAMPlayer.SDKData[transactionId][sessionTokenKey] = tokenEvent;
                            _this2.emit(BAMPlayer.Events.SESSIONTOKEN_READY, tokenEvent);
                        }
                        if (requests.indexOf(userTrackingKey) > -1) {
                            var userTrackingEvent = {
                                error: 'timeout',
                                body: {}
                            };
                            BAMPlayer.SDKData[transactionId][userTrackingKey] = userTrackingEvent;
                            _this2.emit(BAMPlayer.Events.USER_TRACKING_INFORMATION_READY, userTrackingEvent);
                        }
                    }, _this2._geoTimeoutInSeconds * 1000);
                }

                if (requests.indexOf(geolocationKey) > -1) {
                    eventBus.on(geoEventName, geoCallback);
                }
                if (requests.indexOf(subscriptionsKey) > -1) {
                    eventBus.on(subEventName, subCallback);
                }
                if (requests.indexOf(sessionTokenKey) > -1) {
                    eventBus.on(sessionTokenEventName, tokenCallback);
                }
                if (requests.indexOf(userTrackingKey) > -1) {
                    eventBus.on(userTrackingEventName, userTrackingCallback);
                }
                __WEBPACK_IMPORTED_MODULE_4__lib_util_perf__["a" /* markStart */](pertName);
                return playerExtension.createSDKWrapper(options.selector, options);
            }));
        }
    }, {
        key: 'renderPaywall',
        value: function renderPaywall(options) {
            var _this3 = this;

            return this.loadPlayer().then(function (playerExtension) {
                var eventBus = playerExtension.eventBus,
                    events = playerExtension.events;

                return playerExtension.renderPaywall(options.selector, options).then(function () {
                    eventBus.once(events.get(BAMPlayer.Events.LOGIN_REQUESTED), function (event) {
                        _this3.emit(BAMPlayer.Events.LOGIN_REQUESTED, event);
                    });
                });
            });
        }
    }, {
        key: 'sendContentReward',
        value: function sendContentReward(selector, rewardToken, contentId, userActivityAction, recommendedContentIds) {
            return this.loadPlayer().then(function (playerExtension) {
                return playerExtension.sendContentReward(selector, rewardToken, contentId, userActivityAction, recommendedContentIds).then(function (result) {
                    return (
                        // TODO: Will be removed once deployed to production
                        console.info('sendContentReward result:', result)
                    );
                } // eslint-disable-line
                );
            });
        }
    }, {
        key: 'loadPlayer',
        value: function loadPlayer(context) {
            var _this4 = this;

            var perfName = context ? 'BAMPlayer/loadPlayer_' + context : 'BAMPlayer/loadPlayer';
            __WEBPACK_IMPORTED_MODULE_4__lib_util_perf__["a" /* markStart */](perfName);
            return this._loader.load(this._sdkHost, this._playerVersion).then(function (BamVideoExtension) {
                __WEBPACK_IMPORTED_MODULE_4__lib_util_perf__["b" /* measureAndTime */](perfName);
                return _this4.getPlayerExtension(BamVideoExtension);
            });
        }
    }, {
        key: 'create',
        value: function create(options) {
            var _this5 = this;

            // only allow one player within `WatchESPNWebPlayer` instance
            // TODO: consider using `singlePlayerMode=true`
            var isNew = !this._playerId;
            return this.loadPlayer().then(function (playerExtension) {
                var eventBus = playerExtension.eventBus,
                    events = playerExtension.events;
                // or is `updatePlayerConfigs` for updating `extensionConfig`?
                // then how do we switch content?

                var api = isNew ? 'createPlayer' : 'loadMedia';
                return new __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a(function (resolve, reject) {
                    console.log(api, options); // eslint-disable-line no-console
                    playerExtension[api](options.selector, options).then(function (playerId) {
                        if (isNew) {
                            _this5._playerId = playerId;
                            _this5.subscribe(playerExtension);
                            var readyTimer = window.setTimeout(function () {
                                resolve(_this5);
                            }, 100);
                            eventBus.once(events.get(BAMPlayer.Events.EMBED_PLAYER_READY), function () {
                                window.clearTimeout(readyTimer);
                                resolve(_this5);
                            });

                            return playerExtension.insertPlayer(playerId);
                        }

                        resolve(_this5);

                        return _this5._playerId;
                    }).catch(function (err) {
                        console.error(err);
                        reject(err);
                    });
                });
            });
        }
    }, {
        key: 'loadMedia',
        value: function loadMedia(options) {
            var _this6 = this;

            if (!this._playerExtension || !this._playerId) {
                return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve(this);
            }
            return this._playerExtension.loadMedia(this._playerId, options).then(function () {
                return _this6;
            });
        }
    }, {
        key: 'destroyPlayer',
        value: function destroyPlayer() {
            var _this7 = this;

            if (this._playerExtension && this._playerId) {
                this.unsubscribe();
                return this._playerExtension.destroyPlayer(this._playerId).then(function () {
                    _this7._playerId = null;
                    return _this7;
                }).catch(function () {});
            }

            return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve(this);
        }
    }, {
        key: 'changeFeed',
        value: function changeFeed(options) {
            var _this8 = this;

            if (!this._playerExtension || !this._playerId) {
                return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve(this);
            }
            console.log('changeFeed', options); // eslint-disable-line no-console
            return this._playerExtension.changeFeed(this._playerId, options).then(function () {
                return _this8;
            });
        }
    }, {
        key: 'deactivate',
        value: function deactivate() {
            var _this9 = this;

            if (!this._playerExtension || !this._playerId) {
                return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve(this);
            }
            return this._playerExtension.deactivatePlayer(this._playerId).then(function () {
                return _this9;
            });
        }
    }, {
        key: 'delete',
        value: function _delete() {
            var _this10 = this;

            if (this._playerExtension && this._playerId) {
                this.unsubscribe();
                return this._playerExtension.deletePlayer(this._playerId).then(function () {
                    _this10._playerId = null;
                    return _this10;
                }).catch(function () {});
            }
            return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve(this);
        }
    }, {
        key: 'play',
        value: function play() {
            var _this11 = this;

            if (!this._playerExtension) {
                return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve(this);
            }
            return this._playerExtension.playPlayer(this._playerId).then(function () {
                return _this11;
            });
        }
    }, {
        key: 'pause',
        value: function pause() {
            var _this12 = this;

            if (!this._playerExtension) {
                return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve(this);
            }
            return this._playerExtension.pausePlayer(this._playerId).then(function () {
                return _this12;
            });
        }
    }, {
        key: 'mute',
        value: function mute() {
            var _this13 = this;

            if (!this._playerExtension) {
                return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve(this);
            }
            return this._playerExtension.mutePlayer(this._playerId).then(function () {
                return _this13;
            });
        }
    }, {
        key: 'unmute',
        value: function unmute() {
            var _this14 = this;

            if (!this._playerExtension) {
                return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve(this);
            }
            return this._playerExtension.unmutePlayer(this._playerId).then(function () {
                return _this14;
            });
        }
    }, {
        key: 'error',
        value: function error() {
            throw new Error('`error` not implemented');
        }
    }, {
        key: 'getPlayerConfigs',
        value: function getPlayerConfigs() {
            if (!this._playerExtension) {
                return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve(this);
            }
            return this._playerExtension.getPlayerConfigs(this._playerId);
        }
    }, {
        key: 'updatePlayerConfigs',
        value: function updatePlayerConfigs(newConfigs) {
            var _this15 = this;

            if (!this._playerExtension) {
                return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve(this);
            }
            return this._playerExtension.updatePlayerConfigs(this._playerId, newConfigs).then(function () {
                return _this15;
            });
        }
    }, {
        key: 'subscribe',
        value: function subscribe(playerExtension) {
            var _this16 = this;

            var eventBus = playerExtension.eventBus,
                events = playerExtension.events;

            events.forEach(function (value, key) {
                // TODO: check if the listeners are cleaned up by `deletePlayer`
                eventBus.on(value, function (event) {
                    _this16.emit(key, event);
                    console.log('Event Received', key, event); // eslint-disable-line no-console
                });
            });
            this._unsubscribeEvents = function () {
                eventBus.removeAllListeners();
            };
        }
    }, {
        key: 'unsubscribe',
        value: function unsubscribe() {
            if (this._unsubscribeEvents) {
                this._unsubscribeEvents();
                this._unsubscribeEvents = null;
            }
        }
    }, {
        key: 'tech',
        get: function get() {
            return __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* PlayerTech */].BAM;
        }
    }, {
        key: 'playerExtension',
        get: function get() {
            return this._playerExtension;
        }
    }, {
        key: 'playerId',
        get: function get() {
            return this._playerId;
        }
    }, {
        key: 'container',
        get: function get() {
            return document.querySelector(this._playerId);
        }
    }]);

    return BAMPlayer;
}(__WEBPACK_IMPORTED_MODULE_2__PlayerBase__["a" /* default */]);

BAMPlayer.loader = new __WEBPACK_IMPORTED_MODULE_3__Loader__["a" /* default */]();

BAMPlayer.SDKPromises = {};
BAMPlayer.SDKData = {};

BAMPlayer.Events = {
    LOGIN_REQUESTED: 'LOGIN_REQUESTED',
    SUBSCRIPTIONS_READY: 'SUBSCRIPTIONS_READY',
    GEOLOCATION_READY: 'GEOLOCATION_READY',
    AUTHORIZE_USER: 'AUTHORIZE_USER',
    EMBED_PLAYER_READY: 'EMBED_PLAYER_READY',
    MEDIA_LOADED: 'MEDIA_LOADED',
    MEDIA_PAUSED: 'MEDIA_PAUSED',
    MEDIA_RESUME: 'MEDIA_RESUME',
    MEDIA_MUTE: 'MEDIA_MUTE',
    MEDIA_UNMUTE: 'MEDIA_UNMUTE',
    PLAYBACK_ERROR: 'PLAYBACK_ERROR', // TODO - to be deprecated
    PLAYBACK_INITIALIZED: 'PLAYBACK_INITIALIZED',
    FEED_CHANGE_REQUEST: 'FEED_CHANGE_REQUEST',
    FEED_CHANGED: 'FEED_CHANGED',
    SETTINGS_CHANGED: 'SETTINGS_CHANGED',
    PLAYER_CONFIGS_RETURNED: 'PLAYER_CONFIGS_RETURNED',
    PLAYER_CONFIGS_UPDATED: 'PLAYER_CONFIGS_UPDATED',
    SESSIONTOKEN_READY: 'SESSIONTOKEN_READY',
    SYNDICATED_PLAYER_MUTE: 'SYNDICATED_PLAYER_MUTE',
    SYNDICATED_PLAYER_UNMUTE: 'SYNDICATED_PLAYER_UNMUTE',
    SYNDICATED_PLAYER_PLAY: 'SYNDICATED_PLAYER_PLAY',
    SYNDICATED_PLAYER_PAUSE: 'SYNDICATED_PLAYER_PAUSE',
    SYNDICATED_PLAYER_ADD_TO_PLAYLIST: 'SYNDICATED_PLAYER_ADD_TO_PLAYLIST',
    SYNDICATED_PLAYER_REMOVE_FROM_PLAYLIST: 'SYNDICATED_PLAYER_REMOVE_FROM_PLAYLIST',
    SYNDICATED_PLAYER_CLEAR_PLAYLIST: 'SYNDICATED_PLAYER_CLEAR_PLAYLIST',
    SYNDICATED_PLAYER_PLAYLIST_NEXT: 'SYNDICATED_PLAYER_PLAYLIST_NEXT',
    SYNDICATED_PLAYER_PLAYLIST_PREVIOUS: 'SYNDICATED_PLAYER_PLAYLIST_PREVIOUS',
    SYNDICATED_PLAYER_GET_CONFIGS: 'SYNDICATED_PLAYER_GET_CONFIGS',
    SYNDICATED_PLAYER_UPDATE_CONFIGS: 'SYNDICATED_PLAYER_UPDATE_CONFIGS',
    USER_TRACKING_INFORMATION_READY: 'USER_TRACKING_INFORMATION_READY'
};

/* harmony default export */ __webpack_exports__["a"] = (BAMPlayer);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bluebird__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-return-assign */


var Loader = function () {
    function Loader() {
        _classCallCheck(this, Loader);

        this._promises = {};
    }

    _createClass(Loader, [{
        key: 'load',
        value: function load() {
            var host = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'https://beta.web.plus.espn.com';
            var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'latest';
            // TODO: DTC - point to prod by default
            return this._promises[version] || (this._promises[version] = new __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a(function (resolve, reject) {
                if (window.BamVideoExtensionVersioned && window.BamVideoExtensionVersioned[version]) {
                    resolve(window.BamVideoExtensionVersioned[version]);
                } else {
                    // TODO: take `environment` into account
                    var url = host + '/builds/' + version + '/dist/index.js';
                    var script = document.createElement('script');
                    script.async = true;

                    script.onload = function () {
                        if (window.BamVideoExtension) {
                            if (!window.BamVideoExtensionVersioned) {
                                window.BamVideoExtensionVersioned = {};
                            }
                            window.BamVideoExtensionVersioned[version] = window.BamVideoExtension;
                            // delete window.BamVideoExtension;
                            resolve(window.BamVideoExtensionVersioned[version]);
                        } else {
                            reject(new Error('script loaded but window.BamVideoExtension not found.'));
                        }
                    };

                    script.onerror = function () {
                        reject(new Error('failed to load BAM SDK'));
                    };

                    script.src = url;
                    document.head.appendChild(script);
                }
            }));
        }
    }]);

    return Loader;
}();

/* harmony default export */ __webpack_exports__["a"] = (Loader);

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var base64_url_decode = __webpack_require__(685);

function InvalidTokenError(message) {
  this.message = message;
}

InvalidTokenError.prototype = new Error();
InvalidTokenError.prototype.name = 'InvalidTokenError';

module.exports = function (token,options) {
  if (typeof token !== 'string') {
    throw new InvalidTokenError('Invalid token specified');
  }

  options = options || {};
  var pos = options.header === true ? 0 : 1;
  try {
    return JSON.parse(base64_url_decode(token.split('.')[pos]));
  } catch (e) {
    throw new InvalidTokenError('Invalid token specified: ' + e.message);
  }
};

module.exports.InvalidTokenError = InvalidTokenError;


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

var atob = __webpack_require__(686);

function b64DecodeUnicode(str) {
  return decodeURIComponent(atob(str).replace(/(.)/g, function (m, p) {
    var code = p.charCodeAt(0).toString(16).toUpperCase();
    if (code.length < 2) {
      code = '0' + code;
    }
    return '%' + code;
  }));
}

module.exports = function(str) {
  var output = str.replace(/-/g, "+").replace(/_/g, "/");
  switch (output.length % 4) {
    case 0:
      break;
    case 2:
      output += "==";
      break;
    case 3:
      output += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }

  try{
    return b64DecodeUnicode(output);
  } catch (err) {
    return atob(output);
  }
};


/***/ }),
/* 686 */
/***/ (function(module, exports) {

/**
 * The code was extracted from:
 * https://github.com/davidchambers/Base64.js
 */

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function InvalidCharacterError(message) {
  this.message = message;
}

InvalidCharacterError.prototype = new Error();
InvalidCharacterError.prototype.name = 'InvalidCharacterError';

function polyfill (input) {
  var str = String(input).replace(/=+$/, '');
  if (str.length % 4 == 1) {
    throw new InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
  }
  for (
    // initialize result and counters
    var bc = 0, bs, buffer, idx = 0, output = '';
    // get next character
    buffer = str.charAt(idx++);
    // character found in table? initialize bit storage and add its ascii value;
    ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
      // and if not first of each 4 characters,
      // convert the first 8 bits to one ascii character
      bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0
  ) {
    // try to find character in table (0-63, not found => -1)
    buffer = chars.indexOf(buffer);
  }
  return output;
}


module.exports = typeof window !== 'undefined' && window.atob && window.atob.bind(window) || polyfill;


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FanAPI = __webpack_require__(688);

var _FanAPI2 = _interopRequireDefault(_FanAPI);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FanAPI2.default;
module.exports = exports['default'];

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _superagentBluebirdPromise = __webpack_require__(689);

var _superagentBluebirdPromise2 = _interopRequireDefault(_superagentBluebirdPromise);

var _bluebird = __webpack_require__(11);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _Storage = __webpack_require__(690);

var _Storage2 = _interopRequireDefault(_Storage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FAN_PRODUCT_PROD_HOST = 'https://fan.api.espn.com';
var FAN_CORE_PROD_HOST = 'https://fan.core.api.espn.com';
var DEFAULT_SOURCE_HEADER = 'espn-video-player'; // watchespn-web // ESPN.com - FAM
var FAN_API_CACHE_MINUTES = 10;
var SWID_RE = /^{[\w-]+}/;

var DEFAULT_CONFIGURATION = {
    sourceHeader: DEFAULT_SOURCE_HEADER,
    cacheDuration: FAN_API_CACHE_MINUTES
};

var _sourceHeader = void 0;
var _cacheDuration = void 0;
var _storage = void 0;

function getFan(id, resolve, reject) {
    var url = FAN_PRODUCT_PROD_HOST + '/apis/v2/fans/' + id;
    _superagentBluebirdPromise2.default.get(url).withCredentials().set('X-Personalization-Source', _sourceHeader).end(function (err, res) {
        if (err || !res.ok) {
            reject(err);
        } else {
            var fan = res && res.body;
            _storage.setFan({ item: fan, id: fan.id, timestamp: Date.now() });
            resolve(fan);
        }
    });
}

function getFanForId(id) {
    if (!SWID_RE.test(id)) {
        return _bluebird2.default.reject(new Error('Invalid SWID'));
    }

    return new _bluebird2.default(function (resolve, reject) {
        _storage.getFan().then(function (cache) {
            var fan = cache && cache.item;
            var cacheExpired = Date.now() - cache.timestamp > _cacheDuration * 60 * 1000;
            if (fan === null || fan.id !== id || cacheExpired) {
                getFan(id, resolve, reject);
            } else {
                resolve(fan);
            }
        }).catch(function () {
            getFan(id, resolve, reject);
        });
    });
}

function updateSettingsForFanId(id, postData) {
    if (!SWID_RE.test(id)) {
        return _bluebird2.default.reject(new Error('Invalid SWID'));
    }

    var url = FAN_CORE_PROD_HOST + '/apis/v2/fans/' + id + '/profile/';
    return _superagentBluebirdPromise2.default.post(url).withCredentials().set('X-Personalization-Source', _sourceHeader).send(postData).promise();
}

function FanAPI() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_CONFIGURATION,
        _ref$sourceHeader = _ref.sourceHeader,
        sourceHeader = _ref$sourceHeader === undefined ? DEFAULT_CONFIGURATION.sourceHeader : _ref$sourceHeader,
        _ref$cacheDuration = _ref.cacheDuration,
        cacheDuration = _ref$cacheDuration === undefined ? DEFAULT_CONFIGURATION.cacheDuration : _ref$cacheDuration;

    if (!(this instanceof FanAPI)) {
        return new FanAPI({ sourceHeader: sourceHeader, cacheDuration: cacheDuration });
    }
    _sourceHeader = sourceHeader;
    _cacheDuration = cacheDuration;
    _storage = new _Storage2.default(_cacheDuration);
    return this;
}

FanAPI.prototype.getFanForId = function (id, callback) {
    return getFanForId(id).tap(function (fan) {
        if (typeof callback === 'function') callback(fan);
    });
};

FanAPI.prototype.getAutoStartForFanId = function (id, callback) {
    return getFanForId(id).then(function (fan) {
        var profile = fan && fan.profile;
        var settings = profile && profile.settings;
        var videoAutoStartValue = settings && settings.videoAutoStart && settings.videoAutoStart.value;
        return videoAutoStartValue !== '2';
    }).catch(function () {
        return true;
    }).tap(function (videoAutoStart) {
        if (typeof callback === 'function') {
            callback(videoAutoStart);
        }
    });
};

FanAPI.prototype.updateAutoStartForFanId = function (id, autoStart, callback) {
    var videoAutoStartValue = (autoStart ? '1' : '2').toString();

    var postData = {
        settings: {
            videoAutoStart: {
                value: videoAutoStartValue,
                lastUpdateSource: _sourceHeader,
                lastUpdateDate: Date.now()
            }
        }
    };

    return updateSettingsForFanId(id, postData).tap(function (err, res) {
        if (typeof callback === 'function') {
            callback(err, res);
        }
    }).catch(function () {
        return true;
    }).finally(function () {
        FanAPI.prototype.updateAutoStartCache(postData.settings);
    });
};

FanAPI.prototype.updateAutoStartCache = function (settings) {
    var videoAutoStart = settings.videoAutoStart;
    _storage.getFan().then(function (cache) {
        var fan = cache && cache.item;
        // const cacheExpired = (Date.now() - cache.timestamp > _cacheDuration * 60 * 1000);
        Object.keys(videoAutoStart).forEach(function (key) {
            fan.profile.settings.videoAutoStart[key] = videoAutoStart[key];
        });
        _storage.setFan({ item: fan, id: fan.id, timestamp: Date.now() });
    }).catch(function () {});
};

FanAPI.prototype.getUidsForFanId = function (id, callback) {
    function hasUid(preference) {
        return preference.metaData.team || preference.metaData.sport;
    }

    function collectUids(preference) {
        if (preference.metaData.team) {
            return preference.metaData.team.uid;
        } else if (preference.metaData.sport) {
            return preference.metaData.sport.uid;
        }
        return null;
    }

    return getFanForId(id).then(function (fan) {
        var preferences = fan && fan.preferences;
        return preferences.filter(hasUid).map(collectUids);
    }).catch(function () {
        return [];
    }).tap(function (uids) {
        if (typeof callback === 'function') {
            callback(uids);
        }
    });
};

exports.default = FanAPI;
module.exports = exports['default'];

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(console) {// From https://gist.github.com/epeli/11209665

var Promise = __webpack_require__(11);

// So you can `var request = require("superagent-bluebird-promise")`
var superagent = module.exports = __webpack_require__(192);
var Request = superagent.Request;

try {
  Promise.config({
    // Enable cancellation.
    cancellation: true
  });
} catch (e) {
  console.warn([
    'Enabling bluebird cancellation failed.',
    'If you are using bluebird elsewhere in your application,',
    'be sure to enable cancellation there as well.',
    'Promise.config({cancellation: true});'].join(' ')
  );
  console.warn(e.stack);
}
// Create custom error type.
// Create a new object, that prototypally inherits from the Error constructor.
var SuperagentPromiseError = function(message, originalError) {
  var stack;
  this.message = message;
  this.name = 'SuperagentPromiseError';
  this.originalError = originalError;

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
    stack = this.stack;
  }
  else {
    stack = (new Error(message)).stack;
  }

  if (Object.defineProperty) {
    Object.defineProperty(this, 'stack', {
      get: function() {
        if (this.originalError) {
          return stack + '\nCaused by:  ' + this.originalError.stack;
        }

        return stack;
      }
    });
  }
};

SuperagentPromiseError.prototype = new Error();
SuperagentPromiseError.prototype.constructor = SuperagentPromiseError;
superagent.SuperagentPromiseError = SuperagentPromiseError;

/**
 * @namespace utils
 * @class Superagent
 */

/**
 *
 * Add promise support for superagent/supertest
 *
 * Call .promise() to return promise for the request
 *
 * @method then
 * @return {Bluebird.Promise}
 */
Request.prototype.promise = function() {
  var req = this;
  var error;

  return new Promise(function(resolve, reject, onCancel) {
      req.end(function(err, res) {
        if (typeof res !== "undefined" && res !== null && res.status >= 400) {
          var msg = 'cannot ' + req.method + ' ' + req.url + ' (' + res.status + ')';
          error = new SuperagentPromiseError(msg);
          error.status = res.status;
          error.body = res.body;
          error.res = res;
          reject(error);
        } else if (err) {
          reject(new SuperagentPromiseError('Bad request', err));
        } else {
          resolve(res);
        }
      });

      if (typeof onCancel === 'function') {
        onCancel(function() {
          req.abort();
        });
      }
    });
};

/**
 *
 * Make superagent requests Promises ES6 conformant
 *
 * Call .then([onFulfilled], [onRejected]) to register callbacks
 *
 * @method then
 * @param {function} [onFulfilled]
 * @param {function} [onRejected]
 * @return {Bluebird.Promise}
 */
Request.prototype.then = function() {
  var promise = this.promise();
  return promise.then.apply(promise, arguments);
};

/**
 *
 * Make superagent requests Promises ES6 conformant
 *
 * Call .catch([onRejected]) to register callback
 *
 * @method catch
 * @param {function} [onRejected]
 * @return {Bluebird.Promise}
 */
Request.prototype.catch = function() {
  var promise = this.promise();
  return promise.catch.apply(promise, arguments);
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StorageType = exports.ESPN_FAN_STORAGE_KEY = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global espn window */


var _bluebird = __webpack_require__(11);

var _bluebird2 = _interopRequireDefault(_bluebird);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// this is the key .com uses for local storage of fanapi data
var ESPN_FAN_STORAGE_KEY = exports.ESPN_FAN_STORAGE_KEY = 'fanapi_fan';
var StorageType = exports.StorageType = {
    ESPN: 'ESPN',
    LOCAL_STORAGE: 'LOCAL_STORAGE'
};

var ls = {
    getItem: function getItem(key) {
        return _bluebird2.default.resolve(JSON.parse(global.localStorage.getItem(key)));
    },
    setItem: function setItem(key, value) {
        global.localStorage.setItem(key, JSON.stringify(value));
    }
};

/**
 * @class {Storage} - This class uses ESPN storage if available, and local storage if not
 */

var Storage = function () {
    /**
     * @constructor
     * @param {int} expiration - expiration of storage in minutes
     */
    function Storage() {
        var expiration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;

        _classCallCheck(this, Storage);

        this.expiration = expiration;
        // default to localstorage.  we will infer storage type at the time [get/set]Fan is called
        this.storageType = StorageType.LOCAL_STORAGE;
    }

    /**
     * This function sets appropriate properties if ESPN storage is available.  Does not set it twice if already determined.
     */


    _createClass(Storage, [{
        key: 'inferStorageType',
        value: function inferStorageType() {
            if (this.storageType !== StorageType.ESPN && window && window.espn && window.espn.storageFactory) {
                this.storageType = StorageType.ESPN;
                this.espnStorage = espn.storageFactory.getMostPermanent();
            }
        }
    }, {
        key: 'getFan',
        value: function getFan() {
            var _this = this;

            this.inferStorageType();
            if (this.storageType === StorageType.ESPN) {
                return new _bluebird2.default(function (resolve, reject) {
                    var cache = _this.espnStorage.getItem(ESPN_FAN_STORAGE_KEY);
                    var fan = cache && cache.item;
                    if (fan) {
                        // keep local storage in sync with espn storage
                        ls.setItem(ESPN_FAN_STORAGE_KEY, {
                            item: fan,
                            id: fan.id,
                            timestamp: Date.now()
                        });
                        resolve(cache);
                    } else {
                        reject(new Error('No item for key'));
                    }
                });
            }
            return ls.getItem(ESPN_FAN_STORAGE_KEY);
        }

        /**
         * @param {object} fan - The fan to replace the current cache
         */

    }, {
        key: 'setFan',
        value: function setFan(fan) {
            this.inferStorageType();
            // always set local storage cache
            ls.setItem(ESPN_FAN_STORAGE_KEY, {
                item: fan.item,
                id: fan.id,
                timestamp: Date.now()
            });

            // only set espn storage if present
            if (this.storageType === StorageType.ESPN) {
                this.espnStorage.setItem(ESPN_FAN_STORAGE_KEY, {
                    item: fan.item,
                    id: fan && fan.id,
                    expiresAt: new Date().getTime() + this.expiration * 60000
                });
            }
        }
    }]);

    return Storage;
}();

exports.default = Storage;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {/**
 * generateCommerceFlowUrl - Returns a formatted url string used for DTC commerce. The `locale` is
 * only appended to the url if the country is `us` and the `lang` is either `en` or `es`.
 *
 * @param {object} urlsMap - External app-configurations object containing list of `PACKAGE.DEVICE_TYPE` urls
 * @param {array} packages - An array of entitlements (ex: ['ESPN_PLUS', 'ESPN_PLUS_NHL'])
 * @param {string} deviceType - String representing the Databag device type (ex: 'xbox', 'ps4')
 * @param {string} lang - String representing the language; default `en`
 * @param {string} country - String representing the country; default `US`
 *
 * @return {string} - Returns commerce url or an empty string
 */
/* harmony default export */ __webpack_exports__["a"] = (function () {
    var urlsMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var packages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var deviceType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var lang = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'en';
    var country = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'US';

    var packageKeys = packages;
    var packagesWithDevice = void 0;
    var locale = '';

    if (!urlsMap) {
        console.error('generateCommerceFlowUrl(): urlsMap is undefined, verify config file');
        return '';
    }

    // Priority set here since deviceType is defined
    if (typeof deviceType === 'string' && deviceType.trim() !== '' && packageKeys.length) {
        packagesWithDevice = packageKeys.map(function (pkg) {
            return pkg + '.' + deviceType.toLowerCase();
        });
    }

    if (Array.isArray(packagesWithDevice)) {
        packageKeys = packagesWithDevice;
    }

    var url = urlsMap[packageKeys[0]] || urlsMap.ESPN_PLUS;
    var shouldAppendLocale = url.indexOf('locale') === -1;
    // Add locale if it doesn't exist; only supporting US (domestic) locale for Spanish (es) and English (en)
    if (shouldAppendLocale && typeof country === 'string' && country.toLowerCase() === 'us' && (lang === 'en' || lang === 'es')) {
        locale = url.indexOf('?') !== -1 ? '&locale=' + lang + '_' + country : '?locale=' + lang + '_' + country;
    }

    return '' + url + locale;
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 692 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__(694), src$en$$ = __webpack_require__(699);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(337), src$es5$$ = __webpack_require__(695), src$compiler$$ = __webpack_require__(696), intl$messageformat$parser$$ = __webpack_require__(697);
exports["default"] = MessageFormat;

// -- MessageFormat --------------------------------------------------------

function MessageFormat(message, locales, formats) {
    // Parse string messages into an AST.
    var ast = typeof message === 'string' ?
            MessageFormat.__parse(message) : message;

    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new TypeError('A message must be provided as a String or AST.');
    }

    // Creates a new object with the specified `formats` merged with the default
    // formats.
    formats = this._mergeFormats(MessageFormat.formats, formats);

    // Defined first because it's used to build the format pattern.
    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});

    // Compile the `ast` to a pattern that is highly optimized for repeated
    // `format()` invocations. **Note:** This passes the `locales` set provided
    // to the constructor instead of just the resolved locale.
    var pluralFn = this._findPluralRuleFunction(this._locale);
    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var messageFormat = this;
    this.format = function (values) {
      try {
        return messageFormat._format(pattern, values);
      } catch (e) {
        if (e.variableId) {
          throw new Error(
            'The intl string context variable \'' + e.variableId + '\'' +
            ' was not provided to the string \'' + message + '\''
          );
        } else {
          throw e;
        }
      }
    };
}

// Default format options used as the prototype of the `formats` provided to the
// constructor. These are used when constructing the internal Intl.NumberFormat
// and Intl.DateTimeFormat instances.
src$es5$$.defineProperty(MessageFormat, 'formats', {
    enumerable: true,

    value: {
        number: {
            'currency': {
                style: 'currency'
            },

            'percent': {
                style: 'percent'
            }
        },

        date: {
            'short': {
                month: 'numeric',
                day  : 'numeric',
                year : '2-digit'
            },

            'medium': {
                month: 'short',
                day  : 'numeric',
                year : 'numeric'
            },

            'long': {
                month: 'long',
                day  : 'numeric',
                year : 'numeric'
            },

            'full': {
                weekday: 'long',
                month  : 'long',
                day    : 'numeric',
                year   : 'numeric'
            }
        },

        time: {
            'short': {
                hour  : 'numeric',
                minute: 'numeric'
            },

            'medium':  {
                hour  : 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },

            'long': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            },

            'full': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            }
        }
    }
});

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlMessageFormat is missing a ' +
            '`locale` property'
        );
    }

    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
}});

// Defines `__parse()` static method as an exposed private.
src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});

// Define public `defaultLocale` property which defaults to English, but can be
// set by the developer.
src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

MessageFormat.prototype.resolvedOptions = function () {
    // TODO: Provide anything else?
    return {
        locale: this._locale
    };
};

MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
    return compiler.compile(ast);
};

MessageFormat.prototype._findPluralRuleFunction = function (locale) {
    var localeData = MessageFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find a `pluralRuleFunction` to return.
    while (data) {
        if (data.pluralRuleFunction) {
            return data.pluralRuleFunction;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlMessageFormat is missing a ' +
        '`pluralRuleFunction` for :' + locale
    );
};

MessageFormat.prototype._format = function (pattern, values) {
    var result = '',
        i, len, part, id, value, err;

    for (i = 0, len = pattern.length; i < len; i += 1) {
        part = pattern[i];

        // Exist early for string parts.
        if (typeof part === 'string') {
            result += part;
            continue;
        }

        id = part.id;

        // Enforce that all required values are provided by the caller.
        if (!(values && src$utils$$.hop.call(values, id))) {
          err = new Error('A value must be provided for: ' + id);
          err.variableId = id;
          throw err;
        }

        value = values[id];

        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (part.options) {
            result += this._format(part.getOption(value), values);
        } else {
            result += part.format(value);
        }
    }

    return result;
};

MessageFormat.prototype._mergeFormats = function (defaults, formats) {
    var mergedFormats = {},
        type, mergedType;

    for (type in defaults) {
        if (!src$utils$$.hop.call(defaults, type)) { continue; }

        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);

        if (formats && src$utils$$.hop.call(formats, type)) {
            src$utils$$.extend(mergedType, formats[type]);
        }
    }

    return mergedFormats;
};

MessageFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(MessageFormat.defaultLocale);

    var localeData = MessageFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlMessageFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

//# sourceMappingURL=core.js.map

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(337);

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (src$utils$$.hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports["default"] = Compiler;

function Compiler(locales, formats, pluralFn) {
    this.locales  = locales;
    this.formats  = formats;
    this.pluralFn = pluralFn;
}

Compiler.prototype.compile = function (ast) {
    this.pluralStack        = [];
    this.currentPlural      = null;
    this.pluralNumberFormat = null;

    return this.compileMessage(ast);
};

Compiler.prototype.compileMessage = function (ast) {
    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new Error('Message AST is not of type: "messageFormatPattern"');
    }

    var elements = ast.elements,
        pattern  = [];

    var i, len, element;

    for (i = 0, len = elements.length; i < len; i += 1) {
        element = elements[i];

        switch (element.type) {
            case 'messageTextElement':
                pattern.push(this.compileMessageText(element));
                break;

            case 'argumentElement':
                pattern.push(this.compileArgument(element));
                break;

            default:
                throw new Error('Message element does not have a valid type');
        }
    }

    return pattern;
};

Compiler.prototype.compileMessageText = function (element) {
    // When this `element` is part of plural sub-pattern and its value contains
    // an unescaped '#', use a `PluralOffsetString` helper to properly output
    // the number with the correct offset in the string.
    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
        // Create a cache a NumberFormat instance that can be reused for any
        // PluralOffsetString instance in this message.
        if (!this.pluralNumberFormat) {
            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
        }

        return new PluralOffsetString(
                this.currentPlural.id,
                this.currentPlural.format.offset,
                this.pluralNumberFormat,
                element.value);
    }

    // Unescape the escaped '#'s in the message text.
    return element.value.replace(/\\#/g, '#');
};

Compiler.prototype.compileArgument = function (element) {
    var format = element.format;

    if (!format) {
        return new StringFormat(element.id);
    }

    var formats  = this.formats,
        locales  = this.locales,
        pluralFn = this.pluralFn,
        options;

    switch (format.type) {
        case 'numberFormat':
            options = formats.number[format.style];
            return {
                id    : element.id,
                format: new Intl.NumberFormat(locales, options).format
            };

        case 'dateFormat':
            options = formats.date[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'timeFormat':
            options = formats.time[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'pluralFormat':
            options = this.compileOptions(element);
            return new PluralFormat(
                element.id, format.ordinal, format.offset, options, pluralFn
            );

        case 'selectFormat':
            options = this.compileOptions(element);
            return new SelectFormat(element.id, options);

        default:
            throw new Error('Message element does not have a valid format type');
    }
};

Compiler.prototype.compileOptions = function (element) {
    var format      = element.format,
        options     = format.options,
        optionsHash = {};

    // Save the current plural element, if any, then set it to a new value when
    // compiling the options sub-patterns. This conforms the spec's algorithm
    // for handling `"#"` syntax in message text.
    this.pluralStack.push(this.currentPlural);
    this.currentPlural = format.type === 'pluralFormat' ? element : null;

    var i, len, option;

    for (i = 0, len = options.length; i < len; i += 1) {
        option = options[i];

        // Compile the sub-pattern and save it under the options's selector.
        optionsHash[option.selector] = this.compileMessage(option.value);
    }

    // Pop the plural stack to put back the original current plural value.
    this.currentPlural = this.pluralStack.pop();

    return optionsHash;
};

// -- Compiler Helper Classes --------------------------------------------------

function StringFormat(id) {
    this.id = id;
}

StringFormat.prototype.format = function (value) {
    if (!value && typeof value !== 'number') {
        return '';
    }

    return typeof value === 'string' ? value : String(value);
};

function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
    this.id         = id;
    this.useOrdinal = useOrdinal;
    this.offset     = offset;
    this.options    = options;
    this.pluralFn   = pluralFn;
}

PluralFormat.prototype.getOption = function (value) {
    var options = this.options;

    var option = options['=' + value] ||
            options[this.pluralFn(value - this.offset, this.useOrdinal)];

    return option || options.other;
};

function PluralOffsetString(id, offset, numberFormat, string) {
    this.id           = id;
    this.offset       = offset;
    this.numberFormat = numberFormat;
    this.string       = string;
}

PluralOffsetString.prototype.format = function (value) {
    var number = this.numberFormat.format(value - this.offset);

    return this.string
            .replace(/(^|[^\\])#/g, '$1' + number)
            .replace(/\\#/g, '#');
};

function SelectFormat(id, options) {
    this.id      = id;
    this.options = options;
}

SelectFormat.prototype.getOption = function (value) {
    var options = this.options;
    return options[value] || options.other;
};

//# sourceMappingURL=compiler.js.map

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(698)['default'];
exports['default'] = exports;


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports["default"] = (function() {
  "use strict";

  /*
   * Generated by PEG.js 0.9.0.
   *
   * http://pegjs.org/
   */

  function peg$subclass(child, parent) {
    function ctor() { this.constructor = child; }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
  }

  function peg$SyntaxError(message, expected, found, location) {
    this.message  = message;
    this.expected = expected;
    this.found    = found;
    this.location = location;
    this.name     = "SyntaxError";

    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, peg$SyntaxError);
    }
  }

  peg$subclass(peg$SyntaxError, Error);

  function peg$parse(input) {
    var options = arguments.length > 1 ? arguments[1] : {},
        parser  = this,

        peg$FAILED = {},

        peg$startRuleFunctions = { start: peg$parsestart },
        peg$startRuleFunction  = peg$parsestart,

        peg$c0 = function(elements) {
                return {
                    type    : 'messageFormatPattern',
                    elements: elements,
                    location: location()
                };
            },
        peg$c1 = function(text) {
                var string = '',
                    i, j, outerLen, inner, innerLen;

                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
                    inner = text[i];

                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
                        string += inner[j];
                    }
                }

                return string;
            },
        peg$c2 = function(messageText) {
                return {
                    type : 'messageTextElement',
                    value: messageText,
                    location: location()
                };
            },
        peg$c3 = /^[^ \t\n\r,.+={}#]/,
        peg$c4 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
        peg$c5 = "{",
        peg$c6 = { type: "literal", value: "{", description: "\"{\"" },
        peg$c7 = ",",
        peg$c8 = { type: "literal", value: ",", description: "\",\"" },
        peg$c9 = "}",
        peg$c10 = { type: "literal", value: "}", description: "\"}\"" },
        peg$c11 = function(id, format) {
                return {
                    type  : 'argumentElement',
                    id    : id,
                    format: format && format[2],
                    location: location()
                };
            },
        peg$c12 = "number",
        peg$c13 = { type: "literal", value: "number", description: "\"number\"" },
        peg$c14 = "date",
        peg$c15 = { type: "literal", value: "date", description: "\"date\"" },
        peg$c16 = "time",
        peg$c17 = { type: "literal", value: "time", description: "\"time\"" },
        peg$c18 = function(type, style) {
                return {
                    type : type + 'Format',
                    style: style && style[2],
                    location: location()
                };
            },
        peg$c19 = "plural",
        peg$c20 = { type: "literal", value: "plural", description: "\"plural\"" },
        peg$c21 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: false,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options,
                    location: location()
                };
            },
        peg$c22 = "selectordinal",
        peg$c23 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
        peg$c24 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: true,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options,
                    location: location()
                }
            },
        peg$c25 = "select",
        peg$c26 = { type: "literal", value: "select", description: "\"select\"" },
        peg$c27 = function(options) {
                return {
                    type   : 'selectFormat',
                    options: options,
                    location: location()
                };
            },
        peg$c28 = "=",
        peg$c29 = { type: "literal", value: "=", description: "\"=\"" },
        peg$c30 = function(selector, pattern) {
                return {
                    type    : 'optionalFormatPattern',
                    selector: selector,
                    value   : pattern,
                    location: location()
                };
            },
        peg$c31 = "offset:",
        peg$c32 = { type: "literal", value: "offset:", description: "\"offset:\"" },
        peg$c33 = function(number) {
                return number;
            },
        peg$c34 = function(offset, options) {
                return {
                    type   : 'pluralFormat',
                    offset : offset,
                    options: options,
                    location: location()
                };
            },
        peg$c35 = { type: "other", description: "whitespace" },
        peg$c36 = /^[ \t\n\r]/,
        peg$c37 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
        peg$c38 = { type: "other", description: "optionalWhitespace" },
        peg$c39 = /^[0-9]/,
        peg$c40 = { type: "class", value: "[0-9]", description: "[0-9]" },
        peg$c41 = /^[0-9a-f]/i,
        peg$c42 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
        peg$c43 = "0",
        peg$c44 = { type: "literal", value: "0", description: "\"0\"" },
        peg$c45 = /^[1-9]/,
        peg$c46 = { type: "class", value: "[1-9]", description: "[1-9]" },
        peg$c47 = function(digits) {
            return parseInt(digits, 10);
        },
        peg$c48 = /^[^{}\\\0-\x1F \t\n\r]/,
        peg$c49 = { type: "class", value: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]" },
        peg$c50 = "\\\\",
        peg$c51 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
        peg$c52 = function() { return '\\'; },
        peg$c53 = "\\#",
        peg$c54 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
        peg$c55 = function() { return '\\#'; },
        peg$c56 = "\\{",
        peg$c57 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
        peg$c58 = function() { return '\u007B'; },
        peg$c59 = "\\}",
        peg$c60 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
        peg$c61 = function() { return '\u007D'; },
        peg$c62 = "\\u",
        peg$c63 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
        peg$c64 = function(digits) {
                return String.fromCharCode(parseInt(digits, 16));
            },
        peg$c65 = function(chars) { return chars.join(''); },

        peg$currPos          = 0,
        peg$savedPos         = 0,
        peg$posDetailsCache  = [{ line: 1, column: 1, seenCR: false }],
        peg$maxFailPos       = 0,
        peg$maxFailExpected  = [],
        peg$silentFails      = 0,

        peg$result;

    if ("startRule" in options) {
      if (!(options.startRule in peg$startRuleFunctions)) {
        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
      }

      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }

    function text() {
      return input.substring(peg$savedPos, peg$currPos);
    }

    function location() {
      return peg$computeLocation(peg$savedPos, peg$currPos);
    }

    function expected(description) {
      throw peg$buildException(
        null,
        [{ type: "other", description: description }],
        input.substring(peg$savedPos, peg$currPos),
        peg$computeLocation(peg$savedPos, peg$currPos)
      );
    }

    function error(message) {
      throw peg$buildException(
        message,
        null,
        input.substring(peg$savedPos, peg$currPos),
        peg$computeLocation(peg$savedPos, peg$currPos)
      );
    }

    function peg$computePosDetails(pos) {
      var details = peg$posDetailsCache[pos],
          p, ch;

      if (details) {
        return details;
      } else {
        p = pos - 1;
        while (!peg$posDetailsCache[p]) {
          p--;
        }

        details = peg$posDetailsCache[p];
        details = {
          line:   details.line,
          column: details.column,
          seenCR: details.seenCR
        };

        while (p < pos) {
          ch = input.charAt(p);
          if (ch === "\n") {
            if (!details.seenCR) { details.line++; }
            details.column = 1;
            details.seenCR = false;
          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
            details.line++;
            details.column = 1;
            details.seenCR = true;
          } else {
            details.column++;
            details.seenCR = false;
          }

          p++;
        }

        peg$posDetailsCache[pos] = details;
        return details;
      }
    }

    function peg$computeLocation(startPos, endPos) {
      var startPosDetails = peg$computePosDetails(startPos),
          endPosDetails   = peg$computePosDetails(endPos);

      return {
        start: {
          offset: startPos,
          line:   startPosDetails.line,
          column: startPosDetails.column
        },
        end: {
          offset: endPos,
          line:   endPosDetails.line,
          column: endPosDetails.column
        }
      };
    }

    function peg$fail(expected) {
      if (peg$currPos < peg$maxFailPos) { return; }

      if (peg$currPos > peg$maxFailPos) {
        peg$maxFailPos = peg$currPos;
        peg$maxFailExpected = [];
      }

      peg$maxFailExpected.push(expected);
    }

    function peg$buildException(message, expected, found, location) {
      function cleanupExpected(expected) {
        var i = 1;

        expected.sort(function(a, b) {
          if (a.description < b.description) {
            return -1;
          } else if (a.description > b.description) {
            return 1;
          } else {
            return 0;
          }
        });

        while (i < expected.length) {
          if (expected[i - 1] === expected[i]) {
            expected.splice(i, 1);
          } else {
            i++;
          }
        }
      }

      function buildMessage(expected, found) {
        function stringEscape(s) {
          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }

          return s
            .replace(/\\/g,   '\\\\')
            .replace(/"/g,    '\\"')
            .replace(/\x08/g, '\\b')
            .replace(/\t/g,   '\\t')
            .replace(/\n/g,   '\\n')
            .replace(/\f/g,   '\\f')
            .replace(/\r/g,   '\\r')
            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
            .replace(/[\u0100-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
            .replace(/[\u1000-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
        }

        var expectedDescs = new Array(expected.length),
            expectedDesc, foundDesc, i;

        for (i = 0; i < expected.length; i++) {
          expectedDescs[i] = expected[i].description;
        }

        expectedDesc = expected.length > 1
          ? expectedDescs.slice(0, -1).join(", ")
              + " or "
              + expectedDescs[expected.length - 1]
          : expectedDescs[0];

        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";

        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
      }

      if (expected !== null) {
        cleanupExpected(expected);
      }

      return new peg$SyntaxError(
        message !== null ? message : buildMessage(expected, found),
        expected,
        found,
        location
      );
    }

    function peg$parsestart() {
      var s0;

      s0 = peg$parsemessageFormatPattern();

      return s0;
    }

    function peg$parsemessageFormatPattern() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsemessageFormatElement();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsemessageFormatElement();
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c0(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsemessageFormatElement() {
      var s0;

      s0 = peg$parsemessageTextElement();
      if (s0 === peg$FAILED) {
        s0 = peg$parseargumentElement();
      }

      return s0;
    }

    function peg$parsemessageText() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$currPos;
      s3 = peg$parse_();
      if (s3 !== peg$FAILED) {
        s4 = peg$parsechars();
        if (s4 !== peg$FAILED) {
          s5 = peg$parse_();
          if (s5 !== peg$FAILED) {
            s3 = [s3, s4, s5];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$currPos;
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            s4 = peg$parsechars();
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s3 = [s3, s4, s5];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$FAILED;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c1(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsews();
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parsemessageTextElement() {
      var s0, s1;

      s0 = peg$currPos;
      s1 = peg$parsemessageText();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c2(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parseargument() {
      var s0, s1, s2;

      s0 = peg$parsenumber();
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = [];
        if (peg$c3.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c4); }
        }
        if (s2 !== peg$FAILED) {
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            if (peg$c3.test(input.charAt(peg$currPos))) {
              s2 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c4); }
            }
          }
        } else {
          s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parseargumentElement() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 123) {
        s1 = peg$c5;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c6); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseargument();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$currPos;
              if (input.charCodeAt(peg$currPos) === 44) {
                s6 = peg$c7;
                peg$currPos++;
              } else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c8); }
              }
              if (s6 !== peg$FAILED) {
                s7 = peg$parse_();
                if (s7 !== peg$FAILED) {
                  s8 = peg$parseelementFormat();
                  if (s8 !== peg$FAILED) {
                    s6 = [s6, s7, s8];
                    s5 = s6;
                  } else {
                    peg$currPos = s5;
                    s5 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s5;
                  s5 = peg$FAILED;
                }
              } else {
                peg$currPos = s5;
                s5 = peg$FAILED;
              }
              if (s5 === peg$FAILED) {
                s5 = null;
              }
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 125) {
                    s7 = peg$c9;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c10); }
                  }
                  if (s7 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c11(s3, s5);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseelementFormat() {
      var s0;

      s0 = peg$parsesimpleFormat();
      if (s0 === peg$FAILED) {
        s0 = peg$parsepluralFormat();
        if (s0 === peg$FAILED) {
          s0 = peg$parseselectOrdinalFormat();
          if (s0 === peg$FAILED) {
            s0 = peg$parseselectFormat();
          }
        }
      }

      return s0;
    }

    function peg$parsesimpleFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c12) {
        s1 = peg$c12;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c13); }
      }
      if (s1 === peg$FAILED) {
        if (input.substr(peg$currPos, 4) === peg$c14) {
          s1 = peg$c14;
          peg$currPos += 4;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c15); }
        }
        if (s1 === peg$FAILED) {
          if (input.substr(peg$currPos, 4) === peg$c16) {
            s1 = peg$c16;
            peg$currPos += 4;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c17); }
          }
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 44) {
            s4 = peg$c7;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parse_();
            if (s5 !== peg$FAILED) {
              s6 = peg$parsechars();
              if (s6 !== peg$FAILED) {
                s4 = [s4, s5, s6];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
          if (s3 === peg$FAILED) {
            s3 = null;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c18(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c19) {
        s1 = peg$c19;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c20); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c21(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselectOrdinalFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 13) === peg$c22) {
        s1 = peg$c22;
        peg$currPos += 13;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c23); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c24(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselectFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c25) {
        s1 = peg$c25;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c26); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = [];
              s6 = peg$parseoptionalFormatPattern();
              if (s6 !== peg$FAILED) {
                while (s6 !== peg$FAILED) {
                  s5.push(s6);
                  s6 = peg$parseoptionalFormatPattern();
                }
              } else {
                s5 = peg$FAILED;
              }
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c27(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselector() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      s1 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 61) {
        s2 = peg$c28;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c29); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parsenumber();
        if (s3 !== peg$FAILED) {
          s2 = [s2, s3];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$parsechars();
      }

      return s0;
    }

    function peg$parseoptionalFormatPattern() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      s1 = peg$parse_();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseselector();
        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 123) {
              s4 = peg$c5;
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c6); }
            }
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s6 = peg$parsemessageFormatPattern();
                if (s6 !== peg$FAILED) {
                  s7 = peg$parse_();
                  if (s7 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 125) {
                      s8 = peg$c9;
                      peg$currPos++;
                    } else {
                      s8 = peg$FAILED;
                      if (peg$silentFails === 0) { peg$fail(peg$c10); }
                    }
                    if (s8 !== peg$FAILED) {
                      peg$savedPos = s0;
                      s1 = peg$c30(s2, s6);
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseoffset() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 7) === peg$c31) {
        s1 = peg$c31;
        peg$currPos += 7;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c32); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parsenumber();
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c33(s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralStyle() {
      var s0, s1, s2, s3, s4;

      s0 = peg$currPos;
      s1 = peg$parseoffset();
      if (s1 === peg$FAILED) {
        s1 = null;
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = [];
          s4 = peg$parseoptionalFormatPattern();
          if (s4 !== peg$FAILED) {
            while (s4 !== peg$FAILED) {
              s3.push(s4);
              s4 = peg$parseoptionalFormatPattern();
            }
          } else {
            s3 = peg$FAILED;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c34(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsews() {
      var s0, s1;

      peg$silentFails++;
      s0 = [];
      if (peg$c36.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c37); }
      }
      if (s1 !== peg$FAILED) {
        while (s1 !== peg$FAILED) {
          s0.push(s1);
          if (peg$c36.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c37); }
          }
        }
      } else {
        s0 = peg$FAILED;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c35); }
      }

      return s0;
    }

    function peg$parse_() {
      var s0, s1, s2;

      peg$silentFails++;
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsews();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsews();
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c38); }
      }

      return s0;
    }

    function peg$parsedigit() {
      var s0;

      if (peg$c39.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c40); }
      }

      return s0;
    }

    function peg$parsehexDigit() {
      var s0;

      if (peg$c41.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c42); }
      }

      return s0;
    }

    function peg$parsenumber() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 48) {
        s1 = peg$c43;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c44); }
      }
      if (s1 === peg$FAILED) {
        s1 = peg$currPos;
        s2 = peg$currPos;
        if (peg$c45.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c46); }
        }
        if (s3 !== peg$FAILED) {
          s4 = [];
          s5 = peg$parsedigit();
          while (s5 !== peg$FAILED) {
            s4.push(s5);
            s5 = peg$parsedigit();
          }
          if (s4 !== peg$FAILED) {
            s3 = [s3, s4];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
          s1 = input.substring(s1, peg$currPos);
        } else {
          s1 = s2;
        }
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c47(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsechar() {
      var s0, s1, s2, s3, s4, s5, s6, s7;

      if (peg$c48.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c49); }
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c50) {
          s1 = peg$c50;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c51); }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c52();
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c53) {
            s1 = peg$c53;
            peg$currPos += 2;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c54); }
          }
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c55();
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c56) {
              s1 = peg$c56;
              peg$currPos += 2;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c57); }
            }
            if (s1 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c58();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              if (input.substr(peg$currPos, 2) === peg$c59) {
                s1 = peg$c59;
                peg$currPos += 2;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c60); }
              }
              if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c61();
              }
              s0 = s1;
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 2) === peg$c62) {
                  s1 = peg$c62;
                  peg$currPos += 2;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$c63); }
                }
                if (s1 !== peg$FAILED) {
                  s2 = peg$currPos;
                  s3 = peg$currPos;
                  s4 = peg$parsehexDigit();
                  if (s4 !== peg$FAILED) {
                    s5 = peg$parsehexDigit();
                    if (s5 !== peg$FAILED) {
                      s6 = peg$parsehexDigit();
                      if (s6 !== peg$FAILED) {
                        s7 = peg$parsehexDigit();
                        if (s7 !== peg$FAILED) {
                          s4 = [s4, s5, s6, s7];
                          s3 = s4;
                        } else {
                          peg$currPos = s3;
                          s3 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s3;
                      s3 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                  }
                  if (s3 !== peg$FAILED) {
                    s2 = input.substring(s2, peg$currPos);
                  } else {
                    s2 = s3;
                  }
                  if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c64(s2);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              }
            }
          }
        }
      }

      return s0;
    }

    function peg$parsechars() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsechar();
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$parsechar();
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c65(s1);
      }
      s0 = s1;

      return s0;
    }

    peg$result = peg$startRuleFunction();

    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
      return peg$result;
    } else {
      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
        peg$fail({ type: "end", description: "end of input" });
      }

      throw peg$buildException(
        null,
        peg$maxFailExpected,
        peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
        peg$maxFailPos < input.length
          ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
          : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
      );
    }
  }

  return {
    SyntaxError: peg$SyntaxError,
    parse:       peg$parse
  };
})();

//# sourceMappingURL=parser.js.map

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};

//# sourceMappingURL=en.js.map

/***/ }),
/* 700 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlRelativeFormat = __webpack_require__(702)['default'];

// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(707);

// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlRelativeFormat;
exports['default'] = exports;


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* jslint esnext: true */
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(703);
var en_1 = __webpack_require__(706);
core_1.default.__addLocaleData(en_1.default);
core_1.default.defaultLocale = 'en';
exports.default = core_1.default;
//# sourceMappingURL=main.js.map

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
Object.defineProperty(exports, "__esModule", { value: true });
/* jslint esnext: true */
var intl_messageformat_1 = __webpack_require__(336);
var diff_1 = __webpack_require__(704);
var es5_1 = __webpack_require__(705);
exports.default = RelativeFormat;
// -----------------------------------------------------------------------------
var FIELDS = [
    'second', 'second-short',
    'minute', 'minute-short',
    'hour', 'hour-short',
    'day', 'day-short',
    'month', 'month-short',
    'year', 'year-short'
];
var STYLES = ['best fit', 'numeric'];
// -- RelativeFormat -----------------------------------------------------------
function RelativeFormat(locales, options) {
    options = options || {};
    // Make a copy of `locales` if it's an array, so that it doesn't change
    // since it's used lazily.
    if (es5_1.isArray(locales)) {
        locales = locales.concat();
    }
    es5_1.defineProperty(this, '_locale', { value: this._resolveLocale(locales) });
    es5_1.defineProperty(this, '_options', { value: {
            style: this._resolveStyle(options.style),
            units: this._isValidUnits(options.units) && options.units
        } });
    es5_1.defineProperty(this, '_locales', { value: locales });
    es5_1.defineProperty(this, '_fields', { value: this._findFields(this._locale) });
    es5_1.defineProperty(this, '_messages', { value: es5_1.objCreate(null) });
    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var relativeFormat = this;
    this.format = function format(date, options) {
        return relativeFormat._format(date, options);
    };
}
// Define internal private properties for dealing with locale data.
es5_1.defineProperty(RelativeFormat, '__localeData__', { value: es5_1.objCreate(null) });
es5_1.defineProperty(RelativeFormat, '__addLocaleData', { value: function () {
        for (var i = 0; i < arguments.length; i++) {
            var datum = arguments[i];
            if (!(datum && datum.locale)) {
                throw new Error('Locale data provided to IntlRelativeFormat is missing a ' +
                    '`locale` property value');
            }
            RelativeFormat.__localeData__[datum.locale.toLowerCase()] = datum;
            // Add data to IntlMessageFormat.
            intl_messageformat_1.default.__addLocaleData(datum);
        }
    } });
// Define public `defaultLocale` property which can be set by the developer, or
// it will be set when the first RelativeFormat instance is created by
// leveraging the resolved locale from `Intl`.
es5_1.defineProperty(RelativeFormat, 'defaultLocale', {
    enumerable: true,
    writable: true,
    value: undefined
});
// Define public `thresholds` property which can be set by the developer, and
// defaults to relative time thresholds from moment.js.
es5_1.defineProperty(RelativeFormat, 'thresholds', {
    enumerable: true,
    value: {
        second: 45, 'second-short': 45,
        minute: 45, 'minute-short': 45,
        hour: 22, 'hour-short': 22,
        day: 26, 'day-short': 26,
        month: 11, 'month-short': 11 // months to year
    }
});
RelativeFormat.prototype.resolvedOptions = function () {
    return {
        locale: this._locale,
        style: this._options.style,
        units: this._options.units
    };
};
RelativeFormat.prototype._compileMessage = function (units) {
    // `this._locales` is the original set of locales the user specified to the
    // constructor, while `this._locale` is the resolved root locale.
    var locales = this._locales;
    var resolvedLocale = this._locale;
    var field = this._fields[units];
    var relativeTime = field.relativeTime;
    var future = '';
    var past = '';
    var i;
    for (i in relativeTime.future) {
        if (relativeTime.future.hasOwnProperty(i)) {
            future += ' ' + i + ' {' +
                relativeTime.future[i].replace('{0}', '#') + '}';
        }
    }
    for (i in relativeTime.past) {
        if (relativeTime.past.hasOwnProperty(i)) {
            past += ' ' + i + ' {' +
                relativeTime.past[i].replace('{0}', '#') + '}';
        }
    }
    var message = '{when, select, future {{0, plural, ' + future + '}}' +
        'past {{0, plural, ' + past + '}}}';
    // Create the synthetic IntlMessageFormat instance using the original
    // locales value specified by the user when constructing the the parent
    // IntlRelativeFormat instance.
    return new intl_messageformat_1.default(message, locales);
};
RelativeFormat.prototype._getMessage = function (units) {
    var messages = this._messages;
    // Create a new synthetic message based on the locale data from CLDR.
    if (!messages[units]) {
        messages[units] = this._compileMessage(units);
    }
    return messages[units];
};
RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
    var field = this._fields[units];
    if (field.relative) {
        return field.relative[diff];
    }
};
RelativeFormat.prototype._findFields = function (locale) {
    var localeData = RelativeFormat.__localeData__;
    var data = localeData[locale.toLowerCase()];
    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find `fields` to return.
    while (data) {
        if (data.fields) {
            return data.fields;
        }
        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }
    throw new Error('Locale data added to IntlRelativeFormat is missing `fields` for :' +
        locale);
};
RelativeFormat.prototype._format = function (date, options) {
    var now = options && options.now !== undefined ? options.now : es5_1.dateNow();
    if (date === undefined) {
        date = now;
    }
    // Determine if the `date` and optional `now` values are valid, and throw a
    // similar error to what `Intl.DateTimeFormat#format()` would throw.
    if (!isFinite(now)) {
        throw new RangeError('The `now` option provided to IntlRelativeFormat#format() is not ' +
            'in valid range.');
    }
    if (!isFinite(date)) {
        throw new RangeError('The date value provided to IntlRelativeFormat#format() is not ' +
            'in valid range.');
    }
    var diffReport = diff_1.default(now, date);
    var units = this._options.units || this._selectUnits(diffReport);
    var diffInUnits = diffReport[units];
    if (this._options.style !== 'numeric') {
        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
        if (relativeUnits) {
            return relativeUnits;
        }
    }
    return this._getMessage(units).format({
        '0': Math.abs(diffInUnits),
        when: diffInUnits < 0 ? 'past' : 'future'
    });
};
RelativeFormat.prototype._isValidUnits = function (units) {
    if (!units || es5_1.arrIndexOf.call(FIELDS, units) >= 0) {
        return true;
    }
    if (typeof units === 'string') {
        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
        if (suggestion && es5_1.arrIndexOf.call(FIELDS, suggestion) >= 0) {
            throw new Error('"' + units + '" is not a valid IntlRelativeFormat `units` ' +
                'value, did you mean: ' + suggestion);
        }
    }
    throw new Error('"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
        'must be one of: "' + FIELDS.join('", "') + '"');
};
RelativeFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }
    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(RelativeFormat.defaultLocale);
    var localeData = RelativeFormat.__localeData__;
    var i, len, localeParts, data;
    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');
        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }
            localeParts.pop();
        }
    }
    var defaultLocale = locales.pop();
    throw new Error('No locale data has been added to IntlRelativeFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale);
};
RelativeFormat.prototype._resolveStyle = function (style) {
    // Default to "best fit" style.
    if (!style) {
        return STYLES[0];
    }
    if (es5_1.arrIndexOf.call(STYLES, style) >= 0) {
        return style;
    }
    throw new Error('"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
        'must be one of: "' + STYLES.join('", "') + '"');
};
RelativeFormat.prototype._selectUnits = function (diffReport) {
    var i, l, units;
    var fields = FIELDS.filter(function (field) {
        return field.indexOf('-short') < 1;
    });
    for (i = 0, l = fields.length; i < l; i += 1) {
        units = fields[i];
        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
            break;
        }
    }
    return units;
};
//# sourceMappingURL=core.js.map

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
Object.defineProperty(exports, "__esModule", { value: true });
/* jslint esnext: true */
var round = Math.round;
function daysToYears(days) {
    // 400 years have 146097 days (taking into account leap year rules)
    return days * 400 / 146097;
}
// Thanks to date-fns
// https://github.com/date-fns/date-fns
// MIT © Sasha Koss
var MILLISECONDS_IN_MINUTE = 60000;
var MILLISECONDS_IN_DAY = 86400000;
function startOfDay(dirtyDate) {
    var date = new Date(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
    var startOfDayLeft = startOfDay(dirtyDateLeft);
    var startOfDayRight = startOfDay(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() -
        startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
    var timestampRight = startOfDayRight.getTime() -
        startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}
function default_1(from, to) {
    // Convert to ms timestamps.
    from = +from;
    to = +to;
    var millisecond = round(to - from), second = round(millisecond / 1000), minute = round(second / 60), hour = round(minute / 60);
    // We expect a more precision in rounding when dealing with
    // days as it feels wrong when something happended 13 hours ago and
    // is regarded as "yesterday" even if the time was this morning.
    var day = differenceInCalendarDays(to, from);
    var week = round(day / 7);
    var rawYears = daysToYears(day), month = round(rawYears * 12), year = round(rawYears);
    return {
        millisecond: millisecond,
        second: second,
        'second-short': second,
        minute: minute,
        'minute-short': minute,
        hour: hour,
        'hour-short': hour,
        day: day,
        'day-short': day,
        week: week,
        'week-short': week,
        month: month,
        'month-short': month,
        year: year,
        'year-short': year
    };
}
exports.default = default_1;
//# sourceMappingURL=diff.js.map

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
Object.defineProperty(exports, "__esModule", { value: true });
/* jslint esnext: true */
// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License
var hop = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;
var realDefineProp = (function () {
    try {
        return !!Object.defineProperty({}, 'a', {});
    }
    catch (e) {
        return false;
    }
})();
var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
var defineProperty = realDefineProp ? Object.defineProperty :
    function (obj, name, desc) {
        if ('get' in desc && obj.__defineGetter__) {
            obj.__defineGetter__(name, desc.get);
        }
        else if (!hop.call(obj, name) || 'value' in desc) {
            obj[name] = desc.value;
        }
    };
exports.defineProperty = defineProperty;
var objCreate = Object.create || function (proto, props) {
    var obj, k;
    function F() { }
    F.prototype = proto;
    obj = new F();
    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }
    return obj;
};
exports.objCreate = objCreate;
var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
    /*jshint validthis:true */
    var arr = this;
    if (!arr.length) {
        return -1;
    }
    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
        if (arr[i] === search) {
            return i;
        }
    }
    return -1;
};
exports.arrIndexOf = arrIndexOf;
var isArray = Array.isArray || function (obj) {
    return toString.call(obj) === '[object Array]';
};
exports.isArray = isArray;
var dateNow = Date.now || function () {
    return new Date().getTime();
};
exports.dateNow = dateNow;
//# sourceMappingURL=es5.js.map

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* @generated */
exports.default = { "locale": "en", "pluralRuleFunction": function (n, ord) {
        var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
        if (ord)
            return (n10 == 1 && n100 != 11) ? 'one'
                : (n10 == 2 && n100 != 12) ? 'two'
                    : (n10 == 3 && n100 != 13) ? 'few'
                        : 'other';
        return (n == 1 && v0) ? 'one' : 'other';
    }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "year-short": { "displayName": "yr.", "relative": { "0": "this yr.", "1": "next yr.", "-1": "last yr." }, "relativeTime": { "future": { "one": "in {0} yr.", "other": "in {0} yr." }, "past": { "one": "{0} yr. ago", "other": "{0} yr. ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "month-short": { "displayName": "mo.", "relative": { "0": "this mo.", "1": "next mo.", "-1": "last mo." }, "relativeTime": { "future": { "one": "in {0} mo.", "other": "in {0} mo." }, "past": { "one": "{0} mo. ago", "other": "{0} mo. ago" } } }, "week": { "displayName": "week", "relativePeriod": "the week of {0}", "relative": { "0": "this week", "1": "next week", "-1": "last week" }, "relativeTime": { "future": { "one": "in {0} week", "other": "in {0} weeks" }, "past": { "one": "{0} week ago", "other": "{0} weeks ago" } } }, "week-short": { "displayName": "wk.", "relativePeriod": "the week of {0}", "relative": { "0": "this wk.", "1": "next wk.", "-1": "last wk." }, "relativeTime": { "future": { "one": "in {0} wk.", "other": "in {0} wk." }, "past": { "one": "{0} wk. ago", "other": "{0} wk. ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "day-short": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "hour-short": { "displayName": "hr.", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hr.", "other": "in {0} hr." }, "past": { "one": "{0} hr. ago", "other": "{0} hr. ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "minute-short": { "displayName": "min.", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} min.", "other": "in {0} min." }, "past": { "one": "{0} min. ago", "other": "{0} min. ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } }, "second-short": { "displayName": "sec.", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} sec.", "other": "in {0} sec." }, "past": { "one": "{0} sec. ago", "other": "{0} sec. ago" } } } } };
//# sourceMappingURL=en.js.map

/***/ }),
/* 707 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var ReactIs = __webpack_require__(179);
var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};

var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};

var TYPE_STATICS = {};
TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;

function getStatics(component) {
    if (ReactIs.isMemo(component)) {
        return MEMO_STATICS;
    }
    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* eslint-disable */
/**
 * source: https://github.com/jfriend00/docReady
 * @param  {String} funcName function name
 * @param  {Object} baseObj  scope
 * @return {Function}        document ready
 */
/* harmony default export */ __webpack_exports__["a"] = ((function (funcName, baseObj) {
    funcName = funcName || 'docReady';
    baseObj = baseObj || global.window;
    var readyList = [];
    var readyFired = false;
    var readyEventHandlersInstalled = false;

    function ready() {
        if (!readyFired) {
            readyFired = true;
            for (var i = 0; i < readyList.length; i++) {
                readyList[i].fn.call(window, readyList[i].ctx);
            }
            readyList = [];
        }
    }

    function readyStateChange() {
        if (document.readyState === 'complete') {
            ready();
        }
    }

    return function (callback, context) {
        if (readyFired) {
            setTimeout(function () {
                callback(context);
            }, 1);
            return;
        } else {
            readyList.push({ fn: callback, ctx: context });
        }
        if (document.readyState === 'complete' || !document.attachEvent && document.readyState === 'interactive') {
            setTimeout(ready, 1);
        } else if (!readyEventHandlersInstalled) {
            if (document.addEventListener) {
                document.addEventListener('DOMContentLoaded', ready, false);
                window.addEventListener('load', ready, false);
            } else {
                document.attachEvent('onreadystatechange', readyStateChange);
                window.attachEvent('onload', ready);
            }
            readyEventHandlersInstalled = true;
        }
    };
})('docReady', global.window));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(24)))

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch;
    var getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

exports['default'] = thunk;

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {/* unused harmony export START_GET_NETWORKS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COMPLETE_GET_NETWORKS; });
/* unused harmony export startGetNetworks */
/* unused harmony export completeGetNetworks */
/* unused harmony export fetchNetworks */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apiAction__ = __webpack_require__(55);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



var START_GET_NETWORKS = 'START_GET_NETWORKS';
var COMPLETE_GET_NETWORKS = 'COMPLETE_GET_NETWORKS';

function startGetNetworks() {
    return {
        type: START_GET_NETWORKS,
        startTime: Date.now()
    };
}

function completeGetNetworks(networks) {
    return {
        type: COMPLETE_GET_NETWORKS,
        completeTime: Date.now(),
        networks: networks
    };
}

function fetchNetworks() {
    var _this = this;

    return function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
            var networks, response;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            dispatch(startGetNetworks());

                            networks = [];
                            _context.prev = 2;
                            _context.next = 5;
                            return dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__apiAction__["k" /* graphql */])('getNetworks'));

                        case 5:
                            response = _context.sent;

                            networks = response.data.networks;
                            _context.next = 12;
                            break;

                        case 9:
                            _context.prev = 9;
                            _context.t0 = _context['catch'](2);

                            console.error(_context.t0);

                        case 12:

                            dispatch(completeGetNetworks(networks));

                            return _context.abrupt('return', networks);

                        case 14:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this, [[2, 9]]);
        }));

        return function (_x) {
            return _ref.apply(this, arguments);
        };
    }();
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(285),
    map = __webpack_require__(713);

/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */
function flatMap(collection, iteratee) {
  return baseFlatten(map(collection, iteratee), 1);
}

module.exports = flatMap;


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(133),
    baseIteratee = __webpack_require__(113),
    baseMap = __webpack_require__(714),
    isArray = __webpack_require__(32);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(341),
    isArrayLike = __webpack_require__(51);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(342),
    keys = __webpack_require__(140);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 716 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(51);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(719),
    findIndex = __webpack_require__(208);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(113),
    isArrayLike = __webpack_require__(51),
    keys = __webpack_require__(140);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(721),
    createAssigner = __webpack_require__(734);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(209),
    assignMergeValue = __webpack_require__(343),
    baseFor = __webpack_require__(342),
    baseMergeDeep = __webpack_require__(722),
    isObject = __webpack_require__(35),
    keysIn = __webpack_require__(346),
    safeGet = __webpack_require__(345);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(343),
    cloneBuffer = __webpack_require__(723),
    cloneTypedArray = __webpack_require__(724),
    copyArray = __webpack_require__(726),
    initCloneObject = __webpack_require__(727),
    isArguments = __webpack_require__(111),
    isArray = __webpack_require__(32),
    isArrayLikeObject = __webpack_require__(303),
    isBuffer = __webpack_require__(141),
    isFunction = __webpack_require__(196),
    isObject = __webpack_require__(35),
    isPlainObject = __webpack_require__(729),
    isTypedArray = __webpack_require__(142),
    safeGet = __webpack_require__(345),
    toPlainObject = __webpack_require__(730);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(39);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(107)(module)))

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(725);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(313);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 726 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(728),
    getPrototype = __webpack_require__(344),
    isPrototype = __webpack_require__(136);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(35);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(71),
    getPrototype = __webpack_require__(344),
    isObjectLike = __webpack_require__(59);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(731),
    keysIn = __webpack_require__(346);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(282),
    baseAssignValue = __webpack_require__(134);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(35),
    isPrototype = __webpack_require__(136),
    nativeKeysIn = __webpack_require__(733);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 733 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(302),
    isIterateeCall = __webpack_require__(324);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FeedsSelectorAuthPill__ = __webpack_require__(736);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable max-len */



var isStreamStatus = function isStreamStatus(status, type) {
    return typeof status === 'string' && status.trim() !== '' && typeof type === 'string' && type.trim() !== '' && status.trim().toLowerCase() === type.trim().toLowerCase();
};

var getDisplayTimeMetaData = function getDisplayTimeMetaData(_ref) {
    var status = _ref.status,
        duration = _ref.duration,
        time = _ref.time;

    var displayTime = null;
    var displayClass = '';
    var STATUS_TYPES = {
        LIVE: 'live',
        UPCOMING: 'upcoming',
        REPLAY: 'replay'
    };

    if (isStreamStatus(status, STATUS_TYPES.LIVE)) {
        displayTime = STATUS_TYPES.LIVE.toUpperCase();
        displayClass = STATUS_TYPES.LIVE;
    } else if (isStreamStatus(status, STATUS_TYPES.UPCOMING)) {
        displayTime = '' + time;
    } else if (isStreamStatus(status, STATUS_TYPES.REPLAY)) {
        displayTime = duration;
    }

    return {
        displayTime: displayTime,
        displayClass: displayClass
    };
};

var findMatchingStreamById = function findMatchingStreamById(streamId) {
    var streamsList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    var matchingStream = void 0;

    if (Array.isArray(streamsList) && streamsList.length > 0 && streamId) {
        streamsList.some(function (elem) {
            if (Array.isArray(elem.contents) && elem.contents.length > 0) {
                matchingStream = elem.contents.filter(function (stream) {
                    return typeof stream.id === 'string' && stream.id === streamId;
                })[0];
            }

            if (matchingStream) {
                return true;
            }

            return false;
        });
    }

    return matchingStream;
};

var FeedsSelector = function (_PureComponent) {
    _inherits(FeedsSelector, _PureComponent);

    function FeedsSelector(props) {
        _classCallCheck(this, FeedsSelector);

        var _this = _possibleConstructorReturn(this, (FeedsSelector.__proto__ || Object.getPrototypeOf(FeedsSelector)).call(this, props));

        _this.onClick = _this.onClick.bind(_this);
        _this.closeModal = _this.closeModal.bind(_this);
        return _this;
    }

    _createClass(FeedsSelector, [{
        key: 'onClick',
        value: function onClick(event) {
            console.log('Feeds Selector onClick triggered:', this.props, streamId); // eslint-disable-line
            var streamId = event.currentTarget.getAttribute('data-id');
            var feeds = this.props.feeds;

            var selectedStream = findMatchingStreamById(streamId, feeds);
            if (selectedStream && !selectedStream.selected && !selectedStream.blackoutText) {
                this.props.onClick(selectedStream.streams[0]);
                this.props.onClose();
            } else {
                console.warn('Will not play stream, current stream matches selected stream');
            }
        }
    }, {
        key: 'closeModal',
        value: function closeModal() {
            this.props.onClose();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                title = _props.title,
                feeds = _props.feeds,
                userAuth = _props.userAuth;


            var feedItems = feeds.length > 0 && feeds.map(function (_ref2) {
                var name = _ref2.name,
                    contents = _ref2.contents;

                var feedEntries = null;

                if (Array.isArray(contents) && contents.length > 0) {
                    feedEntries = contents.map(function (_ref3) {
                        var id = _ref3.id,
                            imageHref = _ref3.imageHref,
                            streamName = _ref3.name,
                            subtitle = _ref3.subtitle,
                            status = _ref3.status,
                            duration = _ref3.duration,
                            time = _ref3.time,
                            playbackErrorMessage = _ref3.playbackErrorMessage,
                            selected = _ref3.selected,
                            _ref3$authTypes = _ref3.authTypes,
                            authTypes = _ref3$authTypes === undefined ? [] : _ref3$authTypes,
                            _ref3$packages = _ref3.packages,
                            packages = _ref3$packages === undefined ? [] : _ref3$packages;

                        var timeMeta = getDisplayTimeMetaData({ status: status, duration: duration, time: time });
                        var selectedClass = selected ? 'selected' : '';

                        return _jsx('div', {
                            className: 'StreamingCard ' + selectedClass,
                            'data-id': id,
                            onClick: _this2.onClick
                        }, void 0, _jsx('div', {
                            className: 'StreamingCard__MediaWrapper'
                        }, void 0, imageHref && _jsx('img', {
                            src: imageHref,
                            alt: streamName
                        }), _jsx('div', {
                            className: 'StreamingCard__Media__Play ' + timeMeta.displayClass
                        }), _jsx('div', {
                            className: 'StreamingCard__Media__Pill ' + timeMeta.displayClass
                        }, void 0, timeMeta.displayTime), selected && _jsx('div', {
                            className: 'StreamingCard__NowPlaying'
                        }, void 0, 'Now Playing')), _jsx('div', {
                            className: 'StreamingCard__ContentWrapper'
                        }, void 0, _jsx('div', {
                            className: 'StreamingCard__Content'
                        }, void 0, _jsx('h4', {}, void 0, streamName), _jsx('ul', {
                            className: 'StreamingCard__Meta'
                        }, void 0, _jsx('li', {}, void 0, subtitle)), playbackErrorMessage && _jsx('div', {
                            className: 'StreamingCard__Error'
                        }, void 0, playbackErrorMessage)), !playbackErrorMessage && _jsx(__WEBPACK_IMPORTED_MODULE_1__FeedsSelectorAuthPill__["a" /* default */], {
                            streamContent: { authTypes: authTypes, packages: packages, id: id, streamName: streamName },
                            userAuth: userAuth
                        })));
                    });
                }

                return _jsx('div', {
                    className: 'StreamPicker__Row'
                }, void 0, _jsx('div', {
                    className: 'StreamPicker__Broadcast'
                }, void 0, name), feedEntries);
            });

            return _jsx('div', {
                className: 'video-overlays-container'
            }, void 0, _jsx('div', {
                className: 'overlay streampicker'
            }, void 0, _jsx('div', {
                id: 'stream-view',
                className: 'video-player__stream js-video-player__stream'
            }, void 0, _jsx('div', {
                className: 'StreamPicker__Container'
            }, void 0, _jsx('div', {
                className: 'StreamPicker__Header'
            }, void 0, _jsx('h1', {}, void 0, title), _jsx('div', {
                className: 'StreamPicker__Close',
                onClick: this.closeModal
            })), _jsx('div', {
                className: 'StreamPicker__Body'
            }, void 0, feedItems)))));
        }
    }]);

    return FeedsSelector;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

FeedsSelector.defaultProps = {
    feeds: [],
    userAuth: []
};

/* harmony default export */ __webpack_exports__["a"] = (FeedsSelector);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getAuthLabel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_intersection__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_intersection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_intersection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__enums__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_auth_streamHasAuthType__ = __webpack_require__(45);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();






// const isStreamEspnPlusBase = (packages = []) => (
//     packages.find(entitlement => entitlement === Entitlements.ESPN_PLUS)
// );

var isStreamEspnPlusMlb = function isStreamEspnPlusMlb() {
    var packages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return packages.find(function (entitlement) {
        return entitlement === __WEBPACK_IMPORTED_MODULE_2__enums__["s" /* Entitlements */].ESPN_PLUS_MLB;
    });
};

var isStreamEspnPlusPPV = function isStreamEspnPlusPPV() {
    var packages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return packages.find(function (entitlement) {
        return entitlement.includes(__WEBPACK_IMPORTED_MODULE_2__enums__["s" /* Entitlements */].ESPN_PLUS_UFC_PPV);
    });
};

var isUserEntitled = function isUserEntitled() {
    var authTypes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var userAuth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    var isEntitled = [];
    if (Array.isArray(authTypes) && Array.isArray(userAuth)) {
        isEntitled = __WEBPACK_IMPORTED_MODULE_1_lodash_intersection___default()(authTypes, userAuth);
    }

    return isEntitled.length > 0;
};

var getAuthLabel = function getAuthLabel(_ref) {
    var _ref$userAuth = _ref.userAuth,
        userAuth = _ref$userAuth === undefined ? [] : _ref$userAuth,
        _ref$streamContent = _ref.streamContent,
        streamContent = _ref$streamContent === undefined ? {} : _ref$streamContent;

    if (!streamContent || !streamContent.authTypes) {
        return null;
    }

    var _streamContent$authTy = streamContent.authTypes,
        authTypes = _streamContent$authTy === undefined ? [] : _streamContent$authTy,
        _streamContent$packag = streamContent.packages,
        packages = _streamContent$packag === undefined ? [] : _streamContent$packag;

    var labelClass = 'button sm';
    var label = null;
    var labelText = '';
    var isEntitled = false;

    // E+ Event
    if (Array.isArray(packages) && packages.length > 0 && Object(__WEBPACK_IMPORTED_MODULE_3__lib_auth_streamHasAuthType__["a" /* default */])(streamContent, __WEBPACK_IMPORTED_MODULE_2__enums__["e" /* AuthTypes */].BAM)) {
        isEntitled = isUserEntitled(packages, userAuth);
        if (isStreamEspnPlusPPV(packages)) {
            // Verify if PPV Event
            labelText = isEntitled ? 'PURCHASED' : 'BUY PPV';
        } else if (isStreamEspnPlusMlb(packages)) {
            // Verify if MLB Event
            labelText = isEntitled ? 'SUBSCRIBED TO ESPN+ MLB' : 'Get MLB.TV';
        } else {
            labelText = isEntitled ? 'SUBSCRIBED TO ESPN+' : 'ESPN+';
            labelClass = 'button sm espn-plus';
        }

        label = isEntitled ? _jsx('div', {
            className: 'auth-label auth-label--dark'
        }, void 0, labelText) : _jsx('button', {
            className: '' + labelClass
        }, void 0, labelText);
    } else if (Object(__WEBPACK_IMPORTED_MODULE_3__lib_auth_streamHasAuthType__["a" /* default */])(streamContent, __WEBPACK_IMPORTED_MODULE_2__enums__["e" /* AuthTypes */].MVPD) || Object(__WEBPACK_IMPORTED_MODULE_3__lib_auth_streamHasAuthType__["a" /* default */])(streamContent, __WEBPACK_IMPORTED_MODULE_2__enums__["e" /* AuthTypes */].ISP)) {
        isEntitled = isUserEntitled(authTypes, userAuth);
        labelText = isEntitled ? 'LOGGED INTO TV PROVIDER' : 'CHOOSE TV PROVIDER';
        label = isEntitled ? _jsx('div', {
            className: 'auth-label auth-label--dark'
        }, void 0, labelText) : _jsx('button', {
            className: '' + labelClass
        }, void 0, labelText);
    }

    return label;
};

var FeedsSelectorAuthPill = function FeedsSelectorAuthPill(_ref2) {
    var userAuth = _ref2.userAuth,
        streamContent = _ref2.streamContent;
    return _jsx('div', {
        className: 'StreamingCard__Labels'
    }, void 0, getAuthLabel({ userAuth: userAuth, streamContent: streamContent }));
};

FeedsSelectorAuthPill.defaultProps = {
    userAuth: []
};

/* harmony default export */ __webpack_exports__["a"] = (FeedsSelectorAuthPill);

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pageSelector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__heroSelector__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__selectedContentSelector__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_util_isEmpty__ = __webpack_require__(12);






/**
 * This selector determines which content should be used for the intial embed.
 * If there a piece of content is selected, use that, otherwise use the hero
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_1__pageSelector__["c" /* default */], __WEBPACK_IMPORTED_MODULE_2__heroSelector__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__selectedContentSelector__["a" /* default */], function (_ref, hero, selectedContent) {
    var isFinal = _ref.isFinal;

    // NOTE: When the selectedContent/heroContent type is `vod`, we want to allow playback.
    // This will allow Domestic & International VODs to play
    if (!Object(__WEBPACK_IMPORTED_MODULE_4__lib_util_isEmpty__["a" /* default */])(selectedContent) && typeof selectedContent.type === 'string' && selectedContent.type.trim().toLowerCase() === 'vod') {
        return selectedContent;
    }

    if (!Object(__WEBPACK_IMPORTED_MODULE_4__lib_util_isEmpty__["a" /* default */])(hero) && typeof hero.type === 'string' && hero.type.trim().toLowerCase() === 'vod') {
        return hero;
    }

    if (!isFinal) {
        return null;
    }

    return !Object(__WEBPACK_IMPORTED_MODULE_4__lib_util_isEmpty__["a" /* default */])(selectedContent) ? selectedContent : hero;
}));

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enums__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appSelector__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pageSelector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__selectedContentSelector__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectedStreamSelector__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__playingStreamSelector__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__playerSelector__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__oneIdSelector__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__authenticationSelectors__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_auth_authStateKnown__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_auth_streamHasAuthType__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_auth_canPlayContent__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib_auth_shallowCheckAuthentication__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib_util_isEmpty__ = __webpack_require__(12);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

















/**
 * This selector only returns content if all the conditions needed for playback are met
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_3__pageSelector__["c" /* default */], __WEBPACK_IMPORTED_MODULE_7__playerSelector__["b" /* default */], __WEBPACK_IMPORTED_MODULE_4__selectedContentSelector__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__playingStreamSelector__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__selectedStreamSelector__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__authenticationSelectors__["r" /* userAuthSelector */], __WEBPACK_IMPORTED_MODULE_9__authenticationSelectors__["m" /* ipInfoSelector */], __WEBPACK_IMPORTED_MODULE_9__authenticationSelectors__["b" /* adobePassInfoSelector */], __WEBPACK_IMPORTED_MODULE_2__appSelector__["e" /* bypassTokenSelector */], __WEBPACK_IMPORTED_MODULE_8__oneIdSelector__["g" /* oneIdTokenSelector */], function (page, player, selectedContent, playingStream, selectedStream, userAuth, ipInfo, adobePassInfo, bypassToken, oneIdToken) {
    var isVod = selectedContent && selectedContent.type === 'vod';

    if (page.scored && player.ready === true && (Object(__WEBPACK_IMPORTED_MODULE_10__lib_auth_authStateKnown__["a" /* default */])(userAuth) || isVod || !userAuth.length) && !Object(__WEBPACK_IMPORTED_MODULE_14__lib_util_isEmpty__["a" /* default */])(selectedStream) && selectedContent.reEmbed !== false && player.autoEmbedTimerComplete === true && (
    // This must be for when the linear content has changed the program
    selectedStream.content && selectedContent.id !== selectedStream.content.id || selectedStream.id !== playingStream.id)) {
        if (Object(__WEBPACK_IMPORTED_MODULE_12__lib_auth_canPlayContent__["a" /* default */])(selectedContent, userAuth, false) && Object(__WEBPACK_IMPORTED_MODULE_13__lib_auth_shallowCheckAuthentication__["b" /* default */])(selectedStream, userAuth, false)) {
            if (!selectedStream.authTypes || selectedStream.authTypes.length === 0 || selectedStream.source.id === 'SHORTSTOPLIVE' || bypassToken) {
                return _extends({}, selectedStream);
            } else if (Object(__WEBPACK_IMPORTED_MODULE_11__lib_auth_streamHasAuthType__["a" /* default */])(selectedStream, __WEBPACK_IMPORTED_MODULE_1__enums__["e" /* AuthTypes */].ISP) && userAuth.indexOf(__WEBPACK_IMPORTED_MODULE_1__enums__["e" /* AuthTypes */].ISP) !== -1) {
                return _extends({}, selectedStream, { ipInfo: ipInfo });
            } else if (Object(__WEBPACK_IMPORTED_MODULE_11__lib_auth_streamHasAuthType__["a" /* default */])(selectedStream, __WEBPACK_IMPORTED_MODULE_1__enums__["e" /* AuthTypes */].MVPD) && adobePassInfo) {
                return _extends({}, selectedStream, { adobePassInfo: adobePassInfo });
            } else if (Object(__WEBPACK_IMPORTED_MODULE_11__lib_auth_streamHasAuthType__["a" /* default */])(selectedStream, __WEBPACK_IMPORTED_MODULE_1__enums__["e" /* AuthTypes */].OPEN)) {
                return _extends({}, selectedStream);
            } else if (Object(__WEBPACK_IMPORTED_MODULE_11__lib_auth_streamHasAuthType__["a" /* default */])(selectedStream, __WEBPACK_IMPORTED_MODULE_1__enums__["e" /* AuthTypes */].BAM) && oneIdToken) {
                return _extends({}, selectedStream);
            }
        }
    }
    return {};
}));

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {/* unused harmony export NativeBridge */
/* harmony export (immutable) */ __webpack_exports__["a"] = createNativeBridge;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function NOOP() {}

var nativeBridge = void 0;

function constructMessage(commandName, params, callback) {
    //
    var message = {
        commandName: commandName,
        params: params,
        callBack: callback
    };
    return message;
}

function handleCallback(callback, data, err) {
    // Incoming callback can be either a function or a string - handle either
    if (typeof callback === 'function') {
        callback(data, err);
    } else if (typeof callback === 'string') {
        window[callback](data, err);
    }
}

var NativeBridge = function () {
    function NativeBridge() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { globalNS: 'espn.nativeBridge' },
            globalNS = _ref.globalNS;

        _classCallCheck(this, NativeBridge);

        this.isProcessing = false;
        this.processId = null;
        this.messageQueue = [];
        this.globalNS = globalNS;
        this.ns = globalNS.split('.').reduce(function (acc, ns) {
            acc[ns] = acc[ns] || {};
            return acc[ns];
        }, window);
        var qs = {};
        location.search.replace(/([^?=&]+)(=([^&#]*))?/g, function ($0, $1, $2, $3) {
            qs[$1] = $3;
        });
        this.isIOS = qs.platform === 'ios';
        this.isAndroid = qs.platform === 'android';
        this.isWindows = qs.platform === 'windows';
        // this.sendMessageAsPromise = Promise.promisify(this.sendMessage);
        // this.getDataAsPromise = Promise.promisify(this.getData);
    }

    _createClass(NativeBridge, [{
        key: '_processQueue',
        value: function _processQueue() {
            if (this.isProcessing) {
                return;
            }
            this.isProcessing = true;
            setTimeout(this._processMessages.bind(this), 0);
        }
    }, {
        key: '_processMessages',
        value: function _processMessages() {
            var message = this.messageQueue.shift();
            if (message) {
                var callBack = message.callBack;


                try {
                    this._createCallback(callBack);
                    this._transmitMessage(_extends({}, message, { callBack: this.globalNS + '.callback' }));
                } catch (err) {
                    console.error('NativeBridge: error - _processMessages ' + err.message);
                    this._next(callBack, null, err);
                }

                if (!this.messageQueue.length) {
                    this.isProcessing = false;
                }

                // WINDOWS ONLY
                // Windows Devices do NOT trigger a callback (custom or espn.nativeBridge.callback)
                // If still processing (messageQueue is NOT empty), we will set a short timer to manually trigger
                // the callback and call _processMessges method until processing is complete.
                if (this.isProcessing && this.isWindows) {
                    this.processId = setTimeout(this._processMessages.bind(this), 200);
                }
            }
        }
    }, {
        key: '_createCallback',
        value: function _createCallback(callback) {
            var _this = this;

            // The purpose is to create "chaining" of the native messages since they unfortunately
            // have to share a singular global callback. But this enables us to pass callbacks as functions vs strings.
            this.ns.callback = function (data) {
                _this._next(callback, data);
            };
        }
    }, {
        key: '_next',
        value: function _next(callback, data, err) {
            // if callback is triggered, clear timeout to remove duplicate call
            if (this.processId) {
                clearTimeout(this.processId);
                this.processId = null;
            }
            if (callback) {
                if (err) {
                    handleCallback(callback, null, err);
                } else {
                    try {
                        handleCallback(callback, data);
                    } catch (err2) {
                        handleCallback(callback, null, err2);
                    }
                }
            }
            if (this.messageQueue.length) {
                this._processMessages();
            } else {
                this.ns.callback = NOOP; // reset
            }
        }
    }, {
        key: '_transmitMessage',
        value: function _transmitMessage(message) {
            if (typeof message === 'undefined') {
                return;
            }

            // console.log('NativeBridge: _transmitMessage');

            if (typeof window.webkit !== 'undefined') {
                // iOS, looking for WKWebview injected handler
                window.webkit.messageHandlers.espnWebview.postMessage(message);
                return;
            }

            var data = JSON.stringify(message);
            if (this.isAndroid && window.linklanguage) {
                // Android
                window.linklanguage.sendJSONMessage(data);
            } else if (this.isWindows) {
                // Windows
                window.external.notify(data);
            } else if (this.isIOS) {
                // fallback for backwards compatibility
                window.location = data;
            } else {
                console.log("NativeBridge: message sent with", message);
            }
        }
    }, {
        key: '_sendMessage',
        value: function _sendMessage(message) {
            this.messageQueue.push(message);
            this._processQueue();
        }
    }, {
        key: 'getData',
        value: function getData(dataName, callback) {
            // Provided as a fallback for backwards compatibility
            var native = window.espn.native;

            if (typeof native !== 'undefined') {
                if (native[dataName] === 'true' || native[dataName] === 'false') {
                    // convert boolean string to boolean
                    native[dataName] = native[dataName] === 'true';
                }
                callback(native[dataName]);
                return;
            }

            this.sendMessage(dataName, {}, callback);
        }
    }, {
        key: 'sendMessage',
        value: function sendMessage(message, params, callback) {
            this._sendMessage(constructMessage(message, params, callback));
        }
    }, {
        key: 'loadMinibrowser',
        value: function loadMinibrowser(url) {
            if (this.isAndroid) {
                try {
                    window.linklanguage.loadMinibrowserWithURL(url);
                } catch (err) {
                    console.warn('nativeBridge send failed', url);
                }
            } else {
                this.sendMessage('loadMinibrowserWithURL', { url: url, link: url });
            }
        }
    }]);

    return NativeBridge;
}();

function createNativeBridge(config) {
    if (!nativeBridge && typeof window !== 'undefined') {
        nativeBridge = new NativeBridge(config);
    }
    return nativeBridge;
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BaseSearchResultAsList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__alias_Playable__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_format_dateFormat__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__enums__ = __webpack_require__(1);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var headerMappings = [{
    keyType: 'Date',
    value: 'startTime'
}, {
    keyType: 'Title',
    value: 'name'
}, {
    keyType: 'Sport',
    value: 'sport'
}, {
    keyType: 'League',
    value: 'league'
}, {
    keyType: 'Network',
    value: 'network'
}, {
    keyType: 'Link',
    value: 'link'
}];

function sortByDateDescending(c1, c2) {
    return new Date(c2.utc) - new Date(c1.utc);
}

function getSearchResultList() {
    var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var stream = content.streams.find(function (el) {
        return el.links && el.links.web;
    });
    var displayTime = content.utc && __WEBPACK_IMPORTED_MODULE_2__lib_format_dateFormat__["a" /* default */].dateFormat(content.utc, 'dateTime7');
    return {
        displayTime: displayTime,
        name: content.name,
        sport: content.programmingData.sport,
        league: content.programmingData.league,
        network: stream.source.name,
        link: stream.links.web
    };
}

function copyToClipboard(copiedText) {
    var clipboardElement = document.createElement('input');
    document.body.appendChild(clipboardElement);
    clipboardElement.setAttribute('value', copiedText);
    clipboardElement.select();
    document.execCommand('copy');
    document.body.removeChild(clipboardElement);
}

var SearchResultAsList = function (_Component) {
    _inherits(SearchResultAsList, _Component);

    function SearchResultAsList(props) {
        _classCallCheck(this, SearchResultAsList);

        var _this = _possibleConstructorReturn(this, (SearchResultAsList.__proto__ || Object.getPrototypeOf(SearchResultAsList)).call(this, props));

        _this.state = {
            sortBy: 'Date',
            sortOrder: __WEBPACK_IMPORTED_MODULE_3__enums__["D" /* SortOrder */].DESC
        };
        return _this;
    }

    _createClass(SearchResultAsList, [{
        key: 'clickHeader',
        value: function clickHeader(index) {
            var _state = this.state,
                sortBy = _state.sortBy,
                sortOrder = _state.sortOrder;
            var keyType = headerMappings[index].keyType;

            if (keyType === this.state.sortBy) {
                sortOrder = this.state.sortOrder === __WEBPACK_IMPORTED_MODULE_3__enums__["D" /* SortOrder */].DESC ? __WEBPACK_IMPORTED_MODULE_3__enums__["D" /* SortOrder */].ASC : __WEBPACK_IMPORTED_MODULE_3__enums__["D" /* SortOrder */].DESC;
            } else {
                sortBy = keyType;
                sortOrder = __WEBPACK_IMPORTED_MODULE_3__enums__["D" /* SortOrder */].DESC;
            }
            this.setState({
                sortBy: sortBy,
                sortOrder: sortOrder
            });
            this.props.sortContents(headerMappings[index].value, sortOrder);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var headerRows = headerMappings.map(function (headerMapping, index) {
                return _jsx('th', {
                    onClick: function onClick() {
                        return _this2.clickHeader(index);
                    }
                }, void 0, headerMapping.keyType);
            });
            var header = _jsx('tr', {}, void 0, headerRows);
            var rows = this.props.contents.sort(sortByDateDescending).map(function (content) {
                var searchResultListing = getSearchResultList(content);
                return _jsx('tr', {}, 'tr_' + content.id, _jsx('td', {
                    className: 'schedule__time'
                }, void 0, searchResultListing.displayTime), _jsx('td', {
                    className: 'schedule__time'
                }, void 0, searchResultListing.name), _jsx('td', {
                    className: 'schedule__time'
                }, void 0, searchResultListing.sport), _jsx('td', {
                    className: 'schedule__time'
                }, void 0, searchResultListing.league), _jsx('td', {
                    className: 'schedule__network'
                }, void 0, searchResultListing.network), _jsx('td', {
                    className: 'schedule__competitors'
                }, void 0, _jsx('button', {
                    onClick: function onClick() {
                        copyToClipboard(searchResultListing.link);
                    }
                }, void 0, 'Copy Event Link')));
            });
            return _jsx('table', {}, void 0, _jsx('thead', {}, void 0, header), _jsx('tbody', {}, void 0, rows));
        }
    }]);

    return SearchResultAsList;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__alias_Playable__["a" /* default */])(SearchResultAsList));


/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_file_saver__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_format_dateFormat__ = __webpack_require__(33);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();






function prepareCsv(buckets) {
    var csvContent = 'Start Time,Event Name,Sport,League,Network,Link\r\n';
    buckets.forEach(function (bucket) {
        var contents = bucket.contents;
        contents.forEach(function (content) {
            if (!content.programmingData) {
                content.programmingData = {};
            }
            var _content$programmingD = content.programmingData,
                _content$programmingD2 = _content$programmingD.sport,
                sport = _content$programmingD2 === undefined ? '' : _content$programmingD2,
                _content$programmingD3 = _content$programmingD.league,
                league = _content$programmingD3 === undefined ? '' : _content$programmingD3,
                _content$name = content.name,
                name = _content$name === undefined ? '' : _content$name,
                _content$utc = content.utc,
                utc = _content$utc === undefined ? '' : _content$utc;
            var _content$streams$ = content.streams[0],
                _content$streams$$sou = _content$streams$.source.name,
                sourceName = _content$streams$$sou === undefined ? '' : _content$streams$$sou,
                _content$streams$$lin = _content$streams$.links.web,
                webLink = _content$streams$$lin === undefined ? '' : _content$streams$$lin;

            var dateAndTime = __WEBPACK_IMPORTED_MODULE_2__lib_format_dateFormat__["a" /* default */].dateFormat(utc, 'dateTime7');
            var row = '"' + dateAndTime + '","' + name + '",' + sport + ',' + league + ',' + sourceName + ',' + webLink;
            csvContent = '' + csvContent + row + '\r\n';
        });
    });
    return csvContent;
}

var DownloadLink = function DownloadLink(_ref) {
    var text = _ref.text,
        buckets = _ref.buckets,
        fileName = _ref.fileName,
        _ref$mimeType = _ref.mimeType,
        mimeType = _ref$mimeType === undefined ? 'text/csv' : _ref$mimeType;

    var dataString = prepareCsv(buckets);
    function clickHandler(ev) {
        // File is not available on the server, so must be built in the browser
        var file = new File([dataString], fileName, { type: mimeType });
        ev.preventDefault();
        __WEBPACK_IMPORTED_MODULE_1_file_saver___default.a.saveAs(file);
    }
    return _jsx('a', {
        onClick: clickHandler
    }, void 0, text);
};

/* harmony default export */ __webpack_exports__["a"] = (DownloadLink);

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/* FileSaver.js
 * A saveAs() FileSaver implementation.
 * 1.3.2
 * 2016-06-16 18:25:19
 *
 * By Eli Grey, http://eligrey.com
 * License: MIT
 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
 */

/*global self */
/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */

/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */

var saveAs = saveAs || (function(view) {
	"use strict";
	// IE <10 is explicitly unsupported
	if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
		return;
	}
	var
		  doc = view.document
		  // only get URL when necessary in case Blob.js hasn't overridden it yet
		, get_URL = function() {
			return view.URL || view.webkitURL || view;
		}
		, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a")
		, can_use_save_link = "download" in save_link
		, click = function(node) {
			var event = new MouseEvent("click");
			node.dispatchEvent(event);
		}
		, is_safari = /constructor/i.test(view.HTMLElement) || view.safari
		, is_chrome_ios =/CriOS\/[\d]+/.test(navigator.userAgent)
		, throw_outside = function(ex) {
			(view.setImmediate || view.setTimeout)(function() {
				throw ex;
			}, 0);
		}
		, force_saveable_type = "application/octet-stream"
		// the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
		, arbitrary_revoke_timeout = 1000 * 40 // in ms
		, revoke = function(file) {
			var revoker = function() {
				if (typeof file === "string") { // file is an object URL
					get_URL().revokeObjectURL(file);
				} else { // file is a File
					file.remove();
				}
			};
			setTimeout(revoker, arbitrary_revoke_timeout);
		}
		, dispatch = function(filesaver, event_types, event) {
			event_types = [].concat(event_types);
			var i = event_types.length;
			while (i--) {
				var listener = filesaver["on" + event_types[i]];
				if (typeof listener === "function") {
					try {
						listener.call(filesaver, event || filesaver);
					} catch (ex) {
						throw_outside(ex);
					}
				}
			}
		}
		, auto_bom = function(blob) {
			// prepend BOM for UTF-8 XML and text/* types (including HTML)
			// note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
			if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
				return new Blob([String.fromCharCode(0xFEFF), blob], {type: blob.type});
			}
			return blob;
		}
		, FileSaver = function(blob, name, no_auto_bom) {
			if (!no_auto_bom) {
				blob = auto_bom(blob);
			}
			// First try a.download, then web filesystem, then object URLs
			var
				  filesaver = this
				, type = blob.type
				, force = type === force_saveable_type
				, object_url
				, dispatch_all = function() {
					dispatch(filesaver, "writestart progress write writeend".split(" "));
				}
				// on any filesys errors revert to saving with object URLs
				, fs_error = function() {
					if ((is_chrome_ios || (force && is_safari)) && view.FileReader) {
						// Safari doesn't allow downloading of blob urls
						var reader = new FileReader();
						reader.onloadend = function() {
							var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
							var popup = view.open(url, '_blank');
							if(!popup) view.location.href = url;
							url=undefined; // release reference before dispatching
							filesaver.readyState = filesaver.DONE;
							dispatch_all();
						};
						reader.readAsDataURL(blob);
						filesaver.readyState = filesaver.INIT;
						return;
					}
					// don't create more object URLs than needed
					if (!object_url) {
						object_url = get_URL().createObjectURL(blob);
					}
					if (force) {
						view.location.href = object_url;
					} else {
						var opened = view.open(object_url, "_blank");
						if (!opened) {
							// Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
							view.location.href = object_url;
						}
					}
					filesaver.readyState = filesaver.DONE;
					dispatch_all();
					revoke(object_url);
				}
			;
			filesaver.readyState = filesaver.INIT;

			if (can_use_save_link) {
				object_url = get_URL().createObjectURL(blob);
				setTimeout(function() {
					save_link.href = object_url;
					save_link.download = name;
					click(save_link);
					dispatch_all();
					revoke(object_url);
					filesaver.readyState = filesaver.DONE;
				});
				return;
			}

			fs_error();
		}
		, FS_proto = FileSaver.prototype
		, saveAs = function(blob, name, no_auto_bom) {
			return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
		}
	;
	// IE 10+ (native saveAs)
	if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
		return function(blob, name, no_auto_bom) {
			name = name || blob.name || "download";

			if (!no_auto_bom) {
				blob = auto_bom(blob);
			}
			return navigator.msSaveOrOpenBlob(blob, name);
		};
	}

	FS_proto.abort = function(){};
	FS_proto.readyState = FS_proto.INIT = 0;
	FS_proto.WRITING = 1;
	FS_proto.DONE = 2;

	FS_proto.error =
	FS_proto.onwritestart =
	FS_proto.onprogress =
	FS_proto.onwrite =
	FS_proto.onabort =
	FS_proto.onerror =
	FS_proto.onwriteend =
		null;

	return saveAs;
}(
	   typeof self !== "undefined" && self
	|| typeof window !== "undefined" && window
	|| this.content
));
// `self` is undefined in Firefox for Android content script context
// while `this` is nsIContentFrameMessageManager
// with an attribute `content` that corresponds to the window

if (typeof module !== "undefined" && module.exports) {
  module.exports.saveAs = saveAs;
} else if (("function" !== "undefined" && __webpack_require__(743) !== null) && (__webpack_require__(744) !== null)) {
  !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
    return saveAs;
  }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}


/***/ }),
/* 743 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 744 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_format_dateFormat__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isPacRimOrCarib__ = __webpack_require__(360);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable */








function buildInitialState(_ref) {
    var isResponsive = _ref.isResponsive;

    var iDayRange = 7;
    var iItemWidth = 36;
    var maxWidthMedium = 768;

    /*
     Below condition checks for screen size and initialize iDayRange and iItemWidth
     based on that. For mobile < 768 iItemWidth is fixed to 40px
     */
    if (isResponsive && true && screen && 'width' in screen && screen.width < maxWidthMedium) {
        iDayRange = 5;
        iItemWidth = 37;
    }

    var iStartPos = 0 - iDayRange * iItemWidth;
    return {
        activeDate: null,
        displayDate: null,
        oneDay: 86400000, // 1 day in milliseconds
        dayRange: iDayRange,
        itemWidth: iItemWidth,
        touchObject: {
            startX: null,
            startY: null,
            curX: null,
            curY: null,
            swipeLength: null
        },
        didSwipe: false,
        dragging: false,
        animate: false,
        currentPos: iStartPos
    };
}

var DateSlider = function (_Component) {
    _inherits(DateSlider, _Component);

    function DateSlider(props) {
        _classCallCheck(this, DateSlider);

        var _this = _possibleConstructorReturn(this, (DateSlider.__proto__ || Object.getPrototypeOf(DateSlider)).call(this, props));

        _this.dateFormat = __WEBPACK_IMPORTED_MODULE_2__lib_format_dateFormat__["a" /* default */].dateFormat;
        _this.dateToObject = __WEBPACK_IMPORTED_MODULE_2__lib_format_dateFormat__["a" /* default */].dateToObject;
        _this.dateToKey = __WEBPACK_IMPORTED_MODULE_2__lib_format_dateFormat__["a" /* default */].dateToKey;
        _this.state = buildInitialState(props);
        _this.animateToDate = _this.animateToDate.bind(_this);
        _this.previous = _this.previous.bind(_this);
        _this.next = _this.next.bind(_this);
        _this.reset = _this.reset.bind(_this);
        _this.swipeStart = _this.swipeStart.bind(_this);
        _this.swipeMove = _this.swipeMove.bind(_this);
        _this.swipeEnd = _this.swipeEnd.bind(_this);
        _this.swipeDirection = _this.swipeDirection.bind(_this);
        _this._throttle = _this._throttle.bind(_this);
        _this.selectDate = _this.selectDate.bind(_this);
        _this.dateSelected = _this.dateSelected.bind(_this);
        return _this;
    }

    /**
     * Intial load so add the date to the state for use and manipulation
     * @returns {undefined} undefined
     **/


    _createClass(DateSlider, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            // Ignore "dates" param if in Replay tab (default to current date)
            var oDate = this.props.isReplaySlider ? new Date() : this.dateToObject(this.props.date) || new Date();
            var iDate = oDate.setHours(0, 0, 0, 0);
            this.setState({
                activeDate: iDate,
                displayDate: iDate
            });
        }

        /**
         * Reset state if league has changed
         *
         * @param {Object} nextProps Props
         * @returns {undefined} undefined
         **/

    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var oDate = this.dateToObject(nextProps.date) || new Date();
            var iDate = oDate.setHours(0, 0, 0, 0);

            if (nextProps.league !== this.props.league) {
                this.animateToDate(iDate);
                this.setState({
                    activeDate: iDate,
                    didSwipe: false
                });
            }
        }

        /**
         * Subtracts 7 days from the current date and then forces a redraw
         * @returns {undefined} undefined
         **/

    }, {
        key: 'previous',
        value: function previous() {
            var _state = this.state,
                displayDate = _state.displayDate,
                dayRange = _state.dayRange;

            var iNewDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(displayDate).subtract(dayRange, 'days').valueOf();
            this.animateToDate(iNewDate);
        }

        /**
         * Adds 7 days to the current date and then forces a redraw
         * @returns {undefined} undefined
         **/

    }, {
        key: 'next',
        value: function next() {
            var _state2 = this.state,
                displayDate = _state2.displayDate,
                dayRange = _state2.dayRange;

            var iNewDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(displayDate).add(dayRange, 'days').valueOf();
            this.animateToDate(iNewDate);
        }

        /**
         * Redraws the page to last know good state
         * @returns {undefined} undefined
         **/

    }, {
        key: 'reset',
        value: function reset() {
            this.setState({});
        }

        /**
         * Capture the start position of the mouse/touch so that we can
         * determine the direction and size of the interaction later.
         *
         * @param {Object} e event object
         * @returns {undefined} undefined
         **/

    }, {
        key: 'swipeStart',
        value: function swipeStart(e) {
            var posX = e.touches !== undefined ? e.touches[0].pageX : e.clientX;
            var posY = e.touches !== undefined ? e.touches[0].pageY : e.clientY;

            this.setState({
                dragging: true,
                touchObject: {
                    startX: posX,
                    startY: posY,
                    curX: posX,
                    curY: posY
                }
            });

            // e.preventDefault()
        }

        /**
         * Captures the current mouse/finger movement and stores the value to
         * allow the position of the slider to be updated.
         *
         * @param {Object} e event object
         * @returns {undefined} undefined
         **/

    }, {
        key: 'swipeMove',
        value: function swipeMove(e) {
            if (!this.state.dragging) {
                return;
            }

            var touchObject = this.state.touchObject;

            var iCurrX = e.touches ? e.touches[0].pageX : e.clientX;
            touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
            touchObject.swipeLength = touchObject.curX - touchObject.startX;
            var iMoved = iCurrX - this.state.touchObject.curX;
            touchObject.curX = iCurrX;
            this.setState({
                touchObject: touchObject,
                currentPos: this.state.currentPos + iMoved
            });
            if (e && e.preventDefault) {
                e.preventDefault();
            }
        }

        /**
         * Capture end event and then calculate the action desired by the user
         *
         * @param {Object} e event object
         * @returns {undefined} undefined
         **/

    }, {
        key: 'swipeEnd',
        value: function swipeEnd() {
            // e.preventDefault()

            if (!this.state.dragging) {
                return;
            }

            var touchObject = this.state.touchObject;
            // const minSwipe        = this.state.listWidth/this.props.touchThreshold
            var swipeDirection = this.swipeDirection(touchObject);

            // reset the state of touch related state constiables.
            this.setState({
                dragging: false,
                touchObject: {},
                swipeLength: 0
            });

            if (swipeDirection === 'left' && Math.abs(touchObject.swipeLength) > 5) {
                this.setState({ didSwipe: true });
                this.previous();
            } else if (swipeDirection === 'right' && Math.abs(touchObject.swipeLength) > 5) {
                this.setState({ didSwipe: true });
                this.next();
            } else if (Math.abs(touchObject.swipeLength) > 1) {
                // micro swipe, not really a click.
                this.reset();
            } else {
                this.reset();
            }
        }

        /**
         * Determines whether the swipe was within a certain angle range and
         * therefore a horizontal swipe rather than a verticle one.
         *
         * @param {Object} touchObject touchObject
         * @returns {String} left/right/vertical
         **/

    }, {
        key: 'swipeDirection',
        value: function swipeDirection(touchObject) {
            var xDist = touchObject.startX - touchObject.curX;
            var yDist = touchObject.startY - touchObject.curY;
            var r = Math.atan2(yDist, xDist);
            var swipeAngle = Math.round(r * 180 / Math.PI);

            if (swipeAngle < 0) {
                swipeAngle = 360 - Math.abs(swipeAngle);
            }
            if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
                return this.props.rtl === false ? 'left' : 'right';
            }
            if (swipeAngle >= 135 && swipeAngle <= 225) {
                return this.props.rtl === false ? 'right' : 'left';
            }

            return 'vertical';
        }

        /**
         * for performance reasons provide a facility to throttle the updates
         * triggered by mousemove
         *
         * @param {Number} delay time to delay
         * @param {Function} callback function reference which needs to be throttled
         * @returns {Function} Anonymous Function
         **/

    }, {
        key: '_throttle',
        value: function _throttle(delay, callback) {
            var previousCall = new Date().getTime();
            return function () {
                var time = new Date().getTime();
                if (time - previousCall >= delay) {
                    previousCall = time;
                    callback.apply(null, arguments);
                }
            };
        }

        /**
         * Captures the date of the node clicked and sets the state to that. If
         * a swipe was tracked the click is ignored and the swipe tracker reset
         *
         * @param {Number} iDate date
         * @param {Number} iItemPos position index
         * @param {Object} e Event
         * @returns {undefined} undefined
         **/

    }, {
        key: 'selectDate',
        value: function selectDate(iDate, iItemPos, e) {
            if (e && e.stopPropagation) {
                e.stopPropagation();
            }
            if (e && e.preventDefault) {
                e.preventDefault();
            }
            iDate = (typeof iDate === 'undefined' ? 'undefined' : _typeof(iDate)) === 'object' ? iDate.setHours(0, 0, 0, 0) : iDate;
            if (typeof this.state.touchObject.swipeLength !== 'number') {
                this.setState({
                    activeDate: iDate
                });
                this.animateToDate(iDate);
                this.dateSelected(iDate);
            }
        }

        /**
         * Calculates the position of the original display date within the
         * new range of dates so it can create the animation effect
         *
         * @param {Number} iNewDate date
         * @returns {undefined} undefined
         **/

    }, {
        key: 'animateToDate',
        value: function animateToDate(iNewDate) {
            // get the visible range of dates.
            // Ignore "dates" param if in Replay tab (default to current date)
            var oDate = this.props.isReplaySlider ? new Date() : this.dateToObject(this.props.date) || new Date();
            var iDate = oDate.setHours(0, 0, 0, 0);
            var lastDateInRange = this.props.isReplaySlider ? __WEBPACK_IMPORTED_MODULE_3_moment___default()(iDate).add(this.props.maxDaysInFuture, 'days') : __WEBPACK_IMPORTED_MODULE_3_moment___default()(iDate).add(this.props.maxDaysInFuture - this.state.dayRange, 'days');
            var firstDateInrange = __WEBPACK_IMPORTED_MODULE_3_moment___default()(iDate).subtract(this.props.maxDaysInPast, 'days');
            var canSlideForward = __WEBPACK_IMPORTED_MODULE_3_moment___default()(iNewDate).isBefore(lastDateInRange, 'day');
            var canSlideBack = __WEBPACK_IMPORTED_MODULE_3_moment___default()(iNewDate).isAfter(firstDateInrange, 'day');
            var iOneDay = this.state.oneDay;
            var iDayRange = this.state.dayRange;
            if (!canSlideBack) {
                iNewDate = firstDateInrange.valueOf();
            }
            if (!canSlideForward) {
                iNewDate = lastDateInRange.valueOf();
            }
            var iDisplayDate = this.state.displayDate;
            // NOTE: All date calculations such as adding/subtracting will be using moment to ensure daylight savings compatibility
            var iMinDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(iNewDate).subtract(iDayRange, 'days').valueOf();
            var iMaxDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(iMinDate).add(iDayRange * 3, 'days').valueOf();
            var iItemWidth = this.state.itemWidth;
            var iMoveTo = 0;

            if (iDisplayDate >= iMinDate && iDisplayDate <= iMaxDate) {
                // is the original date within the visible range?
                var iDiff = iDisplayDate - iMinDate;
                iMoveTo = 0 - iDiff / iOneDay * iItemWidth;
            } else if (iDisplayDate > iMaxDate) {
                // is it bigger then set moveto to last
                iMoveTo = 0 - iItemWidth * (iDayRange * 3);
            } else if (iDisplayDate < iMinDate) {
                // is it smaller then set moveto to first
                iMoveTo = 0;
            }

            this.setState({
                displayDate: iNewDate,
                currentPos: iMoveTo,
                animate: false
            });
        }

        /**
         * Call once we have selected a date
         *
         * @param {Number} iDate date
         * @returns {undefined} undefined
         **/

    }, {
        key: 'dateSelected',
        value: function dateSelected(iDate) {
            var selectedDate = this.dateFormat(iDate, 'date12');
            this.props.onDateSelected(this.dateToObject(iDate), selectedDate);
        }

        /**
         * After the component has drawn reset the position of the slider
         * this will cause the css animation to trigger. The timeout is to
         * force react to re-render else it trys to group the changes into 1
         * update and you won't see the animation
         *
         * @returns {undefined} undefined
         **/

    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var _this2 = this;

            var iDayRange = this.state.dayRange;
            var iItemWidth = this.state.itemWidth;
            var iNewPos = 0 - iDayRange * iItemWidth;

            if (iNewPos !== this.state.currentPos) {
                setTimeout(function () {
                    _this2.setState({
                        currentPos: iNewPos,
                        animate: true
                    });
                }, 1);
            }
        }
    }, {
        key: 'getIntlDate',
        value: function getIntlDate(date) {
            try {
                var _props = this.props,
                    formatMessage = _props.formatMessage,
                    messages = _props.messages,
                    isIntl = _props.isIntl;

                var watchRegion = this.props.watchRegion;

                // PacRim/Carib (au) needs format tweak
                if (!isIntl && !Object(__WEBPACK_IMPORTED_MODULE_4__isPacRimOrCarib__["a" /* default */])(watchRegion)) {
                    return date;
                }
                var arr = date.split(' ');
                var month = formatMessage(messages['schedule.calendar.month.' + arr[0]]);
                var day = arr[1];
                var year = arr[2];

                // for PacRim/Carib (au), it needs to remove commas
                if (Object(__WEBPACK_IMPORTED_MODULE_4__isPacRimOrCarib__["a" /* default */])(watchRegion)) {
                    day = arr[1].replace(',', '');
                    return day + ' ' + month + ' ' + year;
                }

                var isNLEdition = typeof watchRegion === 'string' && watchRegion.toLowerCase() === "netherlands";

                // All INTL removes date suffix
                day = arr[1].replace(/st,|nd,|rd,|th,/i, "");
                if (isNLEdition) {
                    var nlFormatedDate = day + ' ' + month + ' ' + year;
                    return nlFormatedDate.toLocaleLowerCase();
                }

                // All other INTL edition, adds 'de'
                return day + ' de ' + month + ', ' + year;
            } catch (e) {
                console.error(e.messages);
                return date;
            }
        }
    }, {
        key: 'getStartDate',
        value: function getStartDate(isReplaySlider, iDisplayDate, iDayRange) {
            var startDate = iDisplayDate;
            if (isReplaySlider && iDayRange === 5) {
                /**
                 * currently on mobile, iDayRange is set to 5, but the day range on the scroll is showing 9 days
                 * because of dynamic day width calculation, we need to substract 8 from 9 to get the
                 * correct startDate for the header
                 */
                startDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(iDisplayDate).subtract(8, 'days').valueOf();
            } else if (isReplaySlider) {
                startDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(iDisplayDate).subtract(iDayRange - 1, 'days').valueOf();
            }
            return startDate;
        }
    }, {
        key: 'getEndDate',
        value: function getEndDate(isReplaySlider, iDisplayDate, iDayRange, iOneDay) {
            var endDate = iDisplayDate;
            if (!isReplaySlider) {
                endDate = iDayRange === 5 ? iDisplayDate + 8 * iOneDay : iDisplayDate + (iDayRange - 1) * iOneDay;
            }
            return endDate;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                formatMessage = _props2.formatMessage,
                messages = _props2.messages,
                isResponsive = _props2.isResponsive;

            var oActiveDates = this.props.activeDates || {};
            var iDisplayDate = this.state.displayDate;
            var iActiveDate = this.state.activeDate;
            var iOneDay = this.state.oneDay;
            var iDayRange = this.state.dayRange;
            var iItemWidth = this.state.itemWidth;
            var iStartDate = this.props.isReplaySlider ? __WEBPACK_IMPORTED_MODULE_3_moment___default()(iDisplayDate).subtract(13, 'days') : __WEBPACK_IMPORTED_MODULE_3_moment___default()(iDisplayDate).subtract(iDayRange, 'days');
            var aOptNodes = [];
            var allDaysActive = this.props.allDaysActive;
            var cDate = new Date().setHours(0, 0, 0, 0);

            /**
             * Build the date list for the carousel, take the date and build
             * an item for each day X days either side
             **/
            for (var i = 0; i < iDayRange * 3; i++) {
                // NOTE: Using moment to add days will account for daylight savings time
                var iOptDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(iStartDate).add(i, 'days').startOf('day').valueOf();
                var iItemPos = iItemWidth * i;
                var sActiveClass = '';

                var props = {
                    'data-id': this.dateToKey(iOptDate),
                    className: 'day slick-slide', // slick-active
                    // index: i,
                    style: { width: iItemWidth + 'px' },
                    key: i
                };

                // If allDaysActive is true, all dates get marked as active
                if (!allDaysActive && !oActiveDates[iOptDate]) {
                    sActiveClass = 'inactive';
                }

                if (__WEBPACK_IMPORTED_MODULE_3_moment___default()(iActiveDate).isSame(__WEBPACK_IMPORTED_MODULE_3_moment___default()(iOptDate), 'day')) {
                    sActiveClass = 'active';
                }

                /* react will add a span round the first value and the css dosn't want that */
                var oOptDate = this.dateToObject(iOptDate);
                var formatedOptDay = formatMessage(messages['schedule.calendar.day.' + this.dateFormat(oOptDate, 'date9')]);

                var sDisplayValue = formatedOptDay + ' <span>' + oOptDate.getDate() + '</span>';

                // NOTE: comparing `day` via moment ensures moment date instances account for daylight savings time
                if (!this.props.isReplaySlider || __WEBPACK_IMPORTED_MODULE_3_moment___default()(iOptDate).isSameOrBefore(__WEBPACK_IMPORTED_MODULE_3_moment___default()(cDate), 'day')) {
                    aOptNodes.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        _extends({}, props, { onClick: this.selectDate.bind(this, iOptDate, iItemPos) }),
                        _jsx('a', {
                            className: sActiveClass,
                            dangerouslySetInnerHTML: { __html: sDisplayValue }
                        }, 'item' + this.dateToKey(iOptDate))
                    ));
                }
            }

            var oSliderprops = {
                onMouseDown: this.swipeStart,
                onMouseMove: this.state.dragging ? this._throttle(50, this.swipeMove) : null,
                onMouseUp: this.swipeEnd,
                onMouseLeave: this.state.dragging ? this.swipeEnd : null,
                onTouchStart: this.swipeStart,
                onTouchMove: this.state.dragging ? this._throttle(50, this.swipeMove) : null,
                onTouchEnd: this.swipeEnd,
                onTouchCancel: this.state.dragging ? this.swipeEnd : null,
                className: 'slick-list draggable',
                tabIndex: 0
            };

            var oSliderStyle = {
                width: iItemWidth * (iDayRange * 3) + 'px',
                left: this.state.currentPos + (this.props.centered ? iItemWidth * Math.floor(iDayRange / 2) : 0) + 'px'
            };

            var startDate = this.getStartDate(this.props.isReplaySlider, iDisplayDate, iDayRange);
            var endDate = this.getEndDate(this.props.isReplaySlider, iDisplayDate, iDayRange, iOneDay);

            var dateString = _jsx('span', {}, void 0, _jsx('span', {
                className: 'firstDay'
            }, 'firstDay', this.getIntlDate(this.dateFormat(startDate, 'date13')), ' - '), _jsx('span', {
                className: 'lastDay'
            }, 'lastDay', this.getIntlDate(this.dateFormat(endDate, 'date13'))));

            if (this.state.animate) {
                oSliderStyle.transition = 'left 0.5s'; // 'all 1s ease-in-out'
            }

            // console.log('month: ', formatMessage(messages['schedule.calendar.month.January']));
            return _jsx('div', {
                className: 'carousel-wrap',
                style: { float: 'none' }
            }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1_react_helmet___default.a, {
                style: isResponsive ? [] : [{
                    cssText: '\n                            .date-picker-carousel.slick-slider {\n                                margin-bottom: 15px !important;\n                                padding: 0 28px !important;\n                                width: 307px !important;\n                            }\n                            .slick-prev, .slick-next {\n                                display: block !important;\n                            }\n                        '
                }]
            }), _jsx('div', {
                className: 'carousel-week'
            }, void 0, dateString), _jsx('div', {
                className: 'date-picker-carousel slick-initialized slick-slider'
            }, void 0, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                oSliderprops,
                _jsx('div', {
                    className: 'slick-track',
                    style: oSliderStyle
                }, void 0, aOptNodes)
            ), _jsx('button', {
                type: 'button',
                'data-role': 'none',
                className: 'slick-prev slice-arrow',
                style: { display: 'block' },
                onClick: this.previous
            }, void 0), _jsx('button', {
                type: 'button',
                'data-role': 'none',
                className: 'slick-next slice-arrow',
                style: { display: 'block' },
                onClick: this.next
            }, void 0)), _jsx('div', {
                className: 'carousel-day'
            }, void 0, _jsx('span', {
                id: 'sbpDate',
                className: 'date'
            })));
        }
    }]);

    return DateSlider;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DateSlider.defaultProps = {
    date: new Date(),
    onDateSelected: function onDateSelected(date) {
        date;
    },
    maxDaysInFuture: 30,
    maxDaysInPast: 0,
    isResponsive: true,
    isReplaySlider: false
};

/* harmony default export */ __webpack_exports__["a"] = (DateSlider);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

var arrayAggregator = __webpack_require__(747),
    baseAggregator = __webpack_require__(748),
    baseIteratee = __webpack_require__(113),
    isArray = __webpack_require__(32);

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = isArray(collection) ? arrayAggregator : baseAggregator,
        accumulator = initializer ? initializer() : {};

    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
  };
}

module.exports = createAggregator;


/***/ }),
/* 747 */
/***/ (function(module, exports) {

/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

module.exports = arrayAggregator;


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(341);

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

module.exports = baseAggregator;


/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/lodash/groupBy.js
var groupBy = __webpack_require__(362);
var groupBy_default = /*#__PURE__*/__webpack_require__.n(groupBy);

// EXTERNAL MODULE: ./node_modules/lodash/uniqBy.js
var uniqBy = __webpack_require__(145);
var uniqBy_default = /*#__PURE__*/__webpack_require__.n(uniqBy);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(14);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__(16);
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// EXTERNAL MODULE: ./app/enums.js
var enums = __webpack_require__(1);

// EXTERNAL MODULE: ./app/lib/format/dateFormat.js
var dateFormat = __webpack_require__(33);

// EXTERNAL MODULE: ./app/lib/auth/isContentLocked.js
var isContentLocked = __webpack_require__(220);

// EXTERNAL MODULE: ./app/common/Select.js
var Select = __webpack_require__(359);

// EXTERNAL MODULE: ./app/lib/format/getContentFromListing.js
var getContentFromListing = __webpack_require__(293);

// CONCATENATED MODULE: ./app/lib/format/getListingNameFromStream.js

/**
 * getListingNameFromStream - returns the proper string representation for the listing.name.
 * Depending on the entitlements and packages available, it will append the feedName to the name.
 *
 * @param  {Object} listing - Object containing all metadata for the current listing
 * @param  {string[]} packageNamesList - Array containing the current packages associated with the listing
 * @param  {string[]} entitlementsList - Array containing the current entitlements
 * @return {string}
 */
function getListingNameFromStream() {
    var listing = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var packageNamesList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var entitlementsList = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    var name = listing.name && listing.name !== '' ? listing.name.trim() : '';
    var feedName = listing.feedName || '';

    // Verify the existence of the entitlements in the current listing
    var foundMatchingPackages = packageNamesList.length > 0 && entitlementsList.length > 0 ? packageNamesList.every(function (item) {
        return entitlementsList.indexOf(item) !== -1;
    }) : false;

    if (foundMatchingPackages === true && feedName !== '') {
        return name + ' (' + feedName + ')';
    }

    return name;
};
// EXTERNAL MODULE: ./app/webapp/common/playable.js + 2 modules
var playable = __webpack_require__(64);

// CONCATENATED MODULE: ./app/common/schedule/ScheduleLink.js
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var ScheduleLink = function ScheduleLink(_ref) {
    var clickHandler = _ref.clickHandler,
        listing = _ref.listing,
        _ref$name = _ref.name,
        name = _ref$name === undefined ? '' : _ref$name,
        playerHref = _ref.playerHref,
        userIsBlackedOut = _ref.userIsBlackedOut,
        blackoutClickHandler = _ref.blackoutClickHandler,
        blackoutMessage = _ref.blackoutMessage;

    var blackoutLink = void 0;
    if (userIsBlackedOut) {
        blackoutLink = _jsx('p', {
            style: { display: 'inline' }
        }, void 0, '\xA0|\xA0', _jsx('a', {
            onClick: blackoutClickHandler
        }, void 0, blackoutMessage));
    }

    return listing.type === 'upcoming' ? _jsx('div', {}, void 0, name, blackoutLink) : _jsx('div', {}, void 0, _jsx('a', {
        href: playerHref,
        'data-route': 'false',
        onClick: clickHandler
    }, void 0, name), blackoutLink);
};

/* harmony default export */ var schedule_ScheduleLink = (Object(playable["a" /* default */])(ScheduleLink));

// EXTERNAL MODULE: ./app/common/schedule/StatusFilter.js
var StatusFilter = __webpack_require__(96);

// CONCATENATED MODULE: ./app/webapp/common/schedule/ResponsiveTable.js
var ResponsiveTable__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var ResponsiveTable = function ResponsiveTable(_ref) {
    var children = _ref.children;
    return ResponsiveTable__jsx("div", {
        className: "responsive-table-wrap"
    }, void 0, ResponsiveTable__jsx("table", {
        cellPadding: "0",
        cellSpacing: "0",
        className: "schedule align-left",
        "data-text-contract": "Contract table",
        "data-text-expand": "Expand table",
        "data-fix-cols": "0",
        "data-behavior": "responsive_table"
    }, void 0, children));
};

/* harmony default export */ var schedule_ResponsiveTable = (ResponsiveTable);
// CONCATENATED MODULE: ./app/webapp/schedule/ScheduleCategorySection.js
var ScheduleCategorySection__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var secureCdnHost = config_default.a.secureCdnHost;


var networkToImageName = { espn1: 'espn', espndeportes: 'espndeportes_blk' };

function getNetworkImage(abbr) {
    var packageNamesArg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var darkTheme = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var images = [];
    if (abbr === 'espn_dtc' || abbr === 'bam_dtc' || abbr === 'espn_ppv') {
        var packageNames = packageNamesArg;
        if (!packageNames.length) {
            packageNames = [enums["s" /* Entitlements */].ESPN_PLUS];
        }
        images = packageNames.sort().map(function (packageName) {
            var logo = void 0;
            var alt = void 0;
            if (packageName === enums["s" /* Entitlements */].ESPN_PLUS) {
                logo = 'espnplus';
                if (darkTheme) {
                    logo += '_wht';
                }
                alt = 'espn+';
            } else if (packageName === enums["s" /* Entitlements */].ESPN_PLUS_MLB) {
                logo = 'mlb';
                alt = 'mlb.tv';
            } else if (packageName === enums["s" /* Entitlements */].ESPN_PLUS_NHL) {
                logo = 'nhl';
                if (darkTheme) {
                    logo += '_wht';
                }
                alt = 'nhl.tv';
                // NOTE: Find a match for any `ESPN_PLUS_UFC_PPV_*` entitlements
            } else if (packageName.indexOf(enums["s" /* Entitlements */].ESPN_PLUS_UFC_PPV) !== -1) {
                logo = 'ufc_ppv';
                alt = 'ufc';

                if (darkTheme) {
                    logo += '_wht';
                }
            }
            var image = secureCdnHost + '/watchespn/images/web/network_logos/channel_logo_' + logo + '_2x.png';
            return { image: image, alt: alt };
        });
    } else {
        var networkLogoName = networkToImageName[abbr] || abbr;
        var networkAlt = abbr;

        if (darkTheme) {
            if (abbr === 'espndeportes') {
                networkLogoName = 'espndeportes';
            } else if (enums["p" /* DarkThemeLogos */][abbr]) {
                // NOTE: Use the dictionary to determine which logos support darkmode
                networkLogoName = enums["p" /* DarkThemeLogos */][abbr];
            }
        }

        var networkLogoImageSource = secureCdnHost + '/watchespn/images/web/network_logos/channel_logo_' + networkLogoName + '_2x.png';
        images.push({ image: networkLogoImageSource, alt: networkAlt });
    }

    return images;
}

var ScheduleCategorySection_ScheduleCategorySection = function (_Component) {
    _inherits(ScheduleCategorySection, _Component);

    function ScheduleCategorySection(props) {
        _classCallCheck(this, ScheduleCategorySection);

        var _this = _possibleConstructorReturn(this, (ScheduleCategorySection.__proto__ || Object.getPrototypeOf(ScheduleCategorySection)).call(this, props));

        _this.state = { selectedSubcategoryId: -1 };
        _this.onSubcategorySelect = _this.onSubcategorySelect.bind(_this);
        return _this;
    }

    _createClass(ScheduleCategorySection, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.selectedTab !== this.props.selectedTab) {
                this.setState({ selectedSubcategoryId: -1 });
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            // Re-Render if:
            // (1) Number of listings changes in a section
            // (2) User authenticates
            // (3) Subcategory filter is used
            // (4) The first listing is different
            return this.props.listings.length !== nextProps.listings.length || this.props.userAuth.length !== nextProps.userAuth.length || this.state.selectedSubcategoryId !== nextState.selectedSubcategoryId || this.props.listings[0].id !== nextProps.listings[0].id || this.props.preauthorizedResources !== nextProps.preauthorizedResources;
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (window.espn_ui) {
                window.espn_ui.LoadBehavior();
            }
        }
    }, {
        key: 'onSubcategorySelect',
        value: function onSubcategorySelect(option) {
            this.setState({ selectedSubcategoryId: option.value });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                category = _props.category,
                listings = _props.listings,
                preauthorizedResources = _props.preauthorizedResources,
                userAuth = _props.userAuth,
                selectedTab = _props.selectedTab,
                dateFormatStr = _props.dateFormat,
                defaultLabel = _props.defaultLabel,
                blackoutMessage = _props.blackoutMessage,
                showSectionCaption = _props.showSectionCaption,
                bucketName = _props.bucketName;

            var compareObjectsByName = function compareObjectsByName(objA, objB) {
                var aName = objA.name.trim().toLowerCase();
                var bName = objB.name.trim().toLowerCase();
                if (aName > bName) {
                    return 1;
                } else if (aName < bName) {
                    return -1;
                }
                return 0;
            };

            var isReplaySelected = selectedTab === StatusFilter["a" /* default */].Options.REPLAY;

            var subcategories = uniqBy_default()(listings.map(function (listing) {
                return listing.subcategories[0];
            }), 'name').sort(compareObjectsByName);

            // moved the 'undefined' subcat to the top
            if (subcategories[subcategories.length - 1] === undefined) {
                subcategories.pop();
                subcategories.unshift(undefined);
            }

            var listingsGroupedBySubcategory = groupBy_default()(listings, function (listing) {
                return listing.subcategories[0] && listing.subcategories[0].name;
            });

            var hasDropdown = Object.keys(subcategories.filter(function (sc) {
                return !!sc;
            })).length > 1;

            var h2ClassName = classnames_default()('table-caption', {
                'has-dropdown': hasDropdown
            });

            var selectOptions = [{ label: defaultLabel, value: -1 }].concat(subcategories.filter(function (item) {
                return !!item;
            }) // don't include the "undefined" subcat
            .map(function (subcat) {
                return { label: subcat.name, value: subcat.name };
            }));

            var select = hasDropdown && ScheduleCategorySection__jsx(Select["a" /* default */], {
                options: selectOptions,
                menuSizeClass: 'drop-left sm',
                onChange: this.onSubcategorySelect
            });
            var columns = isReplaySelected ? 5 : 4;
            var tableChildren = [];

            subcategories.forEach(function (subcategory) {
                var subcatgoryNotFiltered = _this2.state.selectedSubcategoryId === -1 || !!subcategory && _this2.state.selectedSubcategoryId !== -1 && _this2.state.selectedSubcategoryId === subcategory.name;
                if (!!subcategory && subcatgoryNotFiltered) {
                    tableChildren.push(ScheduleCategorySection__jsx('thead', {}, 'thead_' + tableChildren.length, ScheduleCategorySection__jsx('tr', {}, void 0, ScheduleCategorySection__jsx('th', {
                        colSpan: columns
                    }, void 0, ScheduleCategorySection__jsx('span', {}, void 0, subcategory.name)))));
                } else {
                    // insert a blank <thead> for listings without a subcat
                    tableChildren.push(ScheduleCategorySection__jsx('thead', {}, 'thead_' + tableChildren.length));
                }

                var subcategoryListings = listingsGroupedBySubcategory[subcategory && subcategory.name || subcategory] || [];

                var filteredSubcategories = [];
                if (subcatgoryNotFiltered) {
                    filteredSubcategories = subcategoryListings;
                }

                tableChildren.push(ScheduleCategorySection__jsx('tbody', {}, 'tbody_' + tableChildren.length, filteredSubcategories.map(function (listing) {
                    var showLock = Object(isContentLocked["a" /* default */])(Object(getContentFromListing["a" /* default */])(listing), userAuth, preauthorizedResources);

                    var key = showLock ? ScheduleCategorySection__jsx('span', {
                        className: 'icon-font-before icon-lock-solid-before'
                    }) : null;

                    var networkAbbreviation = listing.broadcasts[0].abbreviation;
                    var packageNames = listing.broadcasts[0].packages;
                    var images = getNetworkImage(networkAbbreviation, packageNames);
                    var imageNode = images && images.map(function (_ref) {
                        var image = _ref.image,
                            alt = _ref.alt;
                        return ScheduleCategorySection__jsx('img', {
                            src: image,
                            alt: alt
                        });
                    });
                    var startTime = listing.startTime && dateFormat["a" /* default */].toISOString(listing.startTime);
                    var displayTime = startTime && dateFormat["a" /* default */].dateFormat(startTime, dateFormatStr);

                    var placement = 'schedule-' + listing.type;
                    var listingContent = Object(getContentFromListing["a" /* default */])(listing);
                    var listingName = getListingNameFromStream(listing, packageNames, [enums["s" /* Entitlements */].ESPN_PLUS, enums["s" /* Entitlements */].ESPN_PLUS_MLB, enums["s" /* Entitlements */].ESPN_PLUS_NHL]);

                    return ScheduleCategorySection__jsx('tr', {}, 'tr_' + listing.id, ScheduleCategorySection__jsx('td', {
                        className: 'schedule__time'
                    }, void 0, displayTime), ScheduleCategorySection__jsx('td', {
                        className: 'schedule__competitors'
                    }, void 0, ScheduleCategorySection__jsx(schedule_ScheduleLink, {
                        content: listingContent,
                        listing: listing,
                        name: listingName,
                        placement: placement,
                        blackoutMessage: blackoutMessage,
                        bucketName: bucketName
                    })), ScheduleCategorySection__jsx('td', {
                        className: 'schedule__auth'
                    }, void 0, key), ScheduleCategorySection__jsx('td', {
                        className: 'schedule__network'
                    }, void 0, ScheduleCategorySection__jsx('div', {
                        className: 'schedule__network__content'
                    }, void 0, imageNode)));
                })));
            });

            return ScheduleCategorySection__jsx('div', {}, category.id, showSectionCaption && ScheduleCategorySection__jsx('div', {}, void 0, ScheduleCategorySection__jsx('h2', {
                className: h2ClassName
            }, void 0, ScheduleCategorySection__jsx('span', {
                className: 'long-caption'
            }, void 0, category.name)), select), ScheduleCategorySection__jsx(schedule_ResponsiveTable, {}, void 0, tableChildren));
        }
    }]);

    return ScheduleCategorySection;
}(react["Component"]);

ScheduleCategorySection_ScheduleCategorySection.defaultProps = {
    showSectionCaption: true
};

/* harmony default export */ var schedule_ScheduleCategorySection = __webpack_exports__["a"] = (ScheduleCategorySection_ScheduleCategorySection);

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(console) {var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(81);
var ExecutionEnvironment = __webpack_require__(751);
var ModalPortal = React.createFactory(__webpack_require__(752));
var ariaAppHider = __webpack_require__(764);
var elementClass = __webpack_require__(765);
var renderSubtreeIntoContainer = __webpack_require__(81).unstable_renderSubtreeIntoContainer;
var Assign = __webpack_require__(366);

var SafeHTMLElement = ExecutionEnvironment.canUseDOM ? window.HTMLElement : {};
var AppElement = ExecutionEnvironment.canUseDOM ? document.body : {appendChild: function() {}};

var Modal = React.createClass({

  displayName: 'Modal',
  statics: {
    setAppElement: function(element) {
        AppElement = ariaAppHider.setElement(element);
    },
    injectCSS: function() {
      "production" !== "production"
        && console.warn('React-Modal: injectCSS has been deprecated ' +
                        'and no longer has any effect. It will be removed in a later version');
    }
  },

  propTypes: {
    isOpen: React.PropTypes.bool.isRequired,
    style: React.PropTypes.shape({
      content: React.PropTypes.object,
      overlay: React.PropTypes.object
    }),
    appElement: React.PropTypes.instanceOf(SafeHTMLElement),
    onAfterOpen: React.PropTypes.func,
    onRequestClose: React.PropTypes.func,
    closeTimeoutMS: React.PropTypes.number,
    ariaHideApp: React.PropTypes.bool,
    shouldCloseOnOverlayClick: React.PropTypes.bool
  },

  getDefaultProps: function () {
    return {
      isOpen: false,
      ariaHideApp: true,
      closeTimeoutMS: 0,
      shouldCloseOnOverlayClick: true
    };
  },

  componentDidMount: function() {
    this.node = document.createElement('div');
    this.node.className = 'ReactModalPortal';
    document.body.appendChild(this.node);
    this.renderPortal(this.props);
  },

  componentWillReceiveProps: function(newProps) {
    this.renderPortal(newProps);
  },

  componentWillUnmount: function() {
    ReactDOM.unmountComponentAtNode(this.node);
    document.body.removeChild(this.node);
    elementClass(document.body).remove('ReactModal__Body--open');
  },

  renderPortal: function(props) {
    if (props.isOpen) {
      elementClass(document.body).add('ReactModal__Body--open');
    } else {
      elementClass(document.body).remove('ReactModal__Body--open');
    }

    if (props.ariaHideApp) {
      ariaAppHider.toggle(props.isOpen, props.appElement);
    }

    this.portal = renderSubtreeIntoContainer(this, ModalPortal(Assign({}, props, {defaultStyles: Modal.defaultStyles})), this.node);
  },

  render: function () {
    return React.DOM.noscript();
  }
});

Modal.defaultStyles = {
  overlay: {
    position        : 'fixed',
    top             : 0,
    left            : 0,
    right           : 0,
    bottom          : 0,
    backgroundColor : 'rgba(255, 255, 255, 0.75)'
  },
  content: {
    position                : 'absolute',
    top                     : '40px',
    left                    : '40px',
    right                   : '40px',
    bottom                  : '40px',
    border                  : '1px solid #ccc',
    background              : '#fff',
    overflow                : 'auto',
    WebkitOverflowScrolling : 'touch',
    borderRadius            : '4px',
    outline                 : 'none',
    padding                 : '20px'
  }
}

module.exports = Modal

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return ExecutionEnvironment;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);
var div = React.DOM.div;
var focusManager = __webpack_require__(753);
var scopeTab = __webpack_require__(754);
var Assign = __webpack_require__(366);

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: {
    base: 'ReactModal__Overlay',
    afterOpen: 'ReactModal__Overlay--after-open',
    beforeClose: 'ReactModal__Overlay--before-close'
  },
  content: {
    base: 'ReactModal__Content',
    afterOpen: 'ReactModal__Content--after-open',
    beforeClose: 'ReactModal__Content--before-close'
  }
};

var ModalPortal = module.exports = React.createClass({

  displayName: 'ModalPortal',

  getDefaultProps: function() {
    return {
      style: {
        overlay: {},
        content: {}
      }
    };
  },

  getInitialState: function() {
    return {
      afterOpen: false,
      beforeClose: false
    };
  },

  componentDidMount: function() {
    // Focus needs to be set when mounting and already open
    if (this.props.isOpen) {
      this.setFocusAfterRender(true);
      this.open();
    }
  },

  componentWillUnmount: function() {
    clearTimeout(this.closeTimer);
  },

  componentWillReceiveProps: function(newProps) {
    // Focus only needs to be set once when the modal is being opened
    if (!this.props.isOpen && newProps.isOpen) {
      this.setFocusAfterRender(true);
      this.open();
    } else if (this.props.isOpen && !newProps.isOpen) {
      this.close();
    }
  },

  componentDidUpdate: function () {
    if (this.focusAfterRender) {
      this.focusContent();
      this.setFocusAfterRender(false);
    }
  },

  setFocusAfterRender: function (focus) {
    this.focusAfterRender = focus;
  },

  open: function() {
    if (this.state.afterOpen && this.state.beforeClose) {
      clearTimeout(this.closeTimer);
      this.setState({ beforeClose: false });
    } else {
      focusManager.setupScopedFocus(this.node);
      focusManager.markForFocusLater();
      this.setState({isOpen: true}, function() {
        this.setState({afterOpen: true});

        if (this.props.isOpen && this.props.onAfterOpen) {
          this.props.onAfterOpen();
        }
      }.bind(this));
    }
  },

  close: function() {
    if (!this.ownerHandlesClose())
      return;
    if (this.props.closeTimeoutMS > 0)
      this.closeWithTimeout();
    else
      this.closeWithoutTimeout();
  },

  focusContent: function() {
    this.refs.content.focus();
  },

  closeWithTimeout: function() {
    this.setState({beforeClose: true}, function() {
      this.closeTimer = setTimeout(this.closeWithoutTimeout, this.props.closeTimeoutMS);
    }.bind(this));
  },

  closeWithoutTimeout: function() {
    this.setState({
      beforeClose: false,
      isOpen: false,
      afterOpen: false,
    }, this.afterClose);
  },

  afterClose: function() {
    focusManager.returnFocus();
    focusManager.teardownScopedFocus();
  },

  handleKeyDown: function(event) {
    if (event.keyCode == 9 /*tab*/) scopeTab(this.refs.content, event);
    if (event.keyCode == 27 /*esc*/) {
      event.preventDefault();
      this.requestClose(event);
    }
  },

  handleOverlayClick: function(event) {
    var node = event.target

    while (node) {
      if (node === this.refs.content) return
      node = node.parentNode
    }

    if (this.props.shouldCloseOnOverlayClick) {
      if (this.ownerHandlesClose())
        this.requestClose(event);
      else
        this.focusContent();
    }
  },

  requestClose: function(event) {
    if (this.ownerHandlesClose())
      this.props.onRequestClose(event);
  },

  ownerHandlesClose: function() {
    return this.props.onRequestClose;
  },

  shouldBeClosed: function() {
    return !this.props.isOpen && !this.state.beforeClose;
  },

  buildClassName: function(which, additional) {
    var className = CLASS_NAMES[which].base;
    if (this.state.afterOpen)
      className += ' '+CLASS_NAMES[which].afterOpen;
    if (this.state.beforeClose)
      className += ' '+CLASS_NAMES[which].beforeClose;
    return additional ? className + ' ' + additional : className;
  },

  render: function() {
    var contentStyles = (this.props.className) ? {} : this.props.defaultStyles.content;
    var overlayStyles = (this.props.overlayClassName) ? {} : this.props.defaultStyles.overlay;

    return this.shouldBeClosed() ? div() : (
      div({
        ref: "overlay",
        className: this.buildClassName('overlay', this.props.overlayClassName),
        style: Assign({}, overlayStyles, this.props.style.overlay || {}),
        onClick: this.handleOverlayClick
      },
        div({
          ref: "content",
          style: Assign({}, contentStyles, this.props.style.content || {}),
          className: this.buildClassName('content', this.props.className),
          tabIndex: "-1",
          onKeyDown: this.handleKeyDown
        },
          this.props.children
        )
      )
    );
  }
});


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(console) {var findTabbable = __webpack_require__(365);
var modalElement = null;
var focusLaterElement = null;
var needToFocus = false;

function handleBlur(event) {
  needToFocus = true;
}

function handleFocus(event) {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation 
    // is that the document.body gets focus, and then we focus our element right 
    // after, seems fine.
    setTimeout(function() {
      if (modalElement.contains(document.activeElement))
        return;
      var el = (findTabbable(modalElement)[0] || modalElement);
      el.focus();
    }, 0);
  }
}

exports.markForFocusLater = function() {
  focusLaterElement = document.activeElement;
};

exports.returnFocus = function() {
  try {
    focusLaterElement.focus();
  }
  catch (e) {
    console.warn('You tried to return focus to '+focusLaterElement+' but it is not in the DOM anymore');
  }
  focusLaterElement = null;
};

exports.setupScopedFocus = function(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener('blur', handleBlur, false);
    document.addEventListener('focus', handleFocus, true);
  } else {
    window.attachEvent('onBlur', handleBlur);
    document.attachEvent('onFocus', handleFocus);
  }
};

exports.teardownScopedFocus = function() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener('blur', handleBlur);
    document.removeEventListener('focus', handleFocus);
  } else {
    window.detachEvent('onBlur', handleBlur);
    document.detachEvent('onFocus', handleFocus);
  }
};



/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

var findTabbable = __webpack_require__(365);

module.exports = function(node, event) {
  var tabbable = findTabbable(node);
  if (!tabbable.length) {
      event.preventDefault();
      return;
  }
  var finalTabbable = tabbable[event.shiftKey ? 0 : tabbable.length - 1];
  var leavingFinalTabbable = (
    finalTabbable === document.activeElement ||
    // handle immediate shift+tab after opening with mouse
    node === document.activeElement
  );
  if (!leavingFinalTabbable) return;
  event.preventDefault();
  var target = tabbable[event.shiftKey ? tabbable.length - 1 : 0];
  target.focus();
};


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.2.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var baseCopy = __webpack_require__(756),
    keys = __webpack_require__(367);

/**
 * The base implementation of `_.assign` without support for argument juggling,
 * multiple sources, and `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return source == null
    ? object
    : baseCopy(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 756 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property names to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @returns {Object} Returns `object`.
 */
function baseCopy(source, props, object) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];
    object[key] = source[key];
  }
  return object;
}

module.exports = baseCopy;


/***/ }),
/* 757 */
/***/ (function(module, exports) {

/**
 * lodash 3.9.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var funcTag = '[object Function]';

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var fnToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative(value) ? value : undefined;
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in older versions of Chrome and Safari which return 'function' for regexes
  // and Safari 8 equivalents which return 'object' for typed array constructors.
  return isObject(value) && objToString.call(value) == funcTag;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction(value)) {
    return reIsNative.test(fnToString.call(value));
  }
  return isObjectLike(value) && reIsHostCtor.test(value);
}

module.exports = getNative;


/***/ }),
/* 758 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

module.exports = isArguments;


/***/ }),
/* 759 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var arrayTag = '[object Array]',
    funcTag = '[object Function]';

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var fnToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/* Native method references for those with the same name as other `lodash` methods. */
var nativeIsArray = getNative(Array, 'isArray');

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(function() { return arguments; }());
 * // => false
 */
var isArray = nativeIsArray || function(value) {
  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
};

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in older versions of Chrome and Safari which return 'function' for regexes
  // and Safari 8 equivalents which return 'object' for typed array constructors.
  return isObject(value) && objToString.call(value) == funcTag;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction(value)) {
    return reIsNative.test(fnToString.call(value));
  }
  return isObjectLike(value) && reIsHostCtor.test(value);
}

module.exports = isArray;


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.1.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var bindCallback = __webpack_require__(761),
    isIterateeCall = __webpack_require__(762),
    restParam = __webpack_require__(763);

/**
 * Creates a function that assigns properties of source object(s) to a given
 * destination object.
 *
 * **Note:** This function is used to create `_.assign`, `_.defaults`, and `_.merge`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return restParam(function(object, sources) {
    var index = -1,
        length = object == null ? 0 : sources.length,
        customizer = length > 2 ? sources[length - 2] : undefined,
        guard = length > 2 ? sources[2] : undefined,
        thisArg = length > 1 ? sources[length - 1] : undefined;

    if (typeof customizer == 'function') {
      customizer = bindCallback(customizer, thisArg, 5);
      length -= 2;
    } else {
      customizer = typeof thisArg == 'function' ? thisArg : undefined;
      length -= (customizer ? 1 : 0);
    }
    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 761 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * A specialized version of `baseCallback` which only supports `this` binding
 * and specifying the number of arguments to provide to `func`.
 *
 * @private
 * @param {Function} func The function to bind.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {number} [argCount] The number of arguments to provide to `func`.
 * @returns {Function} Returns the callback.
 */
function bindCallback(func, thisArg, argCount) {
  if (typeof func != 'function') {
    return identity;
  }
  if (thisArg === undefined) {
    return func;
  }
  switch (argCount) {
    case 1: return function(value) {
      return func.call(thisArg, value);
    };
    case 3: return function(value, index, collection) {
      return func.call(thisArg, value, index, collection);
    };
    case 4: return function(accumulator, value, index, collection) {
      return func.call(thisArg, accumulator, value, index, collection);
    };
    case 5: return function(value, other, key, object, source) {
      return func.call(thisArg, value, other, key, object, source);
    };
  }
  return function() {
    return func.apply(thisArg, arguments);
  };
}

/**
 * This method returns the first argument provided to it.
 *
 * @static
 * @memberOf _
 * @category Utility
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.identity(object) === object;
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = bindCallback;


/***/ }),
/* 762 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.9 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** Used to detect unsigned integer values. */
var reIsUint = /^\d+$/;

/**
 * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Checks if `value` is array-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value));
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
  length = length == null ? MAX_SAFE_INTEGER : length;
  return value > -1 && value % 1 == 0 && value < length;
}

/**
 * Checks if the provided arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
      ? (isArrayLike(object) && isIndex(index, object.length))
      : (type == 'string' && index in object)) {
    var other = object[index];
    return value === value ? (value === other) : (other !== other);
  }
  return false;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = isIterateeCall;


/***/ }),
/* 763 */
/***/ (function(module, exports) {

/**
 * lodash 3.6.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Native method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that invokes `func` with the `this` binding of the
 * created function and arguments from `start` and beyond provided as an array.
 *
 * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
 *
 * @static
 * @memberOf _
 * @category Function
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var say = _.restParam(function(what, names) {
 *   return what + ' ' + _.initial(names).join(', ') +
 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
 * });
 *
 * say('hello', 'fred', 'barney', 'pebbles');
 * // => 'hello fred, barney, & pebbles'
 */
function restParam(func, start) {
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        rest = Array(length);

    while (++index < length) {
      rest[index] = args[start + index];
    }
    switch (start) {
      case 0: return func.call(this, rest);
      case 1: return func.call(this, args[0], rest);
      case 2: return func.call(this, args[0], args[1], rest);
    }
    var otherArgs = Array(start + 1);
    index = -1;
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = rest;
    return func.apply(this, otherArgs);
  };
}

module.exports = restParam;


/***/ }),
/* 764 */
/***/ (function(module, exports) {

var _element = typeof document !== 'undefined' ? document.body : null;

function setElement(element) {
  if (typeof element === 'string') {
    var el = document.querySelectorAll(element);
    element = 'length' in el ? el[0] : el;
  }
  _element = element || _element;
  return _element;
}

function hide(appElement) {
  validateElement(appElement);
  (appElement || _element).setAttribute('aria-hidden', 'true');
}

function show(appElement) {
  validateElement(appElement);
  (appElement || _element).removeAttribute('aria-hidden');
}

function toggle(shouldHide, appElement) {
  if (shouldHide)
    hide(appElement);
  else
    show(appElement);
}

function validateElement(appElement) {
  if (!appElement && !_element)
    throw new Error('react-modal: You must set an element with `Modal.setAppElement(el)` to make this accessible');
}

function resetForTesting() {
  _element = document.body;
}

exports.toggle = toggle;
exports.setElement = setElement;
exports.show = show;
exports.hide = hide;
exports.resetForTesting = resetForTesting;


/***/ }),
/* 765 */
/***/ (function(module, exports) {

module.exports = function(opts) {
  return new ElementClass(opts)
}

function indexOf(arr, prop) {
  if (arr.indexOf) return arr.indexOf(prop)
  for (var i = 0, len = arr.length; i < len; i++)
    if (arr[i] === prop) return i
  return -1
}

function ElementClass(opts) {
  if (!(this instanceof ElementClass)) return new ElementClass(opts)
  var self = this
  if (!opts) opts = {}

  // similar doing instanceof HTMLElement but works in IE8
  if (opts.nodeType) opts = {el: opts}

  this.opts = opts
  this.el = opts.el || document.body
  if (typeof this.el !== 'object') this.el = document.querySelector(this.el)
}

ElementClass.prototype.add = function(className) {
  var el = this.el
  if (!el) return
  if (el.className === "") return el.className = className
  var classes = el.className.split(' ')
  if (indexOf(classes, className) > -1) return classes
  classes.push(className)
  el.className = classes.join(' ')
  return classes
}

ElementClass.prototype.remove = function(className) {
  var el = this.el
  if (!el) return
  if (el.className === "") return
  var classes = el.className.split(' ')
  var idx = indexOf(classes, className)
  if (idx > -1) classes.splice(idx, 1)
  el.className = classes.join(' ')
  return classes
}

ElementClass.prototype.has = function(className) {
  var el = this.el
  if (!el) return
  var classes = el.className.split(' ')
  return indexOf(classes, className) > -1
}

ElementClass.prototype.toggle = function(className) {
  var el = this.el
  if (!el) return
  if (this.has(className)) this.remove(className)
  else this.add(className)
}


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _slider = __webpack_require__(767);

var _slider2 = _interopRequireDefault(_slider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _slider2.default;

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _innerSlider = __webpack_require__(768);

var _json2mq = __webpack_require__(775);

var _json2mq2 = _interopRequireDefault(_json2mq);

var _defaultProps = __webpack_require__(777);

var _defaultProps2 = _interopRequireDefault(_defaultProps);

var _innerSliderUtils = __webpack_require__(156);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(778);

var Slider = function (_React$Component) {
  _inherits(Slider, _React$Component);

  function Slider(props) {
    _classCallCheck(this, Slider);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.innerSliderRefHandler = function (ref) {
      return _this.innerSlider = ref;
    };

    _this.slickPrev = function () {
      return _this.innerSlider.slickPrev();
    };

    _this.slickNext = function () {
      return _this.innerSlider.slickNext();
    };

    _this.slickGoTo = function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return _this.innerSlider.slickGoTo(slide, dontAnimate);
    };

    _this.slickPause = function () {
      return _this.innerSlider.pause("paused");
    };

    _this.slickPlay = function () {
      return _this.innerSlider.autoPlay("play");
    };

    _this.state = {
      breakpoint: null
    };
    _this._responsiveMediaHandlers = [];
    return _this;
  }

  Slider.prototype.media = function media(query, handler) {
    // javascript handler for  css media query
    enquire.register(query, handler);
    this._responsiveMediaHandlers.push({ query: query, handler: handler });
  };

  // handles responsive breakpoints


  Slider.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    // performance monitoring
    //if (process.env.NODE_ENV !== 'production') {
    //const { whyDidYouUpdate } = require('why-did-you-update')
    //whyDidYouUpdate(React)
    //}
    if (this.props.responsive) {
      var breakpoints = this.props.responsive.map(function (breakpt) {
        return breakpt.breakpoint;
      });
      // sort them in increasing order of their numerical value
      breakpoints.sort(function (x, y) {
        return x - y;
      });

      breakpoints.forEach(function (breakpoint, index) {
        // media query for each breakpoint
        var bQuery = void 0;
        if (index === 0) {
          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
        } else {
          bQuery = (0, _json2mq2.default)({
            minWidth: breakpoints[index - 1] + 1,
            maxWidth: breakpoint
          });
        }
        // when not using server side rendering
        (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
          _this2.setState({ breakpoint: breakpoint });
        });
      });

      // Register media query for full screen. Need to support resize from small to large
      // convert javascript object to media query string
      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });

      (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
        _this2.setState({ breakpoint: null });
      });
    }
  };

  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
    this._responsiveMediaHandlers.forEach(function (obj) {
      enquire.unregister(obj.query, obj.handler);
    });
  };

  Slider.prototype.render = function render() {
    var _this3 = this;

    var settings;
    var newProps;
    if (this.state.breakpoint) {
      newProps = this.props.responsive.filter(function (resp) {
        return resp.breakpoint === _this3.state.breakpoint;
      });
      settings = newProps[0].settings === "unslick" ? "unslick" : _extends({}, _defaultProps2.default, this.props, newProps[0].settings);
    } else {
      settings = _extends({}, _defaultProps2.default, this.props);
    }

    // force scrolling by one if centerMode is on
    if (settings.centerMode) {
      if (settings.slidesToScroll > 1 && "production" !== "production") {
        console.warn("slidesToScroll should be equal to 1 in centerMode, you are using " + settings.slidesToScroll);
      }
      settings.slidesToScroll = 1;
    }
    // force showing one slide and scrolling by one if the fade mode is on
    if (settings.fade) {
      if (settings.slidesToShow > 1 && "production" !== "production") {
        console.warn("slidesToShow should be equal to 1 when fade is true, you're using " + settings.slidesToShow);
      }
      if (settings.slidesToScroll > 1 && "production" !== "production") {
        console.warn("slidesToScroll should be equal to 1 when fade is true, you're using " + settings.slidesToScroll);
      }
      settings.slidesToShow = 1;
      settings.slidesToScroll = 1;
    }

    // makes sure that children is an array, even when there is only 1 child
    var children = _react2.default.Children.toArray(this.props.children);

    // Children may contain false or null, so we should filter them
    // children may also contain string filled with spaces (in certain cases where we use jsx strings)
    children = children.filter(function (child) {
      if (typeof child === "string") {
        return !!child.trim();
      }
      return !!child;
    });

    // rows and slidesPerRow logic is handled here
    if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
      console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
      settings.variableWidth = false;
    }
    var newChildren = [];
    var currentWidth = null;
    for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
      var newSlide = [];
      for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
        var row = [];
        for (var k = j; k < j + settings.slidesPerRow; k += 1) {
          if (settings.variableWidth && children[k].props.style) {
            currentWidth = children[k].props.style.width;
          }
          if (k >= children.length) break;
          row.push(_react2.default.cloneElement(children[k], {
            key: 100 * i + 10 * j + k,
            tabIndex: -1,
            style: {
              width: 100 / settings.slidesPerRow + "%",
              display: "inline-block"
            }
          }));
        }
        newSlide.push(_react2.default.createElement(
          "div",
          { key: 10 * i + j },
          row
        ));
      }
      if (settings.variableWidth) {
        newChildren.push(_react2.default.createElement(
          "div",
          { key: i, style: { width: currentWidth } },
          newSlide
        ));
      } else {
        newChildren.push(_react2.default.createElement(
          "div",
          { key: i },
          newSlide
        ));
      }
    }

    if (settings === "unslick") {
      var className = "regular slider " + (this.props.className || "");
      return _react2.default.createElement(
        "div",
        { className: className },
        newChildren
      );
    } else if (newChildren.length <= settings.slidesToShow) {
      settings.unslick = true;
    }
    return _react2.default.createElement(
      _innerSlider.InnerSlider,
      _extends({ ref: this.innerSliderRefHandler }, settings),
      newChildren
    );
  };

  return Slider;
}(_react2.default.Component);

exports.default = Slider;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.InnerSlider = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(81);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _initialState = __webpack_require__(769);

var _initialState2 = _interopRequireDefault(_initialState);

var _lodash = __webpack_require__(770);

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(156);

var _track = __webpack_require__(771);

var _dots = __webpack_require__(772);

var _arrows = __webpack_require__(773);

var _resizeObserverPolyfill = __webpack_require__(774);

var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InnerSlider = exports.InnerSlider = function (_React$Component) {
  _inherits(InnerSlider, _React$Component);

  function InnerSlider(props) {
    _classCallCheck(this, InnerSlider);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.listRefHandler = function (ref) {
      return _this.list = ref;
    };

    _this.trackRefHandler = function (ref) {
      return _this.track = ref;
    };

    _this.adaptHeight = function () {
      if (_this.props.adaptiveHeight && _this.list) {
        var elem = _this.list.querySelector("[data-index=\"" + _this.state.currentSlide + "\"]");
        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
      }
    };

    _this.componentWillMount = function () {
      _this.ssrInit();
      _this.props.onInit && _this.props.onInit();
      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });
          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
    };

    _this.componentDidMount = function () {
      var spec = _extends({ listRef: _this.list, trackRef: _this.track }, _this.props);
      _this.updateState(spec, true, function () {
        _this.adaptHeight();
        _this.props.autoplay && _this.autoPlay("update");
      });
      if (_this.props.lazyLoad === "progressive") {
        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
      }
      _this.ro = new _resizeObserverPolyfill2.default(function () {
        if (_this.state.animating) {
          _this.onWindowResized(false); // don't set trackStyle hence don't break animation
          _this.callbackTimers.push(setTimeout(function () {
            return _this.onWindowResized();
          }, _this.props.speed));
        } else {
          _this.onWindowResized();
        }
      });
      _this.ro.observe(_this.list);
      Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
      });
      // To support server-side rendering
      if (!window) {
        return;
      }
      if (window.addEventListener) {
        window.addEventListener("resize", _this.onWindowResized);
      } else {
        window.attachEvent("onresize", _this.onWindowResized);
      }
    };

    _this.componentWillUnmount = function () {
      if (_this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
      }
      if (_this.lazyLoadTimer) {
        clearInterval(_this.lazyLoadTimer);
      }
      if (_this.callbackTimers.length) {
        _this.callbackTimers.forEach(function (timer) {
          return clearTimeout(timer);
        });
        _this.callbackTimers = [];
      }
      if (window.addEventListener) {
        window.removeEventListener("resize", _this.onWindowResized);
      } else {
        window.detachEvent("onresize", _this.onWindowResized);
      }
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
    };

    _this.componentWillReceiveProps = function (nextProps) {
      var spec = _extends({
        listRef: _this.list,
        trackRef: _this.track
      }, nextProps, _this.state);
      var setTrackStyle = false;
      for (var _iterator = Object.keys(_this.props), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var key = _ref;

        if (!nextProps.hasOwnProperty(key)) {
          setTrackStyle = true;
          break;
        }
        if (_typeof(nextProps[key]) === "object" || typeof nextProps[key] === "function") {
          continue;
        }
        if (nextProps[key] !== _this.props[key]) {
          setTrackStyle = true;
          break;
        }
      }
      _this.updateState(spec, setTrackStyle, function () {
        if (_this.state.currentSlide >= _react2.default.Children.count(nextProps.children)) {
          _this.changeSlide({
            message: "index",
            index: _react2.default.Children.count(nextProps.children) - nextProps.slidesToShow,
            currentSlide: _this.state.currentSlide
          });
        }
        if (nextProps.autoplay) {
          _this.autoPlay("update");
        } else {
          _this.pause("paused");
        }
      });
    };

    _this.componentDidUpdate = function () {
      _this.checkImagesLoad();
      _this.props.onReInit && _this.props.onReInit();
      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });
          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
      // if (this.props.onLazyLoad) {
      //   this.props.onLazyLoad([leftMostSlide])
      // }
      _this.adaptHeight();
    };

    _this.onWindowResized = function (setTrackStyle) {
      if (_this.debouncedResize) _this.debouncedResize.cancel();
      _this.debouncedResize = (0, _lodash2.default)(function () {
        return _this.resizeWindow(setTrackStyle);
      }, 50);
      _this.debouncedResize();
    };

    _this.resizeWindow = function () {
      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (!_reactDom2.default.findDOMNode(_this.track)) return;
      var spec = _extends({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props, _this.state);
      _this.updateState(spec, setTrackStyle, function () {
        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
      });
      // animating state should be cleared while resizing, otherwise autoplay stops working
      _this.setState({
        animating: false
      });
      clearTimeout(_this.animationEndCallback);
      delete _this.animationEndCallback;
    };

    _this.updateState = function (spec, setTrackStyle, callback) {
      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
      spec = _extends({}, spec, updatedState, { slideIndex: updatedState.currentSlide });
      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
      spec = _extends({}, spec, { left: targetLeft });
      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);
      if (setTrackStyle || _react2.default.Children.count(_this.props.children) !== _react2.default.Children.count(spec.children)) {
        updatedState["trackStyle"] = trackStyle;
      }
      _this.setState(updatedState, callback);
    };

    _this.ssrInit = function () {
      if (_this.props.variableWidth) {
        var _trackWidth = 0,
            _trackLeft = 0;
        var childrenWidths = [];
        var preClones = (0, _innerSliderUtils.getPreClones)(_extends({}, _this.props, _this.state, {
          slideCount: _this.props.children.length
        }));
        var postClones = (0, _innerSliderUtils.getPostClones)(_extends({}, _this.props, _this.state, {
          slideCount: _this.props.children.length
        }));
        _this.props.children.forEach(function (child) {
          childrenWidths.push(child.props.style.width);
          _trackWidth += child.props.style.width;
        });
        for (var i = 0; i < preClones; i++) {
          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
        }
        for (var _i2 = 0; _i2 < postClones; _i2++) {
          _trackWidth += childrenWidths[_i2];
        }
        for (var _i3 = 0; _i3 < _this.state.currentSlide; _i3++) {
          _trackLeft += childrenWidths[_i3];
        }
        var _trackStyle = {
          width: _trackWidth + "px",
          left: -_trackLeft + "px"
        };
        if (_this.props.centerMode) {
          var currentWidth = childrenWidths[_this.state.currentSlide] + "px";
          _trackStyle.left = "calc(" + _trackStyle.left + " + (100% - " + currentWidth + ") / 2 ) ";
        }
        _this.setState({
          trackStyle: _trackStyle
        });
        return;
      }
      var childrenCount = _react2.default.Children.count(_this.props.children);
      var spec = _extends({}, _this.props, _this.state, { slideCount: childrenCount });
      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
      var slideWidth = 100 / slideCount;
      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
      if (_this.props.centerMode) {
        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
      }
      var trackStyle = {
        width: trackWidth + "%",
        left: trackLeft + "%"
      };
      _this.setState({
        slideWidth: slideWidth + "%",
        trackStyle: trackStyle
      });
    };

    _this.checkImagesLoad = function () {
      var images = document.querySelectorAll(".slick-slide img");
      var imagesCount = images.length,
          loadedCount = 0;
      Array.prototype.forEach.call(images, function (image) {
        var handler = function handler() {
          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
        };
        if (!image.onclick) {
          image.onclick = function () {
            return image.parentNode.focus();
          };
        } else {
          var prevClickHandler = image.onclick;
          image.onclick = function () {
            prevClickHandler();
            image.parentNode.focus();
          };
        }
        if (!image.onload) {
          if (_this.props.lazyLoad) {
            image.onload = function () {
              _this.adaptHeight();
              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
            };
          } else {
            image.onload = handler;
            image.onerror = function () {
              handler();
              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
            };
          }
        }
      });
    };

    _this.progressiveLazyLoad = function () {
      var slidesToLoad = [];
      var spec = _extends({}, _this.props, _this.state);
      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
          slidesToLoad.push(index);
          break;
        }
      }
      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
          slidesToLoad.push(_index);
          break;
        }
      }
      if (slidesToLoad.length > 0) {
        _this.setState(function (state) {
          return {
            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
          };
        });
        if (_this.props.onLazyLoad) {
          _this.props.onLazyLoad(slidesToLoad);
        }
      } else {
        if (_this.lazyLoadTimer) {
          clearInterval(_this.lazyLoadTimer);
          delete _this.lazyLoadTimer;
        }
      }
    };

    _this.slideHandler = function (index) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
          asNavFor = _this$props.asNavFor,
          currentSlide = _this$props.currentSlide,
          beforeChange = _this$props.beforeChange,
          onLazyLoad = _this$props.onLazyLoad,
          speed = _this$props.speed,
          afterChange = _this$props.afterChange;

      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_extends({
        index: index
      }, _this.props, _this.state, {
        trackRef: _this.track,
        useCSS: _this.props.useCSS && !dontAnimate
      })),
          state = _slideHandler.state,
          nextState = _slideHandler.nextState;

      if (!state) return;
      beforeChange && beforeChange(currentSlide, state.currentSlide);
      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
        return _this.state.lazyLoadedList.indexOf(value) < 0;
      });
      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
      _this.setState(state, function () {
        asNavFor && asNavFor.innerSlider.state.currentSlide !== currentSlide && asNavFor.innerSlider.slideHandler(index);
        if (!nextState) return;
        _this.animationEndCallback = setTimeout(function () {
          var animating = nextState.animating,
              firstBatch = _objectWithoutProperties(nextState, ["animating"]);

          _this.setState(firstBatch, function () {
            _this.callbackTimers.push(setTimeout(function () {
              return _this.setState({ animating: animating });
            }, 10));
            afterChange && afterChange(state.currentSlide);
            delete _this.animationEndCallback;
          });
        }, speed);
      });
    };

    _this.changeSlide = function (options) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var spec = _extends({}, _this.props, _this.state);
      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
      if (targetSlide !== 0 && !targetSlide) return;
      if (dontAnimate === true) {
        _this.slideHandler(targetSlide, dontAnimate);
      } else {
        _this.slideHandler(targetSlide);
      }
    };

    _this.clickHandler = function (e) {
      if (_this.clickable === false) {
        e.stopPropagation();
        e.preventDefault();
      }
      _this.clickable = true;
    };

    _this.keyHandler = function (e) {
      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
      dir !== "" && _this.changeSlide({ message: dir });
    };

    _this.selectHandler = function (options) {
      _this.changeSlide(options);
    };

    _this.disableBodyScroll = function () {
      var preventDefault = function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault) e.preventDefault();
        e.returnValue = false;
      };
      window.ontouchmove = preventDefault;
    };

    _this.enableBodyScroll = function () {
      window.ontouchmove = null;
    };

    _this.swipeStart = function (e) {
      if (_this.props.verticalSwiping) {
        _this.disableBodyScroll();
      }
      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
      state !== "" && _this.setState(state);
    };

    _this.swipeMove = function (e) {
      var state = (0, _innerSliderUtils.swipeMove)(e, _extends({}, _this.props, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      if (state["swiping"]) {
        _this.clickable = false;
      }
      _this.setState(state);
    };

    _this.swipeEnd = function (e) {
      var state = (0, _innerSliderUtils.swipeEnd)(e, _extends({}, _this.props, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      var triggerSlideHandler = state["triggerSlideHandler"];
      delete state["triggerSlideHandler"];
      _this.setState(state);
      if (triggerSlideHandler === undefined) return;
      _this.slideHandler(triggerSlideHandler);
      if (_this.props.verticalSwiping) {
        _this.enableBodyScroll();
      }
    };

    _this.slickPrev = function () {
      // this and fellow methods are wrapped in setTimeout
      // to make sure initialize setState has happened before
      // any of such methods are called
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({ message: "previous" });
      }, 0));
    };

    _this.slickNext = function () {
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({ message: "next" });
      }, 0));
    };

    _this.slickGoTo = function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      slide = Number(slide);
      if (isNaN(slide)) return "";
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "index",
          index: slide,
          currentSlide: _this.state.currentSlide
        }, dontAnimate);
      }, 0));
    };

    _this.play = function () {
      var nextIndex;
      if (_this.props.rtl) {
        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
      } else {
        if ((0, _innerSliderUtils.canGoNext)(_extends({}, _this.props, _this.state))) {
          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
        } else {
          return false;
        }
      }

      _this.slideHandler(nextIndex);
    };

    _this.autoPlay = function (playType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
      var autoplaying = _this.state.autoplaying;
      if (playType === "update") {
        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
          return;
        }
      } else if (playType === "leave") {
        if (autoplaying === "paused" || autoplaying === "focused") {
          return;
        }
      } else if (playType === "blur") {
        if (autoplaying === "paused" || autoplaying === "hovered") {
          return;
        }
      }
      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
      _this.setState({ autoplaying: "playing" });
    };

    _this.pause = function (pauseType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
        _this.autoplayTimer = null;
      }
      var autoplaying = _this.state.autoplaying;
      if (pauseType === "paused") {
        _this.setState({ autoplaying: "paused" });
      } else if (pauseType === "focused") {
        if (autoplaying === "hovered" || autoplaying === "playing") {
          _this.setState({ autoplaying: "focused" });
        }
      } else {
        // pauseType  is 'hovered'
        if (autoplaying === "playing") {
          _this.setState({ autoplaying: "hovered" });
        }
      }
    };

    _this.onDotsOver = function () {
      return _this.props.autoplay && _this.pause("hovered");
    };

    _this.onDotsLeave = function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    };

    _this.onTrackOver = function () {
      return _this.props.autoplay && _this.pause("hovered");
    };

    _this.onTrackLeave = function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    };

    _this.onSlideFocus = function () {
      return _this.props.autoplay && _this.pause("focused");
    };

    _this.onSlideBlur = function () {
      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
    };

    _this.render = function () {
      var className = (0, _classnames2.default)("slick-slider", _this.props.className, {
        "slick-vertical": _this.props.vertical,
        "slick-initialized": true
      });
      var spec = _extends({}, _this.props, _this.state);
      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding"]);
      var pauseOnHover = _this.props.pauseOnHover;

      trackProps = _extends({}, trackProps, {
        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
        focusOnSelect: _this.props.focusOnSelect ? _this.selectHandler : null
      });

      var dots;
      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
        var pauseOnDotsHover = _this.props.pauseOnDotsHover;

        dotProps = _extends({}, dotProps, {
          clickHandler: _this.changeSlide,
          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
        });
        dots = _react2.default.createElement(_dots.Dots, dotProps);
      }

      var prevArrow, nextArrow;
      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      arrowProps.clickHandler = _this.changeSlide;

      if (_this.props.arrows) {
        prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
        nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
      }

      var verticalHeightStyle = null;

      if (_this.props.vertical) {
        verticalHeightStyle = {
          height: _this.state.listHeight
        };
      }

      var centerPaddingStyle = null;

      if (_this.props.vertical === false) {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: "0px " + _this.props.centerPadding
          };
        }
      } else {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: _this.props.centerPadding + " 0px"
          };
        }
      }

      var listStyle = _extends({}, verticalHeightStyle, centerPaddingStyle);
      var touchMove = _this.props.touchMove;
      var listProps = {
        className: "slick-list",
        style: listStyle,
        onClick: _this.clickHandler,
        onMouseDown: touchMove ? _this.swipeStart : null,
        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onMouseUp: touchMove ? _this.swipeEnd : null,
        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onTouchStart: touchMove ? _this.swipeStart : null,
        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onTouchEnd: touchMove ? _this.swipeEnd : null,
        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
      };

      var innerSliderProps = {
        className: className,
        dir: "ltr"
      };

      if (_this.props.unslick) {
        listProps = { className: "slick-list" };
        innerSliderProps = { className: className };
      }
      return _react2.default.createElement(
        "div",
        innerSliderProps,
        !_this.props.unslick ? prevArrow : "",
        _react2.default.createElement(
          "div",
          _extends({ ref: _this.listRefHandler }, listProps),
          _react2.default.createElement(
            _track.Track,
            _extends({ ref: _this.trackRefHandler }, trackProps),
            _this.props.children
          )
        ),
        !_this.props.unslick ? nextArrow : "",
        !_this.props.unslick ? dots : ""
      );
    };

    _this.list = null;
    _this.track = null;
    _this.state = _extends({}, _initialState2.default, {
      currentSlide: _this.props.initialSlide,
      slideCount: _react2.default.Children.count(_this.props.children)
    });
    _this.callbackTimers = [];
    _this.clickable = true;
    _this.debouncedResize = null;
    return _this;
  }

  return InnerSlider;
}(_react2.default.Component);

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var initialState = {
  animating: false,
  autoplaying: null,
  currentDirection: 0,
  currentLeft: null,
  currentSlide: 0,
  direction: 1,
  dragging: false,
  edgeDragged: false,
  initialized: false,
  lazyLoadedList: [],
  listHeight: null,
  listWidth: null,
  scrolling: false,
  slideCount: null,
  slideHeight: null,
  slideWidth: null,
  swipeLeft: null,
  swiped: false, // used by swipeEvent. differentites between touch and swipe.
  swiping: false,
  touchObject: { startX: 0, startY: 0, curX: 0, curY: 0 },
  trackStyle: {},
  trackWidth: 0
};

exports.default = initialState;

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Track = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(156);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var getSlideClasses = function getSlideClasses(spec) {
  var slickActive, slickCenter, slickCloned;
  var centerOffset, index;

  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }
  slickCloned = index < 0 || index >= spec.slideCount;
  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }
  var slickCurrent = index === spec.currentSlide;
  return {
    "slick-slide": true,
    "slick-active": slickActive,
    "slick-center": slickCenter,
    "slick-cloned": slickCloned,
    "slick-current": slickCurrent // dubious in case of RTL
  };
};

var getSlideStyle = function getSlideStyle(spec) {
  var style = {};

  if (spec.variableWidth === undefined || spec.variableWidth === false) {
    style.width = spec.slideWidth;
  }

  if (spec.fade) {
    style.position = "relative";
    if (spec.vertical) {
      style.top = -spec.index * parseInt(spec.slideHeight);
    } else {
      style.left = -spec.index * parseInt(spec.slideWidth);
    }
    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
    style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    style.WebkitTransition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
  }

  return style;
};

var getKey = function getKey(child, fallbackKey) {
  return child.key || fallbackKey;
};

var renderSlides = function renderSlides(spec) {
  var key;
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];
  var childrenCount = _react2.default.Children.count(spec.children);
  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);

  _react2.default.Children.forEach(spec.children, function (elem, index) {
    var child = void 0;
    var childOnClickOptions = {
      message: "children",
      index: index,
      slidesToScroll: spec.slidesToScroll,
      currentSlide: spec.currentSlide
    };

    // in case of lazyLoad, whether or not we want to fetch the slide
    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
      child = elem;
    } else {
      child = _react2.default.createElement("div", null);
    }
    var childStyle = getSlideStyle(_extends({}, spec, { index: index }));
    var slideClass = child.props.className || "";
    var slideClasses = getSlideClasses(_extends({}, spec, { index: index }));
    // push a cloned element of the desired slide
    slides.push(_react2.default.cloneElement(child, {
      key: "original" + getKey(child, index),
      "data-index": index,
      className: (0, _classnames2.default)(slideClasses, slideClass),
      tabIndex: "-1",
      "aria-hidden": !slideClasses["slick-active"],
      style: _extends({ outline: "none" }, child.props.style || {}, childStyle),
      onClick: function onClick(e) {
        child.props && child.props.onClick && child.props.onClick(e);
        if (spec.focusOnSelect) {
          spec.focusOnSelect(childOnClickOptions);
        }
      }
    }));

    // if slide needs to be precloned or postcloned
    if (spec.infinite && spec.fade === false) {
      var preCloneNo = childrenCount - index;
      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
        key = -preCloneNo;
        if (key >= startIndex) {
          child = elem;
        }
        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
        preCloneSlides.push(_react2.default.cloneElement(child, {
          key: "precloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames2.default)(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _extends({}, child.props.style || {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);
            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }

      if (childrenCount !== spec.slidesToShow) {
        key = childrenCount + index;
        if (key < endIndex) {
          child = elem;
        }
        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
        postCloneSlides.push(_react2.default.cloneElement(child, {
          key: "postcloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames2.default)(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _extends({}, child.props.style || {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);
            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }
    }
  });

  if (spec.rtl) {
    return preCloneSlides.concat(slides, postCloneSlides).reverse();
  } else {
    return preCloneSlides.concat(slides, postCloneSlides);
  }
};

var Track = exports.Track = function (_React$PureComponent) {
  _inherits(Track, _React$PureComponent);

  function Track() {
    _classCallCheck(this, Track);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Track.prototype.render = function render() {
    var slides = renderSlides(this.props);
    var _props = this.props,
        onMouseEnter = _props.onMouseEnter,
        onMouseOver = _props.onMouseOver,
        onMouseLeave = _props.onMouseLeave;

    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
    return _react2.default.createElement(
      "div",
      _extends({
        className: "slick-track",
        style: this.props.trackStyle
      }, mouseEvents),
      slides
    );
  };

  return Track;
}(_react2.default.PureComponent);

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Dots = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getDotCount = function getDotCount(spec) {
  var dots;

  if (spec.infinite) {
    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  } else {
    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
  }

  return dots;
};

var Dots = exports.Dots = function (_React$PureComponent) {
  _inherits(Dots, _React$PureComponent);

  function Dots() {
    _classCallCheck(this, Dots);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Dots.prototype.clickHandler = function clickHandler(options, e) {
    // In Autoplay the focus stays on clicked button even after transition
    // to next slide. That only goes away by click somewhere outside
    e.preventDefault();
    this.props.clickHandler(options);
  };

  Dots.prototype.render = function render() {
    var _this2 = this;

    var dotCount = getDotCount({
      slideCount: this.props.slideCount,
      slidesToScroll: this.props.slidesToScroll,
      slidesToShow: this.props.slidesToShow,
      infinite: this.props.infinite
    });

    // Apply join & split to Array to pre-fill it for IE8
    //
    // Credit: http://stackoverflow.com/a/13735425/1849458
    var _props = this.props,
        onMouseEnter = _props.onMouseEnter,
        onMouseOver = _props.onMouseOver,
        onMouseLeave = _props.onMouseLeave;

    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
    var dots = Array.apply(null, Array(dotCount + 1).join("0").split("")).map(function (x, i) {
      var leftBound = i * _this2.props.slidesToScroll;
      var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
      var className = (0, _classnames2.default)({
        "slick-active": _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
      });

      var dotOptions = {
        message: "dots",
        index: i,
        slidesToScroll: _this2.props.slidesToScroll,
        currentSlide: _this2.props.currentSlide
      };

      var onClick = _this2.clickHandler.bind(_this2, dotOptions);
      return _react2.default.createElement(
        "li",
        { key: i, className: className },
        _react2.default.cloneElement(_this2.props.customPaging(i), { onClick: onClick })
      );
    });

    return _react2.default.cloneElement(this.props.appendDots(dots), _extends({
      className: this.props.dotsClass
    }, mouseEvents));
  };

  return Dots;
}(_react2.default.PureComponent);

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.NextArrow = exports.PrevArrow = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(156);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PrevArrow = exports.PrevArrow = function (_React$PureComponent) {
  _inherits(PrevArrow, _React$PureComponent);

  function PrevArrow() {
    _classCallCheck(this, PrevArrow);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
    if (e) {
      e.preventDefault();
    }
    this.props.clickHandler(options, e);
  };

  PrevArrow.prototype.render = function render() {
    var prevClasses = { "slick-arrow": true, "slick-prev": true };
    var prevHandler = this.clickHandler.bind(this, { message: "previous" });

    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
      prevClasses["slick-disabled"] = true;
      prevHandler = null;
    }

    var prevArrowProps = {
      key: "0",
      "data-role": "none",
      className: (0, _classnames2.default)(prevClasses),
      style: { display: "block" },
      onClick: prevHandler
    };
    var customProps = {
      currentSlide: this.props.currentSlide,
      slideCount: this.props.slideCount
    };
    var prevArrow = void 0;

    if (this.props.prevArrow) {
      prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
    } else {
      prevArrow = _react2.default.createElement(
        "button",
        _extends({ key: "0", type: "button" }, prevArrowProps),
        " ",
        "Previous"
      );
    }

    return prevArrow;
  };

  return PrevArrow;
}(_react2.default.PureComponent);

var NextArrow = exports.NextArrow = function (_React$PureComponent2) {
  _inherits(NextArrow, _React$PureComponent2);

  function NextArrow() {
    _classCallCheck(this, NextArrow);

    return _possibleConstructorReturn(this, _React$PureComponent2.apply(this, arguments));
  }

  NextArrow.prototype.clickHandler = function clickHandler(options, e) {
    if (e) {
      e.preventDefault();
    }
    this.props.clickHandler(options, e);
  };

  NextArrow.prototype.render = function render() {
    var nextClasses = { "slick-arrow": true, "slick-next": true };
    var nextHandler = this.clickHandler.bind(this, { message: "next" });

    if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
      nextClasses["slick-disabled"] = true;
      nextHandler = null;
    }

    var nextArrowProps = {
      key: "1",
      "data-role": "none",
      className: (0, _classnames2.default)(nextClasses),
      style: { display: "block" },
      onClick: nextHandler
    };
    var customProps = {
      currentSlide: this.props.currentSlide,
      slideCount: this.props.slideCount
    };
    var nextArrow = void 0;

    if (this.props.nextArrow) {
      nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
    } else {
      nextArrow = _react2.default.createElement(
        "button",
        _extends({ key: "1", type: "button" }, nextArrowProps),
        " ",
        "Next"
      );
    }

    return nextArrow;
  };

  return NextArrow;
}(_react2.default.PureComponent);

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(24)))

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

var camel2hyphen = __webpack_require__(776);

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and '
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', '
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

module.exports = json2mq;

/***/ }),
/* 776 */
/***/ (function(module, exports) {

var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

module.exports = camel2hyphen;

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultProps = {
  accessibility: true,
  adaptiveHeight: false,
  afterChange: null,
  appendDots: function appendDots(dots) {
    return _react2.default.createElement(
      "ul",
      { style: { display: "block" } },
      dots
    );
  },
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  beforeChange: null,
  centerMode: false,
  centerPadding: "50px",
  className: "",
  cssEase: "ease",
  customPaging: function customPaging(i) {
    return _react2.default.createElement(
      "button",
      null,
      i + 1
    );
  },
  dots: false,
  dotsClass: "slick-dots",
  draggable: true,
  easing: "linear",
  edgeFriction: 0.35,
  fade: false,
  focusOnSelect: false,
  infinite: true,
  initialSlide: 0,
  lazyLoad: null,
  nextArrow: null,
  onEdge: null,
  onInit: null,
  onLazyLoadError: null,
  onReInit: null,
  pauseOnDotsHover: false,
  pauseOnFocus: false,
  pauseOnHover: true,
  prevArrow: null,
  responsive: null,
  rows: 1,
  rtl: false,
  slide: "div",
  slidesPerRow: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  swipe: true,
  swipeEvent: null,
  swipeToSlide: false,
  touchMove: true,
  touchThreshold: 5,
  useCSS: true,
  useTransform: true,
  variableWidth: false,
  vertical: false,
  waitForAnimate: true
};

exports.default = defaultProps;

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQueryDispatch = __webpack_require__(779);
module.exports = new MediaQueryDispatch();


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQuery = __webpack_require__(780);
var Util = __webpack_require__(369);
var each = Util.each;
var isFunction = Util.isFunction;
var isArray = Util.isArray;

/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */
function MediaQueryDispatch () {
    if(!window.matchMedia) {
        throw new Error('matchMedia not present, legacy browsers require a polyfill');
    }

    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}

MediaQueryDispatch.prototype = {

    constructor : MediaQueryDispatch,

    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register : function(q, options, shouldDegrade) {
        var queries         = this.queries,
            isUnconditional = shouldDegrade && this.browserIsIncapable;

        if(!queries[q]) {
            queries[q] = new MediaQuery(q, isUnconditional);
        }

        //normalise to object in an array
        if(isFunction(options)) {
            options = { match : options };
        }
        if(!isArray(options)) {
            options = [options];
        }
        each(options, function(handler) {
            if (isFunction(handler)) {
                handler = { match : handler };
            }
            queries[q].addHandler(handler);
        });

        return this;
    },

    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister : function(q, handler) {
        var query = this.queries[q];

        if(query) {
            if(handler) {
                query.removeHandler(handler);
            }
            else {
                query.clear();
                delete this.queries[q];
            }
        }

        return this;
    }
};

module.exports = MediaQueryDispatch;


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

var QueryHandler = __webpack_require__(781);
var each = __webpack_require__(369).each;

/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */
function MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);

    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}

MediaQuery.prototype = {

    constuctor : MediaQuery,

    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler : function(handler) {
        var qh = new QueryHandler(handler);
        this.handlers.push(qh);

        this.matches() && qh.on();
    },

    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler : function(handler) {
        var handlers = this.handlers;
        each(handlers, function(h, i) {
            if(h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i,1); //remove from array and exit each early
            }
        });
    },

    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches : function() {
        return this.mql.matches || this.isUnconditional;
    },

    /**
     * Clears all handlers and unbinds events
     */
    clear : function() {
        each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },

    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess : function() {
        var action = this.matches() ? 'on' : 'off';

        each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};

module.exports = MediaQuery;


/***/ }),
/* 781 */
/***/ (function(module, exports) {

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */
function QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}

QueryHandler.prototype = {

    constructor : QueryHandler,

    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup : function() {
        if(this.options.setup) {
            this.options.setup();
        }
        this.initialised = true;
    },

    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on : function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },

    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off : function() {
        this.options.unmatch && this.options.unmatch();
    },

    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy : function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },

    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals : function(target) {
        return this.options === target || this.options.match === target;
    }

};

module.exports = QueryHandler;


/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {/* unused harmony export SyndicatedPlayerPageComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bluebird__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enums__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_PropTypes__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_auth_canPlayContent__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_auth_getAccessMethodFromAuthTypes__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_auth_getContentId__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_util_isEmpty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_oneId__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_injectIntl__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_actions_appActions__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_actions_listingsActions__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__syndicated_actions__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_schedule_actions__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_page_actions__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__common_actions_authenticationActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__common_actions_oneIdActions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__common_selectors_bootstrapSelector__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__common_selectors_playerSelector__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__common_selectors_authenticationSelectors__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__common_selectors_providerSelector__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__common_selectors_pageSelector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__common_selectors_appSelector__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__common_selectors_heroSelector__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__common_selectors_routingSelector__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__syndicated_SyndicatedPlayer__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__syndicated_SyndicatedScheduleModule__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__config__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__modal_messaging_MessagingContainer__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__constants__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__common_actions_fanActions__ = __webpack_require__(216);
var _this2 = this;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new __WEBPACK_IMPORTED_MODULE_3_bluebird___default.a(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return __WEBPACK_IMPORTED_MODULE_3_bluebird___default.a.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





































var shellVersion = __WEBPACK_IMPORTED_MODULE_29__config___default.a.shellVersion,
    secureCdnHost = __WEBPACK_IMPORTED_MODULE_29__config___default.a.secureCdnHost,
    devStyles = __WEBPACK_IMPORTED_MODULE_29__config___default.a.devStyles;


var BASE_HREF = secureCdnHost + '/redesign/' + shellVersion;
var STYLE_HREF = BASE_HREF + '/css/secure';
if (devStyles) {
    STYLE_HREF = 'http://localhost:8080/static/css';
}

var OneIdJs = __WEBPACK_IMPORTED_MODULE_10__lib_oneId__["b" /* OneIdJs */];
var NEW_WINDOW_MANAGED = __WEBPACK_IMPORTED_MODULE_4__enums__["G" /* SyndicatedPlayerLoginOptions */].NEW_WINDOW_MANAGED;


var SyndicatedPlayerPageComponent = function (_PureComponent) {
    _inherits(SyndicatedPlayerPageComponent, _PureComponent);

    function SyndicatedPlayerPageComponent(props) {
        _classCallCheck(this, SyndicatedPlayerPageComponent);

        var _this = _possibleConstructorReturn(this, (SyndicatedPlayerPageComponent.__proto__ || Object.getPrototypeOf(SyndicatedPlayerPageComponent)).call(this, props));

        _this.state = {
            domainAuth: __WEBPACK_IMPORTED_MODULE_27__syndicated_SyndicatedPlayer__["b" /* domainAuthStatus */].UNKNOWN,
            hovered: false,
            overlayOpened: false
        };
        _this.onParentHost = _this.onParentHost.bind(_this);
        _this.onMouseOver = _this.onMouseOver.bind(_this);
        _this.onMouseOut = _this.onMouseOut.bind(_this);
        _this.onOverlayOpened = _this.onOverlayOpened.bind(_this);
        _this.onOverlayClosed = _this.onOverlayClosed.bind(_this);
        return _this;
    }

    _createClass(SyndicatedPlayerPageComponent, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _document = document,
                _document$referrer = _document.referrer,
                referrer = _document$referrer === undefined ? '' : _document$referrer;

            this.checkDomain(referrer);

            var _props = this.props,
                dispatch = _props.dispatch,
                content = _props.content,
                locationBeforeTransitions = _props.routing.locationBeforeTransitions;

            var _ref = locationBeforeTransitions || {},
                _ref$query = _ref.query,
                query = _ref$query === undefined ? {} : _ref$query;

            var newQuery = void 0;
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__common_actions_oneIdActions__["h" /* checkSWIDAuthentication */])());
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_32__common_actions_fanActions__["b" /* createSmartFanAction */])());
            if (content) {
                delete query.eventId;
                delete query.gameId;
                delete query.league;
                newQuery = _extends({}, query, Object(__WEBPACK_IMPORTED_MODULE_8__lib_auth_getContentId__["a" /* default */])(content));
            } else if (query.id || query.eventId || query.channel || query.network) {
                newQuery = query;
            } else if (!query.partner) {
                newQuery = _extends({}, query, {
                    network: 'espn'
                });
            }

            dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__common_actions_appActions__["Q" /* updateRoute */])(newQuery));
        }
    }, {
        key: 'onParentHost',
        value: function onParentHost(href) {
            // this is a fallback when `document.referrer` is empty
            if (!this._domainChecked) {
                this.checkDomain(href);
            }
        }
    }, {
        key: 'onMouseOver',
        value: function onMouseOver() {
            if (this.state.overlayOpened) {
                return;
            }
            this.setState({ hovered: true });
        }
    }, {
        key: 'onMouseOut',
        value: function onMouseOut() {
            if (this.state.overlayOpened) {
                return;
            }
            this.setState({ hovered: false });
        }
    }, {
        key: 'onOverlayOpened',
        value: function onOverlayOpened() {
            this.setState({ overlayOpened: true });
            this.setState({ hovered: false });
        }
    }, {
        key: 'onOverlayClosed',
        value: function onOverlayClosed() {
            this.setState({ overlayOpened: false });
        }
    }, {
        key: 'checkDomain',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(href) {
                var _props2, _props2$bootstrap$syn, _props2$bootstrap$syn2, gatedAll, _props2$bootstrap$syn3, gatedIE, dispatch, params, hostResult, host, canAllowDomain, key, _ref3, _ref3$domainAllowed, domainAllowed;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _props2 = this.props, _props2$bootstrap$syn = _props2.bootstrap.syndicatedPlayer;
                                _props2$bootstrap$syn = _props2$bootstrap$syn === undefined ? {} : _props2$bootstrap$syn;
                                _props2$bootstrap$syn2 = _props2$bootstrap$syn.gatedAll, gatedAll = _props2$bootstrap$syn2 === undefined ? false : _props2$bootstrap$syn2, _props2$bootstrap$syn3 = _props2$bootstrap$syn.gatedIE, gatedIE = _props2$bootstrap$syn3 === undefined ? true : _props2$bootstrap$syn3, dispatch = _props2.dispatch, params = _props2.params;
                                hostResult = /https?:\/\/([^\/:?#]+)/.exec(href);
                                host = (hostResult && hostResult[1] || '').replace(/^www\./, ''); // that's how hostname is stored in CMS

                                canAllowDomain = void 0;

                                if (!(gatedAll || window.top === window.self)) {
                                    _context.next = 11;
                                    break;
                                }

                                // not in iframe, no need for domain check
                                this._domainChecked = true;
                                canAllowDomain = true;
                                _context.next = 30;
                                break;

                            case 11:
                                if (!host) {
                                    _context.next = 29;
                                    break;
                                }

                                this._domainChecked = true;
                                key = window.btoa(host);
                                _context.prev = 14;
                                _context.next = 17;
                                return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__syndicated_actions__["a" /* domainCheck */])(key));

                            case 17:
                                _ref3 = _context.sent;
                                _ref3$domainAllowed = _ref3.domainAllowed;
                                domainAllowed = _ref3$domainAllowed === undefined ? 'false' : _ref3$domainAllowed;

                                canAllowDomain = domainAllowed === 'true';
                                _context.next = 27;
                                break;

                            case 23:
                                _context.prev = 23;
                                _context.t0 = _context['catch'](14);
                                // in the case of unexpected error, we open gate to everyone.
                                console.error(_context.t0);
                                canAllowDomain = true;

                            case 27:
                                _context.next = 30;
                                break;

                            case 29:
                                if (gatedIE) {
                                    this._domainChecked = true;
                                    // partner embeds the player directly with iframe, so can't pass parent location,
                                    // this should apply only for the old browser
                                    canAllowDomain = true;
                                } else {
                                    console.warn('syndicated player: host unknown');
                                }

                            case 30:
                                if (!(canAllowDomain != null)) {
                                    _context.next = 41;
                                    break;
                                }

                                if (!canAllowDomain) {
                                    _context.next = 40;
                                    break;
                                }

                                _context.prev = 32;
                                _context.next = 35;
                                return __WEBPACK_IMPORTED_MODULE_3_bluebird___default.a.all([dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__common_actions_authenticationActions__["V" /* createSmartAdobePassInitializeAction */])(params)), dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__common_actions_authenticationActions__["W" /* createSmartIpAuthenticationAction */])()), dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__common_actions_oneIdActions__["g" /* checkOneIDAuthentication */])())]);

                            case 35:
                                _context.next = 40;
                                break;

                            case 37:
                                _context.prev = 37;
                                _context.t1 = _context['catch'](32);

                                console.error(_context.t1);

                            case 40:
                                this.setState({
                                    domainAuth: canAllowDomain ? __WEBPACK_IMPORTED_MODULE_27__syndicated_SyndicatedPlayer__["b" /* domainAuthStatus */].ALLOWED : __WEBPACK_IMPORTED_MODULE_27__syndicated_SyndicatedPlayer__["b" /* domainAuthStatus */].NOT_ALLOWED
                                });

                            case 41:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[14, 23], [32, 37]]);
            }));

            function checkDomain(_x) {
                return _ref2.apply(this, arguments);
            }

            return checkDomain;
        }()
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                domainAuth = _state.domainAuth,
                hovered = _state.hovered,
                overlayOpened = _state.overlayOpened;
            var _props3 = this.props,
                content = _props3.content,
                canPlayContentFlag = _props3.canPlayContent,
                branding = _props3.branding,
                location = _props3.location,
                page = _props3.page,
                player = _props3.player,
                country = _props3.country,
                providerInfo = _props3.providerInfo,
                adobePassEnv = _props3.adobePassEnv,
                oneIdEnv = _props3.oneIdEnv,
                authStatus = _props3.authStatus,
                _props3$espnPlayerSrc = _props3.espnPlayerSrc,
                espnPlayerJsUrl = _props3$espnPlayerSrc.espnPlayerJsUrl,
                espnPlayerCssUrl = _props3$espnPlayerSrc.espnPlayerCssUrl,
                locationBeforeTransitions = _props3.routing.locationBeforeTransitions,
                messages = _props3.messages,
                formatMessage = _props3.intl.formatMessage;

            var _ref4 = locationBeforeTransitions || {},
                _ref4$query = _ref4.query,
                query = _ref4$query === undefined ? {} : _ref4$query;

            var showScheduleModule = country === 'US' && (query[__WEBPACK_IMPORTED_MODULE_4__enums__["t" /* Flags */].PARTNER] && query[__WEBPACK_IMPORTED_MODULE_4__enums__["t" /* Flags */].SHOW_SCHEDULE_IN_SYNDICATED_PLAYER] !== 'false' || query[__WEBPACK_IMPORTED_MODULE_4__enums__["t" /* Flags */].SHOW_SCHEDULE_IN_SYNDICATED_PLAYER] === 'true') && domainAuth === __WEBPACK_IMPORTED_MODULE_27__syndicated_SyndicatedPlayer__["b" /* domainAuthStatus */].ALLOWED;
            var authRetry = !!query[__WEBPACK_IMPORTED_MODULE_4__enums__["t" /* Flags */].AUTH_RETRY];
            var xdomainBlocked = !!query[__WEBPACK_IMPORTED_MODULE_4__enums__["t" /* Flags */].XDOMAIN_BLOCKED];
            var errorMessage = void 0;
            if (query.partner && country !== 'US') {
                errorMessage = formatMessage(messages['syndicated.player.message.geo']);
            } else if (domainAuth === __WEBPACK_IMPORTED_MODULE_27__syndicated_SyndicatedPlayer__["b" /* domainAuthStatus */].NOT_ALLOWED) {
                errorMessage = formatMessage(messages['syndicated.player.domain.error']);
            } else if (Object(__WEBPACK_IMPORTED_MODULE_9__lib_util_isEmpty__["a" /* default */])(content)) {
                errorMessage = formatMessage(messages['syndicated.player.message.no-events']);
            } else if (content && content.status === __WEBPACK_IMPORTED_MODULE_4__enums__["n" /* ContentStatus */].UPCOMING) {
                errorMessage = formatMessage(messages['syndicated.player.message.upcoming']);
            }

            return _jsx('div', {
                style: { position: 'absolute', width: '100%', height: '100%' },
                onMouseOver: this.onMouseOver,
                onMouseOut: this.onMouseOut
            }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_helmet___default.a, {
                meta: [{ name: 'robots', content: 'noindex, nofollow' }],
                link: [{ rel: 'stylesheet', href: STYLE_HREF + '/page.css' }, { rel: 'stylesheet', href: STYLE_HREF + '/watch.css' }, {
                    class: '__watch-player-bundle__',
                    rel: 'stylesheet',
                    href: espnPlayerCssUrl
                }],
                style: [{
                    cssText: '\n                            body {\n                                overflow: hidden;\n                            }\n                            html, body, #app, .watch-root { width: 100%; height: 100%; margin: 0; padding: 0; }\n                            .reload:before {\n                                font-family: ESPNVideoIcons;\n                                content:"\\e929";\n                                padding-right: 4px;\n                            }\n                            .vjs-menu li { text-transform: none; }\n\n                            #watchespn-bam-player {\n                                background-color: #000 !important;\n                                height: 100% !important;\n                                left: 0;\n                                position: absolute;\n                                top: 0;\n                                width: 100% !important;\n                                z-index: 1000031;\n                            }\n\n                            #watchespn-player iframe,\n                            #watchespn-bam-player iframe{\n                                width: 100%;\n                                height: 100%;\n                                border: none;\n                            }\n\n                            .' + __WEBPACK_IMPORTED_MODULE_31__constants__["c" /* BAM_PROXY_IFRAME_ID */] + ', .' + __WEBPACK_IMPORTED_MODULE_31__constants__["c" /* BAM_PROXY_IFRAME_ID */] + ' iframe {\n                                position: absolute;\n                                left: -10000px;\n                                width: 1px;\n                                height: 1px;\n                                border: none;\n                            }\n\n                            #' + __WEBPACK_IMPORTED_MODULE_31__constants__["b" /* BAM_PROMO_IFRAME_ID */] + ' {\n                                width: 100%;\n                                height: 506.25px;\n                                margin-bottom: 10px;\n                            }\n\n                            #' + __WEBPACK_IMPORTED_MODULE_31__constants__["b" /* BAM_PROMO_IFRAME_ID */] + ' iframe,\n                            #' + __WEBPACK_IMPORTED_MODULE_31__constants__["a" /* BAM_PAYWALL_IFRAME_ID */] + ' iframe {\n                                height: 100% !important;\n                                left: 0;\n                                position: absolute;\n                                top: 0;\n                                width: 100% !important;\n                                z-index: 1000033;\n                            }\n                        '
                }],
                script: [{
                    src: OneIdJs[oneIdEnv]
                }, {
                    src: espnPlayerJsUrl,
                    async: true
                }]
            }), _jsx(__WEBPACK_IMPORTED_MODULE_27__syndicated_SyndicatedPlayer__["a" /* default */], {
                content: content,
                canPlayContent: canPlayContentFlag,
                branding: branding,
                query: query,
                location: location,
                page: page,
                player: player,
                providerInfo: providerInfo,
                adobePassEnv: adobePassEnv,
                authStatus: authStatus,
                loginOption: NEW_WINDOW_MANAGED,
                domainAuth: domainAuth,
                authRetry: authRetry,
                xdomainBlocked: xdomainBlocked,
                errorMessage: errorMessage,
                onParentHost: this.onParentHost,
                onSocialOpened: this.onOverlayOpened,
                onSocialClosed: this.onOverlayClosed,
                onCaptionOpened: this.onOverlayOpened,
                onCaptionClosed: this.onOverlayClosed
            }), showScheduleModule && _jsx(__WEBPACK_IMPORTED_MODULE_28__syndicated_SyndicatedScheduleModule__["a" /* default */], {
                location: location,
                hovered: hovered,
                hidden: overlayOpened
            }), _jsx(__WEBPACK_IMPORTED_MODULE_30__modal_messaging_MessagingContainer__["a" /* default */], {}));
        }
    }]);

    return SyndicatedPlayerPageComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

SyndicatedPlayerPageComponent.defaultProps = {
    content: {},
    providers: []
};

SyndicatedPlayerPageComponent.loadActions = [__WEBPACK_IMPORTED_MODULE_12__common_actions_appActions__["D" /* fetchExternalConfig */], __WEBPACK_IMPORTED_MODULE_17__common_actions_authenticationActions__["Z" /* getProviders */], function (params, _ref5) {
    var _ref5$type = _ref5.type,
        type = _ref5$type === undefined ? 'live' : _ref5$type;
    return Object(__WEBPACK_IMPORTED_MODULE_15__common_schedule_actions__["l" /* setStatusFilter */])(type);
}, function (pathParams, query) {
    return function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
            var id, name, eventId, partner, dates, thumbnail, content, newQuery, payload, _ref8, _ref8$page, edition, heroContent;

            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            id = 'syndicated-player';
                            name = 'SyndicatedPlayer';

                            dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__common_page_actions__["r" /* createRequestPageAction */])(id));
                            dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__common_page_actions__["n" /* completePageLoad */])());
                            dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__common_actions_appActions__["w" /* analyticsReady */])({}));

                            eventId = query.eventId || query.gameId;
                            partner = query.partner, dates = query.dates, thumbnail = query.thumbnail;
                            content = void 0;

                            if (!(!query.id && partner)) {
                                _context2.next = 19;
                                break;
                            }

                            if (!query.categoryId) {
                                _context2.next = 16;
                                break;
                            }

                            _context2.next = 12;
                            return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__common_schedule_actions__["k" /* fetchSyndicatedSchedule */])(query));

                        case 12:
                            content = _context2.sent;

                            content = content.filter(function (_ref7) {
                                var broadcasts = _ref7.broadcasts,
                                    subcategories = _ref7.subcategories;

                                var broadcastMatch = broadcasts[0] && broadcasts[0].abbreviation && broadcasts[0].abbreviation.match(/3|_dtc/i);

                                // Only listings that match the `partner` query param, if provided
                                var partnerMatch = true;

                                if (partner && subcategories[0]) {
                                    var league = subcategories[0];
                                    var partnerRegEx = new RegExp(partner + '|' + partner.replace('-', ' '), 'i');
                                    var codeMatch = league.code && league.code.match(partnerRegEx);
                                    var idMatch = league.id && league.id.toLowerCase() === partner.toLowerCase();
                                    var nameMatch = !!(league.name && league.name.match(partnerRegEx));

                                    partnerMatch = codeMatch || idMatch || nameMatch;
                                }

                                return broadcastMatch && partnerMatch;
                            })[0];
                            _context2.next = 19;
                            break;

                        case 16:
                            _context2.next = 18;
                            return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__common_actions_listingsActions__["a" /* getEventByQuery */])({ partner: partner, dates: dates }));

                        case 18:
                            content = _context2.sent;

                        case 19:
                            newQuery = void 0;

                            delete query.thumbnail;
                            if (content) {
                                delete query.eventId;
                                delete query.gameId;
                                delete query.league;
                                delete query.partner;
                                delete query.dates;
                                newQuery = _extends({}, query, { id: content.id });
                            } else if (eventId) {
                                newQuery = { eventId: eventId };
                            } else if (query.id || query.channel || query.network) {
                                newQuery = query;
                            } else if (!partner) {
                                newQuery = _extends({}, query, {
                                    network: 'espn'
                                });
                            }

                            payload = void 0;

                            if (!newQuery) {
                                _context2.next = 27;
                                break;
                            }

                            _context2.next = 26;
                            return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__common_page_actions__["t" /* fetchEventOrVideoByQuery */])(newQuery));

                        case 26:
                            payload = _context2.sent;

                        case 27:
                            _ref8 = payload || {}, _ref8$page = _ref8.page;
                            _ref8$page = _ref8$page === undefined ? {} : _ref8$page;
                            edition = _ref8$page.edition, heroContent = _ref8$page.contents;

                            if (heroContent && thumbnail) {
                                heroContent.imageHref = thumbnail;
                            }
                            dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__common_page_actions__["q" /* createReceivePageAction */])({
                                id: id,
                                name: name,
                                edition: edition,
                                heroContent: heroContent,
                                isFinal: true
                            }));

                            if (!partner) {
                                dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__common_actions_appActions__["Q" /* updateRoute */])(newQuery));
                            }

                        case 33:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }));

        return function (_x2) {
            return _ref6.apply(this, arguments);
        };
    }();
}];

// it's important to return hero content so that `disableAuthPrompt` gets evaluated correctly in `authenticationAware`
var mapStateToProps = function mapStateToProps(state) {
    var schedule = state.schedule;

    var userAuth = Object(__WEBPACK_IMPORTED_MODULE_21__common_selectors_authenticationSelectors__["r" /* userAuthSelector */])(state);
    var content = Object(__WEBPACK_IMPORTED_MODULE_25__common_selectors_heroSelector__["a" /* default */])(state);
    var page = Object(__WEBPACK_IMPORTED_MODULE_23__common_selectors_pageSelector__["c" /* default */])(state);
    // this will return `true` when `selectedContent` is empty on purpose
    var canPlayContentFlag = Object(__WEBPACK_IMPORTED_MODULE_6__lib_auth_canPlayContent__["a" /* default */])(content, userAuth, false) && !Object(__WEBPACK_IMPORTED_MODULE_9__lib_util_isEmpty__["a" /* default */])(content) && content.status !== __WEBPACK_IMPORTED_MODULE_4__enums__["n" /* ContentStatus */].UPCOMING;
    var authStatus = Object(__WEBPACK_IMPORTED_MODULE_7__lib_auth_getAccessMethodFromAuthTypes__["a" /* default */])(userAuth);
    return {
        bootstrap: Object(__WEBPACK_IMPORTED_MODULE_19__common_selectors_bootstrapSelector__["a" /* default */])(state),
        content: content,
        canPlayContent: canPlayContentFlag,
        branding: Object(__WEBPACK_IMPORTED_MODULE_23__common_selectors_pageSelector__["a" /* brandingSelector */])(state),
        page: { id: page.id, name: page.name },
        routing: Object(__WEBPACK_IMPORTED_MODULE_26__common_selectors_routingSelector__["a" /* default */])(state),
        player: Object(__WEBPACK_IMPORTED_MODULE_20__common_selectors_playerSelector__["b" /* default */])(state),
        espnPlayerSrc: Object(__WEBPACK_IMPORTED_MODULE_19__common_selectors_bootstrapSelector__["b" /* espnPlayerSrcFilesSelector */])(state),
        country: Object(__WEBPACK_IMPORTED_MODULE_24__common_selectors_appSelector__["h" /* countrySelector */])(state),
        authStatus: authStatus,
        providerInfo: Object(__WEBPACK_IMPORTED_MODULE_22__common_selectors_providerSelector__["a" /* default */])(state),
        adobePassEnv: Object(__WEBPACK_IMPORTED_MODULE_24__common_selectors_appSelector__["b" /* adobePassEnvSelector */])(state),
        oneIdEnv: Object(__WEBPACK_IMPORTED_MODULE_24__common_selectors_appSelector__["y" /* oneIdEnvSelector */])(state),
        selectedTab: schedule.statusFilterValue,
        listings: schedule.listings || [],
        loading: schedule.loading
    };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(Object(__WEBPACK_IMPORTED_MODULE_11__common_injectIntl__["a" /* default */])(SyndicatedPlayerPageComponent)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./app/common/injectIntl.js
var injectIntl = __webpack_require__(20);

// EXTERNAL MODULE: ./app/common/LinkWithFlags.js
var LinkWithFlags = __webpack_require__(147);

// CONCATENATED MODULE: ./app/webapp/syndicated/ProviderDialog/style.js
/* harmony default export */ var style = ({
    container: {
        position: 'absolute',
        top: 0,
        width: '100%',
        height: '100%',
        color: '#fff'
    },
    dialog: {
        position: 'relative',
        margin: '0 auto',
        padding: 10,
        top: '50%',
        transform: 'translateY(-50%)',
        width: '100%',
        maxWidth: 400,
        height: 'auto',
        color: '#fff',
        lineHeight: 1.3,
        fontFamily: '-apple-system, "Roboto", Helvetica, Arial, sans-serif'
    },
    dialogRow: {
        position: 'relative',
        marginTop: 10
    },
    alignCenter: {
        textAlign: 'center'
    },
    logo: {
        // you need this `width: auto`, otherwise some magic script in the page shell will set the `width` and `height` attribute
        // on the `img` element with the original size
        width: 'auto',
        height: 20
    },
    providerListCol: {
        float: 'left'
    },
    providerList: {
        fontSize: 14,
        width: 200
    },
    continueBtn: {
        height: 30,
        marginTop: 10
    },
    standAlone: {
        maxWidth: 320,
        minWidth: 120,
        background: '#06c',
        border: 0,
        borderRadius: 4,
        color: '#fff',
        position: 'relative',
        textAlign: 'center',
        whiteSpace: 'nowrap',
        padding: '0 15px',
        fontSize: 11,
        width: 180
    },
    clear: {
        clear: 'left'
    }
});
// CONCATENATED MODULE: ./app/webapp/syndicated/ProviderDialog/index.js
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var DEF_PROVIDER_VALUE = 'default';

var ProviderDialog_ProviderDialog = function (_PureComponent) {
    _inherits(ProviderDialog, _PureComponent);

    function ProviderDialog(props) {
        _classCallCheck(this, ProviderDialog);

        var _this = _possibleConstructorReturn(this, (ProviderDialog.__proto__ || Object.getPrototypeOf(ProviderDialog)).call(this, props));

        _this.onProviderChange = _this.onProviderChange.bind(_this);
        _this.onContinueClick = _this.onContinueClick.bind(_this);
        _this.state = {
            provider: DEF_PROVIDER_VALUE
        };
        return _this;
    }

    _createClass(ProviderDialog, [{
        key: 'onProviderChange',
        value: function onProviderChange(event) {
            var provider = event.target.value;
            this.setState({
                provider: provider
            });
        }
    }, {
        key: 'onContinueClick',
        value: function onContinueClick(event) {
            var provider = this.state.provider;
            var _props = this.props,
                providers = _props.providers,
                onContinueClick = _props.onContinueClick;


            var providerInfo = providers.filter(function (_ref) {
                var abbreviation = _ref.abbreviation;
                return abbreviation === provider;
            })[0];
            if (providerInfo && onContinueClick) {
                onContinueClick(event, providerInfo);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var provider = this.state.provider;
            var _props2 = this.props,
                providers = _props2.providers,
                _props2$branding = _props2.branding,
                brandingName = _props2$branding.name,
                brandingLogoUrl = _props2$branding.logoUrl,
                isAuthenticated = _props2.isAuthenticated,
                authRetry = _props2.authRetry,
                xdomainBlocked = _props2.xdomainBlocked,
                onReloadClick = _props2.onReloadClick,
                messages = _props2.messages,
                formatMessage = _props2.intl.formatMessage;

            var centeredRowStyle = _extends({}, style.dialogRow, style.alignCenter);

            var tier1Providers = providers.filter(function (_ref2) {
                var tier = _ref2.tier;
                return tier === 1;
            });
            var tier2Providers = providers.filter(function (_ref3) {
                var tier = _ref3.tier;
                return tier !== 1;
            });

            // build provider list
            var providerOptions = tier1Providers.concat(tier2Providers).map(function (_ref4) {
                var name = _ref4.name,
                    abbreviation = _ref4.abbreviation;
                return _jsx('option', {
                    value: abbreviation
                }, void 0, name);
            });
            providerOptions.unshift(_jsx('option', {
                value: DEF_PROVIDER_VALUE
            }, void 0, '----- ' + formatMessage(messages['feedback.provider.default']) + ' -----'));

            var linkTo = '/mvpd/login?mvpd=' + provider + '&syndicated=true';
            var linkTarget = '_blank';

            var xdomainMessage = xdomainBlocked ? formatMessage(messages['syndicated.player.dialog.message.xdomain']) : '';

            var reloadViewMessage = authRetry ? formatMessage(messages['syndicated.player.dialog.message.auth-retry']) : formatMessage(messages['syndicated.player.dialog.message.auth-success']);

            return _jsx('div', {
                className: 'playback-dialog-container',
                style: style.container
            }, void 0, _jsx('div', {
                className: 'playback-dialog',
                style: style.dialog
            }, void 0, _jsx('div', {
                style: style.alignCenter
            }, void 0, _jsx('img', {
                style: style.logo,
                src: brandingLogoUrl,
                alt: brandingName
            })), !isAuthenticated && !authRetry ? _jsx('div', {}, void 0, _jsx('div', {
                style: style.dialogRow
            }, void 0, _jsx('p', {}, void 0, formatMessage(messages['syndicated.player.dialog']))), _jsx('div', {
                style: style.dialogRow
            }, void 0, _jsx('div', {
                style: style.providerListCol
            }, void 0, formatMessage(messages['provider.dialog.title']), ':\xA0'), _jsx('div', {
                style: style.providerListCol
            }, void 0, _jsx('select', {
                id: 'providerList',
                defaultValue: provider,
                style: style.providerList,
                onChange: this.onProviderChange
            }, void 0, providerOptions), _jsx('div', {
                style: style.continueBtn
            }, void 0, provider !== DEF_PROVIDER_VALUE && _jsx(LinkWithFlags["a" /* default */], {
                to: linkTo,
                target: linkTarget,
                onClick: this.onContinueClick
            }, void 0, _jsx('button', {
                className: 'button med stand-alone',
                style: style.standAlone
            }, void 0, formatMessage(messages['syndicated.player.dialog.label.continute']))))), _jsx('div', {
                style: style.clear
            }))) : _jsx('div', {}, void 0, _jsx('div', {
                style: centeredRowStyle
            }, void 0, _jsx('div', {}, void 0, reloadViewMessage), _jsx('br', {}), _jsx('div', {}, void 0, xdomainMessage)), !authRetry && _jsx('div', {
                style: centeredRowStyle
            }, void 0, _jsx('button', {
                className: 'button lg stand-alone reload',
                onClick: onReloadClick,
                style: style.standAlone
            }, void 0, formatMessage(messages['syndicated.player.dialog.label.recheck']))))));
        }
    }]);

    return ProviderDialog;
}(react["PureComponent"]);

/* harmony default export */ var syndicated_ProviderDialog = __webpack_exports__["a"] = (Object(injectIntl["a" /* default */])(ProviderDialog_ProviderDialog));

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/lodash/throttle.js
var throttle = __webpack_require__(785);
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);

// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__(16);
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// EXTERNAL MODULE: ./app/common/PropTypes.js
var PropTypes = __webpack_require__(28);

// EXTERNAL MODULE: ./app/webapp/player/connectPlayer.js
var connectPlayer = __webpack_require__(223);

// EXTERNAL MODULE: ./node_modules/selectn/index.js
var selectn = __webpack_require__(112);
var selectn_default = /*#__PURE__*/__webpack_require__.n(selectn);

// EXTERNAL MODULE: ./app/enums.js
var enums = __webpack_require__(1);

// EXTERNAL MODULE: ./app/lib/format/queryString.js
var queryString = __webpack_require__(18);

// EXTERNAL MODULE: ./app/lib/util/canUseDOM.js
var canUseDOM = __webpack_require__(61);

// EXTERNAL MODULE: ./app/common/injectIntl.js
var injectIntl = __webpack_require__(20);

// CONCATENATED MODULE: ./app/webapp/syndicated/PlayerOverlay/style.js
var HEADER_HEIGHT = 40;
var SOURCE_LOGO_WIDTH = 60;
var BRANDING_LOGO_WIDTH = 100;
var PROVIDER_LOGO_WIDTH = 100;

/* harmony default export */ var PlayerOverlay_style = ({
    header: {
        position: 'absolute',
        background: 'linear-gradient(to bottom, rgba(0,0,0,1) 0%,rgba(0,0,0,0) 100%)',
        width: '100%',
        height: HEADER_HEIGHT,
        zIndex: 1000032,
        transition: 'transform 0.2s ease-out',
        color: '#fff',
        fontSize: 12,
        pointerEvents: 'none',
        paddingBottom: 5,
        fontFamily: '-apple-system, "Roboto", Helvetica, Arial, sans-serif'
    },
    show: {
        transform: 'translateY(0)'
    },
    hide: {
        transform: 'translateY(-' + HEADER_HEIGHT + 'px)'
    },
    logo: {
        float: 'left',
        width: SOURCE_LOGO_WIDTH,
        height: '100%',
        padding: '0 10px'
    },
    title: {
        height: '100%',
        fontWeight: 'bold',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        marginLeft: SOURCE_LOGO_WIDTH,
        marginRight: BRANDING_LOGO_WIDTH
    },
    titleText: {
        verticalAlign: 'middle'
    },
    branding: {
        float: 'right',
        width: BRANDING_LOGO_WIDTH,
        height: '100%',
        padding: '0 10px',
        pointerEvents: 'all'
    },
    provider: {
        float: 'right',
        width: PROVIDER_LOGO_WIDTH,
        height: '100%',
        paddingRight: 10,
        pointerEvents: 'all',
        whiteSpace: 'nowrap',
        transition: 'width 0.2s'
    },
    logoImg: {
        verticalAlign: 'middle',
        width: 'auto',
        height: 'auto',
        maxWidth: '100%',
        maxHeight: '100%',
        transition: 'width 0.2s'
    },
    signout: {
        display: 'inline-block',
        color: '#fff',
        width: 0,
        paddingLeft: 20,
        overflow: 'hidden',
        verticalAlign: 'middle'
    },
    separator: {
        verticalAlign: 'middle'
    },
    helper: {
        display: 'inline-block',
        height: '100%',
        verticalAlign: 'middle'
    }
});
// CONCATENATED MODULE: ./app/webapp/syndicated/PlayerOverlay/index.js
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var EVENT_QUERY_KEYS = enums["b" /* Api */].Page.EVENT_QUERY_KEYS;

var PlayerOverlay_PlayerOverlay = function (_PureComponent) {
    _inherits(PlayerOverlay, _PureComponent);

    function PlayerOverlay(props) {
        _classCallCheck(this, PlayerOverlay);

        var _this = _possibleConstructorReturn(this, (PlayerOverlay.__proto__ || Object.getPrototypeOf(PlayerOverlay)).call(this, props));

        _this.state = {
            providerHovered: false,
            signoutWidth: undefined
        };
        _this.onLogoutClick = _this.onLogoutClick.bind(_this);
        _this.onProviderMouseOver = _this.onProviderMouseOver.bind(_this);
        _this.onProviderMouseOut = _this.onProviderMouseOut.bind(_this);
        return _this;
    }

    _createClass(PlayerOverlay, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setSignoutWidth();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.setSignoutWidth();
        }
    }, {
        key: 'onLogoutClick',
        value: function onLogoutClick(event) {
            event.preventDefault();
            this.props.handleLogout();
        }
    }, {
        key: 'onProviderMouseOver',
        value: function onProviderMouseOver() {
            this.setState({ providerHovered: true });
        }
    }, {
        key: 'onProviderMouseOut',
        value: function onProviderMouseOut() {
            this.setState({ providerHovered: false });
        }
    }, {
        key: 'setSignoutWidth',
        value: function setSignoutWidth() {
            if (this.signout && this.state.signoutWidth === undefined) {
                this.setState({ signoutWidth: this.signout.offsetWidth + 30 });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                providerHovered = _state.providerHovered,
                signoutWidth = _state.signoutWidth;
            var _props = this.props,
                show = _props.show,
                name = _props.name,
                _props$source = _props.source,
                sourceName = _props$source.name,
                sourceLogoUrl = _props$source.logoUrl,
                _props$branding = _props.branding,
                brandingName = _props$branding.name,
                brandingLogoUrl = _props$branding.logoUrl,
                provider = _props.provider,
                query = _props.location.query,
                messages = _props.messages,
                formatMessage = _props.intl.formatMessage;


            var newQuery = _extends({}, query);
            Object.keys(newQuery).forEach(function (key) {
                if (EVENT_QUERY_KEYS.indexOf(key) === -1) {
                    delete newQuery[key];
                }
                if (key === 'id' && (newQuery.network || newQuery.channel)) {
                    delete newQuery[key];
                }
            });
            var search = Object(queryString["a" /* default */])(newQuery);
            var watchLink = '/watch/player' + search;
            if (canUseDOM["a" /* default */]) {
                // force http
                watchLink = 'http://' + window.location.host + watchLink;
            }

            var style = _extends({}, PlayerOverlay_style.header, PlayerOverlay_style[show ? 'show' : 'hide']);

            var titleStyle = sourceLogoUrl ? PlayerOverlay_style.title : _extends({}, PlayerOverlay_style.title, {
                marginLeft: 10
            });

            var providerName = provider.name;

            var providerLogoUrl = selectn_default()('images.colorWithNegativeBackground.href', provider) || selectn_default()('images.logo.href', provider) || '';
            var providerLink = selectn_default()('links.web.href', provider) || '/watch';

            var signoutStyle = _extends({}, PlayerOverlay_style.signout, {
                display: 'none'
            });
            if (signoutWidth === undefined) {
                signoutStyle = _extends({}, PlayerOverlay_style.signout, {
                    width: 'auto',
                    visibility: 'hidden'
                });
            } else if (providerHovered) {
                signoutStyle = _extends({}, PlayerOverlay_style.signout, {
                    width: signoutWidth - 5
                });
            }

            return _jsx('div', {
                className: 'player-header',
                style: style
            }, void 0, sourceLogoUrl && _jsx('div', {
                style: PlayerOverlay_style.logo
            }, void 0, _jsx('span', {
                style: PlayerOverlay_style.helper
            }), _jsx('img', {
                src: sourceLogoUrl,
                alt: sourceName,
                style: PlayerOverlay_style.logoImg
            })), providerLogoUrl ? _jsx('div', {
                style: providerHovered ? _extends({}, PlayerOverlay_style.provider, {
                    width: PlayerOverlay_style.provider.width + signoutWidth
                }) : PlayerOverlay_style.provider,
                onMouseOver: this.onProviderMouseOver,
                onMouseOut: this.onProviderMouseOut
            }, void 0, _jsx('span', {
                style: PlayerOverlay_style.helper
            }), _jsx('a', {
                href: providerLink,
                target: '_blank',
                rel: 'noopener noreferrer',
                alt: providerName
            }, void 0, _jsx('img', {
                src: providerLogoUrl,
                alt: providerName,
                style: providerHovered ? _extends({}, PlayerOverlay_style.logoImg, {
                    maxWidth: 'calc(100% - ' + signoutWidth + 'px)'
                }) : PlayerOverlay_style.logoImg
            })), _jsx('span', {
                style: providerHovered ? PlayerOverlay_style.separator : _extends({}, PlayerOverlay_style.separator, {
                    display: 'none'
                })
            }, void 0, '\xA0|\xA0'), react_default.a.createElement(
                'a',
                {
                    ref: function ref(el) {
                        _this2.signout = el;
                    },
                    style: signoutStyle,
                    onClick: this.onLogoutClick
                },
                formatMessage(messages['signout.label'])
            )) : _jsx('div', {
                style: _extends({}, PlayerOverlay_style.provider, { marginTop: 10 })
            }, void 0, _jsx('span', {
                style: PlayerOverlay_style.separator
            }, void 0, '\xA0|\xA0'), react_default.a.createElement(
                'a',
                {
                    ref: function ref(el) {
                        _this2.signout = el;
                    },
                    style: _extends({}, PlayerOverlay_style.signout, {
                        width: signoutWidth - 5
                    }),
                    onClick: this.onLogoutClick
                },
                formatMessage(messages['signout.label'])
            )), _jsx('div', {
                style: PlayerOverlay_style.branding
            }, void 0, _jsx('span', {
                style: PlayerOverlay_style.helper
            }), _jsx('a', {
                href: watchLink,
                target: '_blank',
                rel: 'noopener noreferrer',
                title: formatMessage(messages['syndicated.player.branding.tooltip'], {
                    brandingName: brandingName
                })
            }, void 0, _jsx('img', {
                src: brandingLogoUrl,
                alt: brandingName,
                style: PlayerOverlay_style.logoImg
            }))), _jsx('div', {
                style: titleStyle,
                title: name
            }, void 0, _jsx('span', {
                style: PlayerOverlay_style.helper
            }), _jsx('span', {
                style: PlayerOverlay_style.titleText
            }, void 0, name)));
        }
    }]);

    return PlayerOverlay;
}(react["PureComponent"]);

PlayerOverlay_PlayerOverlay.defaultProps = {
    show: false,
    source: {},
    branding: {},
    provider: {}
};

/* harmony default export */ var syndicated_PlayerOverlay = (Object(injectIntl["a" /* default */])(PlayerOverlay_PlayerOverlay));
// CONCATENATED MODULE: ./app/webapp/syndicated/ConnectedPlayer/style.js
/* harmony default export */ var ConnectedPlayer_style = ({
    container: {
        position: 'relative',
        width: '100%',
        height: '100%'
    },
    player: {
        position: 'relative',
        width: '100%',
        height: '100%'
    }
});
// CONCATENATED MODULE: ./app/webapp/syndicated/ConnectedPlayer/index.js
var ConnectedPlayer__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var ConnectedPlayer__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ConnectedPlayer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ConnectedPlayer__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ConnectedPlayer__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var secureCdnHost = config_default.a.secureCdnHost;


var networkToImageName = { espn1: 'espn' };

var ConnectedPlayer_Player = function (_PureComponent) {
    ConnectedPlayer__inherits(Player, _PureComponent);

    function Player(props) {
        ConnectedPlayer__classCallCheck(this, Player);

        var _this = ConnectedPlayer__possibleConstructorReturn(this, (Player.__proto__ || Object.getPrototypeOf(Player)).call(this, props));

        _this.onPlayerMouseMove = _this.onPlayerMouseMove.bind(_this);
        _this.processMouseMove = throttle_default()(_this.processMouseMove.bind(_this), 100);
        _this.state = {
            showOverlay: false
        };
        return _this;
    }

    ConnectedPlayer__createClass(Player, [{
        key: 'onPlayerMouseMove',
        value: function onPlayerMouseMove(event) {
            if (this.props.socialOpened || this.props.captionOpened) {
                return;
            }
            var pageY = event.nativeEvent.pageY;

            this.processMouseMove(pageY);
        }
    }, {
        key: 'processMouseMove',
        value: function processMouseMove(pageY) {
            var showOverlay = pageY <= HEADER_HEIGHT;
            if (this.state.showOverlay !== showOverlay) {
                this.setState({ showOverlay: showOverlay });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                location = _props.location,
                branding = _props.branding,
                provider = _props.provider,
                selectedStream = _props.selectedStream,
                playingStream = _props.playingStream,
                render = _props.render,
                handleLogout = _props.handleLogout;


            var stream = playingStream || selectedStream || {};
            var name = stream.name,
                _stream$source = stream.source;
            _stream$source = _stream$source === undefined ? {} : _stream$source;
            var sourceId = _stream$source.id,
                _stream$source$name = _stream$source.name,
                sourceOrig = _stream$source$name === undefined ? '' : _stream$source$name;

            var source = (sourceId || sourceOrig).toLowerCase();
            var networkLogoName = networkToImageName[source] || source;
            var logoUrl = networkLogoName ? secureCdnHost + '/watchespn/images/web/network_logos/channel_logo_' + networkLogoName + '_2x.png' : null;
            var sourceObj = {
                name: sourceId || source,
                logoUrl: logoUrl
            };

            return react_default.a.createElement(
                'div',
                {
                    ref: function ref(el) {
                        _this2.container = el;
                    },
                    className: 'player-container',
                    style: render ? ConnectedPlayer_style.container : { display: 'none' },
                    onMouseMove: render && this.onPlayerMouseMove
                },
                render && ConnectedPlayer__jsx(syndicated_PlayerOverlay, {
                    show: this.state.showOverlay,
                    name: name,
                    source: sourceObj,
                    branding: branding,
                    location: location,
                    provider: provider,
                    handleLogout: handleLogout
                }),
                react_default.a.createElement('div', {
                    ref: 'playerContainer',
                    id: 'watchespn-player-container',
                    style: ConnectedPlayer_style.player
                })
            );
        }
    }]);

    return Player;
}(react["PureComponent"]);

/* harmony default export */ var ConnectedPlayer = __webpack_exports__["a"] = (Object(connectPlayer["a" /* default */])(ConnectedPlayer_Player));

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

var debounce = __webpack_require__(372),
    isObject = __webpack_require__(35);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(39);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    container: {
        position: 'absolute',
        zIndex: 0,
        width: '100%',
        height: '100%',
        background: '#000'
    },
    dialogContainer: {
        width: '100%',
        height: '100%'
    },
    message: {
        position: 'absolute',
        margin: '0 auto',
        background: 'rgba(0,0,0,0.7)',
        padding: 10,
        top: '50%',
        transform: 'translateY(-50%)',
        width: '100%',
        height: 'auto',
        color: '#fff',
        lineHeight: 1.3,
        textAlign: 'center'
    }
});

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(4);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(14);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./app/common/schedule/ScheduleCategoryContainer.js
var ScheduleCategoryContainer = __webpack_require__(361);

// EXTERNAL MODULE: ./app/common/schedule/FilterGroupContainer.js + 1 modules
var FilterGroupContainer = __webpack_require__(358);

// EXTERNAL MODULE: ./app/common/selectors/authenticationSelectors.js
var authenticationSelectors = __webpack_require__(10);

// EXTERNAL MODULE: ./app/common/schedule/actions/index.js
var actions = __webpack_require__(95);

// CONCATENATED MODULE: ./app/webapp/syndicated/SyndicatedScheduleModule/style.js
/* harmony default export */ var style = ({
    container: {
        position: 'relative',
        zIndex: 1,
        top: 0,
        left: '80%',
        float: 'right',
        width: '80%',
        height: '100%',
        transition: 'left 0.3s',
        WebkitTransition: 'left 0.3s'
    },
    opened: {
        left: 0
    },
    scheduleContainer: {
        position: 'relative',
        top: 0,
        width: '100%',
        height: '100%',
        background: '#fff',
        padding: 20,
        overflowY: 'auto'
    },
    toggleButton: {
        position: 'absolute',
        left: -90,
        top: 'calc(50% - 25px)',
        width: 90,
        height: 50,
        display: 'block',
        opacity: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        borderRadius: '30px 0 0 30px',
        padding: 10,
        textAlign: 'center',
        transition: 'opacity 0.2s',
        WebkitTransition: 'opacity 0.2s',
        color: '#fff'
    },
    toggleButtonHide: {
        opacity: 0
    },
    toggleButtonHidden: {
        display: 'none'
    },
    toggleButtonLabel: {
        fontSize: 12,
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)'
    }
});
// CONCATENATED MODULE: ./app/webapp/syndicated/SyndicatedScheduleModule/index.js
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var SyndicatedScheduleModule_SyndicatedScheduleModule = function (_Component) {
    _inherits(SyndicatedScheduleModule, _Component);

    function SyndicatedScheduleModule(props) {
        _classCallCheck(this, SyndicatedScheduleModule);

        var _this = _possibleConstructorReturn(this, (SyndicatedScheduleModule.__proto__ || Object.getPrototypeOf(SyndicatedScheduleModule)).call(this, props));

        _this.state = {
            init: true,
            opened: false
        };
        _this.fetchAction = actions["j" /* fetchSchedule */];
        _this.onToggleClick = _this.onToggleClick.bind(_this);
        return _this;
    }

    _createClass(SyndicatedScheduleModule, [{
        key: 'onToggleClick',
        value: function onToggleClick() {
            var query = this.props.location.query;

            var state = { opened: !this.state.opened };
            if (this.state.init) {
                this.props.dispatch(this.fetchAction(_extends({ type: 'live' }, query)));
                state.init = false;
            }
            this.setState(state);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                location = _props.location,
                partner = _props.location.query.partner,
                listingsArg = _props.listings,
                loading = _props.loading,
                userAuth = _props.userAuth,
                selectedTab = _props.selectedTab,
                isMobile = _props.isMobile,
                hovered = _props.hovered,
                hidden = _props.hidden;
            var opened = this.state.opened;

            var tabClassname = classnames_default()('watch-tab', { loading: loading });
            var label = opened ? 'Close' : 'Schedule';
            var containerStyle = opened ? _extends({}, style.container, style.opened) : style.container;
            var buttonStyle = !opened && !hovered ? _extends({}, style.toggleButton, style.toggleButtonHide, hidden ? style.toggleButtonHidden : {}) : style.toggleButton;

            var listings = listingsArg;

            listings = listings.filter(function (_ref) {
                var subcategories = _ref.subcategories;

                // Only listings that match the `partner` query param, if provided
                var partnerMatch = false;

                if (partner && subcategories[0]) {
                    var league = subcategories[0];
                    var partnerRegEx = new RegExp(partner + '|' + partner.replace('-', ' '), 'i');
                    var codeMatch = league.code && league.code.match(partnerRegEx);
                    var idMatch = league.id && league.id.toLowerCase() === partner.toLowerCase();
                    var nameMatch = !!(league.name && league.name.match(partnerRegEx));

                    partnerMatch = codeMatch || idMatch || nameMatch;
                }

                return partnerMatch;
            });

            return _jsx('div', {
                style: containerStyle
            }, void 0, _jsx('a', {
                style: buttonStyle,
                onClick: this.onToggleClick
            }, void 0, _jsx('span', {
                style: style.toggleButtonLabel
            }, void 0, label)), _jsx('article', {
                className: 'watch-schedule',
                style: style.scheduleContainer
            }, void 0, _jsx(FilterGroupContainer["a" /* default */], {
                location: location,
                showSportOptions: false,
                showNetworkOptions: false,
                fetchAction: this.fetchAction
            }), _jsx('div', {
                className: 'content',
                style: selectedTab !== 'upcoming' ? { paddingTop: 20 } : {}
            }, void 0, _jsx('div', {
                id: 'tabLive',
                className: tabClassname,
                style: { display: 'block' }
            }, void 0, _jsx(ScheduleCategoryContainer["a" /* default */], {
                listings: listings,
                userAuth: userAuth,
                selectedTab: selectedTab,
                isMobile: isMobile,
                startDateValue: location.query.startDate,
                showSectionCaption: false,
                watchRegion: location.query.watchRegion
            })))));
        }
    }]);

    return SyndicatedScheduleModule;
}(react["Component"]);

var SyndicatedScheduleModule_mapStateToProps = function mapStateToProps(state) {
    var app = state.app,
        schedule = state.schedule;

    var userAuth = Object(authenticationSelectors["r" /* userAuthSelector */])(state);
    return {
        userAuth: userAuth,
        selectedTab: schedule.statusFilterValue,
        listings: schedule.listings || [],
        loading: schedule.loading,
        isMobile: app.isMobile
    };
};

/* harmony default export */ var syndicated_SyndicatedScheduleModule = __webpack_exports__["a"] = (Object(es["b" /* connect */])(SyndicatedScheduleModule_mapStateToProps)(SyndicatedScheduleModule_SyndicatedScheduleModule));

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_format_queryString__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__syndicated_SyndicatedPlayerAPIProxy__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_selectors_bootstrapSelector__ = __webpack_require__(29);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var shellVersion = __WEBPACK_IMPORTED_MODULE_4__config___default.a.shellVersion,
    cdnHost = __WEBPACK_IMPORTED_MODULE_4__config___default.a.cdnHost,
    devStyles = __WEBPACK_IMPORTED_MODULE_4__config___default.a.devStyles;


var BASE_HREF = cdnHost + '/redesign/' + shellVersion;
var STYLE_HREF = BASE_HREF + '/css';
if (devStyles) {
    STYLE_HREF = 'http://localhost:8080/static/css';
}

var PARTNER = __WEBPACK_IMPORTED_MODULE_5__syndicated_SyndicatedPlayerAPIProxy__["a" /* default */].PARTNER,
    DOMAIN = __WEBPACK_IMPORTED_MODULE_5__syndicated_SyndicatedPlayerAPIProxy__["a" /* default */].DOMAIN;


var containerStyle = {
    padding: 20
};

var playerContainerStyle = {
    marginTop: 20
};

var iframeStyle = {
    width: 640,
    height: 360
};

var SyndicatedPlayerExample = function (_PureComponent) {
    _inherits(SyndicatedPlayerExample, _PureComponent);

    function SyndicatedPlayerExample(props) {
        _classCallCheck(this, SyndicatedPlayerExample);

        var _this = _possibleConstructorReturn(this, (SyndicatedPlayerExample.__proto__ || Object.getPrototypeOf(SyndicatedPlayerExample)).call(this, props));

        _this.state = {
            id: '',
            gameId: '',
            league: '',
            network: '',
            position: 0,
            currentTime: 0,
            thumbnail: ''
        };
        _this.playVideo = _this.playVideo.bind(_this);
        _this.pauseVideo = _this.pauseVideo.bind(_this);
        _this.muteStream = _this.muteStream.bind(_this);
        _this.unMuteStream = _this.unMuteStream.bind(_this);
        _this.setVideoPosition = _this.setVideoPosition.bind(_this);
        _this.getVideoPosition = _this.getVideoPosition.bind(_this);
        _this.enterFullScreen = _this.enterFullScreen.bind(_this);
        _this.selectById = _this.selectById.bind(_this);
        _this.selectByEventId = _this.selectByEventId.bind(_this);
        _this.selectEventByNetworkName = _this.selectEventByNetworkName.bind(_this);
        _this.selectEventByGameIdLeague = _this.selectEventByGameIdLeague.bind(_this);
        _this.recheckAccess = _this.recheckAccess.bind(_this);
        _this.adobePassLogout = _this.adobePassLogout.bind(_this);
        _this.getAffiliate = _this.getAffiliate.bind(_this);
        _this.getSelectedProvider = _this.getSelectedProvider.bind(_this);
        _this.getAuthenticationStatus = _this.getAuthenticationStatus.bind(_this);
        _this.onIdChange = _this.onIdChange.bind(_this);
        _this.onEventIdChange = _this.onEventIdChange.bind(_this);
        _this.onGameIdChange = _this.onGameIdChange.bind(_this);
        _this.onLeagueChange = _this.onLeagueChange.bind(_this);
        _this.onNetworkChange = _this.onNetworkChange.bind(_this);
        _this.onPositionChange = _this.onPositionChange.bind(_this);
        _this.onThumbnailChange = _this.onThumbnailChange.bind(_this);
        _this.onPostMessage = _this.onPostMessage.bind(_this);
        return _this;
    }

    _createClass(SyndicatedPlayerExample, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.addEventListener('message', this.onPostMessage);
        }
    }, {
        key: 'onPostMessage',
        value: function onPostMessage(event) {
            var _props$location$query = this.props.location.query;
            _props$location$query = _props$location$query === undefined ? {} : _props$location$query;
            var _props$location$query2 = _props$location$query.bridge,
                bridge = _props$location$query2 === undefined ? true : _props$location$query2;


            if (bridge === 'false') {
                // simulate iframe embed only mode
                return;
            }

            if (typeof event.data !== 'string') {
                return;
            }

            var data = void 0;
            try {
                var prefix = PARTNER + ':' + DOMAIN + ':';
                data = JSON.parse(event.data.substr(prefix.length));
            } catch (err) {
                data = {};
            }

            var _data = data,
                type = _data.type,
                payload = _data.payload;


            if (!type) {
                return;
            }

            var _type$split = type.split(':'),
                _type$split2 = _slicedToArray(_type$split, 3),
                partner = _type$split2[0],
                domain = _type$split2[1],
                apiName = _type$split2[2];

            if (partner !== PARTNER) {
                return;
            }

            if (domain === DOMAIN) {
                switch (apiName) {
                    case 'bridgeReady':
                        // send the parent location to the iframe player in case
                        // `document.referrer` is not available for domain check.
                        this.callAPI({
                            type: __WEBPACK_IMPORTED_MODULE_5__syndicated_SyndicatedPlayerAPIProxy__["a" /* default */].PARENT_HOST,
                            payload: [window.location.href]
                        });
                        break;
                    case 'getVideoPosition':
                        this.setState({ currentTime: payload });
                        break;
                    case 'getAffiliate':
                    case 'getSelectedProvider':
                    case 'getAuthenticationStatus':
                        console.log(apiName, payload); // eslint-disable-line no-console
                        break;
                    case 'authenticationSuccessful':
                    case 'recheckAccess':
                        {
                            var url = payload && payload.href || this.iframe.src;

                            var _url$split = url.split('?'),
                                _url$split2 = _slicedToArray(_url$split, 2),
                                host = _url$split2[0],
                                searchStr = _url$split2[1];

                            if (searchStr) {
                                var newSearchStr = searchStr.replace(/&autoStart(=[^&]*)?|^autoStart(=[^&]*)?&?/, '');
                                url = host + '?' + newSearchStr;
                            }
                            this.iframe.src = url;
                            break;
                        }
                    default:
                        break;
                }
            }
        }
    }, {
        key: 'onIdChange',
        value: function onIdChange(event) {
            this.setState({ id: event.target.value });
        }
    }, {
        key: 'onEventIdChange',
        value: function onEventIdChange(event) {
            this.setState({ eventId: event.target.value });
        }
    }, {
        key: 'onGameIdChange',
        value: function onGameIdChange(event) {
            this.setState({ gameId: event.target.value });
        }
    }, {
        key: 'onLeagueChange',
        value: function onLeagueChange(event) {
            this.setState({ league: event.target.value });
        }
    }, {
        key: 'onThumbnailChange',
        value: function onThumbnailChange(event) {
            this.setState({ thumbnail: event.target.value });
        }
    }, {
        key: 'onNetworkChange',
        value: function onNetworkChange(event) {
            this.setState({ network: event.target.value });
        }
    }, {
        key: 'onPositionChange',
        value: function onPositionChange(event) {
            this.setState({ position: parseInt(event.target.value, 10) });
        }
    }, {
        key: 'setVideoPosition',
        value: function setVideoPosition() {
            this.callAPI({
                type: __WEBPACK_IMPORTED_MODULE_5__syndicated_SyndicatedPlayerAPIProxy__["a" /* default */].SET_CURRENT_TIME,
                payload: [this.state.position]
            });
        }
    }, {
        key: 'getVideoPosition',
        value: function getVideoPosition() {
            this.callAPI({
                type: __WEBPACK_IMPORTED_MODULE_5__syndicated_SyndicatedPlayerAPIProxy__["a" /* default */].GET_CURRENT_TIME
            });
        }
    }, {
        key: 'getAffiliate',
        value: function getAffiliate() {
            this.callAPI({
                type: __WEBPACK_IMPORTED_MODULE_5__syndicated_SyndicatedPlayerAPIProxy__["a" /* default */].GET_AFFILIATE
            });
        }
    }, {
        key: 'getSelectedProvider',
        value: function getSelectedProvider() {
            this.callAPI({
                type: __WEBPACK_IMPORTED_MODULE_5__syndicated_SyndicatedPlayerAPIProxy__["a" /* default */].GET_SELECTED_PROVIDER
            });
        }
    }, {
        key: 'getAuthenticationStatus',
        value: function getAuthenticationStatus() {
            this.callAPI({
                type: __WEBPACK_IMPORTED_MODULE_5__syndicated_SyndicatedPlayerAPIProxy__["a" /* default */].GET_AUTH_STATUS
            });
        }
    }, {
        key: 'playVideo',
        value: function playVideo() {
            this.callAPI({
                type: __WEBPACK_IMPORTED_MODULE_5__syndicated_SyndicatedPlayerAPIProxy__["a" /* default */].PLAY
            });
        }
    }, {
        key: 'pauseVideo',
        value: function pauseVideo() {
            this.callAPI({
                type: __WEBPACK_IMPORTED_MODULE_5__syndicated_SyndicatedPlayerAPIProxy__["a" /* default */].PAUSE
            });
        }
    }, {
        key: 'muteStream',
        value: function muteStream() {
            this.callAPI({
                type: __WEBPACK_IMPORTED_MODULE_5__syndicated_SyndicatedPlayerAPIProxy__["a" /* default */].MUTE
            });
        }
    }, {
        key: 'unMuteStream',
        value: function unMuteStream() {
            this.callAPI({
                type: __WEBPACK_IMPORTED_MODULE_5__syndicated_SyndicatedPlayerAPIProxy__["a" /* default */].UNMUTE
            });
        }
    }, {
        key: 'enterFullScreen',
        value: function enterFullScreen() {
            this.callAPI({
                type: __WEBPACK_IMPORTED_MODULE_5__syndicated_SyndicatedPlayerAPIProxy__["a" /* default */].ENTER_FULLSCREEN
            });
        }
    }, {
        key: 'selectById',
        value: function selectById() {
            this.callAPI({
                type: __WEBPACK_IMPORTED_MODULE_5__syndicated_SyndicatedPlayerAPIProxy__["a" /* default */].SELECT_BY_ID,
                payload: [this.state.id, this.autoPlayForSelectById.checked, this.state.thumbnail]
            });
        }
    }, {
        key: 'selectByEventId',
        value: function selectByEventId() {
            this.callAPI({
                type: __WEBPACK_IMPORTED_MODULE_5__syndicated_SyndicatedPlayerAPIProxy__["a" /* default */].SELECT_BY_EVENT_ID,
                payload: [this.state.eventId, this.autoPlayForSelectByEventId.checked, this.state.thumbnail]
            });
        }
    }, {
        key: 'selectEventByNetworkName',
        value: function selectEventByNetworkName() {
            this.callAPI({
                type: __WEBPACK_IMPORTED_MODULE_5__syndicated_SyndicatedPlayerAPIProxy__["a" /* default */].SELECT_EVENT_BY_NETWORK_NAME,
                payload: [this.state.network, this.state.thumbnail]
            });
        }
    }, {
        key: 'selectEventByGameIdLeague',
        value: function selectEventByGameIdLeague() {
            this.callAPI({
                type: __WEBPACK_IMPORTED_MODULE_5__syndicated_SyndicatedPlayerAPIProxy__["a" /* default */].SELECT_EVENT_BY_GAME_ID,
                payload: [this.state.gameId, this.state.league, this.state.thumbnail]
            });
        }
    }, {
        key: 'recheckAccess',
        value: function recheckAccess() {
            this.callAPI({
                type: __WEBPACK_IMPORTED_MODULE_5__syndicated_SyndicatedPlayerAPIProxy__["a" /* default */].RECHECK_ACCESS
            });
        }
    }, {
        key: 'adobePassLogout',
        value: function adobePassLogout() {
            this.callAPI({
                type: __WEBPACK_IMPORTED_MODULE_5__syndicated_SyndicatedPlayerAPIProxy__["a" /* default */].ADOBE_PASS_LOGOUT
            });
        }
    }, {
        key: 'callAPI',
        value: function callAPI(data) {
            var originResult = /https?:\/\/[^\/]+/.exec(this.iframe.src);
            var origin = originResult && originResult[0] || '*';
            this.iframe.contentWindow.postMessage(JSON.stringify(data), origin);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                id = _state.id,
                eventId = _state.eventId,
                gameId = _state.gameId,
                league = _state.league,
                network = _state.network,
                position = _state.position,
                currentTime = _state.currentTime,
                thumbnail = _state.thumbnail;
            var _props = this.props,
                query = _props.location.query,
                _props$espnPlayerSrc = _props.espnPlayerSrc,
                espnPlayerJsUrl = _props$espnPlayerSrc.espnPlayerJsUrl,
                espnPlayerCssUrl = _props$espnPlayerSrc.espnPlayerCssUrl;
            var responsive = query.responsive,
                _query$origin = query.origin,
                origin = _query$origin === undefined ? '' : _query$origin;
            var width = query.width,
                height = query.height;

            if (responsive) {
                width = '100%';
                height = '56.25vw';
            } else if (width && !height) {
                height = Math.round(width * (9 / 16));
            } else if (!width && height) {
                width = Math.round(height * (16 / 9));
            }
            iframeStyle = width && height ? _extends({}, iframeStyle, { width: width, height: height }) : iframeStyle;
            var ifmQuery = _extends({}, query);
            delete ifmQuery.bridge;
            delete ifmQuery.origin;
            var qs = Object(__WEBPACK_IMPORTED_MODULE_3__lib_format_queryString__["a" /* default */])(ifmQuery);

            return _jsx('div', {
                style: containerStyle
            }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_helmet___default.a, {
                meta: [{ name: 'robots', content: 'noindex, nofollow' }],
                link: [{ rel: 'stylesheet', href: STYLE_HREF + '/page.css' }, {
                    class: '__watch-player-bundle__',
                    rel: 'stylesheet',
                    href: espnPlayerCssUrl
                }],
                style: [{
                    cssText: '\n                        body {\n                            font-family: sans-serif;\n                        }\n                        h1 { font-size: 24px; }\n                        h2 { font-size: 20px; }\n                        h3 { font-size: 18px; }\n                    '
                }],
                script: [{
                    src: espnPlayerJsUrl,
                    async: true
                }]
            }), _jsx('h1', {}, void 0, 'Syndicated Player Test'), _jsx('div', {}, void 0, _jsx('button', {
                onClick: this.playVideo
            }, void 0, 'playVideo'), _jsx('button', {
                onClick: this.pauseVideo
            }, void 0, 'pauseVideo'), _jsx('button', {
                onClick: this.muteStream
            }, void 0, 'muteStream'), _jsx('button', {
                onClick: this.unMuteStream
            }, void 0, 'unMuteStream'), _jsx('button', {
                onClick: this.enterFullScreen
            }, void 0, 'enterFullScreen')), _jsx('div', {}, void 0, _jsx('button', {
                onClick: this.setVideoPosition
            }, void 0, 'setVideoPosition'), _jsx('input', {
                type: 'text',
                value: position,
                onChange: this.onPositionChange
            }), _jsx('button', {
                onClick: this.getVideoPosition
            }, void 0, 'getVideoPosition'), _jsx('input', {
                type: 'text',
                value: currentTime,
                readOnly: true
            })), _jsx('div', {}, void 0, _jsx('button', {
                onClick: this.selectById
            }, void 0, 'selectById'), _jsx('input', {
                type: 'text',
                value: id,
                onChange: this.onIdChange
            }), _jsx('label', {
                htmlFor: 'autoplay'
            }, void 0, 'Autoplay:', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                ref: function ref(input) {
                    _this2.autoPlayForSelectById = input;
                },
                id: 'autoplay',
                type: 'checkbox',
                defaultChecked: true,
                style: { display: 'inline-block' }
            })), _jsx('span', {}, void 0, 'Thumbnail: '), _jsx('input', {
                type: 'text',
                value: thumbnail,
                onChange: this.onThumbnailChange
            })), _jsx('div', {}, void 0, _jsx('button', {
                onClick: this.selectByEventId
            }, void 0, 'selectByEventId'), _jsx('input', {
                type: 'text',
                value: eventId,
                onChange: this.onEventIdChange
            }), _jsx('label', {
                htmlFor: 'autoplay'
            }, void 0, 'Autoplay:', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                ref: function ref(input) {
                    _this2.autoPlayForSelectByEventId = input;
                },
                id: 'autoplay',
                type: 'checkbox',
                defaultChecked: true,
                style: { display: 'inline-block' }
            })), _jsx('span', {}, void 0, 'Thumbnail: '), _jsx('input', {
                type: 'text',
                value: thumbnail,
                onChange: this.onThumbnailChange
            })), _jsx('div', {}, void 0, _jsx('button', {
                onClick: this.selectEventByNetworkName
            }, void 0, 'selectEventByNetworkName'), _jsx('input', {
                type: 'text',
                value: network,
                onChange: this.onNetworkChange
            })), _jsx('div', {}, void 0, _jsx('button', {
                onClick: this.selectEventByGameIdLeague
            }, void 0, 'selectEventByGameIdLeague'), _jsx('span', {}, void 0, 'GameId: '), _jsx('input', {
                type: 'text',
                value: gameId,
                onChange: this.onGameIdChange
            }), _jsx('span', {}, void 0, 'League: '), _jsx('input', {
                type: 'text',
                value: league,
                onChange: this.onLeagueChange
            }), _jsx('span', {}, void 0, 'Thumbnail: '), _jsx('input', {
                type: 'text',
                value: thumbnail,
                onChange: this.onThumbnailChange
            })), _jsx('div', {}, void 0, _jsx('button', {
                onClick: this.recheckAccess
            }, void 0, 'recheckAccess'), _jsx('button', {
                onClick: this.adobePassLogout
            }, void 0, 'adobePassLogout')), _jsx('div', {}, void 0, _jsx('button', {
                onClick: this.getAffiliate
            }, void 0, 'getAffiliate'), _jsx('button', {
                onClick: this.getSelectedProvider
            }, void 0, 'getSelectedProvider'), _jsx('button', {
                onClick: this.getAuthenticationStatus
            }, void 0, 'getAuthenticationStatus')), _jsx('div', {
                style: playerContainerStyle
            }, void 0, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe', {
                ref: function ref(iframe) {
                    _this2.iframe = iframe;
                },
                id: 'syndicated_player',
                src: origin + '/watch/syndicated/player' + qs,
                frameBorder: '0',
                allowFullScreen: true,
                style: iframeStyle
            })));
        }
    }]);

    return SyndicatedPlayerExample;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

var mapStateToProps = function mapStateToProps(state) {
    return {
        espnPlayerSrc: Object(__WEBPACK_IMPORTED_MODULE_6__common_selectors_bootstrapSelector__["b" /* espnPlayerSrcFilesSelector */])(state)
    };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(SyndicatedPlayerExample));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_helmet__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__enums__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_util_canUseDOM__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_actions_appActions__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_actions_scoringActions__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_injectIntl__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_page_actions__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__player_actions__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_ads_connectAdInitializer__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_selectors_bootstrapSelector__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_selectors_appSelector__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_selectors_authenticationSelectors__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_selectors_playerSelector__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__common_selectors_routingSelector__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__common_selectors_pageSelector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__common_selectors_flagsSelector__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__branding_BrandingContainer__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__modal_authn_ProviderModal__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__modal_messaging_MessagingContainer__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__lib_format_addQueryToUrl__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__lib_observe__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__lib_observe_scoringObserver__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__lib_observe_trackingObserver__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__lib_ui_loading__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__lib_util_localStorage__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__constants__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__common_IntlProvider__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__config__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__config__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



































var shellVersion = __WEBPACK_IMPORTED_MODULE_31__config___default.a.shellVersion,
    secureCdnHost = __WEBPACK_IMPORTED_MODULE_31__config___default.a.secureCdnHost,
    devStyles = __WEBPACK_IMPORTED_MODULE_31__config___default.a.devStyles,
    clientNavigation = __WEBPACK_IMPORTED_MODULE_31__config___default.a.clientNavigation;


var STYLE_HREF = devStyles ? 'http://localhost:8080/static/css' : secureCdnHost + '/redesign/' + shellVersion + '/css/secure';

// sanitize anchor tags in nav (don't ajax, and remove useless href)
function sanitizeAnchor(anchor) {
    if (anchor instanceof HTMLAnchorElement) {
        if (anchor.getAttribute('href') === '#') {
            anchor.removeAttribute('href');
        }
        anchor.setAttribute('data-route', 'false');
    }
}

function initializeEspnChat() {
    var chatLink = document.querySelector('#global-nav-secondary .global-nav-container ul li a[data-abbrev=chatwidget]');

    if (chatLink) {
        var htmlHead = document.getElementsByTagName('head')[0];
        var chatScript = document.createElement('script');
        chatScript.type = 'text/javascript';
        chatScript.src = 'https://c.la4-c2-chi.salesforceliveagent.com/content/g/js/43.0/deployment.js';
        chatScript.onload = function () {
            window.liveagent.init('https://d.la4-c2-chi.salesforceliveagent.com/chat', '5721a000000055c', '00D1a000000JpU6');
            if (!window._laq) {
                window._laq = [];
            }
            window._laq.push(function () {
                window.liveagent.showWhenOnline('5731a00000005l3', chatLink);
            });
        };
        // Append the liveagent script to the head tag
        htmlHead.append(chatScript);

        // Add click handler to open the chat window
        chatLink.setAttribute('id', 'liveagent_button_online_5731a00000005l3');
        chatLink.onclick = function (event) {
            event.preventDefault();
            if (window.liveagent && window.liveagent.startChat) {
                window.liveagent.startChat('5731a00000005l3');
            }
        };
    } else {
        console.warn('Unable to initialize chat widget, selector is undefined.');
    }
}

// TODO: DTC - remove this once we have it in the nav
function insertNavItems(navItems) {
    if (!window.jQuery) {
        return;
    }

    function insertItem(index, route, label) {
        if (!document.querySelector('#global-nav-secondary .global-nav-container ul li a[href*="/watch/' + route + '"]')) {
            var navList = document.querySelectorAll('#global-nav-secondary .global-nav-container ul li');
            if (navList) {
                window.jQuery('\n                    <li class="" itemprop="name">\n                        <a itemprop="url" href="http://www.espn.com/watch/' + route + '/" name="&lpos=sitenavcustom_watch_' + route + '" data-route="false" data-abbrev="watch">\n                            <span class="link-text">' + label + '</span>\n                            <span class="link-text-short">' + label + '</span>\n                        </a>\n                    </li>\n                ').insertAfter(window.jQuery(navList).get(index));
            }
        }
    }

    if (navItems && navItems.length) {
        navItems.forEach(function (_ref) {
            var index = _ref.index,
                label = _ref.label,
                path = _ref.path;
            return insertItem(index, path, label);
        });
    }
}

function updateSubNav(location, navItems) {
    if (navItems) {
        insertNavItems(navItems);
    }
    // updateSubNav is called only on the client side.
    if (location && window.jQuery) {
        window.jQuery('#global-nav-secondary li').each(function () {
            // eslint-disable-line
            var $this = window.jQuery(this);
            var href = $this.find('a[itemprop="url"]').attr('href');

            if ('' + location.basename + location.pathname === href || '' + location.basename + location.pathname + '/' === href) {
                $this.addClass('active');
            } else if ($this.hasClass('active')) {
                $this.removeClass('active');
            }
        });
    }
}

var PageShell = function (_Component) {
    _inherits(PageShell, _Component);

    function PageShell(props) {
        _classCallCheck(this, PageShell);

        var _this = _possibleConstructorReturn(this, (PageShell.__proto__ || Object.getPrototypeOf(PageShell)).call(this, props));

        _this.mountBrandingComponent = _this.mountBrandingComponent.bind(_this);
        _this.insertProviderContainer = _this.insertProviderContainer.bind(_this);
        _this.providerContainer = null;
        _this.subNavEl = null;
        _this.latestLocation = null;
        return _this;
    }

    _createClass(PageShell, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            var _props = this.props,
                _props$bootstrap$page = _props.bootstrap.pageShell;
            _props$bootstrap$page = _props$bootstrap$page === undefined ? {} : _props$bootstrap$page;
            var nav = _props$bootstrap$page.nav,
                isIntl = _props.isIntl,
                navOverride = _props.navOverride;


            if (__WEBPACK_IMPORTED_MODULE_6__lib_util_canUseDOM__["a" /* default */]) {
                // this disables the shell from rendering ads (so that we can do it)
                // see https://code.espn.com/webdev/score/blob/ec82c07f8a607971029786f21fffbb211996e370/static/js/ads/init.js#L358
                if (window.espn_ui) {
                    window.espn_ui.pageShell = true;
                }

                var _context = this.context,
                    store = _context.store,
                    router = _context.router;
                var dispatch = this.props.dispatch;


                this.unsubscribeFromStore = Object(__WEBPACK_IMPORTED_MODULE_24__lib_observe__["a" /* subscribeToStore */])(store, [__WEBPACK_IMPORTED_MODULE_25__lib_observe_scoringObserver__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__lib_observe_trackingObserver__["a" /* default */]]);

                var unlistenBefore = router.listenBefore(function (newLocation) {
                    var _props2 = _this2.props,
                        player = _props2.player,
                        routing = _props2.routing;

                    if (player.embedding === true) {
                        return false;
                    }

                    // if the pathname is different, clear the redux state
                    var _routing$locationBefo = routing.locationBeforeTransitions,
                        currentLocation = _routing$locationBefo === undefined ? {} : _routing$locationBefo;

                    var currentPath = '' + currentLocation.basename + currentLocation.pathname;
                    var newPath = '' + newLocation.basename + newLocation.pathname;
                    var currentPathRegex = new RegExp('^' + currentPath + '/?$');

                    if (!newPath.match(currentPathRegex)) {
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__common_actions_appActions__["A" /* contentUnSelect */])());
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__common_actions_appActions__["P" /* streamUnSelect */])());
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__player_actions__["p" /* createClearPlayingStreamAction */])());
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__player_actions__["x" /* createResetPlayerAction */])());
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__common_page_actions__["m" /* clearPage */])());
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__player_actions__["r" /* createFeedResetAction */])());
                    }
                    return true;
                });

                var unlisten = router.listen(function (location) {
                    _this2.latestLocation = location;

                    // this fixes broken scrolling when using the back and forward browser buttons btw ajax pages
                    if (window.espn_ui && window.espn_ui.Helpers) {
                        window.espn_ui.Helpers.history.updateState('react', true);
                    }

                    updateSubNav(location, navOverride && nav);
                });

                this.unlisten = function () {
                    unlistenBefore();
                    unlisten();
                };

                if (isIntl) {
                    this.initPageShell();
                }
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this3 = this;

            var _props3 = this.props,
                dispatch = _props3.dispatch,
                _props3$bootstrap$pag = _props3.bootstrap.pageShell;
            _props3$bootstrap$pag = _props3$bootstrap$pag === undefined ? {} : _props3$bootstrap$pag;
            var nav = _props3$bootstrap$pag.nav,
                flags = _props3.flags,
                isIntl = _props3.isIntl,
                navOverride = _props3.navOverride;

            if (!isIntl) {
                this.initPageShell();
            }
            if (window.jQuery) {
                if (window.jQuery.subscribe) {
                    window.jQuery.subscribe('userBuilt', function () {
                        setTimeout(function () {
                            var profileAnchorTags = document.querySelectorAll('.user a');
                            Array.prototype.forEach.call(profileAnchorTags, function (anchor) {
                                sanitizeAnchor(anchor);
                            });
                        }, 0);
                    });
                    window.jQuery.subscribe('analytics.loaded', function (initData) {
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__common_actions_appActions__["w" /* analyticsReady */])(initData));
                    });
                    window.jQuery.subscribe('espn.defer.end', function () {
                        // noop `FastClick.attach` before it gets called here to fix the button click issue on mobile
                        // https://code.espn.com/webdev/score/blob/develop/static/js/espn-ui.js#L296
                        if (window.FastClick) {
                            window.FastClick.attach = function () {};
                        }
                    });
                }

                window.jQuery(window).on('media_query_updated', function () {
                    if (window.espn_ui && window.espn_ui.Helpers) {
                        var nextMq = window.espn_ui.Helpers.get_media_query_in_use();
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__common_actions_appActions__["E" /* mediaQuery */])(nextMq));
                    }
                });
                if (window.espn_ui && window.espn_ui.Helpers) {
                    var currentMq = window.espn_ui.Helpers.get_media_query_in_use();
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__common_actions_appActions__["E" /* mediaQuery */])(currentMq));
                }

                // NOTE: this may not fire locally on all browsers
                // 'nav.ready' will be fired not only the initial load but also every break point change
                window.jQuery(document).on('nav.ready', function () {
                    window.jQuery('#global-nav > ul > li.watch').addClass('active');
                    var headerAnchorTags = document.querySelectorAll('#header-wrapper a');
                    Array.prototype.forEach.call(headerAnchorTags, function (anchor) {
                        sanitizeAnchor(anchor);
                    });
                    updateSubNav(_this3.latestLocation, navOverride && nav);

                    // Append the Chat subnav within FAQ nav item only for Domestic
                    if (!isIntl) {
                        initializeEspnChat();
                    }

                    _this3.mountBrandingComponent(); // in the event the nav completes after auth
                });
            }

            if (window.espn && window.espn.refresh) {
                window.espn.refresh.stop();
            }

            if (clientNavigation || flags[__WEBPACK_IMPORTED_MODULE_5__enums__["t" /* Flags */].CLIENT_NAV] === 'true') {
                var secondaryNavContainer = document.getElementById('global-nav-secondary');
                if (secondaryNavContainer) {
                    secondaryNavContainer.addEventListener('click', function (event) {
                        _this3.interceptNavClick(secondaryNavContainer, event);
                    });
                }
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _nextProps$location = nextProps.location,
                location = _nextProps$location === undefined ? {} : _nextProps$location;

            var currentLocation = this.props.location;
            if (currentLocation !== location) {
                // add playback specific class to body on playback page
                if (location.pathname.indexOf('/player') !== -1) {
                    if (document.body.className.indexOf('playback') === -1) {
                        document.body.className = document.body.className + ' watch--playback';
                    }
                } else {
                    document.body.className = document.body.className.replace(/\s?watch--playback/, '');
                }
            }

            // media queries dirty the dom in the subnav, listen for them and clean it up
            if (this.props.mq && this.props.mq !== nextProps.mq && this.providerContainer) {
                // unmount the branding component entirely followed by mounting it again by 'nav.ready'
                __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unmountComponentAtNode(this.providerContainer);
                if (this.subNavEl) {
                    this.subNavEl.removeChild(this.providerContainer);
                    this.providerContainer = null;
                }
            }

            this.handleSessionTokenPageRefetch(nextProps);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.unlisten) {
                this.unlisten();
            }
            if (this.unsubscribeFromStore) {
                this.unsubscribeFromStore();
            }
        }
    }, {
        key: 'initPageShell',
        value: function initPageShell() {
            var _props4 = this.props,
                dispatch = _props4.dispatch,
                params = _props4.params;

            dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__common_page_actions__["p" /* createPageShellInitAction */])(params, __WEBPACK_IMPORTED_MODULE_29__constants__["c" /* BAM_PROXY_IFRAME_ID */]));
        }
    }, {
        key: 'interceptNavClick',
        value: function interceptNavClick(root, event, parent) {
            var target = parent || event.target;
            if (target === root) {
                return;
            }

            var flags = this.props.flags;

            var href = target.getAttribute && target.getAttribute('href');
            // exclude feedback page from client render since it uses basic shell
            if (href && href.indexOf('/watch/') > 0 && href.indexOf('/watch/feedback') === -1) {
                event.preventDefault();
                this.context.store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["push"])(Object(__WEBPACK_IMPORTED_MODULE_23__lib_format_addQueryToUrl__["a" /* default */])(href.split('/watch/')[1], flags)));
            } else if (target.parentNode) {
                this.interceptNavClick(root, event, target.parentNode);
            }
        }
    }, {
        key: 'handleSessionTokenPageRefetch',
        value: function handleSessionTokenPageRefetch() {
            var nextProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var sessionToken = nextProps.sessionToken,
                pageId = nextProps.pageId,
                params = nextProps.params;
            var _props5 = this.props,
                dispatch = _props5.dispatch,
                initialSessionToken = _props5.sessionToken;

            var localStoredSessionToken = Object(__WEBPACK_IMPORTED_MODULE_28__lib_util_localStorage__["a" /* get */])(__WEBPACK_IMPORTED_MODULE_29__constants__["o" /* SESSION_TOKEN_KEY */]);
            try {
                // NOTE: Refetches the Page buckets if the sessionToken is updated in the store
                // and the initialSessionToken is undefined along with the localStorage sessionToken.
                // The sessionToken is always re-assigned on any client transition or page load.
                // Does not impact routes with /schedule or /player
                if (!initialSessionToken && sessionToken && !localStoredSessionToken && ['schedule', 'player'].indexOf(pageId) === -1) {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__common_page_actions__["v" /* refreshBuckets */])(pageId, { params: params, forceRefresh: true }));
                }
            } catch (error) {
                console.error('handleSessionTokenPageRefetch() Error: Failed to refresh buckets ' + pageId);
            }
        }
    }, {
        key: 'mountBrandingComponent',
        value: function mountBrandingComponent() {
            var store = this.context.store;

            this.insertProviderContainer();
            if (this.providerContainer) {
                __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(_jsx(__WEBPACK_IMPORTED_MODULE_2_react_redux__["a" /* Provider */], {
                    store: store
                }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_30__common_IntlProvider__["a" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_20__branding_BrandingContainer__["a" /* default */], {}))), this.providerContainer);
            }
        }

        // This is a hack to insert DOM into the nav element to hold the provider logo.  It will go away

    }, {
        key: 'insertProviderContainer',
        value: function insertProviderContainer() {
            if (this.subNavEl === null) {
                this.subNavEl = document.querySelector('#global-nav-secondary .global-nav-container');
            }
            if (!this.subNavEl) {
                return;
            }

            if (!document.querySelector('#provider-logo-subnav')) {
                var providerLogo = document.createElement('div');
                providerLogo.id = 'provider-logo-subnav';
                this.providerContainer = this.subNavEl.appendChild(providerLogo);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props6 = this.props,
                isSecure = _props6.isSecure,
                _props6$espnPlayerSrc = _props6.espnPlayerSrc,
                espnPlayerJsUrl = _props6$espnPlayerSrc.espnPlayerJsUrl,
                espnPlayerCssUrl = _props6$espnPlayerSrc.espnPlayerCssUrl;


            return _jsx('div', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_4_react_helmet___default.a, {
                link: [{ rel: 'stylesheet', href: STYLE_HREF + '/shell-desktop.css' }, { rel: 'stylesheet', href: STYLE_HREF + '/page-shell.css' }, { class: 'page-type-include', rel: 'stylesheet', href: STYLE_HREF + '/index.css' }, { rel: 'stylesheet', href: STYLE_HREF + '/watch.css' }, { rel: 'stylesheet', href: STYLE_HREF + '/watch-provider.css' }, { rel: 'stylesheet', href: STYLE_HREF + '/watch-stream-picker.css' }, {
                    class: '__watch-player-bundle__',
                    rel: 'stylesheet',
                    href: espnPlayerCssUrl
                }],
                style: [{
                    cssText: '\n                            audio::-internal-media-controls-cast-button, video::-internal-media-controls-cast-button {\n                                display: none;\n                            }\n\n                            .no-header #main-container { padding-top: 0; }\n\n                            @media screen and (min-width: 1024px) {\n                                .collection.collection--watch .ad-300 {\n                                    margin-left: 20px;\n                                }\n                                .playback__content .collection_item>.collection__link {\n                                    padding-left: 20px;\n                                    padding-right: 20px;\n                                }\n                            }\n                            /* TODO: remove once we have it in css */\n                            #global-nav-secondary .global-nav-container .sportbrand .sportbrand__watch>img {\n                                max-height: 25px;\n                            }\n\n                            /* Carousel Hero CSS */\n                            .dtc-watch__carousel--container {\n                                position: relative;\n                                width: 100%;\n                            }\n\n                            .dtc-watch__carousel--container.carousel-loading .dtc-watch__carousel {\n                                display: none;\n                            }\n\n                            .dtc-watch__carousel--container.carousel-loading {\n                                margin-bottom: 44px;\n                            }\n\n                            .dtc-watch__carousel--container.carousel-loading:before {\n                                background:url("' + __WEBPACK_IMPORTED_MODULE_29__constants__["x" /* secureLoadingImageUrl */] + '") 50% 50% no-repeat #dcdddf !important;\n                                background-size:cover !important;\n                                bottom:0;\n                                content:\'\';\n                                display:block;\n                                left:0px;\n                                opacity:1 !important;\n                                position:absolute;\n                                right:0px;\n                                top:0;\n                                z-index:3 !important;\n                            }\n\n                            @media screen and (max-width: 767px) {\n                                .dtc-watch__carousel--container,\n                                .dtc-watch__carousel__item img {\n                                    min-height: 40vw;\n                                }\n                            }\n\n                            @media screen and (min-width: 768px) and (max-width: 1023px) {\n                                .dtc-watch__carousel--container,\n                                .dtc-watch__carousel__item img {\n                                    min-height: 296px;\n                                }\n                            }\n\n                            @media screen and (min-width: 1024px) and (max-width: 1259px) {\n                                .dtc-watch__carousel--container,\n                                .dtc-watch__carousel__item img {\n                                    min-height: 392px;\n                                }\n                            }\n\n                            @media screen and (min-width: 1260px) {\n                                .dtc-watch__carousel--container,\n                                .dtc-watch__carousel__item img {\n                                    min-height: 488px;\n                                }\n                            }\n\n                            .dtc_carousel__dots { display: flex !important; }\n\n                            #watchespn-bam-player {\n                                background-color: #000 !important;\n                                height: 100% !important;\n                                left: 0;\n                                position: absolute;\n                                top: 0;\n                                width: 100% !important;\n                                z-index: 1000031;\n                            }\n\n                            #watchespn-player iframe,\n                            #watchespn-bam-player iframe{\n                                width: 100%;\n                                height: 100%;\n                                border: none;\n                            }\n\n                            .' + __WEBPACK_IMPORTED_MODULE_29__constants__["c" /* BAM_PROXY_IFRAME_ID */] + ', .' + __WEBPACK_IMPORTED_MODULE_29__constants__["c" /* BAM_PROXY_IFRAME_ID */] + ' iframe {\n                                position: absolute;\n                                left: -10000px;\n                                width: 1px;\n                                height: 1px;\n                                border: none;\n                            }\n\n                            #' + __WEBPACK_IMPORTED_MODULE_29__constants__["b" /* BAM_PROMO_IFRAME_ID */] + ' {\n                                width: 100%;\n                                height: 506.25px;\n                                margin-bottom: 10px;\n                            }\n\n                            .collection_item_truncate>span, .hero_truncate>span {\n                                font-family: BentonSans, -apple-system, Roboto, Helvetica, Arial, sans-serif;\n                            }\n\n                            #' + __WEBPACK_IMPORTED_MODULE_29__constants__["b" /* BAM_PROMO_IFRAME_ID */] + ' iframe,\n                            #' + __WEBPACK_IMPORTED_MODULE_29__constants__["a" /* BAM_PAYWALL_IFRAME_ID */] + ' iframe {\n                                width: 100%;\n                                height: 100%;\n                                border: none;\n                                display: block;\n                            }\n\n                            .lightbox-container .lightbox-watch.watch-provider-modal.lightbox-paywall .btn-close {\n                                padding: 0;\n                            }\n\n                            .lightbox-container .lightbox-watch.watch-provider-modal.lightbox-paywall .btn-close:before {\n                                color: #fff;\n                                line-height: 36px;\n                            }\n\n                            body.ReactModal__Body--open {\n                                overflow: hidden;\n                            }\n\n                            .video-overlays-container {\n                                position: absolute;\n                                top: 0;\n                                left: 0;\n                                width: 100%;\n                                height: 100%;\n                            }\n                            .streampicker.overlay {\n                                width: 100%;\n                                height: 100%;\n                            }\n                            .StreamPicker__Container {\n                                height: auto;\n                                top: auto;\n                            }\n                            .video-player__stream {\n                                position: relative;\n                                height: 100%;\n                                display: flex;\n                                justify-content: center;\n                                align-items: center;\n                            }\n                            .StreamPicker__Header {\n                                border-bottom: #48494a 1px solid;\n                                height: 50px;\n                                position: relative;\n                                text-align: center;\n                            }\n                            .StreamPicker__Body {\n                                padding: 16px;\n                                max-height: 253px;\n                                overflow-y: scroll;\n                            }\n                            .StreamPicker__Broadcast {\n                                margin-bottom: 12px;\n                                margin-top: 0;\n                            }\n                            .StreamPicker__Row {\n                                margin-bottom: 18px;\n                            }\n                            .StreamPicker__Row:last-child {\n                                margin-bottom: 0;\n                            }\n                        '
                }],
                script: [{
                    src: '//a.espncdn.com/combiner/c?js=analytics/visitorAPI_312.js'
                }, {
                    src: espnPlayerJsUrl,
                    async: true
                }]
            }), _jsx('img', {
                alt: 'prefetch loading graphic',
                src: isSecure ? __WEBPACK_IMPORTED_MODULE_29__constants__["x" /* secureLoadingImageUrl */] : __WEBPACK_IMPORTED_MODULE_29__constants__["u" /* loadingImageUrl */],
                style: { display: 'none' }
            }), isSecure ? null : _jsx('img', {
                alt: 'prefetch loading graphic',
                src: __WEBPACK_IMPORTED_MODULE_29__constants__["v" /* loadingImageUrlDark */],
                style: { display: 'none' }
            }), _jsx(__WEBPACK_IMPORTED_MODULE_21__modal_authn_ProviderModal__["a" /* default */], {}), _jsx(__WEBPACK_IMPORTED_MODULE_22__modal_messaging_MessagingContainer__["a" /* default */], {}), this.props.children);
        }
    }]);

    return PageShell;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

PageShell.contextTypes = {
    store: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object.isRequired,
    router: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object.isRequired,
    intl: __WEBPACK_IMPORTED_MODULE_9__common_injectIntl__["b" /* intlShape */].isRequired,
    messages: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object.isRequired
};

PageShell.renderTemplate = __WEBPACK_IMPORTED_MODULE_5__enums__["C" /* RenderTemplateTypes */].PAGE_SHELL;
PageShell.preActions = [__WEBPACK_IMPORTED_MODULE_7__common_actions_appActions__["D" /* fetchExternalConfig */]];
PageShell.loadActions = [];
PageShell.onLoadStart = __WEBPACK_IMPORTED_MODULE_27__lib_ui_loading__["b" /* uiLoadingStart */];
PageShell.onComplete = function onComplete(dispatch) {
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__common_actions_scoringActions__["a" /* scoreAll */])());
};

var mapStateToProps = function mapStateToProps(state) {
    var bootstrap = Object(__WEBPACK_IMPORTED_MODULE_13__common_selectors_bootstrapSelector__["a" /* default */])(state);
    var mq = Object(__WEBPACK_IMPORTED_MODULE_14__common_selectors_appSelector__["j" /* default */])(state).mq;
    var lang = Object(__WEBPACK_IMPORTED_MODULE_14__common_selectors_appSelector__["j" /* default */])(state).lang;
    var env = Object(__WEBPACK_IMPORTED_MODULE_14__common_selectors_appSelector__["j" /* default */])(state).env;
    var player = Object(__WEBPACK_IMPORTED_MODULE_16__common_selectors_playerSelector__["b" /* default */])(state);
    var routing = Object(__WEBPACK_IMPORTED_MODULE_17__common_selectors_routingSelector__["a" /* default */])(state);
    var flags = Object(__WEBPACK_IMPORTED_MODULE_19__common_selectors_flagsSelector__["a" /* persistentFlagsSelector */])(state);
    var isSecure = Object(__WEBPACK_IMPORTED_MODULE_14__common_selectors_appSelector__["v" /* isSecureSelector */])(state);
    var isIntl = Object(__WEBPACK_IMPORTED_MODULE_14__common_selectors_appSelector__["u" /* isIntlSelector */])(state);

    var _pageSelector = Object(__WEBPACK_IMPORTED_MODULE_18__common_selectors_pageSelector__["c" /* default */])(state),
        pageId = _pageSelector.id;

    var sessionToken = Object(__WEBPACK_IMPORTED_MODULE_15__common_selectors_authenticationSelectors__["j" /* bamSessionTokenSelector */])(state);
    var espnPlayerSrc = Object(__WEBPACK_IMPORTED_MODULE_13__common_selectors_bootstrapSelector__["b" /* espnPlayerSrcFilesSelector */])(state);
    return {
        bootstrap: bootstrap,
        mq: mq,
        navOverride: !isIntl && env !== __WEBPACK_IMPORTED_MODULE_5__enums__["c" /* AppEnvs */].prod,
        player: player,
        routing: routing,
        flags: flags,
        isSecure: isSecure,
        isIntl: isIntl,
        sessionToken: sessionToken,
        lang: lang,
        pageId: pageId,
        espnPlayerSrc: espnPlayerSrc
    };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(Object(__WEBPACK_IMPORTED_MODULE_12__common_ads_connectAdInitializer__["a" /* default */])(PageShell)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__selectors_flagsSelector__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AdManager__ = __webpack_require__(792);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
    Higher order component of PageShell for global ad initialization of all ads on current page.  Responsible for 'refreshing'
    all ads that are visible on initial page load
    The code for the global 'admgr' is here https://code.espn.com/webdev/score/blob/develop/static/js/ads/admgr.js
    You can see the ad requests in the console by filtering on 'pubads'
*/






function connectAdInitializer(WrappedComponent) {
    var AdInitializer = function (_Component) {
        _inherits(AdInitializer, _Component);

        function AdInitializer(props) {
            _classCallCheck(this, AdInitializer);

            var _this = _possibleConstructorReturn(this, (AdInitializer.__proto__ || Object.getPrototypeOf(AdInitializer)).call(this, props));

            _this.watchAdManager = new __WEBPACK_IMPORTED_MODULE_4__AdManager__["a" /* default */](props);
            return _this;
        }

        _createClass(AdInitializer, [{
            key: 'getChildContext',
            value: function getChildContext() {
                return {
                    watchAdManager: this.watchAdManager
                };
            }
        }, {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (window.admgr) {
                    // patch to accept config object and filter out non-refreshable in-page ads
                    window.admgr.getGPTArray = function getGPTArray() {
                        var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                        var slots = window.admgr.getGPTSlots() || {};
                        var arr = [];
                        var slot = void 0;

                        Object.keys(slots).forEach(function (key) {
                            slot = slots[key];
                            if (obj.independent !== false || slot.isIndependent !== true) {
                                if (obj.inPage === true && slot.isOutOfPage !== true && slot.refreshable) {
                                    arr.push(slot);
                                } else if (obj.outOfPage === true && (slot.isOutOfPage === true || slot.isCatExclusion === true)) {
                                    arr.push(slot);
                                } else if (obj.inPage !== true && obj.outOfPage !== true) {
                                    arr.push(slot);
                                }
                            }
                        });

                        return arr;
                    };
                    // patch to use the patched `getGPTArray`, original API uses the local `getGPTArray` so can't use as is.
                    window.admgr.refreshInPageAdSlots = function refreshInPageAdSlots() {
                        var arr = window.admgr.getGPTArray({ inPage: true, independent: false });
                        window.googletag.cmd.push(function () {
                            window.googletag.pubads().refresh(arr);
                        });
                    };
                    this.watchAdManager.adManager = window.admgr;
                }
            }
        }, {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                var _props = this.props,
                    mq = _props.mq,
                    routing = _props.routing;
                // refresh initially visible ads as early as possible.  also refresh for media queries

                if (mq !== nextProps.mq) {
                    if (!mq) {
                        this.watchAdManager.initAds(nextProps);
                    } else {
                        this.watchAdManager.onMediaQueryChange(nextProps);
                    }
                }
                var pathname = routing.locationBeforeTransitions.pathname;

                if (pathname !== nextProps.routing.locationBeforeTransitions.pathname) {
                    this.watchAdManager.preInit();
                }
            }

            // if this is a HOC of the PageShell, this is only called on route changes

        }, {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                if (prevProps.ads !== this.props.ads) {
                    this.watchAdManager.initAds(this.props);
                }
            }
        }, {
            key: 'render',
            value: function render() {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({}, this.props, this.state));
            }
        }]);

        return AdInitializer;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    AdInitializer.childContextTypes = {
        watchAdManager: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object.isRequired
    };

    var mapStateToProps = function mapStateToProps(state) {
        return {
            ads: state.ads,
            mq: state.app.mq,
            routing: state.routing,
            flags: Object(__WEBPACK_IMPORTED_MODULE_3__selectors_flagsSelector__["a" /* persistentFlagsSelector */])(state)
        };
    };

    return Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(AdInitializer, WrappedComponent));
}

/* harmony default export */ __webpack_exports__["a"] = (connectAdInitializer);

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_ui_isElementVisible__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_getMergedAdConfig__ = __webpack_require__(794);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }







var breakpoints = {
    'desktop-lg': 'xl',
    desktop: 'l',
    tablet: 'm',
    mobile: 's'
};

var AdType = {
    WALLPAPER: 'wallpaper',
    OVERLAY: 'overlay'
};

var AdManager = function () {
    function AdManager(props) {
        _classCallCheck(this, AdManager);

        this.props = props;
        this._onResize = __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(this._onResize.bind(this), 100);
        // debounced to handle multiple late ads that's added at the same timing in one shot
        this._onRegister = __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(this._refreshAll.bind(this), 4);
    }

    _createClass(AdManager, [{
        key: 'getMountedInstances',
        value: function getMountedInstances() {
            if (!this.mountedInstances) {
                this.mountedInstances = [];
            }
            return this.mountedInstances;
        }
    }, {
        key: 'addInstance',
        value: function addInstance(instance) {
            var instances = this.getMountedInstances();
            var index = instances.indexOf(instance);
            if (index === -1) {
                // The first instance starts listening for the event.
                if (instances.length === 0) {
                    this._toggleListener(true);
                }
                instances.push(instance);
            }
            // register ad individually when they are added after the page load/route change.
            // this will get called earlier than a page request is made which invalidates `this.props.ads.initialized`,
            // so need to check the flag `this._initializing` to make sure this is called after the ad initialization is done
            if (!this._initializing && this.props.ads.initialized) {
                this._registerAd(instance);
            }
        }
    }, {
        key: 'removeInstance',
        value: function removeInstance(instance) {
            var instances = this.getMountedInstances();
            var index = instances.indexOf(instance);
            if (index >= 0) {
                instances.splice(index, 1);
                // The last instance removes listening for the event.
                if (instances.length === 0) {
                    this._toggleListener(false);
                }
            }
        }
    }, {
        key: 'preInit',
        value: function preInit() {
            this._initializing = true;
        }
    }, {
        key: 'initAds',
        value: function initAds(props) {
            var _this = this;

            if (!this._adManager || !this.hasAds) {
                this._initializing = false;
                return;
            }

            this.props = props;

            var _props$ads = props.ads,
                ads = _props$ads === undefined ? {} : _props$ads,
                dispatch = props.dispatch;

            if (ads.id && ads.configured && (!ads.initialized || ads.refresh)) {
                try {
                    this._adConfig = Object(__WEBPACK_IMPORTED_MODULE_3__util_getMergedAdConfig__["a" /* default */])(props);
                    this._adManager.init(this._adConfig);
                    this._initializing = false;
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["e" /* adsInitialized */])());
                    // add refreshing ads in the queue to ensure it gets called after the ad initialization is complete
                    // which is also enqueued
                    window.googletag.cmd.push(function () {
                        _this._refreshAll();
                    });
                } catch (err) {
                    console.error(err); // eslint-disable-line
                }
            }
        }
    }, {
        key: 'onMediaQueryChange',
        value: function onMediaQueryChange(props) {
            this.props = props;
            this._refreshAds();
        }
    }, {
        key: '_toggleListener',
        value: function _toggleListener(add) {
            var _this2 = this;

            ['scroll', 'resize'].forEach(function (eventName) {
                window[add ? 'addEventListener' : 'removeEventListener'](eventName, _this2._onResize);
            });
        }
    }, {
        key: '_registerAd',
        value: function _registerAd(instance) {
            if (!this._adManager) {
                return;
            }
            var adSlot = instance.refs.adSlot;

            this._adManager.registerSlot(adSlot, this._adConfig);
            this._onRegister();
        }
    }, {
        key: '_refreshAll',
        value: function _refreshAll() {
            var _this3 = this;

            // check the element visibility first to update component state so that they will be reflected in `refreshAds`
            this._checkElementVisibility(function () {
                _this3._refreshAds();
            });
        }
    }, {
        key: '_refreshAds',
        value: function _refreshAds() {
            var _this4 = this;

            var instances = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getMountedInstances();

            if (!this._adManager) {
                return;
            }
            var dispatch = this.props.dispatch;

            var slotsToClear = [];
            var slotsToRefresh = this.gptSlots.filter(function (gptSlot) {
                var shouldRefresh = false;
                // wallpaper ad is added by a page shell, mark as refreshable
                if (gptSlot.type === AdType.WALLPAPER) {
                    shouldRefresh = true;
                } else {
                    var activeAdInstance = instances.filter(function (_ref) {
                        var adSlot = _ref.refs.adSlot;
                        return adSlot.id === gptSlot.getSlotElementId();
                    })[0];
                    if (activeAdInstance) {
                        var refreshed = activeAdInstance.state.refreshed,
                            refreshWhenVisible = activeAdInstance.props.refreshWhenVisible,
                            adSlot = activeAdInstance.refs.adSlot;
                        // either a non-lazy ad or a lazy ad which has been already refreshed

                        var isRefreshable = !refreshWhenVisible || refreshWhenVisible && refreshed;
                        var isIncludedInBreakpoint = _this4._shouldShowSlotForBreakpoint(adSlot);
                        shouldRefresh = isRefreshable && isIncludedInBreakpoint;
                        if (!shouldRefresh) {
                            slotsToClear.push(gptSlot);
                        }
                        gptSlot.refreshable = shouldRefresh;
                    }
                }
                // this flag is used in the patched `getGPTArray` in `connectAdInitializer` to filter out non-refreshable ads
                gptSlot.refreshable = shouldRefresh;

                return shouldRefresh;
            });

            if (slotsToClear.length > 0) {
                // FIXME: this._adManager.clear() doesn't accept an array of slots
                window.googletag.cmd.push(function () {
                    window.googletag.pubads().clear(slotsToClear);
                });
            }
            // when there is an out-of-page ad in the page, it needs to render an out-of-page ad first followed by the rest of ads
            // https://code.espn.com/webdev/score/blob/develop/static/js/ads/admgr.js#L145-L149
            // https://code.espn.com/webdev/score/blob/develop/static/js/ads/init.js#L341-L368
            if (this.hasOutOfPageAd) {
                this._adManager.refreshOutOfPageAdSlots();
            } else if (slotsToRefresh.length > 0) {
                this._adManager.refresh(slotsToRefresh);
            }
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["f" /* adsRefreshed */])());
        }
    }, {
        key: '_onResize',
        value: function _onResize() {
            var _this5 = this;

            this._checkElementVisibility(function (instances) {
                if (instances) {
                    // call `refreshAds` only when there are instances to refresh
                    // use this logic when it's ok to just refresh the ad which just gets visible
                    // this._refreshAds(instances);

                    // use this logic so that we can ensure competitive exclusion in a page
                    _this5._refreshAds();
                }
            });
        }
    }, {
        key: '_checkElementVisibility',
        value: function _checkElementVisibility(callback) {
            // instances set to lazy-render and not rendered yet
            var instancesToCheck = this.getMountedInstances().filter(function (_ref2) {
                var refreshed = _ref2.state.refreshed,
                    refreshWhenVisible = _ref2.props.refreshWhenVisible;
                return refreshWhenVisible && !refreshed;
            });

            if (instancesToCheck.length > 0) {
                var visibleInstances = instancesToCheck.filter(function (_ref3) {
                    var adSlot = _ref3.refs.adSlot;
                    return Object(__WEBPACK_IMPORTED_MODULE_1__lib_ui_isElementVisible__["a" /* default */])(adSlot);
                });

                if (visibleInstances.length > 0) {
                    visibleInstances.forEach(function (instance, index, arr) {
                        instance.setState({ refreshed: true }, index === arr.length - 1 ? function () {
                            callback(visibleInstances);
                        } : null);
                    });
                    return;
                }
            }

            if (callback) {
                callback();
            }
        }

        // logic copied from https://code.espn.com/webdev/score/blob/develop/static/js/ads/admgr.js#L664

    }, {
        key: '_shouldShowSlotForBreakpoint',
        value: function _shouldShowSlotForBreakpoint(slot) {
            var bp = breakpoints[this.props.mq];
            var include = slot.getAttribute('data-include-bp');
            var exclude = slot.getAttribute('data-exclude-bp');
            var shouldShow = true;

            if (include) {
                // if the current breakpoint is not found in the included array, skip this slot
                if (include.split(',').indexOf(bp) === -1) {
                    shouldShow = false;
                }
            }

            if (exclude) {
                // if the current breakpoint is found in the exluded breakpoints array, skip this slot
                if (exclude.split(',').indexOf(bp) !== -1) {
                    shouldShow = false;
                }
            }

            return shouldShow;
        }
    }, {
        key: 'adManager',
        set: function set(value) {
            this._adManager = value;
        }
    }, {
        key: 'gptSlots',
        get: function get() {
            return this._adManager && this._adManager.getGPTArray({ independent: false }) || [];
        }
    }, {
        key: 'hasAds',
        get: function get() {
            return this.getMountedInstances().length > 0;
        }
    }, {
        key: 'hasOutOfPageAd',
        get: function get() {
            return this.gptSlots.filter(function (slot) {
                return slot.type === AdType.OVERLAY;
            }).length > 0;
        }
    }]);

    return AdManager;
}();

/* harmony default export */ __webpack_exports__["a"] = (AdManager);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isElementVisible;
function isElementVisible(el) {
    if (el) {
        var rect = el.getBoundingClientRect();
        return (
            // uncomment this to get this to return true when the entire element is visible
            // rect.top >= 0 &&
            // rect.left >= 0 &&
            // rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            // rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            rect.top <= (window.innerHeight || document.documentElement.clientHeight)
        );
    }
    return false;
};

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable no-console */


function getTargeting(owner) {
    var targetingKeys = owner.getTargetingKeys();
    var targeting = targetingKeys.reduce(function (acc, key) {
        var val = owner.getTargeting(key);
        acc[key] = val.length === 1 ? val[0] : val;
        return acc;
    }, {});
    return targeting;
}

/* harmony default export */ __webpack_exports__["a"] = (function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var globalAdsConfig = window.espn.ads && window.espn.ads.config || {};
    var globalKvpsMap = globalAdsConfig.kvps.reduce(function (total, current) {
        total[current.name] = current.value;
        return total;
    }, {});

    var ads = props.ads;

    if (ads) {
        var localAdsConfig = ads.config;
        var combinedKvpsMap = _extends({}, globalKvpsMap, localAdsConfig.kvps);
        var combinedKvpsArray = Object.keys(combinedKvpsMap || {}).map(function (name) {
            return {
                name: name,
                value: combinedKvpsMap[name]
            };
        });

        // Fixes breakpoints not found error
        globalAdsConfig.breakpoints = {
            xl: [1260],
            l: [1024, 1259],
            m: [768, 1023],
            s: [321, 767],
            xs: [0, 320]
        };

        var adConfig = _extends({}, globalAdsConfig, {
            disableInitialLoad: true,
            kvps: combinedKvpsArray,
            level: localAdsConfig.level
        });

        if (props.flags[__WEBPACK_IMPORTED_MODULE_0__enums__["t" /* Flags */].DEBUG_AD] === 'true') {
            adConfig.onSlotRenderEnded = function onSlotRenderEnded(event) {
                var creativeId = event.creativeId,
                    isEmpty = event.isEmpty,
                    size = event.size,
                    slot = event.slot;

                var divId = slot.getSlotElementId();
                var pageTargeting = getTargeting(window.googletag.pubads());
                var slotTargeting = getTargeting(slot);

                if (!isEmpty && size) {
                    console.info('[Ad] type(\'' + slot.type + '\'), creative(\'' + creativeId + '\', \'' + size[0] + 'x' + size[1] + '\'), div(\'' + divId + '\')', slotTargeting, pageTargeting, event);
                } else {
                    console.info('[Ad] type(\'' + slot.type + '\'), creative(\'empty\'), div(\'' + divId + '\')', slotTargeting, pageTargeting, event);
                }
            };
        }

        return adConfig;
    }
    return {};
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_chooseProvider_ProviderDialog__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_selectors_providerSelector__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_authenticationAware__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_actions_authenticationActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_omniture__ = __webpack_require__(34);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/no-danger */









// empty the modal's default styles
__WEBPACK_IMPORTED_MODULE_2_react_modal___default.a.defaultStyles = {};

var ProviderModal = function (_Component) {
    _inherits(ProviderModal, _Component);

    function ProviderModal(props) {
        _classCallCheck(this, ProviderModal);

        var _this = _possibleConstructorReturn(this, (ProviderModal.__proto__ || Object.getPrototypeOf(ProviderModal)).call(this, props));

        _this.closeAuthModal = _this.closeAuthModal.bind(_this);
        return _this;
    }

    _createClass(ProviderModal, [{
        key: 'closeAuthModal',
        value: function closeAuthModal() {
            this.setState({ searchFilter: '' });
            Object(__WEBPACK_IMPORTED_MODULE_7__lib_omniture__["b" /* clearTrackingData */])();
            this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__common_actions_authenticationActions__["H" /* createCloseProviderDialogAction */])());
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                showProviderDialog = _props.showProviderDialog,
                providerSelect = _props.providerSelect;


            var transparentMask = showProviderDialog ? _jsx('div', {
                className: 'js-feed-item-mask active'
            }) : null;
            return _jsx('div', {}, void 0, transparentMask, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_modal___default.a, {
                isOpen: showProviderDialog,
                onRequestClose: this.closeAuthModal,
                overlayClassName: 'lightbox-container'
            }, void 0, _jsx('article', {
                className: 'lightbox-watch watch-provider-modal js-bloomed'
            }, void 0, _jsx('div', {
                className: 'btn-close icon-font-before icon-close-solid-before',
                onClick: this.closeAuthModal
            }), _jsx('section', {
                className: 'watchProvider--modal'
            }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_3__common_chooseProvider_ProviderDialog__["a" /* default */], {
                providerSelect: providerSelect,
                providerClass: 'watchProvider__scroll'
            })))));
        }
    }]);

    return ProviderModal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ProviderModal.defaultProps = {
    showProviderDialog: false
};

var mapStateToProps = function mapStateToProps(state) {
    var showProviderDialog = Object(__WEBPACK_IMPORTED_MODULE_4__common_selectors_providerSelector__["b" /* displayProviderDialogSelector */])(state);
    return {
        showProviderDialog: showProviderDialog
    };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__common_authenticationAware__["a" /* default */])()(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(ProviderModal)));

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = scoringObserver;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_selectors_pageSelector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_loading__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__observeStore__ = __webpack_require__(377);




function scoringObserver(store) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__observeStore__["a" /* default */])(store, __WEBPACK_IMPORTED_MODULE_0__common_selectors_pageSelector__["c" /* default */], function (currentPage, nextPage) {
        if (nextPage.scored === true) {
            Object(__WEBPACK_IMPORTED_MODULE_1__ui_loading__["a" /* uiLoadingComplete */])();
        }
    });
};

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__(106)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var es = moment.defineLocale('es', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsParseExact : true,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY H:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        ordinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return es;

}));

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    true ? factory(__webpack_require__(106)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var pt_br = moment.defineLocale('pt-br', {
        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
        },
        calendar : {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return (this.day() === 0 || this.day() === 6) ?
                    '[Último] dddd [às] LT' : // Saturday + Sunday
                    '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'em %s',
            past : '%s atrás',
            s : 'poucos segundos',
            m : 'um minuto',
            mm : '%d minutos',
            h : 'uma hora',
            hh : '%d horas',
            d : 'um dia',
            dd : '%d dias',
            M : 'um mês',
            MM : '%d meses',
            y : 'um ano',
            yy : '%d anos'
        },
        ordinalParse: /\d{1,2}º/,
        ordinal : '%dº'
    });

    return pt_br;

}));

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {/* unused harmony export renderCollection */
/* harmony export (immutable) */ __webpack_exports__["a"] = createCollection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__enums__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__page_actions__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scheduleModule_actions__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ads_BannerAd__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Editorial__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ads_InContentAd__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__page_buckets_BucketListContainer__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__page_common_MainContainer__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__page_common_TopLayoutContainer__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__selectors_heroSelector__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PropTypes__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__selectors_appSelector__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__selectors_oneIdSelector__ = __webpack_require__(27);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();


















function renderRedirect() {
    try {
        window.location.href = __WEBPACK_IMPORTED_MODULE_12__constants__["w" /* notFoundUrl */];
    } catch (err) {
        console.error(err);
    }
}

function renderCollection(props) {
    var buckets = props.buckets,
        hero = props.hero,
        isFetching = props.isFetching,
        showOneIdLogin = props.showOneIdLogin,
        isLoggedIn = props.isLoggedIn;
    // if there is no bucket list and hero data, redirect to not found page

    if (!buckets.length && Object.keys(hero).length === 0 && isFetching === false) {
        return _jsx('div', {}, void 0, renderRedirect());
    }

    var bannerAd = [_jsx(__WEBPACK_IMPORTED_MODULE_5__ads_BannerAd__["a" /* default */], {}, 'banner_ad')];

    // layout will change depending on presence of editorial description, set some defaults
    var editorial = null;
    var inContentAd = null;
    var layoutOverride = __WEBPACK_IMPORTED_MODULE_2__enums__["i" /* BucketLayout */].DEFAULT_UNLIMITED;
    var layoutClass = 'layout-full layout-full--watch';
    var columnClass = 'col-a';

    // if there is a description, show the ad and override to DEFAULT layout with unlimited items
    if (buckets[0] && buckets[0].description) {
        var header = 'About ' + buckets[0].name;
        var content = buckets[0].description;
        editorial = _jsx(__WEBPACK_IMPORTED_MODULE_6__Editorial__["a" /* default */], {
            header: header,
            content: content
        });
        inContentAd = _jsx(__WEBPACK_IMPORTED_MODULE_7__ads_InContentAd__["a" /* default */], {
            exclude: ['s', 'm']
        });
        layoutClass = 'layout-bc layout-bc--watch';
        columnClass = 'col-b';
    }

    var renderHeroInBucket = true;
    var hideHeaderLink = false;

    var _ref = buckets[0] || {},
        _ref$metadata = _ref.metadata;

    _ref$metadata = _ref$metadata === undefined ? {} : _ref$metadata;
    var imageFormat = _ref$metadata.imageFormat;

    if (imageFormat === __WEBPACK_IMPORTED_MODULE_2__enums__["j" /* BucketRatio */].FiveTwo || imageFormat === __WEBPACK_IMPORTED_MODULE_2__enums__["j" /* BucketRatio */].FourThree || imageFormat === __WEBPACK_IMPORTED_MODULE_2__enums__["j" /* BucketRatio */].TwoThree) {
        renderHeroInBucket = false;
        layoutOverride = null;
        hideHeaderLink = true;
    }
    var showLogin = !isLoggedIn && showOneIdLogin;
    return _jsx(__WEBPACK_IMPORTED_MODULE_9__page_common_MainContainer__["a" /* default */], {
        pre: bannerAd,
        showLogin: showLogin
    }, void 0, renderHeroInBucket ? _jsx(__WEBPACK_IMPORTED_MODULE_10__page_common_TopLayoutContainer__["a" /* default */], {}) : null, _jsx('div', {
        className: layoutClass
    }, void 0, _jsx('section', {
        className: columnClass
    }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_8__page_buckets_BucketListContainer__["a" /* default */], {
        pageType: __WEBPACK_IMPORTED_MODULE_2__enums__["y" /* PageType */].COLLECTION,
        layoutOverride: layoutOverride,
        renderHeroInBucket: !renderHeroInBucket,
        hideHeaderLink: hideHeaderLink
    }, 'bucket_list_container')), _jsx('section', {
        className: 'col-c'
    }, void 0, editorial, inContentAd)));
}

// create collection-like page(e.g. collection, product)
function createCollection() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$pageName = options.pageName,
        pageName = _options$pageName === undefined ? 'collection' : _options$pageName;


    var Collection = function Collection(props) {
        return renderCollection(props);
    };

    Collection.propTypes = {
        buckets: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array,
        isFetching: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
        hero: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object
    };

    Collection.loadActions = [function (params, query, lang) {
        return Object(__WEBPACK_IMPORTED_MODULE_3__page_actions__["o" /* createFetchPageAction */])(pageName, params, query, lang);
    }, function (params, query, lang) {
        return Object(__WEBPACK_IMPORTED_MODULE_4__scheduleModule_actions__["d" /* fetchScheduleModule */])(lang);
    }];

    Collection.refreshInterval = 65; // 1 min and 5 secs
    Collection.onRefresh = function (_ref2) {
        var dispatch = _ref2.dispatch,
            routeParams = _ref2.routeParams,
            lang = _ref2.lang,
            _ref2$location$query = _ref2.location.query,
            query = _ref2$location$query === undefined ? {} : _ref2$location$query;

        dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__page_actions__["o" /* createFetchPageAction */])(Collection.pageName, routeParams, query, lang)).then(function () {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__page_actions__["n" /* completePageLoad */])());
        });
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__scheduleModule_actions__["d" /* fetchScheduleModule */])(lang)).then(function () {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__scheduleModule_actions__["e" /* scoreScheduleModule */])());
        });
    };

    var mapStateToProps = function mapStateToProps(state) {
        return {
            buckets: state.page && state.page.buckets || [],
            isFetching: state.page && state.page.isFetching,
            hero: Object(__WEBPACK_IMPORTED_MODULE_11__selectors_heroSelector__["a" /* default */])(state),
            showOneIdLogin: Object(__WEBPACK_IMPORTED_MODULE_14__selectors_appSelector__["G" /* showOneIdLoginSelector */])(state),
            isLoggedIn: Object(__WEBPACK_IMPORTED_MODULE_15__selectors_oneIdSelector__["f" /* oneIdLoggedInSelector */])(state)
        };
    };

    return Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(Collection);
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var Editorial = function Editorial(props) {
    return _jsx("article", {
        className: "sub-module module_editorial"
    }, void 0, _jsx("header", {}, void 0, _jsx("h1", {}, void 0, props.header)), _jsx("div", {
        className: "content"
    }, void 0, _jsx("p", {}, void 0, props.content)));
};

/* harmony default export */ __webpack_exports__["a"] = (Editorial);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// webapp.aa6bc9ac24e22e445afe.js